
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4232"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4232"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9w4Jx", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6edac62b517fe22a$export$ffb0004e005737fa; }, function (v) { return $6edac62b517fe22a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $6edac62b517fe22a$export$34b9dba7ce09269b; }, function (v) { return $6edac62b517fe22a$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $6edac62b517fe22a$export$25062201e9e25d76; }, function (v) { return $6edac62b517fe22a$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6edac62b517fe22a$export$ffb0004e005737fa;
var $6edac62b517fe22a$export$34b9dba7ce09269b;
var $6edac62b517fe22a$export$25062201e9e25d76;
"use strict";

var $3QbnI = parcelRequire("3QbnI");
var $6edac62b517fe22a$var$k = Symbol.for("react.element"), $6edac62b517fe22a$var$l = Symbol.for("react.fragment"), $6edac62b517fe22a$var$m = Object.prototype.hasOwnProperty, $6edac62b517fe22a$var$n = $3QbnI.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $6edac62b517fe22a$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $6edac62b517fe22a$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$6edac62b517fe22a$var$m.call(a, b) && !$6edac62b517fe22a$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $6edac62b517fe22a$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $6edac62b517fe22a$var$n.current
    };
}
$6edac62b517fe22a$export$ffb0004e005737fa = $6edac62b517fe22a$var$l;
$6edac62b517fe22a$export$34b9dba7ce09269b = $6edac62b517fe22a$var$q;
$6edac62b517fe22a$export$25062201e9e25d76 = $6edac62b517fe22a$var$q;

});
parcelRegister("3QbnI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("SYOhR"));

});
parcelRegister("SYOhR", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $0a5436e054bab3e9$export$dca3b0875bd9a954; }, function (v) { return $0a5436e054bab3e9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0a5436e054bab3e9$export$16fa2f45be04daa8; }, function (v) { return $0a5436e054bab3e9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0a5436e054bab3e9$export$ffb0004e005737fa; }, function (v) { return $0a5436e054bab3e9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $0a5436e054bab3e9$export$e2c29f18771995cb; }, function (v) { return $0a5436e054bab3e9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0a5436e054bab3e9$export$221d75b3f55bb0bd; }, function (v) { return $0a5436e054bab3e9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0a5436e054bab3e9$export$5f8d39834fd61797; }, function (v) { return $0a5436e054bab3e9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0a5436e054bab3e9$export$74bf444e3cd11ea5; }, function (v) { return $0a5436e054bab3e9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0a5436e054bab3e9$export$ae55be85d98224ed; }, function (v) { return $0a5436e054bab3e9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $0a5436e054bab3e9$export$3ba232387fd5d6dd; }, function (v) { return $0a5436e054bab3e9$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0a5436e054bab3e9$export$e530037191fcd5d7; }, function (v) { return $0a5436e054bab3e9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0a5436e054bab3e9$export$fd42f52fd3ae1109; }, function (v) { return $0a5436e054bab3e9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0a5436e054bab3e9$export$c8a8987d4410bf2d; }, function (v) { return $0a5436e054bab3e9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $0a5436e054bab3e9$export$d38cd72104c1f0e9; }, function (v) { return $0a5436e054bab3e9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $0a5436e054bab3e9$export$7d1e3a5e95ceca43; }, function (v) { return $0a5436e054bab3e9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0a5436e054bab3e9$export$257a8862b851cb5b; }, function (v) { return $0a5436e054bab3e9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0a5436e054bab3e9$export$a8257692ac88316c; }, function (v) { return $0a5436e054bab3e9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0a5436e054bab3e9$export$488013bae63b21da; }, function (v) { return $0a5436e054bab3e9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0a5436e054bab3e9$export$7c73462e0d25e514; }, function (v) { return $0a5436e054bab3e9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $0a5436e054bab3e9$export$7568632d0d33d16d; }, function (v) { return $0a5436e054bab3e9$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $0a5436e054bab3e9$export$88948ce120ea2619; }, function (v) { return $0a5436e054bab3e9$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0a5436e054bab3e9$export$35808ee640e87ca7; }, function (v) { return $0a5436e054bab3e9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0a5436e054bab3e9$export$fae74005e78b1a27; }, function (v) { return $0a5436e054bab3e9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0a5436e054bab3e9$export$dc8fbce3eb94dc1e; }, function (v) { return $0a5436e054bab3e9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $0a5436e054bab3e9$export$6a7bc4e911dc01cf; }, function (v) { return $0a5436e054bab3e9$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $0a5436e054bab3e9$export$6d9c69b0de29b591; }, function (v) { return $0a5436e054bab3e9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $0a5436e054bab3e9$export$f680877a34711e37; }, function (v) { return $0a5436e054bab3e9$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0a5436e054bab3e9$export$d5a552a76deda3c2; }, function (v) { return $0a5436e054bab3e9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $0a5436e054bab3e9$export$aaabe4eda9ed9969; }, function (v) { return $0a5436e054bab3e9$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0a5436e054bab3e9$export$e5c5a5f917a5871c; }, function (v) { return $0a5436e054bab3e9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0a5436e054bab3e9$export$1538c33de8887b59; }, function (v) { return $0a5436e054bab3e9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $0a5436e054bab3e9$export$13e3392192263954; }, function (v) { return $0a5436e054bab3e9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0a5436e054bab3e9$export$b8f5890fc79d6aca; }, function (v) { return $0a5436e054bab3e9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0a5436e054bab3e9$export$60241385465d0a34; }, function (v) { return $0a5436e054bab3e9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $0a5436e054bab3e9$export$306c0aa65ff9ec16; }, function (v) { return $0a5436e054bab3e9$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $0a5436e054bab3e9$export$7b286972b8d8ccbf; }, function (v) { return $0a5436e054bab3e9$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $0a5436e054bab3e9$export$83d89fbfd8236492; }, function (v) { return $0a5436e054bab3e9$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0a5436e054bab3e9$export$dca3b0875bd9a954;
var $0a5436e054bab3e9$export$16fa2f45be04daa8;
var $0a5436e054bab3e9$export$ffb0004e005737fa;
var $0a5436e054bab3e9$export$e2c29f18771995cb;
var $0a5436e054bab3e9$export$221d75b3f55bb0bd;
var $0a5436e054bab3e9$export$5f8d39834fd61797;
var $0a5436e054bab3e9$export$74bf444e3cd11ea5;
var $0a5436e054bab3e9$export$ae55be85d98224ed;
var $0a5436e054bab3e9$export$3ba232387fd5d6dd;
var $0a5436e054bab3e9$export$e530037191fcd5d7;
var $0a5436e054bab3e9$export$fd42f52fd3ae1109;
var $0a5436e054bab3e9$export$c8a8987d4410bf2d;
var $0a5436e054bab3e9$export$d38cd72104c1f0e9;
var $0a5436e054bab3e9$export$7d1e3a5e95ceca43;
var $0a5436e054bab3e9$export$257a8862b851cb5b;
var $0a5436e054bab3e9$export$a8257692ac88316c;
var $0a5436e054bab3e9$export$488013bae63b21da;
var $0a5436e054bab3e9$export$7c73462e0d25e514;
var $0a5436e054bab3e9$export$7568632d0d33d16d;
var $0a5436e054bab3e9$export$88948ce120ea2619;
var $0a5436e054bab3e9$export$35808ee640e87ca7;
var $0a5436e054bab3e9$export$fae74005e78b1a27;
var $0a5436e054bab3e9$export$dc8fbce3eb94dc1e;
var $0a5436e054bab3e9$export$6a7bc4e911dc01cf;
var $0a5436e054bab3e9$export$6d9c69b0de29b591;
var $0a5436e054bab3e9$export$f680877a34711e37;
var $0a5436e054bab3e9$export$d5a552a76deda3c2;
var $0a5436e054bab3e9$export$aaabe4eda9ed9969;
var $0a5436e054bab3e9$export$e5c5a5f917a5871c;
var $0a5436e054bab3e9$export$1538c33de8887b59;
var $0a5436e054bab3e9$export$13e3392192263954;
var $0a5436e054bab3e9$export$b8f5890fc79d6aca;
var $0a5436e054bab3e9$export$60241385465d0a34;
var $0a5436e054bab3e9$export$306c0aa65ff9ec16;
var $0a5436e054bab3e9$export$7b286972b8d8ccbf;
var $0a5436e054bab3e9$export$83d89fbfd8236492;
"use strict";
var $0a5436e054bab3e9$var$l = Symbol.for("react.element"), $0a5436e054bab3e9$var$n = Symbol.for("react.portal"), $0a5436e054bab3e9$var$p = Symbol.for("react.fragment"), $0a5436e054bab3e9$var$q = Symbol.for("react.strict_mode"), $0a5436e054bab3e9$var$r = Symbol.for("react.profiler"), $0a5436e054bab3e9$var$t = Symbol.for("react.provider"), $0a5436e054bab3e9$var$u = Symbol.for("react.context"), $0a5436e054bab3e9$var$v = Symbol.for("react.forward_ref"), $0a5436e054bab3e9$var$w = Symbol.for("react.suspense"), $0a5436e054bab3e9$var$x = Symbol.for("react.memo"), $0a5436e054bab3e9$var$y = Symbol.for("react.lazy"), $0a5436e054bab3e9$var$z = Symbol.iterator;
function $0a5436e054bab3e9$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0a5436e054bab3e9$var$z && a[$0a5436e054bab3e9$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0a5436e054bab3e9$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0a5436e054bab3e9$var$C = Object.assign, $0a5436e054bab3e9$var$D = {};
function $0a5436e054bab3e9$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0a5436e054bab3e9$var$D;
    this.updater = e || $0a5436e054bab3e9$var$B;
}
$0a5436e054bab3e9$var$E.prototype.isReactComponent = {};
$0a5436e054bab3e9$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0a5436e054bab3e9$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0a5436e054bab3e9$var$F() {}
$0a5436e054bab3e9$var$F.prototype = $0a5436e054bab3e9$var$E.prototype;
function $0a5436e054bab3e9$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0a5436e054bab3e9$var$D;
    this.updater = e || $0a5436e054bab3e9$var$B;
}
var $0a5436e054bab3e9$var$H = $0a5436e054bab3e9$var$G.prototype = new $0a5436e054bab3e9$var$F;
$0a5436e054bab3e9$var$H.constructor = $0a5436e054bab3e9$var$G;
$0a5436e054bab3e9$var$C($0a5436e054bab3e9$var$H, $0a5436e054bab3e9$var$E.prototype);
$0a5436e054bab3e9$var$H.isPureReactComponent = !0;
var $0a5436e054bab3e9$var$I = Array.isArray, $0a5436e054bab3e9$var$J = Object.prototype.hasOwnProperty, $0a5436e054bab3e9$var$K = {
    current: null
}, $0a5436e054bab3e9$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0a5436e054bab3e9$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0a5436e054bab3e9$var$J.call(b, d) && !$0a5436e054bab3e9$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0a5436e054bab3e9$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0a5436e054bab3e9$var$K.current
    };
}
function $0a5436e054bab3e9$var$N(a, b) {
    return {
        $$typeof: $0a5436e054bab3e9$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0a5436e054bab3e9$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0a5436e054bab3e9$var$l;
}
function $0a5436e054bab3e9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0a5436e054bab3e9$var$P = /\/+/g;
function $0a5436e054bab3e9$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0a5436e054bab3e9$var$escape("" + a.key) : b.toString(36);
}
function $0a5436e054bab3e9$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0a5436e054bab3e9$var$l:
                case $0a5436e054bab3e9$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0a5436e054bab3e9$var$Q(h, 0) : d, $0a5436e054bab3e9$var$I(c) ? (e = "", null != a && (e = a.replace($0a5436e054bab3e9$var$P, "$&/") + "/"), $0a5436e054bab3e9$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0a5436e054bab3e9$var$O(c) && (c = $0a5436e054bab3e9$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0a5436e054bab3e9$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0a5436e054bab3e9$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0a5436e054bab3e9$var$Q(k, g);
        h += $0a5436e054bab3e9$var$R(k, b, e, f, c);
    }
    else if (f = $0a5436e054bab3e9$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0a5436e054bab3e9$var$Q(k, g++), h += $0a5436e054bab3e9$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0a5436e054bab3e9$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0a5436e054bab3e9$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0a5436e054bab3e9$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0a5436e054bab3e9$var$U = {
    current: null
}, $0a5436e054bab3e9$var$V = {
    transition: null
}, $0a5436e054bab3e9$var$W = {
    ReactCurrentDispatcher: $0a5436e054bab3e9$var$U,
    ReactCurrentBatchConfig: $0a5436e054bab3e9$var$V,
    ReactCurrentOwner: $0a5436e054bab3e9$var$K
};
function $0a5436e054bab3e9$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0a5436e054bab3e9$export$dca3b0875bd9a954 = {
    map: $0a5436e054bab3e9$var$S,
    forEach: function(a, b, e) {
        $0a5436e054bab3e9$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0a5436e054bab3e9$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0a5436e054bab3e9$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0a5436e054bab3e9$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0a5436e054bab3e9$export$16fa2f45be04daa8 = $0a5436e054bab3e9$var$E;
$0a5436e054bab3e9$export$ffb0004e005737fa = $0a5436e054bab3e9$var$p;
$0a5436e054bab3e9$export$e2c29f18771995cb = $0a5436e054bab3e9$var$r;
$0a5436e054bab3e9$export$221d75b3f55bb0bd = $0a5436e054bab3e9$var$G;
$0a5436e054bab3e9$export$5f8d39834fd61797 = $0a5436e054bab3e9$var$q;
$0a5436e054bab3e9$export$74bf444e3cd11ea5 = $0a5436e054bab3e9$var$w;
$0a5436e054bab3e9$export$ae55be85d98224ed = $0a5436e054bab3e9$var$W;
$0a5436e054bab3e9$export$3ba232387fd5d6dd = $0a5436e054bab3e9$var$X;
$0a5436e054bab3e9$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0a5436e054bab3e9$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0a5436e054bab3e9$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0a5436e054bab3e9$var$J.call(b, f) && !$0a5436e054bab3e9$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0a5436e054bab3e9$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0a5436e054bab3e9$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0a5436e054bab3e9$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0a5436e054bab3e9$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0a5436e054bab3e9$export$c8a8987d4410bf2d = $0a5436e054bab3e9$var$M;
$0a5436e054bab3e9$export$d38cd72104c1f0e9 = function(a) {
    var b = $0a5436e054bab3e9$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0a5436e054bab3e9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0a5436e054bab3e9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0a5436e054bab3e9$var$v,
        render: a
    };
};
$0a5436e054bab3e9$export$a8257692ac88316c = $0a5436e054bab3e9$var$O;
$0a5436e054bab3e9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0a5436e054bab3e9$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0a5436e054bab3e9$var$T
    };
};
$0a5436e054bab3e9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0a5436e054bab3e9$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0a5436e054bab3e9$export$7568632d0d33d16d = function(a) {
    var b = $0a5436e054bab3e9$var$V.transition;
    $0a5436e054bab3e9$var$V.transition = {};
    try {
        a();
    } finally{
        $0a5436e054bab3e9$var$V.transition = b;
    }
};
$0a5436e054bab3e9$export$88948ce120ea2619 = $0a5436e054bab3e9$var$X;
$0a5436e054bab3e9$export$35808ee640e87ca7 = function(a, b) {
    return $0a5436e054bab3e9$var$U.current.useCallback(a, b);
};
$0a5436e054bab3e9$export$fae74005e78b1a27 = function(a) {
    return $0a5436e054bab3e9$var$U.current.useContext(a);
};
$0a5436e054bab3e9$export$dc8fbce3eb94dc1e = function() {};
$0a5436e054bab3e9$export$6a7bc4e911dc01cf = function(a) {
    return $0a5436e054bab3e9$var$U.current.useDeferredValue(a);
};
$0a5436e054bab3e9$export$6d9c69b0de29b591 = function(a, b) {
    return $0a5436e054bab3e9$var$U.current.useEffect(a, b);
};
$0a5436e054bab3e9$export$f680877a34711e37 = function() {
    return $0a5436e054bab3e9$var$U.current.useId();
};
$0a5436e054bab3e9$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0a5436e054bab3e9$var$U.current.useImperativeHandle(a, b, e);
};
$0a5436e054bab3e9$export$aaabe4eda9ed9969 = function(a, b) {
    return $0a5436e054bab3e9$var$U.current.useInsertionEffect(a, b);
};
$0a5436e054bab3e9$export$e5c5a5f917a5871c = function(a, b) {
    return $0a5436e054bab3e9$var$U.current.useLayoutEffect(a, b);
};
$0a5436e054bab3e9$export$1538c33de8887b59 = function(a, b) {
    return $0a5436e054bab3e9$var$U.current.useMemo(a, b);
};
$0a5436e054bab3e9$export$13e3392192263954 = function(a, b, e) {
    return $0a5436e054bab3e9$var$U.current.useReducer(a, b, e);
};
$0a5436e054bab3e9$export$b8f5890fc79d6aca = function(a) {
    return $0a5436e054bab3e9$var$U.current.useRef(a);
};
$0a5436e054bab3e9$export$60241385465d0a34 = function(a) {
    return $0a5436e054bab3e9$var$U.current.useState(a);
};
$0a5436e054bab3e9$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0a5436e054bab3e9$var$U.current.useSyncExternalStore(a, b, e);
};
$0a5436e054bab3e9$export$7b286972b8d8ccbf = function() {
    return $0a5436e054bab3e9$var$U.current.useTransition();
};
$0a5436e054bab3e9$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("chU0U", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8f2285b8ffe719da$export$ae55be85d98224ed; }, function (v) { return $8f2285b8ffe719da$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $8f2285b8ffe719da$export$d39a5bbd09211389; }, function (v) { return $8f2285b8ffe719da$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $8f2285b8ffe719da$export$882461b6382ed46c; }, function (v) { return $8f2285b8ffe719da$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $8f2285b8ffe719da$export$466bfc07425424d5; }, function (v) { return $8f2285b8ffe719da$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $8f2285b8ffe719da$export$cd75ccfd720a3cd4; }, function (v) { return $8f2285b8ffe719da$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $8f2285b8ffe719da$export$fa8d919ba61d84db; }, function (v) { return $8f2285b8ffe719da$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $8f2285b8ffe719da$export$757ceba2d55c277e; }, function (v) { return $8f2285b8ffe719da$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $8f2285b8ffe719da$export$b3890eb0ae9dca99; }, function (v) { return $8f2285b8ffe719da$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $8f2285b8ffe719da$export$502457920280e6be; }, function (v) { return $8f2285b8ffe719da$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $8f2285b8ffe719da$export$c78a37762a8d58e1; }, function (v) { return $8f2285b8ffe719da$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $8f2285b8ffe719da$export$dc54d992c10e8a18; }, function (v) { return $8f2285b8ffe719da$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $8f2285b8ffe719da$export$83d89fbfd8236492; }, function (v) { return $8f2285b8ffe719da$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $8f2285b8ffe719da$export$ae55be85d98224ed;
var $8f2285b8ffe719da$export$d39a5bbd09211389;
var $8f2285b8ffe719da$export$882461b6382ed46c;
var $8f2285b8ffe719da$export$466bfc07425424d5;
var $8f2285b8ffe719da$export$cd75ccfd720a3cd4;
var $8f2285b8ffe719da$export$fa8d919ba61d84db;
var $8f2285b8ffe719da$export$757ceba2d55c277e;
var $8f2285b8ffe719da$export$b3890eb0ae9dca99;
var $8f2285b8ffe719da$export$502457920280e6be;
var $8f2285b8ffe719da$export$c78a37762a8d58e1;
var $8f2285b8ffe719da$export$dc54d992c10e8a18;
var $8f2285b8ffe719da$export$83d89fbfd8236492;
"use strict";

var $3QbnI = parcelRequire("3QbnI");

var $e00l3 = parcelRequire("e00l3");
function $8f2285b8ffe719da$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8f2285b8ffe719da$var$da = new Set, $8f2285b8ffe719da$var$ea = {};
function $8f2285b8ffe719da$var$fa(a, b) {
    $8f2285b8ffe719da$var$ha(a, b);
    $8f2285b8ffe719da$var$ha(a + "Capture", b);
}
function $8f2285b8ffe719da$var$ha(a, b) {
    $8f2285b8ffe719da$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$8f2285b8ffe719da$var$da.add(b[a]);
}
var $8f2285b8ffe719da$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $8f2285b8ffe719da$var$ja = Object.prototype.hasOwnProperty, $8f2285b8ffe719da$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $8f2285b8ffe719da$var$la = {}, $8f2285b8ffe719da$var$ma = {};
function $8f2285b8ffe719da$var$oa(a) {
    if ($8f2285b8ffe719da$var$ja.call($8f2285b8ffe719da$var$ma, a)) return !0;
    if ($8f2285b8ffe719da$var$ja.call($8f2285b8ffe719da$var$la, a)) return !1;
    if ($8f2285b8ffe719da$var$ka.test(a)) return $8f2285b8ffe719da$var$ma[a] = !0;
    $8f2285b8ffe719da$var$la[a] = !0;
    return !1;
}
function $8f2285b8ffe719da$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $8f2285b8ffe719da$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $8f2285b8ffe719da$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $8f2285b8ffe719da$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $8f2285b8ffe719da$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $8f2285b8ffe719da$var$z[b] = new $8f2285b8ffe719da$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $8f2285b8ffe719da$var$ra = /[\-:]([a-z])/g;
function $8f2285b8ffe719da$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($8f2285b8ffe719da$var$ra, $8f2285b8ffe719da$var$sa);
    $8f2285b8ffe719da$var$z[b] = new $8f2285b8ffe719da$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($8f2285b8ffe719da$var$ra, $8f2285b8ffe719da$var$sa);
    $8f2285b8ffe719da$var$z[b] = new $8f2285b8ffe719da$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($8f2285b8ffe719da$var$ra, $8f2285b8ffe719da$var$sa);
    $8f2285b8ffe719da$var$z[b] = new $8f2285b8ffe719da$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$8f2285b8ffe719da$var$z.xlinkHref = new $8f2285b8ffe719da$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $8f2285b8ffe719da$var$z[a] = new $8f2285b8ffe719da$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $8f2285b8ffe719da$var$ta(a, b, c, d) {
    var e = $8f2285b8ffe719da$var$z.hasOwnProperty(b) ? $8f2285b8ffe719da$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $8f2285b8ffe719da$var$qa(b, c, e, d) && (c = null), d || null === e ? $8f2285b8ffe719da$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $8f2285b8ffe719da$var$ua = $3QbnI.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $8f2285b8ffe719da$var$va = Symbol.for("react.element"), $8f2285b8ffe719da$var$wa = Symbol.for("react.portal"), $8f2285b8ffe719da$var$ya = Symbol.for("react.fragment"), $8f2285b8ffe719da$var$za = Symbol.for("react.strict_mode"), $8f2285b8ffe719da$var$Aa = Symbol.for("react.profiler"), $8f2285b8ffe719da$var$Ba = Symbol.for("react.provider"), $8f2285b8ffe719da$var$Ca = Symbol.for("react.context"), $8f2285b8ffe719da$var$Da = Symbol.for("react.forward_ref"), $8f2285b8ffe719da$var$Ea = Symbol.for("react.suspense"), $8f2285b8ffe719da$var$Fa = Symbol.for("react.suspense_list"), $8f2285b8ffe719da$var$Ga = Symbol.for("react.memo"), $8f2285b8ffe719da$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $8f2285b8ffe719da$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $8f2285b8ffe719da$var$Ja = Symbol.iterator;
function $8f2285b8ffe719da$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8f2285b8ffe719da$var$Ja && a[$8f2285b8ffe719da$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $8f2285b8ffe719da$var$A = Object.assign, $8f2285b8ffe719da$var$La;
function $8f2285b8ffe719da$var$Ma(a) {
    if (void 0 === $8f2285b8ffe719da$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $8f2285b8ffe719da$var$La = b && b[1] || "";
    }
    return "\n" + $8f2285b8ffe719da$var$La + a;
}
var $8f2285b8ffe719da$var$Na = !1;
function $8f2285b8ffe719da$var$Oa(a, b) {
    if (!a || $8f2285b8ffe719da$var$Na) return "";
    $8f2285b8ffe719da$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $8f2285b8ffe719da$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $8f2285b8ffe719da$var$Ma(a) : "";
}
function $8f2285b8ffe719da$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $8f2285b8ffe719da$var$Ma(a.type);
        case 16:
            return $8f2285b8ffe719da$var$Ma("Lazy");
        case 13:
            return $8f2285b8ffe719da$var$Ma("Suspense");
        case 19:
            return $8f2285b8ffe719da$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $8f2285b8ffe719da$var$Oa(a.type, !1), a;
        case 11:
            return a = $8f2285b8ffe719da$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $8f2285b8ffe719da$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $8f2285b8ffe719da$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $8f2285b8ffe719da$var$ya:
            return "Fragment";
        case $8f2285b8ffe719da$var$wa:
            return "Portal";
        case $8f2285b8ffe719da$var$Aa:
            return "Profiler";
        case $8f2285b8ffe719da$var$za:
            return "StrictMode";
        case $8f2285b8ffe719da$var$Ea:
            return "Suspense";
        case $8f2285b8ffe719da$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $8f2285b8ffe719da$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $8f2285b8ffe719da$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $8f2285b8ffe719da$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $8f2285b8ffe719da$var$Ga:
            return b = a.displayName || null, null !== b ? b : $8f2285b8ffe719da$var$Qa(a.type) || "Memo";
        case $8f2285b8ffe719da$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $8f2285b8ffe719da$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $8f2285b8ffe719da$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $8f2285b8ffe719da$var$Qa(b);
        case 8:
            return b === $8f2285b8ffe719da$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $8f2285b8ffe719da$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $8f2285b8ffe719da$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $8f2285b8ffe719da$var$Ua(a) {
    var b = $8f2285b8ffe719da$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $8f2285b8ffe719da$var$Va(a) {
    a._valueTracker || (a._valueTracker = $8f2285b8ffe719da$var$Ua(a));
}
function $8f2285b8ffe719da$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $8f2285b8ffe719da$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $8f2285b8ffe719da$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $8f2285b8ffe719da$var$Ya(a, b) {
    var c = b.checked;
    return $8f2285b8ffe719da$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $8f2285b8ffe719da$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $8f2285b8ffe719da$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $8f2285b8ffe719da$var$ab(a, b) {
    b = b.checked;
    null != b && $8f2285b8ffe719da$var$ta(a, "checked", b, !1);
}
function $8f2285b8ffe719da$var$bb(a, b) {
    $8f2285b8ffe719da$var$ab(a, b);
    var c = $8f2285b8ffe719da$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $8f2285b8ffe719da$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $8f2285b8ffe719da$var$cb(a, b.type, $8f2285b8ffe719da$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $8f2285b8ffe719da$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $8f2285b8ffe719da$var$cb(a, b, c) {
    if ("number" !== b || $8f2285b8ffe719da$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $8f2285b8ffe719da$var$eb = Array.isArray;
function $8f2285b8ffe719da$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $8f2285b8ffe719da$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $8f2285b8ffe719da$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($8f2285b8ffe719da$var$p(91));
    return $8f2285b8ffe719da$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $8f2285b8ffe719da$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($8f2285b8ffe719da$var$p(92));
            if ($8f2285b8ffe719da$var$eb(c)) {
                if (1 < c.length) throw Error($8f2285b8ffe719da$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $8f2285b8ffe719da$var$Sa(c)
    };
}
function $8f2285b8ffe719da$var$ib(a, b) {
    var c = $8f2285b8ffe719da$var$Sa(b.value), d = $8f2285b8ffe719da$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $8f2285b8ffe719da$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $8f2285b8ffe719da$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $8f2285b8ffe719da$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $8f2285b8ffe719da$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $8f2285b8ffe719da$var$mb, $8f2285b8ffe719da$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $8f2285b8ffe719da$var$mb = $8f2285b8ffe719da$var$mb || document.createElement("div");
        $8f2285b8ffe719da$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $8f2285b8ffe719da$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $8f2285b8ffe719da$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $8f2285b8ffe719da$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $8f2285b8ffe719da$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($8f2285b8ffe719da$var$pb).forEach(function(a) {
    $8f2285b8ffe719da$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $8f2285b8ffe719da$var$pb[b] = $8f2285b8ffe719da$var$pb[a];
    });
});
function $8f2285b8ffe719da$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $8f2285b8ffe719da$var$pb.hasOwnProperty(a) && $8f2285b8ffe719da$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $8f2285b8ffe719da$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $8f2285b8ffe719da$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $8f2285b8ffe719da$var$tb = $8f2285b8ffe719da$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $8f2285b8ffe719da$var$ub(a, b) {
    if (b) {
        if ($8f2285b8ffe719da$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($8f2285b8ffe719da$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($8f2285b8ffe719da$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($8f2285b8ffe719da$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($8f2285b8ffe719da$var$p(62));
    }
}
function $8f2285b8ffe719da$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $8f2285b8ffe719da$var$wb = null;
function $8f2285b8ffe719da$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $8f2285b8ffe719da$var$yb = null, $8f2285b8ffe719da$var$zb = null, $8f2285b8ffe719da$var$Ab = null;
function $8f2285b8ffe719da$var$Bb(a) {
    if (a = $8f2285b8ffe719da$var$Cb(a)) {
        if ("function" !== typeof $8f2285b8ffe719da$var$yb) throw Error($8f2285b8ffe719da$var$p(280));
        var b = a.stateNode;
        b && (b = $8f2285b8ffe719da$var$Db(b), $8f2285b8ffe719da$var$yb(a.stateNode, a.type, b));
    }
}
function $8f2285b8ffe719da$var$Eb(a) {
    $8f2285b8ffe719da$var$zb ? $8f2285b8ffe719da$var$Ab ? $8f2285b8ffe719da$var$Ab.push(a) : $8f2285b8ffe719da$var$Ab = [
        a
    ] : $8f2285b8ffe719da$var$zb = a;
}
function $8f2285b8ffe719da$var$Fb() {
    if ($8f2285b8ffe719da$var$zb) {
        var a = $8f2285b8ffe719da$var$zb, b = $8f2285b8ffe719da$var$Ab;
        $8f2285b8ffe719da$var$Ab = $8f2285b8ffe719da$var$zb = null;
        $8f2285b8ffe719da$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$8f2285b8ffe719da$var$Bb(b[a]);
    }
}
function $8f2285b8ffe719da$var$Gb(a, b) {
    return a(b);
}
function $8f2285b8ffe719da$var$Hb() {}
var $8f2285b8ffe719da$var$Ib = !1;
function $8f2285b8ffe719da$var$Jb(a, b, c) {
    if ($8f2285b8ffe719da$var$Ib) return a(b, c);
    $8f2285b8ffe719da$var$Ib = !0;
    try {
        return $8f2285b8ffe719da$var$Gb(a, b, c);
    } finally{
        if ($8f2285b8ffe719da$var$Ib = !1, null !== $8f2285b8ffe719da$var$zb || null !== $8f2285b8ffe719da$var$Ab) $8f2285b8ffe719da$var$Hb(), $8f2285b8ffe719da$var$Fb();
    }
}
function $8f2285b8ffe719da$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $8f2285b8ffe719da$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($8f2285b8ffe719da$var$p(231, b, typeof c));
    return c;
}
var $8f2285b8ffe719da$var$Lb = !1;
if ($8f2285b8ffe719da$var$ia) try {
    var $8f2285b8ffe719da$var$Mb = {};
    Object.defineProperty($8f2285b8ffe719da$var$Mb, "passive", {
        get: function() {
            $8f2285b8ffe719da$var$Lb = !0;
        }
    });
    window.addEventListener("test", $8f2285b8ffe719da$var$Mb, $8f2285b8ffe719da$var$Mb);
    window.removeEventListener("test", $8f2285b8ffe719da$var$Mb, $8f2285b8ffe719da$var$Mb);
} catch (a) {
    $8f2285b8ffe719da$var$Lb = !1;
}
function $8f2285b8ffe719da$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $8f2285b8ffe719da$var$Ob = !1, $8f2285b8ffe719da$var$Pb = null, $8f2285b8ffe719da$var$Qb = !1, $8f2285b8ffe719da$var$Rb = null, $8f2285b8ffe719da$var$Sb = {
    onError: function(a) {
        $8f2285b8ffe719da$var$Ob = !0;
        $8f2285b8ffe719da$var$Pb = a;
    }
};
function $8f2285b8ffe719da$var$Tb(a, b, c, d, e, f, g, h, k) {
    $8f2285b8ffe719da$var$Ob = !1;
    $8f2285b8ffe719da$var$Pb = null;
    $8f2285b8ffe719da$var$Nb.apply($8f2285b8ffe719da$var$Sb, arguments);
}
function $8f2285b8ffe719da$var$Ub(a, b, c, d, e, f, g, h, k) {
    $8f2285b8ffe719da$var$Tb.apply(this, arguments);
    if ($8f2285b8ffe719da$var$Ob) {
        if ($8f2285b8ffe719da$var$Ob) {
            var l = $8f2285b8ffe719da$var$Pb;
            $8f2285b8ffe719da$var$Ob = !1;
            $8f2285b8ffe719da$var$Pb = null;
        } else throw Error($8f2285b8ffe719da$var$p(198));
        $8f2285b8ffe719da$var$Qb || ($8f2285b8ffe719da$var$Qb = !0, $8f2285b8ffe719da$var$Rb = l);
    }
}
function $8f2285b8ffe719da$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $8f2285b8ffe719da$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $8f2285b8ffe719da$var$Xb(a) {
    if ($8f2285b8ffe719da$var$Vb(a) !== a) throw Error($8f2285b8ffe719da$var$p(188));
}
function $8f2285b8ffe719da$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $8f2285b8ffe719da$var$Vb(a);
        if (null === b) throw Error($8f2285b8ffe719da$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $8f2285b8ffe719da$var$Xb(e), a;
                if (f === d) return $8f2285b8ffe719da$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($8f2285b8ffe719da$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($8f2285b8ffe719da$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($8f2285b8ffe719da$var$p(190));
    }
    if (3 !== c.tag) throw Error($8f2285b8ffe719da$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $8f2285b8ffe719da$var$Zb(a) {
    a = $8f2285b8ffe719da$var$Yb(a);
    return null !== a ? $8f2285b8ffe719da$var$$b(a) : null;
}
function $8f2285b8ffe719da$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $8f2285b8ffe719da$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $8f2285b8ffe719da$var$ac = $e00l3.unstable_scheduleCallback, $8f2285b8ffe719da$var$bc = $e00l3.unstable_cancelCallback, $8f2285b8ffe719da$var$cc = $e00l3.unstable_shouldYield, $8f2285b8ffe719da$var$dc = $e00l3.unstable_requestPaint, $8f2285b8ffe719da$var$B = $e00l3.unstable_now, $8f2285b8ffe719da$var$ec = $e00l3.unstable_getCurrentPriorityLevel, $8f2285b8ffe719da$var$fc = $e00l3.unstable_ImmediatePriority, $8f2285b8ffe719da$var$gc = $e00l3.unstable_UserBlockingPriority, $8f2285b8ffe719da$var$hc = $e00l3.unstable_NormalPriority, $8f2285b8ffe719da$var$ic = $e00l3.unstable_LowPriority, $8f2285b8ffe719da$var$jc = $e00l3.unstable_IdlePriority, $8f2285b8ffe719da$var$kc = null, $8f2285b8ffe719da$var$lc = null;
function $8f2285b8ffe719da$var$mc(a) {
    if ($8f2285b8ffe719da$var$lc && "function" === typeof $8f2285b8ffe719da$var$lc.onCommitFiberRoot) try {
        $8f2285b8ffe719da$var$lc.onCommitFiberRoot($8f2285b8ffe719da$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $8f2285b8ffe719da$var$oc = Math.clz32 ? Math.clz32 : $8f2285b8ffe719da$var$nc, $8f2285b8ffe719da$var$pc = Math.log, $8f2285b8ffe719da$var$qc = Math.LN2;
function $8f2285b8ffe719da$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($8f2285b8ffe719da$var$pc(a) / $8f2285b8ffe719da$var$qc | 0) | 0;
}
var $8f2285b8ffe719da$var$rc = 64, $8f2285b8ffe719da$var$sc = 4194304;
function $8f2285b8ffe719da$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $8f2285b8ffe719da$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $8f2285b8ffe719da$var$tc(h) : (f &= g, 0 !== f && (d = $8f2285b8ffe719da$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $8f2285b8ffe719da$var$tc(g) : 0 !== f && (d = $8f2285b8ffe719da$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $8f2285b8ffe719da$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $8f2285b8ffe719da$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $8f2285b8ffe719da$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $8f2285b8ffe719da$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $8f2285b8ffe719da$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $8f2285b8ffe719da$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $8f2285b8ffe719da$var$yc() {
    var a = $8f2285b8ffe719da$var$rc;
    $8f2285b8ffe719da$var$rc <<= 1;
    0 === ($8f2285b8ffe719da$var$rc & 4194240) && ($8f2285b8ffe719da$var$rc = 64);
    return a;
}
function $8f2285b8ffe719da$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $8f2285b8ffe719da$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $8f2285b8ffe719da$var$oc(b);
    a[b] = c;
}
function $8f2285b8ffe719da$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $8f2285b8ffe719da$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $8f2285b8ffe719da$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $8f2285b8ffe719da$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $8f2285b8ffe719da$var$C = 0;
function $8f2285b8ffe719da$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $8f2285b8ffe719da$var$Ec, $8f2285b8ffe719da$var$Fc, $8f2285b8ffe719da$var$Gc, $8f2285b8ffe719da$var$Hc, $8f2285b8ffe719da$var$Ic, $8f2285b8ffe719da$var$Jc = !1, $8f2285b8ffe719da$var$Kc = [], $8f2285b8ffe719da$var$Lc = null, $8f2285b8ffe719da$var$Mc = null, $8f2285b8ffe719da$var$Nc = null, $8f2285b8ffe719da$var$Oc = new Map, $8f2285b8ffe719da$var$Pc = new Map, $8f2285b8ffe719da$var$Qc = [], $8f2285b8ffe719da$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $8f2285b8ffe719da$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $8f2285b8ffe719da$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $8f2285b8ffe719da$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $8f2285b8ffe719da$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $8f2285b8ffe719da$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $8f2285b8ffe719da$var$Pc.delete(b.pointerId);
    }
}
function $8f2285b8ffe719da$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $8f2285b8ffe719da$var$Cb(b), null !== b && $8f2285b8ffe719da$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $8f2285b8ffe719da$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $8f2285b8ffe719da$var$Lc = $8f2285b8ffe719da$var$Tc($8f2285b8ffe719da$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $8f2285b8ffe719da$var$Mc = $8f2285b8ffe719da$var$Tc($8f2285b8ffe719da$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $8f2285b8ffe719da$var$Nc = $8f2285b8ffe719da$var$Tc($8f2285b8ffe719da$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $8f2285b8ffe719da$var$Oc.set(f, $8f2285b8ffe719da$var$Tc($8f2285b8ffe719da$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $8f2285b8ffe719da$var$Pc.set(f, $8f2285b8ffe719da$var$Tc($8f2285b8ffe719da$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $8f2285b8ffe719da$var$Vc(a) {
    var b = $8f2285b8ffe719da$var$Wc(a.target);
    if (null !== b) {
        var c = $8f2285b8ffe719da$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $8f2285b8ffe719da$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $8f2285b8ffe719da$var$Ic(a.priority, function() {
                        $8f2285b8ffe719da$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $8f2285b8ffe719da$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $8f2285b8ffe719da$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $8f2285b8ffe719da$var$wb = d;
            c.target.dispatchEvent(d);
            $8f2285b8ffe719da$var$wb = null;
        } else return b = $8f2285b8ffe719da$var$Cb(c), null !== b && $8f2285b8ffe719da$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $8f2285b8ffe719da$var$Zc(a, b, c) {
    $8f2285b8ffe719da$var$Xc(a) && c.delete(b);
}
function $8f2285b8ffe719da$var$$c() {
    $8f2285b8ffe719da$var$Jc = !1;
    null !== $8f2285b8ffe719da$var$Lc && $8f2285b8ffe719da$var$Xc($8f2285b8ffe719da$var$Lc) && ($8f2285b8ffe719da$var$Lc = null);
    null !== $8f2285b8ffe719da$var$Mc && $8f2285b8ffe719da$var$Xc($8f2285b8ffe719da$var$Mc) && ($8f2285b8ffe719da$var$Mc = null);
    null !== $8f2285b8ffe719da$var$Nc && $8f2285b8ffe719da$var$Xc($8f2285b8ffe719da$var$Nc) && ($8f2285b8ffe719da$var$Nc = null);
    $8f2285b8ffe719da$var$Oc.forEach($8f2285b8ffe719da$var$Zc);
    $8f2285b8ffe719da$var$Pc.forEach($8f2285b8ffe719da$var$Zc);
}
function $8f2285b8ffe719da$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $8f2285b8ffe719da$var$Jc || ($8f2285b8ffe719da$var$Jc = !0, $e00l3.unstable_scheduleCallback($e00l3.unstable_NormalPriority, $8f2285b8ffe719da$var$$c)));
}
function $8f2285b8ffe719da$var$bd(a) {
    function b(b) {
        return $8f2285b8ffe719da$var$ad(b, a);
    }
    if (0 < $8f2285b8ffe719da$var$Kc.length) {
        $8f2285b8ffe719da$var$ad($8f2285b8ffe719da$var$Kc[0], a);
        for(var c = 1; c < $8f2285b8ffe719da$var$Kc.length; c++){
            var d = $8f2285b8ffe719da$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $8f2285b8ffe719da$var$Lc && $8f2285b8ffe719da$var$ad($8f2285b8ffe719da$var$Lc, a);
    null !== $8f2285b8ffe719da$var$Mc && $8f2285b8ffe719da$var$ad($8f2285b8ffe719da$var$Mc, a);
    null !== $8f2285b8ffe719da$var$Nc && $8f2285b8ffe719da$var$ad($8f2285b8ffe719da$var$Nc, a);
    $8f2285b8ffe719da$var$Oc.forEach(b);
    $8f2285b8ffe719da$var$Pc.forEach(b);
    for(c = 0; c < $8f2285b8ffe719da$var$Qc.length; c++)d = $8f2285b8ffe719da$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $8f2285b8ffe719da$var$Qc.length && (c = $8f2285b8ffe719da$var$Qc[0], null === c.blockedOn);)$8f2285b8ffe719da$var$Vc(c), null === c.blockedOn && $8f2285b8ffe719da$var$Qc.shift();
}
var $8f2285b8ffe719da$var$cd = $8f2285b8ffe719da$var$ua.ReactCurrentBatchConfig, $8f2285b8ffe719da$var$dd = !0;
function $8f2285b8ffe719da$var$ed(a, b, c, d) {
    var e = $8f2285b8ffe719da$var$C, f = $8f2285b8ffe719da$var$cd.transition;
    $8f2285b8ffe719da$var$cd.transition = null;
    try {
        $8f2285b8ffe719da$var$C = 1, $8f2285b8ffe719da$var$fd(a, b, c, d);
    } finally{
        $8f2285b8ffe719da$var$C = e, $8f2285b8ffe719da$var$cd.transition = f;
    }
}
function $8f2285b8ffe719da$var$gd(a, b, c, d) {
    var e = $8f2285b8ffe719da$var$C, f = $8f2285b8ffe719da$var$cd.transition;
    $8f2285b8ffe719da$var$cd.transition = null;
    try {
        $8f2285b8ffe719da$var$C = 4, $8f2285b8ffe719da$var$fd(a, b, c, d);
    } finally{
        $8f2285b8ffe719da$var$C = e, $8f2285b8ffe719da$var$cd.transition = f;
    }
}
function $8f2285b8ffe719da$var$fd(a, b, c, d) {
    if ($8f2285b8ffe719da$var$dd) {
        var e = $8f2285b8ffe719da$var$Yc(a, b, c, d);
        if (null === e) $8f2285b8ffe719da$var$hd(a, b, d, $8f2285b8ffe719da$var$id, c), $8f2285b8ffe719da$var$Sc(a, d);
        else if ($8f2285b8ffe719da$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($8f2285b8ffe719da$var$Sc(a, d), b & 4 && -1 < $8f2285b8ffe719da$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $8f2285b8ffe719da$var$Cb(e);
                null !== f && $8f2285b8ffe719da$var$Ec(f);
                f = $8f2285b8ffe719da$var$Yc(a, b, c, d);
                null === f && $8f2285b8ffe719da$var$hd(a, b, d, $8f2285b8ffe719da$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $8f2285b8ffe719da$var$hd(a, b, d, null, c);
    }
}
var $8f2285b8ffe719da$var$id = null;
function $8f2285b8ffe719da$var$Yc(a, b, c, d) {
    $8f2285b8ffe719da$var$id = null;
    a = $8f2285b8ffe719da$var$xb(d);
    a = $8f2285b8ffe719da$var$Wc(a);
    if (null !== a) {
        if (b = $8f2285b8ffe719da$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $8f2285b8ffe719da$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $8f2285b8ffe719da$var$id = a;
    return null;
}
function $8f2285b8ffe719da$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($8f2285b8ffe719da$var$ec()){
                case $8f2285b8ffe719da$var$fc:
                    return 1;
                case $8f2285b8ffe719da$var$gc:
                    return 4;
                case $8f2285b8ffe719da$var$hc:
                case $8f2285b8ffe719da$var$ic:
                    return 16;
                case $8f2285b8ffe719da$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $8f2285b8ffe719da$var$kd = null, $8f2285b8ffe719da$var$ld = null, $8f2285b8ffe719da$var$md = null;
function $8f2285b8ffe719da$var$nd() {
    if ($8f2285b8ffe719da$var$md) return $8f2285b8ffe719da$var$md;
    var a, b = $8f2285b8ffe719da$var$ld, c = b.length, d, e = "value" in $8f2285b8ffe719da$var$kd ? $8f2285b8ffe719da$var$kd.value : $8f2285b8ffe719da$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $8f2285b8ffe719da$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $8f2285b8ffe719da$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $8f2285b8ffe719da$var$pd() {
    return !0;
}
function $8f2285b8ffe719da$var$qd() {
    return !1;
}
function $8f2285b8ffe719da$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $8f2285b8ffe719da$var$pd : $8f2285b8ffe719da$var$qd;
        this.isPropagationStopped = $8f2285b8ffe719da$var$qd;
        return this;
    }
    $8f2285b8ffe719da$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $8f2285b8ffe719da$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $8f2285b8ffe719da$var$pd);
        },
        persist: function() {},
        isPersistent: $8f2285b8ffe719da$var$pd
    });
    return b;
}
var $8f2285b8ffe719da$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $8f2285b8ffe719da$var$td = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$sd), $8f2285b8ffe719da$var$ud = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$sd, {
    view: 0,
    detail: 0
}), $8f2285b8ffe719da$var$vd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$ud), $8f2285b8ffe719da$var$wd, $8f2285b8ffe719da$var$xd, $8f2285b8ffe719da$var$yd, $8f2285b8ffe719da$var$Ad = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $8f2285b8ffe719da$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $8f2285b8ffe719da$var$yd && ($8f2285b8ffe719da$var$yd && "mousemove" === a.type ? ($8f2285b8ffe719da$var$wd = a.screenX - $8f2285b8ffe719da$var$yd.screenX, $8f2285b8ffe719da$var$xd = a.screenY - $8f2285b8ffe719da$var$yd.screenY) : $8f2285b8ffe719da$var$xd = $8f2285b8ffe719da$var$wd = 0, $8f2285b8ffe719da$var$yd = a);
        return $8f2285b8ffe719da$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $8f2285b8ffe719da$var$xd;
    }
}), $8f2285b8ffe719da$var$Bd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Ad), $8f2285b8ffe719da$var$Cd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$Ad, {
    dataTransfer: 0
}), $8f2285b8ffe719da$var$Dd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Cd), $8f2285b8ffe719da$var$Ed = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$ud, {
    relatedTarget: 0
}), $8f2285b8ffe719da$var$Fd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Ed), $8f2285b8ffe719da$var$Gd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8f2285b8ffe719da$var$Hd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Gd), $8f2285b8ffe719da$var$Id = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $8f2285b8ffe719da$var$Jd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Id), $8f2285b8ffe719da$var$Kd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$sd, {
    data: 0
}), $8f2285b8ffe719da$var$Ld = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Kd), $8f2285b8ffe719da$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $8f2285b8ffe719da$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $8f2285b8ffe719da$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $8f2285b8ffe719da$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $8f2285b8ffe719da$var$Od[a]) ? !!b[a] : !1;
}
function $8f2285b8ffe719da$var$zd() {
    return $8f2285b8ffe719da$var$Pd;
}
var $8f2285b8ffe719da$var$Qd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $8f2285b8ffe719da$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $8f2285b8ffe719da$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $8f2285b8ffe719da$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $8f2285b8ffe719da$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $8f2285b8ffe719da$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $8f2285b8ffe719da$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $8f2285b8ffe719da$var$Rd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Qd), $8f2285b8ffe719da$var$Sd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $8f2285b8ffe719da$var$Td = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Sd), $8f2285b8ffe719da$var$Ud = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $8f2285b8ffe719da$var$zd
}), $8f2285b8ffe719da$var$Vd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Ud), $8f2285b8ffe719da$var$Wd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8f2285b8ffe719da$var$Xd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Wd), $8f2285b8ffe719da$var$Yd = $8f2285b8ffe719da$var$A({}, $8f2285b8ffe719da$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $8f2285b8ffe719da$var$Zd = $8f2285b8ffe719da$var$rd($8f2285b8ffe719da$var$Yd), $8f2285b8ffe719da$var$$d = [
    9,
    13,
    27,
    32
], $8f2285b8ffe719da$var$ae = $8f2285b8ffe719da$var$ia && "CompositionEvent" in window, $8f2285b8ffe719da$var$be = null;
$8f2285b8ffe719da$var$ia && "documentMode" in document && ($8f2285b8ffe719da$var$be = document.documentMode);
var $8f2285b8ffe719da$var$ce = $8f2285b8ffe719da$var$ia && "TextEvent" in window && !$8f2285b8ffe719da$var$be, $8f2285b8ffe719da$var$de = $8f2285b8ffe719da$var$ia && (!$8f2285b8ffe719da$var$ae || $8f2285b8ffe719da$var$be && 8 < $8f2285b8ffe719da$var$be && 11 >= $8f2285b8ffe719da$var$be), $8f2285b8ffe719da$var$ee = String.fromCharCode(32), $8f2285b8ffe719da$var$fe = !1;
function $8f2285b8ffe719da$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $8f2285b8ffe719da$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $8f2285b8ffe719da$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $8f2285b8ffe719da$var$ie = !1;
function $8f2285b8ffe719da$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $8f2285b8ffe719da$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $8f2285b8ffe719da$var$fe = !0;
            return $8f2285b8ffe719da$var$ee;
        case "textInput":
            return a = b.data, a === $8f2285b8ffe719da$var$ee && $8f2285b8ffe719da$var$fe ? null : a;
        default:
            return null;
    }
}
function $8f2285b8ffe719da$var$ke(a, b) {
    if ($8f2285b8ffe719da$var$ie) return "compositionend" === a || !$8f2285b8ffe719da$var$ae && $8f2285b8ffe719da$var$ge(a, b) ? (a = $8f2285b8ffe719da$var$nd(), $8f2285b8ffe719da$var$md = $8f2285b8ffe719da$var$ld = $8f2285b8ffe719da$var$kd = null, $8f2285b8ffe719da$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $8f2285b8ffe719da$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $8f2285b8ffe719da$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $8f2285b8ffe719da$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$8f2285b8ffe719da$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $8f2285b8ffe719da$var$ne(a, b, c, d) {
    $8f2285b8ffe719da$var$Eb(d);
    b = $8f2285b8ffe719da$var$oe(b, "onChange");
    0 < b.length && (c = new $8f2285b8ffe719da$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $8f2285b8ffe719da$var$pe = null, $8f2285b8ffe719da$var$qe = null;
function $8f2285b8ffe719da$var$re(a) {
    $8f2285b8ffe719da$var$se(a, 0);
}
function $8f2285b8ffe719da$var$te(a) {
    var b = $8f2285b8ffe719da$var$ue(a);
    if ($8f2285b8ffe719da$var$Wa(b)) return a;
}
function $8f2285b8ffe719da$var$ve(a, b) {
    if ("change" === a) return b;
}
var $8f2285b8ffe719da$var$we = !1;
if ($8f2285b8ffe719da$var$ia) {
    var $8f2285b8ffe719da$var$xe;
    if ($8f2285b8ffe719da$var$ia) {
        var $8f2285b8ffe719da$var$ye = "oninput" in document;
        if (!$8f2285b8ffe719da$var$ye) {
            var $8f2285b8ffe719da$var$ze = document.createElement("div");
            $8f2285b8ffe719da$var$ze.setAttribute("oninput", "return;");
            $8f2285b8ffe719da$var$ye = "function" === typeof $8f2285b8ffe719da$var$ze.oninput;
        }
        $8f2285b8ffe719da$var$xe = $8f2285b8ffe719da$var$ye;
    } else $8f2285b8ffe719da$var$xe = !1;
    $8f2285b8ffe719da$var$we = $8f2285b8ffe719da$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $8f2285b8ffe719da$var$Ae() {
    $8f2285b8ffe719da$var$pe && ($8f2285b8ffe719da$var$pe.detachEvent("onpropertychange", $8f2285b8ffe719da$var$Be), $8f2285b8ffe719da$var$qe = $8f2285b8ffe719da$var$pe = null);
}
function $8f2285b8ffe719da$var$Be(a) {
    if ("value" === a.propertyName && $8f2285b8ffe719da$var$te($8f2285b8ffe719da$var$qe)) {
        var b = [];
        $8f2285b8ffe719da$var$ne(b, $8f2285b8ffe719da$var$qe, a, $8f2285b8ffe719da$var$xb(a));
        $8f2285b8ffe719da$var$Jb($8f2285b8ffe719da$var$re, b);
    }
}
function $8f2285b8ffe719da$var$Ce(a, b, c) {
    "focusin" === a ? ($8f2285b8ffe719da$var$Ae(), $8f2285b8ffe719da$var$pe = b, $8f2285b8ffe719da$var$qe = c, $8f2285b8ffe719da$var$pe.attachEvent("onpropertychange", $8f2285b8ffe719da$var$Be)) : "focusout" === a && $8f2285b8ffe719da$var$Ae();
}
function $8f2285b8ffe719da$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $8f2285b8ffe719da$var$te($8f2285b8ffe719da$var$qe);
}
function $8f2285b8ffe719da$var$Ee(a, b) {
    if ("click" === a) return $8f2285b8ffe719da$var$te(b);
}
function $8f2285b8ffe719da$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $8f2285b8ffe719da$var$te(b);
}
function $8f2285b8ffe719da$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8f2285b8ffe719da$var$He = "function" === typeof Object.is ? Object.is : $8f2285b8ffe719da$var$Ge;
function $8f2285b8ffe719da$var$Ie(a, b) {
    if ($8f2285b8ffe719da$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$8f2285b8ffe719da$var$ja.call(b, e) || !$8f2285b8ffe719da$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $8f2285b8ffe719da$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $8f2285b8ffe719da$var$Ke(a, b) {
    var c = $8f2285b8ffe719da$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $8f2285b8ffe719da$var$Je(c);
    }
}
function $8f2285b8ffe719da$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $8f2285b8ffe719da$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $8f2285b8ffe719da$var$Me() {
    for(var a = window, b = $8f2285b8ffe719da$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $8f2285b8ffe719da$var$Xa(a.document);
    }
    return b;
}
function $8f2285b8ffe719da$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $8f2285b8ffe719da$var$Oe(a) {
    var b = $8f2285b8ffe719da$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $8f2285b8ffe719da$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $8f2285b8ffe719da$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $8f2285b8ffe719da$var$Ke(c, f);
                var g = $8f2285b8ffe719da$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $8f2285b8ffe719da$var$Pe = $8f2285b8ffe719da$var$ia && "documentMode" in document && 11 >= document.documentMode, $8f2285b8ffe719da$var$Qe = null, $8f2285b8ffe719da$var$Re = null, $8f2285b8ffe719da$var$Se = null, $8f2285b8ffe719da$var$Te = !1;
function $8f2285b8ffe719da$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $8f2285b8ffe719da$var$Te || null == $8f2285b8ffe719da$var$Qe || $8f2285b8ffe719da$var$Qe !== $8f2285b8ffe719da$var$Xa(d) || (d = $8f2285b8ffe719da$var$Qe, "selectionStart" in d && $8f2285b8ffe719da$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $8f2285b8ffe719da$var$Se && $8f2285b8ffe719da$var$Ie($8f2285b8ffe719da$var$Se, d) || ($8f2285b8ffe719da$var$Se = d, d = $8f2285b8ffe719da$var$oe($8f2285b8ffe719da$var$Re, "onSelect"), 0 < d.length && (b = new $8f2285b8ffe719da$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $8f2285b8ffe719da$var$Qe)));
}
function $8f2285b8ffe719da$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $8f2285b8ffe719da$var$We = {
    animationend: $8f2285b8ffe719da$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $8f2285b8ffe719da$var$Ve("Animation", "AnimationIteration"),
    animationstart: $8f2285b8ffe719da$var$Ve("Animation", "AnimationStart"),
    transitionend: $8f2285b8ffe719da$var$Ve("Transition", "TransitionEnd")
}, $8f2285b8ffe719da$var$Xe = {}, $8f2285b8ffe719da$var$Ye = {};
$8f2285b8ffe719da$var$ia && ($8f2285b8ffe719da$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $8f2285b8ffe719da$var$We.animationend.animation, delete $8f2285b8ffe719da$var$We.animationiteration.animation, delete $8f2285b8ffe719da$var$We.animationstart.animation), "TransitionEvent" in window || delete $8f2285b8ffe719da$var$We.transitionend.transition);
function $8f2285b8ffe719da$var$Ze(a) {
    if ($8f2285b8ffe719da$var$Xe[a]) return $8f2285b8ffe719da$var$Xe[a];
    if (!$8f2285b8ffe719da$var$We[a]) return a;
    var b = $8f2285b8ffe719da$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $8f2285b8ffe719da$var$Ye) return $8f2285b8ffe719da$var$Xe[a] = b[c];
    return a;
}
var $8f2285b8ffe719da$var$$e = $8f2285b8ffe719da$var$Ze("animationend"), $8f2285b8ffe719da$var$af = $8f2285b8ffe719da$var$Ze("animationiteration"), $8f2285b8ffe719da$var$bf = $8f2285b8ffe719da$var$Ze("animationstart"), $8f2285b8ffe719da$var$cf = $8f2285b8ffe719da$var$Ze("transitionend"), $8f2285b8ffe719da$var$df = new Map, $8f2285b8ffe719da$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $8f2285b8ffe719da$var$ff(a, b) {
    $8f2285b8ffe719da$var$df.set(a, b);
    $8f2285b8ffe719da$var$fa(b, [
        a
    ]);
}
for(var $8f2285b8ffe719da$var$gf = 0; $8f2285b8ffe719da$var$gf < $8f2285b8ffe719da$var$ef.length; $8f2285b8ffe719da$var$gf++){
    var $8f2285b8ffe719da$var$hf = $8f2285b8ffe719da$var$ef[$8f2285b8ffe719da$var$gf], $8f2285b8ffe719da$var$jf = $8f2285b8ffe719da$var$hf.toLowerCase(), $8f2285b8ffe719da$var$kf = $8f2285b8ffe719da$var$hf[0].toUpperCase() + $8f2285b8ffe719da$var$hf.slice(1);
    $8f2285b8ffe719da$var$ff($8f2285b8ffe719da$var$jf, "on" + $8f2285b8ffe719da$var$kf);
}
$8f2285b8ffe719da$var$ff($8f2285b8ffe719da$var$$e, "onAnimationEnd");
$8f2285b8ffe719da$var$ff($8f2285b8ffe719da$var$af, "onAnimationIteration");
$8f2285b8ffe719da$var$ff($8f2285b8ffe719da$var$bf, "onAnimationStart");
$8f2285b8ffe719da$var$ff("dblclick", "onDoubleClick");
$8f2285b8ffe719da$var$ff("focusin", "onFocus");
$8f2285b8ffe719da$var$ff("focusout", "onBlur");
$8f2285b8ffe719da$var$ff($8f2285b8ffe719da$var$cf, "onTransitionEnd");
$8f2285b8ffe719da$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$8f2285b8ffe719da$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$8f2285b8ffe719da$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$8f2285b8ffe719da$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$8f2285b8ffe719da$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$8f2285b8ffe719da$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$8f2285b8ffe719da$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$8f2285b8ffe719da$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$8f2285b8ffe719da$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$8f2285b8ffe719da$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $8f2285b8ffe719da$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $8f2285b8ffe719da$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($8f2285b8ffe719da$var$lf));
function $8f2285b8ffe719da$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $8f2285b8ffe719da$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $8f2285b8ffe719da$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8f2285b8ffe719da$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8f2285b8ffe719da$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($8f2285b8ffe719da$var$Qb) throw a = $8f2285b8ffe719da$var$Rb, $8f2285b8ffe719da$var$Qb = !1, $8f2285b8ffe719da$var$Rb = null, a;
}
function $8f2285b8ffe719da$var$D(a, b) {
    var c = b[$8f2285b8ffe719da$var$of];
    void 0 === c && (c = b[$8f2285b8ffe719da$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($8f2285b8ffe719da$var$pf(b, a, 2, !1), c.add(d));
}
function $8f2285b8ffe719da$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $8f2285b8ffe719da$var$pf(c, a, d, b);
}
var $8f2285b8ffe719da$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $8f2285b8ffe719da$var$sf(a) {
    if (!a[$8f2285b8ffe719da$var$rf]) {
        a[$8f2285b8ffe719da$var$rf] = !0;
        $8f2285b8ffe719da$var$da.forEach(function(b) {
            "selectionchange" !== b && ($8f2285b8ffe719da$var$mf.has(b) || $8f2285b8ffe719da$var$qf(b, !1, a), $8f2285b8ffe719da$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$8f2285b8ffe719da$var$rf] || (b[$8f2285b8ffe719da$var$rf] = !0, $8f2285b8ffe719da$var$qf("selectionchange", !1, b));
    }
}
function $8f2285b8ffe719da$var$pf(a, b, c, d) {
    switch($8f2285b8ffe719da$var$jd(b)){
        case 1:
            var e = $8f2285b8ffe719da$var$ed;
            break;
        case 4:
            e = $8f2285b8ffe719da$var$gd;
            break;
        default:
            e = $8f2285b8ffe719da$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$8f2285b8ffe719da$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $8f2285b8ffe719da$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $8f2285b8ffe719da$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $8f2285b8ffe719da$var$Jb(function() {
        var d = f, e = $8f2285b8ffe719da$var$xb(c), g = [];
        a: {
            var h = $8f2285b8ffe719da$var$df.get(a);
            if (void 0 !== h) {
                var k = $8f2285b8ffe719da$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $8f2285b8ffe719da$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $8f2285b8ffe719da$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $8f2285b8ffe719da$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $8f2285b8ffe719da$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $8f2285b8ffe719da$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $8f2285b8ffe719da$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $8f2285b8ffe719da$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $8f2285b8ffe719da$var$Vd;
                        break;
                    case $8f2285b8ffe719da$var$$e:
                    case $8f2285b8ffe719da$var$af:
                    case $8f2285b8ffe719da$var$bf:
                        k = $8f2285b8ffe719da$var$Hd;
                        break;
                    case $8f2285b8ffe719da$var$cf:
                        k = $8f2285b8ffe719da$var$Xd;
                        break;
                    case "scroll":
                        k = $8f2285b8ffe719da$var$vd;
                        break;
                    case "wheel":
                        k = $8f2285b8ffe719da$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $8f2285b8ffe719da$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $8f2285b8ffe719da$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $8f2285b8ffe719da$var$Kb(w, x), null != F && t.push($8f2285b8ffe719da$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $8f2285b8ffe719da$var$wb && (n = c.relatedTarget || c.fromElement) && ($8f2285b8ffe719da$var$Wc(n) || n[$8f2285b8ffe719da$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $8f2285b8ffe719da$var$Wc(n) : null, null !== n && (J = $8f2285b8ffe719da$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $8f2285b8ffe719da$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $8f2285b8ffe719da$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $8f2285b8ffe719da$var$ue(k);
                        u = null == n ? h : $8f2285b8ffe719da$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $8f2285b8ffe719da$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $8f2285b8ffe719da$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $8f2285b8ffe719da$var$vf(F))u++;
                            for(; 0 < w - u;)t = $8f2285b8ffe719da$var$vf(t), w--;
                            for(; 0 < u - w;)x = $8f2285b8ffe719da$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $8f2285b8ffe719da$var$vf(t);
                                x = $8f2285b8ffe719da$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $8f2285b8ffe719da$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $8f2285b8ffe719da$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $8f2285b8ffe719da$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $8f2285b8ffe719da$var$ve;
                else if ($8f2285b8ffe719da$var$me(h)) {
                    if ($8f2285b8ffe719da$var$we) na = $8f2285b8ffe719da$var$Fe;
                    else {
                        na = $8f2285b8ffe719da$var$De;
                        var xa = $8f2285b8ffe719da$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $8f2285b8ffe719da$var$Ee);
                if (na && (na = na(a, d))) {
                    $8f2285b8ffe719da$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $8f2285b8ffe719da$var$cb(h, "number", h.value);
            }
            xa = d ? $8f2285b8ffe719da$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($8f2285b8ffe719da$var$me(xa) || "true" === xa.contentEditable) $8f2285b8ffe719da$var$Qe = xa, $8f2285b8ffe719da$var$Re = d, $8f2285b8ffe719da$var$Se = null;
                    break;
                case "focusout":
                    $8f2285b8ffe719da$var$Se = $8f2285b8ffe719da$var$Re = $8f2285b8ffe719da$var$Qe = null;
                    break;
                case "mousedown":
                    $8f2285b8ffe719da$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $8f2285b8ffe719da$var$Te = !1;
                    $8f2285b8ffe719da$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($8f2285b8ffe719da$var$Pe) break;
                case "keydown":
                case "keyup":
                    $8f2285b8ffe719da$var$Ue(g, c, e);
            }
            var $a;
            if ($8f2285b8ffe719da$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $8f2285b8ffe719da$var$ie ? $8f2285b8ffe719da$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($8f2285b8ffe719da$var$de && "ko" !== c.locale && ($8f2285b8ffe719da$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $8f2285b8ffe719da$var$ie && ($a = $8f2285b8ffe719da$var$nd()) : ($8f2285b8ffe719da$var$kd = e, $8f2285b8ffe719da$var$ld = "value" in $8f2285b8ffe719da$var$kd ? $8f2285b8ffe719da$var$kd.value : $8f2285b8ffe719da$var$kd.textContent, $8f2285b8ffe719da$var$ie = !0)), xa = $8f2285b8ffe719da$var$oe(d, ba), 0 < xa.length && (ba = new $8f2285b8ffe719da$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $8f2285b8ffe719da$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $8f2285b8ffe719da$var$ce ? $8f2285b8ffe719da$var$je(a, c) : $8f2285b8ffe719da$var$ke(a, c)) d = $8f2285b8ffe719da$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $8f2285b8ffe719da$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $8f2285b8ffe719da$var$se(g, b);
    });
}
function $8f2285b8ffe719da$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $8f2285b8ffe719da$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $8f2285b8ffe719da$var$Kb(a, c), null != f && d.unshift($8f2285b8ffe719da$var$tf(a, f, e)), f = $8f2285b8ffe719da$var$Kb(a, b), null != f && d.push($8f2285b8ffe719da$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $8f2285b8ffe719da$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $8f2285b8ffe719da$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $8f2285b8ffe719da$var$Kb(c, f), null != k && g.unshift($8f2285b8ffe719da$var$tf(c, k, h))) : e || (k = $8f2285b8ffe719da$var$Kb(c, f), null != k && g.push($8f2285b8ffe719da$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $8f2285b8ffe719da$var$xf = /\r\n?/g, $8f2285b8ffe719da$var$yf = /\u0000|\uFFFD/g;
function $8f2285b8ffe719da$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($8f2285b8ffe719da$var$xf, "\n").replace($8f2285b8ffe719da$var$yf, "");
}
function $8f2285b8ffe719da$var$Af(a, b, c) {
    b = $8f2285b8ffe719da$var$zf(b);
    if ($8f2285b8ffe719da$var$zf(a) !== b && c) throw Error($8f2285b8ffe719da$var$p(425));
}
function $8f2285b8ffe719da$var$Bf() {}
var $8f2285b8ffe719da$var$Cf = null, $8f2285b8ffe719da$var$Df = null;
function $8f2285b8ffe719da$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $8f2285b8ffe719da$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $8f2285b8ffe719da$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $8f2285b8ffe719da$var$Hf = "function" === typeof Promise ? Promise : void 0, $8f2285b8ffe719da$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $8f2285b8ffe719da$var$Hf ? function(a) {
    return $8f2285b8ffe719da$var$Hf.resolve(null).then(a).catch($8f2285b8ffe719da$var$If);
} : $8f2285b8ffe719da$var$Ff;
function $8f2285b8ffe719da$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $8f2285b8ffe719da$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $8f2285b8ffe719da$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $8f2285b8ffe719da$var$bd(b);
}
function $8f2285b8ffe719da$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $8f2285b8ffe719da$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $8f2285b8ffe719da$var$Nf = Math.random().toString(36).slice(2), $8f2285b8ffe719da$var$Of = "__reactFiber$" + $8f2285b8ffe719da$var$Nf, $8f2285b8ffe719da$var$Pf = "__reactProps$" + $8f2285b8ffe719da$var$Nf, $8f2285b8ffe719da$var$uf = "__reactContainer$" + $8f2285b8ffe719da$var$Nf, $8f2285b8ffe719da$var$of = "__reactEvents$" + $8f2285b8ffe719da$var$Nf, $8f2285b8ffe719da$var$Qf = "__reactListeners$" + $8f2285b8ffe719da$var$Nf, $8f2285b8ffe719da$var$Rf = "__reactHandles$" + $8f2285b8ffe719da$var$Nf;
function $8f2285b8ffe719da$var$Wc(a) {
    var b = a[$8f2285b8ffe719da$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$8f2285b8ffe719da$var$uf] || c[$8f2285b8ffe719da$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $8f2285b8ffe719da$var$Mf(a); null !== a;){
                if (c = a[$8f2285b8ffe719da$var$Of]) return c;
                a = $8f2285b8ffe719da$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $8f2285b8ffe719da$var$Cb(a) {
    a = a[$8f2285b8ffe719da$var$Of] || a[$8f2285b8ffe719da$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $8f2285b8ffe719da$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($8f2285b8ffe719da$var$p(33));
}
function $8f2285b8ffe719da$var$Db(a) {
    return a[$8f2285b8ffe719da$var$Pf] || null;
}
var $8f2285b8ffe719da$var$Sf = [], $8f2285b8ffe719da$var$Tf = -1;
function $8f2285b8ffe719da$var$Uf(a) {
    return {
        current: a
    };
}
function $8f2285b8ffe719da$var$E(a) {
    0 > $8f2285b8ffe719da$var$Tf || (a.current = $8f2285b8ffe719da$var$Sf[$8f2285b8ffe719da$var$Tf], $8f2285b8ffe719da$var$Sf[$8f2285b8ffe719da$var$Tf] = null, $8f2285b8ffe719da$var$Tf--);
}
function $8f2285b8ffe719da$var$G(a, b) {
    $8f2285b8ffe719da$var$Tf++;
    $8f2285b8ffe719da$var$Sf[$8f2285b8ffe719da$var$Tf] = a.current;
    a.current = b;
}
var $8f2285b8ffe719da$var$Vf = {}, $8f2285b8ffe719da$var$H = $8f2285b8ffe719da$var$Uf($8f2285b8ffe719da$var$Vf), $8f2285b8ffe719da$var$Wf = $8f2285b8ffe719da$var$Uf(!1), $8f2285b8ffe719da$var$Xf = $8f2285b8ffe719da$var$Vf;
function $8f2285b8ffe719da$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $8f2285b8ffe719da$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $8f2285b8ffe719da$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $8f2285b8ffe719da$var$$f() {
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf);
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$H);
}
function $8f2285b8ffe719da$var$ag(a, b, c) {
    if ($8f2285b8ffe719da$var$H.current !== $8f2285b8ffe719da$var$Vf) throw Error($8f2285b8ffe719da$var$p(168));
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$H, b);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$Wf, c);
}
function $8f2285b8ffe719da$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($8f2285b8ffe719da$var$p(108, $8f2285b8ffe719da$var$Ra(a) || "Unknown", e));
    return $8f2285b8ffe719da$var$A({}, c, d);
}
function $8f2285b8ffe719da$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $8f2285b8ffe719da$var$Vf;
    $8f2285b8ffe719da$var$Xf = $8f2285b8ffe719da$var$H.current;
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$H, a);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$Wf, $8f2285b8ffe719da$var$Wf.current);
    return !0;
}
function $8f2285b8ffe719da$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($8f2285b8ffe719da$var$p(169));
    c ? (a = $8f2285b8ffe719da$var$bg(a, b, $8f2285b8ffe719da$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf), $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$H), $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$H, a)) : $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$Wf, c);
}
var $8f2285b8ffe719da$var$eg = null, $8f2285b8ffe719da$var$fg = !1, $8f2285b8ffe719da$var$gg = !1;
function $8f2285b8ffe719da$var$hg(a) {
    null === $8f2285b8ffe719da$var$eg ? $8f2285b8ffe719da$var$eg = [
        a
    ] : $8f2285b8ffe719da$var$eg.push(a);
}
function $8f2285b8ffe719da$var$ig(a) {
    $8f2285b8ffe719da$var$fg = !0;
    $8f2285b8ffe719da$var$hg(a);
}
function $8f2285b8ffe719da$var$jg() {
    if (!$8f2285b8ffe719da$var$gg && null !== $8f2285b8ffe719da$var$eg) {
        $8f2285b8ffe719da$var$gg = !0;
        var a = 0, b = $8f2285b8ffe719da$var$C;
        try {
            var c = $8f2285b8ffe719da$var$eg;
            for($8f2285b8ffe719da$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $8f2285b8ffe719da$var$eg = null;
            $8f2285b8ffe719da$var$fg = !1;
        } catch (e) {
            throw null !== $8f2285b8ffe719da$var$eg && ($8f2285b8ffe719da$var$eg = $8f2285b8ffe719da$var$eg.slice(a + 1)), $8f2285b8ffe719da$var$ac($8f2285b8ffe719da$var$fc, $8f2285b8ffe719da$var$jg), e;
        } finally{
            $8f2285b8ffe719da$var$C = b, $8f2285b8ffe719da$var$gg = !1;
        }
    }
    return null;
}
var $8f2285b8ffe719da$var$kg = [], $8f2285b8ffe719da$var$lg = 0, $8f2285b8ffe719da$var$mg = null, $8f2285b8ffe719da$var$ng = 0, $8f2285b8ffe719da$var$og = [], $8f2285b8ffe719da$var$pg = 0, $8f2285b8ffe719da$var$qg = null, $8f2285b8ffe719da$var$rg = 1, $8f2285b8ffe719da$var$sg = "";
function $8f2285b8ffe719da$var$tg(a, b) {
    $8f2285b8ffe719da$var$kg[$8f2285b8ffe719da$var$lg++] = $8f2285b8ffe719da$var$ng;
    $8f2285b8ffe719da$var$kg[$8f2285b8ffe719da$var$lg++] = $8f2285b8ffe719da$var$mg;
    $8f2285b8ffe719da$var$mg = a;
    $8f2285b8ffe719da$var$ng = b;
}
function $8f2285b8ffe719da$var$ug(a, b, c) {
    $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$rg;
    $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$sg;
    $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$qg;
    $8f2285b8ffe719da$var$qg = a;
    var d = $8f2285b8ffe719da$var$rg;
    a = $8f2285b8ffe719da$var$sg;
    var e = 32 - $8f2285b8ffe719da$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $8f2285b8ffe719da$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $8f2285b8ffe719da$var$rg = 1 << 32 - $8f2285b8ffe719da$var$oc(b) + e | c << e | d;
        $8f2285b8ffe719da$var$sg = f + a;
    } else $8f2285b8ffe719da$var$rg = 1 << f | c << e | d, $8f2285b8ffe719da$var$sg = a;
}
function $8f2285b8ffe719da$var$vg(a) {
    null !== a.return && ($8f2285b8ffe719da$var$tg(a, 1), $8f2285b8ffe719da$var$ug(a, 1, 0));
}
function $8f2285b8ffe719da$var$wg(a) {
    for(; a === $8f2285b8ffe719da$var$mg;)$8f2285b8ffe719da$var$mg = $8f2285b8ffe719da$var$kg[--$8f2285b8ffe719da$var$lg], $8f2285b8ffe719da$var$kg[$8f2285b8ffe719da$var$lg] = null, $8f2285b8ffe719da$var$ng = $8f2285b8ffe719da$var$kg[--$8f2285b8ffe719da$var$lg], $8f2285b8ffe719da$var$kg[$8f2285b8ffe719da$var$lg] = null;
    for(; a === $8f2285b8ffe719da$var$qg;)$8f2285b8ffe719da$var$qg = $8f2285b8ffe719da$var$og[--$8f2285b8ffe719da$var$pg], $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg] = null, $8f2285b8ffe719da$var$sg = $8f2285b8ffe719da$var$og[--$8f2285b8ffe719da$var$pg], $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg] = null, $8f2285b8ffe719da$var$rg = $8f2285b8ffe719da$var$og[--$8f2285b8ffe719da$var$pg], $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg] = null;
}
var $8f2285b8ffe719da$var$xg = null, $8f2285b8ffe719da$var$yg = null, $8f2285b8ffe719da$var$I = !1, $8f2285b8ffe719da$var$zg = null;
function $8f2285b8ffe719da$var$Ag(a, b) {
    var c = $8f2285b8ffe719da$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $8f2285b8ffe719da$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $8f2285b8ffe719da$var$xg = a, $8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $8f2285b8ffe719da$var$xg = a, $8f2285b8ffe719da$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $8f2285b8ffe719da$var$qg ? {
                id: $8f2285b8ffe719da$var$rg,
                overflow: $8f2285b8ffe719da$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $8f2285b8ffe719da$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $8f2285b8ffe719da$var$xg = a, $8f2285b8ffe719da$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $8f2285b8ffe719da$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $8f2285b8ffe719da$var$Eg(a) {
    if ($8f2285b8ffe719da$var$I) {
        var b = $8f2285b8ffe719da$var$yg;
        if (b) {
            var c = b;
            if (!$8f2285b8ffe719da$var$Cg(a, b)) {
                if ($8f2285b8ffe719da$var$Dg(a)) throw Error($8f2285b8ffe719da$var$p(418));
                b = $8f2285b8ffe719da$var$Lf(c.nextSibling);
                var d = $8f2285b8ffe719da$var$xg;
                b && $8f2285b8ffe719da$var$Cg(a, b) ? $8f2285b8ffe719da$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $8f2285b8ffe719da$var$I = !1, $8f2285b8ffe719da$var$xg = a);
            }
        } else {
            if ($8f2285b8ffe719da$var$Dg(a)) throw Error($8f2285b8ffe719da$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $8f2285b8ffe719da$var$I = !1;
            $8f2285b8ffe719da$var$xg = a;
        }
    }
}
function $8f2285b8ffe719da$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $8f2285b8ffe719da$var$xg = a;
}
function $8f2285b8ffe719da$var$Gg(a) {
    if (a !== $8f2285b8ffe719da$var$xg) return !1;
    if (!$8f2285b8ffe719da$var$I) return $8f2285b8ffe719da$var$Fg(a), $8f2285b8ffe719da$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$8f2285b8ffe719da$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $8f2285b8ffe719da$var$yg)) {
        if ($8f2285b8ffe719da$var$Dg(a)) throw $8f2285b8ffe719da$var$Hg(), Error($8f2285b8ffe719da$var$p(418));
        for(; b;)$8f2285b8ffe719da$var$Ag(a, b), b = $8f2285b8ffe719da$var$Lf(b.nextSibling);
    }
    $8f2285b8ffe719da$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($8f2285b8ffe719da$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $8f2285b8ffe719da$var$yg = null;
        }
    } else $8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$xg ? $8f2285b8ffe719da$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $8f2285b8ffe719da$var$Hg() {
    for(var a = $8f2285b8ffe719da$var$yg; a;)a = $8f2285b8ffe719da$var$Lf(a.nextSibling);
}
function $8f2285b8ffe719da$var$Ig() {
    $8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$xg = null;
    $8f2285b8ffe719da$var$I = !1;
}
function $8f2285b8ffe719da$var$Jg(a) {
    null === $8f2285b8ffe719da$var$zg ? $8f2285b8ffe719da$var$zg = [
        a
    ] : $8f2285b8ffe719da$var$zg.push(a);
}
var $8f2285b8ffe719da$var$Kg = $8f2285b8ffe719da$var$ua.ReactCurrentBatchConfig;
function $8f2285b8ffe719da$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($8f2285b8ffe719da$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($8f2285b8ffe719da$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($8f2285b8ffe719da$var$p(284));
        if (!c._owner) throw Error($8f2285b8ffe719da$var$p(290, a));
    }
    return a;
}
function $8f2285b8ffe719da$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($8f2285b8ffe719da$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $8f2285b8ffe719da$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $8f2285b8ffe719da$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $8f2285b8ffe719da$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $8f2285b8ffe719da$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $8f2285b8ffe719da$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $8f2285b8ffe719da$var$Ha && $8f2285b8ffe719da$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $8f2285b8ffe719da$var$Lg(a, b, c), d.return = a, d;
        d = $8f2285b8ffe719da$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $8f2285b8ffe719da$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $8f2285b8ffe719da$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $8f2285b8ffe719da$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $8f2285b8ffe719da$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $8f2285b8ffe719da$var$va:
                    return c = $8f2285b8ffe719da$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $8f2285b8ffe719da$var$Lg(a, null, b), c.return = a, c;
                case $8f2285b8ffe719da$var$wa:
                    return b = $8f2285b8ffe719da$var$Sg(b, a.mode, c), b.return = a, b;
                case $8f2285b8ffe719da$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($8f2285b8ffe719da$var$eb(b) || $8f2285b8ffe719da$var$Ka(b)) return b = $8f2285b8ffe719da$var$Tg(b, a.mode, c, null), b.return = a, b;
            $8f2285b8ffe719da$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $8f2285b8ffe719da$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $8f2285b8ffe719da$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $8f2285b8ffe719da$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($8f2285b8ffe719da$var$eb(c) || $8f2285b8ffe719da$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $8f2285b8ffe719da$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $8f2285b8ffe719da$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $8f2285b8ffe719da$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $8f2285b8ffe719da$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($8f2285b8ffe719da$var$eb(d) || $8f2285b8ffe719da$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $8f2285b8ffe719da$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $8f2285b8ffe719da$var$Ka(h);
        if ("function" !== typeof l) throw Error($8f2285b8ffe719da$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($8f2285b8ffe719da$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $8f2285b8ffe719da$var$I && $8f2285b8ffe719da$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $8f2285b8ffe719da$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $8f2285b8ffe719da$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $8f2285b8ffe719da$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $8f2285b8ffe719da$var$Ha && $8f2285b8ffe719da$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $8f2285b8ffe719da$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $8f2285b8ffe719da$var$ya ? (d = $8f2285b8ffe719da$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $8f2285b8ffe719da$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $8f2285b8ffe719da$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $8f2285b8ffe719da$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $8f2285b8ffe719da$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $8f2285b8ffe719da$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($8f2285b8ffe719da$var$eb(f)) return n(a, d, f, h);
            if ($8f2285b8ffe719da$var$Ka(f)) return t(a, d, f, h);
            $8f2285b8ffe719da$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $8f2285b8ffe719da$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $8f2285b8ffe719da$var$Ug = $8f2285b8ffe719da$var$Og(!0), $8f2285b8ffe719da$var$Vg = $8f2285b8ffe719da$var$Og(!1), $8f2285b8ffe719da$var$Wg = $8f2285b8ffe719da$var$Uf(null), $8f2285b8ffe719da$var$Xg = null, $8f2285b8ffe719da$var$Yg = null, $8f2285b8ffe719da$var$Zg = null;
function $8f2285b8ffe719da$var$$g() {
    $8f2285b8ffe719da$var$Zg = $8f2285b8ffe719da$var$Yg = $8f2285b8ffe719da$var$Xg = null;
}
function $8f2285b8ffe719da$var$ah(a) {
    var b = $8f2285b8ffe719da$var$Wg.current;
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wg);
    a._currentValue = b;
}
function $8f2285b8ffe719da$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $8f2285b8ffe719da$var$ch(a, b) {
    $8f2285b8ffe719da$var$Xg = a;
    $8f2285b8ffe719da$var$Zg = $8f2285b8ffe719da$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($8f2285b8ffe719da$var$dh = !0), a.firstContext = null);
}
function $8f2285b8ffe719da$var$eh(a) {
    var b = a._currentValue;
    if ($8f2285b8ffe719da$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $8f2285b8ffe719da$var$Yg) {
            if (null === $8f2285b8ffe719da$var$Xg) throw Error($8f2285b8ffe719da$var$p(308));
            $8f2285b8ffe719da$var$Yg = a;
            $8f2285b8ffe719da$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $8f2285b8ffe719da$var$Yg = $8f2285b8ffe719da$var$Yg.next = a;
    }
    return b;
}
var $8f2285b8ffe719da$var$fh = null;
function $8f2285b8ffe719da$var$gh(a) {
    null === $8f2285b8ffe719da$var$fh ? $8f2285b8ffe719da$var$fh = [
        a
    ] : $8f2285b8ffe719da$var$fh.push(a);
}
function $8f2285b8ffe719da$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $8f2285b8ffe719da$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $8f2285b8ffe719da$var$ih(a, d);
}
function $8f2285b8ffe719da$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $8f2285b8ffe719da$var$jh = !1;
function $8f2285b8ffe719da$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $8f2285b8ffe719da$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $8f2285b8ffe719da$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $8f2285b8ffe719da$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($8f2285b8ffe719da$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $8f2285b8ffe719da$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $8f2285b8ffe719da$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $8f2285b8ffe719da$var$ih(a, c);
}
function $8f2285b8ffe719da$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8f2285b8ffe719da$var$Cc(a, c);
    }
}
function $8f2285b8ffe719da$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $8f2285b8ffe719da$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $8f2285b8ffe719da$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $8f2285b8ffe719da$var$A({}, q, r);
                            break a;
                        case 2:
                            $8f2285b8ffe719da$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $8f2285b8ffe719da$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $8f2285b8ffe719da$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($8f2285b8ffe719da$var$p(191, e));
            e.call(d);
        }
    }
}
var $8f2285b8ffe719da$var$th = {}, $8f2285b8ffe719da$var$uh = $8f2285b8ffe719da$var$Uf($8f2285b8ffe719da$var$th), $8f2285b8ffe719da$var$vh = $8f2285b8ffe719da$var$Uf($8f2285b8ffe719da$var$th), $8f2285b8ffe719da$var$wh = $8f2285b8ffe719da$var$Uf($8f2285b8ffe719da$var$th);
function $8f2285b8ffe719da$var$xh(a) {
    if (a === $8f2285b8ffe719da$var$th) throw Error($8f2285b8ffe719da$var$p(174));
    return a;
}
function $8f2285b8ffe719da$var$yh(a, b) {
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$wh, b);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$vh, a);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$uh, $8f2285b8ffe719da$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $8f2285b8ffe719da$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $8f2285b8ffe719da$var$lb(b, a);
    }
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$uh);
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$uh, b);
}
function $8f2285b8ffe719da$var$zh() {
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$uh);
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$vh);
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$wh);
}
function $8f2285b8ffe719da$var$Ah(a) {
    $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$wh.current);
    var b = $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$uh.current);
    var c = $8f2285b8ffe719da$var$lb(b, a.type);
    b !== c && ($8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$vh, a), $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$uh, c));
}
function $8f2285b8ffe719da$var$Bh(a) {
    $8f2285b8ffe719da$var$vh.current === a && ($8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$uh), $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$vh));
}
var $8f2285b8ffe719da$var$L = $8f2285b8ffe719da$var$Uf(0);
function $8f2285b8ffe719da$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $8f2285b8ffe719da$var$Dh = [];
function $8f2285b8ffe719da$var$Eh() {
    for(var a = 0; a < $8f2285b8ffe719da$var$Dh.length; a++)$8f2285b8ffe719da$var$Dh[a]._workInProgressVersionPrimary = null;
    $8f2285b8ffe719da$var$Dh.length = 0;
}
var $8f2285b8ffe719da$var$Fh = $8f2285b8ffe719da$var$ua.ReactCurrentDispatcher, $8f2285b8ffe719da$var$Gh = $8f2285b8ffe719da$var$ua.ReactCurrentBatchConfig, $8f2285b8ffe719da$var$Hh = 0, $8f2285b8ffe719da$var$M = null, $8f2285b8ffe719da$var$N = null, $8f2285b8ffe719da$var$O = null, $8f2285b8ffe719da$var$Ih = !1, $8f2285b8ffe719da$var$Jh = !1, $8f2285b8ffe719da$var$Kh = 0, $8f2285b8ffe719da$var$Lh = 0;
function $8f2285b8ffe719da$var$P() {
    throw Error($8f2285b8ffe719da$var$p(321));
}
function $8f2285b8ffe719da$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$8f2285b8ffe719da$var$He(a[c], b[c])) return !1;
    return !0;
}
function $8f2285b8ffe719da$var$Nh(a, b, c, d, e, f) {
    $8f2285b8ffe719da$var$Hh = f;
    $8f2285b8ffe719da$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $8f2285b8ffe719da$var$Fh.current = null === a || null === a.memoizedState ? $8f2285b8ffe719da$var$Oh : $8f2285b8ffe719da$var$Ph;
    a = c(d, e);
    if ($8f2285b8ffe719da$var$Jh) {
        f = 0;
        do {
            $8f2285b8ffe719da$var$Jh = !1;
            $8f2285b8ffe719da$var$Kh = 0;
            if (25 <= f) throw Error($8f2285b8ffe719da$var$p(301));
            f += 1;
            $8f2285b8ffe719da$var$O = $8f2285b8ffe719da$var$N = null;
            b.updateQueue = null;
            $8f2285b8ffe719da$var$Fh.current = $8f2285b8ffe719da$var$Qh;
            a = c(d, e);
        }while ($8f2285b8ffe719da$var$Jh);
    }
    $8f2285b8ffe719da$var$Fh.current = $8f2285b8ffe719da$var$Rh;
    b = null !== $8f2285b8ffe719da$var$N && null !== $8f2285b8ffe719da$var$N.next;
    $8f2285b8ffe719da$var$Hh = 0;
    $8f2285b8ffe719da$var$O = $8f2285b8ffe719da$var$N = $8f2285b8ffe719da$var$M = null;
    $8f2285b8ffe719da$var$Ih = !1;
    if (b) throw Error($8f2285b8ffe719da$var$p(300));
    return a;
}
function $8f2285b8ffe719da$var$Sh() {
    var a = 0 !== $8f2285b8ffe719da$var$Kh;
    $8f2285b8ffe719da$var$Kh = 0;
    return a;
}
function $8f2285b8ffe719da$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $8f2285b8ffe719da$var$O ? $8f2285b8ffe719da$var$M.memoizedState = $8f2285b8ffe719da$var$O = a : $8f2285b8ffe719da$var$O = $8f2285b8ffe719da$var$O.next = a;
    return $8f2285b8ffe719da$var$O;
}
function $8f2285b8ffe719da$var$Uh() {
    if (null === $8f2285b8ffe719da$var$N) {
        var a = $8f2285b8ffe719da$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $8f2285b8ffe719da$var$N.next;
    var b = null === $8f2285b8ffe719da$var$O ? $8f2285b8ffe719da$var$M.memoizedState : $8f2285b8ffe719da$var$O.next;
    if (null !== b) $8f2285b8ffe719da$var$O = b, $8f2285b8ffe719da$var$N = a;
    else {
        if (null === a) throw Error($8f2285b8ffe719da$var$p(310));
        $8f2285b8ffe719da$var$N = a;
        a = {
            memoizedState: $8f2285b8ffe719da$var$N.memoizedState,
            baseState: $8f2285b8ffe719da$var$N.baseState,
            baseQueue: $8f2285b8ffe719da$var$N.baseQueue,
            queue: $8f2285b8ffe719da$var$N.queue,
            next: null
        };
        null === $8f2285b8ffe719da$var$O ? $8f2285b8ffe719da$var$M.memoizedState = $8f2285b8ffe719da$var$O = a : $8f2285b8ffe719da$var$O = $8f2285b8ffe719da$var$O.next = a;
    }
    return $8f2285b8ffe719da$var$O;
}
function $8f2285b8ffe719da$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $8f2285b8ffe719da$var$Wh(a) {
    var b = $8f2285b8ffe719da$var$Uh(), c = b.queue;
    if (null === c) throw Error($8f2285b8ffe719da$var$p(311));
    c.lastRenderedReducer = a;
    var d = $8f2285b8ffe719da$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($8f2285b8ffe719da$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $8f2285b8ffe719da$var$M.lanes |= m;
                $8f2285b8ffe719da$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $8f2285b8ffe719da$var$He(d, b.memoizedState) || ($8f2285b8ffe719da$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $8f2285b8ffe719da$var$M.lanes |= f, $8f2285b8ffe719da$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $8f2285b8ffe719da$var$Xh(a) {
    var b = $8f2285b8ffe719da$var$Uh(), c = b.queue;
    if (null === c) throw Error($8f2285b8ffe719da$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $8f2285b8ffe719da$var$He(f, b.memoizedState) || ($8f2285b8ffe719da$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $8f2285b8ffe719da$var$Yh() {}
function $8f2285b8ffe719da$var$Zh(a, b) {
    var c = $8f2285b8ffe719da$var$M, d = $8f2285b8ffe719da$var$Uh(), e = b(), f = !$8f2285b8ffe719da$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $8f2285b8ffe719da$var$dh = !0);
    d = d.queue;
    $8f2285b8ffe719da$var$$h($8f2285b8ffe719da$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $8f2285b8ffe719da$var$O && $8f2285b8ffe719da$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $8f2285b8ffe719da$var$bi(9, $8f2285b8ffe719da$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $8f2285b8ffe719da$var$Q) throw Error($8f2285b8ffe719da$var$p(349));
        0 !== ($8f2285b8ffe719da$var$Hh & 30) || $8f2285b8ffe719da$var$di(c, b, e);
    }
    return e;
}
function $8f2285b8ffe719da$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $8f2285b8ffe719da$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8f2285b8ffe719da$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $8f2285b8ffe719da$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $8f2285b8ffe719da$var$ei(b) && $8f2285b8ffe719da$var$fi(a);
}
function $8f2285b8ffe719da$var$ai(a, b, c) {
    return c(function() {
        $8f2285b8ffe719da$var$ei(b) && $8f2285b8ffe719da$var$fi(a);
    });
}
function $8f2285b8ffe719da$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$8f2285b8ffe719da$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $8f2285b8ffe719da$var$fi(a) {
    var b = $8f2285b8ffe719da$var$ih(a, 1);
    null !== b && $8f2285b8ffe719da$var$gi(b, a, 1, -1);
}
function $8f2285b8ffe719da$var$hi(a) {
    var b = $8f2285b8ffe719da$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8f2285b8ffe719da$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $8f2285b8ffe719da$var$ii.bind(null, $8f2285b8ffe719da$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $8f2285b8ffe719da$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $8f2285b8ffe719da$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8f2285b8ffe719da$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $8f2285b8ffe719da$var$ji() {
    return $8f2285b8ffe719da$var$Uh().memoizedState;
}
function $8f2285b8ffe719da$var$ki(a, b, c, d) {
    var e = $8f2285b8ffe719da$var$Th();
    $8f2285b8ffe719da$var$M.flags |= a;
    e.memoizedState = $8f2285b8ffe719da$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $8f2285b8ffe719da$var$li(a, b, c, d) {
    var e = $8f2285b8ffe719da$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $8f2285b8ffe719da$var$N) {
        var g = $8f2285b8ffe719da$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $8f2285b8ffe719da$var$Mh(d, g.deps)) {
            e.memoizedState = $8f2285b8ffe719da$var$bi(b, c, f, d);
            return;
        }
    }
    $8f2285b8ffe719da$var$M.flags |= a;
    e.memoizedState = $8f2285b8ffe719da$var$bi(1 | b, c, f, d);
}
function $8f2285b8ffe719da$var$mi(a, b) {
    return $8f2285b8ffe719da$var$ki(8390656, 8, a, b);
}
function $8f2285b8ffe719da$var$$h(a, b) {
    return $8f2285b8ffe719da$var$li(2048, 8, a, b);
}
function $8f2285b8ffe719da$var$ni(a, b) {
    return $8f2285b8ffe719da$var$li(4, 2, a, b);
}
function $8f2285b8ffe719da$var$oi(a, b) {
    return $8f2285b8ffe719da$var$li(4, 4, a, b);
}
function $8f2285b8ffe719da$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $8f2285b8ffe719da$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $8f2285b8ffe719da$var$li(4, 4, $8f2285b8ffe719da$var$pi.bind(null, b, a), c);
}
function $8f2285b8ffe719da$var$ri() {}
function $8f2285b8ffe719da$var$si(a, b) {
    var c = $8f2285b8ffe719da$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8f2285b8ffe719da$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8f2285b8ffe719da$var$ti(a, b) {
    var c = $8f2285b8ffe719da$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8f2285b8ffe719da$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8f2285b8ffe719da$var$ui(a, b, c) {
    if (0 === ($8f2285b8ffe719da$var$Hh & 21)) return a.baseState && (a.baseState = !1, $8f2285b8ffe719da$var$dh = !0), a.memoizedState = c;
    $8f2285b8ffe719da$var$He(c, b) || (c = $8f2285b8ffe719da$var$yc(), $8f2285b8ffe719da$var$M.lanes |= c, $8f2285b8ffe719da$var$rh |= c, a.baseState = !0);
    return b;
}
function $8f2285b8ffe719da$var$vi(a, b) {
    var c = $8f2285b8ffe719da$var$C;
    $8f2285b8ffe719da$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $8f2285b8ffe719da$var$Gh.transition;
    $8f2285b8ffe719da$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $8f2285b8ffe719da$var$C = c, $8f2285b8ffe719da$var$Gh.transition = d;
    }
}
function $8f2285b8ffe719da$var$wi() {
    return $8f2285b8ffe719da$var$Uh().memoizedState;
}
function $8f2285b8ffe719da$var$xi(a, b, c) {
    var d = $8f2285b8ffe719da$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8f2285b8ffe719da$var$zi(a)) $8f2285b8ffe719da$var$Ai(b, c);
    else if (c = $8f2285b8ffe719da$var$hh(a, b, c, d), null !== c) {
        var e = $8f2285b8ffe719da$var$R();
        $8f2285b8ffe719da$var$gi(c, a, d, e);
        $8f2285b8ffe719da$var$Bi(c, b, d);
    }
}
function $8f2285b8ffe719da$var$ii(a, b, c) {
    var d = $8f2285b8ffe719da$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8f2285b8ffe719da$var$zi(a)) $8f2285b8ffe719da$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($8f2285b8ffe719da$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $8f2285b8ffe719da$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $8f2285b8ffe719da$var$hh(a, b, e, d);
        null !== c && (e = $8f2285b8ffe719da$var$R(), $8f2285b8ffe719da$var$gi(c, a, d, e), $8f2285b8ffe719da$var$Bi(c, b, d));
    }
}
function $8f2285b8ffe719da$var$zi(a) {
    var b = a.alternate;
    return a === $8f2285b8ffe719da$var$M || null !== b && b === $8f2285b8ffe719da$var$M;
}
function $8f2285b8ffe719da$var$Ai(a, b) {
    $8f2285b8ffe719da$var$Jh = $8f2285b8ffe719da$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $8f2285b8ffe719da$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8f2285b8ffe719da$var$Cc(a, c);
    }
}
var $8f2285b8ffe719da$var$Rh = {
    readContext: $8f2285b8ffe719da$var$eh,
    useCallback: $8f2285b8ffe719da$var$P,
    useContext: $8f2285b8ffe719da$var$P,
    useEffect: $8f2285b8ffe719da$var$P,
    useImperativeHandle: $8f2285b8ffe719da$var$P,
    useInsertionEffect: $8f2285b8ffe719da$var$P,
    useLayoutEffect: $8f2285b8ffe719da$var$P,
    useMemo: $8f2285b8ffe719da$var$P,
    useReducer: $8f2285b8ffe719da$var$P,
    useRef: $8f2285b8ffe719da$var$P,
    useState: $8f2285b8ffe719da$var$P,
    useDebugValue: $8f2285b8ffe719da$var$P,
    useDeferredValue: $8f2285b8ffe719da$var$P,
    useTransition: $8f2285b8ffe719da$var$P,
    useMutableSource: $8f2285b8ffe719da$var$P,
    useSyncExternalStore: $8f2285b8ffe719da$var$P,
    useId: $8f2285b8ffe719da$var$P,
    unstable_isNewReconciler: !1
}, $8f2285b8ffe719da$var$Oh = {
    readContext: $8f2285b8ffe719da$var$eh,
    useCallback: function(a, b) {
        $8f2285b8ffe719da$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $8f2285b8ffe719da$var$eh,
    useEffect: $8f2285b8ffe719da$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $8f2285b8ffe719da$var$ki(4194308, 4, $8f2285b8ffe719da$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $8f2285b8ffe719da$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $8f2285b8ffe719da$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $8f2285b8ffe719da$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $8f2285b8ffe719da$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $8f2285b8ffe719da$var$xi.bind(null, $8f2285b8ffe719da$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $8f2285b8ffe719da$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $8f2285b8ffe719da$var$hi,
    useDebugValue: $8f2285b8ffe719da$var$ri,
    useDeferredValue: function(a) {
        return $8f2285b8ffe719da$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $8f2285b8ffe719da$var$hi(!1), b = a[0];
        a = $8f2285b8ffe719da$var$vi.bind(null, a[1]);
        $8f2285b8ffe719da$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $8f2285b8ffe719da$var$M, e = $8f2285b8ffe719da$var$Th();
        if ($8f2285b8ffe719da$var$I) {
            if (void 0 === c) throw Error($8f2285b8ffe719da$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $8f2285b8ffe719da$var$Q) throw Error($8f2285b8ffe719da$var$p(349));
            0 !== ($8f2285b8ffe719da$var$Hh & 30) || $8f2285b8ffe719da$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $8f2285b8ffe719da$var$mi($8f2285b8ffe719da$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $8f2285b8ffe719da$var$bi(9, $8f2285b8ffe719da$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $8f2285b8ffe719da$var$Th(), b = $8f2285b8ffe719da$var$Q.identifierPrefix;
        if ($8f2285b8ffe719da$var$I) {
            var c = $8f2285b8ffe719da$var$sg;
            var d = $8f2285b8ffe719da$var$rg;
            c = (d & ~(1 << 32 - $8f2285b8ffe719da$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $8f2285b8ffe719da$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $8f2285b8ffe719da$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $8f2285b8ffe719da$var$Ph = {
    readContext: $8f2285b8ffe719da$var$eh,
    useCallback: $8f2285b8ffe719da$var$si,
    useContext: $8f2285b8ffe719da$var$eh,
    useEffect: $8f2285b8ffe719da$var$$h,
    useImperativeHandle: $8f2285b8ffe719da$var$qi,
    useInsertionEffect: $8f2285b8ffe719da$var$ni,
    useLayoutEffect: $8f2285b8ffe719da$var$oi,
    useMemo: $8f2285b8ffe719da$var$ti,
    useReducer: $8f2285b8ffe719da$var$Wh,
    useRef: $8f2285b8ffe719da$var$ji,
    useState: function() {
        return $8f2285b8ffe719da$var$Wh($8f2285b8ffe719da$var$Vh);
    },
    useDebugValue: $8f2285b8ffe719da$var$ri,
    useDeferredValue: function(a) {
        var b = $8f2285b8ffe719da$var$Uh();
        return $8f2285b8ffe719da$var$ui(b, $8f2285b8ffe719da$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $8f2285b8ffe719da$var$Wh($8f2285b8ffe719da$var$Vh)[0], b = $8f2285b8ffe719da$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8f2285b8ffe719da$var$Yh,
    useSyncExternalStore: $8f2285b8ffe719da$var$Zh,
    useId: $8f2285b8ffe719da$var$wi,
    unstable_isNewReconciler: !1
}, $8f2285b8ffe719da$var$Qh = {
    readContext: $8f2285b8ffe719da$var$eh,
    useCallback: $8f2285b8ffe719da$var$si,
    useContext: $8f2285b8ffe719da$var$eh,
    useEffect: $8f2285b8ffe719da$var$$h,
    useImperativeHandle: $8f2285b8ffe719da$var$qi,
    useInsertionEffect: $8f2285b8ffe719da$var$ni,
    useLayoutEffect: $8f2285b8ffe719da$var$oi,
    useMemo: $8f2285b8ffe719da$var$ti,
    useReducer: $8f2285b8ffe719da$var$Xh,
    useRef: $8f2285b8ffe719da$var$ji,
    useState: function() {
        return $8f2285b8ffe719da$var$Xh($8f2285b8ffe719da$var$Vh);
    },
    useDebugValue: $8f2285b8ffe719da$var$ri,
    useDeferredValue: function(a) {
        var b = $8f2285b8ffe719da$var$Uh();
        return null === $8f2285b8ffe719da$var$N ? b.memoizedState = a : $8f2285b8ffe719da$var$ui(b, $8f2285b8ffe719da$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $8f2285b8ffe719da$var$Xh($8f2285b8ffe719da$var$Vh)[0], b = $8f2285b8ffe719da$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8f2285b8ffe719da$var$Yh,
    useSyncExternalStore: $8f2285b8ffe719da$var$Zh,
    useId: $8f2285b8ffe719da$var$wi,
    unstable_isNewReconciler: !1
};
function $8f2285b8ffe719da$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $8f2285b8ffe719da$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $8f2285b8ffe719da$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8f2285b8ffe719da$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $8f2285b8ffe719da$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $8f2285b8ffe719da$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8f2285b8ffe719da$var$R(), e = $8f2285b8ffe719da$var$yi(a), f = $8f2285b8ffe719da$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8f2285b8ffe719da$var$nh(a, f, e);
        null !== b && ($8f2285b8ffe719da$var$gi(b, a, e, d), $8f2285b8ffe719da$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8f2285b8ffe719da$var$R(), e = $8f2285b8ffe719da$var$yi(a), f = $8f2285b8ffe719da$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8f2285b8ffe719da$var$nh(a, f, e);
        null !== b && ($8f2285b8ffe719da$var$gi(b, a, e, d), $8f2285b8ffe719da$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $8f2285b8ffe719da$var$R(), d = $8f2285b8ffe719da$var$yi(a), e = $8f2285b8ffe719da$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $8f2285b8ffe719da$var$nh(a, e, d);
        null !== b && ($8f2285b8ffe719da$var$gi(b, a, d, c), $8f2285b8ffe719da$var$oh(b, a, d));
    }
};
function $8f2285b8ffe719da$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$8f2285b8ffe719da$var$Ie(c, d) || !$8f2285b8ffe719da$var$Ie(e, f) : !0;
}
function $8f2285b8ffe719da$var$Gi(a, b, c) {
    var d = !1, e = $8f2285b8ffe719da$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $8f2285b8ffe719da$var$eh(f) : (e = $8f2285b8ffe719da$var$Zf(b) ? $8f2285b8ffe719da$var$Xf : $8f2285b8ffe719da$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $8f2285b8ffe719da$var$Yf(a, e) : $8f2285b8ffe719da$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $8f2285b8ffe719da$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $8f2285b8ffe719da$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $8f2285b8ffe719da$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $8f2285b8ffe719da$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $8f2285b8ffe719da$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $8f2285b8ffe719da$var$eh(f) : (f = $8f2285b8ffe719da$var$Zf(b) ? $8f2285b8ffe719da$var$Xf : $8f2285b8ffe719da$var$H.current, e.context = $8f2285b8ffe719da$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($8f2285b8ffe719da$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $8f2285b8ffe719da$var$Ei.enqueueReplaceState(e, e.state, null), $8f2285b8ffe719da$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $8f2285b8ffe719da$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $8f2285b8ffe719da$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $8f2285b8ffe719da$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $8f2285b8ffe719da$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $8f2285b8ffe719da$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $8f2285b8ffe719da$var$Ni(a, b, c) {
    c = $8f2285b8ffe719da$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $8f2285b8ffe719da$var$Oi || ($8f2285b8ffe719da$var$Oi = !0, $8f2285b8ffe719da$var$Pi = d);
        $8f2285b8ffe719da$var$Li(a, b);
    };
    return c;
}
function $8f2285b8ffe719da$var$Qi(a, b, c) {
    c = $8f2285b8ffe719da$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $8f2285b8ffe719da$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $8f2285b8ffe719da$var$Li(a, b);
        "function" !== typeof d && (null === $8f2285b8ffe719da$var$Ri ? $8f2285b8ffe719da$var$Ri = new Set([
            this
        ]) : $8f2285b8ffe719da$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $8f2285b8ffe719da$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $8f2285b8ffe719da$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $8f2285b8ffe719da$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $8f2285b8ffe719da$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $8f2285b8ffe719da$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $8f2285b8ffe719da$var$mh(-1, 1), b.tag = 2, $8f2285b8ffe719da$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $8f2285b8ffe719da$var$Wi = $8f2285b8ffe719da$var$ua.ReactCurrentOwner, $8f2285b8ffe719da$var$dh = !1;
function $8f2285b8ffe719da$var$Xi(a, b, c, d) {
    b.child = null === a ? $8f2285b8ffe719da$var$Vg(b, null, c, d) : $8f2285b8ffe719da$var$Ug(b, a.child, c, d);
}
function $8f2285b8ffe719da$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $8f2285b8ffe719da$var$ch(b, e);
    d = $8f2285b8ffe719da$var$Nh(a, b, c, d, f, e);
    c = $8f2285b8ffe719da$var$Sh();
    if (null !== a && !$8f2285b8ffe719da$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8f2285b8ffe719da$var$Zi(a, b, e);
    $8f2285b8ffe719da$var$I && c && $8f2285b8ffe719da$var$vg(b);
    b.flags |= 1;
    $8f2285b8ffe719da$var$Xi(a, b, d, e);
    return b.child;
}
function $8f2285b8ffe719da$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$8f2285b8ffe719da$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $8f2285b8ffe719da$var$bj(a, b, f, d, e);
        a = $8f2285b8ffe719da$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $8f2285b8ffe719da$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $8f2285b8ffe719da$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $8f2285b8ffe719da$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $8f2285b8ffe719da$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($8f2285b8ffe719da$var$Ie(f, d) && a.ref === b.ref) {
            if ($8f2285b8ffe719da$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($8f2285b8ffe719da$var$dh = !0);
            else return b.lanes = a.lanes, $8f2285b8ffe719da$var$Zi(a, b, e);
        }
    }
    return $8f2285b8ffe719da$var$cj(a, b, c, d, e);
}
function $8f2285b8ffe719da$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$ej, $8f2285b8ffe719da$var$fj), $8f2285b8ffe719da$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$ej, $8f2285b8ffe719da$var$fj), $8f2285b8ffe719da$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$ej, $8f2285b8ffe719da$var$fj);
            $8f2285b8ffe719da$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$ej, $8f2285b8ffe719da$var$fj), $8f2285b8ffe719da$var$fj |= d;
    $8f2285b8ffe719da$var$Xi(a, b, e, c);
    return b.child;
}
function $8f2285b8ffe719da$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $8f2285b8ffe719da$var$cj(a, b, c, d, e) {
    var f = $8f2285b8ffe719da$var$Zf(c) ? $8f2285b8ffe719da$var$Xf : $8f2285b8ffe719da$var$H.current;
    f = $8f2285b8ffe719da$var$Yf(b, f);
    $8f2285b8ffe719da$var$ch(b, e);
    c = $8f2285b8ffe719da$var$Nh(a, b, c, d, f, e);
    d = $8f2285b8ffe719da$var$Sh();
    if (null !== a && !$8f2285b8ffe719da$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8f2285b8ffe719da$var$Zi(a, b, e);
    $8f2285b8ffe719da$var$I && d && $8f2285b8ffe719da$var$vg(b);
    b.flags |= 1;
    $8f2285b8ffe719da$var$Xi(a, b, c, e);
    return b.child;
}
function $8f2285b8ffe719da$var$hj(a, b, c, d, e) {
    if ($8f2285b8ffe719da$var$Zf(c)) {
        var f = !0;
        $8f2285b8ffe719da$var$cg(b);
    } else f = !1;
    $8f2285b8ffe719da$var$ch(b, e);
    if (null === b.stateNode) $8f2285b8ffe719da$var$ij(a, b), $8f2285b8ffe719da$var$Gi(b, c, d), $8f2285b8ffe719da$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $8f2285b8ffe719da$var$eh(l) : (l = $8f2285b8ffe719da$var$Zf(c) ? $8f2285b8ffe719da$var$Xf : $8f2285b8ffe719da$var$H.current, l = $8f2285b8ffe719da$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $8f2285b8ffe719da$var$Hi(b, g, d, l);
        $8f2285b8ffe719da$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $8f2285b8ffe719da$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $8f2285b8ffe719da$var$Wf.current || $8f2285b8ffe719da$var$jh ? ("function" === typeof m && ($8f2285b8ffe719da$var$Di(b, c, m, d), k = b.memoizedState), (h = $8f2285b8ffe719da$var$jh || $8f2285b8ffe719da$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $8f2285b8ffe719da$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $8f2285b8ffe719da$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $8f2285b8ffe719da$var$eh(k) : (k = $8f2285b8ffe719da$var$Zf(c) ? $8f2285b8ffe719da$var$Xf : $8f2285b8ffe719da$var$H.current, k = $8f2285b8ffe719da$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $8f2285b8ffe719da$var$Hi(b, g, d, k);
        $8f2285b8ffe719da$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $8f2285b8ffe719da$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $8f2285b8ffe719da$var$Wf.current || $8f2285b8ffe719da$var$jh ? ("function" === typeof y && ($8f2285b8ffe719da$var$Di(b, c, y, d), n = b.memoizedState), (l = $8f2285b8ffe719da$var$jh || $8f2285b8ffe719da$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $8f2285b8ffe719da$var$jj(a, b, c, d, f, e);
}
function $8f2285b8ffe719da$var$jj(a, b, c, d, e, f) {
    $8f2285b8ffe719da$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $8f2285b8ffe719da$var$dg(b, c, !1), $8f2285b8ffe719da$var$Zi(a, b, f);
    d = b.stateNode;
    $8f2285b8ffe719da$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $8f2285b8ffe719da$var$Ug(b, a.child, null, f), b.child = $8f2285b8ffe719da$var$Ug(b, null, h, f)) : $8f2285b8ffe719da$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $8f2285b8ffe719da$var$dg(b, c, !0);
    return b.child;
}
function $8f2285b8ffe719da$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $8f2285b8ffe719da$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $8f2285b8ffe719da$var$ag(a, b.context, !1);
    $8f2285b8ffe719da$var$yh(a, b.containerInfo);
}
function $8f2285b8ffe719da$var$lj(a, b, c, d, e) {
    $8f2285b8ffe719da$var$Ig();
    $8f2285b8ffe719da$var$Jg(e);
    b.flags |= 256;
    $8f2285b8ffe719da$var$Xi(a, b, c, d);
    return b.child;
}
var $8f2285b8ffe719da$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $8f2285b8ffe719da$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $8f2285b8ffe719da$var$oj(a, b, c) {
    var d = b.pendingProps, e = $8f2285b8ffe719da$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, e & 1);
    if (null === a) {
        $8f2285b8ffe719da$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $8f2285b8ffe719da$var$pj(g, d, 0, null), a = $8f2285b8ffe719da$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $8f2285b8ffe719da$var$nj(c), b.memoizedState = $8f2285b8ffe719da$var$mj, a) : $8f2285b8ffe719da$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $8f2285b8ffe719da$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $8f2285b8ffe719da$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $8f2285b8ffe719da$var$Pg(h, f) : (f = $8f2285b8ffe719da$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $8f2285b8ffe719da$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $8f2285b8ffe719da$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $8f2285b8ffe719da$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $8f2285b8ffe719da$var$qj(a, b) {
    b = $8f2285b8ffe719da$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $8f2285b8ffe719da$var$sj(a, b, c, d) {
    null !== d && $8f2285b8ffe719da$var$Jg(d);
    $8f2285b8ffe719da$var$Ug(b, a.child, null, c);
    a = $8f2285b8ffe719da$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $8f2285b8ffe719da$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $8f2285b8ffe719da$var$Ki(Error($8f2285b8ffe719da$var$p(422))), $8f2285b8ffe719da$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $8f2285b8ffe719da$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $8f2285b8ffe719da$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $8f2285b8ffe719da$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $8f2285b8ffe719da$var$nj(g);
        b.memoizedState = $8f2285b8ffe719da$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $8f2285b8ffe719da$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($8f2285b8ffe719da$var$p(419));
        d = $8f2285b8ffe719da$var$Ki(f, d, void 0);
        return $8f2285b8ffe719da$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($8f2285b8ffe719da$var$dh || h) {
        d = $8f2285b8ffe719da$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $8f2285b8ffe719da$var$ih(a, e), $8f2285b8ffe719da$var$gi(d, a, e, -1));
        }
        $8f2285b8ffe719da$var$tj();
        d = $8f2285b8ffe719da$var$Ki(Error($8f2285b8ffe719da$var$p(421)));
        return $8f2285b8ffe719da$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $8f2285b8ffe719da$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$Lf(e.nextSibling);
    $8f2285b8ffe719da$var$xg = b;
    $8f2285b8ffe719da$var$I = !0;
    $8f2285b8ffe719da$var$zg = null;
    null !== a && ($8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$rg, $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$sg, $8f2285b8ffe719da$var$og[$8f2285b8ffe719da$var$pg++] = $8f2285b8ffe719da$var$qg, $8f2285b8ffe719da$var$rg = a.id, $8f2285b8ffe719da$var$sg = a.overflow, $8f2285b8ffe719da$var$qg = b);
    b = $8f2285b8ffe719da$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $8f2285b8ffe719da$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $8f2285b8ffe719da$var$bh(a.return, b, c);
}
function $8f2285b8ffe719da$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $8f2285b8ffe719da$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $8f2285b8ffe719da$var$Xi(a, b, d.children, c);
    d = $8f2285b8ffe719da$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $8f2285b8ffe719da$var$vj(a, c, b);
            else if (19 === a.tag) $8f2285b8ffe719da$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $8f2285b8ffe719da$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $8f2285b8ffe719da$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $8f2285b8ffe719da$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $8f2285b8ffe719da$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $8f2285b8ffe719da$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $8f2285b8ffe719da$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $8f2285b8ffe719da$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $8f2285b8ffe719da$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($8f2285b8ffe719da$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $8f2285b8ffe719da$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $8f2285b8ffe719da$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $8f2285b8ffe719da$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $8f2285b8ffe719da$var$kj(b);
            $8f2285b8ffe719da$var$Ig();
            break;
        case 5:
            $8f2285b8ffe719da$var$Ah(b);
            break;
        case 1:
            $8f2285b8ffe719da$var$Zf(b.type) && $8f2285b8ffe719da$var$cg(b);
            break;
        case 4:
            $8f2285b8ffe719da$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, $8f2285b8ffe719da$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $8f2285b8ffe719da$var$oj(a, b, c);
                $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, $8f2285b8ffe719da$var$L.current & 1);
                a = $8f2285b8ffe719da$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, $8f2285b8ffe719da$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $8f2285b8ffe719da$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, $8f2285b8ffe719da$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $8f2285b8ffe719da$var$dj(a, b, c);
    }
    return $8f2285b8ffe719da$var$Zi(a, b, c);
}
var $8f2285b8ffe719da$var$zj, $8f2285b8ffe719da$var$Aj, $8f2285b8ffe719da$var$Bj, $8f2285b8ffe719da$var$Cj;
$8f2285b8ffe719da$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$8f2285b8ffe719da$var$Aj = function() {};
$8f2285b8ffe719da$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $8f2285b8ffe719da$var$Ya(a, e);
                d = $8f2285b8ffe719da$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $8f2285b8ffe719da$var$A({}, e, {
                    value: void 0
                });
                d = $8f2285b8ffe719da$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $8f2285b8ffe719da$var$gb(a, e);
                d = $8f2285b8ffe719da$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $8f2285b8ffe719da$var$Bf);
        }
        $8f2285b8ffe719da$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($8f2285b8ffe719da$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($8f2285b8ffe719da$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $8f2285b8ffe719da$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$8f2285b8ffe719da$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $8f2285b8ffe719da$var$Dj(a, b) {
    if (!$8f2285b8ffe719da$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $8f2285b8ffe719da$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $8f2285b8ffe719da$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $8f2285b8ffe719da$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $8f2285b8ffe719da$var$S(b), null;
        case 1:
            return $8f2285b8ffe719da$var$Zf(b.type) && $8f2285b8ffe719da$var$$f(), $8f2285b8ffe719da$var$S(b), null;
        case 3:
            d = b.stateNode;
            $8f2285b8ffe719da$var$zh();
            $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf);
            $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$H);
            $8f2285b8ffe719da$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $8f2285b8ffe719da$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $8f2285b8ffe719da$var$zg && ($8f2285b8ffe719da$var$Fj($8f2285b8ffe719da$var$zg), $8f2285b8ffe719da$var$zg = null));
            $8f2285b8ffe719da$var$Aj(a, b);
            $8f2285b8ffe719da$var$S(b);
            return null;
        case 5:
            $8f2285b8ffe719da$var$Bh(b);
            var e = $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $8f2285b8ffe719da$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($8f2285b8ffe719da$var$p(166));
                    $8f2285b8ffe719da$var$S(b);
                    return null;
                }
                a = $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$uh.current);
                if ($8f2285b8ffe719da$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$8f2285b8ffe719da$var$Of] = b;
                    d[$8f2285b8ffe719da$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $8f2285b8ffe719da$var$D("cancel", d);
                            $8f2285b8ffe719da$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $8f2285b8ffe719da$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $8f2285b8ffe719da$var$lf.length; e++)$8f2285b8ffe719da$var$D($8f2285b8ffe719da$var$lf[e], d);
                            break;
                        case "source":
                            $8f2285b8ffe719da$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $8f2285b8ffe719da$var$D("error", d);
                            $8f2285b8ffe719da$var$D("load", d);
                            break;
                        case "details":
                            $8f2285b8ffe719da$var$D("toggle", d);
                            break;
                        case "input":
                            $8f2285b8ffe719da$var$Za(d, f);
                            $8f2285b8ffe719da$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $8f2285b8ffe719da$var$D("invalid", d);
                            break;
                        case "textarea":
                            $8f2285b8ffe719da$var$hb(d, f), $8f2285b8ffe719da$var$D("invalid", d);
                    }
                    $8f2285b8ffe719da$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $8f2285b8ffe719da$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $8f2285b8ffe719da$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $8f2285b8ffe719da$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $8f2285b8ffe719da$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $8f2285b8ffe719da$var$Va(d);
                            $8f2285b8ffe719da$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $8f2285b8ffe719da$var$Va(d);
                            $8f2285b8ffe719da$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $8f2285b8ffe719da$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $8f2285b8ffe719da$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$8f2285b8ffe719da$var$Of] = b;
                    a[$8f2285b8ffe719da$var$Pf] = d;
                    $8f2285b8ffe719da$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $8f2285b8ffe719da$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $8f2285b8ffe719da$var$D("cancel", a);
                                $8f2285b8ffe719da$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $8f2285b8ffe719da$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $8f2285b8ffe719da$var$lf.length; e++)$8f2285b8ffe719da$var$D($8f2285b8ffe719da$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $8f2285b8ffe719da$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $8f2285b8ffe719da$var$D("error", a);
                                $8f2285b8ffe719da$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $8f2285b8ffe719da$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $8f2285b8ffe719da$var$Za(a, d);
                                e = $8f2285b8ffe719da$var$Ya(a, d);
                                $8f2285b8ffe719da$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $8f2285b8ffe719da$var$A({}, d, {
                                    value: void 0
                                });
                                $8f2285b8ffe719da$var$D("invalid", a);
                                break;
                            case "textarea":
                                $8f2285b8ffe719da$var$hb(a, d);
                                e = $8f2285b8ffe719da$var$gb(a, d);
                                $8f2285b8ffe719da$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $8f2285b8ffe719da$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $8f2285b8ffe719da$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $8f2285b8ffe719da$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $8f2285b8ffe719da$var$ob(a, k) : "number" === typeof k && $8f2285b8ffe719da$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($8f2285b8ffe719da$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $8f2285b8ffe719da$var$D("scroll", a) : null != k && $8f2285b8ffe719da$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $8f2285b8ffe719da$var$Va(a);
                                $8f2285b8ffe719da$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $8f2285b8ffe719da$var$Va(a);
                                $8f2285b8ffe719da$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $8f2285b8ffe719da$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $8f2285b8ffe719da$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $8f2285b8ffe719da$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $8f2285b8ffe719da$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $8f2285b8ffe719da$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $8f2285b8ffe719da$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($8f2285b8ffe719da$var$p(166));
                c = $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$wh.current);
                $8f2285b8ffe719da$var$xh($8f2285b8ffe719da$var$uh.current);
                if ($8f2285b8ffe719da$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$8f2285b8ffe719da$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $8f2285b8ffe719da$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $8f2285b8ffe719da$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $8f2285b8ffe719da$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$8f2285b8ffe719da$var$Of] = b, b.stateNode = d;
            }
            $8f2285b8ffe719da$var$S(b);
            return null;
        case 13:
            $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($8f2285b8ffe719da$var$I && null !== $8f2285b8ffe719da$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $8f2285b8ffe719da$var$Hg(), $8f2285b8ffe719da$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $8f2285b8ffe719da$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($8f2285b8ffe719da$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($8f2285b8ffe719da$var$p(317));
                        f[$8f2285b8ffe719da$var$Of] = b;
                    } else $8f2285b8ffe719da$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $8f2285b8ffe719da$var$S(b);
                    f = !1;
                } else null !== $8f2285b8ffe719da$var$zg && ($8f2285b8ffe719da$var$Fj($8f2285b8ffe719da$var$zg), $8f2285b8ffe719da$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($8f2285b8ffe719da$var$L.current & 1) ? 0 === $8f2285b8ffe719da$var$T && ($8f2285b8ffe719da$var$T = 3) : $8f2285b8ffe719da$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $8f2285b8ffe719da$var$S(b);
            return null;
        case 4:
            return $8f2285b8ffe719da$var$zh(), $8f2285b8ffe719da$var$Aj(a, b), null === a && $8f2285b8ffe719da$var$sf(b.stateNode.containerInfo), $8f2285b8ffe719da$var$S(b), null;
        case 10:
            return $8f2285b8ffe719da$var$ah(b.type._context), $8f2285b8ffe719da$var$S(b), null;
        case 17:
            return $8f2285b8ffe719da$var$Zf(b.type) && $8f2285b8ffe719da$var$$f(), $8f2285b8ffe719da$var$S(b), null;
        case 19:
            $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L);
            f = b.memoizedState;
            if (null === f) return $8f2285b8ffe719da$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $8f2285b8ffe719da$var$Dj(f, !1);
                else {
                    if (0 !== $8f2285b8ffe719da$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $8f2285b8ffe719da$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $8f2285b8ffe719da$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, $8f2285b8ffe719da$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $8f2285b8ffe719da$var$B() > $8f2285b8ffe719da$var$Gj && (b.flags |= 128, d = !0, $8f2285b8ffe719da$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $8f2285b8ffe719da$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $8f2285b8ffe719da$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$8f2285b8ffe719da$var$I) return $8f2285b8ffe719da$var$S(b), null;
                    } else 2 * $8f2285b8ffe719da$var$B() - f.renderingStartTime > $8f2285b8ffe719da$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $8f2285b8ffe719da$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $8f2285b8ffe719da$var$B(), b.sibling = null, c = $8f2285b8ffe719da$var$L.current, $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$L, d ? c & 1 | 2 : c & 1), b;
            $8f2285b8ffe719da$var$S(b);
            return null;
        case 22:
        case 23:
            return $8f2285b8ffe719da$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($8f2285b8ffe719da$var$fj & 1073741824) && ($8f2285b8ffe719da$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $8f2285b8ffe719da$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($8f2285b8ffe719da$var$p(156, b.tag));
}
function $8f2285b8ffe719da$var$Ij(a, b) {
    $8f2285b8ffe719da$var$wg(b);
    switch(b.tag){
        case 1:
            return $8f2285b8ffe719da$var$Zf(b.type) && $8f2285b8ffe719da$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $8f2285b8ffe719da$var$zh(), $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf), $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$H), $8f2285b8ffe719da$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $8f2285b8ffe719da$var$Bh(b), null;
        case 13:
            $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($8f2285b8ffe719da$var$p(340));
                $8f2285b8ffe719da$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L), null;
        case 4:
            return $8f2285b8ffe719da$var$zh(), null;
        case 10:
            return $8f2285b8ffe719da$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $8f2285b8ffe719da$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $8f2285b8ffe719da$var$Jj = !1, $8f2285b8ffe719da$var$U = !1, $8f2285b8ffe719da$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $8f2285b8ffe719da$var$V = null;
function $8f2285b8ffe719da$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $8f2285b8ffe719da$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $8f2285b8ffe719da$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $8f2285b8ffe719da$var$W(a, b, d);
    }
}
var $8f2285b8ffe719da$var$Nj = !1;
function $8f2285b8ffe719da$var$Oj(a, b) {
    $8f2285b8ffe719da$var$Cf = $8f2285b8ffe719da$var$dd;
    a = $8f2285b8ffe719da$var$Me();
    if ($8f2285b8ffe719da$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $8f2285b8ffe719da$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $8f2285b8ffe719da$var$dd = !1;
    for($8f2285b8ffe719da$var$V = b; null !== $8f2285b8ffe719da$var$V;)if (b = $8f2285b8ffe719da$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $8f2285b8ffe719da$var$V = a;
    else for(; null !== $8f2285b8ffe719da$var$V;){
        b = $8f2285b8ffe719da$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $8f2285b8ffe719da$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($8f2285b8ffe719da$var$p(163));
            }
        } catch (F) {
            $8f2285b8ffe719da$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $8f2285b8ffe719da$var$V = a;
            break;
        }
        $8f2285b8ffe719da$var$V = b.return;
    }
    n = $8f2285b8ffe719da$var$Nj;
    $8f2285b8ffe719da$var$Nj = !1;
    return n;
}
function $8f2285b8ffe719da$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $8f2285b8ffe719da$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $8f2285b8ffe719da$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $8f2285b8ffe719da$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $8f2285b8ffe719da$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $8f2285b8ffe719da$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$8f2285b8ffe719da$var$Of], delete b[$8f2285b8ffe719da$var$Pf], delete b[$8f2285b8ffe719da$var$of], delete b[$8f2285b8ffe719da$var$Qf], delete b[$8f2285b8ffe719da$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $8f2285b8ffe719da$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $8f2285b8ffe719da$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $8f2285b8ffe719da$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $8f2285b8ffe719da$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $8f2285b8ffe719da$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($8f2285b8ffe719da$var$Vj(a, b, c), a = a.sibling; null !== a;)$8f2285b8ffe719da$var$Vj(a, b, c), a = a.sibling;
}
function $8f2285b8ffe719da$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($8f2285b8ffe719da$var$Wj(a, b, c), a = a.sibling; null !== a;)$8f2285b8ffe719da$var$Wj(a, b, c), a = a.sibling;
}
var $8f2285b8ffe719da$var$X = null, $8f2285b8ffe719da$var$Xj = !1;
function $8f2285b8ffe719da$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$8f2285b8ffe719da$var$Zj(a, b, c), c = c.sibling;
}
function $8f2285b8ffe719da$var$Zj(a, b, c) {
    if ($8f2285b8ffe719da$var$lc && "function" === typeof $8f2285b8ffe719da$var$lc.onCommitFiberUnmount) try {
        $8f2285b8ffe719da$var$lc.onCommitFiberUnmount($8f2285b8ffe719da$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $8f2285b8ffe719da$var$U || $8f2285b8ffe719da$var$Lj(c, b);
        case 6:
            var d = $8f2285b8ffe719da$var$X, e = $8f2285b8ffe719da$var$Xj;
            $8f2285b8ffe719da$var$X = null;
            $8f2285b8ffe719da$var$Yj(a, b, c);
            $8f2285b8ffe719da$var$X = d;
            $8f2285b8ffe719da$var$Xj = e;
            null !== $8f2285b8ffe719da$var$X && ($8f2285b8ffe719da$var$Xj ? (a = $8f2285b8ffe719da$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $8f2285b8ffe719da$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $8f2285b8ffe719da$var$X && ($8f2285b8ffe719da$var$Xj ? (a = $8f2285b8ffe719da$var$X, c = c.stateNode, 8 === a.nodeType ? $8f2285b8ffe719da$var$Kf(a.parentNode, c) : 1 === a.nodeType && $8f2285b8ffe719da$var$Kf(a, c), $8f2285b8ffe719da$var$bd(a)) : $8f2285b8ffe719da$var$Kf($8f2285b8ffe719da$var$X, c.stateNode));
            break;
        case 4:
            d = $8f2285b8ffe719da$var$X;
            e = $8f2285b8ffe719da$var$Xj;
            $8f2285b8ffe719da$var$X = c.stateNode.containerInfo;
            $8f2285b8ffe719da$var$Xj = !0;
            $8f2285b8ffe719da$var$Yj(a, b, c);
            $8f2285b8ffe719da$var$X = d;
            $8f2285b8ffe719da$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$8f2285b8ffe719da$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $8f2285b8ffe719da$var$Mj(c, b, g) : 0 !== (f & 4) && $8f2285b8ffe719da$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $8f2285b8ffe719da$var$Yj(a, b, c);
            break;
        case 1:
            if (!$8f2285b8ffe719da$var$U && ($8f2285b8ffe719da$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $8f2285b8ffe719da$var$W(c, b, h);
            }
            $8f2285b8ffe719da$var$Yj(a, b, c);
            break;
        case 21:
            $8f2285b8ffe719da$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($8f2285b8ffe719da$var$U = (d = $8f2285b8ffe719da$var$U) || null !== c.memoizedState, $8f2285b8ffe719da$var$Yj(a, b, c), $8f2285b8ffe719da$var$U = d) : $8f2285b8ffe719da$var$Yj(a, b, c);
            break;
        default:
            $8f2285b8ffe719da$var$Yj(a, b, c);
    }
}
function $8f2285b8ffe719da$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $8f2285b8ffe719da$var$Kj);
        b.forEach(function(b) {
            var d = $8f2285b8ffe719da$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $8f2285b8ffe719da$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $8f2285b8ffe719da$var$X = h.stateNode;
                        $8f2285b8ffe719da$var$Xj = !1;
                        break a;
                    case 3:
                        $8f2285b8ffe719da$var$X = h.stateNode.containerInfo;
                        $8f2285b8ffe719da$var$Xj = !0;
                        break a;
                    case 4:
                        $8f2285b8ffe719da$var$X = h.stateNode.containerInfo;
                        $8f2285b8ffe719da$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $8f2285b8ffe719da$var$X) throw Error($8f2285b8ffe719da$var$p(160));
            $8f2285b8ffe719da$var$Zj(f, g, e);
            $8f2285b8ffe719da$var$X = null;
            $8f2285b8ffe719da$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $8f2285b8ffe719da$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$8f2285b8ffe719da$var$dk(b, a), b = b.sibling;
}
function $8f2285b8ffe719da$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            if (d & 4) {
                try {
                    $8f2285b8ffe719da$var$Pj(3, a, a.return), $8f2285b8ffe719da$var$Qj(3, a);
                } catch (t) {
                    $8f2285b8ffe719da$var$W(a, a.return, t);
                }
                try {
                    $8f2285b8ffe719da$var$Pj(5, a, a.return);
                } catch (t) {
                    $8f2285b8ffe719da$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            d & 512 && null !== c && $8f2285b8ffe719da$var$Lj(c, c.return);
            break;
        case 5:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            d & 512 && null !== c && $8f2285b8ffe719da$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $8f2285b8ffe719da$var$ob(e, "");
                } catch (t) {
                    $8f2285b8ffe719da$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $8f2285b8ffe719da$var$ab(e, f);
                    $8f2285b8ffe719da$var$vb(h, g);
                    var l = $8f2285b8ffe719da$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $8f2285b8ffe719da$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $8f2285b8ffe719da$var$nb(e, q) : "children" === m ? $8f2285b8ffe719da$var$ob(e, q) : $8f2285b8ffe719da$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $8f2285b8ffe719da$var$bb(e, f);
                            break;
                        case "textarea":
                            $8f2285b8ffe719da$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $8f2285b8ffe719da$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $8f2285b8ffe719da$var$fb(e, !!f.multiple, f.defaultValue, !0) : $8f2285b8ffe719da$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$8f2285b8ffe719da$var$Pf] = f;
                } catch (t) {
                    $8f2285b8ffe719da$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($8f2285b8ffe719da$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $8f2285b8ffe719da$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $8f2285b8ffe719da$var$bd(b.containerInfo);
            } catch (t) {
                $8f2285b8ffe719da$var$W(a, a.return, t);
            }
            break;
        case 4:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            break;
        case 13:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($8f2285b8ffe719da$var$fk = $8f2285b8ffe719da$var$B()));
            d & 4 && $8f2285b8ffe719da$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($8f2285b8ffe719da$var$U = (l = $8f2285b8ffe719da$var$U) || m, $8f2285b8ffe719da$var$ck(b, a), $8f2285b8ffe719da$var$U = l) : $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($8f2285b8ffe719da$var$V = a, m = a.child; null !== m;){
                    for(q = $8f2285b8ffe719da$var$V = m; null !== $8f2285b8ffe719da$var$V;){
                        r = $8f2285b8ffe719da$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $8f2285b8ffe719da$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $8f2285b8ffe719da$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $8f2285b8ffe719da$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $8f2285b8ffe719da$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $8f2285b8ffe719da$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $8f2285b8ffe719da$var$V = y) : $8f2285b8ffe719da$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $8f2285b8ffe719da$var$rb("display", g));
                            } catch (t) {
                                $8f2285b8ffe719da$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $8f2285b8ffe719da$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $8f2285b8ffe719da$var$ck(b, a);
            $8f2285b8ffe719da$var$ek(a);
            d & 4 && $8f2285b8ffe719da$var$ak(a);
            break;
        case 21:
            break;
        default:
            $8f2285b8ffe719da$var$ck(b, a), $8f2285b8ffe719da$var$ek(a);
    }
}
function $8f2285b8ffe719da$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($8f2285b8ffe719da$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($8f2285b8ffe719da$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($8f2285b8ffe719da$var$ob(e, ""), d.flags &= -33);
                    var f = $8f2285b8ffe719da$var$Uj(a);
                    $8f2285b8ffe719da$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $8f2285b8ffe719da$var$Uj(a);
                    $8f2285b8ffe719da$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($8f2285b8ffe719da$var$p(161));
            }
        } catch (k) {
            $8f2285b8ffe719da$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $8f2285b8ffe719da$var$hk(a, b, c) {
    $8f2285b8ffe719da$var$V = a;
    $8f2285b8ffe719da$var$ik(a, b, c);
}
function $8f2285b8ffe719da$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $8f2285b8ffe719da$var$V;){
        var e = $8f2285b8ffe719da$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $8f2285b8ffe719da$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $8f2285b8ffe719da$var$U;
                h = $8f2285b8ffe719da$var$Jj;
                var l = $8f2285b8ffe719da$var$U;
                $8f2285b8ffe719da$var$Jj = g;
                if (($8f2285b8ffe719da$var$U = k) && !l) for($8f2285b8ffe719da$var$V = e; null !== $8f2285b8ffe719da$var$V;)g = $8f2285b8ffe719da$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $8f2285b8ffe719da$var$jk(e) : null !== k ? (k.return = g, $8f2285b8ffe719da$var$V = k) : $8f2285b8ffe719da$var$jk(e);
                for(; null !== f;)$8f2285b8ffe719da$var$V = f, $8f2285b8ffe719da$var$ik(f, b, c), f = f.sibling;
                $8f2285b8ffe719da$var$V = e;
                $8f2285b8ffe719da$var$Jj = h;
                $8f2285b8ffe719da$var$U = l;
            }
            $8f2285b8ffe719da$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $8f2285b8ffe719da$var$V = f) : $8f2285b8ffe719da$var$kk(a, b, c);
    }
}
function $8f2285b8ffe719da$var$kk(a) {
    for(; null !== $8f2285b8ffe719da$var$V;){
        var b = $8f2285b8ffe719da$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $8f2285b8ffe719da$var$U || $8f2285b8ffe719da$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$8f2285b8ffe719da$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $8f2285b8ffe719da$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $8f2285b8ffe719da$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $8f2285b8ffe719da$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $8f2285b8ffe719da$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($8f2285b8ffe719da$var$p(163));
                }
                $8f2285b8ffe719da$var$U || b.flags & 512 && $8f2285b8ffe719da$var$Rj(b);
            } catch (r) {
                $8f2285b8ffe719da$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $8f2285b8ffe719da$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $8f2285b8ffe719da$var$V = c;
            break;
        }
        $8f2285b8ffe719da$var$V = b.return;
    }
}
function $8f2285b8ffe719da$var$gk(a) {
    for(; null !== $8f2285b8ffe719da$var$V;){
        var b = $8f2285b8ffe719da$var$V;
        if (b === a) {
            $8f2285b8ffe719da$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $8f2285b8ffe719da$var$V = c;
            break;
        }
        $8f2285b8ffe719da$var$V = b.return;
    }
}
function $8f2285b8ffe719da$var$jk(a) {
    for(; null !== $8f2285b8ffe719da$var$V;){
        var b = $8f2285b8ffe719da$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $8f2285b8ffe719da$var$Qj(4, b);
                    } catch (k) {
                        $8f2285b8ffe719da$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $8f2285b8ffe719da$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $8f2285b8ffe719da$var$Rj(b);
                    } catch (k) {
                        $8f2285b8ffe719da$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $8f2285b8ffe719da$var$Rj(b);
                    } catch (k) {
                        $8f2285b8ffe719da$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $8f2285b8ffe719da$var$W(b, b.return, k);
        }
        if (b === a) {
            $8f2285b8ffe719da$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $8f2285b8ffe719da$var$V = h;
            break;
        }
        $8f2285b8ffe719da$var$V = b.return;
    }
}
var $8f2285b8ffe719da$var$lk = Math.ceil, $8f2285b8ffe719da$var$mk = $8f2285b8ffe719da$var$ua.ReactCurrentDispatcher, $8f2285b8ffe719da$var$nk = $8f2285b8ffe719da$var$ua.ReactCurrentOwner, $8f2285b8ffe719da$var$ok = $8f2285b8ffe719da$var$ua.ReactCurrentBatchConfig, $8f2285b8ffe719da$var$K = 0, $8f2285b8ffe719da$var$Q = null, $8f2285b8ffe719da$var$Y = null, $8f2285b8ffe719da$var$Z = 0, $8f2285b8ffe719da$var$fj = 0, $8f2285b8ffe719da$var$ej = $8f2285b8ffe719da$var$Uf(0), $8f2285b8ffe719da$var$T = 0, $8f2285b8ffe719da$var$pk = null, $8f2285b8ffe719da$var$rh = 0, $8f2285b8ffe719da$var$qk = 0, $8f2285b8ffe719da$var$rk = 0, $8f2285b8ffe719da$var$sk = null, $8f2285b8ffe719da$var$tk = null, $8f2285b8ffe719da$var$fk = 0, $8f2285b8ffe719da$var$Gj = Infinity, $8f2285b8ffe719da$var$uk = null, $8f2285b8ffe719da$var$Oi = !1, $8f2285b8ffe719da$var$Pi = null, $8f2285b8ffe719da$var$Ri = null, $8f2285b8ffe719da$var$vk = !1, $8f2285b8ffe719da$var$wk = null, $8f2285b8ffe719da$var$xk = 0, $8f2285b8ffe719da$var$yk = 0, $8f2285b8ffe719da$var$zk = null, $8f2285b8ffe719da$var$Ak = -1, $8f2285b8ffe719da$var$Bk = 0;
function $8f2285b8ffe719da$var$R() {
    return 0 !== ($8f2285b8ffe719da$var$K & 6) ? $8f2285b8ffe719da$var$B() : -1 !== $8f2285b8ffe719da$var$Ak ? $8f2285b8ffe719da$var$Ak : $8f2285b8ffe719da$var$Ak = $8f2285b8ffe719da$var$B();
}
function $8f2285b8ffe719da$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($8f2285b8ffe719da$var$K & 2) && 0 !== $8f2285b8ffe719da$var$Z) return $8f2285b8ffe719da$var$Z & -$8f2285b8ffe719da$var$Z;
    if (null !== $8f2285b8ffe719da$var$Kg.transition) return 0 === $8f2285b8ffe719da$var$Bk && ($8f2285b8ffe719da$var$Bk = $8f2285b8ffe719da$var$yc()), $8f2285b8ffe719da$var$Bk;
    a = $8f2285b8ffe719da$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $8f2285b8ffe719da$var$jd(a.type);
    return a;
}
function $8f2285b8ffe719da$var$gi(a, b, c, d) {
    if (50 < $8f2285b8ffe719da$var$yk) throw $8f2285b8ffe719da$var$yk = 0, $8f2285b8ffe719da$var$zk = null, Error($8f2285b8ffe719da$var$p(185));
    $8f2285b8ffe719da$var$Ac(a, c, d);
    if (0 === ($8f2285b8ffe719da$var$K & 2) || a !== $8f2285b8ffe719da$var$Q) a === $8f2285b8ffe719da$var$Q && (0 === ($8f2285b8ffe719da$var$K & 2) && ($8f2285b8ffe719da$var$qk |= c), 4 === $8f2285b8ffe719da$var$T && $8f2285b8ffe719da$var$Ck(a, $8f2285b8ffe719da$var$Z)), $8f2285b8ffe719da$var$Dk(a, d), 1 === c && 0 === $8f2285b8ffe719da$var$K && 0 === (b.mode & 1) && ($8f2285b8ffe719da$var$Gj = $8f2285b8ffe719da$var$B() + 500, $8f2285b8ffe719da$var$fg && $8f2285b8ffe719da$var$jg());
}
function $8f2285b8ffe719da$var$Dk(a, b) {
    var c = a.callbackNode;
    $8f2285b8ffe719da$var$wc(a, b);
    var d = $8f2285b8ffe719da$var$uc(a, a === $8f2285b8ffe719da$var$Q ? $8f2285b8ffe719da$var$Z : 0);
    if (0 === d) null !== c && $8f2285b8ffe719da$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $8f2285b8ffe719da$var$bc(c);
        if (1 === b) 0 === a.tag ? $8f2285b8ffe719da$var$ig($8f2285b8ffe719da$var$Ek.bind(null, a)) : $8f2285b8ffe719da$var$hg($8f2285b8ffe719da$var$Ek.bind(null, a)), $8f2285b8ffe719da$var$Jf(function() {
            0 === ($8f2285b8ffe719da$var$K & 6) && $8f2285b8ffe719da$var$jg();
        }), c = null;
        else {
            switch($8f2285b8ffe719da$var$Dc(d)){
                case 1:
                    c = $8f2285b8ffe719da$var$fc;
                    break;
                case 4:
                    c = $8f2285b8ffe719da$var$gc;
                    break;
                case 16:
                    c = $8f2285b8ffe719da$var$hc;
                    break;
                case 536870912:
                    c = $8f2285b8ffe719da$var$jc;
                    break;
                default:
                    c = $8f2285b8ffe719da$var$hc;
            }
            c = $8f2285b8ffe719da$var$Fk(c, $8f2285b8ffe719da$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $8f2285b8ffe719da$var$Gk(a, b) {
    $8f2285b8ffe719da$var$Ak = -1;
    $8f2285b8ffe719da$var$Bk = 0;
    if (0 !== ($8f2285b8ffe719da$var$K & 6)) throw Error($8f2285b8ffe719da$var$p(327));
    var c = a.callbackNode;
    if ($8f2285b8ffe719da$var$Hk() && a.callbackNode !== c) return null;
    var d = $8f2285b8ffe719da$var$uc(a, a === $8f2285b8ffe719da$var$Q ? $8f2285b8ffe719da$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $8f2285b8ffe719da$var$Ik(a, d);
    else {
        b = d;
        var e = $8f2285b8ffe719da$var$K;
        $8f2285b8ffe719da$var$K |= 2;
        var f = $8f2285b8ffe719da$var$Jk();
        if ($8f2285b8ffe719da$var$Q !== a || $8f2285b8ffe719da$var$Z !== b) $8f2285b8ffe719da$var$uk = null, $8f2285b8ffe719da$var$Gj = $8f2285b8ffe719da$var$B() + 500, $8f2285b8ffe719da$var$Kk(a, b);
        for(;;)try {
            $8f2285b8ffe719da$var$Lk();
            break;
        } catch (h) {
            $8f2285b8ffe719da$var$Mk(a, h);
        }
        $8f2285b8ffe719da$var$$g();
        $8f2285b8ffe719da$var$mk.current = f;
        $8f2285b8ffe719da$var$K = e;
        null !== $8f2285b8ffe719da$var$Y ? b = 0 : ($8f2285b8ffe719da$var$Q = null, $8f2285b8ffe719da$var$Z = 0, b = $8f2285b8ffe719da$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $8f2285b8ffe719da$var$xc(a), 0 !== e && (d = e, b = $8f2285b8ffe719da$var$Nk(a, e)));
        if (1 === b) throw c = $8f2285b8ffe719da$var$pk, $8f2285b8ffe719da$var$Kk(a, 0), $8f2285b8ffe719da$var$Ck(a, d), $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B()), c;
        if (6 === b) $8f2285b8ffe719da$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$8f2285b8ffe719da$var$Ok(e) && (b = $8f2285b8ffe719da$var$Ik(a, d), 2 === b && (f = $8f2285b8ffe719da$var$xc(a), 0 !== f && (d = f, b = $8f2285b8ffe719da$var$Nk(a, f))), 1 === b)) throw c = $8f2285b8ffe719da$var$pk, $8f2285b8ffe719da$var$Kk(a, 0), $8f2285b8ffe719da$var$Ck(a, d), $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($8f2285b8ffe719da$var$p(345));
                case 2:
                    $8f2285b8ffe719da$var$Pk(a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk);
                    break;
                case 3:
                    $8f2285b8ffe719da$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $8f2285b8ffe719da$var$fk + 500 - $8f2285b8ffe719da$var$B(), 10 < b)) {
                        if (0 !== $8f2285b8ffe719da$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $8f2285b8ffe719da$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $8f2285b8ffe719da$var$Ff($8f2285b8ffe719da$var$Pk.bind(null, a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk), b);
                        break;
                    }
                    $8f2285b8ffe719da$var$Pk(a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk);
                    break;
                case 4:
                    $8f2285b8ffe719da$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $8f2285b8ffe719da$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $8f2285b8ffe719da$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $8f2285b8ffe719da$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $8f2285b8ffe719da$var$Ff($8f2285b8ffe719da$var$Pk.bind(null, a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk), d);
                        break;
                    }
                    $8f2285b8ffe719da$var$Pk(a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk);
                    break;
                case 5:
                    $8f2285b8ffe719da$var$Pk(a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk);
                    break;
                default:
                    throw Error($8f2285b8ffe719da$var$p(329));
            }
        }
    }
    $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B());
    return a.callbackNode === c ? $8f2285b8ffe719da$var$Gk.bind(null, a) : null;
}
function $8f2285b8ffe719da$var$Nk(a, b) {
    var c = $8f2285b8ffe719da$var$sk;
    a.current.memoizedState.isDehydrated && ($8f2285b8ffe719da$var$Kk(a, b).flags |= 256);
    a = $8f2285b8ffe719da$var$Ik(a, b);
    2 !== a && (b = $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$tk = c, null !== b && $8f2285b8ffe719da$var$Fj(b));
    return a;
}
function $8f2285b8ffe719da$var$Fj(a) {
    null === $8f2285b8ffe719da$var$tk ? $8f2285b8ffe719da$var$tk = a : $8f2285b8ffe719da$var$tk.push.apply($8f2285b8ffe719da$var$tk, a);
}
function $8f2285b8ffe719da$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$8f2285b8ffe719da$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $8f2285b8ffe719da$var$Ck(a, b) {
    b &= ~$8f2285b8ffe719da$var$rk;
    b &= ~$8f2285b8ffe719da$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $8f2285b8ffe719da$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $8f2285b8ffe719da$var$Ek(a) {
    if (0 !== ($8f2285b8ffe719da$var$K & 6)) throw Error($8f2285b8ffe719da$var$p(327));
    $8f2285b8ffe719da$var$Hk();
    var b = $8f2285b8ffe719da$var$uc(a, 0);
    if (0 === (b & 1)) return $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B()), null;
    var c = $8f2285b8ffe719da$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $8f2285b8ffe719da$var$xc(a);
        0 !== d && (b = d, c = $8f2285b8ffe719da$var$Nk(a, d));
    }
    if (1 === c) throw c = $8f2285b8ffe719da$var$pk, $8f2285b8ffe719da$var$Kk(a, 0), $8f2285b8ffe719da$var$Ck(a, b), $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B()), c;
    if (6 === c) throw Error($8f2285b8ffe719da$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $8f2285b8ffe719da$var$Pk(a, $8f2285b8ffe719da$var$tk, $8f2285b8ffe719da$var$uk);
    $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B());
    return null;
}
function $8f2285b8ffe719da$var$Qk(a, b) {
    var c = $8f2285b8ffe719da$var$K;
    $8f2285b8ffe719da$var$K |= 1;
    try {
        return a(b);
    } finally{
        $8f2285b8ffe719da$var$K = c, 0 === $8f2285b8ffe719da$var$K && ($8f2285b8ffe719da$var$Gj = $8f2285b8ffe719da$var$B() + 500, $8f2285b8ffe719da$var$fg && $8f2285b8ffe719da$var$jg());
    }
}
function $8f2285b8ffe719da$var$Rk(a) {
    null !== $8f2285b8ffe719da$var$wk && 0 === $8f2285b8ffe719da$var$wk.tag && 0 === ($8f2285b8ffe719da$var$K & 6) && $8f2285b8ffe719da$var$Hk();
    var b = $8f2285b8ffe719da$var$K;
    $8f2285b8ffe719da$var$K |= 1;
    var c = $8f2285b8ffe719da$var$ok.transition, d = $8f2285b8ffe719da$var$C;
    try {
        if ($8f2285b8ffe719da$var$ok.transition = null, $8f2285b8ffe719da$var$C = 1, a) return a();
    } finally{
        $8f2285b8ffe719da$var$C = d, $8f2285b8ffe719da$var$ok.transition = c, $8f2285b8ffe719da$var$K = b, 0 === ($8f2285b8ffe719da$var$K & 6) && $8f2285b8ffe719da$var$jg();
    }
}
function $8f2285b8ffe719da$var$Hj() {
    $8f2285b8ffe719da$var$fj = $8f2285b8ffe719da$var$ej.current;
    $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$ej);
}
function $8f2285b8ffe719da$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $8f2285b8ffe719da$var$Gf(c));
    if (null !== $8f2285b8ffe719da$var$Y) for(c = $8f2285b8ffe719da$var$Y.return; null !== c;){
        var d = c;
        $8f2285b8ffe719da$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $8f2285b8ffe719da$var$$f();
                break;
            case 3:
                $8f2285b8ffe719da$var$zh();
                $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$Wf);
                $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$H);
                $8f2285b8ffe719da$var$Eh();
                break;
            case 5:
                $8f2285b8ffe719da$var$Bh(d);
                break;
            case 4:
                $8f2285b8ffe719da$var$zh();
                break;
            case 13:
                $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L);
                break;
            case 19:
                $8f2285b8ffe719da$var$E($8f2285b8ffe719da$var$L);
                break;
            case 10:
                $8f2285b8ffe719da$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $8f2285b8ffe719da$var$Hj();
        }
        c = c.return;
    }
    $8f2285b8ffe719da$var$Q = a;
    $8f2285b8ffe719da$var$Y = a = $8f2285b8ffe719da$var$Pg(a.current, null);
    $8f2285b8ffe719da$var$Z = $8f2285b8ffe719da$var$fj = b;
    $8f2285b8ffe719da$var$T = 0;
    $8f2285b8ffe719da$var$pk = null;
    $8f2285b8ffe719da$var$rk = $8f2285b8ffe719da$var$qk = $8f2285b8ffe719da$var$rh = 0;
    $8f2285b8ffe719da$var$tk = $8f2285b8ffe719da$var$sk = null;
    if (null !== $8f2285b8ffe719da$var$fh) {
        for(b = 0; b < $8f2285b8ffe719da$var$fh.length; b++)if (c = $8f2285b8ffe719da$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $8f2285b8ffe719da$var$fh = null;
    }
    return a;
}
function $8f2285b8ffe719da$var$Mk(a, b) {
    do {
        var c = $8f2285b8ffe719da$var$Y;
        try {
            $8f2285b8ffe719da$var$$g();
            $8f2285b8ffe719da$var$Fh.current = $8f2285b8ffe719da$var$Rh;
            if ($8f2285b8ffe719da$var$Ih) {
                for(var d = $8f2285b8ffe719da$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $8f2285b8ffe719da$var$Ih = !1;
            }
            $8f2285b8ffe719da$var$Hh = 0;
            $8f2285b8ffe719da$var$O = $8f2285b8ffe719da$var$N = $8f2285b8ffe719da$var$M = null;
            $8f2285b8ffe719da$var$Jh = !1;
            $8f2285b8ffe719da$var$Kh = 0;
            $8f2285b8ffe719da$var$nk.current = null;
            if (null === c || null === c.return) {
                $8f2285b8ffe719da$var$T = 1;
                $8f2285b8ffe719da$var$pk = b;
                $8f2285b8ffe719da$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $8f2285b8ffe719da$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $8f2285b8ffe719da$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $8f2285b8ffe719da$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $8f2285b8ffe719da$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $8f2285b8ffe719da$var$Si(f, l, b);
                            $8f2285b8ffe719da$var$tj();
                            break a;
                        }
                        k = Error($8f2285b8ffe719da$var$p(426));
                    }
                } else if ($8f2285b8ffe719da$var$I && h.mode & 1) {
                    var J = $8f2285b8ffe719da$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $8f2285b8ffe719da$var$Vi(J, g, h, f, b);
                        $8f2285b8ffe719da$var$Jg($8f2285b8ffe719da$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $8f2285b8ffe719da$var$Ji(k, h);
                4 !== $8f2285b8ffe719da$var$T && ($8f2285b8ffe719da$var$T = 2);
                null === $8f2285b8ffe719da$var$sk ? $8f2285b8ffe719da$var$sk = [
                    f
                ] : $8f2285b8ffe719da$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $8f2285b8ffe719da$var$Ni(f, k, b);
                            $8f2285b8ffe719da$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $8f2285b8ffe719da$var$Ri || !$8f2285b8ffe719da$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $8f2285b8ffe719da$var$Qi(f, h, b);
                                $8f2285b8ffe719da$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $8f2285b8ffe719da$var$Sk(c);
        } catch (na) {
            b = na;
            $8f2285b8ffe719da$var$Y === c && null !== c && ($8f2285b8ffe719da$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $8f2285b8ffe719da$var$Jk() {
    var a = $8f2285b8ffe719da$var$mk.current;
    $8f2285b8ffe719da$var$mk.current = $8f2285b8ffe719da$var$Rh;
    return null === a ? $8f2285b8ffe719da$var$Rh : a;
}
function $8f2285b8ffe719da$var$tj() {
    if (0 === $8f2285b8ffe719da$var$T || 3 === $8f2285b8ffe719da$var$T || 2 === $8f2285b8ffe719da$var$T) $8f2285b8ffe719da$var$T = 4;
    null === $8f2285b8ffe719da$var$Q || 0 === ($8f2285b8ffe719da$var$rh & 268435455) && 0 === ($8f2285b8ffe719da$var$qk & 268435455) || $8f2285b8ffe719da$var$Ck($8f2285b8ffe719da$var$Q, $8f2285b8ffe719da$var$Z);
}
function $8f2285b8ffe719da$var$Ik(a, b) {
    var c = $8f2285b8ffe719da$var$K;
    $8f2285b8ffe719da$var$K |= 2;
    var d = $8f2285b8ffe719da$var$Jk();
    if ($8f2285b8ffe719da$var$Q !== a || $8f2285b8ffe719da$var$Z !== b) $8f2285b8ffe719da$var$uk = null, $8f2285b8ffe719da$var$Kk(a, b);
    for(;;)try {
        $8f2285b8ffe719da$var$Tk();
        break;
    } catch (e) {
        $8f2285b8ffe719da$var$Mk(a, e);
    }
    $8f2285b8ffe719da$var$$g();
    $8f2285b8ffe719da$var$K = c;
    $8f2285b8ffe719da$var$mk.current = d;
    if (null !== $8f2285b8ffe719da$var$Y) throw Error($8f2285b8ffe719da$var$p(261));
    $8f2285b8ffe719da$var$Q = null;
    $8f2285b8ffe719da$var$Z = 0;
    return $8f2285b8ffe719da$var$T;
}
function $8f2285b8ffe719da$var$Tk() {
    for(; null !== $8f2285b8ffe719da$var$Y;)$8f2285b8ffe719da$var$Uk($8f2285b8ffe719da$var$Y);
}
function $8f2285b8ffe719da$var$Lk() {
    for(; null !== $8f2285b8ffe719da$var$Y && !$8f2285b8ffe719da$var$cc();)$8f2285b8ffe719da$var$Uk($8f2285b8ffe719da$var$Y);
}
function $8f2285b8ffe719da$var$Uk(a) {
    var b = $8f2285b8ffe719da$var$Vk(a.alternate, a, $8f2285b8ffe719da$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $8f2285b8ffe719da$var$Sk(a) : $8f2285b8ffe719da$var$Y = b;
    $8f2285b8ffe719da$var$nk.current = null;
}
function $8f2285b8ffe719da$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $8f2285b8ffe719da$var$Ej(c, b, $8f2285b8ffe719da$var$fj), null !== c) {
                $8f2285b8ffe719da$var$Y = c;
                return;
            }
        } else {
            c = $8f2285b8ffe719da$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $8f2285b8ffe719da$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $8f2285b8ffe719da$var$T = 6;
                $8f2285b8ffe719da$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $8f2285b8ffe719da$var$Y = b;
            return;
        }
        $8f2285b8ffe719da$var$Y = b = a;
    }while (null !== b);
    0 === $8f2285b8ffe719da$var$T && ($8f2285b8ffe719da$var$T = 5);
}
function $8f2285b8ffe719da$var$Pk(a, b, c) {
    var d = $8f2285b8ffe719da$var$C, e = $8f2285b8ffe719da$var$ok.transition;
    try {
        $8f2285b8ffe719da$var$ok.transition = null, $8f2285b8ffe719da$var$C = 1, $8f2285b8ffe719da$var$Wk(a, b, c, d);
    } finally{
        $8f2285b8ffe719da$var$ok.transition = e, $8f2285b8ffe719da$var$C = d;
    }
    return null;
}
function $8f2285b8ffe719da$var$Wk(a, b, c, d) {
    do $8f2285b8ffe719da$var$Hk();
    while (null !== $8f2285b8ffe719da$var$wk);
    if (0 !== ($8f2285b8ffe719da$var$K & 6)) throw Error($8f2285b8ffe719da$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($8f2285b8ffe719da$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $8f2285b8ffe719da$var$Bc(a, f);
    a === $8f2285b8ffe719da$var$Q && ($8f2285b8ffe719da$var$Y = $8f2285b8ffe719da$var$Q = null, $8f2285b8ffe719da$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $8f2285b8ffe719da$var$vk || ($8f2285b8ffe719da$var$vk = !0, $8f2285b8ffe719da$var$Fk($8f2285b8ffe719da$var$hc, function() {
        $8f2285b8ffe719da$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $8f2285b8ffe719da$var$ok.transition;
        $8f2285b8ffe719da$var$ok.transition = null;
        var g = $8f2285b8ffe719da$var$C;
        $8f2285b8ffe719da$var$C = 1;
        var h = $8f2285b8ffe719da$var$K;
        $8f2285b8ffe719da$var$K |= 4;
        $8f2285b8ffe719da$var$nk.current = null;
        $8f2285b8ffe719da$var$Oj(a, c);
        $8f2285b8ffe719da$var$dk(c, a);
        $8f2285b8ffe719da$var$Oe($8f2285b8ffe719da$var$Df);
        $8f2285b8ffe719da$var$dd = !!$8f2285b8ffe719da$var$Cf;
        $8f2285b8ffe719da$var$Df = $8f2285b8ffe719da$var$Cf = null;
        a.current = c;
        $8f2285b8ffe719da$var$hk(c, a, e);
        $8f2285b8ffe719da$var$dc();
        $8f2285b8ffe719da$var$K = h;
        $8f2285b8ffe719da$var$C = g;
        $8f2285b8ffe719da$var$ok.transition = f;
    } else a.current = c;
    $8f2285b8ffe719da$var$vk && ($8f2285b8ffe719da$var$vk = !1, $8f2285b8ffe719da$var$wk = a, $8f2285b8ffe719da$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($8f2285b8ffe719da$var$Ri = null);
    $8f2285b8ffe719da$var$mc(c.stateNode, d);
    $8f2285b8ffe719da$var$Dk(a, $8f2285b8ffe719da$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($8f2285b8ffe719da$var$Oi) throw $8f2285b8ffe719da$var$Oi = !1, a = $8f2285b8ffe719da$var$Pi, $8f2285b8ffe719da$var$Pi = null, a;
    0 !== ($8f2285b8ffe719da$var$xk & 1) && 0 !== a.tag && $8f2285b8ffe719da$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $8f2285b8ffe719da$var$zk ? $8f2285b8ffe719da$var$yk++ : ($8f2285b8ffe719da$var$yk = 0, $8f2285b8ffe719da$var$zk = a) : $8f2285b8ffe719da$var$yk = 0;
    $8f2285b8ffe719da$var$jg();
    return null;
}
function $8f2285b8ffe719da$var$Hk() {
    if (null !== $8f2285b8ffe719da$var$wk) {
        var a = $8f2285b8ffe719da$var$Dc($8f2285b8ffe719da$var$xk), b = $8f2285b8ffe719da$var$ok.transition, c = $8f2285b8ffe719da$var$C;
        try {
            $8f2285b8ffe719da$var$ok.transition = null;
            $8f2285b8ffe719da$var$C = 16 > a ? 16 : a;
            if (null === $8f2285b8ffe719da$var$wk) var d = !1;
            else {
                a = $8f2285b8ffe719da$var$wk;
                $8f2285b8ffe719da$var$wk = null;
                $8f2285b8ffe719da$var$xk = 0;
                if (0 !== ($8f2285b8ffe719da$var$K & 6)) throw Error($8f2285b8ffe719da$var$p(331));
                var e = $8f2285b8ffe719da$var$K;
                $8f2285b8ffe719da$var$K |= 4;
                for($8f2285b8ffe719da$var$V = a.current; null !== $8f2285b8ffe719da$var$V;){
                    var f = $8f2285b8ffe719da$var$V, g = f.child;
                    if (0 !== ($8f2285b8ffe719da$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($8f2285b8ffe719da$var$V = l; null !== $8f2285b8ffe719da$var$V;){
                                    var m = $8f2285b8ffe719da$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $8f2285b8ffe719da$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $8f2285b8ffe719da$var$V = q;
                                    else for(; null !== $8f2285b8ffe719da$var$V;){
                                        m = $8f2285b8ffe719da$var$V;
                                        var r = m.sibling, y = m.return;
                                        $8f2285b8ffe719da$var$Sj(m);
                                        if (m === l) {
                                            $8f2285b8ffe719da$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $8f2285b8ffe719da$var$V = r;
                                            break;
                                        }
                                        $8f2285b8ffe719da$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $8f2285b8ffe719da$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $8f2285b8ffe719da$var$V = g;
                    else b: for(; null !== $8f2285b8ffe719da$var$V;){
                        f = $8f2285b8ffe719da$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $8f2285b8ffe719da$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $8f2285b8ffe719da$var$V = x;
                            break b;
                        }
                        $8f2285b8ffe719da$var$V = f.return;
                    }
                }
                var w = a.current;
                for($8f2285b8ffe719da$var$V = w; null !== $8f2285b8ffe719da$var$V;){
                    g = $8f2285b8ffe719da$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $8f2285b8ffe719da$var$V = u;
                    else b: for(g = w; null !== $8f2285b8ffe719da$var$V;){
                        h = $8f2285b8ffe719da$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $8f2285b8ffe719da$var$Qj(9, h);
                            }
                        } catch (na) {
                            $8f2285b8ffe719da$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $8f2285b8ffe719da$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $8f2285b8ffe719da$var$V = F;
                            break b;
                        }
                        $8f2285b8ffe719da$var$V = h.return;
                    }
                }
                $8f2285b8ffe719da$var$K = e;
                $8f2285b8ffe719da$var$jg();
                if ($8f2285b8ffe719da$var$lc && "function" === typeof $8f2285b8ffe719da$var$lc.onPostCommitFiberRoot) try {
                    $8f2285b8ffe719da$var$lc.onPostCommitFiberRoot($8f2285b8ffe719da$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $8f2285b8ffe719da$var$C = c, $8f2285b8ffe719da$var$ok.transition = b;
        }
    }
    return !1;
}
function $8f2285b8ffe719da$var$Xk(a, b, c) {
    b = $8f2285b8ffe719da$var$Ji(c, b);
    b = $8f2285b8ffe719da$var$Ni(a, b, 1);
    a = $8f2285b8ffe719da$var$nh(a, b, 1);
    b = $8f2285b8ffe719da$var$R();
    null !== a && ($8f2285b8ffe719da$var$Ac(a, 1, b), $8f2285b8ffe719da$var$Dk(a, b));
}
function $8f2285b8ffe719da$var$W(a, b, c) {
    if (3 === a.tag) $8f2285b8ffe719da$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $8f2285b8ffe719da$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $8f2285b8ffe719da$var$Ri || !$8f2285b8ffe719da$var$Ri.has(d))) {
                a = $8f2285b8ffe719da$var$Ji(c, a);
                a = $8f2285b8ffe719da$var$Qi(b, a, 1);
                b = $8f2285b8ffe719da$var$nh(b, a, 1);
                a = $8f2285b8ffe719da$var$R();
                null !== b && ($8f2285b8ffe719da$var$Ac(b, 1, a), $8f2285b8ffe719da$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $8f2285b8ffe719da$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $8f2285b8ffe719da$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $8f2285b8ffe719da$var$Q === a && ($8f2285b8ffe719da$var$Z & c) === c && (4 === $8f2285b8ffe719da$var$T || 3 === $8f2285b8ffe719da$var$T && ($8f2285b8ffe719da$var$Z & 130023424) === $8f2285b8ffe719da$var$Z && 500 > $8f2285b8ffe719da$var$B() - $8f2285b8ffe719da$var$fk ? $8f2285b8ffe719da$var$Kk(a, 0) : $8f2285b8ffe719da$var$rk |= c);
    $8f2285b8ffe719da$var$Dk(a, b);
}
function $8f2285b8ffe719da$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $8f2285b8ffe719da$var$sc, $8f2285b8ffe719da$var$sc <<= 1, 0 === ($8f2285b8ffe719da$var$sc & 130023424) && ($8f2285b8ffe719da$var$sc = 4194304)));
    var c = $8f2285b8ffe719da$var$R();
    a = $8f2285b8ffe719da$var$ih(a, b);
    null !== a && ($8f2285b8ffe719da$var$Ac(a, b, c), $8f2285b8ffe719da$var$Dk(a, c));
}
function $8f2285b8ffe719da$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $8f2285b8ffe719da$var$Yk(a, c);
}
function $8f2285b8ffe719da$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($8f2285b8ffe719da$var$p(314));
    }
    null !== d && d.delete(b);
    $8f2285b8ffe719da$var$Yk(a, c);
}
var $8f2285b8ffe719da$var$Vk;
$8f2285b8ffe719da$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $8f2285b8ffe719da$var$Wf.current) $8f2285b8ffe719da$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $8f2285b8ffe719da$var$dh = !1, $8f2285b8ffe719da$var$yj(a, b, c);
            $8f2285b8ffe719da$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $8f2285b8ffe719da$var$dh = !1, $8f2285b8ffe719da$var$I && 0 !== (b.flags & 1048576) && $8f2285b8ffe719da$var$ug(b, $8f2285b8ffe719da$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $8f2285b8ffe719da$var$ij(a, b);
            a = b.pendingProps;
            var e = $8f2285b8ffe719da$var$Yf(b, $8f2285b8ffe719da$var$H.current);
            $8f2285b8ffe719da$var$ch(b, c);
            e = $8f2285b8ffe719da$var$Nh(null, b, d, a, e, c);
            var f = $8f2285b8ffe719da$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $8f2285b8ffe719da$var$Zf(d) ? (f = !0, $8f2285b8ffe719da$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $8f2285b8ffe719da$var$kh(b), e.updater = $8f2285b8ffe719da$var$Ei, b.stateNode = e, e._reactInternals = b, $8f2285b8ffe719da$var$Ii(b, d, a, c), b = $8f2285b8ffe719da$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $8f2285b8ffe719da$var$I && f && $8f2285b8ffe719da$var$vg(b), $8f2285b8ffe719da$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $8f2285b8ffe719da$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $8f2285b8ffe719da$var$Zk(d);
                a = $8f2285b8ffe719da$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $8f2285b8ffe719da$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $8f2285b8ffe719da$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $8f2285b8ffe719da$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $8f2285b8ffe719da$var$$i(null, b, d, $8f2285b8ffe719da$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($8f2285b8ffe719da$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8f2285b8ffe719da$var$Ci(d, e), $8f2285b8ffe719da$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8f2285b8ffe719da$var$Ci(d, e), $8f2285b8ffe719da$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $8f2285b8ffe719da$var$kj(b);
                if (null === a) throw Error($8f2285b8ffe719da$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $8f2285b8ffe719da$var$lh(a, b);
                $8f2285b8ffe719da$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $8f2285b8ffe719da$var$Ji(Error($8f2285b8ffe719da$var$p(423)), b);
                        b = $8f2285b8ffe719da$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $8f2285b8ffe719da$var$Ji(Error($8f2285b8ffe719da$var$p(424)), b);
                        b = $8f2285b8ffe719da$var$lj(a, b, d, c, e);
                        break a;
                    } else for($8f2285b8ffe719da$var$yg = $8f2285b8ffe719da$var$Lf(b.stateNode.containerInfo.firstChild), $8f2285b8ffe719da$var$xg = b, $8f2285b8ffe719da$var$I = !0, $8f2285b8ffe719da$var$zg = null, c = $8f2285b8ffe719da$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $8f2285b8ffe719da$var$Ig();
                    if (d === e) {
                        b = $8f2285b8ffe719da$var$Zi(a, b, c);
                        break a;
                    }
                    $8f2285b8ffe719da$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $8f2285b8ffe719da$var$Ah(b), null === a && $8f2285b8ffe719da$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $8f2285b8ffe719da$var$Ef(d, e) ? g = null : null !== f && $8f2285b8ffe719da$var$Ef(d, f) && (b.flags |= 32), $8f2285b8ffe719da$var$gj(a, b), $8f2285b8ffe719da$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $8f2285b8ffe719da$var$Eg(b), null;
        case 13:
            return $8f2285b8ffe719da$var$oj(a, b, c);
        case 4:
            return $8f2285b8ffe719da$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $8f2285b8ffe719da$var$Ug(b, null, d, c) : $8f2285b8ffe719da$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8f2285b8ffe719da$var$Ci(d, e), $8f2285b8ffe719da$var$Yi(a, b, d, e, c);
        case 7:
            return $8f2285b8ffe719da$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $8f2285b8ffe719da$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $8f2285b8ffe719da$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $8f2285b8ffe719da$var$G($8f2285b8ffe719da$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($8f2285b8ffe719da$var$He(f.value, g)) {
                        if (f.children === e.children && !$8f2285b8ffe719da$var$Wf.current) {
                            b = $8f2285b8ffe719da$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $8f2285b8ffe719da$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $8f2285b8ffe719da$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($8f2285b8ffe719da$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $8f2285b8ffe719da$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $8f2285b8ffe719da$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $8f2285b8ffe719da$var$ch(b, c), e = $8f2285b8ffe719da$var$eh(e), d = d(e), b.flags |= 1, $8f2285b8ffe719da$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $8f2285b8ffe719da$var$Ci(d, b.pendingProps), e = $8f2285b8ffe719da$var$Ci(d.type, e), $8f2285b8ffe719da$var$$i(a, b, d, e, c);
        case 15:
            return $8f2285b8ffe719da$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8f2285b8ffe719da$var$Ci(d, e), $8f2285b8ffe719da$var$ij(a, b), b.tag = 1, $8f2285b8ffe719da$var$Zf(d) ? (a = !0, $8f2285b8ffe719da$var$cg(b)) : a = !1, $8f2285b8ffe719da$var$ch(b, c), $8f2285b8ffe719da$var$Gi(b, d, e), $8f2285b8ffe719da$var$Ii(b, d, e, c), $8f2285b8ffe719da$var$jj(null, b, d, !0, a, c);
        case 19:
            return $8f2285b8ffe719da$var$xj(a, b, c);
        case 22:
            return $8f2285b8ffe719da$var$dj(a, b, c);
    }
    throw Error($8f2285b8ffe719da$var$p(156, b.tag));
};
function $8f2285b8ffe719da$var$Fk(a, b) {
    return $8f2285b8ffe719da$var$ac(a, b);
}
function $8f2285b8ffe719da$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $8f2285b8ffe719da$var$Bg(a, b, c, d) {
    return new $8f2285b8ffe719da$var$$k(a, b, c, d);
}
function $8f2285b8ffe719da$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $8f2285b8ffe719da$var$Zk(a) {
    if ("function" === typeof a) return $8f2285b8ffe719da$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $8f2285b8ffe719da$var$Da) return 11;
        if (a === $8f2285b8ffe719da$var$Ga) return 14;
    }
    return 2;
}
function $8f2285b8ffe719da$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $8f2285b8ffe719da$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $8f2285b8ffe719da$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $8f2285b8ffe719da$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $8f2285b8ffe719da$var$ya:
            return $8f2285b8ffe719da$var$Tg(c.children, e, f, b);
        case $8f2285b8ffe719da$var$za:
            g = 8;
            e |= 8;
            break;
        case $8f2285b8ffe719da$var$Aa:
            return a = $8f2285b8ffe719da$var$Bg(12, c, b, e | 2), a.elementType = $8f2285b8ffe719da$var$Aa, a.lanes = f, a;
        case $8f2285b8ffe719da$var$Ea:
            return a = $8f2285b8ffe719da$var$Bg(13, c, b, e), a.elementType = $8f2285b8ffe719da$var$Ea, a.lanes = f, a;
        case $8f2285b8ffe719da$var$Fa:
            return a = $8f2285b8ffe719da$var$Bg(19, c, b, e), a.elementType = $8f2285b8ffe719da$var$Fa, a.lanes = f, a;
        case $8f2285b8ffe719da$var$Ia:
            return $8f2285b8ffe719da$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $8f2285b8ffe719da$var$Ba:
                    g = 10;
                    break a;
                case $8f2285b8ffe719da$var$Ca:
                    g = 9;
                    break a;
                case $8f2285b8ffe719da$var$Da:
                    g = 11;
                    break a;
                case $8f2285b8ffe719da$var$Ga:
                    g = 14;
                    break a;
                case $8f2285b8ffe719da$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($8f2285b8ffe719da$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $8f2285b8ffe719da$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $8f2285b8ffe719da$var$Tg(a, b, c, d) {
    a = $8f2285b8ffe719da$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $8f2285b8ffe719da$var$pj(a, b, c, d) {
    a = $8f2285b8ffe719da$var$Bg(22, a, d, b);
    a.elementType = $8f2285b8ffe719da$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $8f2285b8ffe719da$var$Qg(a, b, c) {
    a = $8f2285b8ffe719da$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $8f2285b8ffe719da$var$Sg(a, b, c) {
    b = $8f2285b8ffe719da$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $8f2285b8ffe719da$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $8f2285b8ffe719da$var$zc(0);
    this.expirationTimes = $8f2285b8ffe719da$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $8f2285b8ffe719da$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $8f2285b8ffe719da$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $8f2285b8ffe719da$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $8f2285b8ffe719da$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $8f2285b8ffe719da$var$kh(f);
    return a;
}
function $8f2285b8ffe719da$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $8f2285b8ffe719da$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $8f2285b8ffe719da$var$dl(a) {
    if (!a) return $8f2285b8ffe719da$var$Vf;
    a = a._reactInternals;
    a: {
        if ($8f2285b8ffe719da$var$Vb(a) !== a || 1 !== a.tag) throw Error($8f2285b8ffe719da$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($8f2285b8ffe719da$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($8f2285b8ffe719da$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($8f2285b8ffe719da$var$Zf(c)) return $8f2285b8ffe719da$var$bg(a, c, b);
    }
    return b;
}
function $8f2285b8ffe719da$var$el(a, b, c, d, e, f, g, h, k) {
    a = $8f2285b8ffe719da$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $8f2285b8ffe719da$var$dl(null);
    c = a.current;
    d = $8f2285b8ffe719da$var$R();
    e = $8f2285b8ffe719da$var$yi(c);
    f = $8f2285b8ffe719da$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $8f2285b8ffe719da$var$nh(c, f, e);
    a.current.lanes = e;
    $8f2285b8ffe719da$var$Ac(a, e, d);
    $8f2285b8ffe719da$var$Dk(a, d);
    return a;
}
function $8f2285b8ffe719da$var$fl(a, b, c, d) {
    var e = b.current, f = $8f2285b8ffe719da$var$R(), g = $8f2285b8ffe719da$var$yi(e);
    c = $8f2285b8ffe719da$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $8f2285b8ffe719da$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $8f2285b8ffe719da$var$nh(e, b, g);
    null !== a && ($8f2285b8ffe719da$var$gi(a, e, g, f), $8f2285b8ffe719da$var$oh(a, e, g));
    return g;
}
function $8f2285b8ffe719da$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $8f2285b8ffe719da$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $8f2285b8ffe719da$var$il(a, b) {
    $8f2285b8ffe719da$var$hl(a, b);
    (a = a.alternate) && $8f2285b8ffe719da$var$hl(a, b);
}
function $8f2285b8ffe719da$var$jl() {
    return null;
}
var $8f2285b8ffe719da$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $8f2285b8ffe719da$var$ll(a) {
    this._internalRoot = a;
}
$8f2285b8ffe719da$var$ml.prototype.render = $8f2285b8ffe719da$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($8f2285b8ffe719da$var$p(409));
    $8f2285b8ffe719da$var$fl(a, b, null, null);
};
$8f2285b8ffe719da$var$ml.prototype.unmount = $8f2285b8ffe719da$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $8f2285b8ffe719da$var$Rk(function() {
            $8f2285b8ffe719da$var$fl(null, a, null, null);
        });
        b[$8f2285b8ffe719da$var$uf] = null;
    }
};
function $8f2285b8ffe719da$var$ml(a) {
    this._internalRoot = a;
}
$8f2285b8ffe719da$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $8f2285b8ffe719da$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $8f2285b8ffe719da$var$Qc.length && 0 !== b && b < $8f2285b8ffe719da$var$Qc[c].priority; c++);
        $8f2285b8ffe719da$var$Qc.splice(c, 0, a);
        0 === c && $8f2285b8ffe719da$var$Vc(a);
    }
};
function $8f2285b8ffe719da$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $8f2285b8ffe719da$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $8f2285b8ffe719da$var$pl() {}
function $8f2285b8ffe719da$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $8f2285b8ffe719da$var$gl(g);
                f.call(a);
            };
        }
        var g = $8f2285b8ffe719da$var$el(b, d, a, 0, null, !1, !1, "", $8f2285b8ffe719da$var$pl);
        a._reactRootContainer = g;
        a[$8f2285b8ffe719da$var$uf] = g.current;
        $8f2285b8ffe719da$var$sf(8 === a.nodeType ? a.parentNode : a);
        $8f2285b8ffe719da$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $8f2285b8ffe719da$var$gl(k);
            h.call(a);
        };
    }
    var k = $8f2285b8ffe719da$var$bl(a, 0, !1, null, null, !1, !1, "", $8f2285b8ffe719da$var$pl);
    a._reactRootContainer = k;
    a[$8f2285b8ffe719da$var$uf] = k.current;
    $8f2285b8ffe719da$var$sf(8 === a.nodeType ? a.parentNode : a);
    $8f2285b8ffe719da$var$Rk(function() {
        $8f2285b8ffe719da$var$fl(b, k, c, d);
    });
    return k;
}
function $8f2285b8ffe719da$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $8f2285b8ffe719da$var$gl(g);
                h.call(a);
            };
        }
        $8f2285b8ffe719da$var$fl(b, g, a, e);
    } else g = $8f2285b8ffe719da$var$ql(c, b, a, e, d);
    return $8f2285b8ffe719da$var$gl(g);
}
$8f2285b8ffe719da$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $8f2285b8ffe719da$var$tc(b.pendingLanes);
                0 !== c && ($8f2285b8ffe719da$var$Cc(b, c | 1), $8f2285b8ffe719da$var$Dk(b, $8f2285b8ffe719da$var$B()), 0 === ($8f2285b8ffe719da$var$K & 6) && ($8f2285b8ffe719da$var$Gj = $8f2285b8ffe719da$var$B() + 500, $8f2285b8ffe719da$var$jg()));
            }
            break;
        case 13:
            $8f2285b8ffe719da$var$Rk(function() {
                var b = $8f2285b8ffe719da$var$ih(a, 1);
                if (null !== b) {
                    var c = $8f2285b8ffe719da$var$R();
                    $8f2285b8ffe719da$var$gi(b, a, 1, c);
                }
            }), $8f2285b8ffe719da$var$il(a, 1);
    }
};
$8f2285b8ffe719da$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $8f2285b8ffe719da$var$ih(a, 134217728);
        if (null !== b) {
            var c = $8f2285b8ffe719da$var$R();
            $8f2285b8ffe719da$var$gi(b, a, 134217728, c);
        }
        $8f2285b8ffe719da$var$il(a, 134217728);
    }
};
$8f2285b8ffe719da$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $8f2285b8ffe719da$var$yi(a), c = $8f2285b8ffe719da$var$ih(a, b);
        if (null !== c) {
            var d = $8f2285b8ffe719da$var$R();
            $8f2285b8ffe719da$var$gi(c, a, b, d);
        }
        $8f2285b8ffe719da$var$il(a, b);
    }
};
$8f2285b8ffe719da$var$Hc = function() {
    return $8f2285b8ffe719da$var$C;
};
$8f2285b8ffe719da$var$Ic = function(a, b) {
    var c = $8f2285b8ffe719da$var$C;
    try {
        return $8f2285b8ffe719da$var$C = a, b();
    } finally{
        $8f2285b8ffe719da$var$C = c;
    }
};
$8f2285b8ffe719da$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $8f2285b8ffe719da$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $8f2285b8ffe719da$var$Db(d);
                        if (!e) throw Error($8f2285b8ffe719da$var$p(90));
                        $8f2285b8ffe719da$var$Wa(d);
                        $8f2285b8ffe719da$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $8f2285b8ffe719da$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $8f2285b8ffe719da$var$fb(a, !!c.multiple, b, !1);
    }
};
$8f2285b8ffe719da$var$Gb = $8f2285b8ffe719da$var$Qk;
$8f2285b8ffe719da$var$Hb = $8f2285b8ffe719da$var$Rk;
var $8f2285b8ffe719da$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $8f2285b8ffe719da$var$Cb,
        $8f2285b8ffe719da$var$ue,
        $8f2285b8ffe719da$var$Db,
        $8f2285b8ffe719da$var$Eb,
        $8f2285b8ffe719da$var$Fb,
        $8f2285b8ffe719da$var$Qk
    ]
}, $8f2285b8ffe719da$var$tl = {
    findFiberByHostInstance: $8f2285b8ffe719da$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $8f2285b8ffe719da$var$ul = {
    bundleType: $8f2285b8ffe719da$var$tl.bundleType,
    version: $8f2285b8ffe719da$var$tl.version,
    rendererPackageName: $8f2285b8ffe719da$var$tl.rendererPackageName,
    rendererConfig: $8f2285b8ffe719da$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $8f2285b8ffe719da$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $8f2285b8ffe719da$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $8f2285b8ffe719da$var$tl.findFiberByHostInstance || $8f2285b8ffe719da$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $8f2285b8ffe719da$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$8f2285b8ffe719da$var$vl.isDisabled && $8f2285b8ffe719da$var$vl.supportsFiber) try {
        $8f2285b8ffe719da$var$kc = $8f2285b8ffe719da$var$vl.inject($8f2285b8ffe719da$var$ul), $8f2285b8ffe719da$var$lc = $8f2285b8ffe719da$var$vl;
    } catch (a) {}
}
$8f2285b8ffe719da$export$ae55be85d98224ed = $8f2285b8ffe719da$var$sl;
$8f2285b8ffe719da$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$8f2285b8ffe719da$var$nl(b)) throw Error($8f2285b8ffe719da$var$p(200));
    return $8f2285b8ffe719da$var$cl(a, b, null, c);
};
$8f2285b8ffe719da$export$882461b6382ed46c = function(a, b) {
    if (!$8f2285b8ffe719da$var$nl(a)) throw Error($8f2285b8ffe719da$var$p(299));
    var c = !1, d = "", e = $8f2285b8ffe719da$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $8f2285b8ffe719da$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$8f2285b8ffe719da$var$uf] = b.current;
    $8f2285b8ffe719da$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $8f2285b8ffe719da$var$ll(b);
};
$8f2285b8ffe719da$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($8f2285b8ffe719da$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($8f2285b8ffe719da$var$p(268, a));
    }
    a = $8f2285b8ffe719da$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$8f2285b8ffe719da$export$cd75ccfd720a3cd4 = function(a) {
    return $8f2285b8ffe719da$var$Rk(a);
};
$8f2285b8ffe719da$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$8f2285b8ffe719da$var$ol(b)) throw Error($8f2285b8ffe719da$var$p(200));
    return $8f2285b8ffe719da$var$rl(null, a, b, !0, c);
};
$8f2285b8ffe719da$export$757ceba2d55c277e = function(a, b, c) {
    if (!$8f2285b8ffe719da$var$nl(a)) throw Error($8f2285b8ffe719da$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $8f2285b8ffe719da$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $8f2285b8ffe719da$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$8f2285b8ffe719da$var$uf] = b.current;
    $8f2285b8ffe719da$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $8f2285b8ffe719da$var$ml(b);
};
$8f2285b8ffe719da$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$8f2285b8ffe719da$var$ol(b)) throw Error($8f2285b8ffe719da$var$p(200));
    return $8f2285b8ffe719da$var$rl(null, a, b, !1, c);
};
$8f2285b8ffe719da$export$502457920280e6be = function(a) {
    if (!$8f2285b8ffe719da$var$ol(a)) throw Error($8f2285b8ffe719da$var$p(40));
    return a._reactRootContainer ? ($8f2285b8ffe719da$var$Rk(function() {
        $8f2285b8ffe719da$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$8f2285b8ffe719da$var$uf] = null;
        });
    }), !0) : !1;
};
$8f2285b8ffe719da$export$c78a37762a8d58e1 = $8f2285b8ffe719da$var$Qk;
$8f2285b8ffe719da$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$8f2285b8ffe719da$var$ol(c)) throw Error($8f2285b8ffe719da$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($8f2285b8ffe719da$var$p(38));
    return $8f2285b8ffe719da$var$rl(a, b, c, !1, d);
};
$8f2285b8ffe719da$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("e00l3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gwwKq"));

});
parcelRegister("gwwKq", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $c079098268807020$export$c4744153514ff05d; }, function (v) { return $c079098268807020$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $c079098268807020$export$3e506c1ccc9cc1a7; }, function (v) { return $c079098268807020$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $c079098268807020$export$e26fe2ed2fa76875; }, function (v) { return $c079098268807020$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $c079098268807020$export$502329bbf4b505b1; }, function (v) { return $c079098268807020$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $c079098268807020$export$6e3807111c4874c4; }, function (v) { return $c079098268807020$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $c079098268807020$export$c27134553091fb3a; }, function (v) { return $c079098268807020$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $c079098268807020$export$33ee1acdc04fd2a2; }, function (v) { return $c079098268807020$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $c079098268807020$export$b00a404bbd5edef2; }, function (v) { return $c079098268807020$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $c079098268807020$export$8352ce38b91d0c62; }, function (v) { return $c079098268807020$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $c079098268807020$export$d66a1c1c77bd778b; }, function (v) { return $c079098268807020$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $c079098268807020$export$d3dfb8e4810cb555; }, function (v) { return $c079098268807020$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $c079098268807020$export$839f9183b0465a69; }, function (v) { return $c079098268807020$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $c079098268807020$export$72fdf0e06517287b; }, function (v) { return $c079098268807020$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $c079098268807020$export$4b844e58a3e414b4; }, function (v) { return $c079098268807020$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $c079098268807020$export$816d2913ae6b83b1; }, function (v) { return $c079098268807020$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $c079098268807020$export$61bcfe829111a1d0; }, function (v) { return $c079098268807020$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $c079098268807020$export$7ee8c9beb337bc3f; }, function (v) { return $c079098268807020$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $c079098268807020$export$b5836b71941fa3ed; }, function (v) { return $c079098268807020$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $c079098268807020$export$cf845f2c119da08a; }, function (v) { return $c079098268807020$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c079098268807020$export$c4744153514ff05d;
var $c079098268807020$export$3e506c1ccc9cc1a7;
var $c079098268807020$export$e26fe2ed2fa76875;
var $c079098268807020$export$502329bbf4b505b1;
var $c079098268807020$export$6e3807111c4874c4;
var $c079098268807020$export$c27134553091fb3a;
var $c079098268807020$export$33ee1acdc04fd2a2;
var $c079098268807020$export$b00a404bbd5edef2;
var $c079098268807020$export$8352ce38b91d0c62;
var $c079098268807020$export$d66a1c1c77bd778b;
var $c079098268807020$export$d3dfb8e4810cb555;
var $c079098268807020$export$839f9183b0465a69;
var $c079098268807020$export$72fdf0e06517287b;
var $c079098268807020$export$4b844e58a3e414b4;
var $c079098268807020$export$816d2913ae6b83b1;
var $c079098268807020$export$61bcfe829111a1d0;
var $c079098268807020$export$7ee8c9beb337bc3f;
var $c079098268807020$export$b5836b71941fa3ed;
var $c079098268807020$export$cf845f2c119da08a;
"use strict";
function $c079098268807020$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $c079098268807020$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $c079098268807020$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $c079098268807020$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $c079098268807020$var$g(C, c)) n < e && 0 > $c079098268807020$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $c079098268807020$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $c079098268807020$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $c079098268807020$var$l = performance;
    $c079098268807020$export$c4744153514ff05d = function() {
        return $c079098268807020$var$l.now();
    };
} else {
    var $c079098268807020$var$p = Date, $c079098268807020$var$q = $c079098268807020$var$p.now();
    $c079098268807020$export$c4744153514ff05d = function() {
        return $c079098268807020$var$p.now() - $c079098268807020$var$q;
    };
}
var $c079098268807020$var$r = [], $c079098268807020$var$t = [], $c079098268807020$var$u = 1, $c079098268807020$var$v = null, $c079098268807020$var$y = 3, $c079098268807020$var$z = !1, $c079098268807020$var$A = !1, $c079098268807020$var$B = !1, $c079098268807020$var$D = "function" === typeof setTimeout ? setTimeout : null, $c079098268807020$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $c079098268807020$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $c079098268807020$var$G(a) {
    for(var b = $c079098268807020$var$h($c079098268807020$var$t); null !== b;){
        if (null === b.callback) $c079098268807020$var$k($c079098268807020$var$t);
        else if (b.startTime <= a) $c079098268807020$var$k($c079098268807020$var$t), b.sortIndex = b.expirationTime, $c079098268807020$var$f($c079098268807020$var$r, b);
        else break;
        b = $c079098268807020$var$h($c079098268807020$var$t);
    }
}
function $c079098268807020$var$H(a) {
    $c079098268807020$var$B = !1;
    $c079098268807020$var$G(a);
    if (!$c079098268807020$var$A) {
        if (null !== $c079098268807020$var$h($c079098268807020$var$r)) $c079098268807020$var$A = !0, $c079098268807020$var$I($c079098268807020$var$J);
        else {
            var b = $c079098268807020$var$h($c079098268807020$var$t);
            null !== b && $c079098268807020$var$K($c079098268807020$var$H, b.startTime - a);
        }
    }
}
function $c079098268807020$var$J(a, b) {
    $c079098268807020$var$A = !1;
    $c079098268807020$var$B && ($c079098268807020$var$B = !1, $c079098268807020$var$E($c079098268807020$var$L), $c079098268807020$var$L = -1);
    $c079098268807020$var$z = !0;
    var c = $c079098268807020$var$y;
    try {
        $c079098268807020$var$G(b);
        for($c079098268807020$var$v = $c079098268807020$var$h($c079098268807020$var$r); null !== $c079098268807020$var$v && (!($c079098268807020$var$v.expirationTime > b) || a && !$c079098268807020$var$M());){
            var d = $c079098268807020$var$v.callback;
            if ("function" === typeof d) {
                $c079098268807020$var$v.callback = null;
                $c079098268807020$var$y = $c079098268807020$var$v.priorityLevel;
                var e = d($c079098268807020$var$v.expirationTime <= b);
                b = $c079098268807020$export$c4744153514ff05d();
                "function" === typeof e ? $c079098268807020$var$v.callback = e : $c079098268807020$var$v === $c079098268807020$var$h($c079098268807020$var$r) && $c079098268807020$var$k($c079098268807020$var$r);
                $c079098268807020$var$G(b);
            } else $c079098268807020$var$k($c079098268807020$var$r);
            $c079098268807020$var$v = $c079098268807020$var$h($c079098268807020$var$r);
        }
        if (null !== $c079098268807020$var$v) var w = !0;
        else {
            var m = $c079098268807020$var$h($c079098268807020$var$t);
            null !== m && $c079098268807020$var$K($c079098268807020$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $c079098268807020$var$v = null, $c079098268807020$var$y = c, $c079098268807020$var$z = !1;
    }
}
var $c079098268807020$var$N = !1, $c079098268807020$var$O = null, $c079098268807020$var$L = -1, $c079098268807020$var$P = 5, $c079098268807020$var$Q = -1;
function $c079098268807020$var$M() {
    return $c079098268807020$export$c4744153514ff05d() - $c079098268807020$var$Q < $c079098268807020$var$P ? !1 : !0;
}
function $c079098268807020$var$R() {
    if (null !== $c079098268807020$var$O) {
        var a = $c079098268807020$export$c4744153514ff05d();
        $c079098268807020$var$Q = a;
        var b = !0;
        try {
            b = $c079098268807020$var$O(!0, a);
        } finally{
            b ? $c079098268807020$var$S() : ($c079098268807020$var$N = !1, $c079098268807020$var$O = null);
        }
    } else $c079098268807020$var$N = !1;
}
var $c079098268807020$var$S;
if ("function" === typeof $c079098268807020$var$F) $c079098268807020$var$S = function() {
    $c079098268807020$var$F($c079098268807020$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $c079098268807020$var$T = new MessageChannel, $c079098268807020$var$U = $c079098268807020$var$T.port2;
    $c079098268807020$var$T.port1.onmessage = $c079098268807020$var$R;
    $c079098268807020$var$S = function() {
        $c079098268807020$var$U.postMessage(null);
    };
} else $c079098268807020$var$S = function() {
    $c079098268807020$var$D($c079098268807020$var$R, 0);
};
function $c079098268807020$var$I(a) {
    $c079098268807020$var$O = a;
    $c079098268807020$var$N || ($c079098268807020$var$N = !0, $c079098268807020$var$S());
}
function $c079098268807020$var$K(a, b) {
    $c079098268807020$var$L = $c079098268807020$var$D(function() {
        a($c079098268807020$export$c4744153514ff05d());
    }, b);
}
$c079098268807020$export$3e506c1ccc9cc1a7 = 5;
$c079098268807020$export$e26fe2ed2fa76875 = 1;
$c079098268807020$export$502329bbf4b505b1 = 4;
$c079098268807020$export$6e3807111c4874c4 = 3;
$c079098268807020$export$c27134553091fb3a = null;
$c079098268807020$export$33ee1acdc04fd2a2 = 2;
$c079098268807020$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$c079098268807020$export$8352ce38b91d0c62 = function() {
    $c079098268807020$var$A || $c079098268807020$var$z || ($c079098268807020$var$A = !0, $c079098268807020$var$I($c079098268807020$var$J));
};
$c079098268807020$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $c079098268807020$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$c079098268807020$export$d3dfb8e4810cb555 = function() {
    return $c079098268807020$var$y;
};
$c079098268807020$export$839f9183b0465a69 = function() {
    return $c079098268807020$var$h($c079098268807020$var$r);
};
$c079098268807020$export$72fdf0e06517287b = function(a) {
    switch($c079098268807020$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $c079098268807020$var$y;
    }
    var c = $c079098268807020$var$y;
    $c079098268807020$var$y = b;
    try {
        return a();
    } finally{
        $c079098268807020$var$y = c;
    }
};
$c079098268807020$export$4b844e58a3e414b4 = function() {};
$c079098268807020$export$816d2913ae6b83b1 = function() {};
$c079098268807020$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $c079098268807020$var$y;
    $c079098268807020$var$y = a;
    try {
        return b();
    } finally{
        $c079098268807020$var$y = c;
    }
};
$c079098268807020$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $c079098268807020$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $c079098268807020$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $c079098268807020$var$f($c079098268807020$var$t, a), null === $c079098268807020$var$h($c079098268807020$var$r) && a === $c079098268807020$var$h($c079098268807020$var$t) && ($c079098268807020$var$B ? ($c079098268807020$var$E($c079098268807020$var$L), $c079098268807020$var$L = -1) : $c079098268807020$var$B = !0, $c079098268807020$var$K($c079098268807020$var$H, c - d))) : (a.sortIndex = e, $c079098268807020$var$f($c079098268807020$var$r, a), $c079098268807020$var$A || $c079098268807020$var$z || ($c079098268807020$var$A = !0, $c079098268807020$var$I($c079098268807020$var$J)));
    return a;
};
$c079098268807020$export$b5836b71941fa3ed = $c079098268807020$var$M;
$c079098268807020$export$cf845f2c119da08a = function(a) {
    var b = $c079098268807020$var$y;
    return function() {
        var c = $c079098268807020$var$y;
        $c079098268807020$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $c079098268807020$var$y = c;
        }
    };
};

});



parcelRegister("biihp", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $838f8e26ffad97d3$export$306c0aa65ff9ec16; }, function (v) { return $838f8e26ffad97d3$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $838f8e26ffad97d3$export$306c0aa65ff9ec16;
"use strict";

var $3QbnI = parcelRequire("3QbnI");
function $838f8e26ffad97d3$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $838f8e26ffad97d3$var$k = "function" === typeof Object.is ? Object.is : $838f8e26ffad97d3$var$h, $838f8e26ffad97d3$var$l = $3QbnI.useState, $838f8e26ffad97d3$var$m = $3QbnI.useEffect, $838f8e26ffad97d3$var$n = $3QbnI.useLayoutEffect, $838f8e26ffad97d3$var$p = $3QbnI.useDebugValue;
function $838f8e26ffad97d3$var$q(a, b) {
    var d = b(), f = $838f8e26ffad97d3$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $838f8e26ffad97d3$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $838f8e26ffad97d3$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $838f8e26ffad97d3$var$m(function() {
        $838f8e26ffad97d3$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $838f8e26ffad97d3$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $838f8e26ffad97d3$var$p(d);
    return d;
}
function $838f8e26ffad97d3$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$838f8e26ffad97d3$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $838f8e26ffad97d3$var$t(a, b) {
    return b();
}
var $838f8e26ffad97d3$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $838f8e26ffad97d3$var$t : $838f8e26ffad97d3$var$q;
$838f8e26ffad97d3$export$306c0aa65ff9ec16 = void 0 !== $3QbnI.useSyncExternalStore ? $3QbnI.useSyncExternalStore : $838f8e26ffad97d3$var$u;

});

parcelRegister("154Qf", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $0c9a038ff2d9e8b0$export$bf730a2d8bf68b42; }, function (v) { return $0c9a038ff2d9e8b0$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0c9a038ff2d9e8b0$export$bf730a2d8bf68b42;
"use strict";

var $3QbnI = parcelRequire("3QbnI");

var $eW1QL = parcelRequire("eW1QL");
function $0c9a038ff2d9e8b0$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0c9a038ff2d9e8b0$var$q = "function" === typeof Object.is ? Object.is : $0c9a038ff2d9e8b0$var$p, $0c9a038ff2d9e8b0$var$r = $eW1QL.useSyncExternalStore, $0c9a038ff2d9e8b0$var$t = $3QbnI.useRef, $0c9a038ff2d9e8b0$var$u = $3QbnI.useEffect, $0c9a038ff2d9e8b0$var$v = $3QbnI.useMemo, $0c9a038ff2d9e8b0$var$w = $3QbnI.useDebugValue;
$0c9a038ff2d9e8b0$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $0c9a038ff2d9e8b0$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $0c9a038ff2d9e8b0$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($0c9a038ff2d9e8b0$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $0c9a038ff2d9e8b0$var$r(a, c[0], c[1]);
    $0c9a038ff2d9e8b0$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $0c9a038ff2d9e8b0$var$w(d);
    return d;
};

});
parcelRegister("eW1QL", function(module, exports) {
"use strict";

module.exports = (parcelRequire("biihp"));

});


parcelRegister("a5UKC", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $759664958dfcc4e1$export$2b8d127b894957b9; }, function (v) { return $759664958dfcc4e1$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $759664958dfcc4e1$export$cea3a54a6425200c; }, function (v) { return $759664958dfcc4e1$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $759664958dfcc4e1$export$a7c73072b1a182ae; }, function (v) { return $759664958dfcc4e1$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $759664958dfcc4e1$export$9f27bc3417b4524d; }, function (v) { return $759664958dfcc4e1$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $759664958dfcc4e1$export$db77ccec0bb4ccac; }, function (v) { return $759664958dfcc4e1$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $759664958dfcc4e1$export$8392c0c9d3dcbd35; }, function (v) { return $759664958dfcc4e1$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $759664958dfcc4e1$export$ffb0004e005737fa; }, function (v) { return $759664958dfcc4e1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $759664958dfcc4e1$export$b624eff549462981; }, function (v) { return $759664958dfcc4e1$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $759664958dfcc4e1$export$7897aa7841a5380c; }, function (v) { return $759664958dfcc4e1$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $759664958dfcc4e1$export$602eac185826482c; }, function (v) { return $759664958dfcc4e1$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $759664958dfcc4e1$export$e2c29f18771995cb; }, function (v) { return $759664958dfcc4e1$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $759664958dfcc4e1$export$5f8d39834fd61797; }, function (v) { return $759664958dfcc4e1$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $759664958dfcc4e1$export$74bf444e3cd11ea5; }, function (v) { return $759664958dfcc4e1$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $759664958dfcc4e1$export$92387174baf9b227; }, function (v) { return $759664958dfcc4e1$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $759664958dfcc4e1$export$ec112efeb987d9c6; }, function (v) { return $759664958dfcc4e1$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $759664958dfcc4e1$export$b706b080d889d2c9; }, function (v) { return $759664958dfcc4e1$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $759664958dfcc4e1$export$5be5a87408f70ddc; }, function (v) { return $759664958dfcc4e1$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $759664958dfcc4e1$export$45a5e7f76e0caa8d; }, function (v) { return $759664958dfcc4e1$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $759664958dfcc4e1$export$455c2e768291efa6; }, function (v) { return $759664958dfcc4e1$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $759664958dfcc4e1$export$9522e17588c12572; }, function (v) { return $759664958dfcc4e1$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $759664958dfcc4e1$export$2110ac352bb060b9; }, function (v) { return $759664958dfcc4e1$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $759664958dfcc4e1$export$56885ab8b9c456ab; }, function (v) { return $759664958dfcc4e1$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $759664958dfcc4e1$export$d927fcb6adf8f9de; }, function (v) { return $759664958dfcc4e1$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $759664958dfcc4e1$export$b82d16f27459e05a; }, function (v) { return $759664958dfcc4e1$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $759664958dfcc4e1$export$522c17b4f5e123e8; }, function (v) { return $759664958dfcc4e1$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $759664958dfcc4e1$export$1aabd8a0274ecfd6; }, function (v) { return $759664958dfcc4e1$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $759664958dfcc4e1$export$9b621391a187a31a; }, function (v) { return $759664958dfcc4e1$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $759664958dfcc4e1$export$f5bbd400c2f4426f; }, function (v) { return $759664958dfcc4e1$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $759664958dfcc4e1$export$2b8d127b894957b9;
var $759664958dfcc4e1$export$cea3a54a6425200c;
var $759664958dfcc4e1$export$a7c73072b1a182ae;
var $759664958dfcc4e1$export$9f27bc3417b4524d;
var $759664958dfcc4e1$export$db77ccec0bb4ccac;
var $759664958dfcc4e1$export$8392c0c9d3dcbd35;
var $759664958dfcc4e1$export$ffb0004e005737fa;
var $759664958dfcc4e1$export$b624eff549462981;
var $759664958dfcc4e1$export$7897aa7841a5380c;
var $759664958dfcc4e1$export$602eac185826482c;
var $759664958dfcc4e1$export$e2c29f18771995cb;
var $759664958dfcc4e1$export$5f8d39834fd61797;
var $759664958dfcc4e1$export$74bf444e3cd11ea5;
var $759664958dfcc4e1$export$92387174baf9b227;
var $759664958dfcc4e1$export$ec112efeb987d9c6;
var $759664958dfcc4e1$export$b706b080d889d2c9;
var $759664958dfcc4e1$export$5be5a87408f70ddc;
var $759664958dfcc4e1$export$45a5e7f76e0caa8d;
var $759664958dfcc4e1$export$455c2e768291efa6;
var $759664958dfcc4e1$export$9522e17588c12572;
var $759664958dfcc4e1$export$2110ac352bb060b9;
var $759664958dfcc4e1$export$56885ab8b9c456ab;
var $759664958dfcc4e1$export$d927fcb6adf8f9de;
var $759664958dfcc4e1$export$b82d16f27459e05a;
var $759664958dfcc4e1$export$522c17b4f5e123e8;
var $759664958dfcc4e1$export$1aabd8a0274ecfd6;
var $759664958dfcc4e1$export$9b621391a187a31a;
var $759664958dfcc4e1$export$f5bbd400c2f4426f;
"use strict";
var $759664958dfcc4e1$var$b = "function" === typeof Symbol && Symbol.for, $759664958dfcc4e1$var$c = $759664958dfcc4e1$var$b ? Symbol.for("react.element") : 60103, $759664958dfcc4e1$var$d = $759664958dfcc4e1$var$b ? Symbol.for("react.portal") : 60106, $759664958dfcc4e1$var$e = $759664958dfcc4e1$var$b ? Symbol.for("react.fragment") : 60107, $759664958dfcc4e1$var$f = $759664958dfcc4e1$var$b ? Symbol.for("react.strict_mode") : 60108, $759664958dfcc4e1$var$g = $759664958dfcc4e1$var$b ? Symbol.for("react.profiler") : 60114, $759664958dfcc4e1$var$h = $759664958dfcc4e1$var$b ? Symbol.for("react.provider") : 60109, $759664958dfcc4e1$var$k = $759664958dfcc4e1$var$b ? Symbol.for("react.context") : 60110, $759664958dfcc4e1$var$l = $759664958dfcc4e1$var$b ? Symbol.for("react.async_mode") : 60111, $759664958dfcc4e1$var$m = $759664958dfcc4e1$var$b ? Symbol.for("react.concurrent_mode") : 60111, $759664958dfcc4e1$var$n = $759664958dfcc4e1$var$b ? Symbol.for("react.forward_ref") : 60112, $759664958dfcc4e1$var$p = $759664958dfcc4e1$var$b ? Symbol.for("react.suspense") : 60113, $759664958dfcc4e1$var$q = $759664958dfcc4e1$var$b ? Symbol.for("react.suspense_list") : 60120, $759664958dfcc4e1$var$r = $759664958dfcc4e1$var$b ? Symbol.for("react.memo") : 60115, $759664958dfcc4e1$var$t = $759664958dfcc4e1$var$b ? Symbol.for("react.lazy") : 60116, $759664958dfcc4e1$var$v = $759664958dfcc4e1$var$b ? Symbol.for("react.block") : 60121, $759664958dfcc4e1$var$w = $759664958dfcc4e1$var$b ? Symbol.for("react.fundamental") : 60117, $759664958dfcc4e1$var$x = $759664958dfcc4e1$var$b ? Symbol.for("react.responder") : 60118, $759664958dfcc4e1$var$y = $759664958dfcc4e1$var$b ? Symbol.for("react.scope") : 60119;
function $759664958dfcc4e1$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $759664958dfcc4e1$var$c:
                switch(a = a.type, a){
                    case $759664958dfcc4e1$var$l:
                    case $759664958dfcc4e1$var$m:
                    case $759664958dfcc4e1$var$e:
                    case $759664958dfcc4e1$var$g:
                    case $759664958dfcc4e1$var$f:
                    case $759664958dfcc4e1$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $759664958dfcc4e1$var$k:
                            case $759664958dfcc4e1$var$n:
                            case $759664958dfcc4e1$var$t:
                            case $759664958dfcc4e1$var$r:
                            case $759664958dfcc4e1$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $759664958dfcc4e1$var$d:
                return u;
        }
    }
}
function $759664958dfcc4e1$var$A(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$m;
}
$759664958dfcc4e1$export$2b8d127b894957b9 = $759664958dfcc4e1$var$l;
$759664958dfcc4e1$export$cea3a54a6425200c = $759664958dfcc4e1$var$m;
$759664958dfcc4e1$export$a7c73072b1a182ae = $759664958dfcc4e1$var$k;
$759664958dfcc4e1$export$9f27bc3417b4524d = $759664958dfcc4e1$var$h;
$759664958dfcc4e1$export$db77ccec0bb4ccac = $759664958dfcc4e1$var$c;
$759664958dfcc4e1$export$8392c0c9d3dcbd35 = $759664958dfcc4e1$var$n;
$759664958dfcc4e1$export$ffb0004e005737fa = $759664958dfcc4e1$var$e;
$759664958dfcc4e1$export$b624eff549462981 = $759664958dfcc4e1$var$t;
$759664958dfcc4e1$export$7897aa7841a5380c = $759664958dfcc4e1$var$r;
$759664958dfcc4e1$export$602eac185826482c = $759664958dfcc4e1$var$d;
$759664958dfcc4e1$export$e2c29f18771995cb = $759664958dfcc4e1$var$g;
$759664958dfcc4e1$export$5f8d39834fd61797 = $759664958dfcc4e1$var$f;
$759664958dfcc4e1$export$74bf444e3cd11ea5 = $759664958dfcc4e1$var$p;
$759664958dfcc4e1$export$92387174baf9b227 = function(a) {
    return $759664958dfcc4e1$var$A(a) || $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$l;
};
$759664958dfcc4e1$export$ec112efeb987d9c6 = $759664958dfcc4e1$var$A;
$759664958dfcc4e1$export$b706b080d889d2c9 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$k;
};
$759664958dfcc4e1$export$5be5a87408f70ddc = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$h;
};
$759664958dfcc4e1$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $759664958dfcc4e1$var$c;
};
$759664958dfcc4e1$export$455c2e768291efa6 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$n;
};
$759664958dfcc4e1$export$9522e17588c12572 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$e;
};
$759664958dfcc4e1$export$2110ac352bb060b9 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$t;
};
$759664958dfcc4e1$export$56885ab8b9c456ab = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$r;
};
$759664958dfcc4e1$export$d927fcb6adf8f9de = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$d;
};
$759664958dfcc4e1$export$b82d16f27459e05a = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$g;
};
$759664958dfcc4e1$export$522c17b4f5e123e8 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$f;
};
$759664958dfcc4e1$export$1aabd8a0274ecfd6 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$p;
};
$759664958dfcc4e1$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $759664958dfcc4e1$var$e || a === $759664958dfcc4e1$var$m || a === $759664958dfcc4e1$var$g || a === $759664958dfcc4e1$var$f || a === $759664958dfcc4e1$var$p || a === $759664958dfcc4e1$var$q || "object" === typeof a && null !== a && (a.$$typeof === $759664958dfcc4e1$var$t || a.$$typeof === $759664958dfcc4e1$var$r || a.$$typeof === $759664958dfcc4e1$var$h || a.$$typeof === $759664958dfcc4e1$var$k || a.$$typeof === $759664958dfcc4e1$var$n || a.$$typeof === $759664958dfcc4e1$var$w || a.$$typeof === $759664958dfcc4e1$var$x || a.$$typeof === $759664958dfcc4e1$var$y || a.$$typeof === $759664958dfcc4e1$var$v);
};
$759664958dfcc4e1$export$f5bbd400c2f4426f = $759664958dfcc4e1$var$z;

});

parcelRegister("iCWoj", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $d8f911d802dd94a5$export$a7c73072b1a182ae; }, function (v) { return $d8f911d802dd94a5$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $d8f911d802dd94a5$export$9f27bc3417b4524d; }, function (v) { return $d8f911d802dd94a5$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $d8f911d802dd94a5$export$db77ccec0bb4ccac; }, function (v) { return $d8f911d802dd94a5$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $d8f911d802dd94a5$export$8392c0c9d3dcbd35; }, function (v) { return $d8f911d802dd94a5$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d8f911d802dd94a5$export$ffb0004e005737fa; }, function (v) { return $d8f911d802dd94a5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $d8f911d802dd94a5$export$b624eff549462981; }, function (v) { return $d8f911d802dd94a5$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $d8f911d802dd94a5$export$7897aa7841a5380c; }, function (v) { return $d8f911d802dd94a5$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $d8f911d802dd94a5$export$602eac185826482c; }, function (v) { return $d8f911d802dd94a5$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $d8f911d802dd94a5$export$e2c29f18771995cb; }, function (v) { return $d8f911d802dd94a5$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d8f911d802dd94a5$export$5f8d39834fd61797; }, function (v) { return $d8f911d802dd94a5$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d8f911d802dd94a5$export$74bf444e3cd11ea5; }, function (v) { return $d8f911d802dd94a5$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $d8f911d802dd94a5$export$998bcd577473dd93; }, function (v) { return $d8f911d802dd94a5$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $d8f911d802dd94a5$export$92387174baf9b227; }, function (v) { return $d8f911d802dd94a5$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $d8f911d802dd94a5$export$ec112efeb987d9c6; }, function (v) { return $d8f911d802dd94a5$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $d8f911d802dd94a5$export$b706b080d889d2c9; }, function (v) { return $d8f911d802dd94a5$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $d8f911d802dd94a5$export$5be5a87408f70ddc; }, function (v) { return $d8f911d802dd94a5$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $d8f911d802dd94a5$export$45a5e7f76e0caa8d; }, function (v) { return $d8f911d802dd94a5$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $d8f911d802dd94a5$export$455c2e768291efa6; }, function (v) { return $d8f911d802dd94a5$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $d8f911d802dd94a5$export$9522e17588c12572; }, function (v) { return $d8f911d802dd94a5$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $d8f911d802dd94a5$export$2110ac352bb060b9; }, function (v) { return $d8f911d802dd94a5$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $d8f911d802dd94a5$export$56885ab8b9c456ab; }, function (v) { return $d8f911d802dd94a5$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $d8f911d802dd94a5$export$d927fcb6adf8f9de; }, function (v) { return $d8f911d802dd94a5$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $d8f911d802dd94a5$export$b82d16f27459e05a; }, function (v) { return $d8f911d802dd94a5$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $d8f911d802dd94a5$export$522c17b4f5e123e8; }, function (v) { return $d8f911d802dd94a5$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $d8f911d802dd94a5$export$1aabd8a0274ecfd6; }, function (v) { return $d8f911d802dd94a5$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $d8f911d802dd94a5$export$3d6c20d97e46b957; }, function (v) { return $d8f911d802dd94a5$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $d8f911d802dd94a5$export$9b621391a187a31a; }, function (v) { return $d8f911d802dd94a5$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $d8f911d802dd94a5$export$f5bbd400c2f4426f; }, function (v) { return $d8f911d802dd94a5$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d8f911d802dd94a5$export$a7c73072b1a182ae;
var $d8f911d802dd94a5$export$9f27bc3417b4524d;
var $d8f911d802dd94a5$export$db77ccec0bb4ccac;
var $d8f911d802dd94a5$export$8392c0c9d3dcbd35;
var $d8f911d802dd94a5$export$ffb0004e005737fa;
var $d8f911d802dd94a5$export$b624eff549462981;
var $d8f911d802dd94a5$export$7897aa7841a5380c;
var $d8f911d802dd94a5$export$602eac185826482c;
var $d8f911d802dd94a5$export$e2c29f18771995cb;
var $d8f911d802dd94a5$export$5f8d39834fd61797;
var $d8f911d802dd94a5$export$74bf444e3cd11ea5;
var $d8f911d802dd94a5$export$998bcd577473dd93;
var $d8f911d802dd94a5$export$92387174baf9b227;
var $d8f911d802dd94a5$export$ec112efeb987d9c6;
var $d8f911d802dd94a5$export$b706b080d889d2c9;
var $d8f911d802dd94a5$export$5be5a87408f70ddc;
var $d8f911d802dd94a5$export$45a5e7f76e0caa8d;
var $d8f911d802dd94a5$export$455c2e768291efa6;
var $d8f911d802dd94a5$export$9522e17588c12572;
var $d8f911d802dd94a5$export$2110ac352bb060b9;
var $d8f911d802dd94a5$export$56885ab8b9c456ab;
var $d8f911d802dd94a5$export$d927fcb6adf8f9de;
var $d8f911d802dd94a5$export$b82d16f27459e05a;
var $d8f911d802dd94a5$export$522c17b4f5e123e8;
var $d8f911d802dd94a5$export$1aabd8a0274ecfd6;
var $d8f911d802dd94a5$export$3d6c20d97e46b957;
var $d8f911d802dd94a5$export$9b621391a187a31a;
var $d8f911d802dd94a5$export$f5bbd400c2f4426f;
"use strict";
var $d8f911d802dd94a5$var$b = Symbol.for("react.element"), $d8f911d802dd94a5$var$c = Symbol.for("react.portal"), $d8f911d802dd94a5$var$d = Symbol.for("react.fragment"), $d8f911d802dd94a5$var$e = Symbol.for("react.strict_mode"), $d8f911d802dd94a5$var$f = Symbol.for("react.profiler"), $d8f911d802dd94a5$var$g = Symbol.for("react.provider"), $d8f911d802dd94a5$var$h = Symbol.for("react.context"), $d8f911d802dd94a5$var$k = Symbol.for("react.server_context"), $d8f911d802dd94a5$var$l = Symbol.for("react.forward_ref"), $d8f911d802dd94a5$var$m = Symbol.for("react.suspense"), $d8f911d802dd94a5$var$n = Symbol.for("react.suspense_list"), $d8f911d802dd94a5$var$p = Symbol.for("react.memo"), $d8f911d802dd94a5$var$q = Symbol.for("react.lazy"), $d8f911d802dd94a5$var$t = Symbol.for("react.offscreen"), $d8f911d802dd94a5$var$u;
$d8f911d802dd94a5$var$u = Symbol.for("react.module.reference");
function $d8f911d802dd94a5$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $d8f911d802dd94a5$var$b:
                switch(a = a.type, a){
                    case $d8f911d802dd94a5$var$d:
                    case $d8f911d802dd94a5$var$f:
                    case $d8f911d802dd94a5$var$e:
                    case $d8f911d802dd94a5$var$m:
                    case $d8f911d802dd94a5$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $d8f911d802dd94a5$var$k:
                            case $d8f911d802dd94a5$var$h:
                            case $d8f911d802dd94a5$var$l:
                            case $d8f911d802dd94a5$var$q:
                            case $d8f911d802dd94a5$var$p:
                            case $d8f911d802dd94a5$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $d8f911d802dd94a5$var$c:
                return r;
        }
    }
}
$d8f911d802dd94a5$export$a7c73072b1a182ae = $d8f911d802dd94a5$var$h;
$d8f911d802dd94a5$export$9f27bc3417b4524d = $d8f911d802dd94a5$var$g;
$d8f911d802dd94a5$export$db77ccec0bb4ccac = $d8f911d802dd94a5$var$b;
$d8f911d802dd94a5$export$8392c0c9d3dcbd35 = $d8f911d802dd94a5$var$l;
$d8f911d802dd94a5$export$ffb0004e005737fa = $d8f911d802dd94a5$var$d;
$d8f911d802dd94a5$export$b624eff549462981 = $d8f911d802dd94a5$var$q;
$d8f911d802dd94a5$export$7897aa7841a5380c = $d8f911d802dd94a5$var$p;
$d8f911d802dd94a5$export$602eac185826482c = $d8f911d802dd94a5$var$c;
$d8f911d802dd94a5$export$e2c29f18771995cb = $d8f911d802dd94a5$var$f;
$d8f911d802dd94a5$export$5f8d39834fd61797 = $d8f911d802dd94a5$var$e;
$d8f911d802dd94a5$export$74bf444e3cd11ea5 = $d8f911d802dd94a5$var$m;
$d8f911d802dd94a5$export$998bcd577473dd93 = $d8f911d802dd94a5$var$n;
$d8f911d802dd94a5$export$92387174baf9b227 = function() {
    return !1;
};
$d8f911d802dd94a5$export$ec112efeb987d9c6 = function() {
    return !1;
};
$d8f911d802dd94a5$export$b706b080d889d2c9 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$h;
};
$d8f911d802dd94a5$export$5be5a87408f70ddc = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$g;
};
$d8f911d802dd94a5$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d8f911d802dd94a5$var$b;
};
$d8f911d802dd94a5$export$455c2e768291efa6 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$l;
};
$d8f911d802dd94a5$export$9522e17588c12572 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$d;
};
$d8f911d802dd94a5$export$2110ac352bb060b9 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$q;
};
$d8f911d802dd94a5$export$56885ab8b9c456ab = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$p;
};
$d8f911d802dd94a5$export$d927fcb6adf8f9de = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$c;
};
$d8f911d802dd94a5$export$b82d16f27459e05a = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$f;
};
$d8f911d802dd94a5$export$522c17b4f5e123e8 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$e;
};
$d8f911d802dd94a5$export$1aabd8a0274ecfd6 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$m;
};
$d8f911d802dd94a5$export$3d6c20d97e46b957 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$n;
};
$d8f911d802dd94a5$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $d8f911d802dd94a5$var$d || a === $d8f911d802dd94a5$var$f || a === $d8f911d802dd94a5$var$e || a === $d8f911d802dd94a5$var$m || a === $d8f911d802dd94a5$var$n || a === $d8f911d802dd94a5$var$t || "object" === typeof a && null !== a && (a.$$typeof === $d8f911d802dd94a5$var$q || a.$$typeof === $d8f911d802dd94a5$var$p || a.$$typeof === $d8f911d802dd94a5$var$g || a.$$typeof === $d8f911d802dd94a5$var$h || a.$$typeof === $d8f911d802dd94a5$var$l || a.$$typeof === $d8f911d802dd94a5$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$d8f911d802dd94a5$export$f5bbd400c2f4426f = $d8f911d802dd94a5$var$v;

});

parcelRegister("bZSVP", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8bc0008288327973$var$ReactIs, $8bc0008288327973$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("16YfO"))();

});
parcelRegister("16YfO", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $aeBUn = parcelRequire("aeBUn");
function $0cf5172cc1cce171$var$emptyFunction() {}
function $0cf5172cc1cce171$var$emptyFunctionWithReset() {}
$0cf5172cc1cce171$var$emptyFunctionWithReset.resetWarningCache = $0cf5172cc1cce171$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aeBUn) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $0cf5172cc1cce171$var$emptyFunctionWithReset,
        resetWarningCache: $0cf5172cc1cce171$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aeBUn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $77389e03939e8cd3$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $77389e03939e8cd3$var$ReactPropTypesSecret;

});



parcelRegister("57utv", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $3ba53eda535cc01a$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $3ba53eda535cc01a$export$2e2bcd8739ae039 = fn;

});

parcelRegister("bei3G", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("140KF", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");

var $2nHU7 = parcelRequire("2nHU7");

var $9V2cF = parcelRequire("9V2cF");

var $j7ZM2 = parcelRequire("j7ZM2");

var $9aOZU = parcelRequire("9aOZU");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $0c66bf6daf4b8f2b$var$createInstance(defaultConfig) {
    var context = new $9V2cF(defaultConfig);
    var instance = $2nHU7($9V2cF.prototype.request, context);
    // Copy axios.prototype to instance
    $dux9i.extend(instance, $9V2cF.prototype, context);
    // Copy context to instance
    $dux9i.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $0c66bf6daf4b8f2b$var$createInstance($j7ZM2(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $0c66bf6daf4b8f2b$var$axios = $0c66bf6daf4b8f2b$var$createInstance($9aOZU);
// Expose Axios class to allow class inheritance
$0c66bf6daf4b8f2b$var$axios.Axios = $9V2cF;

// Expose Cancel & CancelToken
$0c66bf6daf4b8f2b$var$axios.CanceledError = (parcelRequire("ah65u"));

$0c66bf6daf4b8f2b$var$axios.CancelToken = (parcelRequire("dr9i3"));

$0c66bf6daf4b8f2b$var$axios.isCancel = (parcelRequire("3qPST"));

$0c66bf6daf4b8f2b$var$axios.VERSION = (parcelRequire("bxj5i")).version;

$0c66bf6daf4b8f2b$var$axios.toFormData = (parcelRequire("iIhlx"));

// Expose AxiosError class
$0c66bf6daf4b8f2b$var$axios.AxiosError = (parcelRequire("i0tOE"));
// alias for CanceledError for backward compatibility
$0c66bf6daf4b8f2b$var$axios.Cancel = $0c66bf6daf4b8f2b$var$axios.CanceledError;
// Expose all/spread
$0c66bf6daf4b8f2b$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$0c66bf6daf4b8f2b$var$axios.spread = (parcelRequire("jhHUj"));

// Expose isAxiosError
$0c66bf6daf4b8f2b$var$axios.isAxiosError = (parcelRequire("3YNly"));
module.exports = $0c66bf6daf4b8f2b$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $0c66bf6daf4b8f2b$var$axios;

});
parcelRegister("dux9i", function(module, exports) {
"use strict";

var $2nHU7 = parcelRequire("2nHU7");
// utils is a library of generic helper functions non-specific to axios
var $9d27ca652cf4b216$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $9d27ca652cf4b216$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $9d27ca652cf4b216$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $9d27ca652cf4b216$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $9d27ca652cf4b216$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $9d27ca652cf4b216$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $9d27ca652cf4b216$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $9d27ca652cf4b216$var$isBuffer(val) {
    return val !== null && !$9d27ca652cf4b216$var$isUndefined(val) && val.constructor !== null && !$9d27ca652cf4b216$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $9d27ca652cf4b216$var$isArrayBuffer = $9d27ca652cf4b216$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $9d27ca652cf4b216$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $9d27ca652cf4b216$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $9d27ca652cf4b216$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $9d27ca652cf4b216$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $9d27ca652cf4b216$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $9d27ca652cf4b216$var$isPlainObject(val) {
    if ($9d27ca652cf4b216$var$kindOf(val) !== "object") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $9d27ca652cf4b216$var$isDate = $9d27ca652cf4b216$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $9d27ca652cf4b216$var$isFile = $9d27ca652cf4b216$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $9d27ca652cf4b216$var$isBlob = $9d27ca652cf4b216$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $9d27ca652cf4b216$var$isFileList = $9d27ca652cf4b216$var$kindOfTest("FileList");
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $9d27ca652cf4b216$var$isFunction(val) {
    return $9d27ca652cf4b216$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $9d27ca652cf4b216$var$isStream(val) {
    return $9d27ca652cf4b216$var$isObject(val) && $9d27ca652cf4b216$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $9d27ca652cf4b216$var$isFormData(thing) {
    var pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $9d27ca652cf4b216$var$toString.call(thing) === pattern || $9d27ca652cf4b216$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $9d27ca652cf4b216$var$isURLSearchParams = $9d27ca652cf4b216$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $9d27ca652cf4b216$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $9d27ca652cf4b216$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $9d27ca652cf4b216$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($9d27ca652cf4b216$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $9d27ca652cf4b216$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($9d27ca652cf4b216$var$isPlainObject(result[key]) && $9d27ca652cf4b216$var$isPlainObject(val)) result[key] = $9d27ca652cf4b216$var$merge(result[key], val);
        else if ($9d27ca652cf4b216$var$isPlainObject(val)) result[key] = $9d27ca652cf4b216$var$merge({}, val);
        else if ($9d27ca652cf4b216$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$9d27ca652cf4b216$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $9d27ca652cf4b216$var$extend(a, b, thisArg) {
    $9d27ca652cf4b216$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $2nHU7(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $9d27ca652cf4b216$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $9d27ca652cf4b216$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $9d27ca652cf4b216$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $9d27ca652cf4b216$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $9d27ca652cf4b216$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($9d27ca652cf4b216$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $9d27ca652cf4b216$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $9d27ca652cf4b216$var$isArray,
    isArrayBuffer: $9d27ca652cf4b216$var$isArrayBuffer,
    isBuffer: $9d27ca652cf4b216$var$isBuffer,
    isFormData: $9d27ca652cf4b216$var$isFormData,
    isArrayBufferView: $9d27ca652cf4b216$var$isArrayBufferView,
    isString: $9d27ca652cf4b216$var$isString,
    isNumber: $9d27ca652cf4b216$var$isNumber,
    isObject: $9d27ca652cf4b216$var$isObject,
    isPlainObject: $9d27ca652cf4b216$var$isPlainObject,
    isUndefined: $9d27ca652cf4b216$var$isUndefined,
    isDate: $9d27ca652cf4b216$var$isDate,
    isFile: $9d27ca652cf4b216$var$isFile,
    isBlob: $9d27ca652cf4b216$var$isBlob,
    isFunction: $9d27ca652cf4b216$var$isFunction,
    isStream: $9d27ca652cf4b216$var$isStream,
    isURLSearchParams: $9d27ca652cf4b216$var$isURLSearchParams,
    isStandardBrowserEnv: $9d27ca652cf4b216$var$isStandardBrowserEnv,
    forEach: $9d27ca652cf4b216$var$forEach,
    merge: $9d27ca652cf4b216$var$merge,
    extend: $9d27ca652cf4b216$var$extend,
    trim: $9d27ca652cf4b216$var$trim,
    stripBOM: $9d27ca652cf4b216$var$stripBOM,
    inherits: $9d27ca652cf4b216$var$inherits,
    toFlatObject: $9d27ca652cf4b216$var$toFlatObject,
    kindOf: $9d27ca652cf4b216$var$kindOf,
    kindOfTest: $9d27ca652cf4b216$var$kindOfTest,
    endsWith: $9d27ca652cf4b216$var$endsWith,
    toArray: $9d27ca652cf4b216$var$toArray,
    isTypedArray: $9d27ca652cf4b216$var$isTypedArray,
    isFileList: $9d27ca652cf4b216$var$isFileList
};

});
parcelRegister("2nHU7", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("9V2cF", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");

var $8PwwH = parcelRequire("8PwwH");

var $205Gq = parcelRequire("205Gq");

var $dGbBL = parcelRequire("dGbBL");

var $j7ZM2 = parcelRequire("j7ZM2");

var $lYv93 = parcelRequire("lYv93");

var $jxrCF = parcelRequire("jxrCF");
var $738b257bca6702d0$var$validators = $jxrCF.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $738b257bca6702d0$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $205Gq(),
        response: new $205Gq()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $738b257bca6702d0$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $j7ZM2(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $jxrCF.assertOptions(transitional, {
        silentJSONParsing: $738b257bca6702d0$var$validators.transitional($738b257bca6702d0$var$validators.boolean),
        forcedJSONParsing: $738b257bca6702d0$var$validators.transitional($738b257bca6702d0$var$validators.boolean),
        clarifyTimeoutError: $738b257bca6702d0$var$validators.transitional($738b257bca6702d0$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $dGbBL,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $dGbBL(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$738b257bca6702d0$var$Axios.prototype.getUri = function getUri(config) {
    config = $j7ZM2(this.defaults, config);
    var fullPath = $lYv93(config.baseURL, config.url);
    return $8PwwH(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$dux9i.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $738b257bca6702d0$var$Axios.prototype[method] = function(url, config) {
        return this.request($j7ZM2(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$dux9i.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($j7ZM2(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $738b257bca6702d0$var$Axios.prototype[method] = generateHTTPMethod();
    $738b257bca6702d0$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
module.exports = $738b257bca6702d0$var$Axios;

});
parcelRegister("8PwwH", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");
function $66dc51365193bc02$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($dux9i.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $dux9i.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($dux9i.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $dux9i.forEach(val, function parseValue(v) {
                if ($dux9i.isDate(v)) v = v.toISOString();
                else if ($dux9i.isObject(v)) v = JSON.stringify(v);
                parts.push($66dc51365193bc02$var$encode(key) + "=" + $66dc51365193bc02$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("205Gq", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");
function $174ffd69d11b37cf$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $174ffd69d11b37cf$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $174ffd69d11b37cf$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $174ffd69d11b37cf$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $dux9i.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $174ffd69d11b37cf$var$InterceptorManager;

});

parcelRegister("dGbBL", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");

var $1qbT4 = parcelRequire("1qbT4");

var $3qPST = parcelRequire("3qPST");

var $9aOZU = parcelRequire("9aOZU");

var $ah65u = parcelRequire("ah65u");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $9f5833b5af512637$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $ah65u();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9f5833b5af512637$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $1qbT4.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $dux9i.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $dux9i.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $9aOZU.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9f5833b5af512637$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $1qbT4.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$3qPST(reason)) {
            $9f5833b5af512637$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $1qbT4.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("1qbT4", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");

var $9aOZU = parcelRequire("9aOZU");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $9aOZU;
    /*eslint no-param-reassign:0*/ $dux9i.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("9aOZU", function(module, exports) {

var $54X9E = parcelRequire("54X9E");
"use strict";

var $dux9i = parcelRequire("dux9i");

var $eTAOJ = parcelRequire("eTAOJ");

var $i0tOE = parcelRequire("i0tOE");

var $edUfG = parcelRequire("edUfG");

var $iIhlx = parcelRequire("iIhlx");
var $6adc9b4ab62de8a1$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $6adc9b4ab62de8a1$var$setContentTypeIfUnset(headers, value) {
    if (!$dux9i.isUndefined(headers) && $dux9i.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $6adc9b4ab62de8a1$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("fjbsZ"));
    else if (typeof $54X9E !== "undefined" && Object.prototype.toString.call($54X9E) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("fjbsZ"));
    return adapter;
}
function $6adc9b4ab62de8a1$var$stringifySafely(rawValue, parser, encoder) {
    if ($dux9i.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $dux9i.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $6adc9b4ab62de8a1$var$defaults = {
    transitional: $edUfG,
    adapter: $6adc9b4ab62de8a1$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $eTAOJ(headers, "Accept");
            $eTAOJ(headers, "Content-Type");
            if ($dux9i.isFormData(data) || $dux9i.isArrayBuffer(data) || $dux9i.isBuffer(data) || $dux9i.isStream(data) || $dux9i.isFile(data) || $dux9i.isBlob(data)) return data;
            if ($dux9i.isArrayBufferView(data)) return data.buffer;
            if ($dux9i.isURLSearchParams(data)) {
                $6adc9b4ab62de8a1$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            var isObjectPayload = $dux9i.isObject(data);
            var contentType = headers && headers["Content-Type"];
            var isFileList;
            if ((isFileList = $dux9i.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
                var _FormData = this.env && this.env.FormData;
                return $iIhlx(isFileList ? {
                    "files[]": data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === "application/json") {
                $6adc9b4ab62de8a1$var$setContentTypeIfUnset(headers, "application/json");
                return $6adc9b4ab62de8a1$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $6adc9b4ab62de8a1$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $dux9i.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $i0tOE.from(e, $i0tOE.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("gEoVV"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$dux9i.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $6adc9b4ab62de8a1$var$defaults.headers[method] = {};
});
$dux9i.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $6adc9b4ab62de8a1$var$defaults.headers[method] = $dux9i.merge($6adc9b4ab62de8a1$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $6adc9b4ab62de8a1$var$defaults;

});
parcelRegister("54X9E", function(module, exports) {
// shim for using process in browser
var $3b2b36599051fe09$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3b2b36599051fe09$var$cachedSetTimeout;
var $3b2b36599051fe09$var$cachedClearTimeout;
function $3b2b36599051fe09$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $3b2b36599051fe09$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $3b2b36599051fe09$var$cachedSetTimeout = setTimeout;
        else $3b2b36599051fe09$var$cachedSetTimeout = $3b2b36599051fe09$var$defaultSetTimout;
    } catch (e) {
        $3b2b36599051fe09$var$cachedSetTimeout = $3b2b36599051fe09$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $3b2b36599051fe09$var$cachedClearTimeout = clearTimeout;
        else $3b2b36599051fe09$var$cachedClearTimeout = $3b2b36599051fe09$var$defaultClearTimeout;
    } catch (e) {
        $3b2b36599051fe09$var$cachedClearTimeout = $3b2b36599051fe09$var$defaultClearTimeout;
    }
})();
function $3b2b36599051fe09$var$runTimeout(fun) {
    if ($3b2b36599051fe09$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3b2b36599051fe09$var$cachedSetTimeout === $3b2b36599051fe09$var$defaultSetTimout || !$3b2b36599051fe09$var$cachedSetTimeout) && setTimeout) {
        $3b2b36599051fe09$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3b2b36599051fe09$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3b2b36599051fe09$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3b2b36599051fe09$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3b2b36599051fe09$var$runClearTimeout(marker) {
    if ($3b2b36599051fe09$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3b2b36599051fe09$var$cachedClearTimeout === $3b2b36599051fe09$var$defaultClearTimeout || !$3b2b36599051fe09$var$cachedClearTimeout) && clearTimeout) {
        $3b2b36599051fe09$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3b2b36599051fe09$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3b2b36599051fe09$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3b2b36599051fe09$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3b2b36599051fe09$var$queue = [];
var $3b2b36599051fe09$var$draining = false;
var $3b2b36599051fe09$var$currentQueue;
var $3b2b36599051fe09$var$queueIndex = -1;
function $3b2b36599051fe09$var$cleanUpNextTick() {
    if (!$3b2b36599051fe09$var$draining || !$3b2b36599051fe09$var$currentQueue) return;
    $3b2b36599051fe09$var$draining = false;
    if ($3b2b36599051fe09$var$currentQueue.length) $3b2b36599051fe09$var$queue = $3b2b36599051fe09$var$currentQueue.concat($3b2b36599051fe09$var$queue);
    else $3b2b36599051fe09$var$queueIndex = -1;
    if ($3b2b36599051fe09$var$queue.length) $3b2b36599051fe09$var$drainQueue();
}
function $3b2b36599051fe09$var$drainQueue() {
    if ($3b2b36599051fe09$var$draining) return;
    var timeout = $3b2b36599051fe09$var$runTimeout($3b2b36599051fe09$var$cleanUpNextTick);
    $3b2b36599051fe09$var$draining = true;
    var len = $3b2b36599051fe09$var$queue.length;
    while(len){
        $3b2b36599051fe09$var$currentQueue = $3b2b36599051fe09$var$queue;
        $3b2b36599051fe09$var$queue = [];
        while(++$3b2b36599051fe09$var$queueIndex < len)if ($3b2b36599051fe09$var$currentQueue) $3b2b36599051fe09$var$currentQueue[$3b2b36599051fe09$var$queueIndex].run();
        $3b2b36599051fe09$var$queueIndex = -1;
        len = $3b2b36599051fe09$var$queue.length;
    }
    $3b2b36599051fe09$var$currentQueue = null;
    $3b2b36599051fe09$var$draining = false;
    $3b2b36599051fe09$var$runClearTimeout(timeout);
}
$3b2b36599051fe09$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3b2b36599051fe09$var$queue.push(new $3b2b36599051fe09$var$Item(fun, args));
    if ($3b2b36599051fe09$var$queue.length === 1 && !$3b2b36599051fe09$var$draining) $3b2b36599051fe09$var$runTimeout($3b2b36599051fe09$var$drainQueue);
};
// v8 likes predictible objects
function $3b2b36599051fe09$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3b2b36599051fe09$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3b2b36599051fe09$var$process.title = "browser";
$3b2b36599051fe09$var$process.browser = true;
$3b2b36599051fe09$var$process.env = {};
$3b2b36599051fe09$var$process.argv = [];
$3b2b36599051fe09$var$process.version = ""; // empty string to avoid regexp issues
$3b2b36599051fe09$var$process.versions = {};
function $3b2b36599051fe09$var$noop() {}
$3b2b36599051fe09$var$process.on = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.addListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.once = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.off = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.removeListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.removeAllListeners = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.emit = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.prependListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.prependOnceListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.listeners = function(name) {
    return [];
};
$3b2b36599051fe09$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$3b2b36599051fe09$var$process.cwd = function() {
    return "/";
};
$3b2b36599051fe09$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$3b2b36599051fe09$var$process.umask = function() {
    return 0;
};

});

parcelRegister("eTAOJ", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $dux9i.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("i0tOE", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $d1bf5aebcbcc335b$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$dux9i.inherits($d1bf5aebcbcc335b$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $d1bf5aebcbcc335b$var$prototype = $d1bf5aebcbcc335b$var$AxiosError.prototype;
var $d1bf5aebcbcc335b$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
].forEach(function(code) {
    $d1bf5aebcbcc335b$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($d1bf5aebcbcc335b$var$AxiosError, $d1bf5aebcbcc335b$var$descriptors);
Object.defineProperty($d1bf5aebcbcc335b$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$d1bf5aebcbcc335b$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($d1bf5aebcbcc335b$var$prototype);
    $dux9i.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $d1bf5aebcbcc335b$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $d1bf5aebcbcc335b$var$AxiosError;

});

parcelRegister("edUfG", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("iIhlx", function(module, exports) {

var $bzcxo = parcelRequire("bzcxo");
var $d9f9cab5fbbf9925$require$Buffer = $bzcxo.Buffer;
"use strict";

var $dux9i = parcelRequire("dux9i");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $d9f9cab5fbbf9925$var$toFormData(obj, formData) {
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
        if (value === null) return "";
        if ($dux9i.isDate(value)) return value.toISOString();
        if ($dux9i.isArrayBuffer(value) || $dux9i.isTypedArray(value)) return typeof Blob === "function" ? new Blob([
            value
        ]) : $d9f9cab5fbbf9925$require$Buffer.from(value);
        return value;
    }
    function build(data, parentKey) {
        if ($dux9i.isPlainObject(data) || $dux9i.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error("Circular reference detected in " + parentKey);
            stack.push(data);
            $dux9i.forEach(data, function each(value, key) {
                if ($dux9i.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + "." + key : key;
                var arr;
                if (value && !parentKey && typeof value === "object") {
                    if ($dux9i.endsWith(key, "{}")) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($dux9i.endsWith(key, "[]") && (arr = $dux9i.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$dux9i.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $d9f9cab5fbbf9925$var$toFormData;

});
parcelRegister("bzcxo", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $86bcb047f6cbaf61$export$a143d493d941bafc; }, function (v) { return $86bcb047f6cbaf61$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $86bcb047f6cbaf61$export$f99ded8fe4b79145; }, function (v) { return $86bcb047f6cbaf61$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $86bcb047f6cbaf61$export$a143d493d941bafc;
var $86bcb047f6cbaf61$export$e4cf37d7f6fb9e0a;
var $86bcb047f6cbaf61$export$f99ded8fe4b79145;
var $86bcb047f6cbaf61$export$599f31c3813fae4d;
"use strict";

var $gzGF9 = parcelRequire("gzGF9");

var $ZhBnF = parcelRequire("ZhBnF");
var $86bcb047f6cbaf61$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$86bcb047f6cbaf61$export$a143d493d941bafc = $86bcb047f6cbaf61$var$Buffer;
$86bcb047f6cbaf61$export$e4cf37d7f6fb9e0a = $86bcb047f6cbaf61$var$SlowBuffer;
$86bcb047f6cbaf61$export$f99ded8fe4b79145 = 50;
var $86bcb047f6cbaf61$var$K_MAX_LENGTH = 0x7fffffff;
$86bcb047f6cbaf61$export$599f31c3813fae4d = $86bcb047f6cbaf61$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $86bcb047f6cbaf61$var$Buffer.TYPED_ARRAY_SUPPORT = $86bcb047f6cbaf61$var$typedArraySupport();
if (!$86bcb047f6cbaf61$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $86bcb047f6cbaf61$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($86bcb047f6cbaf61$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$86bcb047f6cbaf61$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($86bcb047f6cbaf61$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$86bcb047f6cbaf61$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $86bcb047f6cbaf61$var$createBuffer(length) {
    if (length > $86bcb047f6cbaf61$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $86bcb047f6cbaf61$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $86bcb047f6cbaf61$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $86bcb047f6cbaf61$var$allocUnsafe(arg);
    }
    return $86bcb047f6cbaf61$var$from(arg, encodingOrOffset, length);
}
$86bcb047f6cbaf61$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $86bcb047f6cbaf61$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $86bcb047f6cbaf61$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $86bcb047f6cbaf61$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($86bcb047f6cbaf61$var$isInstance(value, ArrayBuffer) || value && $86bcb047f6cbaf61$var$isInstance(value.buffer, ArrayBuffer)) return $86bcb047f6cbaf61$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($86bcb047f6cbaf61$var$isInstance(value, SharedArrayBuffer) || value && $86bcb047f6cbaf61$var$isInstance(value.buffer, SharedArrayBuffer))) return $86bcb047f6cbaf61$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $86bcb047f6cbaf61$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $86bcb047f6cbaf61$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $86bcb047f6cbaf61$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $86bcb047f6cbaf61$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $86bcb047f6cbaf61$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($86bcb047f6cbaf61$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($86bcb047f6cbaf61$var$Buffer, Uint8Array);
function $86bcb047f6cbaf61$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $86bcb047f6cbaf61$var$alloc(size, fill, encoding) {
    $86bcb047f6cbaf61$var$assertSize(size);
    if (size <= 0) return $86bcb047f6cbaf61$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $86bcb047f6cbaf61$var$createBuffer(size).fill(fill, encoding) : $86bcb047f6cbaf61$var$createBuffer(size).fill(fill);
    return $86bcb047f6cbaf61$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $86bcb047f6cbaf61$var$Buffer.alloc = function(size, fill, encoding) {
    return $86bcb047f6cbaf61$var$alloc(size, fill, encoding);
};
function $86bcb047f6cbaf61$var$allocUnsafe(size) {
    $86bcb047f6cbaf61$var$assertSize(size);
    return $86bcb047f6cbaf61$var$createBuffer(size < 0 ? 0 : $86bcb047f6cbaf61$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $86bcb047f6cbaf61$var$Buffer.allocUnsafe = function(size) {
    return $86bcb047f6cbaf61$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $86bcb047f6cbaf61$var$Buffer.allocUnsafeSlow = function(size) {
    return $86bcb047f6cbaf61$var$allocUnsafe(size);
};
function $86bcb047f6cbaf61$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$86bcb047f6cbaf61$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $86bcb047f6cbaf61$var$byteLength(string, encoding) | 0;
    var buf = $86bcb047f6cbaf61$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $86bcb047f6cbaf61$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $86bcb047f6cbaf61$var$checked(array.length) | 0;
    var buf = $86bcb047f6cbaf61$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $86bcb047f6cbaf61$var$fromArrayView(arrayView) {
    if ($86bcb047f6cbaf61$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $86bcb047f6cbaf61$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $86bcb047f6cbaf61$var$fromArrayLike(arrayView);
}
function $86bcb047f6cbaf61$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $86bcb047f6cbaf61$var$Buffer.prototype);
    return buf;
}
function $86bcb047f6cbaf61$var$fromObject(obj) {
    if ($86bcb047f6cbaf61$var$Buffer.isBuffer(obj)) {
        var len = $86bcb047f6cbaf61$var$checked(obj.length) | 0;
        var buf = $86bcb047f6cbaf61$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $86bcb047f6cbaf61$var$numberIsNaN(obj.length)) return $86bcb047f6cbaf61$var$createBuffer(0);
        return $86bcb047f6cbaf61$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $86bcb047f6cbaf61$var$fromArrayLike(obj.data);
}
function $86bcb047f6cbaf61$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $86bcb047f6cbaf61$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $86bcb047f6cbaf61$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $86bcb047f6cbaf61$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $86bcb047f6cbaf61$var$Buffer.alloc(+length);
}
$86bcb047f6cbaf61$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $86bcb047f6cbaf61$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$86bcb047f6cbaf61$var$Buffer.compare = function compare(a, b) {
    if ($86bcb047f6cbaf61$var$isInstance(a, Uint8Array)) a = $86bcb047f6cbaf61$var$Buffer.from(a, a.offset, a.byteLength);
    if ($86bcb047f6cbaf61$var$isInstance(b, Uint8Array)) b = $86bcb047f6cbaf61$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$86bcb047f6cbaf61$var$Buffer.isBuffer(a) || !$86bcb047f6cbaf61$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$86bcb047f6cbaf61$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$86bcb047f6cbaf61$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $86bcb047f6cbaf61$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $86bcb047f6cbaf61$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($86bcb047f6cbaf61$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $86bcb047f6cbaf61$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$86bcb047f6cbaf61$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $86bcb047f6cbaf61$var$byteLength(string, encoding) {
    if ($86bcb047f6cbaf61$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $86bcb047f6cbaf61$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $86bcb047f6cbaf61$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $86bcb047f6cbaf61$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $86bcb047f6cbaf61$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$86bcb047f6cbaf61$var$Buffer.byteLength = $86bcb047f6cbaf61$var$byteLength;
function $86bcb047f6cbaf61$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $86bcb047f6cbaf61$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $86bcb047f6cbaf61$var$utf8Slice(this, start, end);
        case "ascii":
            return $86bcb047f6cbaf61$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $86bcb047f6cbaf61$var$latin1Slice(this, start, end);
        case "base64":
            return $86bcb047f6cbaf61$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $86bcb047f6cbaf61$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$86bcb047f6cbaf61$var$Buffer.prototype._isBuffer = true;
function $86bcb047f6cbaf61$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$86bcb047f6cbaf61$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$86bcb047f6cbaf61$var$swap(this, i, i + 1);
    return this;
};
$86bcb047f6cbaf61$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $86bcb047f6cbaf61$var$swap(this, i, i + 3);
        $86bcb047f6cbaf61$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$86bcb047f6cbaf61$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $86bcb047f6cbaf61$var$swap(this, i, i + 7);
        $86bcb047f6cbaf61$var$swap(this, i + 1, i + 6);
        $86bcb047f6cbaf61$var$swap(this, i + 2, i + 5);
        $86bcb047f6cbaf61$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$86bcb047f6cbaf61$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $86bcb047f6cbaf61$var$utf8Slice(this, 0, length);
    return $86bcb047f6cbaf61$var$slowToString.apply(this, arguments);
};
$86bcb047f6cbaf61$var$Buffer.prototype.toLocaleString = $86bcb047f6cbaf61$var$Buffer.prototype.toString;
$86bcb047f6cbaf61$var$Buffer.prototype.equals = function equals(b) {
    if (!$86bcb047f6cbaf61$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $86bcb047f6cbaf61$var$Buffer.compare(this, b) === 0;
};
$86bcb047f6cbaf61$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $86bcb047f6cbaf61$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($86bcb047f6cbaf61$var$customInspectSymbol) $86bcb047f6cbaf61$var$Buffer.prototype[$86bcb047f6cbaf61$var$customInspectSymbol] = $86bcb047f6cbaf61$var$Buffer.prototype.inspect;
$86bcb047f6cbaf61$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($86bcb047f6cbaf61$var$isInstance(target, Uint8Array)) target = $86bcb047f6cbaf61$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$86bcb047f6cbaf61$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $86bcb047f6cbaf61$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($86bcb047f6cbaf61$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $86bcb047f6cbaf61$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($86bcb047f6cbaf61$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $86bcb047f6cbaf61$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $86bcb047f6cbaf61$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $86bcb047f6cbaf61$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$86bcb047f6cbaf61$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$86bcb047f6cbaf61$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $86bcb047f6cbaf61$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$86bcb047f6cbaf61$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $86bcb047f6cbaf61$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $86bcb047f6cbaf61$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($86bcb047f6cbaf61$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $86bcb047f6cbaf61$var$utf8Write(buf, string, offset, length) {
    return $86bcb047f6cbaf61$var$blitBuffer($86bcb047f6cbaf61$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $86bcb047f6cbaf61$var$asciiWrite(buf, string, offset, length) {
    return $86bcb047f6cbaf61$var$blitBuffer($86bcb047f6cbaf61$var$asciiToBytes(string), buf, offset, length);
}
function $86bcb047f6cbaf61$var$base64Write(buf, string, offset, length) {
    return $86bcb047f6cbaf61$var$blitBuffer($86bcb047f6cbaf61$var$base64ToBytes(string), buf, offset, length);
}
function $86bcb047f6cbaf61$var$ucs2Write(buf, string, offset, length) {
    return $86bcb047f6cbaf61$var$blitBuffer($86bcb047f6cbaf61$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$86bcb047f6cbaf61$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $86bcb047f6cbaf61$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $86bcb047f6cbaf61$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $86bcb047f6cbaf61$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $86bcb047f6cbaf61$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $86bcb047f6cbaf61$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$86bcb047f6cbaf61$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $86bcb047f6cbaf61$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gzGF9.fromByteArray(buf);
    else return $gzGF9.fromByteArray(buf.slice(start, end));
}
function $86bcb047f6cbaf61$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $86bcb047f6cbaf61$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $86bcb047f6cbaf61$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $86bcb047f6cbaf61$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $86bcb047f6cbaf61$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $86bcb047f6cbaf61$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $86bcb047f6cbaf61$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $86bcb047f6cbaf61$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $86bcb047f6cbaf61$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $86bcb047f6cbaf61$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $86bcb047f6cbaf61$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$86bcb047f6cbaf61$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $86bcb047f6cbaf61$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $86bcb047f6cbaf61$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$86bcb047f6cbaf61$var$Buffer.prototype.readUintLE = $86bcb047f6cbaf61$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$86bcb047f6cbaf61$var$Buffer.prototype.readUintBE = $86bcb047f6cbaf61$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$86bcb047f6cbaf61$var$Buffer.prototype.readUint8 = $86bcb047f6cbaf61$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$86bcb047f6cbaf61$var$Buffer.prototype.readUint16LE = $86bcb047f6cbaf61$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$86bcb047f6cbaf61$var$Buffer.prototype.readUint16BE = $86bcb047f6cbaf61$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$86bcb047f6cbaf61$var$Buffer.prototype.readUint32LE = $86bcb047f6cbaf61$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$86bcb047f6cbaf61$var$Buffer.prototype.readUint32BE = $86bcb047f6cbaf61$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$86bcb047f6cbaf61$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$86bcb047f6cbaf61$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$86bcb047f6cbaf61$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$86bcb047f6cbaf61$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$86bcb047f6cbaf61$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$86bcb047f6cbaf61$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$86bcb047f6cbaf61$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$86bcb047f6cbaf61$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 4, this.length);
    return $ZhBnF.read(this, offset, true, 23, 4);
};
$86bcb047f6cbaf61$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 4, this.length);
    return $ZhBnF.read(this, offset, false, 23, 4);
};
$86bcb047f6cbaf61$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 8, this.length);
    return $ZhBnF.read(this, offset, true, 52, 8);
};
$86bcb047f6cbaf61$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkOffset(offset, 8, this.length);
    return $ZhBnF.read(this, offset, false, 52, 8);
};
function $86bcb047f6cbaf61$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$86bcb047f6cbaf61$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$86bcb047f6cbaf61$var$Buffer.prototype.writeUintLE = $86bcb047f6cbaf61$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $86bcb047f6cbaf61$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeUintBE = $86bcb047f6cbaf61$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $86bcb047f6cbaf61$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeUint8 = $86bcb047f6cbaf61$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeUint16LE = $86bcb047f6cbaf61$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeUint16BE = $86bcb047f6cbaf61$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeUint32LE = $86bcb047f6cbaf61$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeUint32BE = $86bcb047f6cbaf61$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $86bcb047f6cbaf61$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $86bcb047f6cbaf61$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $86bcb047f6cbaf61$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $86bcb047f6cbaf61$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ZhBnF.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$86bcb047f6cbaf61$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $86bcb047f6cbaf61$var$writeFloat(this, value, offset, true, noAssert);
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $86bcb047f6cbaf61$var$writeFloat(this, value, offset, false, noAssert);
};
function $86bcb047f6cbaf61$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86bcb047f6cbaf61$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ZhBnF.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$86bcb047f6cbaf61$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $86bcb047f6cbaf61$var$writeDouble(this, value, offset, true, noAssert);
};
$86bcb047f6cbaf61$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $86bcb047f6cbaf61$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$86bcb047f6cbaf61$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$86bcb047f6cbaf61$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$86bcb047f6cbaf61$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$86bcb047f6cbaf61$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $86bcb047f6cbaf61$var$Buffer.isBuffer(val) ? val : $86bcb047f6cbaf61$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $86bcb047f6cbaf61$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $86bcb047f6cbaf61$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($86bcb047f6cbaf61$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $86bcb047f6cbaf61$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $86bcb047f6cbaf61$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $86bcb047f6cbaf61$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $86bcb047f6cbaf61$var$base64ToBytes(str) {
    return $gzGF9.toByteArray($86bcb047f6cbaf61$var$base64clean(str));
}
function $86bcb047f6cbaf61$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $86bcb047f6cbaf61$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $86bcb047f6cbaf61$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $86bcb047f6cbaf61$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("gzGF9", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $c1110228c8ce65d7$export$d622b2ad8d90c771; }, function (v) { return $c1110228c8ce65d7$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $c1110228c8ce65d7$export$6100ba28696e12de; }, function (v) { return $c1110228c8ce65d7$export$6100ba28696e12de = v; });
var $c1110228c8ce65d7$export$a48f0734ac7c2329;
var $c1110228c8ce65d7$export$d622b2ad8d90c771;
var $c1110228c8ce65d7$export$6100ba28696e12de;
"use strict";
$c1110228c8ce65d7$export$a48f0734ac7c2329 = $c1110228c8ce65d7$var$byteLength;
$c1110228c8ce65d7$export$d622b2ad8d90c771 = $c1110228c8ce65d7$var$toByteArray;
$c1110228c8ce65d7$export$6100ba28696e12de = $c1110228c8ce65d7$var$fromByteArray;
var $c1110228c8ce65d7$var$lookup = [];
var $c1110228c8ce65d7$var$revLookup = [];
var $c1110228c8ce65d7$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $c1110228c8ce65d7$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $c1110228c8ce65d7$var$i = 0, $c1110228c8ce65d7$var$len = $c1110228c8ce65d7$var$code.length; $c1110228c8ce65d7$var$i < $c1110228c8ce65d7$var$len; ++$c1110228c8ce65d7$var$i){
    $c1110228c8ce65d7$var$lookup[$c1110228c8ce65d7$var$i] = $c1110228c8ce65d7$var$code[$c1110228c8ce65d7$var$i];
    $c1110228c8ce65d7$var$revLookup[$c1110228c8ce65d7$var$code.charCodeAt($c1110228c8ce65d7$var$i)] = $c1110228c8ce65d7$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$c1110228c8ce65d7$var$revLookup["-".charCodeAt(0)] = 62;
$c1110228c8ce65d7$var$revLookup["_".charCodeAt(0)] = 63;
function $c1110228c8ce65d7$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $c1110228c8ce65d7$var$byteLength(b64) {
    var lens = $c1110228c8ce65d7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c1110228c8ce65d7$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c1110228c8ce65d7$var$toByteArray(b64) {
    var tmp;
    var lens = $c1110228c8ce65d7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $c1110228c8ce65d7$var$Arr($c1110228c8ce65d7$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 18 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 2 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 10 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $c1110228c8ce65d7$var$tripletToBase64(num) {
    return $c1110228c8ce65d7$var$lookup[num >> 18 & 0x3F] + $c1110228c8ce65d7$var$lookup[num >> 12 & 0x3F] + $c1110228c8ce65d7$var$lookup[num >> 6 & 0x3F] + $c1110228c8ce65d7$var$lookup[num & 0x3F];
}
function $c1110228c8ce65d7$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($c1110228c8ce65d7$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $c1110228c8ce65d7$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($c1110228c8ce65d7$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($c1110228c8ce65d7$var$lookup[tmp >> 2] + $c1110228c8ce65d7$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($c1110228c8ce65d7$var$lookup[tmp >> 10] + $c1110228c8ce65d7$var$lookup[tmp >> 4 & 0x3F] + $c1110228c8ce65d7$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("ZhBnF", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $0b8359fe6fd9cd49$export$aafa59e2e03f2942; }, function (v) { return $0b8359fe6fd9cd49$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $0b8359fe6fd9cd49$export$68d8715fc104d294; }, function (v) { return $0b8359fe6fd9cd49$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $0b8359fe6fd9cd49$export$aafa59e2e03f2942;
var $0b8359fe6fd9cd49$export$68d8715fc104d294;
$0b8359fe6fd9cd49$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$0b8359fe6fd9cd49$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("fjbsZ", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");

var $gqPXg = parcelRequire("gqPXg");

var $22fw2 = parcelRequire("22fw2");

var $8PwwH = parcelRequire("8PwwH");

var $lYv93 = parcelRequire("lYv93");

var $ejBOE = parcelRequire("ejBOE");

var $dza6I = parcelRequire("dza6I");

var $edUfG = parcelRequire("edUfG");

var $i0tOE = parcelRequire("i0tOE");

var $ah65u = parcelRequire("ah65u");

var $04BkQ = parcelRequire("04BkQ");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($dux9i.isFormData(requestData) && $dux9i.isStandardBrowserEnv()) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $lYv93(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $8PwwH(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $ejBOE(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $gqPXg(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $i0tOE("Request aborted", $i0tOE.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $i0tOE("Network Error", $i0tOE.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $edUfG;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $i0tOE(timeoutErrorMessage, transitional.clarifyTimeoutError ? $i0tOE.ETIMEDOUT : $i0tOE.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($dux9i.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $dza6I(fullPath)) && config.xsrfCookieName ? $22fw2.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $dux9i.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$dux9i.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $ah65u() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $04BkQ(fullPath);
        if (protocol && [
            "http",
            "https",
            "file"
        ].indexOf(protocol) === -1) {
            reject(new $i0tOE("Unsupported protocol " + protocol + ":", $i0tOE.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("gqPXg", function(module, exports) {
"use strict";

var $i0tOE = parcelRequire("i0tOE");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $i0tOE("Request failed with status code " + response.status, [
        $i0tOE.ERR_BAD_REQUEST,
        $i0tOE.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("22fw2", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");
module.exports = $dux9i.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($dux9i.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($dux9i.isString(path)) cookie.push("path=" + path);
            if ($dux9i.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("lYv93", function(module, exports) {
"use strict";

var $1gTr5 = parcelRequire("1gTr5");

var $af0nM = parcelRequire("af0nM");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$1gTr5(requestedURL)) return $af0nM(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("1gTr5", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("af0nM", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("ejBOE", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $a6c02c7bd7170710$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $dux9i.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $dux9i.trim(line.substr(0, i)).toLowerCase();
        val = $dux9i.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $a6c02c7bd7170710$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("dza6I", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");
module.exports = $dux9i.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $dux9i.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("ah65u", function(module, exports) {
"use strict";

var $i0tOE = parcelRequire("i0tOE");

var $dux9i = parcelRequire("dux9i");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $77b036cbc2a8b13f$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $i0tOE.call(this, message == null ? "canceled" : message, $i0tOE.ERR_CANCELED);
    this.name = "CanceledError";
}
$dux9i.inherits($77b036cbc2a8b13f$var$CanceledError, $i0tOE, {
    __CANCEL__: true
});
module.exports = $77b036cbc2a8b13f$var$CanceledError;

});

parcelRegister("04BkQ", function(module, exports) {
"use strict";
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
};

});


parcelRegister("gEoVV", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRegister("3qPST", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("j7ZM2", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($dux9i.isPlainObject(target) && $dux9i.isPlainObject(source)) return $dux9i.merge(target, source);
        else if ($dux9i.isPlainObject(source)) return $dux9i.merge({}, source);
        else if ($dux9i.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$dux9i.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$dux9i.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$dux9i.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$dux9i.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$dux9i.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $dux9i.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $dux9i.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("jxrCF", function(module, exports) {
"use strict";

var $bxj5i = parcelRequire("bxj5i");
var $e39686a69c4650fa$require$VERSION = $bxj5i.version;

var $i0tOE = parcelRequire("i0tOE");
var $e39686a69c4650fa$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $e39686a69c4650fa$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $e39686a69c4650fa$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $e39686a69c4650fa$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $e39686a69c4650fa$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $i0tOE(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), $i0tOE.ERR_DEPRECATED);
        if (version && !$e39686a69c4650fa$var$deprecatedWarnings[opt]) {
            $e39686a69c4650fa$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $e39686a69c4650fa$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new $i0tOE("options must be an object", $i0tOE.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $i0tOE("option " + opt + " must be " + result, $i0tOE.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $i0tOE("Unknown option " + opt, $i0tOE.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $e39686a69c4650fa$var$assertOptions,
    validators: $e39686a69c4650fa$var$validators
};

});
parcelRegister("bxj5i", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRegister("dr9i3", function(module, exports) {
"use strict";

var $ah65u = parcelRequire("ah65u");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $9c8500d16854c13d$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $ah65u(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $9c8500d16854c13d$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $9c8500d16854c13d$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $9c8500d16854c13d$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $9c8500d16854c13d$var$CancelToken.source = function source() {
    var cancel;
    var token = new $9c8500d16854c13d$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $9c8500d16854c13d$var$CancelToken;

});

parcelRegister("jhHUj", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("3YNly", function(module, exports) {
"use strict";

var $dux9i = parcelRequire("dux9i");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $dux9i.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("87Z3V", function(module, exports) {

$parcel$export(module.exports, "createInstance", function () { return createInstance; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "loadResources", function () { return loadResources; });
$parcel$export(module.exports, "reloadResources", function () { return reloadResources; });
$parcel$export(module.exports, "use", function () { return use; });
$parcel$export(module.exports, "changeLanguage", function () { return changeLanguage; });
$parcel$export(module.exports, "getFixedT", function () { return getFixedT; });
$parcel$export(module.exports, "t", function () { return t; });
$parcel$export(module.exports, "exists", function () { return exists; });
$parcel$export(module.exports, "setDefaultNamespace", function () { return setDefaultNamespace; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return hasLoadedNamespace; });
$parcel$export(module.exports, "loadNamespaces", function () { return loadNamespaces; });
$parcel$export(module.exports, "loadLanguages", function () { return loadLanguages; });
$parcel$export(module.exports, "default", function () { return $5eae57daa7ba0604$export$2e2bcd8739ae039; });

var $lC9Fk = parcelRequire("lC9Fk");

var $4lDXN = parcelRequire("4lDXN");

var $9i3GH = parcelRequire("9i3GH");

var $cvW56 = parcelRequire("cvW56");

var $4Vkek = parcelRequire("4Vkek");

var $cAmgy = parcelRequire("cAmgy");

var $2APsq = parcelRequire("2APsq");

var $b92rS = parcelRequire("b92rS");

var $cafeZ = parcelRequire("cafeZ");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, $b92rS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4lDXN.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $9i3GH.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, _objectSpread(_objectSpread({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
    function EventEmitter() {
        (0, $4lDXN.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $9i3GH.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    var _getLastOfPath3 = getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return _entityMap[s];
    });
    return data;
}
var isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $b92rS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $2APsq.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $2APsq.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $cAmgy.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var ResourceStore = function(_EventEmitter) {
    (0, $4Vkek.default)(ResourceStore, _EventEmitter);
    var _super = _createSuper(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $4lDXN.default)(this, ResourceStore);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $cvW56.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $9i3GH.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (deep) deepExtend(pack, resources, overwrite);
                else pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
                setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $b92rS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $2APsq.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $2APsq.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $cAmgy.default)(this, result);
    };
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
    (0, $4Vkek.default)(Translator, _EventEmitter);
    var _super = _createSuper$1(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4lDXN.default)(this, Translator);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $cvW56.default)(_this));
        copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $cvW56.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = baseLogger.create("translator");
        return _this;
    }
    (0, $9i3GH.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $lC9Fk.default)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) {
                            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
                            return resolved;
                        }
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) {
                        resolved.res = key;
                        return resolved;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
                        interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $4lDXN.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create("languageUtils");
    }
    (0, $9i3GH.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var _rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    var rules = {};
    sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4lDXN.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = createRules();
    }
    (0, $9i3GH.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$3(Object(source), true).forEach(function(key) {
            (0, $b92rS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $4lDXN.default)(this, Interpolator);
        this.logger = baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $9i3GH.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && options.hasOwnProperty(matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = _objectSpread$3({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$4(Object(source), true).forEach(function(key) {
            (0, $b92rS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $cafeZ.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $4lDXN.default)(this, Formatter);
        this.logger = baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, options);
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val, options.range || "day");
                };
            }),
            list: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $9i3GH.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng, options) {
                var _this = this;
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$5(Object(source), true).forEach(function(key) {
            (0, $b92rS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $2APsq.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $2APsq.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $cAmgy.default)(this, result);
    };
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var Connector = function(_EventEmitter) {
    (0, $4Vkek.default)(Connector, _EventEmitter);
    var _super = _createSuper$2(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $4lDXN.default)(this, Connector);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $cvW56.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $9i3GH.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(ns) {
                                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                return this.backend[fcName](lng, ns, function(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $lC9Fk.default)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $lC9Fk.default)(args[2]) === "object" || (0, $lC9Fk.default)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$6(Object(source), true).forEach(function(key) {
            (0, $b92rS.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $2APsq.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $2APsq.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $cAmgy.default)(this, result);
    };
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function noop() {}
function bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var I18n = function(_EventEmitter) {
    (0, $4Vkek.default)(I18n, _EventEmitter);
    var _super = _createSuper$3(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $4lDXN.default)(this, I18n);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $cvW56.default)(_this));
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions((0, $cvW56.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $cAmgy.default)(_this, (0, $cvW56.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $9i3GH.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = get();
                this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = Formatter;
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $lC9Fk.default)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = _objectSpread$6({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = _objectSpread$6({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}(EventEmitter);
(0, $b92rS.default)(I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;
var $5eae57daa7ba0604$export$2e2bcd8739ae039 = instance;

});
parcelRegister("lC9Fk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbc4a4fc716f719e$export$2e2bcd8739ae039; });
function $fbc4a4fc716f719e$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $fbc4a4fc716f719e$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fbc4a4fc716f719e$export$2e2bcd8739ae039(o);
}

});

parcelRegister("4lDXN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32a81f7b5617108c$export$2e2bcd8739ae039; });
function $32a81f7b5617108c$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9i3GH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c38a7c9cb3b78d6$export$2e2bcd8739ae039; });

var $9PTcD = parcelRequire("9PTcD");
function $6c38a7c9cb3b78d6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $9PTcD.default)(descriptor.key), descriptor);
    }
}
function $6c38a7c9cb3b78d6$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $6c38a7c9cb3b78d6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6c38a7c9cb3b78d6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRegister("9PTcD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7293b29a505e48ad$export$2e2bcd8739ae039; });

var $lC9Fk = parcelRequire("lC9Fk");

var $fa0A2 = parcelRequire("fa0A2");
function $7293b29a505e48ad$export$2e2bcd8739ae039(t) {
    var i = (0, $fa0A2.default)(t, "string");
    return "symbol" == (0, $lC9Fk.default)(i) ? i : i + "";
}

});
parcelRegister("fa0A2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0983d667aba9f6d$export$2e2bcd8739ae039; });

var $lC9Fk = parcelRequire("lC9Fk");
function $b0983d667aba9f6d$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $lC9Fk.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $lC9Fk.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("cvW56", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91c56f0902bfa314$export$2e2bcd8739ae039; });
function $91c56f0902bfa314$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("4Vkek", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $395c2d91ab0fa92d$export$2e2bcd8739ae039; });

var $jAQHc = parcelRequire("jAQHc");
function $395c2d91ab0fa92d$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $jAQHc.default)(subClass, superClass);
}

});
parcelRegister("jAQHc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e43a4162b9477b0d$export$2e2bcd8739ae039; });
function $e43a4162b9477b0d$export$2e2bcd8739ae039(o, p) {
    $e43a4162b9477b0d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e43a4162b9477b0d$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("cAmgy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $929a1e623eaf2313$export$2e2bcd8739ae039; });

var $lC9Fk = parcelRequire("lC9Fk");

var $cvW56 = parcelRequire("cvW56");
function $929a1e623eaf2313$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $lC9Fk.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cvW56.default)(self);
}

});

parcelRegister("2APsq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e36dbf550b470f7$export$2e2bcd8739ae039; });
function $1e36dbf550b470f7$export$2e2bcd8739ae039(o) {
    $1e36dbf550b470f7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1e36dbf550b470f7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("b92rS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81d26f3ac97128a5$export$2e2bcd8739ae039; });

var $9PTcD = parcelRequire("9PTcD");
function $81d26f3ac97128a5$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $9PTcD.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("cafeZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8db23daf5943dde9$export$2e2bcd8739ae039; });

var $7PsUX = parcelRequire("7PsUX");

var $4THKy = parcelRequire("4THKy");

var $iVmtO = parcelRequire("iVmtO");

var $7wFv5 = parcelRequire("7wFv5");
function $8db23daf5943dde9$export$2e2bcd8739ae039(arr) {
    return (0, $7PsUX.default)(arr) || (0, $4THKy.default)(arr) || (0, $iVmtO.default)(arr) || (0, $7wFv5.default)();
}

});
parcelRegister("7PsUX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b33ba488787fe8f$export$2e2bcd8739ae039; });
function $5b33ba488787fe8f$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("4THKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $390e3c4fa3891770$export$2e2bcd8739ae039; });
function $390e3c4fa3891770$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("iVmtO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc6efce20eb501c3$export$2e2bcd8739ae039; });

var $i0NCu = parcelRequire("i0NCu");
function $dc6efce20eb501c3$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $i0NCu.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $i0NCu.default)(o, minLen);
}

});
parcelRegister("i0NCu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1ceb79026976d4f$export$2e2bcd8739ae039; });
function $d1ceb79026976d4f$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("7wFv5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57abb6abebc60a27$export$2e2bcd8739ae039; });
function $57abb6abebc60a27$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("4JqPN", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("j212u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddaf029589183ba4$export$2e2bcd8739ae039; });

var $jfZTJ = parcelRequire("jfZTJ");
var $ddaf029589183ba4$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $ddaf029589183ba4$var$index = (0, $jfZTJ.default)(function(prop) {
    return $ddaf029589183ba4$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $ddaf029589183ba4$export$2e2bcd8739ae039 = $ddaf029589183ba4$var$index;

});
parcelRegister("jfZTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e04f6eafaa4e7bac$export$2e2bcd8739ae039; });
function $e04f6eafaa4e7bac$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $e04f6eafaa4e7bac$export$2e2bcd8739ae039 = $e04f6eafaa4e7bac$var$memoize;

});


parcelRegister("lgZPq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "unstable_serialize", function () { return $f7cb0d75015db7f1$export$dbab534a48e651ef; });
$parcel$export(module.exports, "SWRConfig", function () { return $f7cb0d75015db7f1$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "default", function () { return $f7cb0d75015db7f1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "mutate", function () { return (parcelRequire("fqGKQ")).mutate; });
$parcel$export(module.exports, "preload", function () { return (parcelRequire("fqGKQ")).preload; });
$parcel$export(module.exports, "useSWRConfig", function () { return (parcelRequire("fqGKQ")).useSWRConfig; });

var $3QbnI = parcelRequire("3QbnI");

var $eW1QL = parcelRequire("eW1QL");

var $fqGKQ = parcelRequire("fqGKQ");
const $f7cb0d75015db7f1$export$dbab534a48e651ef = (key)=>(0, $fqGKQ.serialize)(key)[0];
/// <reference types="react/experimental" />
const $f7cb0d75015db7f1$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $f7cb0d75015db7f1$var$WITH_DEDUPE = {
    dedupe: true
};
const $f7cb0d75015db7f1$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $fqGKQ.SWRGlobalState).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $fqGKQ.serialize)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $3QbnI.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $3QbnI.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $3QbnI.useRef)(key);
    const fetcherRef = (0, $3QbnI.useRef)(fetcher);
    const configRef = (0, $3QbnI.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $fqGKQ.createCacheHelper)(cache, key);
    const stateDependencies = (0, $3QbnI.useRef)({}).current;
    const fallback = (0, $fqGKQ.isUndefined)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $fqGKQ.isUndefined)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $3QbnI.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $fqGKQ.isUndefined)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $fqGKQ.isUndefined)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $fqGKQ.mergeObjects)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $eW1QL.useSyncExternalStore)((0, $3QbnI.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $fqGKQ.isUndefined)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $3QbnI.useRef)(data);
    const returnedData = keepPreviousData ? (0, $fqGKQ.isUndefined)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $fqGKQ.isUndefined)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $fqGKQ.isUndefined)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $fqGKQ.isUndefined)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $fqGKQ.isUndefined)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $fqGKQ.isUndefined)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $fqGKQ.isUndefined)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $3QbnI.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $fqGKQ.IS_REACT_LEGACY) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $fqGKQ.isUndefined)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $fqGKQ.isUndefined)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $fqGKQ.getTimestamp)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $fqGKQ.UNDEFINED);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $fqGKQ.isUndefined)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $fqGKQ.isFunction)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $fqGKQ.revalidateEvents).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const boundMutate = (0, $3QbnI.useCallback)((...args)=>{
        return (0, $fqGKQ.internalMutate)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $fqGKQ.useIsomorphicLayoutEffect)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $fqGKQ.isUndefined)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $fqGKQ.useIsomorphicLayoutEffect)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $fqGKQ.UNDEFINED), $f7cb0d75015db7f1$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $fqGKQ.revalidateEvents).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $fqGKQ.revalidateEvents).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $fqGKQ.revalidateEvents).MUTATE_EVENT) return revalidate();
            else if (type == (0, $fqGKQ.revalidateEvents).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $fqGKQ.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $fqGKQ.isUndefined)(data) || (0, $fqGKQ.IS_SERVER)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $fqGKQ.rAF)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $fqGKQ.useIsomorphicLayoutEffect)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $fqGKQ.isFunction)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($f7cb0d75015db7f1$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $3QbnI.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $fqGKQ.isUndefined)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $fqGKQ.IS_REACT_LEGACY) && (0, $fqGKQ.IS_SERVER)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $fqGKQ.isUndefined)(req)) {
            const promise = boundMutate(req);
            $f7cb0d75015db7f1$var$use(promise);
        }
        if ((0, $fqGKQ.isUndefined)(error)) {
            const promise = revalidate($f7cb0d75015db7f1$var$WITH_DEDUPE);
            if (!(0, $fqGKQ.isUndefined)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $f7cb0d75015db7f1$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $f7cb0d75015db7f1$export$4c7bbecdacc3ca2c = (0, $fqGKQ.OBJECT).defineProperty((0, $fqGKQ.SWRConfig), "defaultValue", {
    value: (0, $fqGKQ.defaultConfig)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (!data) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $f7cb0d75015db7f1$export$2e2bcd8739ae039 = (0, $fqGKQ.withArgs)($f7cb0d75015db7f1$var$useSWRHandler);

});
parcelRegister("fqGKQ", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", function () { return $b3ba72e338f746a4$export$6db089fe7b26f5b6; });
$parcel$export(module.exports, "OBJECT", function () { return $b3ba72e338f746a4$export$8b8a958a7f6f130c; });
$parcel$export(module.exports, "isUndefined", function () { return $b3ba72e338f746a4$export$fce6876652108ab; });
$parcel$export(module.exports, "isFunction", function () { return $b3ba72e338f746a4$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "mergeObjects", function () { return $b3ba72e338f746a4$export$2321aea138b44780; });
$parcel$export(module.exports, "SWRGlobalState", function () { return $b3ba72e338f746a4$export$b94ca9901c60634; });
$parcel$export(module.exports, "createCacheHelper", function () { return $b3ba72e338f746a4$export$1251d51d9c571b45; });
$parcel$export(module.exports, "IS_REACT_LEGACY", function () { return $b3ba72e338f746a4$export$ddb64fe6466374f7; });
$parcel$export(module.exports, "IS_SERVER", function () { return $b3ba72e338f746a4$export$d2f4d8e74279c212; });
$parcel$export(module.exports, "rAF", function () { return $b3ba72e338f746a4$export$eba6076d3d7d0c06; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $b3ba72e338f746a4$export$700979bc83e7db82; });
$parcel$export(module.exports, "serialize", function () { return $b3ba72e338f746a4$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "getTimestamp", function () { return $b3ba72e338f746a4$export$3c95c4c8b671ef0; });
$parcel$export(module.exports, "revalidateEvents", function () { return $b3ba72e338f746a4$export$10213d6aa5ce32e6; });
$parcel$export(module.exports, "internalMutate", function () { return $b3ba72e338f746a4$export$c9d44e5bea4509be; });
$parcel$export(module.exports, "mutate", function () { return $b3ba72e338f746a4$export$57e795267c26e600; });
$parcel$export(module.exports, "defaultConfig", function () { return $b3ba72e338f746a4$export$f84bd70098573c5c; });
$parcel$export(module.exports, "SWRConfig", function () { return $b3ba72e338f746a4$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "useSWRConfig", function () { return $b3ba72e338f746a4$export$f1dc0e282d4c1c0; });
$parcel$export(module.exports, "preload", function () { return $b3ba72e338f746a4$export$513ccb98c53b8039; });
$parcel$export(module.exports, "withArgs", function () { return $b3ba72e338f746a4$export$84d44e54e14b0133; });
$parcel$export(module.exports, "subscribeCallback", function () { return $b3ba72e338f746a4$export$e005210ed621746; });
$parcel$export(module.exports, "withMiddleware", function () { return $b3ba72e338f746a4$export$525ea7fc6ba00096; });

var $3QbnI = parcelRequire("3QbnI");
// Shared state between server components and client components
const $b3ba72e338f746a4$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $b3ba72e338f746a4$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $b3ba72e338f746a4$export$8793edee2d425525();
const $b3ba72e338f746a4$export$8b8a958a7f6f130c = Object;
const $b3ba72e338f746a4$export$fce6876652108ab = (v)=>v === $b3ba72e338f746a4$export$6db089fe7b26f5b6;
const $b3ba72e338f746a4$export$f6e2535fb5126e54 = (v)=>typeof v == "function";
const $b3ba72e338f746a4$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $b3ba72e338f746a4$export$ae936b9d47e5870e = (x)=>$b3ba72e338f746a4$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $b3ba72e338f746a4$var$table = new WeakMap();
// counter of the key
let $b3ba72e338f746a4$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $b3ba72e338f746a4$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($b3ba72e338f746a4$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $b3ba72e338f746a4$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$b3ba72e338f746a4$var$counter + "~";
        $b3ba72e338f746a4$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $b3ba72e338f746a4$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $b3ba72e338f746a4$var$table.set(arg, result);
        }
        if (constructor == $b3ba72e338f746a4$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = "#";
            const keys = $b3ba72e338f746a4$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$b3ba72e338f746a4$export$fce6876652108ab(index = keys.pop()))if (!$b3ba72e338f746a4$export$fce6876652108ab(arg[index])) result += index + ":" + $b3ba72e338f746a4$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $b3ba72e338f746a4$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $b3ba72e338f746a4$export$b94ca9901c60634 = new WeakMap();
const $b3ba72e338f746a4$var$EMPTY_CACHE = {};
const $b3ba72e338f746a4$var$INITIAL_CACHE = {};
const $b3ba72e338f746a4$var$STR_UNDEFINED = "undefined";
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $b3ba72e338f746a4$export$6e85fd745dc51282 = typeof window != $b3ba72e338f746a4$var$STR_UNDEFINED;
const $b3ba72e338f746a4$export$842dfe7a9f24298 = typeof document != $b3ba72e338f746a4$var$STR_UNDEFINED;
const $b3ba72e338f746a4$export$a9116928c9d15917 = ()=>$b3ba72e338f746a4$export$6e85fd745dc51282 && typeof window["requestAnimationFrame"] != $b3ba72e338f746a4$var$STR_UNDEFINED;
const $b3ba72e338f746a4$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $b3ba72e338f746a4$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$b3ba72e338f746a4$export$fce6876652108ab(key) && cache.get(key) || $b3ba72e338f746a4$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$b3ba72e338f746a4$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $b3ba72e338f746a4$var$INITIAL_CACHE)) $b3ba72e338f746a4$var$INITIAL_CACHE[key] = prev;
                state[5](key, $b3ba72e338f746a4$export$2321aea138b44780(prev, info), prev || $b3ba72e338f746a4$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$b3ba72e338f746a4$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $b3ba72e338f746a4$var$INITIAL_CACHE) return $b3ba72e338f746a4$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$b3ba72e338f746a4$export$fce6876652108ab(key) && cache.get(key) || $b3ba72e338f746a4$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $b3ba72e338f746a4$var$online = true;
const $b3ba72e338f746a4$var$isOnline = ()=>$b3ba72e338f746a4$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$b3ba72e338f746a4$var$onWindowEvent, $b3ba72e338f746a4$var$offWindowEvent] = $b3ba72e338f746a4$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $b3ba72e338f746a4$export$8793edee2d425525,
    $b3ba72e338f746a4$export$8793edee2d425525
];
const $b3ba72e338f746a4$var$isVisible = ()=>{
    const visibilityState = $b3ba72e338f746a4$export$842dfe7a9f24298 && document.visibilityState;
    return $b3ba72e338f746a4$export$fce6876652108ab(visibilityState) || visibilityState !== "hidden";
};
const $b3ba72e338f746a4$var$initFocus = (callback)=>{
    // focus revalidate
    if ($b3ba72e338f746a4$export$842dfe7a9f24298) document.addEventListener("visibilitychange", callback);
    $b3ba72e338f746a4$var$onWindowEvent("focus", callback);
    return ()=>{
        if ($b3ba72e338f746a4$export$842dfe7a9f24298) document.removeEventListener("visibilitychange", callback);
        $b3ba72e338f746a4$var$offWindowEvent("focus", callback);
    };
};
const $b3ba72e338f746a4$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $b3ba72e338f746a4$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $b3ba72e338f746a4$var$online = false;
    };
    $b3ba72e338f746a4$var$onWindowEvent("online", onOnline);
    $b3ba72e338f746a4$var$onWindowEvent("offline", onOffline);
    return ()=>{
        $b3ba72e338f746a4$var$offWindowEvent("online", onOnline);
        $b3ba72e338f746a4$var$offWindowEvent("offline", onOffline);
    };
};
const $b3ba72e338f746a4$export$f5ab8217e0edff04 = {
    isOnline: $b3ba72e338f746a4$var$isOnline,
    isVisible: $b3ba72e338f746a4$var$isVisible
};
const $b3ba72e338f746a4$export$b1857f3440a65373 = {
    initFocus: $b3ba72e338f746a4$var$initFocus,
    initReconnect: $b3ba72e338f746a4$var$initReconnect
};
const $b3ba72e338f746a4$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useId;
const $b3ba72e338f746a4$export$d2f4d8e74279c212 = !$b3ba72e338f746a4$export$6e85fd745dc51282 || "Deno" in window;
// Polyfill requestAnimationFrame
const $b3ba72e338f746a4$export$eba6076d3d7d0c06 = (f)=>$b3ba72e338f746a4$export$a9116928c9d15917() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $b3ba72e338f746a4$export$700979bc83e7db82 = $b3ba72e338f746a4$export$d2f4d8e74279c212 ? (0, $3QbnI.useEffect) : (0, $3QbnI.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $b3ba72e338f746a4$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $b3ba72e338f746a4$export$3723beb60427dc52 = !$b3ba72e338f746a4$export$d2f4d8e74279c212 && $b3ba72e338f746a4$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($b3ba72e338f746a4$var$navigatorConnection.effectiveType) || $b3ba72e338f746a4$var$navigatorConnection.saveData);
const $b3ba72e338f746a4$export$dfdc1655ccc5b9cb = (key)=>{
    if ($b3ba72e338f746a4$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $b3ba72e338f746a4$export$e9a4e06c7dfb0bd4(key) : "";
    return [
        key,
        args
    ];
};
// Global timestamp.
let $b3ba72e338f746a4$var$__timestamp = 0;
const $b3ba72e338f746a4$export$3c95c4c8b671ef0 = ()=>++$b3ba72e338f746a4$var$__timestamp;
const $b3ba72e338f746a4$var$FOCUS_EVENT = 0;
const $b3ba72e338f746a4$var$RECONNECT_EVENT = 1;
const $b3ba72e338f746a4$var$MUTATE_EVENT = 2;
const $b3ba72e338f746a4$var$ERROR_REVALIDATE_EVENT = 3;
var $b3ba72e338f746a4$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $b3ba72e338f746a4$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $b3ba72e338f746a4$var$FOCUS_EVENT,
    MUTATE_EVENT: $b3ba72e338f746a4$var$MUTATE_EVENT,
    RECONNECT_EVENT: $b3ba72e338f746a4$var$RECONNECT_EVENT
};
async function $b3ba72e338f746a4$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $b3ba72e338f746a4$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === "boolean" ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const revalidate = options.revalidate !== false;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($b3ba72e338f746a4$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $b3ba72e338f746a4$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $b3ba72e338f746a4$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $b3ba72e338f746a4$export$b94ca9901c60634.get(cache);
        const revalidators = EVENT_REVALIDATORS[key];
        const startRevalidate = ()=>{
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($b3ba72e338f746a4$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $b3ba72e338f746a4$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$b3ba72e338f746a4$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $b3ba72e338f746a4$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $b3ba72e338f746a4$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($b3ba72e338f746a4$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $b3ba72e338f746a4$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                data = committedData;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: data,
                    _c: $b3ba72e338f746a4$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($b3ba72e338f746a4$export$f6e2535fb5126e54(populateCache)) data = populateCache(data, committedData);
                // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $b3ba72e338f746a4$export$6db089fe7b26f5b6,
                    _c: $b3ba72e338f746a4$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $b3ba72e338f746a4$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        const res = await startRevalidate();
        // The mutation and revalidation are ended, we can clear it since the data is
        // not an optimistic value anymore.
        set({
            _c: $b3ba72e338f746a4$export$6db089fe7b26f5b6
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return populateCache ? res : data;
    }
}
const $b3ba72e338f746a4$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $b3ba72e338f746a4$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$b3ba72e338f746a4$export$b94ca9901c60634.has(provider)) {
        const opts = $b3ba72e338f746a4$export$2321aea138b44780($b3ba72e338f746a4$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $b3ba72e338f746a4$export$c9d44e5bea4509be.bind($b3ba72e338f746a4$export$6db089fe7b26f5b6, provider);
        let unmount = $b3ba72e338f746a4$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$b3ba72e338f746a4$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $b3ba72e338f746a4$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$b3ba72e338f746a4$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($b3ba72e338f746a4$export$6db089fe7b26f5b6, $b3ba72e338f746a4$var$revalidateAllKeys.bind($b3ba72e338f746a4$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $b3ba72e338f746a4$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($b3ba72e338f746a4$export$6db089fe7b26f5b6, $b3ba72e338f746a4$var$revalidateAllKeys.bind($b3ba72e338f746a4$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $b3ba72e338f746a4$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $b3ba72e338f746a4$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $b3ba72e338f746a4$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $b3ba72e338f746a4$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$b3ba72e338f746a4$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $b3ba72e338f746a4$export$398604a469f7de9a = (currentData, newData)=>$b3ba72e338f746a4$export$e9a4e06c7dfb0bd4(currentData) == $b3ba72e338f746a4$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$b3ba72e338f746a4$export$69a3209f1a06c04d, $b3ba72e338f746a4$export$57e795267c26e600] = $b3ba72e338f746a4$export$4008f5b66f9e0b3c(new Map());
// Default config
const $b3ba72e338f746a4$export$f84bd70098573c5c = $b3ba72e338f746a4$export$2321aea138b44780({
    // events
    onLoadingSlow: $b3ba72e338f746a4$export$8793edee2d425525,
    onSuccess: $b3ba72e338f746a4$export$8793edee2d425525,
    onError: $b3ba72e338f746a4$export$8793edee2d425525,
    onErrorRetry: $b3ba72e338f746a4$var$onErrorRetry,
    onDiscarded: $b3ba72e338f746a4$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $b3ba72e338f746a4$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $b3ba72e338f746a4$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $b3ba72e338f746a4$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $b3ba72e338f746a4$export$69a3209f1a06c04d,
    mutate: $b3ba72e338f746a4$export$57e795267c26e600,
    fallback: {}
}, $b3ba72e338f746a4$export$f5ab8217e0edff04);
const $b3ba72e338f746a4$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $b3ba72e338f746a4$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $b3ba72e338f746a4$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $b3ba72e338f746a4$var$SWRConfigContext = (0, $3QbnI.createContext)({});
const $b3ba72e338f746a4$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $3QbnI.useContext)($b3ba72e338f746a4$var$SWRConfigContext);
    const isFunctionalConfig = $b3ba72e338f746a4$export$f6e2535fb5126e54(value);
    const config = (0, $3QbnI.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $3QbnI.useMemo)(()=>isFunctionalConfig ? config : $b3ba72e338f746a4$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $3QbnI.useRef)($b3ba72e338f746a4$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $b3ba72e338f746a4$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $b3ba72e338f746a4$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $b3ba72e338f746a4$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $3QbnI.createElement)($b3ba72e338f746a4$var$SWRConfigContext.Provider, $b3ba72e338f746a4$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
// @ts-expect-error
const $b3ba72e338f746a4$var$enableDevtools = $b3ba72e338f746a4$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $b3ba72e338f746a4$var$use = $b3ba72e338f746a4$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $b3ba72e338f746a4$var$setupDevTools = ()=>{
    if ($b3ba72e338f746a4$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI)));
};
const $b3ba72e338f746a4$export$a3295358bff77e = (args)=>{
    return $b3ba72e338f746a4$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $b3ba72e338f746a4$export$f1dc0e282d4c1c0 = ()=>{
    return $b3ba72e338f746a4$export$2321aea138b44780($b3ba72e338f746a4$export$f84bd70098573c5c, (0, $3QbnI.useContext)($b3ba72e338f746a4$var$SWRConfigContext));
};
const $b3ba72e338f746a4$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $b3ba72e338f746a4$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $b3ba72e338f746a4$export$b94ca9901c60634.get($b3ba72e338f746a4$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $b3ba72e338f746a4$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $b3ba72e338f746a4$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $b3ba72e338f746a4$export$b94ca9901c60634.get($b3ba72e338f746a4$export$69a3209f1a06c04d);
            const req = PRELOAD[key];
            if ($b3ba72e338f746a4$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $b3ba72e338f746a4$var$BUILT_IN_MIDDLEWARE = $b3ba72e338f746a4$var$use.concat($b3ba72e338f746a4$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $b3ba72e338f746a4$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $b3ba72e338f746a4$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $b3ba72e338f746a4$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $b3ba72e338f746a4$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($b3ba72e338f746a4$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
/**
 * An implementation of state with dependency-tracking.
 */ const $b3ba72e338f746a4$export$e1784150b9e765ac = (state)=>{
    const rerender = (0, $3QbnI.useState)({})[1];
    const unmountedRef = (0, $3QbnI.useRef)(false);
    const stateRef = (0, $3QbnI.useRef)(state);
    // If a state property (data, error, or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    const stateDependenciesRef = (0, $3QbnI.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
   * @param payload To change stateRef, pass the values explicitly to setState:
   * @example
   * ```js
   * setState({
   *   isValidating: false
   *   data: newData // set data to newData
   *   error: undefined // set error to undefined
   * })
   *
   * setState({
   *   isValidating: false
   *   data: undefined // set data to undefined
   *   error: err // set error to err
   * })
   * ```
   */ const setState = (0, $3QbnI.useCallback)((payload)=>{
        let shouldRerender = false;
        const currentState = stateRef.current;
        for(const _ in payload){
            const k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) shouldRerender = true;
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            if ($b3ba72e338f746a4$export$ddb64fe6466374f7) rerender({});
            else (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).startTransition(()=>rerender({}));
        }
    }, [
        rerender
    ]);
    $b3ba72e338f746a4$export$700979bc83e7db82(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
        };
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $b3ba72e338f746a4$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $b3ba72e338f746a4$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $b3ba72e338f746a4$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$b3ba72e338f746a4$var$setupDevTools();

});


parcelRegister("78BOR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "unstable_serialize", function () { return $53269de00902b4d3$export$dbab534a48e651ef; });
$parcel$export(module.exports, "infinite", function () { return $53269de00902b4d3$export$f27219e7b43e81d; });
$parcel$export(module.exports, "default", function () { return $53269de00902b4d3$export$2e2bcd8739ae039; });

var $3QbnI = parcelRequire("3QbnI");

var $lgZPq = parcelRequire("lgZPq");

var $fqGKQ = parcelRequire("fqGKQ");

var $eW1QL = parcelRequire("eW1QL");
const $53269de00902b4d3$var$INFINITE_PREFIX = "$inf$";
const $53269de00902b4d3$var$getFirstPageKey = (getKey)=>{
    return (0, $fqGKQ.serialize)(getKey ? getKey(0, null) : null)[0];
};
const $53269de00902b4d3$export$dbab534a48e651ef = (getKey)=>{
    return $53269de00902b4d3$var$INFINITE_PREFIX + $53269de00902b4d3$var$getFirstPageKey(getKey);
};
// We have to several type castings here because `useSWRInfinite` is a special
// const INFINITE_PREFIX = '$inf$'
const $53269de00902b4d3$var$EMPTY_PROMISE = Promise.resolve();
// export const unstable_serialize = (getKey: SWRInfiniteKeyLoader) => {
//   return INFINITE_PREFIX + getFirstPageKey(getKey)
// }
const $53269de00902b4d3$export$f27219e7b43e81d = (useSWRNext)=>(getKey, fn, config)=>{
        const didMountRef = (0, $3QbnI.useRef)(false);
        const { cache: cache, initialSize: initialSize = 1, revalidateAll: revalidateAll = false, persistSize: persistSize = false, revalidateFirstPage: revalidateFirstPage = true, revalidateOnMount: revalidateOnMount = false, parallel: parallel = false } = config;
        // The serialized key of the first page. This key will be used to store
        // metadata of this SWR infinite hook.
        let infiniteKey;
        try {
            infiniteKey = $53269de00902b4d3$var$getFirstPageKey(getKey);
            if (infiniteKey) infiniteKey = $53269de00902b4d3$var$INFINITE_PREFIX + infiniteKey;
        } catch (err) {
        // Not ready yet.
        }
        const [get, set, subscribeCache] = (0, $fqGKQ.createCacheHelper)(cache, infiniteKey);
        const getSnapshot = (0, $3QbnI.useCallback)(()=>{
            const size = (0, $fqGKQ.isUndefined)(get()._l) ? initialSize : get()._l;
            return size;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            cache,
            infiniteKey,
            initialSize
        ]);
        (0, $eW1QL.useSyncExternalStore)((0, $3QbnI.useCallback)((callback)=>{
            if (infiniteKey) return subscribeCache(infiniteKey, ()=>{
                callback();
            });
            return ()=>{};
        }, [
            cache,
            infiniteKey
        ]), getSnapshot, getSnapshot);
        const resolvePageSize = (0, $3QbnI.useCallback)(()=>{
            const cachedPageSize = get()._l;
            return (0, $fqGKQ.isUndefined)(cachedPageSize) ? initialSize : cachedPageSize;
        // `cache` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            infiniteKey,
            initialSize
        ]);
        // keep the last page size to restore it with the persistSize option
        const lastPageSizeRef = (0, $3QbnI.useRef)(resolvePageSize());
        // When the page key changes, we reset the page size if it's not persisted
        (0, $fqGKQ.useIsomorphicLayoutEffect)(()=>{
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (infiniteKey) // If the key has been changed, we keep the current page size if persistSize is enabled
            // Otherwise, we reset the page size to cached pageSize
            set({
                _l: persistSize ? lastPageSizeRef.current : resolvePageSize()
            });
        // `initialSize` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            infiniteKey,
            cache
        ]);
        // Needs to check didMountRef during mounting, not in the fetcher
        const shouldRevalidateOnMount = revalidateOnMount && !didMountRef.current;
        // Actual SWR hook to load all pages in one fetcher.
        const swr = useSWRNext(infiniteKey, async (key)=>{
            // get the revalidate context
            const forceRevalidateAll = get()._i;
            // return an array of page data
            const data = [];
            const pageSize = resolvePageSize();
            const [getCache] = (0, $fqGKQ.createCacheHelper)(cache, key);
            const cacheData = getCache().data;
            const revalidators = [];
            let previousPageData = null;
            for(let i = 0; i < pageSize; ++i){
                const [pageKey, pageArg] = (0, $fqGKQ.serialize)(getKey(i, parallel ? null : previousPageData));
                if (!pageKey) break;
                const [getSWRCache, setSWRCache] = (0, $fqGKQ.createCacheHelper)(cache, pageKey);
                // Get the cached page data.
                let pageData = getSWRCache().data;
                // should fetch (or revalidate) if:
                // - `revalidateAll` is enabled
                // - `mutate()` called
                // - the cache is missing
                // - it's the first page and it's not the initial render
                // - `revalidateOnMount` is enabled and it's on mount
                // - cache for that page has changed
                const shouldFetchPage = revalidateAll || forceRevalidateAll || (0, $fqGKQ.isUndefined)(pageData) || revalidateFirstPage && !i && !(0, $fqGKQ.isUndefined)(cacheData) || shouldRevalidateOnMount || cacheData && !(0, $fqGKQ.isUndefined)(cacheData[i]) && !config.compare(cacheData[i], pageData);
                if (fn && shouldFetchPage) {
                    const revalidate = async ()=>{
                        pageData = await fn(pageArg);
                        setSWRCache({
                            data: pageData,
                            _k: pageArg
                        });
                        data[i] = pageData;
                    };
                    if (parallel) revalidators.push(revalidate);
                    else await revalidate();
                } else data[i] = pageData;
                if (!parallel) previousPageData = pageData;
            }
            // flush all revalidateions in parallel
            if (parallel) await Promise.all(revalidators.map((r)=>r()));
            // once we executed the data fetching based on the context, clear the context
            set({
                _i: (0, $fqGKQ.UNDEFINED)
            });
            // return the data
            return data;
        }, config);
        const mutate = (0, $3QbnI.useCallback)(function(data, opts) {
            // When passing as a boolean, it's explicitly used to disable/enable
            // revalidation.
            const options = typeof opts === "boolean" ? {
                revalidate: opts
            } : opts || {};
            // Default to true.
            const shouldRevalidate = options.revalidate !== false;
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $53269de00902b4d3$var$EMPTY_PROMISE;
            if (shouldRevalidate) {
                if (!(0, $fqGKQ.isUndefined)(data)) // We only revalidate the pages that are changed
                set({
                    _i: false
                });
                else // Calling `mutate()`, we revalidate all pages
                set({
                    _i: true
                });
            }
            return arguments.length ? swr.mutate(data, {
                ...options,
                revalidate: shouldRevalidate
            }) : swr.mutate();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache
        ]);
        // Extend the SWR API
        const setSize = (0, $3QbnI.useCallback)((arg)=>{
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $53269de00902b4d3$var$EMPTY_PROMISE;
            const [, changeSize] = (0, $fqGKQ.createCacheHelper)(cache, infiniteKey);
            let size;
            if ((0, $fqGKQ.isFunction)(arg)) size = arg(resolvePageSize());
            else if (typeof arg == "number") size = arg;
            if (typeof size != "number") return $53269de00902b4d3$var$EMPTY_PROMISE;
            changeSize({
                _l: size
            });
            lastPageSizeRef.current = size;
            // Calculate the page data after the size change.
            const data = [];
            const [getInfiniteCache] = (0, $fqGKQ.createCacheHelper)(cache, infiniteKey);
            let previousPageData = null;
            for(let i = 0; i < size; ++i){
                const [pageKey] = (0, $fqGKQ.serialize)(getKey(i, previousPageData));
                const [getCache] = (0, $fqGKQ.createCacheHelper)(cache, pageKey);
                // Get the cached page data.
                const pageData = pageKey ? getCache().data : (0, $fqGKQ.UNDEFINED);
                // Call `mutate` with infinte cache data if we can't get it from the page cache.
                if ((0, $fqGKQ.isUndefined)(pageData)) return mutate(getInfiniteCache().data);
                data.push(pageData);
                previousPageData = pageData;
            }
            return mutate(data);
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache,
            mutate,
            resolvePageSize
        ]);
        // Use getter functions to avoid unnecessary re-renders caused by triggering
        // all the getters of the returned swr object.
        return {
            size: resolvePageSize(),
            setSize: setSize,
            mutate: mutate,
            get data () {
                return swr.data;
            },
            get error () {
                return swr.error;
            },
            get isValidating () {
                return swr.isValidating;
            },
            get isLoading () {
                return swr.isLoading;
            }
        };
    };
const $53269de00902b4d3$export$2e2bcd8739ae039 = (0, $fqGKQ.withMiddleware)((0, $lgZPq.default), $53269de00902b4d3$export$f27219e7b43e81d);

});

parcelRegister("22I3K", function(module, exports) {
typeof navigator !== "undefined" && function(global, factory) {
    module.exports = factory();
}(this, function() {
    "use strict";
    var svgNS = "http://www.w3.org/2000/svg";
    var locationHref = "";
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker(flag) {
        _useWebWorker = !!flag;
    };
    var getWebWorker = function getWebWorker() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref(value) {
        locationHref = value;
    };
    var getLocationHref = function getLocationHref() {
        return locationHref;
    };
    function createTag(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type);
    }
    function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for(i = 0; i < len; i += 1){
            sourcePrototype = sources[i].prototype;
            for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
        }
    }
    function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
    }
    function createProxyFunction(prototype) {
        function ProxyFunction() {}
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController(audioFactory) {
            this.audios = [];
            this.audioFactory = audioFactory;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController.prototype = {
            addAudio: function addAudio(audio) {
                this.audios.push(audio);
            },
            pause: function pause() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].pause();
            },
            resume: function resume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].resume();
            },
            setRate: function setRate(rateValue) {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
            },
            createAudio: function createAudio(assetPath) {
                if (this.audioFactory) return this.audioFactory(assetPath);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play() {
                        this.isPlaying = true;
                    },
                    seek: function seek() {
                        this.isPlaying = false;
                    },
                    playing: function playing() {},
                    rate: function rate() {},
                    setVolume: function setVolume() {}
                };
            },
            setAudioFactory: function setAudioFactory(audioFactory) {
                this.audioFactory = audioFactory;
            },
            setVolume: function setVolume(value) {
                this._volume = value;
                this._updateVolume();
            },
            mute: function mute() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume() {
                return this._volume;
            },
            _updateVolume: function _updateVolume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray(type, len) {
            var i = 0;
            var arr = [];
            var value;
            switch(type){
                case "int16":
                case "uint8c":
                    value = 1;
                    break;
                default:
                    value = 1.1;
                    break;
            }
            for(i = 0; i < len; i += 1)arr.push(value);
            return arr;
        }
        function createTypedArrayFactory(type, len) {
            if (type === "float32") return new Float32Array(len);
            if (type === "int16") return new Int16Array(len);
            if (type === "uint8c") return new Uint8ClampedArray(len);
            return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === "function" && typeof Float32Array === "function") return createTypedArrayFactory;
        return createRegularArray;
    }();
    function createSizedArray(len) {
        return Array.apply(null, {
            length: len
        });
    }
    function _typeof$6(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$6 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$6 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$6(obj);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = "";
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames = [
            "abs",
            "acos",
            "acosh",
            "asin",
            "asinh",
            "atan",
            "atanh",
            "atan2",
            "ceil",
            "cbrt",
            "expm1",
            "clz32",
            "cos",
            "cosh",
            "exp",
            "floor",
            "fround",
            "hypot",
            "imul",
            "log",
            "log1p",
            "log2",
            "log10",
            "max",
            "min",
            "pow",
            "random",
            "round",
            "sign",
            "sin",
            "sinh",
            "sqrt",
            "tan",
            "tanh",
            "trunc",
            "E",
            "LN10",
            "LN2",
            "LOG10E",
            "LOG2E",
            "PI",
            "SQRT1_2",
            "SQRT2"
        ];
        var i;
        var len = propertyNames.length;
        for(i = 0; i < len; i += 1)BMMath[propertyNames[i]] = Math[propertyNames[i]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val) {
        var tOfVal = _typeof$6(val);
        if (tOfVal === "object" && val.length) {
            var absArr = createSizedArray(val.length);
            var i;
            var len = val.length;
            for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
            return absArr;
        }
        return Math.abs(val);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag) {
        _shouldRoundValues = !!flag;
    }
    function bmRnd(value) {
        if (_shouldRoundValues) return Math.round(value);
        return value;
    }
    function styleDiv(element) {
        element.style.position = "absolute";
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = "block";
        element.style.transformOrigin = "0 0";
        element.style.webkitTransformOrigin = "0 0";
        element.style.backfaceVisibility = "visible";
        element.style.webkitBackfaceVisibility = "visible";
        element.style.transformStyle = "preserve-3d";
        element.style.webkitTransformStyle = "preserve-3d";
        element.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
    }
    function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
    }
    function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = "renderFrameError";
        this.nativeError = nativeError;
        this.currentTime = currentTime;
    }
    function BMConfigErrorEvent(nativeError) {
        this.type = "configError";
        this.nativeError = nativeError;
    }
    function BMAnimationConfigErrorEvent(type, nativeError) {
        this.type = type;
        this.nativeError = nativeError;
    }
    var createElementID = function() {
        var _count = 0;
        return function createID() {
            _count += 1;
            return idPrefix$1 + "__lottie_element_" + _count;
        };
    }();
    function HSVtoRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
            default:
                break;
        }
        return [
            r,
            g,
            b
        ];
    }
    function RGBtoHSV(r, g, b) {
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        switch(max){
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
            default:
                break;
        }
        return [
            h,
            s,
            v
        ];
    }
    function addSaturationToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) hsv[1] = 1;
        else if (hsv[1] <= 0) hsv[1] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addBrightnessToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) hsv[2] = 1;
        else if (hsv[2] < 0) hsv[2] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addHueToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) hsv[0] -= 1;
        else if (hsv[0] < 0) hsv[0] += 1;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex;
        for(i = 0; i < 256; i += 1){
            hex = i.toString(16);
            colorMap[i] = hex.length === 1 ? "0" + hex : hex;
        }
        return function(r, g, b) {
            if (r < 0) r = 0;
            if (g < 0) g = 0;
            if (b < 0) b = 0;
            return "#" + colorMap[r] + colorMap[g] + colorMap[b];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled(flag) {
        subframeEnabled = !!flag;
    };
    var getSubframeEnabled = function getSubframeEnabled() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin(value) {
        expressionsPlugin = value;
    };
    var getExpressionsPlugin = function getExpressionsPlugin() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces(value) {
        expressionsInterfaces = value;
    };
    var getExpressionInterfaces = function getExpressionInterfaces() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
        defaultCurveSegments = value;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix(value) {
        idPrefix$1 = value;
    };
    var getIdPrefix = function getIdPrefix() {
        return idPrefix$1;
    };
    function createNS(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type);
    }
    function _typeof$5(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$5 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$5 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$5(obj);
    }
    var dataManager = function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
            onmessage: function onmessage() {},
            postMessage: function postMessage(path) {
                workerFn({
                    data: path
                });
            }
        };
        var _workerSelf = {
            postMessage: function postMessage(data) {
                workerProxy.onmessage({
                    data: data
                });
            }
        };
        function createWorker(fn) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob = new Blob([
                    "var _workerSelf = self; self.onmessage = ",
                    fn.toString()
                ], {
                    type: "text/javascript"
                }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url = URL.createObjectURL(blob);
                return new Worker(url);
            }
            workerFn = fn;
            return workerProxy;
        }
        function setupWorker() {
            if (!workerInstance) {
                workerInstance = createWorker(function workerStart(e) {
                    function dataFunctionManager() {
                        function completeLayers(layers, comps) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if ("ks" in layerData && !layerData.completed) {
                                    layerData.completed = true;
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                                if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData.ty === 0) {
                                        layerData.layers = findCompLayers(layerData.refId, comps);
                                        completeLayers(layerData.layers, comps);
                                    } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                    else if (layerData.ty === 5) completeText(layerData);
                                }
                            }
                        }
                        function completeChars(chars, assets) {
                            if (chars) {
                                var i = 0;
                                var len = chars.length;
                                for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers(chars[i].data.layers, assets);
                                }
                            }
                        }
                        function findComp(id, comps) {
                            var i = 0;
                            var len = comps.length;
                            while(i < len){
                                if (comps[i].id === id) return comps[i];
                                i += 1;
                            }
                            return null;
                        }
                        function findCompLayers(id, comps) {
                            var comp = findComp(id, comps);
                            if (comp) {
                                if (!comp.layers.__used) {
                                    comp.layers.__used = true;
                                    return comp.layers;
                                }
                                return JSON.parse(JSON.stringify(comp.layers));
                            }
                            return null;
                        }
                        function completeShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === "sh") {
                                    if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                            if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                        }
                                    }
                                } else if (arr[i].ty === "gr") completeShapes(arr[i].it);
                            }
                        }
                        function convertPathsToAbsoluteValues(path) {
                            var i;
                            var len = path.i.length;
                            for(i = 0; i < len; i += 1){
                                path.i[i][0] += path.v[i][0];
                                path.i[i][1] += path.v[i][1];
                                path.o[i][0] += path.v[i][0];
                                path.o[i][1] += path.v[i][1];
                            }
                        }
                        function checkVersion(minimum, animVersionString) {
                            var animVersion = animVersionString ? animVersionString.split(".") : [
                                100,
                                100,
                                100
                            ];
                            if (minimum[0] > animVersion[0]) return true;
                            if (animVersion[0] > minimum[0]) return false;
                            if (minimum[1] > animVersion[1]) return true;
                            if (animVersion[1] > minimum[1]) return false;
                            if (minimum[2] > animVersion[2]) return true;
                            if (animVersion[2] > minimum[2]) return false;
                            return null;
                        }
                        var checkText = function() {
                            var minimumVersion = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer(textLayer) {
                                var documentData = textLayer.t.d;
                                textLayer.t.d = {
                                    k: [
                                        {
                                            s: documentData,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars = function() {
                            var minimumVersion = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData) {
                                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                    var i;
                                    var len = animationData.chars.length;
                                    for(i = 0; i < len; i += 1){
                                        var charData = animationData.chars[i];
                                        if (charData.data && charData.data.shapes) {
                                            completeShapes(charData.data.shapes);
                                            charData.data.ip = 0;
                                            charData.data.op = 99999;
                                            charData.data.st = 0;
                                            charData.data.sr = 1;
                                            charData.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData.chars[i].t) {
                                                charData.data.shapes.push({
                                                    ty: "no"
                                                });
                                                charData.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: "tr"
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties = function() {
                            var minimumVersion = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer(textLayer) {
                                var pathData = textLayer.t.p;
                                if (typeof pathData.a === "number") pathData.a = {
                                    a: 0,
                                    k: pathData.a
                                };
                                if (typeof pathData.p === "number") pathData.p = {
                                    a: 0,
                                    k: pathData.p
                                };
                                if (typeof pathData.r === "number") pathData.r = {
                                    a: 0,
                                    k: pathData.r
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors = function() {
                            var minimumVersion = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes(shapes) {
                                var i;
                                var len = shapes.length;
                                var j;
                                var jLen;
                                for(i = 0; i < len; i += 1){
                                    if (shapes[i].ty === "gr") iterateShapes(shapes[i].it);
                                    else if (shapes[i].ty === "fl" || shapes[i].ty === "st") {
                                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                            jLen = shapes[i].c.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (shapes[i].c.k[j].s) {
                                                    shapes[i].c.k[j].s[0] /= 255;
                                                    shapes[i].c.k[j].s[1] /= 255;
                                                    shapes[i].c.k[j].s[2] /= 255;
                                                    shapes[i].c.k[j].s[3] /= 255;
                                                }
                                                if (shapes[i].c.k[j].e) {
                                                    shapes[i].c.k[j].e[0] /= 255;
                                                    shapes[i].c.k[j].e[1] /= 255;
                                                    shapes[i].c.k[j].e[2] /= 255;
                                                    shapes[i].c.k[j].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes[i].c.k[0] /= 255;
                                            shapes[i].c.k[1] /= 255;
                                            shapes[i].c.k[2] /= 255;
                                            shapes[i].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes = function() {
                            var minimumVersion = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes(arr) {
                                var i;
                                var len = arr.length;
                                var j;
                                var jLen;
                                for(i = len - 1; i >= 0; i -= 1){
                                    if (arr[i].ty === "sh") {
                                        if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                        else {
                                            jLen = arr[i].ks.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                                if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                            }
                                        }
                                    } else if (arr[i].ty === "gr") completeClosingShapes(arr[i].it);
                                }
                            }
                            function iterateLayers(layers) {
                                var layerData;
                                var i;
                                var len = layers.length;
                                var j;
                                var jLen;
                                var k;
                                var kLen;
                                for(i = 0; i < len; i += 1){
                                    layerData = layers[i];
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                                if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                            }
                                        }
                                    }
                                    if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                                }
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        function completeData(animationData) {
                            if (animationData.__complete) return;
                            checkColors(animationData);
                            checkText(animationData);
                            checkChars(animationData);
                            checkPathProperties(animationData);
                            checkShapes(animationData);
                            completeLayers(animationData.layers, animationData.assets);
                            completeChars(animationData.chars, animationData.assets);
                            animationData.__complete = true;
                        }
                        function completeText(data) {
                            data.t.a.length === 0 && data.t.p;
                        }
                        var moduleOb = {};
                        moduleOb.completeData = completeData;
                        moduleOb.checkColors = checkColors;
                        moduleOb.checkChars = checkChars;
                        moduleOb.checkPathProperties = checkPathProperties;
                        moduleOb.checkShapes = checkShapes;
                        moduleOb.completeLayers = completeLayers;
                        return moduleOb;
                    }
                    if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                    if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                        function formatResponse(xhr) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader = xhr.getResponseHeader("content-type");
                            if (contentTypeHeader && xhr.responseType === "json" && contentTypeHeader.indexOf("json") !== -1) return xhr.response;
                            if (xhr.response && _typeof$5(xhr.response) === "object") return xhr.response;
                            if (xhr.response && typeof xhr.response === "string") return JSON.parse(xhr.response);
                            if (xhr.responseText) return JSON.parse(xhr.responseText);
                            return null;
                        }
                        function loadAsset(path, fullPath, callback, errorCallback) {
                            var response;
                            var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr.responseType = "json";
                            } catch (err) {} // eslint-disable-line no-empty
                            xhr.onreadystatechange = function() {
                                if (xhr.readyState === 4) {
                                    if (xhr.status === 200) {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } else try {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } catch (err) {
                                        if (errorCallback) errorCallback(err);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr.open([
                                    "G",
                                    "E",
                                    "T"
                                ].join(""), path, true);
                            } catch (error) {
                                // Hack to workaround banner validation
                                xhr.open([
                                    "G",
                                    "E",
                                    "T"
                                ].join(""), fullPath + "/" + path, true);
                            }
                            xhr.send();
                        }
                        return {
                            load: loadAsset
                        };
                    }();
                    if (e.data.type === "loadAnimation") _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.dataManager.completeData(data);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: "error"
                        });
                    });
                    else if (e.data.type === "complete") {
                        var animation = e.data.animation;
                        _workerSelf.dataManager.completeData(animation);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: animation,
                            status: "success"
                        });
                    } else if (e.data.type === "loadData") _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: "error"
                        });
                    });
                });
                workerInstance.onmessage = function(event) {
                    var data = event.data;
                    var id = data.id;
                    var process = processes[id];
                    processes[id] = null;
                    if (data.status === "success") process.onComplete(data.payload);
                    else if (process.onError) process.onError();
                };
            }
        }
        function createProcess(onComplete, onError) {
            _counterId += 1;
            var id = "processId_" + _counterId;
            processes[id] = {
                onComplete: onComplete,
                onError: onError
            };
            return id;
        }
        function loadAnimation(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: "loadAnimation",
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function loadData(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: "loadData",
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function completeAnimation(anim, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: "complete",
                animation: anim,
                id: processId
            });
        }
        return {
            loadAnimation: loadAnimation,
            loadData: loadData,
            completeAnimation: completeAnimation
        };
    }();
    var ImagePreloader = function() {
        var proxyImage = function() {
            var canvas = createTag("canvas");
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext("2d");
            ctx.fillStyle = "rgba(0,0,0,0)";
            ctx.fillRect(0, 0, 1, 1);
            return canvas;
        }();
        function imageLoaded() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
            var path = "";
            if (assetData.e) path = assetData.p;
            else if (assetsPath) {
                var imagePath = assetData.p;
                if (imagePath.indexOf("images/") !== -1) imagePath = imagePath.split("/")[1];
                path = assetsPath + imagePath;
            } else {
                path = originalPath;
                path += assetData.u ? assetData.u : "";
                path += assetData.p;
            }
            return path;
        }
        function testImageLoaded(img) {
            var _count = 0;
            var intervalId = setInterval((function() {
                var box = img.getBBox();
                if (box.width || _count > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId);
                }
                _count += 1;
            }).bind(this), 50);
        }
        function createImageData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createNS("image");
            if (isSafari) this.testImageLoaded(img);
            else img.addEventListener("load", this._imageLoaded, false);
            img.addEventListener("error", (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.setAttributeNS("http://www.w3.org/1999/xlink", "href", path);
            if (this._elementHelper.append) this._elementHelper.append(img);
            else this._elementHelper.appendChild(img);
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createImgData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createTag("img");
            img.crossOrigin = "anonymous";
            img.addEventListener("load", this._imageLoaded, false);
            img.addEventListener("error", (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.src = path;
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createFootageData(data) {
            var ob = {
                assetData: data
            };
            var path = getAssetsPath(data, this.assetsPath, this.path);
            dataManager.loadData(path, (function(footageData) {
                ob.img = footageData;
                this._footageLoaded();
            }).bind(this), (function() {
                ob.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob;
        }
        function loadAssets(assets, cb) {
            this.imagesLoadedCb = cb;
            var i;
            var len = assets.length;
            for(i = 0; i < len; i += 1)if (!assets[i].layers) {
                if (!assets[i].t || assets[i].t === "seq") {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets[i]));
                } else if (assets[i].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets[i]));
                }
            }
        }
        function setPath(path) {
            this.path = path || "";
        }
        function setAssetsPath(path) {
            this.assetsPath = path || "";
        }
        function getAsset(assetData) {
            var i = 0;
            var len = this.images.length;
            while(i < len){
                if (this.images[i].assetData === assetData) return this.images[i].img;
                i += 1;
            }
            return null;
        }
        function destroy() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
            if (type === "svg") {
                this._elementHelper = elementHelper;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory() {
            this._imageLoaded = imageLoaded.bind(this);
            this._footageLoaded = footageLoaded.bind(this);
            this.testImageLoaded = testImageLoaded.bind(this);
            this.createFootageData = createFootageData.bind(this);
            this.assetsPath = "";
            this.path = "";
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory.prototype = {
            loadAssets: loadAssets,
            setAssetsPath: setAssetsPath,
            setPath: setPath,
            loadedImages: loadedImages,
            loadedFootages: loadedFootages,
            destroy: destroy,
            getAsset: getAsset,
            createImgData: createImgData,
            createImageData: createImageData,
            imageLoaded: imageLoaded,
            footageLoaded: footageLoaded,
            setCacheType: setCacheType
        };
        return ImagePreloaderFactory;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
            if (this._cbs[eventName]) {
                var callbacks = this._cbs[eventName];
                for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
            }
        },
        addEventListener: function addEventListener(eventName, callback) {
            if (!this._cbs[eventName]) this._cbs[eventName] = [];
            this._cbs[eventName].push(callback);
            return (function() {
                this.removeEventListener(eventName, callback);
            }).bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
            if (!callback) this._cbs[eventName] = null;
            else if (this._cbs[eventName]) {
                var i = 0;
                var len = this._cbs[eventName].length;
                while(i < len){
                    if (this._cbs[eventName][i] === callback) {
                        this._cbs[eventName].splice(i, 1);
                        i -= 1;
                        len -= 1;
                    }
                    i += 1;
                }
                if (!this._cbs[eventName].length) this._cbs[eventName] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines(payload) {
            var lines = payload.split("\r\n");
            var keys = {};
            var line;
            var keysCount = 0;
            for(var i = 0; i < lines.length; i += 1){
                line = lines[i].split(":");
                if (line.length === 2) {
                    keys[line[0]] = line[1].trim();
                    keysCount += 1;
                }
            }
            if (keysCount === 0) throw new Error();
            return keys;
        }
        return function(_markers) {
            var markers = [];
            for(var i = 0; i < _markers.length; i += 1){
                var _marker = _markers[i];
                var markerData = {
                    time: _marker.tm,
                    duration: _marker.dr
                };
                try {
                    markerData.payload = JSON.parse(_markers[i].cm);
                } catch (_) {
                    try {
                        markerData.payload = parsePayloadLines(_markers[i].cm);
                    } catch (__) {
                        markerData.payload = {
                            name: _markers[i].cm
                        };
                    }
                }
                markers.push(markerData);
            }
            return markers;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition(comp) {
            this.compositions.push(comp);
        }
        return function() {
            function _thisProjectFunction(name) {
                var i = 0;
                var len = this.compositions.length;
                while(i < len){
                    if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                        if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                        return this.compositions[i].compInterface;
                    }
                    i += 1;
                }
                return null;
            }
            _thisProjectFunction.compositions = [];
            _thisProjectFunction.currentFrame = 0;
            _thisProjectFunction.registerComposition = registerComposition;
            return _thisProjectFunction;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer(key, value) {
        renderers[key] = value;
    };
    function getRenderer(key) {
        return renderers[key];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return "canvas";
         // Returns any renderer that is registered
        for(var key in renderers){
            if (renderers[key]) return key;
        }
        return "";
    }
    function _typeof$4(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$4 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$4 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$4(obj);
    }
    var AnimationItem = function AnimationItem() {
        this._cbs = [];
        this.name = "";
        this.path = "";
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = "";
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
        var animType = "svg";
        if (params.animType) animType = params.animType;
        else if (params.renderer) animType = params.renderer;
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === "" || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
        else if (params.loop === false) this.loop = false;
        else this.loop = parseInt(params.loop, 10);
        this.autoplay = "autoplay" in params ? params.autoplay : true;
        this.name = params.name ? params.name : "";
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, "autoloadSegments") ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
        if (params.animationData) this.setupAnimation(params.animationData);
        else if (params.path) {
            if (params.path.lastIndexOf("\\") !== -1) this.path = params.path.substr(0, params.path.lastIndexOf("\\") + 1);
            else this.path = params.path.substr(0, params.path.lastIndexOf("/") + 1);
            this.fileName = params.path.substr(params.path.lastIndexOf("/") + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json"));
            dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger("data_failed");
    };
    AnimationItem.prototype.setupAnimation = function(data) {
        dataManager.completeAnimation(data, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper, animationData) {
        if (animationData) {
            if (_typeof$4(animationData) !== "object") animationData = JSON.parse(animationData);
        }
        var params = {
            wrapper: wrapper,
            animationData: animationData
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem("data-animation-path") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-animation-path").value : wrapperAttributes.getNamedItem("data-bm-path") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-path").value : wrapperAttributes.getNamedItem("bm-path") ? wrapperAttributes.getNamedItem("bm-path").value : "";
        params.animType = wrapperAttributes.getNamedItem("data-anim-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-anim-type").value : wrapperAttributes.getNamedItem("data-bm-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-type").value : wrapperAttributes.getNamedItem("bm-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("bm-type").value : wrapperAttributes.getNamedItem("data-bm-renderer") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-renderer").value : wrapperAttributes.getNamedItem("bm-renderer") ? wrapperAttributes.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
        var loop = wrapperAttributes.getNamedItem("data-anim-loop") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-anim-loop").value : wrapperAttributes.getNamedItem("data-bm-loop") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-loop").value : wrapperAttributes.getNamedItem("bm-loop") ? wrapperAttributes.getNamedItem("bm-loop").value : "";
        if (loop === "false") params.loop = false;
        else if (loop === "true") params.loop = true;
        else if (loop !== "") params.loop = parseInt(loop, 10);
        var autoplay = wrapperAttributes.getNamedItem("data-anim-autoplay") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-anim-autoplay").value : wrapperAttributes.getNamedItem("data-bm-autoplay") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-autoplay").value : wrapperAttributes.getNamedItem("bm-autoplay") ? wrapperAttributes.getNamedItem("bm-autoplay").value : true;
        params.autoplay = autoplay !== "false";
        params.name = wrapperAttributes.getNamedItem("data-name") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-name").value : wrapperAttributes.getNamedItem("data-bm-name") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-name").value : wrapperAttributes.getNamedItem("bm-name") ? wrapperAttributes.getNamedItem("bm-name").value : "";
        var prerender = wrapperAttributes.getNamedItem("data-anim-prerender") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-anim-prerender").value : wrapperAttributes.getNamedItem("data-bm-prerender") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-prerender").value : wrapperAttributes.getNamedItem("bm-prerender") ? wrapperAttributes.getNamedItem("bm-prerender").value : "";
        if (prerender === "false") params.prerender = false;
        if (!params.path) this.trigger("destroy");
        else this.setParams(params);
    };
    AnimationItem.prototype.includeLayers = function(data) {
        if (data.op > this.animationData.op) {
            this.animationData.op = data.op;
            this.totalFrames = Math.floor(data.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data.layers;
        var j;
        var jLen = newLayers.length;
        for(j = 0; j < jLen; j += 1){
            i = 0;
            while(i < len){
                if (layers[i].id === newLayers[j].id) {
                    layers[i] = newLayers[j];
                    break;
                }
                i += 1;
            }
        }
        if (data.chars || data.fonts) {
            this.renderer.globalData.fontManager.addChars(data.chars);
            this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
        }
        if (data.assets) {
            len = data.assets.length;
            for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data) {
        this.animationData = data;
        var expressionsPlugin = getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
            this.trigger("data_ready");
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + "_" + this.segmentPos + ".json";
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
            this.trigger("data_failed");
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger("loaded_images");
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) return;
        try {
            this.animationData = animData;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData);
            if (!animData.assets) animData.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData.assets);
            this.markers = markerParser(animData.markers || []);
            this.trigger("config_ready");
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error) {
            this.triggerConfigError(error);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin = getExpressionsPlugin();
            if (expressionsPlugin) expressionsPlugin.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger("DOMLoaded");
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width, height) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width = typeof width === "number" ? width : undefined;
        var _height = typeof height === "number" ? height : undefined;
        this.renderer.updateContainerSize(_width, _height);
    };
    AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger("enterFrame");
        this.renderFrame();
        this.trigger("drawnFrame");
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
            this.triggerRenderFrameError(error);
        }
    };
    AnimationItem.prototype.play = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger("_play");
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger("_active");
            }
        }
    };
    AnimationItem.prototype.pause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger("_pause");
            this._idle = true;
            this.trigger("_idle");
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name) {
        if (name && this.name !== name) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for(var i = 0; i < this.markers.length; i += 1){
            marker = this.markers[i];
            if (marker.payload && marker.payload.name === markerName) return marker;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) this.goToAndStop(marker.time, true);
        } else if (isFrame) this.setCurrentRawFrameValue(value);
        else this.setCurrentRawFrameValue(value * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) {
                if (!marker.duration) this.goToAndStop(marker.time, true);
                else this.playSegments([
                    marker.time,
                    marker.time + marker.duration
                ], true);
            }
        } else this.goToAndStop(numValue, isFrame, name);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue = this.currentRawFrame + value * this.frameModifier;
        var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                    _isComplete = true;
                    nextValue = this.totalFrames - 1;
                }
            } else if (nextValue >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger("loopComplete");
                }
            } else this.setCurrentRawFrameValue(nextValue);
        } else if (nextValue < 0) {
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger("loopComplete");
                } else {
                    _isComplete = true;
                    nextValue = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue);
        if (_isComplete) {
            this.setCurrentRawFrameValue(nextValue);
            this.pause();
            this.trigger("complete");
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr[0] - arr[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
        } else if (arr[1] > arr[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr[1] - arr[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[0];
            this.setCurrentRawFrameValue(0.001 + offset);
        }
        this.trigger("segmentStart");
    };
    AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
            else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
    };
    AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) this.segments.length = 0;
        if (_typeof$4(arr[0]) === "object") {
            var i;
            var len = arr.length;
            for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
        } else this.segments.push(arr);
        if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name) {
        if (name && this.name !== name || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger("destroy");
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
        this.currentRawFrame = value;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val) {
        this.playSpeed = val;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val) {
        this.playDirection = val < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping) {
        this.loop = isLooping;
    };
    AnimationItem.prototype.setVolume = function(val, name) {
        if (name && this.name !== name) return;
        this.audioController.setVolume(val);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path = "";
        if (assetData.e) path = assetData.p;
        else if (this.assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf("images/") !== -1) imagePath = imagePath.split("/")[1];
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : "";
            path += assetData.p;
        }
        return path;
    };
    AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while(i < len){
            if (id === this.assets[i].id) return this.assets[i];
            i += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
        try {
            var element = this.renderer.getElementByPath(path);
            element.updateDocumentData(documentData, index);
        } catch (error) {}
    };
    AnimationItem.prototype.trigger = function(name) {
        if (this._cbs && this._cbs[name]) switch(name){
            case "enterFrame":
                this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case "drawnFrame":
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name, this.drawnFrameEvent);
                break;
            case "loopComplete":
                this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
                break;
            case "complete":
                this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
                break;
            case "segmentStart":
                this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
                break;
            case "destroy":
                this.triggerEvent(name, new BMDestroyEvent(name, this));
                break;
            default:
                this.triggerEvent(name);
        }
        if (name === "enterFrame" && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
        if (name === "loopComplete" && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        if (name === "complete" && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
        if (name === "segmentStart" && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        if (name === "destroy" && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent("error", error);
        if (this.onError) this.onError.call(this, error);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent("error", error);
        if (this.onError) this.onError.call(this, error);
    };
    var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
            var i = 0;
            var animItem = ev.target;
            while(i < len){
                if (registeredAnimations[i].animation === animItem) {
                    registeredAnimations.splice(i, 1);
                    i -= 1;
                    len -= 1;
                    if (!animItem.isPaused) subtractPlayingCount();
                }
                i += 1;
            }
        }
        function registerAnimation(element, animationData) {
            if (!element) return null;
            var i = 0;
            while(i < len){
                if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
                i += 1;
            }
            var animItem = new AnimationItem();
            setupAnimation(animItem, element);
            animItem.setData(element, animationData);
            return animItem;
        }
        function getRegisteredAnimations() {
            var i;
            var lenAnims = registeredAnimations.length;
            var animations = [];
            for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
            return animations;
        }
        function addPlayingCount() {
            playingAnimationsNum += 1;
            activate();
        }
        function subtractPlayingCount() {
            playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
            animItem.addEventListener("destroy", removeElement);
            animItem.addEventListener("_active", addPlayingCount);
            animItem.addEventListener("_idle", subtractPlayingCount);
            registeredAnimations.push({
                elem: element,
                animation: animItem
            });
            len += 1;
        }
        function loadAnimation(params) {
            var animItem = new AnimationItem();
            setupAnimation(animItem, null);
            animItem.setParams(params);
            return animItem;
        }
        function setSpeed(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
        }
        function setDirection(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
        }
        function play(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
        }
        function resume(nowTime) {
            var elapsedTime = nowTime - initTime;
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
            initTime = nowTime;
            if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
            else _stopped = true;
        }
        function first(nowTime) {
            initTime = nowTime;
            window.requestAnimationFrame(resume);
        }
        function pause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
        }
        function goToAndStop(value, isFrame, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
        }
        function stop(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
        }
        function togglePause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
        }
        function destroy(animation) {
            var i;
            for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
        }
        function searchAnimations(animationData, standalone, renderer) {
            var animElements = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin")));
            var i;
            var lenAnims = animElements.length;
            for(i = 0; i < lenAnims; i += 1){
                if (renderer) animElements[i].setAttribute("data-bm-type", renderer);
                registerAnimation(animElements[i], animationData);
            }
            if (standalone && lenAnims === 0) {
                if (!renderer) renderer = "svg";
                var body = document.getElementsByTagName("body")[0];
                body.innerText = "";
                var div = createTag("div");
                div.style.width = "100%";
                div.style.height = "100%";
                div.setAttribute("data-bm-type", renderer);
                body.appendChild(div);
                registerAnimation(div, animationData);
            }
        }
        function resize() {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
        }
        function activate() {
            if (!_isFrozen && playingAnimationsNum) {
                if (_stopped) {
                    window.requestAnimationFrame(first);
                    _stopped = false;
                }
            }
        }
        function freeze() {
            _isFrozen = true;
        }
        function unfreeze() {
            _isFrozen = false;
            activate();
        }
        function setVolume(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
        }
        function mute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
        }
        function unmute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations;
        moduleOb.resize = resize; // moduleOb.start = start;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob = {};
        ob.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a, b, c, d, nm) {
            var str = nm || ("bez_" + a + "_" + b + "_" + c + "_" + d).replace(/\./g, "p");
            if (beziers[str]) return beziers[str];
            var bezEasing = new BezierEasing([
                a,
                b,
                c,
                d
            ]);
            beziers[str] = bezEasing;
            return bezEasing;
        } // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var float32ArraySupported = typeof Float32Array === "function";
        function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
            return 3.0 * aA1;
        } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX, currentT, i = 0;
            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) aB = currentT;
                else aA = currentT;
            }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) return aGuessT;
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing(points) {
            this._p = points;
            this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
            get: function get(x) {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX1 === mY1 && mX2 === mY2) return x; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x === 0) return 0;
                if (x === 1) return 1;
                return calcBezier(this._getTForX(x), mY1, mY2);
            },
            // Private part
            _precompute: function _precompute() {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                this._precomputed = true;
                if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues() {
                var mX1 = this._p[0], mX2 = this._p[2];
                for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX(aX) {
                var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                --currentSample; // Interpolate to provide an initial guess for t
                var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                if (initialSlope === 0.0) return guessForT;
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        };
        return ob;
    }();
    var pooling = function() {
        function _double(arr) {
            return arr.concat(createSizedArray(arr.length));
        }
        return {
            "double": _double
        };
    }();
    var poolFactory = function() {
        return function(initialLength, _create, _release) {
            var _length = 0;
            var _maxLength = initialLength;
            var pool = createSizedArray(_maxLength);
            var ob = {
                newElement: newElement,
                release: release
            };
            function newElement() {
                var element;
                if (_length) {
                    _length -= 1;
                    element = pool[_length];
                } else element = _create();
                return element;
            }
            function release(element) {
                if (_length === _maxLength) {
                    pool = pooling["double"](pool);
                    _maxLength *= 2;
                }
                if (_release) _release(element);
                pool[_length] = element;
                _length += 1;
            }
            return ob;
        };
    }();
    var bezierLengthPool = function() {
        function create() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create);
    }();
    var segmentsLengthPool = function() {
        function create() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release(element) {
            var i;
            var len = element.lengths.length;
            for(i = 0; i < len; i += 1)bezierLengthPool.release(element.lengths[i]);
            element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
    }();
    function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
            var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
            return det1 > -0.001 && det1 < 0.001;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
            if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
            var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
            var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
            var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
            var diffDist;
            if (dist1 > dist2) {
                if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
                else diffDist = dist3 - dist2 - dist1;
            } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
            else diffDist = dist2 - dist1 - dist3;
            return diffDist > -0.0001 && diffDist < 0.0001;
        }
        var getBezierLength = function() {
            return function(pt1, pt2, pt3, pt4) {
                var curveSegments = getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point = [];
                var lastPoint = [];
                var lengthData = bezierLengthPool.newElement();
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint[i] !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        lastPoint[i] = point[i];
                    }
                    if (ptDistance) {
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                    }
                    lengthData.percents[k] = perc;
                    lengthData.lengths[k] = addedLength;
                }
                lengthData.addedLength = addedLength;
                return lengthData;
            };
        }();
        function getSegmentsLength(shapeData) {
            var segmentsLength = segmentsLengthPool.newElement();
            var closed = shapeData.c;
            var pathV = shapeData.v;
            var pathO = shapeData.o;
            var pathI = shapeData.i;
            var i;
            var len = shapeData._length;
            var lengths = segmentsLength.lengths;
            var totalLength = 0;
            for(i = 0; i < len - 1; i += 1){
                lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
                totalLength += lengths[i].addedLength;
            }
            if (closed && len) {
                lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
                totalLength += lengths[i].addedLength;
            }
            segmentsLength.totalLength = totalLength;
            return segmentsLength;
        }
        function BezierData(length) {
            this.segmentLength = 0;
            this.points = new Array(length);
        }
        function PointData(partial, point) {
            this.partialLength = partial;
            this.point = point;
        }
        var buildBezierData = function() {
            var storedData = {};
            return function(pt1, pt2, pt3, pt4) {
                var bezierName = (pt1[0] + "_" + pt1[1] + "_" + pt2[0] + "_" + pt2[1] + "_" + pt3[0] + "_" + pt3[1] + "_" + pt4[0] + "_" + pt4[1]).replace(/\./g, "p");
                if (!storedData[bezierName]) {
                    var curveSegments = getDefaultCurveSegments();
                    var k;
                    var i;
                    var len;
                    var ptCoord;
                    var perc;
                    var addedLength = 0;
                    var ptDistance;
                    var point;
                    var lastPoint = null;
                    if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                    var bezierData = new BezierData(curveSegments);
                    len = pt3.length;
                    for(k = 0; k < curveSegments; k += 1){
                        point = createSizedArray(len);
                        perc = k / (curveSegments - 1);
                        ptDistance = 0;
                        for(i = 0; i < len; i += 1){
                            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                            point[i] = ptCoord;
                            if (lastPoint !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        }
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                        bezierData.points[k] = new PointData(ptDistance, point);
                        lastPoint = point;
                    }
                    bezierData.segmentLength = addedLength;
                    storedData[bezierName] = bezierData;
                }
                return storedData[bezierName];
            };
        }();
        function getDistancePerc(perc, bezierData) {
            var percents = bezierData.percents;
            var lengths = bezierData.lengths;
            var len = percents.length;
            var initPos = bmFloor((len - 1) * perc);
            var lengthPos = perc * bezierData.addedLength;
            var lPerc = 0;
            if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
            var dir = lengths[initPos] > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                    flag = false;
                } else initPos += dir;
                if (initPos < 0 || initPos >= len - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos === len - 1) return percents[initPos];
                    flag = false;
                }
            }
            return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
            var t1 = getDistancePerc(percent, bezierData);
            var u1 = 1 - t1;
            var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
            var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
            return [
                ptX,
                ptY
            ];
        }
        var bezierSegmentPoints = createTypedArray("float32", 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
            if (startPerc < 0) startPerc = 0;
            else if (startPerc > 1) startPerc = 1;
            var t0 = getDistancePerc(startPerc, bezierData);
            endPerc = endPerc > 1 ? 1 : endPerc;
            var t1 = getDistancePerc(endPerc, bezierData);
            var i;
            var len = pt1.length;
            var u0 = 1 - t0;
            var u1 = 1 - t1;
            var u0u0u0 = u0 * u0 * u0;
            var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0t0 = t0 * t0 * t0; //
            var u0u0u1 = u0 * u0 * u1;
            var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0t1 = t0 * t0 * t1; //
            var u0u1u1 = u0 * u1 * u1;
            var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1t1 = t0 * t1 * t1; //
            var u1u1u1 = u1 * u1 * u1;
            var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1t1 = t1 * t1 * t1;
            for(i = 0; i < len; i += 1){
                bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints;
        }
        return {
            getSegmentsLength: getSegmentsLength,
            getNewSegment: getNewSegment,
            getPointInSegment: getPointInSegment,
            buildBezierData: buildBezierData,
            pointOnLine2D: pointOnLine2D,
            pointOnLine3D: pointOnLine3D
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum, caching) {
        var offsetTime = this.offsetTime;
        var newValue;
        if (this.propType === "multidimensional") newValue = createTypedArray("float32", this.pv.length);
        var iterationIndex = caching.lastIndex;
        var i = iterationIndex;
        var len = this.keyframes.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i + 1];
            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
                if (keyData.h) keyData = nextKeyData;
                iterationIndex = 0;
                break;
            }
            if (nextKeyData.t - offsetTime > frameNum) {
                iterationIndex = i;
                break;
            }
            if (i < len - 1) i += 1;
            else {
                iterationIndex = 0;
                flag = false;
            }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        var k;
        var kLen;
        var perc;
        var jLen;
        var j;
        var fnc;
        var nextKeyTime = nextKeyData.t - offsetTime;
        var keyTime = keyData.t - offsetTime;
        var endValue;
        if (keyData.to) {
            if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
            var bezierData = keyframeMetadata.bezierData;
            if (frameNum >= nextKeyTime || frameNum < keyTime) {
                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
                 // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                else {
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyframeMetadata.__fnct = fnc;
                }
                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                var distanceInLine = bezierData.segmentLength * perc;
                var segmentPerc;
                var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
                j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
                flag = true;
                jLen = bezierData.points.length;
                while(flag){
                    addedLength += bezierData.points[j].partialLength;
                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        break;
                    }
                    if (j < jLen - 1) j += 1;
                    else flag = false;
                }
                caching._lastPoint = j;
                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                caching._lastKeyframeIndex = i;
            }
        } else {
            var outX;
            var outY;
            var inX;
            var inY;
            var keyValue;
            len = keyData.s.length;
            endValue = nextKeyData.s || keyData.e;
            if (this.sh && keyData.h !== 1) {
                if (frameNum >= nextKeyTime) {
                    newValue[0] = endValue[0];
                    newValue[1] = endValue[1];
                    newValue[2] = endValue[2];
                } else if (frameNum <= keyTime) {
                    newValue[0] = keyData.s[0];
                    newValue[1] = keyData.s[1];
                    newValue[2] = keyData.s[2];
                } else {
                    var quatStart = createQuaternion(keyData.s);
                    var quatEnd = createQuaternion(endValue);
                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
                }
            } else for(i = 0; i < len; i += 1){
                if (keyData.h !== 1) {
                    if (frameNum >= nextKeyTime) perc = 1;
                    else if (frameNum < keyTime) perc = 0;
                    else {
                        if (keyData.o.x.constructor === Array) {
                            if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                            if (!keyframeMetadata.__fnct[i]) {
                                outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                                outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                                inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                                inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                keyframeMetadata.__fnct[i] = fnc;
                            } else fnc = keyframeMetadata.__fnct[i];
                        } else if (!keyframeMetadata.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                            fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                            keyData.keyframeMetadata = fnc;
                        } else fnc = keyframeMetadata.__fnct;
                        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                    }
                }
                endValue = nextKeyData.s || keyData.e;
                keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
                if (this.propType === "multidimensional") newValue[i] = keyValue;
                else newValue = keyValue;
            }
        }
        caching.lastIndex = iterationIndex;
        return newValue;
    } // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a, b, t) {
        var out = [];
        var ax = a[0];
        var ay = a[1];
        var az = a[2];
        var aw = a[3];
        var bx = b[0];
        var by = b[1];
        var bz = b[2];
        var bw = b[3];
        var omega;
        var cosom;
        var sinom;
        var scale0;
        var scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        if (1.0 - cosom > 0.000001) {
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        } else {
            scale0 = 1.0 - t;
            scale1 = t;
        }
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
    }
    function quaternionToEuler(out, quat) {
        var qx = quat[0];
        var qy = quat[1];
        var qz = quat[2];
        var qw = quat[3];
        var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
        var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
        var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
        out[0] = heading / degToRads;
        out[1] = attitude / degToRads;
        out[2] = bank / degToRads;
    }
    function createQuaternion(values) {
        var heading = values[0] * degToRads;
        var attitude = values[1] * degToRads;
        var bank = values[2] * degToRads;
        var c1 = Math.cos(heading / 2);
        var c2 = Math.cos(attitude / 2);
        var c3 = Math.cos(bank / 2);
        var s1 = Math.sin(heading / 2);
        var s2 = Math.sin(attitude / 2);
        var s3 = Math.sin(bank / 2);
        var w = c1 * c2 * c3 - s1 * s2 * s3;
        var x = s1 * s2 * c3 + c1 * c2 * s3;
        var y = s1 * c2 * c3 + c1 * s2 * s3;
        var z = c1 * s2 * c3 - s1 * c2 * s3;
        return [
            x,
            y,
            z,
            w
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
            if (this._caching.lastFrame >= frameNum) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult = this.interpolateValue(frameNum, this._caching);
            this.pv = renderResult;
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
    }
    function setVValue(val) {
        var multipliedValue;
        if (this.propType === "unidimensional") {
            multipliedValue = val * this.mult;
            if (mathAbs(this.v - multipliedValue) > 0.00001) {
                this.v = multipliedValue;
                this._mdf = true;
            }
        } else {
            var i = 0;
            var len = this.v.length;
            while(i < len){
                multipliedValue = val[i] * this.mult;
                if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                    this.v[i] = multipliedValue;
                    this._mdf = true;
                }
                i += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = this.kf ? this.pv : this.data.k;
        for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
        this.setVValue(finalValue);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem, data, mult, container) {
        this.propType = "unidimensional";
        this.mult = mult || 1;
        this.data = data;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem, data, mult, container) {
        this.propType = "multidimensional";
        this.mult = mult || 1;
        this.data = data;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i;
        var len = data.k.length;
        this.v = createTypedArray("float32", len);
        this.pv = createTypedArray("float32", len);
        this.vel = createTypedArray("float32", len);
        for(i = 0; i < len; i += 1){
            this.v[i] = data.k[i] * this.mult;
            this.pv[i] = data.k[i];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem, data, mult, container) {
        this.propType = "unidimensional";
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem, data, mult, container) {
        this.propType = "multidimensional";
        var i;
        var len = data.k.length;
        var s;
        var e;
        var to;
        var ti;
        for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
            s = data.k[i].s;
            e = data.k[i + 1].s;
            to = data.k[i].to;
            ti = data.k[i].ti;
            if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
                data.k[i].to = null;
                data.k[i].ti = null;
            }
            if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
                if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data;
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen = data.k[0].s.length;
        this.v = createTypedArray("float32", arrLen);
        this.pv = createTypedArray("float32", arrLen);
        for(i = 0; i < arrLen; i += 1){
            this.v[i] = initFrame;
            this.pv[i] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray("float32", arrLen)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp(elem, data, type, mult, container) {
            if (data.sid) data = elem.globalData.slotManager.getProp(data);
            var p;
            if (!data.k.length) p = new ValueProperty(elem, data, mult, container);
            else if (typeof data.k[0] === "number") p = new MultiDimensionalProperty(elem, data, mult, container);
            else switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem, data, mult, container);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
                    break;
                default:
                    break;
            }
            if (p.effectsSequence.length) container.addDynamicProperty(p);
            return p;
        }
        var ob = {
            getProp: getProp
        };
        return ob;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) {
                this.dynamicProperties.push(prop);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
            this._mdf = false;
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1){
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
            this.container = container;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create() {
            return createTypedArray("float32", 2);
        }
        return poolFactory(8, create);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while(i < len){
            this.v[i] = pointPool.newElement();
            this.o[i] = pointPool.newElement();
            this.i[i] = pointPool.newElement();
            i += 1;
        }
    };
    ShapePath.prototype.setLength = function(len) {
        while(this._maxLength < len)this.doubleArrayLength();
        this._length = len;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type){
            case "v":
                arr = this.v;
                break;
            case "i":
                arr = this.i;
                break;
            case "o":
                arr = this.o;
                break;
            default:
                arr = [];
                break;
        }
        if (!arr[pos] || arr[pos] && !replace) arr[pos] = pointPool.newElement();
        arr[pos][0] = x;
        arr[pos][1] = y;
    };
    ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, "v", pos, replace);
        this.setXYAt(oX, oY, "o", pos, replace);
        this.setXYAt(iX, iY, "i", pos, replace);
    };
    ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
            newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
            init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for(i = init; i < len; i += 1){
            newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
            cnt -= 1;
        }
        return newPath;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create() {
            return new ShapePath();
        }
        function release(shapePath) {
            var len = shapePath._length;
            var i;
            for(i = 0; i < len; i += 1){
                pointPool.release(shapePath.v[i]);
                pointPool.release(shapePath.i[i]);
                pointPool.release(shapePath.o[i]);
                shapePath.v[i] = null;
                shapePath.i[i] = null;
                shapePath.o[i] = null;
            }
            shapePath._length = 0;
            shapePath.c = false;
        }
        function clone(shape) {
            var cloned = factory.newElement();
            var i;
            var len = shape._length === undefined ? shape.v.length : shape._length;
            cloned.setLength(len);
            cloned.c = shape.c;
            for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
            return cloned;
        }
        var factory = poolFactory(4, create, release);
        factory.clone = clone;
        return factory;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for(i = 0; i < this._length; i += 1)shapePool.release(this.shapes[i]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob = {
            newShapeCollection: newShapeCollection,
            release: release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
            var shapeCollection;
            if (_length) {
                _length -= 1;
                shapeCollection = pool[_length];
            } else shapeCollection = new ShapeCollection();
            return shapeCollection;
        }
        function release(shapeCollection) {
            var i;
            var len = shapeCollection._length;
            for(i = 0; i < len; i += 1)shapePool.release(shapeCollection.shapes[i]);
            shapeCollection._length = 0;
            if (_length === _maxLength) {
                pool = pooling["double"](pool);
                _maxLength *= 2;
            }
            pool[_length] = shapeCollection;
            _length += 1;
        }
        return ob;
    }();
    var ShapePropertyFactory = function() {
        var initFrame = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
            var iterationIndex = caching.lastIndex;
            var keyPropS;
            var keyPropE;
            var isHold;
            var j;
            var k;
            var jLen;
            var kLen;
            var perc;
            var vertexValue;
            var kf = this.keyframes;
            if (frameNum < kf[0].t - this.offsetTime) {
                keyPropS = kf[0].s[0];
                isHold = true;
                iterationIndex = 0;
            } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
                keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold = true;
            } else {
                var i = iterationIndex;
                var len = kf.length - 1;
                var flag = true;
                var keyData;
                var nextKeyData;
                var keyframeMetadata;
                while(flag){
                    keyData = kf[i];
                    nextKeyData = kf[i + 1];
                    if (nextKeyData.t - this.offsetTime > frameNum) break;
                    if (i < len - 1) i += 1;
                    else flag = false;
                }
                keyframeMetadata = this.keyframesMetadata[i] || {};
                isHold = keyData.h === 1;
                iterationIndex = i;
                if (!isHold) {
                    if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                    else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                    else {
                        var fnc;
                        if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                        else {
                            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                            keyframeMetadata.__fnct = fnc;
                        }
                        perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                    }
                    keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = previousValue._length;
            kLen = keyPropS.i[0].length;
            caching.lastIndex = iterationIndex;
            for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
                vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
                previousValue.i[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
                previousValue.o[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
                previousValue.v[j][k] = vertexValue;
            }
        }
        function interpolateShapeCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame = this._caching.lastFrame;
            if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
                /// /
                this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum, this.pv, this._caching); /// /
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function resetShape() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
            if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
            var i;
            var len = shape1._length;
            for(i = 0; i < len; i += 1){
                if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
            }
            return true;
        }
        function setVValue(newPath) {
            if (!shapesEqual(this.v, newPath)) {
                this.v = shapePool.clone(newPath);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue;
            if (this.kf) finalValue = this.pv;
            else if (this.data.ks) finalValue = this.data.ks.k;
            else finalValue = this.data.pt.k;
            var i;
            var len = this.effectsSequence.length;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem, data, type) {
            this.propType = "shape";
            this.comp = elem.comp;
            this.container = elem;
            this.elem = elem;
            this.data = data;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData = type === 3 ? data.pt.k : data.ks.k;
            this.v = shapePool.clone(pathData);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape;
            this.effectsSequence = [];
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence;
        ShapeProperty.prototype.setVValue = setVValue;
        ShapeProperty.prototype.addEffect = addEffect;
        function KeyframedShapeProperty(elem, data, type) {
            this.propType = "shape";
            this.comp = elem.comp;
            this.elem = elem;
            this.container = elem;
            this.offsetTime = elem.data.st;
            this.keyframes = type === 3 ? data.pt.k : data.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame;
            this.reset = resetShape;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime.bind(this)
            ];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue;
        KeyframedShapeProperty.prototype.addEffect = addEffect;
        var EllShapeProperty = function() {
            var cPoint = roundCorner;
            function EllShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data.d;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var s0 = this.s.v[0] / 2;
                    var s1 = this.s.v[1] / 2;
                    var _cw = this.d !== 3;
                    var _v = this.v;
                    _v.v[0][0] = p0;
                    _v.v[0][1] = p1 - s1;
                    _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.v[1][1] = p1;
                    _v.v[2][0] = p0;
                    _v.v[2][1] = p1 + s1;
                    _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.v[3][1] = p1;
                    _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.i[0][1] = p1 - s1;
                    _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.i[1][1] = p1 - s1 * cPoint;
                    _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.i[2][1] = p1 + s1;
                    _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.i[3][1] = p1 + s1 * cPoint;
                    _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.o[0][1] = p1 - s1;
                    _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.o[1][1] = p1 + s1 * cPoint;
                    _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.o[2][1] = p1 + s1;
                    _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.o[3][1] = p1 - s1 * cPoint;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory);
            return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
            function StarShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem;
                this.comp = elem.comp;
                this.data = data;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                if (data.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath() {
                    var numPts = Math.floor(this.pt.v) * 2;
                    var angle = Math.PI * 2 / numPts;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag = true;
                    var longRad = this.or.v;
                    var shortRad = this.ir.v;
                    var longRound = this.os.v;
                    var shortRound = this.is.v;
                    var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                    var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                    var i;
                    var rad;
                    var roundness;
                    var perimSegment;
                    var currentAng = -Math.PI / 2;
                    currentAng += this.r.v;
                    var dir = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        rad = longFlag ? longRad : shortRad;
                        roundness = longFlag ? longRound : shortRound;
                        perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag = !longFlag;
                        currentAng += angle * dir;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath() {
                    var numPts = Math.floor(this.pt.v);
                    var angle = Math.PI * 2 / numPts;
                    var rad = this.or.v;
                    var roundness = this.os.v;
                    var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                    var i;
                    var currentAng = -Math.PI * 0.5;
                    var dir = this.data.d === 3 ? -1 : 1;
                    currentAng += this.r.v;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        currentAng += angle * dir;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory);
            return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
            function RectShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory.prototype = {
                convertRectToPath: function convertRectToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var v0 = this.s.v[0] / 2;
                    var v1 = this.s.v[1] / 2;
                    var round = bmMin(v0, v1, this.r.v);
                    var cPoint = round * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                        }
                    } else {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                        }
                    }
                },
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory);
            return RectShapePropertyFactory;
        }();
        function getShapeProp(elem, data, type) {
            var prop;
            if (type === 3 || type === 4) {
                var dataProp = type === 3 ? data.pt : data.ks;
                var keys = dataProp.k;
                if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
                else prop = new ShapeProperty(elem, data, type);
            } else if (type === 5) prop = new RectShapeProperty(elem, data);
            else if (type === 6) prop = new EllShapeProperty(elem, data);
            else if (type === 7) prop = new StarShapeProperty(elem, data);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        }
        function getConstructorFunction() {
            return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
        }
        var ob = {};
        ob.getShapeProp = getShapeProp;
        ob.getConstructorFunction = getConstructorFunction;
        ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
            return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
            return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale(sx, sy, sz) {
            if (!sz && sz !== 0) sz = 1;
            if (sx === 1 && sy === 1 && sz === 1) return this;
            return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
            this.props[0] = a;
            this.props[1] = b;
            this.props[2] = c;
            this.props[3] = d;
            this.props[4] = e;
            this.props[5] = f;
            this.props[6] = g;
            this.props[7] = h;
            this.props[8] = i;
            this.props[9] = j;
            this.props[10] = k;
            this.props[11] = l;
            this.props[12] = m;
            this.props[13] = n;
            this.props[14] = o;
            this.props[15] = p;
            return this;
        }
        function translate(tx, ty, tz) {
            tz = tz || 0;
            if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
            return this;
        }
        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
            var _p = this.props;
            if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p[12] = _p[12] * a2 + _p[15] * m2;
                _p[13] = _p[13] * f2 + _p[15] * n2;
                _p[14] = _p[14] * k2 + _p[15] * o2;
                _p[15] *= p2; // }
                this._identityCalculated = false;
                return this;
            }
            var a1 = _p[0];
            var b1 = _p[1];
            var c1 = _p[2];
            var d1 = _p[3];
            var e1 = _p[4];
            var f1 = _p[5];
            var g1 = _p[6];
            var h1 = _p[7];
            var i1 = _p[8];
            var j1 = _p[9];
            var k1 = _p[10];
            var l1 = _p[11];
            var m1 = _p[12];
            var n1 = _p[13];
            var o1 = _p[14];
            var p1 = _p[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
            _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
            _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
            _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
            _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
            _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
            _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
            _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
            _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
            _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
            _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
            _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
            _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
            _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
            _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
            _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
            this._identityCalculated = false;
            return this;
        }
        function multiply(matrix) {
            var matrixProps = matrix.props;
            return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
        }
        function isIdentity() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals(matr) {
            var i = 0;
            while(i < 16){
                if (matr.props[i] !== this.props[i]) return false;
                i += 1;
            }
            return true;
        }
        function clone(matr) {
            var i;
            for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
            return matr;
        }
        function cloneFromProps(props) {
            var i;
            for(i = 0; i < 16; i += 1)this.props[i] = props[i];
        }
        function applyToPoint(x, y, z) {
            return {
                x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX(x, y, z) {
            return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x, y, z) {
            return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x, y, z) {
            return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
            var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a = this.props[5] / determinant;
            var b = -this.props[1] / determinant;
            var c = -this.props[4] / determinant;
            var d = this.props[0] / determinant;
            var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
            var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
            var inverseMatrix = new Matrix();
            inverseMatrix.props[0] = a;
            inverseMatrix.props[1] = b;
            inverseMatrix.props[4] = c;
            inverseMatrix.props[5] = d;
            inverseMatrix.props[12] = e;
            inverseMatrix.props[13] = f;
            return inverseMatrix;
        }
        function inversePoint(pt) {
            var inverseMatrix = this.getInverseMatrix();
            return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
            var i;
            var len = pts.length;
            var retPts = [];
            for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
            return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
            var arr = createTypedArray("float32", 6);
            if (this.isIdentity()) {
                arr[0] = pt1[0];
                arr[1] = pt1[1];
                arr[2] = pt2[0];
                arr[3] = pt2[1];
                arr[4] = pt3[0];
                arr[5] = pt3[1];
            } else {
                var p0 = this.props[0];
                var p1 = this.props[1];
                var p4 = this.props[4];
                var p5 = this.props[5];
                var p12 = this.props[12];
                var p13 = this.props[13];
                arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
                arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
                arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
                arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
                arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
                arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
            }
            return arr;
        }
        function applyToPointArray(x, y, z) {
            var arr;
            if (this.isIdentity()) arr = [
                x,
                y,
                z
            ];
            else arr = [
                x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            ];
            return arr;
        }
        function applyToPointStringified(x, y) {
            if (this.isIdentity()) return x + "," + y;
            var _p = this.props;
            return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + "," + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i = 0;
            var props = this.props;
            var cssValue = "matrix3d(";
            var v = 10000;
            while(i < 16){
                cssValue += _rnd(props[i] * v) / v;
                cssValue += i === 15 ? ")" : ",";
                i += 1;
            }
            return cssValue;
        }
        function roundMatrixProperty(val) {
            var v = 10000;
            if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
            return val;
        }
        function to2dCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props = this.props;
            var _a = roundMatrixProperty(props[0]);
            var _b = roundMatrixProperty(props[1]);
            var _c = roundMatrixProperty(props[4]);
            var _d = roundMatrixProperty(props[5]);
            var _e = roundMatrixProperty(props[12]);
            var _f = roundMatrixProperty(props[13]);
            return "matrix(" + _a + "," + _b + "," + _c + "," + _d + "," + _e + "," + _f + ")";
        }
        return function() {
            this.reset = reset;
            this.rotate = rotate;
            this.rotateX = rotateX;
            this.rotateY = rotateY;
            this.rotateZ = rotateZ;
            this.skew = skew;
            this.skewFromAxis = skewFromAxis;
            this.shear = shear;
            this.scale = scale;
            this.setTransform = setTransform;
            this.translate = translate;
            this.transform = transform;
            this.multiply = multiply;
            this.applyToPoint = applyToPoint;
            this.applyToX = applyToX;
            this.applyToY = applyToY;
            this.applyToZ = applyToZ;
            this.applyToPointArray = applyToPointArray;
            this.applyToTriplePoints = applyToTriplePoints;
            this.applyToPointStringified = applyToPointStringified;
            this.toCSS = toCSS;
            this.to2dCSS = to2dCSS;
            this.clone = clone;
            this.cloneFromProps = cloneFromProps;
            this.equals = equals;
            this.inversePoints = inversePoints;
            this.inversePoint = inversePoint;
            this.getInverseMatrix = getInverseMatrix;
            this._t = this.transform;
            this.isIdentity = isIdentity;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray("float32", 16);
            this.reset();
        };
    }();
    function _typeof$3(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$3 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$3(obj);
    }
    var lottie = {};
    var standalone = "__[STANDALONE]__";
    var animationData = "__[ANIMATIONDATA]__";
    var renderer = "";
    function setLocation(href) {
        setLocationHref(href);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
    }
    function setPrefix(prefix) {
        setIdPrefix(prefix);
    }
    function loadAnimation(params) {
        if (standalone === true) params.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params);
    }
    function setQuality(value) {
        if (typeof value === "string") switch(value){
            case "high":
                setDefaultCurveSegments(200);
                break;
            default:
            case "medium":
                setDefaultCurveSegments(50);
                break;
            case "low":
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value) && value > 1) setDefaultCurveSegments(value);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== "undefined";
    }
    function installPlugin(type, plugin) {
        if (type === "expressions") setExpressionsPlugin(plugin);
    }
    function getFactory(name) {
        switch(name){
            case "propertyFactory":
                return PropertyFactory;
            case "shapePropertyFactory":
                return ShapePropertyFactory;
            case "matrix":
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize; // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = "5.12.2";
    function checkReady() {
        if (document.readyState === "complete") {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable) {
        var vars = queryString.split("&");
        for(var i = 0; i < vars.length; i += 1){
            var pair = vars[i].split("=");
            if (decodeURIComponent(pair[0]) == variable) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair[1]);
        }
        return null;
    }
    var queryString = "";
    if (standalone) {
        var scripts = document.getElementsByTagName("script");
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ""
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : ""; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof$3(exports) === "object" && true) && !(typeof define === "function" && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {}
    var ShapeModifiers = function() {
        var ob = {};
        var modifiers = {};
        ob.registerModifier = registerModifier;
        ob.getModifier = getModifier;
        function registerModifier(nm, factory) {
            if (!modifiers[nm]) modifiers[nm] = factory;
        }
        function getModifier(nm, elem, data) {
            return new modifiers[nm](elem, data);
        }
        return ob;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data.sh.container.addDynamicProperty(data.sh);
            var shapeData = {
                shape: data.sh,
                data: data,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData);
            this.addShapeToModifier(shapeData);
            if (this._isAnimated) data.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem, data) {
        this.shapes = [];
        this.elem = elem;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, data);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem, data) {
        this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) segments.push({
            s: s,
            e: e
        });
        else if (s >= 1) segments.push({
            s: s - 1,
            e: e - 1
        });
        else {
            segments.push({
                s: s,
                e: 1
            });
            segments.push({
                s: 0,
                e: e - 1
            });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for(i = 0; i < len; i += 1){
            segmentOb = segments[i];
            if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
                var shapeS;
                var shapeE;
                if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
                else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
                if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
                else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
                shapeSegments.push([
                    shapeS,
                    shapeE
                ]);
            }
        }
        if (!shapeSegments.length) shapeSegments.push([
            0,
            0
        ]);
        return shapeSegments;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for(i = 0; i < len; i += 1)segmentsLengthPool.release(pathsData[i]);
        pathsData.length = 0;
        return pathsData;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s;
        var e;
        if (this._mdf || _isFirstFrame) {
            var o = this.o.v % 360 / 360;
            if (o < 0) o += 1;
            if (this.s.v > 1) s = 1 + o;
            else if (this.s.v < 0) s = 0 + o;
            else s = this.s.v + o;
            if (this.e.v > 1) e = 1 + o;
            else if (this.e.v < 0) e = 0 + o;
            else e = this.e.v + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            s = Math.round(s * 10000) * 0.0001;
            e = Math.round(e * 10000) * 0.0001;
            this.sValue = s;
            this.eValue = e;
        } else {
            s = this.sValue;
            e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s) for(i = 0; i < len; i += 1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) this.shapes[i].pathsData.length = 0;
        }
        else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
            var segments = [];
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
                else {
                    shapePaths = shapeData.shape.paths;
                    jLen = shapePaths._length;
                    totalShapeLength = 0;
                    if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                    else {
                        pathsData = this.releasePathsData(shapeData.pathsData);
                        for(j = 0; j < jLen; j += 1){
                            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                            pathsData.push(pathData);
                            totalShapeLength += pathData.totalLength;
                        }
                        shapeData.totalShapeLength = totalShapeLength;
                        shapeData.pathsData = pathsData;
                    }
                    totalModifierLength += totalShapeLength;
                    shapeData.shape._mdf = true;
                }
            }
            var shapeS = s;
            var shapeE = e;
            var addedLength = 0;
            var edges;
            for(i = len - 1; i >= 0; i -= 1){
                shapeData = this.shapes[i];
                if (shapeData.shape._mdf) {
                    localShapeCollection = shapeData.localShapeCollection;
                    localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len > 1) {
                        edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                        addedLength += shapeData.totalShapeLength;
                    } else edges = [
                        [
                            shapeS,
                            shapeE
                        ]
                    ];
                    jLen = edges.length;
                    for(j = 0; j < jLen; j += 1){
                        shapeS = edges[j][0];
                        shapeE = edges[j][1];
                        segments.length = 0;
                        if (shapeE <= 1) segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength * shapeE
                        });
                        else if (shapeS >= 1) segments.push({
                            s: shapeData.totalShapeLength * (shapeS - 1),
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                        else {
                            segments.push({
                                s: shapeData.totalShapeLength * shapeS,
                                e: shapeData.totalShapeLength
                            });
                            segments.push({
                                s: 0,
                                e: shapeData.totalShapeLength * (shapeE - 1)
                            });
                        }
                        var newShapesData = this.addShapes(shapeData, segments[0]);
                        if (segments[0].s !== segments[0].e) {
                            if (segments.length > 1) {
                                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                                if (lastShapeInCollection.c) {
                                    var lastShape = newShapesData.pop();
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                                } else {
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1]);
                                }
                            }
                            this.addPaths(newShapesData, localShapeCollection);
                        }
                    }
                    shapeData.shape.paths = localShapeCollection;
                }
            }
        } else if (this._mdf) for(i = 0; i < len; i += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
    };
    TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], "o", pos);
        shapePath.setXYAt(pt3[0], pt3[1], "i", pos + 1);
        if (newShape) shapePath.setXYAt(pt1[0], pt1[1], "v", pos);
        shapePath.setXYAt(pt4[0], pt4[1], "v", pos + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], "o", pos);
        shapePath.setXYAt(points[2], points[6], "i", pos + 1);
        if (newShape) shapePath.setXYAt(points[0], points[4], "v", pos);
        shapePath.setXYAt(points[3], points[7], "v", pos + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
            shapePath = shapePool.newElement();
            segmentCount = 0;
            initPos = 0;
        } else {
            segmentCount = shapePath._length;
            initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for(i = 0; i < len; i += 1){
            lengths = pathsData[i].lengths;
            shapePath.c = shapePaths[i].c;
            jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
            for(j = 1; j < jLen; j += 1){
                currentLengthData = lengths[j - 1];
                if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                    addedLength += currentLengthData.addedLength;
                    shapePath.c = false;
                } else if (addedLength > shapeSegment.e) {
                    shapePath.c = false;
                    break;
                } else {
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                    addedLength += currentLengthData.addedLength;
                    segmentCount += 1;
                }
            }
            if (shapePaths[i].c && lengths.length) {
                currentLengthData = lengths[j - 1];
                if (addedLength <= shapeSegment.e) {
                    var segmentLength = lengths[j - 1].addedLength;
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                } else shapePath.c = false;
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
            if (shapePath._length) {
                shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], "i", initPos);
                shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], "o", shapePath._length - 1);
            }
            if (addedLength > shapeSegment.e) break;
            if (i < len - 1) {
                shapePath = shapePool.newElement();
                newShape = true;
                shapes.push(shapePath);
                segmentCount = 0;
            }
        }
        return shapes;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
        var percent = amount / 100;
        var centerPoint = [
            0,
            0
        ];
        var pathLength = path._length;
        var i = 0;
        for(i = 0; i < pathLength; i += 1){
            centerPoint[0] += path.v[i][0];
            centerPoint[1] += path.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < pathLength; i += 1){
            vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
            vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
            oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
            oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
            iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
            iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
            clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector = [
            0,
            0
        ];
        function applyToMatrix(mat) {
            var _mdf = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf;
            if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat.rotate(-this.r.v);
            else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
                else mat.translate(this.px.v, this.py.v, 0);
            } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys(forceRender) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender) {
                var frameRate;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v1;
                    var v2;
                    frameRate = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                        } else {
                            v1 = this.p.pv;
                            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v1 = [];
                        v2 = [];
                        var px = this.px;
                        var py = this.py;
                        if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                            v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                            v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                        } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                            v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                            v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        } else {
                            v1 = [
                                px.pv,
                                py.pv
                            ];
                            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                        }
                    } else {
                        v2 = defaultVector;
                        v1 = v2;
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
            this.appliedTransformations = 0;
            this.pre.reset();
            if (!this.a.effectsSequence.length) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient() {
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty(prop) {
            this._addDynamicProperty(prop);
            this.elem.addDynamicProperty(prop);
            this._isDirty = true;
        }
        function TransformProperty(elem, data, container) {
            this.elem = elem;
            this.frameId = -1;
            this.propType = "transform";
            this.data = data;
            this.v = new Matrix(); // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container || elem);
            if (data.p && data.p.s) {
                this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
                if (data.p.z) this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem, data.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
                if (data.or.k[0].ti) {
                    var i;
                    var len = data.or.k.length;
                    for(i = 0; i < len; i += 1){
                        data.or.k[i].to = null;
                        data.or.k[i].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem, data.r || {
                k: 0
            }, 0, degToRads, this);
            if (data.sk) {
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem, data.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data.o) this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty.prototype = {
            applyToMatrix: applyToMatrix,
            getValue: processKeys,
            precalculateMatrix: precalculateMatrix,
            autoOrient: autoOrient
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem, data, container) {
            return new TransformProperty(elem, data, container);
        }
        return {
            getTransformProperty: getTransformProperty
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
        this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
        this.data = data;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
        var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
        pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
        rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        rMatrix.rotate(-transform.r.v * dir * perc);
        rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
        sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
        this.elem = elem;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, arr[pos]);
        while(pos > 0){
            pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._processed = false;
            if (elements[i].ty === "gr") this.resetElements(elements[i].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._render = renderFlag;
            if (elements[i].ty === "gr") this.changeGroupRender(elements[i].it, renderFlag);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
            var copies = Math.ceil(this.c.v);
            if (this._groups.length < copies) {
                while(this._groups.length < copies){
                    var group = {
                        it: this.cloneElements(this._elements),
                        ty: "gr"
                    };
                    group.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: "Transform",
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: "tr"
                    });
                    this.arr.splice(0, 0, group);
                    this._groups.splice(0, 0, group);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded = true;
            }
            cont = 0;
            var renderFlag;
            for(i = 0; i <= this._groups.length - 1; i += 1){
                renderFlag = cont < copies;
                this._groups[i]._render = renderFlag;
                this.changeGroupRender(this._groups[i].it, renderFlag);
                if (!renderFlag) {
                    var elems = this.elemsData[i].it;
                    var transformData = elems[elems.length - 1];
                    if (transformData.transform.op.v !== 0) {
                        transformData.transform.op._mdf = true;
                        transformData.transform.op.v = 0;
                    } else transformData.transform.op._mdf = false;
                }
                cont += 1;
            }
            this._currentCopies = copies; /// /
            var offset = this.o.v;
            var offsetModulo = offset % 1;
            var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
            var pProps = this.pMatrix.props;
            var rProps = this.rMatrix.props;
            var sProps = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration = 0;
            if (offset > 0) {
                while(iteration < roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if (offset < 0) {
                while(iteration > roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            i = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir = this.data.m === 1 ? 1 : -1;
            cont = this._currentCopies;
            var j;
            var jLen;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                jLen = itemsTransform.length;
                items[items.length - 1].transform.mProps._mdf = true;
                items[items.length - 1].transform.op._mdf = true;
                items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
                if (iteration !== 0) {
                    if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                    this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                    this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                }
                iteration += 1;
                cont -= 1;
                i += dir;
            }
        } else {
            cont = this._currentCopies;
            i = 0;
            dir = 1;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                items[items.length - 1].transform.mProps._mdf = false;
                items[items.length - 1].transform.op._mdf = false;
                cont -= 1;
                i += dir;
            }
        }
        return hasReloaded;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path, round) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var i;
        var len = path._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < len; i += 1){
            currentV = path.v[i];
            currentO = path.o[i];
            currentI = path.i[i];
            if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
                if ((i === 0 || i === len - 1) && !path.c) {
                    clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index += 1;
                } else {
                    if (i === 0) closerV = path.v[len - 1];
                    else closerV = path.v[i - 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = iX;
                    iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                    vY = iY;
                    oX = vX - (vX - currentV[0]) * roundCorner;
                    oY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                    if (i === len - 1) closerV = path.v[0];
                    else closerV = path.v[i + 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = oX;
                    oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                    vY = oY;
                    iX = vX - (vX - currentV[0]) * roundCorner;
                    iY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                }
            } else {
                clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
                index += 1;
            }
        }
        return clonedPath;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a, b) {
        return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
    }
    function floatZero(f) {
        return Math.abs(f) <= 0.00001;
    }
    function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
    }
    function lerpPoint(p0, p1, amount) {
        return [
            lerp(p0[0], p1[0], amount),
            lerp(p0[1], p1[1], amount)
        ];
    }
    function quadRoots(a, b, c) {
        // no root
        if (a === 0) return [];
        var s = b * b - 4 * a * c; // Complex roots
        if (s < 0) return [];
        var singleRoot = -b / (2 * a); // 1 root
        if (s === 0) return [
            singleRoot
        ];
        var delta = Math.sqrt(s) / (2 * a); // 2 roots
        return [
            singleRoot - delta,
            singleRoot + delta
        ];
    }
    function polynomialCoefficients(p0, p1, p2, p3) {
        return [
            -p0 + 3 * p1 - 3 * p2 + p3,
            3 * p0 - 6 * p1 + 3 * p2,
            -3 * p0 + 3 * p1,
            p0
        ];
    }
    function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
    }
    function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) p1 = lerpPoint(p0, p3, 1 / 3);
        if (linearize && pointEqual(p2, p3)) p2 = lerpPoint(p0, p3, 2 / 3);
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [
            coeffx[0],
            coeffy[0]
        ];
        this.b = [
            coeffx[1],
            coeffy[1]
        ];
        this.c = [
            coeffx[2],
            coeffy[2]
        ];
        this.d = [
            coeffx[3],
            coeffy[3]
        ];
        this.points = [
            p0,
            p1,
            p2,
            p3
        ];
    }
    PolynomialBezier.prototype.point = function(t) {
        return [
            ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
            ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t) {
        return [
            (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
            (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square < 0) return [];
        var root = Math.sqrt(square);
        if (floatZero(root)) {
            if (root > 0 && root < 1) return [
                tcusp
            ];
            return [];
        }
        return [
            tcusp - root,
            tcusp + root
        ].filter(function(r) {
            return r > 0 && r < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [
            new PolynomialBezier(this.points[0], p10, p20, p3, true),
            new PolynomialBezier(p3, p21, p12, this.points[3], true)
        ];
    };
    function extrema(bez, comp) {
        var min = bez.points[0][comp];
        var max = bez.points[bez.points.length - 1][comp];
        if (min > max) {
            var e = max;
            max = min;
            min = e;
        } // Derivative roots to find min/max
        var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
        for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
            var val = bez.point(f[i])[comp];
            if (val < min) min = val;
            else if (val > max) max = val;
        }
        return {
            min: min,
            max: max
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
            left: bounds.x.min,
            right: bounds.x.max,
            top: bounds.y.min,
            bottom: bounds.y.max,
            width: bounds.x.max - bounds.x.min,
            height: bounds.y.max - bounds.y.min,
            cx: (bounds.x.max + bounds.x.min) / 2,
            cy: (bounds.y.max + bounds.y.min) / 2
        };
    };
    function intersectData(bez, t1, t2) {
        var box = bez.boundingBox();
        return {
            cx: box.cx,
            cy: box.cy,
            width: box.width,
            height: box.height,
            bez: bez,
            t: (t1 + t2) / 2,
            t1: t1,
            t2: t2
        };
    }
    function splitData(data) {
        var split = data.bez.split(0.5);
        return [
            intersectData(split[0], data.t1, data.t),
            intersectData(split[1], data.t, data.t2)
        ];
    }
    function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
    }
    function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
            intersections.push([
                d1.t,
                d2.t
            ]);
            return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    }
    PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === undefined) tolerance = 2;
        if (maxRecursion === undefined) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
    };
    PolynomialBezier.shapeSegment = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
    };
    function crossProduct(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    function lineIntersection(start1, end1, start2, end2) {
        var v1 = [
            start1[0],
            start1[1],
            1
        ];
        var v2 = [
            end1[0],
            end1[1],
            1
        ];
        var v3 = [
            start2[0],
            start2[1],
            1
        ];
        var v4 = [
            end2[0],
            end2[1],
            1
        ];
        var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r[2])) return null;
        return [
            r[0] / r[2],
            r[1] / r[2]
        ];
    }
    function polarOffset(p, angle, length) {
        return [
            p[0] + Math.cos(angle) * length,
            p[1] - Math.sin(angle) * length
        ];
    }
    function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
    }
    function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point[0] + Math.cos(angle) * direction * amplitude;
        var py = point[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
    }
    function getPerpendicularVector(pt1, pt2) {
        var vector = [
            pt2[0] - pt1[0],
            pt2[1] - pt1[1]
        ];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [
            Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
            Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
        ];
        return rotatedVector;
    }
    function getProjectingAngle(path, cur) {
        var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path.length();
        var prevPoint = path.v[prevIndex];
        var nextPoint = path.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
    }
    function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path, cur);
        var point = path.v[cur % path._length];
        var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
        var nextPoint = path.v[(cur + 1) % path._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
    }
    function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for(var i = 0; i < frequency; i += 1){
            var t = (i + 1) / (frequency + 1);
            var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
            var angle = segment.normalAngle(t);
            var point = segment.point(t);
            setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
            direction = -direction;
        }
        return direction;
    }
    ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
        var count = path._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        if (!path.c) count -= 1;
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path, 0);
        zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
        for(var i = 0; i < count; i += 1){
            direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
            if (i === count - 1 && !path.c) segment = null;
            else segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
            zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [
            polarOffset(p1, angle, amount),
            polarOffset(p2, angle, amount)
        ];
    }
    function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
    }
    function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0]; // Bevel
        if (lineJoin === 3) return p0; // Connected, they don't need a joint
        if (pointEqual(p0, p1)) return p0; // Round
        if (lineJoin === 2) {
            var angleOut = -seg1.tangentAngle(1);
            var angleIn = -seg2.tangentAngle(0) + Math.PI;
            var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
            var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
            var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
            outputBezier.setXYAt(tan[0], tan[1], "o", outputBezier.length() - 1);
            tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
            outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
            return p1;
        } // Miter
        var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t0, p0, p1, t1);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
            outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
            return intersection;
        }
        return p0;
    }
    function getIntersection(a, b) {
        var intersect = a.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
    }
    function pruneSegmentIntersection(a, b) {
        var outa = a.slice();
        var outb = b.slice();
        var intersect = getIntersection(a[a.length - 1], b[0]);
        if (intersect) {
            outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
            outb[0] = b[0].split(intersect[1])[1];
        }
        if (a.length > 1 && b.length > 1) {
            intersect = getIntersection(a[0], b[b.length - 1]);
            if (intersect) return [
                [
                    a[0].split(intersect[0])[0]
                ],
                [
                    b[b.length - 1].split(intersect[1])[1]
                ]
            ];
        }
        return [
            outa,
            outb
        ];
    }
    function pruneIntersections(segments) {
        var e;
        for(var i = 1; i < segments.length; i += 1){
            e = pruneSegmentIntersection(segments[i - 1], segments[i]);
            segments[i - 1] = e[0];
            segments[i] = e[1];
        }
        if (segments.length > 1) {
            e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
            segments[segments.length - 1] = e[0];
            segments[0] = e[1];
        }
        return segments;
    }
    function offsetSegmentSplit(segment, amount) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */ var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) return [
            offsetSegment(segment, amount)
        ];
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
            split = segment.split(flex[0]);
            left = split[0];
            right = split[1];
            return [
                offsetSegment(left, amount),
                offsetSegment(right, amount)
            ];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [
            offsetSegment(left, amount),
            offsetSegment(mid, amount),
            offsetSegment(right, amount)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
        this.lineJoin = data.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) count -= 1;
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for(i = 0; i < count; i += 1){
            segment = PolynomialBezier.shapeSegment(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints
        var lastPoint = null;
        var lastSeg = null;
        for(i = 0; i < multiSegments.length; i += 1){
            var multiSegment = multiSegments[i];
            if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
            lastSeg = multiSegment[multiSegment.length - 1];
            for(j = 0; j < multiSegment.length; j += 1){
                segment = multiSegment[j];
                if (lastPoint && pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], "o", outputBezier.length() - 1);
                else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
                outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
                lastPoint = segment.points[3];
            }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(" ") : [];
        var fWeight = "normal";
        var fStyle = "normal";
        var len = styles.length;
        var styleName;
        for(var i = 0; i < len; i += 1){
            styleName = styles[i].toLowerCase();
            switch(styleName){
                case "italic":
                    fStyle = "italic";
                    break;
                case "bold":
                    fWeight = "700";
                    break;
                case "black":
                    fWeight = "900";
                    break;
                case "medium":
                    fWeight = "500";
                    break;
                case "regular":
                case "normal":
                    fWeight = "400";
                    break;
                case "light":
                case "thin":
                    fWeight = "200";
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle,
            weight: fontData.fWeight || fWeight
        };
    }
    var FontManager = function() {
        var maxWaitingTime = 5000;
        var emptyChar = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters = []; // Hindi characters
        combinedCharacters = combinedCharacters.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var BLACK_FLAG_CODE_POINT = 127988;
        var CANCEL_TAG_CODE_POINT = 917631;
        var A_TAG_CODE_POINT = 917601;
        var Z_TAG_CODE_POINT = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
        var surrogateModifiers = [
            "d83cdffb",
            "d83cdffc",
            "d83cdffd",
            "d83cdffe",
            "d83cdfff"
        ];
        function trimFontOptions(font) {
            var familyArray = font.split(",");
            var i;
            var len = familyArray.length;
            var enabledFamilies = [];
            for(i = 0; i < len; i += 1)if (familyArray[i] !== "sans-serif" && familyArray[i] !== "monospace") enabledFamilies.push(familyArray[i]);
            return enabledFamilies.join(",");
        }
        function setUpNode(font, family) {
            var parentNode = createTag("span"); // Node is invisible to screen readers.
            parentNode.setAttribute("aria-hidden", true);
            parentNode.style.fontFamily = family;
            var node = createTag("span"); // Characters that vary significantly among different fonts
            node.innerText = "giItT1WQy@!-/#"; // Visible - so we can measure it - but not on the screen
            parentNode.style.position = "absolute";
            parentNode.style.left = "-10000px";
            parentNode.style.top = "-10000px"; // Large font size makes even subtle changes obvious
            parentNode.style.fontSize = "300px"; // Reset any font properties
            parentNode.style.fontVariant = "normal";
            parentNode.style.fontStyle = "normal";
            parentNode.style.fontWeight = "normal";
            parentNode.style.letterSpacing = "0";
            parentNode.appendChild(node);
            document.body.appendChild(parentNode); // Remember width with no applied web font
            var width = node.offsetWidth;
            node.style.fontFamily = trimFontOptions(font) + ", " + family;
            return {
                node: node,
                w: width,
                parent: parentNode
            };
        }
        function checkLoadedFonts() {
            var i;
            var len = this.fonts.length;
            var node;
            var w;
            var loadedCount = len;
            for(i = 0; i < len; i += 1){
                if (this.fonts[i].loaded) loadedCount -= 1;
                else if (this.fonts[i].fOrigin === "n" || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
                else {
                    node = this.fonts[i].monoCase.node;
                    w = this.fonts[i].monoCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    } else {
                        node = this.fonts[i].sansCase.node;
                        w = this.fonts[i].sansCase.w;
                        if (node.offsetWidth !== w) {
                            loadedCount -= 1;
                            this.fonts[i].loaded = true;
                        }
                    }
                    if (this.fonts[i].loaded) {
                        this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                        this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                    }
                }
            }
            if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper(fontData, def) {
            var engine = document.body && def ? "svg" : "canvas";
            var helper;
            var fontProps = getFontProperties(fontData);
            if (engine === "svg") {
                var tHelper = createNS("text");
                tHelper.style.fontSize = "100px"; // tHelper.style.fontFamily = fontData.fFamily;
                tHelper.setAttribute("font-family", fontData.fFamily);
                tHelper.setAttribute("font-style", fontProps.style);
                tHelper.setAttribute("font-weight", fontProps.weight);
                tHelper.textContent = "1";
                if (fontData.fClass) {
                    tHelper.style.fontFamily = "inherit";
                    tHelper.setAttribute("class", fontData.fClass);
                } else tHelper.style.fontFamily = fontData.fFamily;
                def.appendChild(tHelper);
                helper = tHelper;
            } else {
                var tCanvasHelper = new OffscreenCanvas(500, 500).getContext("2d");
                tCanvasHelper.font = fontProps.style + " " + fontProps.weight + " 100px " + fontData.fFamily;
                helper = tCanvasHelper;
            }
            function measure(text) {
                if (engine === "svg") {
                    helper.textContent = text;
                    return helper.getComputedTextLength();
                }
                return helper.measureText(text).width;
            }
            return {
                measureText: measure
            };
        }
        function addFonts(fontData, defs) {
            if (!fontData) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData.list.forEach(function(data) {
                    data.helper = createHelper(data);
                    data.cache = {};
                });
                this.fonts = fontData.list;
                return;
            }
            var fontArr = fontData.list;
            var i;
            var len = fontArr.length;
            var _pendingFonts = len;
            for(i = 0; i < len; i += 1){
                var shouldLoadFont = true;
                var loadedSelector;
                var j;
                fontArr[i].loaded = false;
                fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, "monospace");
                fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, "sans-serif");
                if (!fontArr[i].fPath) {
                    fontArr[i].loaded = true;
                    _pendingFonts -= 1;
                } else if (fontArr[i].fOrigin === "p" || fontArr[i].origin === 3) {
                    loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                    if (loadedSelector.length > 0) shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var s = createTag("style");
                        s.setAttribute("f-forigin", fontArr[i].fOrigin);
                        s.setAttribute("f-origin", fontArr[i].origin);
                        s.setAttribute("f-family", fontArr[i].fFamily);
                        s.type = "text/css";
                        s.innerText = "@font-face {font-family: " + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                        defs.appendChild(s);
                    }
                } else if (fontArr[i].fOrigin === "g" || fontArr[i].origin === 1) {
                    loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var l = createTag("link");
                        l.setAttribute("f-forigin", fontArr[i].fOrigin);
                        l.setAttribute("f-origin", fontArr[i].origin);
                        l.type = "text/css";
                        l.rel = "stylesheet";
                        l.href = fontArr[i].fPath;
                        document.body.appendChild(l);
                    }
                } else if (fontArr[i].fOrigin === "t" || fontArr[i].origin === 2) {
                    loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var sc = createTag("link");
                        sc.setAttribute("f-forigin", fontArr[i].fOrigin);
                        sc.setAttribute("f-origin", fontArr[i].origin);
                        sc.setAttribute("rel", "stylesheet");
                        sc.setAttribute("href", fontArr[i].fPath);
                        defs.appendChild(sc);
                    }
                }
                fontArr[i].helper = createHelper(fontArr[i], defs);
                fontArr[i].cache = {};
                this.fonts.push(fontArr[i]);
            }
            if (_pendingFonts === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars(chars) {
            if (!chars) return;
            if (!this.chars) this.chars = [];
            var i;
            var len = chars.length;
            var j;
            var jLen = this.chars.length;
            var found;
            for(i = 0; i < len; i += 1){
                j = 0;
                found = false;
                while(j < jLen){
                    if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                    j += 1;
                }
                if (!found) {
                    this.chars.push(chars[i]);
                    jLen += 1;
                }
            }
        }
        function getCharData(_char, style, font) {
            var i = 0;
            var len = this.chars.length;
            while(i < len){
                if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
                i += 1;
            }
            if ((typeof _char === "string" && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn("Missing character from exported characters list: ", _char, style, font); // eslint-disable-line no-console
            }
            return emptyChar;
        }
        function measureText(_char2, fontName, size) {
            var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
            // to avoid collisions between equal chars
            var index = _char2;
            if (!fontData.cache[index]) {
                var tHelper = fontData.helper;
                if (_char2 === " ") {
                    var doubleSize = tHelper.measureText("|" + _char2 + "|");
                    var singleSize = tHelper.measureText("||");
                    fontData.cache[index] = (doubleSize - singleSize) / 100;
                } else fontData.cache[index] = tHelper.measureText(_char2) / 100;
            }
            return fontData.cache[index] * size;
        }
        function getFontByName(name) {
            var i = 0;
            var len = this.fonts.length;
            while(i < len){
                if (this.fonts[i].fName === name) return this.fonts[i];
                i += 1;
            }
            return this.fonts[0];
        }
        function getCodePoint(string) {
            var codePoint = 0;
            var first = string.charCodeAt(0);
            if (first >= 0xD800 && first <= 0xDBFF) {
                var second = string.charCodeAt(1);
                if (second >= 0xDC00 && second <= 0xDFFF) codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
            return codePoint;
        } // Skin tone modifiers
        function isModifier(firstCharCode, secondCharCode) {
            var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
            return surrogateModifiers.indexOf(sum) !== -1;
        }
        function isZeroWidthJoiner(charCode) {
            return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
        } // This codepoint may change the appearance of the preceding character.
        // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
        // as a colorful image as compared to a monochrome text variant.
        function isVariationSelector(charCode) {
            return charCode === VARIATION_SELECTOR_16_CODE_POINT;
        } // The regional indicator symbols are a set of 26 alphabetic Unicode
        /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
        // two-letter country codes in a way that allows optional special treatment.
        function isRegionalCode(string) {
            var codePoint = getCodePoint(string);
            if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) return true;
            return false;
        } // Some Emoji implementations represent combinations of
        // two “regional indicator” letters as a single flag symbol.
        function isFlagEmoji(string) {
            return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
        }
        function isCombinedCharacter(_char3) {
            return combinedCharacters.indexOf(_char3) !== -1;
        } // Regional flags start with a BLACK_FLAG_CODE_POINT
        // folowed by 5 chars in the TAG range
        // and end with a CANCEL_TAG_CODE_POINT
        function isRegionalFlag(text, index) {
            var codePoint = getCodePoint(text.substr(index, 2));
            if (codePoint !== BLACK_FLAG_CODE_POINT) return false;
            var count = 0;
            index += 2;
            while(count < 5){
                codePoint = getCodePoint(text.substr(index, 2));
                if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) return false;
                count += 1;
                index += 2;
            }
            return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
        }
        function setIsLoaded() {
            this.isLoaded = true;
        }
        var Font = function Font() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isFlagEmoji = isFlagEmoji;
        Font.isRegionalCode = isRegionalCode;
        Font.isCombinedCharacter = isCombinedCharacter;
        Font.isRegionalFlag = isRegionalFlag;
        Font.isVariationSelector = isVariationSelector;
        Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
        var fontPrototype = {
            addChars: addChars,
            addFonts: addFonts,
            getCharData: getCharData,
            getFontByName: getFontByName,
            measureText: measureText,
            checkLoadedFonts: checkLoadedFonts,
            setIsLoaded: setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
    }();
    function SlotManager(animationData) {
        this.animationData = animationData;
    }
    SlotManager.prototype.getProp = function(data) {
        if (this.animationData.slots && this.animationData.slots[data.sid]) return Object.assign(data, this.animationData.slots[data.sid].p);
        return data;
    };
    function slotFactory(animationData) {
        return new SlotManager(animationData);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false; // layer's display state
            this.hidden = false; // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false; // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
            this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits(num) {
            if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable() {
            var i;
            var len = this.renderableComponents.length;
            for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        };
        return function(mode) {
            return blendModeEnums[mode] || "";
        };
    }();
    function SliderEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function AngleEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function ColorEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function PointEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function LayerIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function MaskIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function CheckboxEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data, element) {
        var effects = data.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for(i = 0; i < len; i += 1){
            effectItem = new GroupEffect(effects[i], element);
            this.effectElements.push(effectItem);
        }
    }
    function GroupEffect(data, element) {
        this.init(data, element);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data, element) {
        this.data = data;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for(i = 0; i < len; i += 1){
            eff = null;
            switch(effects[i].ty){
                case 0:
                    eff = new SliderEffect(effects[i], element, this);
                    break;
                case 1:
                    eff = new AngleEffect(effects[i], element, this);
                    break;
                case 2:
                    eff = new ColorEffect(effects[i], element, this);
                    break;
                case 3:
                    eff = new PointEffect(effects[i], element, this);
                    break;
                case 4:
                case 7:
                    eff = new CheckboxEffect(effects[i], element, this);
                    break;
                case 10:
                    eff = new LayerIndexEffect(effects[i], element, this);
                    break;
                case 11:
                    eff = new MaskIndexEffect(effects[i], element, this);
                    break;
                case 5:
                    eff = new EffectsManager(effects[i], element, this);
                    break;
                // case 6:
                default:
                    eff = new NoValueEffect(effects[i], element, this);
                    break;
            }
            if (eff) this.effectElements.push(eff);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks() {
            if (!this.data.hasMask) return false;
            var i = 0;
            var len = this.data.masksProperties.length;
            while(i < len){
                if (this.data.masksProperties[i].mode !== "n" && this.data.masksProperties[i].cl !== false) return true;
                i += 1;
            }
            return false;
        },
        initExpressions: function initExpressions() {
            var expressionsInterfaces = getExpressionInterfaces();
            if (!expressionsInterfaces) return;
            var LayerExpressionInterface = expressionsInterfaces("layer");
            var EffectsExpressionInterface = expressionsInterfaces("effects");
            var ShapeExpressionInterface = expressionsInterfaces("shape");
            var TextExpressionInterface = expressionsInterfaces("text");
            var CompExpressionInterface = expressionsInterfaces("comp");
            this.layerInterface = LayerExpressionInterface(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode() {
            var blendModeValue = getBlendMode(this.data.bm);
            var elem = this.baseElement || this.layerElement;
            elem.style["mix-blend-mode"] = blendModeValue;
        },
        initBaseData: function initBaseData(data, globalData, comp) {
            this.globalData = globalData;
            this.comp = comp;
            this.data = data;
            this.layerId = createElementID(); // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
             // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false; // list of animated properties
            this.dynamicProperties = []; // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties(num, isVisible) {
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === "transform") {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
        }
    };
    function FootageElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.footageData = globalData.imageLoader.getAsset(this.assetData);
        this.initBaseData(data, globalData, comp);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces = getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        var FootageInterface = expressionsInterfaces("footage");
        this.layerInterface = FootageInterface(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.initBaseData(data, globalData, comp);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            this._currentTime = timeRemapped;
        } else this._currentTime = num / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
            this._previousVolume = totalVolume;
            this.audio.volume(totalVolume);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {};
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
    };
    AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data;
        this.completeLayers = true;
        for(i = len - 1; i >= 0; i -= 1){
            if (!this.elements[i]) {
                data = this.layers[i];
                if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
            }
            this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer) {
        switch(layer.ty){
            case 2:
                return this.createImage(layer);
            case 0:
                return this.createComp(layer);
            case 1:
                return this.createSolid(layer);
            case 3:
                return this.createNull(layer);
            case 4:
                return this.createShape(layer);
            case 5:
                return this.createText(layer);
            case 6:
                return this.createAudio(layer);
            case 13:
                return this.createCamera(layer);
            case 15:
                return this.createFootage(layer);
            default:
                return this.createNull(layer);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error("You're using a 3d camera. Try the html renderer.");
    };
    BaseRenderer.prototype.createAudio = function(data) {
        return new AudioElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data) {
        return new FootageElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)this.buildItem(i);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for(i = 0; i < len; i += 1){
            j = 0;
            while(j < jLen){
                if (this.layers[j].id === newLayers[i].id) {
                    this.layers[j] = newLayers[i];
                    break;
                }
                j += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while(i < len){
            if (layers[i].ind == parentName) {
                // eslint-disable-line eqeqeq
                if (!elements[i] || elements[i] === true) {
                    this.buildItem(i);
                    this.addPendingElement(element);
                } else {
                    hierarchy.push(elements[i]);
                    elements[i].setAsParent();
                    if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                    else element.setHierarchy(hierarchy);
                }
            }
            i += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i]);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind) {
        var i;
        var len = this.elements.length;
        for(i = 0; i < len; i += 1){
            if (this.elements[i].data.ind === ind) return this.elements[i];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path) {
        var pathValue = path.shift();
        var element;
        if (typeof pathValue === "number") element = this.elements[pathValue];
        else {
            var i;
            var len = this.elements.length;
            for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
                element = this.elements[i];
                break;
            }
        }
        if (path.length === 0) return element;
        return element.getElementByPath(path);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData);
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
            w: animData.w,
            h: animData.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: "transformEFfect"
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform() {
            var mat = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat,
                localMat: mat,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
             // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat;
                var finalMat = this.finalTransform.mat;
                var i = 0;
                var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i < len){
                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat = this.finalTransform.mProp.v.props;
                    finalMat.cloneFromProps(mat);
                    for(i = 0; i < len; i += 1)finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
                }
            }
            if (this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform() {
            if (this.localTransforms) {
                var i = 0;
                var len = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i < len){
                    if (this.localTransforms[i]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                        this.finalTransform._opMdf = true;
                    }
                    i += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat);
                    for(i = 1; i < len; i += 1){
                        var lmat = this.localTransforms[i].matrix;
                        localMat.multiply(lmat);
                    }
                    localMat.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp = this.finalTransform.localOpacity;
                    for(i = 0; i < len; i += 1)localOp *= this.localTransforms[i].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms() {
            if (this.renderableEffectsManager) {
                var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i = 0;
                    var len = transformEffects.length;
                    for(i = 0; i < len; i += 1)this.localTransforms.push(transformEffects[i]);
                }
            }
        },
        globalToLocal: function globalToLocal(pt) {
            var transforms = [];
            transforms.push(this.finalTransform);
            var flag = true;
            var comp = this.comp;
            while(flag)if (comp.finalTransform) {
                if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
                comp = comp.comp;
            } else flag = false;
            var i;
            var len = transforms.length;
            var ptNew;
            for(i = 0; i < len; i += 1){
                ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt = [
                    pt[0] - ptNew[0],
                    pt[1] - ptNew[1],
                    0
                ];
            }
            return pt;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data, element, globalData) {
        this.data = data;
        this.element = element;
        this.globalData = globalData;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = "";
        var path;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x;
        var maskType = "clipPath";
        var maskRef = "clip-path";
        for(i = 0; i < len; i += 1){
            if (properties[i].mode !== "a" && properties[i].mode !== "n" || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
                maskType = "mask";
                maskRef = "mask";
            }
            if ((properties[i].mode === "s" || properties[i].mode === "i") && count === 0) {
                rect = createNS("rect");
                rect.setAttribute("fill", "#ffffff");
                rect.setAttribute("width", this.element.comp.data.w || 0);
                rect.setAttribute("height", this.element.comp.data.h || 0);
                currentMasks.push(rect);
            } else rect = null;
            path = createNS("path");
            if (properties[i].mode === "n") {
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    elem: path,
                    lastPath: ""
                };
                defs.appendChild(path);
            } else {
                count += 1;
                path.setAttribute("fill", properties[i].mode === "s" ? "#000000" : "#ffffff");
                path.setAttribute("clip-rule", "nonzero");
                var filterID;
                if (properties[i].x.k !== 0) {
                    maskType = "mask";
                    maskRef = "mask";
                    x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                    filterID = createElementID();
                    expansor = createNS("filter");
                    expansor.setAttribute("id", filterID);
                    feMorph = createNS("feMorphology");
                    feMorph.setAttribute("operator", "erode");
                    feMorph.setAttribute("in", "SourceGraphic");
                    feMorph.setAttribute("radius", "0");
                    expansor.appendChild(feMorph);
                    defs.appendChild(expansor);
                    path.setAttribute("stroke", properties[i].mode === "s" ? "#000000" : "#ffffff");
                } else {
                    feMorph = null;
                    x = null;
                } // TODO move this to a factory or to a constructor
                this.storedData[i] = {
                    elem: path,
                    x: x,
                    expan: feMorph,
                    lastPath: "",
                    lastOperator: "",
                    filterId: filterID,
                    lastRadius: 0
                };
                if (properties[i].mode === "i") {
                    jLen = currentMasks.length;
                    var g = createNS("g");
                    for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                    var mask = createNS("mask");
                    mask.setAttribute("mask-type", "alpha");
                    mask.setAttribute("id", layerId + "_" + count);
                    mask.appendChild(path);
                    defs.appendChild(mask);
                    g.setAttribute("mask", "url(" + getLocationHref() + "#" + layerId + "_" + count + ")");
                    currentMasks.length = 0;
                    currentMasks.push(g);
                } else currentMasks.push(path);
                if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                 // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    elem: path,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    invRect: rect
                };
                if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
        if (count > 0) {
            this.maskElement.setAttribute("id", layerId);
            this.element.maskedElement.setAttribute(maskRef, "url(" + getLocationHref() + "#" + layerId + ")");
            defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for(i = 0; i < len; i += 1){
            if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
            if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute("fill-opacity", this.viewData[i].op.v);
            if (this.masksProperties[i].mode !== "n") {
                if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute("transform", finalMat.getInverseMatrix().to2dCSS());
                if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                    var feMorph = this.storedData[i].expan;
                    if (this.storedData[i].x.v < 0) {
                        if (this.storedData[i].lastOperator !== "erode") {
                            this.storedData[i].lastOperator = "erode";
                            this.storedData[i].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[i].filterId + ")");
                        }
                        feMorph.setAttribute("radius", -this.storedData[i].x.v);
                    } else {
                        if (this.storedData[i].lastOperator !== "dilate") {
                            this.storedData[i].lastOperator = "dilate";
                            this.storedData[i].elem.setAttribute("filter", null);
                        }
                        this.storedData[i].elem.setAttribute("stroke-width", this.storedData[i].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path = "M0,0 ";
        path += " h" + this.globalData.compSize.w;
        path += " v" + this.globalData.compSize.h;
        path += " h-" + this.globalData.compSize.w;
        path += " v-" + this.globalData.compSize.h + " ";
        return path;
    };
    MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = " M" + pathNodes.v[0][0] + "," + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += " C" + pathNodes.o[i - 1][0] + "," + pathNodes.o[i - 1][1] + " " + pathNodes.i[i][0] + "," + pathNodes.i[i][1] + " " + pathNodes.v[i][0] + "," + pathNodes.v[i][1];
         // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes.c && len > 1) pathString += " C" + pathNodes.o[i - 1][0] + "," + pathNodes.o[i - 1][1] + " " + pathNodes.i[0][0] + "," + pathNodes.i[0][1] + " " + pathNodes.v[0][0] + "," + pathNodes.v[0][1];
         // pathNodes.__renderedString = pathString;
        if (viewData.lastPath !== pathString) {
            var pathShapeValue = "";
            if (viewData.elem) {
                if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
                viewData.elem.setAttribute("d", pathShapeValue);
            }
            viewData.lastPath = pathString;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob = {};
        ob.createFilter = createFilter;
        ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
            var fil = createNS("filter");
            fil.setAttribute("id", filId);
            if (skipCoordinates !== true) {
                fil.setAttribute("filterUnits", "objectBoundingBox");
                fil.setAttribute("x", "0%");
                fil.setAttribute("y", "0%");
                fil.setAttribute("width", "100%");
                fil.setAttribute("height", "100%");
            }
            return fil;
        }
        function createAlphaToLuminanceFilter() {
            var feColorMatrix = createNS("feColorMatrix");
            feColorMatrix.setAttribute("type", "matrix");
            feColorMatrix.setAttribute("color-interpolation-filters", "sRGB");
            feColorMatrix.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1");
            return feColorMatrix;
        }
        return ob;
    }();
    var featureSupport = function() {
        var ob = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== "undefined"
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob.svgLumaHidden = false;
        return ob;
    }();
    var registeredEffects$1 = {};
    var idPrefix = "filter_result_";
    function SVGEffects(elem) {
        var i;
        var source = "SourceGraphic";
        var len = elem.data.ef ? elem.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects$1[type]) {
                var Effect = registeredEffects$1[type].effect;
                filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
                source = idPrefix + count;
                if (registeredEffects$1[type].countsAsEffect) count += 1;
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (count) {
            elem.globalData.defs.appendChild(fil);
            elem.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + filId + ")");
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    SVGEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect$1(id, effect, countsAsEffect) {
        registeredEffects$1[id] = {
            effect: effect,
            countsAsEffect: countsAsEffect
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
            this.layerElement = createNS("g");
        },
        createContainerElements: function createContainerElements() {
            this.matteElement = createNS("g");
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent = null; // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg = createNS("g");
                gg.setAttribute("id", this.layerId);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                this.globalData.defs.appendChild(gg);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute("id", this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute("class", this.data.cl);
             // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp = createNS("clipPath");
                var pt = createNS("path");
                pt.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                var clipId = createElementID();
                cp.setAttribute("id", clipId);
                cp.appendChild(pt);
                this.globalData.defs.appendChild(cp);
                if (this.checkMasks()) {
                    var cpGroup = createNS("g");
                    cpGroup.setAttribute("clip-path", "url(" + getLocationHref() + "#" + clipId + ")");
                    cpGroup.appendChild(this.layerElement);
                    this.transformedElement = cpGroup;
                    if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + clipId + ")");
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte(matteType) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType]) {
                var id = this.layerId + "_" + matteType;
                var filId;
                var fil;
                var useElement;
                var gg;
                if (matteType === 1 || matteType === 3) {
                    var masker = createNS("mask");
                    masker.setAttribute("id", id);
                    masker.setAttribute("mask-type", matteType === 3 ? "luminance" : "alpha");
                    useElement = createNS("use");
                    useElement.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId);
                    masker.appendChild(useElement);
                    this.globalData.defs.appendChild(masker);
                    if (!featureSupport.maskType && matteType === 1) {
                        masker.setAttribute("mask-type", "luminance");
                        filId = createElementID();
                        fil = filtersFactory.createFilter(filId);
                        this.globalData.defs.appendChild(fil);
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS("g");
                        gg.appendChild(useElement);
                        masker.appendChild(gg);
                        gg.setAttribute("filter", "url(" + getLocationHref() + "#" + filId + ")");
                    }
                } else if (matteType === 2) {
                    var maskGroup = createNS("mask");
                    maskGroup.setAttribute("id", id);
                    maskGroup.setAttribute("mask-type", "alpha");
                    var maskGrouper = createNS("g");
                    maskGroup.appendChild(maskGrouper);
                    filId = createElementID();
                    fil = filtersFactory.createFilter(filId); /// /
                    var feCTr = createNS("feComponentTransfer");
                    feCTr.setAttribute("in", "SourceGraphic");
                    fil.appendChild(feCTr);
                    var feFunc = createNS("feFuncA");
                    feFunc.setAttribute("type", "table");
                    feFunc.setAttribute("tableValues", "1.0 0.0");
                    feCTr.appendChild(feFunc); /// /
                    this.globalData.defs.appendChild(fil);
                    var alphaRect = createNS("rect");
                    alphaRect.setAttribute("width", this.comp.data.w);
                    alphaRect.setAttribute("height", this.comp.data.h);
                    alphaRect.setAttribute("x", "0");
                    alphaRect.setAttribute("y", "0");
                    alphaRect.setAttribute("fill", "#ffffff");
                    alphaRect.setAttribute("opacity", "0");
                    maskGrouper.setAttribute("filter", "url(" + getLocationHref() + "#" + filId + ")");
                    maskGrouper.appendChild(alphaRect);
                    useElement = createNS("use");
                    useElement.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId);
                    maskGrouper.appendChild(useElement);
                    if (!featureSupport.maskType) {
                        maskGroup.setAttribute("mask-type", "luminance");
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS("g");
                        maskGrouper.appendChild(alphaRect);
                        gg.appendChild(this.layerElement);
                        maskGrouper.appendChild(gg);
                    }
                    this.globalData.defs.appendChild(maskGroup);
                }
                this.matteMasks[matteType] = id;
            }
            return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + id + ")");
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy() {
            // element's parent list
            this.hierarchy = []; // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy(hierarchy) {
            this.hierarchy = hierarchy;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype = {
            initElement: function initElement(data, globalData, comp) {
                this.initFrame();
                this.initBaseData(data, globalData, comp);
                this.initTransform(data, globalData, comp);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = "none";
                    this.hidden = true;
                }
            },
            show: function show() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem = this.baseElement || this.layerElement;
                        elem.style.display = "block";
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent() {},
            prepareFrame: function prepareFrame(num) {
                this._mdf = false;
                this.prepareRenderableFrame(num);
                this.prepareProperties(num, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype)
        ], RenderableDOMElement);
    })();
    function IImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData.slotManager.getProp(this.assetData);
        this.initElement(data, globalData, comp);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS("image");
        this.innerElem.setAttribute("width", this.assetData.w + "px");
        this.innerElem.setAttribute("height", this.assetData.h + "px");
        this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", assetPath);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element, position) {
        this.elem = element;
        this.pos = position;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data) {
            var i;
            var len = this.shapeModifiers.length;
            for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
            var i = 0;
            var len = this.shapeModifiers.length;
            while(i < len){
                if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers() {
            if (!this.shapeModifiers.length) return;
            var i;
            var len = this.shapes.length;
            for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
            len = this.shapeModifiers.length;
            var shouldBreakProcess;
            for(i = len - 1; i >= 0; i -= 1){
                shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess) break;
            }
        },
        searchProcessedElement: function searchProcessedElement(elem) {
            var elements = this.processedElements;
            var i = 0;
            var len = elements.length;
            while(i < len){
                if (elements[i].elem === elem) return elements[i].pos;
                i += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement(elem, pos) {
            var elements = this.processedElements;
            var i = elements.length;
            while(i){
                i -= 1;
                if (elements[i].elem === elem) {
                    elements[i].pos = pos;
                    return;
                }
            }
            elements.push(new ProcessedElement(elem, pos));
        },
        prepareFrame: function prepareFrame(num) {
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: "butt",
        2: "round",
        3: "square"
    };
    var lineJoinEnum = {
        1: "miter",
        2: "round",
        3: "bevel"
    };
    function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = "";
        this.sh = shape;
        this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated
        var i = 0;
        var len = transformers.length;
        while(i < len){
            if (transformers[i].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data, level) {
        this.data = data;
        this.type = data.ty;
        this.d = "";
        this.lvl = level;
        this._mdf = false;
        this.closed = data.hd === true;
        this.pElem = createNS("path");
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = "";
        this._mdf = false;
    };
    function DashProperty(elem, data, renderer, container) {
        this.elem = elem;
        this.frameId = -1;
        this.dataProps = createSizedArray(data.length);
        this.renderer = renderer;
        this.k = false;
        this.dashStr = "";
        this.dashArray = createTypedArray("float32", data.length ? data.length - 1 : 0);
        this.dashoffset = createTypedArray("float32", 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data.length || 0;
        var prop;
        for(i = 0; i < len; i += 1){
            prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
            this.k = prop.k || this.k;
            this.dataProps[i] = {
                n: data[i].n,
                p: prop
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
            var i = 0;
            var len = this.dataProps.length;
            if (this.renderer === "svg") this.dashStr = "";
            for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== "o") {
                if (this.renderer === "svg") this.dashStr += " " + this.dataProps[i].p.v;
                else this.dashArray[i] = this.dataProps[i].p.v;
            } else this.dashoffset[0] = this.dataProps[i].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, "svg", this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem, data, container) {
        this.data = data;
        this.c = createTypedArray("uint8c", data.p * 4);
        var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
        this.o = createTypedArray("float32", cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while(i < len){
            diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
            if (diff > 0.01) return false;
            i += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i = 0;
            var len = this.data.k.k.length;
            while(i < len){
                if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
                i += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
            var i;
            var len = this.data.p * 4;
            var mult;
            var val;
            for(i = 0; i < len; i += 1){
                mult = i % 4 === 0 ? 100 : 255;
                val = Math.round(this.prop.v[i] * mult);
                if (this.c[i] !== val) {
                    this.c[i] = val;
                    this._cmdf = !forceRender;
                }
            }
            if (this.o.length) {
                len = this.prop.v.length;
                for(i = this.data.p * 4; i < len; i += 1){
                    mult = i % 2 === 0 ? 100 : 1;
                    val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                    if (this.o[i - this.data.p * 4] !== val) {
                        this.o[i - this.data.p * 4] = val;
                        this._omdf = !forceRender;
                    }
                }
            }
            this._mdf = !forceRender;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem, data, styleOb);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem, data.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem, data.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem, data.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data);
        this.setGradientOpacity(data, styleOb);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
        var gradientId = createElementID();
        var gfill = createNS(data.t === 1 ? "linearGradient" : "radialGradient");
        gfill.setAttribute("id", gradientId);
        gfill.setAttribute("spreadMethod", "pad");
        gfill.setAttribute("gradientUnits", "userSpaceOnUse");
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data.g.p * 4;
        for(j = 0; j < jLen; j += 4){
            stop = createNS("stop");
            gfill.appendChild(stop);
            stops.push(stop);
        }
        pathElement.setAttribute(data.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + gradientId + ")");
        this.gf = gfill;
        this.cst = stops;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop;
            var j;
            var jLen;
            var mask = createNS("mask");
            var maskElement = createNS("path");
            mask.appendChild(maskElement);
            var opacityId = createElementID();
            var maskId = createElementID();
            mask.setAttribute("id", maskId);
            var opFill = createNS(data.t === 1 ? "linearGradient" : "radialGradient");
            opFill.setAttribute("id", opacityId);
            opFill.setAttribute("spreadMethod", "pad");
            opFill.setAttribute("gradientUnits", "userSpaceOnUse");
            jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
            var stops = this.stops;
            for(j = data.g.p * 4; j < jLen; j += 2){
                stop = createNS("stop");
                stop.setAttribute("stop-color", "rgb(255,255,255)");
                opFill.appendChild(stop);
                stops.push(stop);
            }
            maskElement.setAttribute(data.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + opacityId + ")");
            if (data.ty === "gs") {
                maskElement.setAttribute("stroke-linecap", lineCapEnum[data.lc || 2]);
                maskElement.setAttribute("stroke-linejoin", lineJoinEnum[data.lj || 2]);
                if (data.lj === 1) maskElement.setAttribute("stroke-miterlimit", data.ml);
            }
            this.of = opFill;
            this.ms = mask;
            this.ost = stops;
            this.maskId = maskId;
            styleOb.msElem = maskElement;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, "svg", this);
        this.initGradientData(elem, data, styleOb);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS("g");
    }
    function SVGTransformData(mProps, op, container) {
        this.transform = {
            mProps: mProps,
            op: op,
            container: container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
        if (length === 0) return "";
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = " M" + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for(i = 1; i < length; i += 1)shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[i][0], _i[i][1]) + " " + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        if (closed && length) {
            shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[0][0], _i[0][1]) + " " + mat.applyToPointStringified(_v[0][0], _v[0][1]);
            shapeString += "z";
        }
        return shapeString;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob = {
            createRenderFunction: createRenderFunction
        };
        function createRenderFunction(data) {
            switch(data.ty){
                case "fl":
                    return renderFill;
                case "gf":
                    return renderGradient;
                case "gs":
                    return renderGradientStroke;
                case "st":
                    return renderStroke;
                case "sh":
                case "el":
                case "rc":
                case "sr":
                    return renderPath;
                case "tr":
                    return renderContentTransform;
                case "no":
                    return renderNoop;
                default:
                    return null;
            }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
            if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute("opacity", itemData.transform.op.v);
            if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute("transform", itemData.transform.mProps.v.to2dCSS());
        }
        function renderNoop() {}
        function renderPath(styleData, itemData, isFirstFrame) {
            var j;
            var jLen;
            var pathStringTransformed;
            var redraw;
            var pathNodes;
            var l;
            var lLen = itemData.styles.length;
            var lvl = itemData.lvl;
            var paths;
            var mat;
            var iterations;
            var k;
            for(l = 0; l < lLen; l += 1){
                redraw = itemData.sh._mdf || isFirstFrame;
                if (itemData.styles[l].lvl < lvl) {
                    mat = _matrixHelper.reset();
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(!redraw && iterations > 0){
                        redraw = itemData.transformers[k].mProps._mdf || redraw;
                        iterations -= 1;
                        k -= 1;
                    }
                    if (redraw) {
                        iterations = lvl - itemData.styles[l].lvl;
                        k = itemData.transformers.length - 1;
                        while(iterations > 0){
                            mat.multiply(itemData.transformers[k].mProps.v);
                            iterations -= 1;
                            k -= 1;
                        }
                    }
                } else mat = _identityMatrix;
                paths = itemData.sh.paths;
                jLen = paths._length;
                if (redraw) {
                    pathStringTransformed = "";
                    for(j = 0; j < jLen; j += 1){
                        pathNodes = paths.shapes[j];
                        if (pathNodes && pathNodes._length) pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else pathStringTransformed = itemData.caches[l];
                itemData.styles[l].d += styleData.hd === true ? "" : pathStringTransformed;
                itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
            }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute("fill", "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")");
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute("fill-opacity", itemData.o.v);
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
            renderGradient(styleData, itemData, isFirstFrame);
            renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
            var gfill = itemData.gf;
            var hasOpacity = itemData.g._hasOpacity;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (itemData.o._mdf || isFirstFrame) {
                var attr = styleData.ty === "gf" ? "fill-opacity" : "stroke-opacity";
                itemData.style.pElem.setAttribute(attr, itemData.o.v);
            }
            if (itemData.s._mdf || isFirstFrame) {
                var attr1 = styleData.t === 1 ? "x1" : "cx";
                var attr2 = attr1 === "x1" ? "y1" : "cy";
                gfill.setAttribute(attr1, pt1[0]);
                gfill.setAttribute(attr2, pt1[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute(attr1, pt1[0]);
                    itemData.of.setAttribute(attr2, pt1[1]);
                }
            }
            var stops;
            var i;
            var len;
            var stop;
            if (itemData.g._cmdf || isFirstFrame) {
                stops = itemData.cst;
                var cValues = itemData.g.c;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    stop.setAttribute("offset", cValues[i * 4] + "%");
                    stop.setAttribute("stop-color", "rgb(" + cValues[i * 4 + 1] + "," + cValues[i * 4 + 2] + "," + cValues[i * 4 + 3] + ")");
                }
            }
            if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
                var oValues = itemData.g.o;
                if (itemData.g._collapsable) stops = itemData.cst;
                else stops = itemData.ost;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    if (!itemData.g._collapsable) stop.setAttribute("offset", oValues[i * 2] + "%");
                    stop.setAttribute("stop-opacity", oValues[i * 2 + 1]);
                }
            }
            if (styleData.t === 1) {
                if (itemData.e._mdf || isFirstFrame) {
                    gfill.setAttribute("x2", pt2[0]);
                    gfill.setAttribute("y2", pt2[1]);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute("x2", pt2[0]);
                        itemData.of.setAttribute("y2", pt2[1]);
                    }
                }
            } else {
                var rad;
                if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                    rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    gfill.setAttribute("r", rad);
                    if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute("r", rad);
                }
                if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                    if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                    var percent = itemData.h.v;
                    if (percent >= 1) percent = 0.99;
                    else if (percent <= -1) percent = -0.99;
                    var dist = rad * percent;
                    var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                    var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                    gfill.setAttribute("fx", x);
                    gfill.setAttribute("fy", y);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute("fx", x);
                        itemData.of.setAttribute("fy", y);
                    }
                } // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            var d = itemData.d;
            if (d && (d._mdf || isFirstFrame) && d.dashStr) {
                styleElem.pElem.setAttribute("stroke-dasharray", d.dashStr);
                styleElem.pElem.setAttribute("stroke-dashoffset", d.dashoffset[0]);
            }
            if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute("stroke", "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")");
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute("stroke-opacity", itemData.o.v);
            if (itemData.w._mdf || isFirstFrame) {
                styleElem.pElem.setAttribute("stroke-width", itemData.w.v);
                if (styleElem.msElem) styleElem.msElem.setAttribute("stroke-width", itemData.w.v);
            }
        }
        return ob;
    }();
    function SVGShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for(j = 0; j < jLen; j += 1){
            style = this.stylesList[j];
            areAnimated = false;
            tempShapes.length = 0;
            for(i = 0; i < len; i += 1){
                shape = this.shapes[i];
                if (shape.styles.indexOf(style) !== -1) {
                    tempShapes.push(shape);
                    areAnimated = shape._isAnimated || areAnimated;
                }
            }
            if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data, level) {
        // TODO: prevent drawing of hidden styles
        var elementData;
        var styleOb = new SVGStyleData(data, level);
        var pathElement = styleOb.pElem;
        if (data.ty === "st") elementData = new SVGStrokeStyleData(this, data, styleOb);
        else if (data.ty === "fl") elementData = new SVGFillStyleData(this, data, styleOb);
        else if (data.ty === "gf" || data.ty === "gs") {
            var GradientConstructor = data.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData = new GradientConstructor(this, data, styleOb);
            this.globalData.defs.appendChild(elementData.gf);
            if (elementData.maskId) {
                this.globalData.defs.appendChild(elementData.ms);
                this.globalData.defs.appendChild(elementData.of);
                pathElement.setAttribute("mask", "url(" + getLocationHref() + "#" + elementData.maskId + ")");
            }
        } else if (data.ty === "no") elementData = new SVGNoStyleData(this, data, styleOb);
        if (data.ty === "st" || data.ty === "gs") {
            pathElement.setAttribute("stroke-linecap", lineCapEnum[data.lc || 2]);
            pathElement.setAttribute("stroke-linejoin", lineJoinEnum[data.lj || 2]);
            pathElement.setAttribute("fill-opacity", "0");
            if (data.lj === 1) pathElement.setAttribute("stroke-miterlimit", data.ml);
        }
        if (data.r === 2) pathElement.setAttribute("fill-rule", "evenodd");
        if (data.ln) pathElement.setAttribute("id", data.ln);
        if (data.cl) pathElement.setAttribute("class", data.cl);
        if (data.bm) pathElement.style["mix-blend-mode"] = getBlendMode(data.bm);
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createGroupElement = function(data) {
        var elementData = new ShapeGroupData();
        if (data.ln) elementData.gr.setAttribute("id", data.ln);
        if (data.cl) elementData.gr.setAttribute("class", data.cl);
        if (data.bm) elementData.gr.style["mix-blend-mode"] = getBlendMode(data.bm);
        return elementData;
    };
    SVGShapeElement.prototype.createTransformElement = function(data, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
        var ty = 4;
        if (data.ty === "rc") ty = 5;
        else if (data.ty === "el") ty = 6;
        else if (data.ty === "sr") ty = 7;
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while(i < len){
            if (this.animatedContents[i].element === element) return;
            i += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data),
            element: element,
            data: data
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for(j = 0; j < jLen; j += 1)if (!this.stylesList[j].closed) arr.push(this.stylesList[j]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._render = render;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === "fl" || arr[i].ty === "st" || arr[i].ty === "gf" || arr[i].ty === "gs" || arr[i].ty === "no") {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
                else itemsData[i].style.closed = false;
                if (arr[i]._render) {
                    if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
                }
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === "gr") {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
                if (arr[i]._render) {
                    if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
                }
            } else if (arr[i].ty === "tr") {
                if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
                currentTransform = itemsData[i].transform;
                ownTransformers.push(currentTransform);
            } else if (arr[i].ty === "sh" || arr[i].ty === "rc" || arr[i].ty === "el" || arr[i].ty === "sr") {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
                this.setElementStyles(itemsData[i]);
            } else if (arr[i].ty === "tm" || arr[i].ty === "rd" || arr[i].ty === "ms" || arr[i].ty === "pb" || arr[i].ty === "zz" || arr[i].ty === "op") {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === "rp") {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    render = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)this.stylesList[i].reset();
        this.renderShape();
        for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
                this.stylesList[i].msElem.setAttribute("d", this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i].d = "M0 0" + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute("d", this.stylesList[i].d || "M0 0");
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for(i = 0; i < len; i += 1){
            animatedContent = this.animatedContents[i];
            if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
            o: true,
            sw: !!sw,
            sc: !!sc,
            fc: !!fc,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
            this.o = o;
            this._mdf.o = true;
            updated = true;
        }
        if (this.sw !== sw) {
            this.sw = sw;
            this._mdf.sw = true;
            updated = true;
        }
        if (this.sc !== sc) {
            this.sc = sc;
            this._mdf.sc = true;
            updated = true;
        }
        if (this.fc !== fc) {
            this.fc = fc;
            this._mdf.fc = true;
            updated = true;
        }
        if (this.m !== m) {
            this.m = m;
            this._mdf.m = true;
            updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
            this.p = p;
            this._mdf.p = true;
            updated = true;
        }
        return updated;
    };
    function TextProperty(elem, data) {
        this._frameId = initialDefaultFrame;
        this.pv = "";
        this.v = "";
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data.d && data.d.sid) data.d = elem.globalData.slotManager.getProp(data.d);
        this.data = data;
        this.elem = elem;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: "",
            fStyle: "",
            fWeight: "",
            fc: "",
            j: "",
            justifyOffset: "",
            l: [],
            lh: 0,
            lineWidths: [],
            ls: "",
            of: "",
            s: "",
            sc: "",
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj, data) {
        for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
        return obj;
    };
    TextProperty.prototype.setCurrentData = function(data) {
        if (!data.__complete) this.completeTextData(data);
        this.currentData = data;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
        else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
        if (currentValue !== finalValue) this.setCurrentData(finalValue);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while(i <= len - 1){
            if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
            i += 1;
        }
        if (this.keysIndex !== i) this.keysIndex = i;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text) {
        var charactersArray = [];
        var i = 0;
        var len = text.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        var shouldCombineNext = false;
        var currentChars = "";
        while(i < len){
            shouldCombine = shouldCombineNext;
            shouldCombineNext = false;
            charCode = text.charCodeAt(i);
            currentChars = text.charAt(i);
            if (FontManager.isCombinedCharacter(charCode)) shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
            else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                if (FontManager.isRegionalFlag(text, i)) currentChars = text.substr(i, 14);
                else {
                    secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)
                    if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                        if (FontManager.isModifier(charCode, secondCharCode)) {
                            currentChars = text.substr(i, 2);
                            shouldCombine = true;
                        } else if (FontManager.isFlagEmoji(text.substr(i, 4))) currentChars = text.substr(i, 4);
                        else currentChars = text.substr(i, 2);
                    }
                }
            } else if (charCode > 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (FontManager.isVariationSelector(charCode)) shouldCombine = true;
            } else if (FontManager.isZeroWidthJoiner(charCode)) {
                shouldCombine = true;
                shouldCombineNext = true;
            }
            if (shouldCombine) {
                charactersArray[charactersArray.length - 1] += currentChars;
                shouldCombine = false;
            } else charactersArray.push(currentChars);
            i += currentChars.length;
        }
        return charactersArray;
    };
    TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index = 0;
        var val;
        var anchorGrouping = data.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
            var flag = true;
            var boxWidth = documentData.sz[0];
            var boxHeight = documentData.sz[1];
            var currentHeight;
            var finalText;
            while(flag){
                finalText = this.buildFinalText(documentData.t);
                currentHeight = 0;
                lineWidth = 0;
                len = finalText.length;
                trackingOffset = documentData.tr / 1000 * documentData.finalSize;
                var lastSpaceIndex = -1;
                for(i = 0; i < len; i += 1){
                    charCode = finalText[i].charCodeAt(0);
                    newLineFlag = false;
                    if (finalText[i] === " ") lastSpaceIndex = i;
                    else if (charCode === 13 || charCode === 3) {
                        lineWidth = 0;
                        newLineFlag = true;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    }
                    if (fontManager.chars) {
                        charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                    if (lineWidth + cLength > boxWidth && finalText[i] !== " ") {
                        if (lastSpaceIndex === -1) len += 1;
                        else i = lastSpaceIndex;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                        finalText.splice(i, lastSpaceIndex === i ? 1 : 0, "\r"); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    } else {
                        lineWidth += cLength;
                        lineWidth += trackingOffset;
                    }
                }
                currentHeight += fontData.ascent * documentData.finalSize / 100;
                if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                    documentData.finalSize -= 1;
                    documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
                } else {
                    documentData.finalText = finalText;
                    len = documentData.finalText.length;
                    flag = false;
                }
            }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for(i = 0; i < len; i += 1){
            newLineFlag = false;
            currentChar = documentData.finalText[i];
            charCode = currentChar.charCodeAt(0);
            if (charCode === 13 || charCode === 3) {
                uncollapsedSpaces = 0;
                lineWidths.push(lineWidth);
                maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                lineWidth = -2 * trackingOffset;
                val = "";
                newLineFlag = true;
                currentLine += 1;
            } else val = currentChar;
            if (fontManager.chars) {
                charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
             //
            if (currentChar === " ") uncollapsedSpaces += cLength + trackingOffset;
            else {
                lineWidth += cLength + trackingOffset + uncollapsedSpaces;
                uncollapsedSpaces = 0;
            }
            letters.push({
                l: cLength,
                an: cLength,
                add: currentSize,
                n: newLineFlag,
                anIndexes: [],
                val: val,
                line: currentLine,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping == 2) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === "" || val === " " || i === len - 1) {
                    if (val === "" || val === " ") currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    index += 1;
                    currentSize = 0;
                }
            } else if (anchorGrouping == 3) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === "" || i === len - 1) {
                    if (val === "") currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    currentSize = 0;
                    index += 1;
                }
            } else {
                letters[index].ind = index;
                letters[index].extra = 0;
                index += 1;
            }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
            documentData.boxWidth = documentData.sz[0];
            documentData.justifyOffset = 0;
        } else {
            documentData.boxWidth = maxLineWidth;
            switch(documentData.j){
                case 1:
                    documentData.justifyOffset = -documentData.boxWidth;
                    break;
                case 2:
                    documentData.justifyOffset = -documentData.boxWidth / 2;
                    break;
                default:
                    documentData.justifyOffset = 0;
            }
        }
        documentData.lineWidths = lineWidths;
        var animators = data.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for(j = 0; j < jLen; j += 1){
            animatorData = animators[j];
            if (animatorData.a.sc) documentData.strokeColorAnim = true;
            if (animatorData.a.sw) documentData.strokeWidthAnim = true;
            if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
            ind = 0;
            based = animatorData.s.b;
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                letterData.anIndexes[j] = ind;
                if (based == 1 && letterData.val !== "" || based == 2 && letterData.val !== "" && letterData.val !== " " || based == 3 && (letterData.n || letterData.val == " " || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData.s.rn === 1) indexes.push(ind);
                    ind += 1;
                }
            }
            data.a[j].s.totalChars = ind;
            var currentInd = -1;
            var newInd;
            if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if (currentInd != letterData.anIndexes[j]) {
                    // eslint-disable-line eqeqeq
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData, index) {
        index = index === undefined ? this.keysIndex : index;
        var dData = this.copyData({}, this.data.d.k[index].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index].s = dData;
        this.recalculate(index);
        this.setCurrentData(dData);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index) {
        var dData = this.data.d.k[index].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
    };
    TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem, data) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: 0
            }, 0, 0, this);
            if ("e" in data) this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem, data.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem, data.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem, data.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem, data.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory.prototype = {
            getMult: function getMult(ind) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x1 = 0;
                var y1 = 0;
                var x2 = 1;
                var y2 = 1;
                if (this.ne.v > 0) x1 = this.ne.v / 100.0;
                else y1 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
                else y2 = 1.0 + this.xe.v / 100.0;
                var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
                var mult = 0;
                var s = this.finalS;
                var e = this.finalE;
                var type = this.data.sh;
                if (type === 2) {
                    if (e === s) mult = ind >= e ? 1 : 0;
                    else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 3) {
                    if (e === s) mult = ind >= e ? 0 : 1;
                    else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 4) {
                    if (e === s) mult = 0;
                    else {
                        mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                        if (mult < 0.5) mult *= 2;
                        else mult = 1 - 2 * (mult - 0.5);
                    }
                    mult = easer(mult);
                } else if (type === 5) {
                    if (e === s) mult = 0;
                    else {
                        var tot = e - s;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                        var x = -tot / 2 + ind;
                        var a = tot / 2;
                        mult = Math.sqrt(1 - x * x / (a * a));
                    }
                    mult = easer(mult);
                } else if (type === 6) {
                    if (e === s) mult = 0;
                    else {
                        ind = min(max(0, ind + 0.5 - s), e - s);
                        mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                    }
                    mult = easer(mult);
                } else {
                    if (ind >= floor(s)) {
                        if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                        else mult = max(0, min(e - ind, 1));
                    }
                    mult = easer(mult);
                } // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness = this.sm.v * 0.01;
                    if (smoothness === 0) smoothness = 0.00000001;
                    var threshold = 0.5 - smoothness * 0.5;
                    if (mult < threshold) mult = 0;
                    else {
                        mult = (mult - threshold) / smoothness;
                        if (mult > 1) mult = 1;
                    }
                }
                return mult * this.a.v;
            },
            getValue: function getValue(newCharsFlag) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o = this.o.v / divisor;
                var s = this.s.v / divisor + o;
                var e = this.e.v / divisor + o;
                if (s > e) {
                    var _s = s;
                    s = e;
                    e = _s;
                }
                this.finalS = s;
                this.finalE = e;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory);
        function getTextSelectorProp(elem, data, arr) {
            return new TextSelectorPropFactory(elem, data, arr);
        }
        return {
            getTextSelectorProp: getTextSelectorProp
        };
    }();
    function TextAnimatorDataProperty(elem, animatorProps, container) {
        var defaultData = {
            propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
            r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
            rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
            ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
            sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
            sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
            s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
            a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
            o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
            p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
            sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
            sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
            fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
            fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
            fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
            fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
            t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
    }
    function TextAnimatorProperty(textData, renderType, elem) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for(i = 0; i < len; i += 1){
            animatorProps = this._textData.a[i];
            this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && "m" in this._textData.p) {
            this._pathData = {
                a: getProp(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask;
        if (this._hasMaskedPath) {
            mask = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths = mask.v;
                if (this._pathData.r.v) paths = paths.reverse();
                 // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo = {
                    tLength: 0,
                    segments: []
                };
                len = paths._length - 1;
                var bezierData;
                totalLength = 0;
                for(i = 0; i < len; i += 1){
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[i + 1][0] - paths.v[i + 1][0],
                        paths.i[i + 1][1] - paths.v[i + 1][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                i = len;
                if (mask.v.c) {
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[0][0] - paths.v[0][0],
                        paths.i[0][1] - paths.v[0][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                this._pathData.pi = pathInfo;
            }
            pathInfo = this._pathData.pi;
            currentLength = this._pathData.f.v;
            segmentInd = 0;
            pointInd = 1;
            segmentLength = 0;
            flag = true;
            segments = pathInfo.segments;
            if (currentLength < 0 && mask.v.c) {
                if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
                segmentInd = segments.length - 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
                while(currentLength < 0){
                    currentLength += points[pointInd].partialLength;
                    pointInd -= 1;
                    if (pointInd < 0) {
                        segmentInd -= 1;
                        points = segments[segmentInd].points;
                        pointInd = points.length - 1;
                    }
                }
            }
            points = segments[segmentInd].points;
            prevPoint = points[pointInd - 1];
            currentPoint = points[pointInd];
            partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = "";
        var letterP = this.defaultPropsArray;
        var letterO; //
        if (documentData.j === 2 || documentData.j === 1) {
            var animatorJustifyOffset = 0;
            var animatorFirstCharOffset = 0;
            var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
            var lastIndex = 0;
            var isNewLine = true;
            for(i = 0; i < len; i += 1)if (letters[i].n) {
                if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
                while(lastIndex < i){
                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                    lastIndex += 1;
                }
                animatorJustifyOffset = 0;
                isNewLine = true;
            } else {
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                        else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                    }
                }
                isNewLine = false;
            }
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
        } //
        for(i = 0; i < len; i += 1){
            matrixHelper.reset();
            elemOpacity = 1;
            if (letters[i].n) {
                xPos = 0;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                currentLength = initPathPos;
                firstLine = false;
                if (this._hasMaskedPath) {
                    segmentInd = initSegmentInd;
                    pointInd = initPointInd;
                    points = segments[segmentInd].points;
                    prevPoint = points[pointInd - 1];
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                    segmentLength = 0;
                }
                letterM = "";
                letterFc = "";
                letterSw = "";
                letterO = "";
                letterP = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine !== letters[i].line) {
                        switch(documentData.j){
                            case 1:
                                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                                break;
                            case 2:
                                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine = letters[i].line;
                    }
                    if (ind !== letters[i].ind) {
                        if (letters[ind]) currentLength += letters[ind].extra;
                        currentLength += letters[i].an / 2;
                        ind = letters[i].ind;
                    }
                    currentLength += alignment[0] * letters[i].an * 0.005;
                    var animatorOffset = 0;
                    for(j = 0; j < jLen; j += 1){
                        animatorProps = animators[j].a;
                        if (animatorProps.p.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                            else animatorOffset += animatorProps.p.v[0] * mult;
                        }
                        if (animatorProps.a.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                            else animatorOffset += animatorProps.a.v[0] * mult;
                        }
                    }
                    flag = true; // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                        currentLength += this._pathData.f.v;
                    }
                    while(flag){
                        if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                            matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                            flag = false;
                        } else if (points) {
                            segmentLength += currentPoint.partialLength;
                            pointInd += 1;
                            if (pointInd >= points.length) {
                                pointInd = 0;
                                segmentInd += 1;
                                if (!segments[segmentInd]) {
                                    if (mask.v.c) {
                                        pointInd = 0;
                                        segmentInd = 0;
                                        points = segments[segmentInd].points;
                                    } else {
                                        segmentLength -= currentPoint.partialLength;
                                        points = null;
                                    }
                                } else points = segments[segmentInd].points;
                            }
                            if (points) {
                                prevPoint = currentPoint;
                                currentPoint = points[pointInd];
                                partialLength = currentPoint.partialLength;
                            }
                        }
                    }
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                } else {
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0); // Grouping alignment
                    matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos !== 0 || documentData.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult.length) currentLength += animatorProps.t.v * mult[0];
                                else currentLength += animatorProps.t.v * mult;
                            } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                            else xPos += animatorProps.t.v * mult;
                        }
                    }
                }
                if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
                if (documentData.strokeColorAnim) {
                    if (documentData.sc) sc = [
                        documentData.sc[0],
                        documentData.sc[1],
                        documentData.sc[2]
                    ];
                    else sc = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData.fillColorAnim && documentData.fc) fc = [
                    documentData.fc[0],
                    documentData.fc[1],
                    documentData.fc[2]
                ];
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                        else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.s.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                        else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (animatorProps.sk.propType) {
                        if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                        else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                    if (animatorProps.r.propType) {
                        if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                        else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                    if (animatorProps.ry.propType) {
                        if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                        else matrixHelper.rotateY(animatorProps.ry.v * mult);
                    }
                    if (animatorProps.rx.propType) {
                        if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                        else matrixHelper.rotateX(animatorProps.rx.v * mult);
                    }
                    if (animatorProps.o.propType) {
                        if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                        else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                    }
                    if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                        if (mult.length) sw += animatorProps.sw.v * mult[0];
                        else sw += animatorProps.sw.v * mult;
                    }
                    if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                        else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                    }
                    if (documentData.fillColorAnim && documentData.fc) {
                        if (animatorProps.fc.propType) {
                            for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                            else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                        }
                        if (animatorProps.fh.propType) {
                            if (mult.length) fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                            else fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                        }
                        if (animatorProps.fs.propType) {
                            if (mult.length) fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                            else fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                        }
                        if (animatorProps.fb.propType) {
                            if (mult.length) fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                            else fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                        }
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                            else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    }
                }
                if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
                if (documentData.strokeColorAnim) letterSc = "rgb(" + Math.round(sc[0] * 255) + "," + Math.round(sc[1] * 255) + "," + Math.round(sc[2] * 255) + ")";
                if (documentData.fillColorAnim && documentData.fc) letterFc = "rgb(" + Math.round(fc[0] * 255) + "," + Math.round(fc[1] * 255) + "," + Math.round(fc[2] * 255) + ")";
                if (this._hasMaskedPath) {
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                    if (this._pathData.p.v) {
                        tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                        var rot = Math.atan(tanAngle) * 180 / Math.PI;
                        if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                        matrixHelper.rotate(-rot * Math.PI / 180);
                    }
                    matrixHelper.translate(xPathPos, yPathPos, 0);
                    currentLength -= alignment[0] * letters[i].an * 0.005;
                    if (letters[i + 1] && ind !== letters[i + 1].ind) {
                        currentLength += letters[i].an / 2;
                        currentLength += documentData.tr * 0.001 * documentData.finalSize;
                    }
                } else {
                    matrixHelper.translate(xPos, yPos, 0);
                    if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                    switch(documentData.j){
                        case 1:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(offf, 0, 0);
                    matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                    xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
                }
                if (renderType === "html") letterM = matrixHelper.toCSS();
                else if (renderType === "svg") letterM = matrixHelper.to2dCSS();
                else letterP = [
                    matrixHelper.props[0],
                    matrixHelper.props[1],
                    matrixHelper.props[2],
                    matrixHelper.props[3],
                    matrixHelper.props[4],
                    matrixHelper.props[5],
                    matrixHelper.props[6],
                    matrixHelper.props[7],
                    matrixHelper.props[8],
                    matrixHelper.props[9],
                    matrixHelper.props[10],
                    matrixHelper.props[11],
                    matrixHelper.props[12],
                    matrixHelper.props[13],
                    matrixHelper.props[14],
                    matrixHelper.props[15]
                ];
                letterO = elemOpacity;
            }
            if (renderedLettersCount <= i) {
                letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
                this.renderedLetters.push(letterValue);
                renderedLettersCount += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue = this.renderedLetters[i];
                this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data, globalData, comp) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = "";
        for(j = 0; j < jLen; j += 1)if (shapes[j].ty === "sh") {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
        }
        return shapeStr;
    };
    ITextElement.prototype.updateDocumentData = function(newData, index) {
        this.textProperty.updateDocumentData(newData, index);
    };
    ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        matrixHelper.translate(0, -documentData.ls, 0);
        switch(documentData.j){
            case 1:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
                break;
            case 2:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper.translate(xPos, yPos, 0);
    };
    ITextElement.prototype.buildColor = function(colorData) {
        return "rgb(" + Math.round(colorData[0] * 255) + "," + Math.round(colorData[1] * 255) + "," + Math.round(colorData[2] * 255) + ")";
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data, globalData, comp) {
        this.textSpans = [];
        this.renderType = "svg";
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS("text");
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = "";
        while(i < len){
            if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
                textContents.push(currentTextContent);
                currentTextContent = "";
            } else currentTextContent += textArray[i];
            i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data.shapes && data.shapes.length) {
            var shape = data.shapes[0];
            if (shape.it) {
                var shapeItem = shape.it[shape.it.length - 1];
                if (shapeItem.s) {
                    shapeItem.s.k[0] = scale;
                    shapeItem.s.k[1] = scale;
                }
            }
        }
        return data;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) this.layerElement.setAttribute("fill", this.buildColor(documentData.fc));
        else this.layerElement.setAttribute("fill", "rgba(0,0,0,0)");
        if (documentData.sc) {
            this.layerElement.setAttribute("stroke", this.buildColor(documentData.sc));
            this.layerElement.setAttribute("stroke-width", documentData.sw);
        }
        this.layerElement.setAttribute("font-size", documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) this.layerElement.setAttribute("class", fontData.fClass);
        else {
            this.layerElement.setAttribute("font-family", fontData.fFamily);
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            this.layerElement.setAttribute("font-style", fStyle);
            this.layerElement.setAttribute("font-weight", fWeight);
        }
        this.layerElement.setAttribute("aria-label", documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = "";
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
            var tElement = this.textContainer;
            var justify = "start";
            switch(documentData.j){
                case 1:
                    justify = "end";
                    break;
                case 2:
                    justify = "middle";
                    break;
                default:
                    justify = "start";
                    break;
            }
            tElement.setAttribute("text-anchor", justify);
            tElement.setAttribute("letter-spacing", trackingOffset);
            var textContent = this.buildTextContents(documentData.finalText);
            len = textContent.length;
            yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
            for(i = 0; i < len; i += 1){
                tSpan = this.textSpans[i].span || createNS("tspan");
                tSpan.textContent = textContent[i];
                tSpan.setAttribute("x", 0);
                tSpan.setAttribute("y", yPos);
                tSpan.style.display = "inherit";
                tElement.appendChild(tSpan);
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i].span = tSpan;
                yPos += documentData.finalLineHeight;
            }
            this.layerElement.appendChild(tElement);
        } else {
            var cachedSpansLength = this.textSpans.length;
            var charData;
            for(i = 0; i < len; i += 1){
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs || !singleShape || i === 0) {
                    tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? "g" : "text");
                    if (cachedSpansLength <= i) {
                        tSpan.setAttribute("stroke-linecap", "butt");
                        tSpan.setAttribute("stroke-linejoin", "round");
                        tSpan.setAttribute("stroke-miterlimit", "4");
                        this.textSpans[i].span = tSpan;
                        if (usesGlyphs) {
                            var childSpan = createNS("g");
                            tSpan.appendChild(childSpan);
                            this.textSpans[i].childSpan = childSpan;
                        }
                        this.textSpans[i].span = tSpan;
                        this.layerElement.appendChild(tSpan);
                    }
                    tSpan.style.display = "inherit";
                }
                matrixHelper.reset();
                if (singleShape) {
                    if (letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                if (usesGlyphs) {
                    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                    var glyphElement; // t === 1 means the character has been replaced with an animated shaped
                    if (charData.t === 1) glyphElement = new SVGCompElement(charData.data, this.globalData, this);
                    else {
                        var data = emptyShapeData;
                        if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                        glyphElement = new SVGShapeElement(data, this.globalData, this);
                    }
                    if (this.textSpans[i].glyph) {
                        var glyph = this.textSpans[i].glyph;
                        this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                        glyph.destroy();
                    }
                    this.textSpans[i].glyph = glyphElement;
                    glyphElement._debug = true;
                    glyphElement.prepareFrame(0);
                    glyphElement.renderFrame();
                    this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData.t === 1) this.textSpans[i].childSpan.setAttribute("transform", "scale(" + documentData.finalSize / 100 + "," + documentData.finalSize / 100 + ")");
                } else {
                    if (singleShape) tSpan.setAttribute("transform", "translate(" + matrixHelper.props[12] + "," + matrixHelper.props[13] + ")");
                    tSpan.textContent = letters[i].val;
                    tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                } //
            }
            if (singleShape && tSpan) tSpan.setAttribute("d", shapeStr);
        }
        while(i < this.textSpans.length){
            this.textSpans[i].span.style.display = "none";
            i += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox = this.layerElement.getBBox();
            this.bbox = {
                top: textBox.y,
                left: textBox.x,
                width: textBox.width,
                height: textBox.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for(i = 0; i < len; i += 1){
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
                glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i;
                var len;
                var renderedLetters = this.textAnimator.renderedLetters;
                var letters = this.textProperty.currentData.l;
                len = letters.length;
                var renderedLetter;
                var textSpan;
                var glyphElement;
                for(i = 0; i < len; i += 1)if (!letters[i].n) {
                    renderedLetter = renderedLetters[i];
                    textSpan = this.textSpans[i].span;
                    glyphElement = this.textSpans[i].glyph;
                    if (glyphElement) glyphElement.renderFrame();
                    if (renderedLetter._mdf.m) textSpan.setAttribute("transform", renderedLetter.m);
                    if (renderedLetter._mdf.o) textSpan.setAttribute("opacity", renderedLetter.o);
                    if (renderedLetter._mdf.sw) textSpan.setAttribute("stroke-width", renderedLetter.sw);
                    if (renderedLetter._mdf.sc) textSpan.setAttribute("stroke", renderedLetter.sc);
                    if (renderedLetter._mdf.fc) textSpan.setAttribute("fill", renderedLetter.fc);
                }
            }
        }
    };
    function ISolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect = createNS("rect"); /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect.setAttribute("width", this.data.sw);
        rect.setAttribute("height", this.data.sh);
        rect.setAttribute("fill", this.data.sc);
        this.layerElement.appendChild(rect);
    };
    function NullElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initFrame();
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data) {
        return new NullElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data) {
        return new SVGShapeElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data) {
        return new SVGTextLottieElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data) {
        return new IImageElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data) {
        return new ISolidElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute("viewBox", "0 0 " + animData.w + " " + animData.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute("width", animData.w);
            this.svgElement.setAttribute("height", animData.h);
            this.svgElement.style.width = "100%";
            this.svgElement.style.height = "100%";
            this.svgElement.style.transform = "translate3d(0,0,0)";
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute("width", this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute("height", this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute("class", this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute("id", this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute("focusable", this.renderConfig.focusable);
        this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS("clipPath");
        var rect = createNS("rect");
        rect.setAttribute("width", animData.w);
        rect.setAttribute("height", animData.h);
        rect.setAttribute("x", 0);
        rect.setAttribute("y", 0);
        var maskId = createElementID();
        maskElement.setAttribute("id", maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + maskId + ")");
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1){
            if (this.layers[i].ind === ind) return i;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
            if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
            element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
            var elementIndex = "tp" in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
            if (elementIndex === -1) return;
            if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
                this.buildItem(elementIndex);
                this.addPendingElement(element);
            } else {
                var matteElement = elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[pos].tt);
                element.setMatte(matteMask);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
            if (element.data.tt) {
                var i = 0;
                var len = this.elements.length;
                while(i < len){
                    if (this.elements[i] === element) {
                        var elementIndex = "tp" in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                        var matteElement = this.elements[elementIndex];
                        var matteMask = matteElement.getMatte(this.layers[i].tt);
                        element.setMatte(matteMask);
                        break;
                    }
                    i += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) return;
        if (num === null) num = this.renderedFrame;
        else this.renderedFrame = num;
         // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) return;
        var i = 0;
        var nextElement;
        while(i < pos){
            if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
            i += 1;
        }
        if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
        else this.layerElement.appendChild(newElement);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = "none";
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = "block";
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
            this.renderedFrame = timeRemapped;
        } else this.renderedFrame = num / this.data.sr;
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
         // This iteration needs to be backwards because of how expressions connect between each other
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function SVGRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS("svg");
        var ariaLabel = "";
        if (config && config.title) {
            var titleElement = createNS("title");
            var titleId = createElementID();
            titleElement.setAttribute("id", titleId);
            titleElement.textContent = config.title;
            this.svgElement.appendChild(titleElement);
            ariaLabel += titleId;
        }
        if (config && config.description) {
            var descElement = createNS("desc");
            var descId = createElementID();
            descElement.setAttribute("id", descId);
            descElement.textContent = config.description;
            this.svgElement.appendChild(descElement);
            ariaLabel += " " + descId;
        }
        if (ariaLabel) this.svgElement.setAttribute("aria-labelledby", ariaLabel);
        var defs = createNS("defs");
        this.svgElement.appendChild(defs);
        var maskElement = createNS("g");
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
            preserveAspectRatio: config && config.preserveAspectRatio || "xMidYMid meet",
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || "xMidYMid slice",
            contentVisibility: config && config.contentVisibility || "visible",
            progressiveLoad: config && config.progressiveLoad || false,
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            viewBoxOnly: config && config.viewBoxOnly || false,
            viewBoxSize: config && config.viewBoxSize || false,
            className: config && config.className || "",
            id: config && config.id || "",
            focusable: config && config.focusable,
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || "100%",
                height: config && config.filterSize && config.filterSize.height || "100%",
                x: config && config.filterSize && config.filterSize.x || "0%",
                y: config && config.filterSize && config.filterSize.y || "0%"
            },
            width: config && config.width,
            height: config && config.height,
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = "svg";
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence(transforms) {
            var i;
            var len = transforms.length;
            var key = "_";
            for(i = 0; i < len; i += 1)key += transforms[i].transform.key + "_";
            var sequence = this.sequences[key];
            if (!sequence) {
                sequence = {
                    transforms: [].concat(transforms),
                    finalTransform: new Matrix(),
                    _mdf: false
                };
                this.sequences[key] = sequence;
                this.sequenceList.push(sequence);
            }
            return sequence;
        },
        processSequence: function processSequence(sequence, isFirstFrame) {
            var i = 0;
            var len = sequence.transforms.length;
            var _mdf = isFirstFrame;
            while(i < len && !isFirstFrame){
                if (sequence.transforms[i].transform.mProps._mdf) {
                    _mdf = true;
                    break;
                }
                i += 1;
            }
            if (_mdf) {
                sequence.finalTransform.reset();
                for(i = len - 1; i >= 0; i -= 1)sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
            }
            sequence._mdf = _mdf;
        },
        processSequences: function processSequences(isFirstFrame) {
            var i;
            var len = this.sequenceList.length;
            for(i = 0; i < len; i += 1)this.processSequence(this.sequenceList[i], isFirstFrame);
        },
        getNewKey: function getNewKey() {
            this.transform_key_count += 1;
            return "_" + this.transform_key_count;
        }
    };
    var lumaLoader = function lumaLoader() {
        var id = "__lottie_element_luma_buffer";
        var lumaBuffer = null;
        var lumaBufferCtx = null;
        var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
        // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
        // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
        // Naming it solution 2 to mark the extra comment lines.
        /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */ function createLumaSvgFilter() {
            var _svg = createNS("svg");
            var fil = createNS("filter");
            var matrix = createNS("feColorMatrix");
            fil.setAttribute("id", id);
            matrix.setAttribute("type", "matrix");
            matrix.setAttribute("color-interpolation-filters", "sRGB");
            matrix.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0");
            fil.appendChild(matrix);
            _svg.appendChild(fil);
            _svg.setAttribute("id", id + "_svg");
            if (featureSupport.svgLumaHidden) _svg.style.display = "none";
            return _svg;
        }
        function loadLuma() {
            if (!lumaBuffer) {
                svg = createLumaSvgFilter();
                document.body.appendChild(svg);
                lumaBuffer = createTag("canvas");
                lumaBufferCtx = lumaBuffer.getContext("2d"); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
                lumaBufferCtx.filter = "url(#" + id + ")";
                lumaBufferCtx.fillStyle = "rgba(0,0,0,0)";
                lumaBufferCtx.fillRect(0, 0, 1, 1);
            }
        }
        function getLuma(canvas) {
            if (!lumaBuffer) loadLuma();
            lumaBuffer.width = canvas.width;
            lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
            lumaBufferCtx.filter = "url(#" + id + ")";
            return lumaBuffer;
        }
        return {
            load: loadLuma,
            get: getLuma
        };
    };
    function createCanvas(width, height) {
        if (featureSupport.offscreenCanvas) return new OffscreenCanvas(width, height);
        var canvas = createTag("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    var assetLoader = function() {
        return {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
    }();
    var registeredEffects = {};
    function CVEffects(elem) {
        var i;
        var len = elem.data.ef ? elem.data.ef.length : 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects[type]) {
                var Effect = registeredEffects[type].effect;
                filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    CVEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect(id, effect) {
        registeredEffects[id] = {
            effect: effect
        };
    }
    function CVMaskElement(data, element) {
        this.data = data;
        this.element = element;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i;
        var len = this.masksProperties.length;
        var hasMasks = false;
        for(i = 0; i < len; i += 1){
            if (this.masksProperties[i].mode !== "n") hasMasks = true;
            this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
        }
        this.hasMasks = hasMasks;
        if (hasMasks) this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) return;
        var transform = this.element.finalTransform.mat;
        var ctx = this.element.canvasContext;
        var i;
        var len = this.masksProperties.length;
        var pt;
        var pts;
        var data;
        ctx.beginPath();
        for(i = 0; i < len; i += 1)if (this.masksProperties[i].mode !== "n") {
            if (this.masksProperties[i].inv) {
                ctx.moveTo(0, 0);
                ctx.lineTo(this.element.globalData.compSize.w, 0);
                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
                ctx.lineTo(0, this.element.globalData.compSize.h);
                ctx.lineTo(0, 0);
            }
            data = this.viewData[i].v;
            pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
            ctx.moveTo(pt[0], pt[1]);
            var j;
            var jLen = data._length;
            for(j = 1; j < jLen; j += 1){
                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
            }
            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }
        this.element.globalData.renderer.save(true);
        ctx.clip();
    };
    CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
    CVMaskElement.prototype.destroy = function() {
        this.element = null;
    };
    function CVBaseElement() {}
    var operationsMap = {
        1: "source-in",
        2: "source-out",
        3: "source-in",
        4: "source-out"
    };
    CVBaseElement.prototype = {
        createElements: function createElements() {},
        initRendererElement: function initRendererElement() {},
        createContainerElements: function createContainerElements() {
            // If the layer is masked we will use two buffers to store each different states of the drawing
            // This solution is not ideal for several reason. But unfortunately, because of the recursive
            // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
            // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
            // It might be challenging because the layer most likely is transformed in some way
            if (this.data.tt >= 1) {
                this.buffers = [];
                var canvasContext = this.globalData.canvasContext;
                var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas);
                var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas2);
                if (this.data.tt >= 3 && !document._isProxy) assetLoader.loadLumaCanvas();
            }
            this.canvasContext = this.globalData.canvasContext;
            this.transformCanvas = this.globalData.transformCanvas;
            this.renderableEffectsManager = new CVEffects(this);
            this.searchEffectTransforms();
        },
        createContent: function createContent() {},
        setBlendMode: function setBlendMode() {
            var globalData = this.globalData;
            if (globalData.blendMode !== this.data.bm) {
                globalData.blendMode = this.data.bm;
                var blendModeValue = getBlendMode(this.data.bm);
                globalData.canvasContext.globalCompositeOperation = blendModeValue;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new CVMaskElement(this.data, this);
            this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) this.hidden = true;
        },
        showElement: function showElement() {
            if (this.isInRange && !this.isTransparent) {
                this.hidden = false;
                this._isFirstFrame = true;
                this.maskManager._isFirstFrame = true;
            }
        },
        clearCanvas: function clearCanvas(canvasContext) {
            canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[0];
                var bufferCtx = buffer.getContext("2d");
                this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
                // TODO: Check if there is a way to clear the canvas without resetting the transform
                this.currentTransform = this.canvasContext.getTransform();
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
            }
        },
        exitLayer: function exitLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
                // that only contains the content of this layer
                // (if it is a composition, it also includes the nested layers)
                var bufferCtx = buffer.getContext("2d");
                this.clearCanvas(bufferCtx);
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform); // We draw the mask
                var mask = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
                mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
                // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
                if (this.data.tt >= 3 && !document._isProxy) {
                    // We copy the painted mask to a buffer that has a color matrix filter applied to it
                    // that applies the rgb values to the alpha channel
                    var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                    var lumaBufferCtx = lumaBuffer.getContext("2d");
                    lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
                    this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
                    this.canvasContext.drawImage(lumaBuffer, 0, 0);
                }
                this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
                this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
                // We use destination-over to draw the global drawing below the current layer
                this.canvasContext.globalCompositeOperation = "destination-over";
                this.canvasContext.drawImage(this.buffers[0], 0, 0);
                this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
                this.canvasContext.globalCompositeOperation = "source-over";
            }
        },
        renderFrame: function renderFrame(forceRender) {
            if (this.hidden || this.data.hd) return;
            if (this.data.td === 1 && !forceRender) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.setBlendMode();
            var forceRealStack = this.data.ty === 0;
            this.prepareLayer();
            this.globalData.renderer.save(forceRealStack);
            this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
            this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
            this.renderInnerContent();
            this.globalData.renderer.restore(forceRealStack);
            this.exitLayer();
            if (this.maskManager.hasMasks) this.globalData.renderer.restore(true);
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.canvasContext = null;
            this.data = null;
            this.globalData = null;
            this.maskManager.destroy();
        },
        mHelper: new Matrix()
    };
    CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
    CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(element, data, styles, transformsManager) {
        this.styledShapes = [];
        this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var ty = 4;
        if (data.ty === "rc") ty = 5;
        else if (data.ty === "el") ty = 6;
        else if (data.ty === "sr") ty = 7;
        this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
        var i;
        var len = styles.length;
        var styledShape;
        for(i = 0; i < len; i += 1)if (!styles[i].closed) {
            styledShape = {
                transforms: transformsManager.addTransformSequence(styles[i].transforms),
                trNodes: []
            };
            this.styledShapes.push(styledShape);
            styles[i].elements.push(styledShape);
        }
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(data, globalData, comp) {
        this.shapes = [];
        this.shapesData = data.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement);
    CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
    CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
    };
    CVShapeElement.prototype.dashResetter = [];
    CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    };
    CVShapeElement.prototype.createStyleElement = function(data, transforms) {
        var styleElem = {
            data: data,
            type: data.ty,
            preTransforms: this.transformsManager.addTransformSequence(transforms),
            transforms: [],
            elements: [],
            closed: data.hd === true
        };
        var elementData = {};
        if (data.ty === "fl" || data.ty === "st") {
            elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
            if (!elementData.c.k) styleElem.co = "rgb(" + bmFloor(elementData.c.v[0]) + "," + bmFloor(elementData.c.v[1]) + "," + bmFloor(elementData.c.v[2]) + ")";
        } else if (data.ty === "gf" || data.ty === "gs") {
            elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
            elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
            elementData.h = PropertyFactory.getProp(this, data.h || {
                k: 0
            }, 0, 0.01, this);
            elementData.a = PropertyFactory.getProp(this, data.a || {
                k: 0
            }, 0, degToRads, this);
            elementData.g = new GradientProperty(this, data.g, this);
        }
        elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
        if (data.ty === "st" || data.ty === "gs") {
            styleElem.lc = lineCapEnum[data.lc || 2];
            styleElem.lj = lineJoinEnum[data.lj || 2];
            if (data.lj == 1) // eslint-disable-line eqeqeq
            styleElem.ml = data.ml;
            elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
            if (!elementData.w.k) styleElem.wi = elementData.w.v;
            if (data.d) {
                var d = new DashProperty(this, data.d, "canvas", this);
                elementData.d = d;
                if (!elementData.d.k) {
                    styleElem.da = elementData.d.dashArray;
                    styleElem["do"] = elementData.d.dashoffset[0];
                }
            }
        } else styleElem.r = data.r === 2 ? "evenodd" : "nonzero";
        this.stylesList.push(styleElem);
        elementData.style = styleElem;
        return elementData;
    };
    CVShapeElement.prototype.createGroupElement = function() {
        var elementData = {
            it: [],
            prevViewData: []
        };
        return elementData;
    };
    CVShapeElement.prototype.createTransformElement = function(data) {
        var elementData = {
            transform: {
                opacity: 1,
                _opMdf: false,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
            }
        };
        return elementData;
    };
    CVShapeElement.prototype.createShapeElement = function(data) {
        var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        return elementData;
    };
    CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
    };
    CVShapeElement.prototype.addTransformToStyleList = function(transform) {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.push(transform);
    };
    CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.pop();
    };
    CVShapeElement.prototype.closeStyles = function(styles) {
        var i;
        var len = styles.length;
        for(i = 0; i < len; i += 1)styles[i].closed = true;
    };
    CVShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, shouldRender, transforms) {
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var processedPos;
        var modifier;
        var currentTransform;
        var ownTransforms = [].concat(transforms);
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._shouldRender = shouldRender;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === "fl" || arr[i].ty === "st" || arr[i].ty === "gf" || arr[i].ty === "gs") {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
                else itemsData[i].style.closed = false;
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === "gr") {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
            } else if (arr[i].ty === "tr") {
                if (!processedPos) {
                    currentTransform = this.createTransformElement(arr[i]);
                    itemsData[i] = currentTransform;
                }
                ownTransforms.push(itemsData[i]);
                this.addTransformToStyleList(itemsData[i]);
            } else if (arr[i].ty === "sh" || arr[i].ty === "rc" || arr[i].ty === "el" || arr[i].ty === "sr") {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i]);
            } else if (arr[i].ty === "tm" || arr[i].ty === "rd" || arr[i].ty === "pb" || arr[i].ty === "zz" || arr[i].ty === "op") {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === "rp") {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    shouldRender = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles);
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
    };
    CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
        if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
            groupTransform.opacity = parentTransform.opacity;
            groupTransform.opacity *= groupTransform.op.v;
            groupTransform._opMdf = true;
        }
    };
    CVShapeElement.prototype.drawLayer = function() {
        var i;
        var len = this.stylesList.length;
        var j;
        var jLen;
        var k;
        var kLen;
        var elems;
        var nodes;
        var renderer = this.globalData.renderer;
        var ctx = this.globalData.canvasContext;
        var type;
        var currentStyle;
        for(i = 0; i < len; i += 1){
            currentStyle = this.stylesList[i];
            type = currentStyle.type; // Skipping style when
            // Stroke width equals 0
            // style should not be rendered (extra unused repeaters)
            // current opacity equals 0
            // global opacity equals 0
            if (!((type === "st" || type === "gs") && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                renderer.save();
                elems = currentStyle.elements;
                if (type === "st" || type === "gs") {
                    renderer.ctxStrokeStyle(type === "st" ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
                    renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;
                    renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;
                    renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;
                    renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
                } else renderer.ctxFillStyle(type === "fl" ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
                renderer.ctxOpacity(currentStyle.coOp);
                if (type !== "st" && type !== "gs") ctx.beginPath();
                renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
                jLen = elems.length;
                for(j = 0; j < jLen; j += 1){
                    if (type === "st" || type === "gs") {
                        ctx.beginPath();
                        if (currentStyle.da) {
                            ctx.setLineDash(currentStyle.da);
                            ctx.lineDashOffset = currentStyle["do"];
                        }
                    }
                    nodes = elems[j].trNodes;
                    kLen = nodes.length;
                    for(k = 0; k < kLen; k += 1){
                        if (nodes[k].t === "m") ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
                        else if (nodes[k].t === "c") ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
                        else ctx.closePath();
                    }
                    if (type === "st" || type === "gs") {
                        // ctx.stroke();
                        renderer.ctxStroke();
                        if (currentStyle.da) ctx.setLineDash(this.dashResetter);
                    }
                }
                if (type !== "st" && type !== "gs") // ctx.fill(currentStyle.r);
                this.globalData.renderer.ctxFill(currentStyle.r);
                renderer.restore();
            }
        }
    };
    CVShapeElement.prototype.renderShape = function(parentTransform, items, data, isMain) {
        var i;
        var len = items.length - 1;
        var groupTransform;
        groupTransform = parentTransform;
        for(i = len; i >= 0; i -= 1){
            if (items[i].ty === "tr") {
                groupTransform = data[i].transform;
                this.renderShapeTransform(parentTransform, groupTransform);
            } else if (items[i].ty === "sh" || items[i].ty === "el" || items[i].ty === "rc" || items[i].ty === "sr") this.renderPath(items[i], data[i]);
            else if (items[i].ty === "fl") this.renderFill(items[i], data[i], groupTransform);
            else if (items[i].ty === "st") this.renderStroke(items[i], data[i], groupTransform);
            else if (items[i].ty === "gf" || items[i].ty === "gs") this.renderGradientFill(items[i], data[i], groupTransform);
            else if (items[i].ty === "gr") this.renderShape(groupTransform, items[i].it, data[i].it);
            else items[i].ty;
        }
        if (isMain) this.drawLayer();
    };
    CVShapeElement.prototype.renderStyledShape = function(styledShape, shape) {
        if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
            var shapeNodes = styledShape.trNodes;
            var paths = shape.paths;
            var i;
            var len;
            var j;
            var jLen = paths._length;
            shapeNodes.length = 0;
            var groupTransformMat = styledShape.transforms.finalTransform;
            for(j = 0; j < jLen; j += 1){
                var pathNodes = paths.shapes[j];
                if (pathNodes && pathNodes.v) {
                    len = pathNodes._length;
                    for(i = 1; i < len; i += 1){
                        if (i === 1) shapeNodes.push({
                            t: "m",
                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                        shapeNodes.push({
                            t: "c",
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
                        });
                    }
                    if (len === 1) shapeNodes.push({
                        t: "m",
                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    if (pathNodes.c && len) {
                        shapeNodes.push({
                            t: "c",
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
                        });
                        shapeNodes.push({
                            t: "z"
                        });
                    }
                }
            }
            styledShape.trNodes = shapeNodes;
        }
    };
    CVShapeElement.prototype.renderPath = function(pathData, itemData) {
        if (pathData.hd !== true && pathData._shouldRender) {
            var i;
            var len = itemData.styledShapes.length;
            for(i = 0; i < len; i += 1)this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
        }
    };
    CVShapeElement.prototype.renderFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")";
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderGradientFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var grd;
        if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
            var ctx = this.globalData.canvasContext;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (styleData.t === 1) grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
            else {
                var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                var percent = itemData.h.v;
                if (percent >= 1) percent = 0.99;
                else if (percent <= -1) percent = -0.99;
                var dist = rad * percent;
                var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
            }
            var i;
            var len = styleData.g.p;
            var cValues = itemData.g.c;
            var opacity = 1;
            for(i = 0; i < len; i += 1){
                if (itemData.g._hasOpacity && itemData.g._collapsable) opacity = itemData.g.o[i * 2 + 1];
                grd.addColorStop(cValues[i * 4] / 100, "rgba(" + cValues[i * 4 + 1] + "," + cValues[i * 4 + 2] + "," + cValues[i * 4 + 3] + "," + opacity + ")");
            }
            styleElem.grd = grd;
        }
        styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderStroke = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var d = itemData.d;
        if (d && (d._mdf || this._isFirstFrame)) {
            styleElem.da = d.dashArray;
            styleElem["do"] = d.dashoffset[0];
        }
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")";
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
        if (itemData.w._mdf || this._isFirstFrame) styleElem.wi = itemData.w.v;
    };
    CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
    };
    function CVTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = "canvas";
        this.values = {
            fill: "rgba(0,0,0,0)",
            stroke: "rgba(0,0,0,0)",
            sWidth: 0,
            fValue: ""
        };
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement);
    CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d");
    CVTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var hasFill = false;
        if (documentData.fc) {
            hasFill = true;
            this.values.fill = this.buildColor(documentData.fc);
        } else this.values.fill = "rgba(0,0,0,0)";
        this.fill = hasFill;
        var hasStroke = false;
        if (documentData.sc) {
            hasStroke = true;
            this.values.stroke = this.buildColor(documentData.sc);
            this.values.sWidth = documentData.sw;
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        var i;
        var len;
        var letters = documentData.l;
        var matrixHelper = this.mHelper;
        this.stroke = hasStroke;
        this.values.fValue = documentData.finalSize + "px " + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
        len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;
        var charData;
        var shapeData;
        var k;
        var kLen;
        var shapes;
        var j;
        var jLen;
        var pathNodes;
        var commands;
        var pathArr;
        var singleShape = this.data.singleShape;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            shapeData = charData && charData.data || {};
            matrixHelper.reset();
            if (singleShape && letters[i].n) {
                xPos = -trackingOffset;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                firstLine = false;
            }
            shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
            jLen = shapes.length;
            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
            if (singleShape) this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
            commands = createSizedArray(jLen - 1);
            var commandsCounter = 0;
            for(j = 0; j < jLen; j += 1)if (shapes[j].ty === "sh") {
                kLen = shapes[j].ks.k.i.length;
                pathNodes = shapes[j].ks.k;
                pathArr = [];
                for(k = 1; k < kLen; k += 1){
                    if (k === 1) pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                commands[commandsCounter] = pathArr;
                commandsCounter += 1;
            }
            if (singleShape) {
                xPos += letters[i].l;
                xPos += trackingOffset;
            }
            if (this.textSpans[cnt]) this.textSpans[cnt].elem = commands;
            else this.textSpans[cnt] = {
                elem: commands
            };
            cnt += 1;
        }
    };
    CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx = this.canvasContext;
        ctx.font = this.values.fValue;
        this.globalData.renderer.ctxLineCap("butt"); // ctx.lineCap = 'butt';
        this.globalData.renderer.ctxLineJoin("miter"); // ctx.lineJoin = 'miter';
        this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;
        if (!this.data.singleShape) this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var i;
        var len;
        var j;
        var jLen;
        var k;
        var kLen;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var lastFill = null;
        var lastStroke = null;
        var lastStrokeW = null;
        var commands;
        var pathArr;
        var renderer = this.globalData.renderer;
        for(i = 0; i < len; i += 1)if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            if (renderedLetter) {
                renderer.save();
                renderer.ctxTransform(renderedLetter.p);
                renderer.ctxOpacity(renderedLetter.o);
            }
            if (this.fill) {
                if (renderedLetter && renderedLetter.fc) {
                    if (lastFill !== renderedLetter.fc) {
                        renderer.ctxFillStyle(renderedLetter.fc);
                        lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
                    }
                } else if (lastFill !== this.values.fill) {
                    lastFill = this.values.fill;
                    renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxFill(); // this.globalData.canvasContext.fill();
            /// ctx.fillText(this.textSpans[i].val,0,0);
            }
            if (this.stroke) {
                if (renderedLetter && renderedLetter.sw) {
                    if (lastStrokeW !== renderedLetter.sw) {
                        lastStrokeW = renderedLetter.sw;
                        renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
                    }
                } else if (lastStrokeW !== this.values.sWidth) {
                    lastStrokeW = this.values.sWidth;
                    renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
                }
                if (renderedLetter && renderedLetter.sc) {
                    if (lastStroke !== renderedLetter.sc) {
                        lastStroke = renderedLetter.sc;
                        renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
                    }
                } else if (lastStroke !== this.values.stroke) {
                    lastStroke = this.values.stroke;
                    renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
            /// ctx.strokeText(letters[i].val,0,0);
            }
            if (renderedLetter) this.globalData.renderer.restore();
        }
    };
    function CVImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.img = globalData.imageLoader.getAsset(this.assetData);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement);
    CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var canvas = createTag("canvas");
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext("2d");
            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w / this.assetData.h;
            var widthCrop;
            var heightCrop;
            var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            if (imgRel > canvasRel && par === "xMidYMid slice" || imgRel < canvasRel && par !== "xMidYMid slice") {
                heightCrop = imgH;
                widthCrop = heightCrop * canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop / canvasRel;
            }
            ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
            this.img = canvas;
        }
    };
    CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    };
    CVImageElement.prototype.destroy = function() {
        this.img = null;
    };
    function CVSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement);
    CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVSolidElement.prototype.renderInnerContent = function() {
        // var ctx = this.canvasContext;
        this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;
        this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
    };
    function CanvasRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], CanvasRendererBase);
    CanvasRendererBase.prototype.createShape = function(data) {
        return new CVShapeElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createText = function(data) {
        return new CVTextElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createImage = function(data) {
        return new CVImageElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createSolid = function(data) {
        return new CVSolidElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    CanvasRendererBase.prototype.ctxTransform = function(props) {
        if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) return;
        this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    };
    CanvasRendererBase.prototype.ctxOpacity = function(op) {
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    };
    CanvasRendererBase.prototype.ctxFillStyle = function(value) {
        this.canvasContext.fillStyle = value;
    };
    CanvasRendererBase.prototype.ctxStrokeStyle = function(value) {
        this.canvasContext.strokeStyle = value;
    };
    CanvasRendererBase.prototype.ctxLineWidth = function(value) {
        this.canvasContext.lineWidth = value;
    };
    CanvasRendererBase.prototype.ctxLineCap = function(value) {
        this.canvasContext.lineCap = value;
    };
    CanvasRendererBase.prototype.ctxLineJoin = function(value) {
        this.canvasContext.lineJoin = value;
    };
    CanvasRendererBase.prototype.ctxMiterLimit = function(value) {
        this.canvasContext.miterLimit = value;
    };
    CanvasRendererBase.prototype.ctxFill = function(rule) {
        this.canvasContext.fill(rule);
    };
    CanvasRendererBase.prototype.ctxFillRect = function(x, y, w, h) {
        this.canvasContext.fillRect(x, y, w, h);
    };
    CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
    };
    CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        this.contextData.reset();
    };
    CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
    };
    CanvasRendererBase.prototype.restore = function(actionFlag) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        if (actionFlag) this.globalData.blendMode = "source-over";
        this.contextData.restore(actionFlag);
    };
    CanvasRendererBase.prototype.configAnimation = function(animData) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag("canvas");
            var containerStyle = this.animationItem.container.style;
            containerStyle.width = "100%";
            containerStyle.height = "100%";
            var origin = "0px 0px 0px";
            containerStyle.transformOrigin = origin;
            containerStyle.mozTransformOrigin = origin;
            containerStyle.webkitTransformOrigin = origin;
            containerStyle["-webkit-transform"] = origin;
            containerStyle.contentVisibility = this.renderConfig.contentVisibility;
            this.animationItem.wrapper.appendChild(this.animationItem.container);
            this.canvasContext = this.animationItem.container.getContext("2d");
            if (this.renderConfig.className) this.animationItem.container.setAttribute("class", this.renderConfig.className);
            if (this.renderConfig.id) this.animationItem.container.setAttribute("id", this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext);
        this.data = animData;
        this.layers = animData.layers;
        this.transformCanvas = {
            w: animData.w,
            h: animData.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        };
        this.setupGlobalData(animData, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData.layers.length);
        this.updateContainerSize();
    };
    CanvasRendererBase.prototype.updateContainerSize = function(width, height) {
        this.reset();
        var elementWidth;
        var elementHeight;
        if (width) {
            elementWidth = width;
            elementHeight = height;
            this.canvasContext.canvas.width = elementWidth;
            this.canvasContext.canvas.height = elementHeight;
        } else {
            if (this.animationItem.wrapper && this.animationItem.container) {
                elementWidth = this.animationItem.wrapper.offsetWidth;
                elementHeight = this.animationItem.wrapper.offsetHeight;
            } else {
                elementWidth = this.canvasContext.canvas.width;
                elementHeight = this.canvasContext.canvas.height;
            }
            this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
            this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
        }
        var elementRel;
        var animationRel;
        if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
            var par = this.renderConfig.preserveAspectRatio.split(" ");
            var fillType = par[1] || "meet";
            var pos = par[0] || "xMidYMid";
            var xPos = pos.substr(0, 4);
            var yPos = pos.substr(4);
            elementRel = elementWidth / elementHeight;
            animationRel = this.transformCanvas.w / this.transformCanvas.h;
            if (animationRel > elementRel && fillType === "meet" || animationRel < elementRel && fillType === "slice") {
                this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
                this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            } else {
                this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
                this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            }
            if (xPos === "xMid" && (animationRel < elementRel && fillType === "meet" || animationRel > elementRel && fillType === "slice")) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
            else if (xPos === "xMax" && (animationRel < elementRel && fillType === "meet" || animationRel > elementRel && fillType === "slice")) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
            else this.transformCanvas.tx = 0;
            if (yPos === "YMid" && (animationRel > elementRel && fillType === "meet" || animationRel < elementRel && fillType === "slice")) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
            else if (yPos === "YMax" && (animationRel > elementRel && fillType === "meet" || animationRel < elementRel && fillType === "slice")) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
            else this.transformCanvas.ty = 0;
        } else if (this.renderConfig.preserveAspectRatio === "none") {
            this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        } else {
            this.transformCanvas.sx = this.renderConfig.dpr;
            this.transformCanvas.sy = this.renderConfig.dpr;
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ];
        /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */ this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
    };
    CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
    };
    CanvasRendererBase.prototype.renderFrame = function(num, forceRender) {
        if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) return;
        this.renderedFrame = num;
        this.globalData.frameNum = num - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
        this.globalData.projectInterface.currentFrame = num; // console.log('--------');
        // console.log('NEW: ',num);
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            if (this.renderConfig.clearCanvas === true) this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
            else this.save();
            for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
            if (this.renderConfig.clearCanvas !== true) this.restore();
        }
    };
    CanvasRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        var element = this.createItem(this.layers[pos], this, this.globalData);
        elements[pos] = element;
        element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */ };
    CanvasRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = "none";
    };
    CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = "block";
    };
    function CanvasContext() {
        this.opacity = -1;
        this.transform = createTypedArray("float32", 16);
        this.fillStyle = "";
        this.strokeStyle = "";
        this.lineWidth = "";
        this.lineCap = "";
        this.lineJoin = "";
        this.miterLimit = "";
        this.id = Math.random();
    }
    function CVContextData() {
        this.stack = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        var i;
        var len = 15;
        for(i = 0; i < len; i += 1){
            var canvasContext = new CanvasContext();
            this.stack[i] = canvasContext;
        }
        this._length = len;
        this.nativeContext = null;
        this.transformMat = new Matrix();
        this.currentOpacity = 1; //
        this.currentFillStyle = "";
        this.appliedFillStyle = ""; //
        this.currentStrokeStyle = "";
        this.appliedStrokeStyle = ""; //
        this.currentLineWidth = "";
        this.appliedLineWidth = ""; //
        this.currentLineCap = "";
        this.appliedLineCap = ""; //
        this.currentLineJoin = "";
        this.appliedLineJoin = ""; //
        this.appliedMiterLimit = "";
        this.currentMiterLimit = "";
    }
    CVContextData.prototype.duplicate = function() {
        var newLength = this._length * 2;
        var i = 0;
        for(i = this._length; i < newLength; i += 1)this.stack[i] = new CanvasContext();
        this._length = newLength;
    };
    CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.stack[this.cArrPos].opacity = 1;
    };
    CVContextData.prototype.restore = function(forceRestore) {
        this.cArrPos -= 1;
        var currentContext = this.stack[this.cArrPos];
        var transform = currentContext.transform;
        var i;
        var arr = this.cTr.props;
        for(i = 0; i < 16; i += 1)arr[i] = transform[i];
        if (forceRestore) {
            this.nativeContext.restore();
            var prevStack = this.stack[this.cArrPos + 1];
            this.appliedFillStyle = prevStack.fillStyle;
            this.appliedStrokeStyle = prevStack.strokeStyle;
            this.appliedLineWidth = prevStack.lineWidth;
            this.appliedLineCap = prevStack.lineCap;
            this.appliedLineJoin = prevStack.lineJoin;
            this.appliedMiterLimit = prevStack.miterLimit;
        }
        this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
        if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
            this.nativeContext.globalAlpha = currentContext.opacity;
            this.currentOpacity = currentContext.opacity;
        }
        this.currentFillStyle = currentContext.fillStyle;
        this.currentStrokeStyle = currentContext.strokeStyle;
        this.currentLineWidth = currentContext.lineWidth;
        this.currentLineCap = currentContext.lineCap;
        this.currentLineJoin = currentContext.lineJoin;
        this.currentMiterLimit = currentContext.miterLimit;
    };
    CVContextData.prototype.save = function(saveOnNativeFlag) {
        if (saveOnNativeFlag) this.nativeContext.save();
        var props = this.cTr.props;
        if (this._length <= this.cArrPos) this.duplicate();
        var currentStack = this.stack[this.cArrPos];
        var i;
        for(i = 0; i < 16; i += 1)currentStack.transform[i] = props[i];
        this.cArrPos += 1;
        var newStack = this.stack[this.cArrPos];
        newStack.opacity = currentStack.opacity;
        newStack.fillStyle = currentStack.fillStyle;
        newStack.strokeStyle = currentStack.strokeStyle;
        newStack.lineWidth = currentStack.lineWidth;
        newStack.lineCap = currentStack.lineCap;
        newStack.lineJoin = currentStack.lineJoin;
        newStack.miterLimit = currentStack.miterLimit;
    };
    CVContextData.prototype.setOpacity = function(value) {
        this.stack[this.cArrPos].opacity = value;
    };
    CVContextData.prototype.setContext = function(value) {
        this.nativeContext = value;
    };
    CVContextData.prototype.fillStyle = function(value) {
        if (this.stack[this.cArrPos].fillStyle !== value) {
            this.currentFillStyle = value;
            this.stack[this.cArrPos].fillStyle = value;
        }
    };
    CVContextData.prototype.strokeStyle = function(value) {
        if (this.stack[this.cArrPos].strokeStyle !== value) {
            this.currentStrokeStyle = value;
            this.stack[this.cArrPos].strokeStyle = value;
        }
    };
    CVContextData.prototype.lineWidth = function(value) {
        if (this.stack[this.cArrPos].lineWidth !== value) {
            this.currentLineWidth = value;
            this.stack[this.cArrPos].lineWidth = value;
        }
    };
    CVContextData.prototype.lineCap = function(value) {
        if (this.stack[this.cArrPos].lineCap !== value) {
            this.currentLineCap = value;
            this.stack[this.cArrPos].lineCap = value;
        }
    };
    CVContextData.prototype.lineJoin = function(value) {
        if (this.stack[this.cArrPos].lineJoin !== value) {
            this.currentLineJoin = value;
            this.stack[this.cArrPos].lineJoin = value;
        }
    };
    CVContextData.prototype.miterLimit = function(value) {
        if (this.stack[this.cArrPos].miterLimit !== value) {
            this.currentMiterLimit = value;
            this.stack[this.cArrPos].miterLimit = value;
        }
    };
    CVContextData.prototype.transform = function(props) {
        this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms
        var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations
        this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform
        currentTransform.cloneFromProps(this.transformMat.props);
        var trProps = currentTransform.props; // Applying the new transform to the canvas
        this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
    };
    CVContextData.prototype.opacity = function(op) {
        var currentOpacity = this.stack[this.cArrPos].opacity;
        currentOpacity *= op < 0 ? 0 : op;
        if (this.stack[this.cArrPos].opacity !== currentOpacity) {
            if (this.currentOpacity !== op) {
                this.nativeContext.globalAlpha = op;
                this.currentOpacity = op;
            }
            this.stack[this.cArrPos].opacity = currentOpacity;
        }
    };
    CVContextData.prototype.fill = function(rule) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fill(rule);
    };
    CVContextData.prototype.fillRect = function(x, y, w, h) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fillRect(x, y, w, h);
    };
    CVContextData.prototype.stroke = function() {
        if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
            this.appliedStrokeStyle = this.currentStrokeStyle;
            this.nativeContext.strokeStyle = this.appliedStrokeStyle;
        }
        if (this.appliedLineWidth !== this.currentLineWidth) {
            this.appliedLineWidth = this.currentLineWidth;
            this.nativeContext.lineWidth = this.appliedLineWidth;
        }
        if (this.appliedLineCap !== this.currentLineCap) {
            this.appliedLineCap = this.currentLineCap;
            this.nativeContext.lineCap = this.appliedLineCap;
        }
        if (this.appliedLineJoin !== this.currentLineJoin) {
            this.appliedLineJoin = this.currentLineJoin;
            this.nativeContext.lineJoin = this.appliedLineJoin;
        }
        if (this.appliedMiterLimit !== this.currentMiterLimit) {
            this.appliedMiterLimit = this.currentMiterLimit;
            this.nativeContext.miterLimit = this.appliedMiterLimit;
        }
        this.nativeContext.stroke();
    };
    function CVCompElement(data, globalData, comp) {
        this.completeLayers = false;
        this.layers = data.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        CanvasRendererBase,
        ICompElement,
        CVBaseElement
    ], CVCompElement);
    CVCompElement.prototype.renderInnerContent = function() {
        var ctx = this.canvasContext;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.data.w, 0);
        ctx.lineTo(this.data.w, this.data.h);
        ctx.lineTo(0, this.data.h);
        ctx.lineTo(0, 0);
        ctx.clip();
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    CVCompElement.prototype.destroy = function() {
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i]) this.elements[i].destroy();
        this.layers = null;
        this.elements = null;
    };
    CVCompElement.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function CanvasRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.renderConfig = {
            clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
            context: config && config.context || null,
            progressiveLoad: config && config.progressiveLoad || false,
            preserveAspectRatio: config && config.preserveAspectRatio || "xMidYMid meet",
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || "xMidYMid slice",
            contentVisibility: config && config.contentVisibility || "visible",
            className: config && config.className || "",
            id: config && config.id || "",
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.renderConfig.dpr = config && config.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = "canvas";
        if (this.renderConfig.clearCanvas) {
            this.ctxTransform = this.contextData.transform.bind(this.contextData);
            this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
            this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
            this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
            this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
            this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
            this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
            this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
            this.ctxFill = this.contextData.fill.bind(this.contextData);
            this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
            this.ctxStroke = this.contextData.stroke.bind(this.contextData);
            this.save = this.contextData.save.bind(this.contextData);
        }
    }
    extendPrototype([
        CanvasRendererBase
    ], CanvasRenderer);
    CanvasRenderer.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function HBaseElement() {}
    HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode() {},
        initRendererElement: function initRendererElement() {
            this.baseElement = createTag(this.data.tg || "div");
            if (this.data.hasMask) {
                this.svgElement = createNS("svg");
                this.layerElement = createNS("g");
                this.maskedElement = this.layerElement;
                this.svgElement.appendChild(this.layerElement);
                this.baseElement.appendChild(this.svgElement);
            } else this.layerElement = this.baseElement;
            styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements() {
            this.renderableEffectsManager = new CVEffects(this);
            this.transformedElement = this.baseElement;
            this.maskedElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute("id", this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute("class", this.data.cl);
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var matrixValue = this.finalTransform.mat.toCSS();
                transformedElementStyle.transform = matrixValue;
                transformedElementStyle.webkitTransform = matrixValue;
            }
            if (this.finalTransform._opMdf) transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
        },
        renderFrame: function renderFrame() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.layerElement = null;
            this.transformedElement = null;
            if (this.matteElement) this.matteElement = null;
            if (this.maskManager) {
                this.maskManager.destroy();
                this.maskManager = null;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects() {},
        setMatte: function setMatte() {}
    };
    HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
    HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
    HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement);
    HSolidElement.prototype.createContent = function() {
        var rect;
        if (this.data.hasMask) {
            rect = createNS("rect");
            rect.setAttribute("width", this.data.sw);
            rect.setAttribute("height", this.data.sh);
            rect.setAttribute("fill", this.data.sc);
            this.svgElement.setAttribute("width", this.data.sw);
            this.svgElement.setAttribute("height", this.data.sh);
        } else {
            rect = createTag("div");
            rect.style.width = this.data.sw + "px";
            rect.style.height = this.data.sh + "px";
            rect.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect);
    };
    function HShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.shapesContainer = createNS("g");
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement);
    HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
    HShapeElement.prototype.createContent = function() {
        var cont;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
            this.layerElement.appendChild(this.shapesContainer);
            cont = this.svgElement;
        } else {
            cont = createNS("svg");
            var size = this.comp.data ? this.comp.data : this.globalData.compSize;
            cont.setAttribute("width", size.w);
            cont.setAttribute("height", size.h);
            cont.appendChild(this.shapesContainer);
            this.layerElement.appendChild(cont);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont;
    };
    HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
        var i;
        var len = transformers.length;
        for(i = 0; i < len; i += 1)point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
        return point;
    };
    HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
        var shape = item.sh.v;
        var transformers = item.transformers;
        var i;
        var len = shape._length;
        var vPoint;
        var oPoint;
        var nextIPoint;
        var nextVPoint;
        if (len <= 1) return;
        for(i = 0; i < len - 1; i += 1){
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
        if (shape.c) {
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
    };
    HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
        this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
        var bounds = this.shapeBoundingBox;
        boundingBox.x = bmMin(bounds.left, boundingBox.x);
        boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
        boundingBox.y = bmMin(bounds.top, boundingBox.y);
        boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
    };
    HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    };
    HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
        var bounds = [
            [
                p0[0],
                p3[0]
            ],
            [
                p0[1],
                p3[1]
            ]
        ];
        for(var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i){
            // eslint-disable-line no-plusplus
            b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            c = 3 * p1[i] - 3 * p0[i];
            b |= 0; // eslint-disable-line no-bitwise
            a |= 0; // eslint-disable-line no-bitwise
            c |= 0; // eslint-disable-line no-bitwise
            if (a === 0 && b === 0) ;
            else if (a === 0) {
                t = -c / b;
                if (t > 0 && t < 1) bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
            } else {
                b2ac = b * b - 4 * c * a;
                if (b2ac >= 0) {
                    t1 = (-b + bmSqrt(b2ac)) / (2 * a);
                    if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
                    t2 = (-b - bmSqrt(b2ac)) / (2 * a);
                    if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
                }
            }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
    };
    HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
        return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
    };
    HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
        var i;
        var len = itemsData.length;
        for(i = 0; i < len; i += 1){
            if (itemsData[i] && itemsData[i].sh) this.calculateShapeBoundingBox(itemsData[i], boundingBox);
            else if (itemsData[i] && itemsData[i].it) this.calculateBoundingBox(itemsData[i].it, boundingBox);
            else if (itemsData[i] && itemsData[i].style && itemsData[i].w) this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
        }
    };
    HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty, boundingBox) {
        var width = 0;
        if (widthProperty.keyframes) {
            for(var i = 0; i < widthProperty.keyframes.length; i += 1){
                var kfw = widthProperty.keyframes[i].s;
                if (kfw > width) width = kfw;
            }
            width *= widthProperty.mult;
        } else width = widthProperty.v * widthProperty.mult;
        boundingBox.x -= width;
        boundingBox.xMax += width;
        boundingBox.y -= width;
        boundingBox.yMax += width;
    };
    HShapeElement.prototype.currentBoxContains = function(box) {
        return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
    };
    HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
            var tempBoundingBox = this.tempBoundingBox;
            var max = 999999;
            tempBoundingBox.x = max;
            tempBoundingBox.xMax = -max;
            tempBoundingBox.y = max;
            tempBoundingBox.yMax = -max;
            this.calculateBoundingBox(this.itemsData, tempBoundingBox);
            tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
            tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();
            if (this.currentBoxContains(tempBoundingBox)) return;
            var changed = false;
            if (this.currentBBox.w !== tempBoundingBox.width) {
                this.currentBBox.w = tempBoundingBox.width;
                this.shapeCont.setAttribute("width", tempBoundingBox.width);
                changed = true;
            }
            if (this.currentBBox.h !== tempBoundingBox.height) {
                this.currentBBox.h = tempBoundingBox.height;
                this.shapeCont.setAttribute("height", tempBoundingBox.height);
                changed = true;
            }
            if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
                this.currentBBox.w = tempBoundingBox.width;
                this.currentBBox.h = tempBoundingBox.height;
                this.currentBBox.x = tempBoundingBox.x;
                this.currentBBox.y = tempBoundingBox.y;
                this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                var shapeStyle = this.shapeCont.style;
                var shapeTransform = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                shapeStyle.transform = shapeTransform;
                shapeStyle.webkitTransform = shapeTransform;
            }
        }
    };
    function HTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
        this.renderType = "svg";
        this.isMasked = false;
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement);
    HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
            this.renderType = "svg";
            this.compW = this.comp.data.w;
            this.compH = this.comp.data.h;
            this.svgElement.setAttribute("width", this.compW);
            this.svgElement.setAttribute("height", this.compH);
            var g = createNS("g");
            this.maskedElement.appendChild(g);
            this.innerElem = g;
        } else {
            this.renderType = "html";
            this.innerElem = this.layerElement;
        }
        this.checkParenting();
    };
    HTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var innerElemStyle = this.innerElem.style;
        var textColor = documentData.fc ? this.buildColor(documentData.fc) : "rgba(0,0,0,0)";
        innerElemStyle.fill = textColor;
        innerElemStyle.color = textColor;
        if (documentData.sc) {
            innerElemStyle.stroke = this.buildColor(documentData.sc);
            innerElemStyle.strokeWidth = documentData.sw + "px";
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (!this.globalData.fontManager.chars) {
            innerElemStyle.fontSize = documentData.finalSize + "px";
            innerElemStyle.lineHeight = documentData.finalSize + "px";
            if (fontData.fClass) this.innerElem.className = fontData.fClass;
            else {
                innerElemStyle.fontFamily = fontData.fFamily;
                var fWeight = documentData.fWeight;
                var fStyle = documentData.fStyle;
                innerElemStyle.fontStyle = fStyle;
                innerElemStyle.fontWeight = fWeight;
            }
        }
        var i;
        var len;
        var letters = documentData.l;
        len = letters.length;
        var tSpan;
        var tParent;
        var tCont;
        var matrixHelper = this.mHelper;
        var shapes;
        var shapeStr = "";
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            if (this.globalData.fontManager.chars) {
                if (!this.textPaths[cnt]) {
                    tSpan = createNS("path");
                    tSpan.setAttribute("stroke-linecap", lineCapEnum[1]);
                    tSpan.setAttribute("stroke-linejoin", lineJoinEnum[2]);
                    tSpan.setAttribute("stroke-miterlimit", "4");
                } else tSpan = this.textPaths[cnt];
                if (!this.isMasked) {
                    if (this.textSpans[cnt]) {
                        tParent = this.textSpans[cnt];
                        tCont = tParent.children[0];
                    } else {
                        tParent = createTag("div");
                        tParent.style.lineHeight = 0;
                        tCont = createNS("svg");
                        tCont.appendChild(tSpan);
                        styleDiv(tParent);
                    }
                }
            } else if (!this.isMasked) {
                if (this.textSpans[cnt]) {
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = createTag("span");
                    styleDiv(tParent);
                    tSpan = createTag("span");
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS("text");
             // tSpan.setAttribute('visibility', 'hidden');
            if (this.globalData.fontManager.chars) {
                var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                var shapeData;
                if (charData) shapeData = charData.data;
                else shapeData = null;
                matrixHelper.reset();
                if (shapeData && shapeData.shapes && shapeData.shapes.length) {
                    shapes = shapeData.shapes[0].it;
                    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
                    shapeStr = this.createPathShape(matrixHelper, shapes);
                    tSpan.setAttribute("d", shapeStr);
                }
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent);
                    if (shapeData && shapeData.shapes) {
                        // document.body.appendChild is needed to get exact measure of shape
                        document.body.appendChild(tCont);
                        var boundingBox = tCont.getBBox();
                        tCont.setAttribute("width", boundingBox.width + 2);
                        tCont.setAttribute("height", boundingBox.height + 2);
                        tCont.setAttribute("viewBox", boundingBox.x - 1 + " " + (boundingBox.y - 1) + " " + (boundingBox.width + 2) + " " + (boundingBox.height + 2));
                        var tContStyle = tCont.style;
                        var tContTranslation = "translate(" + (boundingBox.x - 1) + "px," + (boundingBox.y - 1) + "px)";
                        tContStyle.transform = tContTranslation;
                        tContStyle.webkitTransform = tContTranslation;
                        letters[i].yOffset = boundingBox.y - 1;
                    } else {
                        tCont.setAttribute("width", 1);
                        tCont.setAttribute("height", 1);
                    }
                    tParent.appendChild(tCont);
                } else this.innerElem.appendChild(tSpan);
            } else {
                tSpan.textContent = letters[i].val;
                tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent); //
                    var tStyle = tSpan.style;
                    var tSpanTranslation = "translate3d(0," + -documentData.finalSize / 1.2 + "px,0)";
                    tStyle.transform = tSpanTranslation;
                    tStyle.webkitTransform = tSpanTranslation;
                } else this.innerElem.appendChild(tSpan);
            } //
            if (!this.isMasked) this.textSpans[cnt] = tParent;
            else this.textSpans[cnt] = tSpan;
            this.textSpans[cnt].style.display = "block";
            this.textPaths[cnt] = tSpan;
            cnt += 1;
        }
        while(cnt < this.textSpans.length){
            this.textSpans[cnt].style.display = "none";
            cnt += 1;
        }
    };
    HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                // Todo Benchmark if using this is better than getBBox
                this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH);
                svgStyle = this.svgElement.style;
                var translation = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                svgStyle.transform = translation;
                svgStyle.webkitTransform = translation;
            }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) return;
        var i;
        var len;
        var count = 0;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var textPath;
        for(i = 0; i < len; i += 1)if (letters[i].n) count += 1;
        else {
            textSpan = this.textSpans[i];
            textPath = this.textPaths[i];
            renderedLetter = renderedLetters[count];
            count += 1;
            if (renderedLetter._mdf.m) {
                if (!this.isMasked) {
                    textSpan.style.webkitTransform = renderedLetter.m;
                    textSpan.style.transform = renderedLetter.m;
                } else textSpan.setAttribute("transform", renderedLetter.m);
            } /// /textSpan.setAttribute('opacity',renderedLetter.o);
            textSpan.style.opacity = renderedLetter.o;
            if (renderedLetter.sw && renderedLetter._mdf.sw) textPath.setAttribute("stroke-width", renderedLetter.sw);
            if (renderedLetter.sc && renderedLetter._mdf.sc) textPath.setAttribute("stroke", renderedLetter.sc);
            if (renderedLetter.fc && renderedLetter._mdf.fc) {
                textPath.setAttribute("fill", renderedLetter.fc);
                textPath.style.color = renderedLetter.fc;
            }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var boundingBox = this.innerElem.getBBox();
            if (this.currentBBox.w !== boundingBox.width) {
                this.currentBBox.w = boundingBox.width;
                this.svgElement.setAttribute("width", boundingBox.width);
            }
            if (this.currentBBox.h !== boundingBox.height) {
                this.currentBBox.h = boundingBox.height;
                this.svgElement.setAttribute("height", boundingBox.height);
            }
            var margin = 1;
            if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
                this.currentBBox.w = boundingBox.width + margin * 2;
                this.currentBBox.h = boundingBox.height + margin * 2;
                this.currentBBox.x = boundingBox.x - margin;
                this.currentBBox.y = boundingBox.y - margin;
                this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                svgStyle = this.svgElement.style;
                var svgTransform = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                svgStyle.transform = svgTransform;
                svgStyle.webkitTransform = svgTransform;
            }
        }
    };
    function HCameraElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initHierarchy();
        var getProp = PropertyFactory.getProp;
        this.pe = getProp(this, data.pe, 0, 0, this);
        if (data.ks.p.s) {
            this.px = getProp(this, data.ks.p.x, 1, 0, this);
            this.py = getProp(this, data.ks.p.y, 1, 0, this);
            this.pz = getProp(this, data.ks.p.z, 1, 0, this);
        } else this.p = getProp(this, data.ks.p, 1, 0, this);
        if (data.ks.a) this.a = getProp(this, data.ks.a, 1, 0, this);
        if (data.ks.or.k.length && data.ks.or.k[0].to) {
            var i;
            var len = data.ks.or.k.length;
            for(i = 0; i < len; i += 1){
                data.ks.or.k[i].to = null;
                data.ks.or.k[i].ti = null;
            }
        }
        this.or = getProp(this, data.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
        this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
        this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
        this.finalTransform = {
            mProp: this
        };
    }
    extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement);
    HCameraElement.prototype.setup = function() {
        var i;
        var len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;
        for(i = 0; i < len; i += 1){
            // [perspectiveElem,container]
            comp = this.comp.threeDElements[i];
            if (comp.type === "3d") {
                perspectiveStyle = comp.perspectiveElem.style;
                containerStyle = comp.container.style;
                var perspective = this.pe.v + "px";
                var origin = "0px 0px 0px";
                var matrix = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                perspectiveStyle.perspective = perspective;
                perspectiveStyle.webkitPerspective = perspective;
                containerStyle.transformOrigin = origin;
                containerStyle.mozTransformOrigin = origin;
                containerStyle.webkitTransformOrigin = origin;
                perspectiveStyle.transform = matrix;
                perspectiveStyle.webkitTransform = matrix;
            }
        }
    };
    HCameraElement.prototype.createElements = function() {};
    HCameraElement.prototype.hide = function() {};
    HCameraElement.prototype.renderFrame = function() {
        var _mdf = this._isFirstFrame;
        var i;
        var len;
        if (this.hierarchy) {
            len = this.hierarchy.length;
            for(i = 0; i < len; i += 1)_mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
        }
        if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            this.mat.reset();
            if (this.hierarchy) {
                len = this.hierarchy.length - 1;
                for(i = len; i >= 0; i -= 1){
                    var mTransf = this.hierarchy[i].finalTransform.mProp;
                    this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
                    this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
                    this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
                    this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
                    this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
                }
            }
            if (this.p) this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
            else this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
            if (this.a) {
                var diffVector;
                if (this.p) diffVector = [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ];
                else diffVector = [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
                var lookDir = [
                    diffVector[0] / mag,
                    diffVector[1] / mag,
                    diffVector[2] / mag
                ];
                var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
                var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
                var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
                this.mat.rotateY(mRotationY).rotateX(-mRotationX);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
            this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
            this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
            this.mat.translate(0, 0, this.pe.v);
            var hasMatrixChanged = !this._prevMat.equals(this.mat);
            if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
                len = this.comp.threeDElements.length;
                var comp;
                var perspectiveStyle;
                var containerStyle;
                for(i = 0; i < len; i += 1){
                    comp = this.comp.threeDElements[i];
                    if (comp.type === "3d") {
                        if (hasMatrixChanged) {
                            var matValue = this.mat.toCSS();
                            containerStyle = comp.container.style;
                            containerStyle.transform = matValue;
                            containerStyle.webkitTransform = matValue;
                        }
                        if (this.pe._mdf) {
                            perspectiveStyle = comp.perspectiveElem.style;
                            perspectiveStyle.perspective = this.pe.v + "px";
                            perspectiveStyle.webkitPerspective = this.pe.v + "px";
                        }
                    }
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = false;
    };
    HCameraElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    HCameraElement.prototype.destroy = function() {};
    HCameraElement.prototype.getBaseElement = function() {
        return null;
    };
    function HImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement);
    HImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        var img = new Image();
        if (this.data.hasMask) {
            this.imageElem = createNS("image");
            this.imageElem.setAttribute("width", this.assetData.w + "px");
            this.imageElem.setAttribute("height", this.assetData.h + "px");
            this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", assetPath);
            this.layerElement.appendChild(this.imageElem);
            this.baseElement.setAttribute("width", this.assetData.w);
            this.baseElement.setAttribute("height", this.assetData.h);
        } else this.layerElement.appendChild(img);
        img.crossOrigin = "anonymous";
        img.src = assetPath;
        if (this.data.ln) this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || "",
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || "xMidYMid slice",
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || "400%",
                height: config && config.filterSize && config.filterSize.height || "400%",
                x: config && config.filterSize && config.filterSize.x || "-100%",
                y: config && config.filterSize && config.filterSize.y || "-100%"
            }
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = "html";
    }
    extendPrototype([
        BaseRenderer
    ], HybridRendererBase);
    HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
    HybridRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    HybridRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newDOMElement = element.getBaseElement();
        if (!newDOMElement) return;
        var layer = this.layers[pos];
        if (!layer.ddd || !this.supports3d) {
            if (this.threeDElements) this.addTo3dContainer(newDOMElement, pos);
            else {
                var i = 0;
                var nextDOMElement;
                var nextLayer;
                var tmpDOMElement;
                while(i < pos){
                    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
                        nextLayer = this.elements[i];
                        tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
                        nextDOMElement = tmpDOMElement || nextDOMElement;
                    }
                    i += 1;
                }
                if (nextDOMElement) {
                    if (!layer.ddd || !this.supports3d) this.layerElement.insertBefore(newDOMElement, nextDOMElement);
                } else if (!layer.ddd || !this.supports3d) this.layerElement.appendChild(newDOMElement);
            }
        } else this.addTo3dContainer(newDOMElement, pos);
    };
    HybridRendererBase.prototype.createShape = function(data) {
        if (!this.supports3d) return new SVGShapeElement(data, this.globalData, this);
        return new HShapeElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createText = function(data) {
        if (!this.supports3d) return new SVGTextLottieElement(data, this.globalData, this);
        return new HTextElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createCamera = function(data) {
        this.camera = new HCameraElement(data, this.globalData, this);
        return this.camera;
    };
    HybridRendererBase.prototype.createImage = function(data) {
        if (!this.supports3d) return new IImageElement(data, this.globalData, this);
        return new HImageElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createSolid = function(data) {
        if (!this.supports3d) return new ISolidElement(data, this.globalData, this);
        return new HSolidElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    HybridRendererBase.prototype.getThreeDContainerByPos = function(pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) return this.threeDElements[i].perspectiveElem;
            i += 1;
        }
        return null;
    };
    HybridRendererBase.prototype.createThreeDContainer = function(pos, type) {
        var perspectiveElem = createTag("div");
        var style;
        var containerStyle;
        styleDiv(perspectiveElem);
        var container = createTag("div");
        styleDiv(container);
        if (type === "3d") {
            style = perspectiveElem.style;
            style.width = this.globalData.compSize.w + "px";
            style.height = this.globalData.compSize.h + "px";
            var center = "50% 50%";
            style.webkitTransformOrigin = center;
            style.mozTransformOrigin = center;
            style.transformOrigin = center;
            containerStyle = container.style;
            var matrix = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
            containerStyle.transform = matrix;
            containerStyle.webkitTransform = matrix;
        }
        perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);
        var threeDContainerData = {
            container: container,
            perspectiveElem: perspectiveElem,
            startPos: pos,
            endPos: pos,
            type: type
        };
        this.threeDElements.push(threeDContainerData);
        return threeDContainerData;
    };
    HybridRendererBase.prototype.build3dContainers = function() {
        var i;
        var len = this.layers.length;
        var lastThreeDContainerData;
        var currentContainer = "";
        for(i = 0; i < len; i += 1)if (this.layers[i].ddd && this.layers[i].ty !== 3) {
            if (currentContainer !== "3d") {
                currentContainer = "3d";
                lastThreeDContainerData = this.createThreeDContainer(i, "3d");
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        } else {
            if (currentContainer !== "2d") {
                currentContainer = "2d";
                lastThreeDContainerData = this.createThreeDContainer(i, "2d");
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        }
        len = this.threeDElements.length;
        for(i = len - 1; i >= 0; i -= 1)this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    };
    HybridRendererBase.prototype.addTo3dContainer = function(elem, pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (pos <= this.threeDElements[i].endPos) {
                var j = this.threeDElements[i].startPos;
                var nextElement;
                while(j < pos){
                    if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
                    j += 1;
                }
                if (nextElement) this.threeDElements[i].container.insertBefore(elem, nextElement);
                else this.threeDElements[i].container.appendChild(elem);
                break;
            }
            i += 1;
        }
    };
    HybridRendererBase.prototype.configAnimation = function(animData) {
        var resizerElem = createTag("div");
        var wrapper = this.animationItem.wrapper;
        var style = resizerElem.style;
        style.width = animData.w + "px";
        style.height = animData.h + "px";
        this.resizerElem = resizerElem;
        styleDiv(resizerElem);
        style.transformStyle = "flat";
        style.mozTransformStyle = "flat";
        style.webkitTransformStyle = "flat";
        if (this.renderConfig.className) resizerElem.setAttribute("class", this.renderConfig.className);
        wrapper.appendChild(resizerElem);
        style.overflow = "hidden";
        var svg = createNS("svg");
        svg.setAttribute("width", "1");
        svg.setAttribute("height", "1");
        styleDiv(svg);
        this.resizerElem.appendChild(svg);
        var defs = createNS("defs");
        svg.appendChild(defs);
        this.data = animData; // Mask animation
        this.setupGlobalData(animData, svg);
        this.globalData.defs = defs;
        this.layers = animData.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
    };
    HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth = this.animationItem.wrapper.offsetWidth;
        var elementHeight = this.animationItem.wrapper.offsetHeight;
        var elementRel = elementWidth / elementHeight;
        var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx;
        var sy;
        var tx;
        var ty;
        if (animationRel > elementRel) {
            sx = elementWidth / this.globalData.compSize.w;
            sy = elementWidth / this.globalData.compSize.w;
            tx = 0;
            ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
        } else {
            sx = elementHeight / this.globalData.compSize.h;
            sy = elementHeight / this.globalData.compSize.h;
            tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
            ty = 0;
        }
        var style = this.resizerElem.style;
        style.webkitTransform = "matrix3d(" + sx + ",0,0,0,0," + sy + ",0,0,0,0,1,0," + tx + "," + ty + ",0,1)";
        style.transform = style.webkitTransform;
    };
    HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
    HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = "none";
    };
    HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = "block";
    };
    HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) this.camera.setup();
        else {
            var cWidth = this.globalData.compSize.w;
            var cHeight = this.globalData.compSize.h;
            var i;
            var len = this.threeDElements.length;
            for(i = 0; i < len; i += 1){
                var style = this.threeDElements[i].perspectiveElem.style;
                style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + "px";
                style.perspective = style.webkitPerspective;
            }
        }
    };
    HybridRendererBase.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        var floatingContainer = createTag("div");
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    function HCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = !data.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        HybridRendererBase,
        ICompElement,
        HBaseElement
    ], HCompElement);
    HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
    HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
        if (this.data.hasMask) {
            this.svgElement.setAttribute("width", this.data.w);
            this.svgElement.setAttribute("height", this.data.h);
            this.transformedElement = this.baseElement;
        } else this.transformedElement = this.layerElement;
    };
    HCompElement.prototype.addTo3dContainer = function(elem, pos) {
        var j = 0;
        var nextElement;
        while(j < pos){
            if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
            j += 1;
        }
        if (nextElement) this.layerElement.insertBefore(elem, nextElement);
        else this.layerElement.appendChild(elem);
    };
    HCompElement.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    function HybridRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || "",
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || "xMidYMid slice",
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || "400%",
                height: config && config.filterSize && config.filterSize.height || "400%",
                x: config && config.filterSize && config.filterSize.x || "-100%",
                y: config && config.filterSize && config.filterSize.y || "-100%"
            },
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = "html";
    }
    extendPrototype([
        HybridRendererBase
    ], HybridRenderer);
    HybridRenderer.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    var CompExpressionInterface = function() {
        return function(comp) {
            function _thisLayerFunction(name) {
                var i = 0;
                var len = comp.layers.length;
                while(i < len){
                    if (comp.layers[i].nm === name || comp.layers[i].ind === name) return comp.elements[i].layerInterface;
                    i += 1;
                }
                return null; // return {active:false};
            }
            Object.defineProperty(_thisLayerFunction, "_name", {
                value: comp.data.nm
            });
            _thisLayerFunction.layer = _thisLayerFunction;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
            _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
            _thisLayerFunction.displayStartTime = 0;
            _thisLayerFunction.numLayers = comp.layers.length;
            return _thisLayerFunction;
        };
    }();
    function _typeof$2(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$2 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$2(obj);
    }
    /* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */ function seedRandom(pool, math) {
        //
        // The following constants are related to IEEE 754 limits.
        //
        var global = this, width = 256, // each RC4 output is 0 <= x < 256
        chunks = 6, // at least six RC4 outputs for each double
        digits = 52, // there are 52 significant digits in a double
        rngname = "random", // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
        //
        // seedrandom()
        // This is the seedrandom function described above.
        //
        function seedrandom(seed, options, callback) {
            var key = [];
            options = options === true ? {
                entropy: true
            } : options || {}; // Flatten the seed string or build one from local entropy if needed.
            var shortseed = mixkey(flatten(options.entropy ? [
                seed,
                tostring(pool)
            ] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.
            var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
            // randomness in every bit of the mantissa of the IEEE 754 value.
            var prng = function prng() {
                var n = arc4.g(chunks), // Start with a numerator n < 2 ^ 48
                d = startdenom, //   and denominator d = 2 ^ 48.
                x = 0; //   and no 'extra last byte'.
                while(n < significance){
                    // Fill up all significant digits by
                    n = (n + x) * width; //   shifting numerator and
                    d *= width; //   denominator and generating a
                    x = arc4.g(1); //   new least-significant-byte.
                }
                while(n >= overflow){
                    // To avoid rounding up, before adding
                    n /= 2; //   last byte, shift everything
                    d /= 2; //   right using integer math until
                    x >>>= 1; //   we have exactly the desired bits.
                }
                return (n + x) / d; // Form the number within [0, 1).
            };
            prng.int32 = function() {
                return arc4.g(4) | 0;
            };
            prng.quick = function() {
                return arc4.g(4) / 0x100000000;
            };
            prng["double"] = prng; // Mix the randomness into accumulated entropy.
            mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.
            return (options.pass || callback || function(prng, seed, is_math_call, state) {
                if (state) {
                    // Load the arc4 state from the given state if it has an S array.
                    if (state.S) copy(state, arc4);
                     // Only provide the .state method if requested via options.state.
                    prng.state = function() {
                        return copy(arc4, {});
                    };
                } // If called as a method of Math (Math.seedrandom()), mutate
                // Math.random because that is how seedrandom.js has worked since v1.0.
                if (is_math_call) {
                    math[rngname] = prng;
                    return seed;
                } else return prng;
            })(prng, shortseed, "global" in options ? options.global : this == math, options.state);
        }
        math["seed" + rngname] = seedrandom; //
        // ARC4
        //
        // An ARC4 implementation.  The constructor takes a key in the form of
        // an array of at most (width) integers that should be 0 <= x < (width).
        //
        // The g(count) method returns a pseudorandom integer that concatenates
        // the next (count) outputs from ARC4.  Its return value is a number x
        // that is in the range 0 <= x < (width ^ count).
        //
        function ARC4(key) {
            var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = []; // The empty key [] is treated as [0].
            if (!keylen) key = [
                keylen++
            ];
             // Set up S using the standard key scheduling algorithm.
            while(i < width)s[i] = i++;
            for(i = 0; i < width; i++){
                s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
                s[j] = t;
            } // The "g" method returns the next (count) outputs as one number.
            me.g = function(count) {
                // Using instance members instead of closure state nearly doubles speed.
                var t, r = 0, i = me.i, j = me.j, s = me.S;
                while(count--){
                    t = s[i = mask & i + 1];
                    r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
                }
                me.i = i;
                me.j = j;
                return r; // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
            };
        } //
        // copy()
        // Copies internal state of ARC4 to or from a plain object.
        //
        function copy(f, t) {
            t.i = f.i;
            t.j = f.j;
            t.S = f.S.slice();
            return t;
        } //
        // flatten()
        // Converts an object tree to nested arrays of strings.
        //
        function flatten(obj, depth) {
            var result = [], typ = _typeof$2(obj), prop;
            if (depth && typ == "object") {
                for(prop in obj)try {
                    result.push(flatten(obj[prop], depth - 1));
                } catch (e) {}
            }
            return result.length ? result : typ == "string" ? obj : obj + "\0";
        } //
        // mixkey()
        // Mixes a string seed into a key that is an array of integers, and
        // returns a shortened string seed that is equivalent to the result key.
        //
        function mixkey(seed, key) {
            var stringseed = seed + "", smear, j = 0;
            while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
            return tostring(key);
        } //
        // autoseed()
        // Returns an object for autoseeding, using window.crypto and Node crypto
        // module if available.
        //
        function autoseed() {
            try {
                if (nodecrypto) return tostring(nodecrypto.randomBytes(width));
                var out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
                return tostring(out);
            } catch (e) {
                var browser = global.navigator, plugins = browser && browser.plugins;
                return [
                    +new Date(),
                    global,
                    plugins,
                    global.screen,
                    tostring(pool)
                ];
            }
        } //
        // tostring()
        // Converts an array of charcodes to a string
        //
        function tostring(a) {
            return String.fromCharCode.apply(0, a);
        } //
        // When seedrandom.js is loaded, we immediately mix a few bits
        // from the built-in RNG into the entropy pool.  Because we do
        // not want to interfere with deterministic PRNG state later,
        // seedrandom will not call math.random on its own again after
        // initialization.
        //
        mixkey(math.random(), pool); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
    }
    function initialize$2(BMMath) {
        seedRandom([], BMMath);
    }
    var propTypes = {
        SHAPE: "shape"
    };
    function _typeof$1(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$1 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$1(obj);
    }
    var ExpressionManager = function() {
        "use strict";
        var ob = {};
        var Math1 = BMMath;
        var window1 = null;
        var document1 = null;
        var XMLHttpRequest1 = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
            _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr) {
            return arr.constructor === Array || arr.constructor === Float32Array;
        }
        function isNumerable(tOfV, v) {
            return tOfV === "number" || v instanceof Number || tOfV === "boolean" || tOfV === "string";
        }
        function $bm_neg(a) {
            var tOfA = _typeof$1(a);
            if (tOfA === "number" || a instanceof Number || tOfA === "boolean") return -a;
            if ($bm_isInstanceOfArray(a)) {
                var i;
                var lenA = a.length;
                var retArr = [];
                for(i = 0; i < lenA; i += 1)retArr[i] = -a[i];
                return retArr;
            }
            if (a.propType) return a.v;
            return -a;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
        function sum(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === "string" || tOfB === "string") return a + b;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] += b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a + b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === "number" || a[i] instanceof Number) && (typeof b[i] === "number" || b[i] instanceof Number)) retArr[i] = a[i] + b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        var add = sum;
        function sub(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
                if (tOfA === "string") a = parseInt(a, 10);
                if (tOfB === "string") b = parseInt(b, 10);
                return a - b;
            }
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] -= b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a - b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === "number" || a[i] instanceof Number) && (typeof b[i] === "number" || b[i] instanceof Number)) retArr[i] = a[i] - b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        function mul(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a * b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray("float32", len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] * b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray("float32", len);
                for(i = 0; i < len; i += 1)arr[i] = a * b[i];
                return arr;
            }
            return 0;
        }
        function div(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a / b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray("float32", len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] / b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray("float32", len);
                for(i = 0; i < len; i += 1)arr[i] = a / b[i];
                return arr;
            }
            return 0;
        }
        function mod(a, b) {
            if (typeof a === "string") a = parseInt(a, 10);
            if (typeof b === "string") b = parseInt(b, 10);
            return a % b;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num, min, max) {
            if (min > max) {
                var mm = max;
                max = min;
                min = mm;
            }
            return Math1.min(Math1.max(num, min), max);
        }
        function radiansToDegrees(val) {
            return val / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val) {
            return val * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(arr1, arr2) {
            if (typeof arr1 === "number" || arr1 instanceof Number) {
                arr2 = arr2 || 0;
                return Math1.abs(arr1 - arr2);
            }
            if (!arr2) arr2 = helperLengthArray;
            var i;
            var len = Math1.min(arr1.length, arr2.length);
            var addedLength = 0;
            for(i = 0; i < len; i += 1)addedLength += Math1.pow(arr2[i] - arr1[i], 2);
            return Math1.sqrt(addedLength);
        }
        function normalize(vec) {
            return div(vec, length(vec));
        }
        function rgbToHsl(val) {
            var r = val[0];
            var g = val[1];
            var b = val[2];
            var max = Math1.max(r, g, b);
            var min = Math1.min(r, g, b);
            var h;
            var s;
            var l = (max + min) / 2;
            if (max === min) {
                h = 0; // achromatic
                s = 0; // achromatic
            } else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                    default:
                        break;
                }
                h /= 6;
            }
            return [
                h,
                s,
                l,
                val[3]
            ];
        }
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        function hslToRgb(val) {
            var h = val[0];
            var s = val[1];
            var l = val[2];
            var r;
            var g;
            var b;
            if (s === 0) {
                r = l; // achromatic
                b = l; // achromatic
                g = l; // achromatic
            } else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return [
                r,
                g,
                b,
                val[3]
            ];
        }
        function linear(t, tMin, tMax, value1, value2) {
            if (value1 === undefined || value2 === undefined) {
                value1 = tMin;
                value2 = tMax;
                tMin = 0;
                tMax = 1;
            }
            if (tMax < tMin) {
                var _tMin = tMax;
                tMax = tMin;
                tMin = _tMin;
            }
            if (t <= tMin) return value1;
            if (t >= tMax) return value2;
            var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
            if (!value1.length) return value1 + (value2 - value1) * perc;
            var i;
            var len = value1.length;
            var arr = createTypedArray("float32", len);
            for(i = 0; i < len; i += 1)arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
            return arr;
        }
        function random(min, max) {
            if (max === undefined) {
                if (min === undefined) {
                    min = 0;
                    max = 1;
                } else {
                    max = min;
                    min = undefined;
                }
            }
            if (max.length) {
                var i;
                var len = max.length;
                if (!min) min = createTypedArray("float32", len);
                var arr = createTypedArray("float32", len);
                var rnd = BMMath.random();
                for(i = 0; i < len; i += 1)arr[i] = min[i] + rnd * (max[i] - min[i]);
                return arr;
            }
            if (min === undefined) min = 0;
            var rndm = BMMath.random();
            return min + rndm * (max - min);
        }
        function createPath(points, inTangents, outTangents, closed) {
            var i;
            var len = points.length;
            var path = shapePool.newElement();
            path.setPathData(!!closed, len);
            var arrPlaceholder = [
                0,
                0
            ];
            var inVertexPoint;
            var outVertexPoint;
            for(i = 0; i < len; i += 1){
                inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
                outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
                path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
            }
            return path;
        }
        function initiateExpression(elem, data, property) {
            // Bail out if we don't want expressions
            function noOp(_value) {
                return _value;
            }
            if (!elem.globalData.renderConfig.runExpressions) return noOp;
            var val = data.x;
            var needsVelocity = /velocity(?![\w\d])/.test(val);
            var _needsRandom = val.indexOf("random") !== -1;
            var elemType = elem.data.ty;
            var transform;
            var $bm_transform;
            var content;
            var effect;
            var thisProperty = property;
            thisProperty.valueAtTime = thisProperty.getValueAtTime;
            Object.defineProperty(thisProperty, "value", {
                get: function get() {
                    return thisProperty.v;
                }
            });
            elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
            elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            var outPoint = elem.data.op / elem.comp.globalData.frameRate;
            var width = elem.data.sw ? elem.data.sw : 0;
            var height = elem.data.sh ? elem.data.sh : 0;
            var name = elem.data.nm;
            var loopIn;
            var loop_in;
            var loopOut;
            var loop_out;
            var smooth;
            var toWorld;
            var fromWorld;
            var fromComp;
            var toComp;
            var fromCompToSurface;
            var position;
            var rotation;
            var anchorPoint;
            var scale;
            var thisLayer;
            var thisComp;
            var mask;
            var valueAtTime;
            var velocityAtTime;
            var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
            var expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0]; // eslint-disable-line no-eval
            var numKeys = property.kf ? data.k.length : 0;
            var active = !this.data || this.data.hd !== true;
            var wiggle = (function wiggle(freq, amp) {
                var iWiggle;
                var j;
                var lenWiggle = this.pv.length ? this.pv.length : 1;
                var addedAmps = createTypedArray("float32", lenWiggle);
                freq = 5;
                var iterations = Math1.floor(time * freq);
                iWiggle = 0;
                j = 0;
                while(iWiggle < iterations){
                    // var rnd = BMMath.random();
                    for(j = 0; j < lenWiggle; j += 1)addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
                    iWiggle += 1;
                } // var rnd2 = BMMath.random();
                var periods = time * freq;
                var perc = periods - Math1.floor(periods);
                var arr = createTypedArray("float32", lenWiggle);
                if (lenWiggle > 1) {
                    for(j = 0; j < lenWiggle; j += 1)arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    return arr;
                }
                return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
            }).bind(this);
            if (thisProperty.loopIn) {
                loopIn = thisProperty.loopIn.bind(thisProperty);
                loop_in = loopIn;
            }
            if (thisProperty.loopOut) {
                loopOut = thisProperty.loopOut.bind(thisProperty);
                loop_out = loopOut;
            }
            if (thisProperty.smooth) smooth = thisProperty.smooth.bind(thisProperty);
            function loopInDuration(type, duration) {
                return loopIn(type, duration, true);
            }
            function loopOutDuration(type, duration) {
                return loopOut(type, duration, true);
            }
            if (this.getValueAtTime) valueAtTime = this.getValueAtTime.bind(this);
            if (this.getVelocityAtTime) velocityAtTime = this.getVelocityAtTime.bind(this);
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
            function lookAt(elem1, elem2) {
                var fVec = [
                    elem2[0] - elem1[0],
                    elem2[1] - elem1[1],
                    elem2[2] - elem1[2]
                ];
                var pitch = Math1.atan2(fVec[0], Math1.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
                var yaw = -Math1.atan2(fVec[1], fVec[2]) / degToRads;
                return [
                    yaw,
                    pitch,
                    0
                ];
            }
            function easeOut(t, tMin, tMax, val1, val2) {
                return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
            }
            function easeIn(t, tMin, tMax, val1, val2) {
                return applyEase(easeInBez, t, tMin, tMax, val1, val2);
            }
            function ease(t, tMin, tMax, val1, val2) {
                return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
            }
            function applyEase(fn, t, tMin, tMax, val1, val2) {
                if (val1 === undefined) {
                    val1 = tMin;
                    val2 = tMax;
                } else t = (t - tMin) / (tMax - tMin);
                if (t > 1) t = 1;
                else if (t < 0) t = 0;
                var mult = fn(t);
                if ($bm_isInstanceOfArray(val1)) {
                    var iKey;
                    var lenKey = val1.length;
                    var arr = createTypedArray("float32", lenKey);
                    for(iKey = 0; iKey < lenKey; iKey += 1)arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
                    return arr;
                }
                return (val2 - val1) * mult + val1;
            }
            function nearestKey(time) {
                var iKey;
                var lenKey = data.k.length;
                var index;
                var keyTime;
                if (!data.k.length || typeof data.k[0] === "number") {
                    index = 0;
                    keyTime = 0;
                } else {
                    index = -1;
                    time *= elem.comp.globalData.frameRate;
                    if (time < data.k[0].t) {
                        index = 1;
                        keyTime = data.k[0].t;
                    } else {
                        for(iKey = 0; iKey < lenKey - 1; iKey += 1){
                            if (time === data.k[iKey].t) {
                                index = iKey + 1;
                                keyTime = data.k[iKey].t;
                                break;
                            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                                    index = iKey + 2;
                                    keyTime = data.k[iKey + 1].t;
                                } else {
                                    index = iKey + 1;
                                    keyTime = data.k[iKey].t;
                                }
                                break;
                            }
                        }
                        if (index === -1) {
                            index = iKey + 1;
                            keyTime = data.k[iKey].t;
                        }
                    }
                }
                var obKey = {};
                obKey.index = index;
                obKey.time = keyTime / elem.comp.globalData.frameRate;
                return obKey;
            }
            function key(ind) {
                var obKey;
                var iKey;
                var lenKey;
                if (!data.k.length || typeof data.k[0] === "number") throw new Error("The property has no keyframe at index " + ind);
                ind -= 1;
                obKey = {
                    time: data.k[ind].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var arr = Object.prototype.hasOwnProperty.call(data.k[ind], "s") ? data.k[ind].s : data.k[ind - 1].e;
                lenKey = arr.length;
                for(iKey = 0; iKey < lenKey; iKey += 1){
                    obKey[iKey] = arr[iKey];
                    obKey.value[iKey] = arr[iKey];
                }
                return obKey;
            }
            function framesToTime(fr, fps) {
                if (!fps) fps = elem.comp.globalData.frameRate;
                return fr / fps;
            }
            function timeToFrames(t, fps) {
                if (!t && t !== 0) t = time;
                if (!fps) fps = elem.comp.globalData.frameRate;
                return t * fps;
            }
            function seedRandom(seed) {
                BMMath.seedrandom(randSeed + seed);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(init, end) {
                if (typeof value === "string") {
                    if (end === undefined) return value.substring(init);
                    return value.substring(init, end);
                }
                return "";
            }
            function substr(init, end) {
                if (typeof value === "string") {
                    if (end === undefined) return value.substr(init);
                    return value.substr(init, end);
                }
                return "";
            }
            function posterizeTime(framesPerSecond) {
                time = framesPerSecond === 0 ? 0 : Math1.floor(time * framesPerSecond) / framesPerSecond;
                value = valueAtTime(time);
            }
            var time;
            var velocity;
            var value;
            var text;
            var textIndex;
            var textTotal;
            var selectorValue;
            var index = elem.data.ind;
            var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            var parent;
            var randSeed = Math1.floor(Math1.random() * 1000000);
            var globalData = elem.globalData;
            function executeExpression(_value) {
                // globalData.pushExpression();
                value = _value;
                if (this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector") return value;
                if (this.propType === "textSelector") {
                    textIndex = this.textIndex;
                    textTotal = this.textTotal;
                    selectorValue = this.selectorValue;
                }
                if (!thisLayer) {
                    text = elem.layerInterface.text;
                    thisLayer = elem.layerInterface;
                    thisComp = elem.comp.compInterface;
                    toWorld = thisLayer.toWorld.bind(thisLayer);
                    fromWorld = thisLayer.fromWorld.bind(thisLayer);
                    fromComp = thisLayer.fromComp.bind(thisLayer);
                    toComp = thisLayer.toComp.bind(thisLayer);
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
                    fromCompToSurface = fromComp;
                }
                if (!transform) {
                    transform = elem.layerInterface("ADBE Transform Group");
                    $bm_transform = transform;
                    if (transform) anchorPoint = transform.anchorPoint;
                }
                if (elemType === 4 && !content) content = thisLayer("ADBE Root Vectors Group");
                if (!effect) effect = thisLayer(4);
                hasParent = !!(elem.hierarchy && elem.hierarchy.length);
                if (hasParent && !parent) parent = elem.hierarchy[0].layerInterface;
                time = this.comp.renderedFrame / this.comp.globalData.frameRate;
                if (_needsRandom) seedRandom(randSeed + time);
                if (needsVelocity) velocity = velocityAtTime(time);
                expression_function();
                this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
                // Changed this to a ternary operation because Rollup failed compiling it correctly
                scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
                return scoped_bm_rt;
            } // Bundlers will see these as dead code and unless we reference them
            executeExpression.__preventDeadCodeRemoval = [
                $bm_transform,
                anchorPoint,
                time,
                velocity,
                inPoint,
                outPoint,
                width,
                height,
                name,
                loop_in,
                loop_out,
                smooth,
                toComp,
                fromCompToSurface,
                toWorld,
                fromWorld,
                mask,
                position,
                rotation,
                scale,
                thisComp,
                numKeys,
                active,
                wiggle,
                loopInDuration,
                loopOutDuration,
                comp,
                lookAt,
                easeOut,
                easeIn,
                ease,
                nearestKey,
                key,
                text,
                textIndex,
                textTotal,
                selectorValue,
                framesToTime,
                timeToFrames,
                sourceRectAtTime,
                substring,
                substr,
                posterizeTime,
                index,
                globalData
            ];
            return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [
            window1,
            document1,
            XMLHttpRequest1,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal
        ];
        ob.resetFrame = resetFrame;
        return ob;
    }();
    var Expressions = function() {
        var ob = {};
        ob.initExpressions = initExpressions;
        ob.resetFrame = ExpressionManager.resetFrame;
        function initExpressions(animation) {
            var stackCount = 0;
            var registers = [];
            function pushExpression() {
                stackCount += 1;
            }
            function popExpression() {
                stackCount -= 1;
                if (stackCount === 0) releaseInstances();
            }
            function registerExpressionProperty(expression) {
                if (registers.indexOf(expression) === -1) registers.push(expression);
            }
            function releaseInstances() {
                var i;
                var len = registers.length;
                for(i = 0; i < len; i += 1)registers[i].release();
                registers.length = 0;
            }
            animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
            animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
            animation.renderer.globalData.pushExpression = pushExpression;
            animation.renderer.globalData.popExpression = popExpression;
            animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
        }
        return ob;
    }();
    var MaskManagerInterface = function() {
        function MaskInterface(mask, data) {
            this._mask = mask;
            this._data = data;
        }
        Object.defineProperty(MaskInterface.prototype, "maskPath", {
            get: function get() {
                if (this._mask.prop.k) this._mask.prop.getValue();
                return this._mask.prop;
            }
        });
        Object.defineProperty(MaskInterface.prototype, "maskOpacity", {
            get: function get() {
                if (this._mask.op.k) this._mask.op.getValue();
                return this._mask.op.v * 100;
            }
        });
        var MaskManager = function MaskManager(maskManager) {
            var _masksInterfaces = createSizedArray(maskManager.viewData.length);
            var i;
            var len = maskManager.viewData.length;
            for(i = 0; i < len; i += 1)_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
            var maskFunction = function maskFunction(name) {
                i = 0;
                while(i < len){
                    if (maskManager.masksProperties[i].nm === name) return _masksInterfaces[i];
                    i += 1;
                }
                return null;
            };
            return maskFunction;
        };
        return MaskManager;
    }();
    var ExpressionPropertyInterface = function() {
        var defaultUnidimensionalValue = {
            pv: 0,
            v: 0,
            mult: 1
        };
        var defaultMultidimensionalValue = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function completeProperty(expressionValue, property, type) {
            Object.defineProperty(expressionValue, "velocity", {
                get: function get() {
                    return property.getVelocityAtTime(property.comp.currentFrame);
                }
            });
            expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
            expressionValue.key = function(pos) {
                if (!expressionValue.numKeys) return 0;
                var value = "";
                if ("s" in property.keyframes[pos - 1]) value = property.keyframes[pos - 1].s;
                else if ("e" in property.keyframes[pos - 2]) value = property.keyframes[pos - 2].e;
                else value = property.keyframes[pos - 2].s;
                var valueProp = type === "unidimensional" ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
                valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
                valueProp.value = type === "unidimensional" ? value[0] : value;
                return valueProp;
            };
            expressionValue.valueAtTime = property.getValueAtTime;
            expressionValue.speedAtTime = property.getSpeedAtTime;
            expressionValue.velocityAtTime = property.getVelocityAtTime;
            expressionValue.propertyGroup = property.propertyGroup;
        }
        function UnidimensionalPropertyInterface(property) {
            if (!property || !("pv" in property)) property = defaultUnidimensionalValue;
            var mult = 1 / property.mult;
            var val = property.pv * mult;
            var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
            expressionValue.value = val;
            completeProperty(expressionValue, property, "unidimensional");
            return function() {
                if (property.k) property.getValue();
                val = property.v * mult;
                if (expressionValue.value !== val) {
                    expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
                    expressionValue.value = val;
                    completeProperty(expressionValue, property, "unidimensional");
                }
                return expressionValue;
            };
        }
        function MultidimensionalPropertyInterface(property) {
            if (!property || !("pv" in property)) property = defaultMultidimensionalValue;
            var mult = 1 / property.mult;
            var len = property.data && property.data.l || property.pv.length;
            var expressionValue = createTypedArray("float32", len);
            var arrValue = createTypedArray("float32", len);
            expressionValue.value = arrValue;
            completeProperty(expressionValue, property, "multidimensional");
            return function() {
                if (property.k) property.getValue();
                for(var i = 0; i < len; i += 1){
                    arrValue[i] = property.v[i] * mult;
                    expressionValue[i] = arrValue[i];
                }
                return expressionValue;
            };
        } // TODO: try to avoid using this getter
        function defaultGetter() {
            return defaultUnidimensionalValue;
        }
        return function(property) {
            if (!property) return defaultGetter;
            if (property.propType === "unidimensional") return UnidimensionalPropertyInterface(property);
            return MultidimensionalPropertyInterface(property);
        };
    }();
    var TransformExpressionInterface = function() {
        return function(transform) {
            function _thisFunction(name) {
                switch(name){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return _thisFunction.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return _thisFunction.rotation;
                    case "ADBE Rotate X":
                        return _thisFunction.xRotation;
                    case "ADBE Rotate Y":
                        return _thisFunction.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return _thisFunction.position;
                    case "ADBE Position_0":
                        return _thisFunction.xPosition;
                    case "ADBE Position_1":
                        return _thisFunction.yPosition;
                    case "ADBE Position_2":
                        return _thisFunction.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return _thisFunction.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return _thisFunction.opacity;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisFunction, "rotation", {
                get: ExpressionPropertyInterface(transform.r || transform.rz)
            });
            Object.defineProperty(_thisFunction, "zRotation", {
                get: ExpressionPropertyInterface(transform.rz || transform.r)
            });
            Object.defineProperty(_thisFunction, "xRotation", {
                get: ExpressionPropertyInterface(transform.rx)
            });
            Object.defineProperty(_thisFunction, "yRotation", {
                get: ExpressionPropertyInterface(transform.ry)
            });
            Object.defineProperty(_thisFunction, "scale", {
                get: ExpressionPropertyInterface(transform.s)
            });
            var _px;
            var _py;
            var _pz;
            var _transformFactory;
            if (transform.p) _transformFactory = ExpressionPropertyInterface(transform.p);
            else {
                _px = ExpressionPropertyInterface(transform.px);
                _py = ExpressionPropertyInterface(transform.py);
                if (transform.pz) _pz = ExpressionPropertyInterface(transform.pz);
            }
            Object.defineProperty(_thisFunction, "position", {
                get: function get() {
                    if (transform.p) return _transformFactory();
                    return [
                        _px(),
                        _py(),
                        _pz ? _pz() : 0
                    ];
                }
            });
            Object.defineProperty(_thisFunction, "xPosition", {
                get: ExpressionPropertyInterface(transform.px)
            });
            Object.defineProperty(_thisFunction, "yPosition", {
                get: ExpressionPropertyInterface(transform.py)
            });
            Object.defineProperty(_thisFunction, "zPosition", {
                get: ExpressionPropertyInterface(transform.pz)
            });
            Object.defineProperty(_thisFunction, "anchorPoint", {
                get: ExpressionPropertyInterface(transform.a)
            });
            Object.defineProperty(_thisFunction, "opacity", {
                get: ExpressionPropertyInterface(transform.o)
            });
            Object.defineProperty(_thisFunction, "skew", {
                get: ExpressionPropertyInterface(transform.sk)
            });
            Object.defineProperty(_thisFunction, "skewAxis", {
                get: ExpressionPropertyInterface(transform.sa)
            });
            Object.defineProperty(_thisFunction, "orientation", {
                get: ExpressionPropertyInterface(transform.or)
            });
            return _thisFunction;
        };
    }();
    var LayerExpressionInterface = function() {
        function getMatrix(time) {
            var toWorldMat = new Matrix();
            if (time !== undefined) {
                var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
                propMatrix.clone(toWorldMat);
            } else {
                var transformMat = this._elem.finalTransform.mProp;
                transformMat.applyToMatrix(toWorldMat);
            }
            return toWorldMat;
        }
        function toWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.applyPoint(toWorldMat, arr);
        }
        function toWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.applyPoint(toWorldMat, arr);
        }
        function fromWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.invertPoint(toWorldMat, arr);
        }
        function fromWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.invertPoint(toWorldMat, arr);
        }
        function applyPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
        }
        function invertPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.inversePoint(arr);
        }
        function fromComp(arr) {
            var toWorldMat = new Matrix();
            toWorldMat.reset();
            this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
                return toWorldMat.inversePoint(arr);
            }
            return toWorldMat.inversePoint(arr);
        }
        function sampleImage() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(elem) {
            var transformInterface;
            function _registerMaskInterface(maskManager) {
                _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
            }
            function _registerEffectsInterface(effects) {
                _thisLayerFunction.effect = effects;
            }
            function _thisLayerFunction(name) {
                switch(name){
                    case "ADBE Root Vectors Group":
                    case "Contents":
                    case 2:
                        return _thisLayerFunction.shapeInterface;
                    case 1:
                    case 6:
                    case "Transform":
                    case "transform":
                    case "ADBE Transform Group":
                        return transformInterface;
                    case 4:
                    case "ADBE Effect Parade":
                    case "effects":
                    case "Effects":
                        return _thisLayerFunction.effect;
                    case "ADBE Text Properties":
                        return _thisLayerFunction.textInterface;
                    default:
                        return null;
                }
            }
            _thisLayerFunction.getMatrix = getMatrix;
            _thisLayerFunction.invertPoint = invertPoint;
            _thisLayerFunction.applyPoint = applyPoint;
            _thisLayerFunction.toWorld = toWorld;
            _thisLayerFunction.toWorldVec = toWorldVec;
            _thisLayerFunction.fromWorld = fromWorld;
            _thisLayerFunction.fromWorldVec = fromWorldVec;
            _thisLayerFunction.toComp = toWorld;
            _thisLayerFunction.fromComp = fromComp;
            _thisLayerFunction.sampleImage = sampleImage;
            _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
            _thisLayerFunction._elem = elem;
            transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
            var anchorPointDescriptor = getDescriptor(transformInterface, "anchorPoint");
            Object.defineProperties(_thisLayerFunction, {
                hasParent: {
                    get: function get() {
                        return elem.hierarchy.length;
                    }
                },
                parent: {
                    get: function get() {
                        return elem.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(transformInterface, "rotation"),
                scale: getDescriptor(transformInterface, "scale"),
                position: getDescriptor(transformInterface, "position"),
                opacity: getDescriptor(transformInterface, "opacity"),
                anchorPoint: anchorPointDescriptor,
                anchor_point: anchorPointDescriptor,
                transform: {
                    get: function get() {
                        return transformInterface;
                    }
                },
                active: {
                    get: function get() {
                        return elem.isInRange;
                    }
                }
            });
            _thisLayerFunction.startTime = elem.data.st;
            _thisLayerFunction.index = elem.data.ind;
            _thisLayerFunction.source = elem.data.refId;
            _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
            _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
            _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
            _thisLayerFunction._name = elem.data.nm;
            _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
            _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
            return _thisLayerFunction;
        };
    }();
    var propertyGroupFactory = function() {
        return function(interfaceFunction, parentPropertyGroup) {
            return function(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return parentPropertyGroup(val - 1);
            };
        };
    }();
    var PropertyInterface = function() {
        return function(propertyName, propertyGroup) {
            var interfaceFunction = {
                _name: propertyName
            };
            function _propertyGroup(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return propertyGroup(val - 1);
            }
            return _propertyGroup;
        };
    }();
    var EffectsExpressionInterface = function() {
        var ob = {
            createEffectsInterface: createEffectsInterface
        };
        function createEffectsInterface(elem, propertyGroup) {
            if (elem.effectsManager) {
                var effectElements = [];
                var effectsData = elem.data.ef;
                var i;
                var len = elem.effectsManager.effectElements.length;
                for(i = 0; i < len; i += 1)effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
                var effects = elem.data.ef || [];
                var groupInterface = function groupInterface(name) {
                    i = 0;
                    len = effects.length;
                    while(i < len){
                        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) return effectElements[i];
                        i += 1;
                    }
                    return null;
                };
                Object.defineProperty(groupInterface, "numProperties", {
                    get: function get() {
                        return effects.length;
                    }
                });
                return groupInterface;
            }
            return null;
        }
        function createGroupInterface(data, elements, propertyGroup, elem) {
            function groupInterface(name) {
                var effects = data.ef;
                var i = 0;
                var len = effects.length;
                while(i < len){
                    if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
                        if (effects[i].ty === 5) return effectElements[i];
                        return effectElements[i]();
                    }
                    i += 1;
                }
                throw new Error();
            }
            var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
            var effectElements = [];
            var i;
            var len = data.ef.length;
            for(i = 0; i < len; i += 1)if (data.ef[i].ty === 5) effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
            else effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
            if (data.mn === "ADBE Color Control") Object.defineProperty(groupInterface, "color", {
                get: function get() {
                    return effectElements[0]();
                }
            });
            Object.defineProperties(groupInterface, {
                numProperties: {
                    get: function get() {
                        return data.np;
                    }
                },
                _name: {
                    value: data.nm
                },
                propertyGroup: {
                    value: _propertyGroup
                }
            });
            groupInterface.enabled = data.en !== 0;
            groupInterface.active = groupInterface.enabled;
            return groupInterface;
        }
        function createValueInterface(element, type, elem, propertyGroup) {
            var expressionProperty = ExpressionPropertyInterface(element.p);
            function interfaceFunction() {
                if (type === 10) return elem.comp.compInterface(element.p.v);
                return expressionProperty();
            }
            if (element.p.setGroupProperty) element.p.setGroupProperty(PropertyInterface("", propertyGroup));
            return interfaceFunction;
        }
        return ob;
    }();
    var ShapePathInterface = function() {
        return function pathInterfaceFactory(shape, view, propertyGroup) {
            var prop = view.sh;
            function interfaceFunction(val) {
                if (val === "Shape" || val === "shape" || val === "Path" || val === "path" || val === "ADBE Vector Shape" || val === 2) return interfaceFunction.path;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            prop.setGroupProperty(PropertyInterface("Path", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                path: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                shape: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                _name: {
                    value: shape.nm
                },
                ix: {
                    value: shape.ix
                },
                propertyIndex: {
                    value: shape.ix
                },
                mn: {
                    value: shape.mn
                },
                propertyGroup: {
                    value: propertyGroup
                }
            });
            return interfaceFunction;
        };
    }();
    var ShapeExpressionInterface = function() {
        function iterateElements(shapes, view, propertyGroup) {
            var arr = [];
            var i;
            var len = shapes ? shapes.length : 0;
            for(i = 0; i < len; i += 1){
                if (shapes[i].ty === "gr") arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "fl") arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "st") arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "tm") arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "tr") ;
                else if (shapes[i].ty === "el") arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "sr") arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "sh") arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "rc") arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "rd") arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "rp") arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "gf") arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
            }
            return arr;
        }
        function contentsInterfaceFactory(shape, view, propertyGroup) {
            var interfaces;
            var interfaceFunction = function _interfaceFunction(value) {
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) return interfaces[i];
                    i += 1;
                }
                if (typeof value === "number") return interfaces[value - 1];
                return null;
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
            interfaceFunction.numProperties = interfaces.length;
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.transform = transformInterface;
            interfaceFunction.propertyIndex = shape.cix;
            interfaceFunction._name = shape.nm;
            return interfaceFunction;
        }
        function groupInterfaceFactory(shape, view, propertyGroup) {
            var interfaceFunction = function _interfaceFunction(value) {
                switch(value){
                    case "ADBE Vectors Group":
                    case "Contents":
                    case 2:
                        return interfaceFunction.content;
                    // Not necessary for now. Keeping them here in case a new case appears
                    // case 'ADBE Vector Transform Group':
                    // case 3:
                    default:
                        return interfaceFunction.transform;
                }
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, "_name", {
                get: function get() {
                    return shape.nm;
                }
            }); // interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function fillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === "Color" || val === "color") return interfaceFunction.color;
                if (val === "Opacity" || val === "opacity") return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface("Color", propertyGroup));
            view.o.setGroupProperty(PropertyInterface("Opacity", propertyGroup));
            return interfaceFunction;
        }
        function gradientFillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === "Start Point" || val === "start point") return interfaceFunction.startPoint;
                if (val === "End Point" || val === "end point") return interfaceFunction.endPoint;
                if (val === "Opacity" || val === "opacity") return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                startPoint: {
                    get: ExpressionPropertyInterface(view.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(view.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                type: {
                    get: function get() {
                        return "a";
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.s.setGroupProperty(PropertyInterface("Start Point", propertyGroup));
            view.e.setGroupProperty(PropertyInterface("End Point", propertyGroup));
            view.o.setGroupProperty(PropertyInterface("Opacity", propertyGroup));
            return interfaceFunction;
        }
        function defaultInterfaceFactory() {
            function interfaceFunction() {
                return null;
            }
            return interfaceFunction;
        }
        function strokeInterfaceFactory(shape, view, propertyGroup) {
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: ExpressionPropertyInterface(view.d.dataProps[i].p)
                });
            }
            var i;
            var len = shape.d ? shape.d.length : 0;
            var dashOb = {};
            for(i = 0; i < len; i += 1){
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }
            function interfaceFunction(val) {
                if (val === "Color" || val === "color") return interfaceFunction.color;
                if (val === "Opacity" || val === "opacity") return interfaceFunction.opacity;
                if (val === "Stroke Width" || val === "stroke width") return interfaceFunction.strokeWidth;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(view.w)
                },
                dash: {
                    get: function get() {
                        return dashOb;
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface("Color", _propertyGroup));
            view.o.setGroupProperty(PropertyInterface("Opacity", _propertyGroup));
            view.w.setGroupProperty(PropertyInterface("Stroke Width", _propertyGroup));
            return interfaceFunction;
        }
        function trimInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === shape.e.ix || val === "End" || val === "end") return interfaceFunction.end;
                if (val === shape.s.ix) return interfaceFunction.start;
                if (val === shape.o.ix) return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            view.s.setGroupProperty(PropertyInterface("Start", _propertyGroup));
            view.e.setGroupProperty(PropertyInterface("End", _propertyGroup));
            view.o.setGroupProperty(PropertyInterface("Offset", _propertyGroup));
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.propertyGroup = propertyGroup;
            Object.defineProperties(interfaceFunction, {
                start: {
                    get: ExpressionPropertyInterface(view.s)
                },
                end: {
                    get: ExpressionPropertyInterface(view.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function transformInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.a.ix === value || value === "Anchor Point") return interfaceFunction.anchorPoint;
                if (shape.o.ix === value || value === "Opacity") return interfaceFunction.opacity;
                if (shape.p.ix === value || value === "Position") return interfaceFunction.position;
                if (shape.r.ix === value || value === "Rotation" || value === "ADBE Vector Rotation") return interfaceFunction.rotation;
                if (shape.s.ix === value || value === "Scale") return interfaceFunction.scale;
                if (shape.sk && shape.sk.ix === value || value === "Skew") return interfaceFunction.skew;
                if (shape.sa && shape.sa.ix === value || value === "Skew Axis") return interfaceFunction.skewAxis;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            view.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", _propertyGroup));
            view.transform.mProps.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
            view.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", _propertyGroup));
            view.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", _propertyGroup));
            view.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup));
            if (view.transform.mProps.sk) {
                view.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", _propertyGroup));
                view.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", _propertyGroup));
            }
            view.transform.op.setGroupProperty(PropertyInterface("Opacity", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                opacity: {
                    get: ExpressionPropertyInterface(view.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(view.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(view.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(view.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(view.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sa)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.ty = "tr";
            interfaceFunction.mn = shape.mn;
            interfaceFunction.propertyGroup = propertyGroup;
            return interfaceFunction;
        }
        function ellipseInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.s.ix === value) return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === "tm" ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(PropertyInterface("Size", _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function starInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.rotation;
                if (shape.pt.ix === value) return interfaceFunction.points;
                if (shape.or.ix === value || value === "ADBE Vector Star Outer Radius") return interfaceFunction.outerRadius;
                if (shape.os.ix === value) return interfaceFunction.outerRoundness;
                if (shape.ir && (shape.ir.ix === value || value === "ADBE Vector Star Inner Radius")) return interfaceFunction.innerRadius;
                if (shape.is && shape.is.ix === value) return interfaceFunction.innerRoundness;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === "tm" ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(PropertyInterface("Outer Radius", _propertyGroup));
            prop.os.setGroupProperty(PropertyInterface("Outer Roundness", _propertyGroup));
            prop.pt.setGroupProperty(PropertyInterface("Points", _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup));
            if (shape.ir) {
                prop.ir.setGroupProperty(PropertyInterface("Inner Radius", _propertyGroup));
                prop.is.setGroupProperty(PropertyInterface("Inner Roundness", _propertyGroup));
            }
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                points: {
                    get: ExpressionPropertyInterface(prop.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(prop.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(prop.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(prop.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(prop.is)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function rectInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.roundness;
                if (shape.s.ix === value || value === "Size" || value === "ADBE Vector Rect Size") return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === "tm" ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
            prop.s.setGroupProperty(PropertyInterface("Size", _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function roundedInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.r.ix === value || value === "Round Corners 1") return interfaceFunction.radius;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(PropertyInterface("Radius", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                radius: {
                    get: ExpressionPropertyInterface(prop.rd)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function repeaterInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.c.ix === value || value === "Copies") return interfaceFunction.copies;
                if (shape.o.ix === value || value === "Offset") return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(PropertyInterface("Copies", _propertyGroup));
            prop.o.setGroupProperty(PropertyInterface("Offset", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                copies: {
                    get: ExpressionPropertyInterface(prop.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(prop.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        return function(shapes, view, propertyGroup) {
            var interfaces;
            function _interfaceFunction(value) {
                if (typeof value === "number") {
                    value = value === undefined ? 1 : value;
                    if (value === 0) return propertyGroup;
                    return interfaces[value - 1];
                }
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value) return interfaces[i];
                    i += 1;
                }
                return null;
            }
            function parentGroupWrapper() {
                return propertyGroup;
            }
            _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
            interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
            _interfaceFunction.numProperties = interfaces.length;
            _interfaceFunction._name = "Contents";
            return _interfaceFunction;
        };
    }();
    var TextExpressionInterface = function() {
        return function(elem) {
            var _sourceText;
            function _thisLayerFunction(name) {
                switch(name){
                    case "ADBE Text Document":
                        return _thisLayerFunction.sourceText;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisLayerFunction, "sourceText", {
                get: function get() {
                    elem.textProperty.getValue();
                    var stringValue = elem.textProperty.currentData.t;
                    if (!_sourceText || stringValue !== _sourceText.value) {
                        _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
                        // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                        _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
                        Object.defineProperty(_sourceText, "style", {
                            get: function get() {
                                return {
                                    fillColor: elem.textProperty.currentData.fc
                                };
                            }
                        });
                    }
                    return _sourceText;
                }
            });
            return _thisLayerFunction;
        };
    }();
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    var FootageInterface = function() {
        var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
            var currentPropertyName = "";
            var currentProperty = elem.getFootageData();
            function init() {
                currentPropertyName = "";
                currentProperty = elem.getFootageData();
                return searchProperty;
            }
            function searchProperty(value) {
                if (currentProperty[value]) {
                    currentPropertyName = value;
                    currentProperty = currentProperty[value];
                    if (_typeof(currentProperty) === "object") return searchProperty;
                    return currentProperty;
                }
                var propertyNameIndex = value.indexOf(currentPropertyName);
                if (propertyNameIndex !== -1) {
                    var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
                    currentProperty = currentProperty[index];
                    if (_typeof(currentProperty) === "object") return searchProperty;
                    return currentProperty;
                }
                return "";
            }
            return init;
        };
        var dataInterfaceFactory = function dataInterfaceFactory(elem) {
            function interfaceFunction(value) {
                if (value === "Outline") return interfaceFunction.outlineInterface();
                return null;
            }
            interfaceFunction._name = "Outline";
            interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
            return interfaceFunction;
        };
        return function(elem) {
            function _interfaceFunction(value) {
                if (value === "Data") return _interfaceFunction.dataInterface;
                return null;
            }
            _interfaceFunction._name = "Data";
            _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
            return _interfaceFunction;
        };
    }();
    var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
    };
    function getInterface(type) {
        return interfaces[type] || null;
    }
    var expressionHelpers = function() {
        function searchExpressions(elem, data, prop) {
            if (data.x) {
                prop.k = true;
                prop.x = true;
                prop.initiateExpression = ExpressionManager.initiateExpression;
                prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
            }
        }
        function getValueAtTime(frameNum) {
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastFrame) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
                this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
                this._cachingAtTime.lastFrame = frameNum;
            }
            return this._cachingAtTime.value;
        }
        function getSpeedAtTime(frameNum) {
            var delta = -0.01;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var speed = 0;
            if (v1.length) {
                var i;
                for(i = 0; i < v1.length; i += 1)speed += Math.pow(v2[i] - v1[i], 2);
                speed = Math.sqrt(speed) * 100;
            } else speed = 0;
            return speed;
        }
        function getVelocityAtTime(frameNum) {
            if (this.vel !== undefined) return this.vel;
            var delta = -0.001; // frameNum += this.elem.data.st;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var velocity;
            if (v1.length) {
                velocity = createTypedArray("float32", v1.length);
                var i;
                for(i = 0; i < v1.length; i += 1)// removing frameRate
                // if needed, don't add it here
                // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i]) / delta;
            } else velocity = (v2 - v1) / delta;
            return velocity;
        }
        function getStaticValueAtTime() {
            return this.pv;
        }
        function setGroupProperty(propertyGroup) {
            this.propertyGroup = propertyGroup;
        }
        return {
            searchExpressions: searchExpressions,
            getSpeedAtTime: getSpeedAtTime,
            getVelocityAtTime: getVelocityAtTime,
            getValueAtTime: getValueAtTime,
            getStaticValueAtTime: getStaticValueAtTime,
            setGroupProperty: setGroupProperty
        };
    }();
    function addPropertyDecorator() {
        function loopOut(type, duration, durationFlag) {
            if (!this.k || !this.keyframes) return this.pv;
            type = type ? type.toLowerCase() : "";
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var lastKeyFrame = keyframes[keyframes.length - 1].t;
            if (currentFrame <= lastKeyFrame) return this.pv;
            var cycleDuration;
            var firstKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
                else cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
                firstKeyFrame = lastKeyFrame - cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === "pingpong") {
                var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (iterations % 2 !== 0) return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === "offset") {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
                var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = (endV[i] - initV[i]) * repeats + current[i];
                    return ret;
                }
                return (endV - initV) * repeats + current;
            } else if (type === "continue") {
                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(lastValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
                    return ret;
                }
                return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
            }
            return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function loopIn(type, duration, durationFlag) {
            if (!this.k) return this.pv;
            type = type ? type.toLowerCase() : "";
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var firstKeyFrame = keyframes[0].t;
            if (currentFrame >= firstKeyFrame) return this.pv;
            var cycleDuration;
            var lastKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                lastKeyFrame = keyframes[duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
                else cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
                lastKeyFrame = firstKeyFrame + cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === "pingpong") {
                var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
                if (iterations % 2 === 0) return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === "offset") {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
                var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
                    return ret;
                }
                return current - (endV - initV) * repeats;
            } else if (type === "continue") {
                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(firstValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
                    return ret;
                }
                return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
            }
            return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function smooth(width, samples) {
            if (!this.k) return this.pv;
            width = (width || 0.4) * 0.5;
            samples = Math.floor(samples || 5);
            if (samples <= 1) return this.pv;
            var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
            var initFrame = currentTime - width;
            var endFrame = currentTime + width;
            var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
            var i = 0;
            var j = 0;
            var value;
            if (this.pv.length) value = createTypedArray("float32", this.pv.length);
            else value = 0;
            var sampleValue;
            while(i < samples){
                sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
                if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] += sampleValue[j];
                else value += sampleValue;
                i += 1;
            }
            if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] /= samples;
            else value /= samples;
            return value;
        }
        function getTransformValueAtTime(time) {
            if (!this._transformCachingAtTime) this._transformCachingAtTime = {
                v: new Matrix()
            };
             /// /
            var matrix = this._transformCachingAtTime.v;
            matrix.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
                var anchor = this.a.getValueAtTime(time);
                matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
            }
            if (this.appliedTransformations < 2) {
                var scale = this.s.getValueAtTime(time);
                matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
            }
            if (this.sk && this.appliedTransformations < 3) {
                var skew = this.sk.getValueAtTime(time);
                var skewAxis = this.sa.getValueAtTime(time);
                matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
                var rotation = this.r.getValueAtTime(time);
                matrix.rotate(-rotation * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
                var rotationZ = this.rz.getValueAtTime(time);
                var rotationY = this.ry.getValueAtTime(time);
                var rotationX = this.rx.getValueAtTime(time);
                var orientation = this.or.getValueAtTime(time);
                matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
                var positionX = this.px.getValueAtTime(time);
                var positionY = this.py.getValueAtTime(time);
                if (this.data.p.z) {
                    var positionZ = this.pz.getValueAtTime(time);
                    matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
                } else matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
            } else {
                var position = this.p.getValueAtTime(time);
                matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
            }
            return matrix; /// /
        }
        function getTransformStaticValueAtTime() {
            return this.v.clone(new Matrix());
        }
        var getTransformProperty = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
            var prop = getTransformProperty(elem, data, container);
            if (prop.dynamicProperties.length) prop.getValueAtTime = getTransformValueAtTime.bind(prop);
            else prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            return prop;
        };
        var propertyGetProp = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem, data, type, mult, container) {
            var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
            // prop.loopOut = loopOut;
            // prop.loopIn = loopIn;
            if (prop.kf) prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
            else prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            prop.loopOut = loopOut;
            prop.loopIn = loopIn;
            prop.smooth = smooth;
            prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
            prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
            prop.numKeys = data.a === 1 ? data.k.length : 0;
            prop.propertyIndex = data.ix;
            var value = 0;
            if (type !== 0) value = createTypedArray("float32", data.a === 1 ? data.k[0].s.length : data.k.length);
            prop._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: value
            };
            expressionHelpers.searchExpressions(elem, data, prop);
            if (prop.k) container.addDynamicProperty(prop);
            return prop;
        };
        function getShapeValueAtTime(frameNum) {
            // For now this caching object is created only when needed instead of creating it when the shape is initialized.
            if (!this._cachingAtTime) this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            };
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastTime) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
                this._cachingAtTime.lastTime = frameNum;
                this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
            }
            return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions() {}
        ShapeExpressions.prototype = {
            vertices: function vertices(prop, time) {
                if (this.k) this.getValue();
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                var i;
                var len = shapePath._length;
                var vertices = shapePath[prop];
                var points = shapePath.v;
                var arr = createSizedArray(len);
                for(i = 0; i < len; i += 1)if (prop === "i" || prop === "o") arr[i] = [
                    vertices[i][0] - points[i][0],
                    vertices[i][1] - points[i][1]
                ];
                else arr[i] = [
                    vertices[i][0],
                    vertices[i][1]
                ];
                return arr;
            },
            points: function points(time) {
                return this.vertices("v", time);
            },
            inTangents: function inTangents(time) {
                return this.vertices("i", time);
            },
            outTangents: function outTangents(time) {
                return this.vertices("o", time);
            },
            isClosed: function isClosed() {
                return this.v.c;
            },
            pointOnPath: function pointOnPath(perc, time) {
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                if (!this._segmentsLength) this._segmentsLength = bez.getSegmentsLength(shapePath);
                var segmentsLength = this._segmentsLength;
                var lengths = segmentsLength.lengths;
                var lengthPos = segmentsLength.totalLength * perc;
                var i = 0;
                var len = lengths.length;
                var accumulatedLength = 0;
                var pt;
                while(i < len){
                    if (accumulatedLength + lengths[i].addedLength > lengthPos) {
                        var initIndex = i;
                        var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
                        var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
                        pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
                        break;
                    } else accumulatedLength += lengths[i].addedLength;
                    i += 1;
                }
                if (!pt) pt = shapePath.c ? [
                    shapePath.v[0][0],
                    shapePath.v[0][1]
                ] : [
                    shapePath.v[shapePath._length - 1][0],
                    shapePath.v[shapePath._length - 1][1]
                ];
                return pt;
            },
            vectorOnPath: function vectorOnPath(perc, time, vectorType) {
                // perc doesn't use triple equality because it can be a Number object as well as a primitive.
                if (perc == 1) // eslint-disable-line eqeqeq
                perc = this.v.c;
                else if (perc == 0) // eslint-disable-line eqeqeq
                perc = 0.999;
                var pt1 = this.pointOnPath(perc, time);
                var pt2 = this.pointOnPath(perc + 0.001, time);
                var xLength = pt2[0] - pt1[0];
                var yLength = pt2[1] - pt1[1];
                var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
                if (magnitude === 0) return [
                    0,
                    0
                ];
                var unitVector = vectorType === "tangent" ? [
                    xLength / magnitude,
                    yLength / magnitude
                ] : [
                    -yLength / magnitude,
                    xLength / magnitude
                ];
                return unitVector;
            },
            tangentOnPath: function tangentOnPath(perc, time) {
                return this.vectorOnPath(perc, time, "tangent");
            },
            normalOnPath: function normalOnPath(perc, time) {
                return this.vectorOnPath(perc, time, "normal");
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([
            ShapeExpressions
        ], ShapePropertyConstructorFunction);
        extendPrototype([
            ShapeExpressions
        ], KeyframedShapePropertyConstructorFunction);
        KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
        KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem, data, type, arr, trims) {
            var prop = propertyGetShapeProp(elem, data, type, arr, trims);
            prop.propertyIndex = data.ix;
            prop.lock = false;
            if (type === 3) expressionHelpers.searchExpressions(elem, data.pt, prop);
            else if (type === 4) expressionHelpers.searchExpressions(elem, data.ks, prop);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        };
    }
    function initialize$1() {
        addPropertyDecorator();
    }
    function addDecorator() {
        function searchExpressions() {
            if (this.data.d.x) {
                this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
                this.addEffect(this.getExpressionValue.bind(this));
                return true;
            }
            return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue, text) {
            var newValue = this.calculateExpression(text);
            if (currentValue.t !== newValue) {
                var newData = {};
                this.copyData(newData, currentValue);
                newData.t = newValue.toString();
                newData.__complete = false;
                return newData;
            }
            return currentValue;
        };
        TextProperty.prototype.searchProperty = function() {
            var isKeyframed = this.searchKeyframes();
            var hasExpressions = this.searchExpressions();
            this.kf = isKeyframed || hasExpressions;
            return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions;
    }
    function initialize() {
        addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode(resultId, ins) {
            var feMerge = createNS("feMerge");
            feMerge.setAttribute("result", resultId);
            var feMergeNode;
            var i;
            for(i = 0; i < ins.length; i += 1){
                feMergeNode = createNS("feMergeNode");
                feMergeNode.setAttribute("in", ins[i]);
                feMerge.appendChild(feMergeNode);
                feMerge.appendChild(feMergeNode);
            }
            return feMerge;
        }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(filter, filterManager, elem, id, source) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "linearRGB");
        feColorMatrix.setAttribute("values", linearFilterValue + " 1 0");
        this.linearFilter = feColorMatrix;
        feColorMatrix.setAttribute("result", id + "_tint_1");
        filter.appendChild(feColorMatrix);
        feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "sRGB");
        feColorMatrix.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0");
        feColorMatrix.setAttribute("result", id + "_tint_2");
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
        var feMerge = this.createMergeNode(id, [
            source,
            id + "_tint_1",
            id + "_tint_2"
        ]);
        filter.appendChild(feMerge);
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGTintFilter);
    SVGTintFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var colorBlack = this.filterManager.effectElements[0].p.v;
            var colorWhite = this.filterManager.effectElements[1].p.v;
            var opacity = this.filterManager.effectElements[2].p.v / 100;
            this.linearFilter.setAttribute("values", linearFilterValue + " " + opacity + " 0");
            this.matrixFilter.setAttribute("values", colorWhite[0] - colorBlack[0] + " 0 0 0 " + colorBlack[0] + " " + (colorWhite[1] - colorBlack[1]) + " 0 0 0 " + colorBlack[1] + " " + (colorWhite[2] - colorBlack[2]) + " 0 0 0 " + colorBlack[2] + " 0 0 0 1 0");
        }
    };
    function SVGFillFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "sRGB");
        feColorMatrix.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0");
        feColorMatrix.setAttribute("result", id);
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
    }
    SVGFillFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color = this.filterManager.effectElements[2].p.v;
            var opacity = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute("values", "0 0 0 0 " + color[0] + " 0 0 0 0 " + color[1] + " 0 0 0 0 " + color[2] + " 0 0 0 " + opacity + " 0");
        }
    };
    function SVGStrokeEffect(fil, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.elem = elem;
        this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path;
        var groupPath;
        var i;
        var len;
        if (this.filterManager.effectElements[1].p.v === 1) {
            len = this.elem.maskManager.masksProperties.length;
            i = 0;
        } else {
            i = this.filterManager.effectElements[0].p.v - 1;
            len = i + 1;
        }
        groupPath = createNS("g");
        groupPath.setAttribute("fill", "none");
        groupPath.setAttribute("stroke-linecap", "round");
        groupPath.setAttribute("stroke-dashoffset", 1);
        for(i; i < len; i += 1){
            path = createNS("path");
            groupPath.appendChild(path);
            this.paths.push({
                p: path,
                m: i
            });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
            var mask = createNS("mask");
            var id = createElementID();
            mask.setAttribute("id", id);
            mask.setAttribute("mask-type", "alpha");
            mask.appendChild(groupPath);
            this.elem.globalData.defs.appendChild(mask);
            var g = createNS("g");
            g.setAttribute("mask", "url(" + getLocationHref() + "#" + id + ")");
            while(elemChildren[0])g.appendChild(elemChildren[0]);
            this.elem.layerElement.appendChild(g);
            this.masker = mask;
            groupPath.setAttribute("stroke", "#fff");
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (this.filterManager.effectElements[10].p.v === 2) {
                elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                while(elemChildren.length)this.elem.layerElement.removeChild(elemChildren[0]);
            }
            this.elem.layerElement.appendChild(groupPath);
            this.elem.layerElement.removeAttribute("mask");
            groupPath.setAttribute("stroke", "#fff");
        }
        this.initialized = true;
        this.pathMasker = groupPath;
    };
    SVGStrokeEffect.prototype.renderFrame = function(forceRender) {
        if (!this.initialized) this.initialize();
        var i;
        var len = this.paths.length;
        var mask;
        var path;
        for(i = 0; i < len; i += 1)if (this.paths[i].m !== -1) {
            mask = this.elem.maskManager.viewData[this.paths[i].m];
            path = this.paths[i].p;
            if (forceRender || this.filterManager._mdf || mask.prop._mdf) path.setAttribute("d", mask.lastPath);
            if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
                var dasharrayValue;
                if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                    var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var l = path.getTotalLength();
                    dasharrayValue = "0 0 0 " + l * s + " ";
                    var lineLength = l * (e - s);
                    var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                    var units = Math.floor(lineLength / segment);
                    var j;
                    for(j = 0; j < units; j += 1)dasharrayValue += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
                    dasharrayValue += "0 " + l * 10 + " 0 0";
                } else dasharrayValue = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                path.setAttribute("stroke-dasharray", dasharrayValue);
            }
        }
        if (forceRender || this.filterManager.effectElements[4].p._mdf) this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2);
        if (forceRender || this.filterManager.effectElements[6].p._mdf) this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v);
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (forceRender || this.filterManager.effectElements[3].p._mdf) {
                var color = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(color[0] * 255) + "," + bmFloor(color[1] * 255) + "," + bmFloor(color[2] * 255) + ")");
            }
        }
    };
    function SVGTritoneFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "linearRGB");
        feColorMatrix.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0");
        filter.appendChild(feColorMatrix);
        var feComponentTransfer = createNS("feComponentTransfer");
        feComponentTransfer.setAttribute("color-interpolation-filters", "sRGB");
        feComponentTransfer.setAttribute("result", id);
        this.matrixFilter = feComponentTransfer;
        var feFuncR = createNS("feFuncR");
        feFuncR.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFuncR);
        this.feFuncR = feFuncR;
        var feFuncG = createNS("feFuncG");
        feFuncG.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFuncG);
        this.feFuncG = feFuncG;
        var feFuncB = createNS("feFuncB");
        feFuncB.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFuncB);
        this.feFuncB = feFuncB;
        filter.appendChild(feComponentTransfer);
    }
    SVGTritoneFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color1 = this.filterManager.effectElements[0].p.v;
            var color2 = this.filterManager.effectElements[1].p.v;
            var color3 = this.filterManager.effectElements[2].p.v;
            var tableR = color3[0] + " " + color2[0] + " " + color1[0];
            var tableG = color3[1] + " " + color2[1] + " " + color1[1];
            var tableB = color3[2] + " " + color2[2] + " " + color1[2];
            this.feFuncR.setAttribute("tableValues", tableR);
            this.feFuncG.setAttribute("tableValues", tableG);
            this.feFuncB.setAttribute("tableValues", tableB);
        }
    };
    function SVGProLevelsFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var effectElements = this.filterManager.effectElements;
        var feComponentTransfer = createNS("feComponentTransfer"); // Red
        if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) this.feFuncR = this.createFeFunc("feFuncR", feComponentTransfer);
         // Green
        if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) this.feFuncG = this.createFeFunc("feFuncG", feComponentTransfer);
         // Blue
        if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) this.feFuncB = this.createFeFunc("feFuncB", feComponentTransfer);
         // Alpha
        if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) this.feFuncA = this.createFeFunc("feFuncA", feComponentTransfer);
         // RGB
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
            feComponentTransfer.setAttribute("color-interpolation-filters", "sRGB");
            filter.appendChild(feComponentTransfer);
        }
        if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
            feComponentTransfer = createNS("feComponentTransfer");
            feComponentTransfer.setAttribute("color-interpolation-filters", "sRGB");
            feComponentTransfer.setAttribute("result", id);
            filter.appendChild(feComponentTransfer);
            this.feFuncRComposed = this.createFeFunc("feFuncR", feComponentTransfer);
            this.feFuncGComposed = this.createFeFunc("feFuncG", feComponentTransfer);
            this.feFuncBComposed = this.createFeFunc("feFuncB", feComponentTransfer);
        }
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
        var feFunc = createNS(type);
        feFunc.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFunc);
        return feFunc;
    };
    SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
        var cnt = 0;
        var segments = 256;
        var perc;
        var min = Math.min(inputBlack, inputWhite);
        var max = Math.max(inputBlack, inputWhite);
        var table = Array.call(null, {
            length: segments
        });
        var colorValue;
        var pos = 0;
        var outputDelta = outputWhite - outputBlack;
        var inputDelta = inputWhite - inputBlack;
        while(cnt <= 256){
            perc = cnt / 256;
            if (perc <= min) colorValue = inputDelta < 0 ? outputWhite : outputBlack;
            else if (perc >= max) colorValue = inputDelta < 0 ? outputBlack : outputWhite;
            else colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
            table[pos] = colorValue;
            pos += 1;
            cnt += 256 / (segments - 1);
        }
        return table.join(" ");
    };
    SVGProLevelsFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var val;
            var effectElements = this.filterManager.effectElements;
            if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
                val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
                this.feFuncRComposed.setAttribute("tableValues", val);
                this.feFuncGComposed.setAttribute("tableValues", val);
                this.feFuncBComposed.setAttribute("tableValues", val);
            }
            if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
                val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
                this.feFuncR.setAttribute("tableValues", val);
            }
            if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
                val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
                this.feFuncG.setAttribute("tableValues", val);
            }
            if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
                val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
                this.feFuncB.setAttribute("tableValues", val);
            }
            if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
                val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
                this.feFuncA.setAttribute("tableValues", val);
            }
        }
    };
    function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
        var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
        var filterSize = filterManager.data.fs || globalFilterSize;
        filter.setAttribute("x", filterSize.x || globalFilterSize.x);
        filter.setAttribute("y", filterSize.y || globalFilterSize.y);
        filter.setAttribute("width", filterSize.width || globalFilterSize.width);
        filter.setAttribute("height", filterSize.height || globalFilterSize.height);
        this.filterManager = filterManager;
        var feGaussianBlur = createNS("feGaussianBlur");
        feGaussianBlur.setAttribute("in", "SourceAlpha");
        feGaussianBlur.setAttribute("result", id + "_drop_shadow_1");
        feGaussianBlur.setAttribute("stdDeviation", "0");
        this.feGaussianBlur = feGaussianBlur;
        filter.appendChild(feGaussianBlur);
        var feOffset = createNS("feOffset");
        feOffset.setAttribute("dx", "25");
        feOffset.setAttribute("dy", "0");
        feOffset.setAttribute("in", id + "_drop_shadow_1");
        feOffset.setAttribute("result", id + "_drop_shadow_2");
        this.feOffset = feOffset;
        filter.appendChild(feOffset);
        var feFlood = createNS("feFlood");
        feFlood.setAttribute("flood-color", "#00ff00");
        feFlood.setAttribute("flood-opacity", "1");
        feFlood.setAttribute("result", id + "_drop_shadow_3");
        this.feFlood = feFlood;
        filter.appendChild(feFlood);
        var feComposite = createNS("feComposite");
        feComposite.setAttribute("in", id + "_drop_shadow_3");
        feComposite.setAttribute("in2", id + "_drop_shadow_2");
        feComposite.setAttribute("operator", "in");
        feComposite.setAttribute("result", id + "_drop_shadow_4");
        filter.appendChild(feComposite);
        var feMerge = this.createMergeNode(id, [
            id + "_drop_shadow_4",
            source
        ]);
        filter.appendChild(feMerge); //
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGDropShadowEffect);
    SVGDropShadowEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            if (forceRender || this.filterManager.effectElements[4].p._mdf) this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4);
            if (forceRender || this.filterManager.effectElements[0].p._mdf) {
                var col = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
            }
            if (forceRender || this.filterManager.effectElements[1].p._mdf) this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255);
            if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var distance = this.filterManager.effectElements[3].p.v;
                var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
                var x = distance * Math.cos(angle);
                var y = distance * Math.sin(angle);
                this.feOffset.setAttribute("dx", x);
                this.feOffset.setAttribute("dy", y);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(filterElem, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.filterElem = filterElem;
        this.elem = elem;
        elem.matteElement = createNS("g");
        elem.matteElement.appendChild(elem.layerElement);
        elem.matteElement.appendChild(elem.transformedElement);
        elem.baseElement = elem.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(mask) {
        var i = 0;
        var len = _svgMatteSymbols.length;
        while(i < len){
            if (_svgMatteSymbols[i] === mask) return _svgMatteSymbols[i];
            i += 1;
        }
        return null;
    };
    SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
        var parentNode = mask.layerElement.parentNode;
        if (!parentNode) return;
        var children = parentNode.children;
        var i = 0;
        var len = children.length;
        while(i < len){
            if (children[i] === mask.layerElement) break;
            i += 1;
        }
        var nextChild;
        if (i <= len - 2) nextChild = children[i + 1];
        var useElem = createNS("use");
        useElem.setAttribute("href", "#" + symbolId);
        if (nextChild) parentNode.insertBefore(useElem, nextChild);
        else parentNode.appendChild(useElem);
    };
    SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
        if (!this.findSymbol(mask)) {
            var symbolId = createElementID();
            var masker = createNS("mask");
            masker.setAttribute("id", mask.layerId);
            masker.setAttribute("mask-type", "alpha");
            _svgMatteSymbols.push(mask);
            var defs = elem.globalData.defs;
            defs.appendChild(masker);
            var symbol = createNS("symbol");
            symbol.setAttribute("id", symbolId);
            this.replaceInParent(mask, symbolId);
            symbol.appendChild(mask.layerElement);
            defs.appendChild(symbol);
            var useElem = createNS("use");
            useElem.setAttribute("href", "#" + symbolId);
            masker.appendChild(useElem);
            mask.data.hd = false;
            mask.show();
        }
        elem.setMatte(mask.layerId);
    };
    SVGMatte3Effect.prototype.initialize = function() {
        var ind = this.filterManager.effectElements[0].p.v;
        var elements = this.elem.comp.elements;
        var i = 0;
        var len = elements.length;
        while(i < len){
            if (elements[i] && elements[i].data.ind === ind) this.setElementAsMask(this.elem, elements[i]);
            i += 1;
        }
        this.initialized = true;
    };
    SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) this.initialize();
    };
    function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
        // Outset the filter region by 100% on all sides to accommodate blur expansion.
        filter.setAttribute("x", "-100%");
        filter.setAttribute("y", "-100%");
        filter.setAttribute("width", "300%");
        filter.setAttribute("height", "300%");
        this.filterManager = filterManager;
        var feGaussianBlur = createNS("feGaussianBlur");
        feGaussianBlur.setAttribute("result", id);
        filter.appendChild(feGaussianBlur);
        this.feGaussianBlur = feGaussianBlur;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            // Empirical value, matching AE's blur appearance.
            var kBlurrinessToSigma = 0.3;
            var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
            //
            //   1 -> horizontal & vertical
            //   2 -> horizontal only
            //   3 -> vertical only
            //
            var dimensions = this.filterManager.effectElements[1].p.v;
            var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
            var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute("stdDeviation", sigmaX + " " + sigmaY); // Repeat edges mapping:
            //
            //   0 -> off -> duplicate
            //   1 -> on  -> wrap
            var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate"; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute("edgeMode", edgeMode);
        }
    };
    function TransformEffect() {}
    TransformEffect.prototype.init = function(effectsManager) {
        this.effectsManager = effectsManager;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
    };
    TransformEffect.prototype.renderFrame = function(forceFrame) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame || this.effectsManager._mdf) {
            var effectElements = this.effectsManager.effectElements;
            var anchor = effectElements[0].p.v;
            var position = effectElements[1].p.v;
            var isUniformScale = effectElements[2].p.v === 1;
            var scaleHeight = effectElements[3].p.v;
            var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
            var skew = effectElements[5].p.v;
            var skewAxis = effectElements[6].p.v;
            var rotation = effectElements[7].p.v;
            this.matrix.reset();
            this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
            this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
            this.matrix.rotate(-rotation * degToRads);
            this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
            this.matrix.translate(position[0], position[1], 0);
            this._mdf = true;
            if (this.opacity !== effectElements[8].p.v) {
                this.opacity = effectElements[8].p.v;
                this._opMdf = true;
            }
        }
    };
    function SVGTransformEffect(_, filterManager) {
        this.init(filterManager);
    }
    extendPrototype([
        TransformEffect
    ], SVGTransformEffect);
    function CVTransformEffect(effectsManager) {
        this.init(effectsManager);
    }
    extendPrototype([
        TransformEffect
    ], CVTransformEffect);
    registerRenderer("canvas", CanvasRenderer);
    registerRenderer("html", HybridRenderer);
    registerRenderer("svg", SVGRenderer); // Registering shape modifiers
    ShapeModifiers.registerModifier("tm", TrimModifier);
    ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier);
    ShapeModifiers.registerModifier("rp", RepeaterModifier);
    ShapeModifiers.registerModifier("rd", RoundCornersModifier);
    ShapeModifiers.registerModifier("zz", ZigZagModifier);
    ShapeModifiers.registerModifier("op", OffsetPathModifier); // Registering expression plugin
    setExpressionsPlugin(Expressions);
    setExpressionInterfaces(getInterface);
    initialize$1();
    initialize(); // Registering svg effects
    registerEffect$1(20, SVGTintFilter, true);
    registerEffect$1(21, SVGFillFilter, true);
    registerEffect$1(22, SVGStrokeEffect, false);
    registerEffect$1(23, SVGTritoneFilter, true);
    registerEffect$1(24, SVGProLevelsFilter, true);
    registerEffect$1(25, SVGDropShadowEffect, true);
    registerEffect$1(28, SVGMatte3Effect, false);
    registerEffect$1(29, SVGGaussianBlurEffect, true);
    registerEffect$1(35, SVGTransformEffect, false);
    registerEffect(35, CVTransformEffect);
    return lottie;
});

});

parcelRegister("kzj6W", function(module, exports) {

var $bpgl8 = parcelRequire("bpgl8");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $ef95e68c3c4f66ef$var$isEqual(value, other) {
    return $bpgl8(value, other);
}
module.exports = $ef95e68c3c4f66ef$var$isEqual;

});
parcelRegister("bpgl8", function(module, exports) {

var $dFBzV = parcelRequire("dFBzV");

var $2Q0Th = parcelRequire("2Q0Th");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $84deb446a3e1b942$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$2Q0Th(value) && !$2Q0Th(other)) return value !== value && other !== other;
    return $dFBzV(value, other, bitmask, customizer, $84deb446a3e1b942$var$baseIsEqual, stack);
}
module.exports = $84deb446a3e1b942$var$baseIsEqual;

});
parcelRegister("dFBzV", function(module, exports) {

var $Zc7Li = parcelRequire("Zc7Li");

var $bJfbj = parcelRequire("bJfbj");

var $83CUX = parcelRequire("83CUX");

var $5i7qB = parcelRequire("5i7qB");

var $7K2r8 = parcelRequire("7K2r8");

var $i7g7V = parcelRequire("i7g7V");

var $kNG5d = parcelRequire("kNG5d");

var $gwYfV = parcelRequire("gwYfV");
/** Used to compose bitmasks for value comparisons. */ var $9f3c410396a940ed$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $9f3c410396a940ed$var$argsTag = "[object Arguments]", $9f3c410396a940ed$var$arrayTag = "[object Array]", $9f3c410396a940ed$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $9f3c410396a940ed$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9f3c410396a940ed$var$hasOwnProperty = $9f3c410396a940ed$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9f3c410396a940ed$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $i7g7V(object), othIsArr = $i7g7V(other), objTag = objIsArr ? $9f3c410396a940ed$var$arrayTag : $7K2r8(object), othTag = othIsArr ? $9f3c410396a940ed$var$arrayTag : $7K2r8(other);
    objTag = objTag == $9f3c410396a940ed$var$argsTag ? $9f3c410396a940ed$var$objectTag : objTag;
    othTag = othTag == $9f3c410396a940ed$var$argsTag ? $9f3c410396a940ed$var$objectTag : othTag;
    var objIsObj = objTag == $9f3c410396a940ed$var$objectTag, othIsObj = othTag == $9f3c410396a940ed$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $kNG5d(object)) {
        if (!$kNG5d(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $Zc7Li);
        return objIsArr || $gwYfV(object) ? $bJfbj(object, other, bitmask, customizer, equalFunc, stack) : $83CUX(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $9f3c410396a940ed$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $9f3c410396a940ed$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $9f3c410396a940ed$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $Zc7Li);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $Zc7Li);
    return $5i7qB(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $9f3c410396a940ed$var$baseIsEqualDeep;

});
parcelRegister("Zc7Li", function(module, exports) {

var $gvdKS = parcelRequire("gvdKS");

var $3wcqR = parcelRequire("3wcqR");

var $23CMU = parcelRequire("23CMU");

var $2jWam = parcelRequire("2jWam");

var $cF84e = parcelRequire("cF84e");

var $c0PST = parcelRequire("c0PST");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0b7f1a3b3f2b2666$var$Stack(entries) {
    var data = this.__data__ = new $gvdKS(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$0b7f1a3b3f2b2666$var$Stack.prototype.clear = $3wcqR;
$0b7f1a3b3f2b2666$var$Stack.prototype["delete"] = $23CMU;
$0b7f1a3b3f2b2666$var$Stack.prototype.get = $2jWam;
$0b7f1a3b3f2b2666$var$Stack.prototype.has = $cF84e;
$0b7f1a3b3f2b2666$var$Stack.prototype.set = $c0PST;
module.exports = $0b7f1a3b3f2b2666$var$Stack;

});
parcelRegister("gvdKS", function(module, exports) {

var $6Iq3G = parcelRequire("6Iq3G");

var $83FpH = parcelRequire("83FpH");

var $aJRHT = parcelRequire("aJRHT");

var $3tgCy = parcelRequire("3tgCy");

var $hRHYA = parcelRequire("hRHYA");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c03a360af3c87456$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$c03a360af3c87456$var$ListCache.prototype.clear = $6Iq3G;
$c03a360af3c87456$var$ListCache.prototype["delete"] = $83FpH;
$c03a360af3c87456$var$ListCache.prototype.get = $aJRHT;
$c03a360af3c87456$var$ListCache.prototype.has = $3tgCy;
$c03a360af3c87456$var$ListCache.prototype.set = $hRHYA;
module.exports = $c03a360af3c87456$var$ListCache;

});
parcelRegister("6Iq3G", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4e3b10c6eaa4a501$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $4e3b10c6eaa4a501$var$listCacheClear;

});

parcelRegister("83FpH", function(module, exports) {

var $kHRPY = parcelRequire("kHRPY");
/** Used for built-in method references. */ var $5ddeba6284ace21b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $5ddeba6284ace21b$var$splice = $5ddeba6284ace21b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5ddeba6284ace21b$var$listCacheDelete(key) {
    var data = this.__data__, index = $kHRPY(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $5ddeba6284ace21b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $5ddeba6284ace21b$var$listCacheDelete;

});
parcelRegister("kHRPY", function(module, exports) {

var $hXykb = parcelRequire("hXykb");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f13195c24032ba0e$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($hXykb(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $f13195c24032ba0e$var$assocIndexOf;

});
parcelRegister("hXykb", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $d13292808fb6c9f3$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $d13292808fb6c9f3$var$eq;

});



parcelRegister("aJRHT", function(module, exports) {

var $kHRPY = parcelRequire("kHRPY");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7d17c47284f15e17$var$listCacheGet(key) {
    var data = this.__data__, index = $kHRPY(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $7d17c47284f15e17$var$listCacheGet;

});

parcelRegister("3tgCy", function(module, exports) {

var $kHRPY = parcelRequire("kHRPY");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2870f9144ac4d007$var$listCacheHas(key) {
    return $kHRPY(this.__data__, key) > -1;
}
module.exports = $2870f9144ac4d007$var$listCacheHas;

});

parcelRegister("hRHYA", function(module, exports) {

var $kHRPY = parcelRequire("kHRPY");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $d0197fa95029f733$var$listCacheSet(key, value) {
    var data = this.__data__, index = $kHRPY(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $d0197fa95029f733$var$listCacheSet;

});


parcelRegister("3wcqR", function(module, exports) {

var $gvdKS = parcelRequire("gvdKS");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $28fe01065c65793c$var$stackClear() {
    this.__data__ = new $gvdKS;
    this.size = 0;
}
module.exports = $28fe01065c65793c$var$stackClear;

});

parcelRegister("23CMU", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $17f9f30dd327edf6$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $17f9f30dd327edf6$var$stackDelete;

});

parcelRegister("2jWam", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1b0a79b367d02cba$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $1b0a79b367d02cba$var$stackGet;

});

parcelRegister("cF84e", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $937f925b122392de$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $937f925b122392de$var$stackHas;

});

parcelRegister("c0PST", function(module, exports) {

var $gvdKS = parcelRequire("gvdKS");

var $kkAOZ = parcelRequire("kkAOZ");

var $hkepI = parcelRequire("hkepI");
/** Used as the size to enable large array optimizations. */ var $8bedbb469e360d2b$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $8bedbb469e360d2b$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $gvdKS) {
        var pairs = data.__data__;
        if (!$kkAOZ || pairs.length < $8bedbb469e360d2b$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $hkepI(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $8bedbb469e360d2b$var$stackSet;

});
parcelRegister("kkAOZ", function(module, exports) {

var $cAmET = parcelRequire("cAmET");

var $90DZ0 = parcelRequire("90DZ0");
/* Built-in method references that are verified to be native. */ var $ecd23ce29148d615$var$Map = $cAmET($90DZ0, "Map");
module.exports = $ecd23ce29148d615$var$Map;

});
parcelRegister("cAmET", function(module, exports) {

var $dEaPe = parcelRequire("dEaPe");

var $fXvH1 = parcelRequire("fXvH1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $929a6c5acb32eaf1$var$getNative(object, key) {
    var value = $fXvH1(object, key);
    return $dEaPe(value) ? value : undefined;
}
module.exports = $929a6c5acb32eaf1$var$getNative;

});
parcelRegister("dEaPe", function(module, exports) {

var $8l1wZ = parcelRequire("8l1wZ");

var $13fLS = parcelRequire("13fLS");

var $evJZp = parcelRequire("evJZp");

var $hJN8N = parcelRequire("hJN8N");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $9ef7687ee84c216a$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $9ef7687ee84c216a$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $9ef7687ee84c216a$var$funcProto = Function.prototype, $9ef7687ee84c216a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $9ef7687ee84c216a$var$funcToString = $9ef7687ee84c216a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $9ef7687ee84c216a$var$hasOwnProperty = $9ef7687ee84c216a$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $9ef7687ee84c216a$var$reIsNative = RegExp("^" + $9ef7687ee84c216a$var$funcToString.call($9ef7687ee84c216a$var$hasOwnProperty).replace($9ef7687ee84c216a$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $9ef7687ee84c216a$var$baseIsNative(value) {
    if (!$evJZp(value) || $13fLS(value)) return false;
    var pattern = $8l1wZ(value) ? $9ef7687ee84c216a$var$reIsNative : $9ef7687ee84c216a$var$reIsHostCtor;
    return pattern.test($hJN8N(value));
}
module.exports = $9ef7687ee84c216a$var$baseIsNative;

});
parcelRegister("8l1wZ", function(module, exports) {

var $4dBZ2 = parcelRequire("4dBZ2");

var $evJZp = parcelRequire("evJZp");
/** `Object#toString` result references. */ var $612178f1216980b6$var$asyncTag = "[object AsyncFunction]", $612178f1216980b6$var$funcTag = "[object Function]", $612178f1216980b6$var$genTag = "[object GeneratorFunction]", $612178f1216980b6$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $612178f1216980b6$var$isFunction(value) {
    if (!$evJZp(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $4dBZ2(value);
    return tag == $612178f1216980b6$var$funcTag || tag == $612178f1216980b6$var$genTag || tag == $612178f1216980b6$var$asyncTag || tag == $612178f1216980b6$var$proxyTag;
}
module.exports = $612178f1216980b6$var$isFunction;

});
parcelRegister("4dBZ2", function(module, exports) {

var $jKWZf = parcelRequire("jKWZf");

var $6Hu8p = parcelRequire("6Hu8p");

var $et3CR = parcelRequire("et3CR");
/** `Object#toString` result references. */ var $3125d712601865c3$var$nullTag = "[object Null]", $3125d712601865c3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $3125d712601865c3$var$symToStringTag = $jKWZf ? $jKWZf.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $3125d712601865c3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $3125d712601865c3$var$undefinedTag : $3125d712601865c3$var$nullTag;
    return $3125d712601865c3$var$symToStringTag && $3125d712601865c3$var$symToStringTag in Object(value) ? $6Hu8p(value) : $et3CR(value);
}
module.exports = $3125d712601865c3$var$baseGetTag;

});
parcelRegister("jKWZf", function(module, exports) {

var $90DZ0 = parcelRequire("90DZ0");
/** Built-in value references. */ var $e62011c91336a38e$var$Symbol = $90DZ0.Symbol;
module.exports = $e62011c91336a38e$var$Symbol;

});
parcelRegister("90DZ0", function(module, exports) {

var $209Wz = parcelRequire("209Wz");
/** Detect free variable `self`. */ var $68f320efee199526$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $68f320efee199526$var$root = $209Wz || $68f320efee199526$var$freeSelf || Function("return this")();
module.exports = $68f320efee199526$var$root;

});
parcelRegister("209Wz", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $17534b7afc6b7691$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $17534b7afc6b7691$var$freeGlobal;

});



parcelRegister("6Hu8p", function(module, exports) {

var $jKWZf = parcelRequire("jKWZf");
/** Used for built-in method references. */ var $4e0e22547af04f15$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4e0e22547af04f15$var$hasOwnProperty = $4e0e22547af04f15$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4e0e22547af04f15$var$nativeObjectToString = $4e0e22547af04f15$var$objectProto.toString;
/** Built-in value references. */ var $4e0e22547af04f15$var$symToStringTag = $jKWZf ? $jKWZf.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $4e0e22547af04f15$var$getRawTag(value) {
    var isOwn = $4e0e22547af04f15$var$hasOwnProperty.call(value, $4e0e22547af04f15$var$symToStringTag), tag = value[$4e0e22547af04f15$var$symToStringTag];
    try {
        value[$4e0e22547af04f15$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $4e0e22547af04f15$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$4e0e22547af04f15$var$symToStringTag] = tag;
        else delete value[$4e0e22547af04f15$var$symToStringTag];
    }
    return result;
}
module.exports = $4e0e22547af04f15$var$getRawTag;

});

parcelRegister("et3CR", function(module, exports) {
/** Used for built-in method references. */ var $a886961d63455237$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a886961d63455237$var$nativeObjectToString = $a886961d63455237$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $a886961d63455237$var$objectToString(value) {
    return $a886961d63455237$var$nativeObjectToString.call(value);
}
module.exports = $a886961d63455237$var$objectToString;

});


parcelRegister("evJZp", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a907a279eb9c391c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $a907a279eb9c391c$var$isObject;

});


parcelRegister("13fLS", function(module, exports) {

var $eMnBR = parcelRequire("eMnBR");
/** Used to detect methods masquerading as native. */ var $0c424e165c5aa5fa$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($eMnBR && $eMnBR.keys && $eMnBR.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $0c424e165c5aa5fa$var$isMasked(func) {
    return !!$0c424e165c5aa5fa$var$maskSrcKey && $0c424e165c5aa5fa$var$maskSrcKey in func;
}
module.exports = $0c424e165c5aa5fa$var$isMasked;

});
parcelRegister("eMnBR", function(module, exports) {

var $90DZ0 = parcelRequire("90DZ0");
/** Used to detect overreaching core-js shims. */ var $ac27dcbf61071e7c$var$coreJsData = $90DZ0["__core-js_shared__"];
module.exports = $ac27dcbf61071e7c$var$coreJsData;

});


parcelRegister("hJN8N", function(module, exports) {
/** Used for built-in method references. */ var $ce9cc1f9c79940bc$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce9cc1f9c79940bc$var$funcToString = $ce9cc1f9c79940bc$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $ce9cc1f9c79940bc$var$toSource(func) {
    if (func != null) {
        try {
            return $ce9cc1f9c79940bc$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $ce9cc1f9c79940bc$var$toSource;

});


parcelRegister("fXvH1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b9e4f34423ae56ea$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $b9e4f34423ae56ea$var$getValue;

});



parcelRegister("hkepI", function(module, exports) {

var $gWoEB = parcelRequire("gWoEB");

var $8m7rL = parcelRequire("8m7rL");

var $h1iis = parcelRequire("h1iis");

var $jAntr = parcelRequire("jAntr");

var $gBQxw = parcelRequire("gBQxw");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c9cf7c353d57a3d9$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$c9cf7c353d57a3d9$var$MapCache.prototype.clear = $gWoEB;
$c9cf7c353d57a3d9$var$MapCache.prototype["delete"] = $8m7rL;
$c9cf7c353d57a3d9$var$MapCache.prototype.get = $h1iis;
$c9cf7c353d57a3d9$var$MapCache.prototype.has = $jAntr;
$c9cf7c353d57a3d9$var$MapCache.prototype.set = $gBQxw;
module.exports = $c9cf7c353d57a3d9$var$MapCache;

});
parcelRegister("gWoEB", function(module, exports) {

var $jkgPI = parcelRequire("jkgPI");

var $gvdKS = parcelRequire("gvdKS");

var $kkAOZ = parcelRequire("kkAOZ");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $c5552fde0e4da01a$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $jkgPI,
        "map": new ($kkAOZ || $gvdKS),
        "string": new $jkgPI
    };
}
module.exports = $c5552fde0e4da01a$var$mapCacheClear;

});
parcelRegister("jkgPI", function(module, exports) {

var $9ZJAu = parcelRequire("9ZJAu");

var $cJk1l = parcelRequire("cJk1l");

var $2rHwO = parcelRequire("2rHwO");

var $24KXO = parcelRequire("24KXO");

var $9n9Fp = parcelRequire("9n9Fp");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e11cf146bd2821c8$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$e11cf146bd2821c8$var$Hash.prototype.clear = $9ZJAu;
$e11cf146bd2821c8$var$Hash.prototype["delete"] = $cJk1l;
$e11cf146bd2821c8$var$Hash.prototype.get = $2rHwO;
$e11cf146bd2821c8$var$Hash.prototype.has = $24KXO;
$e11cf146bd2821c8$var$Hash.prototype.set = $9n9Fp;
module.exports = $e11cf146bd2821c8$var$Hash;

});
parcelRegister("9ZJAu", function(module, exports) {

var $kMwW0 = parcelRequire("kMwW0");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $746d2c4b190fcac2$var$hashClear() {
    this.__data__ = $kMwW0 ? $kMwW0(null) : {};
    this.size = 0;
}
module.exports = $746d2c4b190fcac2$var$hashClear;

});
parcelRegister("kMwW0", function(module, exports) {

var $cAmET = parcelRequire("cAmET");
/* Built-in method references that are verified to be native. */ var $f211d67d36f1822d$var$nativeCreate = $cAmET(Object, "create");
module.exports = $f211d67d36f1822d$var$nativeCreate;

});


parcelRegister("cJk1l", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $944937b1f498ffa0$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $944937b1f498ffa0$var$hashDelete;

});

parcelRegister("2rHwO", function(module, exports) {

var $kMwW0 = parcelRequire("kMwW0");
/** Used to stand-in for `undefined` hash values. */ var $1c7fde32a4676826$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $1c7fde32a4676826$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1c7fde32a4676826$var$hasOwnProperty = $1c7fde32a4676826$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1c7fde32a4676826$var$hashGet(key) {
    var data = this.__data__;
    if ($kMwW0) {
        var result = data[key];
        return result === $1c7fde32a4676826$var$HASH_UNDEFINED ? undefined : result;
    }
    return $1c7fde32a4676826$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $1c7fde32a4676826$var$hashGet;

});

parcelRegister("24KXO", function(module, exports) {

var $kMwW0 = parcelRequire("kMwW0");
/** Used for built-in method references. */ var $18306287a99cfbe3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18306287a99cfbe3$var$hasOwnProperty = $18306287a99cfbe3$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $18306287a99cfbe3$var$hashHas(key) {
    var data = this.__data__;
    return $kMwW0 ? data[key] !== undefined : $18306287a99cfbe3$var$hasOwnProperty.call(data, key);
}
module.exports = $18306287a99cfbe3$var$hashHas;

});

parcelRegister("9n9Fp", function(module, exports) {

var $kMwW0 = parcelRequire("kMwW0");
/** Used to stand-in for `undefined` hash values. */ var $6d2dc2a97470f687$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $6d2dc2a97470f687$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $kMwW0 && value === undefined ? $6d2dc2a97470f687$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $6d2dc2a97470f687$var$hashSet;

});



parcelRegister("8m7rL", function(module, exports) {

var $btbfg = parcelRequire("btbfg");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $61562791956929ce$var$mapCacheDelete(key) {
    var result = $btbfg(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $61562791956929ce$var$mapCacheDelete;

});
parcelRegister("btbfg", function(module, exports) {

var $7xKTh = parcelRequire("7xKTh");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $859b2034a216e74e$var$getMapData(map, key) {
    var data = map.__data__;
    return $7xKTh(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $859b2034a216e74e$var$getMapData;

});
parcelRegister("7xKTh", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $57dffcfcf0724031$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $57dffcfcf0724031$var$isKeyable;

});



parcelRegister("h1iis", function(module, exports) {

var $btbfg = parcelRequire("btbfg");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c640b903d8789647$var$mapCacheGet(key) {
    return $btbfg(this, key).get(key);
}
module.exports = $c640b903d8789647$var$mapCacheGet;

});

parcelRegister("jAntr", function(module, exports) {

var $btbfg = parcelRequire("btbfg");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e423968af27f8656$var$mapCacheHas(key) {
    return $btbfg(this, key).has(key);
}
module.exports = $e423968af27f8656$var$mapCacheHas;

});

parcelRegister("gBQxw", function(module, exports) {

var $btbfg = parcelRequire("btbfg");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c178db560e0cf9ad$var$mapCacheSet(key, value) {
    var data = $btbfg(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $c178db560e0cf9ad$var$mapCacheSet;

});




parcelRegister("bJfbj", function(module, exports) {

var $6KN3c = parcelRequire("6KN3c");

var $lg20k = parcelRequire("lg20k");

var $9V4Kn = parcelRequire("9V4Kn");
/** Used to compose bitmasks for value comparisons. */ var $889fac67ba0c1a3c$var$COMPARE_PARTIAL_FLAG = 1, $889fac67ba0c1a3c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $889fac67ba0c1a3c$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $889fac67ba0c1a3c$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $889fac67ba0c1a3c$var$COMPARE_UNORDERED_FLAG ? new $6KN3c : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$lg20k(other, function(othValue, othIndex) {
                if (!$9V4Kn(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $889fac67ba0c1a3c$var$equalArrays;

});
parcelRegister("6KN3c", function(module, exports) {

var $hkepI = parcelRequire("hkepI");

var $6D1Uo = parcelRequire("6D1Uo");

var $6Mefk = parcelRequire("6Mefk");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $4ead165e1d32874e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $hkepI;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$4ead165e1d32874e$var$SetCache.prototype.add = $4ead165e1d32874e$var$SetCache.prototype.push = $6D1Uo;
$4ead165e1d32874e$var$SetCache.prototype.has = $6Mefk;
module.exports = $4ead165e1d32874e$var$SetCache;

});
parcelRegister("6D1Uo", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $4d37dd98a5e9d1b9$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $4d37dd98a5e9d1b9$var$setCacheAdd(value) {
    this.__data__.set(value, $4d37dd98a5e9d1b9$var$HASH_UNDEFINED);
    return this;
}
module.exports = $4d37dd98a5e9d1b9$var$setCacheAdd;

});

parcelRegister("6Mefk", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $4ef246cbd2e1fd38$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $4ef246cbd2e1fd38$var$setCacheHas;

});


parcelRegister("lg20k", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $f79ca59ba54b6324$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $f79ca59ba54b6324$var$arraySome;

});

parcelRegister("9V4Kn", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $738d1e9174cf1920$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $738d1e9174cf1920$var$cacheHas;

});


parcelRegister("83CUX", function(module, exports) {

var $jKWZf = parcelRequire("jKWZf");

var $9vbLG = parcelRequire("9vbLG");

var $hXykb = parcelRequire("hXykb");

var $bJfbj = parcelRequire("bJfbj");

var $alfi4 = parcelRequire("alfi4");

var $iRBDH = parcelRequire("iRBDH");
/** Used to compose bitmasks for value comparisons. */ var $5ddccacbf661a7e0$var$COMPARE_PARTIAL_FLAG = 1, $5ddccacbf661a7e0$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $5ddccacbf661a7e0$var$boolTag = "[object Boolean]", $5ddccacbf661a7e0$var$dateTag = "[object Date]", $5ddccacbf661a7e0$var$errorTag = "[object Error]", $5ddccacbf661a7e0$var$mapTag = "[object Map]", $5ddccacbf661a7e0$var$numberTag = "[object Number]", $5ddccacbf661a7e0$var$regexpTag = "[object RegExp]", $5ddccacbf661a7e0$var$setTag = "[object Set]", $5ddccacbf661a7e0$var$stringTag = "[object String]", $5ddccacbf661a7e0$var$symbolTag = "[object Symbol]";
var $5ddccacbf661a7e0$var$arrayBufferTag = "[object ArrayBuffer]", $5ddccacbf661a7e0$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $5ddccacbf661a7e0$var$symbolProto = $jKWZf ? $jKWZf.prototype : undefined, $5ddccacbf661a7e0$var$symbolValueOf = $5ddccacbf661a7e0$var$symbolProto ? $5ddccacbf661a7e0$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $5ddccacbf661a7e0$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $5ddccacbf661a7e0$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $5ddccacbf661a7e0$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $9vbLG(object), new $9vbLG(other))) return false;
            return true;
        case $5ddccacbf661a7e0$var$boolTag:
        case $5ddccacbf661a7e0$var$dateTag:
        case $5ddccacbf661a7e0$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $hXykb(+object, +other);
        case $5ddccacbf661a7e0$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $5ddccacbf661a7e0$var$regexpTag:
        case $5ddccacbf661a7e0$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $5ddccacbf661a7e0$var$mapTag:
            var convert = $alfi4;
        case $5ddccacbf661a7e0$var$setTag:
            var isPartial = bitmask & $5ddccacbf661a7e0$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $iRBDH);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $5ddccacbf661a7e0$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $bJfbj(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $5ddccacbf661a7e0$var$symbolTag:
            if ($5ddccacbf661a7e0$var$symbolValueOf) return $5ddccacbf661a7e0$var$symbolValueOf.call(object) == $5ddccacbf661a7e0$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $5ddccacbf661a7e0$var$equalByTag;

});
parcelRegister("9vbLG", function(module, exports) {

var $90DZ0 = parcelRequire("90DZ0");
/** Built-in value references. */ var $6eb0233855d9f9d2$var$Uint8Array = $90DZ0.Uint8Array;
module.exports = $6eb0233855d9f9d2$var$Uint8Array;

});

parcelRegister("alfi4", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $7877b9ec4c466bbb$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $7877b9ec4c466bbb$var$mapToArray;

});

parcelRegister("iRBDH", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $dbba5f9c5ff69d7a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $dbba5f9c5ff69d7a$var$setToArray;

});


parcelRegister("5i7qB", function(module, exports) {

var $gE1kR = parcelRequire("gE1kR");
/** Used to compose bitmasks for value comparisons. */ var $3da46543fa8e58d4$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $3da46543fa8e58d4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da46543fa8e58d4$var$hasOwnProperty = $3da46543fa8e58d4$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $3da46543fa8e58d4$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3da46543fa8e58d4$var$COMPARE_PARTIAL_FLAG, objProps = $gE1kR(object), objLength = objProps.length, othProps = $gE1kR(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $3da46543fa8e58d4$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $3da46543fa8e58d4$var$equalObjects;

});
parcelRegister("gE1kR", function(module, exports) {

var $20lxO = parcelRequire("20lxO");

var $ghBJ5 = parcelRequire("ghBJ5");

var $cFrUu = parcelRequire("cFrUu");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c1e16af8d2378bd4$var$getAllKeys(object) {
    return $20lxO(object, $cFrUu, $ghBJ5);
}
module.exports = $c1e16af8d2378bd4$var$getAllKeys;

});
parcelRegister("20lxO", function(module, exports) {

var $7v2EH = parcelRequire("7v2EH");

var $i7g7V = parcelRequire("i7g7V");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $175c4b19c2fa1459$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $i7g7V(object) ? result : $7v2EH(result, symbolsFunc(object));
}
module.exports = $175c4b19c2fa1459$var$baseGetAllKeys;

});
parcelRegister("7v2EH", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $575d7cfe73cf9a75$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $575d7cfe73cf9a75$var$arrayPush;

});

parcelRegister("i7g7V", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d30563dfe4b5a399$var$isArray = Array.isArray;
module.exports = $d30563dfe4b5a399$var$isArray;

});


parcelRegister("ghBJ5", function(module, exports) {

var $fYa58 = parcelRequire("fYa58");

var $4Zy0i = parcelRequire("4Zy0i");
/** Used for built-in method references. */ var $bdab7f89335843c3$var$objectProto = Object.prototype;
/** Built-in value references. */ var $bdab7f89335843c3$var$propertyIsEnumerable = $bdab7f89335843c3$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bdab7f89335843c3$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $bdab7f89335843c3$var$getSymbols = !$bdab7f89335843c3$var$nativeGetSymbols ? $4Zy0i : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $fYa58($bdab7f89335843c3$var$nativeGetSymbols(object), function(symbol) {
        return $bdab7f89335843c3$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $bdab7f89335843c3$var$getSymbols;

});
parcelRegister("fYa58", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $ba0447a4ae86c3c6$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $ba0447a4ae86c3c6$var$arrayFilter;

});

parcelRegister("4Zy0i", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $3a273c644af62660$var$stubArray() {
    return [];
}
module.exports = $3a273c644af62660$var$stubArray;

});


parcelRegister("cFrUu", function(module, exports) {

var $gaSPF = parcelRequire("gaSPF");

var $hQhcc = parcelRequire("hQhcc");

var $zlD7L = parcelRequire("zlD7L");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $938ef6bad5499717$var$keys(object) {
    return $zlD7L(object) ? $gaSPF(object) : $hQhcc(object);
}
module.exports = $938ef6bad5499717$var$keys;

});
parcelRegister("gaSPF", function(module, exports) {

var $4ZYJI = parcelRequire("4ZYJI");

var $b2cjw = parcelRequire("b2cjw");

var $i7g7V = parcelRequire("i7g7V");

var $kNG5d = parcelRequire("kNG5d");

var $5Dc8z = parcelRequire("5Dc8z");

var $gwYfV = parcelRequire("gwYfV");
/** Used for built-in method references. */ var $bc681d0dea7aaa7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bc681d0dea7aaa7f$var$hasOwnProperty = $bc681d0dea7aaa7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $bc681d0dea7aaa7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $i7g7V(value), isArg = !isArr && $b2cjw(value), isBuff = !isArr && !isArg && $kNG5d(value), isType = !isArr && !isArg && !isBuff && $gwYfV(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $4ZYJI(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $bc681d0dea7aaa7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $5Dc8z(key, length)))) result.push(key);
    return result;
}
module.exports = $bc681d0dea7aaa7f$var$arrayLikeKeys;

});
parcelRegister("4ZYJI", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $3a3bf8e6fa707b17$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $3a3bf8e6fa707b17$var$baseTimes;

});

parcelRegister("b2cjw", function(module, exports) {

var $h3rqc = parcelRequire("h3rqc");

var $2Q0Th = parcelRequire("2Q0Th");
/** Used for built-in method references. */ var $80896eeab9a768af$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $80896eeab9a768af$var$hasOwnProperty = $80896eeab9a768af$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $80896eeab9a768af$var$propertyIsEnumerable = $80896eeab9a768af$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $80896eeab9a768af$var$isArguments = $h3rqc(function() {
    return arguments;
}()) ? $h3rqc : function(value) {
    return $2Q0Th(value) && $80896eeab9a768af$var$hasOwnProperty.call(value, "callee") && !$80896eeab9a768af$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $80896eeab9a768af$var$isArguments;

});
parcelRegister("h3rqc", function(module, exports) {

var $4dBZ2 = parcelRequire("4dBZ2");

var $2Q0Th = parcelRequire("2Q0Th");
/** `Object#toString` result references. */ var $c6a7fcd8c84d36d9$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $c6a7fcd8c84d36d9$var$baseIsArguments(value) {
    return $2Q0Th(value) && $4dBZ2(value) == $c6a7fcd8c84d36d9$var$argsTag;
}
module.exports = $c6a7fcd8c84d36d9$var$baseIsArguments;

});
parcelRegister("2Q0Th", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $211120fa3b9d50b6$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $211120fa3b9d50b6$var$isObjectLike;

});



parcelRegister("kNG5d", function(module, exports) {

var $90DZ0 = parcelRequire("90DZ0");

var $8HDCV = parcelRequire("8HDCV");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $90DZ0.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $8HDCV;
module.exports = isBuffer;

});
parcelRegister("8HDCV", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $656113ec6f9cb300$var$stubFalse() {
    return false;
}
module.exports = $656113ec6f9cb300$var$stubFalse;

});


parcelRegister("5Dc8z", function(module, exports) {
/** Used as references for various `Number` constants. */ var $419a027284a64f12$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $419a027284a64f12$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $419a027284a64f12$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $419a027284a64f12$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $419a027284a64f12$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $419a027284a64f12$var$isIndex;

});

parcelRegister("gwYfV", function(module, exports) {

var $cwA9s = parcelRequire("cwA9s");

var $3Zr4W = parcelRequire("3Zr4W");

var $61667 = parcelRequire("61667");
/* Node.js helper references. */ var $c08e6012d64254c0$var$nodeIsTypedArray = $61667 && $61667.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $c08e6012d64254c0$var$isTypedArray = $c08e6012d64254c0$var$nodeIsTypedArray ? $3Zr4W($c08e6012d64254c0$var$nodeIsTypedArray) : $cwA9s;
module.exports = $c08e6012d64254c0$var$isTypedArray;

});
parcelRegister("cwA9s", function(module, exports) {

var $4dBZ2 = parcelRequire("4dBZ2");

var $8DhxR = parcelRequire("8DhxR");

var $2Q0Th = parcelRequire("2Q0Th");
/** `Object#toString` result references. */ var $91e4841e9e1f5ca9$var$argsTag = "[object Arguments]", $91e4841e9e1f5ca9$var$arrayTag = "[object Array]", $91e4841e9e1f5ca9$var$boolTag = "[object Boolean]", $91e4841e9e1f5ca9$var$dateTag = "[object Date]", $91e4841e9e1f5ca9$var$errorTag = "[object Error]", $91e4841e9e1f5ca9$var$funcTag = "[object Function]", $91e4841e9e1f5ca9$var$mapTag = "[object Map]", $91e4841e9e1f5ca9$var$numberTag = "[object Number]", $91e4841e9e1f5ca9$var$objectTag = "[object Object]", $91e4841e9e1f5ca9$var$regexpTag = "[object RegExp]", $91e4841e9e1f5ca9$var$setTag = "[object Set]", $91e4841e9e1f5ca9$var$stringTag = "[object String]", $91e4841e9e1f5ca9$var$weakMapTag = "[object WeakMap]";
var $91e4841e9e1f5ca9$var$arrayBufferTag = "[object ArrayBuffer]", $91e4841e9e1f5ca9$var$dataViewTag = "[object DataView]", $91e4841e9e1f5ca9$var$float32Tag = "[object Float32Array]", $91e4841e9e1f5ca9$var$float64Tag = "[object Float64Array]", $91e4841e9e1f5ca9$var$int8Tag = "[object Int8Array]", $91e4841e9e1f5ca9$var$int16Tag = "[object Int16Array]", $91e4841e9e1f5ca9$var$int32Tag = "[object Int32Array]", $91e4841e9e1f5ca9$var$uint8Tag = "[object Uint8Array]", $91e4841e9e1f5ca9$var$uint8ClampedTag = "[object Uint8ClampedArray]", $91e4841e9e1f5ca9$var$uint16Tag = "[object Uint16Array]", $91e4841e9e1f5ca9$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $91e4841e9e1f5ca9$var$typedArrayTags = {};
$91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$float32Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$float64Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$int8Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$int16Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$int32Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$uint8Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$uint8ClampedTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$uint16Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$uint32Tag] = true;
$91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$argsTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$arrayTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$arrayBufferTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$boolTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$dataViewTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$dateTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$errorTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$funcTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$mapTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$numberTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$objectTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$regexpTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$setTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$stringTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $91e4841e9e1f5ca9$var$baseIsTypedArray(value) {
    return $2Q0Th(value) && $8DhxR(value.length) && !!$91e4841e9e1f5ca9$var$typedArrayTags[$4dBZ2(value)];
}
module.exports = $91e4841e9e1f5ca9$var$baseIsTypedArray;

});
parcelRegister("8DhxR", function(module, exports) {
/** Used as references for various `Number` constants. */ var $648f935d2d306587$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $648f935d2d306587$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $648f935d2d306587$var$MAX_SAFE_INTEGER;
}
module.exports = $648f935d2d306587$var$isLength;

});


parcelRegister("3Zr4W", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $2e7c12d7c1c23c18$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $2e7c12d7c1c23c18$var$baseUnary;

});

parcelRegister("61667", function(module, exports) {

var $209Wz = parcelRequire("209Wz");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $209Wz.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("hQhcc", function(module, exports) {

var $VtIOd = parcelRequire("VtIOd");

var $lIoPh = parcelRequire("lIoPh");
/** Used for built-in method references. */ var $cfd4a1b5fe90449a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cfd4a1b5fe90449a$var$hasOwnProperty = $cfd4a1b5fe90449a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $cfd4a1b5fe90449a$var$baseKeys(object) {
    if (!$VtIOd(object)) return $lIoPh(object);
    var result = [];
    for(var key in Object(object))if ($cfd4a1b5fe90449a$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $cfd4a1b5fe90449a$var$baseKeys;

});
parcelRegister("VtIOd", function(module, exports) {
/** Used for built-in method references. */ var $0acc6119f1de8223$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $0acc6119f1de8223$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $0acc6119f1de8223$var$objectProto;
    return value === proto;
}
module.exports = $0acc6119f1de8223$var$isPrototype;

});

parcelRegister("lIoPh", function(module, exports) {

var $6zeve = parcelRequire("6zeve");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fcf0f6ff5ed9829c$var$nativeKeys = $6zeve(Object.keys, Object);
module.exports = $fcf0f6ff5ed9829c$var$nativeKeys;

});
parcelRegister("6zeve", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $4c8142e631f639a0$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $4c8142e631f639a0$var$overArg;

});



parcelRegister("zlD7L", function(module, exports) {

var $8l1wZ = parcelRequire("8l1wZ");

var $8DhxR = parcelRequire("8DhxR");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $06a40c4626ec02cc$var$isArrayLike(value) {
    return value != null && $8DhxR(value.length) && !$8l1wZ(value);
}
module.exports = $06a40c4626ec02cc$var$isArrayLike;

});




parcelRegister("7K2r8", function(module, exports) {

var $kaHGq = parcelRequire("kaHGq");

var $kkAOZ = parcelRequire("kkAOZ");

var $6ii2s = parcelRequire("6ii2s");

var $cSHZC = parcelRequire("cSHZC");

var $lEQGI = parcelRequire("lEQGI");

var $4dBZ2 = parcelRequire("4dBZ2");

var $hJN8N = parcelRequire("hJN8N");
/** `Object#toString` result references. */ var $5a2eb8212e9759db$var$mapTag = "[object Map]", $5a2eb8212e9759db$var$objectTag = "[object Object]", $5a2eb8212e9759db$var$promiseTag = "[object Promise]", $5a2eb8212e9759db$var$setTag = "[object Set]", $5a2eb8212e9759db$var$weakMapTag = "[object WeakMap]";
var $5a2eb8212e9759db$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $5a2eb8212e9759db$var$dataViewCtorString = $hJN8N($kaHGq), $5a2eb8212e9759db$var$mapCtorString = $hJN8N($kkAOZ), $5a2eb8212e9759db$var$promiseCtorString = $hJN8N($6ii2s), $5a2eb8212e9759db$var$setCtorString = $hJN8N($cSHZC), $5a2eb8212e9759db$var$weakMapCtorString = $hJN8N($lEQGI);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $5a2eb8212e9759db$var$getTag = $4dBZ2;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($kaHGq && $5a2eb8212e9759db$var$getTag(new $kaHGq(new ArrayBuffer(1))) != $5a2eb8212e9759db$var$dataViewTag || $kkAOZ && $5a2eb8212e9759db$var$getTag(new $kkAOZ) != $5a2eb8212e9759db$var$mapTag || $6ii2s && $5a2eb8212e9759db$var$getTag($6ii2s.resolve()) != $5a2eb8212e9759db$var$promiseTag || $cSHZC && $5a2eb8212e9759db$var$getTag(new $cSHZC) != $5a2eb8212e9759db$var$setTag || $lEQGI && $5a2eb8212e9759db$var$getTag(new $lEQGI) != $5a2eb8212e9759db$var$weakMapTag) $5a2eb8212e9759db$var$getTag = function(value) {
    var result = $4dBZ2(value), Ctor = result == $5a2eb8212e9759db$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $hJN8N(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $5a2eb8212e9759db$var$dataViewCtorString:
            return $5a2eb8212e9759db$var$dataViewTag;
        case $5a2eb8212e9759db$var$mapCtorString:
            return $5a2eb8212e9759db$var$mapTag;
        case $5a2eb8212e9759db$var$promiseCtorString:
            return $5a2eb8212e9759db$var$promiseTag;
        case $5a2eb8212e9759db$var$setCtorString:
            return $5a2eb8212e9759db$var$setTag;
        case $5a2eb8212e9759db$var$weakMapCtorString:
            return $5a2eb8212e9759db$var$weakMapTag;
    }
    return result;
};
module.exports = $5a2eb8212e9759db$var$getTag;

});
parcelRegister("kaHGq", function(module, exports) {

var $cAmET = parcelRequire("cAmET");

var $90DZ0 = parcelRequire("90DZ0");
/* Built-in method references that are verified to be native. */ var $eaf6a06c5a810587$var$DataView = $cAmET($90DZ0, "DataView");
module.exports = $eaf6a06c5a810587$var$DataView;

});

parcelRegister("6ii2s", function(module, exports) {

var $cAmET = parcelRequire("cAmET");

var $90DZ0 = parcelRequire("90DZ0");
/* Built-in method references that are verified to be native. */ var $49526a9ff16d96e7$var$Promise = $cAmET($90DZ0, "Promise");
module.exports = $49526a9ff16d96e7$var$Promise;

});

parcelRegister("cSHZC", function(module, exports) {

var $cAmET = parcelRequire("cAmET");

var $90DZ0 = parcelRequire("90DZ0");
/* Built-in method references that are verified to be native. */ var $960ca74452c26c48$var$Set = $cAmET($90DZ0, "Set");
module.exports = $960ca74452c26c48$var$Set;

});

parcelRegister("lEQGI", function(module, exports) {

var $cAmET = parcelRequire("cAmET");

var $90DZ0 = parcelRequire("90DZ0");
/* Built-in method references that are verified to be native. */ var $fc46342694bd5fc0$var$WeakMap = $cAmET($90DZ0, "WeakMap");
module.exports = $fc46342694bd5fc0$var$WeakMap;

});





parcelRegister("bAbuX", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $86ebf9cdb817c64f$var$noop() {
// No operation performed.
}
module.exports = $86ebf9cdb817c64f$var$noop;

});

parcelRegister("5kW8A", function(module, exports) {

var $emjEh = parcelRequire("emjEh");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $3e2beae33aad27ca$var$uniq(array) {
    return array && array.length ? $emjEh(array) : [];
}
module.exports = $3e2beae33aad27ca$var$uniq;

});
parcelRegister("emjEh", function(module, exports) {

var $6KN3c = parcelRequire("6KN3c");

var $48UZF = parcelRequire("48UZF");

var $fcz2q = parcelRequire("fcz2q");

var $9V4Kn = parcelRequire("9V4Kn");

var $kpY87 = parcelRequire("kpY87");

var $iRBDH = parcelRequire("iRBDH");
/** Used as the size to enable large array optimizations. */ var $a7425c8f073cb9c0$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $a7425c8f073cb9c0$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $48UZF, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $fcz2q;
    } else if (length >= $a7425c8f073cb9c0$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $kpY87(array);
        if (set) return $iRBDH(set);
        isCommon = false;
        includes = $9V4Kn;
        seen = new $6KN3c;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $a7425c8f073cb9c0$var$baseUniq;

});
parcelRegister("48UZF", function(module, exports) {

var $lXpHp = parcelRequire("lXpHp");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $30441e8856eb668e$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $lXpHp(array, value, 0) > -1;
}
module.exports = $30441e8856eb668e$var$arrayIncludes;

});
parcelRegister("lXpHp", function(module, exports) {

var $bRvLX = parcelRequire("bRvLX");

var $9cc5l = parcelRequire("9cc5l");

var $j0ZIP = parcelRequire("j0ZIP");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ffc30afcdd6e0420$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $j0ZIP(array, value, fromIndex) : $bRvLX(array, $9cc5l, fromIndex);
}
module.exports = $ffc30afcdd6e0420$var$baseIndexOf;

});
parcelRegister("bRvLX", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $8a2d4a47b21f0d76$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $8a2d4a47b21f0d76$var$baseFindIndex;

});

parcelRegister("9cc5l", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $6b1e9be6ef193739$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $6b1e9be6ef193739$var$baseIsNaN;

});

parcelRegister("j0ZIP", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $dd7de51d22c5d63a$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $dd7de51d22c5d63a$var$strictIndexOf;

});



parcelRegister("fcz2q", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $b11327d2a758c2ad$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $b11327d2a758c2ad$var$arrayIncludesWith;

});

parcelRegister("kpY87", function(module, exports) {

var $cSHZC = parcelRequire("cSHZC");

var $bAbuX = parcelRequire("bAbuX");

var $iRBDH = parcelRequire("iRBDH");
/** Used as references for various `Number` constants. */ var $edd4c90219aa9c1f$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $edd4c90219aa9c1f$var$createSet = !($cSHZC && 1 / $iRBDH(new $cSHZC([
    ,
    -0
]))[1] == $edd4c90219aa9c1f$var$INFINITY) ? $bAbuX : function(values) {
    return new $cSHZC(values);
};
module.exports = $edd4c90219aa9c1f$var$createSet;

});



parcelRegister("2LA01", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $203be54761fcfed3$var$_react = $203be54761fcfed3$var$_interopRequireDefault((parcelRequire("3QbnI")));

var $203be54761fcfed3$var$_propTypes = $203be54761fcfed3$var$_interopRequireDefault((parcelRequire("bZSVP")));
function $203be54761fcfed3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $203be54761fcfed3$var$ClearAllTags = function ClearAllTags(props) {
    return /*#__PURE__*/ $203be54761fcfed3$var$_react["default"].createElement("button", {
        className: props.classNames.clearAll,
        onClick: props.onClick
    }, "Clear all");
};
$203be54761fcfed3$var$ClearAllTags.propTypes = {
    classNames: $203be54761fcfed3$var$_propTypes["default"].object,
    onClick: $203be54761fcfed3$var$_propTypes["default"].func
};
var $203be54761fcfed3$var$_default = module.exports["default"] = $203be54761fcfed3$var$ClearAllTags;

});

parcelRegister("a5YPb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $75998d7cbf292a22$var$_react = $75998d7cbf292a22$var$_interopRequireWildcard((parcelRequire("3QbnI")));

var $75998d7cbf292a22$var$_propTypes = $75998d7cbf292a22$var$_interopRequireDefault((parcelRequire("bZSVP")));

var $75998d7cbf292a22$var$_isEqual = $75998d7cbf292a22$var$_interopRequireDefault((parcelRequire("kzj6W")));

var $75998d7cbf292a22$var$_escape = $75998d7cbf292a22$var$_interopRequireDefault((parcelRequire("k4uFV")));
function $75998d7cbf292a22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $75998d7cbf292a22$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($75998d7cbf292a22$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $75998d7cbf292a22$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $75998d7cbf292a22$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $75998d7cbf292a22$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $75998d7cbf292a22$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $75998d7cbf292a22$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $75998d7cbf292a22$var$_typeof(o);
}
function $75998d7cbf292a22$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $75998d7cbf292a22$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $75998d7cbf292a22$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $75998d7cbf292a22$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $75998d7cbf292a22$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $75998d7cbf292a22$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $75998d7cbf292a22$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $75998d7cbf292a22$var$_setPrototypeOf(subClass, superClass);
}
function $75998d7cbf292a22$var$_setPrototypeOf(o, p) {
    $75998d7cbf292a22$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $75998d7cbf292a22$var$_setPrototypeOf(o, p);
}
function $75998d7cbf292a22$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $75998d7cbf292a22$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $75998d7cbf292a22$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $75998d7cbf292a22$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $75998d7cbf292a22$var$_possibleConstructorReturn(this, result);
    };
}
function $75998d7cbf292a22$var$_possibleConstructorReturn(self, call) {
    if (call && ($75998d7cbf292a22$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $75998d7cbf292a22$var$_assertThisInitialized(self);
}
function $75998d7cbf292a22$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $75998d7cbf292a22$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $75998d7cbf292a22$var$_getPrototypeOf(o) {
    $75998d7cbf292a22$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $75998d7cbf292a22$var$_getPrototypeOf(o);
}
function $75998d7cbf292a22$var$_defineProperty(obj, key, value) {
    key = $75998d7cbf292a22$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75998d7cbf292a22$var$_toPropertyKey(arg) {
    var key = $75998d7cbf292a22$var$_toPrimitive(arg, "string");
    return $75998d7cbf292a22$var$_typeof(key) === "symbol" ? key : String(key);
}
function $75998d7cbf292a22$var$_toPrimitive(input, hint) {
    if ($75998d7cbf292a22$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($75998d7cbf292a22$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $75998d7cbf292a22$var$maybeScrollSuggestionIntoView = function maybeScrollSuggestionIntoView(suggestionEl, suggestionsContainer) {
    var containerHeight = suggestionsContainer.offsetHeight;
    var suggestionHeight = suggestionEl.offsetHeight;
    var relativeSuggestionTop = suggestionEl.offsetTop - suggestionsContainer.scrollTop;
    if (relativeSuggestionTop + suggestionHeight >= containerHeight) suggestionsContainer.scrollTop += relativeSuggestionTop - containerHeight + suggestionHeight;
    else if (relativeSuggestionTop < 0) suggestionsContainer.scrollTop += relativeSuggestionTop;
};
var $75998d7cbf292a22$var$Suggestions = /*#__PURE__*/ function(_Component) {
    $75998d7cbf292a22$var$_inherits(Suggestions, _Component);
    var _super = $75998d7cbf292a22$var$_createSuper(Suggestions);
    function Suggestions() {
        var _this;
        $75998d7cbf292a22$var$_classCallCheck(this, Suggestions);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $75998d7cbf292a22$var$_defineProperty($75998d7cbf292a22$var$_assertThisInitialized(_this), "markIt", function(input, query) {
            var escapedRegex = query.trim().replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
            var labelValue = input[_this.props.labelField];
            return {
                __html: labelValue.replace(RegExp(escapedRegex, "gi"), function(x) {
                    return "<mark>".concat((0, $75998d7cbf292a22$var$_escape["default"])(x), "</mark>");
                })
            };
        });
        $75998d7cbf292a22$var$_defineProperty($75998d7cbf292a22$var$_assertThisInitialized(_this), "shouldRenderSuggestions", function(query) {
            var _this$props = _this.props, minQueryLength = _this$props.minQueryLength, isFocused = _this$props.isFocused;
            return query.length >= minQueryLength && isFocused;
        });
        $75998d7cbf292a22$var$_defineProperty($75998d7cbf292a22$var$_assertThisInitialized(_this), "renderSuggestion", function(item, query) {
            var renderSuggestion = _this.props.renderSuggestion;
            if (typeof renderSuggestion === "function") return renderSuggestion(item, query);
            return /*#__PURE__*/ $75998d7cbf292a22$var$_react["default"].createElement("span", {
                dangerouslySetInnerHTML: _this.markIt(item, query)
            });
        });
        return _this;
    }
    $75998d7cbf292a22$var$_createClass(Suggestions, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var props = this.props;
                var shouldRenderSuggestions = props.shouldRenderSuggestions || this.shouldRenderSuggestions;
                return props.isFocused !== nextProps.isFocused || !(0, $75998d7cbf292a22$var$_isEqual["default"])(props.suggestions, nextProps.suggestions) || shouldRenderSuggestions(nextProps.query) || shouldRenderSuggestions(nextProps.query) !== shouldRenderSuggestions(props.query);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props2 = this.props, selectedIndex = _this$props2.selectedIndex, classNames = _this$props2.classNames;
                if (this.suggestionsContainer && prevProps.selectedIndex !== selectedIndex) {
                    var activeSuggestion = this.suggestionsContainer.querySelector(".".concat(classNames.activeSuggestion));
                    if (activeSuggestion) $75998d7cbf292a22$var$maybeScrollSuggestionIntoView(activeSuggestion, this.suggestionsContainer);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var props = this.props;
                var suggestions = props.suggestions.map((function(item, i) {
                    return /*#__PURE__*/ $75998d7cbf292a22$var$_react["default"].createElement("li", {
                        key: i,
                        onMouseDown: props.handleClick.bind(null, i),
                        onTouchStart: props.handleClick.bind(null, i),
                        onMouseOver: props.handleHover.bind(null, i),
                        className: i === props.selectedIndex ? props.classNames.activeSuggestion : ""
                    }, this.renderSuggestion(item, props.query));
                }).bind(this));
                // use the override, if provided
                var shouldRenderSuggestions = props.shouldRenderSuggestions || this.shouldRenderSuggestions;
                if (suggestions.length === 0 || !shouldRenderSuggestions(props.query)) return null;
                return /*#__PURE__*/ $75998d7cbf292a22$var$_react["default"].createElement("div", {
                    ref: function ref(elem) {
                        _this2.suggestionsContainer = elem;
                    },
                    className: this.props.classNames.suggestions
                }, /*#__PURE__*/ $75998d7cbf292a22$var$_react["default"].createElement("ul", null, " ", suggestions, " "));
            }
        }
    ]);
    return Suggestions;
}($75998d7cbf292a22$var$_react.Component);
$75998d7cbf292a22$var$_defineProperty($75998d7cbf292a22$var$Suggestions, "propTypes", {
    query: $75998d7cbf292a22$var$_propTypes["default"].string.isRequired,
    selectedIndex: $75998d7cbf292a22$var$_propTypes["default"].number.isRequired,
    suggestions: $75998d7cbf292a22$var$_propTypes["default"].array.isRequired,
    handleClick: $75998d7cbf292a22$var$_propTypes["default"].func.isRequired,
    handleHover: $75998d7cbf292a22$var$_propTypes["default"].func.isRequired,
    minQueryLength: $75998d7cbf292a22$var$_propTypes["default"].number,
    shouldRenderSuggestions: $75998d7cbf292a22$var$_propTypes["default"].func,
    isFocused: $75998d7cbf292a22$var$_propTypes["default"].bool.isRequired,
    classNames: $75998d7cbf292a22$var$_propTypes["default"].object,
    labelField: $75998d7cbf292a22$var$_propTypes["default"].string.isRequired,
    renderSuggestion: $75998d7cbf292a22$var$_propTypes["default"].func
});
$75998d7cbf292a22$var$_defineProperty($75998d7cbf292a22$var$Suggestions, "defaultProps", {
    minQueryLength: 2
});
var $75998d7cbf292a22$var$_default = module.exports["default"] = $75998d7cbf292a22$var$Suggestions;

});
parcelRegister("k4uFV", function(module, exports) {

var $cOrXT = parcelRequire("cOrXT");

var $8cwsH = parcelRequire("8cwsH");
/** Used to match HTML entities and HTML characters. */ var $e9cbf9d9d9790bff$var$reUnescapedHtml = /[&<>"']/g, $e9cbf9d9d9790bff$var$reHasUnescapedHtml = RegExp($e9cbf9d9d9790bff$var$reUnescapedHtml.source);
/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */ function $e9cbf9d9d9790bff$var$escape(string) {
    string = $8cwsH(string);
    return string && $e9cbf9d9d9790bff$var$reHasUnescapedHtml.test(string) ? string.replace($e9cbf9d9d9790bff$var$reUnescapedHtml, $cOrXT) : string;
}
module.exports = $e9cbf9d9d9790bff$var$escape;

});
parcelRegister("cOrXT", function(module, exports) {

var $9Pxv2 = parcelRequire("9Pxv2");
/** Used to map characters to HTML entities. */ var $953fd8d0a98efa7d$var$htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */ var $953fd8d0a98efa7d$var$escapeHtmlChar = $9Pxv2($953fd8d0a98efa7d$var$htmlEscapes);
module.exports = $953fd8d0a98efa7d$var$escapeHtmlChar;

});
parcelRegister("9Pxv2", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $7282dcc76e78a5bc$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $7282dcc76e78a5bc$var$basePropertyOf;

});


parcelRegister("8cwsH", function(module, exports) {

var $iUfbT = parcelRequire("iUfbT");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $5f889ff337c3b19a$var$toString(value) {
    return value == null ? "" : $iUfbT(value);
}
module.exports = $5f889ff337c3b19a$var$toString;

});
parcelRegister("iUfbT", function(module, exports) {

var $jKWZf = parcelRequire("jKWZf");

var $1AC85 = parcelRequire("1AC85");

var $i7g7V = parcelRequire("i7g7V");

var $7907u = parcelRequire("7907u");
/** Used as references for various `Number` constants. */ var $dc393d85e9974d53$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $dc393d85e9974d53$var$symbolProto = $jKWZf ? $jKWZf.prototype : undefined, $dc393d85e9974d53$var$symbolToString = $dc393d85e9974d53$var$symbolProto ? $dc393d85e9974d53$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $dc393d85e9974d53$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($i7g7V(value)) // Recursively convert values (susceptible to call stack limits).
    return $1AC85(value, $dc393d85e9974d53$var$baseToString) + "";
    if ($7907u(value)) return $dc393d85e9974d53$var$symbolToString ? $dc393d85e9974d53$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$dc393d85e9974d53$var$INFINITY ? "-0" : result;
}
module.exports = $dc393d85e9974d53$var$baseToString;

});
parcelRegister("1AC85", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $1286baf6978c1736$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $1286baf6978c1736$var$arrayMap;

});

parcelRegister("7907u", function(module, exports) {

var $4dBZ2 = parcelRequire("4dBZ2");

var $2Q0Th = parcelRequire("2Q0Th");
/** `Object#toString` result references. */ var $5339777265736955$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5339777265736955$var$isSymbol(value) {
    return typeof value == "symbol" || $2Q0Th(value) && $4dBZ2(value) == $5339777265736955$var$symbolTag;
}
module.exports = $5339777265736955$var$isSymbol;

});





parcelRegister("jVS5x", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("dAEho", function(module, exports) {
"use strict";
function $9e4de1d33f3fbf79$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9e4de1d33f3fbf79$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9e4de1d33f3fbf79$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9e4de1d33f3fbf79$var$_react = $9e4de1d33f3fbf79$var$_interopRequireWildcard((parcelRequire("3QbnI")));

var $d6onY = parcelRequire("d6onY");
var $fM90j = parcelRequire("fM90j");

var $9e4de1d33f3fbf79$var$_propTypes = $9e4de1d33f3fbf79$var$_interopRequireDefault((parcelRequire("bZSVP")));

var $9e4de1d33f3fbf79$var$_classnames = $9e4de1d33f3fbf79$var$_interopRequireDefault((parcelRequire("jVS5x")));

var $iWuDm = parcelRequire("iWuDm");

var $9e4de1d33f3fbf79$var$_RemoveComponent = $9e4de1d33f3fbf79$var$_interopRequireDefault((parcelRequire("hIrdR")));
function $9e4de1d33f3fbf79$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9e4de1d33f3fbf79$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9e4de1d33f3fbf79$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9e4de1d33f3fbf79$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $9e4de1d33f3fbf79$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $9e4de1d33f3fbf79$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9e4de1d33f3fbf79$var$_slicedToArray(arr, i) {
    return $9e4de1d33f3fbf79$var$_arrayWithHoles(arr) || $9e4de1d33f3fbf79$var$_iterableToArrayLimit(arr, i) || $9e4de1d33f3fbf79$var$_unsupportedIterableToArray(arr, i) || $9e4de1d33f3fbf79$var$_nonIterableRest();
}
function $9e4de1d33f3fbf79$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e4de1d33f3fbf79$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9e4de1d33f3fbf79$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e4de1d33f3fbf79$var$_arrayLikeToArray(o, minLen);
}
function $9e4de1d33f3fbf79$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9e4de1d33f3fbf79$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9e4de1d33f3fbf79$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $9e4de1d33f3fbf79$var$ItemTypes = {
    TAG: "tag"
};
var $9e4de1d33f3fbf79$var$Tag = function Tag(props) {
    var tagRef = (0, $9e4de1d33f3fbf79$var$_react.useRef)(null);
    var readOnly = props.readOnly, tag = props.tag, classNames = props.classNames, index = props.index;
    var _useDrag = (0, $d6onY.useDrag)(function() {
        return {
            type: $9e4de1d33f3fbf79$var$ItemTypes.TAG,
            collect: function collect(monitor) {
                return {
                    isDragging: !!monitor.isDragging()
                };
            },
            item: props,
            canDrag: function canDrag() {
                return (0, $iWuDm.canDrag)(props);
            }
        };
    }), _useDrag2 = $9e4de1d33f3fbf79$var$_slicedToArray(_useDrag, 2), isDragging = _useDrag2[0].isDragging, drag = _useDrag2[1];
    var _useDrop = (0, $fM90j.useDrop)(function() {
        return {
            accept: $9e4de1d33f3fbf79$var$ItemTypes.TAG,
            drop: function drop(item, monitor) {
                var dragIndex = item.index;
                var hoverIndex = index;
                if (dragIndex === hoverIndex) return;
                props.moveTag(dragIndex, hoverIndex);
            },
            canDrop: function canDrop(item) {
                return (0, $iWuDm.canDrop)(item);
            }
        };
    }), _useDrop2 = $9e4de1d33f3fbf79$var$_slicedToArray(_useDrop, 2), drop = _useDrop2[1];
    drag(drop(tagRef));
    var label = props.tag[props.labelField];
    var _tag$className = tag.className, className = _tag$className === void 0 ? "" : _tag$className;
    /* istanbul ignore next */ var opacity = isDragging ? 0 : 1;
    var tagComponent = /*#__PURE__*/ $9e4de1d33f3fbf79$var$_react["default"].createElement("span", {
        ref: tagRef,
        className: (0, $9e4de1d33f3fbf79$var$_classnames["default"])("tag-wrapper", classNames.tag, className),
        style: {
            opacity: opacity,
            cursor: (0, $iWuDm.canDrag)(props) ? "move" : "auto"
        },
        onClick: props.onTagClicked,
        onTouchStart: props.onTagClicked
    }, label, /*#__PURE__*/ $9e4de1d33f3fbf79$var$_react["default"].createElement($9e4de1d33f3fbf79$var$_RemoveComponent["default"], {
        tag: props.tag,
        className: classNames.remove,
        removeComponent: props.removeComponent,
        onRemove: props.onDelete,
        readOnly: readOnly,
        index: index
    }));
    return tagComponent;
};
$9e4de1d33f3fbf79$var$Tag.propTypes = {
    labelField: $9e4de1d33f3fbf79$var$_propTypes["default"].string,
    onDelete: $9e4de1d33f3fbf79$var$_propTypes["default"].func.isRequired,
    tag: $9e4de1d33f3fbf79$var$_propTypes["default"].shape({
        id: $9e4de1d33f3fbf79$var$_propTypes["default"].string.isRequired,
        className: $9e4de1d33f3fbf79$var$_propTypes["default"].string,
        key: $9e4de1d33f3fbf79$var$_propTypes["default"].string
    }),
    moveTag: $9e4de1d33f3fbf79$var$_propTypes["default"].func,
    removeComponent: $9e4de1d33f3fbf79$var$_propTypes["default"].func,
    onTagClicked: $9e4de1d33f3fbf79$var$_propTypes["default"].func,
    classNames: $9e4de1d33f3fbf79$var$_propTypes["default"].object,
    readOnly: $9e4de1d33f3fbf79$var$_propTypes["default"].bool,
    index: $9e4de1d33f3fbf79$var$_propTypes["default"].number.isRequired
};
$9e4de1d33f3fbf79$var$Tag.defaultProps = {
    labelField: "text",
    readOnly: false
};
var $9e4de1d33f3fbf79$var$_default = module.exports["default"] = $9e4de1d33f3fbf79$var$Tag;

});
parcelRegister("d6onY", function(module, exports) {

$parcel$export(module.exports, "useDrag", function () { return $989ec05e94ec157d$export$7941f8aafa4b6021; });

var $rwcxx = parcelRequire("rwcxx");

var $1nHeE = parcelRequire("1nHeE");

var $geR43 = parcelRequire("geR43");

var $fYuA9 = parcelRequire("fYuA9");

var $3OU1W = parcelRequire("3OU1W");

var $8bIXp = parcelRequire("8bIXp");

var $b07x1 = parcelRequire("b07x1");
function $989ec05e94ec157d$export$7941f8aafa4b6021(specArg, deps) {
    const spec = (0, $geR43.useOptionalFactory)(specArg, deps);
    (0, $rwcxx.invariant)(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = (0, $8bIXp.useDragSourceMonitor)();
    const connector = (0, $3OU1W.useDragSourceConnector)(spec.options, spec.previewOptions);
    (0, $b07x1.useRegisteredDragSource)(spec, monitor, connector);
    return [
        (0, $1nHeE.useCollectedProps)(spec.collect, monitor, connector),
        (0, $fYuA9.useConnectDragSource)(connector),
        (0, $fYuA9.useConnectDragPreview)(connector)
    ];
}

});
parcelRegister("rwcxx", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $052b803ae11b591e$export$f5708dca728d7177; });
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ 
var $54X9E = parcelRequire("54X9E");
function $052b803ae11b591e$export$f5708dca728d7177(condition, format, ...args) {
    if ($052b803ae11b591e$var$isProduction()) {
        if (format === undefined) throw new Error("invariant requires an error message argument");
    }
    if (!condition) {
        let error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function $052b803ae11b591e$var$isProduction() {
    return typeof $54X9E !== "undefined" && true;
}

});

parcelRegister("1nHeE", function(module, exports) {

$parcel$export(module.exports, "useCollectedProps", function () { return $10197a0cfd6fd35b$export$a55a4e3c0acb6f15; });

var $9gH5h = parcelRequire("9gH5h");
function $10197a0cfd6fd35b$export$a55a4e3c0acb6f15(collector, monitor, connector) {
    return (0, $9gH5h.useMonitorOutput)(monitor, collector || (()=>({})), ()=>connector.reconnect());
}

});
parcelRegister("9gH5h", function(module, exports) {

$parcel$export(module.exports, "useMonitorOutput", function () { return $6bf7074b6bb2e553$export$f34439a5e43bd79c; });

var $iPqAe = parcelRequire("iPqAe");

var $23Wqq = parcelRequire("23Wqq");
function $6bf7074b6bb2e553$export$f34439a5e43bd79c(monitor, collect, onCollect) {
    const [collected, updateCollected] = (0, $iPqAe.useCollector)(monitor, collect, onCollect);
    (0, $23Wqq.useIsomorphicLayoutEffect)(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) return;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}

});
parcelRegister("iPqAe", function(module, exports) {

$parcel$export(module.exports, "useCollector", function () { return $db519c4f9726c45e$export$e32e64a4387f290a; });

var $cjMwV = parcelRequire("cjMwV");

var $3QbnI = parcelRequire("3QbnI");

var $23Wqq = parcelRequire("23Wqq");
function $db519c4f9726c45e$export$e32e64a4387f290a(monitor, collect, onUpdate) {
    const [collected, setCollected] = (0, $3QbnI.useState)(()=>collect(monitor));
    const updateCollected = (0, $3QbnI.useCallback)(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cjMwV)))(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    (0, $23Wqq.useIsomorphicLayoutEffect)(updateCollected);
    return [
        collected,
        updateCollected
    ];
}

});
parcelRegister("cjMwV", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("23Wqq", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $18092ea3c105e89c$export$700979bc83e7db82; });

var $3QbnI = parcelRequire("3QbnI");
const $18092ea3c105e89c$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $3QbnI.useLayoutEffect) : (0, $3QbnI.useEffect);

});




parcelRegister("geR43", function(module, exports) {

$parcel$export(module.exports, "useOptionalFactory", function () { return $bd271da300fe8b20$export$f16a07909151e918; });

var $3QbnI = parcelRequire("3QbnI");
function $bd271da300fe8b20$export$f16a07909151e918(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== "function") memoDeps.push(arg);
    return (0, $3QbnI.useMemo)(()=>{
        return typeof arg === "function" ? arg() : arg;
    }, memoDeps);
}

});

parcelRegister("fYuA9", function(module, exports) {

$parcel$export(module.exports, "useConnectDragSource", function () { return $ba142e91e153a3b4$export$90c397533e0cc6; });
$parcel$export(module.exports, "useConnectDragPreview", function () { return $ba142e91e153a3b4$export$a66b3011bc8970d6; });

var $3QbnI = parcelRequire("3QbnI");
function $ba142e91e153a3b4$export$90c397533e0cc6(connector) {
    return (0, $3QbnI.useMemo)(()=>connector.hooks.dragSource(), [
        connector
    ]);
}
function $ba142e91e153a3b4$export$a66b3011bc8970d6(connector) {
    return (0, $3QbnI.useMemo)(()=>connector.hooks.dragPreview(), [
        connector
    ]);
}

});

parcelRegister("3OU1W", function(module, exports) {

$parcel$export(module.exports, "useDragSourceConnector", function () { return $2c818111223149d0$export$a5dfa024c6f78e86; });

var $3QbnI = parcelRequire("3QbnI");

var $aTAJ9 = parcelRequire("aTAJ9");

var $jkdsW = parcelRequire("jkdsW");

var $23Wqq = parcelRequire("23Wqq");
function $2c818111223149d0$export$a5dfa024c6f78e86(dragSourceOptions, dragPreviewOptions) {
    const manager = (0, $jkdsW.useDragDropManager)();
    const connector = (0, $3QbnI.useMemo)(()=>new (0, $aTAJ9.SourceConnector)(manager.getBackend()), [
        manager
    ]);
    (0, $23Wqq.useIsomorphicLayoutEffect)(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource();
    }, [
        connector,
        dragSourceOptions
    ]);
    (0, $23Wqq.useIsomorphicLayoutEffect)(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview();
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}

});
parcelRegister("aTAJ9", function(module, exports) {

$parcel$export(module.exports, "SourceConnector", function () { return $020c0e93655a4c5c$export$9a7176fb37ab5028; });

var $9u1L5 = parcelRequire("9u1L5");

var $jvtfw = parcelRequire("jvtfw");

var $8nhMz = parcelRequire("8nhMz");
class $020c0e93655a4c5c$export$9a7176fb37ab5028 {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) this.disconnectDragSource();
        if (!this.handlerId) return didChange;
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) this.disconnectDragPreview();
        if (!this.handlerId) return;
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !(0, $9u1L5.shallowEqual)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !(0, $9u1L5.shallowEqual)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = (0, $8nhMz.wrapConnectorHooks)({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if ((0, $jvtfw.isRef)(node)) this.dragSourceRef = node;
                else this.dragSourceNode = node;
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if ((0, $jvtfw.isRef)(node)) this.dragPreviewRef = node;
                else this.dragPreviewNode = node;
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}

});
parcelRegister("9u1L5", function(module, exports) {

$parcel$export(module.exports, "shallowEqual", function () { return $6e784797409116c5$export$d36bdfa510afb180; });
function $6e784797409116c5$export$d36bdfa510afb180(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}

});

parcelRegister("jvtfw", function(module, exports) {

$parcel$export(module.exports, "isRef", function () { return $e33799e1a592dd91$export$4f9f5282de18fc69; });
function $e33799e1a592dd91$export$4f9f5282de18fc69(obj) {
    return obj !== null && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, "current");
}

});

parcelRegister("8nhMz", function(module, exports) {

$parcel$export(module.exports, "wrapConnectorHooks", function () { return $618e43eabd27623c$export$d8dcaf80ab4f6cb7; });

var $rwcxx = parcelRequire("rwcxx");

var $3QbnI = parcelRequire("3QbnI");
function $618e43eabd27623c$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === "string") return;
    const displayName = element.type.displayName || element.type.name || "the component";
    throw new Error("Only native element nodes can now be passed to React DnD connectors." + `You can either wrap ${displayName} into a <div>, or turn it into a ` + "drag source or a drop target itself.");
}
function $618e43eabd27623c$var$wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!(0, $3QbnI.isValidElement)(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        $618e43eabd27623c$var$throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options) : hook;
        return $618e43eabd27623c$var$cloneWithRef(element, ref);
    };
}
function $618e43eabd27623c$export$d8dcaf80ab4f6cb7(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith("Ref")) wrappedHooks[key] = hooks[key];
        else {
            const wrappedHook = $618e43eabd27623c$var$wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook;
        }
    });
    return wrappedHooks;
}
function $618e43eabd27623c$var$setRef(ref, node) {
    if (typeof ref === "function") ref(node);
    else ref.current = node;
}
function $618e43eabd27623c$var$cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    (0, $rwcxx.invariant)(typeof previousRef !== "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $3QbnI.cloneElement)(element, {
        ref: newRef
    });
    else return (0, $3QbnI.cloneElement)(element, {
        ref: (node)=>{
            $618e43eabd27623c$var$setRef(previousRef, node);
            $618e43eabd27623c$var$setRef(newRef, node);
        }
    });
}

});


parcelRegister("jkdsW", function(module, exports) {

$parcel$export(module.exports, "useDragDropManager", function () { return $e11a549fe5751fa8$export$49db7e1a057ab0fa; });

var $rwcxx = parcelRequire("rwcxx");

var $3QbnI = parcelRequire("3QbnI");

var $h8sf9 = parcelRequire("h8sf9");
function $e11a549fe5751fa8$export$49db7e1a057ab0fa() {
    const { dragDropManager: dragDropManager } = (0, $3QbnI.useContext)((0, $h8sf9.DndContext));
    (0, $rwcxx.invariant)(dragDropManager != null, "Expected drag drop context");
    return dragDropManager;
}

});
parcelRegister("h8sf9", function(module, exports) {

$parcel$export(module.exports, "DndContext", function () { return $c799179282de76aa$export$2d5c5ceac203fc1e; });

var $3QbnI = parcelRequire("3QbnI");
const $c799179282de76aa$export$2d5c5ceac203fc1e = (0, $3QbnI.createContext)({
    dragDropManager: undefined
});

});



parcelRegister("8bIXp", function(module, exports) {

$parcel$export(module.exports, "useDragSourceMonitor", function () { return $0189d7a2a039875a$export$82f95eab323fcd7a; });

var $3QbnI = parcelRequire("3QbnI");

var $iD78c = parcelRequire("iD78c");

var $jkdsW = parcelRequire("jkdsW");
function $0189d7a2a039875a$export$82f95eab323fcd7a() {
    const manager = (0, $jkdsW.useDragDropManager)();
    return (0, $3QbnI.useMemo)(()=>new (0, $iD78c.DragSourceMonitorImpl)(manager), [
        manager
    ]);
}

});
parcelRegister("iD78c", function(module, exports) {

$parcel$export(module.exports, "DragSourceMonitorImpl", function () { return $d901669e375810c8$export$af934094fb48ddf; });

var $rwcxx = parcelRequire("rwcxx");
let $d901669e375810c8$var$isCallingCanDrag = false;
let $d901669e375810c8$var$isCallingIsDragging = false;
class $d901669e375810c8$export$af934094fb48ddf {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        (0, $rwcxx.invariant)(!$d901669e375810c8$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $d901669e375810c8$var$isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            $d901669e375810c8$var$isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) return false;
        (0, $rwcxx.invariant)(!$d901669e375810c8$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $d901669e375810c8$var$isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            $d901669e375810c8$var$isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}

});


parcelRegister("b07x1", function(module, exports) {

$parcel$export(module.exports, "useRegisteredDragSource", function () { return $8025896fdae6ed0b$export$1bdd19ff5ac2e03c; });

var $4GMxP = parcelRequire("4GMxP");

var $jkdsW = parcelRequire("jkdsW");

var $23Wqq = parcelRequire("23Wqq");

var $92URR = parcelRequire("92URR");

var $86MJi = parcelRequire("86MJi");
function $8025896fdae6ed0b$export$1bdd19ff5ac2e03c(spec, monitor, connector) {
    const manager = (0, $jkdsW.useDragDropManager)();
    const handler = (0, $92URR.useDragSource)(spec, monitor, connector);
    const itemType = (0, $86MJi.useDragType)(spec);
    (0, $23Wqq.useIsomorphicLayoutEffect)(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = (0, $4GMxP.registerSource)(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}

});
parcelRegister("4GMxP", function(module, exports) {

$parcel$export(module.exports, "registerTarget", function () { return $36a0bd994ec74405$export$38b18180ae58b09b; });
$parcel$export(module.exports, "registerSource", function () { return $36a0bd994ec74405$export$51c814b9e17958c; });
function $36a0bd994ec74405$export$38b18180ae58b09b(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function $36a0bd994ec74405$export$51c814b9e17958c(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}

});

parcelRegister("92URR", function(module, exports) {

$parcel$export(module.exports, "useDragSource", function () { return $696069b2176fb640$export$cdddb20adb7aad5c; });

var $3QbnI = parcelRequire("3QbnI");

var $ji9WL = parcelRequire("ji9WL");
function $696069b2176fb640$export$cdddb20adb7aad5c(spec, monitor, connector) {
    const handler = (0, $3QbnI.useMemo)(()=>new (0, $ji9WL.DragSourceImpl)(spec, monitor, connector), [
        monitor,
        connector
    ]);
    (0, $3QbnI.useEffect)(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}

});
parcelRegister("ji9WL", function(module, exports) {

$parcel$export(module.exports, "DragSourceImpl", function () { return $e0b769fa1f98f9ad$export$680f0a3c92f9d645; });
class $e0b769fa1f98f9ad$export$680f0a3c92f9d645 {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === "object") result = spec.item;
        else if (typeof spec.item === "function") result = spec.item(monitor);
        else result = {};
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === "boolean") return spec.canDrag;
        else if (typeof spec.canDrag === "function") return spec.canDrag(monitor);
        else return true;
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging: isDragging } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end: end } = spec;
        if (end) end(monitor.getItem(), monitor);
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}

});


parcelRegister("86MJi", function(module, exports) {

$parcel$export(module.exports, "useDragType", function () { return $5e74aef02b9c0899$export$dec3a5d742510a3f; });

var $rwcxx = parcelRequire("rwcxx");

var $3QbnI = parcelRequire("3QbnI");
function $5e74aef02b9c0899$export$dec3a5d742510a3f(spec) {
    return (0, $3QbnI.useMemo)(()=>{
        const result = spec.type;
        (0, $rwcxx.invariant)(result != null, "spec.type must be defined");
        return result;
    }, [
        spec
    ]);
}

});



parcelRegister("fM90j", function(module, exports) {

$parcel$export(module.exports, "useDrop", function () { return $b7c252bb9842970a$export$ccdee5eaf73cf661; });

var $1nHeE = parcelRequire("1nHeE");

var $geR43 = parcelRequire("geR43");

var $4M8Mz = parcelRequire("4M8Mz");

var $j0dE2 = parcelRequire("j0dE2");

var $egc6Y = parcelRequire("egc6Y");

var $cqITg = parcelRequire("cqITg");
function $b7c252bb9842970a$export$ccdee5eaf73cf661(specArg, deps) {
    const spec = (0, $geR43.useOptionalFactory)(specArg, deps);
    const monitor = (0, $egc6Y.useDropTargetMonitor)();
    const connector = (0, $j0dE2.useDropTargetConnector)(spec.options);
    (0, $cqITg.useRegisteredDropTarget)(spec, monitor, connector);
    return [
        (0, $1nHeE.useCollectedProps)(spec.collect, monitor, connector),
        (0, $4M8Mz.useConnectDropTarget)(connector)
    ];
}

});
parcelRegister("4M8Mz", function(module, exports) {

$parcel$export(module.exports, "useConnectDropTarget", function () { return $37a2752349f27bb6$export$c914595a34b9504a; });

var $3QbnI = parcelRequire("3QbnI");
function $37a2752349f27bb6$export$c914595a34b9504a(connector) {
    return (0, $3QbnI.useMemo)(()=>connector.hooks.dropTarget(), [
        connector
    ]);
}

});

parcelRegister("j0dE2", function(module, exports) {

$parcel$export(module.exports, "useDropTargetConnector", function () { return $dd5899fc96048ec2$export$29242ded1aad6df7; });

var $3QbnI = parcelRequire("3QbnI");

var $h9rQR = parcelRequire("h9rQR");

var $jkdsW = parcelRequire("jkdsW");

var $23Wqq = parcelRequire("23Wqq");
function $dd5899fc96048ec2$export$29242ded1aad6df7(options) {
    const manager = (0, $jkdsW.useDragDropManager)();
    const connector = (0, $3QbnI.useMemo)(()=>new (0, $h9rQR.TargetConnector)(manager.getBackend()), [
        manager
    ]);
    (0, $23Wqq.useIsomorphicLayoutEffect)(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget();
    }, [
        options
    ]);
    return connector;
}

});
parcelRegister("h9rQR", function(module, exports) {

$parcel$export(module.exports, "TargetConnector", function () { return $c7c8e1a947f55882$export$ed6d7b7bc55193cf; });

var $9u1L5 = parcelRequire("9u1L5");

var $jvtfw = parcelRequire("jvtfw");

var $8nhMz = parcelRequire("8nhMz");
class $c7c8e1a947f55882$export$ed6d7b7bc55193cf {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) this.disconnectDropTarget();
        const dropTarget = this.dropTarget;
        if (!this.handlerId) return;
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !(0, $9u1L5.shallowEqual)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = (0, $8nhMz.wrapConnectorHooks)({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if ((0, $jvtfw.isRef)(node)) this.dropTargetRef = node;
                else this.dropTargetNode = node;
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}

});


parcelRegister("egc6Y", function(module, exports) {

$parcel$export(module.exports, "useDropTargetMonitor", function () { return $a61bf46a5877445b$export$f0c0ad05844dec3b; });

var $3QbnI = parcelRequire("3QbnI");

var $lCeQj = parcelRequire("lCeQj");

var $jkdsW = parcelRequire("jkdsW");
function $a61bf46a5877445b$export$f0c0ad05844dec3b() {
    const manager = (0, $jkdsW.useDragDropManager)();
    return (0, $3QbnI.useMemo)(()=>new (0, $lCeQj.DropTargetMonitorImpl)(manager), [
        manager
    ]);
}

});
parcelRegister("lCeQj", function(module, exports) {

$parcel$export(module.exports, "DropTargetMonitorImpl", function () { return $fbc8a9051b3720b2$export$9fe8834769ae8ddf; });

var $rwcxx = parcelRequire("rwcxx");
let $fbc8a9051b3720b2$var$isCallingCanDrop = false;
class $fbc8a9051b3720b2$export$9fe8834769ae8ddf {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) return false;
        (0, $rwcxx.invariant)(!$fbc8a9051b3720b2$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
        try {
            $fbc8a9051b3720b2$var$isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            $fbc8a9051b3720b2$var$isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) return false;
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}

});


parcelRegister("cqITg", function(module, exports) {

$parcel$export(module.exports, "useRegisteredDropTarget", function () { return $90cabc0a86c44fdf$export$b31a008bfacf9de1; });

var $4GMxP = parcelRequire("4GMxP");

var $jkdsW = parcelRequire("jkdsW");

var $23Wqq = parcelRequire("23Wqq");

var $69IDN = parcelRequire("69IDN");

var $ih497 = parcelRequire("ih497");
function $90cabc0a86c44fdf$export$b31a008bfacf9de1(spec, monitor, connector) {
    const manager = (0, $jkdsW.useDragDropManager)();
    const dropTarget = (0, $ih497.useDropTarget)(spec, monitor);
    const accept = (0, $69IDN.useAccept)(spec);
    (0, $23Wqq.useIsomorphicLayoutEffect)(function registerDropTarget() {
        const [handlerId, unregister] = (0, $4GMxP.registerTarget)(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()).join("|")
    ]);
}

});
parcelRegister("69IDN", function(module, exports) {

$parcel$export(module.exports, "useAccept", function () { return $47b6361b30dc3330$export$2a5cc7f0ac8651d0; });

var $rwcxx = parcelRequire("rwcxx");

var $3QbnI = parcelRequire("3QbnI");
function $47b6361b30dc3330$export$2a5cc7f0ac8651d0(spec) {
    const { accept: accept } = spec;
    return (0, $3QbnI.useMemo)(()=>{
        (0, $rwcxx.invariant)(spec.accept != null, "accept must be defined");
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}

});

parcelRegister("ih497", function(module, exports) {

$parcel$export(module.exports, "useDropTarget", function () { return $d4dd07d3b52f9acf$export$5967d4bb72ce3c0; });

var $3QbnI = parcelRequire("3QbnI");

var $8wcub = parcelRequire("8wcub");
function $d4dd07d3b52f9acf$export$5967d4bb72ce3c0(spec, monitor) {
    const dropTarget = (0, $3QbnI.useMemo)(()=>new (0, $8wcub.DropTargetImpl)(spec, monitor), [
        monitor
    ]);
    (0, $3QbnI.useEffect)(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}

});
parcelRegister("8wcub", function(module, exports) {

$parcel$export(module.exports, "DropTargetImpl", function () { return $633aff4f8260007f$export$f26a17703f5cb233; });
class $633aff4f8260007f$export$f26a17703f5cb233 {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) spec.hover(monitor.getItem(), monitor);
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) return spec.drop(monitor.getItem(), monitor);
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}

});




parcelRegister("iWuDm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildRegExpFromDelimiters = $dca568032f61f025$var$buildRegExpFromDelimiters;
module.exports.canDrag = $dca568032f61f025$var$canDrag;
module.exports.canDrop = $dca568032f61f025$var$canDrop;

var $dca568032f61f025$var$_escapeRegExp = $dca568032f61f025$var$_interopRequireDefault((parcelRequire("8SaUx")));
function $dca568032f61f025$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Convert an array of delimiter characters into a regular expression
 * that can be used to split content by those delimiters.
 * @param {Array<char>} delimiters Array of characters to turn into a regex
 * @returns {RegExp} Regular expression
 */ function $dca568032f61f025$var$buildRegExpFromDelimiters(delimiters) {
    var delimiterChars = delimiters.map(function(delimiter) {
        // See: http://stackoverflow.com/a/34711175/1463681
        var chrCode = delimiter - 48 * Math.floor(delimiter / 48);
        return String.fromCharCode(96 <= delimiter ? chrCode : delimiter);
    }).join("");
    var escapedDelimiterChars = (0, $dca568032f61f025$var$_escapeRegExp["default"])(delimiterChars);
    return new RegExp("[".concat(escapedDelimiterChars, "]+"));
}
/**
 * Returns true when the tag is drag enabled
 * @param {object} params props of the tag element
 * @returns {boolean} true/false
 * The three different properties which controls this function are moveTag, readOnly and allowDragDrop.
 */ function $dca568032f61f025$var$canDrag(params) {
    var moveTag = params.moveTag, readOnly = params.readOnly, allowDragDrop = params.allowDragDrop;
    return moveTag !== undefined && !readOnly && allowDragDrop;
}
/**
 * Returns true when the tag is drop enabled
 * @param {object} params props of the tag element
 * @returns {boolean} true/false
 * The two different properties which controls this function are readOnly and allowDragDrop.
 */ function $dca568032f61f025$var$canDrop(params) {
    var readOnly = params.readOnly, allowDragDrop = params.allowDragDrop;
    return !readOnly && allowDragDrop;
}

});
parcelRegister("8SaUx", function(module, exports) {

var $8cwsH = parcelRequire("8cwsH");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $675bd493069d675e$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $675bd493069d675e$var$reHasRegExpChar = RegExp($675bd493069d675e$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $675bd493069d675e$var$escapeRegExp(string) {
    string = $8cwsH(string);
    return string && $675bd493069d675e$var$reHasRegExpChar.test(string) ? string.replace($675bd493069d675e$var$reRegExpChar, "\\$&") : string;
}
module.exports = $675bd493069d675e$var$escapeRegExp;

});


parcelRegister("hIrdR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ce5ba9918c41a845$var$_react = $ce5ba9918c41a845$var$_interopRequireDefault((parcelRequire("3QbnI")));

var $ce5ba9918c41a845$var$_propTypes = $ce5ba9918c41a845$var$_interopRequireDefault((parcelRequire("bZSVP")));

var $g21To = parcelRequire("g21To");
function $ce5ba9918c41a845$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $ce5ba9918c41a845$var$crossStr = String.fromCharCode(215);
var $ce5ba9918c41a845$var$RemoveComponent = function RemoveComponent(props) {
    var readOnly = props.readOnly, removeComponent = props.removeComponent, onRemove = props.onRemove, className = props.className, tag = props.tag, index = props.index;
    var onKeydown = function onKeydown(event) {
        if ($g21To.KEYS.ENTER.includes(event.keyCode) || event.keyCode === $g21To.KEYS.SPACE) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        if (event.keyCode === $g21To.KEYS.BACKSPACE) onRemove(event);
    };
    if (readOnly) return /*#__PURE__*/ $ce5ba9918c41a845$var$_react["default"].createElement("span", null);
    var ariaLabel = "Tag at index ".concat(index, " with value ").concat(tag.id, " focussed. Press backspace to remove");
    if (removeComponent) {
        var Component = removeComponent;
        return /*#__PURE__*/ $ce5ba9918c41a845$var$_react["default"].createElement(Component, {
            onRemove: onRemove,
            onKeyDown: onKeydown,
            className: className,
            "aria-label": ariaLabel,
            tag: tag,
            index: index
        });
    }
    return /*#__PURE__*/ $ce5ba9918c41a845$var$_react["default"].createElement("button", {
        onClick: onRemove,
        onKeyDown: onKeydown,
        className: className,
        type: "button",
        "aria-label": ariaLabel
    }, $ce5ba9918c41a845$var$crossStr);
};
$ce5ba9918c41a845$var$RemoveComponent.propTypes = {
    className: $ce5ba9918c41a845$var$_propTypes["default"].string,
    onRemove: $ce5ba9918c41a845$var$_propTypes["default"].func.isRequired,
    readOnly: $ce5ba9918c41a845$var$_propTypes["default"].bool,
    removeComponent: $ce5ba9918c41a845$var$_propTypes["default"].func,
    tag: $ce5ba9918c41a845$var$_propTypes["default"].shape({
        id: $ce5ba9918c41a845$var$_propTypes["default"].string.isRequired,
        className: $ce5ba9918c41a845$var$_propTypes["default"].string,
        key: $ce5ba9918c41a845$var$_propTypes["default"].string
    }),
    index: $ce5ba9918c41a845$var$_propTypes["default"].number.isRequired
};
var $ce5ba9918c41a845$var$_default = module.exports["default"] = $ce5ba9918c41a845$var$RemoveComponent;

});
parcelRegister("g21To", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KEYS = module.exports.INPUT_FIELD_POSITIONS = module.exports.ERRORS = module.exports.DEFAULT_PLACEHOLDER = module.exports.DEFAULT_LABEL_FIELD = module.exports.DEFAULT_CLASSNAMES = void 0;
var $babe4d0d2c2888eb$var$KEYS = module.exports.KEYS = {
    ENTER: [
        10,
        13
    ],
    TAB: 9,
    BACKSPACE: 8,
    UP_ARROW: 38,
    DOWN_ARROW: 40,
    ESCAPE: 27,
    SPACE: 32,
    COMMA: 188
};
var $babe4d0d2c2888eb$var$DEFAULT_PLACEHOLDER = module.exports.DEFAULT_PLACEHOLDER = "Press enter to add new tag";
var $babe4d0d2c2888eb$var$DEFAULT_LABEL_FIELD = module.exports.DEFAULT_LABEL_FIELD = "text";
var $babe4d0d2c2888eb$var$DEFAULT_CLASSNAMES = module.exports.DEFAULT_CLASSNAMES = {
    tags: "ReactTags__tags",
    tagInput: "ReactTags__tagInput",
    tagInputField: "ReactTags__tagInputField",
    selected: "ReactTags__selected",
    tag: "ReactTags__tag",
    remove: "ReactTags__remove",
    suggestions: "ReactTags__suggestions",
    activeSuggestion: "ReactTags__activeSuggestion",
    editTagInput: "ReactTags__editTagInput",
    editTagInputField: "ReactTags__editTagInputField",
    clearAll: "ReactTags__clearAll"
};
var $babe4d0d2c2888eb$var$INPUT_FIELD_POSITIONS = module.exports.INPUT_FIELD_POSITIONS = {
    INLINE: "inline",
    TOP: "top",
    BOTTOM: "bottom"
};
var $babe4d0d2c2888eb$var$ERRORS = module.exports.ERRORS = {
    TAG_LIMIT: "Tag limit reached!"
};

});



parcelRegister("9wden", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.useSpeechRecognition = void 0;

var $3QbnI = parcelRequire("3QbnI");

var $9OCAx = parcelRequire("9OCAx");

var $WQYlD = parcelRequire("WQYlD");

var $hGGql = parcelRequire("hGGql");

var $6ee15d94b48ee2b8$var$_RecognitionManager = $6ee15d94b48ee2b8$var$_interopRequireDefault((parcelRequire("l2NA4")));

var $6ee15d94b48ee2b8$var$_isAndroid = $6ee15d94b48ee2b8$var$_interopRequireDefault((parcelRequire("hL7HH")));

var $6ee15d94b48ee2b8$var$_NativeSpeechRecognition = $6ee15d94b48ee2b8$var$_interopRequireDefault((parcelRequire("lPhmF")));
function $6ee15d94b48ee2b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6ee15d94b48ee2b8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $6ee15d94b48ee2b8$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $6ee15d94b48ee2b8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $6ee15d94b48ee2b8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $6ee15d94b48ee2b8$var$_toConsumableArray(arr) {
    return $6ee15d94b48ee2b8$var$_arrayWithoutHoles(arr) || $6ee15d94b48ee2b8$var$_iterableToArray(arr) || $6ee15d94b48ee2b8$var$_unsupportedIterableToArray(arr) || $6ee15d94b48ee2b8$var$_nonIterableSpread();
}
function $6ee15d94b48ee2b8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6ee15d94b48ee2b8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $6ee15d94b48ee2b8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6ee15d94b48ee2b8$var$_arrayLikeToArray(arr);
}
function $6ee15d94b48ee2b8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6ee15d94b48ee2b8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6ee15d94b48ee2b8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6ee15d94b48ee2b8$var$_typeof(obj);
}
function $6ee15d94b48ee2b8$var$_slicedToArray(arr, i) {
    return $6ee15d94b48ee2b8$var$_arrayWithHoles(arr) || $6ee15d94b48ee2b8$var$_iterableToArrayLimit(arr, i) || $6ee15d94b48ee2b8$var$_unsupportedIterableToArray(arr, i) || $6ee15d94b48ee2b8$var$_nonIterableRest();
}
function $6ee15d94b48ee2b8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6ee15d94b48ee2b8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6ee15d94b48ee2b8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6ee15d94b48ee2b8$var$_arrayLikeToArray(o, minLen);
}
function $6ee15d94b48ee2b8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6ee15d94b48ee2b8$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6ee15d94b48ee2b8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $6ee15d94b48ee2b8$var$_browserSupportsSpeechRecognition = !!$6ee15d94b48ee2b8$var$_NativeSpeechRecognition["default"];
var $6ee15d94b48ee2b8$var$_browserSupportsContinuousListening = $6ee15d94b48ee2b8$var$_browserSupportsSpeechRecognition && !(0, $6ee15d94b48ee2b8$var$_isAndroid["default"])();
var $6ee15d94b48ee2b8$var$recognitionManager;
var $6ee15d94b48ee2b8$var$useSpeechRecognition = function useSpeechRecognition() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$transcribing = _ref.transcribing, transcribing = _ref$transcribing === void 0 ? true : _ref$transcribing, _ref$clearTranscriptO = _ref.clearTranscriptOnListen, clearTranscriptOnListen = _ref$clearTranscriptO === void 0 ? true : _ref$clearTranscriptO, _ref$commands = _ref.commands, commands = _ref$commands === void 0 ? [] : _ref$commands;
    var _useState = (0, $3QbnI.useState)($6ee15d94b48ee2b8$var$SpeechRecognition.getRecognitionManager()), _useState2 = $6ee15d94b48ee2b8$var$_slicedToArray(_useState, 1), recognitionManager = _useState2[0];
    var _useState3 = (0, $3QbnI.useState)($6ee15d94b48ee2b8$var$_browserSupportsSpeechRecognition), _useState4 = $6ee15d94b48ee2b8$var$_slicedToArray(_useState3, 2), browserSupportsSpeechRecognition = _useState4[0], setBrowserSupportsSpeechRecognition = _useState4[1];
    var _useState5 = (0, $3QbnI.useState)($6ee15d94b48ee2b8$var$_browserSupportsContinuousListening), _useState6 = $6ee15d94b48ee2b8$var$_slicedToArray(_useState5, 2), browserSupportsContinuousListening = _useState6[0], setBrowserSupportsContinuousListening = _useState6[1];
    var _useReducer = (0, $3QbnI.useReducer)($hGGql.transcriptReducer, {
        interimTranscript: recognitionManager.interimTranscript,
        finalTranscript: ""
    }), _useReducer2 = $6ee15d94b48ee2b8$var$_slicedToArray(_useReducer, 2), _useReducer2$ = _useReducer2[0], interimTranscript = _useReducer2$.interimTranscript, finalTranscript = _useReducer2$.finalTranscript, dispatch = _useReducer2[1];
    var _useState7 = (0, $3QbnI.useState)(recognitionManager.listening), _useState8 = $6ee15d94b48ee2b8$var$_slicedToArray(_useState7, 2), listening = _useState8[0], setListening = _useState8[1];
    var _useState9 = (0, $3QbnI.useState)(recognitionManager.isMicrophoneAvailable), _useState10 = $6ee15d94b48ee2b8$var$_slicedToArray(_useState9, 2), isMicrophoneAvailable = _useState10[0], setMicrophoneAvailable = _useState10[1];
    var commandsRef = (0, $3QbnI.useRef)(commands);
    commandsRef.current = commands;
    var dispatchClearTranscript = function dispatchClearTranscript() {
        dispatch((0, $WQYlD.clearTranscript)());
    };
    var resetTranscript = (0, $3QbnI.useCallback)(function() {
        recognitionManager.resetTranscript();
        dispatchClearTranscript();
    }, [
        recognitionManager
    ]);
    var testFuzzyMatch = function testFuzzyMatch(command, input, fuzzyMatchingThreshold) {
        var commandToString = $6ee15d94b48ee2b8$var$_typeof(command) === "object" ? command.toString() : command;
        var commandWithoutSpecials = commandToString.replace(/[&/\\#,+()!$~%.'":*?<>{}]/g, "").replace(/  +/g, " ").trim();
        var howSimilar = (0, $9OCAx.compareTwoStringsUsingDiceCoefficient)(commandWithoutSpecials, input);
        if (howSimilar >= fuzzyMatchingThreshold) return {
            command: command,
            commandWithoutSpecials: commandWithoutSpecials,
            howSimilar: howSimilar,
            isFuzzyMatch: true
        };
        return null;
    };
    var testMatch = function testMatch(command, input) {
        var pattern = (0, $9OCAx.commandToRegExp)(command);
        var result = pattern.exec(input);
        if (result) return {
            command: command,
            parameters: result.slice(1)
        };
        return null;
    };
    var matchCommands = (0, $3QbnI.useCallback)(function(newInterimTranscript, newFinalTranscript) {
        commandsRef.current.forEach(function(_ref2) {
            var command = _ref2.command, callback = _ref2.callback, _ref2$matchInterim = _ref2.matchInterim, matchInterim = _ref2$matchInterim === void 0 ? false : _ref2$matchInterim, _ref2$isFuzzyMatch = _ref2.isFuzzyMatch, isFuzzyMatch = _ref2$isFuzzyMatch === void 0 ? false : _ref2$isFuzzyMatch, _ref2$fuzzyMatchingTh = _ref2.fuzzyMatchingThreshold, fuzzyMatchingThreshold = _ref2$fuzzyMatchingTh === void 0 ? 0.8 : _ref2$fuzzyMatchingTh, _ref2$bestMatchOnly = _ref2.bestMatchOnly, bestMatchOnly = _ref2$bestMatchOnly === void 0 ? false : _ref2$bestMatchOnly;
            var input = !newFinalTranscript && matchInterim ? newInterimTranscript.trim() : newFinalTranscript.trim();
            var subcommands = Array.isArray(command) ? command : [
                command
            ];
            var results = subcommands.map(function(subcommand) {
                if (isFuzzyMatch) return testFuzzyMatch(subcommand, input, fuzzyMatchingThreshold);
                return testMatch(subcommand, input);
            }).filter(function(x) {
                return x;
            });
            if (isFuzzyMatch && bestMatchOnly && results.length >= 2) {
                results.sort(function(a, b) {
                    return b.howSimilar - a.howSimilar;
                });
                var _results$ = results[0], _command = _results$.command, commandWithoutSpecials = _results$.commandWithoutSpecials, howSimilar = _results$.howSimilar;
                callback(commandWithoutSpecials, input, howSimilar, {
                    command: _command,
                    resetTranscript: resetTranscript
                });
            } else results.forEach(function(result) {
                if (result.isFuzzyMatch) {
                    var _command2 = result.command, _commandWithoutSpecials = result.commandWithoutSpecials, _howSimilar = result.howSimilar;
                    callback(_commandWithoutSpecials, input, _howSimilar, {
                        command: _command2,
                        resetTranscript: resetTranscript
                    });
                } else {
                    var _command3 = result.command, parameters = result.parameters;
                    callback.apply(void 0, $6ee15d94b48ee2b8$var$_toConsumableArray(parameters).concat([
                        {
                            command: _command3,
                            resetTranscript: resetTranscript
                        }
                    ]));
                }
            });
        });
    }, [
        resetTranscript
    ]);
    var handleTranscriptChange = (0, $3QbnI.useCallback)(function(newInterimTranscript, newFinalTranscript) {
        if (transcribing) dispatch((0, $WQYlD.appendTranscript)(newInterimTranscript, newFinalTranscript));
        matchCommands(newInterimTranscript, newFinalTranscript);
    }, [
        matchCommands,
        transcribing
    ]);
    var handleClearTranscript = (0, $3QbnI.useCallback)(function() {
        if (clearTranscriptOnListen) dispatchClearTranscript();
    }, [
        clearTranscriptOnListen
    ]);
    (0, $3QbnI.useEffect)(function() {
        var id = $6ee15d94b48ee2b8$var$SpeechRecognition.counter;
        $6ee15d94b48ee2b8$var$SpeechRecognition.counter += 1;
        var callbacks = {
            onListeningChange: setListening,
            onMicrophoneAvailabilityChange: setMicrophoneAvailable,
            onTranscriptChange: handleTranscriptChange,
            onClearTranscript: handleClearTranscript,
            onBrowserSupportsSpeechRecognitionChange: setBrowserSupportsSpeechRecognition,
            onBrowserSupportsContinuousListeningChange: setBrowserSupportsContinuousListening
        };
        recognitionManager.subscribe(id, callbacks);
        return function() {
            recognitionManager.unsubscribe(id);
        };
    }, [
        transcribing,
        clearTranscriptOnListen,
        recognitionManager,
        handleTranscriptChange,
        handleClearTranscript
    ]);
    var transcript = (0, $9OCAx.concatTranscripts)(finalTranscript, interimTranscript);
    return {
        transcript: transcript,
        interimTranscript: interimTranscript,
        finalTranscript: finalTranscript,
        listening: listening,
        isMicrophoneAvailable: isMicrophoneAvailable,
        resetTranscript: resetTranscript,
        browserSupportsSpeechRecognition: browserSupportsSpeechRecognition,
        browserSupportsContinuousListening: browserSupportsContinuousListening
    };
};
module.exports.useSpeechRecognition = $6ee15d94b48ee2b8$var$useSpeechRecognition;
var $6ee15d94b48ee2b8$var$SpeechRecognition = {
    counter: 0,
    applyPolyfill: function applyPolyfill(PolyfillSpeechRecognition) {
        if ($6ee15d94b48ee2b8$var$recognitionManager) $6ee15d94b48ee2b8$var$recognitionManager.setSpeechRecognition(PolyfillSpeechRecognition);
        else $6ee15d94b48ee2b8$var$recognitionManager = new $6ee15d94b48ee2b8$var$_RecognitionManager["default"](PolyfillSpeechRecognition);
        var browserSupportsPolyfill = !!PolyfillSpeechRecognition && (0, $9OCAx.browserSupportsPolyfills)();
        $6ee15d94b48ee2b8$var$_browserSupportsSpeechRecognition = browserSupportsPolyfill;
        $6ee15d94b48ee2b8$var$_browserSupportsContinuousListening = browserSupportsPolyfill;
    },
    removePolyfill: function removePolyfill() {
        if ($6ee15d94b48ee2b8$var$recognitionManager) $6ee15d94b48ee2b8$var$recognitionManager.setSpeechRecognition($6ee15d94b48ee2b8$var$_NativeSpeechRecognition["default"]);
        else $6ee15d94b48ee2b8$var$recognitionManager = new $6ee15d94b48ee2b8$var$_RecognitionManager["default"]($6ee15d94b48ee2b8$var$_NativeSpeechRecognition["default"]);
        $6ee15d94b48ee2b8$var$_browserSupportsSpeechRecognition = !!$6ee15d94b48ee2b8$var$_NativeSpeechRecognition["default"];
        $6ee15d94b48ee2b8$var$_browserSupportsContinuousListening = $6ee15d94b48ee2b8$var$_browserSupportsSpeechRecognition && !(0, $6ee15d94b48ee2b8$var$_isAndroid["default"])();
    },
    getRecognitionManager: function getRecognitionManager() {
        if (!$6ee15d94b48ee2b8$var$recognitionManager) $6ee15d94b48ee2b8$var$recognitionManager = new $6ee15d94b48ee2b8$var$_RecognitionManager["default"]($6ee15d94b48ee2b8$var$_NativeSpeechRecognition["default"]);
        return $6ee15d94b48ee2b8$var$recognitionManager;
    },
    getRecognition: function getRecognition() {
        var recognitionManager = $6ee15d94b48ee2b8$var$SpeechRecognition.getRecognitionManager();
        return recognitionManager.getRecognition();
    },
    startListening: function() {
        var _startListening = $6ee15d94b48ee2b8$var$_asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
            var _ref3, continuous, language, recognitionManager, _args = arguments;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _ref3 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, continuous = _ref3.continuous, language = _ref3.language;
                        recognitionManager = $6ee15d94b48ee2b8$var$SpeechRecognition.getRecognitionManager();
                        _context.next = 4;
                        return recognitionManager.startListening({
                            continuous: continuous,
                            language: language
                        });
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        function startListening() {
            return _startListening.apply(this, arguments);
        }
        return startListening;
    }(),
    stopListening: function() {
        var _stopListening = $6ee15d94b48ee2b8$var$_asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee2() {
            var recognitionManager;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        recognitionManager = $6ee15d94b48ee2b8$var$SpeechRecognition.getRecognitionManager();
                        _context2.next = 3;
                        return recognitionManager.stopListening();
                    case 3:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        function stopListening() {
            return _stopListening.apply(this, arguments);
        }
        return stopListening;
    }(),
    abortListening: function() {
        var _abortListening = $6ee15d94b48ee2b8$var$_asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee3() {
            var recognitionManager;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        recognitionManager = $6ee15d94b48ee2b8$var$SpeechRecognition.getRecognitionManager();
                        _context3.next = 3;
                        return recognitionManager.abortListening();
                    case 3:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }));
        function abortListening() {
            return _abortListening.apply(this, arguments);
        }
        return abortListening;
    }(),
    browserSupportsSpeechRecognition: function browserSupportsSpeechRecognition() {
        return $6ee15d94b48ee2b8$var$_browserSupportsSpeechRecognition;
    },
    browserSupportsContinuousListening: function browserSupportsContinuousListening() {
        return $6ee15d94b48ee2b8$var$_browserSupportsContinuousListening;
    }
};
var $6ee15d94b48ee2b8$var$_default = $6ee15d94b48ee2b8$var$SpeechRecognition;
module.exports["default"] = $6ee15d94b48ee2b8$var$_default;

});
parcelRegister("9OCAx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserSupportsPolyfills = module.exports.compareTwoStringsUsingDiceCoefficient = module.exports.commandToRegExp = module.exports.concatTranscripts = module.exports.debounce = void 0;
var $7256b766bd9e42a2$var$debounce = function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this;
        var args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
module.exports.debounce = $7256b766bd9e42a2$var$debounce;
var $7256b766bd9e42a2$var$concatTranscripts = function concatTranscripts() {
    for(var _len = arguments.length, transcriptParts = new Array(_len), _key = 0; _key < _len; _key++)transcriptParts[_key] = arguments[_key];
    return transcriptParts.map(function(t) {
        return t.trim();
    }).join(" ").trim();
}; // The command matching code is a modified version of Backbone.Router by Jeremy Ashkenas, under the MIT license.
module.exports.concatTranscripts = $7256b766bd9e42a2$var$concatTranscripts;
var $7256b766bd9e42a2$var$optionalParam = /\s*\((.*?)\)\s*/g;
var $7256b766bd9e42a2$var$optionalRegex = /(\(\?:[^)]+\))\?/g;
var $7256b766bd9e42a2$var$namedParam = /(\(\?)?:\w+/g;
var $7256b766bd9e42a2$var$splatParam = /\*/g;
var $7256b766bd9e42a2$var$escapeRegExp = /[-{}[\]+?.,\\^$|#]/g;
var $7256b766bd9e42a2$var$commandToRegExp = function commandToRegExp(command) {
    if (command instanceof RegExp) return new RegExp(command.source, "i");
    command = command.replace($7256b766bd9e42a2$var$escapeRegExp, "\\$&").replace($7256b766bd9e42a2$var$optionalParam, "(?:$1)?").replace($7256b766bd9e42a2$var$namedParam, function(match, optional) {
        return optional ? match : "([^\\s]+)";
    }).replace($7256b766bd9e42a2$var$splatParam, "(.*?)").replace($7256b766bd9e42a2$var$optionalRegex, "\\s*$1?\\s*");
    return new RegExp("^" + command + "$", "i");
}; // this is from https://github.com/aceakash/string-similarity
module.exports.commandToRegExp = $7256b766bd9e42a2$var$commandToRegExp;
var $7256b766bd9e42a2$var$compareTwoStringsUsingDiceCoefficient = function compareTwoStringsUsingDiceCoefficient(first, second) {
    first = first.replace(/\s+/g, "").toLowerCase();
    second = second.replace(/\s+/g, "").toLowerCase();
    if (!first.length && !second.length) return 1; // if both are empty strings
    if (!first.length || !second.length) return 0; // if only one is empty string
    if (first === second) return 1; // identical
    if (first.length === 1 && second.length === 1) return 0; // both are 1-letter strings
    if (first.length < 2 || second.length < 2) return 0; // if either is a 1-letter string
    var firstBigrams = new Map();
    for(var i = 0; i < first.length - 1; i++){
        var bigram = first.substring(i, i + 2);
        var count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) + 1 : 1;
        firstBigrams.set(bigram, count);
    }
    var intersectionSize = 0;
    for(var _i = 0; _i < second.length - 1; _i++){
        var _bigram = second.substring(_i, _i + 2);
        var _count = firstBigrams.has(_bigram) ? firstBigrams.get(_bigram) : 0;
        if (_count > 0) {
            firstBigrams.set(_bigram, _count - 1);
            intersectionSize++;
        }
    }
    return 2.0 * intersectionSize / (first.length + second.length - 2);
};
module.exports.compareTwoStringsUsingDiceCoefficient = $7256b766bd9e42a2$var$compareTwoStringsUsingDiceCoefficient;
var $7256b766bd9e42a2$var$browserSupportsPolyfills = function browserSupportsPolyfills() {
    return typeof window !== "undefined" && window.navigator !== undefined && window.navigator.mediaDevices !== undefined && window.navigator.mediaDevices.getUserMedia !== undefined && (window.AudioContext !== undefined || window.webkitAudioContext !== undefined);
};
module.exports.browserSupportsPolyfills = $7256b766bd9e42a2$var$browserSupportsPolyfills;

});

parcelRegister("WQYlD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.appendTranscript = module.exports.clearTranscript = void 0;

var $bQJhd = parcelRequire("bQJhd");
var $0b0e8219afef5c03$var$clearTranscript = function clearTranscript() {
    return {
        type: $bQJhd.CLEAR_TRANSCRIPT
    };
};
module.exports.clearTranscript = $0b0e8219afef5c03$var$clearTranscript;
var $0b0e8219afef5c03$var$appendTranscript = function appendTranscript(interimTranscript, finalTranscript) {
    return {
        type: $bQJhd.APPEND_TRANSCRIPT,
        payload: {
            interimTranscript: interimTranscript,
            finalTranscript: finalTranscript
        }
    };
};
module.exports.appendTranscript = $0b0e8219afef5c03$var$appendTranscript;

});
parcelRegister("bQJhd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.APPEND_TRANSCRIPT = module.exports.CLEAR_TRANSCRIPT = void 0;
var $8a07ac06fb62d33f$var$CLEAR_TRANSCRIPT = "CLEAR_TRANSCRIPT";
module.exports.CLEAR_TRANSCRIPT = $8a07ac06fb62d33f$var$CLEAR_TRANSCRIPT;
var $8a07ac06fb62d33f$var$APPEND_TRANSCRIPT = "APPEND_TRANSCRIPT";
module.exports.APPEND_TRANSCRIPT = $8a07ac06fb62d33f$var$APPEND_TRANSCRIPT;

});


parcelRegister("hGGql", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.transcriptReducer = void 0;

var $bQJhd = parcelRequire("bQJhd");

var $9OCAx = parcelRequire("9OCAx");
var $ce07446e511bd326$var$transcriptReducer = function transcriptReducer(state, action) {
    switch(action.type){
        case $bQJhd.CLEAR_TRANSCRIPT:
            return {
                interimTranscript: "",
                finalTranscript: ""
            };
        case $bQJhd.APPEND_TRANSCRIPT:
            return {
                interimTranscript: action.payload.interimTranscript,
                finalTranscript: (0, $9OCAx.concatTranscripts)(state.finalTranscript, action.payload.finalTranscript)
            };
        default:
            throw new Error();
    }
};
module.exports.transcriptReducer = $ce07446e511bd326$var$transcriptReducer;

});

parcelRegister("l2NA4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f5203e9561ca91f5$var$_isAndroid = $f5203e9561ca91f5$var$_interopRequireDefault((parcelRequire("hL7HH")));

var $9OCAx = parcelRequire("9OCAx");

var $lPhmF = parcelRequire("lPhmF");
function $f5203e9561ca91f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f5203e9561ca91f5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $f5203e9561ca91f5$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $f5203e9561ca91f5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $f5203e9561ca91f5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $f5203e9561ca91f5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f5203e9561ca91f5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f5203e9561ca91f5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f5203e9561ca91f5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f5203e9561ca91f5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $f5203e9561ca91f5$var$RecognitionManager = /*#__PURE__*/ function() {
    function RecognitionManager(SpeechRecognition) {
        $f5203e9561ca91f5$var$_classCallCheck(this, RecognitionManager);
        this.recognition = null;
        this.pauseAfterDisconnect = false;
        this.interimTranscript = "";
        this.finalTranscript = "";
        this.listening = false;
        this.isMicrophoneAvailable = true;
        this.subscribers = {};
        this.onStopListening = function() {};
        this.previousResultWasFinalOnly = false;
        this.resetTranscript = this.resetTranscript.bind(this);
        this.startListening = this.startListening.bind(this);
        this.stopListening = this.stopListening.bind(this);
        this.abortListening = this.abortListening.bind(this);
        this.setSpeechRecognition = this.setSpeechRecognition.bind(this);
        this.disableRecognition = this.disableRecognition.bind(this);
        this.setSpeechRecognition(SpeechRecognition);
        if ((0, $f5203e9561ca91f5$var$_isAndroid["default"])()) this.updateFinalTranscript = (0, $9OCAx.debounce)(this.updateFinalTranscript, 250, true);
    }
    $f5203e9561ca91f5$var$_createClass(RecognitionManager, [
        {
            key: "setSpeechRecognition",
            value: function setSpeechRecognition(SpeechRecognition) {
                var browserSupportsRecogniser = !!SpeechRecognition && ((0, $lPhmF.isNative)(SpeechRecognition) || (0, $9OCAx.browserSupportsPolyfills)());
                if (browserSupportsRecogniser) {
                    this.disableRecognition();
                    this.recognition = new SpeechRecognition();
                    this.recognition.continuous = false;
                    this.recognition.interimResults = true;
                    this.recognition.onresult = this.updateTranscript.bind(this);
                    this.recognition.onend = this.onRecognitionDisconnect.bind(this);
                    this.recognition.onerror = this.onError.bind(this);
                }
                this.emitBrowserSupportsSpeechRecognitionChange(browserSupportsRecogniser);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(id, callbacks) {
                this.subscribers[id] = callbacks;
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(id) {
                delete this.subscribers[id];
            }
        },
        {
            key: "emitListeningChange",
            value: function emitListeningChange(listening) {
                var _this = this;
                this.listening = listening;
                Object.keys(this.subscribers).forEach(function(id) {
                    var onListeningChange = _this.subscribers[id].onListeningChange;
                    onListeningChange(listening);
                });
            }
        },
        {
            key: "emitMicrophoneAvailabilityChange",
            value: function emitMicrophoneAvailabilityChange(isMicrophoneAvailable) {
                var _this2 = this;
                this.isMicrophoneAvailable = isMicrophoneAvailable;
                Object.keys(this.subscribers).forEach(function(id) {
                    var onMicrophoneAvailabilityChange = _this2.subscribers[id].onMicrophoneAvailabilityChange;
                    onMicrophoneAvailabilityChange(isMicrophoneAvailable);
                });
            }
        },
        {
            key: "emitTranscriptChange",
            value: function emitTranscriptChange(interimTranscript, finalTranscript) {
                var _this3 = this;
                Object.keys(this.subscribers).forEach(function(id) {
                    var onTranscriptChange = _this3.subscribers[id].onTranscriptChange;
                    onTranscriptChange(interimTranscript, finalTranscript);
                });
            }
        },
        {
            key: "emitClearTranscript",
            value: function emitClearTranscript() {
                var _this4 = this;
                Object.keys(this.subscribers).forEach(function(id) {
                    var onClearTranscript = _this4.subscribers[id].onClearTranscript;
                    onClearTranscript();
                });
            }
        },
        {
            key: "emitBrowserSupportsSpeechRecognitionChange",
            value: function emitBrowserSupportsSpeechRecognitionChange(browserSupportsSpeechRecognitionChange) {
                var _this5 = this;
                Object.keys(this.subscribers).forEach(function(id) {
                    var _this5$subscribers$id = _this5.subscribers[id], onBrowserSupportsSpeechRecognitionChange = _this5$subscribers$id.onBrowserSupportsSpeechRecognitionChange, onBrowserSupportsContinuousListeningChange = _this5$subscribers$id.onBrowserSupportsContinuousListeningChange;
                    onBrowserSupportsSpeechRecognitionChange(browserSupportsSpeechRecognitionChange);
                    onBrowserSupportsContinuousListeningChange(browserSupportsSpeechRecognitionChange);
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect(disconnectType) {
                if (this.recognition && this.listening) switch(disconnectType){
                    case "ABORT":
                        this.pauseAfterDisconnect = true;
                        this.abort();
                        break;
                    case "RESET":
                        this.pauseAfterDisconnect = false;
                        this.abort();
                        break;
                    case "STOP":
                    default:
                        this.pauseAfterDisconnect = true;
                        this.stop();
                }
            }
        },
        {
            key: "disableRecognition",
            value: function disableRecognition() {
                if (this.recognition) {
                    this.recognition.onresult = function() {};
                    this.recognition.onend = function() {};
                    this.recognition.onerror = function() {};
                    if (this.listening) this.stopListening();
                }
            }
        },
        {
            key: "onError",
            value: function onError(event) {
                if (event && event.error && event.error === "not-allowed") {
                    this.emitMicrophoneAvailabilityChange(false);
                    this.disableRecognition();
                }
            }
        },
        {
            key: "onRecognitionDisconnect",
            value: function onRecognitionDisconnect() {
                this.onStopListening();
                this.listening = false;
                if (this.pauseAfterDisconnect) this.emitListeningChange(false);
                else if (this.recognition) {
                    if (this.recognition.continuous) this.startListening({
                        continuous: this.recognition.continuous
                    });
                    else this.emitListeningChange(false);
                }
                this.pauseAfterDisconnect = false;
            }
        },
        {
            key: "updateTranscript",
            value: function updateTranscript(_ref) {
                var results = _ref.results, resultIndex = _ref.resultIndex;
                var currentIndex = resultIndex === undefined ? results.length - 1 : resultIndex;
                this.interimTranscript = "";
                this.finalTranscript = "";
                for(var i = currentIndex; i < results.length; ++i)if (results[i].isFinal && (!(0, $f5203e9561ca91f5$var$_isAndroid["default"])() || results[i][0].confidence > 0)) this.updateFinalTranscript(results[i][0].transcript);
                else this.interimTranscript = (0, $9OCAx.concatTranscripts)(this.interimTranscript, results[i][0].transcript);
                var isDuplicateResult = false;
                if (this.interimTranscript === "" && this.finalTranscript !== "") {
                    if (this.previousResultWasFinalOnly) isDuplicateResult = true;
                    this.previousResultWasFinalOnly = true;
                } else this.previousResultWasFinalOnly = false;
                if (!isDuplicateResult) this.emitTranscriptChange(this.interimTranscript, this.finalTranscript);
            }
        },
        {
            key: "updateFinalTranscript",
            value: function updateFinalTranscript(newFinalTranscript) {
                this.finalTranscript = (0, $9OCAx.concatTranscripts)(this.finalTranscript, newFinalTranscript);
            }
        },
        {
            key: "resetTranscript",
            value: function resetTranscript() {
                this.disconnect("RESET");
            }
        },
        {
            key: "startListening",
            value: function() {
                var _startListening = $f5203e9561ca91f5$var$_asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                    var _ref2, _ref2$continuous, continuous, language, isContinuousChanged, isLanguageChanged, _args = arguments;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$continuous = _ref2.continuous, continuous = _ref2$continuous === void 0 ? false : _ref2$continuous, language = _ref2.language;
                                if (this.recognition) {
                                    _context.next = 3;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 3:
                                isContinuousChanged = continuous !== this.recognition.continuous;
                                isLanguageChanged = language && language !== this.recognition.lang;
                                if (!(isContinuousChanged || isLanguageChanged)) {
                                    _context.next = 11;
                                    break;
                                }
                                if (!this.listening) {
                                    _context.next = 9;
                                    break;
                                }
                                _context.next = 9;
                                return this.stopListening();
                            case 9:
                                this.recognition.continuous = isContinuousChanged ? continuous : this.recognition.continuous;
                                this.recognition.lang = isLanguageChanged ? language : this.recognition.lang;
                            case 11:
                                if (this.listening) {
                                    _context.next = 22;
                                    break;
                                }
                                if (!this.recognition.continuous) {
                                    this.resetTranscript();
                                    this.emitClearTranscript();
                                }
                                _context.prev = 13;
                                _context.next = 16;
                                return this.start();
                            case 16:
                                this.emitListeningChange(true);
                                _context.next = 22;
                                break;
                            case 19:
                                _context.prev = 19;
                                _context.t0 = _context["catch"](13);
                                // DOMExceptions indicate a redundant microphone start - safe to swallow
                                if (!(_context.t0 instanceof DOMException)) this.emitMicrophoneAvailabilityChange(false);
                            case 22:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            13,
                            19
                        ]
                    ]);
                }));
                function startListening() {
                    return _startListening.apply(this, arguments);
                }
                return startListening;
            }()
        },
        {
            key: "abortListening",
            value: function() {
                var _abortListening = $f5203e9561ca91f5$var$_asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee2() {
                    var _this6 = this;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                this.disconnect("ABORT");
                                this.emitListeningChange(false);
                                _context2.next = 4;
                                return new Promise(function(resolve) {
                                    _this6.onStopListening = resolve;
                                });
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function abortListening() {
                    return _abortListening.apply(this, arguments);
                }
                return abortListening;
            }()
        },
        {
            key: "stopListening",
            value: function() {
                var _stopListening = $f5203e9561ca91f5$var$_asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee3() {
                    var _this7 = this;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                this.disconnect("STOP");
                                this.emitListeningChange(false);
                                _context3.next = 4;
                                return new Promise(function(resolve) {
                                    _this7.onStopListening = resolve;
                                });
                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function stopListening() {
                    return _stopListening.apply(this, arguments);
                }
                return stopListening;
            }()
        },
        {
            key: "getRecognition",
            value: function getRecognition() {
                return this.recognition;
            }
        },
        {
            key: "start",
            value: function() {
                var _start = $f5203e9561ca91f5$var$_asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee4() {
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (!(this.recognition && !this.listening)) {
                                    _context4.next = 4;
                                    break;
                                }
                                _context4.next = 3;
                                return this.recognition.start();
                            case 3:
                                this.listening = true;
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function start() {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "stop",
            value: function stop() {
                if (this.recognition && this.listening) {
                    this.recognition.stop();
                    this.listening = false;
                }
            }
        },
        {
            key: "abort",
            value: function abort() {
                if (this.recognition && this.listening) {
                    this.recognition.abort();
                    this.listening = false;
                }
            }
        }
    ]);
    return RecognitionManager;
}();
module.exports["default"] = $f5203e9561ca91f5$var$RecognitionManager;

});
parcelRegister("hL7HH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $cedccd46fb3b6d29$var$_default = function _default() {
    return /(android)/i.test(typeof navigator !== "undefined" ? navigator.userAgent : "");
};
module.exports["default"] = $cedccd46fb3b6d29$var$_default;

});

parcelRegister("lPhmF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.isNative = void 0;
var $fe3bd49ed2884d89$var$NativeSpeechRecognition = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition || window.oSpeechRecognition);
var $fe3bd49ed2884d89$var$isNative = function isNative(SpeechRecognition) {
    return SpeechRecognition === $fe3bd49ed2884d89$var$NativeSpeechRecognition;
};
module.exports.isNative = $fe3bd49ed2884d89$var$isNative;
var $fe3bd49ed2884d89$var$_default = $fe3bd49ed2884d89$var$NativeSpeechRecognition;
module.exports["default"] = $fe3bd49ed2884d89$var$_default;

});



parcelRegister("hnAsU", function(module, exports) {

var $21uqr = parcelRequire("21uqr");
module.exports = $21uqr("4L2KN").then(()=>parcelRequire("5SOGE"));

});
parcelRegister("21uqr", function(module, exports) {
"use strict";

function $179346a5fc142e8d$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("jHPLc")).resolve(id));
}
module.exports = $179346a5fc142e8d$var$load;

});


/* eslint-disable @typescript-eslint/no-unused-vars */ var $a359a61ebad41d43$exports = {};
"use strict";

$a359a61ebad41d43$exports = (parcelRequire("9w4Jx"));



var $3QbnI = parcelRequire("3QbnI");
var $b44a20a3fc7684be$exports = {};

$parcel$export($b44a20a3fc7684be$exports, "createRoot", function () { return $b44a20a3fc7684be$export$882461b6382ed46c; }, function (v) { return $b44a20a3fc7684be$export$882461b6382ed46c = v; });
$parcel$export($b44a20a3fc7684be$exports, "hydrateRoot", function () { return $b44a20a3fc7684be$export$757ceba2d55c277e; }, function (v) { return $b44a20a3fc7684be$export$757ceba2d55c277e = v; });
var $b44a20a3fc7684be$export$882461b6382ed46c;
var $b44a20a3fc7684be$export$757ceba2d55c277e;
"use strict";
var $70c58451959e30b3$exports = {};
"use strict";
function $70c58451959e30b3$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($70c58451959e30b3$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$70c58451959e30b3$var$checkDCE();

$70c58451959e30b3$exports = (parcelRequire("chU0U"));


var $b44a20a3fc7684be$var$i;
$b44a20a3fc7684be$export$882461b6382ed46c = $70c58451959e30b3$exports.createRoot;
$b44a20a3fc7684be$export$757ceba2d55c277e = $70c58451959e30b3$exports.hydrateRoot;


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $eW1QL = parcelRequire("eW1QL");
var $d6edb712196a191f$exports = {};
"use strict";

$d6edb712196a191f$exports = (parcelRequire("154Qf"));





// Default to a dummy "batch" implementation that just runs the callback
function $9dac20f48fef1fb2$var$defaultNoopBatch(callback) {
    callback();
}
let $9dac20f48fef1fb2$var$batch = $9dac20f48fef1fb2$var$defaultNoopBatch; // Allow injecting another batching function later
const $9dac20f48fef1fb2$export$4b9874722d0da7bc = (newBatch)=>$9dac20f48fef1fb2$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $9dac20f48fef1fb2$export$fc47d4c0ba3bd2c6 = ()=>$9dac20f48fef1fb2$var$batch;



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
const $e222f7ad40bf9780$var$ContextKey = Symbol.for(`react-redux-context`);
const $e222f7ad40bf9780$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $e222f7ad40bf9780$var$getContext() {
    var _gT$ContextKey;
    if (!$3QbnI.createContext) return {};
    const contextMap = (_gT$ContextKey = $e222f7ad40bf9780$var$gT[$e222f7ad40bf9780$var$ContextKey]) != null ? _gT$ContextKey : $e222f7ad40bf9780$var$gT[$e222f7ad40bf9780$var$ContextKey] = new Map();
    let realContext = contextMap.get($3QbnI.createContext);
    if (!realContext) {
        realContext = $3QbnI.createContext(null);
        contextMap.set($3QbnI.createContext, realContext);
    }
    return realContext;
}
const $e222f7ad40bf9780$export$cc80c08dc91f1c00 = /*#__PURE__*/ $e222f7ad40bf9780$var$getContext();
var $e222f7ad40bf9780$export$2e2bcd8739ae039 = $e222f7ad40bf9780$export$cc80c08dc91f1c00;


function $50a484b13ebc8a92$export$d4d6226d5fc61558(context = (0, $e222f7ad40bf9780$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $3QbnI.useContext)(context);
        return contextValue;
    };
}
const $50a484b13ebc8a92$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $50a484b13ebc8a92$export$d4d6226d5fc61558();



const $6699b0f144bb309d$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $7600377419656cdf$var$useSyncExternalStoreWithSelector = (0, $6699b0f144bb309d$export$20656a4825650bd0);
const $7600377419656cdf$export$e2e6e3f3f3b782e3 = (fn)=>{
    $7600377419656cdf$var$useSyncExternalStoreWithSelector = fn;
};
const $7600377419656cdf$var$refEquality = (a, b)=>a === b;
function $7600377419656cdf$export$2b53f90d2bd1cbfb(context = (0, $e222f7ad40bf9780$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $e222f7ad40bf9780$export$cc80c08dc91f1c00) ? (0, $50a484b13ebc8a92$export$c1275ca9a6fd3ec5) : (0, $50a484b13ebc8a92$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $7600377419656cdf$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $3QbnI.useRef)(true);
        const wrappedSelector = (0, $3QbnI.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $7600377419656cdf$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $3QbnI.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $7600377419656cdf$export$2105062e25df4afe = /*#__PURE__*/ $7600377419656cdf$export$2b53f90d2bd1cbfb();


function $dc9dd96d66af11b0$export$2e2bcd8739ae039() {
    $dc9dd96d66af11b0$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc9dd96d66af11b0$export$2e2bcd8739ae039.apply(this, arguments);
}


function $506f89d9550e4bd4$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $6506ac27a174cdb1$exports = {};
"use strict";
var $e3b5edfa6c7901bc$exports = {};
"use strict";

$e3b5edfa6c7901bc$exports = (parcelRequire("a5UKC"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $6506ac27a174cdb1$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $6506ac27a174cdb1$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $6506ac27a174cdb1$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $6506ac27a174cdb1$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $6506ac27a174cdb1$var$TYPE_STATICS = {};
$6506ac27a174cdb1$var$TYPE_STATICS[$e3b5edfa6c7901bc$exports.ForwardRef] = $6506ac27a174cdb1$var$FORWARD_REF_STATICS;
$6506ac27a174cdb1$var$TYPE_STATICS[$e3b5edfa6c7901bc$exports.Memo] = $6506ac27a174cdb1$var$MEMO_STATICS;
function $6506ac27a174cdb1$var$getStatics(component) {
    // React v16.11 and below
    if ($e3b5edfa6c7901bc$exports.isMemo(component)) return $6506ac27a174cdb1$var$MEMO_STATICS;
     // React v16.12 and above
    return $6506ac27a174cdb1$var$TYPE_STATICS[component["$$typeof"]] || $6506ac27a174cdb1$var$REACT_STATICS;
}
var $6506ac27a174cdb1$var$defineProperty = Object.defineProperty;
var $6506ac27a174cdb1$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $6506ac27a174cdb1$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6506ac27a174cdb1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $6506ac27a174cdb1$var$getPrototypeOf = Object.getPrototypeOf;
var $6506ac27a174cdb1$var$objectPrototype = Object.prototype;
function $6506ac27a174cdb1$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($6506ac27a174cdb1$var$objectPrototype) {
            var inheritedComponent = $6506ac27a174cdb1$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $6506ac27a174cdb1$var$objectPrototype) $6506ac27a174cdb1$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $6506ac27a174cdb1$var$getOwnPropertyNames(sourceComponent);
        if ($6506ac27a174cdb1$var$getOwnPropertySymbols) keys = keys.concat($6506ac27a174cdb1$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $6506ac27a174cdb1$var$getStatics(targetComponent);
        var sourceStatics = $6506ac27a174cdb1$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$6506ac27a174cdb1$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $6506ac27a174cdb1$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $6506ac27a174cdb1$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$6506ac27a174cdb1$exports = $6506ac27a174cdb1$var$hoistNonReactStatics;



var $3QbnI = parcelRequire("3QbnI");
var $0b5ae67d154c5a19$exports = {};
"use strict";

$0b5ae67d154c5a19$exports = (parcelRequire("iCWoj"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $e523e5dae3019fc4$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $0ac31d778e009421$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $e523e5dae3019fc4$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $0ac31d778e009421$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $0ac31d778e009421$var$verify(mapStateToProps, "mapStateToProps");
    $0ac31d778e009421$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $0ac31d778e009421$var$verify(mergeProps, "mergeProps");
}


const $3053cde368e01ed0$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $3053cde368e01ed0$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $3053cde368e01ed0$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $506f89d9550e4bd4$export$2e2bcd8739ae039)(_ref, $3053cde368e01ed0$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $3053cde368e01ed0$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $a3307e6ec4e0ebc9$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $91b3cf7b3d02d07e$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $0889db7f2979c8dd$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $91b3cf7b3d02d07e$export$2e2bcd8739ae039)(value)) (0, $e523e5dae3019fc4$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $d03bcea0e667d86b$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $d03bcea0e667d86b$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $d03bcea0e667d86b$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $d03bcea0e667d86b$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $d03bcea0e667d86b$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $ffcc8e5165a237be$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $ef407e6150ae3626$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $d03bcea0e667d86b$export$710f7c60f68acd3e)((dispatch)=>(0, $a3307e6ec4e0ebc9$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $d03bcea0e667d86b$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $d03bcea0e667d86b$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $ffcc8e5165a237be$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $5ec357c46d10e4fa$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $d03bcea0e667d86b$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $d03bcea0e667d86b$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $ffcc8e5165a237be$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}





function $b7c849d9f67a810b$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $dc9dd96d66af11b0$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $b7c849d9f67a810b$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $b7c849d9f67a810b$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$b7c849d9f67a810b$export$691c327fc30bc857 : typeof mergeProps === "function" ? $b7c849d9f67a810b$export$5b105939c84b5234(mergeProps) : (0, $ffcc8e5165a237be$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $b1382113c04a3ce3$var$createListenerCollection() {
    const batch = (0, $9dac20f48fef1fb2$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $b1382113c04a3ce3$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $b1382113c04a3ce3$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $b1382113c04a3ce3$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $b1382113c04a3ce3$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $b1382113c04a3ce3$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $3QbnI = parcelRequire("3QbnI");
const $6daad0eddeccd789$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $6daad0eddeccd789$export$700979bc83e7db82 = $6daad0eddeccd789$export$71594e8a50f746f4 ? $3QbnI.useLayoutEffect : $3QbnI.useEffect;


function $095e932c7d85beb6$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $095e932c7d85beb6$export$2e2bcd8739ae039(objA, objB) {
    if ($095e932c7d85beb6$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$095e932c7d85beb6$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $55897a904b6e40c3$var$_excluded = [
    "reactReduxForwardedRef"
];
let $55897a904b6e40c3$var$useSyncExternalStore = (0, $6699b0f144bb309d$export$20656a4825650bd0);
const $55897a904b6e40c3$export$36d45daa6a4925b8 = (fn)=>{
    $55897a904b6e40c3$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $55897a904b6e40c3$var$EMPTY_ARRAY = [
    null,
    0
];
const $55897a904b6e40c3$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $55897a904b6e40c3$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $55897a904b6e40c3$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $6daad0eddeccd789$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $55897a904b6e40c3$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $55897a904b6e40c3$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $55897a904b6e40c3$var$initStateUpdates = ()=>$55897a904b6e40c3$var$EMPTY_ARRAY;
function $55897a904b6e40c3$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $55897a904b6e40c3$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $55897a904b6e40c3$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55897a904b6e40c3$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $095e932c7d85beb6$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $095e932c7d85beb6$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $095e932c7d85beb6$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $e222f7ad40bf9780$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $5ec357c46d10e4fa$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $ef407e6150ae3626$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $b7c849d9f67a810b$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $3QbnI.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $506f89d9550e4bd4$export$2e2bcd8739ae039)(props, $55897a904b6e40c3$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $3QbnI.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $0b5ae67d154c5a19$exports.isContextConsumer)(/*#__PURE__*/ $3QbnI.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $3QbnI.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $3QbnI.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $3053cde368e01ed0$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $3QbnI.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55897a904b6e40c3$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $b1382113c04a3ce3$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $3QbnI.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $dc9dd96d66af11b0$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $3QbnI.useRef();
            const lastWrapperProps = $3QbnI.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $3QbnI.useRef();
            const renderIsScheduled = $3QbnI.useRef(false);
            const isProcessingDispatch = $3QbnI.useRef(false);
            const isMounted = $3QbnI.useRef(false);
            const latestSubscriptionCallbackError = $3QbnI.useRef();
            (0, $6daad0eddeccd789$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $3QbnI.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $3QbnI.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55897a904b6e40c3$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55897a904b6e40c3$var$useIsomorphicLayoutEffectWithArgs($55897a904b6e40c3$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $55897a904b6e40c3$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $6daad0eddeccd789$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $3QbnI.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $3QbnI.createElement(WrappedComponent, (0, $dc9dd96d66af11b0$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $3QbnI.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $3QbnI.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $3QbnI.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $3QbnI.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $3QbnI.createElement(Connect, (0, $dc9dd96d66af11b0$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6506ac27a174cdb1$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($6506ac27a174cdb1$exports)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55897a904b6e40c3$export$2e2bcd8739ae039 = $55897a904b6e40c3$var$connect;



var $3QbnI = parcelRequire("3QbnI");



function $37606b2ec2c6e282$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $3QbnI.useMemo(()=>{
        const subscription = (0, $b1382113c04a3ce3$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $3QbnI.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $6daad0eddeccd789$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $e222f7ad40bf9780$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $3QbnI.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $37606b2ec2c6e282$export$2e2bcd8739ae039 = $37606b2ec2c6e282$var$Provider;







function $967196c086380c1f$export$671dba69185d0304(context = (0, $e222f7ad40bf9780$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $e222f7ad40bf9780$export$cc80c08dc91f1c00) ? (0, $50a484b13ebc8a92$export$c1275ca9a6fd3ec5) : (0, $50a484b13ebc8a92$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $967196c086380c1f$export$6ccbb43953eebf8 = /*#__PURE__*/ $967196c086380c1f$export$671dba69185d0304();


function $d033bf60a87d7606$export$bc9b55530897c558(context = (0, $e222f7ad40bf9780$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $e222f7ad40bf9780$export$cc80c08dc91f1c00) ? (0, $967196c086380c1f$export$6ccbb43953eebf8) : (0, $967196c086380c1f$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $d033bf60a87d7606$export$8ad76b76a4c905f8 = /*#__PURE__*/ $d033bf60a87d7606$export$bc9b55530897c558();









(0, $7600377419656cdf$export$e2e6e3f3f3b782e3)((0, $d6edb712196a191f$exports.useSyncExternalStoreWithSelector));
(0, $55897a904b6e40c3$export$36d45daa6a4925b8)((0, $eW1QL.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $9dac20f48fef1fb2$export$4b9874722d0da7bc)((0, $70c58451959e30b3$exports.unstable_batchedUpdates));


/**
 * React Router DOM v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3QbnI = parcelRequire("3QbnI");

/**
 * @remix-run/router v1.16.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $437cfabf7953f11e$var$_extends() {
    $437cfabf7953f11e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $437cfabf7953f11e$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $437cfabf7953f11e$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($437cfabf7953f11e$export$e19cd5f9376f8cee || ($437cfabf7953f11e$export$e19cd5f9376f8cee = {}));
const $437cfabf7953f11e$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $437cfabf7953f11e$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $437cfabf7953f11e$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $437cfabf7953f11e$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $437cfabf7953f11e$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $437cfabf7953f11e$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $437cfabf7953f11e$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $437cfabf7953f11e$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $437cfabf7953f11e$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $437cfabf7953f11e$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $437cfabf7953f11e$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $437cfabf7953f11e$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $437cfabf7953f11e$export$fe53371bee54353d(to);
    }
    return $437cfabf7953f11e$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $437cfabf7953f11e$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $437cfabf7953f11e$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $437cfabf7953f11e$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $437cfabf7953f11e$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $437cfabf7953f11e$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $437cfabf7953f11e$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $437cfabf7953f11e$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $437cfabf7953f11e$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $437cfabf7953f11e$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $437cfabf7953f11e$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $437cfabf7953f11e$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $437cfabf7953f11e$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $437cfabf7953f11e$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $437cfabf7953f11e$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $437cfabf7953f11e$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $437cfabf7953f11e$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $437cfabf7953f11e$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $437cfabf7953f11e$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($437cfabf7953f11e$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $437cfabf7953f11e$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $437cfabf7953f11e$export$e19cd5f9376f8cee.Push;
        let location = $437cfabf7953f11e$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $437cfabf7953f11e$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $437cfabf7953f11e$export$e19cd5f9376f8cee.Replace;
        let location = $437cfabf7953f11e$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $437cfabf7953f11e$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $437cfabf7953f11e$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $437cfabf7953f11e$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($437cfabf7953f11e$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($437cfabf7953f11e$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $437cfabf7953f11e$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($437cfabf7953f11e$var$ResultType || ($437cfabf7953f11e$var$ResultType = {}));
const $437cfabf7953f11e$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $437cfabf7953f11e$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $437cfabf7953f11e$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $437cfabf7953f11e$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $437cfabf7953f11e$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($437cfabf7953f11e$var$isIndexRoute(route)) {
            let indexRoute = $437cfabf7953f11e$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $437cfabf7953f11e$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $437cfabf7953f11e$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $437cfabf7953f11e$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $437cfabf7953f11e$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $437cfabf7953f11e$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $437cfabf7953f11e$var$flattenRoutes(routes);
    $437cfabf7953f11e$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $437cfabf7953f11e$var$decodePath(pathname);
        matches = $437cfabf7953f11e$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $437cfabf7953f11e$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $437cfabf7953f11e$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $437cfabf7953f11e$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $437cfabf7953f11e$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $437cfabf7953f11e$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $437cfabf7953f11e$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $437cfabf7953f11e$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $437cfabf7953f11e$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $437cfabf7953f11e$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $437cfabf7953f11e$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $437cfabf7953f11e$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $437cfabf7953f11e$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $437cfabf7953f11e$var$paramRe = /^:[\w-]+$/;
const $437cfabf7953f11e$var$dynamicSegmentValue = 3;
const $437cfabf7953f11e$var$indexRouteValue = 2;
const $437cfabf7953f11e$var$emptySegmentValue = 1;
const $437cfabf7953f11e$var$staticSegmentValue = 10;
const $437cfabf7953f11e$var$splatPenalty = -2;
const $437cfabf7953f11e$var$isSplat = (s)=>s === "*";
function $437cfabf7953f11e$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($437cfabf7953f11e$var$isSplat)) initialScore += $437cfabf7953f11e$var$splatPenalty;
    if (index) initialScore += $437cfabf7953f11e$var$indexRouteValue;
    return segments.filter((s)=>!$437cfabf7953f11e$var$isSplat(s)).reduce((score, segment)=>score + ($437cfabf7953f11e$var$paramRe.test(segment) ? $437cfabf7953f11e$var$dynamicSegmentValue : segment === "" ? $437cfabf7953f11e$var$emptySegmentValue : $437cfabf7953f11e$var$staticSegmentValue), initialScore);
}
function $437cfabf7953f11e$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $437cfabf7953f11e$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $437cfabf7953f11e$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $437cfabf7953f11e$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $437cfabf7953f11e$export$a5c6d149b50c1d86($437cfabf7953f11e$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $437cfabf7953f11e$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $437cfabf7953f11e$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $437cfabf7953f11e$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $437cfabf7953f11e$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $437cfabf7953f11e$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $437cfabf7953f11e$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $437cfabf7953f11e$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $437cfabf7953f11e$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $437cfabf7953f11e$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $437cfabf7953f11e$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $437cfabf7953f11e$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $437cfabf7953f11e$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $437cfabf7953f11e$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $437cfabf7953f11e$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $437cfabf7953f11e$var$normalizeSearch(search),
        hash: $437cfabf7953f11e$var$normalizeHash(hash)
    };
}
function $437cfabf7953f11e$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $437cfabf7953f11e$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $437cfabf7953f11e$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $437cfabf7953f11e$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $437cfabf7953f11e$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $437cfabf7953f11e$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $437cfabf7953f11e$export$8ccf933b0513f8d0(toArg);
    else {
        to = $437cfabf7953f11e$var$_extends({}, toArg);
        $437cfabf7953f11e$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $437cfabf7953f11e$var$getInvalidPathError("?", "pathname", "search", to));
        $437cfabf7953f11e$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $437cfabf7953f11e$var$getInvalidPathError("#", "pathname", "hash", to));
        $437cfabf7953f11e$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $437cfabf7953f11e$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $437cfabf7953f11e$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $437cfabf7953f11e$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $437cfabf7953f11e$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $437cfabf7953f11e$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $437cfabf7953f11e$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $437cfabf7953f11e$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $437cfabf7953f11e$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $437cfabf7953f11e$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $437cfabf7953f11e$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $437cfabf7953f11e$export$42a99a7a4bc0e76a extends Error {
}
class $437cfabf7953f11e$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $437cfabf7953f11e$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $437cfabf7953f11e$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $437cfabf7953f11e$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $437cfabf7953f11e$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $437cfabf7953f11e$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $437cfabf7953f11e$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $437cfabf7953f11e$var$unwrapTrackedPromise(value) {
    if (!$437cfabf7953f11e$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $437cfabf7953f11e$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $437cfabf7953f11e$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $437cfabf7953f11e$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $437cfabf7953f11e$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $437cfabf7953f11e$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $437cfabf7953f11e$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $437cfabf7953f11e$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $437cfabf7953f11e$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $437cfabf7953f11e$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $437cfabf7953f11e$var$validMutationMethods = new Set($437cfabf7953f11e$var$validMutationMethodsArr);
const $437cfabf7953f11e$var$validRequestMethodsArr = [
    "get",
    ...$437cfabf7953f11e$var$validMutationMethodsArr
];
const $437cfabf7953f11e$var$validRequestMethods = new Set($437cfabf7953f11e$var$validRequestMethodsArr);
const $437cfabf7953f11e$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $437cfabf7953f11e$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $437cfabf7953f11e$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $437cfabf7953f11e$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $437cfabf7953f11e$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $437cfabf7953f11e$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $437cfabf7953f11e$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $437cfabf7953f11e$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $437cfabf7953f11e$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $437cfabf7953f11e$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $437cfabf7953f11e$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $437cfabf7953f11e$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $437cfabf7953f11e$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $437cfabf7953f11e$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $437cfabf7953f11e$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $437cfabf7953f11e$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $437cfabf7953f11e$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $437cfabf7953f11e$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $437cfabf7953f11e$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $437cfabf7953f11e$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $437cfabf7953f11e$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $437cfabf7953f11e$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$437cfabf7953f11e$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($437cfabf7953f11e$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $437cfabf7953f11e$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $437cfabf7953f11e$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $437cfabf7953f11e$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $437cfabf7953f11e$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $437cfabf7953f11e$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $437cfabf7953f11e$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $437cfabf7953f11e$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $437cfabf7953f11e$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $437cfabf7953f11e$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($437cfabf7953f11e$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $437cfabf7953f11e$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $437cfabf7953f11e$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $437cfabf7953f11e$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $437cfabf7953f11e$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $437cfabf7953f11e$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $437cfabf7953f11e$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $437cfabf7953f11e$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $437cfabf7953f11e$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $437cfabf7953f11e$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $437cfabf7953f11e$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $437cfabf7953f11e$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $437cfabf7953f11e$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $437cfabf7953f11e$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $437cfabf7953f11e$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $437cfabf7953f11e$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $437cfabf7953f11e$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $437cfabf7953f11e$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $437cfabf7953f11e$var$findNearestBoundary(matches).route.id,
            {
                type: $437cfabf7953f11e$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $437cfabf7953f11e$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $437cfabf7953f11e$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $437cfabf7953f11e$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $437cfabf7953f11e$var$_extends({
            matches: matches
        }, $437cfabf7953f11e$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $437cfabf7953f11e$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $437cfabf7953f11e$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $437cfabf7953f11e$var$ResultType.error,
            error: $437cfabf7953f11e$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($437cfabf7953f11e$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $437cfabf7953f11e$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($437cfabf7953f11e$var$isDeferredResult(result)) throw $437cfabf7953f11e$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($437cfabf7953f11e$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $437cfabf7953f11e$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $437cfabf7953f11e$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $437cfabf7953f11e$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $437cfabf7953f11e$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $437cfabf7953f11e$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $437cfabf7953f11e$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $437cfabf7953f11e$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $437cfabf7953f11e$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $437cfabf7953f11e$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$437cfabf7953f11e$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($437cfabf7953f11e$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $437cfabf7953f11e$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $437cfabf7953f11e$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $437cfabf7953f11e$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $437cfabf7953f11e$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $437cfabf7953f11e$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $437cfabf7953f11e$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $437cfabf7953f11e$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $437cfabf7953f11e$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $437cfabf7953f11e$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $437cfabf7953f11e$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $437cfabf7953f11e$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $437cfabf7953f11e$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($437cfabf7953f11e$var$isRedirectResult(actionResult) || $437cfabf7953f11e$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $437cfabf7953f11e$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($437cfabf7953f11e$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $437cfabf7953f11e$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $437cfabf7953f11e$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($437cfabf7953f11e$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($437cfabf7953f11e$var$isDeferredResult(actionResult)) throw $437cfabf7953f11e$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $437cfabf7953f11e$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $437cfabf7953f11e$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $437cfabf7953f11e$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $437cfabf7953f11e$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $437cfabf7953f11e$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $437cfabf7953f11e$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $437cfabf7953f11e$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $437cfabf7953f11e$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $437cfabf7953f11e$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $437cfabf7953f11e$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $437cfabf7953f11e$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $437cfabf7953f11e$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $437cfabf7953f11e$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($437cfabf7953f11e$var$isDeferredResult(result)) result = await $437cfabf7953f11e$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $437cfabf7953f11e$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($437cfabf7953f11e$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $437cfabf7953f11e$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($437cfabf7953f11e$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $437cfabf7953f11e$export$3e9cee6b33872309(!$437cfabf7953f11e$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $437cfabf7953f11e$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $437cfabf7953f11e$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $437cfabf7953f11e$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $437cfabf7953f11e$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($437cfabf7953f11e$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $437cfabf7953f11e$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $437cfabf7953f11e$export$e19cd5f9376f8cee.Replace : $437cfabf7953f11e$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $437cfabf7953f11e$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($437cfabf7953f11e$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $437cfabf7953f11e$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $437cfabf7953f11e$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $437cfabf7953f11e$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $437cfabf7953f11e$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($437cfabf7953f11e$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $437cfabf7953f11e$var$ResultType.redirect,
                        response: $437cfabf7953f11e$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $437cfabf7953f11e$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $437cfabf7953f11e$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $437cfabf7953f11e$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $437cfabf7953f11e$var$ResultType.error,
                    error: $437cfabf7953f11e$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $437cfabf7953f11e$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $437cfabf7953f11e$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $437cfabf7953f11e$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $437cfabf7953f11e$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $437cfabf7953f11e$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $437cfabf7953f11e$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $437cfabf7953f11e$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $437cfabf7953f11e$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $437cfabf7953f11e$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $437cfabf7953f11e$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $437cfabf7953f11e$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $437cfabf7953f11e$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $437cfabf7953f11e$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$437cfabf7953f11e$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $437cfabf7953f11e$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $437cfabf7953f11e$export$4d0306f8f6a4585b = Symbol("deferred");
function $437cfabf7953f11e$export$3336b097a6fbc59a(routes, opts) {
    $437cfabf7953f11e$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $437cfabf7953f11e$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $437cfabf7953f11e$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $437cfabf7953f11e$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $437cfabf7953f11e$var$createLocation("", $437cfabf7953f11e$export$fe53371bee54353d(url), null, "default");
        let matches = $437cfabf7953f11e$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$437cfabf7953f11e$var$isValidMethod(method) && method !== "HEAD") {
            let error = $437cfabf7953f11e$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $437cfabf7953f11e$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $437cfabf7953f11e$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $437cfabf7953f11e$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($437cfabf7953f11e$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $437cfabf7953f11e$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $437cfabf7953f11e$var$createLocation("", $437cfabf7953f11e$export$fe53371bee54353d(url), null, "default");
        let matches = $437cfabf7953f11e$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$437cfabf7953f11e$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $437cfabf7953f11e$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $437cfabf7953f11e$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $437cfabf7953f11e$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $437cfabf7953f11e$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $437cfabf7953f11e$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($437cfabf7953f11e$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$437cfabf7953f11e$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $437cfabf7953f11e$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($437cfabf7953f11e$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $437cfabf7953f11e$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $437cfabf7953f11e$var$isResponse(result) ? result : $437cfabf7953f11e$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($437cfabf7953f11e$var$isHandlerResult(e) && $437cfabf7953f11e$var$isResponse(e.result)) {
                if (e.type === $437cfabf7953f11e$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($437cfabf7953f11e$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $437cfabf7953f11e$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $437cfabf7953f11e$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $437cfabf7953f11e$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($437cfabf7953f11e$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($437cfabf7953f11e$var$isDeferredResult(result)) {
            let error = $437cfabf7953f11e$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $437cfabf7953f11e$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($437cfabf7953f11e$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($437cfabf7953f11e$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $437cfabf7953f11e$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $437cfabf7953f11e$var$_extends({}, context, {
                statusCode: $437cfabf7953f11e$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $437cfabf7953f11e$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $437cfabf7953f11e$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $437cfabf7953f11e$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $437cfabf7953f11e$var$isErrorResult(pendingActionResult[1]) ? $437cfabf7953f11e$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $437cfabf7953f11e$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $437cfabf7953f11e$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $437cfabf7953f11e$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $437cfabf7953f11e$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $437cfabf7953f11e$var$callDataStrategyImpl(unstable_dataStrategy || $437cfabf7953f11e$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($437cfabf7953f11e$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $437cfabf7953f11e$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($437cfabf7953f11e$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $437cfabf7953f11e$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $437cfabf7953f11e$export$fec11da027c70692(routes, context, error) {
    let newContext = $437cfabf7953f11e$var$_extends({}, context, {
        statusCode: $437cfabf7953f11e$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $437cfabf7953f11e$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $437cfabf7953f11e$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $437cfabf7953f11e$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $437cfabf7953f11e$export$cae722b0cc860f13(to ? to : ".", $437cfabf7953f11e$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $437cfabf7953f11e$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$437cfabf7953f11e$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $437cfabf7953f11e$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $437cfabf7953f11e$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $437cfabf7953f11e$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$437cfabf7953f11e$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$437cfabf7953f11e$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $437cfabf7953f11e$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $437cfabf7953f11e$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $437cfabf7953f11e$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$437cfabf7953f11e$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$437cfabf7953f11e$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $437cfabf7953f11e$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $437cfabf7953f11e$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $437cfabf7953f11e$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $437cfabf7953f11e$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $437cfabf7953f11e$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($437cfabf7953f11e$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $437cfabf7953f11e$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $437cfabf7953f11e$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $437cfabf7953f11e$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $437cfabf7953f11e$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $437cfabf7953f11e$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $437cfabf7953f11e$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $437cfabf7953f11e$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $437cfabf7953f11e$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($437cfabf7953f11e$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $437cfabf7953f11e$var$shouldRevalidateLoader(match, $437cfabf7953f11e$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $437cfabf7953f11e$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $437cfabf7953f11e$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $437cfabf7953f11e$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $437cfabf7953f11e$var$shouldRevalidateLoader(fetcherMatch, $437cfabf7953f11e$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $437cfabf7953f11e$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $437cfabf7953f11e$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $437cfabf7953f11e$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $437cfabf7953f11e$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $437cfabf7953f11e$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $437cfabf7953f11e$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$437cfabf7953f11e$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $437cfabf7953f11e$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $437cfabf7953f11e$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $437cfabf7953f11e$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $437cfabf7953f11e$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $437cfabf7953f11e$var$ResultType.data,
                    result: undefined
                });
            };
            return $437cfabf7953f11e$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$437cfabf7953f11e$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $437cfabf7953f11e$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $437cfabf7953f11e$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $437cfabf7953f11e$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $437cfabf7953f11e$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $437cfabf7953f11e$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $437cfabf7953f11e$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $437cfabf7953f11e$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $437cfabf7953f11e$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $437cfabf7953f11e$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($437cfabf7953f11e$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $437cfabf7953f11e$var$ResultType.error,
                error: e
            };
        }
        if (type === $437cfabf7953f11e$var$ResultType.error) return {
            type: $437cfabf7953f11e$var$ResultType.error,
            error: new $437cfabf7953f11e$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $437cfabf7953f11e$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $437cfabf7953f11e$var$ResultType.error) return {
        type: $437cfabf7953f11e$var$ResultType.error,
        error: result,
        statusCode: $437cfabf7953f11e$export$972111febbeef05b(result) ? result.status : status
    };
    if ($437cfabf7953f11e$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $437cfabf7953f11e$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $437cfabf7953f11e$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $437cfabf7953f11e$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $437cfabf7953f11e$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$437cfabf7953f11e$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $437cfabf7953f11e$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $437cfabf7953f11e$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($437cfabf7953f11e$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $437cfabf7953f11e$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $437cfabf7953f11e$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($437cfabf7953f11e$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $437cfabf7953f11e$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $437cfabf7953f11e$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $437cfabf7953f11e$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $437cfabf7953f11e$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $437cfabf7953f11e$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $437cfabf7953f11e$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $437cfabf7953f11e$export$3e9cee6b33872309(!$437cfabf7953f11e$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($437cfabf7953f11e$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $437cfabf7953f11e$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $437cfabf7953f11e$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($437cfabf7953f11e$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $437cfabf7953f11e$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $437cfabf7953f11e$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $437cfabf7953f11e$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($437cfabf7953f11e$var$isErrorResult(result)) {
            let boundaryMatch = $437cfabf7953f11e$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $437cfabf7953f11e$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($437cfabf7953f11e$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $437cfabf7953f11e$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($437cfabf7953f11e$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $437cfabf7953f11e$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $437cfabf7953f11e$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $437cfabf7953f11e$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $437cfabf7953f11e$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $437cfabf7953f11e$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $437cfabf7953f11e$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $437cfabf7953f11e$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $437cfabf7953f11e$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $437cfabf7953f11e$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $437cfabf7953f11e$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $437cfabf7953f11e$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($437cfabf7953f11e$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $437cfabf7953f11e$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $437cfabf7953f11e$export$8ccf933b0513f8d0(path) : path;
    return $437cfabf7953f11e$export$fe53371bee54353d($437cfabf7953f11e$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $437cfabf7953f11e$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $437cfabf7953f11e$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $437cfabf7953f11e$var$ResultType.data || result.type === $437cfabf7953f11e$var$ResultType.error);
}
function $437cfabf7953f11e$var$isRedirectHandlerResult(result) {
    return $437cfabf7953f11e$var$isResponse(result.result) && $437cfabf7953f11e$var$redirectStatusCodes.has(result.result.status);
}
function $437cfabf7953f11e$var$isDeferredResult(result) {
    return result.type === $437cfabf7953f11e$var$ResultType.deferred;
}
function $437cfabf7953f11e$var$isErrorResult(result) {
    return result.type === $437cfabf7953f11e$var$ResultType.error;
}
function $437cfabf7953f11e$var$isRedirectResult(result) {
    return (result && result.type) === $437cfabf7953f11e$var$ResultType.redirect;
}
function $437cfabf7953f11e$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $437cfabf7953f11e$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $437cfabf7953f11e$var$isRedirectResponse(result) {
    if (!$437cfabf7953f11e$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $437cfabf7953f11e$var$isValidMethod(method) {
    return $437cfabf7953f11e$var$validRequestMethods.has(method.toLowerCase());
}
function $437cfabf7953f11e$var$isMutationMethod(method) {
    return $437cfabf7953f11e$var$validMutationMethods.has(method.toLowerCase());
}
async function $437cfabf7953f11e$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$437cfabf7953f11e$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($437cfabf7953f11e$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $437cfabf7953f11e$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $437cfabf7953f11e$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $437cfabf7953f11e$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $437cfabf7953f11e$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $437cfabf7953f11e$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $437cfabf7953f11e$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $437cfabf7953f11e$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $437cfabf7953f11e$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $437cfabf7953f11e$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $437cfabf7953f11e$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $437cfabf7953f11e$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $437cfabf7953f11e$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $437cfabf7953f11e$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $437cfabf7953f11e$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $437cfabf7953f11e$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $437cfabf7953f11e$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $437cfabf7953f11e$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $437cfabf7953f11e$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($437cfabf7953f11e$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $437cfabf7953f11e$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($437cfabf7953f11e$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $437cfabf7953f11e$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3QbnI = parcelRequire("3QbnI");

function $e724dc7e3b3eec8a$var$_extends() {
    $e724dc7e3b3eec8a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e724dc7e3b3eec8a$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $e724dc7e3b3eec8a$export$3add0d5dce533e2e = /*#__PURE__*/ $3QbnI.createContext(null);
const $e724dc7e3b3eec8a$export$145dfa71566a64dc = /*#__PURE__*/ $3QbnI.createContext(null);
const $e724dc7e3b3eec8a$var$AwaitContext = /*#__PURE__*/ $3QbnI.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $e724dc7e3b3eec8a$export$26749e8557646306 = /*#__PURE__*/ $3QbnI.createContext(null);
const $e724dc7e3b3eec8a$export$c7914228fb69b0f5 = /*#__PURE__*/ $3QbnI.createContext(null);
const $e724dc7e3b3eec8a$export$9072aa6dd1f93057 = /*#__PURE__*/ $3QbnI.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $e724dc7e3b3eec8a$var$RouteErrorContext = /*#__PURE__*/ $3QbnI.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $e724dc7e3b3eec8a$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$e724dc7e3b3eec8a$export$9c954a9d03d32f4a() && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $3QbnI.useContext($e724dc7e3b3eec8a$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $e724dc7e3b3eec8a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $437cfabf7953f11e$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $e724dc7e3b3eec8a$export$9c954a9d03d32f4a() {
    return $3QbnI.useContext($e724dc7e3b3eec8a$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $e724dc7e3b3eec8a$export$45d76561a5302f2b() {
    !$e724dc7e3b3eec8a$export$9c954a9d03d32f4a() && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    return $3QbnI.useContext($e724dc7e3b3eec8a$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $e724dc7e3b3eec8a$export$1b3f31771c5d07c() {
    return $3QbnI.useContext($e724dc7e3b3eec8a$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $e724dc7e3b3eec8a$export$6c330e8992e8a295(pattern) {
    !$e724dc7e3b3eec8a$export$9c954a9d03d32f4a() && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $e724dc7e3b3eec8a$export$45d76561a5302f2b();
    return $3QbnI.useMemo(()=>(0, $437cfabf7953f11e$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $e724dc7e3b3eec8a$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $e724dc7e3b3eec8a$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $3QbnI.useContext($e724dc7e3b3eec8a$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $3QbnI.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $e724dc7e3b3eec8a$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $3QbnI.useContext($e724dc7e3b3eec8a$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $e724dc7e3b3eec8a$var$useNavigateStable() : $e724dc7e3b3eec8a$var$useNavigateUnstable();
}
function $e724dc7e3b3eec8a$var$useNavigateUnstable() {
    !$e724dc7e3b3eec8a$export$9c954a9d03d32f4a() && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    let dataRouterContext = $3QbnI.useContext($e724dc7e3b3eec8a$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $3QbnI.useContext($e724dc7e3b3eec8a$export$26749e8557646306);
    let { matches: matches } = $3QbnI.useContext($e724dc7e3b3eec8a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $e724dc7e3b3eec8a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $437cfabf7953f11e$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $3QbnI.useRef(false);
    $e724dc7e3b3eec8a$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $3QbnI.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $437cfabf7953f11e$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $437cfabf7953f11e$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $e724dc7e3b3eec8a$var$OutletContext = /*#__PURE__*/ $3QbnI.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $e724dc7e3b3eec8a$export$4138103a3ae699cc() {
    return $3QbnI.useContext($e724dc7e3b3eec8a$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $e724dc7e3b3eec8a$export$a3be3530d8e40d0b(context) {
    let outlet = $3QbnI.useContext($e724dc7e3b3eec8a$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $e724dc7e3b3eec8a$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $3QbnI.useContext($e724dc7e3b3eec8a$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $e724dc7e3b3eec8a$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $3QbnI.useContext($e724dc7e3b3eec8a$export$26749e8557646306);
    let { matches: matches } = $3QbnI.useContext($e724dc7e3b3eec8a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $e724dc7e3b3eec8a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $437cfabf7953f11e$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $3QbnI.useMemo(()=>(0, $437cfabf7953f11e$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $e724dc7e3b3eec8a$export$5d3fca4a98652595(routes, locationArg) {
    return $e724dc7e3b3eec8a$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $e724dc7e3b3eec8a$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$e724dc7e3b3eec8a$export$9c954a9d03d32f4a() && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $3QbnI.useContext($e724dc7e3b3eec8a$export$26749e8557646306);
    let { matches: parentMatches } = $3QbnI.useContext($e724dc7e3b3eec8a$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $e724dc7e3b3eec8a$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $437cfabf7953f11e$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $437cfabf7953f11e$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $e724dc7e3b3eec8a$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $437cfabf7953f11e$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $437cfabf7953f11e$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $e724dc7e3b3eec8a$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $437cfabf7953f11e$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $e724dc7e3b3eec8a$var$DefaultErrorComponent() {
    let error = $e724dc7e3b3eec8a$export$ed527bf60f6e05f2();
    let message = (0, $437cfabf7953f11e$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $3QbnI.createElement($3QbnI.Fragment, null, /*#__PURE__*/ $3QbnI.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $3QbnI.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $3QbnI.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $e724dc7e3b3eec8a$var$defaultErrorElement = /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$var$DefaultErrorComponent, null);
class $e724dc7e3b3eec8a$var$RenderErrorBoundary extends $3QbnI.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $e724dc7e3b3eec8a$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $3QbnI.useContext($e724dc7e3b3eec8a$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $e724dc7e3b3eec8a$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $e724dc7e3b3eec8a$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $e724dc7e3b3eec8a$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $3QbnI.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $e724dc7e3b3eec8a$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($e724dc7e3b3eec8a$var$DataRouterHook || {});
var $e724dc7e3b3eec8a$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($e724dc7e3b3eec8a$var$DataRouterStateHook || {});
function $e724dc7e3b3eec8a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $e724dc7e3b3eec8a$var$useDataRouterContext(hookName) {
    let ctx = $3QbnI.useContext($e724dc7e3b3eec8a$export$3add0d5dce533e2e);
    !ctx && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    return ctx;
}
function $e724dc7e3b3eec8a$var$useDataRouterState(hookName) {
    let state = $3QbnI.useContext($e724dc7e3b3eec8a$export$145dfa71566a64dc);
    !state && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    return state;
}
function $e724dc7e3b3eec8a$var$useRouteContext(hookName) {
    let route = $3QbnI.useContext($e724dc7e3b3eec8a$export$9072aa6dd1f93057);
    !route && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $e724dc7e3b3eec8a$var$useCurrentRouteId(hookName) {
    let route = $e724dc7e3b3eec8a$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $e724dc7e3b3eec8a$export$5fc8298006ad9e58() {
    return $e724dc7e3b3eec8a$var$useCurrentRouteId($e724dc7e3b3eec8a$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $e724dc7e3b3eec8a$export$d0fd4b7106de2769() {
    let state = $e724dc7e3b3eec8a$var$useDataRouterState($e724dc7e3b3eec8a$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $e724dc7e3b3eec8a$export$600dc272ed516c15() {
    let dataRouterContext = $e724dc7e3b3eec8a$var$useDataRouterContext($e724dc7e3b3eec8a$var$DataRouterHook.UseRevalidator);
    let state = $e724dc7e3b3eec8a$var$useDataRouterState($e724dc7e3b3eec8a$var$DataRouterStateHook.UseRevalidator);
    return $3QbnI.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $e724dc7e3b3eec8a$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $e724dc7e3b3eec8a$var$useDataRouterState($e724dc7e3b3eec8a$var$DataRouterStateHook.UseMatches);
    return $3QbnI.useMemo(()=>matches.map((m)=>(0, $437cfabf7953f11e$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $e724dc7e3b3eec8a$export$1448a5050d252c4d() {
    let state = $e724dc7e3b3eec8a$var$useDataRouterState($e724dc7e3b3eec8a$var$DataRouterStateHook.UseLoaderData);
    let routeId = $e724dc7e3b3eec8a$var$useCurrentRouteId($e724dc7e3b3eec8a$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $e724dc7e3b3eec8a$export$fd5d37484eab868d(routeId) {
    let state = $e724dc7e3b3eec8a$var$useDataRouterState($e724dc7e3b3eec8a$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $e724dc7e3b3eec8a$export$fdc00f3f26066d5e() {
    let state = $e724dc7e3b3eec8a$var$useDataRouterState($e724dc7e3b3eec8a$var$DataRouterStateHook.UseActionData);
    let routeId = $e724dc7e3b3eec8a$var$useCurrentRouteId($e724dc7e3b3eec8a$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $e724dc7e3b3eec8a$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $3QbnI.useContext($e724dc7e3b3eec8a$var$RouteErrorContext);
    let state = $e724dc7e3b3eec8a$var$useDataRouterState($e724dc7e3b3eec8a$var$DataRouterStateHook.UseRouteError);
    let routeId = $e724dc7e3b3eec8a$var$useCurrentRouteId($e724dc7e3b3eec8a$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $e724dc7e3b3eec8a$export$78a72ddb39bdd145() {
    let value = $3QbnI.useContext($e724dc7e3b3eec8a$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $e724dc7e3b3eec8a$export$17f53340677d5831() {
    let value = $3QbnI.useContext($e724dc7e3b3eec8a$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $e724dc7e3b3eec8a$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $e724dc7e3b3eec8a$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $e724dc7e3b3eec8a$var$useDataRouterContext($e724dc7e3b3eec8a$var$DataRouterHook.UseBlocker);
    let state = $e724dc7e3b3eec8a$var$useDataRouterState($e724dc7e3b3eec8a$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $3QbnI.useState("");
    let blockerFunction = $3QbnI.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $e724dc7e3b3eec8a$var$_extends({}, currentLocation, {
                pathname: (0, $437cfabf7953f11e$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $e724dc7e3b3eec8a$var$_extends({}, nextLocation, {
                pathname: (0, $437cfabf7953f11e$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $3QbnI.useEffect(()=>{
        let key = String(++$e724dc7e3b3eec8a$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $3QbnI.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $437cfabf7953f11e$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $e724dc7e3b3eec8a$var$useNavigateStable() {
    let { router: router } = $e724dc7e3b3eec8a$var$useDataRouterContext($e724dc7e3b3eec8a$var$DataRouterHook.UseNavigateStable);
    let id = $e724dc7e3b3eec8a$var$useCurrentRouteId($e724dc7e3b3eec8a$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $3QbnI.useRef(false);
    $e724dc7e3b3eec8a$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $3QbnI.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $e724dc7e3b3eec8a$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $e724dc7e3b3eec8a$var$alreadyWarned = {};
function $e724dc7e3b3eec8a$var$warningOnce(key, cond, message) {
    if (!cond && !$e724dc7e3b3eec8a$var$alreadyWarned[key]) $e724dc7e3b3eec8a$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $e724dc7e3b3eec8a$var$START_TRANSITION = "startTransition";
const $e724dc7e3b3eec8a$var$startTransitionImpl = $3QbnI[$e724dc7e3b3eec8a$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $e724dc7e3b3eec8a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $3QbnI.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3QbnI.useCallback((newState)=>{
        if (v7_startTransition && $e724dc7e3b3eec8a$var$startTransitionImpl) $e724dc7e3b3eec8a$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $3QbnI.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $3QbnI.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $3QbnI.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $3QbnI.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $3QbnI.createElement($3QbnI.Fragment, null, /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $e724dc7e3b3eec8a$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $e724dc7e3b3eec8a$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $e724dc7e3b3eec8a$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $3QbnI.useRef();
    if (historyRef.current == null) historyRef.current = (0, $437cfabf7953f11e$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3QbnI.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3QbnI.useCallback((newState)=>{
        v7_startTransition && $e724dc7e3b3eec8a$var$startTransitionImpl ? $e724dc7e3b3eec8a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3QbnI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $e724dc7e3b3eec8a$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$e724dc7e3b3eec8a$export$9c954a9d03d32f4a() && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $3QbnI.useContext($e724dc7e3b3eec8a$export$26749e8557646306);
    let { matches: matches } = $3QbnI.useContext($e724dc7e3b3eec8a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $e724dc7e3b3eec8a$export$45d76561a5302f2b();
    let navigate = $e724dc7e3b3eec8a$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $437cfabf7953f11e$export$cae722b0cc860f13)(to, (0, $437cfabf7953f11e$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $3QbnI.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $e724dc7e3b3eec8a$export$910ae8079b2c2852(props) {
    return $e724dc7e3b3eec8a$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $e724dc7e3b3eec8a$export$e7b0ac011bb776c6(_props) {
    (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $e724dc7e3b3eec8a$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $437cfabf7953f11e$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$e724dc7e3b3eec8a$export$9c954a9d03d32f4a() && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $3QbnI.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $e724dc7e3b3eec8a$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $437cfabf7953f11e$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $3QbnI.useMemo(()=>{
        let trailingPathname = (0, $437cfabf7953f11e$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $e724dc7e3b3eec8a$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $e724dc7e3b3eec8a$export$5d3fca4a98652595($e724dc7e3b3eec8a$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $e724dc7e3b3eec8a$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$var$ResolveAwait, null, children));
}
var $e724dc7e3b3eec8a$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($e724dc7e3b3eec8a$var$AwaitRenderStatus || {});
const $e724dc7e3b3eec8a$var$neverSettledPromise = new Promise(()=>{});
class $e724dc7e3b3eec8a$var$AwaitErrorBoundary extends $3QbnI.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $e724dc7e3b3eec8a$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $e724dc7e3b3eec8a$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $e724dc7e3b3eec8a$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $e724dc7e3b3eec8a$var$AwaitRenderStatus.error : "_data" in promise ? $e724dc7e3b3eec8a$var$AwaitRenderStatus.success : $e724dc7e3b3eec8a$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $e724dc7e3b3eec8a$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $e724dc7e3b3eec8a$var$AwaitRenderStatus.error && promise._error instanceof (0, $437cfabf7953f11e$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $e724dc7e3b3eec8a$var$neverSettledPromise;
        if (status === $e724dc7e3b3eec8a$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $e724dc7e3b3eec8a$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $e724dc7e3b3eec8a$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $3QbnI.createElement($e724dc7e3b3eec8a$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $e724dc7e3b3eec8a$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $e724dc7e3b3eec8a$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $3QbnI.createElement($3QbnI.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $e724dc7e3b3eec8a$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $3QbnI.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $3QbnI.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $3QbnI.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $e724dc7e3b3eec8a$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $e724dc7e3b3eec8a$export$e7b0ac011bb776c6) && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $e724dc7e3b3eec8a$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $e724dc7e3b3eec8a$export$daf73786167a7f72(matches) {
    return $e724dc7e3b3eec8a$var$_renderMatches(matches);
}
function $e724dc7e3b3eec8a$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $3QbnI.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $3QbnI.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $3QbnI.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $e724dc7e3b3eec8a$export$f30f7e456d254e83(routes, opts) {
    return (0, $437cfabf7953f11e$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e724dc7e3b3eec8a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $437cfabf7953f11e$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $e724dc7e3b3eec8a$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $500dda12544a1f09$var$_extends() {
    $500dda12544a1f09$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $500dda12544a1f09$var$_extends.apply(this, arguments);
}
function $500dda12544a1f09$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $500dda12544a1f09$var$defaultMethod = "get";
const $500dda12544a1f09$var$defaultEncType = "application/x-www-form-urlencoded";
function $500dda12544a1f09$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $500dda12544a1f09$var$isButtonElement(object) {
    return $500dda12544a1f09$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $500dda12544a1f09$var$isFormElement(object) {
    return $500dda12544a1f09$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $500dda12544a1f09$var$isInputElement(object) {
    return $500dda12544a1f09$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $500dda12544a1f09$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $500dda12544a1f09$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$500dda12544a1f09$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $500dda12544a1f09$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $500dda12544a1f09$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $500dda12544a1f09$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $500dda12544a1f09$var$_formDataSupportsSubmitter = null;
function $500dda12544a1f09$var$isFormDataSubmitterSupported() {
    if ($500dda12544a1f09$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $500dda12544a1f09$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $500dda12544a1f09$var$_formDataSupportsSubmitter = true;
    }
    return $500dda12544a1f09$var$_formDataSupportsSubmitter;
}
const $500dda12544a1f09$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $500dda12544a1f09$var$getFormEncType(encType) {
    if (encType != null && !$500dda12544a1f09$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $500dda12544a1f09$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($500dda12544a1f09$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $437cfabf7953f11e$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $500dda12544a1f09$var$defaultMethod;
        encType = $500dda12544a1f09$var$getFormEncType(target.getAttribute("enctype")) || $500dda12544a1f09$var$defaultEncType;
        formData = new FormData(target);
    } else if ($500dda12544a1f09$var$isButtonElement(target) || $500dda12544a1f09$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $437cfabf7953f11e$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $500dda12544a1f09$var$defaultMethod;
        encType = $500dda12544a1f09$var$getFormEncType(target.getAttribute("formenctype")) || $500dda12544a1f09$var$getFormEncType(form.getAttribute("enctype")) || $500dda12544a1f09$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$500dda12544a1f09$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($500dda12544a1f09$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $500dda12544a1f09$var$defaultMethod;
        action = null;
        encType = $500dda12544a1f09$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $500dda12544a1f09$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $500dda12544a1f09$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $500dda12544a1f09$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $500dda12544a1f09$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $500dda12544a1f09$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $500dda12544a1f09$export$1f3f55432a00e06d(routes, opts) {
    return (0, $437cfabf7953f11e$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $500dda12544a1f09$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $437cfabf7953f11e$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $500dda12544a1f09$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $e724dc7e3b3eec8a$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $500dda12544a1f09$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $437cfabf7953f11e$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $500dda12544a1f09$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $437cfabf7953f11e$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $500dda12544a1f09$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $e724dc7e3b3eec8a$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $500dda12544a1f09$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $500dda12544a1f09$var$_extends({}, state, {
        errors: $500dda12544a1f09$var$deserializeErrors(state.errors)
    });
    return state;
}
function $500dda12544a1f09$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $437cfabf7953f11e$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $500dda12544a1f09$export$7ad602f0e94e62d1 = /*#__PURE__*/ $3QbnI.createContext({
    isTransitioning: false
});
const $500dda12544a1f09$export$148fd98d095596d4 = /*#__PURE__*/ $3QbnI.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $500dda12544a1f09$var$START_TRANSITION = "startTransition";
const $500dda12544a1f09$var$startTransitionImpl = $3QbnI[$500dda12544a1f09$var$START_TRANSITION];
const $500dda12544a1f09$var$FLUSH_SYNC = "flushSync";
const $500dda12544a1f09$var$flushSyncImpl = $70c58451959e30b3$exports[$500dda12544a1f09$var$FLUSH_SYNC];
const $500dda12544a1f09$var$USE_ID = "useId";
const $500dda12544a1f09$var$useIdImpl = $3QbnI[$500dda12544a1f09$var$USE_ID];
function $500dda12544a1f09$var$startTransitionSafe(cb) {
    if ($500dda12544a1f09$var$startTransitionImpl) $500dda12544a1f09$var$startTransitionImpl(cb);
    else cb();
}
function $500dda12544a1f09$var$flushSyncSafe(cb) {
    if ($500dda12544a1f09$var$flushSyncImpl) $500dda12544a1f09$var$flushSyncImpl(cb);
    else cb();
}
class $500dda12544a1f09$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $500dda12544a1f09$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $3QbnI.useState(router.state);
    let [pendingState, setPendingState] = $3QbnI.useState();
    let [vtContext, setVtContext] = $3QbnI.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $3QbnI.useState();
    let [transition, setTransition] = $3QbnI.useState();
    let [interruption, setInterruption] = $3QbnI.useState();
    let fetcherData = $3QbnI.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $3QbnI.useCallback((cb)=>{
        if (v7_startTransition) $500dda12544a1f09$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $3QbnI.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $500dda12544a1f09$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $500dda12544a1f09$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $500dda12544a1f09$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $500dda12544a1f09$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $500dda12544a1f09$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $3QbnI.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $3QbnI.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $500dda12544a1f09$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $3QbnI.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $3QbnI.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $3QbnI.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $3QbnI.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $3QbnI.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $3QbnI.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $3QbnI.createElement($3QbnI.Fragment, null, /*#__PURE__*/ $3QbnI.createElement((0, $e724dc7e3b3eec8a$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $3QbnI.createElement((0, $e724dc7e3b3eec8a$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $3QbnI.createElement($500dda12544a1f09$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $3QbnI.createElement($500dda12544a1f09$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $3QbnI.createElement((0, $e724dc7e3b3eec8a$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $3QbnI.createElement($500dda12544a1f09$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $500dda12544a1f09$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $e724dc7e3b3eec8a$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $500dda12544a1f09$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $3QbnI.useRef();
    if (historyRef.current == null) historyRef.current = (0, $437cfabf7953f11e$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3QbnI.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3QbnI.useCallback((newState)=>{
        v7_startTransition && $500dda12544a1f09$var$startTransitionImpl ? $500dda12544a1f09$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3QbnI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3QbnI.createElement((0, $e724dc7e3b3eec8a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $500dda12544a1f09$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $3QbnI.useRef();
    if (historyRef.current == null) historyRef.current = (0, $437cfabf7953f11e$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3QbnI.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3QbnI.useCallback((newState)=>{
        v7_startTransition && $500dda12544a1f09$var$startTransitionImpl ? $500dda12544a1f09$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3QbnI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3QbnI.createElement((0, $e724dc7e3b3eec8a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $500dda12544a1f09$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $3QbnI.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3QbnI.useCallback((newState)=>{
        v7_startTransition && $500dda12544a1f09$var$startTransitionImpl ? $500dda12544a1f09$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3QbnI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3QbnI.createElement((0, $e724dc7e3b3eec8a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $500dda12544a1f09$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $500dda12544a1f09$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $500dda12544a1f09$export$a6c7ac8248d6e38a = /*#__PURE__*/ $3QbnI.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $500dda12544a1f09$var$_objectWithoutPropertiesLoose(_ref7, $500dda12544a1f09$var$_excluded);
    let { basename: basename } = $3QbnI.useContext((0, $e724dc7e3b3eec8a$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $500dda12544a1f09$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($500dda12544a1f09$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $437cfabf7953f11e$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $e724dc7e3b3eec8a$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $500dda12544a1f09$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $3QbnI.createElement("a", $500dda12544a1f09$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $500dda12544a1f09$export$b0d92dbee9b5b60d = /*#__PURE__*/ $3QbnI.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $500dda12544a1f09$var$_objectWithoutPropertiesLoose(_ref8, $500dda12544a1f09$var$_excluded2);
    let path = (0, $e724dc7e3b3eec8a$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $e724dc7e3b3eec8a$export$45d76561a5302f2b)();
    let routerState = $3QbnI.useContext((0, $e724dc7e3b3eec8a$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $3QbnI.useContext((0, $e724dc7e3b3eec8a$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $500dda12544a1f09$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $437cfabf7953f11e$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $3QbnI.createElement($500dda12544a1f09$export$a6c7ac8248d6e38a, $500dda12544a1f09$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $500dda12544a1f09$export$a7fed597f4b8afd8 = /*#__PURE__*/ $3QbnI.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $500dda12544a1f09$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $500dda12544a1f09$var$_objectWithoutPropertiesLoose(_ref9, $500dda12544a1f09$var$_excluded3);
    let submit = $500dda12544a1f09$export$47c85c6e3a081d3();
    let formAction = $500dda12544a1f09$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $3QbnI.createElement("form", $500dda12544a1f09$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $500dda12544a1f09$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $500dda12544a1f09$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $500dda12544a1f09$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($500dda12544a1f09$var$DataRouterHook || ($500dda12544a1f09$var$DataRouterHook = {}));
var $500dda12544a1f09$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($500dda12544a1f09$var$DataRouterStateHook || ($500dda12544a1f09$var$DataRouterStateHook = {}));
// Internal hooks
function $500dda12544a1f09$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $500dda12544a1f09$var$useDataRouterContext(hookName) {
    let ctx = $3QbnI.useContext((0, $e724dc7e3b3eec8a$export$3add0d5dce533e2e));
    !ctx && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    return ctx;
}
function $500dda12544a1f09$var$useDataRouterState(hookName) {
    let state = $3QbnI.useContext((0, $e724dc7e3b3eec8a$export$145dfa71566a64dc));
    !state && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $500dda12544a1f09$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    let location = (0, $e724dc7e3b3eec8a$export$45d76561a5302f2b)();
    let path = (0, $e724dc7e3b3eec8a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $3QbnI.useCallback((event)=>{
        if ($500dda12544a1f09$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $437cfabf7953f11e$export$fe53371bee54353d)(location) === (0, $437cfabf7953f11e$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $500dda12544a1f09$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $3QbnI.useRef($500dda12544a1f09$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $3QbnI.useRef(false);
    let location = (0, $e724dc7e3b3eec8a$export$45d76561a5302f2b)();
    let searchParams = $3QbnI.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $500dda12544a1f09$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    let setSearchParams = $3QbnI.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $500dda12544a1f09$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $500dda12544a1f09$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $500dda12544a1f09$var$fetcherId = 0;
let $500dda12544a1f09$var$getUniqueFetcherId = ()=>"__" + String(++$500dda12544a1f09$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $500dda12544a1f09$export$47c85c6e3a081d3() {
    let { router: router } = $500dda12544a1f09$var$useDataRouterContext($500dda12544a1f09$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $3QbnI.useContext((0, $e724dc7e3b3eec8a$export$26749e8557646306));
    let currentRouteId = (0, $e724dc7e3b3eec8a$export$5fc8298006ad9e58)();
    return $3QbnI.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $500dda12544a1f09$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $500dda12544a1f09$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $500dda12544a1f09$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $500dda12544a1f09$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $3QbnI.useContext((0, $e724dc7e3b3eec8a$export$26749e8557646306));
    let routeContext = $3QbnI.useContext((0, $e724dc7e3b3eec8a$export$9072aa6dd1f93057));
    !routeContext && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $500dda12544a1f09$var$_extends({}, (0, $e724dc7e3b3eec8a$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $e724dc7e3b3eec8a$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $437cfabf7953f11e$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $437cfabf7953f11e$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $500dda12544a1f09$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $500dda12544a1f09$var$useDataRouterContext($500dda12544a1f09$var$DataRouterHook.UseFetcher);
    let state = $500dda12544a1f09$var$useDataRouterState($500dda12544a1f09$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $3QbnI.useContext($500dda12544a1f09$export$148fd98d095596d4);
    let route = $3QbnI.useContext((0, $e724dc7e3b3eec8a$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    !route && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $500dda12544a1f09$var$useIdImpl ? $500dda12544a1f09$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $3QbnI.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($500dda12544a1f09$var$getUniqueFetcherId());
    // Registration/cleanup
    $3QbnI.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $3QbnI.useCallback((href, opts)=>{
        !routeId && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $500dda12544a1f09$export$47c85c6e3a081d3();
    let submit = $3QbnI.useCallback((target, opts)=>{
        submitImpl(target, $500dda12544a1f09$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $3QbnI.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $3QbnI.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $3QbnI.createElement($500dda12544a1f09$export$a7fed597f4b8afd8, $500dda12544a1f09$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $437cfabf7953f11e$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $3QbnI.useMemo(()=>$500dda12544a1f09$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $500dda12544a1f09$export$fa996778a3a31087() {
    let state = $500dda12544a1f09$var$useDataRouterState($500dda12544a1f09$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $500dda12544a1f09$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $500dda12544a1f09$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $500dda12544a1f09$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $500dda12544a1f09$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $500dda12544a1f09$var$useDataRouterContext($500dda12544a1f09$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $500dda12544a1f09$var$useDataRouterState($500dda12544a1f09$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $3QbnI.useContext((0, $e724dc7e3b3eec8a$export$26749e8557646306));
    let location = (0, $e724dc7e3b3eec8a$export$45d76561a5302f2b)();
    let matches = (0, $e724dc7e3b3eec8a$export$2378eb7f5ff86053)();
    let navigation = (0, $e724dc7e3b3eec8a$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $3QbnI.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $500dda12544a1f09$var$usePageHide($3QbnI.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $500dda12544a1f09$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $500dda12544a1f09$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($500dda12544a1f09$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3QbnI.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $500dda12544a1f09$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $500dda12544a1f09$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3QbnI.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($500dda12544a1f09$var$_extends({}, location, {
                    pathname: (0, $437cfabf7953f11e$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($500dda12544a1f09$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3QbnI.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $500dda12544a1f09$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $3QbnI.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $500dda12544a1f09$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $3QbnI.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $500dda12544a1f09$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $e724dc7e3b3eec8a$export$b273b3273281a049)(when);
    $3QbnI.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $3QbnI.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $500dda12544a1f09$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $3QbnI.useContext($500dda12544a1f09$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $437cfabf7953f11e$export$3e9cee6b33872309)(false);
    let { basename: basename } = $500dda12544a1f09$var$useDataRouterContext($500dda12544a1f09$var$DataRouterHook.useViewTransitionState);
    let path = (0, $e724dc7e3b3eec8a$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $437cfabf7953f11e$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $437cfabf7953f11e$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $437cfabf7953f11e$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $437cfabf7953f11e$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $3QbnI = parcelRequire("3QbnI");

var $bZSVP = parcelRequire("bZSVP");
var $a1d819e2e51f75d1$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $a1d819e2e51f75d1$var$hasElementType = typeof Element !== "undefined";
var $a1d819e2e51f75d1$var$hasMap = typeof Map === "function";
var $a1d819e2e51f75d1$var$hasSet = typeof Set === "function";
var $a1d819e2e51f75d1$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $a1d819e2e51f75d1$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a1d819e2e51f75d1$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($a1d819e2e51f75d1$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$a1d819e2e51f75d1$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($a1d819e2e51f75d1$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($a1d819e2e51f75d1$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($a1d819e2e51f75d1$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$a1d819e2e51f75d1$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$a1d819e2e51f75d1$exports = function isEqual(a, b) {
    try {
        return $a1d819e2e51f75d1$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


var $20efd006456f682e$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $20efd006456f682e$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$20efd006456f682e$exports = $20efd006456f682e$var$invariant;


var $b4b5c45371e652fc$exports = {};
//
$b4b5c45371e652fc$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $0bd4b6cc11215fa4$var$a() {
    return $0bd4b6cc11215fa4$var$a = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var r = arguments[e];
            for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
        }
        return t;
    }, $0bd4b6cc11215fa4$var$a.apply(this, arguments);
}
function $0bd4b6cc11215fa4$var$s(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, $0bd4b6cc11215fa4$var$c(t, e);
}
function $0bd4b6cc11215fa4$var$c(t, e) {
    return $0bd4b6cc11215fa4$var$c = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, $0bd4b6cc11215fa4$var$c(t, e);
}
function $0bd4b6cc11215fa4$var$u(t, e) {
    if (null == t) return {};
    var r, n, i = {}, o = Object.keys(t);
    for(n = 0; n < o.length; n++)e.indexOf(r = o[n]) >= 0 || (i[r] = t[r]);
    return i;
}
var $0bd4b6cc11215fa4$var$l = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title",
    FRAGMENT: "Symbol(react.fragment)"
}, $0bd4b6cc11215fa4$var$p = {
    rel: [
        "amphtml",
        "canonical",
        "alternate"
    ]
}, $0bd4b6cc11215fa4$var$f = {
    type: [
        "application/ld+json"
    ]
}, $0bd4b6cc11215fa4$var$d = {
    charset: "",
    name: [
        "robots",
        "description"
    ],
    property: [
        "og:type",
        "og:title",
        "og:url",
        "og:image",
        "og:image:alt",
        "og:description",
        "twitter:url",
        "twitter:title",
        "twitter:description",
        "twitter:image",
        "twitter:image:alt",
        "twitter:card",
        "twitter:site"
    ]
}, $0bd4b6cc11215fa4$var$h = Object.keys($0bd4b6cc11215fa4$var$l).map(function(t) {
    return $0bd4b6cc11215fa4$var$l[t];
}), $0bd4b6cc11215fa4$var$m = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
}, $0bd4b6cc11215fa4$var$y = Object.keys($0bd4b6cc11215fa4$var$m).reduce(function(t, e) {
    return t[$0bd4b6cc11215fa4$var$m[e]] = e, t;
}, {}), $0bd4b6cc11215fa4$var$T = function(t, e) {
    for(var r = t.length - 1; r >= 0; r -= 1){
        var n = t[r];
        if (Object.prototype.hasOwnProperty.call(n, e)) return n[e];
    }
    return null;
}, $0bd4b6cc11215fa4$var$g = function(t) {
    var e = $0bd4b6cc11215fa4$var$T(t, $0bd4b6cc11215fa4$var$l.TITLE), r = $0bd4b6cc11215fa4$var$T(t, "titleTemplate");
    if (Array.isArray(e) && (e = e.join("")), r && e) return r.replace(/%s/g, function() {
        return e;
    });
    var n = $0bd4b6cc11215fa4$var$T(t, "defaultTitle");
    return e || n || void 0;
}, $0bd4b6cc11215fa4$var$b = function(t) {
    return $0bd4b6cc11215fa4$var$T(t, "onChangeClientState") || function() {};
}, $0bd4b6cc11215fa4$var$v = function(t, e) {
    return e.filter(function(e) {
        return void 0 !== e[t];
    }).map(function(e) {
        return e[t];
    }).reduce(function(t, e) {
        return $0bd4b6cc11215fa4$var$a({}, t, e);
    }, {});
}, $0bd4b6cc11215fa4$var$A = function(t, e) {
    return e.filter(function(t) {
        return void 0 !== t[$0bd4b6cc11215fa4$var$l.BASE];
    }).map(function(t) {
        return t[$0bd4b6cc11215fa4$var$l.BASE];
    }).reverse().reduce(function(e, r) {
        if (!e.length) for(var n = Object.keys(r), i = 0; i < n.length; i += 1){
            var o = n[i].toLowerCase();
            if (-1 !== t.indexOf(o) && r[o]) return e.concat(r);
        }
        return e;
    }, []);
}, $0bd4b6cc11215fa4$var$C = function(t, e, r) {
    var n = {};
    return r.filter(function(e) {
        return !!Array.isArray(e[t]) || (void 0 !== e[t] && console && "function" == typeof console.warn && console.warn("Helmet: " + t + ' should be of type "Array". Instead found type "' + typeof e[t] + '"'), !1);
    }).map(function(e) {
        return e[t];
    }).reverse().reduce(function(t, r) {
        var i = {};
        r.filter(function(t) {
            for(var r, o = Object.keys(t), a = 0; a < o.length; a += 1){
                var s = o[a], c = s.toLowerCase();
                -1 === e.indexOf(c) || "rel" === r && "canonical" === t[r].toLowerCase() || "rel" === c && "stylesheet" === t[c].toLowerCase() || (r = c), -1 === e.indexOf(s) || "innerHTML" !== s && "cssText" !== s && "itemprop" !== s || (r = s);
            }
            if (!r || !t[r]) return !1;
            var u = t[r].toLowerCase();
            return n[r] || (n[r] = {}), i[r] || (i[r] = {}), !n[r][u] && (i[r][u] = !0, !0);
        }).reverse().forEach(function(e) {
            return t.push(e);
        });
        for(var o = Object.keys(i), s = 0; s < o.length; s += 1){
            var c = o[s], u = $0bd4b6cc11215fa4$var$a({}, n[c], i[c]);
            n[c] = u;
        }
        return t;
    }, []).reverse();
}, $0bd4b6cc11215fa4$var$O = function(t, e) {
    if (Array.isArray(t) && t.length) {
        for(var r = 0; r < t.length; r += 1)if (t[r][e]) return !0;
    }
    return !1;
}, $0bd4b6cc11215fa4$var$S = function(t) {
    return Array.isArray(t) ? t.join("") : t;
}, $0bd4b6cc11215fa4$var$E = function(t, e) {
    return Array.isArray(t) ? t.reduce(function(t, r) {
        return function(t, e) {
            for(var r = Object.keys(t), n = 0; n < r.length; n += 1)if (e[r[n]] && e[r[n]].includes(t[r[n]])) return !0;
            return !1;
        }(r, e) ? t.priority.push(r) : t.default.push(r), t;
    }, {
        priority: [],
        default: []
    }) : {
        default: t
    };
}, $0bd4b6cc11215fa4$var$I = function(t, e) {
    var r;
    return $0bd4b6cc11215fa4$var$a({}, t, ((r = {})[e] = void 0, r));
}, $0bd4b6cc11215fa4$var$P = [
    $0bd4b6cc11215fa4$var$l.NOSCRIPT,
    $0bd4b6cc11215fa4$var$l.SCRIPT,
    $0bd4b6cc11215fa4$var$l.STYLE
], $0bd4b6cc11215fa4$var$w = function(t, e) {
    return void 0 === e && (e = !0), !1 === e ? String(t) : String(t).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}, $0bd4b6cc11215fa4$var$x = function(t) {
    return Object.keys(t).reduce(function(e, r) {
        var n = void 0 !== t[r] ? r + '="' + t[r] + '"' : "" + r;
        return e ? e + " " + n : n;
    }, "");
}, $0bd4b6cc11215fa4$var$L = function(t, e) {
    return void 0 === e && (e = {}), Object.keys(t).reduce(function(e, r) {
        return e[$0bd4b6cc11215fa4$var$m[r] || r] = t[r], e;
    }, e);
}, $0bd4b6cc11215fa4$var$j = function(e, r) {
    return r.map(function(r, n) {
        var i, o = ((i = {
            key: n
        })["data-rh"] = !0, i);
        return Object.keys(r).forEach(function(t) {
            var e = $0bd4b6cc11215fa4$var$m[t] || t;
            "innerHTML" === e || "cssText" === e ? o.dangerouslySetInnerHTML = {
                __html: r.innerHTML || r.cssText
            } : o[e] = r[t];
        }), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(e, o);
    });
}, $0bd4b6cc11215fa4$var$M = function(e, r, n) {
    switch(e){
        case $0bd4b6cc11215fa4$var$l.TITLE:
            return {
                toComponent: function() {
                    var e, n, i, o;
                    return n = r.titleAttributes, (i = {
                        key: e = r.title
                    })["data-rh"] = !0, o = $0bd4b6cc11215fa4$var$L(n, i), [
                        (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($0bd4b6cc11215fa4$var$l.TITLE, o, e)
                    ];
                },
                toString: function() {
                    return function(t, e, r, n) {
                        var i = $0bd4b6cc11215fa4$var$x(r), o = $0bd4b6cc11215fa4$var$S(e);
                        return i ? "<" + t + ' data-rh="true" ' + i + ">" + $0bd4b6cc11215fa4$var$w(o, n) + "</" + t + ">" : "<" + t + ' data-rh="true">' + $0bd4b6cc11215fa4$var$w(o, n) + "</" + t + ">";
                    }(e, r.title, r.titleAttributes, n);
                }
            };
        case "bodyAttributes":
        case "htmlAttributes":
            return {
                toComponent: function() {
                    return $0bd4b6cc11215fa4$var$L(r);
                },
                toString: function() {
                    return $0bd4b6cc11215fa4$var$x(r);
                }
            };
        default:
            return {
                toComponent: function() {
                    return $0bd4b6cc11215fa4$var$j(e, r);
                },
                toString: function() {
                    return function(t, e, r) {
                        return e.reduce(function(e, n) {
                            var i = Object.keys(n).filter(function(t) {
                                return !("innerHTML" === t || "cssText" === t);
                            }).reduce(function(t, e) {
                                var i = void 0 === n[e] ? e : e + '="' + $0bd4b6cc11215fa4$var$w(n[e], r) + '"';
                                return t ? t + " " + i : i;
                            }, ""), o = n.innerHTML || n.cssText || "", a = -1 === $0bd4b6cc11215fa4$var$P.indexOf(t);
                            return e + "<" + t + ' data-rh="true" ' + i + (a ? "/>" : ">" + o + "</" + t + ">");
                        }, "");
                    }(e, r, n);
                }
            };
    }
}, $0bd4b6cc11215fa4$var$k = function(t) {
    var e = t.baseTag, r = t.bodyAttributes, n = t.encode, i = t.htmlAttributes, o = t.noscriptTags, a = t.styleTags, s = t.title, c = void 0 === s ? "" : s, u = t.titleAttributes, h = t.linkTags, m = t.metaTags, y = t.scriptTags, T = {
        toComponent: function() {},
        toString: function() {
            return "";
        }
    };
    if (t.prioritizeSeoTags) {
        var g = function(t) {
            var e = t.linkTags, r = t.scriptTags, n = t.encode, i = $0bd4b6cc11215fa4$var$E(t.metaTags, $0bd4b6cc11215fa4$var$d), o = $0bd4b6cc11215fa4$var$E(e, $0bd4b6cc11215fa4$var$p), a = $0bd4b6cc11215fa4$var$E(r, $0bd4b6cc11215fa4$var$f);
            return {
                priorityMethods: {
                    toComponent: function() {
                        return [].concat($0bd4b6cc11215fa4$var$j($0bd4b6cc11215fa4$var$l.META, i.priority), $0bd4b6cc11215fa4$var$j($0bd4b6cc11215fa4$var$l.LINK, o.priority), $0bd4b6cc11215fa4$var$j($0bd4b6cc11215fa4$var$l.SCRIPT, a.priority));
                    },
                    toString: function() {
                        return $0bd4b6cc11215fa4$var$M($0bd4b6cc11215fa4$var$l.META, i.priority, n) + " " + $0bd4b6cc11215fa4$var$M($0bd4b6cc11215fa4$var$l.LINK, o.priority, n) + " " + $0bd4b6cc11215fa4$var$M($0bd4b6cc11215fa4$var$l.SCRIPT, a.priority, n);
                    }
                },
                metaTags: i.default,
                linkTags: o.default,
                scriptTags: a.default
            };
        }(t);
        T = g.priorityMethods, h = g.linkTags, m = g.metaTags, y = g.scriptTags;
    }
    return {
        priority: T,
        base: $0bd4b6cc11215fa4$var$M($0bd4b6cc11215fa4$var$l.BASE, e, n),
        bodyAttributes: $0bd4b6cc11215fa4$var$M("bodyAttributes", r, n),
        htmlAttributes: $0bd4b6cc11215fa4$var$M("htmlAttributes", i, n),
        link: $0bd4b6cc11215fa4$var$M($0bd4b6cc11215fa4$var$l.LINK, h, n),
        meta: $0bd4b6cc11215fa4$var$M($0bd4b6cc11215fa4$var$l.META, m, n),
        noscript: $0bd4b6cc11215fa4$var$M($0bd4b6cc11215fa4$var$l.NOSCRIPT, o, n),
        script: $0bd4b6cc11215fa4$var$M($0bd4b6cc11215fa4$var$l.SCRIPT, y, n),
        style: $0bd4b6cc11215fa4$var$M($0bd4b6cc11215fa4$var$l.STYLE, a, n),
        title: $0bd4b6cc11215fa4$var$M($0bd4b6cc11215fa4$var$l.TITLE, {
            title: c,
            titleAttributes: u
        }, n)
    };
}, $0bd4b6cc11215fa4$var$H = [], $0bd4b6cc11215fa4$export$a9cf6990c9c7feb9 = function(t, e) {
    var r = this;
    void 0 === e && (e = "undefined" != typeof document), this.instances = [], this.value = {
        setHelmet: function(t) {
            r.context.helmet = t;
        },
        helmetInstances: {
            get: function() {
                return r.canUseDOM ? $0bd4b6cc11215fa4$var$H : r.instances;
            },
            add: function(t) {
                (r.canUseDOM ? $0bd4b6cc11215fa4$var$H : r.instances).push(t);
            },
            remove: function(t) {
                var e = (r.canUseDOM ? $0bd4b6cc11215fa4$var$H : r.instances).indexOf(t);
                (r.canUseDOM ? $0bd4b6cc11215fa4$var$H : r.instances).splice(e, 1);
            }
        }
    }, this.context = t, this.canUseDOM = e, e || (t.helmet = $0bd4b6cc11215fa4$var$k({
        baseTag: [],
        bodyAttributes: {},
        encodeSpecialCharacters: !0,
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: "",
        titleAttributes: {}
    }));
}, $0bd4b6cc11215fa4$var$R = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createContext({}), $0bd4b6cc11215fa4$var$D = (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).shape({
    setHelmet: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    helmetInstances: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).shape({
        get: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        add: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func
    })
}), $0bd4b6cc11215fa4$var$U = "undefined" != typeof document, $0bd4b6cc11215fa4$export$4719288a8f5f7e71 = /*#__PURE__*/ function(e) {
    function r(t) {
        var n;
        return (n = e.call(this, t) || this).helmetData = new $0bd4b6cc11215fa4$export$a9cf6990c9c7feb9(n.props.context, r.canUseDOM), n;
    }
    return $0bd4b6cc11215fa4$var$s(r, e), r.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($0bd4b6cc11215fa4$var$R.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }, r;
}((0, $3QbnI.Component));
$0bd4b6cc11215fa4$export$4719288a8f5f7e71.canUseDOM = $0bd4b6cc11215fa4$var$U, $0bd4b6cc11215fa4$export$4719288a8f5f7e71.propTypes = {
    context: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).shape({
        helmet: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).shape()
    }),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).node.isRequired
}, $0bd4b6cc11215fa4$export$4719288a8f5f7e71.defaultProps = {
    context: {}
}, $0bd4b6cc11215fa4$export$4719288a8f5f7e71.displayName = "HelmetProvider";
var $0bd4b6cc11215fa4$var$Y = function(t, e) {
    var r, n = document.head || document.querySelector($0bd4b6cc11215fa4$var$l.HEAD), i = n.querySelectorAll(t + "[data-rh]"), o = [].slice.call(i), a = [];
    return e && e.length && e.forEach(function(e) {
        var n = document.createElement(t);
        for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && ("innerHTML" === i ? n.innerHTML = e.innerHTML : "cssText" === i ? n.styleSheet ? n.styleSheet.cssText = e.cssText : n.appendChild(document.createTextNode(e.cssText)) : n.setAttribute(i, void 0 === e[i] ? "" : e[i]));
        n.setAttribute("data-rh", "true"), o.some(function(t, e) {
            return r = e, n.isEqualNode(t);
        }) ? o.splice(r, 1) : a.push(n);
    }), o.forEach(function(t) {
        return t.parentNode.removeChild(t);
    }), a.forEach(function(t) {
        return n.appendChild(t);
    }), {
        oldTags: o,
        newTags: a
    };
}, $0bd4b6cc11215fa4$var$B = function(t, e) {
    var r = document.getElementsByTagName(t)[0];
    if (r) {
        for(var n = r.getAttribute("data-rh"), i = n ? n.split(",") : [], o = [].concat(i), a = Object.keys(e), s = 0; s < a.length; s += 1){
            var c = a[s], u = e[c] || "";
            r.getAttribute(c) !== u && r.setAttribute(c, u), -1 === i.indexOf(c) && i.push(c);
            var l = o.indexOf(c);
            -1 !== l && o.splice(l, 1);
        }
        for(var p = o.length - 1; p >= 0; p -= 1)r.removeAttribute(o[p]);
        i.length === o.length ? r.removeAttribute("data-rh") : r.getAttribute("data-rh") !== a.join(",") && r.setAttribute("data-rh", a.join(","));
    }
}, $0bd4b6cc11215fa4$var$K = function(t, e) {
    var r = t.baseTag, n = t.htmlAttributes, i = t.linkTags, o = t.metaTags, a = t.noscriptTags, s = t.onChangeClientState, c = t.scriptTags, u = t.styleTags, p = t.title, f = t.titleAttributes;
    $0bd4b6cc11215fa4$var$B($0bd4b6cc11215fa4$var$l.BODY, t.bodyAttributes), $0bd4b6cc11215fa4$var$B($0bd4b6cc11215fa4$var$l.HTML, n), function(t, e) {
        void 0 !== t && document.title !== t && (document.title = $0bd4b6cc11215fa4$var$S(t)), $0bd4b6cc11215fa4$var$B($0bd4b6cc11215fa4$var$l.TITLE, e);
    }(p, f);
    var d = {
        baseTag: $0bd4b6cc11215fa4$var$Y($0bd4b6cc11215fa4$var$l.BASE, r),
        linkTags: $0bd4b6cc11215fa4$var$Y($0bd4b6cc11215fa4$var$l.LINK, i),
        metaTags: $0bd4b6cc11215fa4$var$Y($0bd4b6cc11215fa4$var$l.META, o),
        noscriptTags: $0bd4b6cc11215fa4$var$Y($0bd4b6cc11215fa4$var$l.NOSCRIPT, a),
        scriptTags: $0bd4b6cc11215fa4$var$Y($0bd4b6cc11215fa4$var$l.SCRIPT, c),
        styleTags: $0bd4b6cc11215fa4$var$Y($0bd4b6cc11215fa4$var$l.STYLE, u)
    }, h = {}, m = {};
    Object.keys(d).forEach(function(t) {
        var e = d[t], r = e.newTags, n = e.oldTags;
        r.length && (h[t] = r), n.length && (m[t] = d[t].oldTags);
    }), e && e(), s(t, h, m);
}, $0bd4b6cc11215fa4$var$_ = null, $0bd4b6cc11215fa4$var$z = /*#__PURE__*/ function(t) {
    function e() {
        for(var e, r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
        return (e = t.call.apply(t, [
            this
        ].concat(n)) || this).rendered = !1, e;
    }
    $0bd4b6cc11215fa4$var$s(e, t);
    var r = e.prototype;
    return r.shouldComponentUpdate = function(t) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($b4b5c45371e652fc$exports)))(t, this.props);
    }, r.componentDidUpdate = function() {
        this.emitChange();
    }, r.componentWillUnmount = function() {
        this.props.context.helmetInstances.remove(this), this.emitChange();
    }, r.emitChange = function() {
        var t, e, r = this.props.context, n = r.setHelmet, i = null, o = (t = r.helmetInstances.get().map(function(t) {
            var e = $0bd4b6cc11215fa4$var$a({}, t.props);
            return delete e.context, e;
        }), {
            baseTag: $0bd4b6cc11215fa4$var$A([
                "href"
            ], t),
            bodyAttributes: $0bd4b6cc11215fa4$var$v("bodyAttributes", t),
            defer: $0bd4b6cc11215fa4$var$T(t, "defer"),
            encode: $0bd4b6cc11215fa4$var$T(t, "encodeSpecialCharacters"),
            htmlAttributes: $0bd4b6cc11215fa4$var$v("htmlAttributes", t),
            linkTags: $0bd4b6cc11215fa4$var$C($0bd4b6cc11215fa4$var$l.LINK, [
                "rel",
                "href"
            ], t),
            metaTags: $0bd4b6cc11215fa4$var$C($0bd4b6cc11215fa4$var$l.META, [
                "name",
                "charset",
                "http-equiv",
                "property",
                "itemprop"
            ], t),
            noscriptTags: $0bd4b6cc11215fa4$var$C($0bd4b6cc11215fa4$var$l.NOSCRIPT, [
                "innerHTML"
            ], t),
            onChangeClientState: $0bd4b6cc11215fa4$var$b(t),
            scriptTags: $0bd4b6cc11215fa4$var$C($0bd4b6cc11215fa4$var$l.SCRIPT, [
                "src",
                "innerHTML"
            ], t),
            styleTags: $0bd4b6cc11215fa4$var$C($0bd4b6cc11215fa4$var$l.STYLE, [
                "cssText"
            ], t),
            title: $0bd4b6cc11215fa4$var$g(t),
            titleAttributes: $0bd4b6cc11215fa4$var$v("titleAttributes", t),
            prioritizeSeoTags: $0bd4b6cc11215fa4$var$O(t, "prioritizeSeoTags")
        });
        $0bd4b6cc11215fa4$export$4719288a8f5f7e71.canUseDOM ? (e = o, $0bd4b6cc11215fa4$var$_ && cancelAnimationFrame($0bd4b6cc11215fa4$var$_), e.defer ? $0bd4b6cc11215fa4$var$_ = requestAnimationFrame(function() {
            $0bd4b6cc11215fa4$var$K(e, function() {
                $0bd4b6cc11215fa4$var$_ = null;
            });
        }) : ($0bd4b6cc11215fa4$var$K(e), $0bd4b6cc11215fa4$var$_ = null)) : $0bd4b6cc11215fa4$var$k && (i = $0bd4b6cc11215fa4$var$k(o)), n(i);
    }, r.init = function() {
        this.rendered || (this.rendered = !0, this.props.context.helmetInstances.add(this), this.emitChange());
    }, r.render = function() {
        return this.init(), null;
    }, e;
}((0, $3QbnI.Component));
$0bd4b6cc11215fa4$var$z.propTypes = {
    context: $0bd4b6cc11215fa4$var$D.isRequired
}, $0bd4b6cc11215fa4$var$z.displayName = "HelmetDispatcher";
var $0bd4b6cc11215fa4$var$F = [
    "children"
], $0bd4b6cc11215fa4$var$G = [
    "children"
], $0bd4b6cc11215fa4$export$dcef8f9bb9a41431 = /*#__PURE__*/ function(e) {
    function r() {
        return e.apply(this, arguments) || this;
    }
    $0bd4b6cc11215fa4$var$s(r, e);
    var o = r.prototype;
    return o.shouldComponentUpdate = function(t) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($a1d819e2e51f75d1$exports)))($0bd4b6cc11215fa4$var$I(this.props, "helmetData"), $0bd4b6cc11215fa4$var$I(t, "helmetData"));
    }, o.mapNestedChildrenToProps = function(t, e) {
        if (!e) return null;
        switch(t.type){
            case $0bd4b6cc11215fa4$var$l.SCRIPT:
            case $0bd4b6cc11215fa4$var$l.NOSCRIPT:
                return {
                    innerHTML: e
                };
            case $0bd4b6cc11215fa4$var$l.STYLE:
                return {
                    cssText: e
                };
            default:
                throw new Error("<" + t.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        }
    }, o.flattenArrayTypeChildren = function(t) {
        var e, r = t.child, n = t.arrayTypeChildren;
        return $0bd4b6cc11215fa4$var$a({}, n, ((e = {})[r.type] = [].concat(n[r.type] || [], [
            $0bd4b6cc11215fa4$var$a({}, t.newChildProps, this.mapNestedChildrenToProps(r, t.nestedChildren))
        ]), e));
    }, o.mapObjectTypeChildren = function(t) {
        var e, r, n = t.child, i = t.newProps, o = t.newChildProps, s = t.nestedChildren;
        switch(n.type){
            case $0bd4b6cc11215fa4$var$l.TITLE:
                return $0bd4b6cc11215fa4$var$a({}, i, ((e = {})[n.type] = s, e.titleAttributes = $0bd4b6cc11215fa4$var$a({}, o), e));
            case $0bd4b6cc11215fa4$var$l.BODY:
                return $0bd4b6cc11215fa4$var$a({}, i, {
                    bodyAttributes: $0bd4b6cc11215fa4$var$a({}, o)
                });
            case $0bd4b6cc11215fa4$var$l.HTML:
                return $0bd4b6cc11215fa4$var$a({}, i, {
                    htmlAttributes: $0bd4b6cc11215fa4$var$a({}, o)
                });
            default:
                return $0bd4b6cc11215fa4$var$a({}, i, ((r = {})[n.type] = $0bd4b6cc11215fa4$var$a({}, o), r));
        }
    }, o.mapArrayTypeChildrenToProps = function(t, e) {
        var r = $0bd4b6cc11215fa4$var$a({}, e);
        return Object.keys(t).forEach(function(e) {
            var n;
            r = $0bd4b6cc11215fa4$var$a({}, r, ((n = {})[e] = t[e], n));
        }), r;
    }, o.warnOnInvalidChildren = function(t, e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($20efd006456f682e$exports)))($0bd4b6cc11215fa4$var$h.some(function(e) {
            return t.type === e;
        }), "function" == typeof t.type ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : "Only elements types " + $0bd4b6cc11215fa4$var$h.join(", ") + " are allowed. Helmet does not support rendering <" + t.type + "> elements. Refer to our API for more information."), (0, (/*@__PURE__*/$parcel$interopDefault($20efd006456f682e$exports)))(!e || "string" == typeof e || Array.isArray(e) && !e.some(function(t) {
            return "string" != typeof t;
        }), "Helmet expects a string as a child of <" + t.type + ">. Did you forget to wrap your children in braces? ( <" + t.type + ">{``}</" + t.type + "> ) Refer to our API for more information."), !0;
    }, o.mapChildrenToProps = function(e, r) {
        var n = this, i = {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Children.forEach(e, function(t) {
            if (t && t.props) {
                var e = t.props, o = e.children, a = $0bd4b6cc11215fa4$var$u(e, $0bd4b6cc11215fa4$var$F), s = Object.keys(a).reduce(function(t, e) {
                    return t[$0bd4b6cc11215fa4$var$y[e] || e] = a[e], t;
                }, {}), c = t.type;
                switch("symbol" == typeof c ? c = c.toString() : n.warnOnInvalidChildren(t, o), c){
                    case $0bd4b6cc11215fa4$var$l.FRAGMENT:
                        r = n.mapChildrenToProps(o, r);
                        break;
                    case $0bd4b6cc11215fa4$var$l.LINK:
                    case $0bd4b6cc11215fa4$var$l.META:
                    case $0bd4b6cc11215fa4$var$l.NOSCRIPT:
                    case $0bd4b6cc11215fa4$var$l.SCRIPT:
                    case $0bd4b6cc11215fa4$var$l.STYLE:
                        i = n.flattenArrayTypeChildren({
                            child: t,
                            arrayTypeChildren: i,
                            newChildProps: s,
                            nestedChildren: o
                        });
                        break;
                    default:
                        r = n.mapObjectTypeChildren({
                            child: t,
                            newProps: r,
                            newChildProps: s,
                            nestedChildren: o
                        });
                }
            }
        }), this.mapArrayTypeChildrenToProps(i, r);
    }, o.render = function() {
        var e = this.props, r = e.children, n = $0bd4b6cc11215fa4$var$u(e, $0bd4b6cc11215fa4$var$G), i = $0bd4b6cc11215fa4$var$a({}, n), o = n.helmetData;
        return r && (i = this.mapChildrenToProps(r, i)), !o || o instanceof $0bd4b6cc11215fa4$export$a9cf6990c9c7feb9 || (o = new $0bd4b6cc11215fa4$export$a9cf6990c9c7feb9(o.context, o.instances)), o ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($0bd4b6cc11215fa4$var$z, $0bd4b6cc11215fa4$var$a({}, i, {
            context: o.value,
            helmetData: void 0
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($0bd4b6cc11215fa4$var$R.Consumer, null, function(e) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($0bd4b6cc11215fa4$var$z, $0bd4b6cc11215fa4$var$a({}, i, {
                context: e
            }));
        });
    }, r;
}((0, $3QbnI.Component));
$0bd4b6cc11215fa4$export$dcef8f9bb9a41431.propTypes = {
    base: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).node
    ]),
    defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    defer: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    link: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object),
    meta: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object),
    noscript: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object),
    onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    script: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    prioritizeSeoTags: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    helmetData: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object
}, $0bd4b6cc11215fa4$export$dcef8f9bb9a41431.defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0,
    prioritizeSeoTags: !1
}, $0bd4b6cc11215fa4$export$dcef8f9bb9a41431.displayName = "Helmet";


var $f7662152ffecbdcb$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f7662152ffecbdcb$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $f7662152ffecbdcb$exports));
try {
    regeneratorRuntime = $f7662152ffecbdcb$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $f7662152ffecbdcb$var$runtime;
    else Function("r", "regeneratorRuntime = r")($f7662152ffecbdcb$var$runtime);
}



var $57utv = parcelRequire("57utv");

var $b92rS = parcelRequire("b92rS");
function $b3373e864b561c70$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b3373e864b561c70$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b3373e864b561c70$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b92rS.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b3373e864b561c70$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $f57e9dc67fd3979f$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $f57e9dc67fd3979f$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $f57e9dc67fd3979f$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $f57e9dc67fd3979f$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $f57e9dc67fd3979f$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $f57e9dc67fd3979f$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $f57e9dc67fd3979f$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f57e9dc67fd3979f$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $f57e9dc67fd3979f$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($f57e9dc67fd3979f$var$isDate(val)) return "date";
    if ($f57e9dc67fd3979f$var$isError(val)) return "error";
    var constructorName = $f57e9dc67fd3979f$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $f57e9dc67fd3979f$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $f57e9dc67fd3979f$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $f57e9dc67fd3979f$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $f57e9dc67fd3979f$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $f57e9dc67fd3979f$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(1));
        return enhancer($f57e9dc67fd3979f$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$f57e9dc67fd3979f$var$isPlainObject(action)) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $f57e9dc67fd3979f$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$f57e9dc67fd3979f$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $f57e9dc67fd3979f$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$f57e9dc67fd3979f$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $f57e9dc67fd3979f$export$8928921ea2d3b126 = $f57e9dc67fd3979f$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $f57e9dc67fd3979f$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $f57e9dc67fd3979f$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $f57e9dc67fd3979f$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$f57e9dc67fd3979f$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $f57e9dc67fd3979f$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $f57e9dc67fd3979f$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $f57e9dc67fd3979f$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $f57e9dc67fd3979f$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $f57e9dc67fd3979f$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $f57e9dc67fd3979f$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $f57e9dc67fd3979f$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $f57e9dc67fd3979f$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $f57e9dc67fd3979f$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $f57e9dc67fd3979f$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $f57e9dc67fd3979f$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $f57e9dc67fd3979f$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $f57e9dc67fd3979f$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $f57e9dc67fd3979f$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $b3373e864b561c70$export$2e2bcd8739ae039)((0, $b3373e864b561c70$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $14e3cef4dea3154c$var$NOT_FOUND = "NOT_FOUND";
function $14e3cef4dea3154c$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $14e3cef4dea3154c$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $14e3cef4dea3154c$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $14e3cef4dea3154c$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $14e3cef4dea3154c$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $14e3cef4dea3154c$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $14e3cef4dea3154c$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $14e3cef4dea3154c$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $14e3cef4dea3154c$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $14e3cef4dea3154c$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $14e3cef4dea3154c$var$createSingletonCache(comparator) : $14e3cef4dea3154c$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $14e3cef4dea3154c$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $025f9f9d97dabd31$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $025f9f9d97dabd31$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $025f9f9d97dabd31$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $025f9f9d97dabd31$export$595d22ed68ca2841 = /* #__PURE__ */ $025f9f9d97dabd31$export$5943f4447f6ef248((0, $14e3cef4dea3154c$export$281bff7f05488aa2));
var $025f9f9d97dabd31$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $025f9f9d97dabd31$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $740334a8efba208f$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $740334a8efba208f$var$thunk = $740334a8efba208f$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$740334a8efba208f$var$thunk.withExtraArgument = $740334a8efba208f$var$createThunkMiddleware;
var $740334a8efba208f$export$2e2bcd8739ae039 = $740334a8efba208f$var$thunk;



var $54X9E = parcelRequire("54X9E");
var $4718778d9db0bd3e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4718778d9db0bd3e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4718778d9db0bd3e$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $4718778d9db0bd3e$var$__defProp = Object.defineProperty;
var $4718778d9db0bd3e$var$__defProps = Object.defineProperties;
var $4718778d9db0bd3e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4718778d9db0bd3e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4718778d9db0bd3e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4718778d9db0bd3e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4718778d9db0bd3e$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $4718778d9db0bd3e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $4718778d9db0bd3e$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($4718778d9db0bd3e$var$__hasOwnProp.call(b, prop)) $4718778d9db0bd3e$var$__defNormalProp(a, prop, b[prop]);
    if ($4718778d9db0bd3e$var$__getOwnPropSymbols) for(var _i = 0, _c = $4718778d9db0bd3e$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($4718778d9db0bd3e$var$__propIsEnum.call(b, prop)) $4718778d9db0bd3e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4718778d9db0bd3e$var$__spreadProps = function(a, b) {
    return $4718778d9db0bd3e$var$__defProps(a, $4718778d9db0bd3e$var$__getOwnPropDescs(b));
};
var $4718778d9db0bd3e$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $4718778d9db0bd3e$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $025f9f9d97dabd31$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $4718778d9db0bd3e$var$__spreadArray([
            (0, $57utv.isDraft)(value) ? (0, $57utv.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $4718778d9db0bd3e$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $f57e9dc67fd3979f$export$f672e0b6f7222cd7;
    return (0, $f57e9dc67fd3979f$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $4718778d9db0bd3e$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $4718778d9db0bd3e$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $4718778d9db0bd3e$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $4718778d9db0bd3e$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $4718778d9db0bd3e$var$__spreadValues($4718778d9db0bd3e$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $4718778d9db0bd3e$export$b956e38827fca970(action) {
    return $4718778d9db0bd3e$export$53b83ca8eaab0383(action) && "type" in action;
}
function $4718778d9db0bd3e$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $4718778d9db0bd3e$var$hasMatchFunction(action);
}
function $4718778d9db0bd3e$export$ebd532f9034651f3(action) {
    return $4718778d9db0bd3e$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($4718778d9db0bd3e$var$isValidKey);
}
function $4718778d9db0bd3e$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $4718778d9db0bd3e$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $4718778d9db0bd3e$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "' + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $4718778d9db0bd3e$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $4718778d9db0bd3e$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $4718778d9db0bd3e$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $4718778d9db0bd3e$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $4718778d9db0bd3e$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $4718778d9db0bd3e$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $4718778d9db0bd3e$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $4718778d9db0bd3e$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $4718778d9db0bd3e$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $4718778d9db0bd3e$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $4718778d9db0bd3e$var$freezeDraftable(val) {
    return (0, $57utv.isDraftable)(val) ? (0, $57utv.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $4718778d9db0bd3e$var$isProduction = true;
var $4718778d9db0bd3e$var$prefix = "Invariant failed";
function $4718778d9db0bd3e$var$invariant(condition, message) {
    if (condition) return;
    if ($4718778d9db0bd3e$var$isProduction) throw new Error($4718778d9db0bd3e$var$prefix);
    throw new Error($4718778d9db0bd3e$var$prefix + ": " + (message || ""));
}
function $4718778d9db0bd3e$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $4718778d9db0bd3e$var$getSerialize(serializer, decycler), indent);
}
function $4718778d9db0bd3e$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $4718778d9db0bd3e$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $4718778d9db0bd3e$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $4718778d9db0bd3e$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $4718778d9db0bd3e$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $4718778d9db0bd3e$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $4718778d9db0bd3e$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $4718778d9db0bd3e$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $4718778d9db0bd3e$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $4718778d9db0bd3e$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $4718778d9db0bd3e$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $4718778d9db0bd3e$export$53b83ca8eaab0383(val);
}
function $4718778d9db0bd3e$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $4718778d9db0bd3e$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $4718778d9db0bd3e$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $4718778d9db0bd3e$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $4718778d9db0bd3e$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$4718778d9db0bd3e$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $4718778d9db0bd3e$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $4718778d9db0bd3e$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $4718778d9db0bd3e$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $4718778d9db0bd3e$export$36c1185aeee5b0a6(options);
    };
}
function $4718778d9db0bd3e$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $4718778d9db0bd3e$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($4718778d9db0bd3e$var$isBoolean(thunk)) middlewareArray.push((0, $740334a8efba208f$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $740334a8efba208f$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $4718778d9db0bd3e$var$IS_PRODUCTION = true;
function $4718778d9db0bd3e$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $4718778d9db0bd3e$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($4718778d9db0bd3e$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $f57e9dc67fd3979f$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$4718778d9db0bd3e$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$4718778d9db0bd3e$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $f57e9dc67fd3979f$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $f57e9dc67fd3979f$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $4718778d9db0bd3e$var$composeWithDevTools($4718778d9db0bd3e$var$__spreadValues({
        trace: !$4718778d9db0bd3e$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $4718778d9db0bd3e$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $4718778d9db0bd3e$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $f57e9dc67fd3979f$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $4718778d9db0bd3e$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $4718778d9db0bd3e$var$isStateFunction(x) {
    return typeof x === "function";
}
var $4718778d9db0bd3e$var$hasWarnedAboutObjectNotation = false;
function $4718778d9db0bd3e$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $4718778d9db0bd3e$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($4718778d9db0bd3e$var$isStateFunction(initialState)) getInitialState = function() {
        return $4718778d9db0bd3e$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $4718778d9db0bd3e$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $4718778d9db0bd3e$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $57utv.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $57utv.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $57utv.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $4718778d9db0bd3e$var$hasWarnedAboutObjectNotation2 = false;
function $4718778d9db0bd3e$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $4718778d9db0bd3e$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $54X9E;
    var initialState = typeof options.initialState == "function" ? options.initialState : $4718778d9db0bd3e$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $4718778d9db0bd3e$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $4718778d9db0bd3e$export$309c7a02b0b0bc62(type, prepareCallback) : $4718778d9db0bd3e$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $4718778d9db0bd3e$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $4718778d9db0bd3e$var$__spreadValues($4718778d9db0bd3e$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $4718778d9db0bd3e$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $4718778d9db0bd3e$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $4718778d9db0bd3e$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($4718778d9db0bd3e$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $4718778d9db0bd3e$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $4718778d9db0bd3e$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $4718778d9db0bd3e$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $4718778d9db0bd3e$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $4718778d9db0bd3e$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $4718778d9db0bd3e$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $4718778d9db0bd3e$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $4718778d9db0bd3e$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $4718778d9db0bd3e$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $4718778d9db0bd3e$var$createSingleArgumentStateOperator(mutator) {
    var operator = $4718778d9db0bd3e$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $4718778d9db0bd3e$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $4718778d9db0bd3e$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $57utv.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $57utv.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $4718778d9db0bd3e$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $4718778d9db0bd3e$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $4718778d9db0bd3e$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $4718778d9db0bd3e$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $4718778d9db0bd3e$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $4718778d9db0bd3e$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $4718778d9db0bd3e$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $4718778d9db0bd3e$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $4718778d9db0bd3e$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $4718778d9db0bd3e$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4718778d9db0bd3e$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $4718778d9db0bd3e$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $4718778d9db0bd3e$var$__spreadValues($4718778d9db0bd3e$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $4718778d9db0bd3e$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $4718778d9db0bd3e$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $4718778d9db0bd3e$var$createStateOperator(addOneMutably),
        addMany: $4718778d9db0bd3e$var$createStateOperator(addManyMutably),
        setOne: $4718778d9db0bd3e$var$createStateOperator(setOneMutably),
        setMany: $4718778d9db0bd3e$var$createStateOperator(setManyMutably),
        setAll: $4718778d9db0bd3e$var$createStateOperator(setAllMutably),
        updateOne: $4718778d9db0bd3e$var$createStateOperator(updateOneMutably),
        updateMany: $4718778d9db0bd3e$var$createStateOperator(updateManyMutably),
        upsertOne: $4718778d9db0bd3e$var$createStateOperator(upsertOneMutably),
        upsertMany: $4718778d9db0bd3e$var$createStateOperator(upsertManyMutably),
        removeOne: $4718778d9db0bd3e$var$createStateOperator(removeOneMutably),
        removeMany: $4718778d9db0bd3e$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $4718778d9db0bd3e$var$createSortedStateAdapter(selectId, sort) {
    var _c = $4718778d9db0bd3e$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $4718778d9db0bd3e$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($4718778d9db0bd3e$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $4718778d9db0bd3e$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4718778d9db0bd3e$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $4718778d9db0bd3e$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $4718778d9db0bd3e$var$createStateOperator(addOneMutably),
        updateOne: $4718778d9db0bd3e$var$createStateOperator(updateOneMutably),
        upsertOne: $4718778d9db0bd3e$var$createStateOperator(upsertOneMutably),
        setOne: $4718778d9db0bd3e$var$createStateOperator(setOneMutably),
        setMany: $4718778d9db0bd3e$var$createStateOperator(setManyMutably),
        setAll: $4718778d9db0bd3e$var$createStateOperator(setAllMutably),
        addMany: $4718778d9db0bd3e$var$createStateOperator(addManyMutably),
        updateMany: $4718778d9db0bd3e$var$createStateOperator(updateManyMutably),
        upsertMany: $4718778d9db0bd3e$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $4718778d9db0bd3e$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $4718778d9db0bd3e$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $4718778d9db0bd3e$var$createInitialStateFactory();
    var selectorsFactory = $4718778d9db0bd3e$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $4718778d9db0bd3e$var$createSortedStateAdapter(selectId, sortComparer) : $4718778d9db0bd3e$var$createUnsortedStateAdapter(selectId);
    return $4718778d9db0bd3e$var$__spreadValues($4718778d9db0bd3e$var$__spreadValues($4718778d9db0bd3e$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $4718778d9db0bd3e$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $4718778d9db0bd3e$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $4718778d9db0bd3e$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $4718778d9db0bd3e$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $4718778d9db0bd3e$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $4718778d9db0bd3e$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $4718778d9db0bd3e$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $4718778d9db0bd3e$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $4718778d9db0bd3e$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $4718778d9db0bd3e$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $4718778d9db0bd3e$var$__spreadProps($4718778d9db0bd3e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $4718778d9db0bd3e$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $4718778d9db0bd3e$var$__spreadProps($4718778d9db0bd3e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $4718778d9db0bd3e$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $4718778d9db0bd3e$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $4718778d9db0bd3e$var$__spreadProps($4718778d9db0bd3e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $4718778d9db0bd3e$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $4718778d9db0bd3e$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $4718778d9db0bd3e$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$4718778d9db0bd3e$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $4718778d9db0bd3e$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $4718778d9db0bd3e$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $4718778d9db0bd3e$var$RejectWithValue) throw result;
                                                if (result instanceof $4718778d9db0bd3e$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $4718778d9db0bd3e$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($4718778d9db0bd3e$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $4718778d9db0bd3e$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $4718778d9db0bd3e$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $4718778d9db0bd3e$var$matches = function(matcher, action) {
    if ($4718778d9db0bd3e$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $4718778d9db0bd3e$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $4718778d9db0bd3e$var$matches(matcher, action);
        });
    };
}
function $4718778d9db0bd3e$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $4718778d9db0bd3e$var$matches(matcher, action);
        });
    };
}
function $4718778d9db0bd3e$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $4718778d9db0bd3e$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $4718778d9db0bd3e$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4718778d9db0bd3e$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$4718778d9db0bd3e$var$isAsyncThunkArray(asyncThunks)) return $4718778d9db0bd3e$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $4718778d9db0bd3e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $4718778d9db0bd3e$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4718778d9db0bd3e$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$4718778d9db0bd3e$var$isAsyncThunkArray(asyncThunks)) return $4718778d9db0bd3e$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $4718778d9db0bd3e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $4718778d9db0bd3e$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $4718778d9db0bd3e$export$9dd1fb32974da385($4718778d9db0bd3e$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$4718778d9db0bd3e$var$isAsyncThunkArray(asyncThunks)) return $4718778d9db0bd3e$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $4718778d9db0bd3e$export$9dd1fb32974da385($4718778d9db0bd3e$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $4718778d9db0bd3e$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4718778d9db0bd3e$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$4718778d9db0bd3e$var$isAsyncThunkArray(asyncThunks)) return $4718778d9db0bd3e$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $4718778d9db0bd3e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $4718778d9db0bd3e$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4718778d9db0bd3e$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$4718778d9db0bd3e$var$isAsyncThunkArray(asyncThunks)) return $4718778d9db0bd3e$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $4718778d9db0bd3e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $4718778d9db0bd3e$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $4718778d9db0bd3e$var$noop = function() {};
var $4718778d9db0bd3e$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $4718778d9db0bd3e$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $4718778d9db0bd3e$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $4718778d9db0bd3e$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $4718778d9db0bd3e$var$task = "task";
var $4718778d9db0bd3e$var$listener = "listener";
var $4718778d9db0bd3e$var$completed = "completed";
var $4718778d9db0bd3e$var$cancelled = "cancelled";
var $4718778d9db0bd3e$var$taskCancelled = "task-" + $4718778d9db0bd3e$var$cancelled;
var $4718778d9db0bd3e$var$taskCompleted = "task-" + $4718778d9db0bd3e$var$completed;
var $4718778d9db0bd3e$var$listenerCancelled = $4718778d9db0bd3e$var$listener + "-" + $4718778d9db0bd3e$var$cancelled;
var $4718778d9db0bd3e$var$listenerCompleted = $4718778d9db0bd3e$var$listener + "-" + $4718778d9db0bd3e$var$completed;
var $4718778d9db0bd3e$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $4718778d9db0bd3e$var$task + " " + $4718778d9db0bd3e$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $4718778d9db0bd3e$var$validateActive = function(signal) {
    if (signal.aborted) throw new $4718778d9db0bd3e$export$cb1bdac908fed7f(signal.reason);
};
function $4718778d9db0bd3e$var$raceWithSignal(signal, promise2) {
    var cleanup = $4718778d9db0bd3e$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $4718778d9db0bd3e$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $4718778d9db0bd3e$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $4718778d9db0bd3e$var$noop;
    });
}
var $4718778d9db0bd3e$var$runTask = function(task2, cleanUp) {
    return $4718778d9db0bd3e$var$__async(void 0, null, function() {
        var value, error_1;
        return $4718778d9db0bd3e$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $4718778d9db0bd3e$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $4718778d9db0bd3e$var$createPause = function(signal) {
    return function(promise2) {
        return $4718778d9db0bd3e$var$catchRejection($4718778d9db0bd3e$var$raceWithSignal(signal, promise2).then(function(output) {
            $4718778d9db0bd3e$var$validateActive(signal);
            return output;
        }));
    };
};
var $4718778d9db0bd3e$var$createDelay = function(signal) {
    var pause = $4718778d9db0bd3e$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $4718778d9db0bd3e$var$assign = Object.assign;
var $4718778d9db0bd3e$var$INTERNAL_NIL_TOKEN = {};
var $4718778d9db0bd3e$var$alm = "listenerMiddleware";
var $4718778d9db0bd3e$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $4718778d9db0bd3e$var$addAbortSignalListener(parentAbortSignal, function() {
            return $4718778d9db0bd3e$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $4718778d9db0bd3e$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $4718778d9db0bd3e$var$runTask(function() {
            return $4718778d9db0bd3e$var$__async(void 0, null, function() {
                var result2;
                return $4718778d9db0bd3e$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $4718778d9db0bd3e$var$validateActive(parentAbortSignal);
                            $4718778d9db0bd3e$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $4718778d9db0bd3e$var$createPause(childAbortController.signal),
                                    delay: $4718778d9db0bd3e$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $4718778d9db0bd3e$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $4718778d9db0bd3e$var$abortControllerWithReason(childAbortController, $4718778d9db0bd3e$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $4718778d9db0bd3e$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $4718778d9db0bd3e$var$abortControllerWithReason(childAbortController, $4718778d9db0bd3e$var$taskCancelled);
            }
        };
    };
};
var $4718778d9db0bd3e$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $4718778d9db0bd3e$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $4718778d9db0bd3e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $4718778d9db0bd3e$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $4718778d9db0bd3e$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $4718778d9db0bd3e$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $4718778d9db0bd3e$var$catchRejection(take(predicate, timeout));
    };
};
var $4718778d9db0bd3e$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $4718778d9db0bd3e$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $4718778d9db0bd3e$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $4718778d9db0bd3e$var$createListenerEntry = function(options) {
    var _c = $4718778d9db0bd3e$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $4718778d9db0bd3e$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $4718778d9db0bd3e$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $4718778d9db0bd3e$var$abortControllerWithReason(controller, $4718778d9db0bd3e$var$listenerCancelled);
    });
};
var $4718778d9db0bd3e$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($4718778d9db0bd3e$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $4718778d9db0bd3e$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $4718778d9db0bd3e$export$f03a6b845d3fb58b = $4718778d9db0bd3e$export$309c7a02b0b0bc62($4718778d9db0bd3e$var$alm + "/add");
var $4718778d9db0bd3e$export$b1b8022855fb2b71 = $4718778d9db0bd3e$export$309c7a02b0b0bc62($4718778d9db0bd3e$var$alm + "/removeAll");
var $4718778d9db0bd3e$export$b03e9483f936dccb = $4718778d9db0bd3e$export$309c7a02b0b0bc62($4718778d9db0bd3e$var$alm + "/remove");
var $4718778d9db0bd3e$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $4718778d9db0bd3e$var$__spreadArray([
        $4718778d9db0bd3e$var$alm + "/error"
    ], args));
};
function $4718778d9db0bd3e$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $4718778d9db0bd3e$var$defaultErrorHandler : _c;
    $4718778d9db0bd3e$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $4718778d9db0bd3e$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $4718778d9db0bd3e$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $4718778d9db0bd3e$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $4718778d9db0bd3e$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $4718778d9db0bd3e$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $4718778d9db0bd3e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $4718778d9db0bd3e$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $4718778d9db0bd3e$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $4718778d9db0bd3e$var$createDelay(internalTaskController.signal),
                                pause: $4718778d9db0bd3e$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $4718778d9db0bd3e$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $4718778d9db0bd3e$var$abortControllerWithReason(controller, $4718778d9db0bd3e$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $4718778d9db0bd3e$export$cb1bdac908fed7f)) $4718778d9db0bd3e$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $4718778d9db0bd3e$var$abortControllerWithReason(internalTaskController, $4718778d9db0bd3e$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $4718778d9db0bd3e$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$4718778d9db0bd3e$export$b956e38827fca970(action)) return next(action);
                if ($4718778d9db0bd3e$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($4718778d9db0bd3e$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($4718778d9db0bd3e$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $4718778d9db0bd3e$var$INTERNAL_NIL_TOKEN) throw new Error($4718778d9db0bd3e$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $4718778d9db0bd3e$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $4718778d9db0bd3e$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $4718778d9db0bd3e$export$8fb31c0f05df007b = "RTK_autoBatch";
var $4718778d9db0bd3e$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$4718778d9db0bd3e$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $4718778d9db0bd3e$var$promise;
var $4718778d9db0bd3e$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($4718778d9db0bd3e$var$promise || ($4718778d9db0bd3e$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $4718778d9db0bd3e$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $4718778d9db0bd3e$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $4718778d9db0bd3e$var$createQueueWithTimer(10);
var $4718778d9db0bd3e$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $4718778d9db0bd3e$var$queueMicrotaskShim : options.type === "raf" ? $4718778d9db0bd3e$var$rAF : options.type === "callback" ? options.queueNotification : $4718778d9db0bd3e$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$4718778d9db0bd3e$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $57utv.enableES5)();



var $bei3G = parcelRequire("bei3G");


var $bei3G = parcelRequire("bei3G");
var $2c6887bb0d65566f$exports = {};

$2c6887bb0d65566f$exports = (parcelRequire("140KF"));


const $e324a700d775dca8$var$instance = (0, (/*@__PURE__*/$parcel$interopDefault($2c6887bb0d65566f$exports))).create({
    baseURL: "https://us-central1-cookbook-beta-46bc5.cloudfunctions.net/api"
});
const $e324a700d775dca8$var$getInstance = ()=>$e324a700d775dca8$var$instance;
var $e324a700d775dca8$export$2e2bcd8739ae039 = $e324a700d775dca8$var$getInstance;
const $e324a700d775dca8$export$57e714f81a2c3d86 = (token)=>{
    $e324a700d775dca8$var$instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};


const $f7bebd229d5ef758$var$baseURL = "/recipes";
const $f7bebd229d5ef758$var$convertFromHttp = (httpRecipe)=>({
        keywords: [],
        stats: {},
        ingredients: "",
        steps: "",
        ...httpRecipe
    });
const $f7bebd229d5ef758$export$703df97410785df3 = async ()=>{
    const response = await (0, $e324a700d775dca8$export$2e2bcd8739ae039)().get($f7bebd229d5ef758$var$baseURL);
    return response.data?.recipes.map($f7bebd229d5ef758$var$convertFromHttp);
};
const $f7bebd229d5ef758$export$2d5f223c4223f53c = async (link)=>{
    const response = await (0, $e324a700d775dca8$export$2e2bcd8739ae039)().get(`${$f7bebd229d5ef758$var$baseURL}/${link}`);
    return $f7bebd229d5ef758$var$convertFromHttp(response.data?.recipe);
};
const $f7bebd229d5ef758$export$99b76c3aa68bee67 = async (url)=>{
    const response = await (0, $e324a700d775dca8$export$2e2bcd8739ae039)().post(`${$f7bebd229d5ef758$var$baseURL}/import`, {
        url: url
    });
    return $f7bebd229d5ef758$var$convertFromHttp(response?.data?.recipe);
};
const $f7bebd229d5ef758$export$5d49599920443c31 = async (recipe)=>{
    const response = await (0, $e324a700d775dca8$export$2e2bcd8739ae039)().post($f7bebd229d5ef758$var$baseURL, recipe);
    return $f7bebd229d5ef758$var$convertFromHttp(response?.data?.recipe);
};
const $f7bebd229d5ef758$export$ff7478e674f87216 = async (recipe)=>(0, $e324a700d775dca8$export$2e2bcd8739ae039)().delete(`${$f7bebd229d5ef758$var$baseURL}/${recipe.id}`);
const $f7bebd229d5ef758$export$1cfc7aad5cb1833b = async ()=>(0, $e324a700d775dca8$export$2e2bcd8739ae039)().delete(`${$f7bebd229d5ef758$var$baseURL}/all`);
const $f7bebd229d5ef758$export$3220ead45e537228 = async (recipe)=>{
    const response = await (0, $e324a700d775dca8$export$2e2bcd8739ae039)().patch(`${$f7bebd229d5ef758$var$baseURL}/${recipe.id}`, recipe);
    return $f7bebd229d5ef758$var$convertFromHttp(response?.data?.recipe);
};


const $87c50e51b43ee465$export$ab19942a146d5d27 = {
    byId: {},
    areFetched: false,
    areFetching: false,
    metadataById: {},
    trashQueue: [],
    recentSearches: []
};
const $87c50e51b43ee465$export$984e0109ba03b979 = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("recipes/fetch", async ()=>$f7bebd229d5ef758$export$703df97410785df3());
const $87c50e51b43ee465$export$ca4ce413890bfca6 = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("recipes/fetchByLink", async (link)=>$f7bebd229d5ef758$export$2d5f223c4223f53c(link));
const $87c50e51b43ee465$export$ce41afa5774ede8f = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("recipes/update", async (recipe)=>$f7bebd229d5ef758$export$3220ead45e537228(recipe));
const $87c50e51b43ee465$export$1f4a3fe10896614d = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("recipes/import", async (url)=>$f7bebd229d5ef758$export$99b76c3aa68bee67(url));
const $87c50e51b43ee465$export$b49cb8e3052514a2 = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("recipes/add", async (recipe)=>$f7bebd229d5ef758$export$5d49599920443c31(recipe));
const $87c50e51b43ee465$export$3bff20c7462e0e4a = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("recipes/delete", async (recipe)=>{
    $f7bebd229d5ef758$export$ff7478e674f87216(recipe);
});
const $87c50e51b43ee465$export$9d5822594f0e234 = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("recipes/deleteAll", async ()=>{
    $f7bebd229d5ef758$export$1cfc7aad5cb1833b();
});
const $87c50e51b43ee465$var$timeouts = {};
const $87c50e51b43ee465$export$a4f60186122287ba = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("recipes/addToDeleteQueue", async (recipe, thunkApi)=>{
    $87c50e51b43ee465$var$timeouts[recipe.id] = setTimeout(()=>{
        thunkApi.dispatch($87c50e51b43ee465$export$3bff20c7462e0e4a(recipe));
    }, 10000);
});
const $87c50e51b43ee465$export$35820ded2652368d = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("recipes/cancelDelete", async (recipe)=>{
    clearTimeout($87c50e51b43ee465$var$timeouts[recipe.id]);
});
const $87c50e51b43ee465$export$4579f09ab2381822 = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("recipes/confirmDelete", async (recipe, thunkApi)=>{
    clearTimeout($87c50e51b43ee465$var$timeouts[recipe.id]);
    await thunkApi.dispatch($87c50e51b43ee465$export$3bff20c7462e0e4a(recipe));
});
const $87c50e51b43ee465$var$initializeMetadata = (state, recipeId)=>{
    if (!state.metadataById[recipeId]) state.metadataById[recipeId] = {
        recipeId: recipeId,
        currentStepIndex: 0,
        servingCount: 42
    };
};
const $87c50e51b43ee465$export$253720aa2de444d8 = (0, $4718778d9db0bd3e$export$4d8d9bd83c24ae8b)({
    name: "recipes",
    initialState: $87c50e51b43ee465$export$ab19942a146d5d27,
    reducers: {
        setRecipeProgress: (state, action)=>{
            const { recipeId: recipeId, index: index } = action.payload;
            $87c50e51b43ee465$var$initializeMetadata(state, recipeId);
            state.metadataById[recipeId].currentStepIndex = index;
        },
        incrementServingCount: (state, action)=>{
            const recipeId = action.payload;
            $87c50e51b43ee465$var$initializeMetadata(state, recipeId);
            state.metadataById[recipeId].servingCount += 1;
        },
        decrementServingCount: (state, action)=>{
            const recipeId = action.payload;
            $87c50e51b43ee465$var$initializeMetadata(state, recipeId);
            if (state.metadataById[recipeId].servingCount > 1) state.metadataById[recipeId].servingCount -= 1;
        },
        addRecentSearch: (state, action)=>{
            const MAX_RECENT_SEARCHES = 10;
            state.recentSearches = (0, $bei3G.uniq)([
                action.payload.id,
                ...state.recentSearches || []
            ]).slice(0, MAX_RECENT_SEARCHES);
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($87c50e51b43ee465$export$984e0109ba03b979.fulfilled, (state, action)=>{
            const recipes = action.payload;
            state.byId = recipes.reduce((acc, recipe)=>({
                    ...acc,
                    [recipe.id]: recipe
                }), {});
            state.areFetched = true;
            state.areFetching = false;
        });
        builder.addCase($87c50e51b43ee465$export$984e0109ba03b979.pending, (state, action)=>{
            state.areFetching = true;
        });
        builder.addCase($87c50e51b43ee465$export$984e0109ba03b979.rejected, (state, action)=>{
            state.areFetching = false;
        });
        builder.addCase($87c50e51b43ee465$export$ca4ce413890bfca6.fulfilled, (state, action)=>{
            const recipe = action.payload;
            state.byId[recipe.id] = recipe;
        });
        builder.addCase($87c50e51b43ee465$export$ce41afa5774ede8f.fulfilled, (state, action)=>{
            const recipe = action.payload;
            state.byId[recipe.id] = recipe;
        });
        builder.addCase($87c50e51b43ee465$export$b49cb8e3052514a2.fulfilled, (state, action)=>{
            const recipe = action.payload;
            state.byId[recipe.id] = recipe;
        });
        builder.addCase($87c50e51b43ee465$export$1f4a3fe10896614d.fulfilled, (state, action)=>{
            const recipe = action.payload;
            state.byId[recipe.id] = recipe;
        });
        builder.addCase($87c50e51b43ee465$export$3bff20c7462e0e4a.fulfilled, (state, action)=>{
            const recipe = action.meta.arg;
            delete state.byId[recipe.id];
            state.trashQueue = state.trashQueue.filter((id)=>id !== recipe.id);
        });
        builder.addCase($87c50e51b43ee465$export$9d5822594f0e234.fulfilled, (state, action)=>{
            state.byId = {};
        });
        builder.addCase($87c50e51b43ee465$export$a4f60186122287ba.fulfilled, (state, action)=>{
            const recipe = action.meta.arg;
            state.trashQueue = [
                ...state.trashQueue,
                recipe.id
            ];
        });
        builder.addCase($87c50e51b43ee465$export$35820ded2652368d.fulfilled, (state, action)=>{
            const recipe = action.meta.arg;
            state.trashQueue = state.trashQueue.filter((id)=>id !== recipe.id);
        });
        builder.addCase($87c50e51b43ee465$export$4579f09ab2381822.fulfilled, (state, action)=>{
            const recipe = action.meta.arg;
            state.trashQueue = state.trashQueue.filter((id)=>id !== recipe.id);
        });
    }
});
var $87c50e51b43ee465$export$2e2bcd8739ae039 = $87c50e51b43ee465$export$253720aa2de444d8.reducer;
const { setRecipeProgress: $87c50e51b43ee465$export$f55860a67b188c55, incrementServingCount: $87c50e51b43ee465$export$986463213963f015, decrementServingCount: $87c50e51b43ee465$export$e4c50eae2a6dada8, addRecentSearch: $87c50e51b43ee465$export$74e99d9695eabee6 } = $87c50e51b43ee465$export$253720aa2de444d8.actions;
const $87c50e51b43ee465$export$c341f62fd7d1eec8 = (state)=>state.recipes.areFetched;
const $87c50e51b43ee465$export$4cba3d1b5f69aff6 = (state)=>state.recipes.areFetching;
const $87c50e51b43ee465$export$3b86e2cc0677644d = (0, $025f9f9d97dabd31$export$595d22ed68ca2841)((state)=>state.recipes.byId, (state)=>state.recipes.trashQueue, (byId, trashQueue)=>Object.values(byId).filter((recipe)=>!trashQueue.includes(recipe.id)));
const $87c50e51b43ee465$var$cleanId = (id)=>id === undefined ? "" : id;
const $87c50e51b43ee465$export$d3bef8d36f4e0ca4 = (state, id)=>state.recipes.byId[$87c50e51b43ee465$var$cleanId(id)];
const $87c50e51b43ee465$export$98c5022c36dab2d1 = (state, id)=>state.recipes.metadataById[$87c50e51b43ee465$var$cleanId(id)]?.currentStepIndex || 0;
const $87c50e51b43ee465$export$7dc7c2b82377d302 = (0, $025f9f9d97dabd31$export$595d22ed68ca2841)($87c50e51b43ee465$export$d3bef8d36f4e0ca4, (state, id)=>state.recipes.metadataById[$87c50e51b43ee465$var$cleanId(id)]?.servingCount, (recipe, servingCount)=>servingCount || recipe?.stats?.servings?.value || 0);
const $87c50e51b43ee465$export$7de8bac5e848e0d5 = (0, $025f9f9d97dabd31$export$595d22ed68ca2841)((state)=>state.recipes.byId, (state)=>state.recipes.trashQueue, (byId, trashQueue)=>trashQueue.map((id)=>byId[id]));
const $87c50e51b43ee465$var$sortByCount = (a, b)=>b[1] - a[1];
const $87c50e51b43ee465$export$f07ccb41aacbe85f = (0, $025f9f9d97dabd31$export$595d22ed68ca2841)($87c50e51b43ee465$export$3b86e2cc0677644d, (recipeList)=>{
    const keywords = Object.entries(recipeList.flatMap((r)=>r.keywords).reduce((acc, keyword)=>({
            ...acc,
            [keyword]: (acc[keyword] || 0) + 1
        }), {}));
    return keywords.filter((k)=>k[1] >= 1).sort($87c50e51b43ee465$var$sortByCount).map((k)=>k[0]);
// .slice(0, 7)
});
const $87c50e51b43ee465$var$EMPTY_STRING_ARRAY = [];
const $87c50e51b43ee465$export$1216255791599668 = (0, $025f9f9d97dabd31$export$595d22ed68ca2841)((state)=>state.recipes.byId, (state)=>state.recipes.recentSearches || $87c50e51b43ee465$var$EMPTY_STRING_ARRAY, (byId, recentSearches)=>recentSearches.map((id)=>byId[id])) // export const getIngredientList = createSelector(
 //   getRecipe,
 //   (state: RootState, id: string | undefined) =>
 //     state.recipes.metadataById[cleanId(id)]?.servingCount,
 //   (recipe, servingCount): Ingredient[] => {
 //     if (!recipe) {
 //       return []
 //     }
 //     if (!servingCount) {
 //       return recipe.ingredients
 //     }
 //     const ratio = servingCount / recipe.stats.servings.value
 //     return recipe.ingredients.map(ingredient => ({
 //       name: ingredient.name,
 //       measure: {
 //         ...ingredient.measure,
 //         value: ingredient.measure.value * ratio,
 //       },
 //     }))
 //   }
 // )
;



const $68690f862a398578$export$83a0dadfe20b1e39 = {
    error: null,
    user: null,
    loading: true
};
const $68690f862a398578$export$a4617a4027bb509b = (0, $4718778d9db0bd3e$export$4d8d9bd83c24ae8b)({
    name: "auth",
    initialState: $68690f862a398578$export$83a0dadfe20b1e39,
    reducers: {
        login: (state, action)=>{
            state.user = action.payload;
            state.loading = false;
        },
        logout: (state)=>{
            state.user = null;
            state.loading = false;
        }
    }
});
const { login: $68690f862a398578$export$596d806903d1f59e, logout: $68690f862a398578$export$a0973bcfe11b05c9 } = $68690f862a398578$export$a4617a4027bb509b.actions;
var $68690f862a398578$export$2e2bcd8739ae039 = $68690f862a398578$export$a4617a4027bb509b.reducer;
const $68690f862a398578$var$getAuthState = (state)=>state.auth;
const $68690f862a398578$export$e5432d4c8eb97ea7 = (state)=>$68690f862a398578$var$getAuthState(state).user;
const $68690f862a398578$export$c7606e33e48d5b45 = (state)=>Boolean(!$68690f862a398578$var$getAuthState(state).loading && $68690f862a398578$export$e5432d4c8eb97ea7(state));
const $68690f862a398578$export$1ee9436926beb645 = (state)=>Boolean(!$68690f862a398578$var$getAuthState(state).loading && !$68690f862a398578$export$e5432d4c8eb97ea7(state));



var $e321886f11c1d045$var$Temperature;
(function(Temperature) {
    Temperature["Farenheit"] = "Farenheit";
    Temperature["Celsius"] = "Celsius";
    Temperature["Unknown"] = "Unknown";
})($e321886f11c1d045$var$Temperature || ($e321886f11c1d045$var$Temperature = {}));
var $e321886f11c1d045$export$2e2bcd8739ae039 = $e321886f11c1d045$var$Temperature;
const $e321886f11c1d045$export$60ed5db8e67798cf = (s)=>{
    const temperature = Object.values($e321886f11c1d045$var$Temperature).find((t)=>t === s);
    return temperature ? $e321886f11c1d045$var$Temperature[temperature] : "Unknown";
};


const $cb3b9bf6a0fb48f2$export$5ce2a8747fe25672 = {
    temperature: (0, $e321886f11c1d045$export$2e2bcd8739ae039).Unknown,
    ingredientTemplate: "",
    automaticImport: false,
    isVoiceControlEnabled: true,
    isGestureControlEnabled: true,
    cookingModeActivatedOnce: false
};
const $cb3b9bf6a0fb48f2$export$c46a7c20cb562183 = (0, $4718778d9db0bd3e$export$4d8d9bd83c24ae8b)({
    name: "settings",
    initialState: $cb3b9bf6a0fb48f2$export$5ce2a8747fe25672,
    reducers: {
        setTemperature: (state, action)=>{
            state.temperature = action.payload;
        },
        setIngredientTemplate: (state, action)=>{
            state.ingredientTemplate = action.payload;
        },
        setAutomaticimport: (state, action)=>{
            state.automaticImport = action.payload;
        },
        enableVoiceControl: (state, action)=>{
            state.isVoiceControlEnabled = action.payload;
        },
        enableGestureControl: (state, action)=>{
            state.isGestureControlEnabled = action.payload;
        },
        cookingModeActivated: (state)=>{
            state.cookingModeActivatedOnce = true;
        }
    }
});
var $cb3b9bf6a0fb48f2$export$2e2bcd8739ae039 = $cb3b9bf6a0fb48f2$export$c46a7c20cb562183.reducer;
const { setTemperature: $cb3b9bf6a0fb48f2$export$1ee9c5b316663b8d, setIngredientTemplate: $cb3b9bf6a0fb48f2$export$8c38d409f26db51, setAutomaticimport: $cb3b9bf6a0fb48f2$export$65467453d81927f1, enableVoiceControl: $cb3b9bf6a0fb48f2$export$8659b451a486d08e, enableGestureControl: $cb3b9bf6a0fb48f2$export$b4f70692e17432c4, cookingModeActivated: $cb3b9bf6a0fb48f2$export$d435de81108eeb49 } = $cb3b9bf6a0fb48f2$export$c46a7c20cb562183.actions;
const $cb3b9bf6a0fb48f2$export$c477e9ee4c36462f = (state)=>state.settings.temperature;
const $cb3b9bf6a0fb48f2$export$95e92655b1210e4b = (state)=>state.settings.ingredientTemplate;
const $cb3b9bf6a0fb48f2$export$6a52d4affff68ee8 = (state)=>state.settings.automaticImport;
const $cb3b9bf6a0fb48f2$export$5991c89680fe146f = (state)=>state.settings.isVoiceControlEnabled;
const $cb3b9bf6a0fb48f2$export$5df00f26df02d21b = (state)=>state.settings.isGestureControlEnabled;
const $cb3b9bf6a0fb48f2$export$e6d9f46a816dd14 = (state)=>state.settings.cookingModeActivatedOnce;




const $648cd7f3213d4eb3$var$baseURL = "/officialWebsites";
const $648cd7f3213d4eb3$export$703df97410785df3 = async ()=>{
    const response = await (0, $e324a700d775dca8$export$2e2bcd8739ae039)().get($648cd7f3213d4eb3$var$baseURL);
    return response.data?.officialWebsites;
};


const $e55c7c0b1e5b11b1$export$6095d8949efe025 = {
    list: []
};
const $e55c7c0b1e5b11b1$export$19857d102f0f8f66 = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("officialWebsites/fetch", async ()=>$648cd7f3213d4eb3$export$703df97410785df3());
const $e55c7c0b1e5b11b1$export$61c0b77a4fe18f8 = (0, $4718778d9db0bd3e$export$4d8d9bd83c24ae8b)({
    name: "officialWebsites",
    initialState: $e55c7c0b1e5b11b1$export$6095d8949efe025,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($e55c7c0b1e5b11b1$export$19857d102f0f8f66.fulfilled, (state, action)=>{
            state.list = action.payload.sort((a, b)=>a.localeCompare(b));
        });
    }
});
var $e55c7c0b1e5b11b1$export$2e2bcd8739ae039 = $e55c7c0b1e5b11b1$export$61c0b77a4fe18f8.reducer;
const $e55c7c0b1e5b11b1$export$e141af6c897b69ed = (state)=>state.officialWebsites.list;



// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $6d563df6b59e7b94$var$getRandomValues;
var $6d563df6b59e7b94$var$rnds8 = new Uint8Array(16);
function $6d563df6b59e7b94$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$6d563df6b59e7b94$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $6d563df6b59e7b94$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$6d563df6b59e7b94$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $6d563df6b59e7b94$var$getRandomValues($6d563df6b59e7b94$var$rnds8);
}


var $db891adcfbe5d309$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $877745ffe9e7002d$var$validate(uuid) {
    return typeof uuid === "string" && (0, $db891adcfbe5d309$export$2e2bcd8739ae039).test(uuid);
}
var $877745ffe9e7002d$export$2e2bcd8739ae039 = $877745ffe9e7002d$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $63333d5d6bdbe8f2$var$byteToHex = [];
for(var $63333d5d6bdbe8f2$var$i = 0; $63333d5d6bdbe8f2$var$i < 256; ++$63333d5d6bdbe8f2$var$i)$63333d5d6bdbe8f2$var$byteToHex.push(($63333d5d6bdbe8f2$var$i + 0x100).toString(16).substr(1));
function $63333d5d6bdbe8f2$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($63333d5d6bdbe8f2$var$byteToHex[arr[offset + 0]] + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 1]] + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 2]] + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 3]] + "-" + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 4]] + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 5]] + "-" + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 6]] + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 7]] + "-" + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 8]] + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 9]] + "-" + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 10]] + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 11]] + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 12]] + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 13]] + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 14]] + $63333d5d6bdbe8f2$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $877745ffe9e7002d$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $63333d5d6bdbe8f2$export$2e2bcd8739ae039 = $63333d5d6bdbe8f2$var$stringify;


function $d827eaefca5d884a$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $6d563df6b59e7b94$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $63333d5d6bdbe8f2$export$2e2bcd8739ae039)(rnds);
}
var $d827eaefca5d884a$export$2e2bcd8739ae039 = $d827eaefca5d884a$var$v4;


const $44f2d6ec1445318c$export$1420237972dd3493 = (timer)=>new Date(timer.endAt).getTime();
const $44f2d6ec1445318c$export$a4665e647d64ae09 = (timer)=>$44f2d6ec1445318c$export$1420237972dd3493(timer) - new Date().getTime();


const $c625d0b818733e5c$export$fb26b2980ae1a225 = (seconds)=>seconds * 1000;
const $c625d0b818733e5c$export$22ca6081c4f2dca9 = (minutes)=>$c625d0b818733e5c$export$fb26b2980ae1a225(minutes * 60);
const $c625d0b818733e5c$export$94476e93d16b1f00 = (hours)=>$c625d0b818733e5c$export$22ca6081c4f2dca9(hours * 60);
const $c625d0b818733e5c$export$a472b8b4d115b7a3 = (duration)=>duration / 1000;
const $c625d0b818733e5c$export$7cda90e0c352f241 = (a, b)=>a - b;
const $c625d0b818733e5c$export$bd4bc282a1a0d264 = (duration, milliseconds)=>duration < milliseconds;


const $c7da68fdd590423e$export$8e086ae02cc9096d = {
    list: []
};
const $c7da68fdd590423e$export$5985f5b4428bec55 = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("timers/start", async ({ recipeId: recipeId, duration: duration })=>{
    const startedAt = new Date();
    return JSON.parse(JSON.stringify({
        recipeId: recipeId,
        id: (0, $d827eaefca5d884a$export$2e2bcd8739ae039)(),
        startedAt: startedAt,
        duration: duration,
        endAt: new Date(startedAt.getTime() + duration)
    }));
});
const $c7da68fdd590423e$export$4d41f7386211339a = (0, $4718778d9db0bd3e$export$6abd22dc03e5063f)("timers/stop", async (timerId)=>{
    return null;
});
const $c7da68fdd590423e$var$timersSlice = (0, $4718778d9db0bd3e$export$4d8d9bd83c24ae8b)({
    name: "timers",
    initialState: $c7da68fdd590423e$export$8e086ae02cc9096d,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($c7da68fdd590423e$export$5985f5b4428bec55.fulfilled, (state, action)=>{
            state.list = [
                ...state.list,
                action.payload
            ].sort((tA, tB)=>(0, $44f2d6ec1445318c$export$1420237972dd3493)(tA) - (0, $44f2d6ec1445318c$export$1420237972dd3493)(tB)).filter((t)=>!(0, $c625d0b818733e5c$export$bd4bc282a1a0d264)((0, $44f2d6ec1445318c$export$a4665e647d64ae09)(t), 0));
        });
        builder.addCase($c7da68fdd590423e$export$4d41f7386211339a.fulfilled, (state, action)=>{
            state.list = state.list.filter((t)=>t.id !== action.meta.arg);
            return state;
        });
    }
});
var $c7da68fdd590423e$export$2e2bcd8739ae039 = $c7da68fdd590423e$var$timersSlice;
const $c7da68fdd590423e$export$b46d238f7ff52d9f = (0, $025f9f9d97dabd31$export$595d22ed68ca2841)((state)=>state.timers.list, (list)=>{
    const timer = list[0];
    if (list.length > 1) {
        if ((0, $c625d0b818733e5c$export$bd4bc282a1a0d264)((0, $44f2d6ec1445318c$export$a4665e647d64ae09)(timer), -1 * (0, $c625d0b818733e5c$export$fb26b2980ae1a225)(10))) return timer;
        return list[1];
    }
    return list[0];
});
const $c7da68fdd590423e$export$65e54288f66ca3eb = (0, $025f9f9d97dabd31$export$595d22ed68ca2841)((state)=>state.timers.list, (list)=>list);


const $deb99e2547214418$export$ea32cbdd559da174 = ()=>{
    try {
        const serializedState = localStorage.getItem("state");
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};
const $deb99e2547214418$export$9f127573fd964184 = (state)=>{
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem("state", serializedState);
    } catch  {
    // ignore write errors
    }
};



const $465de4f5e1bc4524$export$1650419e431d3ba3 = {
    recipes: $87c50e51b43ee465$export$2e2bcd8739ae039,
    auth: $68690f862a398578$export$2e2bcd8739ae039,
    settings: $cb3b9bf6a0fb48f2$export$2e2bcd8739ae039,
    officialWebsites: $e55c7c0b1e5b11b1$export$2e2bcd8739ae039,
    timers: (0, $c7da68fdd590423e$export$2e2bcd8739ae039).reducer
};
const $465de4f5e1bc4524$var$initialState = {
    recipes: (0, $87c50e51b43ee465$export$ab19942a146d5d27),
    settings: (0, $cb3b9bf6a0fb48f2$export$5ce2a8747fe25672),
    officialWebsites: (0, $e55c7c0b1e5b11b1$export$6095d8949efe025)
};
const $465de4f5e1bc4524$var$persistedState = (0, $deb99e2547214418$export$ea32cbdd559da174)();
const $465de4f5e1bc4524$var$preloadedState = $465de4f5e1bc4524$var$persistedState ? {
    ...$465de4f5e1bc4524$var$initialState,
    settings: $465de4f5e1bc4524$var$persistedState.settings,
    recipes: {
        ...$465de4f5e1bc4524$var$initialState.recipes,
        byId: $465de4f5e1bc4524$var$persistedState.recipes.byId,
        recentSearches: $465de4f5e1bc4524$var$persistedState.recipes.recentSearches
    }
} : $465de4f5e1bc4524$var$initialState;
const $465de4f5e1bc4524$var$store = (0, $4718778d9db0bd3e$export$7d8a5b498da695ac)({
    reducer: $465de4f5e1bc4524$export$1650419e431d3ba3,
    preloadedState: $465de4f5e1bc4524$var$preloadedState
});
$465de4f5e1bc4524$var$store.subscribe((0, $bei3G.throttle)(()=>{
    (0, $deb99e2547214418$export$9f127573fd964184)({
        settings: $465de4f5e1bc4524$var$store.getState().settings,
        recipes: {
            byId: $465de4f5e1bc4524$var$store.getState().recipes.byId,
            recentSearches: $465de4f5e1bc4524$var$store.getState().recipes.recentSearches
        }
    });
}, 1000));
var $465de4f5e1bc4524$export$2e2bcd8739ae039 = $465de4f5e1bc4524$var$store;




var $7e80920ce1da97a9$exports = {};
var $fb83d9f40b7d7281$exports = {};
function $fb83d9f40b7d7281$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$fb83d9f40b7d7281$exports = $fb83d9f40b7d7281$var$_arrayWithHoles, $fb83d9f40b7d7281$exports.__esModule = true, $fb83d9f40b7d7281$exports["default"] = $fb83d9f40b7d7281$exports;


var $74820af807e9447d$exports = {};
function $74820af807e9447d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$74820af807e9447d$exports = $74820af807e9447d$var$_iterableToArrayLimit, $74820af807e9447d$exports.__esModule = true, $74820af807e9447d$exports["default"] = $74820af807e9447d$exports;


var $335fb567b2ba84e2$exports = {};
var $37d7765a3eff1a3f$exports = {};
function $37d7765a3eff1a3f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$37d7765a3eff1a3f$exports = $37d7765a3eff1a3f$var$_arrayLikeToArray, $37d7765a3eff1a3f$exports.__esModule = true, $37d7765a3eff1a3f$exports["default"] = $37d7765a3eff1a3f$exports;


function $335fb567b2ba84e2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $37d7765a3eff1a3f$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $37d7765a3eff1a3f$exports(o, minLen);
}
$335fb567b2ba84e2$exports = $335fb567b2ba84e2$var$_unsupportedIterableToArray, $335fb567b2ba84e2$exports.__esModule = true, $335fb567b2ba84e2$exports["default"] = $335fb567b2ba84e2$exports;


var $d3462e127978cfae$exports = {};
function $d3462e127978cfae$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$d3462e127978cfae$exports = $d3462e127978cfae$var$_nonIterableRest, $d3462e127978cfae$exports.__esModule = true, $d3462e127978cfae$exports["default"] = $d3462e127978cfae$exports;


function $7e80920ce1da97a9$var$_slicedToArray(arr, i) {
    return $fb83d9f40b7d7281$exports(arr) || $74820af807e9447d$exports(arr, i) || $335fb567b2ba84e2$exports(arr, i) || $d3462e127978cfae$exports();
}
$7e80920ce1da97a9$exports = $7e80920ce1da97a9$var$_slicedToArray, $7e80920ce1da97a9$exports.__esModule = true, $7e80920ce1da97a9$exports["default"] = $7e80920ce1da97a9$exports;


var $6f3ad28644d1bb51$exports = {};
var $9d1414153a4f7b30$exports = {};
var $715eacc56db0f410$exports = {};
function $715eacc56db0f410$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $715eacc56db0f410$exports = $715eacc56db0f410$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $715eacc56db0f410$exports.__esModule = true, $715eacc56db0f410$exports["default"] = $715eacc56db0f410$exports, $715eacc56db0f410$var$_typeof(o);
}
$715eacc56db0f410$exports = $715eacc56db0f410$var$_typeof, $715eacc56db0f410$exports.__esModule = true, $715eacc56db0f410$exports["default"] = $715eacc56db0f410$exports;


var $9d1414153a4f7b30$var$_typeof = $715eacc56db0f410$exports.default;
var $39bdce72e3a6d1ea$exports = {};

var $39bdce72e3a6d1ea$var$_typeof = $715eacc56db0f410$exports.default;
function $39bdce72e3a6d1ea$var$toPrimitive(t, r) {
    if ("object" != $39bdce72e3a6d1ea$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $39bdce72e3a6d1ea$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$39bdce72e3a6d1ea$exports = $39bdce72e3a6d1ea$var$toPrimitive, $39bdce72e3a6d1ea$exports.__esModule = true, $39bdce72e3a6d1ea$exports["default"] = $39bdce72e3a6d1ea$exports;


function $9d1414153a4f7b30$var$toPropertyKey(t) {
    var i = $39bdce72e3a6d1ea$exports(t, "string");
    return "symbol" == $9d1414153a4f7b30$var$_typeof(i) ? i : i + "";
}
$9d1414153a4f7b30$exports = $9d1414153a4f7b30$var$toPropertyKey, $9d1414153a4f7b30$exports.__esModule = true, $9d1414153a4f7b30$exports["default"] = $9d1414153a4f7b30$exports;


function $6f3ad28644d1bb51$var$_defineProperty(obj, key, value) {
    key = $9d1414153a4f7b30$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$6f3ad28644d1bb51$exports = $6f3ad28644d1bb51$var$_defineProperty, $6f3ad28644d1bb51$exports.__esModule = true, $6f3ad28644d1bb51$exports["default"] = $6f3ad28644d1bb51$exports;



var $3QbnI = parcelRequire("3QbnI");
var $3ed7a4282418a559$exports = {};
function $3ed7a4282418a559$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$3ed7a4282418a559$exports = $3ed7a4282418a559$var$_classCallCheck, $3ed7a4282418a559$exports.__esModule = true, $3ed7a4282418a559$exports["default"] = $3ed7a4282418a559$exports;


var $ec15f5c4656925e2$exports = {};

function $ec15f5c4656925e2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9d1414153a4f7b30$exports(descriptor.key), descriptor);
    }
}
function $ec15f5c4656925e2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ec15f5c4656925e2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ec15f5c4656925e2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$ec15f5c4656925e2$exports = $ec15f5c4656925e2$var$_createClass, $ec15f5c4656925e2$exports.__esModule = true, $ec15f5c4656925e2$exports["default"] = $ec15f5c4656925e2$exports;




var $3QbnI = parcelRequire("3QbnI");
var $158b3ae03be6057d$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $158b3ae03be6057d$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $158b3ae03be6057d$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $158b3ae03be6057d$var$htmlEntities[m];
};
var $158b3ae03be6057d$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($158b3ae03be6057d$var$matchHtmlEntity, $158b3ae03be6057d$var$unescapeHtmlEntity);
};


function $e4acdf289761376f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e4acdf289761376f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e4acdf289761376f$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6f3ad28644d1bb51$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e4acdf289761376f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $e4acdf289761376f$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $158b3ae03be6057d$export$e8bacd2802a88316)
};
var $e4acdf289761376f$var$i18nInstance;
var $e4acdf289761376f$export$5603ab5ced17ce64 = (0, $3QbnI.createContext)();
function $e4acdf289761376f$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $e4acdf289761376f$var$defaultOptions = $e4acdf289761376f$var$_objectSpread($e4acdf289761376f$var$_objectSpread({}, $e4acdf289761376f$var$defaultOptions), options);
}
function $e4acdf289761376f$export$212bb2fc580a90a8() {
    return $e4acdf289761376f$var$defaultOptions;
}
var $e4acdf289761376f$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3ed7a4282418a559$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ec15f5c4656925e2$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $e4acdf289761376f$export$a039134f2fc7e0(instance) {
    $e4acdf289761376f$var$i18nInstance = instance;
}
function $e4acdf289761376f$export$64af334f494c2f47() {
    return $e4acdf289761376f$var$i18nInstance;
}
var $e4acdf289761376f$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        $e4acdf289761376f$export$2e2366488d12e20d(instance.options.react);
        $e4acdf289761376f$export$a039134f2fc7e0(instance);
    }
};
function $e4acdf289761376f$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $e4acdf289761376f$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($e4acdf289761376f$var$_objectSpread($e4acdf289761376f$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $e4acdf289761376f$export$704200e5d0b9e8f() {
    var i18n = $e4acdf289761376f$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $b12f193bb1c338e4$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $b12f193bb1c338e4$var$alreadyWarned = {};
function $b12f193bb1c338e4$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $b12f193bb1c338e4$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $b12f193bb1c338e4$var$alreadyWarned[args[0]] = new Date();
    $b12f193bb1c338e4$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $b12f193bb1c338e4$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    });
}
function $b12f193bb1c338e4$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $b12f193bb1c338e4$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $b12f193bb1c338e4$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $b12f193bb1c338e4$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $b12f193bb1c338e4$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


function $358cc1813d9f14d1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $358cc1813d9f14d1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $358cc1813d9f14d1$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6f3ad28644d1bb51$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $358cc1813d9f14d1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $358cc1813d9f14d1$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $3QbnI.useRef)();
    (0, $3QbnI.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $358cc1813d9f14d1$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $3QbnI.useContext)((0, $e4acdf289761376f$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $e4acdf289761376f$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $e4acdf289761376f$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $b12f193bb1c338e4$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $b12f193bb1c338e4$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $358cc1813d9f14d1$var$_objectSpread($358cc1813d9f14d1$var$_objectSpread($358cc1813d9f14d1$var$_objectSpread({}, (0, $e4acdf289761376f$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $b12f193bb1c338e4$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $3QbnI.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($7e80920ce1da97a9$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $358cc1813d9f14d1$var$usePrevious(joinedNS);
    var isMounted = (0, $3QbnI.useRef)(true);
    (0, $3QbnI.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $b12f193bb1c338e4$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $3QbnI.useRef)(true);
    (0, $3QbnI.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $b12f193bb1c338e4$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}


var $228ef9ae46c6f5ac$var$Roles;
(function(Roles) {
    Roles[Roles["Admin"] = 0] = "Admin";
    Roles[Roles["User"] = 1] = "User";
})($228ef9ae46c6f5ac$var$Roles || ($228ef9ae46c6f5ac$var$Roles = {}));
const $228ef9ae46c6f5ac$export$b0158c8cc002b36f = (user, roles)=>roles.length === 0 || roles.find((r)=>r === user?.role);
var $228ef9ae46c6f5ac$export$2e2bcd8739ae039 = $228ef9ae46c6f5ac$var$Roles;




var $3QbnI = parcelRequire("3QbnI");



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

var $bZSVP = parcelRequire("bZSVP");
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var $c0afaad3fce72815$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
var $c0afaad3fce72815$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function $c0afaad3fce72815$export$2e2bcd8739ae039() {
    if (!$c0afaad3fce72815$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return $c0afaad3fce72815$var$getRandomValues($c0afaad3fce72815$var$rnds8);
}


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $d1d1604500004b6d$var$byteToHex = [];
for(var $d1d1604500004b6d$var$i = 0; $d1d1604500004b6d$var$i < 256; ++$d1d1604500004b6d$var$i)$d1d1604500004b6d$var$byteToHex[$d1d1604500004b6d$var$i] = ($d1d1604500004b6d$var$i + 0x100).toString(16).substr(1);
function $d1d1604500004b6d$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $d1d1604500004b6d$var$byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
var $d1d1604500004b6d$export$2e2bcd8739ae039 = $d1d1604500004b6d$var$bytesToUuid;


function $10e1a74bd817bb9e$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, $c0afaad3fce72815$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, $d1d1604500004b6d$export$2e2bcd8739ae039)(rnds);
}
var $10e1a74bd817bb9e$export$2e2bcd8739ae039 = $10e1a74bd817bb9e$var$v4;


function $7121bc7d538f81b9$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7121bc7d538f81b9$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7121bc7d538f81b9$var$ownKeys$2(Object(source), !0).forEach(function(key) {
            $7121bc7d538f81b9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7121bc7d538f81b9$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7121bc7d538f81b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7121bc7d538f81b9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7121bc7d538f81b9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7121bc7d538f81b9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7121bc7d538f81b9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7121bc7d538f81b9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7121bc7d538f81b9$var$_extends() {
    $7121bc7d538f81b9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7121bc7d538f81b9$var$_extends.apply(this, arguments);
}
function $7121bc7d538f81b9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7121bc7d538f81b9$var$_setPrototypeOf(subClass, superClass);
}
function $7121bc7d538f81b9$var$_getPrototypeOf(o) {
    $7121bc7d538f81b9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7121bc7d538f81b9$var$_getPrototypeOf(o);
}
function $7121bc7d538f81b9$var$_setPrototypeOf(o, p) {
    $7121bc7d538f81b9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7121bc7d538f81b9$var$_setPrototypeOf(o, p);
}
function $7121bc7d538f81b9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7121bc7d538f81b9$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $7121bc7d538f81b9$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7121bc7d538f81b9$var$_assertThisInitialized(self1);
}
function $7121bc7d538f81b9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7121bc7d538f81b9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7121bc7d538f81b9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7121bc7d538f81b9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7121bc7d538f81b9$var$_possibleConstructorReturn(this, result);
    };
}
function $7121bc7d538f81b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7121bc7d538f81b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7121bc7d538f81b9$var$_arrayLikeToArray(o, minLen);
}
function $7121bc7d538f81b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7121bc7d538f81b9$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $7121bc7d538f81b9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $7121bc7d538f81b9$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $7121bc7d538f81b9$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $7121bc7d538f81b9$var$global$a = // eslint-disable-next-line es/no-global-this -- safe
$7121bc7d538f81b9$var$check(typeof globalThis == "object" && globalThis) || $7121bc7d538f81b9$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$7121bc7d538f81b9$var$check(typeof self == "object" && self) || $7121bc7d538f81b9$var$check(typeof $7121bc7d538f81b9$var$commonjsGlobal == "object" && $7121bc7d538f81b9$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $7121bc7d538f81b9$var$objectGetOwnPropertyDescriptor = {};
var $7121bc7d538f81b9$var$fails$9 = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $7121bc7d538f81b9$var$fails$8 = $7121bc7d538f81b9$var$fails$9;
// Detect IE8's incomplete defineProperty implementation
var $7121bc7d538f81b9$var$descriptors = !$7121bc7d538f81b9$var$fails$8(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $7121bc7d538f81b9$var$fails$7 = $7121bc7d538f81b9$var$fails$9;
var $7121bc7d538f81b9$var$functionBindNative = !$7121bc7d538f81b9$var$fails$7(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $7121bc7d538f81b9$var$NATIVE_BIND$2 = $7121bc7d538f81b9$var$functionBindNative;
var $7121bc7d538f81b9$var$call$4 = Function.prototype.call;
var $7121bc7d538f81b9$var$functionCall = $7121bc7d538f81b9$var$NATIVE_BIND$2 ? $7121bc7d538f81b9$var$call$4.bind($7121bc7d538f81b9$var$call$4) : function() {
    return $7121bc7d538f81b9$var$call$4.apply($7121bc7d538f81b9$var$call$4, arguments);
};
var $7121bc7d538f81b9$var$objectPropertyIsEnumerable = {};
var $7121bc7d538f81b9$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $7121bc7d538f81b9$var$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $7121bc7d538f81b9$var$NASHORN_BUG = $7121bc7d538f81b9$var$getOwnPropertyDescriptor$1 && !$7121bc7d538f81b9$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$7121bc7d538f81b9$var$objectPropertyIsEnumerable.f = $7121bc7d538f81b9$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $7121bc7d538f81b9$var$getOwnPropertyDescriptor$1(this, V);
    return !!descriptor && descriptor.enumerable;
} : $7121bc7d538f81b9$var$$propertyIsEnumerable;
var $7121bc7d538f81b9$var$createPropertyDescriptor$2 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $7121bc7d538f81b9$var$NATIVE_BIND$1 = $7121bc7d538f81b9$var$functionBindNative;
var $7121bc7d538f81b9$var$FunctionPrototype$1 = Function.prototype;
var $7121bc7d538f81b9$var$call$3 = $7121bc7d538f81b9$var$FunctionPrototype$1.call;
var $7121bc7d538f81b9$var$uncurryThisWithBind = $7121bc7d538f81b9$var$NATIVE_BIND$1 && $7121bc7d538f81b9$var$FunctionPrototype$1.bind.bind($7121bc7d538f81b9$var$call$3, $7121bc7d538f81b9$var$call$3);
var $7121bc7d538f81b9$var$functionUncurryThisRaw = function(fn) {
    return $7121bc7d538f81b9$var$NATIVE_BIND$1 ? $7121bc7d538f81b9$var$uncurryThisWithBind(fn) : function() {
        return $7121bc7d538f81b9$var$call$3.apply(fn, arguments);
    };
};
var $7121bc7d538f81b9$var$uncurryThisRaw$1 = $7121bc7d538f81b9$var$functionUncurryThisRaw;
var $7121bc7d538f81b9$var$toString$1 = $7121bc7d538f81b9$var$uncurryThisRaw$1({}.toString);
var $7121bc7d538f81b9$var$stringSlice = $7121bc7d538f81b9$var$uncurryThisRaw$1("".slice);
var $7121bc7d538f81b9$var$classofRaw$2 = function(it) {
    return $7121bc7d538f81b9$var$stringSlice($7121bc7d538f81b9$var$toString$1(it), 8, -1);
};
var $7121bc7d538f81b9$var$classofRaw$1 = $7121bc7d538f81b9$var$classofRaw$2;
var $7121bc7d538f81b9$var$uncurryThisRaw = $7121bc7d538f81b9$var$functionUncurryThisRaw;
var $7121bc7d538f81b9$var$functionUncurryThis = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($7121bc7d538f81b9$var$classofRaw$1(fn) === "Function") return $7121bc7d538f81b9$var$uncurryThisRaw(fn);
};
var $7121bc7d538f81b9$var$uncurryThis$9 = $7121bc7d538f81b9$var$functionUncurryThis;
var $7121bc7d538f81b9$var$fails$6 = $7121bc7d538f81b9$var$fails$9;
var $7121bc7d538f81b9$var$classof$3 = $7121bc7d538f81b9$var$classofRaw$2;
var $7121bc7d538f81b9$var$$Object$3 = Object;
var $7121bc7d538f81b9$var$split = $7121bc7d538f81b9$var$uncurryThis$9("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $7121bc7d538f81b9$var$indexedObject = $7121bc7d538f81b9$var$fails$6(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$7121bc7d538f81b9$var$$Object$3("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $7121bc7d538f81b9$var$classof$3(it) == "String" ? $7121bc7d538f81b9$var$split(it, "") : $7121bc7d538f81b9$var$$Object$3(it);
} : $7121bc7d538f81b9$var$$Object$3;
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var $7121bc7d538f81b9$var$isNullOrUndefined$2 = function(it) {
    return it === null || it === undefined;
};
var $7121bc7d538f81b9$var$isNullOrUndefined$1 = $7121bc7d538f81b9$var$isNullOrUndefined$2;
var $7121bc7d538f81b9$var$$TypeError$5 = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $7121bc7d538f81b9$var$requireObjectCoercible$2 = function(it) {
    if ($7121bc7d538f81b9$var$isNullOrUndefined$1(it)) throw $7121bc7d538f81b9$var$$TypeError$5("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $7121bc7d538f81b9$var$IndexedObject$1 = $7121bc7d538f81b9$var$indexedObject;
var $7121bc7d538f81b9$var$requireObjectCoercible$1 = $7121bc7d538f81b9$var$requireObjectCoercible$2;
var $7121bc7d538f81b9$var$toIndexedObject$4 = function(it) {
    return $7121bc7d538f81b9$var$IndexedObject$1($7121bc7d538f81b9$var$requireObjectCoercible$1(it));
};
var $7121bc7d538f81b9$var$documentAll$2 = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $7121bc7d538f81b9$var$IS_HTMLDDA = typeof $7121bc7d538f81b9$var$documentAll$2 == "undefined" && $7121bc7d538f81b9$var$documentAll$2 !== undefined;
var $7121bc7d538f81b9$var$documentAll_1 = {
    all: $7121bc7d538f81b9$var$documentAll$2,
    IS_HTMLDDA: $7121bc7d538f81b9$var$IS_HTMLDDA
};
var $7121bc7d538f81b9$var$$documentAll$1 = $7121bc7d538f81b9$var$documentAll_1;
var $7121bc7d538f81b9$var$documentAll$1 = $7121bc7d538f81b9$var$$documentAll$1.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $7121bc7d538f81b9$var$isCallable$c = $7121bc7d538f81b9$var$$documentAll$1.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $7121bc7d538f81b9$var$documentAll$1;
} : function(argument) {
    return typeof argument == "function";
};
var $7121bc7d538f81b9$var$isCallable$b = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$$documentAll = $7121bc7d538f81b9$var$documentAll_1;
var $7121bc7d538f81b9$var$documentAll = $7121bc7d538f81b9$var$$documentAll.all;
var $7121bc7d538f81b9$var$isObject$6 = $7121bc7d538f81b9$var$$documentAll.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $7121bc7d538f81b9$var$isCallable$b(it) || it === $7121bc7d538f81b9$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $7121bc7d538f81b9$var$isCallable$b(it);
};
var $7121bc7d538f81b9$var$global$9 = $7121bc7d538f81b9$var$global$a;
var $7121bc7d538f81b9$var$isCallable$a = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$aFunction = function(argument) {
    return $7121bc7d538f81b9$var$isCallable$a(argument) ? argument : undefined;
};
var $7121bc7d538f81b9$var$getBuiltIn$5 = function(namespace, method) {
    return arguments.length < 2 ? $7121bc7d538f81b9$var$aFunction($7121bc7d538f81b9$var$global$9[namespace]) : $7121bc7d538f81b9$var$global$9[namespace] && $7121bc7d538f81b9$var$global$9[namespace][method];
};
var $7121bc7d538f81b9$var$uncurryThis$8 = $7121bc7d538f81b9$var$functionUncurryThis;
var $7121bc7d538f81b9$var$objectIsPrototypeOf = $7121bc7d538f81b9$var$uncurryThis$8({}.isPrototypeOf);
var $7121bc7d538f81b9$var$getBuiltIn$4 = $7121bc7d538f81b9$var$getBuiltIn$5;
var $7121bc7d538f81b9$var$engineUserAgent = $7121bc7d538f81b9$var$getBuiltIn$4("navigator", "userAgent") || "";
var $7121bc7d538f81b9$var$global$8 = $7121bc7d538f81b9$var$global$a;
var $7121bc7d538f81b9$var$userAgent = $7121bc7d538f81b9$var$engineUserAgent;
var $7121bc7d538f81b9$var$process = $7121bc7d538f81b9$var$global$8.process;
var $7121bc7d538f81b9$var$Deno = $7121bc7d538f81b9$var$global$8.Deno;
var $7121bc7d538f81b9$var$versions = $7121bc7d538f81b9$var$process && $7121bc7d538f81b9$var$process.versions || $7121bc7d538f81b9$var$Deno && $7121bc7d538f81b9$var$Deno.version;
var $7121bc7d538f81b9$var$v8 = $7121bc7d538f81b9$var$versions && $7121bc7d538f81b9$var$versions.v8;
var $7121bc7d538f81b9$var$match, $7121bc7d538f81b9$var$version;
if ($7121bc7d538f81b9$var$v8) {
    $7121bc7d538f81b9$var$match = $7121bc7d538f81b9$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $7121bc7d538f81b9$var$version = $7121bc7d538f81b9$var$match[0] > 0 && $7121bc7d538f81b9$var$match[0] < 4 ? 1 : +($7121bc7d538f81b9$var$match[0] + $7121bc7d538f81b9$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$7121bc7d538f81b9$var$version && $7121bc7d538f81b9$var$userAgent) {
    $7121bc7d538f81b9$var$match = $7121bc7d538f81b9$var$userAgent.match(/Edge\/(\d+)/);
    if (!$7121bc7d538f81b9$var$match || $7121bc7d538f81b9$var$match[1] >= 74) {
        $7121bc7d538f81b9$var$match = $7121bc7d538f81b9$var$userAgent.match(/Chrome\/(\d+)/);
        if ($7121bc7d538f81b9$var$match) $7121bc7d538f81b9$var$version = +$7121bc7d538f81b9$var$match[1];
    }
}
var $7121bc7d538f81b9$var$engineV8Version = $7121bc7d538f81b9$var$version;
/* eslint-disable es/no-symbol -- required for testing */ var $7121bc7d538f81b9$var$V8_VERSION = $7121bc7d538f81b9$var$engineV8Version;
var $7121bc7d538f81b9$var$fails$5 = $7121bc7d538f81b9$var$fails$9;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var $7121bc7d538f81b9$var$symbolConstructorDetection = !!Object.getOwnPropertySymbols && !$7121bc7d538f81b9$var$fails$5(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $7121bc7d538f81b9$var$V8_VERSION && $7121bc7d538f81b9$var$V8_VERSION < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var $7121bc7d538f81b9$var$NATIVE_SYMBOL$1 = $7121bc7d538f81b9$var$symbolConstructorDetection;
var $7121bc7d538f81b9$var$useSymbolAsUid = $7121bc7d538f81b9$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $7121bc7d538f81b9$var$getBuiltIn$3 = $7121bc7d538f81b9$var$getBuiltIn$5;
var $7121bc7d538f81b9$var$isCallable$9 = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$isPrototypeOf = $7121bc7d538f81b9$var$objectIsPrototypeOf;
var $7121bc7d538f81b9$var$USE_SYMBOL_AS_UID$1 = $7121bc7d538f81b9$var$useSymbolAsUid;
var $7121bc7d538f81b9$var$$Object$2 = Object;
var $7121bc7d538f81b9$var$isSymbol$2 = $7121bc7d538f81b9$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $7121bc7d538f81b9$var$getBuiltIn$3("Symbol");
    return $7121bc7d538f81b9$var$isCallable$9($Symbol) && $7121bc7d538f81b9$var$isPrototypeOf($Symbol.prototype, $7121bc7d538f81b9$var$$Object$2(it));
};
var $7121bc7d538f81b9$var$$String$1 = String;
var $7121bc7d538f81b9$var$tryToString$1 = function(argument) {
    try {
        return $7121bc7d538f81b9$var$$String$1(argument);
    } catch (error) {
        return "Object";
    }
};
var $7121bc7d538f81b9$var$isCallable$8 = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$tryToString = $7121bc7d538f81b9$var$tryToString$1;
var $7121bc7d538f81b9$var$$TypeError$4 = TypeError;
// `Assert: IsCallable(argument) is true`
var $7121bc7d538f81b9$var$aCallable$2 = function(argument) {
    if ($7121bc7d538f81b9$var$isCallable$8(argument)) return argument;
    throw $7121bc7d538f81b9$var$$TypeError$4($7121bc7d538f81b9$var$tryToString(argument) + " is not a function");
};
var $7121bc7d538f81b9$var$aCallable$1 = $7121bc7d538f81b9$var$aCallable$2;
var $7121bc7d538f81b9$var$isNullOrUndefined = $7121bc7d538f81b9$var$isNullOrUndefined$2;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $7121bc7d538f81b9$var$getMethod$1 = function(V, P) {
    var func = V[P];
    return $7121bc7d538f81b9$var$isNullOrUndefined(func) ? undefined : $7121bc7d538f81b9$var$aCallable$1(func);
};
var $7121bc7d538f81b9$var$call$2 = $7121bc7d538f81b9$var$functionCall;
var $7121bc7d538f81b9$var$isCallable$7 = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$isObject$5 = $7121bc7d538f81b9$var$isObject$6;
var $7121bc7d538f81b9$var$$TypeError$3 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $7121bc7d538f81b9$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $7121bc7d538f81b9$var$isCallable$7(fn = input.toString) && !$7121bc7d538f81b9$var$isObject$5(val = $7121bc7d538f81b9$var$call$2(fn, input))) return val;
    if ($7121bc7d538f81b9$var$isCallable$7(fn = input.valueOf) && !$7121bc7d538f81b9$var$isObject$5(val = $7121bc7d538f81b9$var$call$2(fn, input))) return val;
    if (pref !== "string" && $7121bc7d538f81b9$var$isCallable$7(fn = input.toString) && !$7121bc7d538f81b9$var$isObject$5(val = $7121bc7d538f81b9$var$call$2(fn, input))) return val;
    throw $7121bc7d538f81b9$var$$TypeError$3("Can't convert object to primitive value");
};
var $7121bc7d538f81b9$var$shared$3 = {
    exports: {}
};
var $7121bc7d538f81b9$var$global$7 = $7121bc7d538f81b9$var$global$a;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $7121bc7d538f81b9$var$defineProperty$2 = Object.defineProperty;
var $7121bc7d538f81b9$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $7121bc7d538f81b9$var$defineProperty$2($7121bc7d538f81b9$var$global$7, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $7121bc7d538f81b9$var$global$7[key] = value;
    }
    return value;
};
var $7121bc7d538f81b9$var$global$6 = $7121bc7d538f81b9$var$global$a;
var $7121bc7d538f81b9$var$defineGlobalProperty$2 = $7121bc7d538f81b9$var$defineGlobalProperty$3;
var $7121bc7d538f81b9$var$SHARED = "__core-js_shared__";
var $7121bc7d538f81b9$var$store$3 = $7121bc7d538f81b9$var$global$6[$7121bc7d538f81b9$var$SHARED] || $7121bc7d538f81b9$var$defineGlobalProperty$2($7121bc7d538f81b9$var$SHARED, {});
var $7121bc7d538f81b9$var$sharedStore = $7121bc7d538f81b9$var$store$3;
var $7121bc7d538f81b9$var$store$2 = $7121bc7d538f81b9$var$sharedStore;
($7121bc7d538f81b9$var$shared$3.exports = function(key, value) {
    return $7121bc7d538f81b9$var$store$2[key] || ($7121bc7d538f81b9$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.25.5",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $7121bc7d538f81b9$var$requireObjectCoercible = $7121bc7d538f81b9$var$requireObjectCoercible$2;
var $7121bc7d538f81b9$var$$Object$1 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $7121bc7d538f81b9$var$toObject$2 = function(argument) {
    return $7121bc7d538f81b9$var$$Object$1($7121bc7d538f81b9$var$requireObjectCoercible(argument));
};
var $7121bc7d538f81b9$var$uncurryThis$7 = $7121bc7d538f81b9$var$functionUncurryThis;
var $7121bc7d538f81b9$var$toObject$1 = $7121bc7d538f81b9$var$toObject$2;
var $7121bc7d538f81b9$var$hasOwnProperty = $7121bc7d538f81b9$var$uncurryThis$7({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var $7121bc7d538f81b9$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $7121bc7d538f81b9$var$hasOwnProperty($7121bc7d538f81b9$var$toObject$1(it), key);
};
var $7121bc7d538f81b9$var$uncurryThis$6 = $7121bc7d538f81b9$var$functionUncurryThis;
var $7121bc7d538f81b9$var$id = 0;
var $7121bc7d538f81b9$var$postfix = Math.random();
var $7121bc7d538f81b9$var$toString = $7121bc7d538f81b9$var$uncurryThis$6(1.0.toString);
var $7121bc7d538f81b9$var$uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $7121bc7d538f81b9$var$toString(++$7121bc7d538f81b9$var$id + $7121bc7d538f81b9$var$postfix, 36);
};
var $7121bc7d538f81b9$var$global$5 = $7121bc7d538f81b9$var$global$a;
var $7121bc7d538f81b9$var$shared$2 = $7121bc7d538f81b9$var$shared$3.exports;
var $7121bc7d538f81b9$var$hasOwn$6 = $7121bc7d538f81b9$var$hasOwnProperty_1;
var $7121bc7d538f81b9$var$uid$1 = $7121bc7d538f81b9$var$uid$2;
var $7121bc7d538f81b9$var$NATIVE_SYMBOL = $7121bc7d538f81b9$var$symbolConstructorDetection;
var $7121bc7d538f81b9$var$USE_SYMBOL_AS_UID = $7121bc7d538f81b9$var$useSymbolAsUid;
var $7121bc7d538f81b9$var$WellKnownSymbolsStore = $7121bc7d538f81b9$var$shared$2("wks");
var $7121bc7d538f81b9$var$Symbol$1 = $7121bc7d538f81b9$var$global$5.Symbol;
var $7121bc7d538f81b9$var$symbolFor = $7121bc7d538f81b9$var$Symbol$1 && $7121bc7d538f81b9$var$Symbol$1["for"];
var $7121bc7d538f81b9$var$createWellKnownSymbol = $7121bc7d538f81b9$var$USE_SYMBOL_AS_UID ? $7121bc7d538f81b9$var$Symbol$1 : $7121bc7d538f81b9$var$Symbol$1 && $7121bc7d538f81b9$var$Symbol$1.withoutSetter || $7121bc7d538f81b9$var$uid$1;
var $7121bc7d538f81b9$var$wellKnownSymbol$5 = function(name) {
    if (!$7121bc7d538f81b9$var$hasOwn$6($7121bc7d538f81b9$var$WellKnownSymbolsStore, name) || !($7121bc7d538f81b9$var$NATIVE_SYMBOL || typeof $7121bc7d538f81b9$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($7121bc7d538f81b9$var$NATIVE_SYMBOL && $7121bc7d538f81b9$var$hasOwn$6($7121bc7d538f81b9$var$Symbol$1, name)) $7121bc7d538f81b9$var$WellKnownSymbolsStore[name] = $7121bc7d538f81b9$var$Symbol$1[name];
        else if ($7121bc7d538f81b9$var$USE_SYMBOL_AS_UID && $7121bc7d538f81b9$var$symbolFor) $7121bc7d538f81b9$var$WellKnownSymbolsStore[name] = $7121bc7d538f81b9$var$symbolFor(description);
        else $7121bc7d538f81b9$var$WellKnownSymbolsStore[name] = $7121bc7d538f81b9$var$createWellKnownSymbol(description);
    }
    return $7121bc7d538f81b9$var$WellKnownSymbolsStore[name];
};
var $7121bc7d538f81b9$var$call$1 = $7121bc7d538f81b9$var$functionCall;
var $7121bc7d538f81b9$var$isObject$4 = $7121bc7d538f81b9$var$isObject$6;
var $7121bc7d538f81b9$var$isSymbol$1 = $7121bc7d538f81b9$var$isSymbol$2;
var $7121bc7d538f81b9$var$getMethod = $7121bc7d538f81b9$var$getMethod$1;
var $7121bc7d538f81b9$var$ordinaryToPrimitive = $7121bc7d538f81b9$var$ordinaryToPrimitive$1;
var $7121bc7d538f81b9$var$wellKnownSymbol$4 = $7121bc7d538f81b9$var$wellKnownSymbol$5;
var $7121bc7d538f81b9$var$$TypeError$2 = TypeError;
var $7121bc7d538f81b9$var$TO_PRIMITIVE = $7121bc7d538f81b9$var$wellKnownSymbol$4("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $7121bc7d538f81b9$var$toPrimitive$1 = function(input, pref) {
    if (!$7121bc7d538f81b9$var$isObject$4(input) || $7121bc7d538f81b9$var$isSymbol$1(input)) return input;
    var exoticToPrim = $7121bc7d538f81b9$var$getMethod(input, $7121bc7d538f81b9$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $7121bc7d538f81b9$var$call$1(exoticToPrim, input, pref);
        if (!$7121bc7d538f81b9$var$isObject$4(result) || $7121bc7d538f81b9$var$isSymbol$1(result)) return result;
        throw $7121bc7d538f81b9$var$$TypeError$2("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $7121bc7d538f81b9$var$ordinaryToPrimitive(input, pref);
};
var $7121bc7d538f81b9$var$toPrimitive = $7121bc7d538f81b9$var$toPrimitive$1;
var $7121bc7d538f81b9$var$isSymbol = $7121bc7d538f81b9$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $7121bc7d538f81b9$var$toPropertyKey$2 = function(argument) {
    var key = $7121bc7d538f81b9$var$toPrimitive(argument, "string");
    return $7121bc7d538f81b9$var$isSymbol(key) ? key : key + "";
};
var $7121bc7d538f81b9$var$global$4 = $7121bc7d538f81b9$var$global$a;
var $7121bc7d538f81b9$var$isObject$3 = $7121bc7d538f81b9$var$isObject$6;
var $7121bc7d538f81b9$var$document$1 = $7121bc7d538f81b9$var$global$4.document;
// typeof document.createElement is 'object' in old IE
var $7121bc7d538f81b9$var$EXISTS$1 = $7121bc7d538f81b9$var$isObject$3($7121bc7d538f81b9$var$document$1) && $7121bc7d538f81b9$var$isObject$3($7121bc7d538f81b9$var$document$1.createElement);
var $7121bc7d538f81b9$var$documentCreateElement$1 = function(it) {
    return $7121bc7d538f81b9$var$EXISTS$1 ? $7121bc7d538f81b9$var$document$1.createElement(it) : {};
};
var $7121bc7d538f81b9$var$DESCRIPTORS$7 = $7121bc7d538f81b9$var$descriptors;
var $7121bc7d538f81b9$var$fails$4 = $7121bc7d538f81b9$var$fails$9;
var $7121bc7d538f81b9$var$createElement = $7121bc7d538f81b9$var$documentCreateElement$1;
// Thanks to IE8 for its funny defineProperty
var $7121bc7d538f81b9$var$ie8DomDefine = !$7121bc7d538f81b9$var$DESCRIPTORS$7 && !$7121bc7d538f81b9$var$fails$4(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($7121bc7d538f81b9$var$createElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $7121bc7d538f81b9$var$DESCRIPTORS$6 = $7121bc7d538f81b9$var$descriptors;
var $7121bc7d538f81b9$var$call = $7121bc7d538f81b9$var$functionCall;
var $7121bc7d538f81b9$var$propertyIsEnumerableModule = $7121bc7d538f81b9$var$objectPropertyIsEnumerable;
var $7121bc7d538f81b9$var$createPropertyDescriptor$1 = $7121bc7d538f81b9$var$createPropertyDescriptor$2;
var $7121bc7d538f81b9$var$toIndexedObject$3 = $7121bc7d538f81b9$var$toIndexedObject$4;
var $7121bc7d538f81b9$var$toPropertyKey$1 = $7121bc7d538f81b9$var$toPropertyKey$2;
var $7121bc7d538f81b9$var$hasOwn$5 = $7121bc7d538f81b9$var$hasOwnProperty_1;
var $7121bc7d538f81b9$var$IE8_DOM_DEFINE$1 = $7121bc7d538f81b9$var$ie8DomDefine;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $7121bc7d538f81b9$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$7121bc7d538f81b9$var$objectGetOwnPropertyDescriptor.f = $7121bc7d538f81b9$var$DESCRIPTORS$6 ? $7121bc7d538f81b9$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $7121bc7d538f81b9$var$toIndexedObject$3(O);
    P = $7121bc7d538f81b9$var$toPropertyKey$1(P);
    if ($7121bc7d538f81b9$var$IE8_DOM_DEFINE$1) try {
        return $7121bc7d538f81b9$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($7121bc7d538f81b9$var$hasOwn$5(O, P)) return $7121bc7d538f81b9$var$createPropertyDescriptor$1(!$7121bc7d538f81b9$var$call($7121bc7d538f81b9$var$propertyIsEnumerableModule.f, O, P), O[P]);
};
var $7121bc7d538f81b9$var$objectDefineProperty = {};
var $7121bc7d538f81b9$var$DESCRIPTORS$5 = $7121bc7d538f81b9$var$descriptors;
var $7121bc7d538f81b9$var$fails$3 = $7121bc7d538f81b9$var$fails$9;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $7121bc7d538f81b9$var$v8PrototypeDefineBug = $7121bc7d538f81b9$var$DESCRIPTORS$5 && $7121bc7d538f81b9$var$fails$3(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $7121bc7d538f81b9$var$isObject$2 = $7121bc7d538f81b9$var$isObject$6;
var $7121bc7d538f81b9$var$$String = String;
var $7121bc7d538f81b9$var$$TypeError$1 = TypeError;
// `Assert: Type(argument) is Object`
var $7121bc7d538f81b9$var$anObject$4 = function(argument) {
    if ($7121bc7d538f81b9$var$isObject$2(argument)) return argument;
    throw $7121bc7d538f81b9$var$$TypeError$1($7121bc7d538f81b9$var$$String(argument) + " is not an object");
};
var $7121bc7d538f81b9$var$DESCRIPTORS$4 = $7121bc7d538f81b9$var$descriptors;
var $7121bc7d538f81b9$var$IE8_DOM_DEFINE = $7121bc7d538f81b9$var$ie8DomDefine;
var $7121bc7d538f81b9$var$V8_PROTOTYPE_DEFINE_BUG$1 = $7121bc7d538f81b9$var$v8PrototypeDefineBug;
var $7121bc7d538f81b9$var$anObject$3 = $7121bc7d538f81b9$var$anObject$4;
var $7121bc7d538f81b9$var$toPropertyKey = $7121bc7d538f81b9$var$toPropertyKey$2;
var $7121bc7d538f81b9$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $7121bc7d538f81b9$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $7121bc7d538f81b9$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $7121bc7d538f81b9$var$ENUMERABLE = "enumerable";
var $7121bc7d538f81b9$var$CONFIGURABLE$1 = "configurable";
var $7121bc7d538f81b9$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$7121bc7d538f81b9$var$objectDefineProperty.f = $7121bc7d538f81b9$var$DESCRIPTORS$4 ? $7121bc7d538f81b9$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $7121bc7d538f81b9$var$anObject$3(O);
    P = $7121bc7d538f81b9$var$toPropertyKey(P);
    $7121bc7d538f81b9$var$anObject$3(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $7121bc7d538f81b9$var$WRITABLE in Attributes && !Attributes[$7121bc7d538f81b9$var$WRITABLE]) {
        var current = $7121bc7d538f81b9$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$7121bc7d538f81b9$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $7121bc7d538f81b9$var$CONFIGURABLE$1 in Attributes ? Attributes[$7121bc7d538f81b9$var$CONFIGURABLE$1] : current[$7121bc7d538f81b9$var$CONFIGURABLE$1],
                enumerable: $7121bc7d538f81b9$var$ENUMERABLE in Attributes ? Attributes[$7121bc7d538f81b9$var$ENUMERABLE] : current[$7121bc7d538f81b9$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $7121bc7d538f81b9$var$$defineProperty(O, P, Attributes);
} : $7121bc7d538f81b9$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $7121bc7d538f81b9$var$anObject$3(O);
    P = $7121bc7d538f81b9$var$toPropertyKey(P);
    $7121bc7d538f81b9$var$anObject$3(Attributes);
    if ($7121bc7d538f81b9$var$IE8_DOM_DEFINE) try {
        return $7121bc7d538f81b9$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $7121bc7d538f81b9$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $7121bc7d538f81b9$var$DESCRIPTORS$3 = $7121bc7d538f81b9$var$descriptors;
var $7121bc7d538f81b9$var$definePropertyModule$3 = $7121bc7d538f81b9$var$objectDefineProperty;
var $7121bc7d538f81b9$var$createPropertyDescriptor = $7121bc7d538f81b9$var$createPropertyDescriptor$2;
var $7121bc7d538f81b9$var$createNonEnumerableProperty$2 = $7121bc7d538f81b9$var$DESCRIPTORS$3 ? function(object, key, value) {
    return $7121bc7d538f81b9$var$definePropertyModule$3.f(object, key, $7121bc7d538f81b9$var$createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $7121bc7d538f81b9$var$makeBuiltIn$2 = {
    exports: {}
};
var $7121bc7d538f81b9$var$DESCRIPTORS$2 = $7121bc7d538f81b9$var$descriptors;
var $7121bc7d538f81b9$var$hasOwn$4 = $7121bc7d538f81b9$var$hasOwnProperty_1;
var $7121bc7d538f81b9$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $7121bc7d538f81b9$var$getDescriptor = $7121bc7d538f81b9$var$DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;
var $7121bc7d538f81b9$var$EXISTS = $7121bc7d538f81b9$var$hasOwn$4($7121bc7d538f81b9$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $7121bc7d538f81b9$var$PROPER = $7121bc7d538f81b9$var$EXISTS && (function something() {}).name === "something";
var $7121bc7d538f81b9$var$CONFIGURABLE = $7121bc7d538f81b9$var$EXISTS && (!$7121bc7d538f81b9$var$DESCRIPTORS$2 || $7121bc7d538f81b9$var$DESCRIPTORS$2 && $7121bc7d538f81b9$var$getDescriptor($7121bc7d538f81b9$var$FunctionPrototype, "name").configurable);
var $7121bc7d538f81b9$var$functionName = {
    EXISTS: $7121bc7d538f81b9$var$EXISTS,
    PROPER: $7121bc7d538f81b9$var$PROPER,
    CONFIGURABLE: $7121bc7d538f81b9$var$CONFIGURABLE
};
var $7121bc7d538f81b9$var$uncurryThis$5 = $7121bc7d538f81b9$var$functionUncurryThis;
var $7121bc7d538f81b9$var$isCallable$6 = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$store$1 = $7121bc7d538f81b9$var$sharedStore;
var $7121bc7d538f81b9$var$functionToString = $7121bc7d538f81b9$var$uncurryThis$5(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$7121bc7d538f81b9$var$isCallable$6($7121bc7d538f81b9$var$store$1.inspectSource)) $7121bc7d538f81b9$var$store$1.inspectSource = function(it) {
    return $7121bc7d538f81b9$var$functionToString(it);
};
var $7121bc7d538f81b9$var$inspectSource$2 = $7121bc7d538f81b9$var$store$1.inspectSource;
var $7121bc7d538f81b9$var$global$3 = $7121bc7d538f81b9$var$global$a;
var $7121bc7d538f81b9$var$isCallable$5 = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$WeakMap$1 = $7121bc7d538f81b9$var$global$3.WeakMap;
var $7121bc7d538f81b9$var$weakMapBasicDetection = $7121bc7d538f81b9$var$isCallable$5($7121bc7d538f81b9$var$WeakMap$1) && /native code/.test(String($7121bc7d538f81b9$var$WeakMap$1));
var $7121bc7d538f81b9$var$shared$1 = $7121bc7d538f81b9$var$shared$3.exports;
var $7121bc7d538f81b9$var$uid = $7121bc7d538f81b9$var$uid$2;
var $7121bc7d538f81b9$var$keys = $7121bc7d538f81b9$var$shared$1("keys");
var $7121bc7d538f81b9$var$sharedKey$2 = function(key) {
    return $7121bc7d538f81b9$var$keys[key] || ($7121bc7d538f81b9$var$keys[key] = $7121bc7d538f81b9$var$uid(key));
};
var $7121bc7d538f81b9$var$hiddenKeys$4 = {};
var $7121bc7d538f81b9$var$NATIVE_WEAK_MAP = $7121bc7d538f81b9$var$weakMapBasicDetection;
var $7121bc7d538f81b9$var$global$2 = $7121bc7d538f81b9$var$global$a;
var $7121bc7d538f81b9$var$isObject$1 = $7121bc7d538f81b9$var$isObject$6;
var $7121bc7d538f81b9$var$createNonEnumerableProperty$1 = $7121bc7d538f81b9$var$createNonEnumerableProperty$2;
var $7121bc7d538f81b9$var$hasOwn$3 = $7121bc7d538f81b9$var$hasOwnProperty_1;
var $7121bc7d538f81b9$var$shared = $7121bc7d538f81b9$var$sharedStore;
var $7121bc7d538f81b9$var$sharedKey$1 = $7121bc7d538f81b9$var$sharedKey$2;
var $7121bc7d538f81b9$var$hiddenKeys$3 = $7121bc7d538f81b9$var$hiddenKeys$4;
var $7121bc7d538f81b9$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $7121bc7d538f81b9$var$TypeError$1 = $7121bc7d538f81b9$var$global$2.TypeError;
var $7121bc7d538f81b9$var$WeakMap = $7121bc7d538f81b9$var$global$2.WeakMap;
var $7121bc7d538f81b9$var$set, $7121bc7d538f81b9$var$get, $7121bc7d538f81b9$var$has;
var $7121bc7d538f81b9$var$enforce = function(it) {
    return $7121bc7d538f81b9$var$has(it) ? $7121bc7d538f81b9$var$get(it) : $7121bc7d538f81b9$var$set(it, {});
};
var $7121bc7d538f81b9$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$7121bc7d538f81b9$var$isObject$1(it) || (state = $7121bc7d538f81b9$var$get(it)).type !== TYPE) throw $7121bc7d538f81b9$var$TypeError$1("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($7121bc7d538f81b9$var$NATIVE_WEAK_MAP || $7121bc7d538f81b9$var$shared.state) {
    var $7121bc7d538f81b9$var$store = $7121bc7d538f81b9$var$shared.state || ($7121bc7d538f81b9$var$shared.state = new $7121bc7d538f81b9$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $7121bc7d538f81b9$var$store.get = $7121bc7d538f81b9$var$store.get;
    $7121bc7d538f81b9$var$store.has = $7121bc7d538f81b9$var$store.has;
    $7121bc7d538f81b9$var$store.set = $7121bc7d538f81b9$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $7121bc7d538f81b9$var$set = function(it, metadata) {
        if ($7121bc7d538f81b9$var$store.has(it)) throw $7121bc7d538f81b9$var$TypeError$1($7121bc7d538f81b9$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $7121bc7d538f81b9$var$store.set(it, metadata);
        return metadata;
    };
    $7121bc7d538f81b9$var$get = function(it) {
        return $7121bc7d538f81b9$var$store.get(it) || {};
    };
    $7121bc7d538f81b9$var$has = function(it) {
        return $7121bc7d538f81b9$var$store.has(it);
    };
} else {
    var $7121bc7d538f81b9$var$STATE = $7121bc7d538f81b9$var$sharedKey$1("state");
    $7121bc7d538f81b9$var$hiddenKeys$3[$7121bc7d538f81b9$var$STATE] = true;
    $7121bc7d538f81b9$var$set = function(it, metadata) {
        if ($7121bc7d538f81b9$var$hasOwn$3(it, $7121bc7d538f81b9$var$STATE)) throw $7121bc7d538f81b9$var$TypeError$1($7121bc7d538f81b9$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $7121bc7d538f81b9$var$createNonEnumerableProperty$1(it, $7121bc7d538f81b9$var$STATE, metadata);
        return metadata;
    };
    $7121bc7d538f81b9$var$get = function(it) {
        return $7121bc7d538f81b9$var$hasOwn$3(it, $7121bc7d538f81b9$var$STATE) ? it[$7121bc7d538f81b9$var$STATE] : {};
    };
    $7121bc7d538f81b9$var$has = function(it) {
        return $7121bc7d538f81b9$var$hasOwn$3(it, $7121bc7d538f81b9$var$STATE);
    };
}
var $7121bc7d538f81b9$var$internalState = {
    set: $7121bc7d538f81b9$var$set,
    get: $7121bc7d538f81b9$var$get,
    has: $7121bc7d538f81b9$var$has,
    enforce: $7121bc7d538f81b9$var$enforce,
    getterFor: $7121bc7d538f81b9$var$getterFor
};
var $7121bc7d538f81b9$var$fails$2 = $7121bc7d538f81b9$var$fails$9;
var $7121bc7d538f81b9$var$isCallable$4 = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$hasOwn$2 = $7121bc7d538f81b9$var$hasOwnProperty_1;
var $7121bc7d538f81b9$var$DESCRIPTORS$1 = $7121bc7d538f81b9$var$descriptors;
var $7121bc7d538f81b9$var$CONFIGURABLE_FUNCTION_NAME = $7121bc7d538f81b9$var$functionName.CONFIGURABLE;
var $7121bc7d538f81b9$var$inspectSource$1 = $7121bc7d538f81b9$var$inspectSource$2;
var $7121bc7d538f81b9$var$InternalStateModule = $7121bc7d538f81b9$var$internalState;
var $7121bc7d538f81b9$var$enforceInternalState = $7121bc7d538f81b9$var$InternalStateModule.enforce;
var $7121bc7d538f81b9$var$getInternalState = $7121bc7d538f81b9$var$InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $7121bc7d538f81b9$var$defineProperty$1 = Object.defineProperty;
var $7121bc7d538f81b9$var$CONFIGURABLE_LENGTH = $7121bc7d538f81b9$var$DESCRIPTORS$1 && !$7121bc7d538f81b9$var$fails$2(function() {
    return $7121bc7d538f81b9$var$defineProperty$1(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $7121bc7d538f81b9$var$TEMPLATE = String(String).split("String");
var $7121bc7d538f81b9$var$makeBuiltIn$1 = $7121bc7d538f81b9$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$7121bc7d538f81b9$var$hasOwn$2(value, "name") || $7121bc7d538f81b9$var$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($7121bc7d538f81b9$var$DESCRIPTORS$1) $7121bc7d538f81b9$var$defineProperty$1(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($7121bc7d538f81b9$var$CONFIGURABLE_LENGTH && options && $7121bc7d538f81b9$var$hasOwn$2(options, "arity") && value.length !== options.arity) $7121bc7d538f81b9$var$defineProperty$1(value, "length", {
        value: options.arity
    });
    try {
        if (options && $7121bc7d538f81b9$var$hasOwn$2(options, "constructor") && options.constructor) {
            if ($7121bc7d538f81b9$var$DESCRIPTORS$1) $7121bc7d538f81b9$var$defineProperty$1(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $7121bc7d538f81b9$var$enforceInternalState(value);
    if (!$7121bc7d538f81b9$var$hasOwn$2(state, "source")) state.source = $7121bc7d538f81b9$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $7121bc7d538f81b9$var$makeBuiltIn$1(function toString() {
    return $7121bc7d538f81b9$var$isCallable$4(this) && $7121bc7d538f81b9$var$getInternalState(this).source || $7121bc7d538f81b9$var$inspectSource$1(this);
}, "toString");
var $7121bc7d538f81b9$var$isCallable$3 = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$definePropertyModule$2 = $7121bc7d538f81b9$var$objectDefineProperty;
var $7121bc7d538f81b9$var$makeBuiltIn = $7121bc7d538f81b9$var$makeBuiltIn$2.exports;
var $7121bc7d538f81b9$var$defineGlobalProperty$1 = $7121bc7d538f81b9$var$defineGlobalProperty$3;
var $7121bc7d538f81b9$var$defineBuiltIn$1 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($7121bc7d538f81b9$var$isCallable$3(value)) $7121bc7d538f81b9$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $7121bc7d538f81b9$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $7121bc7d538f81b9$var$definePropertyModule$2.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $7121bc7d538f81b9$var$objectGetOwnPropertyNames = {};
var $7121bc7d538f81b9$var$ceil = Math.ceil;
var $7121bc7d538f81b9$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var $7121bc7d538f81b9$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $7121bc7d538f81b9$var$floor : $7121bc7d538f81b9$var$ceil)(n);
};
var $7121bc7d538f81b9$var$trunc = $7121bc7d538f81b9$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $7121bc7d538f81b9$var$toIntegerOrInfinity$2 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $7121bc7d538f81b9$var$trunc(number);
};
var $7121bc7d538f81b9$var$toIntegerOrInfinity$1 = $7121bc7d538f81b9$var$toIntegerOrInfinity$2;
var $7121bc7d538f81b9$var$max = Math.max;
var $7121bc7d538f81b9$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $7121bc7d538f81b9$var$toAbsoluteIndex$1 = function(index, length) {
    var integer = $7121bc7d538f81b9$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $7121bc7d538f81b9$var$max(integer + length, 0) : $7121bc7d538f81b9$var$min$1(integer, length);
};
var $7121bc7d538f81b9$var$toIntegerOrInfinity = $7121bc7d538f81b9$var$toIntegerOrInfinity$2;
var $7121bc7d538f81b9$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $7121bc7d538f81b9$var$toLength$1 = function(argument) {
    return argument > 0 ? $7121bc7d538f81b9$var$min($7121bc7d538f81b9$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $7121bc7d538f81b9$var$toLength = $7121bc7d538f81b9$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $7121bc7d538f81b9$var$lengthOfArrayLike$2 = function(obj) {
    return $7121bc7d538f81b9$var$toLength(obj.length);
};
var $7121bc7d538f81b9$var$toIndexedObject$2 = $7121bc7d538f81b9$var$toIndexedObject$4;
var $7121bc7d538f81b9$var$toAbsoluteIndex = $7121bc7d538f81b9$var$toAbsoluteIndex$1;
var $7121bc7d538f81b9$var$lengthOfArrayLike$1 = $7121bc7d538f81b9$var$lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $7121bc7d538f81b9$var$createMethod$1 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $7121bc7d538f81b9$var$toIndexedObject$2($this);
        var length = $7121bc7d538f81b9$var$lengthOfArrayLike$1(O);
        var index = $7121bc7d538f81b9$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $7121bc7d538f81b9$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $7121bc7d538f81b9$var$createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $7121bc7d538f81b9$var$createMethod$1(false)
};
var $7121bc7d538f81b9$var$uncurryThis$4 = $7121bc7d538f81b9$var$functionUncurryThis;
var $7121bc7d538f81b9$var$hasOwn$1 = $7121bc7d538f81b9$var$hasOwnProperty_1;
var $7121bc7d538f81b9$var$toIndexedObject$1 = $7121bc7d538f81b9$var$toIndexedObject$4;
var $7121bc7d538f81b9$var$indexOf = $7121bc7d538f81b9$var$arrayIncludes.indexOf;
var $7121bc7d538f81b9$var$hiddenKeys$2 = $7121bc7d538f81b9$var$hiddenKeys$4;
var $7121bc7d538f81b9$var$push$1 = $7121bc7d538f81b9$var$uncurryThis$4([].push);
var $7121bc7d538f81b9$var$objectKeysInternal = function(object, names) {
    var O = $7121bc7d538f81b9$var$toIndexedObject$1(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$7121bc7d538f81b9$var$hasOwn$1($7121bc7d538f81b9$var$hiddenKeys$2, key) && $7121bc7d538f81b9$var$hasOwn$1(O, key) && $7121bc7d538f81b9$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($7121bc7d538f81b9$var$hasOwn$1(O, key = names[i++])) ~$7121bc7d538f81b9$var$indexOf(result, key) || $7121bc7d538f81b9$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $7121bc7d538f81b9$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $7121bc7d538f81b9$var$internalObjectKeys$1 = $7121bc7d538f81b9$var$objectKeysInternal;
var $7121bc7d538f81b9$var$enumBugKeys$2 = $7121bc7d538f81b9$var$enumBugKeys$3;
var $7121bc7d538f81b9$var$hiddenKeys$1 = $7121bc7d538f81b9$var$enumBugKeys$2.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
$7121bc7d538f81b9$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $7121bc7d538f81b9$var$internalObjectKeys$1(O, $7121bc7d538f81b9$var$hiddenKeys$1);
};
var $7121bc7d538f81b9$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
$7121bc7d538f81b9$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $7121bc7d538f81b9$var$getBuiltIn$2 = $7121bc7d538f81b9$var$getBuiltIn$5;
var $7121bc7d538f81b9$var$uncurryThis$3 = $7121bc7d538f81b9$var$functionUncurryThis;
var $7121bc7d538f81b9$var$getOwnPropertyNamesModule = $7121bc7d538f81b9$var$objectGetOwnPropertyNames;
var $7121bc7d538f81b9$var$getOwnPropertySymbolsModule = $7121bc7d538f81b9$var$objectGetOwnPropertySymbols;
var $7121bc7d538f81b9$var$anObject$2 = $7121bc7d538f81b9$var$anObject$4;
var $7121bc7d538f81b9$var$concat = $7121bc7d538f81b9$var$uncurryThis$3([].concat);
// all object keys, includes non-enumerable and symbols
var $7121bc7d538f81b9$var$ownKeys$1 = $7121bc7d538f81b9$var$getBuiltIn$2("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $7121bc7d538f81b9$var$getOwnPropertyNamesModule.f($7121bc7d538f81b9$var$anObject$2(it));
    var getOwnPropertySymbols = $7121bc7d538f81b9$var$getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? $7121bc7d538f81b9$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};
var $7121bc7d538f81b9$var$hasOwn = $7121bc7d538f81b9$var$hasOwnProperty_1;
var $7121bc7d538f81b9$var$ownKeys = $7121bc7d538f81b9$var$ownKeys$1;
var $7121bc7d538f81b9$var$getOwnPropertyDescriptorModule = $7121bc7d538f81b9$var$objectGetOwnPropertyDescriptor;
var $7121bc7d538f81b9$var$definePropertyModule$1 = $7121bc7d538f81b9$var$objectDefineProperty;
var $7121bc7d538f81b9$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $7121bc7d538f81b9$var$ownKeys(source);
    var defineProperty = $7121bc7d538f81b9$var$definePropertyModule$1.f;
    var getOwnPropertyDescriptor = $7121bc7d538f81b9$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$7121bc7d538f81b9$var$hasOwn(target, key) && !(exceptions && $7121bc7d538f81b9$var$hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $7121bc7d538f81b9$var$fails$1 = $7121bc7d538f81b9$var$fails$9;
var $7121bc7d538f81b9$var$isCallable$2 = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$replacement = /#|\.prototype\./;
var $7121bc7d538f81b9$var$isForced$1 = function(feature, detection) {
    var value = $7121bc7d538f81b9$var$data[$7121bc7d538f81b9$var$normalize(feature)];
    return value == $7121bc7d538f81b9$var$POLYFILL ? true : value == $7121bc7d538f81b9$var$NATIVE ? false : $7121bc7d538f81b9$var$isCallable$2(detection) ? $7121bc7d538f81b9$var$fails$1(detection) : !!detection;
};
var $7121bc7d538f81b9$var$normalize = $7121bc7d538f81b9$var$isForced$1.normalize = function(string) {
    return String(string).replace($7121bc7d538f81b9$var$replacement, ".").toLowerCase();
};
var $7121bc7d538f81b9$var$data = $7121bc7d538f81b9$var$isForced$1.data = {};
var $7121bc7d538f81b9$var$NATIVE = $7121bc7d538f81b9$var$isForced$1.NATIVE = "N";
var $7121bc7d538f81b9$var$POLYFILL = $7121bc7d538f81b9$var$isForced$1.POLYFILL = "P";
var $7121bc7d538f81b9$var$isForced_1 = $7121bc7d538f81b9$var$isForced$1;
var $7121bc7d538f81b9$var$global$1 = $7121bc7d538f81b9$var$global$a;
var $7121bc7d538f81b9$var$getOwnPropertyDescriptor = $7121bc7d538f81b9$var$objectGetOwnPropertyDescriptor.f;
var $7121bc7d538f81b9$var$createNonEnumerableProperty = $7121bc7d538f81b9$var$createNonEnumerableProperty$2;
var $7121bc7d538f81b9$var$defineBuiltIn = $7121bc7d538f81b9$var$defineBuiltIn$1;
var $7121bc7d538f81b9$var$defineGlobalProperty = $7121bc7d538f81b9$var$defineGlobalProperty$3;
var $7121bc7d538f81b9$var$copyConstructorProperties = $7121bc7d538f81b9$var$copyConstructorProperties$1;
var $7121bc7d538f81b9$var$isForced = $7121bc7d538f81b9$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $7121bc7d538f81b9$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $7121bc7d538f81b9$var$global$1;
    else if (STATIC) target = $7121bc7d538f81b9$var$global$1[TARGET] || $7121bc7d538f81b9$var$defineGlobalProperty(TARGET, {});
    else target = ($7121bc7d538f81b9$var$global$1[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $7121bc7d538f81b9$var$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $7121bc7d538f81b9$var$isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $7121bc7d538f81b9$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $7121bc7d538f81b9$var$createNonEnumerableProperty(sourceProperty, "sham", true);
        $7121bc7d538f81b9$var$defineBuiltIn(target, key, sourceProperty, options);
    }
};
var $7121bc7d538f81b9$var$uncurryThis$2 = $7121bc7d538f81b9$var$functionUncurryThis;
var $7121bc7d538f81b9$var$aCallable = $7121bc7d538f81b9$var$aCallable$2;
var $7121bc7d538f81b9$var$NATIVE_BIND = $7121bc7d538f81b9$var$functionBindNative;
var $7121bc7d538f81b9$var$bind$1 = $7121bc7d538f81b9$var$uncurryThis$2($7121bc7d538f81b9$var$uncurryThis$2.bind);
// optional / simple context binding
var $7121bc7d538f81b9$var$functionBindContext = function(fn, that) {
    $7121bc7d538f81b9$var$aCallable(fn);
    return that === undefined ? fn : $7121bc7d538f81b9$var$NATIVE_BIND ? $7121bc7d538f81b9$var$bind$1(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $7121bc7d538f81b9$var$classof$2 = $7121bc7d538f81b9$var$classofRaw$2;
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var $7121bc7d538f81b9$var$isArray$1 = Array.isArray || function isArray(argument) {
    return $7121bc7d538f81b9$var$classof$2(argument) == "Array";
};
var $7121bc7d538f81b9$var$wellKnownSymbol$3 = $7121bc7d538f81b9$var$wellKnownSymbol$5;
var $7121bc7d538f81b9$var$TO_STRING_TAG$1 = $7121bc7d538f81b9$var$wellKnownSymbol$3("toStringTag");
var $7121bc7d538f81b9$var$test = {};
$7121bc7d538f81b9$var$test[$7121bc7d538f81b9$var$TO_STRING_TAG$1] = "z";
var $7121bc7d538f81b9$var$toStringTagSupport = String($7121bc7d538f81b9$var$test) === "[object z]";
var $7121bc7d538f81b9$var$TO_STRING_TAG_SUPPORT = $7121bc7d538f81b9$var$toStringTagSupport;
var $7121bc7d538f81b9$var$isCallable$1 = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$classofRaw = $7121bc7d538f81b9$var$classofRaw$2;
var $7121bc7d538f81b9$var$wellKnownSymbol$2 = $7121bc7d538f81b9$var$wellKnownSymbol$5;
var $7121bc7d538f81b9$var$TO_STRING_TAG = $7121bc7d538f81b9$var$wellKnownSymbol$2("toStringTag");
var $7121bc7d538f81b9$var$$Object = Object;
// ES3 wrong here
var $7121bc7d538f81b9$var$CORRECT_ARGUMENTS = $7121bc7d538f81b9$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $7121bc7d538f81b9$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $7121bc7d538f81b9$var$classof$1 = $7121bc7d538f81b9$var$TO_STRING_TAG_SUPPORT ? $7121bc7d538f81b9$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $7121bc7d538f81b9$var$tryGet(O = $7121bc7d538f81b9$var$$Object(it), $7121bc7d538f81b9$var$TO_STRING_TAG)) == "string" ? tag : $7121bc7d538f81b9$var$CORRECT_ARGUMENTS ? $7121bc7d538f81b9$var$classofRaw(O) : (result = $7121bc7d538f81b9$var$classofRaw(O)) == "Object" && $7121bc7d538f81b9$var$isCallable$1(O.callee) ? "Arguments" : result;
};
var $7121bc7d538f81b9$var$uncurryThis$1 = $7121bc7d538f81b9$var$functionUncurryThis;
var $7121bc7d538f81b9$var$fails = $7121bc7d538f81b9$var$fails$9;
var $7121bc7d538f81b9$var$isCallable = $7121bc7d538f81b9$var$isCallable$c;
var $7121bc7d538f81b9$var$classof = $7121bc7d538f81b9$var$classof$1;
var $7121bc7d538f81b9$var$getBuiltIn$1 = $7121bc7d538f81b9$var$getBuiltIn$5;
var $7121bc7d538f81b9$var$inspectSource = $7121bc7d538f81b9$var$inspectSource$2;
var $7121bc7d538f81b9$var$noop = function() {};
var $7121bc7d538f81b9$var$empty = [];
var $7121bc7d538f81b9$var$construct = $7121bc7d538f81b9$var$getBuiltIn$1("Reflect", "construct");
var $7121bc7d538f81b9$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $7121bc7d538f81b9$var$exec = $7121bc7d538f81b9$var$uncurryThis$1($7121bc7d538f81b9$var$constructorRegExp.exec);
var $7121bc7d538f81b9$var$INCORRECT_TO_STRING = !$7121bc7d538f81b9$var$constructorRegExp.exec($7121bc7d538f81b9$var$noop);
var $7121bc7d538f81b9$var$isConstructorModern = function isConstructor(argument) {
    if (!$7121bc7d538f81b9$var$isCallable(argument)) return false;
    try {
        $7121bc7d538f81b9$var$construct($7121bc7d538f81b9$var$noop, $7121bc7d538f81b9$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $7121bc7d538f81b9$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$7121bc7d538f81b9$var$isCallable(argument)) return false;
    switch($7121bc7d538f81b9$var$classof(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $7121bc7d538f81b9$var$INCORRECT_TO_STRING || !!$7121bc7d538f81b9$var$exec($7121bc7d538f81b9$var$constructorRegExp, $7121bc7d538f81b9$var$inspectSource(argument));
    } catch (error) {
        return true;
    }
};
$7121bc7d538f81b9$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $7121bc7d538f81b9$var$isConstructor$1 = !$7121bc7d538f81b9$var$construct || $7121bc7d538f81b9$var$fails(function() {
    var called;
    return $7121bc7d538f81b9$var$isConstructorModern($7121bc7d538f81b9$var$isConstructorModern.call) || !$7121bc7d538f81b9$var$isConstructorModern(Object) || !$7121bc7d538f81b9$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $7121bc7d538f81b9$var$isConstructorLegacy : $7121bc7d538f81b9$var$isConstructorModern;
var $7121bc7d538f81b9$var$isArray = $7121bc7d538f81b9$var$isArray$1;
var $7121bc7d538f81b9$var$isConstructor = $7121bc7d538f81b9$var$isConstructor$1;
var $7121bc7d538f81b9$var$isObject = $7121bc7d538f81b9$var$isObject$6;
var $7121bc7d538f81b9$var$wellKnownSymbol$1 = $7121bc7d538f81b9$var$wellKnownSymbol$5;
var $7121bc7d538f81b9$var$SPECIES = $7121bc7d538f81b9$var$wellKnownSymbol$1("species");
var $7121bc7d538f81b9$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $7121bc7d538f81b9$var$arraySpeciesConstructor$1 = function(originalArray) {
    var C;
    if ($7121bc7d538f81b9$var$isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($7121bc7d538f81b9$var$isConstructor(C) && (C === $7121bc7d538f81b9$var$$Array || $7121bc7d538f81b9$var$isArray(C.prototype))) C = undefined;
        else if ($7121bc7d538f81b9$var$isObject(C)) {
            C = C[$7121bc7d538f81b9$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $7121bc7d538f81b9$var$$Array : C;
};
var $7121bc7d538f81b9$var$arraySpeciesConstructor = $7121bc7d538f81b9$var$arraySpeciesConstructor$1;
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $7121bc7d538f81b9$var$arraySpeciesCreate$1 = function(originalArray, length) {
    return new ($7121bc7d538f81b9$var$arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var $7121bc7d538f81b9$var$bind = $7121bc7d538f81b9$var$functionBindContext;
var $7121bc7d538f81b9$var$uncurryThis = $7121bc7d538f81b9$var$functionUncurryThis;
var $7121bc7d538f81b9$var$IndexedObject = $7121bc7d538f81b9$var$indexedObject;
var $7121bc7d538f81b9$var$toObject = $7121bc7d538f81b9$var$toObject$2;
var $7121bc7d538f81b9$var$lengthOfArrayLike = $7121bc7d538f81b9$var$lengthOfArrayLike$2;
var $7121bc7d538f81b9$var$arraySpeciesCreate = $7121bc7d538f81b9$var$arraySpeciesCreate$1;
var $7121bc7d538f81b9$var$push = $7121bc7d538f81b9$var$uncurryThis([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $7121bc7d538f81b9$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $7121bc7d538f81b9$var$toObject($this);
        var self1 = $7121bc7d538f81b9$var$IndexedObject(O);
        var boundFunction = $7121bc7d538f81b9$var$bind(callbackfn, that);
        var length = $7121bc7d538f81b9$var$lengthOfArrayLike(self1);
        var index = 0;
        var create = specificCreate || $7121bc7d538f81b9$var$arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $7121bc7d538f81b9$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $7121bc7d538f81b9$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var $7121bc7d538f81b9$var$arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $7121bc7d538f81b9$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $7121bc7d538f81b9$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $7121bc7d538f81b9$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $7121bc7d538f81b9$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $7121bc7d538f81b9$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $7121bc7d538f81b9$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $7121bc7d538f81b9$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $7121bc7d538f81b9$var$createMethod(7)
};
var $7121bc7d538f81b9$var$objectDefineProperties = {};
var $7121bc7d538f81b9$var$internalObjectKeys = $7121bc7d538f81b9$var$objectKeysInternal;
var $7121bc7d538f81b9$var$enumBugKeys$1 = $7121bc7d538f81b9$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var $7121bc7d538f81b9$var$objectKeys$1 = Object.keys || function keys(O) {
    return $7121bc7d538f81b9$var$internalObjectKeys(O, $7121bc7d538f81b9$var$enumBugKeys$1);
};
var $7121bc7d538f81b9$var$DESCRIPTORS = $7121bc7d538f81b9$var$descriptors;
var $7121bc7d538f81b9$var$V8_PROTOTYPE_DEFINE_BUG = $7121bc7d538f81b9$var$v8PrototypeDefineBug;
var $7121bc7d538f81b9$var$definePropertyModule = $7121bc7d538f81b9$var$objectDefineProperty;
var $7121bc7d538f81b9$var$anObject$1 = $7121bc7d538f81b9$var$anObject$4;
var $7121bc7d538f81b9$var$toIndexedObject = $7121bc7d538f81b9$var$toIndexedObject$4;
var $7121bc7d538f81b9$var$objectKeys = $7121bc7d538f81b9$var$objectKeys$1;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$7121bc7d538f81b9$var$objectDefineProperties.f = $7121bc7d538f81b9$var$DESCRIPTORS && !$7121bc7d538f81b9$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $7121bc7d538f81b9$var$anObject$1(O);
    var props = $7121bc7d538f81b9$var$toIndexedObject(Properties);
    var keys = $7121bc7d538f81b9$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$7121bc7d538f81b9$var$definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};
var $7121bc7d538f81b9$var$getBuiltIn = $7121bc7d538f81b9$var$getBuiltIn$5;
var $7121bc7d538f81b9$var$html$1 = $7121bc7d538f81b9$var$getBuiltIn("document", "documentElement");
/* global ActiveXObject -- old IE, WSH */ var $7121bc7d538f81b9$var$anObject = $7121bc7d538f81b9$var$anObject$4;
var $7121bc7d538f81b9$var$definePropertiesModule = $7121bc7d538f81b9$var$objectDefineProperties;
var $7121bc7d538f81b9$var$enumBugKeys = $7121bc7d538f81b9$var$enumBugKeys$3;
var $7121bc7d538f81b9$var$hiddenKeys = $7121bc7d538f81b9$var$hiddenKeys$4;
var $7121bc7d538f81b9$var$html = $7121bc7d538f81b9$var$html$1;
var $7121bc7d538f81b9$var$documentCreateElement = $7121bc7d538f81b9$var$documentCreateElement$1;
var $7121bc7d538f81b9$var$sharedKey = $7121bc7d538f81b9$var$sharedKey$2;
var $7121bc7d538f81b9$var$GT = ">";
var $7121bc7d538f81b9$var$LT = "<";
var $7121bc7d538f81b9$var$PROTOTYPE = "prototype";
var $7121bc7d538f81b9$var$SCRIPT = "script";
var $7121bc7d538f81b9$var$IE_PROTO = $7121bc7d538f81b9$var$sharedKey("IE_PROTO");
var $7121bc7d538f81b9$var$EmptyConstructor = function() {};
var $7121bc7d538f81b9$var$scriptTag = function(content) {
    return $7121bc7d538f81b9$var$LT + $7121bc7d538f81b9$var$SCRIPT + $7121bc7d538f81b9$var$GT + content + $7121bc7d538f81b9$var$LT + "/" + $7121bc7d538f81b9$var$SCRIPT + $7121bc7d538f81b9$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $7121bc7d538f81b9$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($7121bc7d538f81b9$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $7121bc7d538f81b9$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $7121bc7d538f81b9$var$documentCreateElement("iframe");
    var JS = "java" + $7121bc7d538f81b9$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $7121bc7d538f81b9$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($7121bc7d538f81b9$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $7121bc7d538f81b9$var$activeXDocument;
var $7121bc7d538f81b9$var$NullProtoObject = function() {
    try {
        $7121bc7d538f81b9$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $7121bc7d538f81b9$var$NullProtoObject = typeof document != "undefined" ? document.domain && $7121bc7d538f81b9$var$activeXDocument ? $7121bc7d538f81b9$var$NullProtoObjectViaActiveX($7121bc7d538f81b9$var$activeXDocument) // old IE
     : $7121bc7d538f81b9$var$NullProtoObjectViaIFrame() : $7121bc7d538f81b9$var$NullProtoObjectViaActiveX($7121bc7d538f81b9$var$activeXDocument); // WSH
    var length = $7121bc7d538f81b9$var$enumBugKeys.length;
    while(length--)delete $7121bc7d538f81b9$var$NullProtoObject[$7121bc7d538f81b9$var$PROTOTYPE][$7121bc7d538f81b9$var$enumBugKeys[length]];
    return $7121bc7d538f81b9$var$NullProtoObject();
};
$7121bc7d538f81b9$var$hiddenKeys[$7121bc7d538f81b9$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var $7121bc7d538f81b9$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $7121bc7d538f81b9$var$EmptyConstructor[$7121bc7d538f81b9$var$PROTOTYPE] = $7121bc7d538f81b9$var$anObject(O);
        result = new $7121bc7d538f81b9$var$EmptyConstructor();
        $7121bc7d538f81b9$var$EmptyConstructor[$7121bc7d538f81b9$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$7121bc7d538f81b9$var$IE_PROTO] = O;
    } else result = $7121bc7d538f81b9$var$NullProtoObject();
    return Properties === undefined ? result : $7121bc7d538f81b9$var$definePropertiesModule.f(result, Properties);
};
var $7121bc7d538f81b9$var$wellKnownSymbol = $7121bc7d538f81b9$var$wellKnownSymbol$5;
var $7121bc7d538f81b9$var$create = $7121bc7d538f81b9$var$objectCreate;
var $7121bc7d538f81b9$var$defineProperty = $7121bc7d538f81b9$var$objectDefineProperty.f;
var $7121bc7d538f81b9$var$UNSCOPABLES = $7121bc7d538f81b9$var$wellKnownSymbol("unscopables");
var $7121bc7d538f81b9$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($7121bc7d538f81b9$var$ArrayPrototype[$7121bc7d538f81b9$var$UNSCOPABLES] == undefined) $7121bc7d538f81b9$var$defineProperty($7121bc7d538f81b9$var$ArrayPrototype, $7121bc7d538f81b9$var$UNSCOPABLES, {
    configurable: true,
    value: $7121bc7d538f81b9$var$create(null)
});
// add a key to Array.prototype[@@unscopables]
var $7121bc7d538f81b9$var$addToUnscopables$1 = function(key) {
    $7121bc7d538f81b9$var$ArrayPrototype[$7121bc7d538f81b9$var$UNSCOPABLES][key] = true;
};
var $7121bc7d538f81b9$var$$ = $7121bc7d538f81b9$var$_export;
var $7121bc7d538f81b9$var$$find = $7121bc7d538f81b9$var$arrayIteration.find;
var $7121bc7d538f81b9$var$addToUnscopables = $7121bc7d538f81b9$var$addToUnscopables$1;
var $7121bc7d538f81b9$var$FIND = "find";
var $7121bc7d538f81b9$var$SKIPS_HOLES = true;
// Shouldn't skip holes
if ($7121bc7d538f81b9$var$FIND in []) Array(1)[$7121bc7d538f81b9$var$FIND](function() {
    $7121bc7d538f81b9$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$7121bc7d538f81b9$var$$({
    target: "Array",
    proto: true,
    forced: $7121bc7d538f81b9$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $7121bc7d538f81b9$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$7121bc7d538f81b9$var$addToUnscopables($7121bc7d538f81b9$var$FIND);
var $7121bc7d538f81b9$var$CONSTANT = {
    GLOBAL: {
        HIDE: "__react_tooltip_hide_event",
        REBUILD: "__react_tooltip_rebuild_event",
        SHOW: "__react_tooltip_show_event"
    }
};
/**
 * Static methods for react-tooltip
 */ var $7121bc7d538f81b9$var$dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    var event;
    if (typeof window.CustomEvent === "function") event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, false, true, opts);
    }
    window.dispatchEvent(event);
};
function $7121bc7d538f81b9$var$staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        $7121bc7d538f81b9$var$dispatchGlobalEvent($7121bc7d538f81b9$var$CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        $7121bc7d538f81b9$var$dispatchGlobalEvent($7121bc7d538f81b9$var$CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        $7121bc7d538f81b9$var$dispatchGlobalEvent($7121bc7d538f81b9$var$CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            this.showTooltip({
                currentTarget: hasTarget && event.detail.target
            }, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function $7121bc7d538f81b9$var$windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener($7121bc7d538f81b9$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener($7121bc7d538f81b9$var$CONSTANT.GLOBAL.HIDE, this.globalHide, false);
        // ReactTooltip.rebuild
        window.removeEventListener($7121bc7d538f81b9$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener($7121bc7d538f81b9$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);
        // ReactTooltip.show
        window.removeEventListener($7121bc7d538f81b9$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener($7121bc7d538f81b9$var$CONSTANT.GLOBAL.SHOW, this.globalShow, false);
        // Resize
        if (resizeHide) {
            window.removeEventListener("resize", this.onWindowResize);
            window.addEventListener("resize", this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener($7121bc7d538f81b9$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener($7121bc7d538f81b9$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener($7121bc7d538f81b9$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener("resize", this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var $7121bc7d538f81b9$var$checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute("currentItem");
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === "true") {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute("currentItem", "true");
        $7121bc7d538f81b9$var$setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var $7121bc7d538f81b9$var$setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute("currentItem", "false");
    else targetArray[i].setAttribute("currentItem", "true");
};
var $7121bc7d538f81b9$var$customListeners = {
    id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: $7121bc7d538f81b9$var$_defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function $7121bc7d538f81b9$var$customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute("data-event");
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute("data-event") || event;
        var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
        dataEvent.split(" ").forEach(function(event) {
            ele.removeEventListener(event, $7121bc7d538f81b9$var$customListeners.get(ele, event));
            var customListener = $7121bc7d538f81b9$var$checkStatus.bind(_this, dataEventOff);
            $7121bc7d538f81b9$var$customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(" ").forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute("data-event");
        var dataEventOff = eventOff || ele.getAttribute("data-event-off");
        ele.removeEventListener(dataEvent, $7121bc7d538f81b9$var$customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function $7121bc7d538f81b9$var$isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function $7121bc7d538f81b9$var$getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute("data-effect");
        return dataEffect || this.props.effect || "float";
    };
}
/**
 * Util method to get effect
 */ var $7121bc7d538f81b9$var$makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === "function") proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var $7121bc7d538f81b9$var$bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = null;
    var forId;
    var target = e.target;
    var lastTarget;
    // walk up parent chain until tip is found
    // there is no match if parent visible area is matched by mouse position, so some corner cases might not work as expected
    while(tip === null && target !== null){
        lastTarget = target;
        tip = target.getAttribute("data-tip") || null;
        forId = target.getAttribute("data-for") || null;
        target = target.parentElement;
    }
    target = lastTarget || e.target;
    if (this.isCustomEvent(target) && !customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
        var proxy = $7121bc7d538f81b9$var$makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var $7121bc7d538f81b9$var$findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(" ").forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var $7121bc7d538f81b9$var$getBody = function getBody() {
    return document.getElementsByTagName("body")[0];
};
function $7121bc7d538f81b9$var$bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = $7121bc7d538f81b9$var$getBody();
        var customEvents = $7121bc7d538f81b9$var$findCustomEvents(targetArray, "data-event");
        var customEventsOff = $7121bc7d538f81b9$var$findCustomEvents(targetArray, "data-event-off");
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(" ").forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(" ").forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = $7121bc7d538f81b9$var$bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = $7121bc7d538f81b9$var$bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = $7121bc7d538f81b9$var$bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = $7121bc7d538f81b9$var$bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
            $7121bc7d538f81b9$var$checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = $7121bc7d538f81b9$var$bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || $7121bc7d538f81b9$var$getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var $7121bc7d538f81b9$var$getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function $7121bc7d538f81b9$var$trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = $7121bc7d538f81b9$var$getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function $7121bc7d538f81b9$var$getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = $7121bc7d538f81b9$var$getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = $7121bc7d538f81b9$var$getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = $7121bc7d538f81b9$var$getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = $7121bc7d538f81b9$var$getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = $7121bc7d538f81b9$var$calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = $7121bc7d538f81b9$var$getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft;
    // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    };
    //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    };
    // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placeIsInside = {
        top: inside("top"),
        bottom: inside("bottom"),
        left: inside("left"),
        right: inside("right")
    };
    function choose() {
        var allPlaces = desiredPlace.split(",").concat(place, [
            "top",
            "bottom",
            "left",
            "right"
        ]);
        var _iterator = $7121bc7d538f81b9$var$_createForOfIteratorHelper(allPlaces), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var d = _step.value;
                if (placeIsInside[d]) return d;
            }
        // if nothing is inside, just use the old place.
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return place;
    }
    var chosen = choose();
    var isNewState = false;
    var newPlace;
    if (chosen && chosen !== place) {
        isNewState = true;
        newPlace = chosen;
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var $7121bc7d538f81b9$var$getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
};
// Get current mouse offset
var $7121bc7d538f81b9$var$getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = $7121bc7d538f81b9$var$getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === "float") return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
};
// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var $7121bc7d538f81b9$var$getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === "float") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === "solid") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
};
// Consider additional offset into position calculation
var $7121bc7d538f81b9$var$calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === "[object String]") offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    for(var key in offset){
        if (key === "top") extraOffsetY -= parseInt(offset[key], 10);
        else if (key === "bottom") extraOffsetY += parseInt(offset[key], 10);
        else if (key === "left") extraOffsetX -= parseInt(offset[key], 10);
        else if (key === "right") extraOffsetX += parseInt(offset[key], 10);
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
};
// Get the offset of the parent elements
var $7121bc7d538f81b9$var$getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        var computedStyle = window.getComputedStyle(currentParent);
        // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (computedStyle.getPropertyValue("transform") !== "none" || computedStyle.getPropertyValue("will-change") === "transform") break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function $7121bc7d538f81b9$var$TipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === "false" || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
    // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function $7121bc7d538f81b9$var$parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function $7121bc7d538f81b9$var$nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
function $7121bc7d538f81b9$var$generateUUID() {
    return "t" + (0, $10e1a74bd817bb9e$export$2e2bcd8739ae039)();
}
var $7121bc7d538f81b9$var$baseCss = '.__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: "";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  bottom: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-bottom::before {\n  top: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-left::before {\n  right: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip.place-right::before {\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}';
/**
 * Default pop-up style values (text color, background color).
 */ var $7121bc7d538f81b9$var$defaultColors = {
    dark: {
        text: "#fff",
        background: "#222",
        border: "transparent",
        arrow: "#222"
    },
    success: {
        text: "#fff",
        background: "#8DC572",
        border: "transparent",
        arrow: "#8DC572"
    },
    warning: {
        text: "#fff",
        background: "#F0AD4E",
        border: "transparent",
        arrow: "#F0AD4E"
    },
    error: {
        text: "#fff",
        background: "#BE6464",
        border: "transparent",
        arrow: "#BE6464"
    },
    info: {
        text: "#fff",
        background: "#337AB7",
        border: "transparent",
        arrow: "#337AB7"
    },
    light: {
        text: "#222",
        background: "#fff",
        border: "transparent",
        arrow: "#fff"
    }
};
function $7121bc7d538f81b9$var$getDefaultPopupColors(type) {
    return $7121bc7d538f81b9$var$defaultColors[type] ? $7121bc7d538f81b9$var$_objectSpread2({}, $7121bc7d538f81b9$var$defaultColors[type]) : undefined;
}
var $7121bc7d538f81b9$var$DEFAULT_PADDING = "8px 21px";
var $7121bc7d538f81b9$var$DEFAULT_RADIUS = {
    tooltip: 3,
    arrow: 0
};
/**
 * Generates the specific tooltip style for use on render.
 */ function $7121bc7d538f81b9$var$generateTooltipStyle(uuid, customColors, type, hasBorder, padding, radius) {
    return $7121bc7d538f81b9$var$generateStyle(uuid, $7121bc7d538f81b9$var$getPopupColors(customColors, type, hasBorder), padding, radius);
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */ function $7121bc7d538f81b9$var$generateStyle(uuid, colors) {
    var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $7121bc7d538f81b9$var$DEFAULT_PADDING;
    var radius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $7121bc7d538f81b9$var$DEFAULT_RADIUS;
    var textColor = colors.text;
    var backgroundColor = colors.background;
    var borderColor = colors.border;
    var arrowColor = colors.arrow;
    var arrowRadius = radius.arrow;
    var tooltipRadius = radius.tooltip;
    return "\n  	.".concat(uuid, " {\n	    color: ").concat(textColor, ";\n	    background: ").concat(backgroundColor, ";\n	    border: 1px solid ").concat(borderColor, ";\n	    border-radius: ").concat(tooltipRadius, "px;\n	    padding: ").concat(padding, ";\n  	}\n\n  	.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, '.place-top::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 20px;\n        height: 12px;\n    }\n    .').concat(uuid, '.place-top::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(135deg);\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, '.place-bottom::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 18px;\n        height: 10px;\n    }\n    .').concat(uuid, '.place-bottom::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        top: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, '.place-left::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(uuid, '.place-left::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        right: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, '.place-right::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(uuid, '.place-right::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        left: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(-135deg);\n    }\n  ");
}
function $7121bc7d538f81b9$var$getPopupColors(customColors, type, hasBorder) {
    var textColor = customColors.text;
    var backgroundColor = customColors.background;
    var borderColor = customColors.border;
    var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
    var colors = $7121bc7d538f81b9$var$getDefaultPopupColors(type);
    if (textColor) colors.text = textColor;
    if (backgroundColor) colors.background = backgroundColor;
    if (hasBorder) {
        if (borderColor) colors.border = borderColor;
        else colors.border = type === "light" ? "black" : "white";
    }
    if (arrowColor) colors.arrow = arrowColor;
    return colors;
}
var $7121bc7d538f81b9$var$_class, $7121bc7d538f81b9$var$_class2;
/* Polyfill */ var $7121bc7d538f81b9$export$2e2bcd8739ae039 = $7121bc7d538f81b9$var$staticMethods($7121bc7d538f81b9$var$_class = $7121bc7d538f81b9$var$windowListener($7121bc7d538f81b9$var$_class = $7121bc7d538f81b9$var$customEvent($7121bc7d538f81b9$var$_class = $7121bc7d538f81b9$var$isCapture($7121bc7d538f81b9$var$_class = $7121bc7d538f81b9$var$getEffect($7121bc7d538f81b9$var$_class = $7121bc7d538f81b9$var$bodyMode($7121bc7d538f81b9$var$_class = $7121bc7d538f81b9$var$trackRemoval($7121bc7d538f81b9$var$_class = ($7121bc7d538f81b9$var$_class2 = /*#__PURE__*/ function(_React$Component) {
    $7121bc7d538f81b9$var$_inherits(ReactTooltip, _React$Component);
    var _super = $7121bc7d538f81b9$var$_createSuper(ReactTooltip);
    function ReactTooltip(props) {
        var _this;
        $7121bc7d538f81b9$var$_classCallCheck(this, ReactTooltip);
        _this = _super.call(this, props);
        _this.state = {
            uuid: props.uuid || $7121bc7d538f81b9$var$generateUUID(),
            place: props.place || "top",
            // Direction of tooltip
            desiredPlace: props.place || "top",
            type: props.type || "dark",
            // Color theme of tooltip
            effect: props.effect || "float",
            // float or fixed
            show: false,
            border: false,
            borderClass: "border",
            customColors: {},
            customRadius: {},
            offset: {},
            padding: props.padding,
            extraClass: "",
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: $7121bc7d538f81b9$var$parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || "",
            possibleCustomEventsOff: props.possibleCustomEventsOff || "",
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            "showTooltip",
            "updateTooltip",
            "hideTooltip",
            "hideTooltipOnScroll",
            "getTooltipContent",
            "globalRebuild",
            "globalShow",
            "globalHide",
            "onWindowResize",
            "mouseOnToolTip"
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ $7121bc7d538f81b9$var$_createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props;
                _this$props.insecure;
                var resizeHide = _this$props.resizeHide, disableInternalStyle = _this$props.disableInternalStyle;
                this.mount = true;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
                if (!disableInternalStyle) this.injectStyles(); // Inject styles for each DOM root having tooltip.
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener(this.state.currentTarget);
                this.unbindWindowEvents();
            }
        },
        {
            key: "injectStyles",
            value: function injectStyles() {
                var tooltipRef = this.tooltipRef;
                if (!tooltipRef) return;
                var parentNode = tooltipRef.parentNode;
                while(parentNode.parentNode)parentNode = parentNode.parentNode;
                var domRoot;
                switch(parentNode.constructor.name){
                    case "Document":
                    case "HTMLDocument":
                    case undefined:
                        domRoot = parentNode.head;
                        break;
                    case "ShadowRoot":
                    default:
                        domRoot = parentNode;
                        break;
                }
                // Prevent styles duplication.
                if (!domRoot.querySelector("style[data-react-tooltip]")) {
                    var style = document.createElement("style");
                    style.textContent = $7121bc7d538f81b9$var$baseCss;
                    style.setAttribute("data-react-tooltip", "true");
                    domRoot.appendChild(style);
                }
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(":hover");
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray = [];
                var selector;
                if (!id) selector = "[data-tip]:not([data-for])";
                else {
                    var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                    selector = '[data-tip][data-for="'.concat(escaped, '"]');
                }
                // Scan document for shadow DOM elements
                $7121bc7d538f81b9$var$nodeListToArray(document.getElementsByTagName("*")).filter(function(element) {
                    return element.shadowRoot;
                }).forEach(function(element) {
                    targetArray = targetArray.concat($7121bc7d538f81b9$var$nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
                });
                return targetArray.concat($7121bc7d538f81b9$var$nodeListToArray(document.querySelectorAll(selector)));
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute("currentItem") === null) target.setAttribute("currentItem", "false");
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
                    target.addEventListener("focus", _this3.showTooltip, isCaptureMode);
                    if (effect === "float") target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
                    target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
                    target.addEventListener("blur", _this3.hideTooltip, isCaptureMode);
                });
                // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                }
                // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
                target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
                target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children;
                // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return $7121bc7d538f81b9$var$TipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === "string" && placeholder === "" || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (!this.tooltipRef) return;
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                }
                // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute("data-tip");
                var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false;
                // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
                // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute("data-scroll-hide")) scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                // adding aria-describedby to target to make tooltips read by screen readers
                if (e && e.currentTarget && e.currentTarget.setAttribute) e.currentTarget.setAttribute("aria-describedby", this.props.id || this.state.uuid);
                // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
                var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
                var result = $7121bc7d538f81b9$var$getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace.split(",")[0], desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace.split(",")[0];
                // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
                var self1 = this;
                var updateState = function updateState() {
                    self1.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute("data-type") || self1.props.type || "dark",
                        customColors: {
                            text: target.getAttribute("data-text-color") || self1.props.textColor || null,
                            background: target.getAttribute("data-background-color") || self1.props.backgroundColor || null,
                            border: target.getAttribute("data-border-color") || self1.props.borderColor || null,
                            arrow: target.getAttribute("data-arrow-color") || self1.props.arrowColor || null
                        },
                        customRadius: {
                            tooltip: target.getAttribute("data-tooltip-radius") || self1.props.tooltipRadius || "3",
                            arrow: target.getAttribute("data-arrow-radius") || self1.props.arrowRadius || "0"
                        },
                        effect: effect,
                        offset: offset,
                        padding: target.getAttribute("data-padding") || self1.props.padding,
                        html: (target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self1.props.html) || false,
                        delayShow: target.getAttribute("data-delay-show") || self1.props.delayShow || 0,
                        delayHide: target.getAttribute("data-delay-hide") || self1.props.delayHide || 0,
                        delayUpdate: target.getAttribute("data-delay-update") || self1.props.delayUpdate || 0,
                        border: (target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self1.props.border) || false,
                        borderClass: target.getAttribute("data-border-class") || self1.props.borderClass || "border",
                        extraClass: target.getAttribute("data-class") || self1.props["class"] || self1.props.className || "",
                        disable: (target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self1.props.disable) || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self1.addScrollListener(self1.state.currentTarget);
                        self1.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self1.intervalUpdateContent = setInterval(function() {
                            if (self1.mount) {
                                var _getContent = self1.props.getContent;
                                var placeholder = $7121bc7d538f81b9$var$TipContent(originTooltip, "", _getContent[0](), isMultiline);
                                var isEmptyTip = self1.isEmptyTip(placeholder);
                                self1.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self1.updatePosition();
                            }
                        }, getContent[1]);
                    });
                };
                // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var _this$props6 = this.props, afterShow = _this$props6.afterShow, disableProp = _this$props6.disable;
                var placeholder = this.getTooltipContent();
                var eventTarget = e.currentTarget || e.target;
                // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                // if the tooltip is empty, disable the tooltip
                if (this.isEmptyTip(placeholder) || disable || disableProp) return;
                var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition(function() {
                                if (isInvisible && afterShow) afterShow(e);
                            });
                        });
                    }
                };
                if (this.delayShowLoop) clearTimeout(this.delayShowLoop);
                if (delayTime) this.delayShowLoop = setTimeout(updateState, delayTime);
                else {
                    this.delayShowLoop = null;
                    updateState();
                }
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var _this$props7 = this.props, afterHide = _this$props7.afterHide, disableProp = _this$props7.disable;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable || disableProp) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                }
                // clean up aria-describedby when hiding tooltip
                if (e && e.currentTarget && e.currentTarget.removeAttribute) e.currentTarget.removeAttribute("aria-describedby");
                var resetState = function resetState() {
                    var isVisible = _this6.state.show;
                    // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener(_this6.state.currentTarget);
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.removeEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(callbackAfter) {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = $7121bc7d538f81b9$var$getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition(callbackAfter);
                });
                if (callbackAfter && typeof callbackAfter === "function") callbackAfter();
                // Set tooltip position
                node.style.left = result.position.left + "px";
                node.style.top = result.position.top + "px";
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                if (this.delayShowLoop) {
                    clearTimeout(this.delayShowLoop);
                    this.delayShowLoop = null;
                }
                if (this.delayHideLoop) {
                    clearTimeout(this.delayHideLoop);
                    this.delayHideLoop = null;
                }
                if (this.delayReshow) {
                    clearTimeout(this.delayReshow);
                    this.delayReshow = null;
                }
                if (this.intervalUpdateContent) {
                    clearInterval(this.intervalUpdateContent);
                    this.intervalUpdateContent = null;
                }
            }
        },
        {
            key: "hasCustomColors",
            value: function hasCustomColors() {
                var _this8 = this;
                return Boolean(Object.keys(this.state.customColors).find(function(color) {
                    return color !== "border" && _this8.state.customColors[color];
                }) || this.state.border && this.state.customColors["border"]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
                var content = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(content);
                var style = this.props.disableInternalStyle ? "" : $7121bc7d538f81b9$var$generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border, this.state.padding, this.state.customRadius);
                var tooltipClass = "__react_component_tooltip" + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " " + this.state.borderClass : "") + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.hasCustomColors() ? "custom" : this.state.type) + // dark, success, warning, error, info, light, custom
                (this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(" ");
                if (html) {
                    var htmlContent = "".concat(content).concat(style ? '\n<style aria-hidden="true">'.concat(style, "</style>") : "");
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(Wrapper, $7121bc7d538f81b9$var$_extends({
                        className: "".concat(wrapperClassName),
                        id: this.props.id || uuid,
                        ref: function ref(_ref) {
                            return _this9.tooltipRef = _ref;
                        }
                    }, ariaProps, {
                        "data-id": "tooltip",
                        dangerouslySetInnerHTML: {
                            __html: htmlContent
                        }
                    }));
                } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(Wrapper, $7121bc7d538f81b9$var$_extends({
                    className: "".concat(wrapperClassName),
                    id: this.props.id || uuid
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this9.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), style && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: style
                    },
                    "aria-hidden": "true"
                }), content);
            }
        }
    ], [
        {
            key: "propTypes",
            get: function get() {
                return {
                    uuid: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).any,
                    place: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    type: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    effect: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    offset: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
                    padding: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    multiline: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
                    border: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
                    borderClass: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    textColor: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    arrowColor: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    arrowRadius: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    tooltipRadius: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    insecure: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
                    "class": (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    id: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    html: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
                    delayHide: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
                    delayUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
                    delayShow: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
                    event: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    eventOff: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    isCapture: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
                    globalEventOff: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    getContent: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).any,
                    afterShow: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
                    afterHide: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
                    overridePosition: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
                    disable: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
                    scrollHide: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
                    resizeHide: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
                    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    bodyMode: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
                    possibleCustomEvents: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    possibleCustomEventsOff: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
                    clickable: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
                    disableInternalStyle: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = $7121bc7d538f81b9$var$parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return $7121bc7d538f81b9$var$_objectSpread2($7121bc7d538f81b9$var$_objectSpread2({}, prevState), {}, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Component), $7121bc7d538f81b9$var$_defineProperty($7121bc7d538f81b9$var$_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: "div",
    clickable: false
}), $7121bc7d538f81b9$var$_defineProperty($7121bc7d538f81b9$var$_class2, "supportedWrappers", [
    "div",
    "span"
]), $7121bc7d538f81b9$var$_defineProperty($7121bc7d538f81b9$var$_class2, "displayName", "ReactTooltip"), $7121bc7d538f81b9$var$_class2)) || $7121bc7d538f81b9$var$_class) || $7121bc7d538f81b9$var$_class) || $7121bc7d538f81b9$var$_class) || $7121bc7d538f81b9$var$_class) || $7121bc7d538f81b9$var$_class) || $7121bc7d538f81b9$var$_class) || $7121bc7d538f81b9$var$_class;




// https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
const $7941da5030926682$export$d0a8044dce8ff2fc = ()=>{
    const regex = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
    const regex2 = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i;
    const agent = navigator.userAgent || navigator.vendor || window.opera;
    return regex.test(agent) || regex2.test(agent.substr(0, 4));
};
const $7941da5030926682$export$509c2fa871ee4b40 = ()=>navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
const $7941da5030926682$export$97c02de5f74f3224 = ()=>/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
const $7941da5030926682$export$4b5f14a3bef5854f = ()=>{
    const standalone = window.navigator.standalone, userAgent = window.navigator.userAgent.toLowerCase(), safari = /safari/.test(userAgent), ios = /iphone|ipod|ipad/.test(userAgent);
    if (ios) {
        if (!standalone && safari) ;
        else if (standalone && !safari) ;
        else if (!standalone && !safari) //uiwebview
        return true;
    } else {
        if (userAgent.includes("wv")) // Android webview
        return true;
    }
    return false;
};



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
const $382adfbc1e51da84$var$useEventListener = (eventName, handler, element = window)=>{
    (0, $3QbnI.useEffect)(()=>{
        if (element) {
            // clean up code
            element.removeEventListener(eventName, handler);
            element.addEventListener(eventName, handler);
            return ()=>element.removeEventListener(eventName, handler);
        }
    }, [
        element,
        eventName,
        handler
    ]);
};
var $382adfbc1e51da84$export$2e2bcd8739ae039 = $382adfbc1e51da84$var$useEventListener;


let $b79cf78f5d739e32$var$deferredPrompt = null;
// https://web.dev/customize-install/
window.addEventListener("beforeinstallprompt", (event)=>{
    // Prevent the mini-infobar from appearing on mobile
    event.preventDefault();
    // Stash the event so it can be triggered later.
    $b79cf78f5d739e32$var$deferredPrompt = event;
// Update UI notify the user they can install the PWA
});
const $b79cf78f5d739e32$export$3ff5d50241ce5ce6 = ()=>$b79cf78f5d739e32$var$deferredPrompt;
const $b79cf78f5d739e32$export$1f9d975a37dc085 = ()=>{
    $b79cf78f5d739e32$var$deferredPrompt = null;
};
const $b79cf78f5d739e32$export$d757fc29e1490623 = ()=>{
    const mqStandAlone = "(display-mode: standalone)";
    return navigator.standalone || window.matchMedia(mqStandAlone).matches;
};


const $b8ecb772f887e697$var$useIsStandalonePWA = ()=>{
    const [isStandalonePWA, setStandalonePWA] = (0, $3QbnI.useState)((0, $b79cf78f5d739e32$export$d757fc29e1490623)());
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("resize", ()=>{
        const newValue = (0, $b79cf78f5d739e32$export$d757fc29e1490623)();
        if (newValue !== isStandalonePWA) setStandalonePWA(newValue);
    });
    return isStandalonePWA;
};
var $b8ecb772f887e697$export$2e2bcd8739ae039 = $b8ecb772f887e697$var$useIsStandalonePWA;



const $e91e729a6066c3b7$var$browserTabTitle = (title, appName)=>{
    const cleanTitle = title ?? "";
    const separator = title ? ` - ` : ``;
    return `${cleanTitle}${separator}${appName}`;
};
const $e91e729a6066c3b7$var$Page = ({ className: className = "", children: children, title: title, onScroll: onScroll = ()=>{}, scroll: scroll = 0, style: style })=>{
    (0, $3QbnI.useEffect)(()=>{
        window.scrollTo(0, scroll);
    }, [
        scroll
    ]);
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("scroll", ()=>{
        onScroll(window.scrollY || 0);
    });
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const isStandalonePWA = (0, $b8ecb772f887e697$export$2e2bcd8739ae039)();
    const fullTitle = isStandalonePWA ? t("_AppName") : $e91e729a6066c3b7$var$browserTabTitle(title, t("_AppName"));
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $0bd4b6cc11215fa4$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("title", {
                        children: fullTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7121bc7d538f81b9$export$2e2bcd8739ae039), {
                effect: "solid",
                getContent: (dataTip)=>dataTip,
                disable: (0, $7941da5030926682$export$d0a8044dce8ff2fc)(),
                backgroundColor: "black",
                delayShow: 250
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: `relative bg-white scroll-auto select-none z-20	${className}`,
                style: style,
                id: "page",
                children: children
            })
        ]
    });
};
var $e91e729a6066c3b7$export$2e2bcd8739ae039 = $e91e729a6066c3b7$var$Page;








var $3QbnI = parcelRequire("3QbnI");

var $d890da727bd41033$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $d890da727bd41033$exports) {
        classNames.default = classNames;
        $d890da727bd41033$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


const $d439fb190db2ad1b$var$GenericButton = /*#__PURE__*/ (0, $3QbnI.forwardRef)(({ className: className = "", children: children = null, title: title = "", to: to, onClick: onClick, disabled: disabled = false, id: id, name: name, type: type = "button" }, ref)=>{
    const allClassName = (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("inline-flex justify-center items-center px-3 py-2 border border-transparent text-base sm:text-sm font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2", className);
    if (to) return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $500dda12544a1f09$export$a6c7ac8248d6e38a), {
        to: to,
        className: allClassName,
        id: id,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                className: "sr-only",
                children: title
            }),
            children
        ]
    });
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("button", {
        ref: ref,
        type: type,
        className: allClassName,
        onClick: onClick,
        disabled: disabled,
        id: id,
        name: name,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                className: "sr-only",
                children: title
            }),
            children
        ]
    });
});
var $d439fb190db2ad1b$export$2e2bcd8739ae039 = $d439fb190db2ad1b$var$GenericButton;




var $3QbnI = parcelRequire("3QbnI");
const $442d066ef18e5172$var$PrimaryButton = /*#__PURE__*/ (0, $3QbnI.forwardRef)(({ className: className = "", children: children = null, title: title = "", to: to, disabled: disabled, ...props }, ref)=>{
    const allClassName = (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("transition-colors	bg-gradient-to-r from-primary-300 via-primary-400 to-primary-500 hover:from-primary-500 hover:via-primary-500 hover:to-primary-500 focus:ring-primary-500", className, disabled ? "opacity-70" : "");
    if (to) return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d439fb190db2ad1b$export$2e2bcd8739ae039), {
        to: to,
        className: allClassName,
        disabled: disabled,
        ...props,
        children: children
    });
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d439fb190db2ad1b$export$2e2bcd8739ae039), {
        className: allClassName,
        disabled: disabled,
        ...props,
        ref: ref,
        children: children
    });
});
var $442d066ef18e5172$export$2e2bcd8739ae039 = $442d066ef18e5172$var$PrimaryButton;





const $17364ea2881d04a7$var$PrimaryButton = ({ className: className = "", children: children = null, title: title = "", to: to, onClick: onClick })=>{
    const allClassName = (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("bg-red-600 hover:bg-red-700 focus:ring-red-500", className);
    if (to) return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d439fb190db2ad1b$export$2e2bcd8739ae039), {
        to: to,
        className: allClassName,
        children: children
    });
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d439fb190db2ad1b$export$2e2bcd8739ae039), {
        className: allClassName,
        onClick: onClick,
        children: children
    });
};
var $17364ea2881d04a7$export$2e2bcd8739ae039 = $17364ea2881d04a7$var$PrimaryButton;






var $3QbnI = parcelRequire("3QbnI");


var $3QbnI = parcelRequire("3QbnI");


const $a3758683e16a4079$export$2a1563f24f434fb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createContext({
    isMaximized: false
});
const $a3758683e16a4079$var$FixedHeader = ({ restRef: restRef, children: children, onMaximizedChanged: onMaximizedChanged = ()=>{}, offset: offset = 90, className: className = "", disableMaximize: disableMaximize = false })=>{
    const [isMaximized, setMaximized] = (0, $3QbnI.useState)(false);
    const onScroll = (0, $3QbnI.useMemo)(()=>()=>{
            if (ref.current && restRef.current && !disableMaximize) {
                const positionY = ref.current.getBoundingClientRect().top;
                const positionY2 = restRef.current.getBoundingClientRect().top;
                const isMaximized = positionY > positionY2 - offset;
                setMaximized(isMaximized);
                onMaximizedChanged(isMaximized);
            }
        }, [
        restRef,
        onMaximizedChanged,
        offset,
        disableMaximize
    ]);
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("scroll", onScroll);
    const ref = (0, $3QbnI.useRef)(null);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))(className, "fixed z-40 top-0 left-0 right-0"),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($a3758683e16a4079$export$2a1563f24f434fb3.Provider, {
                value: {
                    isMaximized: isMaximized
                },
                children: children ? children(isMaximized) : null
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "fixed",
                ref: ref
            })
        ]
    });
};
var $a3758683e16a4079$export$2e2bcd8739ae039 = $a3758683e16a4079$var$FixedHeader;


const $b745f235b68325d9$var$IconButton = ({ url: url, className: className, icon: Icon, onClick: onClick = ()=>{}, children: children = [], disabled: disabled = false, blur: blur = false, label: label = "", basic: basic = false, title: title = "", rightIcon: rightIcon = false })=>{
    const { isMaximized: isMaximized } = (0, $3QbnI.useContext)((0, $a3758683e16a4079$export$2a1563f24f434fb3));
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("p-2 text-base font-medium text-gray-900 hover:text-primary-400 flex h-15 w-15 items-center bg-white pointer-events-auto", disabled ? "cursor-no-drop opacity-50" : "cursor-pointer", isMaximized || basic ? "" : "shadow rounded-md", blur ? "bg-opacity-50 backdrop-filter backdrop-blur" : "", className);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {
        children: url ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $500dda12544a1f09$export$a6c7ac8248d6e38a), {
            className: classes,
            to: url,
            onClick: onClick,
            "aria-label": title,
            children: [
                label && rightIcon && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                    className: "mr-0.5 hidden sm:inline text-normal",
                    children: label
                }),
                Icon && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(Icon, {
                    className: "h-7 w-7",
                    "aria-hidden": "true"
                }),
                label && !rightIcon && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                    className: "ml-0.5 hidden sm:inline text-normal",
                    children: label
                }),
                children
            ]
        }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("button", {
            className: classes,
            onClick: onClick,
            disabled: disabled,
            "aria-label": title,
            children: [
                label && rightIcon && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                    className: "mr-0.5 hidden sm:inline text-normal",
                    children: label
                }),
                Icon && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(Icon, {
                    className: "h-7 w-7",
                    "aria-hidden": "true"
                }),
                label && !rightIcon && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                    className: "ml-0.5 hidden sm:inline text-normal",
                    children: label
                }),
                children
            ]
        })
    });
};
var $b745f235b68325d9$export$2e2bcd8739ae039 = $b745f235b68325d9$var$IconButton;





const $a2fbdf10dddf5abf$var$BlackButton = ({ className: className = "", children: children = null, title: title = "", to: to, onClick: onClick, disabled: disabled = false, ...props })=>{
    const allClassName = (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("bg-black text-white hover:bg-gray-800 focus:ring-gray-900", className, disabled ? "opacity-70" : "");
    if (to) return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d439fb190db2ad1b$export$2e2bcd8739ae039), {
        to: to,
        className: allClassName,
        disabled: disabled,
        ...props,
        children: children
    });
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d439fb190db2ad1b$export$2e2bcd8739ae039), {
        className: allClassName,
        onClick: onClick,
        disabled: disabled,
        ...props,
        children: children
    });
};
var $a2fbdf10dddf5abf$export$2e2bcd8739ae039 = $a2fbdf10dddf5abf$var$BlackButton;





const $913be7cd874df637$var$WhiteButton = ({ className: className = "", children: children = null, title: title = "", to: to, onClick: onClick, disabled: disabled = false, ...props })=>{
    const allClassName = (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("bg-white !text-gray-700 hover:text-gray-900 border !border-gray-300 hover:bg-gray-100 focus:ring-gray-300", className, disabled ? "opacity-70" : "");
    if (to) return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d439fb190db2ad1b$export$2e2bcd8739ae039), {
        to: to,
        className: allClassName,
        disabled: disabled,
        ...props,
        children: children
    });
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d439fb190db2ad1b$export$2e2bcd8739ae039), {
        className: allClassName,
        onClick: onClick,
        disabled: disabled,
        children: children
    });
};
var $913be7cd874df637$export$2e2bcd8739ae039 = $913be7cd874df637$var$WhiteButton;




const $1d26f4e666070607$var$CircleButton = ({ children: children, className: className, "aria-label": ariaLabel, onClick: onClick = ()=>{} })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("rounded-full w-7 h-7 flex items-center justify-center shadow bg-white border border-gray-400 hover:bg-gray-100 focus:ring-gray-300 text-gray-700", className),
        "aria-label": ariaLabel,
        onClick: onClick,
        children: children
    });
};
var $1d26f4e666070607$export$2e2bcd8739ae039 = $1d26f4e666070607$var$CircleButton;


const $e8867e1811a3f10f$var$Button = {
    Primary: (0, $442d066ef18e5172$export$2e2bcd8739ae039),
    Error: (0, $17364ea2881d04a7$export$2e2bcd8739ae039),
    Icon: (0, $b745f235b68325d9$export$2e2bcd8739ae039),
    Black: (0, $a2fbdf10dddf5abf$export$2e2bcd8739ae039),
    White: (0, $913be7cd874df637$export$2e2bcd8739ae039),
    Circle: (0, $1d26f4e666070607$export$2e2bcd8739ae039)
};
var $e8867e1811a3f10f$export$2e2bcd8739ae039 = $e8867e1811a3f10f$var$Button;



// https://redux.js.org/usage/usage-with-typescript#define-typed-hooks

const $67ed7bda3729d158$export$f51d452c10d5b956 = ()=>(0, $d033bf60a87d7606$export$8ad76b76a4c905f8)();
const $67ed7bda3729d158$export$a7347740d65f620b = (selector, ...args)=>(0, $7600377419656cdf$export$2105062e25df4afe)((state)=>selector(state, ...args));




const $7d9071b508ba2a12$var$Container = ({ className: className, fullWidth: fullWidth, ...props })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("px-4 lg:px-16", {
            "max-w-screen-xl m-auto": !fullWidth
        }, className),
        ...props
    });
};
var $7d9071b508ba2a12$export$2e2bcd8739ae039 = $7d9071b508ba2a12$var$Container;




var $3QbnI = parcelRequire("3QbnI");
const $f2ee2a6d8a1239b4$var$BackgroundIllustration = (props)=>{
    let id = (0, $3QbnI.useId)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
                viewBox: "0 0 1026 1026",
                fill: "none",
                "aria-hidden": "true",
                className: "absolute inset-0 h-full w-full animate-spin-slow",
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                        d: "M1025 513c0 282.77-229.23 512-512 512S1 795.77 1 513 230.23 1 513 1s512 229.23 512 512Z",
                        stroke: "#D4D4D4",
                        strokeOpacity: "0.7"
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                        d: "M513 1025C230.23 1025 1 795.77 1 513",
                        stroke: `url(#${id}-gradient-1)`,
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("linearGradient", {
                            id: `${id}-gradient-1`,
                            x1: "1",
                            y1: "513",
                            x2: "1",
                            y2: "1025",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("stop", {
                                    stopColor: "#06b6d4"
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#06b6d4",
                                    stopOpacity: "0"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
                viewBox: "0 0 1026 1026",
                fill: "none",
                "aria-hidden": "true",
                className: "absolute inset-0 h-full w-full animate-spin-reverse-slower",
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                        d: "M913 513c0 220.914-179.086 400-400 400S113 733.914 113 513s179.086-400 400-400 400 179.086 400 400Z",
                        stroke: "#D4D4D4",
                        strokeOpacity: "0.7"
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                        d: "M913 513c0 220.914-179.086 400-400 400",
                        stroke: `url(#${id}-gradient-2)`,
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("linearGradient", {
                            id: `${id}-gradient-2`,
                            x1: "913",
                            y1: "513",
                            x2: "913",
                            y2: "913",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("stop", {
                                    stopColor: "#06b6d4"
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#06b6d4",
                                    stopOpacity: "0"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $f2ee2a6d8a1239b4$export$2e2bcd8739ae039 = $f2ee2a6d8a1239b4$var$BackgroundIllustration;



parcelRequire("3QbnI");

var $5a8d7679adfdf540$exports = {};
$5a8d7679adfdf540$exports = new URL("phone-frame.b86bc4f5.svg", import.meta.url).toString();


const $4eb5d0d997114485$var$PlaceholderFrame = (props)=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
        viewBox: "0 0 366 729",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fill: "#F2F2F2",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M300.092 1c41.22 0 63.223 21.99 63.223 63.213V184.94c-.173.184-.329.476-.458.851.188-.282.404-.547.647-.791.844-.073 2.496.257 2.496 2.157V268.719c-.406 2.023-2.605 2.023-2.605 2.023a7.119 7.119 0 0 1-.08-.102v394.462c0 41.213-22.001 63.212-63.223 63.212h-95.074c-.881-.468-2.474-.795-4.323-.838l-33.704-.005-.049.001h-.231l-.141-.001c-2.028 0-3.798.339-4.745.843H66.751c-41.223 0-63.223-21.995-63.223-63.208V287.739c-.402-.024-2.165-.23-2.524-2.02v-.973A2.039 2.039 0 0 1 1 284.62v-47.611c0-.042.001-.084.004-.126v-.726c0-1.9 1.652-2.23 2.496-2.157l.028.028v-16.289c-.402-.024-2.165-.23-2.524-2.02v-.973A2.039 2.039 0 0 1 1 214.62v-47.611c0-.042.001-.084.004-.126v-.726c0-1.9 1.652-2.23 2.496-2.157l.028.028v-26.041a2.26 2.26 0 0 0 .093-.236l-.064-.01a3.337 3.337 0 0 1-.72-.12l-.166-.028A2 2 0 0 1 1 135.62v-24.611a2 2 0 0 1 1.671-1.973l.857-.143v-44.68C3.528 22.99 25.53 1 66.75 1h233.341ZM3.952 234.516a5.481 5.481 0 0 0-.229-.278c.082.071.159.163.228.278Zm89.99-206.304A4.213 4.213 0 0 0 89.727 24H56.864C38.714 24 24 38.708 24 56.852v618.296C24 693.292 38.714 708 56.864 708h250.272c18.15 0 32.864-14.708 32.864-32.852V56.852C340 38.708 325.286 24 307.136 24h-32.864a4.212 4.212 0 0 0-4.213 4.212v2.527c0 10.235-8.3 18.532-18.539 18.532H112.48c-10.239 0-18.539-8.297-18.539-18.532v-2.527Z"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("rect", {
                x: "154",
                y: "29",
                width: "56",
                height: "5",
                rx: "2.5",
                fill: "#D4D4D4"
            })
        ]
    });
};
const $4eb5d0d997114485$var$PhoneFrame = ({ className: className, children: children, ...props })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("relative aspect-[366/729]", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "absolute inset-y-[calc(1/729*100%)] right-[calc(5/729*100%)] left-[calc(7/729*100%)] rounded-[calc(58/366*100%)/calc(58/729*100%)] shadow-2xl"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "absolute top-[calc(23/729*100%)] left-[calc(23/366*100%)] grid h-[calc(686/729*100%)] w-[calc(318/366*100%)] transform grid-cols-1 overflow-hidden bg-gray-900 pt-[calc(23/318*100%)]",
                children: children
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($4eb5d0d997114485$var$PlaceholderFrame, {
                className: "pointer-events-none absolute inset-0 h-full w-full fill-gray-100"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5a8d7679adfdf540$exports))),
                alt: "",
                className: "pointer-events-none absolute inset-0 h-full w-full"
            })
        ]
    });
};
var $4eb5d0d997114485$export$2e2bcd8739ae039 = $4eb5d0d997114485$var$PhoneFrame;


var $e505b3ac564f021a$exports = {};
$e505b3ac564f021a$exports = new URL("app.d3163006.png", import.meta.url).toString();



// https://stackoverflow.com/questions/61868907/how-to-open-google-chrome-from-webview-via-javascript
const $429785133e340feb$export$963d7d5148aac3a1 = (path)=>window.open(`intent:${"https://beta.getcookbook.io"}${path}#Intent;end`);


const $35610cccd34beda1$var$AppDemo = ()=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("img", {
        className: "absolute inset-0",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e505b3ac564f021a$exports))),
        alt: "App demo"
    });
const $35610cccd34beda1$var$Hero = ()=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("marketing");
    const user = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $68690f862a398578$export$e5432d4c8eb97ea7));
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    const openApp = ()=>{
        if (user) {
            if ((0, $7941da5030926682$export$4b5f14a3bef5854f)()) (0, $429785133e340feb$export$963d7d5148aac3a1)(`/recipes`);
            else navigate("/recipes");
        } else if ((0, $7941da5030926682$export$4b5f14a3bef5854f)()) (0, $429785133e340feb$export$963d7d5148aac3a1)(`/signup`);
        else navigate("/signup");
    };
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: "relative overflow-hidden py-20 sm:py-32 lg:pb-32 xl:pb-36",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                className: "lg:grid lg:grid-cols-12 lg:gap-x-8 lg:gap-y-20",
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "relative z-10 mx-auto max-w-2xl lg:col-span-7 lg:max-w-none lg:pt-6 xl:col-span-6",
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h1", {
                                className: "text-4xl font-medium tracking-tight text-gray-900",
                                style: {
                                    wordSpacing: t("Cook awesome meals easier, faster").includes("\xb7") ? "0.55rem" : undefined
                                },
                                children: t("Cook awesome meals easier, faster")
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                                className: "mt-6 text-lg text-gray-500 leading-8",
                                children: t("gathering recipes")
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "mt-8 flex flex-wrap gap-x-6 gap-y-4",
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary, {
                                    className: "!py-3 !px-5",
                                    onClick: openApp,
                                    children: user ? t("Open CookBook") : t("Create your CookBook")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "relative mt-10 sm:mt-20 lg:col-span-5 lg:row-span-2 lg:mt-0 xl:col-span-6",
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f2ee2a6d8a1239b4$export$2e2bcd8739ae039), {
                                className: "absolute left-1/2 top-4 h-[1026px] w-[1026px] -translate-x-1/3 stroke-gray-300/70 [mask-image:linear-gradient(to_bottom,white_20%,transparent_75%)] sm:top-16 sm:-translate-x-1/2 lg:-top-16 lg:ml-12 xl:-top-14 xl:ml-0"
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "-mx-4 h-[448px] px-9 [mask-image:linear-gradient(to_bottom,white_70%,transparent)] sm:mx-0 lg:absolute lg:-inset-x-10 lg:-top-10 lg:-bottom-20 lg:h-auto lg:px-0 lg:pt-10 xl:-bottom-32",
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4eb5d0d997114485$export$2e2bcd8739ae039), {
                                    className: "mx-auto max-w-[366px]",
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($35610cccd34beda1$var$AppDemo, {})
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $35610cccd34beda1$export$2e2bcd8739ae039 = $35610cccd34beda1$var$Hero;







const $4bf72665163a8648$var$Header = ({ children: children, className: className, fullWidth: fullWidth, white: white })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))({
            "bg-white shadow": white
        }),
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
            fullWidth: fullWidth,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("flex items-center h-16 justify-between", className),
            children: children
        })
    });
};
var $4bf72665163a8648$export$2e2bcd8739ae039 = $4bf72665163a8648$var$Header;





var $e190fc5bb1c833e4$exports = {};
$e190fc5bb1c833e4$exports = new URL("logo.2ea790a4.svg", import.meta.url).toString();


var $06c6973cd55ab443$exports = {};
$06c6973cd55ab443$exports = new URL("logo-rtl.1b37b5a5.svg", import.meta.url).toString();


const $2177ccffcfec9146$var$Logo = ({ className: className })=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setSearchParams] = (0, $500dda12544a1f09$export$f1a78c17382fe22a)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("img", {
        src: document.getElementsByTagName("body")?.[0].dir === "rtl" ? (0, (/*@__PURE__*/$parcel$interopDefault($06c6973cd55ab443$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($e190fc5bb1c833e4$exports))),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("h-9 cursor-pointer", className),
        onClick: ()=>{
            setSearchParams({});
        },
        alt: "logo",
        "data-testid": "logo"
    });
};
var /**
 * E71E4D
 * E21A5F
 * D70466
 */ $2177ccffcfec9146$export$2e2bcd8739ae039 = $2177ccffcfec9146$var$Logo;




const $99a8eda2a8735c38$var$Select = ({ id: id, name: name, className: className, defaultValue: defaultValue, onChange: onChange = ()=>{}, options: options })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("select", {
        id: id,
        name: name,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("block w-full rounded-md border-gray-300 py-2 pl-3 rtl:pl-0 pr-10 rtl:pl-10 text-base focus:border-black focus:outline-none focus:ring-black sm:text-sm cursor-pointer", className),
        defaultValue: defaultValue,
        onChange: (event)=>onChange(event.target.value),
        children: options.map(({ value: value, label: label })=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("option", {
                value: value,
                children: label
            }, value))
    });
};
var $99a8eda2a8735c38$export$2e2bcd8739ae039 = $99a8eda2a8735c38$var$Select;



var $87Z3V = parcelRequire("87Z3V");

function $1d3936925850f0be$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1d3936925850f0be$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1d3936925850f0be$var$_typeof(obj);
}
var $1d3936925850f0be$var$arr = [];
var $1d3936925850f0be$var$each = $1d3936925850f0be$var$arr.forEach;
var $1d3936925850f0be$var$slice = $1d3936925850f0be$var$arr.slice;
function $1d3936925850f0be$export$ebe90cb607ad99e(obj) {
    $1d3936925850f0be$var$each.call($1d3936925850f0be$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $1d3936925850f0be$export$87022daa49baf612() {
    return typeof XMLHttpRequest === "function" || (typeof XMLHttpRequest === "undefined" ? "undefined" : $1d3936925850f0be$var$_typeof(XMLHttpRequest)) === "object";
}
function $1d3936925850f0be$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === "function";
}
function $1d3936925850f0be$export$1625492ec82002b9(maybePromise) {
    if ($1d3936925850f0be$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}



var $047daae2497afea2$exports = {};
var $047daae2497afea2$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $047daae2497afea2$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $047daae2497afea2$var$fetchApi = window.fetch;
    else $047daae2497afea2$var$fetchApi = fetch;
}

if (typeof window === "undefined" || typeof window.document === "undefined") {
    var $047daae2497afea2$var$f = $047daae2497afea2$var$fetchApi || (parcelRequire("4JqPN"));
    if ($047daae2497afea2$var$f.default) $047daae2497afea2$var$f = $047daae2497afea2$var$f.default;
    $047daae2497afea2$exports.default = $047daae2497afea2$var$f;
    $047daae2497afea2$exports = $047daae2497afea2$exports.default;
}


function $a83a545c88088c42$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a83a545c88088c42$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a83a545c88088c42$var$_typeof(obj);
}
var $a83a545c88088c42$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $a83a545c88088c42$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $a83a545c88088c42$var$fetchApi = window.fetch;
    else $a83a545c88088c42$var$fetchApi = fetch;
}
var $a83a545c88088c42$var$XmlHttpRequestApi;
if ((0, $1d3936925850f0be$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== "undefined" && $parcel$global.XMLHttpRequest) $a83a545c88088c42$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== "undefined" && window.XMLHttpRequest) $a83a545c88088c42$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $a83a545c88088c42$var$ActiveXObjectApi;
if (typeof ActiveXObject === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.ActiveXObject) $a83a545c88088c42$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== "undefined" && window.ActiveXObject) $a83a545c88088c42$var$ActiveXObjectApi = window.ActiveXObject;
}
if (!$a83a545c88088c42$var$fetchApi && $047daae2497afea2$exports && !$a83a545c88088c42$var$XmlHttpRequestApi && !$a83a545c88088c42$var$ActiveXObjectApi) $a83a545c88088c42$var$fetchApi = $047daae2497afea2$exports.default || $047daae2497afea2$exports;
if (typeof $a83a545c88088c42$var$fetchApi !== "function") $a83a545c88088c42$var$fetchApi = undefined;
var $a83a545c88088c42$var$addQueryString = function addQueryString(url, params) {
    if (params && $a83a545c88088c42$var$_typeof(params) === "object") {
        var queryString = "";
        for(var paramName in params)queryString += "&" + encodeURIComponent(paramName) + "=" + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf("?") !== -1 ? "&" : "?") + queryString.slice(1);
    }
    return url;
};
var $a83a545c88088c42$var$fetchIt = function fetchIt(url, fetchOptions, callback) {
    $a83a545c88088c42$var$fetchApi(url, fetchOptions).then(function(response) {
        if (!response.ok) return callback(response.statusText || "Error", {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    }).catch(callback);
};
var $a83a545c88088c42$var$omitFetchOptions = false;
var $a83a545c88088c42$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $a83a545c88088c42$var$addQueryString(url, options.queryStringParams);
    var headers = (0, $1d3936925850f0be$export$ebe90cb607ad99e)({}, typeof options.customHeaders === "function" ? options.customHeaders() : options.customHeaders);
    if (payload) headers["Content-Type"] = "application/json";
    var reqOptions = typeof options.requestOptions === "function" ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = (0, $1d3936925850f0be$export$ebe90cb607ad99e)({
        method: payload ? "POST" : "GET",
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $a83a545c88088c42$var$omitFetchOptions ? {} : reqOptions);
    try {
        $a83a545c88088c42$var$fetchIt(url, fetchOptions, callback);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf("not implemented") < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $a83a545c88088c42$var$fetchIt(url, fetchOptions, callback);
            $a83a545c88088c42$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $a83a545c88088c42$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $a83a545c88088c42$var$_typeof(payload) === "object") payload = $a83a545c88088c42$var$addQueryString("", payload).slice(1);
    if (options.queryStringParams) url = $a83a545c88088c42$var$addQueryString(url, options.queryStringParams);
    try {
        var x;
        if ($a83a545c88088c42$var$XmlHttpRequestApi) x = new $a83a545c88088c42$var$XmlHttpRequestApi();
        else x = new $a83a545c88088c42$var$ActiveXObjectApi("MSXML2.XMLHTTP.3.0");
        x.open(payload ? "POST" : "GET", url, 1);
        if (!options.crossDomain) x.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        if (x.overrideMimeType) x.overrideMimeType("application/json");
        var h = options.customHeaders;
        h = typeof h === "function" ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $a83a545c88088c42$var$request = function request(options, url, payload, callback) {
    if (typeof payload === "function") {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($a83a545c88088c42$var$fetchApi) return $a83a545c88088c42$var$requestWithFetch(options, url, payload, callback);
    if ((0, $1d3936925850f0be$export$87022daa49baf612)() || typeof ActiveXObject === "function") return $a83a545c88088c42$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error("No fetch and no xhr implementation found!"));
};
var $a83a545c88088c42$export$2e2bcd8739ae039 = $a83a545c88088c42$var$request;


function $c7072caef5aa6e41$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c7072caef5aa6e41$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c7072caef5aa6e41$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c7072caef5aa6e41$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c7072caef5aa6e41$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c7072caef5aa6e41$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c7072caef5aa6e41$var$getDefaults = function getDefaults() {
    return {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        addPath: "/locales/add/{{lng}}/{{ns}}",
        allowMultiLoading: false,
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $c7072caef5aa6e41$var$_defineProperty({}, key, fallbackValue || "");
        },
        request: (0, $a83a545c88088c42$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== "undefined" ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: "cors",
            credentials: "same-origin",
            cache: "default"
        }
    };
};
var $c7072caef5aa6e41$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $c7072caef5aa6e41$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = "backend";
        this.init(services, options, allOptions);
    }
    $c7072caef5aa6e41$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = (0, $1d3936925850f0be$export$ebe90cb607ad99e)(options, this.options || {}, $c7072caef5aa6e41$var$getDefaults());
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) setInterval(function() {
                    return _this.reload();
                }, this.options.reloadInterval);
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === "function") loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $1d3936925850f0be$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join("+"),
                        ns: namespaces.join("+")
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                this.options.request(this.options, url, undefined, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback("failed loading " + url + "; status code: " + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback("failed loading " + url + "; status code: " + res.status, false);
                    if (!res && err && err.message && err.message.indexOf("Failed to fetch") > -1) return callback("failed loading " + url + ": " + err.message, true);
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === "string") ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = "failed parsing " + url + " to json";
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === "string") languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === "function") addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (callback) callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === "cimode") return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, "read", null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
    return Backend;
}();
$c7072caef5aa6e41$var$Backend.type = "backend";
var $c7072caef5aa6e41$export$2e2bcd8739ae039 = $c7072caef5aa6e41$var$Backend;



var $4lDXN = parcelRequire("4lDXN");

var $9i3GH = parcelRequire("9i3GH");
var $fbf03cc47335edb3$var$arr = [];
var $fbf03cc47335edb3$var$each = $fbf03cc47335edb3$var$arr.forEach;
var $fbf03cc47335edb3$var$slice = $fbf03cc47335edb3$var$arr.slice;
function $fbf03cc47335edb3$var$defaults(obj) {
    $fbf03cc47335edb3$var$each.call($fbf03cc47335edb3$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $fbf03cc47335edb3$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $fbf03cc47335edb3$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$fbf03cc47335edb3$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$fbf03cc47335edb3$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $fbf03cc47335edb3$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $fbf03cc47335edb3$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $fbf03cc47335edb3$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $fbf03cc47335edb3$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $fbf03cc47335edb3$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $fbf03cc47335edb3$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $fbf03cc47335edb3$var$hasLocalStorageSupport = null;
var $fbf03cc47335edb3$var$localStorageAvailable = function localStorageAvailable() {
    if ($fbf03cc47335edb3$var$hasLocalStorageSupport !== null) return $fbf03cc47335edb3$var$hasLocalStorageSupport;
    try {
        $fbf03cc47335edb3$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $fbf03cc47335edb3$var$hasLocalStorageSupport = false;
    }
    return $fbf03cc47335edb3$var$hasLocalStorageSupport;
};
var $fbf03cc47335edb3$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $fbf03cc47335edb3$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $fbf03cc47335edb3$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $fbf03cc47335edb3$var$hasSessionStorageSupport = null;
var $fbf03cc47335edb3$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($fbf03cc47335edb3$var$hasSessionStorageSupport !== null) return $fbf03cc47335edb3$var$hasSessionStorageSupport;
    try {
        $fbf03cc47335edb3$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $fbf03cc47335edb3$var$hasSessionStorageSupport = false;
    }
    return $fbf03cc47335edb3$var$hasSessionStorageSupport;
};
var $fbf03cc47335edb3$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $fbf03cc47335edb3$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $fbf03cc47335edb3$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $fbf03cc47335edb3$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $fbf03cc47335edb3$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $fbf03cc47335edb3$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $fbf03cc47335edb3$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1; // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i); // if there is no match (null) return undefined
        if (!language) return undefined; // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $fbf03cc47335edb3$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ] // cookieMinutes: 10,
    };
}
var $fbf03cc47335edb3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4lDXN.default)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $9i3GH.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $fbf03cc47335edb3$var$defaults(options, this.options || {}, $fbf03cc47335edb3$var$getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($fbf03cc47335edb3$var$cookie$1);
                this.addDetector($fbf03cc47335edb3$var$querystring);
                this.addDetector($fbf03cc47335edb3$var$localStorage);
                this.addDetector($fbf03cc47335edb3$var$sessionStorage);
                this.addDetector($fbf03cc47335edb3$var$navigator$1);
                this.addDetector($fbf03cc47335edb3$var$htmlTag);
                this.addDetector($fbf03cc47335edb3$var$path);
                this.addDetector($fbf03cc47335edb3$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$fbf03cc47335edb3$export$2e2bcd8739ae039.type = "languageDetector";


var $c39f3d5a4cf94fb3$exports = {};
$c39f3d5a4cf94fb3$exports = JSON.parse('{"farsi":true,"focus":true,"timer":false}');


var $701df4756a4017d1$exports = {};
$701df4756a4017d1$exports = JSON.parse('{"farsi":false,"focus":true,"timer":false}');


var $4f27b2737c5808db$exports = {};
$4f27b2737c5808db$exports = JSON.parse('{"farsi":true,"focus":false,"timer":false}');


const $089eebd7fd208286$var$findFeatures = ()=>{
    return 0, (/*@__PURE__*/$parcel$interopDefault($4f27b2737c5808db$exports));
};
const $089eebd7fd208286$var$features = $089eebd7fd208286$var$findFeatures();
const $089eebd7fd208286$export$25eaa035e2e3a214 = (featureName)=>Boolean($089eebd7fd208286$var$features[featureName]);


const $c3738d05463420c7$export$d0d68bb9ed2c643d = [
    {
        value: "fr",
        label: "Fran\xe7ais"
    },
    {
        value: "en",
        label: "English"
    },
    (0, $089eebd7fd208286$export$25eaa035e2e3a214)("farsi") ? {
        value: "fa",
        label: "\u0641\u0627\u0631\u0633\u06CC"
    } : null
].filter(Boolean);
(0, $87Z3V.default)// load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
// learn more: https://github.com/i18next/i18next-http-backend
// want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
.use((0, $c7072caef5aa6e41$export$2e2bcd8739ae039))// detect user language
// learn more: https://github.com/i18next/i18next-browser-languageDetector
.use((0, $fbf03cc47335edb3$export$2e2bcd8739ae039))// pass the i18n instance to react-i18next.
.use((0, $e4acdf289761376f$export$ae7e14d40d89f296))// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
.init({
    ns: [
        "default"
    ],
    fallbackLng: "en",
    debug: false,
    load: "all",
    supportedLngs: $c3738d05463420c7$export$d0d68bb9ed2c643d.map((l)=>l.value),
    interpolation: {
        escapeValue: false
    },
    backend: {
        loadPath: `/locales/{{lng}}/{{ns}}.json`
    }
});
var $c3738d05463420c7$export$2e2bcd8739ae039 = (0, $87Z3V.default);


const $3b62850daa0ffbbd$var$LandingHeader = ()=>{
    const { i18n: i18n } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("marketing");
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $4bf72665163a8648$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $2177ccffcfec9146$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "flex-1"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $99a8eda2a8735c38$export$2e2bcd8739ae039), {
                    id: "languages",
                    name: "languages",
                    className: "mt-1 !text-gray-500 !border-none !focus:outline-none flex-auto",
                    defaultValue: i18n.language,
                    onChange: (language)=>i18n.changeLanguage(language),
                    options: (0, $c3738d05463420c7$export$d0d68bb9ed2c643d)
                })
            })
        ]
    });
};
var $3b62850daa0ffbbd$export$2e2bcd8739ae039 = $3b62850daa0ffbbd$var$LandingHeader;







var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
/**
 * Browser-safe usage of process
 */ 
var $54X9E = parcelRequire("54X9E");
const $f2a6b1e4c1fe889e$var$defaultEnvironment = "production";
const $f2a6b1e4c1fe889e$export$a7b6bc01c63cdfc3 = typeof $54X9E === "undefined" || $54X9E.env === undefined ? $f2a6b1e4c1fe889e$var$defaultEnvironment : "production";


/*
  Detect and load appropriate clock setting for the execution environment
 */ const $5474045332d9479e$export$f8caf8121275292d = 1 / 60 * 1000;
const $5474045332d9479e$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $5474045332d9479e$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($5474045332d9479e$var$getCurrentTime()), $5474045332d9479e$export$f8caf8121275292d);


function $8db0de01a9df5b81$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two arrays, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let toRun = [];
    let toRunNextFrame = [];
    /**
     *
     */ let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            // If the buffer doesn't already contain this callback, add it
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                // If we're adding it to the currently running buffer, update its measured size
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            // Clear the next frame list
            toRunNextFrame.length = 0;
            // Execute this frame
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $bf0b592d43581589$export$fff89137e9e818ce = {
    delta: 0,
    timestamp: 0
};


const $9a179e07aa15314d$var$maxElapsed = 40;
let $9a179e07aa15314d$var$useDefaultElapsed = true;
let $9a179e07aa15314d$var$runNextFrame = false;
let $9a179e07aa15314d$var$isProcessing = false;
const $9a179e07aa15314d$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $9a179e07aa15314d$var$steps = $9a179e07aa15314d$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $8db0de01a9df5b81$export$b995e5e85f5c8289)(()=>$9a179e07aa15314d$var$runNextFrame = true);
    return acc;
}, {});
const $9a179e07aa15314d$export$92d6409d68f0739a = $9a179e07aa15314d$var$stepsOrder.reduce((acc, key)=>{
    const step = $9a179e07aa15314d$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$9a179e07aa15314d$var$runNextFrame) $9a179e07aa15314d$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $9a179e07aa15314d$export$d93e9c1fe0553512 = $9a179e07aa15314d$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $9a179e07aa15314d$var$steps[key].cancel;
    return acc;
}, {});
const $9a179e07aa15314d$export$cd75ccfd720a3cd4 = $9a179e07aa15314d$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$9a179e07aa15314d$var$steps[key].process((0, $bf0b592d43581589$export$fff89137e9e818ce));
    return acc;
}, {});
const $9a179e07aa15314d$var$processStep = (stepId)=>$9a179e07aa15314d$var$steps[stepId].process((0, $bf0b592d43581589$export$fff89137e9e818ce));
const $9a179e07aa15314d$var$processFrame = (timestamp)=>{
    $9a179e07aa15314d$var$runNextFrame = false;
    (0, $bf0b592d43581589$export$fff89137e9e818ce).delta = $9a179e07aa15314d$var$useDefaultElapsed ? (0, $5474045332d9479e$export$f8caf8121275292d) : Math.max(Math.min(timestamp - (0, $bf0b592d43581589$export$fff89137e9e818ce).timestamp, $9a179e07aa15314d$var$maxElapsed), 1);
    (0, $bf0b592d43581589$export$fff89137e9e818ce).timestamp = timestamp;
    $9a179e07aa15314d$var$isProcessing = true;
    $9a179e07aa15314d$var$stepsOrder.forEach($9a179e07aa15314d$var$processStep);
    $9a179e07aa15314d$var$isProcessing = false;
    if ($9a179e07aa15314d$var$runNextFrame) {
        $9a179e07aa15314d$var$useDefaultElapsed = false;
        (0, $5474045332d9479e$export$4fdea63ab5513fd5)($9a179e07aa15314d$var$processFrame);
    }
};
const $9a179e07aa15314d$var$startLoop = ()=>{
    $9a179e07aa15314d$var$runNextFrame = true;
    $9a179e07aa15314d$var$useDefaultElapsed = true;
    if (!$9a179e07aa15314d$var$isProcessing) (0, $5474045332d9479e$export$4fdea63ab5513fd5)($9a179e07aa15314d$var$processFrame);
};



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
const $99db44a5d4c29f46$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $af780b6ff3ca9500$export$700979bc83e7db82 = (0, $99db44a5d4c29f46$export$4e09c449d6c407f7) ? (0, $3QbnI.useLayoutEffect) : (0, $3QbnI.useEffect);


function $507c7f6e40fa65ad$export$80c2a3957bcb42ea() {
    const isMounted = (0, $3QbnI.useRef)(false);
    (0, $af780b6ff3ca9500$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


function $e6dfee27007ee996$export$91db9bc4f8ac944a() {
    const isMounted = (0, $507c7f6e40fa65ad$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $3QbnI.useState)(0);
    const forceRender = (0, $3QbnI.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $3QbnI.useCallback)(()=>(0, $9a179e07aa15314d$export$92d6409d68f0739a).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
/**
 * @public
 */ const $255f9a0b0527cdcb$export$f224e4635b6f8ce2 = (0, $3QbnI.createContext)(null);



var $3QbnI = parcelRequire("3QbnI");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $fe17874da42017ee$export$fe4300aa8eebea86(init) {
    const ref = (0, $3QbnI.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $3QbnI = parcelRequire("3QbnI");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $ad6d6336381544af$var$PopChildMeasure extends $3QbnI.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $ad6d6336381544af$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $3QbnI.useId)();
    const ref = (0, $3QbnI.useRef)(null);
    const size = (0, $3QbnI.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $3QbnI.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $3QbnI.createElement($ad6d6336381544af$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $3QbnI.cloneElement(children, {
        ref: ref
    }));
}


const $a72f9558e82a82ab$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $fe17874da42017ee$export$fe4300aa8eebea86)($a72f9558e82a82ab$var$newChildrenMap);
    const id = (0, $3QbnI.useId)();
    const context = (0, $3QbnI.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $3QbnI.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $3QbnI.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $3QbnI.createElement((0, $ad6d6336381544af$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $3QbnI.createElement((0, $255f9a0b0527cdcb$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $a72f9558e82a82ab$var$newChildrenMap() {
    return new Map();
}



var $3QbnI = parcelRequire("3QbnI");
const $620e8e0b2359a784$export$a3579ca508007a95 = (0, $3QbnI.createContext)({});




var $3QbnI = parcelRequire("3QbnI");
function $e504b98c47df39d3$export$f3a192d0cbd30b96(callback) {
    return (0, $3QbnI.useEffect)(()=>()=>callback(), []);
}


const $801ea30613bca485$var$warned = new Set();
function $801ea30613bca485$export$5b28268982f175ba(condition, message, element) {
    if (condition || $801ea30613bca485$var$warned.has(message)) return;
    console.warn(message);
    if (element) console.warn(element);
    $801ea30613bca485$var$warned.add(message);
}


const $6a867d50f3c49424$var$getChildKey = (child)=>child.key || "";
function $6a867d50f3c49424$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $6a867d50f3c49424$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $6a867d50f3c49424$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $3QbnI.Children).forEach(children, (child)=>{
        if ((0, $3QbnI.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $6a867d50f3c49424$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    // Support deprecated exitBeforeEnter prop
    if (exitBeforeEnter) {
        mode = "wait";
        (0, $801ea30613bca485$export$5b28268982f175ba)(false, "Replace exitBeforeEnter with mode='wait'");
    }
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    let [forceRender] = (0, $e6dfee27007ee996$export$91db9bc4f8ac944a)();
    const forceRenderLayoutGroup = (0, $3QbnI.useContext)((0, $620e8e0b2359a784$export$a3579ca508007a95)).forceRender;
    if (forceRenderLayoutGroup) forceRender = forceRenderLayoutGroup;
    const isMounted = (0, $507c7f6e40fa65ad$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $6a867d50f3c49424$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $3QbnI.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $3QbnI.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $3QbnI.useRef)(true);
    (0, $af780b6ff3ca9500$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $6a867d50f3c49424$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $e504b98c47df39d3$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) return $3QbnI.createElement($3QbnI.Fragment, null, childrenToRender.map((child)=>$3QbnI.createElement((0, $a72f9558e82a82ab$export$979daf65881a382a), {
            key: $6a867d50f3c49424$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($6a867d50f3c49424$var$getChildKey);
    const targetKeys = filteredChildren.map($6a867d50f3c49424$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach((key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        const onExit = ()=>{
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            const removeIndex = presentChildren.current.findIndex((presentChild)=>presentChild.key === key);
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false) return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, $3QbnI.createElement((0, $a72f9558e82a82ab$export$979daf65881a382a), {
            key: $6a867d50f3c49424$var$getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exiting.has(key) ? child : $3QbnI.createElement((0, $a72f9558e82a82ab$export$979daf65881a382a), {
            key: $6a867d50f3c49424$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    if ((0, $f2a6b1e4c1fe889e$export$a7b6bc01c63cdfc3) !== "production" && mode === "wait" && childrenToRender.length > 1) console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
    return $3QbnI.createElement($3QbnI.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map((child)=>(0, $3QbnI.cloneElement)(child)));
};


var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
/**
 * @public
 */ const $6cc415884e1c31ed$export$22a697fb29aac98d = (0, $3QbnI.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $3QbnI = parcelRequire("3QbnI");
const $6e0bc1ba9369d26d$export$2285bbca2c666415 = (0, $3QbnI.createContext)({});
function $6e0bc1ba9369d26d$export$cd995842eb2ab956() {
    return (0, $3QbnI.useContext)($6e0bc1ba9369d26d$export$2285bbca2c666415).visualElement;
}



var $3QbnI = parcelRequire("3QbnI");




var $3QbnI = parcelRequire("3QbnI");
const $e2199e53e3f06e88$export$40f10139ecf1f171 = (0, $3QbnI.createContext)({
    strict: false
});



function $c6d13c2b929f2086$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const parent = (0, $6e0bc1ba9369d26d$export$cd995842eb2ab956)();
    const lazyContext = (0, $3QbnI.useContext)((0, $e2199e53e3f06e88$export$40f10139ecf1f171));
    const presenceContext = (0, $3QbnI.useContext)((0, $255f9a0b0527cdcb$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $3QbnI.useContext)((0, $6cc415884e1c31ed$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $3QbnI.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceId: presenceContext ? presenceContext.id : undefined,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $af780b6ff3ca9500$export$700979bc83e7db82)(()=>{
        visualElement && visualElement.render();
    });
    /**
     * If we have optimised appear animations to handoff from, trigger animateChanges
     * from a synchronous useLayoutEffect to ensure there's no flash of incorrectly
     * styled component in the event of a hydration error.
     */ (0, $af780b6ff3ca9500$export$700979bc83e7db82)(()=>{
        if (visualElement && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $af780b6ff3ca9500$export$700979bc83e7db82)(()=>()=>visualElement && visualElement.notify("Unmount"), []);
    return visualElement;
}



var $3QbnI = parcelRequire("3QbnI");
function $5f2bb49c93cd76c8$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $4dd73d1ba08f8647$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $3QbnI.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $5f2bb49c93cd76c8$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $3QbnI = parcelRequire("3QbnI");

/**
 * Decides if the supplied variable is variant label
 */ function $21719eecd02f42f9$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $d4d04c41765ec410$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}



const $e6cef9ccd8a57339$var$variantProps = [
    "initial",
    "animate",
    "exit",
    "whileHover",
    "whileDrag",
    "whileTap",
    "whileFocus",
    "whileInView"
];
function $e6cef9ccd8a57339$export$4b3c3bd8d910d78d(props) {
    return (0, $d4d04c41765ec410$export$aa71198ceeaf53ce)(props.animate) || $e6cef9ccd8a57339$var$variantProps.some((name)=>(0, $21719eecd02f42f9$export$720b90e312cea233)(props[name]));
}
function $e6cef9ccd8a57339$export$ce46fa4165cdec40(props) {
    return Boolean($e6cef9ccd8a57339$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $32d2e30a3700afc8$export$12fc32fc096a04a3(props, context) {
    if ((0, $e6cef9ccd8a57339$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $21719eecd02f42f9$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $21719eecd02f42f9$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $4ca09e7710d7a61d$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $32d2e30a3700afc8$export$12fc32fc096a04a3)(props, (0, $3QbnI.useContext)((0, $6e0bc1ba9369d26d$export$2285bbca2c666415)));
    return (0, $3QbnI.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $4ca09e7710d7a61d$var$variantLabelsAsDependency(initial),
        $4ca09e7710d7a61d$var$variantLabelsAsDependency(animate)
    ]);
}
function $4ca09e7710d7a61d$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $718e06fa2114feac$var$createDefinition = (propNames)=>({
        isEnabled: (props)=>propNames.some((name)=>!!props[name])
    });
const $718e06fa2114feac$export$65570e08d843624d = {
    measureLayout: $718e06fa2114feac$var$createDefinition([
        "layout",
        "layoutId",
        "drag"
    ]),
    animation: $718e06fa2114feac$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView"
    ]),
    exit: $718e06fa2114feac$var$createDefinition([
        "exit"
    ]),
    drag: $718e06fa2114feac$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $718e06fa2114feac$var$createDefinition([
        "whileFocus"
    ]),
    hover: $718e06fa2114feac$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $718e06fa2114feac$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $718e06fa2114feac$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    inView: $718e06fa2114feac$var$createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ])
};



function $8aaa7289ae4c6c67$export$449561ec5703cdc8(features) {
    for(const key in features)if (key === "projectionNodeConstructor") (0, $718e06fa2114feac$export$65570e08d843624d).projectionNodeConstructor = features[key];
    else (0, $718e06fa2114feac$export$65570e08d843624d)[key].Component = features[key];
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $cf9811a0031fff82$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};


let $18b46e3f3fd4faa4$var$id = 1;
function $18b46e3f3fd4faa4$export$5ed57b87c18af11a() {
    return (0, $fe17874da42017ee$export$fe4300aa8eebea86)(()=>{
        if ((0, $cf9811a0031fff82$export$97db156a3ed1593b).hasEverUpdated) return $18b46e3f3fd4faa4$var$id++;
    });
}




var $3QbnI = parcelRequire("3QbnI");
class $e089c6391902db88$export$a9ca437df31f9491 extends (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Component {
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */ getSnapshotBeforeUpdate() {
        const { visualElement: visualElement, props: props } = this.props;
        if (visualElement) visualElement.setProps(props);
        return null;
    }
    componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}




var $3QbnI = parcelRequire("3QbnI");
/**
 * Internal, exported only for usage in Framer
 */ const $422301a601df0ddc$export$da5f7b802957459a = (0, $3QbnI.createContext)({});


const $47183be101e48a75$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $c89a03112c1d6e5c$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, projectionNodeConstructor: projectionNodeConstructor, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $8aaa7289ae4c6c67$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        const configAndProps = {
            ...(0, $3QbnI.useContext)((0, $6cc415884e1c31ed$export$22a697fb29aac98d)),
            ...props,
            layoutId: $c89a03112c1d6e5c$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        let features = null;
        const context = (0, $4ca09e7710d7a61d$export$c5638d843b37a176)(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */ const projectionId = isStatic ? undefined : (0, $18b46e3f3fd4faa4$export$5ed57b87c18af11a)();
        /**
         *
         */ const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $99db44a5d4c29f46$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $c6d13c2b929f2086$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const lazyStrictMode = (0, $3QbnI.useContext)((0, $e2199e53e3f06e88$export$40f10139ecf1f171)).strict;
            const initialLayoutGroupConfig = (0, $3QbnI.useContext)((0, $422301a601df0ddc$export$da5f7b802957459a));
            if (context.visualElement) features = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, lazyStrictMode, preloadedFeatures, projectionId, projectionNodeConstructor || (0, $718e06fa2114feac$export$65570e08d843624d).projectionNodeConstructor, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $3QbnI.createElement((0, $e089c6391902db88$export$a9ca437df31f9491), {
            visualElement: context.visualElement,
            props: configAndProps
        }, features, $3QbnI.createElement((0, $6e0bc1ba9369d26d$export$2285bbca2c666415).Provider, {
            value: context
        }, useRender(Component, props, projectionId, (0, $4dd73d1ba08f8647$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)));
    }
    const ForwardRefComponent = (0, $3QbnI.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $47183be101e48a75$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $c89a03112c1d6e5c$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $3QbnI.useContext)((0, $620e8e0b2359a784$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $2a13ec88355fa9e0$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $c89a03112c1d6e5c$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $c488e7c02cec9d32$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $e5c1e686740388d5$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $c488e7c02cec9d32$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
const $a066e957945bd554$export$91ddd985b97788d1 = {};
function $a066e957945bd554$export$de9e7791c71225fd(correctors) {
    Object.assign($a066e957945bd554$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $d160cfa1fbfbdd2f$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $d160cfa1fbfbdd2f$export$7b42a0094fb00b6e = new Set($d160cfa1fbfbdd2f$export$280dc01950909d86);


function $16ad1a9a816d139b$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $d160cfa1fbfbdd2f$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $a066e957945bd554$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $98deaa364e648ac8$export$605d60a2578142d3 = (value)=>!!(value === null || value === void 0 ? void 0 : value.getVelocity);



const $f76f974e0c9a791a$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ const $f76f974e0c9a791a$var$sortTransformProps = (a, b)=>(0, $d160cfa1fbfbdd2f$export$280dc01950909d86).indexOf(a) - (0, $d160cfa1fbfbdd2f$export$280dc01950909d86).indexOf(b);
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $f76f974e0c9a791a$export$bdc96e0d5c8f914({ transform: transform, transformKeys: transformKeys }, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort($f76f974e0c9a791a$var$sortTransformProps);
    // Loop over each transform and build them into transformString
    for (const key of transformKeys)transformString += `${$f76f974e0c9a791a$var$translateAlias[key] || key}(${transform[key]}) `;
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


/**
 * Returns true if the provided key is a CSS variable
 */ function $57de5cb506354910$export$451bc42768436155(key) {
    return key.startsWith("--");
}



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $81b5f3915ded9b90$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $fc8aa3a981bda5c2$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $4eaf82465a158227$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $4eaf82465a158227$export$58f0f39f63f3cf42 = {
    ...$4eaf82465a158227$export$98e628dec113755e,
    transform: (v)=>(0, $fc8aa3a981bda5c2$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $4eaf82465a158227$export$dcdf75081b88279d = {
    ...$4eaf82465a158227$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $1c339a848e05ca58$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $1c339a848e05ca58$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $1c339a848e05ca58$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $1c339a848e05ca58$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $1c339a848e05ca58$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $bedfe8fbb87aed27$var$createUnitType = (unit)=>({
        test: (v)=>(0, $1c339a848e05ca58$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $bedfe8fbb87aed27$export$41fc368e1a942b97 = $bedfe8fbb87aed27$var$createUnitType("deg");
const $bedfe8fbb87aed27$export$626336c2cd4b14de = $bedfe8fbb87aed27$var$createUnitType("%");
const $bedfe8fbb87aed27$export$91c0eda1d06bf008 = $bedfe8fbb87aed27$var$createUnitType("px");
const $bedfe8fbb87aed27$export$f91e8c45a95a32f2 = $bedfe8fbb87aed27$var$createUnitType("vh");
const $bedfe8fbb87aed27$export$aed3d7b7d206c196 = $bedfe8fbb87aed27$var$createUnitType("vw");
const $bedfe8fbb87aed27$export$44e2e1705876d7ed = {
    ...$bedfe8fbb87aed27$export$626336c2cd4b14de,
    parse: (v)=>$bedfe8fbb87aed27$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$bedfe8fbb87aed27$export$626336c2cd4b14de.transform(v * 100)
};



const $2bbccdfd2c057527$export$7d260a2a5f8bc19e = {
    ...(0, $4eaf82465a158227$export$98e628dec113755e),
    transform: Math.round
};


const $23f6854e2701e290$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    borderTopWidth: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    borderRightWidth: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    borderRadius: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    radius: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    maxWidth: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    height: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    maxHeight: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    size: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    top: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    right: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    bottom: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    left: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    paddingTop: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    paddingRight: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    paddingBottom: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    paddingLeft: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    margin: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    marginTop: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    marginRight: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    marginBottom: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    marginLeft: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $bedfe8fbb87aed27$export$41fc368e1a942b97),
    rotateX: (0, $bedfe8fbb87aed27$export$41fc368e1a942b97),
    rotateY: (0, $bedfe8fbb87aed27$export$41fc368e1a942b97),
    rotateZ: (0, $bedfe8fbb87aed27$export$41fc368e1a942b97),
    scale: $4eaf82465a158227$export$dcdf75081b88279d,
    scaleX: (0, $4eaf82465a158227$export$dcdf75081b88279d),
    scaleY: (0, $4eaf82465a158227$export$dcdf75081b88279d),
    scaleZ: (0, $4eaf82465a158227$export$dcdf75081b88279d),
    skew: (0, $bedfe8fbb87aed27$export$41fc368e1a942b97),
    skewX: (0, $bedfe8fbb87aed27$export$41fc368e1a942b97),
    skewY: (0, $bedfe8fbb87aed27$export$41fc368e1a942b97),
    distance: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    translateX: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    translateY: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    translateZ: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    x: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    y: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    z: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    perspective: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    transformPerspective: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    opacity: (0, $4eaf82465a158227$export$58f0f39f63f3cf42),
    originX: (0, $bedfe8fbb87aed27$export$44e2e1705876d7ed),
    originY: (0, $bedfe8fbb87aed27$export$44e2e1705876d7ed),
    originZ: (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $2bbccdfd2c057527$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $4eaf82465a158227$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $4eaf82465a158227$export$58f0f39f63f3cf42),
    numOctaves: (0, $2bbccdfd2c057527$export$7d260a2a5f8bc19e)
};


function $e7bbc696ba6d4c61$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformKeys: transformKeys, transformOrigin: transformOrigin } = state;
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $57de5cb506354910$export$451bc42768436155)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $23f6854e2701e290$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $81b5f3915ded9b90$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $d160cfa1fbfbdd2f$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $f76f974e0c9a791a$export$bdc96e0d5c8f914)(state, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $6233cd6cb2642c83$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    });


function $81063d9b33fcb641$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $98deaa364e648ac8$export$605d60a2578142d3)(source[key]) && !(0, $16ad1a9a816d139b$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $81063d9b33fcb641$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $3QbnI.useMemo)(()=>{
        const state = (0, $6233cd6cb2642c83$export$8940b483cf52eeda)();
        (0, $e7bbc696ba6d4c61$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $81063d9b33fcb641$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81063d9b33fcb641$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81063d9b33fcb641$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $81063d9b33fcb641$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $81063d9b33fcb641$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    htmlProps.style = style;
    return htmlProps;
}


const $541efd02ccf3517c$var$animationProps = [
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
];
const $541efd02ccf3517c$var$tapProps = [
    "whileTap",
    "onTap",
    "onTapStart",
    "onTapCancel"
];
const $541efd02ccf3517c$var$panProps = [
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
];
const $541efd02ccf3517c$var$inViewProps = [
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport"
];
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $541efd02ccf3517c$var$validMotionProps = new Set([
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "onHoverStart",
    "onHoverEnd",
    "layoutScroll",
    ...$541efd02ccf3517c$var$inViewProps,
    ...$541efd02ccf3517c$var$tapProps,
    ...$541efd02ccf3517c$var$animationProps,
    ...$541efd02ccf3517c$var$panProps
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $541efd02ccf3517c$export$2f9c46555243bf04(key) {
    return $541efd02ccf3517c$var$validMotionProps.has(key);
}


let $89d7853977c6fea0$var$shouldForward = (key)=>!(0, $541efd02ccf3517c$export$2f9c46555243bf04)(key);
function $89d7853977c6fea0$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $89d7853977c6fea0$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $541efd02ccf3517c$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $89d7853977c6fea0$export$59d6962c470509a5((parcelRequire("j212u")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $89d7853977c6fea0$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props)if ($89d7853977c6fea0$var$shouldForward(key) || forwardMotionProps === true && (0, $541efd02ccf3517c$export$2f9c46555243bf04)(key) || !isDom && !(0, $541efd02ccf3517c$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    return filteredProps;
}




var $3QbnI = parcelRequire("3QbnI");



function $ad74f3bfed6c15a6$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $ad74f3bfed6c15a6$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $ad74f3bfed6c15a6$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $ad74f3bfed6c15a6$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $dd0b3b5f569f9955$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $dd0b3b5f569f9955$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $dd0b3b5f569f9955$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $dd0b3b5f569f9955$var$dashKeys : $dd0b3b5f569f9955$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $838ce897bf46110c$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $e7bbc696ba6d4c61$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $ad74f3bfed6c15a6$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $dd0b3b5f569f9955$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $3482ef61ae10b73b$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $6233cd6cb2642c83$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $af719a20ce2e0076$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $21f00c00ba5def11$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $3QbnI.useMemo)(()=>{
        const state = (0, $3482ef61ae10b73b$export$41be8b43e1c4d4f9)();
        (0, $838ce897bf46110c$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $af719a20ce2e0076$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $81063d9b33fcb641$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}


function $2345953e7bfba91b$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, projectionId, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $e5c1e686740388d5$export$88f3fc2fd3766989)(Component) ? (0, $21f00c00ba5def11$export$84309c4f53cb1bd5) : (0, $81063d9b33fcb641$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $89d7853977c6fea0$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        if (projectionId) elementProps["data-projection-id"] = projectionId;
        return (0, $3QbnI.createElement)(Component, elementProps);
    };
    return useRender;
}


/**
 * Convert camelCase to dash-case properties.
 */ const $8b2f0c14ed6d6d72$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


function $0f0e0a8f7ca59752$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $71dcd65b519498ae$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $9f05ac768b4e52ef$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $0f0e0a8f7ca59752$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $71dcd65b519498ae$export$28931db5d57958e5).has(key) ? (0, $8b2f0c14ed6d6d72$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $dc06775e77d9f98c$export$16da615486abaa45(props) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $98deaa364e648ac8$export$605d60a2578142d3)(style[key]) || (0, $16ad1a9a816d139b$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}


function $b4b2e99100921ff3$export$16da615486abaa45(props) {
    const newValues = (0, $dc06775e77d9f98c$export$16da615486abaa45)(props);
    for(const key in props)if ((0, $98deaa364e648ac8$export$605d60a2578142d3)(props[key])) {
        const targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $3QbnI = parcelRequire("3QbnI");


function $cd6ee1d41d40c26d$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



const $b6d9120ab4ac6727$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $2375302384f51412$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $2375302384f51412$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $b6d9120ab4ac6727$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $090571e56c381a54$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $98deaa364e648ac8$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $2375302384f51412$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $d5e116a4666a12d8$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $d5e116a4666a12d8$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $d5e116a4666a12d8$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $3QbnI.useContext)((0, $6e0bc1ba9369d26d$export$2285bbca2c666415));
        const presenceContext = (0, $3QbnI.useContext)((0, $255f9a0b0527cdcb$export$f224e4635b6f8ce2));
        const make = ()=>$d5e116a4666a12d8$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $fe17874da42017ee$export$fe4300aa8eebea86)(make);
    };
function $d5e116a4666a12d8$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props);
    for(const key in motionValues)values[key] = (0, $090571e56c381a54$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $e6cef9ccd8a57339$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $e6cef9ccd8a57339$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $d4d04c41765ec410$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $cd6ee1d41d40c26d$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $28e5393aff111bb0$export$44dabd3fae512e85 = {
    useVisualState: (0, $d5e116a4666a12d8$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $b4b2e99100921ff3$export$16da615486abaa45),
        createRenderState: (0, $3482ef61ae10b73b$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            (0, $838ce897bf46110c$export$5475d24f125d7053)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, (0, $af719a20ce2e0076$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
            (0, $9f05ac768b4e52ef$export$c5f8399d19a7394b)(instance, renderState);
        }
    })
};





const $30e331c11de6db8b$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $d5e116a4666a12d8$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $dc06775e77d9f98c$export$16da615486abaa45,
        createRenderState: (0, $6233cd6cb2642c83$export$8940b483cf52eeda)
    })
};


function $b6c1cb15331ae5f3$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    const baseConfig = (0, $e5c1e686740388d5$export$88f3fc2fd3766989)(Component) ? (0, $28e5393aff111bb0$export$44dabd3fae512e85) : (0, $30e331c11de6db8b$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $2345953e7bfba91b$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        projectionNodeConstructor: projectionNodeConstructor,
        Component: Component
    };
}


var $c5e4b2394b8140ce$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})($c5e4b2394b8140ce$export$2deb71ebd3734d23 || ($c5e4b2394b8140ce$export$2deb71ebd3734d23 = {}));



var $3QbnI = parcelRequire("3QbnI");
function $0b6c5b02e96942a7$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $0b6c5b02e96942a7$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $3QbnI.useEffect)(()=>{
        const element = ref.current;
        if (handler && element) return $0b6c5b02e96942a7$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}


/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $fee2b6f25e629273$export$cac52d7cca250a66({ whileFocus: whileFocus, visualElement: visualElement }) {
    const { animationState: animationState } = visualElement;
    const onFocus = ()=>{
        animationState && animationState.setActive((0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Focus, true);
    };
    const onBlur = ()=>{
        animationState && animationState.setActive((0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Focus, false);
    };
    (0, $0b6c5b02e96942a7$export$c1052189363cb2e0)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $0b6c5b02e96942a7$export$c1052189363cb2e0)(visualElement, "blur", whileFocus ? onBlur : undefined);
}


function $0aafd1aad305945b$export$764db16956f554f8(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function $0aafd1aad305945b$export$c4dfce035d43d1e0(event) {
    const hasTouches = !!event.touches;
    return hasTouches;
}





/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $074f55200245307f$var$filterPrimaryPointer(eventHandler) {
    return (event)=>{
        const isMouseEvent = event instanceof MouseEvent;
        const isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
const $074f55200245307f$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $074f55200245307f$var$pointFromTouch(e, pointType = "page") {
    const primaryTouch = e.touches[0] || e.changedTouches[0];
    const point = primaryTouch || $074f55200245307f$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $074f55200245307f$var$pointFromMouse(point, pointType = "page") {
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $074f55200245307f$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: (0, $0aafd1aad305945b$export$c4dfce035d43d1e0)(event) ? $074f55200245307f$var$pointFromTouch(event, pointType) : $074f55200245307f$var$pointFromMouse(event, pointType)
    };
}
const $074f55200245307f$export$f4437ba81469b709 = (handler, shouldFilterPrimaryPointer = false)=>{
    const listener = (event)=>handler(event, $074f55200245307f$export$12f84bb882d06e1a(event));
    return shouldFilterPrimaryPointer ? $074f55200245307f$var$filterPrimaryPointer(listener) : listener;
};



// We check for event support via functions in case they've been mocked by a testing suite.
const $24f717d42d161214$export$ed662207763ba653 = ()=>(0, $99db44a5d4c29f46$export$4e09c449d6c407f7) && window.onpointerdown === null;
const $24f717d42d161214$export$58e9cbc5718eb8c2 = ()=>(0, $99db44a5d4c29f46$export$4e09c449d6c407f7) && window.ontouchstart === null;
const $24f717d42d161214$export$1a3879af679d3ede = ()=>(0, $99db44a5d4c29f46$export$4e09c449d6c407f7) && window.onmousedown === null;


const $dabea514f0da5772$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
const $dabea514f0da5772$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $dabea514f0da5772$var$getPointerEventName(name) {
    if ((0, $24f717d42d161214$export$ed662207763ba653)()) return name;
    else if ((0, $24f717d42d161214$export$58e9cbc5718eb8c2)()) return $dabea514f0da5772$var$touchEventNames[name];
    else if ((0, $24f717d42d161214$export$1a3879af679d3ede)()) return $dabea514f0da5772$var$mouseEventNames[name];
    return name;
}
function $dabea514f0da5772$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $0b6c5b02e96942a7$export$b1d829ddf82884aa)(target, $dabea514f0da5772$var$getPointerEventName(eventName), (0, $074f55200245307f$export$f4437ba81469b709)(handler, eventName === "pointerdown"), options);
}
function $dabea514f0da5772$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $0b6c5b02e96942a7$export$c1052189363cb2e0)(ref, $dabea514f0da5772$var$getPointerEventName(eventName), handler && (0, $074f55200245307f$export$f4437ba81469b709)(handler, eventName === "pointerdown"), options);
}


function $463c24a8a9611f6a$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $463c24a8a9611f6a$var$globalHorizontalLock = $463c24a8a9611f6a$export$518c5fc2dcb7974b("dragHorizontal");
const $463c24a8a9611f6a$var$globalVerticalLock = $463c24a8a9611f6a$export$518c5fc2dcb7974b("dragVertical");
function $463c24a8a9611f6a$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $463c24a8a9611f6a$var$globalVerticalLock();
    else if (drag === "x") lock = $463c24a8a9611f6a$var$globalHorizontalLock();
    else {
        const openHorizontal = $463c24a8a9611f6a$var$globalHorizontalLock();
        const openVertical = $463c24a8a9611f6a$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $463c24a8a9611f6a$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $463c24a8a9611f6a$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


function $911f04d97fb73b8f$var$createHoverEvent(visualElement, isActive, callback) {
    return (event, info)=>{
        if (!(0, $0aafd1aad305945b$export$764db16956f554f8)(event) || (0, $463c24a8a9611f6a$export$1b3dd616664938e4)()) return;
        /**
         * Ensure we trigger animations before firing event callback
         */ if (visualElement.animationState) visualElement.animationState.setActive((0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Hover, isActive);
        callback && callback(event, info);
    };
}
function $911f04d97fb73b8f$export$dea06860711b7ebc({ onHoverStart: onHoverStart, onHoverEnd: onHoverEnd, whileHover: whileHover, visualElement: visualElement }) {
    (0, $dabea514f0da5772$export$734d04395f5243cd)(visualElement, "pointerenter", onHoverStart || whileHover ? $911f04d97fb73b8f$var$createHoverEvent(visualElement, true, onHoverStart) : undefined, {
        passive: !onHoverStart
    });
    (0, $dabea514f0da5772$export$734d04395f5243cd)(visualElement, "pointerleave", onHoverEnd || whileHover ? $911f04d97fb73b8f$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined, {
        passive: !onHoverEnd
    });
}



var $3QbnI = parcelRequire("3QbnI");
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $e8e6d544fa3bf528$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $e8e6d544fa3bf528$export$e841ada32ff745b(parent, child.parentElement);
};






/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $74b8d351da40c237$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $74b8d351da40c237$export$a4627e546088548d = (...transformers)=>transformers.reduce($74b8d351da40c237$var$combineFunctions);


/**
 * @param handlers -
 * @internal
 */ function $da200cbd40160c83$export$16dee6ef8c34532({ onTap: onTap, onTapStart: onTapStart, onTapCancel: onTapCancel, whileTap: whileTap, visualElement: visualElement }) {
    const hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    const isPressing = (0, $3QbnI.useRef)(false);
    const cancelPointerEndListeners = (0, $3QbnI.useRef)(null);
    /**
     * Only set listener to passive if there are no external listeners.
     */ const eventOptions = {
        passive: !(onTapStart || onTap || onTapCancel || onPointerDown)
    };
    function removePointerEndListener() {
        cancelPointerEndListeners.current && cancelPointerEndListeners.current();
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        removePointerEndListener();
        isPressing.current = false;
        visualElement.animationState && visualElement.animationState.setActive((0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Tap, false);
        return !(0, $463c24a8a9611f6a$export$1b3dd616664938e4)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $e8e6d544fa3bf528$export$e841ada32ff745b)(visualElement.current, event.target) ? onTapCancel && onTapCancel(event, info) : onTap && onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel && onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $74b8d351da40c237$export$a4627e546088548d)((0, $dabea514f0da5772$export$fcff2e64e6676b81)(window, "pointerup", onPointerUp, eventOptions), (0, $dabea514f0da5772$export$fcff2e64e6676b81)(window, "pointercancel", onPointerCancel, eventOptions));
        /**
         * Ensure we trigger animations before firing event callback
         */ visualElement.animationState && visualElement.animationState.setActive((0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Tap, true);
        onTapStart && onTapStart(event, info);
    }
    (0, $dabea514f0da5772$export$734d04395f5243cd)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined, eventOptions);
    (0, $e504b98c47df39d3$export$f3a192d0cbd30b96)(removePointerEndListener);
}




var $3QbnI = parcelRequire("3QbnI");


/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $44ae131dae66d14a$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $44ae131dae66d14a$var$observers = new WeakMap();
const $44ae131dae66d14a$var$fireObserverCallback = (entry)=>{
    const callback = $44ae131dae66d14a$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $44ae131dae66d14a$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($44ae131dae66d14a$var$fireObserverCallback);
};
function $44ae131dae66d14a$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$44ae131dae66d14a$var$observers.has(lookupRoot)) $44ae131dae66d14a$var$observers.set(lookupRoot, {});
    const rootObservers = $44ae131dae66d14a$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($44ae131dae66d14a$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $44ae131dae66d14a$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $44ae131dae66d14a$var$initIntersectionObserver(options);
    $44ae131dae66d14a$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $44ae131dae66d14a$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


function $97d462d317800cb0$export$297ec8eb77d6211d({ visualElement: visualElement, whileInView: whileInView, onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave, viewport: viewport = {} }) {
    const state = (0, $3QbnI.useRef)({
        hasEnteredView: false,
        isInView: false
    });
    let shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView) shouldObserve = false;
    const useObserver = typeof IntersectionObserver === "undefined" ? $97d462d317800cb0$var$useMissingIntersectionObserver : $97d462d317800cb0$var$useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
const $97d462d317800cb0$var$thresholdNames = {
    some: 0,
    all: 1
};
function $97d462d317800cb0$var$useIntersectionObserver(shouldObserve, state, visualElement, { root: root, margin: rootMargin, amount: amount = "some", once: once }) {
    (0, $3QbnI.useEffect)(()=>{
        if (!shouldObserve || !visualElement.current) return;
        const options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $97d462d317800cb0$var$thresholdNames[amount]
        };
        const intersectionCallback = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (state.isInView === isIntersecting) return;
            state.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && state.hasEnteredView) return;
            else if (isIntersecting) state.hasEnteredView = true;
            if (visualElement.animationState) visualElement.animationState.setActive((0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).InView, isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const props = visualElement.getProps();
            const callback = isIntersecting ? props.onViewportEnter : props.onViewportLeave;
            callback && callback(entry);
        };
        return (0, $44ae131dae66d14a$export$b2bcd62fb7925aa5)(visualElement.current, options, intersectionCallback);
    }, [
        shouldObserve,
        root,
        rootMargin,
        amount
    ]);
}
/**
 * If IntersectionObserver is missing, we activate inView and fire onViewportEnter
 * on mount. This way, the page will be in the state the author expects users
 * to see it in for everyone.
 */ function $97d462d317800cb0$var$useMissingIntersectionObserver(shouldObserve, state, visualElement, { fallback: fallback = true }) {
    (0, $3QbnI.useEffect)(()=>{
        if (!shouldObserve || !fallback) return;
        if ((0, $f2a6b1e4c1fe889e$export$a7b6bc01c63cdfc3) !== "production") (0, $801ea30613bca485$export$5b28268982f175ba)(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         *
         * This hook should be quite rarely called so setting this in an rAF
         * is preferred to changing the behaviour of the animation state.
         */ requestAnimationFrame(()=>{
            state.hasEnteredView = true;
            const { onViewportEnter: onViewportEnter } = visualElement.getProps();
            onViewportEnter && onViewportEnter(null);
            if (visualElement.animationState) visualElement.animationState.setActive((0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).InView, true);
        });
    }, [
        shouldObserve
    ]);
}


const $799315ef62f7fd06$export$46d1d6d046f826e4 = (hook)=>(props)=>{
        hook(props);
        return null;
    };


const $af896d81385bcd90$export$e5b72898e5a201f1 = {
    inView: (0, $799315ef62f7fd06$export$46d1d6d046f826e4)((0, $97d462d317800cb0$export$297ec8eb77d6211d)),
    tap: (0, $799315ef62f7fd06$export$46d1d6d046f826e4)((0, $da200cbd40160c83$export$16dee6ef8c34532)),
    focus: (0, $799315ef62f7fd06$export$46d1d6d046f826e4)((0, $fee2b6f25e629273$export$cac52d7cca250a66)),
    hover: (0, $799315ef62f7fd06$export$46d1d6d046f826e4)((0, $911f04d97fb73b8f$export$dea06860711b7ebc))
};



var $3QbnI = parcelRequire("3QbnI");


var $3QbnI = parcelRequire("3QbnI");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $daea76f5257da47f$export$2a8c16d82a0a0e26() {
    const context = (0, $3QbnI.useContext)((0, $255f9a0b0527cdcb$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useId when released in React
    const id = (0, $3QbnI.useId)();
    (0, $3QbnI.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $daea76f5257da47f$export$8249053f690ea39a() {
    return $daea76f5257da47f$export$ee27c052bca048fb((0, $3QbnI.useContext)((0, $255f9a0b0527cdcb$export$f224e4635b6f8ce2)));
}
function $daea76f5257da47f$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}





function $340d6d79dbe50eef$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $a807859389f62a7d$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $73cbe6c8bcfee801$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);





function $d87b3f0c79447976$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $d87b3f0c79447976$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $d87b3f0c79447976$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $f80207b7ef310be9$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $d87b3f0c79447976$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $d87b3f0c79447976$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $98f79ee3ede8fd0b$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $8f10076a3295e789$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $8f10076a3295e789$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "7.10.3";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $bf0b592d43581589$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $9a179e07aa15314d$export$92d6409d68f0739a).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $9a179e07aa15314d$export$92d6409d68f0739a).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $8f10076a3295e789$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @privateRemarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $f80207b7ef310be9$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect) {
        this.passiveEffect = passiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $98f79ee3ede8fd0b$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(animation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.stopAnimation = animation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.stopAnimation) {
            this.stopAnimation();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.stopAnimation;
    }
    clearAnimation() {
        this.stopAnimation = null;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
    }
}
function $8f10076a3295e789$export$ce8bdc721e76545f(init, options) {
    return new $8f10076a3295e789$export$8cea36d14ee64562(init, options);
}







/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $8ff9d93d32cf8a76$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $1c339a848e05ca58$export$844ec244b1367d54)(v) && (0, $1c339a848e05ca58$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $8ff9d93d32cf8a76$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $1c339a848e05ca58$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $1c339a848e05ca58$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $848db169e4d2ae15$var$clampRgbUnit = (v)=>(0, $fc8aa3a981bda5c2$export$7d15b64cf5a3a4c4)(0, 255, v);
const $848db169e4d2ae15$export$7a99c86b5b1f4c9e = {
    ...(0, $4eaf82465a158227$export$98e628dec113755e),
    transform: (v)=>Math.round($848db169e4d2ae15$var$clampRgbUnit(v))
};
const $848db169e4d2ae15$export$4e46ac54fc82cf3b = {
    test: (0, $8ff9d93d32cf8a76$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $8ff9d93d32cf8a76$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $848db169e4d2ae15$export$7a99c86b5b1f4c9e.transform(red) + ", " + $848db169e4d2ae15$export$7a99c86b5b1f4c9e.transform(green) + ", " + $848db169e4d2ae15$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $1c339a848e05ca58$export$83d2e9e3e4ee39ed)((0, $4eaf82465a158227$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $62d0ae2bc8f2f380$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $62d0ae2bc8f2f380$export$834dfc94dde4b3d8 = {
    test: (0, $8ff9d93d32cf8a76$export$2c8400d58aca05e)("#"),
    parse: $62d0ae2bc8f2f380$var$parseHex,
    transform: (0, $848db169e4d2ae15$export$4e46ac54fc82cf3b).transform
};






const $fcd0ecbbdaa123d9$export$810b04175080204c = {
    test: (0, $8ff9d93d32cf8a76$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $8ff9d93d32cf8a76$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $bedfe8fbb87aed27$export$626336c2cd4b14de).transform((0, $1c339a848e05ca58$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $bedfe8fbb87aed27$export$626336c2cd4b14de).transform((0, $1c339a848e05ca58$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $1c339a848e05ca58$export$83d2e9e3e4ee39ed)((0, $4eaf82465a158227$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $a875cad8443c6f4b$export$35e9368ef982300f = {
    test: (v)=>(0, $848db169e4d2ae15$export$4e46ac54fc82cf3b).test(v) || (0, $62d0ae2bc8f2f380$export$834dfc94dde4b3d8).test(v) || (0, $fcd0ecbbdaa123d9$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $848db169e4d2ae15$export$4e46ac54fc82cf3b).test(v)) return (0, $848db169e4d2ae15$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $fcd0ecbbdaa123d9$export$810b04175080204c).test(v)) return (0, $fcd0ecbbdaa123d9$export$810b04175080204c).parse(v);
        else return (0, $62d0ae2bc8f2f380$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $1c339a848e05ca58$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $848db169e4d2ae15$export$4e46ac54fc82cf3b).transform(v) : (0, $fcd0ecbbdaa123d9$export$810b04175080204c).transform(v);
    }
};




const $330200ac4cef53eb$var$colorToken = "${c}";
const $330200ac4cef53eb$var$numberToken = "${n}";
function $330200ac4cef53eb$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $1c339a848e05ca58$export$844ec244b1367d54)(v) && (((_a = v.match((0, $1c339a848e05ca58$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $1c339a848e05ca58$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
function $330200ac4cef53eb$export$b61fc7c44bf646d5(v) {
    if (typeof v === "number") v = `${v}`;
    const values = [];
    let numColors = 0;
    let numNumbers = 0;
    const colors = v.match((0, $1c339a848e05ca58$export$740b69c5fad25dba));
    if (colors) {
        numColors = colors.length;
        // Strip colors from input so they're not picked up by number regex.
        // There's a better way to combine these regex searches, but its beyond my regex skills
        v = v.replace((0, $1c339a848e05ca58$export$740b69c5fad25dba), $330200ac4cef53eb$var$colorToken);
        values.push(...colors.map((0, $a875cad8443c6f4b$export$35e9368ef982300f).parse));
    }
    const numbers = v.match((0, $1c339a848e05ca58$export$2444ca58c08448e4));
    if (numbers) {
        numNumbers = numbers.length;
        v = v.replace((0, $1c339a848e05ca58$export$2444ca58c08448e4), $330200ac4cef53eb$var$numberToken);
        values.push(...numbers.map((0, $4eaf82465a158227$export$98e628dec113755e).parse));
    }
    return {
        values: values,
        numColors: numColors,
        numNumbers: numNumbers,
        tokenised: v
    };
}
function $330200ac4cef53eb$var$parse(v) {
    return $330200ac4cef53eb$export$b61fc7c44bf646d5(v).values;
}
function $330200ac4cef53eb$var$createTransformer(source) {
    const { values: values, numColors: numColors, tokenised: tokenised } = $330200ac4cef53eb$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? $330200ac4cef53eb$var$colorToken : $330200ac4cef53eb$var$numberToken, i < numColors ? (0, $a875cad8443c6f4b$export$35e9368ef982300f).transform(v[i]) : (0, $1c339a848e05ca58$export$83d2e9e3e4ee39ed)(v[i]));
        return output;
    };
}
const $330200ac4cef53eb$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $330200ac4cef53eb$var$getAnimatableNone(v) {
    const parsed = $330200ac4cef53eb$var$parse(v);
    const transformer = $330200ac4cef53eb$var$createTransformer(v);
    return transformer(parsed.map($330200ac4cef53eb$var$convertNumbersToZero));
}
const $330200ac4cef53eb$export$83a0e34f1302825b = {
    test: $330200ac4cef53eb$var$test,
    parse: $330200ac4cef53eb$var$parse,
    createTransformer: $330200ac4cef53eb$var$createTransformer,
    getAnimatableNone: $330200ac4cef53eb$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $ae92990e843592ab$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $ae92990e843592ab$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $1c339a848e05ca58$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $ae92990e843592ab$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $ae92990e843592ab$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $ae92990e843592ab$export$3dea766d36a8935f = {
    ...(0, $330200ac4cef53eb$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($ae92990e843592ab$var$functionRegex);
        return functions ? functions.map($ae92990e843592ab$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $1589a0c510a1cefe$export$98cd7c72c5a731fb = {
    ...(0, $23f6854e2701e290$export$eec14432cd1cb67b),
    color: // Color props
    $a875cad8443c6f4b$export$35e9368ef982300f,
    backgroundColor: (0, $a875cad8443c6f4b$export$35e9368ef982300f),
    outlineColor: (0, $a875cad8443c6f4b$export$35e9368ef982300f),
    fill: (0, $a875cad8443c6f4b$export$35e9368ef982300f),
    stroke: (0, $a875cad8443c6f4b$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $a875cad8443c6f4b$export$35e9368ef982300f),
    borderTopColor: (0, $a875cad8443c6f4b$export$35e9368ef982300f),
    borderRightColor: (0, $a875cad8443c6f4b$export$35e9368ef982300f),
    borderBottomColor: (0, $a875cad8443c6f4b$export$35e9368ef982300f),
    borderLeftColor: (0, $a875cad8443c6f4b$export$35e9368ef982300f),
    filter: $ae92990e843592ab$export$3dea766d36a8935f,
    WebkitFilter: (0, $ae92990e843592ab$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $1589a0c510a1cefe$export$67d1babe0338d23b = (key)=>$1589a0c510a1cefe$export$98cd7c72c5a731fb[key];


function $6abadeab186dd386$export$cea0cedcb94873b5(key, value) {
    var _a;
    let defaultValueType = (0, $1589a0c510a1cefe$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $ae92990e843592ab$export$3dea766d36a8935f)) defaultValueType = (0, $330200ac4cef53eb$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}






/**
 * Tests a provided value against a ValueType
 */ const $79128312eb1470e5$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $0db83b75dbbf8d15$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $d63e13ed09d9d59b$export$d176691c1998a1f5 = [
    (0, $4eaf82465a158227$export$98e628dec113755e),
    (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008),
    (0, $bedfe8fbb87aed27$export$626336c2cd4b14de),
    (0, $bedfe8fbb87aed27$export$41fc368e1a942b97),
    (0, $bedfe8fbb87aed27$export$aed3d7b7d206c196),
    (0, $bedfe8fbb87aed27$export$f91e8c45a95a32f2),
    (0, $0db83b75dbbf8d15$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $d63e13ed09d9d59b$export$eefdd52e3ccae428 = (v)=>$d63e13ed09d9d59b$export$d176691c1998a1f5.find((0, $79128312eb1470e5$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $ce86b549442434e8$var$valueTypes = [
    ...(0, $d63e13ed09d9d59b$export$d176691c1998a1f5),
    (0, $a875cad8443c6f4b$export$35e9368ef982300f),
    (0, $330200ac4cef53eb$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $ce86b549442434e8$export$950e7e59ea1ffed7 = (v)=>$ce86b549442434e8$var$valueTypes.find((0, $79128312eb1470e5$export$6eae4d0a6a7ca7cd)(v));



/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $2f46f682b4a6162b$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $2f46f682b4a6162b$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $2f46f682b4a6162b$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $cd6ee1d41d40c26d$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $2f46f682b4a6162b$var$getCurrent(visualElement), $2f46f682b4a6162b$var$getVelocity(visualElement));
}


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $179245aac7608fb5$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $8f10076a3295e789$export$ce8bdc721e76545f)(value));
}
function $179245aac7608fb5$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $2f46f682b4a6162b$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $2375302384f51412$export$5485128c47bd48bb)(target[key]);
        $179245aac7608fb5$var$setMotionValue(visualElement, key, value);
    }
}
function $179245aac7608fb5$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        var _a;
        const variant = visualElement.getVariant(key);
        variant && $179245aac7608fb5$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            $179245aac7608fb5$var$setVariants(child, variantLabels);
        });
    });
}
function $179245aac7608fb5$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $179245aac7608fb5$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $179245aac7608fb5$var$setVariants(visualElement, [
        definition
    ]);
    else $179245aac7608fb5$export$1f61c53461aff4a5(visualElement, definition);
}
function $179245aac7608fb5$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $a807859389f62a7d$export$65583ed5a868f2d9)(value) || (0, $73cbe6c8bcfee801$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $ce86b549442434e8$export$950e7e59ea1ffed7)(value) && (0, $330200ac4cef53eb$export$83a0e34f1302825b).test(targetValue)) value = (0, $6abadeab186dd386$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $8f10076a3295e789$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $179245aac7608fb5$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $179245aac7608fb5$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a;
    const origin = {};
    for(const key in target){
        const transitionOrigin = $179245aac7608fb5$export$c3befe8e18686628(key, transition);
        origin[key] = transitionOrigin !== undefined ? transitionOrigin : (_a = visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.get();
    }
    return origin;
}





function $a90e00c392ef6c3b$export$98397f3adbf6259f(value) {
    return Boolean((0, $98deaa364e648ac8$export$605d60a2578142d3)(value) && value.add);
}




const $dd998de9973f76a2$export$c4a39f7e38d37eb9 = (id, value)=>`${id}: ${value}`;


function $ceede13a9ce17aa2$export$470de7e050cf9631(id, name) {
    const { MotionAppearAnimations: MotionAppearAnimations } = window;
    const animationId = (0, $dd998de9973f76a2$export$c4a39f7e38d37eb9)(id, (0, $d160cfa1fbfbdd2f$export$7b42a0094fb00b6e).has(name) ? "transform" : name);
    const animation = MotionAppearAnimations && MotionAppearAnimations.get(animationId);
    if (animation) {
        /**
         * We allow the animation to persist until the next frame:
         *   1. So it continues to play until Framer Motion is ready to render
         *      (avoiding a potential flash of the element's original state)
         *   2. As all independent transforms share a single transform animation, stopping
         *      it synchronously would prevent subsequent transforms from handing off.
         */ (0, $9a179e07aa15314d$export$92d6409d68f0739a).render(()=>{
            /**
             * Animation.cancel() throws so it needs to be wrapped in a try/catch
             */ try {
                animation.cancel();
                MotionAppearAnimations.delete(animationId);
            } catch (e) {}
        });
        return animation.currentTime || 0;
    } else return 0;
}



const $5d875023d99403d2$export$ed7b8fa9dbf0105d = "framerAppearId";
const $5d875023d99403d2$export$8592e1c077c890a6 = "data-" + (0, $8b2f0c14ed6d6d72$export$9fd24a634729c672)($5d875023d99403d2$export$ed7b8fa9dbf0105d);


var $f444ef37a22b988c$export$491112666e282270 = function() {};
var $f444ef37a22b988c$export$f5708dca728d7177 = function() {};


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $a647e52d1aa268c9$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;


const $fe404f374649e575$export$888a3d84909f9e3d = {
    current: false
};



// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $3324d49837564400$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $000068978de317cc$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $89bdee64591ddc1b$export$929e5a82286172a6 = (p)=>p * p;
const $89bdee64591ddc1b$export$57636bb43b1ccbb0 = (0, $000068978de317cc$export$2c07eeff45156d4d)($89bdee64591ddc1b$export$929e5a82286172a6);
const $89bdee64591ddc1b$export$c07234257a03d5e9 = (0, $3324d49837564400$export$f946554fb8aeaf0d)($89bdee64591ddc1b$export$929e5a82286172a6);





/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $dee33a4a46b35b3d$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $1b621d1e36a511ae$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $1b621d1e36a511ae$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $1b621d1e36a511ae$var$hueToRgb(p, q, hue + 1 / 3);
        green = $1b621d1e36a511ae$var$hueToRgb(p, q, hue);
        blue = $1b621d1e36a511ae$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $2ca4ba398651768a$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $2ca4ba398651768a$var$colorTypes = [
    (0, $62d0ae2bc8f2f380$export$834dfc94dde4b3d8),
    (0, $848db169e4d2ae15$export$4e46ac54fc82cf3b),
    (0, $fcd0ecbbdaa123d9$export$810b04175080204c)
];
const $2ca4ba398651768a$var$getColorType = (v)=>$2ca4ba398651768a$var$colorTypes.find((type)=>type.test(v));
function $2ca4ba398651768a$var$asRGBA(color) {
    const type = $2ca4ba398651768a$var$getColorType(color);
    (0, $f444ef37a22b988c$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $fcd0ecbbdaa123d9$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $1b621d1e36a511ae$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $2ca4ba398651768a$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $2ca4ba398651768a$var$asRGBA(from);
    const toRGBA = $2ca4ba398651768a$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $2ca4ba398651768a$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $2ca4ba398651768a$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $2ca4ba398651768a$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $848db169e4d2ae15$export$4e46ac54fc82cf3b).transform(blended);
    };
};








function $9ae3fbf7a51caaa4$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $a875cad8443c6f4b$export$35e9368ef982300f).test(origin)) return (0, $2ca4ba398651768a$export$51e568cf5c039bac)(origin, target);
    else return $9ae3fbf7a51caaa4$export$65516310a87d8205(origin, target);
}
const $9ae3fbf7a51caaa4$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$9ae3fbf7a51caaa4$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $9ae3fbf7a51caaa4$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $9ae3fbf7a51caaa4$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $9ae3fbf7a51caaa4$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $330200ac4cef53eb$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $330200ac4cef53eb$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $330200ac4cef53eb$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $74b8d351da40c237$export$a4627e546088548d)($9ae3fbf7a51caaa4$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $f444ef37a22b988c$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p)=>`${p > 0 ? target : origin}`;
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $55d5e2d6922a2a3c$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


const $145c96d2e45a5947$var$mixNumber = (from, to)=>(p)=>(0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(from, to, p);
function $145c96d2e45a5947$var$detectMixerFactory(v) {
    if (typeof v === "number") return $145c96d2e45a5947$var$mixNumber;
    else if (typeof v === "string") {
        if ((0, $a875cad8443c6f4b$export$35e9368ef982300f).test(v)) return 0, $2ca4ba398651768a$export$51e568cf5c039bac;
        else return 0, $9ae3fbf7a51caaa4$export$65516310a87d8205;
    } else if (Array.isArray(v)) return 0, $9ae3fbf7a51caaa4$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $9ae3fbf7a51caaa4$export$ebc23b6840c51ba1;
    return $145c96d2e45a5947$var$mixNumber;
}
function $145c96d2e45a5947$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $145c96d2e45a5947$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $74b8d351da40c237$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $145c96d2e45a5947$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $f444ef37a22b988c$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0, $f444ef37a22b988c$export$f5708dca728d7177)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $145c96d2e45a5947$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $55d5e2d6922a2a3c$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $fc8aa3a981bda5c2$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}



const $2474671030e506b8$export$8793edee2d425525 = (any)=>any;


/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $f9f36ad2d10c8d23$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $f9f36ad2d10c8d23$var$subdivisionPrecision = 0.0000001;
const $f9f36ad2d10c8d23$var$subdivisionMaxIterations = 12;
function $f9f36ad2d10c8d23$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $f9f36ad2d10c8d23$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $f9f36ad2d10c8d23$var$subdivisionPrecision && ++i < $f9f36ad2d10c8d23$var$subdivisionMaxIterations);
    return currentT;
}
function $f9f36ad2d10c8d23$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $2474671030e506b8$export$8793edee2d425525;
    const getTForX = (aX)=>$f9f36ad2d10c8d23$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $f9f36ad2d10c8d23$var$calcBezier(getTForX(t), mY1, mY2);
}






const $25fc5dc25592b6ac$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $25fc5dc25592b6ac$export$c8d67a19199d1a50 = (0, $000068978de317cc$export$2c07eeff45156d4d)($25fc5dc25592b6ac$export$e444123e42d03385);
const $25fc5dc25592b6ac$export$30d3455eee55bed5 = (0, $3324d49837564400$export$f946554fb8aeaf0d)($25fc5dc25592b6ac$export$c8d67a19199d1a50);





const $5a29d42bc72fc558$export$77edfce482316a60 = (0, $f9f36ad2d10c8d23$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $5a29d42bc72fc558$export$b01116c84cdfe1a2 = (0, $000068978de317cc$export$2c07eeff45156d4d)($5a29d42bc72fc558$export$77edfce482316a60);
const $5a29d42bc72fc558$export$ddc5fd596f6c71b2 = (0, $3324d49837564400$export$f946554fb8aeaf0d)($5a29d42bc72fc558$export$b01116c84cdfe1a2);



const $30cbcda95856dc68$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $5a29d42bc72fc558$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $15cfffe117a82889$var$easingLookup = {
    linear: (0, $2474671030e506b8$export$8793edee2d425525),
    easeIn: $89bdee64591ddc1b$export$929e5a82286172a6,
    easeInOut: $89bdee64591ddc1b$export$c07234257a03d5e9,
    easeOut: $89bdee64591ddc1b$export$57636bb43b1ccbb0,
    circIn: $25fc5dc25592b6ac$export$e444123e42d03385,
    circInOut: $25fc5dc25592b6ac$export$30d3455eee55bed5,
    circOut: $25fc5dc25592b6ac$export$c8d67a19199d1a50,
    backIn: $5a29d42bc72fc558$export$b01116c84cdfe1a2,
    backInOut: $5a29d42bc72fc558$export$ddc5fd596f6c71b2,
    backOut: $5a29d42bc72fc558$export$77edfce482316a60,
    anticipate: $30cbcda95856dc68$export$6b0af63b873d419e
};
const $15cfffe117a82889$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $f444ef37a22b988c$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $f9f36ad2d10c8d23$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $f444ef37a22b988c$export$f5708dca728d7177)($15cfffe117a82889$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $15cfffe117a82889$var$easingLookup[definition];
    }
    return definition;
};
const $15cfffe117a82889$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


function $b9eb6339434b30ab$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $89bdee64591ddc1b$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $b9eb6339434b30ab$export$24dbcec0b26e6d9d(values) {
    const numValues = values.length;
    return values.map((_value, i)=>i !== 0 ? i / (numValues - 1) : 0);
}
function $b9eb6339434b30ab$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}
function $b9eb6339434b30ab$export$d25ddfdf17c3ad3e({ keyframes: keyframeValues, ease: ease = (0, $89bdee64591ddc1b$export$c07234257a03d5e9), times: times, duration: duration = 300 }) {
    keyframeValues = [
        ...keyframeValues
    ];
    const origin = $b9eb6339434b30ab$export$d25ddfdf17c3ad3e[0];
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $15cfffe117a82889$export$216948827bbdc797)(ease) ? ease.map((0, $15cfffe117a82889$export$ef97fe084f156ca4)) : (0, $15cfffe117a82889$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = $b9eb6339434b30ab$export$2a91b4e3a4539316(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === $b9eb6339434b30ab$export$d25ddfdf17c3ad3e.length ? times : $b9eb6339434b30ab$export$24dbcec0b26e6d9d(keyframeValues), duration);
    function createInterpolator() {
        return (0, $145c96d2e45a5947$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
            ease: Array.isArray(easingFunctions) ? easingFunctions : $b9eb6339434b30ab$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t)=>{
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: ()=>{
            keyframeValues.reverse();
            interpolator = createInterpolator();
        }
    };
}




const $66dc2f0323822869$var$safeMin = 0.001;
const $66dc2f0323822869$export$a3cdb76e84ee608e = 0.01;
const $66dc2f0323822869$export$1824b851fad8862b = 10.0;
const $66dc2f0323822869$export$ff08f2d53484465 = 0.05;
const $66dc2f0323822869$export$201ca48e54038115 = 1;
function $66dc2f0323822869$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $f444ef37a22b988c$export$491112666e282270)(duration <= $66dc2f0323822869$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $fc8aa3a981bda5c2$export$7d15b64cf5a3a4c4)($66dc2f0323822869$export$ff08f2d53484465, $66dc2f0323822869$export$201ca48e54038115, dampingRatio);
    duration = (0, $fc8aa3a981bda5c2$export$7d15b64cf5a3a4c4)($66dc2f0323822869$export$a3cdb76e84ee608e, $66dc2f0323822869$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $66dc2f0323822869$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $66dc2f0323822869$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $66dc2f0323822869$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $66dc2f0323822869$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$66dc2f0323822869$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $66dc2f0323822869$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $66dc2f0323822869$var$rootIterations = 12;
function $66dc2f0323822869$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $66dc2f0323822869$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $66dc2f0323822869$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}



const $20968f2c01f6ae32$var$durationKeys = [
    "duration",
    "bounce"
];
const $20968f2c01f6ae32$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $20968f2c01f6ae32$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $20968f2c01f6ae32$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$20968f2c01f6ae32$var$isSpringType(options, $20968f2c01f6ae32$var$physicsKeys) && $20968f2c01f6ae32$var$isSpringType(options, $20968f2c01f6ae32$var$durationKeys)) {
        const derived = (0, $66dc2f0323822869$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
const $20968f2c01f6ae32$var$velocitySampleDuration = 5;
/**
 * This is based on the spring implementation of Wobble https://github.com/skevy/wobble
 */ function $20968f2c01f6ae32$export$b36281d89752ae66({ keyframes: keyframes, restSpeed: restSpeed = 2, restDelta: restDelta = 0.01, ...options }) {
    let origin = keyframes[0];
    let target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $20968f2c01f6ae32$var$getSpringOptions(options);
    let resolveSpring = $20968f2c01f6ae32$var$zero;
    let initialVelocity = velocity ? -(velocity / 1000) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    function createSpring() {
        const initialDelta = target - origin;
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        /**
         * If we're working within what looks like a 0-1 range, change the default restDelta
         * to 0.01
         */ if (restDelta === undefined) restDelta = Math.min(Math.abs(target - origin) / 100, 0.4);
        if (dampingRatio < 1) {
            const angularFreq = (0, $66dc2f0323822869$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
            // Underdamped spring
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
            };
        } else if (dampingRatio === 1) // Critically damped spring
        resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        else {
            // Overdamped spring
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                // When performing sinh or cosh values can hit Infinity so we cap them here
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
            };
        }
    }
    createSpring();
    return {
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) {
                        const prevT = Math.max(0, t - $20968f2c01f6ae32$var$velocitySampleDuration);
                        currentVelocity = (0, $98f79ee3ede8fd0b$export$eab0632f7ad4f9d7)(current - resolveSpring(prevT), t - prevT);
                    } else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        flipTarget: ()=>{
            initialVelocity = -initialVelocity;
            [origin, target] = [
                target,
                origin
            ];
            createSpring();
        }
    };
}
$20968f2c01f6ae32$export$b36281d89752ae66.needsInterpolation = (a, b)=>typeof a === "string" || typeof b === "string";
const $20968f2c01f6ae32$var$zero = (_t)=>0;


function $46a97734604db9f6$export$e9341ba102272ab9({ keyframes: /**
 * The decay animation dynamically calculates an end of the animation
 * based on the initial keyframe, so we only need to define a single keyframe
 * as default.
 */ keyframes = [
    0
], velocity: velocity = 0, power: power = 0.8, timeConstant: timeConstant = 350, restDelta: restDelta = 0.5, modifyTarget: modifyTarget }) {
    const origin = keyframes[0];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    return {
        next: (t)=>{
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: ()=>{}
    };
}




const $906a09c7a3d9b37f$var$types = {
    decay: $46a97734604db9f6$export$e9341ba102272ab9,
    keyframes: (0, $b9eb6339434b30ab$export$d25ddfdf17c3ad3e),
    tween: (0, $b9eb6339434b30ab$export$d25ddfdf17c3ad3e),
    spring: $20968f2c01f6ae32$export$b36281d89752ae66
};
function $906a09c7a3d9b37f$export$7d0784e050d8e25f(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function $906a09c7a3d9b37f$export$ab9042754680126b(elapsed, duration = 0, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback ? $906a09c7a3d9b37f$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $906a09c7a3d9b37f$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}
const $906a09c7a3d9b37f$var$framesync = (update)=>{
    const passTimestamp = ({ delta: delta })=>update(delta);
    return {
        start: ()=>(0, $9a179e07aa15314d$export$92d6409d68f0739a).update(passTimestamp, true),
        stop: ()=>(0, $9a179e07aa15314d$export$d93e9c1fe0553512).update(passTimestamp)
    };
};
function $906a09c7a3d9b37f$export$e3607ec2d7a891c4({ duration: duration, driver: driver = $906a09c7a3d9b37f$var$framesync, elapsed: elapsed = 0, repeat: repeatMax = 0, repeatType: repeatType = "loop", repeatDelay: repeatDelay = 0, keyframes: keyframes, autoplay: autoplay = true, onPlay: onPlay, onStop: onStop, onComplete: onComplete, onRepeat: onRepeat, onUpdate: onUpdate, type: type = "keyframes", ...options }) {
    var _a, _b;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = $906a09c7a3d9b37f$var$types[keyframes.length > 2 ? "keyframes" : type];
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    if ((_b = (_a = animator).needsInterpolation) === null || _b === void 0 ? void 0 : _b.call(_a, origin, target)) {
        interpolateFromNumber = (0, $145c96d2e45a5947$export$89e29e4ab65e70a9)([
            0,
            100
        ], [
            origin,
            target
        ], {
            clamp: false
        });
        keyframes = [
            0,
            100
        ];
    }
    const animation = animator({
        ...options,
        duration: duration,
        keyframes: keyframes
    });
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = $906a09c7a3d9b37f$export$ab9042754680126b(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = $906a09c7a3d9b37f$export$7d0784e050d8e25f(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate && onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration = computedDuration !== undefined ? computedDuration : elapsed;
            if (repeatCount < repeatMax) $906a09c7a3d9b37f$export$c9c9437f9b8733b5(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay && onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: ()=>{
            onStop && onStop();
            driverControls.stop();
        },
        sample: (t)=>{
            return animation.next(Math.max(0, t));
        }
    };
}


function $f37e901b68badf75$export$fcdd8f3f2160beda(easing) {
    return !easing || // Default easing
    Array.isArray(easing) || // Bezier curve
    typeof easing === "string" && $f37e901b68badf75$export$2cf569f5e2221176[easing];
}
const $f37e901b68badf75$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $f37e901b68badf75$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $f37e901b68badf75$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $f37e901b68badf75$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $f37e901b68badf75$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $f37e901b68badf75$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $f37e901b68badf75$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return Array.isArray(easing) ? $f37e901b68badf75$export$2523b8f0bd8f44cb(easing) : $f37e901b68badf75$export$2cf569f5e2221176[easing];
}


function $2cd4315653fe4325$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    return element.animate({
        [valueName]: keyframes,
        offset: times
    }, {
        delay: delay,
        duration: duration,
        easing: (0, $f37e901b68badf75$export$916ea73bcd3a6030)(ease),
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $228e05b68b406565$var$sampleDelta = 10; //ms
function $228e05b68b406565$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    let { keyframes: keyframes, duration: duration = 0.3, elapsed: elapsed = 0, ease: ease } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if (options.type === "spring" || !(0, $f37e901b68badf75$export$fcdd8f3f2160beda)(options.ease)) {
        const sampleAnimation = (0, $906a09c7a3d9b37f$export$e3607ec2d7a891c4)(options);
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        let t = 0;
        while(!state.done){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $228e05b68b406565$var$sampleDelta;
        }
        keyframes = pregeneratedKeyframes;
        duration = t - $228e05b68b406565$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $2cd4315653fe4325$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        delay: -elapsed,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease
    });
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
    };
    /**
     * Animation interrupt callback.
     */ return ()=>{
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ const { currentTime: currentTime } = animation;
        if (currentTime) {
            const sampleAnimation = (0, $906a09c7a3d9b37f$export$e3607ec2d7a891c4)(options);
            value.setWithVelocity(sampleAnimation.sample(currentTime - $228e05b68b406565$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $228e05b68b406565$var$sampleDelta);
        }
        (0, $9a179e07aa15314d$export$92d6409d68f0739a).update(()=>animation.cancel());
    };
}



/**
 * Timeout defined in ms
 */ function $6e4866dc433166b0$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $9a179e07aa15314d$export$d93e9c1fe0553512).read(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $9a179e07aa15314d$export$92d6409d68f0739a).read(checkElapsed, true);
    return ()=>(0, $9a179e07aa15314d$export$d93e9c1fe0553512).read(checkElapsed);
}


function $928c26c163ca7653$export$6f34fc8ef6c42b70({ keyframes: keyframes, elapsed: elapsed, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        return ()=>{};
    };
    return elapsed ? (0, $6e4866dc433166b0$export$1391212d75b2ee65)(setValue, -elapsed) : setValue();
}






function $aac6c3176a359ea3$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0, min: min, max: max, power: power = 0.8, timeConstant: timeConstant = 750, bounceStiffness: bounceStiffness = 500, bounceDamping: bounceDamping = 10, restDelta: restDelta = 1, modifyTarget: modifyTarget, driver: driver, onUpdate: onUpdate, onComplete: onComplete, onStop: onStop }) {
    const origin = keyframes[0];
    let currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function findNearestBoundary(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $906a09c7a3d9b37f$export$e3607ec2d7a891c4)({
            keyframes: [
                0,
                1
            ],
            velocity: 0,
            ...options,
            driver: driver,
            onUpdate: (v)=>{
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete,
            onStop: onStop
        });
    }
    function startSpring(options) {
        startAnimation({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta,
            ...options
        });
    }
    if (isOutOfBounds(origin)) // Start the animation with spring if outside the defined boundaries
    startSpring({
        velocity: velocity,
        keyframes: [
            origin,
            findNearestBoundary(origin)
        ]
    });
    else {
        /**
         * Or if the value is out of bounds, simulate the inertia movement
         * with the decay animation.
         *
         * Pre-calculate the target so we can detect if it's out-of-bounds.
         * If it is, we want to check per frame when to switch to a spring
         * animation
         */ let target = power * velocity + origin;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        const boundary = findNearestBoundary(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v)=>{
            prev = current;
            current = v;
            velocity = (0, $98f79ee3ede8fd0b$export$eab0632f7ad4f9d7)(v - prev, (0, $bf0b592d43581589$export$fff89137e9e818ce).delta);
            if (heading === 1 && v > boundary || heading === -1 && v < boundary) startSpring({
                keyframes: [
                    v,
                    boundary
                ],
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            keyframes: [
                origin,
                0
            ],
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: ()=>currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop()
    };
}


const $42d9fc8e771d3561$export$2577c2184b2254d3 = ()=>({
        type: "spring",
        stiffness: 500,
        damping: 25,
        restSpeed: 10
    });
const $42d9fc8e771d3561$export$a743142a31c132c = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $42d9fc8e771d3561$export$c2d663fbb86d66d6 = ()=>({
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    });
const $42d9fc8e771d3561$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
const $42d9fc8e771d3561$var$defaultTransitions = {
    x: $42d9fc8e771d3561$export$2577c2184b2254d3,
    y: $42d9fc8e771d3561$export$2577c2184b2254d3,
    z: $42d9fc8e771d3561$export$2577c2184b2254d3,
    rotate: $42d9fc8e771d3561$export$2577c2184b2254d3,
    rotateX: $42d9fc8e771d3561$export$2577c2184b2254d3,
    rotateY: $42d9fc8e771d3561$export$2577c2184b2254d3,
    rotateZ: $42d9fc8e771d3561$export$2577c2184b2254d3,
    scaleX: $42d9fc8e771d3561$export$a743142a31c132c,
    scaleY: $42d9fc8e771d3561$export$a743142a31c132c,
    scale: $42d9fc8e771d3561$export$a743142a31c132c,
    opacity: $42d9fc8e771d3561$export$c2d663fbb86d66d6,
    backgroundColor: $42d9fc8e771d3561$export$c2d663fbb86d66d6,
    color: $42d9fc8e771d3561$export$c2d663fbb86d66d6,
    default: $42d9fc8e771d3561$export$a743142a31c132c
};
const $42d9fc8e771d3561$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $42d9fc8e771d3561$var$keyframesTransition;
    else {
        const factory = $42d9fc8e771d3561$var$defaultTransitions[valueKey] || $42d9fc8e771d3561$var$defaultTransitions.default;
        return factory(keyframes[1]);
    }
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $21d69aa6d46ac8f4$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $330200ac4cef53eb$export$83a0e34f1302825b).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $6273179acc4b01d6$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, ...transition }) {
    return !!Object.keys(transition).length;
}
function $6273179acc4b01d6$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $6273179acc4b01d6$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $6abadeab186dd386$export$cea0cedcb94873b5)("", potentialUnitType);
}
function $6273179acc4b01d6$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}


function $e05fabc90b65a320$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $21d69aa6d46ac8f4$export$65676b58b122bc38)(valueName, target);
    let origin = transition.from !== undefined ? transition.from : value.get();
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $6abadeab186dd386$export$cea0cedcb94873b5)(valueName, target);
    else if ((0, $6273179acc4b01d6$export$c46ec7d82fb1f602)(origin) && typeof target === "string") origin = (0, $6273179acc4b01d6$export$36cd6032f9de8a48)(target);
    else if (!Array.isArray(target) && (0, $6273179acc4b01d6$export$c46ec7d82fb1f602)(target) && typeof origin === "string") target = (0, $6273179acc4b01d6$export$36cd6032f9de8a48)(origin);
    /**
     * If the target has been defined as a series of keyframes
     */ if (Array.isArray(target)) {
        /**
         * Ensure an initial wildcard keyframe is hydrated by the origin.
         * TODO: Support extra wildcard keyframes i.e [1, null, 0]
         */ if (target[0] === null) target[0] = origin;
        return target;
    } else return [
        origin,
        target
    ];
}



const $634a4a5a1693d08f$var$featureTests = {
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate")
};
const $634a4a5a1693d08f$var$results = {};
const $634a4a5a1693d08f$export$cde6a56f9669daf6 = {};
/**
 * Generate features tests that cache their results.
 */ for(const key in $634a4a5a1693d08f$var$featureTests)$634a4a5a1693d08f$export$cde6a56f9669daf6[key] = ()=>{
    if ($634a4a5a1693d08f$var$results[key] === undefined) $634a4a5a1693d08f$var$results[key] = $634a4a5a1693d08f$var$featureTests[key]();
    return $634a4a5a1693d08f$var$results[key];
};


/**
 * A list of values that can be hardware-accelerated.
 */ const $40adee63771467ed$var$acceleratedValues = new Set([
    "opacity"
]);
const $40adee63771467ed$export$208d7b28e5ce5514 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $6273179acc4b01d6$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $a647e52d1aa268c9$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $e05fabc90b65a320$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $21d69aa6d46ac8f4$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $21d69aa6d46ac8f4$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $f444ef37a22b988c$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ...valueTransition,
            elapsed: elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $fe404f374649e575$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $928c26c163ca7653$export$6f34fc8ef6c42b70)(options);
        else if (valueTransition.type === "inertia") {
            /**
             * If this is an inertia animation, we currently don't support pre-generating
             * keyframes for this as such it must always run on the main thread.
             */ const animation = (0, $aac6c3176a359ea3$export$ee3ff3a17106998)(options);
            return ()=>animation.stop();
        }
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $6273179acc4b01d6$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $42d9fc8e771d3561$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $a647e52d1aa268c9$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $a647e52d1aa268c9$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        const visualElement = value.owner;
        const element = visualElement && visualElement.current;
        const canAccelerateAnimation = (0, $634a4a5a1693d08f$export$cde6a56f9669daf6).waapi() && $40adee63771467ed$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && visualElement && element instanceof HTMLElement && !visualElement.getProps().onUpdate;
        if (canAccelerateAnimation) /**
             * If this animation is capable of being run via WAAPI, then do so.
             */ return (0, $228e05b68b406565$export$4d5d9557ab897126)(value, valueName, options);
        else {
            /**
             * Otherwise, fall back to the main thread.
             */ const animation = (0, $906a09c7a3d9b37f$export$e3607ec2d7a891c4)(options);
            return ()=>animation.stop();
        }
    };
};


function $00005776e6fafce6$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>$00005776e6fafce6$var$animateVariant(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $00005776e6fafce6$var$animateVariant(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $2f46f682b4a6162b$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = $00005776e6fafce6$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}
function $00005776e6fafce6$var$animateVariant(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $2f46f682b4a6162b$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>$00005776e6fafce6$var$animateTarget(visualElement, resolved, options) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $00005776e6fafce6$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $00005776e6fafce6$var$animateTarget(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && ((_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.getState()[type]);
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $00005776e6fafce6$var$shouldBlockAnimation(animationTypeState, key)) continue;
        let valueTransition = {
            delay: delay,
            elapsed: 0,
            ...transition
        };
        /**
         * Make animation instant if this is a transform prop and we should reduce motion.
         */ if (visualElement.shouldReduceMotion && (0, $d160cfa1fbfbdd2f$export$7b42a0094fb00b6e).has(key)) valueTransition = {
            ...valueTransition,
            type: false,
            delay: 0
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (!value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $5d875023d99403d2$export$8592e1c077c890a6];
            if (appearId) valueTransition.elapsed = (0, $ceede13a9ce17aa2$export$470de7e050cf9631)(appearId, key);
        }
        let animation = value.start((0, $40adee63771467ed$export$208d7b28e5ce5514)(key, value, valueTarget, valueTransition));
        if ((0, $a90e00c392ef6c3b$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation = animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    return Promise.all(animations).then(()=>{
        transitionEnd && (0, $179245aac7608fb5$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
}
function $00005776e6fafce6$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($00005776e6fafce6$export$523a0bedf33ad781).forEach((child, i)=>{
        animations.push($00005776e6fafce6$var$animateVariant(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $00005776e6fafce6$export$3cc6f911ef1fd837(visualElement) {
    visualElement.values.forEach((value)=>value.stop());
}
function $00005776e6fafce6$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $00005776e6fafce6$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}





const $67e4a7166102e015$export$16e45afcc206d3a8 = [
    (0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Animate,
    (0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).InView,
    (0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Focus,
    (0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Hover,
    (0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Tap,
    (0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Drag,
    (0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Exit
];
const $67e4a7166102e015$var$reversePriorityOrder = [
    ...$67e4a7166102e015$export$16e45afcc206d3a8
].reverse();
const $67e4a7166102e015$var$numAnimationTypes = $67e4a7166102e015$export$16e45afcc206d3a8.length;
function $67e4a7166102e015$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $00005776e6fafce6$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $67e4a7166102e015$export$bb53502b7a672aa8(visualElement) {
    let animate = $67e4a7166102e015$var$animateList(visualElement);
    const state = $67e4a7166102e015$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $2f46f682b4a6162b$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $67e4a7166102e015$var$numAnimationTypes; i++){
            const type = $67e4a7166102e015$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $21719eecd02f42f9$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $d4d04c41765ec410$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $67e4a7166102e015$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $b6d9120ab4ac6727$export$9153ad4c4999f4a0)(next) && (0, $b6d9120ab4ac6727$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $340d6d79dbe50eef$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $67e4a7166102e015$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $340d6d79dbe50eef$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $67e4a7166102e015$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $67e4a7166102e015$var$createState() {
    return {
        [(0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Animate]: $67e4a7166102e015$var$createTypeState(true),
        [(0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).InView]: $67e4a7166102e015$var$createTypeState(),
        [(0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Hover]: $67e4a7166102e015$var$createTypeState(),
        [(0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Tap]: $67e4a7166102e015$var$createTypeState(),
        [(0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Drag]: $67e4a7166102e015$var$createTypeState(),
        [(0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Focus]: $67e4a7166102e015$var$createTypeState(),
        [(0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Exit]: $67e4a7166102e015$var$createTypeState()
    };
}




const $70121fc2f386f54c$export$7f9953c70dacfd7f = {
    animation: (0, $799315ef62f7fd06$export$46d1d6d046f826e4)(({ visualElement: visualElement, animate: animate })=>{
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $67e4a7166102e015$export$bb53502b7a672aa8)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $d4d04c41765ec410$export$aa71198ceeaf53ce)(animate)) (0, $3QbnI.useEffect)(()=>animate.subscribe(visualElement), [
            animate
        ]);
    }),
    exit: (0, $799315ef62f7fd06$export$46d1d6d046f826e4)((props)=>{
        const { custom: custom, visualElement: visualElement } = props;
        const [isPresent, safeToRemove] = (0, $daea76f5257da47f$export$2a8c16d82a0a0e26)();
        const presenceContext = (0, $3QbnI.useContext)((0, $255f9a0b0527cdcb$export$f224e4635b6f8ce2));
        (0, $3QbnI.useEffect)(()=>{
            visualElement.isPresent = isPresent;
            const animation = visualElement.animationState && visualElement.animationState.setActive((0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Exit, !isPresent, {
                custom: presenceContext && presenceContext.custom || custom
            });
            if (animation && !isPresent) animation.then(safeToRemove);
        }, [
            isPresent
        ]);
    })
};



var $3QbnI = parcelRequire("3QbnI");







const $b029d87388858bfb$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $b029d87388858bfb$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $b029d87388858bfb$export$9f17032d917177de(a.x, b.x);
    const yDelta = $b029d87388858bfb$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}



/**
 * @internal
 */ class $34401390c71f17f4$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $34401390c71f17f4$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $b029d87388858bfb$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $bf0b592d43581589$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $34401390c71f17f4$var$transformPoint(info, this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $0aafd1aad305945b$export$764db16956f554f8)(event) && event.buttons === 0) {
                this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            (0, $9a179e07aa15314d$export$92d6409d68f0739a).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $34401390c71f17f4$var$getPanInfo($34401390c71f17f4$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $0aafd1aad305945b$export$c4dfce035d43d1e0)(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = (0, $074f55200245307f$export$12f84bb882d06e1a)(event);
        const initialInfo = $34401390c71f17f4$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $bf0b592d43581589$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $34401390c71f17f4$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $74b8d351da40c237$export$a4627e546088548d)((0, $dabea514f0da5772$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $dabea514f0da5772$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $dabea514f0da5772$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $9a179e07aa15314d$export$d93e9c1fe0553512).update(this.updatePoint);
    }
}
function $34401390c71f17f4$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $34401390c71f17f4$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $34401390c71f17f4$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $34401390c71f17f4$var$subtractPoint(point, $34401390c71f17f4$var$lastDevicePoint(history)),
        offset: $34401390c71f17f4$var$subtractPoint(point, $34401390c71f17f4$var$startDevicePoint(history)),
        velocity: $34401390c71f17f4$var$getVelocity(history, 0.1)
    };
}
function $34401390c71f17f4$var$startDevicePoint(history) {
    return history[0];
}
function $34401390c71f17f4$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $34401390c71f17f4$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $34401390c71f17f4$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $a647e52d1aa268c9$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $9f32e16714238f5c$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $9f32e16714238f5c$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $9f32e16714238f5c$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $9f32e16714238f5c$export$c1c127004b72a37(target) / $9f32e16714238f5c$export$c1c127004b72a37(source);
    if ($9f32e16714238f5c$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($9f32e16714238f5c$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $9f32e16714238f5c$export$c0d25e96fc67d310(delta, source, target, origin) {
    $9f32e16714238f5c$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    $9f32e16714238f5c$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function $9f32e16714238f5c$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $9f32e16714238f5c$export$c1c127004b72a37(relative);
}
function $9f32e16714238f5c$export$426154f9d100f99(target, relative, parent) {
    $9f32e16714238f5c$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $9f32e16714238f5c$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $9f32e16714238f5c$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $9f32e16714238f5c$export$c1c127004b72a37(layout);
}
function $9f32e16714238f5c$export$2785bfcc929c5650(target, layout, parent) {
    $9f32e16714238f5c$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $9f32e16714238f5c$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $7df50f5905a857c1$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $7df50f5905a857c1$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $7df50f5905a857c1$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $7df50f5905a857c1$export$690c180aa5775042(layoutBox.x, left, right),
        y: $7df50f5905a857c1$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $7df50f5905a857c1$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $7df50f5905a857c1$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $7df50f5905a857c1$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $7df50f5905a857c1$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $7df50f5905a857c1$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $9f32e16714238f5c$export$c1c127004b72a37)(source);
    const targetLength = (0, $9f32e16714238f5c$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $55d5e2d6922a2a3c$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $55d5e2d6922a2a3c$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $fc8aa3a981bda5c2$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $7df50f5905a857c1$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $7df50f5905a857c1$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $7df50f5905a857c1$export$7c5eaef8f4723d22(dragElastic = $7df50f5905a857c1$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $7df50f5905a857c1$export$a3366d3bac43a742;
    return {
        x: $7df50f5905a857c1$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $7df50f5905a857c1$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $7df50f5905a857c1$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $7df50f5905a857c1$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $7df50f5905a857c1$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $7df50f5905a857c1$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}



const $e44f283e3a9b207b$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $e44f283e3a9b207b$export$3d227df54007d73a = ()=>({
        x: $e44f283e3a9b207b$export$ff25708b37f72782(),
        y: $e44f283e3a9b207b$export$ff25708b37f72782()
    });
const $e44f283e3a9b207b$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $e44f283e3a9b207b$export$6459fc9e86be362e = ()=>({
        x: $e44f283e3a9b207b$export$6db76765312617ac(),
        y: $e44f283e3a9b207b$export$6db76765312617ac()
    });


function $dcf9a29bbccdf88e$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $f2589fd2ef1fb7f0$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $f2589fd2ef1fb7f0$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $f2589fd2ef1fb7f0$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $c19bffa594edf959$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $c19bffa594edf959$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$c19bffa594edf959$var$isIdentityScale(scale) || !$c19bffa594edf959$var$isIdentityScale(scaleX) || !$c19bffa594edf959$var$isIdentityScale(scaleY);
}
function $c19bffa594edf959$export$a545127cf1fbb600(values) {
    return $c19bffa594edf959$export$bdf30dca883ea463(values) || $c19bffa594edf959$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $c19bffa594edf959$export$bf80f5f8f4dc327f(values) {
    return $c19bffa594edf959$var$is2DTranslate(values.x) || $c19bffa594edf959$var$is2DTranslate(values.y);
}
function $c19bffa594edf959$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $bf8f99d36829ad0c$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $bf8f99d36829ad0c$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $bf8f99d36829ad0c$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $bf8f99d36829ad0c$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $bf8f99d36829ad0c$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $bf8f99d36829ad0c$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $bf8f99d36829ad0c$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $bf8f99d36829ad0c$export$d80074982803af5c(box, { x: x, y: y }) {
    $bf8f99d36829ad0c$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $bf8f99d36829ad0c$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $bf8f99d36829ad0c$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    var _a, _b;
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $bf8f99d36829ad0c$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $bf8f99d36829ad0c$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $c19bffa594edf959$export$a545127cf1fbb600)(node.latestValues)) $bf8f99d36829ad0c$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $bf8f99d36829ad0c$var$snapToDefault(treeScale.x);
    treeScale.y = $bf8f99d36829ad0c$var$snapToDefault(treeScale.y);
}
function $bf8f99d36829ad0c$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $bf8f99d36829ad0c$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $bf8f99d36829ad0c$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $bf8f99d36829ad0c$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $bf8f99d36829ad0c$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $bf8f99d36829ad0c$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $bf8f99d36829ad0c$export$58b16271041fbfb(box, transform) {
    $bf8f99d36829ad0c$export$625f1dd140a2f5e7(box.x, transform, $bf8f99d36829ad0c$var$xKeys);
    $bf8f99d36829ad0c$export$625f1dd140a2f5e7(box.y, transform, $bf8f99d36829ad0c$var$yKeys);
}


function $5a129707cecd9f3e$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $f2589fd2ef1fb7f0$export$d3955c6a8f65a36b)((0, $f2589fd2ef1fb7f0$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $5a129707cecd9f3e$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $5a129707cecd9f3e$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $bf8f99d36829ad0c$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $bf8f99d36829ad0c$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









const $2b55ef8d59bddaf1$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: AnyPointerEvent
class $2b55ef8d59bddaf1$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ if (this.visualElement.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $074f55200245307f$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $463c24a8a9611f6a$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $dcf9a29bbccdf88e$export$b789de563eb43b1)((axis)=>{
                var _a, _b;
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $bedfe8fbb87aed27$export$626336c2cd4b14de).test(current)) {
                    const measuredAxis = (_b = (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.layoutBox[axis];
                    if (measuredAxis) {
                        const length = (0, $9f32e16714238f5c$export$c1c127004b72a37)(measuredAxis);
                        current = length * (parseFloat(current) / 100);
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 || onDragStart(event, info);
            (_a = this.visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Drag, true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $2b55ef8d59bddaf1$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock === null || onDirectionLock === void 0 || onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag === null || onDrag === void 0 || onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $34401390c71f17f4$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(event, info);
    }
    cancel() {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) this.visualElement.projection.isAnimationBlocked = false;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $c5e4b2394b8140ce$export$2deb71ebd3734d23).Drag, false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$2b55ef8d59bddaf1$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $7df50f5905a857c1$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const { layout: layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $5f2bb49c93cd76c8$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $7df50f5905a857c1$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $7df50f5905a857c1$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $dcf9a29bbccdf88e$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $7df50f5905a857c1$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $5f2bb49c93cd76c8$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $f444ef37a22b988c$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $5a129707cecd9f3e$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $7df50f5905a857c1$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $f2589fd2ef1fb7f0$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $f2589fd2ef1fb7f0$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $dcf9a29bbccdf88e$export$b789de563eb43b1)((axis)=>{
            if (!$2b55ef8d59bddaf1$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = (constraints === null || constraints === void 0 ? void 0 : constraints[axis]) || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $40adee63771467ed$export$208d7b28e5ce5514)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $dcf9a29bbccdf88e$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        var _a;
        const dragKey = "_drag" + axis.toUpperCase();
        const externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, ((_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) || 0);
    }
    snapToCursor(point) {
        (0, $dcf9a29bbccdf88e$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$2b55ef8d59bddaf1$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        var _a;
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $5f2bb49c93cd76c8$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $dcf9a29bbccdf88e$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $7df50f5905a857c1$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $dcf9a29bbccdf88e$export$b789de563eb43b1)((axis)=>{
            if (!$2b55ef8d59bddaf1$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        var _a;
        if (!this.visualElement.current) return;
        $2b55ef8d59bddaf1$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $dabea514f0da5772$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $5f2bb49c93cd76c8$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $0b6c5b02e96942a7$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $dcf9a29bbccdf88e$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 || stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $7df50f5905a857c1$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $2b55ef8d59bddaf1$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $2b55ef8d59bddaf1$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}



/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $9cd435d6e3a5a95e$export$7941f8aafa4b6021(props) {
    const { dragControls: groupDragControls, visualElement: visualElement } = props;
    const dragControls = (0, $fe17874da42017ee$export$fe4300aa8eebea86)(()=>new (0, $2b55ef8d59bddaf1$export$86bff71f18910307)(visualElement));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $3QbnI.useEffect)(()=>groupDragControls && groupDragControls.subscribe(dragControls), [
        dragControls,
        groupDragControls
    ]);
    // Apply the event listeners to the element
    (0, $3QbnI.useEffect)(()=>dragControls.addListeners(), [
        dragControls
    ]);
}



var $3QbnI = parcelRequire("3QbnI");




/**
 *
 * @param handlers -
 * @param ref -
 *
 * @privateRemarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $9629747fc882eebd$export$eb0f62174cac1aec({ onPan: onPan, onPanStart: onPanStart, onPanEnd: onPanEnd, onPanSessionStart: onPanSessionStart, visualElement: visualElement }) {
    const hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    const panSession = (0, $3QbnI.useRef)(null);
    const { transformPagePoint: transformPagePoint } = (0, $3QbnI.useContext)((0, $6cc415884e1c31ed$export$22a697fb29aac98d));
    const handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: (event, info)=>{
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $3QbnI.useEffect)(()=>{
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $34401390c71f17f4$export$d9c66232c9c4689c)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $dabea514f0da5772$export$734d04395f5243cd)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $e504b98c47df39d3$export$f3a192d0cbd30b96)(()=>panSession.current && panSession.current.end());
}



const $ad838133cd88676e$export$d7d5d435647ed5a0 = {
    pan: (0, $799315ef62f7fd06$export$46d1d6d046f826e4)((0, $9629747fc882eebd$export$eb0f62174cac1aec)),
    drag: (0, $799315ef62f7fd06$export$46d1d6d046f826e4)((0, $9cd435d6e3a5a95e$export$7941f8aafa4b6021))
};











function $9dd90b7cb879614f$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $9dd90b7cb879614f$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $9dd90b7cb879614f$export$b9f0c1f373aee2b0(current) {
    const match = $9dd90b7cb879614f$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $9dd90b7cb879614f$var$maxDepth = 4;
function $9dd90b7cb879614f$var$getVariableValue(current, element, depth = 1) {
    (0, $f444ef37a22b988c$export$f5708dca728d7177)(depth <= $9dd90b7cb879614f$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $9dd90b7cb879614f$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($9dd90b7cb879614f$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $9dd90b7cb879614f$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $9dd90b7cb879614f$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!$9dd90b7cb879614f$var$isCSSVariable(current)) return;
        const resolved = $9dd90b7cb879614f$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!$9dd90b7cb879614f$var$isCSSVariable(current)) continue;
        const resolved = $9dd90b7cb879614f$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd && transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $72e86a908a337a0b$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
const $72e86a908a337a0b$var$isPositionalKey = (key)=>$72e86a908a337a0b$var$positionalKeys.has(key);
const $72e86a908a337a0b$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($72e86a908a337a0b$var$isPositionalKey);
};
const $72e86a908a337a0b$var$setAndResetVelocity = (value, to)=>{
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
const $72e86a908a337a0b$var$isNumOrPxType = (v)=>v === (0, $4eaf82465a158227$export$98e628dec113755e) || v === (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008);
var $72e86a908a337a0b$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($72e86a908a337a0b$export$d0c75e4fa9e69db8 || ($72e86a908a337a0b$export$d0c75e4fa9e69db8 = {}));
const $72e86a908a337a0b$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $72e86a908a337a0b$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $72e86a908a337a0b$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $72e86a908a337a0b$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $72e86a908a337a0b$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $72e86a908a337a0b$var$nonTranslationalTransformKeys = (0, $d160cfa1fbfbdd2f$export$280dc01950909d86).filter((key)=>!$72e86a908a337a0b$var$transformKeys.has(key));
function $72e86a908a337a0b$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $72e86a908a337a0b$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $72e86a908a337a0b$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $72e86a908a337a0b$var$getTranslateFromMatrix(4, 13),
    y: $72e86a908a337a0b$var$getTranslateFromMatrix(5, 14)
};
const $72e86a908a337a0b$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $72e86a908a337a0b$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        $72e86a908a337a0b$var$setAndResetVelocity(value, origin[key]);
        target[key] = $72e86a908a337a0b$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $72e86a908a337a0b$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($72e86a908a337a0b$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $d63e13ed09d9d59b$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $b6d9120ab4ac6727$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $d63e13ed09d9d59b$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++)if (!toType) {
                toType = (0, $d63e13ed09d9d59b$export$eefdd52e3ccae428)(to[i]);
                (0, $f444ef37a22b988c$export$f5708dca728d7177)(toType === fromType || $72e86a908a337a0b$var$isNumOrPxType(fromType) && $72e86a908a337a0b$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $f444ef37a22b988c$export$f5708dca728d7177)((0, $d63e13ed09d9d59b$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $d63e13ed09d9d59b$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($72e86a908a337a0b$var$isNumOrPxType(fromType) && $72e86a908a337a0b$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $72e86a908a337a0b$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                $72e86a908a337a0b$var$setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $72e86a908a337a0b$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $99db44a5d4c29f46$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $72e86a908a337a0b$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $72e86a908a337a0b$var$hasPositionalKey(target) ? $72e86a908a337a0b$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $e4a58f884403555b$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $9dd90b7cb879614f$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $72e86a908a337a0b$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};





var $3QbnI = parcelRequire("3QbnI");





// Does this device prefer reduced motion? Returns `null` server-side.
const $44b6a11435389fab$export$ff7706047246b98b = {
    current: null
};
const $44b6a11435389fab$export$6476d16e2fd2d0db = {
    current: false
};


function $1d5f8b2d8f0513a1$export$ca9f41fb23dded3d() {
    (0, $44b6a11435389fab$export$6476d16e2fd2d0db).current = true;
    if (!(0, $99db44a5d4c29f46$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $44b6a11435389fab$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $44b6a11435389fab$export$ff7706047246b98b).current = false;
}















function $26cec413edfb9800$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $98deaa364e648ac8$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $a90e00c392ef6c3b$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $98deaa364e648ac8$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $8f10076a3295e789$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $a90e00c392ef6c3b$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $8f10076a3295e789$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}



const $b974b8d72ff2afef$var$featureNames = Object.keys((0, $718e06fa2114feac$export$65570e08d843624d));
const $b974b8d72ff2afef$var$numFeatures = $b974b8d72ff2afef$var$featureNames.length;
const $b974b8d72ff2afef$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "Unmount",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $b974b8d72ff2afef$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Tracks whether this VisualElement's React component is currently present
         * within the defined React tree.
         */ this.isPresent = true;
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $9a179e07aa15314d$export$92d6409d68f0739a).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $e6cef9ccd8a57339$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $e6cef9ccd8a57339$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $98deaa364e648ac8$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $a90e00c392ef6c3b$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props) {
        return {};
    }
    mount(instance) {
        var _a;
        this.current = instance;
        if (this.projection) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $44b6a11435389fab$export$6476d16e2fd2d0db).current) (0, $1d5f8b2d8f0513a1$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $44b6a11435389fab$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.setProps(this.props);
    }
    unmount() {
        var _a, _b, _c;
        (_a = this.projection) === null || _a === void 0 || _a.unmount();
        (0, $9a179e07aa15314d$export$d93e9c1fe0553512).update(this.notifyUpdate);
        (0, $9a179e07aa15314d$export$d93e9c1fe0553512).render(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        (_b = this.removeFromVariantTree) === null || _b === void 0 || _b.call(this);
        (_c = this.parent) === null || _c === void 0 || _c.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $d160cfa1fbfbdd2f$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $9a179e07aa15314d$export$92d6409d68f0739a).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures(renderedProps, isStrict, preloadedFeatures, projectionId, ProjectionNodeConstructor, initialLayoutGroupConfig) {
        const features = [];
        /**
         * If we're in development mode, check to make sure we're not rendering a motion component
         * as a child of LazyMotion, as this will break the file-size benefits of using it.
         */ if ((0, $f2a6b1e4c1fe889e$export$a7b6bc01c63cdfc3) !== "production" && preloadedFeatures && isStrict) (0, $f444ef37a22b988c$export$f5708dca728d7177)(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
        for(let i = 0; i < $b974b8d72ff2afef$var$numFeatures; i++){
            const name = $b974b8d72ff2afef$var$featureNames[i];
            const { isEnabled: isEnabled, Component: Component } = (0, $718e06fa2114feac$export$65570e08d843624d)[name];
            /**
             * It might be possible in the future to use this moment to
             * dynamically request functionality. In initial tests this
             * was producing a lot of duplication amongst bundles.
             */ if (isEnabled(renderedProps) && Component) features.push((0, $3QbnI.createElement)(Component, {
                key: name,
                ...renderedProps,
                visualElement: this
            }));
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(projectionId, this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $5f2bb49c93cd76c8$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll
            });
        }
        return features;
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ setProps(props) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.props = props;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $b974b8d72ff2afef$var$propEventHandlers.length; i++){
            const key = $b974b8d72ff2afef$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $26cec413edfb9800$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props), this.prevMotionValues);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        var _a;
        return (_a = this.props.variants) === null || _a === void 0 ? void 0 : _a[name];
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        var _a;
        return this.isVariantNode ? this : (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getClosestVariantNode();
    }
    getVariantContext(startAtParent = false) {
        var _a, _b;
        if (startAtParent) return (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getVariantContext();
        if (!this.isControllingVariants) {
            const context = ((_b = this.parent) === null || _b === void 0 ? void 0 : _b.getVariantContext()) || {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $b974b8d72ff2afef$var$numVariantProps; i++){
            const name = $b974b8d72ff2afef$var$variantProps[i];
            const prop = this.props[name];
            if ((0, $21719eecd02f42f9$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        var _a;
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (this.hasValue(key)) this.removeValue(key);
        this.values.set(key, value);
        this.latestValues[key] = value.get();
        this.bindToMotionValue(key, value);
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        var _a;
        this.values.delete(key);
        (_a = this.valueSubscriptions.get(key)) === null || _a === void 0 || _a();
        this.valueSubscriptions.delete(key);
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    /**
     * Get a motion value for this key. If called with a default
     * value, we'll create one if none exists.
     */ getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $8f10076a3295e789$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $cd6ee1d41d40c26d$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $98deaa364e648ac8$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $f80207b7ef310be9$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        var _a;
        (_a = this.events[eventName]) === null || _a === void 0 || _a.notify(...args);
    }
}
const $b974b8d72ff2afef$var$variantProps = [
    "initial",
    ...(0, $67e4a7166102e015$export$16e45afcc206d3a8)
];
const $b974b8d72ff2afef$var$numVariantProps = $b974b8d72ff2afef$var$variantProps.length;


class $c736ae09978a1b05$export$e49735c2a366bdc7 extends (0, $b974b8d72ff2afef$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $179245aac7608fb5$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $179245aac7608fb5$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $e4a58f884403555b$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}


function $79e4fdb48ea9070a$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $79e4fdb48ea9070a$export$23fea75b03ac16b3 extends (0, $c736ae09978a1b05$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $d160cfa1fbfbdd2f$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $1589a0c510a1cefe$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $79e4fdb48ea9070a$export$3735103072e4a80(instance);
            const value = ((0, $57de5cb506354910$export$451bc42768436155)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $5a129707cecd9f3e$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $e7bbc696ba6d4c61$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props) {
        return (0, $dc06775e77d9f98c$export$16da615486abaa45)(props);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $0f0e0a8f7ca59752$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $1b5ca3384cc072ba$export$86bcdffbaf733d84 extends (0, $c736ae09978a1b05$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        var _a;
        if ((0, $d160cfa1fbfbdd2f$export$7b42a0094fb00b6e).has(key)) return ((_a = (0, $1589a0c510a1cefe$export$67d1babe0338d23b)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $71dcd65b519498ae$export$28931db5d57958e5).has(key) ? (0, $8b2f0c14ed6d6d72$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props) {
        return (0, $b4b2e99100921ff3$export$16da615486abaa45)(props);
    }
    build(renderState, latestValues, options, props) {
        (0, $838ce897bf46110c$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9f05ac768b4e52ef$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $af719a20ce2e0076$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $73b6f3f065424c75$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $e5c1e686740388d5$export$88f3fc2fd3766989)(Component) ? new (0, $1b5ca3384cc072ba$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $79e4fdb48ea9070a$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




var $3QbnI = parcelRequire("3QbnI");





function $89aaff98c09cc903$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $89aaff98c09cc903$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $bedfe8fbb87aed27$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $89aaff98c09cc903$export$fafff692be55225d(latest, node.target.x);
        const y = $89aaff98c09cc903$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};





const $3159227d58b54bc5$var$varToken = "_$css";
const $3159227d58b54bc5$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */ const containsCSSVariables = latest.includes("var(");
        const cssVariables = [];
        if (containsCSSVariables) latest = latest.replace((0, $9dd90b7cb879614f$export$f7c0a352d8ef6313), (match)=>{
            cssVariables.push(match);
            return $3159227d58b54bc5$var$varToken;
        });
        const shadow = (0, $330200ac4cef53eb$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $330200ac4cef53eb$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        let output = template(shadow);
        if (containsCSSVariables) {
            let i = 0;
            output = output.replace($3159227d58b54bc5$var$varToken, ()=>{
                const cssVariable = cssVariables[i];
                i++;
                return cssVariable;
            });
        }
        return output;
    }
};



class $a9ea10d81ddaf282$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $a066e957945bd554$export$de9e7791c71225fd)($a9ea10d81ddaf282$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $cf9811a0031fff82$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $9a179e07aa15314d$export$92d6409d68f0739a).postRender(()=>{
                var _a;
                if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove === null || safeToRemove === void 0 || safeToRemove();
    }
    render() {
        return null;
    }
}
function $a9ea10d81ddaf282$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $daea76f5257da47f$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $3QbnI.useContext)((0, $620e8e0b2359a784$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($a9ea10d81ddaf282$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $3QbnI.useContext)((0, $422301a601df0ddc$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $a9ea10d81ddaf282$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $89aaff98c09cc903$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $89aaff98c09cc903$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $89aaff98c09cc903$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $89aaff98c09cc903$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $89aaff98c09cc903$export$5eafb6257a5844c),
    boxShadow: (0, $3159227d58b54bc5$export$eb0bc629e74dcf8)
};


const $30d5c0dd84e9a9e3$export$518df03f164c507 = {
    measureLayout: (0, $a9ea10d81ddaf282$export$779f5fb01ad751cd)
};






/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */ function $26f404e4010aac71$export$e3607ec2d7a891c4(from, to, transition = {}) {
    const value = (0, $98deaa364e648ac8$export$605d60a2578142d3)(from) ? from : (0, $8f10076a3295e789$export$ce8bdc721e76545f)(from);
    value.start((0, $40adee63771467ed$export$208d7b28e5ce5514)("", value, to, transition));
    return {
        stop: ()=>value.stop(),
        isAnimating: ()=>value.isAnimating()
    };
}








const $dce492c3b5e5f3e9$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $dce492c3b5e5f3e9$var$numBorders = $dce492c3b5e5f3e9$var$borders.length;
const $dce492c3b5e5f3e9$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $dce492c3b5e5f3e9$var$isPx = (value)=>typeof value === "number" || (0, $bedfe8fbb87aed27$export$91c0eda1d06bf008).test(value);
function $dce492c3b5e5f3e9$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $dce492c3b5e5f3e9$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $dce492c3b5e5f3e9$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $dce492c3b5e5f3e9$var$numBorders; i++){
        const borderLabel = `border${$dce492c3b5e5f3e9$var$borders[i]}Radius`;
        let followRadius = $dce492c3b5e5f3e9$var$getRadius(follow, borderLabel);
        let leadRadius = $dce492c3b5e5f3e9$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $dce492c3b5e5f3e9$var$isPx(followRadius) === $dce492c3b5e5f3e9$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)($dce492c3b5e5f3e9$var$asNumber(followRadius), $dce492c3b5e5f3e9$var$asNumber(leadRadius), progress), 0);
            if ((0, $bedfe8fbb87aed27$export$626336c2cd4b14de).test(leadRadius) || (0, $bedfe8fbb87aed27$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $dce492c3b5e5f3e9$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $dce492c3b5e5f3e9$var$easeCrossfadeIn = $dce492c3b5e5f3e9$var$compress(0, 0.5, (0, $25fc5dc25592b6ac$export$c8d67a19199d1a50));
const $dce492c3b5e5f3e9$var$easeCrossfadeOut = $dce492c3b5e5f3e9$var$compress(0.5, 0.95, (0, $2474671030e506b8$export$8793edee2d425525));
function $dce492c3b5e5f3e9$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $55d5e2d6922a2a3c$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $4a89bb3eeead5382$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $4a89bb3eeead5382$export$c53fd88f45d77e4b(box, originBox) {
    $4a89bb3eeead5382$export$a0230ae482601ae8(box.x, originBox.x);
    $4a89bb3eeead5382$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $e0d54783785456ea$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $bf8f99d36829ad0c$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $bf8f99d36829ad0c$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $e0d54783785456ea$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $bedfe8fbb87aed27$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $e0d54783785456ea$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $e0d54783785456ea$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $e0d54783785456ea$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $e0d54783785456ea$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $e0d54783785456ea$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $e0d54783785456ea$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $e0d54783785456ea$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $e0d54783785456ea$export$42b76f1d0d16d5b(box.x, transforms, $e0d54783785456ea$var$xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    $e0d54783785456ea$export$42b76f1d0d16d5b(box.y, transforms, $e0d54783785456ea$var$yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}





function $f583ed6ad8b0ef79$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $f583ed6ad8b0ef79$export$a7ec7642fe550fb6(delta) {
    return $f583ed6ad8b0ef79$var$isAxisDeltaZero(delta.x) && $f583ed6ad8b0ef79$var$isAxisDeltaZero(delta.y);
}
function $f583ed6ad8b0ef79$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $f583ed6ad8b0ef79$export$c5706146bc63213(box) {
    return (0, $9f32e16714238f5c$export$c1c127004b72a37)(box.x) / (0, $9f32e16714238f5c$export$c1c127004b72a37)(box.y);
}



class $39f7ee2fbb924314$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $d87b3f0c79447976$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $d87b3f0c79447976$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        var _a;
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 || _e.call(_d);
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $b9f4a1e61dafd76e$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $7a8d187acd2aaf11$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $cd7a772ef478003c$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $d87b3f0c79447976$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $d87b3f0c79447976$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $7a8d187acd2aaf11$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}






const $7915f523c52977a0$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $7915f523c52977a0$var$animationTarget = 1000;
let $7915f523c52977a0$var$id = 0;
function $7915f523c52977a0$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(elementId, latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $7915f523c52977a0$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            this.isTransformDirty = false;
            /**
             * Flag to true if we think the projection calculations for this or any
             * child might need recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.nodes.forEach($7915f523c52977a0$export$131f2f0cc5fe9609);
                this.nodes.forEach($7915f523c52977a0$var$resolveTargetDelta);
                this.nodes.forEach($7915f523c52977a0$var$calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.elementId = elementId;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            elementId && this.root.registerPotentialNode(elementId, this);
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $cd7a772ef478003c$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $f80207b7ef310be9$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 || subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        registerPotentialNode(elementId, node) {
            this.potentialNodes.set(elementId, node);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = false) {
            var _a;
            if (this.instance) return;
            this.isSVG = instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 || _a.children.add(this);
            this.elementId && this.root.potentialNodes.delete(this.elementId);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $6e4866dc433166b0$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $cf9811a0031fff82$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $cf9811a0031fff82$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($7915f523c52977a0$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                var _a, _b, _c, _d, _e;
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = (_b = (_a = this.options.transition) !== null && _a !== void 0 ? _a : visualElement.getDefaultTransition()) !== null && _b !== void 0 ? _b : $7915f523c52977a0$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $f583ed6ad8b0ef79$export$8d5cf76bb7daff09)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (((_c = this.resumeFrom) === null || _c === void 0 ? void 0 : _c.instance) || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $6273179acc4b01d6$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged && this.animationProgress === 0) $7915f523c52977a0$var$finishAnimation(this);
                    this.isLead() && ((_e = (_d = this.options).onExitComplete) === null || _e === void 0 || _e.call(_d));
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 || _a.remove(this);
            (_b = this.parent) === null || _b === void 0 || _b.children.delete(this);
            this.instance = undefined;
            (0, $9a179e07aa15314d$export$d93e9c1fe0553512).preRender(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            var _a;
            return this.isAnimationBlocked || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            var _a;
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 || _a.forEach($7915f523c52977a0$var$resetRotation);
            this.animationId++;
        }
        willUpdate(shouldNotifyListeners = true) {
            var _a, _b, _c;
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        // Note: Currently only running on root node
        didUpdate() {
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($7915f523c52977a0$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */ if (this.potentialNodes.size) {
                this.potentialNodes.forEach($7915f523c52977a0$var$mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */ this.nodes.forEach($7915f523c52977a0$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($7915f523c52977a0$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($7915f523c52977a0$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            (0, $9a179e07aa15314d$export$cd75ccfd720a3cd4).update();
            (0, $9a179e07aa15314d$export$cd75ccfd720a3cd4).preRender();
            (0, $9a179e07aa15314d$export$cd75ccfd720a3cd4).render();
        }
        clearAllSnapshots() {
            this.nodes.forEach($7915f523c52977a0$var$clearSnapshot);
            this.sharedNodes.forEach($7915f523c52977a0$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            (0, $9a179e07aa15314d$export$92d6409d68f0739a).preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $9a179e07aa15314d$export$92d6409d68f0739a).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            var _a;
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            (_a = this.options.visualElement) === null || _a === void 0 || _a.notify("LayoutMeasure", this.layout.layoutBox, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.layoutBox);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            var _a;
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $f583ed6ad8b0ef79$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            const transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $c19bffa594edf959$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $7915f523c52977a0$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $bf8f99d36829ad0c$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $bf8f99d36829ad0c$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
            (0, $4a89bb3eeead5382$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $4a89bb3eeead5382$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $bf8f99d36829ad0c$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $bf8f99d36829ad0c$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $bf8f99d36829ad0c$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $bf8f99d36829ad0c$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
            (0, $4a89bb3eeead5382$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $bf8f99d36829ad0c$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $c19bffa594edf959$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $bf8f99d36829ad0c$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $c19bffa594edf959$export$a545127cf1fbb600)(this.latestValues)) (0, $bf8f99d36829ad0c$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            var _a;
            const boxWithoutTransform = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
            (0, $4a89bb3eeead5382$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $c19bffa594edf959$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $c19bffa594edf959$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $4a89bb3eeead5382$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $e0d54783785456ea$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layoutBox, sourceBox);
            }
            if ((0, $c19bffa594edf959$export$a545127cf1fbb600)(this.latestValues)) (0, $e0d54783785456ea$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        /**
         *
         */ setTargetDelta(delta) {
            this.targetDelta = delta;
            this.isProjectionDirty = true;
            this.root.scheduleUpdateProjection();
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        /**
         * Frame calculations
         */ resolveTargetDelta() {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ if (!this.isProjectionDirty && !this.attemptToResolveRelativeTarget) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
                    (0, $9f32e16714238f5c$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $4a89bb3eeead5382$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) (0, $9f32e16714238f5c$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $4a89bb3eeead5382$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $bf8f99d36829ad0c$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $4a89bb3eeead5382$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
                    (0, $9f32e16714238f5c$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $4a89bb3eeead5382$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $c19bffa594edf959$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $c19bffa594edf959$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        calcProjection() {
            var _a;
            const { isProjectionDirty: isProjectionDirty, isTransformDirty: isTransformDirty } = this;
            this.isProjectionDirty = this.isTransformDirty = false;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            if (isProjectionDirty) canSkip = false;
            if (isShared && isTransformDirty) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $4a89bb3eeead5382$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $bf8f99d36829ad0c$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            const { target: target } = lead;
            if (!target) return;
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $e44f283e3a9b207b$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $e44f283e3a9b207b$export$3d227df54007d73a)();
            }
            const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $9f32e16714238f5c$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $b9f4a1e61dafd76e$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a, _b, _c;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 || _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 || _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            var _a, _b;
            const snapshot = this.snapshot;
            const snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $e44f283e3a9b207b$export$3d227df54007d73a)();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
            const isSharedLayoutAnimation = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.source) !== ((_a = this.layout) === null || _a === void 0 ? void 0 : _a.source);
            const isOnlyMember = (((_b = this.getStack()) === null || _b === void 0 ? void 0 : _b.members.length) || 0) <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($7915f523c52977a0$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            this.mixTargetDelta = (latest)=>{
                var _a;
                const progress = latest / 1000;
                $7915f523c52977a0$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $7915f523c52977a0$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    (0, $9f32e16714238f5c$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $7915f523c52977a0$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $dce492c3b5e5f3e9$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(0);
        }
        startAnimation(options) {
            var _a, _b;
            this.notifyListeners("animationStart");
            (_a = this.currentAnimation) === null || _a === void 0 || _a.stop();
            if (this.resumingFrom) (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 || _b.stop();
            if (this.pendingAnimation) {
                (0, $9a179e07aa15314d$export$d93e9c1fe0553512).update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $9a179e07aa15314d$export$92d6409d68f0739a).update(()=>{
                (0, $cf9811a0031fff82$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $26f404e4010aac71$export$e3607ec2d7a891c4)(0, $7915f523c52977a0$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        var _a;
                        this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, latest);
                    },
                    onComplete: ()=>{
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 || _a.call(options);
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 || _a.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 || _a.call(this, $7915f523c52977a0$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $7915f523c52977a0$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
                const xLength = (0, $9f32e16714238f5c$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $9f32e16714238f5c$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $4a89bb3eeead5382$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $bf8f99d36829ad0c$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $9f32e16714238f5c$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $39f7ee2fbb924314$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node)
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $7915f523c52977a0$var$transformAxes.length; i++){
                const key = "rotate" + $7915f523c52977a0$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 || visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b, _c;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $090571e56c381a54$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $090571e56c381a54$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $c19bffa594edf959$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $b9f4a1e61dafd76e$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_c = (_b = valuesToRender.opacity) !== null && _b !== void 0 ? _b : this.latestValues.opacity) !== null && _c !== void 0 ? _c : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $a066e957945bd554$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $a066e957945bd554$export$91ddd985b97788d1)[key];
                const corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $090571e56c381a54$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($7915f523c52977a0$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $7915f523c52977a0$var$updateLayout(node) {
    node.updateLayout();
}
function $7915f523c52977a0$var$notifyLayoutUpdate(node) {
    var _a, _b, _c;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $dcf9a29bbccdf88e$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $9f32e16714238f5c$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($7915f523c52977a0$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $dcf9a29bbccdf88e$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $9f32e16714238f5c$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
        });
        const layoutDelta = (0, $e44f283e3a9b207b$export$3d227df54007d73a)();
        (0, $9f32e16714238f5c$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $e44f283e3a9b207b$export$3d227df54007d73a)();
        if (isShared) (0, $9f32e16714238f5c$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $9f32e16714238f5c$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $f583ed6ad8b0ef79$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
                    (0, $9f32e16714238f5c$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $e44f283e3a9b207b$export$6459fc9e86be362e)();
                    (0, $9f32e16714238f5c$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $f583ed6ad8b0ef79$export$8d5cf76bb7daff09)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) (_c = (_b = node.options).onExitComplete) === null || _c === void 0 || _c.call(_b);
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $7915f523c52977a0$export$131f2f0cc5fe9609(node) {
    /**
     * Propagate isProjectionDirty. Nodes are ordered by depth, so if the parent here
     * is dirty we can simply pass this forward.
     */ node.isProjectionDirty || (node.isProjectionDirty = Boolean(node.parent && node.parent.isProjectionDirty));
    /**
     * Propagate isTransformDirty.
     */ node.isTransformDirty || (node.isTransformDirty = Boolean(node.parent && node.parent.isTransformDirty));
}
function $7915f523c52977a0$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $7915f523c52977a0$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $7915f523c52977a0$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement === null || visualElement === void 0 ? void 0 : visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $7915f523c52977a0$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function $7915f523c52977a0$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $7915f523c52977a0$var$calcProjection(node) {
    node.calcProjection();
}
function $7915f523c52977a0$var$resetRotation(node) {
    node.resetRotation();
}
function $7915f523c52977a0$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $7915f523c52977a0$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $7915f523c52977a0$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $dee33a4a46b35b3d$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $7915f523c52977a0$export$6ffd3e6ae339a132(output, from, to, p) {
    $7915f523c52977a0$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $7915f523c52977a0$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $7915f523c52977a0$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $7915f523c52977a0$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $7915f523c52977a0$var$mountNodeEarly(node, elementId) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */ let searchNode = node.root;
    for(let i = node.path.length - 1; i >= 0; i--)if (Boolean(node.path[i].instance)) {
        searchNode = node.path[i];
        break;
    }
    const searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    const element = searchElement.querySelector(`[data-projection-id="${elementId}"]`);
    if (element) node.mount(element, true);
}
function $7915f523c52977a0$var$roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function $7915f523c52977a0$var$roundBox(box) {
    $7915f523c52977a0$var$roundAxis(box.x);
    $7915f523c52977a0$var$roundAxis(box.y);
}
function $7915f523c52977a0$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $9f32e16714238f5c$export$28d0384c4b79bde2)((0, $f583ed6ad8b0ef79$export$c5706146bc63213)(snapshot), (0, $f583ed6ad8b0ef79$export$c5706146bc63213)(layout), 0.2);
}




const $0217101e31a310f6$export$2d029a49a09b6177 = (0, $7915f523c52977a0$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $0b6c5b02e96942a7$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $035fae7c6029140d$export$b91509fcf893b648 = {
    current: undefined
};
const $035fae7c6029140d$export$b61a9eb3dbde8858 = (0, $7915f523c52977a0$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$035fae7c6029140d$export$b91509fcf893b648.current) {
            const documentNode = new (0, $0217101e31a310f6$export$2d029a49a09b6177)(0, {});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $035fae7c6029140d$export$b91509fcf893b648.current = documentNode;
        }
        return $035fae7c6029140d$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $9669961adc9d287a$var$featureBundle = {
    ...(0, $70121fc2f386f54c$export$7f9953c70dacfd7f),
    ...(0, $af896d81385bcd90$export$e5b72898e5a201f1),
    ...(0, $ad838133cd88676e$export$d7d5d435647ed5a0),
    ...(0, $30d5c0dd84e9a9e3$export$518df03f164c507)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $9669961adc9d287a$export$e25e478948902b8b = /*@__PURE__*/ (0, $2a13ec88355fa9e0$export$a28d6df673050e18)((Component, config)=>(0, $b6c1cb15331ae5f3$export$732916c0e88175fb)(Component, config, $9669961adc9d287a$var$featureBundle, (0, $73b6f3f065424c75$export$56ba0183203348f5), (0, $035fae7c6029140d$export$b61a9eb3dbde8858)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $9669961adc9d287a$export$546614c4a05701f9(key) {
    return (0, $c89a03112c1d6e5c$export$46b7e4b9dc6110c3)((0, $b6c1cb15331ae5f3$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $9669961adc9d287a$var$featureBundle, (0, $73b6f3f065424c75$export$56ba0183203348f5), (0, $035fae7c6029140d$export$b61a9eb3dbde8858)));
}



var $3QbnI = parcelRequire("3QbnI");
function $18fdfef8ab518615$export$e70e6da722faba05(u, e, c) {
    var i = this, a = (0, $3QbnI.useRef)(null), o = (0, $3QbnI.useRef)(0), f = (0, $3QbnI.useRef)(null), l = (0, $3QbnI.useRef)([]), m = (0, $3QbnI.useRef)(), v = (0, $3QbnI.useRef)(), d = (0, $3QbnI.useRef)(u), p = (0, $3QbnI.useRef)(!0);
    (0, $3QbnI.useEffect)(function() {
        d.current = u;
    }, [
        u
    ]);
    var g = !e && 0 !== e && "undefined" != typeof window;
    if ("function" != typeof u) throw new TypeError("Expected a function");
    e = +e || 0;
    var w = !!(c = c || {}).leading, s = !("trailing" in c) || !!c.trailing, x = "maxWait" in c, y = x ? Math.max(+c.maxWait || 0, e) : null;
    (0, $3QbnI.useEffect)(function() {
        return p.current = !0, function() {
            p.current = !1;
        };
    }, []);
    var h = (0, $3QbnI.useMemo)(function() {
        var r = function(r) {
            var n = l.current, t = m.current;
            return l.current = m.current = null, o.current = r, v.current = d.current.apply(t, n);
        }, n = function(r, n) {
            g && cancelAnimationFrame(f.current), f.current = g ? requestAnimationFrame(r) : setTimeout(r, n);
        }, t = function(r) {
            if (!p.current) return !1;
            var n = r - a.current;
            return !a.current || n >= e || n < 0 || x && r - o.current >= y;
        }, u = function(n) {
            return f.current = null, s && l.current ? r(n) : (l.current = m.current = null, v.current);
        }, c = function r() {
            var c = Date.now();
            if (t(c)) return u(c);
            if (p.current) {
                var i = e - (c - a.current), f = x ? Math.min(i, y - (c - o.current)) : i;
                n(r, f);
            }
        }, h = function() {
            var u = Date.now(), d = t(u);
            if (l.current = [].slice.call(arguments), m.current = i, a.current = u, d) {
                if (!f.current && p.current) return o.current = a.current, n(c, e), w ? r(a.current) : v.current;
                if (x) return n(c, e), r(a.current);
            }
            return f.current || n(c, e), v.current;
        };
        return h.cancel = function() {
            f.current && (g ? cancelAnimationFrame(f.current) : clearTimeout(f.current)), o.current = 0, l.current = a.current = m.current = f.current = null;
        }, h.isPending = function() {
            return !!f.current;
        }, h.flush = function() {
            return f.current ? u(Date.now()) : v.current;
        }, h;
    }, [
        w,
        x,
        e,
        y,
        s,
        g
    ]);
    return h;
}
function $18fdfef8ab518615$var$i(r, n) {
    return r === n;
}
function $18fdfef8ab518615$var$a(r) {
    return "function" == typeof r ? function() {
        return r;
    } : r;
}
function $18fdfef8ab518615$export$21805fee57372823(n, t, o) {
    var f, l, m = o && o.equalityFn || $18fdfef8ab518615$var$i, v = (f = (0, $3QbnI.useState)($18fdfef8ab518615$var$a(n)), l = f[1], [
        f[0],
        (0, $3QbnI.useCallback)(function(r) {
            return l($18fdfef8ab518615$var$a(r));
        }, [])
    ]), d = v[0], p = v[1], g = $18fdfef8ab518615$export$e70e6da722faba05((0, $3QbnI.useCallback)(function(r) {
        return p(r);
    }, [
        p
    ]), t, o), w = (0, $3QbnI.useRef)(n);
    return m(w.current, n) || (g(n), w.current = n), [
        d,
        g
    ];
}
function $18fdfef8ab518615$export$7158785e55df0693(r, n, t) {
    var u = void 0 === t ? {} : t, e = u.leading, i = u.trailing;
    return $18fdfef8ab518615$export$e70e6da722faba05(r, n, {
        maxWait: n,
        leading: void 0 === e || e,
        trailing: void 0 === i || i
    });
}



var $3QbnI = parcelRequire("3QbnI");
var $e7f7b1113de18964$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($e7f7b1113de18964$export$4b0075e5ea5e1f26 || {});



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
var $9a9be7499c0d7009$var$i = Object.defineProperty;
var $9a9be7499c0d7009$var$d = (t, e, n)=>e in t ? $9a9be7499c0d7009$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $9a9be7499c0d7009$var$r = (t, e, n)=>($9a9be7499c0d7009$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $9a9be7499c0d7009$var$o {
    constructor(){
        $9a9be7499c0d7009$var$r(this, "current", this.detect());
        $9a9be7499c0d7009$var$r(this, "handoffState", "pending");
        $9a9be7499c0d7009$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $9a9be7499c0d7009$export$a7b6bc01c63cdfc3 = new $9a9be7499c0d7009$var$o;


let $4f845bb0423860c5$export$ce5ed857c741fd71 = (e, f)=>{
    (0, $9a9be7499c0d7009$export$a7b6bc01c63cdfc3).isServer ? (0, $3QbnI.useEffect)(e, f) : (0, $3QbnI.useLayoutEffect)(e, f);
};


function $62f55b25b9f4337e$export$86c4283a11f23f95(e) {
    let r = (0, $3QbnI.useRef)(e);
    return (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}


let $2dcba26290db42cf$export$90fc3a17d93f704c = function(t) {
    let e = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};



var $3QbnI = parcelRequire("3QbnI");



var $3QbnI = parcelRequire("3QbnI");

function $84e12220f2f730c7$var$s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in $3QbnI ? ((o)=>o.useSyncExternalStore)($3QbnI)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function $84e12220f2f730c7$export$44ab2b9f2d09b0fa() {
    let r = $84e12220f2f730c7$var$s(), [e, n] = $3QbnI.useState((0, $9a9be7499c0d7009$export$a7b6bc01c63cdfc3).isHandoffComplete);
    return e && (0, $9a9be7499c0d7009$export$a7b6bc01c63cdfc3).isHandoffComplete === !1 && n(!1), $3QbnI.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), $3QbnI.useEffect(()=>(0, $9a9be7499c0d7009$export$a7b6bc01c63cdfc3).handoff(), []), r ? !1 : e;
}


var $32e547b031070140$var$o;
let $32e547b031070140$export$f680877a34711e37 = ($32e547b031070140$var$o = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useId) != null ? $32e547b031070140$var$o : function() {
    let n = (0, $84e12220f2f730c7$export$44ab2b9f2d09b0fa)(), [e, u] = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useState(n ? ()=>(0, $9a9be7499c0d7009$export$a7b6bc01c63cdfc3).nextId() : null);
    return (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        e === null && u((0, $9a9be7499c0d7009$export$a7b6bc01c63cdfc3).nextId());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};





var $3QbnI = parcelRequire("3QbnI");

function $63b58a1e835cc3d1$var$i(t) {
    var n;
    if (t.type) return t.type;
    let e = (n = t.as) != null ? n : "button";
    if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function $63b58a1e835cc3d1$export$53652b2b272efe9c(t, e) {
    let [n, u] = (0, $3QbnI.useState)(()=>$63b58a1e835cc3d1$var$i(t));
    return (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        u($63b58a1e835cc3d1$var$i(t));
    }, [
        t.type,
        t.as
    ]), (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        n || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && u("button");
    }, [
        n,
        e
    ]), n;
}



var $3QbnI = parcelRequire("3QbnI");

let $2965c2f720720e02$var$u = Symbol();
function $2965c2f720720e02$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$2965c2f720720e02$var$u]: n
    });
}
function $2965c2f720720e02$export$f6a25a78204acc7e(...t) {
    let n = (0, $3QbnI.useRef)(t);
    (0, $3QbnI.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$2965c2f720720e02$var$u])) ? void 0 : c;
}



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

function $83975537d9d245c1$export$80c2a3957bcb42ea() {
    let e = (0, $3QbnI.useRef)(!1);
    return (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}



var $3QbnI = parcelRequire("3QbnI");
function $28bce3ff3bb4c0f2$export$ce4ab0c55987d1ff(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}


function $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d), t;
}


var $efef981be50c1ac4$export$617d79dae526d2cf = ((n)=>(n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n))($efef981be50c1ac4$export$617d79dae526d2cf || {}), $efef981be50c1ac4$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($efef981be50c1ac4$export$80c0a745e59f7989 || {});
function $efef981be50c1ac4$export$b3890eb0ae9dca99({ ourProps: r, theirProps: t, slot: e, defaultTag: n, features: o, visible: a = !0, name: f, mergeRefs: l }) {
    l = l != null ? l : $efef981be50c1ac4$var$k;
    let s = $efef981be50c1ac4$var$R(t, r);
    if (a) return $efef981be50c1ac4$var$m(s, e, n, f, l);
    let y = o != null ? o : 0;
    if (y & 2) {
        let { static: u = !1, ...d } = s;
        if (u) return $efef981be50c1ac4$var$m(d, e, n, f, l);
    }
    if (y & 1) {
        let { unmount: u = !0, ...d } = s;
        return (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(u ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $efef981be50c1ac4$var$m({
                    ...d,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, n, f, l);
            }
        });
    }
    return $efef981be50c1ac4$var$m(s, e, n, f, l);
}
function $efef981be50c1ac4$var$m(r, t = {}, e, n, o) {
    let { as: a = e, children: f, refName: l = "ref", ...s } = $efef981be50c1ac4$var$F(r, [
        "unmount",
        "static"
    ]), y = r.ref !== void 0 ? {
        [l]: r.ref
    } : {}, u = typeof f == "function" ? f(t) : f;
    "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(t));
    let d = {};
    if (t) {
        let i = !1, c = [];
        for (let [T, p] of Object.entries(t))typeof p == "boolean" && (i = !0), p === !0 && c.push(T);
        i && (d["data-headlessui-state"] = c.join(" "));
    }
    if (a === (0, $3QbnI.Fragment) && Object.keys($efef981be50c1ac4$export$8e16b83750b44988(s)).length > 0) {
        if (!(0, $3QbnI.isValidElement)(u) || Array.isArray(u) && u.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${n} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(s).map((p)=>`  - ${p}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((p)=>`  - ${p}`).join(`
`)
        ].join(`
`));
        let i = u.props, c = typeof (i == null ? void 0 : i.className) == "function" ? (...p)=>(0, $28bce3ff3bb4c0f2$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className(...p), s.className) : (0, $28bce3ff3bb4c0f2$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className, s.className), T = c ? {
            className: c
        } : {};
        return (0, $3QbnI.cloneElement)(u, Object.assign({}, $efef981be50c1ac4$var$R(u.props, $efef981be50c1ac4$export$8e16b83750b44988($efef981be50c1ac4$var$F(s, [
            "ref"
        ]))), d, y, {
            ref: o(u.ref, y.ref)
        }, T));
    }
    return (0, $3QbnI.createElement)(a, Object.assign({}, $efef981be50c1ac4$var$F(s, [
        "ref"
    ]), a !== (0, $3QbnI.Fragment) && y, a !== (0, $3QbnI.Fragment) && d), u);
}
function $efef981be50c1ac4$export$81218df071161f0a() {
    let r = (0, $3QbnI.useRef)([]), t = (0, $3QbnI.useCallback)((e)=>{
        for (let n of r.current)n != null && (typeof n == "function" ? n(e) : n.current = e);
    }, []);
    return (...e)=>{
        if (!e.every((n)=>n == null)) return r.current = e, t;
    };
}
function $efef981be50c1ac4$var$k(...r) {
    return r.every((t)=>t == null) ? void 0 : (t)=>{
        for (let e of r)e != null && (typeof e == "function" ? e(t) : e.current = t);
    };
}
function $efef981be50c1ac4$var$R(...r) {
    var n;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let o of r)for(let a in o)a.startsWith("on") && typeof o[a] == "function" ? ((n = e[a]) != null || (e[a] = []), e[a].push(o[a])) : t[a] = o[a];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((o)=>[
            o,
            void 0
        ])));
    for(let o in e)Object.assign(t, {
        [o] (a, ...f) {
            let l = e[o];
            for (let s of l){
                if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented) return;
                s(a, ...f);
            }
        }
    });
    return t;
}
function $efef981be50c1ac4$export$e43f39796049410c(r) {
    var t;
    return Object.assign((0, $3QbnI.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function $efef981be50c1ac4$export$8e16b83750b44988(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function $efef981be50c1ac4$var$F(r, t = []) {
    let e = Object.assign({}, r);
    for (let n of t)n in e && delete e[n];
    return e;
}


let $70ad89c09b766687$var$p = "div";
var $70ad89c09b766687$export$617d79dae526d2cf = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($70ad89c09b766687$export$617d79dae526d2cf || {});
function $70ad89c09b766687$var$l(d, o) {
    var n;
    let { features: t = 1, ...e } = d, r = {
        ref: o,
        "aria-hidden": (t & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
        hidden: (t & 4) === 4 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(t & 4) === 4 && (t & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: r,
        theirProps: e,
        slot: {},
        defaultTag: $70ad89c09b766687$var$p,
        name: "Hidden"
    });
}
let $70ad89c09b766687$export$8dc98ba7eadeaa56 = (0, $efef981be50c1ac4$export$e43f39796049410c)($70ad89c09b766687$var$l);


function $180295f1fb00a82a$export$d700fc5421f49f8f({ onFocus: n }) {
    let [r, o] = (0, $3QbnI.useState)(!0), u = (0, $83975537d9d245c1$export$80c2a3957bcb42ea)();
    return r ? (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $70ad89c09b766687$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        features: (0, $70ad89c09b766687$export$617d79dae526d2cf).Focusable,
        onFocus: (a)=>{
            a.preventDefault();
            let e, i = 50;
            function t() {
                if (i-- <= 0) {
                    e && cancelAnimationFrame(e);
                    return;
                }
                if (n()) {
                    if (cancelAnimationFrame(e), !u.current) return;
                    o(!1);
                    return;
                }
                e = requestAnimationFrame(t);
            }
            e = requestAnimationFrame(t);
        }
    }) : null;
}



function $f0108a5abfaa286e$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}


function $7b478da02baf897f$export$12b26c28a05aa001() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $f0108a5abfaa286e$export$a5ff0d6a738703ca)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = $7b478da02baf897f$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}




function $a37d5afd1ae25fcd$export$b204af158042fbac(r) {
    return (0, $9a9be7499c0d7009$export$a7b6bc01c63cdfc3).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}


let $6e492986e168be71$var$c = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $6e492986e168be71$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))($6e492986e168be71$export$807a7eae502106e7 || {}), $6e492986e168be71$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($6e492986e168be71$export$abf286375dfa6dbd || {}), $6e492986e168be71$var$F = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($6e492986e168be71$var$F || {});
function $6e492986e168be71$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($6e492986e168be71$var$c)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $6e492986e168be71$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($6e492986e168be71$export$27112a34f2f8402d || {});
function $6e492986e168be71$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $a37d5afd1ae25fcd$export$b204af158042fbac)(e)) == null ? void 0 : t.body) ? !1 : (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(r, {
        [0] () {
            return e.matches($6e492986e168be71$var$c);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($6e492986e168be71$var$c)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $6e492986e168be71$export$46388676ec35ab85(e) {
    let r = (0, $a37d5afd1ae25fcd$export$b204af158042fbac)(e);
    (0, $7b478da02baf897f$export$12b26c28a05aa001)().nextFrame(()=>{
        r && !$6e492986e168be71$export$ff1ec1c740b3c8d5(r.activeElement, 0) && $6e492986e168be71$export$5fed9cc43865dc7e(e);
    });
}
var $6e492986e168be71$var$w = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($6e492986e168be71$var$w || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $6e492986e168be71$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $6e492986e168be71$var$S = [
    "textarea",
    "input"
].join(",");
function $6e492986e168be71$var$H(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $6e492986e168be71$var$S)) != null ? t : !1;
}
function $6e492986e168be71$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let o = r(t), i = r(l);
        if (o === null || i === null) return 0;
        let n = o.compareDocumentPosition(i);
        return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $6e492986e168be71$export$7fb6c844b485e870(e, r) {
    return $6e492986e168be71$export$82e1f4f412218a1d($6e492986e168be71$export$433aaa1f216cf32d(), r, {
        relativeTo: e
    });
}
function $6e492986e168be71$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
    let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, n = Array.isArray(e) ? t ? $6e492986e168be71$export$20305e96f91bf103(e) : e : $6e492986e168be71$export$433aaa1f216cf32d(e);
    o.length > 0 && n.length > 1 && (n = n.filter((s)=>!o.includes(s))), l = l != null ? l : i.activeElement;
    let E = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, n.indexOf(l)) - 1;
        if (r & 4) return Math.max(0, n.indexOf(l)) + 1;
        if (r & 8) return n.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), p = r & 32 ? {
        preventScroll: !0
    } : {}, d = 0, a = n.length, u;
    do {
        if (d >= a || d + a <= 0) return 0;
        let s = x + d;
        if (r & 16) s = (s + a) % a;
        else {
            if (s < 0) return 3;
            if (s >= a) return 1;
        }
        u = n[s], u == null || u.focus(p), d += E;
    }while (u !== i.activeElement);
    return r & 6 && $6e492986e168be71$var$H(u) && u.select(), 2;
}







var $3QbnI = parcelRequire("3QbnI");
const $da0e89f94852bf19$var$s = $3QbnI.createContext(null);
function $da0e89f94852bf19$var$a() {
    return {
        groups: new Map,
        get (n, t) {
            var c;
            let e = this.groups.get(n);
            e || (e = new Map, this.groups.set(n, e));
            let l = (c = e.get(t)) != null ? c : 0;
            e.set(t, l + 1);
            let o = Array.from(e.keys()).indexOf(t);
            function i() {
                let u = e.get(t);
                u > 1 ? e.set(t, u - 1) : e.delete(t);
            }
            return [
                o,
                i
            ];
        }
    };
}
function $da0e89f94852bf19$export$a9f7b2abf715ece3({ children: n }) {
    let t = $3QbnI.useRef($da0e89f94852bf19$var$a());
    return $3QbnI.createElement($da0e89f94852bf19$var$s.Provider, {
        value: t
    }, n);
}
function $da0e89f94852bf19$export$4fba99d3e9fca1f0(n) {
    let t = $3QbnI.useContext($da0e89f94852bf19$var$s);
    if (!t) throw new Error("You must wrap your component in a <StableCollection>");
    let e = $da0e89f94852bf19$var$f(), [l, o] = t.current.get(n, e);
    return $3QbnI.useEffect(()=>o, []), l;
}
function $da0e89f94852bf19$var$f() {
    var l, o, i;
    let n = (i = (o = (l = $3QbnI.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) == null ? void 0 : l.ReactCurrentOwner) == null ? void 0 : o.current) != null ? i : null;
    if (!n) return Symbol();
    let t = [], e = n;
    for(; e;)t.push(e.index), e = e.return;
    return "$." + t.join(".");
}


var $9866671cff29bede$var$ue = ((t)=>(t[t.Forwards = 0] = "Forwards", t[t.Backwards = 1] = "Backwards", t))($9866671cff29bede$var$ue || {}), $9866671cff29bede$var$Te = ((l)=>(l[l.Less = -1] = "Less", l[l.Equal = 0] = "Equal", l[l.Greater = 1] = "Greater", l))($9866671cff29bede$var$Te || {}), $9866671cff29bede$var$de = ((a)=>(a[a.SetSelectedIndex = 0] = "SetSelectedIndex", a[a.RegisterTab = 1] = "RegisterTab", a[a.UnregisterTab = 2] = "UnregisterTab", a[a.RegisterPanel = 3] = "RegisterPanel", a[a.UnregisterPanel = 4] = "UnregisterPanel", a))($9866671cff29bede$var$de || {});
let $9866671cff29bede$var$ce = {
    [0] (e, n) {
        var i;
        let t = (0, $6e492986e168be71$export$20305e96f91bf103)(e.tabs, (c)=>c.current), l = (0, $6e492986e168be71$export$20305e96f91bf103)(e.panels, (c)=>c.current), o = t.filter((c)=>{
            var p;
            return !((p = c.current) != null && p.hasAttribute("disabled"));
        }), a = {
            ...e,
            tabs: t,
            panels: l
        };
        if (n.index < 0 || n.index > t.length - 1) {
            let c = (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(Math.sign(n.index - e.selectedIndex), {
                [-1]: ()=>1,
                [0]: ()=>(0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(Math.sign(n.index), {
                        [-1]: ()=>0,
                        [0]: ()=>0,
                        [1]: ()=>1
                    }),
                [1]: ()=>0
            });
            if (o.length === 0) return a;
            let p = (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(c, {
                [0]: ()=>t.indexOf(o[0]),
                [1]: ()=>t.indexOf(o[o.length - 1])
            });
            return {
                ...a,
                selectedIndex: p === -1 ? e.selectedIndex : p
            };
        }
        let T = t.slice(0, n.index), m = [
            ...t.slice(n.index),
            ...T
        ].find((c)=>o.includes(c));
        if (!m) return a;
        let b = (i = t.indexOf(m)) != null ? i : e.selectedIndex;
        return b === -1 && (b = e.selectedIndex), {
            ...a,
            selectedIndex: b
        };
    },
    [1] (e, n) {
        if (e.tabs.includes(n.tab)) return e;
        let t = e.tabs[e.selectedIndex], l = (0, $6e492986e168be71$export$20305e96f91bf103)([
            ...e.tabs,
            n.tab
        ], (a)=>a.current), o = e.selectedIndex;
        return e.info.current.isControlled || (o = l.indexOf(t), o === -1 && (o = e.selectedIndex)), {
            ...e,
            tabs: l,
            selectedIndex: o
        };
    },
    [2] (e, n) {
        return {
            ...e,
            tabs: e.tabs.filter((t)=>t !== n.tab)
        };
    },
    [3] (e, n) {
        return e.panels.includes(n.panel) ? e : {
            ...e,
            panels: (0, $6e492986e168be71$export$20305e96f91bf103)([
                ...e.panels,
                n.panel
            ], (t)=>t.current)
        };
    },
    [4] (e, n) {
        return {
            ...e,
            panels: e.panels.filter((t)=>t !== n.panel)
        };
    }
}, $9866671cff29bede$var$X = (0, $3QbnI.createContext)(null);
$9866671cff29bede$var$X.displayName = "TabsDataContext";
function $9866671cff29bede$var$F(e) {
    let n = (0, $3QbnI.useContext)($9866671cff29bede$var$X);
    if (n === null) {
        let t = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $9866671cff29bede$var$F), t;
    }
    return n;
}
let $9866671cff29bede$var$$ = (0, $3QbnI.createContext)(null);
$9866671cff29bede$var$$.displayName = "TabsActionsContext";
function $9866671cff29bede$var$q(e) {
    let n = (0, $3QbnI.useContext)($9866671cff29bede$var$$);
    if (n === null) {
        let t = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $9866671cff29bede$var$q), t;
    }
    return n;
}
function $9866671cff29bede$var$fe(e, n) {
    return (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(n.type, $9866671cff29bede$var$ce, e, n);
}
let $9866671cff29bede$var$be = (0, $3QbnI.Fragment);
function $9866671cff29bede$var$me(e, n) {
    let { defaultIndex: t = 0, vertical: l = !1, manual: o = !1, onChange: a, selectedIndex: T = null, ...R } = e;
    const m = l ? "vertical" : "horizontal", b = o ? "manual" : "auto";
    let i = T !== null, c = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)({
        isControlled: i
    }), p = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(n), [u, f] = (0, $3QbnI.useReducer)($9866671cff29bede$var$fe, {
        info: c,
        selectedIndex: T != null ? T : t,
        tabs: [],
        panels: []
    }), P = (0, $3QbnI.useMemo)(()=>({
            selectedIndex: u.selectedIndex
        }), [
        u.selectedIndex
    ]), g = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)(a || (()=>{})), E = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)(u.tabs), L = (0, $3QbnI.useMemo)(()=>({
            orientation: m,
            activation: b,
            ...u
        }), [
        m,
        b,
        u
    ]), A = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((s)=>(f({
            type: 1,
            tab: s
        }), ()=>f({
                type: 2,
                tab: s
            }))), S = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((s)=>(f({
            type: 3,
            panel: s
        }), ()=>f({
                type: 4,
                panel: s
            }))), k = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((s)=>{
        h.current !== s && g.current(s), i || f({
            type: 0,
            index: s
        });
    }), h = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)(i ? e.selectedIndex : u.selectedIndex), W = (0, $3QbnI.useMemo)(()=>({
            registerTab: A,
            registerPanel: S,
            change: k
        }), []);
    (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        f({
            type: 0,
            index: T != null ? T : t
        });
    }, [
        T
    ]), (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        if (h.current === void 0 || u.tabs.length <= 0) return;
        let s = (0, $6e492986e168be71$export$20305e96f91bf103)(u.tabs, (d)=>d.current);
        s.some((d, M)=>u.tabs[M] !== d) && k(s.indexOf(u.tabs[h.current]));
    });
    let O = {
        ref: p
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $da0e89f94852bf19$export$a9f7b2abf715ece3), null, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($9866671cff29bede$var$$.Provider, {
        value: W
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($9866671cff29bede$var$X.Provider, {
        value: L
    }, L.tabs.length <= 0 && (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $180295f1fb00a82a$export$d700fc5421f49f8f), {
        onFocus: ()=>{
            var s, r;
            for (let d of E.current)if (((s = d.current) == null ? void 0 : s.tabIndex) === 0) return (r = d.current) == null || r.focus(), !0;
            return !1;
        }
    }), (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: O,
        theirProps: R,
        slot: P,
        defaultTag: $9866671cff29bede$var$be,
        name: "Tabs"
    }))));
}
let $9866671cff29bede$var$Pe = "div";
function $9866671cff29bede$var$ye(e, n) {
    let { orientation: t, selectedIndex: l } = $9866671cff29bede$var$F("Tab.List"), o = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(n);
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: o,
            role: "tablist",
            "aria-orientation": t
        },
        theirProps: e,
        slot: {
            selectedIndex: l
        },
        defaultTag: $9866671cff29bede$var$Pe,
        name: "Tabs.List"
    });
}
let $9866671cff29bede$var$xe = "button";
function $9866671cff29bede$var$ge(e, n) {
    var O, s;
    let t = (0, $32e547b031070140$export$f680877a34711e37)(), { id: l = `headlessui-tabs-tab-${t}`, ...o } = e, { orientation: a, activation: T, selectedIndex: R, tabs: m, panels: b } = $9866671cff29bede$var$F("Tab"), i = $9866671cff29bede$var$q("Tab"), c = $9866671cff29bede$var$F("Tab"), p = (0, $3QbnI.useRef)(null), u = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(p, n);
    (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>i.registerTab(p), [
        i,
        p
    ]);
    let f = (0, $da0e89f94852bf19$export$4fba99d3e9fca1f0)("tabs"), P = m.indexOf(p);
    P === -1 && (P = f);
    let g = P === R, E = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((r)=>{
        var M;
        let d = r();
        if (d === (0, $6e492986e168be71$export$abf286375dfa6dbd).Success && T === "auto") {
            let K = (M = (0, $a37d5afd1ae25fcd$export$b204af158042fbac)(p)) == null ? void 0 : M.activeElement, z = c.tabs.findIndex((te)=>te.current === K);
            z !== -1 && i.change(z);
        }
        return d;
    }), L = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((r)=>{
        let d = m.map((K)=>K.current).filter(Boolean);
        if (r.key === (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space || r.key === (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Enter) {
            r.preventDefault(), r.stopPropagation(), i.change(P);
            return;
        }
        switch(r.key){
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Home:
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).PageUp:
                return r.preventDefault(), r.stopPropagation(), E(()=>(0, $6e492986e168be71$export$82e1f4f412218a1d)(d, (0, $6e492986e168be71$export$807a7eae502106e7).First));
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).End:
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).PageDown:
                return r.preventDefault(), r.stopPropagation(), E(()=>(0, $6e492986e168be71$export$82e1f4f412218a1d)(d, (0, $6e492986e168be71$export$807a7eae502106e7).Last));
        }
        if (E(()=>(0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(a, {
                vertical () {
                    return r.key === (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).ArrowUp ? (0, $6e492986e168be71$export$82e1f4f412218a1d)(d, (0, $6e492986e168be71$export$807a7eae502106e7).Previous | (0, $6e492986e168be71$export$807a7eae502106e7).WrapAround) : r.key === (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).ArrowDown ? (0, $6e492986e168be71$export$82e1f4f412218a1d)(d, (0, $6e492986e168be71$export$807a7eae502106e7).Next | (0, $6e492986e168be71$export$807a7eae502106e7).WrapAround) : (0, $6e492986e168be71$export$abf286375dfa6dbd).Error;
                },
                horizontal () {
                    return r.key === (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).ArrowLeft ? (0, $6e492986e168be71$export$82e1f4f412218a1d)(d, (0, $6e492986e168be71$export$807a7eae502106e7).Previous | (0, $6e492986e168be71$export$807a7eae502106e7).WrapAround) : r.key === (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).ArrowRight ? (0, $6e492986e168be71$export$82e1f4f412218a1d)(d, (0, $6e492986e168be71$export$807a7eae502106e7).Next | (0, $6e492986e168be71$export$807a7eae502106e7).WrapAround) : (0, $6e492986e168be71$export$abf286375dfa6dbd).Error;
                }
            })) === (0, $6e492986e168be71$export$abf286375dfa6dbd).Success) return r.preventDefault();
    }), A = (0, $3QbnI.useRef)(!1), S = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        var r;
        A.current || (A.current = !0, (r = p.current) == null || r.focus({
            preventScroll: !0
        }), i.change(P), (0, $f0108a5abfaa286e$export$a5ff0d6a738703ca)(()=>{
            A.current = !1;
        }));
    }), k = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((r)=>{
        r.preventDefault();
    }), h = (0, $3QbnI.useMemo)(()=>{
        var r;
        return {
            selected: g,
            disabled: (r = e.disabled) != null ? r : !1
        };
    }, [
        g,
        e.disabled
    ]), W = {
        ref: u,
        onKeyDown: L,
        onMouseDown: k,
        onClick: S,
        id: l,
        role: "tab",
        type: (0, $63b58a1e835cc3d1$export$53652b2b272efe9c)(e, p),
        "aria-controls": (s = (O = b[P]) == null ? void 0 : O.current) == null ? void 0 : s.id,
        "aria-selected": g,
        tabIndex: g ? 0 : -1
    };
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: W,
        theirProps: o,
        slot: h,
        defaultTag: $9866671cff29bede$var$xe,
        name: "Tabs.Tab"
    });
}
let $9866671cff29bede$var$Ee = "div";
function $9866671cff29bede$var$Ae(e, n) {
    let { selectedIndex: t } = $9866671cff29bede$var$F("Tab.Panels"), l = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(n), o = (0, $3QbnI.useMemo)(()=>({
            selectedIndex: t
        }), [
        t
    ]);
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: l
        },
        theirProps: e,
        slot: o,
        defaultTag: $9866671cff29bede$var$Ee,
        name: "Tabs.Panels"
    });
}
let $9866671cff29bede$var$Re = "div", $9866671cff29bede$var$Le = (0, $efef981be50c1ac4$export$617d79dae526d2cf).RenderStrategy | (0, $efef981be50c1ac4$export$617d79dae526d2cf).Static;
function $9866671cff29bede$var$_e(e, n) {
    var E, L, A, S;
    let t = (0, $32e547b031070140$export$f680877a34711e37)(), { id: l = `headlessui-tabs-panel-${t}`, tabIndex: o = 0, ...a } = e, { selectedIndex: T, tabs: R, panels: m } = $9866671cff29bede$var$F("Tab.Panel"), b = $9866671cff29bede$var$q("Tab.Panel"), i = (0, $3QbnI.useRef)(null), c = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(i, n);
    (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>b.registerPanel(i), [
        b,
        i,
        l
    ]);
    let p = (0, $da0e89f94852bf19$export$4fba99d3e9fca1f0)("panels"), u = m.indexOf(i);
    u === -1 && (u = p);
    let f = u === T, P = (0, $3QbnI.useMemo)(()=>({
            selected: f
        }), [
        f
    ]), g = {
        ref: c,
        id: l,
        role: "tabpanel",
        "aria-labelledby": (L = (E = R[u]) == null ? void 0 : E.current) == null ? void 0 : L.id,
        tabIndex: f ? o : -1
    };
    return !f && ((A = a.unmount) == null || A) && !((S = a.static) != null && S) ? (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $70ad89c09b766687$export$8dc98ba7eadeaa56), {
        as: "span",
        "aria-hidden": "true",
        ...g
    }) : (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: g,
        theirProps: a,
        slot: P,
        defaultTag: $9866671cff29bede$var$Re,
        features: $9866671cff29bede$var$Le,
        visible: f,
        name: "Tabs.Panel"
    });
}
let $9866671cff29bede$var$Se = (0, $efef981be50c1ac4$export$e43f39796049410c)($9866671cff29bede$var$ge), $9866671cff29bede$var$Ie = (0, $efef981be50c1ac4$export$e43f39796049410c)($9866671cff29bede$var$me), $9866671cff29bede$var$De = (0, $efef981be50c1ac4$export$e43f39796049410c)($9866671cff29bede$var$ye), $9866671cff29bede$var$Fe = (0, $efef981be50c1ac4$export$e43f39796049410c)($9866671cff29bede$var$Ae), $9866671cff29bede$var$he = (0, $efef981be50c1ac4$export$e43f39796049410c)($9866671cff29bede$var$_e), $9866671cff29bede$export$3e41faf802a29e71 = Object.assign($9866671cff29bede$var$Se, {
    Group: $9866671cff29bede$var$Ie,
    List: $9866671cff29bede$var$De,
    Panels: $9866671cff29bede$var$Fe,
    Panel: $9866671cff29bede$var$he
});




var $3QbnI = parcelRequire("3QbnI");
const $82f38027744693b3$var$usePrevious = (value)=>{
    let ref = (0, $3QbnI.useRef)();
    (0, $3QbnI.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
var $82f38027744693b3$export$2e2bcd8739ae039 = $82f38027744693b3$var$usePrevious;





var $3QbnI = parcelRequire("3QbnI");
const $906670345aa34efb$var$CircleBackground = ({ color: color, width: width = 558, height: height = 558, ...props })=>{
    let id = (0, $3QbnI.useId)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
        viewBox: "0 0 558 558",
        width: width,
        height: height,
        fill: "none",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("linearGradient", {
                    id: id,
                    x1: "79",
                    y1: "16",
                    x2: "105",
                    y2: "237",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("stop", {
                            stopColor: color
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("stop", {
                            offset: "1",
                            stopColor: color,
                            stopOpacity: "0"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                opacity: ".2",
                d: "M1 279C1 125.465 125.465 1 279 1s278 124.465 278 278-124.465 278-278 278S1 432.535 1 279Z",
                stroke: color
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                d: "M1 279C1 125.465 125.465 1 279 1",
                stroke: `url(#${id})`,
                strokeLinecap: "round"
            })
        ]
    });
};
var $906670345aa34efb$export$2e2bcd8739ae039 = $906670345aa34efb$var$CircleBackground;




const $d93e3a476e11113d$var$SmartphoneShoppingBagIcon = (props)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
        viewBox: "0 0 32 32",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "#A3A3A3",
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 0a4 4 0 00-4 4v24a4 4 0 004 4h14a4 4 0 004-4V4a4 4 0 00-4-4H9zm0 2a2 2 0 00-2 2v24a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9z",
                fill: "#A3A3A3"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                strokeWidth: "1.5",
                width: "16",
                height: "16",
                x: "8",
                y: "8",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                    fill: "#737373",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
                })
            })
        ]
    });
var $d93e3a476e11113d$export$2e2bcd8739ae039 = $d93e3a476e11113d$var$SmartphoneShoppingBagIcon;




var $3QbnI = parcelRequire("3QbnI");
const $15608dc961a1f1b1$var$SmartphoneStepListIcon = (props)=>{
    let id = (0, $3QbnI.useId)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
        viewBox: "0 0 32 32",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 0a4 4 0 00-4 4v24a4 4 0 004 4h14a4 4 0 004-4V4a4 4 0 00-4-4H9zm0 2a2 2 0 00-2 2v24a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9z",
                fill: "#A3A3A3"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 13a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H10a1 1 0 01-1-1v-2zm0 6a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H10a1 1 0 01-1-1v-2zm1 5a1 1 0 00-1 1v2a1 1 0 001 1h12a1 1 0 001-1v-2a1 1 0 00-1-1H10z",
                fill: `url(#${id}-gradient)`
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("rect", {
                x: 9,
                y: 6,
                width: 14,
                height: 4,
                rx: 1,
                fill: "#171717"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "#A3A3A3",
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("linearGradient", {
                    id: `${id}-gradient`,
                    x1: 16,
                    y1: 12,
                    x2: 16,
                    y2: 28,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("stop", {
                            stopColor: "#737373"
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("stop", {
                            offset: 1,
                            stopColor: "#737373",
                            stopOpacity: 0
                        })
                    ]
                })
            })
        ]
    });
};
var $15608dc961a1f1b1$export$2e2bcd8739ae039 = $15608dc961a1f1b1$var$SmartphoneStepListIcon;



const $8598ff8440347b35$var$SmartphoneImportIcon = (props)=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
        viewBox: "0 0 32 32",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "#A3A3A3",
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 4a4 4 0 014-4h14a4 4 0 014 4v10h-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9a2 2 0 00-2 2v24a2 2 0 002 2h5v2H9a4 4 0 01-4-4V4z",
                fill: "#A3A3A3"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                d: "M12 25l8-8m0 0h-6m6 0v6",
                stroke: "#737373",
                strokeWidth: 2,
                strokeLinecap: "round",
                transform: "rotate(-180, 16, 22) translate(-12, -5) scale(1.3)"
            })
        ]
    });
};
var $8598ff8440347b35$export$2e2bcd8739ae039 = $8598ff8440347b35$var$SmartphoneImportIcon;


var $19767e655742d6ff$exports = {};
$19767e655742d6ff$exports = new URL("import.3c8459d8.png", import.meta.url).toString();


var $de0ee853de07b113$exports = {};
$de0ee853de07b113$exports = new URL("shoppingList.3e3fef12.png", import.meta.url).toString();


var $e783119fcbd1b8fe$exports = {};
$e783119fcbd1b8fe$exports = new URL("steps.8557b918.png", import.meta.url).toString();


// resolution 390x844
const $fb473ce75746215d$var$Screen = (image, alt)=>()=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("img", {
            className: "absolute inset-0",
            src: image,
            alt: alt
        });
const $fb473ce75746215d$var$features = [
    {
        name: "Import your recipes in one click",
        description: "Just copy-paste the website url of your favorite recipe and all the details are automatically imported in CookBook.",
        icon: (0, $8598ff8440347b35$export$2e2bcd8739ae039),
        screen: $fb473ce75746215d$var$Screen((0, (/*@__PURE__*/$parcel$interopDefault($19767e655742d6ff$exports))), "Import")
    },
    {
        name: "Create grocery shopping list in a blink",
        description: "The ingredients list of your recipe is added to your favorite todo app in 3 clicks",
        icon: (0, $d93e3a476e11113d$export$2e2bcd8739ae039),
        screen: $fb473ce75746215d$var$Screen((0, (/*@__PURE__*/$parcel$interopDefault($de0ee853de07b113$exports))), "Shopping list")
    },
    {
        name: "Follow the steps without back and forth",
        description: "Each step automatically reminds",
        icon: (0, $15608dc961a1f1b1$export$2e2bcd8739ae039),
        screen: $fb473ce75746215d$var$Screen((0, (/*@__PURE__*/$parcel$interopDefault($e783119fcbd1b8fe$exports))), "Steps")
    }
];
var $fb473ce75746215d$export$2e2bcd8739ae039 = $fb473ce75746215d$var$features;


const $b42d3fdbd1a37013$var$FeaturesDesktop = ()=>{
    let [changeCount, setChangeCount] = (0, $3QbnI.useState)(0);
    let [selectedIndex, setSelectedIndex] = (0, $3QbnI.useState)(0);
    let prevIndex = (0, $82f38027744693b3$export$2e2bcd8739ae039)(selectedIndex);
    let isForwards = prevIndex === undefined ? true : selectedIndex > prevIndex;
    let onChange = (0, $18fdfef8ab518615$export$e70e6da722faba05)((selectedIndex)=>{
        setSelectedIndex(selectedIndex);
        setChangeCount((changeCount)=>changeCount + 1);
    }, 100, {
        leading: true
    });
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("marketing");
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $9866671cff29bede$export$3e41faf802a29e71).Group, {
        as: "div",
        className: "grid grid-cols-12 items-center gap-8 lg:gap-16 xl:gap-24",
        selectedIndex: selectedIndex,
        onChange: onChange,
        vertical: true,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $9866671cff29bede$export$3e41faf802a29e71).List, {
                className: "relative z-10 order-last col-span-6 space-y-6",
                children: (0, $fb473ce75746215d$export$2e2bcd8739ae039).map((feature, featureIndex)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "relative rounded-2xl transition-colors hover:bg-gray-800/40",
                        children: [
                            featureIndex === selectedIndex && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $9669961adc9d287a$export$e25e478948902b8b).div, {
                                layoutId: "activeBackground",
                                className: "absolute inset-0 bg-gray-800/70",
                                initial: {
                                    borderRadius: 16
                                }
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                className: "relative z-10 p-8",
                                children: [
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(feature.icon, {
                                        className: "h-8 w-8"
                                    }),
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h3", {
                                        className: "mt-8 text-lg font-semibold text-white",
                                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $9866671cff29bede$export$3e41faf802a29e71), {
                                            className: "text-left outline-none",
                                            children: [
                                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                                    className: "absolute inset-0 rounded-2xl"
                                                }),
                                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {
                                                    children: t(feature.name)
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                                        className: "mt-2 text-sm text-gray-400",
                                        children: t(feature.description)
                                    })
                                ]
                            })
                        ]
                    }, feature.name))
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                className: "relative col-span-6",
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                        className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $906670345aa34efb$export$2e2bcd8739ae039), {
                            color: "white",
                            className: "animate-spin-slower"
                        })
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4eb5d0d997114485$export$2e2bcd8739ae039), {
                        className: "z-10 mx-auto w-full max-w-[366px]",
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $9866671cff29bede$export$3e41faf802a29e71).Panels, {
                            as: (0, $3QbnI.Fragment),
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $6a867d50f3c49424$export$3ae376d12526dd6f), {
                                initial: false,
                                custom: {
                                    isForwards: isForwards,
                                    changeCount: changeCount
                                },
                                children: (0, $fb473ce75746215d$export$2e2bcd8739ae039).map((feature, featureIndex)=>selectedIndex === featureIndex ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $9866671cff29bede$export$3e41faf802a29e71).Panel, {
                                        static: true,
                                        className: "col-start-1 row-start-1 flex focus:outline-offset-[32px] [&:not(:focus-visible)]:focus:outline-none",
                                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(feature.screen, {})
                                    }, feature.name + changeCount) : null)
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $b42d3fdbd1a37013$export$2e2bcd8739ae039 = $b42d3fdbd1a37013$var$FeaturesDesktop;




var $3QbnI = parcelRequire("3QbnI");




const $4fffc59828433e1c$var$FeaturesMobile = ()=>{
    let [activeIndex, setActiveIndex] = (0, $3QbnI.useState)(0);
    let slideContainerRef = (0, $3QbnI.useRef)(null);
    let slideRefs = (0, $3QbnI.useRef)([]);
    (0, $3QbnI.useEffect)(()=>{
        let observer = new window.IntersectionObserver((entries)=>{
            for (let entry of entries)if (entry.isIntersecting) {
                setActiveIndex(slideRefs.current.indexOf(entry.target));
                break;
            }
        }, {
            root: slideContainerRef.current,
            threshold: 0.6
        });
        for (let slide of slideRefs.current)if (slide) observer.observe(slide);
        return ()=>{
            observer.disconnect();
        };
    }, [
        slideContainerRef,
        slideRefs
    ]);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                ref: slideContainerRef,
                className: "-mb-4 flex snap-x snap-mandatory -space-x-4 overflow-x-auto overscroll-x-contain scroll-smooth pb-4 [scrollbar-width:none] sm:-space-x-6 [&::-webkit-scrollbar]:hidden",
                children: (0, $fb473ce75746215d$export$2e2bcd8739ae039).map((feature, featureIndex)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                        ref: (ref)=>slideRefs.current[featureIndex] = ref,
                        className: "w-full flex-none snap-center px-4 sm:px-6",
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                            className: "relative transform overflow-hidden rounded-2xl bg-gray-800 px-5 py-6",
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                    className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $906670345aa34efb$export$2e2bcd8739ae039), {
                                        color: "#13B5C8",
                                        className: featureIndex % 2 === 1 ? "rotate-180" : undefined
                                    })
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4eb5d0d997114485$export$2e2bcd8739ae039), {
                                    className: "relative mx-auto w-full max-w-[366px]",
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(feature.screen, {})
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                    className: "absolute inset-x-0 bottom-0 bg-gray-800/95 p-6 backdrop-blur sm:p-10",
                                    children: [
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(feature.icon, {
                                            className: "h-8 w-8"
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h3", {
                                            className: "mt-6 text-sm font-semibold text-white sm:text-lg",
                                            children: feature.name
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                                            className: "mt-2 text-sm text-gray-400",
                                            children: feature.description
                                        })
                                    ]
                                })
                            ]
                        })
                    }, featureIndex))
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "mt-6 flex justify-center gap-3",
                children: (0, $fb473ce75746215d$export$2e2bcd8739ae039).map((_, featureIndex)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("button", {
                        type: "button",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("relative h-0.5 w-4 rounded-full", featureIndex === activeIndex ? "bg-gray-300" : "bg-gray-500"),
                        "aria-label": `Go to slide ${featureIndex + 1}`,
                        onClick: ()=>{
                            slideRefs.current[featureIndex]?.scrollIntoView({
                                block: "nearest",
                                inline: "nearest"
                            });
                        },
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                            className: "absolute -inset-x-1.5 -inset-y-3"
                        })
                    }, featureIndex))
            })
        ]
    });
};
var $4fffc59828433e1c$export$2e2bcd8739ae039 = $4fffc59828433e1c$var$FeaturesMobile;


const $3255d5eba7754f90$var$PrimaryFeatures = ()=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("marketing");
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("section", {
        id: "features",
        "aria-label": "Features for investing all your money",
        className: "bg-gray-900 py-20 sm:py-32",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                    className: "mx-auto max-w-2xl lg:mx-0 lg:max-w-3xl",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h2", {
                            className: "text-3xl font-medium tracking-tight text-white",
                            children: t("Every feature you need to be a real chief.")
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                            className: "mt-2 text-lg text-gray-400 leading-8",
                            children: t("CookBook was designed")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "mt-16 md:hidden",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4fffc59828433e1c$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
                className: "hidden md:mt-20 md:block",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b42d3fdbd1a37013$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $3255d5eba7754f90$export$2e2bcd8739ae039 = $3255d5eba7754f90$var$PrimaryFeatures;





const $f10cfa97c13556c2$var$features = [
    {
        name: "_All platforms",
        description: "_CookBook is optimized for mobile, tablet and browsers.",
        icon: $f10cfa97c13556c2$var$DeviceArrowIcon
    },
    {
        name: "_Even manual writing is faster",
        description: "_If you want to write your own recipe, CookBook detects automatically the useful information.",
        icon: $f10cfa97c13556c2$var$SmartphoneEditIcon
    },
    {
        name: "_Stay the owner of your recipes",
        description: "_Your recipes will stay private. You will be able to download your whole cook book at any time.",
        icon: $f10cfa97c13556c2$var$DeviceLockIcon
    },
    {
        name: "_Easy to read",
        description: "_In the opposite of other recipe app, there is no adds and everyting is clear crystal to read.",
        icon: $f10cfa97c13556c2$var$DeviceListIcon
    },
    {
        name: "_Share with your friends",
        description: `_Share a copy of your recipe and don't care about changing yours later.`,
        icon: $f10cfa97c13556c2$var$SmartphoneShareIcon
    },
    {
        name: "_Cooking Mode",
        description: `_A cooking mode to ensure your phone doesn't go to sleep while you are cooking.`,
        icon: $f10cfa97c13556c2$var$DeviceChartIcon
    }
];
function $f10cfa97c13556c2$var$DeviceArrowIcon(props) {
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
        viewBox: "0 0 32 32",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 0a4 4 0 00-4 4v24a4 4 0 004 4h14a4 4 0 004-4V4a4 4 0 00-4-4H9zm0 2a2 2 0 00-2 2v24a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9z",
                fill: "#737373"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                d: "M12 25l8-8m0 0h-6m6 0v6",
                stroke: "#171717",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "#A3A3A3",
                fillOpacity: 0.2
            })
        ]
    });
}
// function DeviceCardsIcon(props: Props) {
//   let id = useId()
//   return (
//     <svg viewBox="0 0 32 32" aria-hidden="true" {...props}>
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M9 0a4 4 0 00-4 4v24a4 4 0 004 4h14a4 4 0 004-4V4a4 4 0 00-4-4H9zm0 2a2 2 0 00-2 2v24a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9z"
//         fill="#737373"
//       />
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M9 13a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H10a1 1 0 01-1-1v-2zm0 6a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H10a1 1 0 01-1-1v-2zm1 5a1 1 0 00-1 1v2a1 1 0 001 1h12a1 1 0 001-1v-2a1 1 0 00-1-1H10z"
//         fill={`url(#${id}-gradient)`}
//       />
//       <rect x={9} y={6} width={14} height={4} rx={1} fill="#171717" />
//       <circle cx={16} cy={16} r={16} fill="#A3A3A3" fillOpacity={0.2} />
//       <defs>
//         <linearGradient
//           id={`${id}-gradient`}
//           x1={16}
//           y1={12}
//           x2={16}
//           y2={28}
//           gradientUnits="userSpaceOnUse"
//         >
//           <stop stopColor="#737373" />
//           <stop offset={1} stopColor="#737373" stopOpacity={0} />
//         </linearGradient>
//       </defs>
//     </svg>
//   )
// }
// function DeviceClockIcon(props: Props) {
//   return (
//     <svg viewBox="0 0 32 32" aria-hidden="true" {...props}>
//       <circle cx={16} cy={16} r={16} fill="#A3A3A3" fillOpacity={0.2} />
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M5 4a4 4 0 014-4h14a4 4 0 014 4v10h-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9a2 2 0 00-2 2v24a2 2 0 002 2h5v2H9a4 4 0 01-4-4V4z"
//         fill="#737373"
//       />
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M24 32a8 8 0 100-16 8 8 0 000 16zm1-8.414V19h-2v5.414l4 4L28.414 27 25 23.586z"
//         fill="#171717"
//       />
//     </svg>
//   )
// }
function $f10cfa97c13556c2$var$DeviceListIcon(props) {
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 0a4 4 0 00-4 4v24a4 4 0 004 4h14a4 4 0 004-4V4a4 4 0 00-4-4H9zm0 2a2 2 0 00-2 2v24a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9z",
                fill: "#737373"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 11,
                cy: 14,
                r: 2,
                fill: "#171717"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 11,
                cy: 20,
                r: 2,
                fill: "#171717"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 11,
                cy: 26,
                r: 2,
                fill: "#171717"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                d: "M16 14h6M16 20h6M16 26h6",
                stroke: "#737373",
                strokeWidth: 2,
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "#A3A3A3",
                fillOpacity: 0.2
            })
        ]
    });
}
function $f10cfa97c13556c2$var$SmartphoneEditIcon(props) {
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
        viewBox: "0 0 32 32",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "#A3A3A3",
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 4a4 4 0 014-4h14a4 4 0 014 4v10h-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9a2 2 0 00-2 2v24a2 2 0 002 2h5v2H9a4 4 0 01-4-4V4z",
                fill: "#737373"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                fill: "#171717",
                className: "w-6 h-6",
                width: "18",
                height: "18",
                x: "14",
                y: "14",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                    d: "M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z"
                })
            })
        ]
    });
}
function $f10cfa97c13556c2$var$SmartphoneShareIcon(props) {
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
        viewBox: "0 0 32 32",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "#A3A3A3",
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 4a4 4 0 014-4h14a4 4 0 014 4v10h-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9a2 2 0 00-2 2v24a2 2 0 002 2h5v2H9a4 4 0 01-4-4V4z",
                fill: "#737373"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                fill: "#171717",
                className: "w-6 h-6",
                width: "20",
                height: "20",
                x: "8",
                y: "14",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M15.75 4.5a3 3 0 11.825 2.066l-8.421 4.679a3.002 3.002 0 010 1.51l8.421 4.679a3 3 0 11-.729 1.31l-8.421-4.678a3 3 0 110-4.132l8.421-4.679a3 3 0 01-.096-.755z",
                    clipRule: "evenodd"
                })
            })
        ]
    });
}
function $f10cfa97c13556c2$var$DeviceLockIcon(props) {
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
        viewBox: "0 0 32 32",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "#A3A3A3",
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 4a4 4 0 014-4h14a4 4 0 014 4v10h-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9a2 2 0 00-2 2v24a2 2 0 002 2h5v2H9a4 4 0 01-4-4V4z",
                fill: "#737373"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18 19.5a3.5 3.5 0 117 0V22a2 2 0 012 2v6a2 2 0 01-2 2h-7a2 2 0 01-2-2v-6a2 2 0 012-2v-2.5zm2 2.5h3v-2.5a1.5 1.5 0 00-3 0V22z",
                fill: "#171717"
            })
        ]
    });
}
function $f10cfa97c13556c2$var$DeviceChartIcon(props) {
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 0a4 4 0 00-4 4v24a4 4 0 004 4h14a4 4 0 004-4V4a4 4 0 00-4-4H9zm0 2a2 2 0 00-2 2v24a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2h-1.382a1 1 0 00-.894.553l-.448.894a1 1 0 01-.894.553h-6.764a1 1 0 01-.894-.553l-.448-.894A1 1 0 0010.382 2H9z",
                fill: "#737373"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23 13.838V26a2 2 0 01-2 2H11a2 2 0 01-2-2V15.65l2.57 3.212a1 1 0 001.38.175L15.4 17.2a1 1 0 011.494.353l1.841 3.681c.399.797 1.562.714 1.843-.13L23 13.837z",
                fill: "#171717"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                d: "M10 12h12",
                stroke: "#737373",
                strokeWidth: 2,
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "#A3A3A3",
                fillOpacity: 0.2
            })
        ]
    });
}
const $f10cfa97c13556c2$var$SecondaryFeatures = ()=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("marketing");
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("section", {
        id: "secondary-features",
        "aria-label": "Features for building a portfolio",
        className: "py-20 sm:py-32",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                    className: "mx-auto max-w-2xl sm:text-center",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h2", {
                            className: "text-3xl font-medium tracking-tight text-gray-900",
                            children: t("Now it is the time to build your CookBook")
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                            className: "mt-2 text-lg text-gray-600",
                            children: t("With typical recipe app")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("ul", {
                    className: "mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 text-sm sm:mt-20 sm:grid-cols-2 md:gap-y-10 lg:max-w-none lg:grid-cols-3",
                    children: $f10cfa97c13556c2$var$features.map((feature)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("li", {
                            className: "rounded-2xl border border-gray-200 p-8",
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(feature.icon, {
                                    className: "h-8 w-8"
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h3", {
                                    className: "mt-6 font-semibold text-gray-900",
                                    children: t(feature.name)
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                                    className: "mt-2 text-gray-700",
                                    children: t(feature.description)
                                })
                            ]
                        }, feature.name))
                })
            ]
        })
    });
};
var $f10cfa97c13556c2$export$2e2bcd8739ae039 = $f10cfa97c13556c2$var$SecondaryFeatures;









const $21456271412505c0$var$CallToAction = ()=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("marketing");
    const user = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $68690f862a398578$export$e5432d4c8eb97ea7));
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("section", {
        id: "get-free-shares-today",
        className: "relative overflow-hidden bg-gray-900 py-20 sm:py-28",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "absolute top-1/2 left-20 -translate-y-1/2 sm:left-1/2 sm:-translate-x-1/2",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $906670345aa34efb$export$2e2bcd8739ae039), {
                    color: "#fff",
                    className: "animate-spin-slower"
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
                className: "relative",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                    className: "mx-auto max-w-md sm:text-center",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h2", {
                            className: "text-3xl font-medium tracking-tight text-white sm:text-4xl",
                            children: t("Add your first recipe today")
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                            className: "mt-4 text-lg text-gray-300",
                            children: t("It takes 30 seconds")
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                            className: "mt-8 flex justify-center",
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary, {
                                className: "px-5 py-3",
                                to: user ? "/recipes" : "/login",
                                children: t("Try")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $21456271412505c0$export$2e2bcd8739ae039 = $21456271412505c0$var$CallToAction;






// import Select from '~/src/components/atoms/Select'
// import Button from '~/src/components/atoms/Button'
// import Input from '~/src/components/atoms/Input'
// import { languages } from '~/src/utils/services/i18n'
const $190bc710ce4d30fe$var$Footer = ()=>{
    // const [email, setEmail] = useState('')
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("marketing");
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("footer", {
        className: "border-t border-gray-200 py-4 lg:py-10",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                className: "flex flex-col items-center border-gray-200 pt-8 pb-12 md:flex-row-reverse md:justify-between md:pt-6",
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                        className: "pl-3 text-sm text-gray-500",
                        children: t("All rights reserved", {
                            date: new Date().getFullYear()
                        })
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                        className: "mt-6 text-sm text-gray-500 md:mt-0 flex items-center",
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $2177ccffcfec9146$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        })
    });
};
var $190bc710ce4d30fe$export$2e2bcd8739ae039 = $190bc710ce4d30fe$var$Footer;


/* eslint-disable i18next/no-literal-string */ 
var $dfb0e843c5df270f$exports = {};
var $8ca0c60bc2e69a43$exports = {};
function $8ca0c60bc2e69a43$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$8ca0c60bc2e69a43$exports = $8ca0c60bc2e69a43$var$_objectWithoutPropertiesLoose, $8ca0c60bc2e69a43$exports.__esModule = true, $8ca0c60bc2e69a43$exports["default"] = $8ca0c60bc2e69a43$exports;


function $dfb0e843c5df270f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8ca0c60bc2e69a43$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$dfb0e843c5df270f$exports = $dfb0e843c5df270f$var$_objectWithoutProperties, $dfb0e843c5df270f$exports.__esModule = true, $dfb0e843c5df270f$exports["default"] = $dfb0e843c5df270f$exports;





var $3QbnI = parcelRequire("3QbnI");
var $de4b3f03ee106e77$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $de4b3f03ee106e77$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $d73cbeccb42e8979$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $d73cbeccb42e8979$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($de4b3f03ee106e77$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($d73cbeccb42e8979$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $d73cbeccb42e8979$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $d73cbeccb42e8979$var$i = /^\s*$/, $d73cbeccb42e8979$var$s = Object.create(null);
function $d73cbeccb42e8979$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($d73cbeccb42e8979$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $d73cbeccb42e8979$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $d73cbeccb42e8979$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($d73cbeccb42e8979$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $d73cbeccb42e8979$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $d73cbeccb42e8979$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $d73cbeccb42e8979$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $d73cbeccb42e8979$var$a("", t);
        }, "");
    }
};
var $d73cbeccb42e8979$export$2e2bcd8739ae039 = $d73cbeccb42e8979$var$c;




var $242f1f28d80c68d3$var$_excluded = [
    "format"
], $242f1f28d80c68d3$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $242f1f28d80c68d3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $242f1f28d80c68d3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $242f1f28d80c68d3$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6f3ad28644d1bb51$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $242f1f28d80c68d3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $242f1f28d80c68d3$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $242f1f28d80c68d3$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $242f1f28d80c68d3$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $3QbnI.isValidElement)(child);
    });
}
function $242f1f28d80c68d3$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $242f1f28d80c68d3$var$mergeProps(source, target) {
    var newTarget = $242f1f28d80c68d3$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $242f1f28d80c68d3$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $242f1f28d80c68d3$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $3QbnI.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $242f1f28d80c68d3$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $b12f193bb1c338e4$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($715eacc56db0f410$exports)))(child) === "object") {
            var format = child.format, clone = (0, (/*@__PURE__*/$parcel$interopDefault($dfb0e843c5df270f$exports)))(child, $242f1f28d80c68d3$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $b12f193bb1c338e4$export$c106dd0671a0fc2d)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $b12f193bb1c338e4$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $242f1f28d80c68d3$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $242f1f28d80c68d3$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($242f1f28d80c68d3$var$hasChildren(child)) getData($242f1f28d80c68d3$var$getChildren(child));
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($715eacc56db0f410$exports)))(child) === "object" && !(0, $3QbnI.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $d73cbeccb42e8979$export$2e2bcd8739ae039).parse("<0>".concat(targetString, "</0>"));
    var opts = $242f1f28d80c68d3$var$_objectSpread($242f1f28d80c68d3$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $242f1f28d80c68d3$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $242f1f28d80c68d3$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $3QbnI.cloneElement)(child, $242f1f28d80c68d3$var$_objectSpread($242f1f28d80c68d3$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $242f1f28d80c68d3$var$getAsArray(reactNode);
        var astNodes = $242f1f28d80c68d3$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $242f1f28d80c68d3$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $3QbnI.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $242f1f28d80c68d3$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, (/*@__PURE__*/$parcel$interopDefault($715eacc56db0f410$exports)))(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, (/*@__PURE__*/$parcel$interopDefault($715eacc56db0f410$exports)))(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($242f1f28d80c68d3$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $3QbnI.cloneElement)(child, $242f1f28d80c68d3$var$_objectSpread($242f1f28d80c68d3$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $3QbnI.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $3QbnI.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, (/*@__PURE__*/$parcel$interopDefault($715eacc56db0f410$exports)))(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $3QbnI.cloneElement)(child, $242f1f28d80c68d3$var$_objectSpread($242f1f28d80c68d3$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $3QbnI.cloneElement)(child, $242f1f28d80c68d3$var$_objectSpread($242f1f28d80c68d3$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $3QbnI.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $242f1f28d80c68d3$var$getAsArray(children || []));
    return $242f1f28d80c68d3$var$getChildren(result[0]);
}
function $242f1f28d80c68d3$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($dfb0e843c5df270f$exports)))(_ref, $242f1f28d80c68d3$var$_excluded2);
    var _ref2 = (0, $3QbnI.useContext)((0, $e4acdf289761376f$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $e4acdf289761376f$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $b12f193bb1c338e4$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $242f1f28d80c68d3$var$_objectSpread($242f1f28d80c68d3$var$_objectSpread({}, (0, $e4acdf289761376f$export$212bb2fc580a90a8)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $242f1f28d80c68d3$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $242f1f28d80c68d3$var$_objectSpread($242f1f28d80c68d3$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $242f1f28d80c68d3$var$_objectSpread($242f1f28d80c68d3$var$_objectSpread($242f1f28d80c68d3$var$_objectSpread($242f1f28d80c68d3$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $242f1f28d80c68d3$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $3QbnI.createElement)(useAsParent, additionalProps, content) : content;
}







var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

function $c86664fa6151526e$export$fd183955ff4b45d9() {
    let [e] = (0, $3QbnI.useState)((0, $7b478da02baf897f$export$12b26c28a05aa001));
    return (0, $3QbnI.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}




var $3QbnI = parcelRequire("3QbnI");

function $9987347a8ddb8c63$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)(a);
    (0, $3QbnI.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}




var $3QbnI = parcelRequire("3QbnI");


function $15406271e09b2909$export$cd059ee7fd0e9f3d(t) {
    let r = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(t), e = (0, $3QbnI.useRef)(!1);
    (0, $3QbnI.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, $f0108a5abfaa286e$export$a5ff0d6a738703ca)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}



var $3QbnI = parcelRequire("3QbnI");

function $0225316d43e68597$export$dd9fbcea3de0ae36(...e) {
    return (0, $3QbnI.useMemo)(()=>(0, $a37d5afd1ae25fcd$export$b204af158042fbac)(...e), [
        ...e
    ]);
}





var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

function $0523a0a1d5e5f235$export$ee579bb285b8d4aa(e, r, n) {
    let o = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)(r);
    (0, $3QbnI.useEffect)(()=>{
        function t(i) {
            o.current(i);
        }
        return window.addEventListener(e, t, n), ()=>window.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}


var $245e037f2cce86f7$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($245e037f2cce86f7$export$cacd6541cfeeb6c1 || {});
function $245e037f2cce86f7$export$19b797546aece48f() {
    let e = (0, $3QbnI.useRef)(0);
    return (0, $0523a0a1d5e5f235$export$ee579bb285b8d4aa)("keydown", (o)=>{
        o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
    }, !0), e;
}



var $3QbnI = parcelRequire("3QbnI");

function $ae9cd3a8ada9dd7a$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $3QbnI.useRef)([]), r = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(u);
    (0, $3QbnI.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [n, a] of t.entries())if (e.current[n] !== a) {
            let l = r(t, o);
            return e.current = t, l;
        }
    }, [
        r,
        ...t
    ]);
}



function $e6421cb929d431f1$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}


let $ade55b4682efeee5$export$55abd4691b317664 = [];
(0, $e6421cb929d431f1$export$a6a2315df743a26b)(()=>{
    function e(n) {
        n.target instanceof HTMLElement && n.target !== document.body && $ade55b4682efeee5$export$55abd4691b317664[0] !== n.target && ($ade55b4682efeee5$export$55abd4691b317664.unshift(n.target), $ade55b4682efeee5$export$55abd4691b317664 = $ade55b4682efeee5$export$55abd4691b317664.filter((r)=>r != null && r.isConnected), $ade55b4682efeee5$export$55abd4691b317664.splice(10));
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});






function $4eaece7f47b8ef95$var$P(t) {
    if (!t) return new Set;
    if (typeof t == "function") return new Set(t());
    let n = new Set;
    for (let e of t.current)e.current instanceof HTMLElement && n.add(e.current);
    return n;
}
let $4eaece7f47b8ef95$var$X = "div";
var $4eaece7f47b8ef95$var$_ = ((r)=>(r[r.None = 1] = "None", r[r.InitialFocus = 2] = "InitialFocus", r[r.TabLock = 4] = "TabLock", r[r.FocusLock = 8] = "FocusLock", r[r.RestoreFocus = 16] = "RestoreFocus", r[r.All = 30] = "All", r))($4eaece7f47b8ef95$var$_ || {});
function $4eaece7f47b8ef95$var$z(t, n) {
    let e = (0, $3QbnI.useRef)(null), o = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(e, n), { initialFocus: l, containers: c, features: r = 30, ...s } = t;
    (0, $84e12220f2f730c7$export$44ab2b9f2d09b0fa)() || (r = 1);
    let i = (0, $0225316d43e68597$export$dd9fbcea3de0ae36)(e);
    $4eaece7f47b8ef95$var$Y({
        ownerDocument: i
    }, Boolean(r & 16));
    let u = $4eaece7f47b8ef95$var$Z({
        ownerDocument: i,
        container: e,
        initialFocus: l
    }, Boolean(r & 2));
    $4eaece7f47b8ef95$var$$({
        ownerDocument: i,
        container: e,
        containers: c,
        previousActiveElement: u
    }, Boolean(r & 8));
    let y = (0, $245e037f2cce86f7$export$19b797546aece48f)(), R = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((a)=>{
        let m = e.current;
        if (!m) return;
        ((B)=>B())(()=>{
            (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(y.current, {
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    (0, $6e492986e168be71$export$82e1f4f412218a1d)(m, (0, $6e492986e168be71$export$807a7eae502106e7).First, {
                        skipElements: [
                            a.relatedTarget
                        ]
                    });
                },
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    (0, $6e492986e168be71$export$82e1f4f412218a1d)(m, (0, $6e492986e168be71$export$807a7eae502106e7).Last, {
                        skipElements: [
                            a.relatedTarget
                        ]
                    });
                }
            });
        });
    }), h = (0, $c86664fa6151526e$export$fd183955ff4b45d9)(), H = (0, $3QbnI.useRef)(!1), j = {
        ref: o,
        onKeyDown (a) {
            a.key == "Tab" && (H.current = !0, h.requestAnimationFrame(()=>{
                H.current = !1;
            }));
        },
        onBlur (a) {
            let m = $4eaece7f47b8ef95$var$P(c);
            e.current instanceof HTMLElement && m.add(e.current);
            let T = a.relatedTarget;
            T instanceof HTMLElement && T.dataset.headlessuiFocusGuard !== "true" && ($4eaece7f47b8ef95$var$S(m, T) || (H.current ? (0, $6e492986e168be71$export$82e1f4f412218a1d)(e.current, (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(y.current, {
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $6e492986e168be71$export$807a7eae502106e7).Next,
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $6e492986e168be71$export$807a7eae502106e7).Previous
            }) | (0, $6e492986e168be71$export$807a7eae502106e7).WrapAround, {
                relativeTo: a.target
            }) : a.target instanceof HTMLElement && (0, $6e492986e168be71$export$5fed9cc43865dc7e)(a.target)));
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Fragment, null, Boolean(r & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $70ad89c09b766687$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, $70ad89c09b766687$export$617d79dae526d2cf).Focusable
    }), (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: j,
        theirProps: s,
        defaultTag: $4eaece7f47b8ef95$var$X,
        name: "FocusTrap"
    }), Boolean(r & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $70ad89c09b766687$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, $70ad89c09b766687$export$617d79dae526d2cf).Focusable
    }));
}
let $4eaece7f47b8ef95$var$D = (0, $efef981be50c1ac4$export$e43f39796049410c)($4eaece7f47b8ef95$var$z), $4eaece7f47b8ef95$export$34eba2437817a67b = Object.assign($4eaece7f47b8ef95$var$D, {
    features: $4eaece7f47b8ef95$var$_
});
function $4eaece7f47b8ef95$var$Q(t = !0) {
    let n = (0, $3QbnI.useRef)((0, $ade55b4682efeee5$export$55abd4691b317664).slice());
    return (0, $ae9cd3a8ada9dd7a$export$3c773aa2b84f29e0)(([e], [o])=>{
        o === !0 && e === !1 && (0, $f0108a5abfaa286e$export$a5ff0d6a738703ca)(()=>{
            n.current.splice(0);
        }), o === !1 && e === !0 && (n.current = (0, $ade55b4682efeee5$export$55abd4691b317664).slice());
    }, [
        t,
        (0, $ade55b4682efeee5$export$55abd4691b317664),
        n
    ]), (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        var e;
        return (e = n.current.find((o)=>o != null && o.isConnected)) != null ? e : null;
    });
}
function $4eaece7f47b8ef95$var$Y({ ownerDocument: t }, n) {
    let e = $4eaece7f47b8ef95$var$Q(n);
    (0, $ae9cd3a8ada9dd7a$export$3c773aa2b84f29e0)(()=>{
        n || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && (0, $6e492986e168be71$export$5fed9cc43865dc7e)(e());
    }, [
        n
    ]), (0, $15406271e09b2909$export$cd059ee7fd0e9f3d)(()=>{
        n && (0, $6e492986e168be71$export$5fed9cc43865dc7e)(e());
    });
}
function $4eaece7f47b8ef95$var$Z({ ownerDocument: t, container: n, initialFocus: e }, o) {
    let l = (0, $3QbnI.useRef)(null), c = (0, $83975537d9d245c1$export$80c2a3957bcb42ea)();
    return (0, $ae9cd3a8ada9dd7a$export$3c773aa2b84f29e0)(()=>{
        if (!o) return;
        let r = n.current;
        r && (0, $f0108a5abfaa286e$export$a5ff0d6a738703ca)(()=>{
            if (!c.current) return;
            let s = t == null ? void 0 : t.activeElement;
            if (e != null && e.current) {
                if ((e == null ? void 0 : e.current) === s) {
                    l.current = s;
                    return;
                }
            } else if (r.contains(s)) {
                l.current = s;
                return;
            }
            e != null && e.current ? (0, $6e492986e168be71$export$5fed9cc43865dc7e)(e.current) : (0, $6e492986e168be71$export$82e1f4f412218a1d)(r, (0, $6e492986e168be71$export$807a7eae502106e7).First) === (0, $6e492986e168be71$export$abf286375dfa6dbd).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), l.current = t == null ? void 0 : t.activeElement;
        });
    }, [
        o
    ]), l;
}
function $4eaece7f47b8ef95$var$$({ ownerDocument: t, container: n, containers: e, previousActiveElement: o }, l) {
    let c = (0, $83975537d9d245c1$export$80c2a3957bcb42ea)();
    (0, $9987347a8ddb8c63$export$7080b3e976bc91ab)(t == null ? void 0 : t.defaultView, "focus", (r)=>{
        if (!l || !c.current) return;
        let s = $4eaece7f47b8ef95$var$P(e);
        n.current instanceof HTMLElement && s.add(n.current);
        let i = o.current;
        if (!i) return;
        let u = r.target;
        u && u instanceof HTMLElement ? $4eaece7f47b8ef95$var$S(s, u) ? (o.current = u, (0, $6e492986e168be71$export$5fed9cc43865dc7e)(u)) : (r.preventDefault(), r.stopPropagation(), (0, $6e492986e168be71$export$5fed9cc43865dc7e)(i)) : (0, $6e492986e168be71$export$5fed9cc43865dc7e)(o.current);
    }, !0);
}
function $4eaece7f47b8ef95$var$S(t, n) {
    for (let e of t)if (e.contains(n)) return !0;
    return !1;
}



var $3QbnI = parcelRequire("3QbnI");








var $3QbnI = parcelRequire("3QbnI");
let $8ec6e2fb058a94c1$var$e = (0, $3QbnI.createContext)(!1);
function $8ec6e2fb058a94c1$export$6ecd3efa4eebe261() {
    return (0, $3QbnI.useContext)($8ec6e2fb058a94c1$var$e);
}
function $8ec6e2fb058a94c1$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($8ec6e2fb058a94c1$var$e.Provider, {
        value: o.force
    }, o.children);
}




function $e1816142ef1407cb$var$F(p) {
    let n = (0, $8ec6e2fb058a94c1$export$6ecd3efa4eebe261)(), l = (0, $3QbnI.useContext)($e1816142ef1407cb$var$_), e = (0, $0225316d43e68597$export$dd9fbcea3de0ae36)(p), [a, o] = (0, $3QbnI.useState)(()=>{
        if (!n && l !== null || (0, $9a9be7499c0d7009$export$a7b6bc01c63cdfc3).isServer) return null;
        let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (t) return t;
        if (e === null) return null;
        let r = e.createElement("div");
        return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
    });
    return (0, $3QbnI.useEffect)(()=>{
        a !== null && (e != null && e.body.contains(a) || e == null || e.body.appendChild(a));
    }, [
        a,
        e
    ]), (0, $3QbnI.useEffect)(()=>{
        n || l !== null && o(l.current);
    }, [
        l,
        o,
        n
    ]), a;
}
let $e1816142ef1407cb$var$U = (0, $3QbnI.Fragment);
function $e1816142ef1407cb$var$N(p, n) {
    let l = p, e = (0, $3QbnI.useRef)(null), a = (0, $2965c2f720720e02$export$f6a25a78204acc7e)((0, $2965c2f720720e02$export$7029785b750eb74)((u)=>{
        e.current = u;
    }), n), o = (0, $0225316d43e68597$export$dd9fbcea3de0ae36)(e), t = $e1816142ef1407cb$var$F(e), [r] = (0, $3QbnI.useState)(()=>{
        var u;
        return (0, $9a9be7499c0d7009$export$a7b6bc01c63cdfc3).isServer ? null : (u = o == null ? void 0 : o.createElement("div")) != null ? u : null;
    }), i = (0, $3QbnI.useContext)($e1816142ef1407cb$var$f), v = (0, $84e12220f2f730c7$export$44ab2b9f2d09b0fa)();
    return (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        !t || !r || t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r));
    }, [
        t,
        r
    ]), (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        if (r && i) return i.register(r);
    }, [
        i,
        r
    ]), (0, $15406271e09b2909$export$cd059ee7fd0e9f3d)(()=>{
        var u;
        !t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((u = t.parentElement) == null || u.removeChild(t)));
    }), v ? !t || !r ? null : (0, $70c58451959e30b3$exports.createPortal)((0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a
        },
        theirProps: l,
        defaultTag: $e1816142ef1407cb$var$U,
        name: "Portal"
    }), r) : null;
}
let $e1816142ef1407cb$var$S = (0, $3QbnI.Fragment), $e1816142ef1407cb$var$_ = (0, $3QbnI.createContext)(null);
function $e1816142ef1407cb$var$j(p, n) {
    let { target: l, ...e } = p, o = {
        ref: (0, $2965c2f720720e02$export$f6a25a78204acc7e)(n)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($e1816142ef1407cb$var$_.Provider, {
        value: l
    }, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: o,
        theirProps: e,
        defaultTag: $e1816142ef1407cb$var$S,
        name: "Popover.Group"
    }));
}
let $e1816142ef1407cb$var$f = (0, $3QbnI.createContext)(null);
function $e1816142ef1407cb$export$26b8c35244a70b37() {
    let p = (0, $3QbnI.useContext)($e1816142ef1407cb$var$f), n = (0, $3QbnI.useRef)([]), l = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((o)=>(n.current.push(o), p && p.register(o), ()=>e(o))), e = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((o)=>{
        let t = n.current.indexOf(o);
        t !== -1 && n.current.splice(t, 1), p && p.unregister(o);
    }), a = (0, $3QbnI.useMemo)(()=>({
            register: l,
            unregister: e,
            portals: n
        }), [
        l,
        e,
        n
    ]);
    return [
        n,
        (0, $3QbnI.useMemo)(()=>function({ children: t }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($e1816142ef1407cb$var$f.Provider, {
                    value: a
                }, t);
            }, [
            a
        ])
    ];
}
let $e1816142ef1407cb$var$D = (0, $efef981be50c1ac4$export$e43f39796049410c)($e1816142ef1407cb$var$N), $e1816142ef1407cb$var$I = (0, $efef981be50c1ac4$export$e43f39796049410c)($e1816142ef1407cb$var$j), $e1816142ef1407cb$export$602eac185826482c = Object.assign($e1816142ef1407cb$var$D, {
    Group: $e1816142ef1407cb$var$I
});



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
function $3e18cdbf4e18d8eb$var$i(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const $3e18cdbf4e18d8eb$var$d = typeof Object.is == "function" ? Object.is : $3e18cdbf4e18d8eb$var$i, { useState: $3e18cdbf4e18d8eb$var$u, useEffect: $3e18cdbf4e18d8eb$var$h, useLayoutEffect: $3e18cdbf4e18d8eb$var$f, useDebugValue: $3e18cdbf4e18d8eb$var$p } = $3QbnI;
let $3e18cdbf4e18d8eb$var$S = !1, $3e18cdbf4e18d8eb$var$_ = !1;
function $3e18cdbf4e18d8eb$export$306c0aa65ff9ec16(e, t, c) {
    const a = t(), [{ inst: n }, o] = $3e18cdbf4e18d8eb$var$u({
        inst: {
            value: a,
            getSnapshot: t
        }
    });
    return $3e18cdbf4e18d8eb$var$f(()=>{
        n.value = a, n.getSnapshot = t, $3e18cdbf4e18d8eb$var$r(n) && o({
            inst: n
        });
    }, [
        e,
        a,
        t
    ]), $3e18cdbf4e18d8eb$var$h(()=>($3e18cdbf4e18d8eb$var$r(n) && o({
            inst: n
        }), e(()=>{
            $3e18cdbf4e18d8eb$var$r(n) && o({
                inst: n
            });
        })), [
        e
    ]), $3e18cdbf4e18d8eb$var$p(a), a;
}
function $3e18cdbf4e18d8eb$var$r(e) {
    const t = e.getSnapshot, c = e.value;
    try {
        const a = t();
        return !$3e18cdbf4e18d8eb$var$d(c, a);
    } catch  {
        return !0;
    }
}


function $95ad6404b110448c$export$306c0aa65ff9ec16(r, e, n) {
    return e();
}


const $f8b6e68d4ae09fd8$var$r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", $f8b6e68d4ae09fd8$var$s = !$f8b6e68d4ae09fd8$var$r, $f8b6e68d4ae09fd8$var$c = $f8b6e68d4ae09fd8$var$s ? (0, $95ad6404b110448c$export$306c0aa65ff9ec16) : (0, $3e18cdbf4e18d8eb$export$306c0aa65ff9ec16), $f8b6e68d4ae09fd8$export$306c0aa65ff9ec16 = "useSyncExternalStore" in $3QbnI ? ((n)=>n.useSyncExternalStore)($3QbnI) : $f8b6e68d4ae09fd8$var$c;


function $b37bb951ef69fff6$export$6ccbb43953eebf8(t) {
    return (0, $f8b6e68d4ae09fd8$export$306c0aa65ff9ec16)(t.subscribe, t.getSnapshot, t.getSnapshot);
}




function $04d6d3ae3248e71f$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}


function $47e23f5b01f28b7d$export$110627fb35ef9205() {
    let o;
    return {
        before ({ doc: e }) {
            var l;
            let n = e.documentElement;
            o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
        },
        after ({ doc: e, d: n }) {
            let t = e.documentElement, l = t.clientWidth - t.offsetWidth, r = o - l;
            n.style(t, "paddingRight", `${r}px`);
        }
    };
}



function $2dbda83d1199c858$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $2dbda83d1199c858$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $2dbda83d1199c858$export$d0a8044dce8ff2fc() {
    return $2dbda83d1199c858$export$fedb369cb70207f1() || $2dbda83d1199c858$export$a11b0059900ceec8();
}


function $708cc0609aa8c080$export$e3a523dfabf27286() {
    return (0, $2dbda83d1199c858$export$fedb369cb70207f1)() ? {
        before ({ doc: r, d: l, meta: c }) {
            function o(a) {
                return c.containers.flatMap((n)=>n()).some((n)=>n.contains(a));
            }
            l.microTask(()=>{
                var s;
                if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
                    let t = (0, $7b478da02baf897f$export$12b26c28a05aa001)();
                    t.style(r.documentElement, "scrollBehavior", "auto"), l.add(()=>l.microTask(()=>t.dispose()));
                }
                let a = (s = window.scrollY) != null ? s : window.pageYOffset, n = null;
                l.addEventListener(r, "click", (t)=>{
                    if (t.target instanceof HTMLElement) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: f } = new URL(e.href), i = r.querySelector(f);
                        i && !o(i) && (n = i);
                    } catch  {}
                }, !0), l.addEventListener(r, "touchstart", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && o(e.parentElement);)e = e.parentElement;
                            l.style(e, "overscrollBehavior", "contain");
                        } else l.style(t.target, "touchAction", "none");
                    }
                }), l.addEventListener(r, "touchmove", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), l.add(()=>{
                    var e;
                    let t = (e = window.scrollY) != null ? e : window.pageYOffset;
                    a !== t && window.scrollTo(0, a), n && n.isConnected && (n.scrollIntoView({
                        block: "nearest"
                    }), n = null);
                });
            });
        }
    } : {};
}


function $790ca819d0c10288$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}


function $76b722852161543c$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $76b722852161543c$export$a4161f418919b5aa = (0, $04d6d3ae3248e71f$export$f51a9068ac82ea43)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $7b478da02baf897f$export$12b26c28a05aa001)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $76b722852161543c$var$m(t)
        }, c = [
            (0, $708cc0609aa8c080$export$e3a523dfabf27286)(),
            (0, $47e23f5b01f28b7d$export$110627fb35ef9205)(),
            (0, $790ca819d0c10288$export$d8b6ff28805e84e9)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$76b722852161543c$export$a4161f418919b5aa.subscribe(()=>{
    let e = $76b722852161543c$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $76b722852161543c$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $76b722852161543c$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});


function $3bc5952e1ab7d67e$export$bb0ae4a42bcd9e0(e, r, n) {
    let f = (0, $b37bb951ef69fff6$export$6ccbb43953eebf8)((0, $76b722852161543c$export$a4161f418919b5aa)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        if (!(!e || !r)) return (0, $76b722852161543c$export$a4161f418919b5aa).dispatch("PUSH", e, n), ()=>(0, $76b722852161543c$export$a4161f418919b5aa).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}






let $7bf9b4ae271ecc19$var$u = new Map, $7bf9b4ae271ecc19$var$t = new Map;
function $7bf9b4ae271ecc19$export$bbe4e2927a3450da(r, l = !0) {
    (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        var o;
        if (!l) return;
        let e = typeof r == "function" ? r() : r.current;
        if (!e) return;
        function a() {
            var d;
            if (!e) return;
            let i = (d = $7bf9b4ae271ecc19$var$t.get(e)) != null ? d : 1;
            if (i === 1 ? $7bf9b4ae271ecc19$var$t.delete(e) : $7bf9b4ae271ecc19$var$t.set(e, i - 1), i !== 1) return;
            let n = $7bf9b4ae271ecc19$var$u.get(e);
            n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, $7bf9b4ae271ecc19$var$u.delete(e));
        }
        let f = (o = $7bf9b4ae271ecc19$var$t.get(e)) != null ? o : 0;
        return $7bf9b4ae271ecc19$var$t.set(e, f + 1), f !== 0 || ($7bf9b4ae271ecc19$var$u.set(e, {
            "aria-hidden": e.getAttribute("aria-hidden"),
            inert: e.inert
        }), e.setAttribute("aria-hidden", "true"), e.inert = !0), a;
    }, [
        r,
        l
    ]);
}



var $3QbnI = parcelRequire("3QbnI");



var $3QbnI = parcelRequire("3QbnI");

function $fbbacc8943482774$export$55d2b5df396a097b(e, r, n) {
    let o = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)(r);
    (0, $3QbnI.useEffect)(()=>{
        function t(u) {
            o.current(u);
        }
        return document.addEventListener(e, t, n), ()=>document.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}



function $fe5967a5f12b8ede$export$71b2224f1ce5e08e(s, m, a = !0) {
    let i = (0, $3QbnI.useRef)(!1);
    (0, $3QbnI.useEffect)(()=>{
        requestAnimationFrame(()=>{
            i.current = a;
        });
    }, [
        a
    ]);
    function c(e, r) {
        if (!i.current || e.defaultPrevented) return;
        let t = r(e);
        if (t === null || !t.getRootNode().contains(t) || !t.isConnected) return;
        let E = function u(n) {
            return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(s);
        for (let u of E){
            if (u === null) continue;
            let n = u instanceof HTMLElement ? u : u.current;
            if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
        }
        return !(0, $6e492986e168be71$export$ff1ec1c740b3c8d5)(t, (0, $6e492986e168be71$export$27112a34f2f8402d).Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
    }
    let o = (0, $3QbnI.useRef)(null);
    (0, $fbbacc8943482774$export$55d2b5df396a097b)("pointerdown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $fbbacc8943482774$export$55d2b5df396a097b)("mousedown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $fbbacc8943482774$export$55d2b5df396a097b)("click", (e)=>{
        (0, $2dbda83d1199c858$export$d0a8044dce8ff2fc)() || o.current && (c(e, ()=>o.current), o.current = null);
    }, !0), (0, $fbbacc8943482774$export$55d2b5df396a097b)("touchend", (e)=>c(e, ()=>e.target instanceof HTMLElement ? e.target : null), !0), (0, $0523a0a1d5e5f235$export$ee579bb285b8d4aa)("blur", (e)=>c(e, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}




var $3QbnI = parcelRequire("3QbnI");



function $e773763f935a119d$export$445f2d1a3d9b1b9f({ defaultContainers: o = [], portals: r, mainTreeNodeRef: u } = {}) {
    var f;
    let t = (0, $3QbnI.useRef)((f = u == null ? void 0 : u.current) != null ? f : null), l = (0, $0225316d43e68597$export$dd9fbcea3de0ae36)(t), c = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        var i, s, a;
        let n = [];
        for (let e of o)e !== null && (e instanceof HTMLElement ? n.push(e) : "current" in e && e.current instanceof HTMLElement && n.push(e.current));
        if (r != null && r.current) for (let e of r.current)n.push(e);
        for (let e of (i = l == null ? void 0 : l.querySelectorAll("html > *, body > *")) != null ? i : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(t.current) || e.contains((a = (s = t.current) == null ? void 0 : s.getRootNode()) == null ? void 0 : a.host) || n.some((L)=>e.contains(L)) || n.push(e));
        return n;
    });
    return {
        resolveContainers: c,
        contains: (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((n)=>c().some((i)=>i.contains(n))),
        mainTreeNodeRef: t,
        MainTreeNode: (0, $3QbnI.useMemo)(()=>function() {
                return u != null ? null : (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $70ad89c09b766687$export$8dc98ba7eadeaa56), {
                    features: (0, $70ad89c09b766687$export$617d79dae526d2cf).Hidden,
                    ref: t
                });
            }, [
            t,
            u
        ])
    };
}
function $e773763f935a119d$export$64db24433d7f4942() {
    let o = (0, $3QbnI.useRef)(null);
    return {
        mainTreeNodeRef: o,
        MainTreeNode: (0, $3QbnI.useMemo)(()=>function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $70ad89c09b766687$export$8dc98ba7eadeaa56), {
                    features: (0, $70ad89c09b766687$export$617d79dae526d2cf).Hidden,
                    ref: o
                });
            }, [
            o
        ])
    };
}





var $3QbnI = parcelRequire("3QbnI");
let $379c3428ac0bb4a2$var$n = (0, $3QbnI.createContext)(null);
$379c3428ac0bb4a2$var$n.displayName = "OpenClosedContext";
var $379c3428ac0bb4a2$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($379c3428ac0bb4a2$export$7254cc27399e90bd || {});
function $379c3428ac0bb4a2$export$fc6fdf0ecf360e() {
    return (0, $3QbnI.useContext)($379c3428ac0bb4a2$var$n);
}
function $379c3428ac0bb4a2$export$2a0ed818b175f558({ value: o, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($379c3428ac0bb4a2$var$n.Provider, {
        value: o
    }, r);
}




var $3QbnI = parcelRequire("3QbnI");


let $d75319b896b9ec16$var$a = (0, $3QbnI.createContext)(()=>{});
$d75319b896b9ec16$var$a.displayName = "StackContext";
var $d75319b896b9ec16$export$2dd25ef07fea092e = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))($d75319b896b9ec16$export$2dd25ef07fea092e || {});
function $d75319b896b9ec16$export$59510f5936c4d8c4() {
    return (0, $3QbnI.useContext)($d75319b896b9ec16$var$a);
}
function $d75319b896b9ec16$export$4aac1a6640027f56({ children: i, onUpdate: r, type: e, element: n, enabled: u }) {
    let l = $d75319b896b9ec16$export$59510f5936c4d8c4(), o = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((...t)=>{
        r == null || r(...t), l(...t);
    });
    return (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        let t = u === void 0 || u === !0;
        return t && o(0, e, n), ()=>{
            t && o(1, e, n);
        };
    }, [
        o,
        e,
        n,
        u
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($d75319b896b9ec16$var$a.Provider, {
        value: o
    }, i);
}


function $9fde5a40ffbcb074$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $9fde5a40ffbcb074$var$i(l) ? !1 : t;
}
function $9fde5a40ffbcb074$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}





var $3QbnI = parcelRequire("3QbnI");





let $ff60c7f0a5393e5a$var$d = (0, $3QbnI.createContext)(null);
function $ff60c7f0a5393e5a$var$f() {
    let r = (0, $3QbnI.useContext)($ff60c7f0a5393e5a$var$d);
    if (r === null) {
        let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $ff60c7f0a5393e5a$var$f), t;
    }
    return r;
}
function $ff60c7f0a5393e5a$export$babde88292020af7() {
    let [r, t] = (0, $3QbnI.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $3QbnI.useMemo)(()=>function(e) {
                let i = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((s)=>(t((o)=>[
                            ...o,
                            s
                        ]), ()=>t((o)=>{
                            let p = o.slice(), c = p.indexOf(s);
                            return c !== -1 && p.splice(c, 1), p;
                        }))), n = (0, $3QbnI.useMemo)(()=>({
                        register: i,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    i,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($ff60c7f0a5393e5a$var$d.Provider, {
                    value: n
                }, e.children);
            }, [
            t
        ])
    ];
}
let $ff60c7f0a5393e5a$var$I = "p";
function $ff60c7f0a5393e5a$var$S(r, t) {
    let a = (0, $32e547b031070140$export$f680877a34711e37)(), { id: e = `headlessui-description-${a}`, ...i } = r, n = $ff60c7f0a5393e5a$var$f(), s = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(t);
    (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>n.register(e), [
        e,
        n.register
    ]);
    let o = {
        ref: s,
        ...n.props,
        id: e
    };
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: o,
        theirProps: i,
        slot: n.slot || {},
        defaultTag: $ff60c7f0a5393e5a$var$I,
        name: n.name || "Description"
    });
}
let $ff60c7f0a5393e5a$var$h = (0, $efef981be50c1ac4$export$e43f39796049410c)($ff60c7f0a5393e5a$var$S), $ff60c7f0a5393e5a$export$393edc798c47379d = Object.assign($ff60c7f0a5393e5a$var$h, {});



var $31a47c4fe4fc06e8$var$Me = ((r)=>(r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r))($31a47c4fe4fc06e8$var$Me || {}), $31a47c4fe4fc06e8$var$we = ((e)=>(e[e.SetTitleId = 0] = "SetTitleId", e))($31a47c4fe4fc06e8$var$we || {});
let $31a47c4fe4fc06e8$var$He = {
    [0] (o, e) {
        return o.titleId === e.id ? o : {
            ...o,
            titleId: e.id
        };
    }
}, $31a47c4fe4fc06e8$var$I = (0, $3QbnI.createContext)(null);
$31a47c4fe4fc06e8$var$I.displayName = "DialogContext";
function $31a47c4fe4fc06e8$var$b(o) {
    let e = (0, $3QbnI.useContext)($31a47c4fe4fc06e8$var$I);
    if (e === null) {
        let r = new Error(`<${o} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(r, $31a47c4fe4fc06e8$var$b), r;
    }
    return e;
}
function $31a47c4fe4fc06e8$var$Be(o, e, r = ()=>[
        document.body
    ]) {
    (0, $3bc5952e1ab7d67e$export$bb0ae4a42bcd9e0)(o, e, (i)=>{
        var n;
        return {
            containers: [
                ...(n = i.containers) != null ? n : [],
                r
            ]
        };
    });
}
function $31a47c4fe4fc06e8$var$Ge(o, e) {
    return (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(e.type, $31a47c4fe4fc06e8$var$He, o, e);
}
let $31a47c4fe4fc06e8$var$Ne = "div", $31a47c4fe4fc06e8$var$Ue = (0, $efef981be50c1ac4$export$617d79dae526d2cf).RenderStrategy | (0, $efef981be50c1ac4$export$617d79dae526d2cf).Static;
function $31a47c4fe4fc06e8$var$We(o, e) {
    let r = (0, $32e547b031070140$export$f680877a34711e37)(), { id: i = `headlessui-dialog-${r}`, open: n, onClose: l, initialFocus: s, role: a = "dialog", __demoMode: T = !1, ...m } = o, [M, f] = (0, $3QbnI.useState)(0), U = (0, $3QbnI.useRef)(!1);
    a = function() {
        return a === "dialog" || a === "alertdialog" ? a : (U.current || (U.current = !0, console.warn(`Invalid role [${a}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
    }();
    let E = (0, $379c3428ac0bb4a2$export$fc6fdf0ecf360e)();
    n === void 0 && E !== null && (n = (E & (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open) === (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open);
    let D = (0, $3QbnI.useRef)(null), ee = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(D, e), g = (0, $0225316d43e68597$export$dd9fbcea3de0ae36)(D), W = o.hasOwnProperty("open") || E !== null, $ = o.hasOwnProperty("onClose");
    if (!W && !$) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!W) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!$) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof n != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);
    if (typeof l != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);
    let p = n ? 0 : 1, [h, te] = (0, $3QbnI.useReducer)($31a47c4fe4fc06e8$var$Ge, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $3QbnI.createRef)()
    }), P = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>l(!1)), Y = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((t)=>te({
            type: 0,
            id: t
        })), S = (0, $84e12220f2f730c7$export$44ab2b9f2d09b0fa)() ? T ? !1 : p === 0 : !1, x = M > 1, j = (0, $3QbnI.useContext)($31a47c4fe4fc06e8$var$I) !== null, [oe, re] = (0, $e1816142ef1407cb$export$26b8c35244a70b37)(), ne = {
        get current () {
            var t;
            return (t = h.panelRef.current) != null ? t : D.current;
        }
    }, { resolveContainers: w, mainTreeNodeRef: L, MainTreeNode: le } = (0, $e773763f935a119d$export$445f2d1a3d9b1b9f)({
        portals: oe,
        defaultContainers: [
            ne
        ]
    }), ae = x ? "parent" : "leaf", J = E !== null ? (E & (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Closing) === (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Closing : !1, ie = (()=>j || J ? !1 : S)(), se = (0, $3QbnI.useCallback)(()=>{
        var t, c;
        return (c = Array.from((t = g == null ? void 0 : g.querySelectorAll("body > *")) != null ? t : []).find((d)=>d.id === "headlessui-portal-root" ? !1 : d.contains(L.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        L
    ]);
    (0, $7bf9b4ae271ecc19$export$bbe4e2927a3450da)(se, ie);
    let pe = (()=>x ? !0 : S)(), de = (0, $3QbnI.useCallback)(()=>{
        var t, c;
        return (c = Array.from((t = g == null ? void 0 : g.querySelectorAll("[data-headlessui-portal]")) != null ? t : []).find((d)=>d.contains(L.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        L
    ]);
    (0, $7bf9b4ae271ecc19$export$bbe4e2927a3450da)(de, pe);
    let ue = (()=>!(!S || x))();
    (0, $fe5967a5f12b8ede$export$71b2224f1ce5e08e)(w, (t)=>{
        t.preventDefault(), P();
    }, ue);
    let fe = (()=>!(x || p !== 0))();
    (0, $9987347a8ddb8c63$export$7080b3e976bc91ab)(g == null ? void 0 : g.defaultView, "keydown", (t)=>{
        fe && (t.defaultPrevented || t.key === (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Escape && (t.preventDefault(), t.stopPropagation(), P()));
    });
    let ge = (()=>!(J || p !== 0 || j))();
    $31a47c4fe4fc06e8$var$Be(g, ge, w), (0, $3QbnI.useEffect)(()=>{
        if (p !== 0 || !D.current) return;
        let t = new ResizeObserver((c)=>{
            for (let d of c){
                let F = d.target.getBoundingClientRect();
                F.x === 0 && F.y === 0 && F.width === 0 && F.height === 0 && P();
            }
        });
        return t.observe(D.current), ()=>t.disconnect();
    }, [
        p,
        D,
        P
    ]);
    let [Te, ce] = (0, $ff60c7f0a5393e5a$export$babde88292020af7)(), De = (0, $3QbnI.useMemo)(()=>[
            {
                dialogState: p,
                close: P,
                setTitleId: Y
            },
            h
        ], [
        p,
        h,
        P,
        Y
    ]), X = (0, $3QbnI.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), me = {
        ref: ee,
        id: i,
        role: a,
        "aria-modal": p === 0 ? !0 : void 0,
        "aria-labelledby": h.titleId,
        "aria-describedby": Te
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $d75319b896b9ec16$export$4aac1a6640027f56), {
        type: "Dialog",
        enabled: p === 0,
        element: D,
        onUpdate: (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((t, c)=>{
            c === "Dialog" && (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(t, {
                [(0, $d75319b896b9ec16$export$2dd25ef07fea092e).Add]: ()=>f((d)=>d + 1),
                [(0, $d75319b896b9ec16$export$2dd25ef07fea092e).Remove]: ()=>f((d)=>d - 1)
            });
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $8ec6e2fb058a94c1$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $e1816142ef1407cb$export$602eac185826482c), null, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($31a47c4fe4fc06e8$var$I.Provider, {
        value: De
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $e1816142ef1407cb$export$602eac185826482c).Group, {
        target: D
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $8ec6e2fb058a94c1$export$8f2af6644e3a3c93), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(ce, {
        slot: X,
        name: "Dialog.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $4eaece7f47b8ef95$export$34eba2437817a67b), {
        initialFocus: s,
        containers: w,
        features: S ? (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(ae, {
            parent: (0, $4eaece7f47b8ef95$export$34eba2437817a67b).features.RestoreFocus,
            leaf: (0, $4eaece7f47b8ef95$export$34eba2437817a67b).features.All & ~(0, $4eaece7f47b8ef95$export$34eba2437817a67b).features.FocusLock
        }) : (0, $4eaece7f47b8ef95$export$34eba2437817a67b).features.None
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(re, null, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: me,
        theirProps: m,
        slot: X,
        defaultTag: $31a47c4fe4fc06e8$var$Ne,
        features: $31a47c4fe4fc06e8$var$Ue,
        visible: p === 0,
        name: "Dialog"
    }))))))))), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(le, null));
}
let $31a47c4fe4fc06e8$var$$e = "div";
function $31a47c4fe4fc06e8$var$Ye(o, e) {
    let r = (0, $32e547b031070140$export$f680877a34711e37)(), { id: i = `headlessui-dialog-overlay-${r}`, ...n } = o, [{ dialogState: l, close: s }] = $31a47c4fe4fc06e8$var$b("Dialog.Overlay"), a = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(e), T = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((f)=>{
        if (f.target === f.currentTarget) {
            if ((0, $9fde5a40ffbcb074$export$db61f031a278447c)(f.currentTarget)) return f.preventDefault();
            f.preventDefault(), f.stopPropagation(), s();
        }
    }), m = (0, $3QbnI.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i,
            "aria-hidden": !0,
            onClick: T
        },
        theirProps: n,
        slot: m,
        defaultTag: $31a47c4fe4fc06e8$var$$e,
        name: "Dialog.Overlay"
    });
}
let $31a47c4fe4fc06e8$var$je = "div";
function $31a47c4fe4fc06e8$var$Je(o, e) {
    let r = (0, $32e547b031070140$export$f680877a34711e37)(), { id: i = `headlessui-dialog-backdrop-${r}`, ...n } = o, [{ dialogState: l }, s] = $31a47c4fe4fc06e8$var$b("Dialog.Backdrop"), a = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(e);
    (0, $3QbnI.useEffect)(()=>{
        if (s.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        s.panelRef
    ]);
    let T = (0, $3QbnI.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $8ec6e2fb058a94c1$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $e1816142ef1407cb$export$602eac185826482c), null, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i,
            "aria-hidden": !0
        },
        theirProps: n,
        slot: T,
        defaultTag: $31a47c4fe4fc06e8$var$je,
        name: "Dialog.Backdrop"
    })));
}
let $31a47c4fe4fc06e8$var$Xe = "div";
function $31a47c4fe4fc06e8$var$Ke(o, e) {
    let r = (0, $32e547b031070140$export$f680877a34711e37)(), { id: i = `headlessui-dialog-panel-${r}`, ...n } = o, [{ dialogState: l }, s] = $31a47c4fe4fc06e8$var$b("Dialog.Panel"), a = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(e, s.panelRef), T = (0, $3QbnI.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), m = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((f)=>{
        f.stopPropagation();
    });
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i,
            onClick: m
        },
        theirProps: n,
        slot: T,
        defaultTag: $31a47c4fe4fc06e8$var$Xe,
        name: "Dialog.Panel"
    });
}
let $31a47c4fe4fc06e8$var$Ve = "h2";
function $31a47c4fe4fc06e8$var$qe(o, e) {
    let r = (0, $32e547b031070140$export$f680877a34711e37)(), { id: i = `headlessui-dialog-title-${r}`, ...n } = o, [{ dialogState: l, setTitleId: s }] = $31a47c4fe4fc06e8$var$b("Dialog.Title"), a = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(e);
    (0, $3QbnI.useEffect)(()=>(s(i), ()=>s(null)), [
        i,
        s
    ]);
    let T = (0, $3QbnI.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i
        },
        theirProps: n,
        slot: T,
        defaultTag: $31a47c4fe4fc06e8$var$Ve,
        name: "Dialog.Title"
    });
}
let $31a47c4fe4fc06e8$var$ze = (0, $efef981be50c1ac4$export$e43f39796049410c)($31a47c4fe4fc06e8$var$We), $31a47c4fe4fc06e8$var$Qe = (0, $efef981be50c1ac4$export$e43f39796049410c)($31a47c4fe4fc06e8$var$Je), $31a47c4fe4fc06e8$var$Ze = (0, $efef981be50c1ac4$export$e43f39796049410c)($31a47c4fe4fc06e8$var$Ke), $31a47c4fe4fc06e8$var$et = (0, $efef981be50c1ac4$export$e43f39796049410c)($31a47c4fe4fc06e8$var$Ye), $31a47c4fe4fc06e8$var$tt = (0, $efef981be50c1ac4$export$e43f39796049410c)($31a47c4fe4fc06e8$var$qe), $31a47c4fe4fc06e8$export$3ddf2d174ce01153 = Object.assign($31a47c4fe4fc06e8$var$ze, {
    Backdrop: $31a47c4fe4fc06e8$var$Qe,
    Panel: $31a47c4fe4fc06e8$var$Ze,
    Overlay: $31a47c4fe4fc06e8$var$et,
    Title: $31a47c4fe4fc06e8$var$tt,
    Description: (0, $ff60c7f0a5393e5a$export$393edc798c47379d)
});


var $3QbnI = parcelRequire("3QbnI");



var $3QbnI = parcelRequire("3QbnI");

function $d5eed7b42bebea04$export$2879604e6aec4ab(a = 0) {
    let [l, r] = (0, $3QbnI.useState)(a), t = (0, $83975537d9d245c1$export$80c2a3957bcb42ea)(), o = (0, $3QbnI.useCallback)((e)=>{
        t.current && r((u)=>u | e);
    }, [
        l,
        t
    ]), m = (0, $3QbnI.useCallback)((e)=>Boolean(l & e), [
        l
    ]), s = (0, $3QbnI.useCallback)((e)=>{
        t.current && r((u)=>u & ~e);
    }, [
        r,
        t
    ]), g = (0, $3QbnI.useCallback)((e)=>{
        t.current && r((u)=>u ^ e);
    }, [
        r
    ]);
    return {
        flags: l,
        addFlag: o,
        hasFlag: m,
        removeFlag: s,
        toggleFlag: g
    };
}









function $046ea37ed8b5679c$export$d2de3aaeafa91619(r) {
    let e = {
        called: !1
    };
    return (...t)=>{
        if (!e.called) return e.called = !0, r(...t);
    };
}


function $f0f2e7ba084b0739$var$g(t, ...e) {
    t && e.length > 0 && t.classList.add(...e);
}
function $f0f2e7ba084b0739$var$v(t, ...e) {
    t && e.length > 0 && t.classList.remove(...e);
}
function $f0f2e7ba084b0739$var$b(t, e) {
    let n = (0, $7b478da02baf897f$export$12b26c28a05aa001)();
    if (!t) return n.dispose;
    let { transitionDuration: m, transitionDelay: a } = getComputedStyle(t), [u, p] = [
        m,
        a
    ].map((l)=>{
        let [r = 0] = l.split(",").filter(Boolean).map((i)=>i.includes("ms") ? parseFloat(i) : parseFloat(i) * 1e3).sort((i, T)=>T - i);
        return r;
    }), o = u + p;
    if (o !== 0) {
        n.group((r)=>{
            r.setTimeout(()=>{
                e(), r.dispose();
            }, o), r.addEventListener(t, "transitionrun", (i)=>{
                i.target === i.currentTarget && r.dispose();
            });
        });
        let l = n.addEventListener(t, "transitionend", (r)=>{
            r.target === r.currentTarget && (e(), l());
        });
    } else e();
    return n.add(()=>e()), n.dispose;
}
function $f0f2e7ba084b0739$export$66bb15e2994e6a26(t, e, n, m) {
    let a = n ? "enter" : "leave", u = (0, $7b478da02baf897f$export$12b26c28a05aa001)(), p = m !== void 0 ? (0, $046ea37ed8b5679c$export$d2de3aaeafa91619)(m) : ()=>{};
    a === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
    let o = (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enter,
        leave: ()=>e.leave
    }), l = (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterTo,
        leave: ()=>e.leaveTo
    }), r = (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterFrom,
        leave: ()=>e.leaveFrom
    });
    return $f0f2e7ba084b0739$var$v(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), $f0f2e7ba084b0739$var$g(t, ...e.base, ...o, ...r), u.nextFrame(()=>{
        $f0f2e7ba084b0739$var$v(t, ...e.base, ...o, ...r), $f0f2e7ba084b0739$var$g(t, ...e.base, ...o, ...l), $f0f2e7ba084b0739$var$b(t, ()=>($f0f2e7ba084b0739$var$v(t, ...e.base, ...o), $f0f2e7ba084b0739$var$g(t, ...e.base, ...e.entered), p()));
    }), u.dispose;
}







function $41237c5929e39fa5$export$7b286972b8d8ccbf({ immediate: t, container: s, direction: n, classes: u, onStart: a, onStop: c }) {
    let l = (0, $83975537d9d245c1$export$80c2a3957bcb42ea)(), d = (0, $c86664fa6151526e$export$fd183955ff4b45d9)(), e = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)(n);
    (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        t && (e.current = "enter");
    }, [
        t
    ]), (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        let r = (0, $7b478da02baf897f$export$12b26c28a05aa001)();
        d.add(r.dispose);
        let i = s.current;
        if (i && e.current !== "idle" && l.current) return r.dispose(), a.current(e.current), r.add((0, $f0f2e7ba084b0739$export$66bb15e2994e6a26)(i, u.current, e.current === "enter", ()=>{
            r.dispose(), c.current(e.current);
        })), r.dispose;
    }, [
        n
    ]);
}






function $516f3ebf7dc9f3d4$var$S(t = "") {
    return t.split(/\s+/).filter((n)=>n.length > 1);
}
let $516f3ebf7dc9f3d4$var$I = (0, $3QbnI.createContext)(null);
$516f3ebf7dc9f3d4$var$I.displayName = "TransitionContext";
var $516f3ebf7dc9f3d4$var$Se = ((r)=>(r.Visible = "visible", r.Hidden = "hidden", r))($516f3ebf7dc9f3d4$var$Se || {});
function $516f3ebf7dc9f3d4$var$ye() {
    let t = (0, $3QbnI.useContext)($516f3ebf7dc9f3d4$var$I);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
function $516f3ebf7dc9f3d4$var$xe() {
    let t = (0, $3QbnI.useContext)($516f3ebf7dc9f3d4$var$M);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
let $516f3ebf7dc9f3d4$var$M = (0, $3QbnI.createContext)(null);
$516f3ebf7dc9f3d4$var$M.displayName = "NestingContext";
function $516f3ebf7dc9f3d4$var$U(t) {
    return "children" in t ? $516f3ebf7dc9f3d4$var$U(t.children) : t.current.filter(({ el: n })=>n.current !== null).filter(({ state: n })=>n === "visible").length > 0;
}
function $516f3ebf7dc9f3d4$var$se(t, n) {
    let r = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)(t), s = (0, $3QbnI.useRef)([]), R = (0, $83975537d9d245c1$export$80c2a3957bcb42ea)(), D = (0, $c86664fa6151526e$export$fd183955ff4b45d9)(), p = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((i, e = (0, $efef981be50c1ac4$export$80c0a745e59f7989).Hidden)=>{
        let a = s.current.findIndex(({ el: o })=>o === i);
        a !== -1 && ((0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(e, {
            [(0, $efef981be50c1ac4$export$80c0a745e59f7989).Unmount] () {
                s.current.splice(a, 1);
            },
            [(0, $efef981be50c1ac4$export$80c0a745e59f7989).Hidden] () {
                s.current[a].state = "hidden";
            }
        }), D.microTask(()=>{
            var o;
            !$516f3ebf7dc9f3d4$var$U(s) && R.current && ((o = r.current) == null || o.call(r));
        }));
    }), x = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((i)=>{
        let e = s.current.find(({ el: a })=>a === i);
        return e ? e.state !== "visible" && (e.state = "visible") : s.current.push({
            el: i,
            state: "visible"
        }), ()=>p(i, (0, $efef981be50c1ac4$export$80c0a745e59f7989).Unmount);
    }), h = (0, $3QbnI.useRef)([]), v = (0, $3QbnI.useRef)(Promise.resolve()), u = (0, $3QbnI.useRef)({
        enter: [],
        leave: [],
        idle: []
    }), g = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((i, e, a)=>{
        h.current.splice(0), n && (n.chains.current[e] = n.chains.current[e].filter(([o])=>o !== i)), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                h.current.push(o);
            })
        ]), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                Promise.all(u.current[e].map(([f, N])=>N)).then(()=>o());
            })
        ]), e === "enter" ? v.current = v.current.then(()=>n == null ? void 0 : n.wait.current).then(()=>a(e)) : a(e);
    }), d = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((i, e, a)=>{
        Promise.all(u.current[e].splice(0).map(([o, f])=>f)).then(()=>{
            var o;
            (o = h.current.shift()) == null || o();
        }).then(()=>a(e));
    });
    return (0, $3QbnI.useMemo)(()=>({
            children: s,
            register: x,
            unregister: p,
            onStart: g,
            onStop: d,
            wait: v,
            chains: u
        }), [
        x,
        p,
        s,
        g,
        d,
        u,
        v
    ]);
}
function $516f3ebf7dc9f3d4$var$Ne() {}
let $516f3ebf7dc9f3d4$var$Pe = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function $516f3ebf7dc9f3d4$var$ae(t) {
    var r;
    let n = {};
    for (let s of $516f3ebf7dc9f3d4$var$Pe)n[s] = (r = t[s]) != null ? r : $516f3ebf7dc9f3d4$var$Ne;
    return n;
}
function $516f3ebf7dc9f3d4$var$Re(t) {
    let n = (0, $3QbnI.useRef)($516f3ebf7dc9f3d4$var$ae(t));
    return (0, $3QbnI.useEffect)(()=>{
        n.current = $516f3ebf7dc9f3d4$var$ae(t);
    }, [
        t
    ]), n;
}
let $516f3ebf7dc9f3d4$var$De = "div", $516f3ebf7dc9f3d4$var$le = (0, $efef981be50c1ac4$export$617d79dae526d2cf).RenderStrategy;
function $516f3ebf7dc9f3d4$var$He(t, n) {
    var Q, Y;
    let { beforeEnter: r, afterEnter: s, beforeLeave: R, afterLeave: D, enter: p, enterFrom: x, enterTo: h, entered: v, leave: u, leaveFrom: g, leaveTo: d, ...i } = t, e = (0, $3QbnI.useRef)(null), a = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(e, n), o = (Q = i.unmount) == null || Q ? (0, $efef981be50c1ac4$export$80c0a745e59f7989).Unmount : (0, $efef981be50c1ac4$export$80c0a745e59f7989).Hidden, { show: f, appear: N, initial: T } = $516f3ebf7dc9f3d4$var$ye(), [l, j] = (0, $3QbnI.useState)(f ? "visible" : "hidden"), z = $516f3ebf7dc9f3d4$var$xe(), { register: L, unregister: O } = z;
    (0, $3QbnI.useEffect)(()=>L(e), [
        L,
        e
    ]), (0, $3QbnI.useEffect)(()=>{
        if (o === (0, $efef981be50c1ac4$export$80c0a745e59f7989).Hidden && e.current) {
            if (f && l !== "visible") {
                j("visible");
                return;
            }
            return (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(l, {
                ["hidden"]: ()=>O(e),
                ["visible"]: ()=>L(e)
            });
        }
    }, [
        l,
        e,
        L,
        O,
        f,
        o
    ]);
    let k = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)({
        base: $516f3ebf7dc9f3d4$var$S(i.className),
        enter: $516f3ebf7dc9f3d4$var$S(p),
        enterFrom: $516f3ebf7dc9f3d4$var$S(x),
        enterTo: $516f3ebf7dc9f3d4$var$S(h),
        entered: $516f3ebf7dc9f3d4$var$S(v),
        leave: $516f3ebf7dc9f3d4$var$S(u),
        leaveFrom: $516f3ebf7dc9f3d4$var$S(g),
        leaveTo: $516f3ebf7dc9f3d4$var$S(d)
    }), V = $516f3ebf7dc9f3d4$var$Re({
        beforeEnter: r,
        afterEnter: s,
        beforeLeave: R,
        afterLeave: D
    }), G = (0, $84e12220f2f730c7$export$44ab2b9f2d09b0fa)();
    (0, $3QbnI.useEffect)(()=>{
        if (G && l === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        e,
        l,
        G
    ]);
    let Te = T && !N, K = N && f && T, de = (()=>!G || Te ? "idle" : f ? "enter" : "leave")(), H = (0, $d5eed7b42bebea04$export$2879604e6aec4ab)(0), fe = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((C)=>(0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(C, {
            enter: ()=>{
                H.addFlag((0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Opening), V.current.beforeEnter();
            },
            leave: ()=>{
                H.addFlag((0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Closing), V.current.beforeLeave();
            },
            idle: ()=>{}
        })), me = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((C)=>(0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(C, {
            enter: ()=>{
                H.removeFlag((0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Opening), V.current.afterEnter();
            },
            leave: ()=>{
                H.removeFlag((0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Closing), V.current.afterLeave();
            },
            idle: ()=>{}
        })), w = $516f3ebf7dc9f3d4$var$se(()=>{
        j("hidden"), O(e);
    }, z), B = (0, $3QbnI.useRef)(!1);
    (0, $41237c5929e39fa5$export$7b286972b8d8ccbf)({
        immediate: K,
        container: e,
        classes: k,
        direction: de,
        onStart: (0, $62f55b25b9f4337e$export$86c4283a11f23f95)((C)=>{
            B.current = !0, w.onStart(e, C, fe);
        }),
        onStop: (0, $62f55b25b9f4337e$export$86c4283a11f23f95)((C)=>{
            B.current = !1, w.onStop(e, C, me), C === "leave" && !$516f3ebf7dc9f3d4$var$U(w) && (j("hidden"), O(e));
        })
    });
    let P = i, ce = {
        ref: a
    };
    return K ? P = {
        ...P,
        className: (0, $28bce3ff3bb4c0f2$export$ce4ab0c55987d1ff)(i.className, ...k.current.enter, ...k.current.enterFrom)
    } : B.current && (P.className = (0, $28bce3ff3bb4c0f2$export$ce4ab0c55987d1ff)(i.className, (Y = e.current) == null ? void 0 : Y.className), P.className === "" && delete P.className), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($516f3ebf7dc9f3d4$var$M.Provider, {
        value: w
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $379c3428ac0bb4a2$export$2a0ed818b175f558), {
        value: (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(l, {
            ["visible"]: (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open,
            ["hidden"]: (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Closed
        }) | H.flags
    }, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: ce,
        theirProps: P,
        defaultTag: $516f3ebf7dc9f3d4$var$De,
        features: $516f3ebf7dc9f3d4$var$le,
        visible: l === "visible",
        name: "Transition.Child"
    })));
}
function $516f3ebf7dc9f3d4$var$Fe(t, n) {
    let { show: r, appear: s = !1, unmount: R = !0, ...D } = t, p = (0, $3QbnI.useRef)(null), x = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(p, n);
    (0, $84e12220f2f730c7$export$44ab2b9f2d09b0fa)();
    let h = (0, $379c3428ac0bb4a2$export$fc6fdf0ecf360e)();
    if (r === void 0 && h !== null && (r = (h & (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open) === (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open), ![
        !0,
        !1
    ].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [v, u] = (0, $3QbnI.useState)(r ? "visible" : "hidden"), g = $516f3ebf7dc9f3d4$var$se(()=>{
        u("hidden");
    }), [d, i] = (0, $3QbnI.useState)(!0), e = (0, $3QbnI.useRef)([
        r
    ]);
    (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        d !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), i(!1));
    }, [
        e,
        r
    ]);
    let a = (0, $3QbnI.useMemo)(()=>({
            show: r,
            appear: s,
            initial: d
        }), [
        r,
        s,
        d
    ]);
    (0, $3QbnI.useEffect)(()=>{
        if (r) u("visible");
        else if (!$516f3ebf7dc9f3d4$var$U(g)) u("hidden");
        else {
            let T = p.current;
            if (!T) return;
            let l = T.getBoundingClientRect();
            l.x === 0 && l.y === 0 && l.width === 0 && l.height === 0 && u("hidden");
        }
    }, [
        r,
        g
    ]);
    let o = {
        unmount: R
    }, f = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        var T;
        d && i(!1), (T = t.beforeEnter) == null || T.call(t);
    }), N = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        var T;
        d && i(!1), (T = t.beforeLeave) == null || T.call(t);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($516f3ebf7dc9f3d4$var$M.Provider, {
        value: g
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($516f3ebf7dc9f3d4$var$I.Provider, {
        value: a
    }, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: {
            ...o,
            as: (0, $3QbnI.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($516f3ebf7dc9f3d4$var$ue, {
                ref: x,
                ...o,
                ...D,
                beforeEnter: f,
                beforeLeave: N
            })
        },
        theirProps: {},
        defaultTag: (0, $3QbnI.Fragment),
        features: $516f3ebf7dc9f3d4$var$le,
        visible: v === "visible",
        name: "Transition"
    })));
}
function $516f3ebf7dc9f3d4$var$_e(t, n) {
    let r = (0, $3QbnI.useContext)($516f3ebf7dc9f3d4$var$I) !== null, s = (0, $379c3428ac0bb4a2$export$fc6fdf0ecf360e)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Fragment, null, !r && s ? (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($516f3ebf7dc9f3d4$var$q, {
        ref: n,
        ...t
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($516f3ebf7dc9f3d4$var$ue, {
        ref: n,
        ...t
    }));
}
let $516f3ebf7dc9f3d4$var$q = (0, $efef981be50c1ac4$export$e43f39796049410c)($516f3ebf7dc9f3d4$var$Fe), $516f3ebf7dc9f3d4$var$ue = (0, $efef981be50c1ac4$export$e43f39796049410c)($516f3ebf7dc9f3d4$var$He), $516f3ebf7dc9f3d4$var$Le = (0, $efef981be50c1ac4$export$e43f39796049410c)($516f3ebf7dc9f3d4$var$_e), $516f3ebf7dc9f3d4$export$be58926105124dd4 = Object.assign($516f3ebf7dc9f3d4$var$q, {
    Child: $516f3ebf7dc9f3d4$var$Le,
    Root: $516f3ebf7dc9f3d4$var$q
});


var $b9c536326972e77d$export$9656cfe2bd6e411f;
(function(PopupType) {
    PopupType[PopupType["Warning"] = 0] = "Warning";
    PopupType[PopupType["Info"] = 1] = "Info";
    PopupType[PopupType["Success"] = 2] = "Success";
    PopupType[PopupType["Black"] = 3] = "Black";
})($b9c536326972e77d$export$9656cfe2bd6e411f || ($b9c536326972e77d$export$9656cfe2bd6e411f = {}));
const $b9c536326972e77d$var$colors = {
    [0]: "red",
    [3]: "gray",
    [1]: "primary",
    [2]: "green"
};
const $b9c536326972e77d$var$Modal = ({ open: open, iconNode: iconNode, icon: Icon, onClose: onClose, children: children, type: type = 1, title: title = "", description: description = "" })=>{
    const color = $b9c536326972e77d$var$colors[type];
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $516f3ebf7dc9f3d4$export$be58926105124dd4).Root, {
        show: open,
        as: (0, $3QbnI.Fragment),
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $31a47c4fe4fc06e8$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-50",
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $516f3ebf7dc9f3d4$export$be58926105124dd4).Child, {
                    as: (0, $3QbnI.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                        className: "flex min-h-full items-end justify-center md:p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $516f3ebf7dc9f3d4$export$be58926105124dd4).Child, {
                            as: (0, $3QbnI.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $31a47c4fe4fc06e8$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-sm sm:p-6",
                                children: [
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                        children: [
                                            iconNode && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                className: `mx-auto flex items-center justify-center`,
                                                children: iconNode
                                            }),
                                            Icon && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                className: `mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-${color}-100`,
                                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(Icon, {
                                                    className: `h-6 w-6 text-${color}-600`,
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                className: "mt-1 text-center",
                                                children: title && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $31a47c4fe4fc06e8$export$3ddf2d174ce01153).Title, {
                                                    as: "h3",
                                                    className: "text-lg md:text-xl font-medium md:font-semibold leading-6 text-gray-900",
                                                    children: title
                                                })
                                            }),
                                            description && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                className: "mt-3 text-center sm:mt-5",
                                                children: description && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                    className: "mt-2",
                                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                        className: "text-sm text-gray-500",
                                                        children: description
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                        className: "mt-5 sm:mt-6",
                                        children: children
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
var $b9c536326972e77d$export$2e2bcd8739ae039 = $b9c536326972e77d$var$Modal;





const $08c6359faa91c4f1$var$ImportHelpPopup = ({ open: open, onClose: onClose })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const officialWebsites = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $e55c7c0b1e5b11b1$export$e141af6c897b69ed));
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        description: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
            children: [
                t("CookBook officially support recipe import from the following websites"),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    className: "overflow-auto h-96 p-1 my-3",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("ul", {
                        className: "ml-10 my-1",
                        children: officialWebsites.map((w)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("a", {
                                    className: "text-indigo-600 hover:text-primary-500",
                                    href: `https://${w}`,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: w
                                })
                            }, w))
                    })
                }),
                t("However import from other websites containing recipes might work too. If your recipe was not imported successfully, let us know by write a "),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("a", {
                    className: "text-indigo-600 hover:text-primary-500",
                    href: "https://github.com/friedrith/cookbook/issues/new?assignees=&labels=issue%3A+proposal%2C+needs+triage&template=proposal.md",
                    target: "_blank",
                    rel: "noreferrer",
                    children: t("proposal")
                }),
                t(" or contact us at "),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("a", {
                    className: "text-indigo-600 hover:text-primary-500",
                    href: "mailto:thibault.friedrich@gmail.com",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "thibault.friedrich@gmail.com"
                })
            ]
        }),
        title: t("import.Import from a recipe catalog"),
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Black, {
                className: "w-full",
                onClick: onClose,
                children: t("_Ok Got it")
            })
        })
    });
};
var $08c6359faa91c4f1$export$2e2bcd8739ae039 = $08c6359faa91c4f1$var$ImportHelpPopup;



var $3QbnI = parcelRequire("3QbnI");
const $4e9e193b5c2ac11b$var$usePopup = (initialState = false)=>{
    const [isOpen, setIsOpen] = (0, $3QbnI.useState)(initialState);
    const open = ()=>setIsOpen(true);
    const close = ()=>setIsOpen(false);
    return {
        isOpen: isOpen,
        open: open,
        close: close,
        toggle: ()=>isOpen ? close() : open()
    };
};
var $4e9e193b5c2ac11b$export$2e2bcd8739ae039 = $4e9e193b5c2ac11b$var$usePopup;


const $ee3724e879d65813$var$faqs = [
    [
        {
            question: "email-not-visible._question",
            answer: "email-not-visible._answer"
        },
        {
            question: "website-list._question",
            answer: "website-list._answer"
        }
    ],
    [
        {
            question: "why-magic-link._question",
            answer: "why-magic-link._answer"
        },
        {
            question: "website-not-working._question",
            answer: "website-not-working._answer"
        }
    ],
    [
        {
            question: "why-not-proposing._question",
            answer: "why-not-proposing._answer"
        }
    ]
];
const $ee3724e879d65813$var$Faqs = ()=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("faq");
    const importHelpPopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    const Link = ({ children: children })=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("button", {
            onClick: importHelpPopup.open,
            className: "text-indigo-600 hover:text-primary-500 cursor-pointer",
            children: children
        });
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("section", {
        id: "faqs",
        "aria-labelledby": "faqs-title",
        className: "border-t border-gray-200 py-20 sm:py-32",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "mx-auto max-w-2xl lg:mx-0",
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h2", {
                                id: "faqs-title",
                                className: "text-3xl font-medium tracking-tight text-gray-900",
                                children: t("Frequently asked questions")
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("p", {
                                className: "mt-2 text-lg text-gray-600",
                                children: [
                                    t("If you have anything else you want to ask,"),
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("a", {
                                        href: "mailto:thibault.friedrich@gmail.com",
                                        className: "text-gray-900 underline",
                                        children: t("reach out to us")
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("ul", {
                        className: "mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 sm:mt-20 lg:max-w-none lg:grid-cols-3",
                        children: $ee3724e879d65813$var$faqs.map((column, columnIndex)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("ul", {
                                    className: "space-y-10",
                                    children: column.map((faq, faqIndex)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h3", {
                                                    className: "text-lg font-semibold leading-6 text-gray-900",
                                                    children: t(faq.question)
                                                }),
                                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                                                    className: "mt-4 text-sm text-gray-700",
                                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $242f1f28d80c68d3$export$8d6a9236f2e3f2ce), {
                                                        i18nKey: t(faq.answer),
                                                        components: {
                                                            Link: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(Link, {})
                                                        }
                                                    })
                                                })
                                            ]
                                        }, faqIndex))
                                })
                            }, columnIndex))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $08c6359faa91c4f1$export$2e2bcd8739ae039), {
                open: importHelpPopup.isOpen,
                onClose: importHelpPopup.close
            })
        ]
    });
};
var $ee3724e879d65813$export$2e2bcd8739ae039 = $ee3724e879d65813$var$Faqs;


class $fb882a1fb757da57$var$Scroll {
    onScroll(v) {
        this.scroll = v;
    }
    constructor(){
        this.scroll = 0;
    }
}
const $fb882a1fb757da57$var$rememberScroll = ()=>new $fb882a1fb757da57$var$Scroll();
var $fb882a1fb757da57$export$2e2bcd8739ae039 = $fb882a1fb757da57$var$rememberScroll;


const $1302b8474027e87c$var$scroll = (0, $fb882a1fb757da57$export$2e2bcd8739ae039)();
const $1302b8474027e87c$export$355f3d6a1f8b250c = ()=>{
    const { hash: hash } = (0, $e724dc7e3b3eec8a$export$45d76561a5302f2b)();
    const questionId = hash.slice(1);
    (0, $3QbnI.useEffect)(()=>{
        document.getElementById(questionId)?.scrollIntoView();
    }, [
        questionId
    ]);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e91e729a6066c3b7$export$2e2bcd8739ae039), {
        scroll: $1302b8474027e87c$var$scroll.scroll,
        onScroll: (v)=>$1302b8474027e87c$var$scroll.onScroll(v),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $3b62850daa0ffbbd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $35610cccd34beda1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $3255d5eba7754f90$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f10cfa97c13556c2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $21456271412505c0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ee3724e879d65813$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $190bc710ce4d30fe$export$2e2bcd8739ae039), {})
        ]
    });
};
var $1302b8474027e87c$export$2e2bcd8739ae039 = $1302b8474027e87c$export$355f3d6a1f8b250c;




var $3QbnI = parcelRequire("3QbnI");






var $3QbnI = parcelRequire("3QbnI");


var $3QbnI = parcelRequire("3QbnI");
function $a430323085bba83a$var$MagnifyingGlassIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z",
        clipRule: "evenodd"
    }));
}
const $a430323085bba83a$var$ForwardRef = $3QbnI.forwardRef($a430323085bba83a$var$MagnifyingGlassIcon);
var $a430323085bba83a$export$2e2bcd8739ae039 = $a430323085bba83a$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $b9c44658f5039ce5$var$PlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        d: "M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"
    }));
}
const $b9c44658f5039ce5$var$ForwardRef = $3QbnI.forwardRef($b9c44658f5039ce5$var$PlusIcon);
var $b9c44658f5039ce5$export$2e2bcd8739ae039 = $b9c44658f5039ce5$var$ForwardRef;





/* This example requires Tailwind CSS v2.0+ */ 

var $3QbnI = parcelRequire("3QbnI");



var $3QbnI = parcelRequire("3QbnI");
/** @deprecated */ function $b3448e465f742ebc$var$ArrowRightOnRectangleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
    }));
}
const $b3448e465f742ebc$var$ForwardRef = $3QbnI.forwardRef($b3448e465f742ebc$var$ArrowRightOnRectangleIcon);
var $b3448e465f742ebc$export$2e2bcd8739ae039 = $b3448e465f742ebc$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $635a3877126a4f0f$var$ArrowTopRightOnSquareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
    }));
}
const $635a3877126a4f0f$var$ForwardRef = $3QbnI.forwardRef($635a3877126a4f0f$var$ArrowTopRightOnSquareIcon);
var $635a3877126a4f0f$export$2e2bcd8739ae039 = $635a3877126a4f0f$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $9d5c67811f5faceb$var$CogIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077 1.41-.513m14.095-5.13 1.41-.513M5.106 17.785l1.15-.964m11.49-9.642 1.149-.964M7.501 19.795l.75-1.3m7.5-12.99.75-1.3m-6.063 16.658.26-1.477m2.605-14.772.26-1.477m0 17.726-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205 12 12m6.894 5.785-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
    }));
}
const $9d5c67811f5faceb$var$ForwardRef = $3QbnI.forwardRef($9d5c67811f5faceb$var$CogIcon);
var $9d5c67811f5faceb$export$2e2bcd8739ae039 = $9d5c67811f5faceb$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $46a779f6e20353fb$var$EllipsisVerticalIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
    }));
}
const $46a779f6e20353fb$var$ForwardRef = $3QbnI.forwardRef($46a779f6e20353fb$var$EllipsisVerticalIcon);
var $46a779f6e20353fb$export$2e2bcd8739ae039 = $46a779f6e20353fb$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $59ea0288aa19d2df$var$QuestionMarkCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
    }));
}
const $59ea0288aa19d2df$var$ForwardRef = $3QbnI.forwardRef($59ea0288aa19d2df$var$QuestionMarkCircleIcon);
var $59ea0288aa19d2df$export$2e2bcd8739ae039 = $59ea0288aa19d2df$var$ForwardRef;







var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");









var $3QbnI = parcelRequire("3QbnI");
let $a5dda373e8ac8e7f$var$a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $a5dda373e8ac8e7f$var$o(e) {
    var r, i;
    let n = (r = e.innerText) != null ? r : "", t = e.cloneNode(!0);
    if (!(t instanceof HTMLElement)) return n;
    let u = !1;
    for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(), u = !0;
    let l = u ? (i = t.innerText) != null ? i : "" : n;
    return $a5dda373e8ac8e7f$var$a.test(l) && (l = l.replace($a5dda373e8ac8e7f$var$a, "")), l;
}
function $a5dda373e8ac8e7f$export$6ca03cb7b75bfa13(e) {
    let n = e.getAttribute("aria-label");
    if (typeof n == "string") return n.trim();
    let t = e.getAttribute("aria-labelledby");
    if (t) {
        let u = t.split(" ").map((l)=>{
            let r = document.getElementById(l);
            if (r) {
                let i = r.getAttribute("aria-label");
                return typeof i == "string" ? i.trim() : $a5dda373e8ac8e7f$var$o(r).trim();
            }
            return null;
        }).filter(Boolean);
        if (u.length > 0) return u.join(", ");
    }
    return $a5dda373e8ac8e7f$var$o(e).trim();
}



function $c1db8ea7eacd3dc4$export$f6862afd851a1cf4(c) {
    let t = (0, $3QbnI.useRef)(""), r = (0, $3QbnI.useRef)("");
    return (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        let e = c.current;
        if (!e) return "";
        let u = e.innerText;
        if (t.current === u) return r.current;
        let n = (0, $a5dda373e8ac8e7f$export$6ca03cb7b75bfa13)(e).trim().toLowerCase();
        return t.current = u, r.current = n, n;
    });
}



var $3QbnI = parcelRequire("3QbnI");
function $d0ac0c39b24241f0$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $d0ac0c39b24241f0$export$24ebee078bde85c3() {
    let e = (0, $3QbnI.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $d0ac0c39b24241f0$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $d0ac0c39b24241f0$var$t(r);
        }
    };
}



var $3QbnI = parcelRequire("3QbnI");


function $bebedd956eb7ca52$export$b0abce39eb34b36({ container: e, accept: t, walk: r, enabled: c = !0 }) {
    let o = (0, $3QbnI.useRef)(t), l = (0, $3QbnI.useRef)(r);
    (0, $3QbnI.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        if (!e || !c) return;
        let n = (0, $a37d5afd1ae25fcd$export$b204af158042fbac)(e);
        if (!n) return;
        let f = o.current, p = l.current, d = Object.assign((i)=>f(i), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, d, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}




function $fb72fa9b06eb0bfd$var$u(l) {
    throw new Error("Unexpected object: " + l);
}
var $fb72fa9b06eb0bfd$export$807a7eae502106e7 = ((i)=>(i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))($fb72fa9b06eb0bfd$export$807a7eae502106e7 || {});
function $fb72fa9b06eb0bfd$export$c6b4626b54936d5e(l, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let r = n.resolveActiveIndex(), s = r != null ? r : -1;
    switch(l.focus){
        case 0:
            for(let e = 0; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 1:
            for(let e = s - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 2:
            for(let e = s + 1; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 3:
            for(let e = t.length - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 4:
            for(let e = 0; e < t.length; ++e)if (n.resolveId(t[e], e, t) === l.id) return e;
            return r;
        case 5:
            return null;
        default:
            $fb72fa9b06eb0bfd$var$u(l);
    }
}







var $a3d783c4de92f5d0$var$me = ((r)=>(r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r))($a3d783c4de92f5d0$var$me || {}), $a3d783c4de92f5d0$var$de = ((r)=>(r[r.Pointer = 0] = "Pointer", r[r.Other = 1] = "Other", r))($a3d783c4de92f5d0$var$de || {}), $a3d783c4de92f5d0$var$fe = ((a)=>(a[a.OpenMenu = 0] = "OpenMenu", a[a.CloseMenu = 1] = "CloseMenu", a[a.GoToItem = 2] = "GoToItem", a[a.Search = 3] = "Search", a[a.ClearSearch = 4] = "ClearSearch", a[a.RegisterItem = 5] = "RegisterItem", a[a.UnregisterItem = 6] = "UnregisterItem", a))($a3d783c4de92f5d0$var$fe || {});
function $a3d783c4de92f5d0$var$w(e, u = (r)=>r) {
    let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, s = (0, $6e492986e168be71$export$20305e96f91bf103)(u(e.items.slice()), (t)=>t.dataRef.current.domRef.current), i = r ? s.indexOf(r) : null;
    return i === -1 && (i = null), {
        items: s,
        activeItemIndex: i
    };
}
let $a3d783c4de92f5d0$var$Te = {
    [1] (e) {
        return e.menuState === 1 ? e : {
            ...e,
            activeItemIndex: null,
            menuState: 1
        };
    },
    [0] (e) {
        return e.menuState === 0 ? e : {
            ...e,
            __demoMode: !1,
            menuState: 0
        };
    },
    [2]: (e, u)=>{
        var i;
        let r = $a3d783c4de92f5d0$var$w(e), s = (0, $fb72fa9b06eb0bfd$export$c6b4626b54936d5e)(u, {
            resolveItems: ()=>r.items,
            resolveActiveIndex: ()=>r.activeItemIndex,
            resolveId: (t)=>t.id,
            resolveDisabled: (t)=>t.dataRef.current.disabled
        });
        return {
            ...e,
            ...r,
            searchQuery: "",
            activeItemIndex: s,
            activationTrigger: (i = u.trigger) != null ? i : 1
        };
    },
    [3]: (e, u)=>{
        let s = e.searchQuery !== "" ? 0 : 1, i = e.searchQuery + u.value.toLowerCase(), o = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + s).concat(e.items.slice(0, e.activeItemIndex + s)) : e.items).find((l)=>{
            var m;
            return ((m = l.dataRef.current.textValue) == null ? void 0 : m.startsWith(i)) && !l.dataRef.current.disabled;
        }), a = o ? e.items.indexOf(o) : -1;
        return a === -1 || a === e.activeItemIndex ? {
            ...e,
            searchQuery: i
        } : {
            ...e,
            searchQuery: i,
            activeItemIndex: a,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.searchQuery === "" ? e : {
            ...e,
            searchQuery: "",
            searchActiveItemIndex: null
        };
    },
    [5]: (e, u)=>{
        let r = $a3d783c4de92f5d0$var$w(e, (s)=>[
                ...s,
                {
                    id: u.id,
                    dataRef: u.dataRef
                }
            ]);
        return {
            ...e,
            ...r
        };
    },
    [6]: (e, u)=>{
        let r = $a3d783c4de92f5d0$var$w(e, (s)=>{
            let i = s.findIndex((t)=>t.id === u.id);
            return i !== -1 && s.splice(i, 1), s;
        });
        return {
            ...e,
            ...r,
            activationTrigger: 1
        };
    }
}, $a3d783c4de92f5d0$var$U = (0, $3QbnI.createContext)(null);
$a3d783c4de92f5d0$var$U.displayName = "MenuContext";
function $a3d783c4de92f5d0$var$C(e) {
    let u = (0, $3QbnI.useContext)($a3d783c4de92f5d0$var$U);
    if (u === null) {
        let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(r, $a3d783c4de92f5d0$var$C), r;
    }
    return u;
}
function $a3d783c4de92f5d0$var$ye(e, u) {
    return (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(u.type, $a3d783c4de92f5d0$var$Te, e, u);
}
let $a3d783c4de92f5d0$var$Ie = (0, $3QbnI.Fragment);
function $a3d783c4de92f5d0$var$Me(e, u) {
    let { __demoMode: r = !1, ...s } = e, i = (0, $3QbnI.useReducer)($a3d783c4de92f5d0$var$ye, {
        __demoMode: r,
        menuState: r ? 0 : 1,
        buttonRef: (0, $3QbnI.createRef)(),
        itemsRef: (0, $3QbnI.createRef)(),
        items: [],
        searchQuery: "",
        activeItemIndex: null,
        activationTrigger: 1
    }), [{ menuState: t, itemsRef: o, buttonRef: a }, l] = i, m = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(u);
    (0, $fe5967a5f12b8ede$export$71b2224f1ce5e08e)([
        a,
        o
    ], (g, R)=>{
        var p;
        l({
            type: 1
        }), (0, $6e492986e168be71$export$ff1ec1c740b3c8d5)(R, (0, $6e492986e168be71$export$27112a34f2f8402d).Loose) || (g.preventDefault(), (p = a.current) == null || p.focus());
    }, t === 0);
    let I = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        l({
            type: 1
        });
    }), A = (0, $3QbnI.useMemo)(()=>({
            open: t === 0,
            close: I
        }), [
        t,
        I
    ]), f = {
        ref: m
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($a3d783c4de92f5d0$var$U.Provider, {
        value: i
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $379c3428ac0bb4a2$export$2a0ed818b175f558), {
        value: (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(t, {
            [0]: (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open,
            [1]: (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Closed
        })
    }, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: f,
        theirProps: s,
        slot: A,
        defaultTag: $a3d783c4de92f5d0$var$Ie,
        name: "Menu"
    })));
}
let $a3d783c4de92f5d0$var$ge = "button";
function $a3d783c4de92f5d0$var$Re(e, u) {
    var R;
    let r = (0, $32e547b031070140$export$f680877a34711e37)(), { id: s = `headlessui-menu-button-${r}`, ...i } = e, [t, o] = $a3d783c4de92f5d0$var$C("Menu.Button"), a = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(t.buttonRef, u), l = (0, $c86664fa6151526e$export$fd183955ff4b45d9)(), m = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((p)=>{
        switch(p.key){
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space:
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Enter:
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).ArrowDown:
                p.preventDefault(), p.stopPropagation(), o({
                    type: 0
                }), l.nextFrame(()=>o({
                        type: 2,
                        focus: (0, $fb72fa9b06eb0bfd$export$807a7eae502106e7).First
                    }));
                break;
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).ArrowUp:
                p.preventDefault(), p.stopPropagation(), o({
                    type: 0
                }), l.nextFrame(()=>o({
                        type: 2,
                        focus: (0, $fb72fa9b06eb0bfd$export$807a7eae502106e7).Last
                    }));
                break;
        }
    }), I = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((p)=>{
        switch(p.key){
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space:
                p.preventDefault();
                break;
        }
    }), A = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((p)=>{
        if ((0, $9fde5a40ffbcb074$export$db61f031a278447c)(p.currentTarget)) return p.preventDefault();
        e.disabled || (t.menuState === 0 ? (o({
            type: 1
        }), l.nextFrame(()=>{
            var M;
            return (M = t.buttonRef.current) == null ? void 0 : M.focus({
                preventScroll: !0
            });
        })) : (p.preventDefault(), o({
            type: 0
        })));
    }), f = (0, $3QbnI.useMemo)(()=>({
            open: t.menuState === 0
        }), [
        t
    ]), g = {
        ref: a,
        id: s,
        type: (0, $63b58a1e835cc3d1$export$53652b2b272efe9c)(e, t.buttonRef),
        "aria-haspopup": "menu",
        "aria-controls": (R = t.itemsRef.current) == null ? void 0 : R.id,
        "aria-expanded": t.menuState === 0,
        onKeyDown: m,
        onKeyUp: I,
        onClick: A
    };
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: g,
        theirProps: i,
        slot: f,
        defaultTag: $a3d783c4de92f5d0$var$ge,
        name: "Menu.Button"
    });
}
let $a3d783c4de92f5d0$var$Ae = "div", $a3d783c4de92f5d0$var$be = (0, $efef981be50c1ac4$export$617d79dae526d2cf).RenderStrategy | (0, $efef981be50c1ac4$export$617d79dae526d2cf).Static;
function $a3d783c4de92f5d0$var$Ee(e, u) {
    var M, b;
    let r = (0, $32e547b031070140$export$f680877a34711e37)(), { id: s = `headlessui-menu-items-${r}`, ...i } = e, [t, o] = $a3d783c4de92f5d0$var$C("Menu.Items"), a = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(t.itemsRef, u), l = (0, $0225316d43e68597$export$dd9fbcea3de0ae36)(t.itemsRef), m = (0, $c86664fa6151526e$export$fd183955ff4b45d9)(), I = (0, $379c3428ac0bb4a2$export$fc6fdf0ecf360e)(), A = (()=>I !== null ? (I & (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open) === (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open : t.menuState === 0)();
    (0, $3QbnI.useEffect)(()=>{
        let n = t.itemsRef.current;
        n && t.menuState === 0 && n !== (l == null ? void 0 : l.activeElement) && n.focus({
            preventScroll: !0
        });
    }, [
        t.menuState,
        t.itemsRef,
        l
    ]), (0, $bebedd956eb7ca52$export$b0abce39eb34b36)({
        container: t.itemsRef.current,
        enabled: t.menuState === 0,
        accept (n) {
            return n.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : n.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (n) {
            n.setAttribute("role", "none");
        }
    });
    let f = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((n)=>{
        var E, x;
        switch(m.dispose(), n.key){
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space:
                if (t.searchQuery !== "") return n.preventDefault(), n.stopPropagation(), o({
                    type: 3,
                    value: n.key
                });
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Enter:
                if (n.preventDefault(), n.stopPropagation(), o({
                    type: 1
                }), t.activeItemIndex !== null) {
                    let { dataRef: S } = t.items[t.activeItemIndex];
                    (x = (E = S.current) == null ? void 0 : E.domRef.current) == null || x.click();
                }
                (0, $6e492986e168be71$export$46388676ec35ab85)(t.buttonRef.current);
                break;
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).ArrowDown:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $fb72fa9b06eb0bfd$export$807a7eae502106e7).Next
                });
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).ArrowUp:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $fb72fa9b06eb0bfd$export$807a7eae502106e7).Previous
                });
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Home:
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).PageUp:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $fb72fa9b06eb0bfd$export$807a7eae502106e7).First
                });
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).End:
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).PageDown:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $fb72fa9b06eb0bfd$export$807a7eae502106e7).Last
                });
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Escape:
                n.preventDefault(), n.stopPropagation(), o({
                    type: 1
                }), (0, $7b478da02baf897f$export$12b26c28a05aa001)().nextFrame(()=>{
                    var S;
                    return (S = t.buttonRef.current) == null ? void 0 : S.focus({
                        preventScroll: !0
                    });
                });
                break;
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Tab:
                n.preventDefault(), n.stopPropagation(), o({
                    type: 1
                }), (0, $7b478da02baf897f$export$12b26c28a05aa001)().nextFrame(()=>{
                    (0, $6e492986e168be71$export$7fb6c844b485e870)(t.buttonRef.current, n.shiftKey ? (0, $6e492986e168be71$export$807a7eae502106e7).Previous : (0, $6e492986e168be71$export$807a7eae502106e7).Next);
                });
                break;
            default:
                n.key.length === 1 && (o({
                    type: 3,
                    value: n.key
                }), m.setTimeout(()=>o({
                        type: 4
                    }), 350));
                break;
        }
    }), g = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((n)=>{
        switch(n.key){
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space:
                n.preventDefault();
                break;
        }
    }), R = (0, $3QbnI.useMemo)(()=>({
            open: t.menuState === 0
        }), [
        t
    ]), p = {
        "aria-activedescendant": t.activeItemIndex === null || (M = t.items[t.activeItemIndex]) == null ? void 0 : M.id,
        "aria-labelledby": (b = t.buttonRef.current) == null ? void 0 : b.id,
        id: s,
        onKeyDown: f,
        onKeyUp: g,
        role: "menu",
        tabIndex: 0,
        ref: a
    };
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: p,
        theirProps: i,
        slot: R,
        defaultTag: $a3d783c4de92f5d0$var$Ae,
        features: $a3d783c4de92f5d0$var$be,
        visible: A,
        name: "Menu.Items"
    });
}
let $a3d783c4de92f5d0$var$Se = (0, $3QbnI.Fragment);
function $a3d783c4de92f5d0$var$xe(e, u) {
    let r = (0, $32e547b031070140$export$f680877a34711e37)(), { id: s = `headlessui-menu-item-${r}`, disabled: i = !1, ...t } = e, [o, a] = $a3d783c4de92f5d0$var$C("Menu.Item"), l = o.activeItemIndex !== null ? o.items[o.activeItemIndex].id === s : !1, m = (0, $3QbnI.useRef)(null), I = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(u, m);
    (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        if (o.__demoMode || o.menuState !== 0 || !l || o.activationTrigger === 0) return;
        let T = (0, $7b478da02baf897f$export$12b26c28a05aa001)();
        return T.requestAnimationFrame(()=>{
            var P, B;
            (B = (P = m.current) == null ? void 0 : P.scrollIntoView) == null || B.call(P, {
                block: "nearest"
            });
        }), T.dispose;
    }, [
        o.__demoMode,
        m,
        l,
        o.menuState,
        o.activationTrigger,
        o.activeItemIndex
    ]);
    let A = (0, $c1db8ea7eacd3dc4$export$f6862afd851a1cf4)(m), f = (0, $3QbnI.useRef)({
        disabled: i,
        domRef: m,
        get textValue () {
            return A();
        }
    });
    (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>{
        f.current.disabled = i;
    }, [
        f,
        i
    ]), (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>(a({
            type: 5,
            id: s,
            dataRef: f
        }), ()=>a({
                type: 6,
                id: s
            })), [
        f,
        s
    ]);
    let g = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        a({
            type: 1
        });
    }), R = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((T)=>{
        if (i) return T.preventDefault();
        a({
            type: 1
        }), (0, $6e492986e168be71$export$46388676ec35ab85)(o.buttonRef.current);
    }), p = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        if (i) return a({
            type: 2,
            focus: (0, $fb72fa9b06eb0bfd$export$807a7eae502106e7).Nothing
        });
        a({
            type: 2,
            focus: (0, $fb72fa9b06eb0bfd$export$807a7eae502106e7).Specific,
            id: s
        });
    }), M = (0, $d0ac0c39b24241f0$export$24ebee078bde85c3)(), b = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((T)=>M.update(T)), n = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((T)=>{
        M.wasMoved(T) && (i || l || a({
            type: 2,
            focus: (0, $fb72fa9b06eb0bfd$export$807a7eae502106e7).Specific,
            id: s,
            trigger: 0
        }));
    }), E = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((T)=>{
        M.wasMoved(T) && (i || l && a({
            type: 2,
            focus: (0, $fb72fa9b06eb0bfd$export$807a7eae502106e7).Nothing
        }));
    }), x = (0, $3QbnI.useMemo)(()=>({
            active: l,
            disabled: i,
            close: g
        }), [
        l,
        i,
        g
    ]);
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: {
            id: s,
            ref: I,
            role: "menuitem",
            tabIndex: i === !0 ? void 0 : -1,
            "aria-disabled": i === !0 ? !0 : void 0,
            disabled: void 0,
            onClick: R,
            onFocus: p,
            onPointerEnter: b,
            onMouseEnter: b,
            onPointerMove: n,
            onMouseMove: n,
            onPointerLeave: E,
            onMouseLeave: E
        },
        theirProps: t,
        slot: x,
        defaultTag: $a3d783c4de92f5d0$var$Se,
        name: "Menu.Item"
    });
}
let $a3d783c4de92f5d0$var$Pe = (0, $efef981be50c1ac4$export$e43f39796049410c)($a3d783c4de92f5d0$var$Me), $a3d783c4de92f5d0$var$ve = (0, $efef981be50c1ac4$export$e43f39796049410c)($a3d783c4de92f5d0$var$Re), $a3d783c4de92f5d0$var$he = (0, $efef981be50c1ac4$export$e43f39796049410c)($a3d783c4de92f5d0$var$Ee), $a3d783c4de92f5d0$var$De = (0, $efef981be50c1ac4$export$e43f39796049410c)($a3d783c4de92f5d0$var$xe), $a3d783c4de92f5d0$export$d9b273488cd8ce6f = Object.assign($a3d783c4de92f5d0$var$Pe, {
    Button: $a3d783c4de92f5d0$var$ve,
    Items: $a3d783c4de92f5d0$var$he,
    Item: $a3d783c4de92f5d0$var$De
});


const $a41e8173b02d5c7f$var$MenuItem = /*#__PURE__*/ (0, $3QbnI.forwardRef)(({ icon: Icon, onClick: onClick, children: children, disabled: disabled, className: className }, ref)=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a3d783c4de92f5d0$export$d9b273488cd8ce6f).Item, {
        children: ({ active: active })=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("button", {
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))(className, disabled ? "opacity-50" : "", active ? "bg-gray-100" : "", "group block px-4 py-2 text-sm text-gray-700 cursor-pointer w-full flex items-center hover:bg-gray-100 hover:text-gray-900 relative z-auto whitespace-nowrap"),
                onClick: onClick,
                disabled: disabled,
                children: [
                    Icon && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(Icon, {
                        className: "inline h-6 w-6 ltr:mr-2 rtl:ml-2 text-gray-400 group-hover:text-gray-500",
                        "aria-hidden": "true"
                    }),
                    children
                ]
            })
    });
});
var $a41e8173b02d5c7f$export$2e2bcd8739ae039 = $a41e8173b02d5c7f$var$MenuItem;




var $3QbnI = parcelRequire("3QbnI");

const $742ff826c2da0ee7$var$CustomMenu = ({ menuButton: menuButton, menuButtonClassName: menuButtonClassName, children: children, as: as })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a3d783c4de92f5d0$export$d9b273488cd8ce6f), {
        as: "div",
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a3d783c4de92f5d0$export$d9b273488cd8ce6f).Button, {
                as: as,
                className: menuButtonClassName,
                children: menuButton
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $516f3ebf7dc9f3d4$export$be58926105124dd4), {
                as: (0, $3QbnI.Fragment),
                enter: "transition ease-out duration-200",
                enterFrom: "transform opacity-0 scale-95",
                enterTo: "transform opacity-100 scale-100",
                leave: "transition ease-in duration-75",
                leaveFrom: "transform opacity-100 scale-100",
                leaveTo: "transform opacity-0 scale-95",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a3d783c4de92f5d0$export$d9b273488cd8ce6f).Items, {
                    className: "absolute ltr:right-0 ltr:origin-top-right rtl:left-0 rtl:origin-top-left z-40 mt-2 w-48  rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                    children: children
                })
            })
        ]
    });
};
var $742ff826c2da0ee7$export$2e2bcd8739ae039 = $742ff826c2da0ee7$var$CustomMenu;



const $ec37006dda574bbc$var$useBeforeInstallPrompt = (callback)=>{
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("beforeinstallprompt", (event)=>{
        event.preventDefault();
        callback(event);
    });
};
var $ec37006dda574bbc$export$2e2bcd8739ae039 = $ec37006dda574bbc$var$useBeforeInstallPrompt;






var $3QbnI = parcelRequire("3QbnI");
function $76466633f364042e$var$BugAntIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
    }));
}
const $76466633f364042e$var$ForwardRef = $3QbnI.forwardRef($76466633f364042e$var$BugAntIcon);
var $76466633f364042e$export$2e2bcd8739ae039 = $76466633f364042e$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $300e1b32a8fb1e73$var$ChatBubbleBottomCenterTextIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
    }));
}
const $300e1b32a8fb1e73$var$ForwardRef = $3QbnI.forwardRef($300e1b32a8fb1e73$var$ChatBubbleBottomCenterTextIcon);
var $300e1b32a8fb1e73$export$2e2bcd8739ae039 = $300e1b32a8fb1e73$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $10662a0f43dbf305$var$LifebuoyIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.712 4.33a9.027 9.027 0 0 1 1.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 0 0-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 0 1 0 9.424m-4.138-5.976a3.736 3.736 0 0 0-.88-1.388 3.737 3.737 0 0 0-1.388-.88m2.268 2.268a3.765 3.765 0 0 1 0 2.528m-2.268-4.796a3.765 3.765 0 0 0-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 0 1-1.388.88m2.268-2.268 4.138 3.448m0 0a9.027 9.027 0 0 1-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0-3.448-4.138m3.448 4.138a9.014 9.014 0 0 1-9.424 0m5.976-4.138a3.765 3.765 0 0 1-2.528 0m0 0a3.736 3.736 0 0 1-1.388-.88 3.737 3.737 0 0 1-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 0 1-1.652-1.306 9.027 9.027 0 0 1-1.306-1.652m0 0 4.138-3.448M4.33 16.712a9.014 9.014 0 0 1 0-9.424m4.138 5.976a3.765 3.765 0 0 1 0-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 0 1 1.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 0 0-1.652 1.306A9.025 9.025 0 0 0 4.33 7.288"
    }));
}
const $10662a0f43dbf305$var$ForwardRef = $3QbnI.forwardRef($10662a0f43dbf305$var$LifebuoyIcon);
var $10662a0f43dbf305$export$2e2bcd8739ae039 = $10662a0f43dbf305$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $8caec240b93de644$var$SparklesIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
    }));
}
const $8caec240b93de644$var$ForwardRef = $3QbnI.forwardRef($8caec240b93de644$var$SparklesIcon);
var $8caec240b93de644$export$2e2bcd8739ae039 = $8caec240b93de644$var$ForwardRef;




var $47d4700db3a3167c$exports = {};
$47d4700db3a3167c$exports = JSON.parse('{"name":"cookbook","version":"0.1.2","private":true,"source":"src/index.html","staticFiles":{"staticPath":"public"},"scripts":{"start":"parcel","dev":"parcel","build":"parcel build","test":"jest","test:e2e":"pnpm playwright test","serve":"npx serve -s build","lint":"eslint --max-warnings=0 ./src/**/*.tsx ./public/locales/**/*.json","format":"prettier --check .","commitlint":"commitlint --from=c70a78dd8d08a2d528f0a1d2876070b879e17805","precommit":"pnpm lint && pnpm format && pnpm test && pnpm build"},"eslintIgnore":["build","node_modules"],"simple-git-hooks":{"pre-commit":"pnpm precommit"},"alias":{"process":"process/browser.js","buffer":"buffer"},"browserslist":"> 0.5%, last 2 versions, not dead","dependencies":{"@clerk/clerk-react":"^4.23.1","@clerk/types":"^3.31.0","@headlessui/react":"^1.6.2","@heroicons/react":"latest","@notionhq/client":"^1.0.4","@react-spring/web":"^9.7.1","@reduxjs/toolkit":"^1.8.1","@tensorflow-models/handpose":"^0.0.7","@tensorflow/tfjs":"^4.0.0","@types/lodash":"^4.14.188","@types/node":"^16.7.13","@types/react":"^18.0.0","@types/react-dom":"^18.0.0","@types/react-helmet":"^6.1.5","axios":"^0.27.2","classnames":"^2.3.1","clsx":"^1.2.1","file-saver":"^2.0.5","fingerpose":"^0.1.0","firebase":"^9.8.1","framer-motion":"^7.8.0","fuse.js":"^6.6.2","i18next":"^21.8.3","i18next-browser-languagedetector":"^6.1.4","i18next-http-backend":"^1.4.0","jszip":"^3.10.1","lodash":"^4.17.21","lord-icon-element":"^4.0.3","lottie-web":"^5.10.2","mixpanel-browser":"^2.45.0","nosleep.js":"^0.12.0","postcss":"^8.4.23","process":"^0.11.10","react":"^18.2.0","react-dnd":"^16.0.1","react-dnd-html5-backend":"^16.0.1","react-dom":"^18.1.0","react-helmet":"^6.1.0","react-helmet-async":"^1.3.0","react-i18next":"^11.16.9","react-input-autosize":"^3.0.0","react-parallax":"^3.5.1","react-redux":"^8.0.1","react-router-dom":"^6.11.1","react-speech-recognition":"^3.10.0","react-tag-input":"^6.8.0","react-textarea-autosize":"^8.3.4","react-tooltip":"^4.4.3","react-webcam":"^7.0.1","regenerator-runtime":"^0.13.11","tailwind":"^4.0.0","typescript":"^4.4.2","use-debounce":"^9.0.2","uuid":"^8.3.2","web-vitals":"^2.1.0"},"devDependencies":{"@axe-core/playwright":"^4.6.1","@commitlint/cli":"^17.5.1","@commitlint/config-conventional":"^17.4.4","@jest/globals":"^29.5.0","@parcel/config-default":"^2.8.3","@parcel/transformer-svg-react":"^2.8.3","@playwright/test":"^1.32.2","@tailwindcss/aspect-ratio":"^0.4.0","@tailwindcss/forms":"^0.5.2","@testing-library/jest-dom":"^5.17.0","@testing-library/react":"^13.0.0","@testing-library/user-event":"^13.2.1","@types/dom-screen-wake-lock":"^1.0.0","@types/file-saver":"^2.0.5","@types/jest":"^27.5.2","@types/mixpanel-browser":"^2.38.0","@types/react-input-autosize":"^2.2.1","@types/react-speech-recognition":"^3.9.0","@types/react-tag-input":"^6.1.3","@types/uuid":"^8.3.4","@typescript-eslint/eslint-plugin":"^5.59.6","@typescript-eslint/parser":"^5.59.6","brfs":"^2.0.2","buffer":"^5.7.1","eslint":"^8.24.0","eslint-config-prettier":"^8.5.0","eslint-import-resolver-parcel":"^1.10.6","eslint-plugin-i18n-json":"^4.0.0","eslint-plugin-i18next":"next","eslint-plugin-json":"^3.1.0","eslint-plugin-jsx-a11y":"^6.7.1","eslint-plugin-prettier":"^4.2.1","eslint-plugin-react":"^7.32.2","eslint-plugin-sonarjs":"^0.19.0","jest":"^29.5.0","jest-environment-jsdom":"^29.5.0","parcel":"^2.0.0","parcel-reporter-static-files-copy":"^1.5.0","prettier":"^2.6.2","serve-static":"^1.15.0","simple-git-hooks":"^2.8.0","tailwindcss":"^3.3.2","ts-jest":"^29.1.0"}}');


const $addd86142b6def57$var$resources = [
    {
        name: "Help Center",
        description: "Get all of your questions answered in our FAQ.",
        href: "/#faqs",
        icon: (0, $10662a0f43dbf305$export$2e2bcd8739ae039)
    },
    {
        name: "Report a bug",
        description: "Help us to understand your situation and fix it.",
        href: "https://github.com/friedrith/cookbook/issues/new?assignees=&labels=bug&template=bug_report.md&title=%5BBug%5D%3A+",
        icon: (0, $76466633f364042e$export$2e2bcd8739ae039),
        blank: true
    },
    {
        name: "Suggest a feature",
        description: "Tell us what is missing and how we can improve CookBook.",
        href: "https://github.com/friedrith/cookbook/issues/new?assignees=&labels=issue%3A+proposal%2C+needs+triage&template=proposal.md",
        icon: (0, $8caec240b93de644$export$2e2bcd8739ae039),
        blank: true
    },
    {
        name: "Contact us",
        description: "You can send an email at thibault.friedrich@gmail.com",
        href: "mailto:thibault.friedrich@gmail.com",
        icon: (0, $300e1b32a8fb1e73$export$2e2bcd8739ae039)
    }
];
const $addd86142b6def57$var$HelpPopup = ({ open: open, onClose: onClose })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("help");
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
        iconNode: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $2177ccffcfec9146$export$2e2bcd8739ae039), {
            className: "inline-flex"
        }),
        open: open,
        onClose: onClose,
        description: t("Version", {
            version: (0, (/*@__PURE__*/$parcel$interopDefault($47d4700db3a3167c$exports))).version
        }),
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
            className: "relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8",
            children: $addd86142b6def57$var$resources.map((item)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("a", {
                    href: item.href,
                    className: "-m-3 flex items-start rounded-lg p-3 transition duration-150 ease-in-out hover:bg-gray-50",
                    target: "_blank",
                    rel: "noreferrer",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(item.icon, {
                            className: "h-6 w-6 flex-shrink-0 text-primary-100",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                            className: "ml-4",
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                                    className: "text-base font-medium text-gray-900",
                                    children: t(item.name)
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                                    className: "mt-1 text-sm text-gray-500",
                                    children: t(item.description)
                                })
                            ]
                        })
                    ]
                }, item.name))
        })
    });
};
var $addd86142b6def57$export$2e2bcd8739ae039 = $addd86142b6def57$var$HelpPopup;









var $3QbnI = parcelRequire("3QbnI");










var $3QbnI = parcelRequire("3QbnI");
var $456197b827b26f6e$var$t;
let $456197b827b26f6e$export$7568632d0d33d16d = ($456197b827b26f6e$var$t = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).startTransition) != null ? $456197b827b26f6e$var$t : function(i) {
    i();
};



var $f4566e13631be5b1$var$Q = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($f4566e13631be5b1$var$Q || {}), $f4566e13631be5b1$var$V = ((t)=>(t[t.ToggleDisclosure = 0] = "ToggleDisclosure", t[t.CloseDisclosure = 1] = "CloseDisclosure", t[t.SetButtonId = 2] = "SetButtonId", t[t.SetPanelId = 3] = "SetPanelId", t[t.LinkPanel = 4] = "LinkPanel", t[t.UnlinkPanel = 5] = "UnlinkPanel", t))($f4566e13631be5b1$var$V || {});
let $f4566e13631be5b1$var$Y = {
    [0]: (e)=>({
            ...e,
            disclosureState: (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(e.disclosureState, {
                [0]: 1,
                [1]: 0
            })
        }),
    [1]: (e)=>e.disclosureState === 1 ? e : {
            ...e,
            disclosureState: 1
        },
    [4] (e) {
        return e.linkedPanel === !0 ? e : {
            ...e,
            linkedPanel: !0
        };
    },
    [5] (e) {
        return e.linkedPanel === !1 ? e : {
            ...e,
            linkedPanel: !1
        };
    },
    [2] (e, n) {
        return e.buttonId === n.buttonId ? e : {
            ...e,
            buttonId: n.buttonId
        };
    },
    [3] (e, n) {
        return e.panelId === n.panelId ? e : {
            ...e,
            panelId: n.panelId
        };
    }
}, $f4566e13631be5b1$var$M = (0, $3QbnI.createContext)(null);
$f4566e13631be5b1$var$M.displayName = "DisclosureContext";
function $f4566e13631be5b1$var$_(e) {
    let n = (0, $3QbnI.useContext)($f4566e13631be5b1$var$M);
    if (n === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $f4566e13631be5b1$var$_), o;
    }
    return n;
}
let $f4566e13631be5b1$var$v = (0, $3QbnI.createContext)(null);
$f4566e13631be5b1$var$v.displayName = "DisclosureAPIContext";
function $f4566e13631be5b1$var$K(e) {
    let n = (0, $3QbnI.useContext)($f4566e13631be5b1$var$v);
    if (n === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $f4566e13631be5b1$var$K), o;
    }
    return n;
}
let $f4566e13631be5b1$var$F = (0, $3QbnI.createContext)(null);
$f4566e13631be5b1$var$F.displayName = "DisclosurePanelContext";
function $f4566e13631be5b1$var$Z() {
    return (0, $3QbnI.useContext)($f4566e13631be5b1$var$F);
}
function $f4566e13631be5b1$var$ee(e, n) {
    return (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(n.type, $f4566e13631be5b1$var$Y, e, n);
}
let $f4566e13631be5b1$var$te = (0, $3QbnI.Fragment);
function $f4566e13631be5b1$var$ne(e, n) {
    let { defaultOpen: o = !1, ...i } = e, f = (0, $3QbnI.useRef)(null), l = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(n, (0, $2965c2f720720e02$export$7029785b750eb74)((u)=>{
        f.current = u;
    }, e.as === void 0 || e.as === (0, $3QbnI.Fragment))), t = (0, $3QbnI.useRef)(null), d = (0, $3QbnI.useRef)(null), s = (0, $3QbnI.useReducer)($f4566e13631be5b1$var$ee, {
        disclosureState: o ? 0 : 1,
        linkedPanel: !1,
        buttonRef: d,
        panelRef: t,
        buttonId: null,
        panelId: null
    }), [{ disclosureState: c, buttonId: a }, D] = s, p = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((u)=>{
        D({
            type: 1
        });
        let y = (0, $a37d5afd1ae25fcd$export$b204af158042fbac)(f);
        if (!y || !a) return;
        let r = (()=>u ? u instanceof HTMLElement ? u : u.current instanceof HTMLElement ? u.current : y.getElementById(a) : y.getElementById(a))();
        r == null || r.focus();
    }), P = (0, $3QbnI.useMemo)(()=>({
            close: p
        }), [
        p
    ]), T = (0, $3QbnI.useMemo)(()=>({
            open: c === 0,
            close: p
        }), [
        c,
        p
    ]), C = {
        ref: l
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($f4566e13631be5b1$var$M.Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($f4566e13631be5b1$var$v.Provider, {
        value: P
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $379c3428ac0bb4a2$export$2a0ed818b175f558), {
        value: (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(c, {
            [0]: (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open,
            [1]: (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Closed
        })
    }, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: C,
        theirProps: i,
        slot: T,
        defaultTag: $f4566e13631be5b1$var$te,
        name: "Disclosure"
    }))));
}
let $f4566e13631be5b1$var$le = "button";
function $f4566e13631be5b1$var$oe(e, n) {
    let o = (0, $32e547b031070140$export$f680877a34711e37)(), { id: i = `headlessui-disclosure-button-${o}`, ...f } = e, [l, t] = $f4566e13631be5b1$var$_("Disclosure.Button"), d = $f4566e13631be5b1$var$Z(), s = d === null ? !1 : d === l.panelId, c = (0, $3QbnI.useRef)(null), a = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(c, n, s ? null : l.buttonRef), D = (0, $efef981be50c1ac4$export$81218df071161f0a)();
    (0, $3QbnI.useEffect)(()=>{
        if (!s) return t({
            type: 2,
            buttonId: i
        }), ()=>{
            t({
                type: 2,
                buttonId: null
            });
        };
    }, [
        i,
        t,
        s
    ]);
    let p = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((r)=>{
        var m;
        if (s) {
            if (l.disclosureState === 1) return;
            switch(r.key){
                case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space:
                case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Enter:
                    r.preventDefault(), r.stopPropagation(), t({
                        type: 0
                    }), (m = l.buttonRef.current) == null || m.focus();
                    break;
            }
        } else switch(r.key){
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space:
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Enter:
                r.preventDefault(), r.stopPropagation(), t({
                    type: 0
                });
                break;
        }
    }), P = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((r)=>{
        switch(r.key){
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space:
                r.preventDefault();
                break;
        }
    }), T = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((r)=>{
        var m;
        (0, $9fde5a40ffbcb074$export$db61f031a278447c)(r.currentTarget) || e.disabled || (s ? (t({
            type: 0
        }), (m = l.buttonRef.current) == null || m.focus()) : t({
            type: 0
        }));
    }), C = (0, $3QbnI.useMemo)(()=>({
            open: l.disclosureState === 0
        }), [
        l
    ]), u = (0, $63b58a1e835cc3d1$export$53652b2b272efe9c)(e, c), y = s ? {
        ref: a,
        type: u,
        onKeyDown: p,
        onClick: T
    } : {
        ref: a,
        id: i,
        type: u,
        "aria-expanded": l.disclosureState === 0,
        "aria-controls": l.linkedPanel ? l.panelId : void 0,
        onKeyDown: p,
        onKeyUp: P,
        onClick: T
    };
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        mergeRefs: D,
        ourProps: y,
        theirProps: f,
        slot: C,
        defaultTag: $f4566e13631be5b1$var$le,
        name: "Disclosure.Button"
    });
}
let $f4566e13631be5b1$var$re = "div", $f4566e13631be5b1$var$se = (0, $efef981be50c1ac4$export$617d79dae526d2cf).RenderStrategy | (0, $efef981be50c1ac4$export$617d79dae526d2cf).Static;
function $f4566e13631be5b1$var$ue(e, n) {
    let o = (0, $32e547b031070140$export$f680877a34711e37)(), { id: i = `headlessui-disclosure-panel-${o}`, ...f } = e, [l, t] = $f4566e13631be5b1$var$_("Disclosure.Panel"), { close: d } = $f4566e13631be5b1$var$K("Disclosure.Panel"), s = (0, $efef981be50c1ac4$export$81218df071161f0a)(), c = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(n, l.panelRef, (T)=>{
        (0, $456197b827b26f6e$export$7568632d0d33d16d)(()=>t({
                type: T ? 4 : 5
            }));
    });
    (0, $3QbnI.useEffect)(()=>(t({
            type: 3,
            panelId: i
        }), ()=>{
            t({
                type: 3,
                panelId: null
            });
        }), [
        i,
        t
    ]);
    let a = (0, $379c3428ac0bb4a2$export$fc6fdf0ecf360e)(), D = (()=>a !== null ? (a & (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open) === (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open : l.disclosureState === 0)(), p = (0, $3QbnI.useMemo)(()=>({
            open: l.disclosureState === 0,
            close: d
        }), [
        l,
        d
    ]), P = {
        ref: c,
        id: i
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($f4566e13631be5b1$var$F.Provider, {
        value: l.panelId
    }, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        mergeRefs: s,
        ourProps: P,
        theirProps: f,
        slot: p,
        defaultTag: $f4566e13631be5b1$var$re,
        features: $f4566e13631be5b1$var$se,
        visible: D,
        name: "Disclosure.Panel"
    }));
}
let $f4566e13631be5b1$var$ie = (0, $efef981be50c1ac4$export$e43f39796049410c)($f4566e13631be5b1$var$ne), $f4566e13631be5b1$var$ae = (0, $efef981be50c1ac4$export$e43f39796049410c)($f4566e13631be5b1$var$oe), $f4566e13631be5b1$var$pe = (0, $efef981be50c1ac4$export$e43f39796049410c)($f4566e13631be5b1$var$ue), $f4566e13631be5b1$export$74a362b31437ec83 = Object.assign($f4566e13631be5b1$var$ie, {
    Button: $f4566e13631be5b1$var$ae,
    Panel: $f4566e13631be5b1$var$pe
});



var $3QbnI = parcelRequire("3QbnI");


var $3QbnI = parcelRequire("3QbnI");
function $1aaf2d418038901b$var$ArchiveBoxArrowDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0-3-3m3 3 3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
    }));
}
const $1aaf2d418038901b$var$ForwardRef = $3QbnI.forwardRef($1aaf2d418038901b$var$ArchiveBoxArrowDownIcon);
var $1aaf2d418038901b$export$2e2bcd8739ae039 = $1aaf2d418038901b$var$ForwardRef;




const $15adcf4933c9d401$export$802db1fec2151c6 = [
    {
        label: "settings.temperatures.keepUnchanged",
        symbol: "",
        value: (0, $e321886f11c1d045$export$2e2bcd8739ae039).Unknown
    },
    {
        label: "settings.temperatures.Farenheit",
        symbol: "\xb0F",
        value: (0, $e321886f11c1d045$export$2e2bcd8739ae039).Farenheit
    },
    {
        label: "settings.temperatures.Celsius",
        symbol: "\xb0C",
        value: (0, $e321886f11c1d045$export$2e2bcd8739ae039).Celsius
    }
];






var $efa35cd2a4b5e353$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $bzcxo = parcelRequire("bzcxo");
var $efa35cd2a4b5e353$require$Buffer = $bzcxo.Buffer;

var $54X9E = parcelRequire("54X9E");
!function(e) {
    $efa35cd2a4b5e353$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $efa35cd2a4b5e353$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($efa35cd2a4b5e353$require$Buffer.from && $efa35cd2a4b5e353$require$Buffer.from !== Uint8Array.from) return $efa35cd2a4b5e353$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $efa35cd2a4b5e353$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($efa35cd2a4b5e353$require$Buffer.alloc) return $efa35cd2a4b5e353$require$Buffer.alloc(e);
                        var t = new $efa35cd2a4b5e353$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $efa35cd2a4b5e353$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $efa35cd2a4b5e353$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $efa35cd2a4b5e353$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $54X9E.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});


var $d34abbe4be3809ca$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($d34abbe4be3809ca$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $d34abbe4be3809ca$exports = g;
});



const $11ac54e8816b7a73$var$baseURL = "/links";
const $11ac54e8816b7a73$export$185802fd694ee1f5 = async (recipeId)=>{
    const response = await (0, $e324a700d775dca8$export$2e2bcd8739ae039)().post($11ac54e8816b7a73$var$baseURL, {
        recipeId: recipeId
    });
    return response?.data?.link;
};


const $450cace7f3a9ea5d$var$cleanLine = (line)=>line.trim().replace(/^-/, "").trim();
const $450cace7f3a9ea5d$var$cleanLines = (ingredients)=>ingredients.split(/\n|\r\n/).map($450cace7f3a9ea5d$var$cleanLine).filter(Boolean);
var $450cace7f3a9ea5d$export$2e2bcd8739ae039 = $450cace7f3a9ea5d$var$cleanLines;



var $bei3G = parcelRequire("bei3G");
const $372477af3890afd9$var$SHARED_LINKS_KEY = "sharedLinks";
const $372477af3890afd9$var$SEPARATOR = ",";
const $372477af3890afd9$export$e19bc8b568728edd = ()=>localStorage.getItem($372477af3890afd9$var$SHARED_LINKS_KEY)?.split($372477af3890afd9$var$SEPARATOR).map((s)=>s.trim()).filter(Boolean) || [];
const $372477af3890afd9$export$b8e943e271d87bdd = (linkIds)=>{
    localStorage.setItem($372477af3890afd9$var$SHARED_LINKS_KEY, (0, $bei3G.uniq)([
        linkIds
    ]).join($372477af3890afd9$var$SEPARATOR));
};
const $372477af3890afd9$export$fd0bf85c110f02fb = ()=>localStorage.removeItem($372477af3890afd9$var$SHARED_LINKS_KEY);
const $372477af3890afd9$export$9a12c63cbd521171 = (linkId)=>`${"https://beta.getcookbook.io"}/share/${linkId}`;


const $a818b7f1c8cbc256$var$renderTextRecipe = async (recipe, t)=>{
    const linkId = await $11ac54e8816b7a73$export$185802fd694ee1f5(recipe.id);
    return `${t("_Import this recipe in CookBook", {
        link: (0, $372477af3890afd9$export$9a12c63cbd521171)(linkId)
    })}

${recipe.name}

${recipe.keywords.map((k)=>`#${k}`).join(", ")}

${t("_Ingredients")}
${(0, $450cace7f3a9ea5d$export$2e2bcd8739ae039)(recipe.ingredients).map((s)=>`- ${s}\n`).join("")}
${t("_Steps")} 
${(0, $450cace7f3a9ea5d$export$2e2bcd8739ae039)(recipe.steps).map((s)=>`- ${s}\n`).join("")}`.trim();
};
var $a818b7f1c8cbc256$export$2e2bcd8739ae039 = $a818b7f1c8cbc256$var$renderTextRecipe;


const $c1e23b84fcfe63c2$var$zip = new (0, (/*@__PURE__*/$parcel$interopDefault($efa35cd2a4b5e353$exports)))();
const $c1e23b84fcfe63c2$var$downloadAllRecipes = (recipes, t)=>{
    return new Promise(async (resolve, reject)=>{
        const recipesText = await Promise.all(recipes.map((r)=>(0, $a818b7f1c8cbc256$export$2e2bcd8739ae039)(r, t)));
        recipes.forEach((recipe, index)=>{
            $c1e23b84fcfe63c2$var$zip.file(`${recipe.name}.txt`, recipesText[index]);
        });
        $c1e23b84fcfe63c2$var$zip.generateAsync({
            type: "blob"
        }).then((content)=>{
            const date = new Date().toJSON().replace(/T.*/, "");
            (0, (/*@__PURE__*/$parcel$interopDefault($d34abbe4be3809ca$exports))).saveAs(content, `CookBook-${date}.zip`);
            resolve();
        });
    });
};
var $c1e23b84fcfe63c2$export$2e2bcd8739ae039 = $c1e23b84fcfe63c2$var$downloadAllRecipes;


var $f214a1ce0cc31a3c$exports = {};
"use strict";
var $f214a1ce0cc31a3c$var$Config = {
    DEBUG: false,
    LIB_VERSION: "2.50.0"
};
/* eslint camelcase: "off", eqeqeq: "off" */ // since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var $f214a1ce0cc31a3c$var$win;
if (typeof window === "undefined") {
    var $f214a1ce0cc31a3c$var$loc = {
        hostname: ""
    };
    $f214a1ce0cc31a3c$var$win = {
        navigator: {
            userAgent: ""
        },
        document: {
            location: $f214a1ce0cc31a3c$var$loc,
            referrer: ""
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $f214a1ce0cc31a3c$var$loc
    };
} else $f214a1ce0cc31a3c$var$win = window;
// Maximum allowed session recording length
var $f214a1ce0cc31a3c$var$MAX_RECORDING_MS = 86400000; // 24 hours
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $f214a1ce0cc31a3c$var$ArrayProto = Array.prototype, $f214a1ce0cc31a3c$var$FuncProto = Function.prototype, $f214a1ce0cc31a3c$var$ObjProto = Object.prototype, $f214a1ce0cc31a3c$var$slice = $f214a1ce0cc31a3c$var$ArrayProto.slice, $f214a1ce0cc31a3c$var$toString = $f214a1ce0cc31a3c$var$ObjProto.toString, $f214a1ce0cc31a3c$var$hasOwnProperty = $f214a1ce0cc31a3c$var$ObjProto.hasOwnProperty, $f214a1ce0cc31a3c$var$windowConsole = $f214a1ce0cc31a3c$var$win.console, $f214a1ce0cc31a3c$var$navigator = $f214a1ce0cc31a3c$var$win.navigator, $f214a1ce0cc31a3c$var$document$1 = $f214a1ce0cc31a3c$var$win.document, $f214a1ce0cc31a3c$var$windowOpera = $f214a1ce0cc31a3c$var$win.opera, $f214a1ce0cc31a3c$var$screen = $f214a1ce0cc31a3c$var$win.screen, $f214a1ce0cc31a3c$var$userAgent = $f214a1ce0cc31a3c$var$navigator.userAgent;
var $f214a1ce0cc31a3c$var$nativeBind = $f214a1ce0cc31a3c$var$FuncProto.bind, $f214a1ce0cc31a3c$var$nativeForEach = $f214a1ce0cc31a3c$var$ArrayProto.forEach, $f214a1ce0cc31a3c$var$nativeIndexOf = $f214a1ce0cc31a3c$var$ArrayProto.indexOf, $f214a1ce0cc31a3c$var$nativeMap = $f214a1ce0cc31a3c$var$ArrayProto.map, $f214a1ce0cc31a3c$var$nativeIsArray = Array.isArray, $f214a1ce0cc31a3c$var$breaker = {};
var $f214a1ce0cc31a3c$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    }
};
// Console override
var $f214a1ce0cc31a3c$var$console = {
    /** @type {function(...*)} */ log: function() {
        if ($f214a1ce0cc31a3c$var$Config.DEBUG && !$f214a1ce0cc31a3c$var$_.isUndefined($f214a1ce0cc31a3c$var$windowConsole) && $f214a1ce0cc31a3c$var$windowConsole) try {
            $f214a1ce0cc31a3c$var$windowConsole.log.apply($f214a1ce0cc31a3c$var$windowConsole, arguments);
        } catch (err) {
            $f214a1ce0cc31a3c$var$_.each(arguments, function(arg) {
                $f214a1ce0cc31a3c$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($f214a1ce0cc31a3c$var$Config.DEBUG && !$f214a1ce0cc31a3c$var$_.isUndefined($f214a1ce0cc31a3c$var$windowConsole) && $f214a1ce0cc31a3c$var$windowConsole) {
            var args = [
                "Mixpanel warning:"
            ].concat($f214a1ce0cc31a3c$var$_.toArray(arguments));
            try {
                $f214a1ce0cc31a3c$var$windowConsole.warn.apply($f214a1ce0cc31a3c$var$windowConsole, args);
            } catch (err) {
                $f214a1ce0cc31a3c$var$_.each(args, function(arg) {
                    $f214a1ce0cc31a3c$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($f214a1ce0cc31a3c$var$Config.DEBUG && !$f214a1ce0cc31a3c$var$_.isUndefined($f214a1ce0cc31a3c$var$windowConsole) && $f214a1ce0cc31a3c$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($f214a1ce0cc31a3c$var$_.toArray(arguments));
            try {
                $f214a1ce0cc31a3c$var$windowConsole.error.apply($f214a1ce0cc31a3c$var$windowConsole, args);
            } catch (err) {
                $f214a1ce0cc31a3c$var$_.each(args, function(arg) {
                    $f214a1ce0cc31a3c$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$f214a1ce0cc31a3c$var$_.isUndefined($f214a1ce0cc31a3c$var$windowConsole) && $f214a1ce0cc31a3c$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($f214a1ce0cc31a3c$var$_.toArray(arguments));
            try {
                $f214a1ce0cc31a3c$var$windowConsole.error.apply($f214a1ce0cc31a3c$var$windowConsole, args);
            } catch (err) {
                $f214a1ce0cc31a3c$var$_.each(args, function(arg) {
                    $f214a1ce0cc31a3c$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $f214a1ce0cc31a3c$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = "[" + prefix + "] " + arguments[0];
        return func.apply($f214a1ce0cc31a3c$var$console, arguments);
    };
};
var $f214a1ce0cc31a3c$var$console_with_prefix = function(prefix) {
    return {
        log: $f214a1ce0cc31a3c$var$log_func_with_prefix($f214a1ce0cc31a3c$var$console.log, prefix),
        error: $f214a1ce0cc31a3c$var$log_func_with_prefix($f214a1ce0cc31a3c$var$console.error, prefix),
        critical: $f214a1ce0cc31a3c$var$log_func_with_prefix($f214a1ce0cc31a3c$var$console.critical, prefix)
    };
};
// UNDERSCORE
// Embed part of the Underscore Library
$f214a1ce0cc31a3c$var$_.bind = function(func, context) {
    var args, bound;
    if ($f214a1ce0cc31a3c$var$nativeBind && func.bind === $f214a1ce0cc31a3c$var$nativeBind) return $f214a1ce0cc31a3c$var$nativeBind.apply(func, $f214a1ce0cc31a3c$var$slice.call(arguments, 1));
    if (!$f214a1ce0cc31a3c$var$_.isFunction(func)) throw new TypeError();
    args = $f214a1ce0cc31a3c$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($f214a1ce0cc31a3c$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat($f214a1ce0cc31a3c$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $f214a1ce0cc31a3c$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($f214a1ce0cc31a3c$var$nativeForEach && obj.forEach === $f214a1ce0cc31a3c$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $f214a1ce0cc31a3c$var$breaker) return;
    }
    else {
        for(var key in obj)if ($f214a1ce0cc31a3c$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $f214a1ce0cc31a3c$var$breaker) return;
        }
    }
};
$f214a1ce0cc31a3c$var$_.extend = function(obj) {
    $f214a1ce0cc31a3c$var$_.each($f214a1ce0cc31a3c$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$f214a1ce0cc31a3c$var$_.isArray = $f214a1ce0cc31a3c$var$nativeIsArray || function(obj) {
    return $f214a1ce0cc31a3c$var$toString.call(obj) === "[object Array]";
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$f214a1ce0cc31a3c$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$f214a1ce0cc31a3c$var$_.isArguments = function(obj) {
    return !!(obj && $f214a1ce0cc31a3c$var$hasOwnProperty.call(obj, "callee"));
};
$f214a1ce0cc31a3c$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($f214a1ce0cc31a3c$var$_.isArray(iterable)) return $f214a1ce0cc31a3c$var$slice.call(iterable);
    if ($f214a1ce0cc31a3c$var$_.isArguments(iterable)) return $f214a1ce0cc31a3c$var$slice.call(iterable);
    return $f214a1ce0cc31a3c$var$_.values(iterable);
};
$f214a1ce0cc31a3c$var$_.map = function(arr, callback, context) {
    if ($f214a1ce0cc31a3c$var$nativeMap && arr.map === $f214a1ce0cc31a3c$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $f214a1ce0cc31a3c$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$f214a1ce0cc31a3c$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $f214a1ce0cc31a3c$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$f214a1ce0cc31a3c$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $f214a1ce0cc31a3c$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$f214a1ce0cc31a3c$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($f214a1ce0cc31a3c$var$nativeIndexOf && obj.indexOf === $f214a1ce0cc31a3c$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $f214a1ce0cc31a3c$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $f214a1ce0cc31a3c$var$breaker;
    });
    return found;
};
$f214a1ce0cc31a3c$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$f214a1ce0cc31a3c$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$f214a1ce0cc31a3c$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$f214a1ce0cc31a3c$var$_.isArray(obj);
};
$f214a1ce0cc31a3c$var$_.isEmptyObject = function(obj) {
    if ($f214a1ce0cc31a3c$var$_.isObject(obj)) {
        for(var key in obj){
            if ($f214a1ce0cc31a3c$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$f214a1ce0cc31a3c$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$f214a1ce0cc31a3c$var$_.isString = function(obj) {
    return $f214a1ce0cc31a3c$var$toString.call(obj) == "[object String]";
};
$f214a1ce0cc31a3c$var$_.isDate = function(obj) {
    return $f214a1ce0cc31a3c$var$toString.call(obj) == "[object Date]";
};
$f214a1ce0cc31a3c$var$_.isNumber = function(obj) {
    return $f214a1ce0cc31a3c$var$toString.call(obj) == "[object Number]";
};
$f214a1ce0cc31a3c$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$f214a1ce0cc31a3c$var$_.encodeDates = function(obj) {
    $f214a1ce0cc31a3c$var$_.each(obj, function(v, k) {
        if ($f214a1ce0cc31a3c$var$_.isDate(v)) obj[k] = $f214a1ce0cc31a3c$var$_.formatDate(v);
        else if ($f214a1ce0cc31a3c$var$_.isObject(v)) obj[k] = $f214a1ce0cc31a3c$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$f214a1ce0cc31a3c$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$f214a1ce0cc31a3c$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? "0" + n : n;
    }
    return d.getUTCFullYear() + "-" + pad(d.getUTCMonth() + 1) + "-" + pad(d.getUTCDate()) + "T" + pad(d.getUTCHours()) + ":" + pad(d.getUTCMinutes()) + ":" + pad(d.getUTCSeconds());
};
$f214a1ce0cc31a3c$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $f214a1ce0cc31a3c$var$_.each(p, function(v, k) {
        if ($f214a1ce0cc31a3c$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $f214a1ce0cc31a3c$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === "string") ret = obj.slice(0, length);
    else if ($f214a1ce0cc31a3c$var$_.isArray(obj)) {
        ret = [];
        $f214a1ce0cc31a3c$var$_.each(obj, function(val) {
            ret.push($f214a1ce0cc31a3c$var$_.truncate(val, length));
        });
    } else if ($f214a1ce0cc31a3c$var$_.isObject(obj)) {
        ret = {};
        $f214a1ce0cc31a3c$var$_.each(obj, function(val, key) {
            ret[key] = $f214a1ce0cc31a3c$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$f214a1ce0cc31a3c$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                "\b": "\\b",
                "	": "\\t",
                "\n": "\\n",
                "\f": "\\f",
                "\r": "\\r",
                '"': '\\"',
                "\\": "\\\\"
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = "";
            var indent = "    ";
            var i = 0; // The loop counter.
            var k = ""; // The member key.
            var v = ""; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case "string":
                    return quote(value);
                case "number":
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : "null";
                case "boolean":
                case "null":
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case "object":
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return "null";
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($f214a1ce0cc31a3c$var$toString.apply(value) === "[object Array]") {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($f214a1ce0cc31a3c$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? "{}" : gap ? "{" + partial.join(",") + "" + mind + "}" : "{" + partial.join(",") + "}";
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str("", {
            "": value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $f214a1ce0cc31a3c$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        "\\": "\\",
        "/": "/",
        "b": "\b",
        "f": "\f",
        "n": "\n",
        "r": "\r",
        "t": "	"
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error("Expected '" + c + "' instead of '" + ch + "'");
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = "";
        if (ch === "-") {
            string = "-";
            next("-");
        }
        while(ch >= "0" && ch <= "9"){
            string += ch;
            next();
        }
        if (ch === ".") {
            string += ".";
            while(next() && ch >= "0" && ch <= "9")string += ch;
        }
        if (ch === "e" || ch === "E") {
            string += ch;
            next();
            if (ch === "-" || ch === "+") {
                string += ch;
                next();
            }
            while(ch >= "0" && ch <= "9"){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error("Bad number");
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = "", uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === "\\") {
                next();
                if (ch === "u") {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === "string") string += escapee[ch];
                else break;
            } else string += ch;
        }
        error("Bad string");
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= " ")next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case "t":
                next("t");
                next("r");
                next("u");
                next("e");
                return true;
            case "f":
                next("f");
                next("a");
                next("l");
                next("s");
                next("e");
                return false;
            case "n":
                next("n");
                next("u");
                next("l");
                next("l");
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === "[") {
            next("[");
            white();
            if (ch === "]") {
                next("]");
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === "]") {
                    next("]");
                    return array;
                }
                next(",");
                white();
            }
        }
        error("Bad array");
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === "{") {
            next("{");
            white();
            if (ch === "}") {
                next("}");
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(":");
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === "}") {
                    next("}");
                    return object;
                }
                next(",");
                white();
            }
        }
        error("Bad object");
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case "{":
                return object();
            case "[":
                return array();
            case '"':
                return string();
            case "-":
                return number();
            default:
                return ch >= "0" && ch <= "9" ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = " ";
        result = value();
        white();
        if (ch) error("Syntax error");
        return result;
    };
}();
$f214a1ce0cc31a3c$var$_.base64Encode = function(data) {
    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = "", tmp_arr = [];
    if (!data) return data;
    data = $f214a1ce0cc31a3c$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join("");
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + "==";
            break;
        case 2:
            enc = enc.slice(0, -1) + "=";
            break;
    }
    return enc;
};
$f214a1ce0cc31a3c$var$_.utf8Encode = function(string) {
    string = (string + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    var utftext = "", start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$f214a1ce0cc31a3c$var$_.UUID = function() {
    // Time-based entropy
    var T = function() {
        var time = 1 * new Date(); // cross-browser version of Date.now()
        var ticks;
        if ($f214a1ce0cc31a3c$var$win.performance && $f214a1ce0cc31a3c$var$win.performance.now) ticks = $f214a1ce0cc31a3c$var$win.performance.now();
        else {
            // fall back to busy loop
            ticks = 0;
            // this while loop figures how many browser ticks go by
            // before 1*new Date() returns a new number, ie the amount
            // of ticks that go by per millisecond
            while(time == 1 * new Date())ticks++;
        }
        return time.toString(16) + Math.floor(ticks).toString(16);
    };
    // Math.Random entropy
    var R = function() {
        return Math.random().toString(16).replace(".", "");
    };
    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function() {
        var ua = $f214a1ce0cc31a3c$var$userAgent, i, ch, buffer = [], ret = 0;
        function xor(result, byte_array) {
            var j, tmp = 0;
            for(j = 0; j < byte_array.length; j++)tmp |= buffer[j] << j * 8;
            return result ^ tmp;
        }
        for(i = 0; i < ua.length; i++){
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }
        if (buffer.length > 0) ret = xor(ret, buffer);
        return ret.toString(16);
    };
    return function() {
        var se = ($f214a1ce0cc31a3c$var$screen.height * $f214a1ce0cc31a3c$var$screen.width).toString(16);
        return T() + "-" + R() + "-" + UA() + "-" + se + "-" + T();
    };
}();
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $f214a1ce0cc31a3c$var$BLOCKED_UA_STRS = [
    "ahrefsbot",
    "ahrefssiteaudit",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "facebookexternal",
    "petalbot",
    "pinterest",
    "screaming frog",
    "yahoo! slurp",
    "yandexbot",
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google"
];
$f214a1ce0cc31a3c$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $f214a1ce0cc31a3c$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($f214a1ce0cc31a3c$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $f214a1ce0cc31a3c$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($f214a1ce0cc31a3c$var$_.isUndefined(arg_separator)) arg_separator = "&";
    $f214a1ce0cc31a3c$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + "=" + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$f214a1ce0cc31a3c$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + param + "=([^&#]*)", regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== "string" && results[1].length) return "";
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $f214a1ce0cc31a3c$var$console.error("Skipping decoding for malformed query param: " + result);
        }
        return result.replace(/\+/g, " ");
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$f214a1ce0cc31a3c$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + "=";
        var ca = $f214a1ce0cc31a3c$var$document$1.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $f214a1ce0cc31a3c$var$_.JSONDecode($f214a1ce0cc31a3c$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $f214a1ce0cc31a3c$var$extract_domain($f214a1ce0cc31a3c$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        $f214a1ce0cc31a3c$var$document$1.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $f214a1ce0cc31a3c$var$extract_domain($f214a1ce0cc31a3c$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        var new_cookie_val = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
        $f214a1ce0cc31a3c$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $f214a1ce0cc31a3c$var$_.cookie.set(name, "", -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $f214a1ce0cc31a3c$var$_localStorageSupported = null;
var $f214a1ce0cc31a3c$var$localStorageSupported = function(storage, forceCheck) {
    if ($f214a1ce0cc31a3c$var$_localStorageSupported !== null && !forceCheck) return $f214a1ce0cc31a3c$var$_localStorageSupported;
    var supported = true;
    try {
        storage = storage || window.localStorage;
        var key = "__mplss_" + $f214a1ce0cc31a3c$var$cheap_guid(8), val = "xyz";
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    $f214a1ce0cc31a3c$var$_localStorageSupported = supported;
    return supported;
};
// _.localStorage
$f214a1ce0cc31a3c$var$_.localStorage = {
    is_supported: function(force_check) {
        var supported = $f214a1ce0cc31a3c$var$localStorageSupported(null, force_check);
        if (!supported) $f214a1ce0cc31a3c$var$console.error("localStorage unsupported; falling back to cookie store");
        return supported;
    },
    error: function(msg) {
        $f214a1ce0cc31a3c$var$console.error("localStorage error: " + msg);
    },
    get: function(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            $f214a1ce0cc31a3c$var$_.localStorage.error(err);
        }
        return null;
    },
    parse: function(name) {
        try {
            return $f214a1ce0cc31a3c$var$_.JSONDecode($f214a1ce0cc31a3c$var$_.localStorage.get(name)) || {};
        } catch (err) {
        // noop
        }
        return null;
    },
    set: function(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            $f214a1ce0cc31a3c$var$_.localStorage.error(err);
        }
    },
    remove: function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            $f214a1ce0cc31a3c$var$_.localStorage.error(err);
        }
    }
};
$f214a1ce0cc31a3c$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $f214a1ce0cc31a3c$var$console.error("No valid element provided to register_event");
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = "on" + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent(window.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($f214a1ce0cc31a3c$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $f214a1ce0cc31a3c$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$f214a1ce0cc31a3c$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName("*");
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = " " + selector + " ";
        return (" " + elem.className + " ").replace(bad_whitespace, " ").indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$f214a1ce0cc31a3c$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(" ");
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $f214a1ce0cc31a3c$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, "").replace(/\s+$/, "");
            if (token.indexOf("#") > -1) {
                // Token is an ID selector
                bits = token.split("#");
                tagName = bits[0];
                var id = bits[1];
                var element = $f214a1ce0cc31a3c$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf(".") > -1) {
                // Token contains a class selector
                bits = token.split(".");
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = "*";
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $f214a1ce0cc31a3c$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($f214a1ce0cc31a3c$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = "*";
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case "=":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case "~":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("\\b" + attrValue + "\\b"));
                        };
                        break;
                    case "|":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("^" + attrValue + "-?"));
                        };
                        break;
                    case "^":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case "$":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case "*":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($f214a1ce0cc31a3c$var$_.isElement(query)) return [
            query
        ];
        else if ($f214a1ce0cc31a3c$var$_.isObject(query) && !$f214a1ce0cc31a3c$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var $f214a1ce0cc31a3c$var$CAMPAIGN_KEYWORDS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term"
];
var $f214a1ce0cc31a3c$var$CLICK_IDS = [
    "dclid",
    "fbclid",
    "gclid",
    "ko_click_id",
    "li_fat_id",
    "msclkid",
    "ttclid",
    "twclid",
    "wbraid"
];
$f214a1ce0cc31a3c$var$_.info = {
    campaignParams: function(default_value) {
        var kw = "", params = {};
        $f214a1ce0cc31a3c$var$_.each($f214a1ce0cc31a3c$var$CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = $f214a1ce0cc31a3c$var$_.getQueryParam($f214a1ce0cc31a3c$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function() {
        var id = "", params = {};
        $f214a1ce0cc31a3c$var$_.each($f214a1ce0cc31a3c$var$CLICK_IDS, function(idkey) {
            id = $f214a1ce0cc31a3c$var$_.getQueryParam($f214a1ce0cc31a3c$var$document$1.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function() {
        return $f214a1ce0cc31a3c$var$_.extend($f214a1ce0cc31a3c$var$_.info.campaignParams(), $f214a1ce0cc31a3c$var$_.info.clickParams());
    },
    searchEngine: function(referrer) {
        if (referrer.search("https?://(.*)google.([^/?]*)") === 0) return "google";
        else if (referrer.search("https?://(.*)bing.com") === 0) return "bing";
        else if (referrer.search("https?://(.*)yahoo.com") === 0) return "yahoo";
        else if (referrer.search("https?://(.*)duckduckgo.com") === 0) return "duckduckgo";
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $f214a1ce0cc31a3c$var$_.info.searchEngine(referrer), param = search != "yahoo" ? "q" : "p", ret = {};
        if (search !== null) {
            ret["$search_engine"] = search;
            var keyword = $f214a1ce0cc31a3c$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret["mp_keyword"] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ""; // vendor is undefined for at least IE9
        if (opera || $f214a1ce0cc31a3c$var$_.includes(user_agent, " OPR/")) {
            if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "Mini")) return "Opera Mini";
            return "Opera";
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "IEMobile") || $f214a1ce0cc31a3c$var$_.includes(user_agent, "WPDesktop")) return "Internet Explorer Mobile";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "SamsungBrowser/")) // https://developer.samsung.com/internet/user-agent-string-format
        return "Samsung Internet";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "Edge") || $f214a1ce0cc31a3c$var$_.includes(user_agent, "Edg/")) return "Microsoft Edge";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "FBIOS")) return "Facebook Mobile";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "Chrome")) return "Chrome";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "CriOS")) return "Chrome iOS";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "UCWEB") || $f214a1ce0cc31a3c$var$_.includes(user_agent, "UCBrowser")) return "UC Browser";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "FxiOS")) return "Firefox iOS";
        else if ($f214a1ce0cc31a3c$var$_.includes(vendor, "Apple")) {
            if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "Mobile")) return "Mobile Safari";
            return "Safari";
        } else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "Android")) return "Android Mobile";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "Konqueror")) return "Konqueror";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "Firefox")) return "Firefox";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "MSIE") || $f214a1ce0cc31a3c$var$_.includes(user_agent, "Trident/")) return "Internet Explorer";
        else if ($f214a1ce0cc31a3c$var$_.includes(user_agent, "Gecko")) return "Mozilla";
        else return "";
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $f214a1ce0cc31a3c$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
            "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
            "Chrome": /Chrome\/(\d+(\.\d+)?)/,
            "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
            "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            "Safari": /Version\/(\d+(\.\d+)?)/,
            "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
            "Opera": /(Opera|OPR)\/(\d+(\.\d+)?)/,
            "Firefox": /Firefox\/(\d+(\.\d+)?)/,
            "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
            "Konqueror": /Konqueror:(\d+(\.\d+)?)/,
            "BlackBerry": /BlackBerry (\d+(\.\d+)?)/,
            "Android Mobile": /android\s(\d+(\.\d+)?)/,
            "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
            "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
            "Mozilla": /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $f214a1ce0cc31a3c$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return "Windows Phone";
            return "Windows";
        } else if (/(iPhone|iPad|iPod)/.test(a)) return "iOS";
        else if (/Android/.test(a)) return "Android";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return "BlackBerry";
        else if (/Mac/i.test(a)) return "Mac OS X";
        else if (/Linux/.test(a)) return "Linux";
        else if (/CrOS/.test(a)) return "Chrome OS";
        else return "";
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return "Windows Phone";
        else if (/iPad/.test(user_agent)) return "iPad";
        else if (/iPod/.test(user_agent)) return "iPod Touch";
        else if (/iPhone/.test(user_agent)) return "iPhone";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if (/Android/.test(user_agent)) return "Android";
        else return "";
    },
    referringDomain: function(referrer) {
        var split = referrer.split("/");
        if (split.length >= 3) return split[2];
        return "";
    },
    currentUrl: function() {
        return $f214a1ce0cc31a3c$var$win.location.href;
    },
    properties: function(extra_props) {
        if (typeof extra_props !== "object") extra_props = {};
        return $f214a1ce0cc31a3c$var$_.extend($f214a1ce0cc31a3c$var$_.strip_empty_properties({
            "$os": $f214a1ce0cc31a3c$var$_.info.os(),
            "$browser": $f214a1ce0cc31a3c$var$_.info.browser($f214a1ce0cc31a3c$var$userAgent, $f214a1ce0cc31a3c$var$navigator.vendor, $f214a1ce0cc31a3c$var$windowOpera),
            "$referrer": $f214a1ce0cc31a3c$var$document$1.referrer,
            "$referring_domain": $f214a1ce0cc31a3c$var$_.info.referringDomain($f214a1ce0cc31a3c$var$document$1.referrer),
            "$device": $f214a1ce0cc31a3c$var$_.info.device($f214a1ce0cc31a3c$var$userAgent)
        }), {
            "$current_url": $f214a1ce0cc31a3c$var$_.info.currentUrl(),
            "$browser_version": $f214a1ce0cc31a3c$var$_.info.browserVersion($f214a1ce0cc31a3c$var$userAgent, $f214a1ce0cc31a3c$var$navigator.vendor, $f214a1ce0cc31a3c$var$windowOpera),
            "$screen_height": $f214a1ce0cc31a3c$var$screen.height,
            "$screen_width": $f214a1ce0cc31a3c$var$screen.width,
            "mp_lib": "web",
            "$lib_version": $f214a1ce0cc31a3c$var$Config.LIB_VERSION,
            "$insert_id": $f214a1ce0cc31a3c$var$cheap_guid(),
            "time": $f214a1ce0cc31a3c$var$_.timestamp() / 1000 // epoch time in seconds
        }, $f214a1ce0cc31a3c$var$_.strip_empty_properties(extra_props));
    },
    people_properties: function() {
        return $f214a1ce0cc31a3c$var$_.extend($f214a1ce0cc31a3c$var$_.strip_empty_properties({
            "$os": $f214a1ce0cc31a3c$var$_.info.os(),
            "$browser": $f214a1ce0cc31a3c$var$_.info.browser($f214a1ce0cc31a3c$var$userAgent, $f214a1ce0cc31a3c$var$navigator.vendor, $f214a1ce0cc31a3c$var$windowOpera)
        }), {
            "$browser_version": $f214a1ce0cc31a3c$var$_.info.browserVersion($f214a1ce0cc31a3c$var$userAgent, $f214a1ce0cc31a3c$var$navigator.vendor, $f214a1ce0cc31a3c$var$windowOpera)
        });
    },
    mpPageViewProperties: function() {
        return $f214a1ce0cc31a3c$var$_.strip_empty_properties({
            "current_page_title": $f214a1ce0cc31a3c$var$document$1.title,
            "current_domain": $f214a1ce0cc31a3c$var$win.location.hostname,
            "current_url_path": $f214a1ce0cc31a3c$var$win.location.pathname,
            "current_url_protocol": $f214a1ce0cc31a3c$var$win.location.protocol,
            "current_url_search": $f214a1ce0cc31a3c$var$win.location.search
        });
    }
};
var $f214a1ce0cc31a3c$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $f214a1ce0cc31a3c$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $f214a1ce0cc31a3c$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $f214a1ce0cc31a3c$var$extract_domain = function(hostname) {
    var domain_regex = $f214a1ce0cc31a3c$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split(".");
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === "com" || tld === "org") domain_regex = $f214a1ce0cc31a3c$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : "";
};
var $f214a1ce0cc31a3c$var$JSONStringify = null, $f214a1ce0cc31a3c$var$JSONParse = null;
if (typeof JSON !== "undefined") {
    $f214a1ce0cc31a3c$var$JSONStringify = JSON.stringify;
    $f214a1ce0cc31a3c$var$JSONParse = JSON.parse;
}
$f214a1ce0cc31a3c$var$JSONStringify = $f214a1ce0cc31a3c$var$JSONStringify || $f214a1ce0cc31a3c$var$_.JSONEncode;
$f214a1ce0cc31a3c$var$JSONParse = $f214a1ce0cc31a3c$var$JSONParse || $f214a1ce0cc31a3c$var$_.JSONDecode;
// EXPORTS (for closure compiler)
$f214a1ce0cc31a3c$var$_["toArray"] = $f214a1ce0cc31a3c$var$_.toArray;
$f214a1ce0cc31a3c$var$_["isObject"] = $f214a1ce0cc31a3c$var$_.isObject;
$f214a1ce0cc31a3c$var$_["JSONEncode"] = $f214a1ce0cc31a3c$var$_.JSONEncode;
$f214a1ce0cc31a3c$var$_["JSONDecode"] = $f214a1ce0cc31a3c$var$_.JSONDecode;
$f214a1ce0cc31a3c$var$_["isBlockedUA"] = $f214a1ce0cc31a3c$var$_.isBlockedUA;
$f214a1ce0cc31a3c$var$_["isEmptyObject"] = $f214a1ce0cc31a3c$var$_.isEmptyObject;
$f214a1ce0cc31a3c$var$_["info"] = $f214a1ce0cc31a3c$var$_.info;
$f214a1ce0cc31a3c$var$_["info"]["device"] = $f214a1ce0cc31a3c$var$_.info.device;
$f214a1ce0cc31a3c$var$_["info"]["browser"] = $f214a1ce0cc31a3c$var$_.info.browser;
$f214a1ce0cc31a3c$var$_["info"]["browserVersion"] = $f214a1ce0cc31a3c$var$_.info.browserVersion;
$f214a1ce0cc31a3c$var$_["info"]["properties"] = $f214a1ce0cc31a3c$var$_.info.properties;
/* eslint camelcase: "off" */ /**
 * DomTracker Object
 * @constructor
 */ var $f214a1ce0cc31a3c$var$DomTracker = function() {};
// interface
$f214a1ce0cc31a3c$var$DomTracker.prototype.create_properties = function() {};
$f214a1ce0cc31a3c$var$DomTracker.prototype.event_handler = function() {};
$f214a1ce0cc31a3c$var$DomTracker.prototype.after_track_handler = function() {};
$f214a1ce0cc31a3c$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $f214a1ce0cc31a3c$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $f214a1ce0cc31a3c$var$_.dom_query(query);
    if (elements.length === 0) {
        $f214a1ce0cc31a3c$var$console.error("The DOM query (" + query + ") returned 0 elements");
        return;
    }
    $f214a1ce0cc31a3c$var$_.each(elements, function(element) {
        $f214a1ce0cc31a3c$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config("track_links_timeout");
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $f214a1ce0cc31a3c$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$f214a1ce0cc31a3c$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === "function") props = properties(element);
    else props = $f214a1ce0cc31a3c$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $f214a1ce0cc31a3c$var$LinkTracker = function() {
    this.override_event = "click";
};
$f214a1ce0cc31a3c$var$_.inherit($f214a1ce0cc31a3c$var$LinkTracker, $f214a1ce0cc31a3c$var$DomTracker);
$f214a1ce0cc31a3c$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $f214a1ce0cc31a3c$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props["url"] = element.href;
    return props;
};
$f214a1ce0cc31a3c$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === "_blank";
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$f214a1ce0cc31a3c$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $f214a1ce0cc31a3c$var$FormTracker = function() {
    this.override_event = "submit";
};
$f214a1ce0cc31a3c$var$_.inherit($f214a1ce0cc31a3c$var$FormTracker, $f214a1ce0cc31a3c$var$DomTracker);
$f214a1ce0cc31a3c$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$f214a1ce0cc31a3c$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
var $f214a1ce0cc31a3c$var$logger$2 = $f214a1ce0cc31a3c$var$console_with_prefix("lock");
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $f214a1ce0cc31a3c$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || window.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$f214a1ce0cc31a3c$var$SharedLock.prototype.withLock = function(lockedCB, errorCB, pid) {
    if (!pid && typeof errorCB !== "function") {
        pid = errorCB;
        errorCB = null;
    }
    var i = pid || new Date().getTime() + "|" + Math.random();
    var startTime = new Date().getTime();
    var key = this.storageKey;
    var pollIntervalMS = this.pollIntervalMS;
    var timeoutMS = this.timeoutMS;
    var storage = this.storage;
    var keyX = key + ":X";
    var keyY = key + ":Y";
    var keyZ = key + ":Z";
    var reportError = function(err) {
        errorCB && errorCB(err);
    };
    var delay = function(cb) {
        if (new Date().getTime() - startTime > timeoutMS) {
            $f214a1ce0cc31a3c$var$logger$2.error("Timeout waiting for mutex on " + key + "; clearing lock. [" + i + "]");
            storage.removeItem(keyZ);
            storage.removeItem(keyY);
            loop();
            return;
        }
        setTimeout(function() {
            try {
                cb();
            } catch (err) {
                reportError(err);
            }
        }, pollIntervalMS * (Math.random() + 0.1));
    };
    var waitFor = function(predicate, cb) {
        if (predicate()) cb();
        else delay(function() {
            waitFor(predicate, cb);
        });
    };
    var getSetY = function() {
        var valY = storage.getItem(keyY);
        if (valY && valY !== i) return false;
        else {
            storage.setItem(keyY, i);
            if (storage.getItem(keyY) === i) return true;
            else {
                if (!$f214a1ce0cc31a3c$var$localStorageSupported(storage, true)) throw new Error("localStorage support dropped while acquiring lock");
                return false;
            }
        }
    };
    var loop = function() {
        storage.setItem(keyX, i);
        waitFor(getSetY, function() {
            if (storage.getItem(keyX) === i) {
                criticalSection();
                return;
            }
            delay(function() {
                if (storage.getItem(keyY) !== i) {
                    loop();
                    return;
                }
                waitFor(function() {
                    return !storage.getItem(keyZ);
                }, criticalSection);
            });
        });
    };
    var criticalSection = function() {
        storage.setItem(keyZ, "1");
        try {
            lockedCB();
        } finally{
            storage.removeItem(keyZ);
            if (storage.getItem(keyY) === i) storage.removeItem(keyY);
            if (storage.getItem(keyX) === i) storage.removeItem(keyX);
        }
    };
    try {
        if ($f214a1ce0cc31a3c$var$localStorageSupported(storage, true)) loop();
        else throw new Error("localStorage support check failed");
    } catch (err) {
        reportError(err);
    }
};
var $f214a1ce0cc31a3c$var$logger$1 = $f214a1ce0cc31a3c$var$console_with_prefix("batch");
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $f214a1ce0cc31a3c$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.storage = options.storage || window.localStorage;
    this.reportError = options.errorReporter || $f214a1ce0cc31a3c$var$_.bind($f214a1ce0cc31a3c$var$logger$1.error, $f214a1ce0cc31a3c$var$logger$1);
    this.lock = new $f214a1ce0cc31a3c$var$SharedLock(storageKey, {
        storage: this.storage
    });
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $f214a1ce0cc31a3c$var$RequestQueue.prototype.enqueue = function(item, flushInterval, cb) {
    var queueEntry = {
        "id": $f214a1ce0cc31a3c$var$cheap_guid(),
        "flushAfter": new Date().getTime() + flushInterval * 2,
        "payload": item
    };
    this.lock.withLock($f214a1ce0cc31a3c$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue.push(queueEntry);
            succeeded = this.saveToStorage(storedQueue);
            if (succeeded) // only add to in-memory queue when storage succeeds
            this.memQueue.push(queueEntry);
        } catch (err) {
            this.reportError("Error enqueueing item", item);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $f214a1ce0cc31a3c$var$_.bind(function lockFailure(err) {
        this.reportError("Error acquiring storage lock", err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $f214a1ce0cc31a3c$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (batch.length < batchSize) {
        // don't need lock just to read events; localStorage is thread-safe
        // and the worst that could happen is a duplicate send of some
        // orphaned events, which will be deduplicated on the server side
        var storedQueue = this.readFromStorage();
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $f214a1ce0cc31a3c$var$_.each(batch, function(item) {
                idsInBatch[item["id"]] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item["flushAfter"] && !idsInBatch[item["id"]]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
    }
    return batch;
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $f214a1ce0cc31a3c$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $f214a1ce0cc31a3c$var$_.each(items, function(item) {
        if (item["id"] && !idSet[item["id"]]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $f214a1ce0cc31a3c$var$RequestQueue.prototype.removeItemsByID = function(ids, cb) {
    var idSet = {}; // poor man's Set
    $f214a1ce0cc31a3c$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $f214a1ce0cc31a3c$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    var removeFromStorage = $f214a1ce0cc31a3c$var$_.bind(function() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $f214a1ce0cc31a3c$var$filterOutIDsAndInvalid(storedQueue, idSet);
            succeeded = this.saveToStorage(storedQueue);
            // an extra check: did storage report success but somehow
            // the items are still there?
            if (succeeded) {
                storedQueue = this.readFromStorage();
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item["id"] && !!idSet[item["id"]]) {
                        this.reportError("Item not removed from storage");
                        return false;
                    }
                }
            }
        } catch (err) {
            this.reportError("Error removing items", ids);
            succeeded = false;
        }
        return succeeded;
    }, this);
    this.lock.withLock(function lockAcquired() {
        var succeeded = removeFromStorage();
        if (cb) cb(succeeded);
    }, $f214a1ce0cc31a3c$var$_.bind(function lockFailure(err) {
        var succeeded = false;
        this.reportError("Error acquiring storage lock", err);
        if (!$f214a1ce0cc31a3c$var$localStorageSupported(this.storage, true)) {
            // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            succeeded = removeFromStorage();
            if (!succeeded) // OK, we couldn't even write out the smaller queue. Try clearing it
            // entirely.
            try {
                this.storage.removeItem(this.storageKey);
            } catch (err) {
                this.reportError("Error clearing queue", err);
            }
        }
        if (cb) cb(succeeded);
    }, this), this.pid);
};
// internal helper for RequestQueue.updatePayloads
var $f214a1ce0cc31a3c$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $f214a1ce0cc31a3c$var$_.each(existingItems, function(item) {
        var id = item["id"];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item["payload"] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $f214a1ce0cc31a3c$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate, cb) {
    this.memQueue = $f214a1ce0cc31a3c$var$updatePayloads(this.memQueue, itemsToUpdate);
    this.lock.withLock($f214a1ce0cc31a3c$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $f214a1ce0cc31a3c$var$updatePayloads(storedQueue, itemsToUpdate);
            succeeded = this.saveToStorage(storedQueue);
        } catch (err) {
            this.reportError("Error updating items", itemsToUpdate);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $f214a1ce0cc31a3c$var$_.bind(function lockFailure(err) {
        this.reportError("Error acquiring storage lock", err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $f214a1ce0cc31a3c$var$RequestQueue.prototype.readFromStorage = function() {
    var storageEntry;
    try {
        storageEntry = this.storage.getItem(this.storageKey);
        if (storageEntry) {
            storageEntry = $f214a1ce0cc31a3c$var$JSONParse(storageEntry);
            if (!$f214a1ce0cc31a3c$var$_.isArray(storageEntry)) {
                this.reportError("Invalid storage entry:", storageEntry);
                storageEntry = null;
            }
        }
    } catch (err) {
        this.reportError("Error retrieving queue", err);
        storageEntry = null;
    }
    return storageEntry || [];
};
/**
 * Serialize the given items array to localStorage.
 */ $f214a1ce0cc31a3c$var$RequestQueue.prototype.saveToStorage = function(queue) {
    try {
        this.storage.setItem(this.storageKey, $f214a1ce0cc31a3c$var$JSONStringify(queue));
        return true;
    } catch (err) {
        this.reportError("Error saving queue", err);
        return false;
    }
};
/**
 * Clear out queues (memory and localStorage).
 */ $f214a1ce0cc31a3c$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    this.storage.removeItem(this.storageKey);
};
// maximum interval between request retries after exponential backoff
var $f214a1ce0cc31a3c$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $f214a1ce0cc31a3c$var$logger = $f214a1ce0cc31a3c$var$console_with_prefix("batch");
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $f214a1ce0cc31a3c$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $f214a1ce0cc31a3c$var$RequestQueue(storageKey, {
        errorReporter: $f214a1ce0cc31a3c$var$_.bind(this.reportError, this),
        storage: options.storage
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig["batch_size"];
    this.flushInterval = this.libConfig["batch_flush_interval_ms"];
    this.stopped = !this.libConfig["batch_autostart"];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
};
/**
 * Add one item to queue.
 */ $f214a1ce0cc31a3c$var$RequestBatcher.prototype.enqueue = function(item, cb) {
    this.queue.enqueue(item, this.flushInterval, cb);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $f214a1ce0cc31a3c$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $f214a1ce0cc31a3c$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $f214a1ce0cc31a3c$var$RequestBatcher.prototype.clear = function() {
    this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $f214a1ce0cc31a3c$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig["batch_size"];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $f214a1ce0cc31a3c$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig["batch_flush_interval_ms"]);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $f214a1ce0cc31a3c$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($f214a1ce0cc31a3c$var$_.bind(this.flush, this), this.flushInterval);
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $f214a1ce0cc31a3c$var$RequestBatcher.prototype.flush = function(options) {
    try {
        if (this.requestInProgress) {
            $f214a1ce0cc31a3c$var$logger.log("Flush: Request already in progress");
            return;
        }
        options = options || {};
        var timeoutMS = this.libConfig["batch_request_timeout_ms"];
        var startTime = new Date().getTime();
        var currentBatchSize = this.batchSize;
        var batch = this.queue.fillBatch(currentBatchSize);
        var dataForRequest = [];
        var transformedItems = {};
        $f214a1ce0cc31a3c$var$_.each(batch, function(item) {
            var payload = item["payload"];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload["event"] && payload["properties"]) payload["properties"] = $f214a1ce0cc31a3c$var$_.extend({}, payload["properties"], {
                    "mp_sent_by_lib_version": $f214a1ce0cc31a3c$var$Config.LIB_VERSION
                });
                var addPayload = true;
                var itemId = item["id"];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError("[dupe] item ID sent too many times, not sending", {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError("[dupe] found item with no ID", {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item["id"]] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.resetFlush();
            return; // nothing to do
        }
        this.requestInProgress = true;
        var batchSendCallback = $f214a1ce0cc31a3c$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                var removeItemsFromQueue = false;
                if (options.unloading) // update persisted data to include hook transformations
                this.queue.updatePayloads(transformedItems);
                else if ($f214a1ce0cc31a3c$var$_.isObject(res) && res.error === "timeout" && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError("Network timeout; retrying");
                    this.flush();
                } else if ($f214a1ce0cc31a3c$var$_.isObject(res) && res.xhr_req && (res.xhr_req["status"] >= 500 || res.xhr_req["status"] === 429 || res.error === "timeout")) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    var headers = res.xhr_req["responseHeaders"];
                    if (headers) {
                        var retryAfter = headers["Retry-After"];
                        if (retryAfter) retryMS = parseInt(retryAfter, 10) * 1000 || retryMS;
                    }
                    retryMS = Math.min($f214a1ce0cc31a3c$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError("Error; retry in " + retryMS + " ms");
                    this.scheduleFlush(retryMS);
                } else if ($f214a1ce0cc31a3c$var$_.isObject(res) && res.xhr_req && res.xhr_req["status"] === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError("413 response; reducing batch size to " + this.batchSize);
                        this.resetFlush();
                    } else {
                        this.reportError("Single-event request too large; dropping", batch);
                        this.resetBatchSize();
                        removeItemsFromQueue = true;
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                removeItemsFromQueue = true;
                if (removeItemsFromQueue) {
                    this.queue.removeItemsByID($f214a1ce0cc31a3c$var$_.map(batch, function(item) {
                        return item["id"];
                    }), $f214a1ce0cc31a3c$var$_.bind(function(succeeded) {
                        if (succeeded) {
                            this.consecutiveRemovalFailures = 0;
                            this.flush(); // handle next batch if the queue isn't empty
                        } else {
                            this.reportError("Failed to remove items from queue");
                            if (++this.consecutiveRemovalFailures > 5) {
                                this.reportError("Too many queue failures; disabling batching system.");
                                this.stopAllBatching();
                            } else this.resetFlush();
                        }
                    }, this));
                    // client-side dedupe
                    $f214a1ce0cc31a3c$var$_.each(batch, $f214a1ce0cc31a3c$var$_.bind(function(item) {
                        var itemId = item["id"];
                        if (itemId) {
                            this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                            this.itemIdsSentSuccessfully[itemId]++;
                            if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError("[dupe] item ID sent too many times", {
                                item: item,
                                batchSize: batch.length,
                                timesSent: this.itemIdsSentSuccessfully[itemId]
                            });
                        } else this.reportError("[dupe] found item with no ID while removing", {
                            item: item
                        });
                    }, this));
                }
            } catch (err) {
                this.reportError("Error handling API response", err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: "POST",
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = "sendBeacon";
        $f214a1ce0cc31a3c$var$logger.log("MIXPANEL REQUEST:", dataForRequest);
        this.sendRequest(dataForRequest, requestOptions, batchSendCallback);
    } catch (err) {
        this.reportError("Error flushing request queue", err);
        this.resetFlush();
    }
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $f214a1ce0cc31a3c$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $f214a1ce0cc31a3c$var$logger.error.apply($f214a1ce0cc31a3c$var$logger.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $f214a1ce0cc31a3c$var$logger.error(err);
    }
};
/**
 * GDPR utils
 *
 * The General Data Protection Regulation (GDPR) is a regulation in EU law on data protection
 * and privacy for all individuals within the European Union. It addresses the export of personal
 * data outside the EU. The GDPR aims primarily to give control back to citizens and residents
 * over their personal data and to simplify the regulatory environment for international business
 * by unifying the regulation within the EU.
 *
 * This set of utilities is intended to enable opt in/out functionality in the Mixpanel JS SDK.
 * These functions are used internally by the SDK and are not intended to be publicly exposed.
 */ /**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $f214a1ce0cc31a3c$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = "__mp_opt_in_out_";
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $f214a1ce0cc31a3c$var$optIn(token, options) {
    $f214a1ce0cc31a3c$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $f214a1ce0cc31a3c$var$optOut(token, options) {
    $f214a1ce0cc31a3c$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $f214a1ce0cc31a3c$var$hasOptedIn(token, options) {
    return $f214a1ce0cc31a3c$var$_getStorageValue(token, options) === "1";
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $f214a1ce0cc31a3c$var$hasOptedOut(token, options) {
    if ($f214a1ce0cc31a3c$var$_hasDoNotTrackFlagOn(options)) {
        $f214a1ce0cc31a3c$var$console.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $f214a1ce0cc31a3c$var$_getStorageValue(token, options) === "0";
    if (optedOut) $f214a1ce0cc31a3c$var$console.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.");
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelLib(method) {
    return $f214a1ce0cc31a3c$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelPeople(method) {
    return $f214a1ce0cc31a3c$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelGroup(method) {
    return $f214a1ce0cc31a3c$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $f214a1ce0cc31a3c$var$clearOptInOut(token, options) {
    options = options || {};
    $f214a1ce0cc31a3c$var$_getStorage(options).remove($f214a1ce0cc31a3c$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $f214a1ce0cc31a3c$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === "localStorage" ? $f214a1ce0cc31a3c$var$_.localStorage : $f214a1ce0cc31a3c$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $f214a1ce0cc31a3c$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $f214a1ce0cc31a3c$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $f214a1ce0cc31a3c$var$_getStorageValue(token, options) {
    return $f214a1ce0cc31a3c$var$_getStorage(options).get($f214a1ce0cc31a3c$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $f214a1ce0cc31a3c$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win$1 = options && options.window || $f214a1ce0cc31a3c$var$win;
    var nav = win$1["navigator"] || {};
    var hasDntOn = false;
    $f214a1ce0cc31a3c$var$_.each([
        nav["doNotTrack"],
        nav["msDoNotTrack"],
        win$1["doNotTrack"]
    ], function(dntValue) {
        if ($f214a1ce0cc31a3c$var$_.includes([
            true,
            1,
            "1",
            "yes"
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $f214a1ce0cc31a3c$var$_optInOut(optValue, token, options) {
    if (!$f214a1ce0cc31a3c$var$_.isString(token) || !token.length) {
        $f214a1ce0cc31a3c$var$console.error("gdpr." + (optValue ? "optIn" : "optOut") + " called with an invalid token");
        return;
    }
    options = options || {};
    $f214a1ce0cc31a3c$var$_getStorage(options).set($f214a1ce0cc31a3c$var$_getStorageKey(token, options), optValue ? 1 : 0, $f214a1ce0cc31a3c$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || "$opt_in", options.trackProperties, {
        "send_immediately": true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $f214a1ce0cc31a3c$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, "token");
            var ignoreDnt = getConfigValue.call(this, "ignore_dnt");
            var persistenceType = getConfigValue.call(this, "opt_out_tracking_persistence_type");
            var persistencePrefix = getConfigValue.call(this, "opt_out_tracking_cookie_prefix");
            var win = getConfigValue.call(this, "window"); // used to override window during browser tests
            if (token) optedOut = $f214a1ce0cc31a3c$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $f214a1ce0cc31a3c$var$console.error("Unexpected error when checking tracking opt-out status: " + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === "function") callback(0);
        return;
    };
}
/* eslint camelcase: "off" */ /** @const */ var $f214a1ce0cc31a3c$var$SET_ACTION = "$set";
/** @const */ var $f214a1ce0cc31a3c$var$SET_ONCE_ACTION = "$set_once";
/** @const */ var $f214a1ce0cc31a3c$var$UNSET_ACTION = "$unset";
/** @const */ var $f214a1ce0cc31a3c$var$ADD_ACTION = "$add";
/** @const */ var $f214a1ce0cc31a3c$var$APPEND_ACTION = "$append";
/** @const */ var $f214a1ce0cc31a3c$var$UNION_ACTION = "$union";
/** @const */ var $f214a1ce0cc31a3c$var$REMOVE_ACTION = "$remove";
/** @const */ var $f214a1ce0cc31a3c$var$DELETE_ACTION = "$delete";
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $f214a1ce0cc31a3c$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($f214a1ce0cc31a3c$var$_.isObject(prop)) $f214a1ce0cc31a3c$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$f214a1ce0cc31a3c$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$f214a1ce0cc31a3c$var$_.isArray(prop)) prop = [
            prop
        ];
        $f214a1ce0cc31a3c$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$f214a1ce0cc31a3c$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($f214a1ce0cc31a3c$var$_.isObject(prop)) $f214a1ce0cc31a3c$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$f214a1ce0cc31a3c$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($f214a1ce0cc31a3c$var$_.isObject(list_name)) $f214a1ce0cc31a3c$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $f214a1ce0cc31a3c$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $f214a1ce0cc31a3c$var$_.isArray(values) ? values : [
            values
        ];
        data[$f214a1ce0cc31a3c$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($f214a1ce0cc31a3c$var$_.isObject(list_name)) $f214a1ce0cc31a3c$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$f214a1ce0cc31a3c$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($f214a1ce0cc31a3c$var$_.isObject(list_name)) $f214a1ce0cc31a3c$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$f214a1ce0cc31a3c$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$f214a1ce0cc31a3c$var$DELETE_ACTION] = "";
        return data;
    }
};
/* eslint camelcase: "off" */ /**
 * Mixpanel Group Object
 * @constructor
 */ var $f214a1ce0cc31a3c$var$MixpanelGroup = function() {};
$f214a1ce0cc31a3c$var$_.extend($f214a1ce0cc31a3c$var$MixpanelGroup.prototype, $f214a1ce0cc31a3c$var$apiActions);
$f214a1ce0cc31a3c$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f214a1ce0cc31a3c$var$MixpanelGroup.prototype.set = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($f214a1ce0cc31a3c$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f214a1ce0cc31a3c$var$MixpanelGroup.prototype.set_once = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($f214a1ce0cc31a3c$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f214a1ce0cc31a3c$var$MixpanelGroup.prototype.unset = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f214a1ce0cc31a3c$var$MixpanelGroup.prototype.union = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($f214a1ce0cc31a3c$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f214a1ce0cc31a3c$var$MixpanelGroup.prototype["delete"] = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f214a1ce0cc31a3c$var$MixpanelGroup.prototype.remove = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$f214a1ce0cc31a3c$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data["$group_key"] = this._group_key;
    data["$group_id"] = this._group_id;
    data["$token"] = this._get_config("token");
    var date_encoded_data = $f214a1ce0cc31a3c$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: "groups",
        data: date_encoded_data,
        endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes")["groups"],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$f214a1ce0cc31a3c$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === "$group_key" || prop === "$group_id";
};
$f214a1ce0cc31a3c$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$f214a1ce0cc31a3c$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
// MixpanelGroup Exports
$f214a1ce0cc31a3c$var$MixpanelGroup.prototype["remove"] = $f214a1ce0cc31a3c$var$MixpanelGroup.prototype.remove;
$f214a1ce0cc31a3c$var$MixpanelGroup.prototype["set"] = $f214a1ce0cc31a3c$var$MixpanelGroup.prototype.set;
$f214a1ce0cc31a3c$var$MixpanelGroup.prototype["set_once"] = $f214a1ce0cc31a3c$var$MixpanelGroup.prototype.set_once;
$f214a1ce0cc31a3c$var$MixpanelGroup.prototype["union"] = $f214a1ce0cc31a3c$var$MixpanelGroup.prototype.union;
$f214a1ce0cc31a3c$var$MixpanelGroup.prototype["unset"] = $f214a1ce0cc31a3c$var$MixpanelGroup.prototype.unset;
$f214a1ce0cc31a3c$var$MixpanelGroup.prototype["toString"] = $f214a1ce0cc31a3c$var$MixpanelGroup.prototype.toString;
/* eslint camelcase: "off" */ /**
 * Mixpanel People Object
 * @constructor
 */ var $f214a1ce0cc31a3c$var$MixpanelPeople = function() {};
$f214a1ce0cc31a3c$var$_.extend($f214a1ce0cc31a3c$var$MixpanelPeople.prototype, $f214a1ce0cc31a3c$var$apiActions);
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.set = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($f214a1ce0cc31a3c$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config("save_referrer")) this._mixpanel["persistence"].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$f214a1ce0cc31a3c$var$SET_ACTION] = $f214a1ce0cc31a3c$var$_.extend({}, $f214a1ce0cc31a3c$var$_.info.people_properties(), data[$f214a1ce0cc31a3c$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.set_once = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($f214a1ce0cc31a3c$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.unset = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.increment = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($f214a1ce0cc31a3c$var$_.isObject(prop)) {
        $f214a1ce0cc31a3c$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $f214a1ce0cc31a3c$var$console.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($f214a1ce0cc31a3c$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$f214a1ce0cc31a3c$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.append = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($f214a1ce0cc31a3c$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.remove = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($f214a1ce0cc31a3c$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.union = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($f214a1ce0cc31a3c$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.track_charge = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!$f214a1ce0cc31a3c$var$_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            $f214a1ce0cc31a3c$var$console.error("Invalid value passed to mixpanel.people.track_charge - must be a number");
            return;
        }
    }
    return this.append("$transactions", $f214a1ce0cc31a3c$var$_.extend({
        "$amount": amount
    }, properties), callback);
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set("$transactions", [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $f214a1ce0cc31a3c$var$console.error("mixpanel.people.delete_user() requires you to call identify() first");
        return;
    }
    var data = {
        "$delete": this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + ".people";
};
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data["$token"] = this._get_config("token");
    data["$distinct_id"] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property("$device_id");
    var user_id = this._mixpanel.get_property("$user_id");
    var had_persisted_distinct_id = this._mixpanel.get_property("$had_persisted_distinct_id");
    if (device_id) data["$device_id"] = device_id;
    if (user_id) data["$user_id"] = user_id;
    if (had_persisted_distinct_id) data["$had_persisted_distinct_id"] = had_persisted_distinct_id;
    var date_encoded_data = $f214a1ce0cc31a3c$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$f214a1ce0cc31a3c$var$_.isUndefined(callback)) {
            if (this._get_config("verbose")) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $f214a1ce0cc31a3c$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: "people",
        data: date_encoded_data,
        endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes")["engage"],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($f214a1ce0cc31a3c$var$SET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($f214a1ce0cc31a3c$var$SET_ACTION, data);
    else if ($f214a1ce0cc31a3c$var$SET_ONCE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($f214a1ce0cc31a3c$var$SET_ONCE_ACTION, data);
    else if ($f214a1ce0cc31a3c$var$UNSET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($f214a1ce0cc31a3c$var$UNSET_ACTION, data);
    else if ($f214a1ce0cc31a3c$var$ADD_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($f214a1ce0cc31a3c$var$ADD_ACTION, data);
    else if ($f214a1ce0cc31a3c$var$APPEND_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($f214a1ce0cc31a3c$var$APPEND_ACTION, data);
    else if ($f214a1ce0cc31a3c$var$REMOVE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($f214a1ce0cc31a3c$var$REMOVE_ACTION, data);
    else if ($f214a1ce0cc31a3c$var$UNION_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($f214a1ce0cc31a3c$var$UNION_ACTION, data);
    else $f214a1ce0cc31a3c$var$console.error("Invalid call to _enqueue():", data);
};
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $f214a1ce0cc31a3c$var$_.extend({}, this._mixpanel["persistence"].load_queue(action));
    var action_params = queued_data;
    if (!$f214a1ce0cc31a3c$var$_.isUndefined(queued_data) && $f214a1ce0cc31a3c$var$_.isObject(queued_data) && !$f214a1ce0cc31a3c$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel["persistence"]._pop_from_people_queue(action, queued_data);
        _this._mixpanel["persistence"].save();
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue(action, queued_data);
            if (!$f214a1ce0cc31a3c$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    this._flush_one_queue($f214a1ce0cc31a3c$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($f214a1ce0cc31a3c$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($f214a1ce0cc31a3c$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $f214a1ce0cc31a3c$var$_.keys(queue);
    });
    this._flush_one_queue($f214a1ce0cc31a3c$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($f214a1ce0cc31a3c$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel["persistence"].load_queue($f214a1ce0cc31a3c$var$APPEND_ACTION);
    if (!$f214a1ce0cc31a3c$var$_.isUndefined($append_queue) && $f214a1ce0cc31a3c$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($f214a1ce0cc31a3c$var$APPEND_ACTION, $append_item);
            if (!$f214a1ce0cc31a3c$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_queue = this._mixpanel["persistence"].load_queue($f214a1ce0cc31a3c$var$APPEND_ACTION);
            $append_item = $append_queue.pop();
            _this._mixpanel["persistence"].save();
            if (!$f214a1ce0cc31a3c$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
    }
    // same for $remove
    var $remove_queue = this._mixpanel["persistence"].load_queue($f214a1ce0cc31a3c$var$REMOVE_ACTION);
    if (!$f214a1ce0cc31a3c$var$_.isUndefined($remove_queue) && $f214a1ce0cc31a3c$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($f214a1ce0cc31a3c$var$REMOVE_ACTION, $remove_item);
            if (!$f214a1ce0cc31a3c$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_queue = this._mixpanel["persistence"].load_queue($f214a1ce0cc31a3c$var$REMOVE_ACTION);
            $remove_item = $remove_queue.pop();
            _this._mixpanel["persistence"].save();
            if (!$f214a1ce0cc31a3c$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
    }
};
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === "$distinct_id" || prop === "$token" || prop === "$device_id" || prop === "$user_id" || prop === "$had_persisted_distinct_id";
};
// MixpanelPeople Exports
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype["set"] = $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.set;
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype["set_once"] = $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.set_once;
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype["unset"] = $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.unset;
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype["increment"] = $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.increment;
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype["append"] = $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.append;
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype["remove"] = $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.remove;
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype["union"] = $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.union;
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype["track_charge"] = $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.track_charge;
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype["clear_charges"] = $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.clear_charges;
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype["delete_user"] = $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.delete_user;
$f214a1ce0cc31a3c$var$MixpanelPeople.prototype["toString"] = $f214a1ce0cc31a3c$var$MixpanelPeople.prototype.toString;
/* eslint camelcase: "off" */ /*
 * Constants
 */ /** @const */ var $f214a1ce0cc31a3c$var$SET_QUEUE_KEY = "__mps";
/** @const */ var $f214a1ce0cc31a3c$var$SET_ONCE_QUEUE_KEY = "__mpso";
/** @const */ var $f214a1ce0cc31a3c$var$UNSET_QUEUE_KEY = "__mpus";
/** @const */ var $f214a1ce0cc31a3c$var$ADD_QUEUE_KEY = "__mpa";
/** @const */ var $f214a1ce0cc31a3c$var$APPEND_QUEUE_KEY = "__mpap";
/** @const */ var $f214a1ce0cc31a3c$var$REMOVE_QUEUE_KEY = "__mpr";
/** @const */ var $f214a1ce0cc31a3c$var$UNION_QUEUE_KEY = "__mpu";
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $f214a1ce0cc31a3c$var$PEOPLE_DISTINCT_ID_KEY = "$people_distinct_id";
/** @const */ var $f214a1ce0cc31a3c$var$ALIAS_ID_KEY = "__alias";
/** @const */ var $f214a1ce0cc31a3c$var$EVENT_TIMERS_KEY = "__timers";
/** @const */ var $f214a1ce0cc31a3c$var$RESERVED_PROPERTIES = [
    $f214a1ce0cc31a3c$var$SET_QUEUE_KEY,
    $f214a1ce0cc31a3c$var$SET_ONCE_QUEUE_KEY,
    $f214a1ce0cc31a3c$var$UNSET_QUEUE_KEY,
    $f214a1ce0cc31a3c$var$ADD_QUEUE_KEY,
    $f214a1ce0cc31a3c$var$APPEND_QUEUE_KEY,
    $f214a1ce0cc31a3c$var$REMOVE_QUEUE_KEY,
    $f214a1ce0cc31a3c$var$UNION_QUEUE_KEY,
    $f214a1ce0cc31a3c$var$PEOPLE_DISTINCT_ID_KEY,
    $f214a1ce0cc31a3c$var$ALIAS_ID_KEY,
    $f214a1ce0cc31a3c$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $f214a1ce0cc31a3c$var$MixpanelPersistence = function(config) {
    this["props"] = {};
    this.campaign_params_saved = false;
    if (config["persistence_name"]) this.name = "mp_" + config["persistence_name"];
    else this.name = "mp_" + config["token"] + "_mixpanel";
    var storage_type = config["persistence"];
    if (storage_type !== "cookie" && storage_type !== "localStorage") {
        $f214a1ce0cc31a3c$var$console.critical("Unknown persistence type " + storage_type + "; falling back to cookie");
        storage_type = config["persistence"] = "cookie";
    }
    if (storage_type === "localStorage" && $f214a1ce0cc31a3c$var$_.localStorage.is_supported()) this.storage = $f214a1ce0cc31a3c$var$_.localStorage;
    else this.storage = $f214a1ce0cc31a3c$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade(config);
    this.save();
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    this.load();
    // Filter out reserved properties
    $f214a1ce0cc31a3c$var$_.each(this["props"], function(v, k) {
        if (!$f214a1ce0cc31a3c$var$_.include($f214a1ce0cc31a3c$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this["props"] = $f214a1ce0cc31a3c$var$_.extend({}, entry);
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.upgrade = function(config) {
    var upgrade_from_old_lib = config["upgrade"], old_cookie_name, old_cookie;
    if (upgrade_from_old_lib) {
        old_cookie_name = "mp_super_properties";
        // Case where they had a custom cookie name before.
        if (typeof upgrade_from_old_lib === "string") old_cookie_name = upgrade_from_old_lib;
        old_cookie = this.storage.parse(old_cookie_name);
        // remove the cookie
        this.storage.remove(old_cookie_name);
        this.storage.remove(old_cookie_name, true);
        if (old_cookie) this["props"] = $f214a1ce0cc31a3c$var$_.extend(this["props"], old_cookie["all"], old_cookie["events"]);
    }
    if (!config["cookie_name"] && config["name"] !== "mixpanel") {
        // special case to handle people with cookies of the form
        // mp_TOKEN_INSTANCENAME from the first release of this library
        old_cookie_name = "mp_" + config["token"] + "_" + config["name"];
        old_cookie = this.storage.parse(old_cookie_name);
        if (old_cookie) {
            this.storage.remove(old_cookie_name);
            this.storage.remove(old_cookie_name, true);
            // Save the prop values that were in the cookie from before -
            // this should only happen once as we delete the old one.
            this.register_once(old_cookie);
        }
    }
    if (this.storage === $f214a1ce0cc31a3c$var$_.localStorage) {
        old_cookie = $f214a1ce0cc31a3c$var$_.cookie.parse(this.name);
        $f214a1ce0cc31a3c$var$_.cookie.remove(this.name);
        $f214a1ce0cc31a3c$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    }
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $f214a1ce0cc31a3c$var$_.JSONEncode(this["props"]), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this["props"][key];
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this["props"] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($f214a1ce0cc31a3c$var$_.isObject(props)) {
        if (typeof default_value === "undefined") default_value = "None";
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        this.load();
        $f214a1ce0cc31a3c$var$_.each(props, function(val, prop) {
            if (!this["props"].hasOwnProperty(prop) || this["props"][prop] === default_value) this["props"][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($f214a1ce0cc31a3c$var$_.isObject(props)) {
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        this.load();
        $f214a1ce0cc31a3c$var$_.extend(this["props"], props);
        this.save();
        return true;
    }
    return false;
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this["props"]) {
        delete this["props"][prop];
        this.save();
    }
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($f214a1ce0cc31a3c$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        "$initial_referrer": referrer || "$direct",
        "$initial_referring_domain": $f214a1ce0cc31a3c$var$_.info.referringDomain(referrer) || "$direct"
    }, "");
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $f214a1ce0cc31a3c$var$_.strip_empty_properties({
        "$initial_referrer": this["props"]["$initial_referrer"],
        "$initial_referring_domain": this["props"]["$initial_referring_domain"]
    });
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config["cookie_expiration"];
    this.set_disabled(config["disable_persistence"]);
    this.set_cookie_domain(config["cookie_domain"]);
    this.set_cross_site(config["cross_site_cookie"]);
    this.set_cross_subdomain(config["cross_subdomain_cookie"]);
    this.set_secure(config["secure_cookie"]);
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($f214a1ce0cc31a3c$var$SET_ACTION), set_once_q = this._get_or_create_queue($f214a1ce0cc31a3c$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($f214a1ce0cc31a3c$var$UNSET_ACTION), add_q = this._get_or_create_queue($f214a1ce0cc31a3c$var$ADD_ACTION), union_q = this._get_or_create_queue($f214a1ce0cc31a3c$var$UNION_ACTION), remove_q = this._get_or_create_queue($f214a1ce0cc31a3c$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($f214a1ce0cc31a3c$var$APPEND_ACTION, []);
    if (q_key === $f214a1ce0cc31a3c$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $f214a1ce0cc31a3c$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($f214a1ce0cc31a3c$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($f214a1ce0cc31a3c$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($f214a1ce0cc31a3c$var$UNSET_ACTION, q_data);
    } else if (q_key === $f214a1ce0cc31a3c$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $f214a1ce0cc31a3c$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($f214a1ce0cc31a3c$var$UNSET_ACTION, q_data);
    } else if (q_key === $f214a1ce0cc31a3c$var$UNSET_QUEUE_KEY) $f214a1ce0cc31a3c$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $f214a1ce0cc31a3c$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $f214a1ce0cc31a3c$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $f214a1ce0cc31a3c$var$ADD_QUEUE_KEY) {
        $f214a1ce0cc31a3c$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($f214a1ce0cc31a3c$var$UNSET_ACTION, q_data);
    } else if (q_key === $f214a1ce0cc31a3c$var$UNION_QUEUE_KEY) {
        $f214a1ce0cc31a3c$var$_.each(q_data, function(v, k) {
            if ($f214a1ce0cc31a3c$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue($f214a1ce0cc31a3c$var$UNSET_ACTION, q_data);
    } else if (q_key === $f214a1ce0cc31a3c$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($f214a1ce0cc31a3c$var$APPEND_ACTION, q_data);
    } else if (q_key === $f214a1ce0cc31a3c$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($f214a1ce0cc31a3c$var$UNSET_ACTION, q_data);
    }
    $f214a1ce0cc31a3c$var$console.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):");
    $f214a1ce0cc31a3c$var$console.log(data);
    this.save();
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this["props"][this._get_queue_key(queue)];
    if (!$f214a1ce0cc31a3c$var$_.isUndefined(q)) $f214a1ce0cc31a3c$var$_.each(data, function(v, k) {
        if (queue === $f214a1ce0cc31a3c$var$APPEND_ACTION || queue === $f214a1ce0cc31a3c$var$REMOVE_ACTION) // list actions: only remove if both k+v match
        // e.g. remove should not override append in a case like
        // append({foo: 'bar'}); remove({foo: 'qux'})
        $f214a1ce0cc31a3c$var$_.each(q, function(queued_action) {
            if (queued_action[k] === v) delete queued_action[k];
        });
        else delete q[k];
    }, this);
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $f214a1ce0cc31a3c$var$SET_ACTION) return $f214a1ce0cc31a3c$var$SET_QUEUE_KEY;
    else if (queue === $f214a1ce0cc31a3c$var$SET_ONCE_ACTION) return $f214a1ce0cc31a3c$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $f214a1ce0cc31a3c$var$UNSET_ACTION) return $f214a1ce0cc31a3c$var$UNSET_QUEUE_KEY;
    else if (queue === $f214a1ce0cc31a3c$var$ADD_ACTION) return $f214a1ce0cc31a3c$var$ADD_QUEUE_KEY;
    else if (queue === $f214a1ce0cc31a3c$var$APPEND_ACTION) return $f214a1ce0cc31a3c$var$APPEND_QUEUE_KEY;
    else if (queue === $f214a1ce0cc31a3c$var$REMOVE_ACTION) return $f214a1ce0cc31a3c$var$REMOVE_QUEUE_KEY;
    else if (queue === $f214a1ce0cc31a3c$var$UNION_ACTION) return $f214a1ce0cc31a3c$var$UNION_QUEUE_KEY;
    else $f214a1ce0cc31a3c$var$console.error("Invalid queue:", queue);
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $f214a1ce0cc31a3c$var$_.isUndefined(default_val) ? {} : default_val;
    return this["props"][key] || (this["props"][key] = default_val);
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop($f214a1ce0cc31a3c$var$EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this["props"][$f214a1ce0cc31a3c$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop($f214a1ce0cc31a3c$var$EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!$f214a1ce0cc31a3c$var$_.isUndefined(timestamp)) {
        delete this["props"][$f214a1ce0cc31a3c$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/* eslint camelcase: "off" */ /*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ // ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==
/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $f214a1ce0cc31a3c$var$init_type; // MODULE or SNIPPET loader
var $f214a1ce0cc31a3c$var$mixpanel_master; // main mixpanel instance / object
var $f214a1ce0cc31a3c$var$INIT_MODULE = 0;
var $f214a1ce0cc31a3c$var$INIT_SNIPPET = 1;
var $f214a1ce0cc31a3c$var$IDENTITY_FUNC = function(x) {
    return x;
};
var $f214a1ce0cc31a3c$var$NOOP_FUNC = function() {};
/** @const */ var $f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME = "mixpanel";
/** @const */ var $f214a1ce0cc31a3c$var$PAYLOAD_TYPE_BASE64 = "base64";
/** @const */ var $f214a1ce0cc31a3c$var$PAYLOAD_TYPE_JSON = "json";
/** @const */ var $f214a1ce0cc31a3c$var$DEVICE_ID_PREFIX = "$device:";
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $f214a1ce0cc31a3c$var$USE_XHR = $f214a1ce0cc31a3c$var$win.XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $f214a1ce0cc31a3c$var$ENQUEUE_REQUESTS = !$f214a1ce0cc31a3c$var$USE_XHR && $f214a1ce0cc31a3c$var$userAgent.indexOf("MSIE") === -1 && $f214a1ce0cc31a3c$var$userAgent.indexOf("Mozilla") === -1;
// save reference to navigator.sendBeacon so it can be minified
var $f214a1ce0cc31a3c$var$sendBeacon = null;
if ($f214a1ce0cc31a3c$var$navigator["sendBeacon"]) $f214a1ce0cc31a3c$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $f214a1ce0cc31a3c$var$navigator["sendBeacon"].apply($f214a1ce0cc31a3c$var$navigator, arguments);
};
var $f214a1ce0cc31a3c$var$DEFAULT_API_ROUTES = {
    "track": "track/",
    "engage": "engage/",
    "groups": "groups/",
    "record": "record/"
};
/*
 * Module-level globals
 */ var $f214a1ce0cc31a3c$var$DEFAULT_CONFIG = {
    "api_host": "https://api-js.mixpanel.com",
    "api_routes": $f214a1ce0cc31a3c$var$DEFAULT_API_ROUTES,
    "api_method": "POST",
    "api_transport": "XHR",
    "api_payload_format": $f214a1ce0cc31a3c$var$PAYLOAD_TYPE_BASE64,
    "app_host": "https://mixpanel.com",
    "cdn": "https://cdn.mxpnl.com",
    "cross_site_cookie": false,
    "cross_subdomain_cookie": true,
    "error_reporter": $f214a1ce0cc31a3c$var$NOOP_FUNC,
    "persistence": "cookie",
    "persistence_name": "",
    "cookie_domain": "",
    "cookie_name": "",
    "loaded": $f214a1ce0cc31a3c$var$NOOP_FUNC,
    "mp_loader": null,
    "track_marketing": true,
    "track_pageview": false,
    "skip_first_touch_marketing": false,
    "store_google": true,
    "stop_utm_persistence": false,
    "save_referrer": true,
    "test": false,
    "verbose": false,
    "img": false,
    "debug": false,
    "track_links_timeout": 300,
    "cookie_expiration": 365,
    "upgrade": false,
    "disable_persistence": false,
    "disable_cookie": false,
    "secure_cookie": false,
    "ip": true,
    "opt_out_tracking_by_default": false,
    "opt_out_persistence_by_default": false,
    "opt_out_tracking_persistence_type": "localStorage",
    "opt_out_tracking_cookie_prefix": null,
    "property_blacklist": [],
    "xhr_headers": {},
    "ignore_dnt": false,
    "batch_requests": true,
    "batch_size": 50,
    "batch_flush_interval_ms": 5000,
    "batch_request_timeout_ms": 90000,
    "batch_autostart": true,
    "hooks": {},
    "record_sessions_percent": 0,
    "record_idle_timeout_ms": 1800000,
    "record_max_ms": $f214a1ce0cc31a3c$var$MAX_RECORDING_MS,
    "record_mask_text_selector": "*",
    "recorder_src": "https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js"
};
var $f214a1ce0cc31a3c$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $f214a1ce0cc31a3c$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $f214a1ce0cc31a3c$var$create_mplib = function(token, config, name) {
    var instance, target = name === $f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME ? $f214a1ce0cc31a3c$var$mixpanel_master : $f214a1ce0cc31a3c$var$mixpanel_master[name];
    if (target && $f214a1ce0cc31a3c$var$init_type === $f214a1ce0cc31a3c$var$INIT_MODULE) instance = target;
    else {
        if (target && !$f214a1ce0cc31a3c$var$_.isArray(target)) {
            $f214a1ce0cc31a3c$var$console.error("You have already initialized " + name);
            return;
        }
        instance = new $f214a1ce0cc31a3c$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance["people"] = new $f214a1ce0cc31a3c$var$MixpanelPeople();
    instance["people"]._init(instance);
    if (!instance.get_config("skip_first_touch_marketing")) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = $f214a1ce0cc31a3c$var$_.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        $f214a1ce0cc31a3c$var$_.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params["initial_" + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance["people"].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $f214a1ce0cc31a3c$var$Config.DEBUG = $f214a1ce0cc31a3c$var$Config.DEBUG || instance.get_config("debug");
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$f214a1ce0cc31a3c$var$_.isUndefined(target) && $f214a1ce0cc31a3c$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance["people"], target["people"]);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($f214a1ce0cc31a3c$var$_.isUndefined(name)) {
        this.report_error("You must name your new library: init(token, config, name)");
        return;
    }
    if (name === $f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME) {
        this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
        return;
    }
    var instance = $f214a1ce0cc31a3c$var$create_mplib(token, config, name);
    $f214a1ce0cc31a3c$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this["__loaded"] = true;
    this["config"] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!("api_payload_format" in config)) {
        var api_host = config["api_host"] || $f214a1ce0cc31a3c$var$DEFAULT_CONFIG["api_host"];
        if (api_host.match(/\.mixpanel\.com/)) variable_features["api_payload_format"] = $f214a1ce0cc31a3c$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($f214a1ce0cc31a3c$var$_.extend({}, $f214a1ce0cc31a3c$var$DEFAULT_CONFIG, variable_features, config, {
        "name": name,
        "token": token,
        "callback_fn": (name === $f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME ? name : $f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME + "." + name) + "._jsc"
    }));
    this["_jsc"] = $f214a1ce0cc31a3c$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        "disable_all_events": false,
        "identify_called": false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config("batch_requests");
    if (this._batch_requests) {
        if (!$f214a1ce0cc31a3c$var$_.localStorage.is_supported(true) || !$f214a1ce0cc31a3c$var$USE_XHR) {
            this._batch_requests = false;
            $f214a1ce0cc31a3c$var$console.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support");
            $f214a1ce0cc31a3c$var$_.each(this.get_batcher_configs(), function(batcher_config) {
                $f214a1ce0cc31a3c$var$console.log("Clearing batch queue " + batcher_config.queue_key);
                $f214a1ce0cc31a3c$var$_.localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if ($f214a1ce0cc31a3c$var$sendBeacon && $f214a1ce0cc31a3c$var$win.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $f214a1ce0cc31a3c$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $f214a1ce0cc31a3c$var$win.addEventListener("pagehide", function(ev) {
                    if (ev["persisted"]) flush_on_unload();
                });
                $f214a1ce0cc31a3c$var$win.addEventListener("visibilitychange", function() {
                    if ($f214a1ce0cc31a3c$var$document$1["visibilityState"] === "hidden") flush_on_unload();
                });
            }
        }
    }
    this["persistence"] = this["cookie"] = new $f214a1ce0cc31a3c$var$MixpanelPersistence(this["config"]);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $f214a1ce0cc31a3c$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        "distinct_id": $f214a1ce0cc31a3c$var$DEVICE_ID_PREFIX + uuid,
        "$device_id": uuid
    }, "");
    var track_pageview_option = this.get_config("track_pageview");
    if (track_pageview_option) this._init_url_change_tracking(track_pageview_option);
    if (this.get_config("record_sessions_percent") > 0 && Math.random() * 100 <= this.get_config("record_sessions_percent")) this.start_session_recording();
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype.start_session_recording = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelLib(function() {
    if (!$f214a1ce0cc31a3c$var$win["MutationObserver"]) {
        $f214a1ce0cc31a3c$var$console.critical("Browser does not support MutationObserver; skipping session recording");
        return;
    }
    var handleLoadedRecorder = $f214a1ce0cc31a3c$var$_.bind(function() {
        this._recorder = this._recorder || new $f214a1ce0cc31a3c$var$win["__mp_recorder"](this);
        this._recorder["startRecording"]();
    }, this);
    if ($f214a1ce0cc31a3c$var$_.isUndefined($f214a1ce0cc31a3c$var$win["__mp_recorder"])) {
        var scriptEl = $f214a1ce0cc31a3c$var$document$1.createElement("script");
        scriptEl.type = "text/javascript";
        scriptEl.async = true;
        scriptEl.onload = handleLoadedRecorder;
        scriptEl.src = this.get_config("recorder_src");
        $f214a1ce0cc31a3c$var$document$1.head.appendChild(scriptEl);
    } else handleLoadedRecorder();
});
$f214a1ce0cc31a3c$var$MixpanelLib.prototype.stop_session_recording = function() {
    if (this._recorder) this._recorder["stopRecording"]();
    else $f214a1ce0cc31a3c$var$console.critical("Session recorder module not loaded");
};
// Private methods
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._loaded = function() {
    this.get_config("loaded")(this);
    this._set_default_superprops();
    this["people"].set_once(this["persistence"].get_referrer_info());
    // The original 'store_google' functionality will be deprecated and the config will be
    // used to clear previously managed UTM parameters from persistence.
    // stop_utm_persistence is `false` by default now but will be default `true` in the future.
    if (this.get_config("store_google") && this.get_config("stop_utm_persistence")) {
        var utm_params = $f214a1ce0cc31a3c$var$_.info.campaignParams(null);
        $f214a1ce0cc31a3c$var$_.each(utm_params, (function(_utm_value, utm_key) {
            // We need to unregister persisted UTM parameters so old values
            // are not mixed with the new UTM parameters
            this.unregister(utm_key);
        }).bind(this));
    }
};
// update persistence with info on referrer, UTM params, etc
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._set_default_superprops = function() {
    this["persistence"].update_search_keyword($f214a1ce0cc31a3c$var$document$1.referrer);
    if (this.get_config("store_google") && !this.get_config("stop_utm_persistence")) this.register($f214a1ce0cc31a3c$var$_.info.campaignParams());
    if (this.get_config("save_referrer")) this["persistence"].update_referrer_info($f214a1ce0cc31a3c$var$document$1.referrer);
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._dom_loaded = function() {
    $f214a1ce0cc31a3c$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $f214a1ce0cc31a3c$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config("img")) {
        this.report_error("You can't use DOM tracking functions with img = true.");
        return false;
    }
    if (!$f214a1ce0cc31a3c$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._init_url_change_tracking = function(track_pageview_option) {
    var previous_tracked_url = "";
    var tracked = this.track_pageview();
    if (tracked) previous_tracked_url = $f214a1ce0cc31a3c$var$_.info.currentUrl();
    if ($f214a1ce0cc31a3c$var$_.include([
        "full-url",
        "url-with-path-and-query-string",
        "url-with-path"
    ], track_pageview_option)) {
        $f214a1ce0cc31a3c$var$win.addEventListener("popstate", function() {
            $f214a1ce0cc31a3c$var$win.dispatchEvent(new Event("mp_locationchange"));
        });
        $f214a1ce0cc31a3c$var$win.addEventListener("hashchange", function() {
            $f214a1ce0cc31a3c$var$win.dispatchEvent(new Event("mp_locationchange"));
        });
        var nativePushState = $f214a1ce0cc31a3c$var$win.history.pushState;
        if (typeof nativePushState === "function") $f214a1ce0cc31a3c$var$win.history.pushState = function(state, unused, url) {
            nativePushState.call($f214a1ce0cc31a3c$var$win.history, state, unused, url);
            $f214a1ce0cc31a3c$var$win.dispatchEvent(new Event("mp_locationchange"));
        };
        var nativeReplaceState = $f214a1ce0cc31a3c$var$win.history.replaceState;
        if (typeof nativeReplaceState === "function") $f214a1ce0cc31a3c$var$win.history.replaceState = function(state, unused, url) {
            nativeReplaceState.call($f214a1ce0cc31a3c$var$win.history, state, unused, url);
            $f214a1ce0cc31a3c$var$win.dispatchEvent(new Event("mp_locationchange"));
        };
        $f214a1ce0cc31a3c$var$win.addEventListener("mp_locationchange", (function() {
            var current_url = $f214a1ce0cc31a3c$var$_.info.currentUrl();
            var should_track = false;
            if (track_pageview_option === "full-url") should_track = current_url !== previous_tracked_url;
            else if (track_pageview_option === "url-with-path-and-query-string") should_track = current_url.split("#")[0] !== previous_tracked_url.split("#")[0];
            else if (track_pageview_option === "url-with-path") should_track = current_url.split("#")[0].split("?")[0] !== previous_tracked_url.split("#")[0].split("?")[0];
            if (should_track) {
                var tracked = this.track_pageview();
                if (tracked) previous_tracked_url = current_url;
            }
        }).bind(this));
    }
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($f214a1ce0cc31a3c$var$_.isUndefined(callback)) return null;
    if ($f214a1ce0cc31a3c$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this["_jsc"];
        var randomized_cb = "" + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config("callback_fn") + "[" + randomized_cb + "]";
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($f214a1ce0cc31a3c$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config("api_method"),
        transport: this.get_config("api_transport"),
        verbose: this.get_config("verbose")
    };
    var body_data = null;
    if (!callback && ($f214a1ce0cc31a3c$var$_.isFunction(options) || typeof options === "string")) {
        callback = options;
        options = null;
    }
    options = $f214a1ce0cc31a3c$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$f214a1ce0cc31a3c$var$USE_XHR) options.method = "GET";
    var use_post = options.method === "POST";
    var use_sendBeacon = $f214a1ce0cc31a3c$var$sendBeacon && use_post && options.transport.toLowerCase() === "sendbeacon";
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data["verbose"]) verbose_mode = true;
    if (this.get_config("test")) data["test"] = 1;
    if (verbose_mode) data["verbose"] = 1;
    if (this.get_config("img")) data["img"] = 1;
    if (!$f214a1ce0cc31a3c$var$USE_XHR) {
        if (callback) data["callback"] = callback;
        else if (verbose_mode || this.get_config("test")) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data["callback"] = "(function(){})";
    }
    data["ip"] = this.get_config("ip") ? 1 : 0;
    data["_"] = new Date().getTime().toString();
    if (use_post) {
        body_data = "data=" + encodeURIComponent(data["data"]);
        delete data["data"];
    }
    url += "?" + $f214a1ce0cc31a3c$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ("img" in data) {
        var img = $f214a1ce0cc31a3c$var$document$1.createElement("img");
        img.src = url;
        $f214a1ce0cc31a3c$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $f214a1ce0cc31a3c$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($f214a1ce0cc31a3c$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config("xhr_headers");
        if (use_post) headers["Content-Type"] = "application/x-www-form-urlencoded";
        $f214a1ce0cc31a3c$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== "undefined") {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $f214a1ce0cc31a3c$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = "timeout";
                    else error = "Bad HTTP status: " + req.status + " " + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) callback({
                            status: 0,
                            error: error,
                            xhr_req: req
                        });
                        else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $f214a1ce0cc31a3c$var$document$1.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $f214a1ce0cc31a3c$var$document$1.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $f214a1ce0cc31a3c$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($f214a1ce0cc31a3c$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === "function") item.call(this);
            else if ($f214a1ce0cc31a3c$var$_.isArray(item) && fn_name === "alias") alias_calls.push(item);
            else if ($f214a1ce0cc31a3c$var$_.isArray(item) && fn_name.indexOf("track") !== -1 && typeof this[fn_name] === "function") tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $f214a1ce0cc31a3c$var$_.each(calls, function(item) {
            if ($f214a1ce0cc31a3c$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $f214a1ce0cc31a3c$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$f214a1ce0cc31a3c$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = "__mpq_" + this.get_config("token");
    var api_routes = this.get_config("api_routes");
    this._batcher_configs = this._batcher_configs || {
        events: {
            type: "events",
            endpoint: "/" + api_routes["track"],
            queue_key: queue_prefix + "_ev"
        },
        people: {
            type: "people",
            endpoint: "/" + api_routes["engage"],
            queue_key: queue_prefix + "_pp"
        },
        groups: {
            type: "groups",
            endpoint: "/" + api_routes["groups"],
            queue_key: queue_prefix + "_gr"
        }
    };
    return this._batcher_configs;
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = $f214a1ce0cc31a3c$var$_.bind(function(attrs) {
            return new $f214a1ce0cc31a3c$var$RequestBatcher(attrs.queue_key, {
                libConfig: this["config"],
                sendRequestFunc: $f214a1ce0cc31a3c$var$_.bind(function(data, options, cb) {
                    this._send_request(this.get_config("api_host") + attrs.endpoint, this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $f214a1ce0cc31a3c$var$_.bind(function(item) {
                    return this._run_hook("before_send_" + attrs.type, item);
                }, this),
                errorReporter: this.get_config("error_reporter"),
                stopAllBatchingFunc: $f214a1ce0cc31a3c$var$_.bind(this.stop_batch_senders, this)
            });
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config("batch_autostart")) this.start_batch_senders();
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $f214a1ce0cc31a3c$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $f214a1ce0cc31a3c$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === "undefined") this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $f214a1ce0cc31a3c$var$_.JSONEncode(data);
    if (this.get_config("api_payload_format") === $f214a1ce0cc31a3c$var$PAYLOAD_TYPE_BASE64) encoded_data = $f214a1ce0cc31a3c$var$_.base64Encode(encoded_data);
    return {
        "data": encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $f214a1ce0cc31a3c$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $f214a1ce0cc31a3c$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $f214a1ce0cc31a3c$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook("before_send_" + options.type, truncated_data);
        if (truncated_data) {
            $f214a1ce0cc31a3c$var$console.log("MIXPANEL REQUEST:");
            $f214a1ce0cc31a3c$var$console.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data, function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.track = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === "function") {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options["transport"]; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options["send_immediately"];
    if (typeof callback !== "function") callback = $f214a1ce0cc31a3c$var$NOOP_FUNC;
    if ($f214a1ce0cc31a3c$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.track");
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = $f214a1ce0cc31a3c$var$_.extend({}, properties);
    properties["token"] = this.get_config("token");
    // set $duration if time_event was previously called for this event
    var start_timestamp = this["persistence"].remove_event_timer(event_name);
    if (!$f214a1ce0cc31a3c$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties["$duration"] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config("track_marketing") ? $f214a1ce0cc31a3c$var$_.info.marketingParams() : {};
    if (this._recorder) {
        var replay_id = this._recorder["replayId"];
        if (replay_id) properties["$mp_replay_id"] = replay_id;
    }
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $f214a1ce0cc31a3c$var$_.extend({}, $f214a1ce0cc31a3c$var$_.info.properties({
        "mp_loader": this.get_config("mp_loader")
    }), marketing_properties, this["persistence"].properties(), this.unpersisted_superprops, properties);
    var property_blacklist = this.get_config("property_blacklist");
    if ($f214a1ce0cc31a3c$var$_.isArray(property_blacklist)) $f214a1ce0cc31a3c$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error("Invalid value for property_blacklist config: " + property_blacklist);
    var data = {
        "event": event_name,
        "properties": properties
    };
    var ret = this._track_or_batch({
        type: "events",
        data: data,
        endpoint: this.get_config("api_host") + "/" + this.get_config("api_routes")["track"],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.set_group = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$f214a1ce0cc31a3c$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this["people"].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.add_group = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        prop[group_key] = old_values;
        this.register(prop);
    }
    return this["people"].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.remove_group = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this["people"].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.track_with_groups = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $f214a1ce0cc31a3c$var$_.extend({}, properties || {});
    $f214a1ce0cc31a3c$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + "_" + JSON.stringify(group_id);
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $f214a1ce0cc31a3c$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data.
 *
 * ### Usage:
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * ### Notes:
 *
 * The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 *     // track only page loads
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: true});
 *
 *     // track when the URL changes in any manner
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'full-url'});
 *
 *     // track when the URL changes, ignoring any changes in the hash part
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path-and-query-string'});
 *
 *     // track when the path changes, ignoring any query parameter or hash changes
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.track_pageview = $f214a1ce0cc31a3c$var$addOptOutCheckMixpanelLib(function(properties, options) {
    if (typeof properties !== "object") properties = {};
    options = options || {};
    var event_name = options["event_name"] || "$mp_web_page_view";
    var default_page_properties = $f214a1ce0cc31a3c$var$_.extend($f214a1ce0cc31a3c$var$_.info.mpPageViewProperties(), $f214a1ce0cc31a3c$var$_.info.campaignParams(), $f214a1ce0cc31a3c$var$_.info.clickParams());
    var event_properties = $f214a1ce0cc31a3c$var$_.extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $f214a1ce0cc31a3c$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $f214a1ce0cc31a3c$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($f214a1ce0cc31a3c$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.time_event");
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this["persistence"].set_event_timer(event_name, new Date().getTime());
};
var $f214a1ce0cc31a3c$var$REGISTER_DEFAULTS = {
    "persistent": true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $f214a1ce0cc31a3c$var$options_for_register = function(days_or_options) {
    var options;
    if ($f214a1ce0cc31a3c$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$f214a1ce0cc31a3c$var$_.isUndefined(days_or_options)) options = {
        "days": days_or_options
    };
    else options = {};
    return $f214a1ce0cc31a3c$var$_.extend({}, $f214a1ce0cc31a3c$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $f214a1ce0cc31a3c$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register(props, options["days"]);
    else $f214a1ce0cc31a3c$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $f214a1ce0cc31a3c$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register_once(props, default_value, options["days"]);
    else {
        if (typeof default_value === "undefined") default_value = "None";
        $f214a1ce0cc31a3c$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $f214a1ce0cc31a3c$var$options_for_register(options);
    if (options["persistent"]) this["persistence"].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === "string" && new_distinct_id.indexOf($f214a1ce0cc31a3c$var$DEVICE_ID_PREFIX) === 0) {
            this.report_error("distinct_id cannot have $device: prefix");
            return -1;
        }
        this.register({
            "$user_id": new_distinct_id
        });
    }
    if (!this.get_property("$device_id")) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            "$had_persisted_distinct_id": true,
            "$device_id": device_id
        }, "");
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($f214a1ce0cc31a3c$var$ALIAS_ID_KEY)) {
        this.unregister($f214a1ce0cc31a3c$var$ALIAS_ID_KEY);
        this.register({
            "distinct_id": new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this["people"]._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track("$identify", {
        "distinct_id": new_distinct_id,
        "$anon_distinct_id": previous_distinct_id
    }, {
        skip_hooks: true
    });
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.reset = function() {
    this["persistence"].clear();
    this._flags.identify_called = false;
    var uuid = $f214a1ce0cc31a3c$var$_.UUID();
    this.register_once({
        "distinct_id": $f214a1ce0cc31a3c$var$DEVICE_ID_PREFIX + uuid,
        "$device_id": uuid
    }, "");
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property("distinct_id");
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($f214a1ce0cc31a3c$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error("Attempting to create alias for existing People user - aborting.");
        return -2;
    }
    var _this = this;
    if ($f214a1ce0cc31a3c$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($f214a1ce0cc31a3c$var$ALIAS_ID_KEY, alias);
        return this.track("$create_alias", {
            "alias": alias,
            "distinct_id": original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error("alias matches current distinct_id - skipping api call.");
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single("mp_name_tag", name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.set_config = function(config) {
    if ($f214a1ce0cc31a3c$var$_.isObject(config)) {
        $f214a1ce0cc31a3c$var$_.extend(this["config"], config);
        var new_batch_size = config["batch_size"];
        if (new_batch_size) $f214a1ce0cc31a3c$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config("persistence_name")) this["config"]["persistence_name"] = this["config"]["cookie_name"];
        if (!this.get_config("disable_persistence")) this["config"]["disable_persistence"] = this["config"]["disable_cookie"];
        if (this["persistence"]) this["persistence"].update_config(this["config"]);
        $f214a1ce0cc31a3c$var$Config.DEBUG = $f214a1ce0cc31a3c$var$Config.DEBUG || this.get_config("debug");
    }
};
/**
 * returns the current config object for the library.
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this["config"][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this["config"]["hooks"][hook_name] || $f214a1ce0cc31a3c$var$IDENTITY_FUNC).apply(this, $f214a1ce0cc31a3c$var$slice.call(arguments, 1));
    if (typeof ret === "undefined") {
        this.report_error(hook_name + " hook did not return a value");
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this["persistence"].load_prop([
        property_name
    ]);
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config("name");
    if (name !== $f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME) name = $f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME + "." + name;
    return name;
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $f214a1ce0cc31a3c$var$_.isBlockedUA($f214a1ce0cc31a3c$var$userAgent) || this._flags.disable_all_events || $f214a1ce0cc31a3c$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $f214a1ce0cc31a3c$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            "persistence_type": "cookie"
        })) this.opt_in_tracking({
            "enable_persistence": false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            "persistence_type": "cookie"
        })) this.opt_out_tracking({
            "clear_persistence": false
        });
        this.clear_opt_in_out_tracking({
            "persistence_type": "cookie",
            "enable_persistence": false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        "clear_persistence": true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || $f214a1ce0cc31a3c$var$_.cookie.get("mp_optout"))) {
        $f214a1ce0cc31a3c$var$_.cookie.remove("mp_optout");
        this.opt_out_tracking({
            "clear_persistence": this.get_config("opt_out_persistence_by_default")
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options["clear_persistence"]) disabled = true;
    else if (options && options["enable_persistence"]) disabled = false;
    else return;
    if (!this.get_config("disable_persistence") && this["persistence"].disabled !== disabled) this["persistence"].set_disabled(disabled);
    if (disabled) this.stop_batch_senders();
    else // only start batchers after opt-in if they have previously been started
    // in order to avoid unintentionally starting up batching for the first time
    if (this._batchers_were_started) this.start_batch_senders();
};
// call a base gdpr function after constructing the appropriate token and options args
$f214a1ce0cc31a3c$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $f214a1ce0cc31a3c$var$_.extend({
        "track": $f214a1ce0cc31a3c$var$_.bind(this.track, this),
        "persistence_type": this.get_config("opt_out_tracking_persistence_type"),
        "cookie_prefix": this.get_config("opt_out_tracking_cookie_prefix"),
        "cookie_expiration": this.get_config("cookie_expiration"),
        "cross_site_cookie": this.get_config("cross_site_cookie"),
        "cross_subdomain_cookie": this.get_config("cross_subdomain_cookie"),
        "cookie_domain": this.get_config("cookie_domain"),
        "secure_cookie": this.get_config("secure_cookie"),
        "ignore_dnt": this.get_config("ignore_dnt")
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$f214a1ce0cc31a3c$var$_.localStorage.is_supported()) options["persistence_type"] = "cookie";
    return func(this.get_config("token"), {
        track: options["track"],
        trackEventName: options["track_event_name"],
        trackProperties: options["track_properties"],
        persistenceType: options["persistence_type"],
        persistencePrefix: options["cookie_prefix"],
        cookieDomain: options["cookie_domain"],
        cookieExpiration: options["cookie_expiration"],
        crossSiteCookie: options["cross_site_cookie"],
        crossSubdomainCookie: options["cross_subdomain_cookie"],
        secureCookie: options["secure_cookie"],
        ignoreDnt: options["ignore_dnt"]
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $f214a1ce0cc31a3c$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($f214a1ce0cc31a3c$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $f214a1ce0cc31a3c$var$_.extend({
        "clear_persistence": true,
        "delete_user": true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options["delete_user"] && this["people"] && this["people"]._identify_called()) {
        this["people"].delete_user();
        this["people"].clear_charges();
    }
    this._gdpr_call_func($f214a1ce0cc31a3c$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($f214a1ce0cc31a3c$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($f214a1ce0cc31a3c$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $f214a1ce0cc31a3c$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $f214a1ce0cc31a3c$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($f214a1ce0cc31a3c$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$f214a1ce0cc31a3c$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $f214a1ce0cc31a3c$var$console.error.apply($f214a1ce0cc31a3c$var$console.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config("error_reporter")(msg, err);
    } catch (err) {
        $f214a1ce0cc31a3c$var$console.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["init"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.init;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["reset"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.reset;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["disable"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.disable;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["time_event"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.time_event;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["track"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.track;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["track_links"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.track_links;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["track_forms"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.track_forms;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["track_pageview"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.track_pageview;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["register"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.register;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["register_once"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.register_once;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["unregister"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.unregister;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["identify"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.identify;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["alias"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.alias;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["name_tag"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.name_tag;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["set_config"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.set_config;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["get_config"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.get_config;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["get_property"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.get_property;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["get_distinct_id"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.get_distinct_id;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["toString"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.toString;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["opt_out_tracking"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.opt_out_tracking;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["opt_in_tracking"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.opt_in_tracking;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["has_opted_out_tracking"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.has_opted_out_tracking;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["has_opted_in_tracking"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.has_opted_in_tracking;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["clear_opt_in_out_tracking"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["get_group"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.get_group;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["set_group"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.set_group;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["add_group"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.add_group;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["remove_group"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.remove_group;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["track_with_groups"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.track_with_groups;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["start_batch_senders"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.start_batch_senders;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["stop_batch_senders"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.stop_batch_senders;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["start_session_recording"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.start_session_recording;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["stop_session_recording"] = $f214a1ce0cc31a3c$var$MixpanelLib.prototype.stop_session_recording;
$f214a1ce0cc31a3c$var$MixpanelLib.prototype["DEFAULT_API_ROUTES"] = $f214a1ce0cc31a3c$var$DEFAULT_API_ROUTES;
// MixpanelPersistence Exports
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype["properties"] = $f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.properties;
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype["update_search_keyword"] = $f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.update_search_keyword;
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype["update_referrer_info"] = $f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.update_referrer_info;
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype["get_cross_subdomain"] = $f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.get_cross_subdomain;
$f214a1ce0cc31a3c$var$MixpanelPersistence.prototype["clear"] = $f214a1ce0cc31a3c$var$MixpanelPersistence.prototype.clear;
var $f214a1ce0cc31a3c$var$instances = {};
var $f214a1ce0cc31a3c$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $f214a1ce0cc31a3c$var$_.each($f214a1ce0cc31a3c$var$instances, function(instance, name) {
        if (name !== $f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME) $f214a1ce0cc31a3c$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $f214a1ce0cc31a3c$var$mixpanel_master["_"] = $f214a1ce0cc31a3c$var$_;
};
var $f214a1ce0cc31a3c$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $f214a1ce0cc31a3c$var$mixpanel_master["init"] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$f214a1ce0cc31a3c$var$mixpanel_master[name]) {
                $f214a1ce0cc31a3c$var$mixpanel_master[name] = $f214a1ce0cc31a3c$var$instances[name] = $f214a1ce0cc31a3c$var$create_mplib(token, config, name);
                $f214a1ce0cc31a3c$var$mixpanel_master[name]._loaded();
            }
            return $f214a1ce0cc31a3c$var$mixpanel_master[name];
        } else {
            var instance = $f214a1ce0cc31a3c$var$mixpanel_master;
            if ($f214a1ce0cc31a3c$var$instances[$f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $f214a1ce0cc31a3c$var$instances[$f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $f214a1ce0cc31a3c$var$create_mplib(token, config, $f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $f214a1ce0cc31a3c$var$instances[$f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $f214a1ce0cc31a3c$var$mixpanel_master = instance;
            if ($f214a1ce0cc31a3c$var$init_type === $f214a1ce0cc31a3c$var$INIT_SNIPPET) $f214a1ce0cc31a3c$var$win[$f214a1ce0cc31a3c$var$PRIMARY_INSTANCE_NAME] = $f214a1ce0cc31a3c$var$mixpanel_master;
            $f214a1ce0cc31a3c$var$extend_mp();
        }
    };
};
var $f214a1ce0cc31a3c$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $f214a1ce0cc31a3c$var$DOM_LOADED = true;
        $f214a1ce0cc31a3c$var$ENQUEUE_REQUESTS = false;
        $f214a1ce0cc31a3c$var$_.each($f214a1ce0cc31a3c$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $f214a1ce0cc31a3c$var$document$1.documentElement.doScroll("left");
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($f214a1ce0cc31a3c$var$document$1.addEventListener) {
        if ($f214a1ce0cc31a3c$var$document$1.readyState === "complete") // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $f214a1ce0cc31a3c$var$document$1.addEventListener("DOMContentLoaded", dom_loaded_handler, false);
    } else if ($f214a1ce0cc31a3c$var$document$1.attachEvent) {
        // IE
        $f214a1ce0cc31a3c$var$document$1.attachEvent("onreadystatechange", dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $f214a1ce0cc31a3c$var$win.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($f214a1ce0cc31a3c$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $f214a1ce0cc31a3c$var$_.register_event($f214a1ce0cc31a3c$var$win, "load", dom_loaded_handler, true);
};
function $f214a1ce0cc31a3c$var$init_as_module() {
    $f214a1ce0cc31a3c$var$init_type = $f214a1ce0cc31a3c$var$INIT_MODULE;
    $f214a1ce0cc31a3c$var$mixpanel_master = new $f214a1ce0cc31a3c$var$MixpanelLib();
    $f214a1ce0cc31a3c$var$override_mp_init_func();
    $f214a1ce0cc31a3c$var$mixpanel_master["init"]();
    $f214a1ce0cc31a3c$var$add_dom_loaded_handler();
    return $f214a1ce0cc31a3c$var$mixpanel_master;
}
/* eslint camelcase: "off" */ var $f214a1ce0cc31a3c$var$mixpanel = $f214a1ce0cc31a3c$var$init_as_module();
$f214a1ce0cc31a3c$exports = $f214a1ce0cc31a3c$var$mixpanel;


(0, (/*@__PURE__*/$parcel$interopDefault($f214a1ce0cc31a3c$exports))).init("", {
    debug: false
});
const $650b40fd3e752928$export$6b2a7d5132615086 = (eventName)=>{
    try {
        (0, (/*@__PURE__*/$parcel$interopDefault($f214a1ce0cc31a3c$exports))).track(eventName);
    } catch (error) {
        console.error("error while tracking", error);
    }
};



const $0e5417d8980ae511$var$Form = ({ className: className, children: children, onSubmit: onSubmit = ()=>{} })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("form", {
        className: className,
        onSubmit: (event)=>{
            event.preventDefault();
            onSubmit(event);
        },
        children: children
    });
};
var $0e5417d8980ae511$export$2e2bcd8739ae039 = $0e5417d8980ae511$var$Form;



const $8685572bc59f0f43$var$FormItem = ({ id: id, label: label, children: children })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("label", {
                htmlFor: id,
                className: "block text-sm font-medium text-gray-700 ltr:text-left rtl:text-right",
                children: label
            }),
            children
        ]
    });
};
var $8685572bc59f0f43$export$2e2bcd8739ae039 = $8685572bc59f0f43$var$FormItem;




var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

function $a4b9e82663276f9b$export$454217e89aea72b(l, r, c) {
    let [i, s] = (0, $3QbnI.useState)(c), e = l !== void 0, t = (0, $3QbnI.useRef)(e), u = (0, $3QbnI.useRef)(!1), d = (0, $3QbnI.useRef)(!1);
    return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? l : i,
        (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((n)=>(e || s(n), r == null ? void 0 : r(n)))
    ];
}









function $6fe10b00a1a4e045$export$bc22b3e852574dab(i = {}, s = null, t = []) {
    for (let [r, n] of Object.entries(i))$6fe10b00a1a4e045$var$o(t, $6fe10b00a1a4e045$var$f(s, r), n);
    return t;
}
function $6fe10b00a1a4e045$var$f(i, s) {
    return i ? i + "[" + s + "]" : s;
}
function $6fe10b00a1a4e045$var$o(i, s, t) {
    if (Array.isArray(t)) for (let [r, n] of t.entries())$6fe10b00a1a4e045$var$o(i, $6fe10b00a1a4e045$var$f(s, r.toString()), n);
    else t instanceof Date ? i.push([
        s,
        t.toISOString()
    ]) : typeof t == "boolean" ? i.push([
        s,
        t ? "1" : "0"
    ]) : typeof t == "string" ? i.push([
        s,
        t
    ]) : typeof t == "number" ? i.push([
        s,
        `${t}`
    ]) : t == null ? i.push([
        s,
        ""
    ]) : $6fe10b00a1a4e045$export$bc22b3e852574dab(t, s, i);
}
function $6fe10b00a1a4e045$export$ee02894bdc79dd36(i) {
    var t, r;
    let s = (t = i == null ? void 0 : i.form) != null ? t : i.closest("form");
    if (s) {
        for (let n of s.elements)if (n !== i && (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image")) {
            n.click();
            return;
        }
        (r = s.requestSubmit) == null || r.call(s);
    }
}






var $3QbnI = parcelRequire("3QbnI");





let $5c39c99123e18c29$var$d = (0, $3QbnI.createContext)(null);
function $5c39c99123e18c29$var$u() {
    let a = (0, $3QbnI.useContext)($5c39c99123e18c29$var$d);
    if (a === null) {
        let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $5c39c99123e18c29$var$u), t;
    }
    return a;
}
function $5c39c99123e18c29$export$d6875122194c7b44() {
    let [a, t] = (0, $3QbnI.useState)([]);
    return [
        a.length > 0 ? a.join(" ") : void 0,
        (0, $3QbnI.useMemo)(()=>function(e) {
                let s = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((r)=>(t((l)=>[
                            ...l,
                            r
                        ]), ()=>t((l)=>{
                            let n = l.slice(), p = n.indexOf(r);
                            return p !== -1 && n.splice(p, 1), n;
                        }))), o = (0, $3QbnI.useMemo)(()=>({
                        register: s,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    s,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($5c39c99123e18c29$var$d.Provider, {
                    value: o
                }, e.children);
            }, [
            t
        ])
    ];
}
let $5c39c99123e18c29$var$A = "label";
function $5c39c99123e18c29$var$h(a, t) {
    let i = (0, $32e547b031070140$export$f680877a34711e37)(), { id: e = `headlessui-label-${i}`, passive: s = !1, ...o } = a, r = $5c39c99123e18c29$var$u(), l = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(t);
    (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>r.register(e), [
        e,
        r.register
    ]);
    let n = {
        ref: l,
        ...r.props,
        id: e
    };
    return s && ("onClick" in n && (delete n.htmlFor, delete n.onClick), "onClick" in o && delete o.onClick), (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: n,
        theirProps: o,
        slot: r.slot || {},
        defaultTag: $5c39c99123e18c29$var$A,
        name: r.name || "Label"
    });
}
let $5c39c99123e18c29$var$v = (0, $efef981be50c1ac4$export$e43f39796049410c)($5c39c99123e18c29$var$h), $5c39c99123e18c29$export$b04be29aa201d4f5 = Object.assign($5c39c99123e18c29$var$v, {});


let $0525ea1cb21a4d92$var$S = (0, $3QbnI.createContext)(null);
$0525ea1cb21a4d92$var$S.displayName = "GroupContext";
let $0525ea1cb21a4d92$var$ee = (0, $3QbnI.Fragment);
function $0525ea1cb21a4d92$var$te(r) {
    var u;
    let [n, p] = (0, $3QbnI.useState)(null), [c, T] = (0, $5c39c99123e18c29$export$d6875122194c7b44)(), [o, b] = (0, $ff60c7f0a5393e5a$export$babde88292020af7)(), a = (0, $3QbnI.useMemo)(()=>({
            switch: n,
            setSwitch: p,
            labelledby: c,
            describedby: o
        }), [
        n,
        p,
        c,
        o
    ]), d = {}, y = r;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(b, {
        name: "Switch.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(T, {
        name: "Switch.Label",
        props: {
            htmlFor: (u = a.switch) == null ? void 0 : u.id,
            onClick (m) {
                n && (m.currentTarget.tagName === "LABEL" && m.preventDefault(), n.click(), n.focus({
                    preventScroll: !0
                }));
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($0525ea1cb21a4d92$var$S.Provider, {
        value: a
    }, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: d,
        theirProps: y,
        defaultTag: $0525ea1cb21a4d92$var$ee,
        name: "Switch.Group"
    }))));
}
let $0525ea1cb21a4d92$var$ne = "button";
function $0525ea1cb21a4d92$var$re(r, n) {
    var E;
    let p = (0, $32e547b031070140$export$f680877a34711e37)(), { id: c = `headlessui-switch-${p}`, checked: T, defaultChecked: o = !1, onChange: b, disabled: a = !1, name: d, value: y, form: u, ...m } = r, t = (0, $3QbnI.useContext)($0525ea1cb21a4d92$var$S), f = (0, $3QbnI.useRef)(null), C = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(f, n, t === null ? null : t.setSwitch), [i, s] = (0, $a4b9e82663276f9b$export$454217e89aea72b)(T, b, o), w = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>s == null ? void 0 : s(!i)), L = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((e)=>{
        if ((0, $9fde5a40ffbcb074$export$db61f031a278447c)(e.currentTarget)) return e.preventDefault();
        e.preventDefault(), w();
    }), x = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((e)=>{
        e.key === (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space ? (e.preventDefault(), w()) : e.key === (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Enter && (0, $6fe10b00a1a4e045$export$ee02894bdc79dd36)(e.currentTarget);
    }), v = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((e)=>e.preventDefault()), G = (0, $3QbnI.useMemo)(()=>({
            checked: i
        }), [
        i
    ]), R = {
        id: c,
        ref: C,
        role: "switch",
        type: (0, $63b58a1e835cc3d1$export$53652b2b272efe9c)(r, f),
        tabIndex: r.tabIndex === -1 ? 0 : (E = r.tabIndex) != null ? E : 0,
        "aria-checked": i,
        "aria-labelledby": t == null ? void 0 : t.labelledby,
        "aria-describedby": t == null ? void 0 : t.describedby,
        disabled: a,
        onClick: L,
        onKeyUp: x,
        onKeyPress: v
    }, k = (0, $c86664fa6151526e$export$fd183955ff4b45d9)();
    return (0, $3QbnI.useEffect)(()=>{
        var _;
        let e = (_ = f.current) == null ? void 0 : _.closest("form");
        e && o !== void 0 && k.addEventListener(e, "reset", ()=>{
            s(o);
        });
    }, [
        f,
        s
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Fragment, null, d != null && i && (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $70ad89c09b766687$export$8dc98ba7eadeaa56), {
        features: (0, $70ad89c09b766687$export$617d79dae526d2cf).Hidden,
        ...(0, $efef981be50c1ac4$export$8e16b83750b44988)({
            as: "input",
            type: "checkbox",
            hidden: !0,
            readOnly: !0,
            disabled: a,
            form: u,
            checked: i,
            name: d,
            value: y
        })
    }), (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: R,
        theirProps: m,
        slot: G,
        defaultTag: $0525ea1cb21a4d92$var$ne,
        name: "Switch"
    }));
}
let $0525ea1cb21a4d92$var$oe = (0, $efef981be50c1ac4$export$e43f39796049410c)($0525ea1cb21a4d92$var$re), $0525ea1cb21a4d92$var$ie = $0525ea1cb21a4d92$var$te, $0525ea1cb21a4d92$export$b5d5cf8927ab7262 = Object.assign($0525ea1cb21a4d92$var$oe, {
    Group: $0525ea1cb21a4d92$var$ie,
    Label: (0, $5c39c99123e18c29$export$b04be29aa201d4f5),
    Description: (0, $ff60c7f0a5393e5a$export$393edc798c47379d)
});



const $035eb2a86eac9e73$var$FormSwitch = ({ description: description, checked: checked, onChange: onChange, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $0525ea1cb21a4d92$export$b5d5cf8927ab7262).Group, {
        as: "li",
        className: "flex items-center justify-between",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "flex flex-col",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $0525ea1cb21a4d92$export$b5d5cf8927ab7262).Description, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("mt-1 text-xs text-gray-500", {
                        "opacity-50": disabled
                    }),
                    children: description
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $0525ea1cb21a4d92$export$b5d5cf8927ab7262), {
                checked: checked,
                disabled: disabled,
                onChange: onChange,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))(checked && !disabled ? "bg-black" : "bg-gray-200", {
                    "cursor-pointer": !disabled
                }, "me-1 ms-4 relative  inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"),
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                    "aria-hidden": "true",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))(checked ? "translate-x-5" : "translate-x-0", "inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out")
                })
            })
        ]
    });
};
var $035eb2a86eac9e73$export$2e2bcd8739ae039 = $035eb2a86eac9e73$var$FormSwitch;


var $bd914ef380e06327$export$2e2bcd8739ae039 = Object.assign((0, $0e5417d8980ae511$export$2e2bcd8739ae039), {
    Item: (0, $8685572bc59f0f43$export$2e2bcd8739ae039),
    Switch: (0, $035eb2a86eac9e73$export$2e2bcd8739ae039)
});



const $925658b656a99677$var$InputBasic = ({ type: type = "text", className: className, onChange: onChange = ()=>{}, id: id, value: value, placeholder: placeholder, style: style = {}, ...props })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("input", {
        type: type,
        name: id,
        id: id,
        style: style,
        className: `p-0 border-0 outline-none focus:outline-none focus:ring-0 ${className}`,
        onChange: (e)=>onChange(e.target.value),
        value: value,
        placeholder: placeholder,
        ...props
    });
};
var $925658b656a99677$export$2e2bcd8739ae039 = $925658b656a99677$var$InputBasic;



const $db5235cbd92d1647$var$InputBack = ({ type: type = "text", className: className, onChange: onChange = ()=>{}, id: id, value: value, name: name, ...props })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("input", {
        type: type,
        name: name,
        id: id,
        className: `block w-full shadow-sm sm:text-sm border-gray-300 focus:ring-black focus:border-black  rounded-md ${className}`,
        onChange: (event)=>onChange(event.target.value),
        value: value,
        ...props
    });
};
var $db5235cbd92d1647$export$2e2bcd8739ae039 = $db5235cbd92d1647$var$InputBack;


const $2b0c6bf8582a103a$var$Input = {
    Basic: (0, $925658b656a99677$export$2e2bcd8739ae039),
    Black: (0, $db5235cbd92d1647$export$2e2bcd8739ae039)
};
var $2b0c6bf8582a103a$export$2e2bcd8739ae039 = $2b0c6bf8582a103a$var$Input;



var $3QbnI = parcelRequire("3QbnI");

const $f47422411e27ad9a$var$useSetting = function(selector, action) {
    const value = (0, $67ed7bda3729d158$export$a7347740d65f620b)(selector);
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const setValue = (0, $3QbnI.useCallback)((v)=>dispatch(action(v)), [
        dispatch,
        action
    ]);
    return (0, $3QbnI.useMemo)(()=>[
            value,
            setValue
        ], [
        value,
        setValue
    ]);
};
var $f47422411e27ad9a$export$2e2bcd8739ae039 = $f47422411e27ad9a$var$useSetting;




var $3QbnI = parcelRequire("3QbnI");

if (typeof window !== "undefined" && !window.global) window.global = typeof $parcel$global === "undefined" ? window : $parcel$global;



var $d0890e2d533e0714$exports = {};
"use strict";
var $d0890e2d533e0714$var$__defProp = Object.defineProperty;
var $d0890e2d533e0714$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d0890e2d533e0714$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d0890e2d533e0714$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d0890e2d533e0714$var$__export = (target, all)=>{
    for(var name in all)$d0890e2d533e0714$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $d0890e2d533e0714$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $d0890e2d533e0714$var$__getOwnPropNames(from))if (!$d0890e2d533e0714$var$__hasOwnProp.call(to, key) && key !== except) $d0890e2d533e0714$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $d0890e2d533e0714$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $d0890e2d533e0714$var$__toCommonJS = (mod)=>$d0890e2d533e0714$var$__copyProps($d0890e2d533e0714$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/keys.ts
var $d0890e2d533e0714$var$keys_exports = {};
$d0890e2d533e0714$var$__export($d0890e2d533e0714$var$keys_exports, {
    buildPublishableKey: ()=>$d0890e2d533e0714$var$buildPublishableKey,
    createDevOrStagingUrlCache: ()=>$d0890e2d533e0714$var$createDevOrStagingUrlCache,
    isDevelopmentFromApiKey: ()=>$d0890e2d533e0714$var$isDevelopmentFromApiKey,
    isLegacyFrontendApiKey: ()=>$d0890e2d533e0714$var$isLegacyFrontendApiKey,
    isProductionFromApiKey: ()=>$d0890e2d533e0714$var$isProductionFromApiKey,
    isPublishableKey: ()=>$d0890e2d533e0714$var$isPublishableKey,
    parsePublishableKey: ()=>$d0890e2d533e0714$var$parsePublishableKey
});
$d0890e2d533e0714$exports = $d0890e2d533e0714$var$__toCommonJS($d0890e2d533e0714$var$keys_exports);
// src/isomorphicAtob.ts
var $d0890e2d533e0714$var$isomorphicAtob = (data)=>{
    if (typeof atob !== "undefined" && typeof atob === "function") return atob(data);
    else if (typeof $parcel$global !== "undefined" && $parcel$global.Buffer) return new $parcel$global.Buffer(data, "base64").toString();
    return data;
};
// src/keys.ts
var $d0890e2d533e0714$var$PUBLISHABLE_KEY_LIVE_PREFIX = "pk_live_";
var $d0890e2d533e0714$var$PUBLISHABLE_KEY_TEST_PREFIX = "pk_test_";
var $d0890e2d533e0714$var$PUBLISHABLE_FRONTEND_API_DEV_REGEX = /^(([a-z]+)-){2}([0-9]{1,2})\.clerk\.accounts([a-z.]*)(dev|com)$/i;
function $d0890e2d533e0714$var$buildPublishableKey(frontendApi) {
    const keyPrefix = $d0890e2d533e0714$var$PUBLISHABLE_FRONTEND_API_DEV_REGEX.test(frontendApi) ? $d0890e2d533e0714$var$PUBLISHABLE_KEY_TEST_PREFIX : $d0890e2d533e0714$var$PUBLISHABLE_KEY_LIVE_PREFIX;
    return `${keyPrefix}${btoa(`${frontendApi}$`)}`;
}
function $d0890e2d533e0714$var$parsePublishableKey(key) {
    key = key || "";
    if (!$d0890e2d533e0714$var$isPublishableKey(key)) return null;
    const instanceType = key.startsWith($d0890e2d533e0714$var$PUBLISHABLE_KEY_LIVE_PREFIX) ? "production" : "development";
    let frontendApi = $d0890e2d533e0714$var$isomorphicAtob(key.split("_")[2]);
    if (!frontendApi.endsWith("$")) return null;
    frontendApi = frontendApi.slice(0, -1);
    return {
        instanceType: instanceType,
        frontendApi: frontendApi
    };
}
function $d0890e2d533e0714$var$isPublishableKey(key) {
    key = key || "";
    const hasValidPrefix = key.startsWith($d0890e2d533e0714$var$PUBLISHABLE_KEY_LIVE_PREFIX) || key.startsWith($d0890e2d533e0714$var$PUBLISHABLE_KEY_TEST_PREFIX);
    const hasValidFrontendApiPostfix = $d0890e2d533e0714$var$isomorphicAtob(key.split("_")[2] || "").endsWith("$");
    return hasValidPrefix && hasValidFrontendApiPostfix;
}
function $d0890e2d533e0714$var$isLegacyFrontendApiKey(key) {
    key = key || "";
    return key.startsWith("clerk.");
}
function $d0890e2d533e0714$var$createDevOrStagingUrlCache() {
    const DEV_OR_STAGING_SUFFIXES = [
        ".lcl.dev",
        ".stg.dev",
        ".lclstage.dev",
        ".stgstage.dev",
        ".dev.lclclerk.com",
        ".stg.lclclerk.com",
        ".accounts.lclclerk.com",
        "accountsstage.dev",
        "accounts.dev"
    ];
    const devOrStagingUrlCache = /* @__PURE__ */ new Map();
    return {
        isDevOrStagingUrl: (url)=>{
            if (!url) return false;
            const hostname = typeof url === "string" ? url : url.hostname;
            let res = devOrStagingUrlCache.get(hostname);
            if (res === void 0) {
                res = DEV_OR_STAGING_SUFFIXES.some((s)=>hostname.endsWith(s));
                devOrStagingUrlCache.set(hostname, res);
            }
            return res;
        }
    };
}
function $d0890e2d533e0714$var$isDevelopmentFromApiKey(apiKey) {
    return apiKey.startsWith("test_") || apiKey.startsWith("sk_test_");
}
function $d0890e2d533e0714$var$isProductionFromApiKey(apiKey) {
    return apiKey.startsWith("live_") || apiKey.startsWith("sk_live_");
}



var $3QbnI = parcelRequire("3QbnI");

var $48e3a5cf47318b89$exports = {};
"use strict";
var $48e3a5cf47318b89$var$__defProp = Object.defineProperty;
var $48e3a5cf47318b89$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $48e3a5cf47318b89$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $48e3a5cf47318b89$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $48e3a5cf47318b89$var$__export = (target, all)=>{
    for(var name in all)$48e3a5cf47318b89$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $48e3a5cf47318b89$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $48e3a5cf47318b89$var$__getOwnPropNames(from))if (!$48e3a5cf47318b89$var$__hasOwnProp.call(to, key) && key !== except) $48e3a5cf47318b89$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $48e3a5cf47318b89$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $48e3a5cf47318b89$var$__toCommonJS = (mod)=>$48e3a5cf47318b89$var$__copyProps($48e3a5cf47318b89$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/error.ts
var $48e3a5cf47318b89$var$error_exports = {};
$48e3a5cf47318b89$var$__export($48e3a5cf47318b89$var$error_exports, {
    ClerkAPIResponseError: ()=>$48e3a5cf47318b89$var$ClerkAPIResponseError,
    ClerkRuntimeError: ()=>$48e3a5cf47318b89$var$ClerkRuntimeError,
    EmailLinkError: ()=>$48e3a5cf47318b89$var$EmailLinkError,
    EmailLinkErrorCode: ()=>$48e3a5cf47318b89$var$EmailLinkErrorCode,
    MagicLinkError: ()=>$48e3a5cf47318b89$var$MagicLinkError,
    MagicLinkErrorCode: ()=>$48e3a5cf47318b89$var$MagicLinkErrorCode,
    buildErrorThrower: ()=>$48e3a5cf47318b89$var$buildErrorThrower,
    is4xxError: ()=>$48e3a5cf47318b89$var$is4xxError,
    isClerkAPIResponseError: ()=>$48e3a5cf47318b89$var$isClerkAPIResponseError,
    isClerkRuntimeError: ()=>$48e3a5cf47318b89$var$isClerkRuntimeError,
    isEmailLinkError: ()=>$48e3a5cf47318b89$var$isEmailLinkError,
    isKnownError: ()=>$48e3a5cf47318b89$var$isKnownError,
    isMagicLinkError: ()=>$48e3a5cf47318b89$var$isMagicLinkError,
    isMetamaskError: ()=>$48e3a5cf47318b89$var$isMetamaskError,
    isNetworkError: ()=>$48e3a5cf47318b89$var$isNetworkError,
    isPasswordPwnedError: ()=>$48e3a5cf47318b89$var$isPasswordPwnedError,
    isUnauthorizedError: ()=>$48e3a5cf47318b89$var$isUnauthorizedError,
    isUserLockedError: ()=>$48e3a5cf47318b89$var$isUserLockedError,
    parseError: ()=>$48e3a5cf47318b89$var$parseError,
    parseErrors: ()=>$48e3a5cf47318b89$var$parseErrors
});
$48e3a5cf47318b89$exports = $48e3a5cf47318b89$var$__toCommonJS($48e3a5cf47318b89$var$error_exports);
// src/utils/runtimeEnvironment.ts
var $48e3a5cf47318b89$var$isTestEnvironment = ()=>{
    try {
        return false;
    } catch (err) {}
    return false;
};
var $48e3a5cf47318b89$var$isProductionEnvironment = ()=>{
    try {
        return true;
    } catch (err) {}
    return false;
};
// src/deprecated.ts
var $48e3a5cf47318b89$var$displayedWarnings = /* @__PURE__ */ new Set();
var $48e3a5cf47318b89$var$deprecated = (fnName, warning, key)=>{
    const hideWarning = $48e3a5cf47318b89$var$isTestEnvironment() || $48e3a5cf47318b89$var$isProductionEnvironment();
    const messageId = key != null ? key : fnName;
    if ($48e3a5cf47318b89$var$displayedWarnings.has(messageId) || hideWarning) return;
    $48e3a5cf47318b89$var$displayedWarnings.add(messageId);
    console.warn(`Clerk - DEPRECATION WARNING: "${fnName}" is deprecated and will be removed in the next major release.
${warning}`);
};
// src/error.ts
function $48e3a5cf47318b89$var$isUnauthorizedError(e) {
    var _a, _b;
    const status = e == null ? void 0 : e.status;
    const code = (_b = (_a = e == null ? void 0 : e.errors) == null ? void 0 : _a[0]) == null ? void 0 : _b.code;
    return code === "authentication_invalid" && status === 401;
}
function $48e3a5cf47318b89$var$is4xxError(e) {
    const status = e == null ? void 0 : e.status;
    return !!status && status >= 400 && status < 500;
}
function $48e3a5cf47318b89$var$isNetworkError(e) {
    const message = (`${e.message}${e.name}` || "").toLowerCase().replace(/\s+/g, "");
    return message.includes("networkerror");
}
function $48e3a5cf47318b89$var$isKnownError(error) {
    return $48e3a5cf47318b89$var$isClerkAPIResponseError(error) || $48e3a5cf47318b89$var$isMetamaskError(error) || $48e3a5cf47318b89$var$isClerkRuntimeError(error);
}
function $48e3a5cf47318b89$var$isClerkAPIResponseError(err) {
    return "clerkError" in err;
}
function $48e3a5cf47318b89$var$isClerkRuntimeError(err) {
    return "clerkRuntimeError" in err;
}
function $48e3a5cf47318b89$var$isMetamaskError(err) {
    return "code" in err && [
        4001,
        32602,
        32603
    ].includes(err.code) && "message" in err;
}
function $48e3a5cf47318b89$var$isUserLockedError(err) {
    var _a, _b;
    return $48e3a5cf47318b89$var$isClerkAPIResponseError(err) && ((_b = (_a = err.errors) == null ? void 0 : _a[0]) == null ? void 0 : _b.code) === "user_locked";
}
function $48e3a5cf47318b89$var$parseErrors(data = []) {
    return data.length > 0 ? data.map($48e3a5cf47318b89$var$parseError) : [];
}
function $48e3a5cf47318b89$var$isPasswordPwnedError(err) {
    var _a, _b;
    return $48e3a5cf47318b89$var$isClerkAPIResponseError(err) && ((_b = (_a = err.errors) == null ? void 0 : _a[0]) == null ? void 0 : _b.code) === "form_password_pwned";
}
function $48e3a5cf47318b89$var$parseError(error) {
    var _a, _b, _c, _d, _e;
    return {
        code: error.code,
        message: error.message,
        longMessage: error.long_message,
        meta: {
            paramName: (_a = error == null ? void 0 : error.meta) == null ? void 0 : _a.param_name,
            sessionId: (_b = error == null ? void 0 : error.meta) == null ? void 0 : _b.session_id,
            emailAddresses: (_c = error == null ? void 0 : error.meta) == null ? void 0 : _c.email_addresses,
            identifiers: (_d = error == null ? void 0 : error.meta) == null ? void 0 : _d.identifiers,
            zxcvbn: (_e = error == null ? void 0 : error.meta) == null ? void 0 : _e.zxcvbn
        }
    };
}
var $48e3a5cf47318b89$var$ClerkAPIResponseError = class _ClerkAPIResponseError extends Error {
    constructor(message, { data: data, status: status, clerkTraceId: clerkTraceId }){
        super(message);
        this.toString = ()=>{
            let message = `[${this.name}]
Message:${this.message}
Status:${this.status}
Serialized errors: ${this.errors.map((e)=>JSON.stringify(e))}`;
            if (this.clerkTraceId) message += `
Clerk Trace ID: ${this.clerkTraceId}`;
            return message;
        };
        Object.setPrototypeOf(this, _ClerkAPIResponseError.prototype);
        this.status = status;
        this.message = message;
        this.clerkTraceId = clerkTraceId;
        this.clerkError = true;
        this.errors = $48e3a5cf47318b89$var$parseErrors(data);
    }
};
var $48e3a5cf47318b89$var$ClerkRuntimeError = class _ClerkRuntimeError extends Error {
    constructor(message, { code: code }){
        super(message);
        /**
     * Returns a string representation of the error.
     *
     * @returns {string} A formatted string with the error name and message.
     * @memberof ClerkRuntimeError
     */ this.toString = ()=>{
            return `[${this.name}]
Message:${this.message}`;
        };
        Object.setPrototypeOf(this, _ClerkRuntimeError.prototype);
        this.code = code;
        this.message = message;
        this.clerkRuntimeError = true;
    }
};
var $48e3a5cf47318b89$var$MagicLinkError = class _MagicLinkError extends Error {
    constructor(code){
        super(code);
        this.code = code;
        Object.setPrototypeOf(this, _MagicLinkError.prototype);
        $48e3a5cf47318b89$var$deprecated("MagicLinkError", "Use `EmailLinkError` instead.");
    }
};
var $48e3a5cf47318b89$var$EmailLinkError = class _EmailLinkError extends Error {
    constructor(code){
        super(code);
        this.code = code;
        Object.setPrototypeOf(this, _EmailLinkError.prototype);
    }
};
function $48e3a5cf47318b89$var$isMagicLinkError(err) {
    $48e3a5cf47318b89$var$deprecated("isMagicLinkError", "Use `isEmailLinkError` instead.");
    return err instanceof $48e3a5cf47318b89$var$MagicLinkError;
}
function $48e3a5cf47318b89$var$isEmailLinkError(err) {
    return err instanceof $48e3a5cf47318b89$var$EmailLinkError;
}
var $48e3a5cf47318b89$var$_MagicLinkErrorCode = {
    Expired: "expired",
    Failed: "failed"
};
var $48e3a5cf47318b89$var$MagicLinkErrorCode = new Proxy($48e3a5cf47318b89$var$_MagicLinkErrorCode, {
    get (target, prop, receiver) {
        $48e3a5cf47318b89$var$deprecated("MagicLinkErrorCode", "Use `EmailLinkErrorCode` instead.");
        return Reflect.get(target, prop, receiver);
    }
});
var $48e3a5cf47318b89$var$EmailLinkErrorCode = {
    Expired: "expired",
    Failed: "failed"
};
var $48e3a5cf47318b89$var$DefaultMessages = Object.freeze({
    InvalidFrontendApiErrorMessage: `The frontendApi passed to Clerk is invalid. You can get your Frontend API key at https://dashboard.clerk.com/last-active?path=api-keys. (key={{key}})`,
    InvalidProxyUrlErrorMessage: `The proxyUrl passed to Clerk is invalid. The expected value for proxyUrl is an absolute URL or a relative path with a leading '/'. (key={{url}})`,
    InvalidPublishableKeyErrorMessage: `The publishableKey passed to Clerk is invalid. You can get your Publishable key at https://dashboard.clerk.com/last-active?path=api-keys. (key={{key}})`,
    MissingPublishableKeyErrorMessage: `Missing publishableKey. You can get your key at https://dashboard.clerk.com/last-active?path=api-keys.`
});
function $48e3a5cf47318b89$var$buildErrorThrower({ packageName: packageName, customMessages: customMessages }) {
    let pkg = packageName;
    const messages = {
        ...$48e3a5cf47318b89$var$DefaultMessages,
        ...customMessages
    };
    function buildMessage(rawMessage, replacements) {
        if (!replacements) return `${pkg}: ${rawMessage}`;
        let msg = rawMessage;
        const matches = rawMessage.matchAll(/{{([a-zA-Z0-9-_]+)}}/g);
        for (const match of matches){
            const replacement = (replacements[match[1]] || "").toString();
            msg = msg.replace(`{{${match[1]}}}`, replacement);
        }
        return `${pkg}: ${msg}`;
    }
    return {
        setPackageName ({ packageName: packageName2 }) {
            if (typeof packageName2 === "string") pkg = packageName2;
            return this;
        },
        setMessages ({ customMessages: customMessages2 }) {
            Object.assign(messages, customMessages2 || {});
            return this;
        },
        throwInvalidPublishableKeyError (params) {
            throw new Error(buildMessage(messages.InvalidPublishableKeyErrorMessage, params));
        },
        throwInvalidFrontendApiError (params) {
            throw new Error(buildMessage(messages.InvalidFrontendApiErrorMessage, params));
        },
        throwInvalidProxyUrl (params) {
            throw new Error(buildMessage(messages.InvalidProxyUrlErrorMessage, params));
        },
        throwMissingPublishableKeyError () {
            throw new Error(buildMessage(messages.MissingPublishableKeyErrorMessage));
        }
    };
}


const $5af9131399f28559$export$87e5051903ee08b8 = "Clerk: You must add the frontendApi prop to your <ClerkProvider>";
const $5af9131399f28559$export$4305f0bba9b5496a = "Clerk: You must wrap your application in a <ClerkProvider> component.";
const $5af9131399f28559$export$8cbe2906da0f4347 = (hookName)=>`Clerk: You're calling ${hookName} before there's a guarantee the client has been loaded. Call ${hookName} from a child of <SignedIn>, <SignedOut>, or <ClerkLoaded>, or use the withClerk() HOC.`;
const $5af9131399f28559$export$7a3359e785387117 = (hookName)=>`Clerk: You're calling ${hookName} before there's a guarantee there's an active user. Call ${hookName} from a child of <SignedIn> or use the withUser() HOC.`;
const $5af9131399f28559$export$2e70edf3ca74a247 = "Clerk: You've added multiple <ClerkProvider> components in your React component tree. Wrap your components in a single <ClerkProvider>.";
const $5af9131399f28559$export$bc1c6a2addae8711 = "Clerk: Child of WithClerk must be a function.";
const $5af9131399f28559$export$625116a18875cb26 = (name)=>`Clerk: You've passed multiple children components to <${name}/>. You can only pass a single child component or text.`;
const $5af9131399f28559$export$f8917dcad71775b3 = "Clerk: Invalid state. Feel free to submit a bug or reach out to support here: https://clerk.com/support";
const $5af9131399f28559$export$ccf659c4f3b60fd5 = "Clerk: Unsupported usage of isSatellite, domain or proxyUrl. The usage of isSatellite, domain or proxyUrl as function is not supported in non-browser environments.";
const $5af9131399f28559$export$6b6e478c58476406 = "Clerk: <UserProfile.Page /> component needs to be a direct child of `<UserProfile />` or `<UserButton />`.";
const $5af9131399f28559$export$f9ac800ca1766c34 = "Clerk: <UserProfile.Link /> component needs to be a direct child of `<UserProfile />` or `<UserButton />`.";
const $5af9131399f28559$export$3a6d585032ffc1c3 = "Clerk: <OrganizationProfile.Page /> component needs to be a direct child of `<OrganizationProfile />` or `<OrganizationSwitcher />`.";
const $5af9131399f28559$export$2fa5a2b2fade66d1 = "Clerk: <OrganizationProfile.Link /> component needs to be a direct child of `<OrganizationProfile />` or `<OrganizationSwitcher />`.";
const $5af9131399f28559$export$6d8abd35e58f966b = (componentName)=>`Clerk: <${componentName} /> can only accept <${componentName}.Page /> and <${componentName}.Link /> as its children. Any other provided component will be ignored.`;
const $5af9131399f28559$export$413c953d0c23c75a = (componentName)=>`Clerk: Missing props. <${componentName}.Page /> component requires the following props: url, label, labelIcon, alongside with children to be rendered inside the page.`;
const $5af9131399f28559$export$6f03073ceba3994d = (componentName)=>`Clerk: Missing props. <${componentName}.Link /> component requires the following props: url, label and labelIcon.`;
const $5af9131399f28559$export$2ddb8bcf9d26499c = 'Clerk: Missing parameters. `has` from `useAuth` requires a permission or role key to be passed. Example usage: `has({permission: "org:posts:edit"`';




const $4b1975c39f3b1069$export$56721dd9fbd2a9c9 = (0, $48e3a5cf47318b89$exports.buildErrorThrower)({
    packageName: "@clerk/react"
});
function $4b1975c39f3b1069$export$c22e1bc86384a064(options) {
    $4b1975c39f3b1069$export$56721dd9fbd2a9c9.setMessages(options).setPackageName(options);
}



var $3QbnI = parcelRequire("3QbnI");
const $e3bf4ed8f919311d$var$counts = /* @__PURE__ */ new Map();
function $e3bf4ed8f919311d$export$9f48bce8647b65e4(name, error, maxCount = 1) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useEffect(()=>{
        const count = $e3bf4ed8f919311d$var$counts.get(name) || 0;
        if (count == maxCount) throw new Error(error);
        $e3bf4ed8f919311d$var$counts.set(name, count + 1);
        return ()=>{
            $e3bf4ed8f919311d$var$counts.set(name, ($e3bf4ed8f919311d$var$counts.get(name) || 1) - 1);
        };
    }, []);
}
function $e3bf4ed8f919311d$export$99c5d48145a0499f(WrappedComponent, name, error) {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || name || "Component";
    const Hoc = (props)=>{
        $e3bf4ed8f919311d$export$9f48bce8647b65e4(name, error);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(WrappedComponent, {
            ...props
        });
    };
    Hoc.displayName = `withMaxAllowedInstancesGuard(${displayName})`;
    return Hoc;
}



var $98eb031f10fd6d90$exports = {};
"use strict";
var $98eb031f10fd6d90$var$__defProp = Object.defineProperty;
var $98eb031f10fd6d90$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $98eb031f10fd6d90$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $98eb031f10fd6d90$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $98eb031f10fd6d90$var$__export = (target, all)=>{
    for(var name in all)$98eb031f10fd6d90$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $98eb031f10fd6d90$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $98eb031f10fd6d90$var$__getOwnPropNames(from))if (!$98eb031f10fd6d90$var$__hasOwnProp.call(to, key) && key !== except) $98eb031f10fd6d90$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $98eb031f10fd6d90$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $98eb031f10fd6d90$var$__toCommonJS = (mod)=>$98eb031f10fd6d90$var$__copyProps($98eb031f10fd6d90$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/deprecated.ts
var $98eb031f10fd6d90$var$deprecated_exports = {};
$98eb031f10fd6d90$var$__export($98eb031f10fd6d90$var$deprecated_exports, {
    deprecated: ()=>$98eb031f10fd6d90$var$deprecated,
    deprecatedObjectProperty: ()=>$98eb031f10fd6d90$var$deprecatedObjectProperty,
    deprecatedProperty: ()=>$98eb031f10fd6d90$var$deprecatedProperty
});
$98eb031f10fd6d90$exports = $98eb031f10fd6d90$var$__toCommonJS($98eb031f10fd6d90$var$deprecated_exports);
// src/utils/runtimeEnvironment.ts
var $98eb031f10fd6d90$var$isTestEnvironment = ()=>{
    try {
        return false;
    } catch (err) {}
    return false;
};
var $98eb031f10fd6d90$var$isProductionEnvironment = ()=>{
    try {
        return true;
    } catch (err) {}
    return false;
};
// src/deprecated.ts
var $98eb031f10fd6d90$var$displayedWarnings = /* @__PURE__ */ new Set();
var $98eb031f10fd6d90$var$deprecated = (fnName, warning, key)=>{
    const hideWarning = $98eb031f10fd6d90$var$isTestEnvironment() || $98eb031f10fd6d90$var$isProductionEnvironment();
    const messageId = key != null ? key : fnName;
    if ($98eb031f10fd6d90$var$displayedWarnings.has(messageId) || hideWarning) return;
    $98eb031f10fd6d90$var$displayedWarnings.add(messageId);
    console.warn(`Clerk - DEPRECATION WARNING: "${fnName}" is deprecated and will be removed in the next major release.
${warning}`);
};
var $98eb031f10fd6d90$var$deprecatedProperty = (cls, propName, warning, isStatic = false)=>{
    const target = isStatic ? cls : cls.prototype;
    let value = target[propName];
    Object.defineProperty(target, propName, {
        get () {
            $98eb031f10fd6d90$var$deprecated(propName, warning, `${cls.name}:${propName}`);
            return value;
        },
        set (v) {
            value = v;
        }
    });
};
var $98eb031f10fd6d90$var$deprecatedObjectProperty = (obj, propName, warning, key)=>{
    let value = obj[propName];
    Object.defineProperty(obj, propName, {
        get () {
            $98eb031f10fd6d90$var$deprecated(propName, warning, key);
            return value;
        },
        set (v) {
            value = v;
        }
    });
};



var $3QbnI = parcelRequire("3QbnI");
var $66227a65b3668026$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $66227a65b3668026$export$18a094aefa070634 = (obj, member, getter)=>{
    $66227a65b3668026$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $66227a65b3668026$export$addf369becd23283 = (obj, member, value)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $66227a65b3668026$export$42432efe6614d3b4 = (obj, member, value, setter)=>{
    $66227a65b3668026$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
};


var $64cf48068dfe7c99$exports = {};
"use strict";
var $64cf48068dfe7c99$var$__defProp = Object.defineProperty;
var $64cf48068dfe7c99$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $64cf48068dfe7c99$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $64cf48068dfe7c99$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $64cf48068dfe7c99$var$__export = (target, all)=>{
    for(var name in all)$64cf48068dfe7c99$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $64cf48068dfe7c99$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $64cf48068dfe7c99$var$__getOwnPropNames(from))if (!$64cf48068dfe7c99$var$__hasOwnProp.call(to, key) && key !== except) $64cf48068dfe7c99$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $64cf48068dfe7c99$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $64cf48068dfe7c99$var$__toCommonJS = (mod)=>$64cf48068dfe7c99$var$__copyProps($64cf48068dfe7c99$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/browser.ts
var $64cf48068dfe7c99$var$browser_exports = {};
$64cf48068dfe7c99$var$__export($64cf48068dfe7c99$var$browser_exports, {
    inBrowser: ()=>$64cf48068dfe7c99$var$inBrowser,
    isBrowserOnline: ()=>$64cf48068dfe7c99$var$isBrowserOnline,
    isValidBrowser: ()=>$64cf48068dfe7c99$var$isValidBrowser,
    isValidBrowserOnline: ()=>$64cf48068dfe7c99$var$isValidBrowserOnline,
    userAgentIsRobot: ()=>$64cf48068dfe7c99$var$userAgentIsRobot
});
$64cf48068dfe7c99$exports = $64cf48068dfe7c99$var$__toCommonJS($64cf48068dfe7c99$var$browser_exports);
function $64cf48068dfe7c99$var$inBrowser() {
    return typeof window !== "undefined";
}
var $64cf48068dfe7c99$var$botAgents = [
    "bot",
    "spider",
    "crawl",
    "APIs-Google",
    "AdsBot",
    "Googlebot",
    "mediapartners",
    "Google Favicon",
    "FeedFetcher",
    "Google-Read-Aloud",
    "DuplexWeb-Google",
    "googleweblight",
    "bing",
    "yandex",
    "baidu",
    "duckduck",
    "yahoo",
    "ecosia",
    "ia_archiver",
    "facebook",
    "instagram",
    "pinterest",
    "reddit",
    "slack",
    "twitter",
    "whatsapp",
    "youtube",
    "semrush"
];
var $64cf48068dfe7c99$var$botAgentRegex = new RegExp($64cf48068dfe7c99$var$botAgents.join("|"), "i");
function $64cf48068dfe7c99$var$userAgentIsRobot(userAgent) {
    return !userAgent ? false : $64cf48068dfe7c99$var$botAgentRegex.test(userAgent);
}
function $64cf48068dfe7c99$var$isValidBrowser() {
    const navigator = $64cf48068dfe7c99$var$inBrowser() ? window == null ? void 0 : window.navigator : null;
    if (!navigator) return false;
    return !$64cf48068dfe7c99$var$userAgentIsRobot(navigator == null ? void 0 : navigator.userAgent) && !(navigator == null ? void 0 : navigator.webdriver);
}
function $64cf48068dfe7c99$var$isBrowserOnline() {
    var _a, _b;
    const navigator = $64cf48068dfe7c99$var$inBrowser() ? window == null ? void 0 : window.navigator : null;
    if (!navigator) return false;
    const isNavigatorOnline = navigator == null ? void 0 : navigator.onLine;
    const isExperimentalConnectionOnline = ((_a = navigator == null ? void 0 : navigator.connection) == null ? void 0 : _a.rtt) !== 0 && ((_b = navigator == null ? void 0 : navigator.connection) == null ? void 0 : _b.downlink) !== 0;
    return isExperimentalConnectionOnline && isNavigatorOnline;
}
function $64cf48068dfe7c99$var$isValidBrowserOnline() {
    return $64cf48068dfe7c99$var$isBrowserOnline() && $64cf48068dfe7c99$var$isValidBrowser();
}



var $c0f1add66a3f2ef9$exports = {};
"use strict";
var $c0f1add66a3f2ef9$var$__defProp = Object.defineProperty;
var $c0f1add66a3f2ef9$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $c0f1add66a3f2ef9$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $c0f1add66a3f2ef9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c0f1add66a3f2ef9$var$__export = (target, all)=>{
    for(var name in all)$c0f1add66a3f2ef9$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $c0f1add66a3f2ef9$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $c0f1add66a3f2ef9$var$__getOwnPropNames(from))if (!$c0f1add66a3f2ef9$var$__hasOwnProp.call(to, key) && key !== except) $c0f1add66a3f2ef9$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $c0f1add66a3f2ef9$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $c0f1add66a3f2ef9$var$__toCommonJS = (mod)=>$c0f1add66a3f2ef9$var$__copyProps($c0f1add66a3f2ef9$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/handleValueOrFn.ts
var $c0f1add66a3f2ef9$var$handleValueOrFn_exports = {};
$c0f1add66a3f2ef9$var$__export($c0f1add66a3f2ef9$var$handleValueOrFn_exports, {
    handleValueOrFn: ()=>$c0f1add66a3f2ef9$var$handleValueOrFn
});
$c0f1add66a3f2ef9$exports = $c0f1add66a3f2ef9$var$__toCommonJS($c0f1add66a3f2ef9$var$handleValueOrFn_exports);
function $c0f1add66a3f2ef9$var$handleValueOrFn(value, url, defaultValue) {
    if (typeof value === "function") return value(url);
    if (typeof value !== "undefined") return value;
    if (typeof defaultValue !== "undefined") return defaultValue;
    return void 0;
}




function $24621e3c66140029$export$6916885f605cecec(f) {
    return typeof f === "function";
}



var $4925a7670f2efdec$exports = {};
"use strict";
var $4925a7670f2efdec$var$__defProp = Object.defineProperty;
var $4925a7670f2efdec$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $4925a7670f2efdec$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $4925a7670f2efdec$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4925a7670f2efdec$var$__export = (target, all)=>{
    for(var name in all)$4925a7670f2efdec$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $4925a7670f2efdec$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $4925a7670f2efdec$var$__getOwnPropNames(from))if (!$4925a7670f2efdec$var$__hasOwnProp.call(to, key) && key !== except) $4925a7670f2efdec$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $4925a7670f2efdec$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $4925a7670f2efdec$var$__toCommonJS = (mod)=>$4925a7670f2efdec$var$__copyProps($4925a7670f2efdec$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/loadScript.ts
var $4925a7670f2efdec$var$loadScript_exports = {};
$4925a7670f2efdec$var$__export($4925a7670f2efdec$var$loadScript_exports, {
    loadScript: ()=>$4925a7670f2efdec$var$loadScript
});
$4925a7670f2efdec$exports = $4925a7670f2efdec$var$__toCommonJS($4925a7670f2efdec$var$loadScript_exports);
var $4925a7670f2efdec$var$NO_DOCUMENT_ERROR = "loadScript cannot be called when document does not exist";
var $4925a7670f2efdec$var$NO_SRC_ERROR = "loadScript cannot be called without a src";
async function $4925a7670f2efdec$var$loadScript(src = "", opts) {
    const { async: async, defer: defer, beforeLoad: beforeLoad, crossOrigin: crossOrigin } = opts || {};
    return new Promise((resolve, reject)=>{
        if (!src) reject($4925a7670f2efdec$var$NO_SRC_ERROR);
        if (!document || !document.body) reject($4925a7670f2efdec$var$NO_DOCUMENT_ERROR);
        const script = document.createElement("script");
        crossOrigin && script.setAttribute("crossorigin", crossOrigin);
        script.async = async || false;
        script.defer = defer || false;
        script.addEventListener("load", ()=>{
            script.remove();
            resolve(script);
        });
        script.addEventListener("error", ()=>{
            script.remove();
            reject();
        });
        script.src = src;
        beforeLoad == null || beforeLoad(script);
        document.body.appendChild(script);
    });
}


var $c426272f7c220d20$exports = {};
"use strict";
var $c426272f7c220d20$var$__defProp = Object.defineProperty;
var $c426272f7c220d20$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $c426272f7c220d20$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $c426272f7c220d20$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c426272f7c220d20$var$__export = (target, all)=>{
    for(var name in all)$c426272f7c220d20$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $c426272f7c220d20$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $c426272f7c220d20$var$__getOwnPropNames(from))if (!$c426272f7c220d20$var$__hasOwnProp.call(to, key) && key !== except) $c426272f7c220d20$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $c426272f7c220d20$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $c426272f7c220d20$var$__toCommonJS = (mod)=>$c426272f7c220d20$var$__copyProps($c426272f7c220d20$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/proxy.ts
var $c426272f7c220d20$var$proxy_exports = {};
$c426272f7c220d20$var$__export($c426272f7c220d20$var$proxy_exports, {
    getRequestUrl: ()=>$c426272f7c220d20$var$getRequestUrl,
    isHttpOrHttps: ()=>$c426272f7c220d20$var$isHttpOrHttps,
    isProxyUrlRelative: ()=>$c426272f7c220d20$var$isProxyUrlRelative,
    isValidProxyUrl: ()=>$c426272f7c220d20$var$isValidProxyUrl,
    proxyUrlToAbsoluteURL: ()=>$c426272f7c220d20$var$proxyUrlToAbsoluteURL
});
$c426272f7c220d20$exports = $c426272f7c220d20$var$__toCommonJS($c426272f7c220d20$var$proxy_exports);
// src/utils/runtimeEnvironment.ts
var $c426272f7c220d20$var$isTestEnvironment = ()=>{
    try {
        return false;
    } catch (err) {}
    return false;
};
var $c426272f7c220d20$var$isProductionEnvironment = ()=>{
    try {
        return true;
    } catch (err) {}
    return false;
};
// src/deprecated.ts
var $c426272f7c220d20$var$displayedWarnings = /* @__PURE__ */ new Set();
var $c426272f7c220d20$var$deprecated = (fnName, warning, key)=>{
    const hideWarning = $c426272f7c220d20$var$isTestEnvironment() || $c426272f7c220d20$var$isProductionEnvironment();
    const messageId = key != null ? key : fnName;
    if ($c426272f7c220d20$var$displayedWarnings.has(messageId) || hideWarning) return;
    $c426272f7c220d20$var$displayedWarnings.add(messageId);
    console.warn(`Clerk - DEPRECATION WARNING: "${fnName}" is deprecated and will be removed in the next major release.
${warning}`);
};
// src/proxy.ts
function $c426272f7c220d20$var$isValidProxyUrl(key) {
    if (!key) return true;
    return $c426272f7c220d20$var$isHttpOrHttps(key) || $c426272f7c220d20$var$isProxyUrlRelative(key);
}
function $c426272f7c220d20$var$isHttpOrHttps(key) {
    return /^http(s)?:\/\//.test(key || "");
}
function $c426272f7c220d20$var$isProxyUrlRelative(key) {
    return key.startsWith("/");
}
function $c426272f7c220d20$var$proxyUrlToAbsoluteURL(url) {
    if (!url) return "";
    return $c426272f7c220d20$var$isProxyUrlRelative(url) ? new URL(url, window.location.origin).toString() : url;
}
function $c426272f7c220d20$var$getRequestUrl({ request: request, relativePath: relativePath }) {
    var _a, _b, _c, _d, _e, _f;
    $c426272f7c220d20$var$deprecated("getRequestUrl", "Use `buildRequestUrl` from @clerk/backend instead.");
    const { headers: headers, url: initialUrl } = request;
    const url = new URL(initialUrl);
    const host = (_c = (_b = (_a = headers.get("X-Forwarded-Host")) != null ? _a : headers.get("host")) != null ? _b : headers["host"]) != null ? _c : url.host;
    let protocol = (_f = (_e = (_d = headers.get("X-Forwarded-Proto")) != null ? _d : headers["X-Forwarded-Proto"]) == null ? void 0 : _e.split(",")[0]) != null ? _f : url.protocol;
    protocol = protocol.replace(/[:/]/, "");
    return new URL(relativePath || url.pathname, `${protocol}://${host}`);
}


var $42e542f3b4a7bb72$exports = {};
"use strict";
var $42e542f3b4a7bb72$var$__defProp = Object.defineProperty;
var $42e542f3b4a7bb72$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $42e542f3b4a7bb72$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $42e542f3b4a7bb72$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $42e542f3b4a7bb72$var$__export = (target, all)=>{
    for(var name in all)$42e542f3b4a7bb72$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $42e542f3b4a7bb72$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $42e542f3b4a7bb72$var$__getOwnPropNames(from))if (!$42e542f3b4a7bb72$var$__hasOwnProp.call(to, key) && key !== except) $42e542f3b4a7bb72$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $42e542f3b4a7bb72$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $42e542f3b4a7bb72$var$__toCommonJS = (mod)=>$42e542f3b4a7bb72$var$__copyProps($42e542f3b4a7bb72$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/url.ts
var $42e542f3b4a7bb72$var$url_exports = {};
$42e542f3b4a7bb72$var$__export($42e542f3b4a7bb72$var$url_exports, {
    addClerkPrefix: ()=>$42e542f3b4a7bb72$var$addClerkPrefix,
    getClerkJsMajorVersionOrTag: ()=>$42e542f3b4a7bb72$var$getClerkJsMajorVersionOrTag,
    getScriptUrl: ()=>$42e542f3b4a7bb72$var$getScriptUrl,
    parseSearchParams: ()=>$42e542f3b4a7bb72$var$parseSearchParams,
    stripScheme: ()=>$42e542f3b4a7bb72$var$stripScheme
});
$42e542f3b4a7bb72$exports = $42e542f3b4a7bb72$var$__toCommonJS($42e542f3b4a7bb72$var$url_exports);
// src/utils/instance.ts
function $42e542f3b4a7bb72$var$isStaging(frontendApi) {
    return frontendApi.endsWith(".lclstage.dev") || frontendApi.endsWith(".stgstage.dev") || frontendApi.endsWith(".clerkstage.dev") || frontendApi.endsWith(".accountsstage.dev");
}
// src/url.ts
function $42e542f3b4a7bb72$var$parseSearchParams(queryString = "") {
    if (queryString.startsWith("?")) queryString = queryString.slice(1);
    return new URLSearchParams(queryString);
}
function $42e542f3b4a7bb72$var$stripScheme(url = "") {
    return (url || "").replace(/^.+:\/\//, "");
}
function $42e542f3b4a7bb72$var$addClerkPrefix(str) {
    if (!str) return "";
    let regex;
    if (str.match(/^(clerk\.)+\w*$/)) regex = /(clerk\.)*(?=clerk\.)/;
    else if (str.match(/\.clerk.accounts/)) return str;
    else regex = /^(clerk\.)*/gi;
    const stripped = str.replace(regex, "");
    return `clerk.${stripped}`;
}
var $42e542f3b4a7bb72$var$getClerkJsMajorVersionOrTag = (frontendApi, pkgVersion)=>{
    if (!pkgVersion && $42e542f3b4a7bb72$var$isStaging(frontendApi)) return "canary";
    if (!pkgVersion) return "latest";
    return pkgVersion.split(".")[0] || "latest";
};
var $42e542f3b4a7bb72$var$getScriptUrl = (frontendApi, { pkgVersion: pkgVersion = "4.71.2", clerkJSVersion: clerkJSVersion })=>{
    const noSchemeFrontendApi = frontendApi.replace(/http(s)?:\/\//, "");
    const major = $42e542f3b4a7bb72$var$getClerkJsMajorVersionOrTag(frontendApi, pkgVersion);
    return `https://${noSchemeFrontendApi}/npm/@clerk/clerk-js@${clerkJSVersion || major}/dist/clerk.browser.js`;
};





const { isDevOrStagingUrl: $8d80e9b0faae86c1$export$c00c90d1e4c473d5 } = (0, $d0890e2d533e0714$exports.createDevOrStagingUrlCache)();



const $22bbd4ad89729956$export$92676ff167d438a8 = (clerkJSVersion)=>{
    if (clerkJSVersion) return clerkJSVersion;
    const prereleaseTag = $22bbd4ad89729956$var$getPrereleaseTag("4.31.1");
    if (prereleaseTag) {
        if (prereleaseTag === "snapshot") return "4.72.2";
        return prereleaseTag;
    }
    return $22bbd4ad89729956$var$getMajorVersion("4.31.1");
};
const $22bbd4ad89729956$var$getPrereleaseTag = (packageVersion)=>{
    var _a;
    return (_a = packageVersion.match(/-(.*)\./)) == null ? void 0 : _a[1];
};
const $22bbd4ad89729956$var$getMajorVersion = (packageVersion)=>packageVersion.split(".")[0];


const $4a523770d36ed493$var$FAILED_TO_LOAD_ERROR = "Clerk: Failed to load Clerk";
const $4a523770d36ed493$export$4236f1a239719b87 = (opts)=>{
    const { frontendApi: frontendApi, publishableKey: publishableKey } = opts;
    if (!publishableKey && !frontendApi) (0, $4b1975c39f3b1069$export$56721dd9fbd2a9c9).throwMissingPublishableKeyError();
    return (0, $4925a7670f2efdec$exports.loadScript)($4a523770d36ed493$var$clerkJsScriptUrl(opts), {
        async: true,
        crossOrigin: "anonymous",
        beforeLoad: $4a523770d36ed493$var$applyClerkJsScriptAttributes(opts)
    }).catch(()=>{
        throw new Error($4a523770d36ed493$var$FAILED_TO_LOAD_ERROR);
    });
};
const $4a523770d36ed493$var$clerkJsScriptUrl = (opts)=>{
    var _a, _b;
    const { clerkJSUrl: clerkJSUrl, clerkJSVariant: clerkJSVariant, clerkJSVersion: clerkJSVersion, proxyUrl: proxyUrl, domain: domain, publishableKey: publishableKey, frontendApi: frontendApi } = opts;
    if (clerkJSUrl) return clerkJSUrl;
    let scriptHost = "";
    if (!!proxyUrl && (0, $c426272f7c220d20$exports.isValidProxyUrl)(proxyUrl)) scriptHost = (0, $c426272f7c220d20$exports.proxyUrlToAbsoluteURL)(proxyUrl).replace(/http(s)?:\/\//, "");
    else if (domain && !(0, $8d80e9b0faae86c1$export$c00c90d1e4c473d5)(((_a = (0, $d0890e2d533e0714$exports.parsePublishableKey)(publishableKey)) == null ? void 0 : _a.frontendApi) || frontendApi || "")) scriptHost = (0, $42e542f3b4a7bb72$exports.addClerkPrefix)(domain);
    else scriptHost = ((_b = (0, $d0890e2d533e0714$exports.parsePublishableKey)(publishableKey)) == null ? void 0 : _b.frontendApi) || frontendApi || "";
    const variant = clerkJSVariant ? `${clerkJSVariant.replace(/\.+$/, "")}.` : "";
    const version = (0, $22bbd4ad89729956$export$92676ff167d438a8)(clerkJSVersion);
    return `https://${scriptHost}/npm/@clerk/clerk-js@${version}/dist/clerk.${variant}browser.js`;
};
const $4a523770d36ed493$var$applyClerkJsScriptAttributes = (options)=>(script)=>{
        const { publishableKey: publishableKey, frontendApi: frontendApi, proxyUrl: proxyUrl, domain: domain } = options;
        if (publishableKey) script.setAttribute("data-clerk-publishable-key", publishableKey);
        else if (frontendApi) script.setAttribute("data-clerk-frontend-api", frontendApi);
        if (proxyUrl) script.setAttribute("data-clerk-proxy-url", proxyUrl);
        if (domain) script.setAttribute("data-clerk-domain", domain);
    };


var $0e8cb273adfe7abd$var$_loaded, $0e8cb273adfe7abd$var$_domain, $0e8cb273adfe7abd$var$_proxyUrl, $0e8cb273adfe7abd$var$_frontendApi, $0e8cb273adfe7abd$var$_publishableKey, $0e8cb273adfe7abd$var$_instance;
const $0e8cb273adfe7abd$var$_IsomorphicClerk = class _IsomorphicClerk {
    constructor(options){
        this.clerkjs = null;
        this.preopenSignIn = null;
        this.preopenSignUp = null;
        this.preopenUserProfile = null;
        this.preopenOrganizationProfile = null;
        this.preopenCreateOrganization = null;
        this.premountSignInNodes = /* @__PURE__ */ new Map();
        this.premountSignUpNodes = /* @__PURE__ */ new Map();
        this.premountUserProfileNodes = /* @__PURE__ */ new Map();
        this.premountUserButtonNodes = /* @__PURE__ */ new Map();
        this.premountOrganizationProfileNodes = /* @__PURE__ */ new Map();
        this.premountCreateOrganizationNodes = /* @__PURE__ */ new Map();
        this.premountOrganizationSwitcherNodes = /* @__PURE__ */ new Map();
        this.premountOrganizationListNodes = /* @__PURE__ */ new Map();
        this.premountMethodCalls = /* @__PURE__ */ new Map();
        this.loadedListeners = [];
        (0, $66227a65b3668026$export$addf369becd23283)(this, $0e8cb273adfe7abd$var$_loaded, false);
        (0, $66227a65b3668026$export$addf369becd23283)(this, $0e8cb273adfe7abd$var$_domain, void 0);
        (0, $66227a65b3668026$export$addf369becd23283)(this, $0e8cb273adfe7abd$var$_proxyUrl, void 0);
        (0, $66227a65b3668026$export$addf369becd23283)(this, $0e8cb273adfe7abd$var$_frontendApi, void 0);
        (0, $66227a65b3668026$export$addf369becd23283)(this, $0e8cb273adfe7abd$var$_publishableKey, void 0);
        this.isReady = ()=>{
            var _a;
            return Boolean((_a = this.clerkjs) == null ? void 0 : _a.isReady());
        };
        this.buildSignInUrl = (opts)=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildSignInUrl(opts)) || "";
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildSignInUrl", callback);
        };
        this.buildSignUpUrl = (opts)=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildSignUpUrl(opts)) || "";
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildSignUpUrl", callback);
        };
        this.buildUserProfileUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildUserProfileUrl()) || "";
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildUserProfileUrl", callback);
        };
        this.buildCreateOrganizationUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildCreateOrganizationUrl()) || "";
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildCreateOrganizationUrl", callback);
        };
        this.buildOrganizationProfileUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildOrganizationProfileUrl()) || "";
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildOrganizationProfileUrl", callback);
        };
        this.buildHomeUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildHomeUrl()) || "";
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildHomeUrl", callback);
        };
        this.buildUrlWithAuth = (to)=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildUrlWithAuth(to)) || "";
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("buildUrlWithAuth", callback);
        };
        this.handleUnauthenticated = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.handleUnauthenticated();
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) callback();
            else this.premountMethodCalls.set("handleUnauthenticated", callback);
        };
        this.addOnLoaded = (cb)=>{
            this.loadedListeners.push(cb);
            if (this.loaded) this.emitLoaded();
        };
        this.emitLoaded = ()=>{
            this.loadedListeners.forEach((cb)=>cb());
            this.loadedListeners = [];
        };
        this.hydrateClerkJS = (clerkjs)=>{
            if (!clerkjs) throw new Error("Failed to hydrate latest Clerk JS");
            this.clerkjs = clerkjs;
            this.premountMethodCalls.forEach((cb)=>cb());
            if (this.preopenSignIn !== null) clerkjs.openSignIn(this.preopenSignIn);
            if (this.preopenSignUp !== null) clerkjs.openSignUp(this.preopenSignUp);
            if (this.preopenUserProfile !== null) clerkjs.openUserProfile(this.preopenUserProfile);
            if (this.preopenOrganizationProfile !== null) clerkjs.openOrganizationProfile(this.preopenOrganizationProfile);
            if (this.preopenCreateOrganization !== null) clerkjs.openCreateOrganization(this.preopenCreateOrganization);
            this.premountSignInNodes.forEach((props, node)=>{
                clerkjs.mountSignIn(node, props);
            });
            this.premountSignUpNodes.forEach((props, node)=>{
                clerkjs.mountSignUp(node, props);
            });
            this.premountUserProfileNodes.forEach((props, node)=>{
                clerkjs.mountUserProfile(node, props);
            });
            this.premountUserButtonNodes.forEach((props, node)=>{
                clerkjs.mountUserButton(node, props);
            });
            this.premountOrganizationListNodes.forEach((props, node)=>{
                clerkjs.mountOrganizationList(node, props);
            });
            (0, $66227a65b3668026$export$42432efe6614d3b4)(this, $0e8cb273adfe7abd$var$_loaded, true);
            this.emitLoaded();
            return this.clerkjs;
        };
        this.__unstable__updateProps = (props)=>{
            if (this.clerkjs && "__unstable__updateProps" in this.clerkjs) this.clerkjs.__unstable__updateProps(props);
            else return void 0;
        };
        /**
     * `setActive` can be used to set the active session and/or organization.
     */ this.setActive = ({ session: session, organization: organization, beforeEmit: beforeEmit })=>{
            if (this.clerkjs) return this.clerkjs.setActive({
                session: session,
                organization: organization,
                beforeEmit: beforeEmit
            });
            else return Promise.reject();
        };
        this.setSession = (session, beforeEmit)=>{
            (0, $98eb031f10fd6d90$exports.deprecated)("setSession", "Use `Clerk.setActive` instead");
            return this.setActive({
                session: session,
                beforeEmit: beforeEmit
            });
        };
        this.openSignIn = (props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.openSignIn(props);
            else this.preopenSignIn = props;
        };
        this.closeSignIn = ()=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.closeSignIn();
            else this.preopenSignIn = null;
        };
        this.openUserProfile = (props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.openUserProfile(props);
            else this.preopenUserProfile = props;
        };
        this.closeUserProfile = ()=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.closeUserProfile();
            else this.preopenUserProfile = null;
        };
        this.openOrganizationProfile = (props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.openOrganizationProfile(props);
            else this.preopenOrganizationProfile = props;
        };
        this.closeOrganizationProfile = ()=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.closeOrganizationProfile();
            else this.preopenOrganizationProfile = null;
        };
        this.openCreateOrganization = (props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.openCreateOrganization(props);
            else this.preopenCreateOrganization = props;
        };
        this.closeCreateOrganization = ()=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.closeCreateOrganization();
            else this.preopenCreateOrganization = null;
        };
        this.openSignUp = (props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.openSignUp(props);
            else this.preopenSignUp = props;
        };
        this.closeSignUp = ()=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.closeSignUp();
            else this.preopenSignUp = null;
        };
        this.mountSignIn = (node, props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.mountSignIn(node, props);
            else this.premountSignInNodes.set(node, props);
        };
        this.unmountSignIn = (node)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.unmountSignIn(node);
            else this.premountSignInNodes.delete(node);
        };
        this.__experimental_mountGoogleOneTap = (node, props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.__experimental_mountGoogleOneTap(node, props);
        };
        this.__experimental_unmountGoogleOneTap = (node)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.__experimental_unmountGoogleOneTap(node);
        };
        this.mountSignUp = (node, props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.mountSignUp(node, props);
            else this.premountSignUpNodes.set(node, props);
        };
        this.unmountSignUp = (node)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.unmountSignUp(node);
            else this.premountSignUpNodes.delete(node);
        };
        this.mountUserProfile = (node, props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.mountUserProfile(node, props);
            else this.premountUserProfileNodes.set(node, props);
        };
        this.unmountUserProfile = (node)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.unmountUserProfile(node);
            else this.premountUserProfileNodes.delete(node);
        };
        this.mountOrganizationProfile = (node, props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.mountOrganizationProfile(node, props);
            else this.premountOrganizationProfileNodes.set(node, props);
        };
        this.unmountOrganizationProfile = (node)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.unmountOrganizationProfile(node);
            else this.premountOrganizationProfileNodes.delete(node);
        };
        this.mountCreateOrganization = (node, props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.mountCreateOrganization(node, props);
            else this.premountCreateOrganizationNodes.set(node, props);
        };
        this.unmountCreateOrganization = (node)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.unmountCreateOrganization(node);
            else this.premountCreateOrganizationNodes.delete(node);
        };
        this.mountOrganizationSwitcher = (node, props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.mountOrganizationSwitcher(node, props);
            else this.premountOrganizationSwitcherNodes.set(node, props);
        };
        this.unmountOrganizationSwitcher = (node)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.unmountOrganizationSwitcher(node);
            else this.premountOrganizationSwitcherNodes.delete(node);
        };
        this.mountOrganizationList = (node, props)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.mountOrganizationList(node, props);
            else this.premountOrganizationListNodes.set(node, props);
        };
        this.unmountOrganizationList = (node)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.unmountOrganizationList(node);
            else this.premountOrganizationListNodes.delete(node);
        };
        this.mountUserButton = (node, userButtonProps)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.mountUserButton(node, userButtonProps);
            else this.premountUserButtonNodes.set(node, userButtonProps);
        };
        this.unmountUserButton = (node)=>{
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) this.clerkjs.unmountUserButton(node);
            else this.premountUserButtonNodes.delete(node);
        };
        this.addListener = (listener)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.addListener(listener);
            };
            if (this.clerkjs) return callback();
            else {
                this.premountMethodCalls.set("addListener", callback);
                return ()=>this.premountMethodCalls.delete("addListener");
            }
        };
        this.navigate = (to)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.navigate(to);
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) callback();
            else this.premountMethodCalls.set("navigate", callback);
        };
        this.redirectWithAuth = (...args)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectWithAuth(...args);
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) callback();
            else this.premountMethodCalls.set("redirectWithAuth", callback);
        };
        this.redirectToSignIn = (opts)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToSignIn(opts);
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) callback();
            else this.premountMethodCalls.set("redirectToSignIn", callback);
        };
        this.redirectToSignUp = (opts)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToSignUp(opts);
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) callback();
            else this.premountMethodCalls.set("redirectToSignUp", callback);
        };
        this.redirectToUserProfile = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToUserProfile();
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) callback();
            else this.premountMethodCalls.set("redirectToUserProfile", callback);
        };
        this.redirectToHome = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToHome();
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) callback();
            else this.premountMethodCalls.set("redirectToHome", callback);
        };
        this.redirectToOrganizationProfile = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToOrganizationProfile();
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) callback();
            else this.premountMethodCalls.set("redirectToOrganizationProfile", callback);
        };
        this.redirectToCreateOrganization = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToCreateOrganization();
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) callback();
            else this.premountMethodCalls.set("redirectToCreateOrganization", callback);
        };
        this.handleRedirectCallback = (params)=>{
            var _a;
            const callback = ()=>{
                var _a2;
                return (_a2 = this.clerkjs) == null ? void 0 : _a2.handleRedirectCallback(params);
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) (_a = callback()) == null || _a.catch(()=>{});
            else this.premountMethodCalls.set("handleRedirectCallback", callback);
        };
        /**
     * @deprecated Use `handleEmailLinkVerification` instead.
     */ this.handleMagicLinkVerification = async (params)=>{
            (0, $98eb031f10fd6d90$exports.deprecated)("handleMagicLinkVerification", "Use `handleEmailLinkVerification` instead.");
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.handleMagicLinkVerification(params);
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("handleMagicLinkVerification", callback);
        };
        this.handleEmailLinkVerification = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.handleEmailLinkVerification(params);
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("handleEmailLinkVerification", callback);
        };
        this.authenticateWithMetamask = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithMetamask(params);
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("authenticateWithMetamask", callback);
        };
        this.createOrganization = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.createOrganization(params);
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("createOrganization", callback);
        };
        this.getOrganizationMemberships = async ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.getOrganizationMemberships();
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("getOrganizationMemberships", callback);
        };
        this.getOrganization = async (organizationId)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.getOrganization(organizationId);
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("getOrganization", callback);
        };
        this.signOut = async (signOutCallbackOrOptions, options)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.signOut(signOutCallbackOrOptions, options);
            };
            if (this.clerkjs && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return callback();
            else this.premountMethodCalls.set("signOut", callback);
        };
        const { Clerk: Clerk = null, frontendApi: frontendApi, publishableKey: publishableKey } = options || {};
        (0, $66227a65b3668026$export$42432efe6614d3b4)(this, $0e8cb273adfe7abd$var$_frontendApi, frontendApi);
        (0, $66227a65b3668026$export$42432efe6614d3b4)(this, $0e8cb273adfe7abd$var$_publishableKey, publishableKey);
        (0, $66227a65b3668026$export$42432efe6614d3b4)(this, $0e8cb273adfe7abd$var$_proxyUrl, options == null ? void 0 : options.proxyUrl);
        (0, $66227a65b3668026$export$42432efe6614d3b4)(this, $0e8cb273adfe7abd$var$_domain, options == null ? void 0 : options.domain);
        this.options = options;
        this.Clerk = Clerk;
        this.mode = (0, $64cf48068dfe7c99$exports.inBrowser)() ? "browser" : "server";
        this.loadClerkJS();
    }
    get publishableKey() {
        return (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_publishableKey);
    }
    get loaded() {
        return (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded);
    }
    static getOrCreateInstance(options) {
        if (!(0, $64cf48068dfe7c99$exports.inBrowser)() || !(0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_instance) || options.Clerk && (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_instance).Clerk !== options.Clerk) (0, $66227a65b3668026$export$42432efe6614d3b4)(this, $0e8cb273adfe7abd$var$_instance, new _IsomorphicClerk(options));
        return (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_instance);
    }
    static clearInstance() {
        (0, $66227a65b3668026$export$42432efe6614d3b4)(this, $0e8cb273adfe7abd$var$_instance, null);
    }
    get domain() {
        if (typeof window !== "undefined" && window.location) return (0, $c0f1add66a3f2ef9$exports.handleValueOrFn)((0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_domain), new URL(window.location.href), "");
        if (typeof (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_domain) === "function") throw new Error((0, $5af9131399f28559$export$ccf659c4f3b60fd5));
        return (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_domain) || "";
    }
    get proxyUrl() {
        if (typeof window !== "undefined" && window.location) return (0, $c0f1add66a3f2ef9$exports.handleValueOrFn)((0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_proxyUrl), new URL(window.location.href), "");
        if (typeof (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_proxyUrl) === "function") throw new Error((0, $5af9131399f28559$export$ccf659c4f3b60fd5));
        return (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_proxyUrl) || "";
    }
    get sdkMetadata() {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.sdkMetadata) || this.options.sdkMetadata || void 0;
    }
    get instanceType() {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.instanceType;
    }
    get frontendApi() {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.frontendApi) || (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_frontendApi) || "";
    }
    get isStandardBrowser() {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.isStandardBrowser) || this.options.standardBrowser || false;
    }
    get isSatellite() {
        if (typeof window !== "undefined" && window.location) return (0, $c0f1add66a3f2ef9$exports.handleValueOrFn)(this.options.isSatellite, new URL(window.location.href), false);
        if (typeof this.options.isSatellite === "function") throw new Error((0, $5af9131399f28559$export$ccf659c4f3b60fd5));
        return false;
    }
    async loadClerkJS() {
        var _a, _b, _c;
        if (this.mode !== "browser" || (0, $66227a65b3668026$export$18a094aefa070634)(this, $0e8cb273adfe7abd$var$_loaded)) return;
        if (typeof window !== "undefined") {
            window.__clerk_frontend_api = this.frontendApi;
            window.__clerk_publishable_key = this.publishableKey;
            window.__clerk_proxy_url = this.proxyUrl;
            window.__clerk_domain = this.domain;
        }
        try {
            if (this.Clerk) {
                let c;
                if ((0, $24621e3c66140029$export$6916885f605cecec)(this.Clerk)) {
                    c = new this.Clerk(this.publishableKey || this.frontendApi || "", {
                        proxyUrl: this.proxyUrl,
                        domain: this.domain
                    });
                    await c.load(this.options);
                } else {
                    c = this.Clerk;
                    if (!c.isReady()) await c.load(this.options);
                }
                $parcel$global.Clerk = c;
            } else {
                if (!$parcel$global.Clerk) await (0, $4a523770d36ed493$export$4236f1a239719b87)({
                    ...this.options,
                    frontendApi: this.frontendApi,
                    publishableKey: this.publishableKey,
                    proxyUrl: this.proxyUrl,
                    domain: this.domain
                });
                if (!$parcel$global.Clerk) throw new Error("Failed to download latest ClerkJS. Contact support@clerk.com.");
                await $parcel$global.Clerk.load(this.options);
            }
            $parcel$global.Clerk.sdkMetadata = (_a = this.options.sdkMetadata) != null ? _a : {
                name: "@clerk/clerk-react",
                version: "4.31.1"
            };
            if (((_b = $parcel$global.Clerk) == null ? void 0 : _b.loaded) || ((_c = $parcel$global.Clerk) == null ? void 0 : _c.isReady())) return this.hydrateClerkJS($parcel$global.Clerk);
            return;
        } catch (err) {
            const error = err;
            console.error(error.stack || error.message || error);
            return;
        }
    }
    get version() {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.version;
    }
    get client() {
        if (this.clerkjs) return this.clerkjs.client;
        else return void 0;
    }
    get session() {
        if (this.clerkjs) return this.clerkjs.session;
        else return void 0;
    }
    get user() {
        if (this.clerkjs) return this.clerkjs.user;
        else return void 0;
    }
    get organization() {
        if (this.clerkjs) return this.clerkjs.organization;
        else return void 0;
    }
    get __unstable__environment() {
        if (this.clerkjs) return this.clerkjs.__unstable__environment;
        else return void 0;
    }
    __unstable__setEnvironment(...args) {
        if (this.clerkjs && "__unstable__setEnvironment" in this.clerkjs) this.clerkjs.__unstable__setEnvironment(args);
        else return void 0;
    }
};
$0e8cb273adfe7abd$var$_loaded = new WeakMap();
$0e8cb273adfe7abd$var$_domain = new WeakMap();
$0e8cb273adfe7abd$var$_proxyUrl = new WeakMap();
$0e8cb273adfe7abd$var$_frontendApi = new WeakMap();
$0e8cb273adfe7abd$var$_publishableKey = new WeakMap();
$0e8cb273adfe7abd$var$_instance = new WeakMap();
(0, $66227a65b3668026$export$addf369becd23283)($0e8cb273adfe7abd$var$_IsomorphicClerk, $0e8cb273adfe7abd$var$_instance, void 0);
let $0e8cb273adfe7abd$export$2e2bcd8739ae039 = $0e8cb273adfe7abd$var$_IsomorphicClerk;



const $b57c7050ed0698b8$export$485fc5c1dea91f96 = (clerkLoaded, state, initialState)=>{
    if (!clerkLoaded && initialState) return $b57c7050ed0698b8$var$deriveFromSsrInitialState(initialState);
    return $b57c7050ed0698b8$var$deriveFromClientSideState(state);
};
const $b57c7050ed0698b8$var$deriveFromSsrInitialState = (initialState)=>{
    const userId = initialState.userId;
    const user = initialState.user;
    const sessionId = initialState.sessionId;
    const session = initialState.session;
    const organization = initialState.organization;
    const orgId = initialState.orgId;
    const orgRole = initialState.orgRole;
    const orgPermissions = initialState.orgPermissions;
    const orgSlug = initialState.orgSlug;
    const actor = initialState.actor;
    return {
        userId: userId,
        user: user,
        sessionId: sessionId,
        session: session,
        organization: organization,
        orgId: orgId,
        orgRole: orgRole,
        orgPermissions: orgPermissions,
        orgSlug: orgSlug,
        actor: actor,
        lastOrganizationInvitation: null,
        lastOrganizationMember: null
    };
};
const $b57c7050ed0698b8$var$deriveFromClientSideState = (state)=>{
    var _a;
    const userId = state.user ? state.user.id : state.user;
    const user = state.user;
    const sessionId = state.session ? state.session.id : state.session;
    const session = state.session;
    const actor = session == null ? void 0 : session.actor;
    const organization = state.organization;
    const orgId = state.organization ? state.organization.id : state.organization;
    const orgSlug = organization == null ? void 0 : organization.slug;
    const membership = organization ? (_a = user == null ? void 0 : user.organizationMemberships) == null ? void 0 : _a.find((om)=>om.organization.id === orgId) : organization;
    const orgPermissions = membership ? membership.permissions : membership;
    const orgRole = membership ? membership.role : membership;
    const lastOrganizationInvitation = state.lastOrganizationInvitation;
    const lastOrganizationMember = state.lastOrganizationMember;
    return {
        userId: userId,
        user: user,
        sessionId: sessionId,
        session: session,
        organization: organization,
        orgId: orgId,
        orgRole: orgRole,
        orgSlug: orgSlug,
        orgPermissions: orgPermissions,
        actor: actor,
        lastOrganizationInvitation: lastOrganizationInvitation,
        lastOrganizationMember: lastOrganizationMember
    };
};



var $0438480e8c63a6c9$exports = {};
"use strict";
var $0438480e8c63a6c9$var$__create = Object.create;
var $0438480e8c63a6c9$var$__defProp = Object.defineProperty;
var $0438480e8c63a6c9$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $0438480e8c63a6c9$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $0438480e8c63a6c9$var$__getProtoOf = Object.getPrototypeOf;
var $0438480e8c63a6c9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0438480e8c63a6c9$var$__export = (target, all)=>{
    for(var name in all)$0438480e8c63a6c9$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $0438480e8c63a6c9$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $0438480e8c63a6c9$var$__getOwnPropNames(from))if (!$0438480e8c63a6c9$var$__hasOwnProp.call(to, key) && key !== except) $0438480e8c63a6c9$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $0438480e8c63a6c9$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $0438480e8c63a6c9$var$__reExport = (target, mod, secondTarget)=>($0438480e8c63a6c9$var$__copyProps(target, mod, "default"), secondTarget && $0438480e8c63a6c9$var$__copyProps(secondTarget, mod, "default"));
var $0438480e8c63a6c9$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $0438480e8c63a6c9$var$__create($0438480e8c63a6c9$var$__getProtoOf(mod)) : {}, $0438480e8c63a6c9$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $0438480e8c63a6c9$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $0438480e8c63a6c9$var$__toCommonJS = (mod)=>$0438480e8c63a6c9$var$__copyProps($0438480e8c63a6c9$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/react/index.ts
var $0438480e8c63a6c9$var$react_exports = {};
$0438480e8c63a6c9$var$__export($0438480e8c63a6c9$var$react_exports, {
    ClerkInstanceContext: ()=>$0438480e8c63a6c9$var$ClerkInstanceContext,
    ClientContext: ()=>$0438480e8c63a6c9$var$ClientContext,
    OrganizationContext: ()=>$0438480e8c63a6c9$var$OrganizationContext,
    OrganizationProvider: ()=>$0438480e8c63a6c9$var$OrganizationProvider,
    SessionContext: ()=>$0438480e8c63a6c9$var$SessionContext,
    UserContext: ()=>$0438480e8c63a6c9$var$UserContext,
    assertContextExists: ()=>$0438480e8c63a6c9$var$assertContextExists,
    createContextAndHook: ()=>$0438480e8c63a6c9$var$createContextAndHook,
    useClerkInstanceContext: ()=>$0438480e8c63a6c9$var$useClerkInstanceContext,
    useClientContext: ()=>$0438480e8c63a6c9$var$useClientContext,
    useOrganization: ()=>$0438480e8c63a6c9$var$useOrganization,
    useOrganizationContext: ()=>$0438480e8c63a6c9$var$useOrganizationContext,
    useOrganizationList: ()=>$0438480e8c63a6c9$var$useOrganizationList,
    useOrganizations: ()=>$0438480e8c63a6c9$var$useOrganizations,
    useSafeLayoutEffect: ()=>$0438480e8c63a6c9$var$useSafeLayoutEffect,
    useSessionContext: ()=>$0438480e8c63a6c9$var$useSessionContext,
    useUserContext: ()=>$0438480e8c63a6c9$var$useUserContext
});
$0438480e8c63a6c9$exports = $0438480e8c63a6c9$var$__toCommonJS($0438480e8c63a6c9$var$react_exports);

// src/react/hooks/createContextAndHook.ts
var $0438480e8c63a6c9$var$import_react = $0438480e8c63a6c9$var$__toESM((parcelRequire("3QbnI")));
function $0438480e8c63a6c9$var$assertContextExists(contextVal, msgOrCtx) {
    if (!contextVal) throw typeof msgOrCtx === "string" ? new Error(msgOrCtx) : new Error(`${msgOrCtx.displayName} not found`);
}
var $0438480e8c63a6c9$var$createContextAndHook = (displayName, options)=>{
    const { assertCtxFn: assertCtxFn = $0438480e8c63a6c9$var$assertContextExists } = options || {};
    const Ctx = $0438480e8c63a6c9$var$import_react.default.createContext(void 0);
    Ctx.displayName = displayName;
    const useCtx = ()=>{
        const ctx = $0438480e8c63a6c9$var$import_react.default.useContext(Ctx);
        assertCtxFn(ctx, `${displayName} not found`);
        return ctx.value;
    };
    const useCtxWithoutGuarantee = ()=>{
        const ctx = $0438480e8c63a6c9$var$import_react.default.useContext(Ctx);
        return ctx ? ctx.value : {};
    };
    return [
        Ctx,
        useCtx,
        useCtxWithoutGuarantee
    ];
};
// src/utils/runtimeEnvironment.ts
var $0438480e8c63a6c9$var$isTestEnvironment = ()=>{
    try {
        return false;
    } catch (err) {}
    return false;
};
var $0438480e8c63a6c9$var$isProductionEnvironment = ()=>{
    try {
        return true;
    } catch (err) {}
    return false;
};
// src/deprecated.ts
var $0438480e8c63a6c9$var$displayedWarnings = /* @__PURE__ */ new Set();
var $0438480e8c63a6c9$var$deprecated = (fnName, warning, key)=>{
    const hideWarning = $0438480e8c63a6c9$var$isTestEnvironment() || $0438480e8c63a6c9$var$isProductionEnvironment();
    const messageId = key != null ? key : fnName;
    if ($0438480e8c63a6c9$var$displayedWarnings.has(messageId) || hideWarning) return;
    $0438480e8c63a6c9$var$displayedWarnings.add(messageId);
    console.warn(`Clerk - DEPRECATION WARNING: "${fnName}" is deprecated and will be removed in the next major release.
${warning}`);
};
var $0438480e8c63a6c9$var$deprecatedObjectProperty = (obj, propName, warning, key)=>{
    let value = obj[propName];
    Object.defineProperty(obj, propName, {
        get () {
            $0438480e8c63a6c9$var$deprecated(propName, warning, key);
            return value;
        },
        set (v) {
            value = v;
        }
    });
};
// src/react/clerk-swr.ts
var $0438480e8c63a6c9$var$clerk_swr_exports = {};
$0438480e8c63a6c9$var$__export($0438480e8c63a6c9$var$clerk_swr_exports, {
    SWRConfig: ()=>$0438480e8c63a6c9$var$import_swr.SWRConfig,
    useSWR: ()=>$0438480e8c63a6c9$var$import_swr.default,
    useSWRInfinite: ()=>$0438480e8c63a6c9$var$import_infinite.default
});

$0438480e8c63a6c9$var$__reExport($0438480e8c63a6c9$var$clerk_swr_exports, (parcelRequire("lgZPq")));

var $0438480e8c63a6c9$var$import_swr = $0438480e8c63a6c9$var$__toESM((parcelRequire("lgZPq")));

var $0438480e8c63a6c9$var$import_infinite = $0438480e8c63a6c9$var$__toESM((parcelRequire("78BOR")));

// src/react/contexts.tsx
var $0438480e8c63a6c9$var$import_react2 = $0438480e8c63a6c9$var$__toESM((parcelRequire("3QbnI")));
var [$0438480e8c63a6c9$var$ClerkInstanceContext, $0438480e8c63a6c9$var$useClerkInstanceContext] = $0438480e8c63a6c9$var$createContextAndHook("ClerkInstanceContext");
var [$0438480e8c63a6c9$var$UserContext, $0438480e8c63a6c9$var$useUserContext] = $0438480e8c63a6c9$var$createContextAndHook("UserContext");
var [$0438480e8c63a6c9$var$ClientContext, $0438480e8c63a6c9$var$useClientContext] = $0438480e8c63a6c9$var$createContextAndHook("ClientContext");
var [$0438480e8c63a6c9$var$SessionContext, $0438480e8c63a6c9$var$useSessionContext] = $0438480e8c63a6c9$var$createContextAndHook("SessionContext");
var [$0438480e8c63a6c9$var$OrganizationContextInternal, $0438480e8c63a6c9$var$useOrganizationContext] = $0438480e8c63a6c9$var$createContextAndHook("OrganizationContext");
var $0438480e8c63a6c9$var$OrganizationProvider = ({ children: children, organization: organization, lastOrganizationMember: lastOrganizationMember, lastOrganizationInvitation: lastOrganizationInvitation, swrConfig: swrConfig })=>{
    return /* @__PURE__ */ $0438480e8c63a6c9$var$import_react2.default.createElement($0438480e8c63a6c9$var$import_swr.SWRConfig, {
        value: swrConfig
    }, /* @__PURE__ */ $0438480e8c63a6c9$var$import_react2.default.createElement($0438480e8c63a6c9$var$OrganizationContextInternal.Provider, {
        value: {
            value: {
                organization: organization,
                lastOrganizationMember: lastOrganizationMember,
                lastOrganizationInvitation: lastOrganizationInvitation
            }
        }
    }, children));
};
var $0438480e8c63a6c9$var$OrganizationContext = (...args)=>{
    $0438480e8c63a6c9$var$deprecated("OrganizationContext", "Use `OrganizationProvider` instead");
    return $0438480e8c63a6c9$var$OrganizationProvider(...args);
};

function $0438480e8c63a6c9$var$getDifferentKeys(obj1, obj2) {
    const keysSet = new Set(Object.keys(obj2));
    const differentKeysObject = {};
    for (const key1 of Object.keys(obj1))if (!keysSet.has(key1)) differentKeysObject[key1] = obj1[key1];
    return differentKeysObject;
}
var $0438480e8c63a6c9$var$useWithSafeValues = (params, defaultValues)=>{
    var _a, _b, _c;
    const shouldUseDefaults = typeof params === "boolean" && params;
    const initialPageRef = (0, (parcelRequire("3QbnI")).useRef)(shouldUseDefaults ? defaultValues.initialPage : (_a = params == null ? void 0 : params.initialPage) != null ? _a : defaultValues.initialPage);
    const pageSizeRef = (0, (parcelRequire("3QbnI")).useRef)(shouldUseDefaults ? defaultValues.pageSize : (_b = params == null ? void 0 : params.pageSize) != null ? _b : defaultValues.pageSize);
    const newObj = {};
    for (const key of Object.keys(defaultValues))newObj[key] = shouldUseDefaults ? defaultValues[key] : (_c = params == null ? void 0 : params[key]) != null ? _c : defaultValues[key];
    return {
        ...newObj,
        initialPage: initialPageRef.current,
        pageSize: pageSizeRef.current
    };
};
var $0438480e8c63a6c9$var$usePagesOrInfinite = (params, fetcher, options, cacheKeys)=>{
    var _a, _b, _c, _d, _e, _f;
    const [paginatedPage, setPaginatedPage] = (0, (parcelRequire("3QbnI")).useState)((_a = params.initialPage) != null ? _a : 1);
    const initialPageRef = (0, (parcelRequire("3QbnI")).useRef)((_b = params.initialPage) != null ? _b : 1);
    const pageSizeRef = (0, (parcelRequire("3QbnI")).useRef)((_c = params.pageSize) != null ? _c : 10);
    const enabled = (_d = options.enabled) != null ? _d : true;
    const triggerInfinite = (_e = options.infinite) != null ? _e : false;
    const keepPreviousData = (_f = options.keepPreviousData) != null ? _f : false;
    const pagesCacheKey = {
        ...cacheKeys,
        ...params,
        initialPage: paginatedPage,
        pageSize: pageSizeRef.current
    };
    const { data: swrData, isValidating: swrIsValidating, isLoading: swrIsLoading, error: swrError, mutate: swrMutate } = (0, $0438480e8c63a6c9$var$import_swr.default)(!triggerInfinite && !!fetcher && enabled ? pagesCacheKey : null, (cacheKeyParams)=>{
        const requestParams = $0438480e8c63a6c9$var$getDifferentKeys(cacheKeyParams, cacheKeys);
        return fetcher == null ? void 0 : fetcher(requestParams);
    }, {
        keepPreviousData: keepPreviousData
    });
    const { data: swrInfiniteData, isLoading: swrInfiniteIsLoading, isValidating: swrInfiniteIsValidating, error: swrInfiniteError, size: size, setSize: setSize, mutate: swrInfiniteMutate } = (0, $0438480e8c63a6c9$var$import_infinite.default)((pageIndex)=>{
        if (!triggerInfinite || !enabled) return null;
        return {
            ...params,
            ...cacheKeys,
            initialPage: initialPageRef.current + pageIndex,
            pageSize: pageSizeRef.current
        };
    }, (cacheKeyParams)=>{
        const requestParams = $0438480e8c63a6c9$var$getDifferentKeys(cacheKeyParams, cacheKeys);
        return fetcher == null ? void 0 : fetcher(requestParams);
    });
    const page = (0, (parcelRequire("3QbnI")).useMemo)(()=>{
        if (triggerInfinite) return size;
        return paginatedPage;
    }, [
        triggerInfinite,
        size,
        paginatedPage
    ]);
    const fetchPage = (0, (parcelRequire("3QbnI")).useCallback)((numberOrgFn)=>{
        if (triggerInfinite) {
            setSize(numberOrgFn);
            return;
        }
        return setPaginatedPage(numberOrgFn);
    }, [
        setSize
    ]);
    const data = (0, (parcelRequire("3QbnI")).useMemo)(()=>{
        var _a2, _b2;
        if (triggerInfinite) return (_a2 = swrInfiniteData == null ? void 0 : swrInfiniteData.map((a)=>a == null ? void 0 : a.data).flat()) != null ? _a2 : [];
        return (_b2 = swrData == null ? void 0 : swrData.data) != null ? _b2 : [];
    }, [
        triggerInfinite,
        swrData,
        swrInfiniteData
    ]);
    const count = (0, (parcelRequire("3QbnI")).useMemo)(()=>{
        var _a2, _b2;
        if (triggerInfinite) return ((_a2 = swrInfiniteData == null ? void 0 : swrInfiniteData[(swrInfiniteData == null ? void 0 : swrInfiniteData.length) - 1]) == null ? void 0 : _a2.total_count) || 0;
        return (_b2 = swrData == null ? void 0 : swrData.total_count) != null ? _b2 : 0;
    }, [
        triggerInfinite,
        swrData,
        swrInfiniteData
    ]);
    const isLoading = triggerInfinite ? swrInfiniteIsLoading : swrIsLoading;
    const isFetching = triggerInfinite ? swrInfiniteIsValidating : swrIsValidating;
    const isError = !!(triggerInfinite ? swrInfiniteError : swrError);
    const fetchNext = (0, (parcelRequire("3QbnI")).useCallback)(()=>{
        fetchPage((n)=>Math.max(0, n + 1));
    }, [
        fetchPage
    ]);
    const fetchPrevious = (0, (parcelRequire("3QbnI")).useCallback)(()=>{
        fetchPage((n)=>Math.max(0, n - 1));
    }, [
        fetchPage
    ]);
    const offsetCount = (initialPageRef.current - 1) * pageSizeRef.current;
    const pageCount = Math.ceil((count - offsetCount) / pageSizeRef.current);
    const hasNextPage = count - offsetCount * pageSizeRef.current > page * pageSizeRef.current;
    const hasPreviousPage = (page - 1) * pageSizeRef.current > offsetCount * pageSizeRef.current;
    const setData = triggerInfinite ? (value)=>swrInfiniteMutate(value, {
            revalidate: false
        }) : (value)=>swrMutate(value, {
            revalidate: false
        });
    const revalidate = triggerInfinite ? ()=>swrInfiniteMutate() : ()=>swrMutate();
    return {
        data: data,
        count: count,
        isLoading: isLoading,
        isFetching: isFetching,
        isError: isError,
        page: page,
        pageCount: pageCount,
        fetchPage: fetchPage,
        fetchNext: fetchNext,
        fetchPrevious: fetchPrevious,
        hasNextPage: hasNextPage,
        hasPreviousPage: hasPreviousPage,
        revalidate: // Let the hook return type define this type
        revalidate,
        setData: // Let the hook return type define this type
        setData
    };
};
// src/react/hooks/useOrganization.tsx
var $0438480e8c63a6c9$var$undefinedPaginatedResource = {
    data: void 0,
    count: void 0,
    isLoading: false,
    isFetching: false,
    isError: false,
    page: void 0,
    pageCount: void 0,
    fetchPage: void 0,
    fetchNext: void 0,
    fetchPrevious: void 0,
    hasNextPage: false,
    hasPreviousPage: false,
    revalidate: void 0,
    setData: void 0
};
var $0438480e8c63a6c9$var$useOrganization = (params)=>{
    const { invitationList: invitationListParams, membershipList: membershipListParams, domains: domainListParams, membershipRequests: membershipRequestsListParams, memberships: membersListParams, invitations: invitationsListParams } = params || {};
    const { organization: organization, lastOrganizationMember: lastOrganizationMember, lastOrganizationInvitation: lastOrganizationInvitation } = $0438480e8c63a6c9$var$useOrganizationContext();
    const session = $0438480e8c63a6c9$var$useSessionContext();
    const domainSafeValues = $0438480e8c63a6c9$var$useWithSafeValues(domainListParams, {
        initialPage: 1,
        pageSize: 10,
        keepPreviousData: false,
        infinite: false,
        enrollmentMode: void 0
    });
    const membershipRequestSafeValues = $0438480e8c63a6c9$var$useWithSafeValues(membershipRequestsListParams, {
        initialPage: 1,
        pageSize: 10,
        status: "pending",
        keepPreviousData: false,
        infinite: false
    });
    const membersSafeValues = $0438480e8c63a6c9$var$useWithSafeValues(membersListParams, {
        initialPage: 1,
        pageSize: 10,
        role: void 0,
        keepPreviousData: false,
        infinite: false
    });
    const invitationsSafeValues = $0438480e8c63a6c9$var$useWithSafeValues(invitationsListParams, {
        initialPage: 1,
        pageSize: 10,
        status: [
            "pending"
        ],
        keepPreviousData: false,
        infinite: false
    });
    const clerk = $0438480e8c63a6c9$var$useClerkInstanceContext();
    const shouldFetch = !!(clerk.loaded && session && organization);
    const domainParams = typeof domainListParams === "undefined" ? void 0 : {
        initialPage: domainSafeValues.initialPage,
        pageSize: domainSafeValues.pageSize,
        enrollmentMode: domainSafeValues.enrollmentMode
    };
    const membershipRequestParams = typeof membershipRequestsListParams === "undefined" ? void 0 : {
        initialPage: membershipRequestSafeValues.initialPage,
        pageSize: membershipRequestSafeValues.pageSize,
        status: membershipRequestSafeValues.status
    };
    const membersParams = typeof membersListParams === "undefined" ? void 0 : {
        initialPage: membersSafeValues.initialPage,
        pageSize: membersSafeValues.pageSize,
        role: membersSafeValues.role
    };
    const invitationsParams = typeof invitationsListParams === "undefined" ? void 0 : {
        initialPage: invitationsSafeValues.initialPage,
        pageSize: invitationsSafeValues.pageSize,
        status: invitationsSafeValues.status
    };
    const domains = $0438480e8c63a6c9$var$usePagesOrInfinite({
        ...domainParams
    }, organization == null ? void 0 : organization.getDomains, {
        keepPreviousData: domainSafeValues.keepPreviousData,
        infinite: domainSafeValues.infinite,
        enabled: !!domainParams
    }, {
        type: "domains",
        organizationId: organization == null ? void 0 : organization.id
    });
    const membershipRequests = $0438480e8c63a6c9$var$usePagesOrInfinite({
        ...membershipRequestParams
    }, organization == null ? void 0 : organization.getMembershipRequests, {
        keepPreviousData: membershipRequestSafeValues.keepPreviousData,
        infinite: membershipRequestSafeValues.infinite,
        enabled: !!membershipRequestParams
    }, {
        type: "membershipRequests",
        organizationId: organization == null ? void 0 : organization.id
    });
    const memberships = $0438480e8c63a6c9$var$usePagesOrInfinite({
        ...membersParams,
        paginated: true
    }, organization == null ? void 0 : organization.getMemberships, {
        keepPreviousData: membersSafeValues.keepPreviousData,
        infinite: membersSafeValues.infinite,
        enabled: !!membersParams
    }, {
        type: "members",
        organizationId: organization == null ? void 0 : organization.id
    });
    const invitations = $0438480e8c63a6c9$var$usePagesOrInfinite({
        ...invitationsParams
    }, organization == null ? void 0 : organization.getInvitations, {
        keepPreviousData: invitationsSafeValues.keepPreviousData,
        infinite: invitationsSafeValues.infinite,
        enabled: !!invitationsParams
    }, {
        type: "invitations",
        organizationId: organization == null ? void 0 : organization.id
    });
    const pendingInvitations = !clerk.loaded ? ()=>[] : ()=>{
        var _a;
        return (_a = clerk.organization) == null ? void 0 : _a.getPendingInvitations(invitationListParams);
    };
    const currentOrganizationMemberships = !clerk.loaded ? ()=>[] : ()=>{
        var _a;
        return (_a = clerk.organization) == null ? void 0 : _a.getMemberships(membershipListParams);
    };
    if (invitationListParams) $0438480e8c63a6c9$var$deprecated("invitationList in useOrganization", "Use the `invitations` property and return value instead.");
    const { data: invitationList, isValidating: isInvitationsLoading, mutate: mutateInvitationList } = (0, $0438480e8c63a6c9$var$import_swr.default)(shouldFetch && invitationListParams ? $0438480e8c63a6c9$var$cacheKey("invites", organization, lastOrganizationInvitation, invitationListParams) : null, pendingInvitations);
    if (membershipListParams) $0438480e8c63a6c9$var$deprecated("membershipList in useOrganization", "Use the `memberships` property and return value instead.");
    const { data: membershipList, isValidating: isMembershipsLoading, mutate: mutateMembershipList } = (0, $0438480e8c63a6c9$var$import_swr.default)(shouldFetch && membershipListParams ? $0438480e8c63a6c9$var$cacheKey("memberships", organization, lastOrganizationMember, membershipListParams) : null, currentOrganizationMemberships);
    if (organization === void 0) return {
        isLoaded: false,
        organization: void 0,
        invitationList: void 0,
        membershipList: void 0,
        membership: void 0,
        domains: $0438480e8c63a6c9$var$undefinedPaginatedResource,
        membershipRequests: $0438480e8c63a6c9$var$undefinedPaginatedResource,
        memberships: $0438480e8c63a6c9$var$undefinedPaginatedResource,
        invitations: $0438480e8c63a6c9$var$undefinedPaginatedResource
    };
    if (organization === null) return {
        isLoaded: true,
        organization: null,
        invitationList: null,
        membershipList: null,
        membership: null,
        domains: null,
        membershipRequests: null,
        memberships: null,
        invitations: null
    };
    if (!clerk.loaded && organization) return {
        isLoaded: true,
        organization: organization,
        invitationList: void 0,
        membershipList: void 0,
        membership: void 0,
        domains: $0438480e8c63a6c9$var$undefinedPaginatedResource,
        membershipRequests: $0438480e8c63a6c9$var$undefinedPaginatedResource,
        memberships: $0438480e8c63a6c9$var$undefinedPaginatedResource,
        invitations: $0438480e8c63a6c9$var$undefinedPaginatedResource
    };
    return {
        isLoaded: !isMembershipsLoading && !isInvitationsLoading,
        organization: organization,
        membershipList: membershipList,
        membership: $0438480e8c63a6c9$var$getCurrentOrganizationMembership(session.user.organizationMemberships, organization.id),
        invitationList: // your membership in the current org
        invitationList,
        unstable__mutate: ()=>{
            mutateMembershipList();
            mutateInvitationList();
        },
        domains: domains,
        membershipRequests: membershipRequests,
        memberships: memberships,
        invitations: invitations
    };
};
function $0438480e8c63a6c9$var$getCurrentOrganizationMembership(organizationMemberships, activeOrganizationId) {
    return organizationMemberships.find((organizationMembership)=>organizationMembership.organization.id === activeOrganizationId);
}
function $0438480e8c63a6c9$var$cacheKey(type, organization, resource, pagination) {
    return [
        type,
        organization.id,
        resource == null ? void 0 : resource.id,
        resource == null ? void 0 : resource.updatedAt,
        pagination.offset,
        pagination.limit
    ].filter(Boolean).join("-");
}
// src/react/hooks/useOrganizationList.tsx
var $0438480e8c63a6c9$var$undefinedPaginatedResource2 = {
    data: void 0,
    count: void 0,
    isLoading: false,
    isFetching: false,
    isError: false,
    page: void 0,
    pageCount: void 0,
    fetchPage: void 0,
    fetchNext: void 0,
    fetchPrevious: void 0,
    hasNextPage: false,
    hasPreviousPage: false,
    revalidate: void 0,
    setData: void 0
};
var $0438480e8c63a6c9$var$useOrganizationList = (params)=>{
    const { userMemberships: userMemberships, userInvitations: userInvitations, userSuggestions: userSuggestions } = params || {};
    const userMembershipsSafeValues = $0438480e8c63a6c9$var$useWithSafeValues(userMemberships, {
        initialPage: 1,
        pageSize: 10,
        keepPreviousData: false,
        infinite: false
    });
    const userInvitationsSafeValues = $0438480e8c63a6c9$var$useWithSafeValues(userInvitations, {
        initialPage: 1,
        pageSize: 10,
        status: "pending",
        keepPreviousData: false,
        infinite: false
    });
    const userSuggestionsSafeValues = $0438480e8c63a6c9$var$useWithSafeValues(userSuggestions, {
        initialPage: 1,
        pageSize: 10,
        status: "pending",
        keepPreviousData: false,
        infinite: false
    });
    const clerk = $0438480e8c63a6c9$var$useClerkInstanceContext();
    const user = $0438480e8c63a6c9$var$useUserContext();
    const userMembershipsParams = typeof userMemberships === "undefined" ? void 0 : {
        initialPage: userMembershipsSafeValues.initialPage,
        pageSize: userMembershipsSafeValues.pageSize
    };
    const userInvitationsParams = typeof userInvitations === "undefined" ? void 0 : {
        initialPage: userInvitationsSafeValues.initialPage,
        pageSize: userInvitationsSafeValues.pageSize,
        status: userInvitationsSafeValues.status
    };
    const userSuggestionsParams = typeof userSuggestions === "undefined" ? void 0 : {
        initialPage: userSuggestionsSafeValues.initialPage,
        pageSize: userSuggestionsSafeValues.pageSize,
        status: userSuggestionsSafeValues.status
    };
    const isClerkLoaded = !!(clerk.loaded && user);
    const memberships = $0438480e8c63a6c9$var$usePagesOrInfinite({
        ...userMembershipsParams,
        paginated: true
    }, user == null ? void 0 : user.getOrganizationMemberships, {
        keepPreviousData: userMembershipsSafeValues.keepPreviousData,
        infinite: userMembershipsSafeValues.infinite,
        enabled: !!userMembershipsParams
    }, {
        type: "userMemberships",
        userId: user == null ? void 0 : user.id
    });
    const invitations = $0438480e8c63a6c9$var$usePagesOrInfinite({
        ...userInvitationsParams
    }, user == null ? void 0 : user.getOrganizationInvitations, {
        keepPreviousData: userInvitationsSafeValues.keepPreviousData,
        infinite: userInvitationsSafeValues.infinite,
        enabled: !!userInvitationsParams
    }, {
        type: "userInvitations",
        userId: user == null ? void 0 : user.id
    });
    const suggestions = $0438480e8c63a6c9$var$usePagesOrInfinite({
        ...userSuggestionsParams
    }, user == null ? void 0 : user.getOrganizationSuggestions, {
        keepPreviousData: userSuggestionsSafeValues.keepPreviousData,
        infinite: userSuggestionsSafeValues.infinite,
        enabled: !!userSuggestionsParams
    }, {
        type: "userSuggestions",
        userId: user == null ? void 0 : user.id
    });
    if (!isClerkLoaded) return {
        isLoaded: false,
        organizationList: void 0,
        createOrganization: void 0,
        setActive: void 0,
        userMemberships: $0438480e8c63a6c9$var$undefinedPaginatedResource2,
        userInvitations: $0438480e8c63a6c9$var$undefinedPaginatedResource2,
        userSuggestions: $0438480e8c63a6c9$var$undefinedPaginatedResource2
    };
    const result = {
        isLoaded: isClerkLoaded,
        organizationList: $0438480e8c63a6c9$var$createOrganizationList(user.organizationMemberships),
        setActive: clerk.setActive,
        createOrganization: clerk.createOrganization,
        userMemberships: memberships,
        userInvitations: invitations,
        userSuggestions: suggestions
    };
    $0438480e8c63a6c9$var$deprecatedObjectProperty(result, "organizationList", "Use `userMemberships` instead.");
    return result;
};
function $0438480e8c63a6c9$var$createOrganizationList(organizationMemberships) {
    return organizationMemberships.map((organizationMembership)=>({
            membership: organizationMembership,
            organization: organizationMembership.organization
        }));
}
// src/react/hooks/useOrganizations.tsx
var $0438480e8c63a6c9$var$useOrganizations = ()=>{
    $0438480e8c63a6c9$var$deprecated("useOrganizations", "Use useOrganizationList, useOrganization, or useClerk instead.");
    const clerk = $0438480e8c63a6c9$var$useClerkInstanceContext();
    if (!clerk.loaded) return {
        isLoaded: false,
        createOrganization: void 0,
        getOrganizationMemberships: void 0,
        getOrganization: void 0
    };
    return {
        isLoaded: true,
        createOrganization: clerk.createOrganization,
        getOrganizationMemberships: clerk.getOrganizationMemberships,
        getOrganization: clerk.getOrganization
    };
};

// src/react/hooks/useSafeLayoutEffect.tsx
var $0438480e8c63a6c9$var$import_react4 = $0438480e8c63a6c9$var$__toESM((parcelRequire("3QbnI")));
var $0438480e8c63a6c9$var$useSafeLayoutEffect = typeof window !== "undefined" ? $0438480e8c63a6c9$var$import_react4.default.useLayoutEffect : $0438480e8c63a6c9$var$import_react4.default.useEffect;


const [$ecdd5581cf25c630$export$a0fd8390cfe8ae69, $ecdd5581cf25c630$export$e4d75cf033246c9e] = (0, $0438480e8c63a6c9$exports.createContextAndHook)("AuthContext");





const [$36c8e061ab629a28$export$ff24f536305ffdef, $36c8e061ab629a28$export$a2eb674f57f684aa] = [
    (0, $0438480e8c63a6c9$exports.ClerkInstanceContext),
    (0, $0438480e8c63a6c9$exports.useClerkInstanceContext)
];





function $a22c7f313b5d5eb6$export$f1c73fe776894c09(props) {
    const { isomorphicClerkOptions: isomorphicClerkOptions, initialState: initialState, children: children } = props;
    const { isomorphicClerk: clerk, loaded: clerkLoaded } = $a22c7f313b5d5eb6$var$useLoadedIsomorphicClerk(isomorphicClerkOptions);
    if (isomorphicClerkOptions.frontendApi) (0, $98eb031f10fd6d90$exports.deprecated)("frontendApi", "Use `publishableKey` instead.");
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useState({
        client: clerk.client,
        session: clerk.session,
        user: clerk.user,
        organization: clerk.organization,
        lastOrganizationInvitation: null,
        lastOrganizationMember: null
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useEffect(()=>{
        return clerk.addListener((e)=>setState({
                ...e
            }));
    }, []);
    const derivedState = (0, $b57c7050ed0698b8$export$485fc5c1dea91f96)(clerkLoaded, state, initialState);
    const clerkCtx = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useMemo(()=>({
            value: clerk
        }), [
        clerkLoaded
    ]);
    const clientCtx = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useMemo(()=>({
            value: state.client
        }), [
        state.client
    ]);
    const { sessionId: sessionId, session: session, userId: userId, user: user, orgId: orgId, actor: actor, lastOrganizationInvitation: lastOrganizationInvitation, lastOrganizationMember: lastOrganizationMember, organization: organization, orgRole: orgRole, orgSlug: orgSlug, orgPermissions: orgPermissions } = derivedState;
    const authCtx = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useMemo(()=>{
        const value = {
            sessionId: sessionId,
            userId: userId,
            actor: actor,
            orgId: orgId,
            orgRole: orgRole,
            orgSlug: orgSlug,
            orgPermissions: orgPermissions
        };
        return {
            value: value
        };
    }, [
        sessionId,
        userId,
        actor,
        orgId,
        orgRole,
        orgSlug
    ]);
    const userCtx = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useMemo(()=>({
            value: user
        }), [
        userId,
        user
    ]);
    const sessionCtx = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useMemo(()=>({
            value: session
        }), [
        sessionId,
        session
    ]);
    const organizationCtx = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useMemo(()=>{
        const value = {
            organization: organization,
            lastOrganizationInvitation: lastOrganizationInvitation,
            lastOrganizationMember: lastOrganizationMember
        };
        return {
            value: value
        };
    }, [
        orgId,
        organization,
        lastOrganizationInvitation,
        lastOrganizationMember
    ]);
    return(// @ts-expect-error value passed is of type IsomorphicClerk where the context expects LoadedClerk
    /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $36c8e061ab629a28$export$ff24f536305ffdef).Provider, {
        value: clerkCtx
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $0438480e8c63a6c9$exports.ClientContext).Provider, {
        value: clientCtx
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $0438480e8c63a6c9$exports.SessionContext).Provider, {
        value: sessionCtx
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $0438480e8c63a6c9$exports.OrganizationProvider), {
        ...organizationCtx.value
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $ecdd5581cf25c630$export$a0fd8390cfe8ae69).Provider, {
        value: authCtx
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $0438480e8c63a6c9$exports.UserContext).Provider, {
        value: userCtx
    }, children)))))));
}
const $a22c7f313b5d5eb6$var$useLoadedIsomorphicClerk = (options)=>{
    const [loaded, setLoaded] = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useState(false);
    const isomorphicClerk = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useMemo(()=>(0, $0e8cb273adfe7abd$export$2e2bcd8739ae039).getOrCreateInstance(options), []);
    (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useEffect(()=>{
        isomorphicClerk.__unstable__updateProps({
            appearance: options.appearance
        });
    }, [
        options.appearance
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useEffect(()=>{
        isomorphicClerk.__unstable__updateProps({
            options: options
        });
    }, [
        options.localization
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useEffect(()=>{
        isomorphicClerk.addOnLoaded(()=>setLoaded(true));
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useEffect(()=>{
        return ()=>{
            (0, $0e8cb273adfe7abd$export$2e2bcd8739ae039).clearInstance();
        };
    }, []);
    return {
        isomorphicClerk: isomorphicClerk,
        loaded: loaded
    };
};




var $3QbnI = parcelRequire("3QbnI");


function $b592d302c090ebba$export$37d634e26bd4780e(contextVal) {
    if (!contextVal) throw new Error((0, $5af9131399f28559$export$4305f0bba9b5496a));
}
function $b592d302c090ebba$export$ee812e31908ebd0c(guarantee, hookName) {
    if (!guarantee) throw new Error((0, $5af9131399f28559$export$8cbe2906da0f4347)(hookName));
}


const $d1c4730d70895ea8$export$982eb220e9756acf = Object.freeze({
    noGuarantees: Object.freeze({
        guaranteedLoaded: false
    }),
    guaranteedLoaded: Object.freeze({
        guaranteedLoaded: true
    })
});
const $d1c4730d70895ea8$export$e887e9d4c102a3d3 = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createContext(void 0);
$d1c4730d70895ea8$export$e887e9d4c102a3d3.displayName = "StructureContext";
const $d1c4730d70895ea8$var$useStructureContext = ()=>{
    const structureCtx = (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).useContext($d1c4730d70895ea8$export$e887e9d4c102a3d3);
    (0, $b592d302c090ebba$export$37d634e26bd4780e)(structureCtx);
    return structureCtx;
};
const $d1c4730d70895ea8$export$7a12ccc32321c583 = ({ children: children })=>{
    const structure = $d1c4730d70895ea8$var$useStructureContext();
    if (structure.guaranteedLoaded) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Fragment, null, children);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($d1c4730d70895ea8$export$e887e9d4c102a3d3.Provider, {
        value: $d1c4730d70895ea8$export$982eb220e9756acf.guaranteedLoaded
    }, children);
};


(0, $4b1975c39f3b1069$export$c22e1bc86384a064)({
    packageName: "@clerk/clerk-react"
});
function $80fa3740fa1bfa8c$var$ClerkProviderBase(props) {
    const { initialState: initialState, children: children, ...restIsomorphicClerkOptions } = props;
    const { frontendApi: frontendApi = "", publishableKey: publishableKey = "", Clerk: userInitialisedClerk } = restIsomorphicClerkOptions;
    if (!userInitialisedClerk) {
        if (!publishableKey && !frontendApi) (0, $4b1975c39f3b1069$export$56721dd9fbd2a9c9).throwMissingPublishableKeyError();
        else if (publishableKey && !(0, $d0890e2d533e0714$exports.isPublishableKey)(publishableKey)) (0, $4b1975c39f3b1069$export$56721dd9fbd2a9c9).throwInvalidPublishableKeyError({
            key: publishableKey
        });
        else if (!publishableKey && frontendApi && !(0, $d0890e2d533e0714$exports.isLegacyFrontendApiKey)(frontendApi)) (0, $4b1975c39f3b1069$export$56721dd9fbd2a9c9).throwInvalidFrontendApiError({
            key: frontendApi
        });
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $d1c4730d70895ea8$export$e887e9d4c102a3d3).Provider, {
        value: (0, $d1c4730d70895ea8$export$982eb220e9756acf).noGuarantees
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $a22c7f313b5d5eb6$export$f1c73fe776894c09), {
        initialState: initialState,
        isomorphicClerkOptions: restIsomorphicClerkOptions
    }, children));
}
const $80fa3740fa1bfa8c$export$9d21b78f14bcb891 = (0, $e3bf4ed8f919311d$export$99c5d48145a0499f)($80fa3740fa1bfa8c$var$ClerkProviderBase, "ClerkProvider", (0, $5af9131399f28559$export$2e70edf3ca74a247));
$80fa3740fa1bfa8c$export$9d21b78f14bcb891.displayName = "ClerkProvider";





var $3QbnI = parcelRequire("3QbnI");




const $bb4ba828b144b76e$var$clerkLoaded = (isomorphicClerk)=>{
    return new Promise((resolve)=>{
        if (isomorphicClerk.loaded) resolve();
        isomorphicClerk.addOnLoaded(resolve);
    });
};
const $bb4ba828b144b76e$export$665ac630e9bb9534 = (isomorphicClerk)=>{
    return async (options)=>{
        await $bb4ba828b144b76e$var$clerkLoaded(isomorphicClerk);
        if (!isomorphicClerk.session) return null;
        return isomorphicClerk.session.getToken(options);
    };
};
const $bb4ba828b144b76e$export$abfa491ff9c469cf = (isomorphicClerk)=>{
    return async (...args)=>{
        await $bb4ba828b144b76e$var$clerkLoaded(isomorphicClerk);
        return isomorphicClerk.signOut(...args);
    };
};


const $ada25319dc58517a$export$1d39dc5b47e56ff0 = ()=>{
    const { sessionId: sessionId, userId: userId, actor: actor, orgId: orgId, orgRole: orgRole, orgSlug: orgSlug, orgPermissions: orgPermissions } = (0, $ecdd5581cf25c630$export$e4d75cf033246c9e)();
    const isomorphicClerk = (0, $36c8e061ab629a28$export$a2eb674f57f684aa)();
    const getToken = (0, $3QbnI.useCallback)((0, $bb4ba828b144b76e$export$665ac630e9bb9534)(isomorphicClerk), [
        isomorphicClerk
    ]);
    const signOut = (0, $3QbnI.useCallback)((0, $bb4ba828b144b76e$export$abfa491ff9c469cf)(isomorphicClerk), [
        isomorphicClerk
    ]);
    const has = (0, $3QbnI.useCallback)((params)=>{
        if (!(params == null ? void 0 : params.permission) && !(params == null ? void 0 : params.role)) throw new Error((0, $5af9131399f28559$export$2ddb8bcf9d26499c));
        if (!orgId || !userId || !orgRole || !orgPermissions) return false;
        if (params.permission) return orgPermissions.includes(params.permission);
        if (params.role) return orgRole === params.role;
        return false;
    }, [
        orgId,
        orgRole,
        userId,
        orgPermissions
    ]);
    if (sessionId === void 0 && userId === void 0) return {
        isLoaded: false,
        isSignedIn: void 0,
        sessionId: sessionId,
        userId: userId,
        actor: void 0,
        orgId: void 0,
        orgRole: void 0,
        orgSlug: void 0,
        has: void 0,
        signOut: signOut,
        getToken: getToken
    };
    if (sessionId === null && userId === null) return {
        isLoaded: true,
        isSignedIn: false,
        sessionId: sessionId,
        userId: userId,
        actor: null,
        orgId: null,
        orgRole: null,
        orgSlug: null,
        has: ()=>false,
        signOut: signOut,
        getToken: getToken
    };
    if (!!sessionId && !!userId && !!orgId && !!orgRole) return {
        isLoaded: true,
        isSignedIn: true,
        sessionId: sessionId,
        userId: userId,
        actor: actor || null,
        orgId: orgId,
        orgRole: orgRole,
        orgSlug: orgSlug || null,
        has: has,
        signOut: signOut,
        getToken: getToken
    };
    if (!!sessionId && !!userId && !orgId) return {
        isLoaded: true,
        isSignedIn: true,
        sessionId: sessionId,
        userId: userId,
        actor: actor || null,
        orgId: null,
        orgRole: null,
        orgSlug: null,
        has: ()=>false,
        signOut: signOut,
        getToken: getToken
    };
    throw new Error((0, $5af9131399f28559$export$f8917dcad71775b3));
};




const $fdf8b244281e92e7$export$23b74bf0884fc372 = ()=>{
    const isomorphicClerk = (0, $36c8e061ab629a28$export$a2eb674f57f684aa)();
    const client = (0, $0438480e8c63a6c9$exports.useClientContext)();
    if (!client) return {
        isLoaded: false,
        signIn: void 0,
        setSession: void 0,
        setActive: void 0
    };
    return {
        isLoaded: true,
        signIn: client.signIn,
        setSession: isomorphicClerk.setSession,
        setActive: isomorphicClerk.setActive
    };
};




const $c42a753ff181698a$export$c15557d6465f6121 = ()=>{
    const isomorphicClerk = (0, $36c8e061ab629a28$export$a2eb674f57f684aa)();
    const client = (0, $0438480e8c63a6c9$exports.useClientContext)();
    if (!client) return {
        isLoaded: false,
        signUp: void 0,
        setSession: void 0,
        setActive: void 0
    };
    return {
        isLoaded: true,
        signUp: client.signUp,
        setSession: isomorphicClerk.setSession,
        setActive: isomorphicClerk.setActive
    };
};



function $23b3856353385633$export$23bbbc4533528f03() {
    const user = (0, $0438480e8c63a6c9$exports.useUserContext)();
    if (user === void 0) return {
        isLoaded: false,
        isSignedIn: void 0,
        user: void 0
    };
    if (user === null) return {
        isLoaded: true,
        isSignedIn: false,
        user: null
    };
    return {
        isLoaded: true,
        isSignedIn: true,
        user: user
    };
}









/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $54X9E = parcelRequire("54X9E");
const $4556d6db4eb60619$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $4556d6db4eb60619$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $4556d6db4eb60619$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $4556d6db4eb60619$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $4556d6db4eb60619$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4556d6db4eb60619$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $4556d6db4eb60619$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $4556d6db4eb60619$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($4556d6db4eb60619$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $4556d6db4eb60619$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $4556d6db4eb60619$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $4556d6db4eb60619$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $4556d6db4eb60619$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $4556d6db4eb60619$var$stringToByteArray$1(str);
    return $4556d6db4eb60619$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $4556d6db4eb60619$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $4556d6db4eb60619$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $4556d6db4eb60619$export$c62426fdd000a97e = function(str) {
    try {
        return $4556d6db4eb60619$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $4556d6db4eb60619$export$6c40052bed430212(value) {
    return $4556d6db4eb60619$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $4556d6db4eb60619$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$4556d6db4eb60619$var$isValidKey(prop)) continue;
        target[prop] = $4556d6db4eb60619$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $4556d6db4eb60619$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $4556d6db4eb60619$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4556d6db4eb60619$var$getDefaultsFromGlobal = ()=>$4556d6db4eb60619$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $4556d6db4eb60619$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $54X9E === "undefined" || typeof $54X9E.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $4556d6db4eb60619$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $4556d6db4eb60619$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $4556d6db4eb60619$export$212bb2fc580a90a8 = ()=>{
    try {
        return $4556d6db4eb60619$var$getDefaultsFromGlobal() || $4556d6db4eb60619$var$getDefaultsFromEnvVariable() || $4556d6db4eb60619$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $4556d6db4eb60619$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $4556d6db4eb60619$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $4556d6db4eb60619$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $4556d6db4eb60619$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $4556d6db4eb60619$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $4556d6db4eb60619$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $4556d6db4eb60619$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $4556d6db4eb60619$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $4556d6db4eb60619$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4556d6db4eb60619$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $4556d6db4eb60619$export$4b5284a3025a455(JSON.stringify(header)),
        $4556d6db4eb60619$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $4556d6db4eb60619$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $4556d6db4eb60619$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($4556d6db4eb60619$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $4556d6db4eb60619$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $4556d6db4eb60619$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $4556d6db4eb60619$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $4556d6db4eb60619$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $4556d6db4eb60619$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $4556d6db4eb60619$export$f2f6a8999f8ebd30() {
    return $4556d6db4eb60619$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $4556d6db4eb60619$export$7e7b1a9668aaed8() {
    const ua = $4556d6db4eb60619$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $4556d6db4eb60619$export$202944b2d2824246() {
    return $4556d6db4eb60619$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $4556d6db4eb60619$export$5d1d834fbbf8bab7() {
    return $4556d6db4eb60619$export$588c7fdda06fbb0a.NODE_CLIENT === true || $4556d6db4eb60619$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $4556d6db4eb60619$export$95df08bae54cb4df() {
    return !$4556d6db4eb60619$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $4556d6db4eb60619$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $4556d6db4eb60619$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $4556d6db4eb60619$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $4556d6db4eb60619$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $4556d6db4eb60619$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $4556d6db4eb60619$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $4556d6db4eb60619$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $4556d6db4eb60619$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $4556d6db4eb60619$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $4556d6db4eb60619$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $4556d6db4eb60619$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $4556d6db4eb60619$var$replaceTemplate(template, data) {
    return template.replace($4556d6db4eb60619$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $4556d6db4eb60619$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $4556d6db4eb60619$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $4556d6db4eb60619$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4556d6db4eb60619$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $4556d6db4eb60619$export$c5a53ce6a17cf18d($4556d6db4eb60619$export$c62426fdd000a97e(parts[0]) || "");
        claims = $4556d6db4eb60619$export$c5a53ce6a17cf18d($4556d6db4eb60619$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4556d6db4eb60619$export$5f870fcca7ae6a88 = function(token) {
    const claims = $4556d6db4eb60619$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4556d6db4eb60619$export$701c661ec91095f2 = function(token) {
    const claims = $4556d6db4eb60619$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4556d6db4eb60619$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $4556d6db4eb60619$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4556d6db4eb60619$export$fc970ed23da99565 = function(token) {
    const claims = $4556d6db4eb60619$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4556d6db4eb60619$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $4556d6db4eb60619$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $4556d6db4eb60619$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $4556d6db4eb60619$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $4556d6db4eb60619$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($4556d6db4eb60619$var$isObject(aProp) && $4556d6db4eb60619$var$isObject(bProp)) {
            if (!$4556d6db4eb60619$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $4556d6db4eb60619$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $4556d6db4eb60619$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $4556d6db4eb60619$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $4556d6db4eb60619$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $4556d6db4eb60619$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $4556d6db4eb60619$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $4556d6db4eb60619$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $4556d6db4eb60619$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $4556d6db4eb60619$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $4556d6db4eb60619$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($4556d6db4eb60619$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $4556d6db4eb60619$var$noop;
        if (observer.error === undefined) observer.error = $4556d6db4eb60619$var$noop;
        if (observer.complete === undefined) observer.complete = $4556d6db4eb60619$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $4556d6db4eb60619$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $4556d6db4eb60619$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $4556d6db4eb60619$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $4556d6db4eb60619$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $4556d6db4eb60619$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $4556d6db4eb60619$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($4556d6db4eb60619$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $4556d6db4eb60619$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($4556d6db4eb60619$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $4556d6db4eb60619$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($4556d6db4eb60619$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $4556d6db4eb60619$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $4556d6db4eb60619$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $4556d6db4eb60619$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $4556d6db4eb60619$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $4556d6db4eb60619$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $4556d6db4eb60619$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $4556d6db4eb60619$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $4556d6db4eb60619$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $4556d6db4eb60619$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $4556d6db4eb60619$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $4556d6db4eb60619$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $4556d6db4eb60619$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($4556d6db4eb60619$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $4556d6db4eb60619$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $4556d6db4eb60619$var$indicator(i);
}
function $4556d6db4eb60619$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4556d6db4eb60619$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}



/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $6d116dc7a5092865$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6d116dc7a5092865$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $6d116dc7a5092865$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $4556d6db4eb60619$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($6d116dc7a5092865$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $6d116dc7a5092865$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $6d116dc7a5092865$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $6d116dc7a5092865$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $6d116dc7a5092865$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $6d116dc7a5092865$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $6d116dc7a5092865$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $6d116dc7a5092865$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $6d116dc7a5092865$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $6d116dc7a5092865$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $6d116dc7a5092865$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $6d116dc7a5092865$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $6d116dc7a5092865$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $e8c0e15d964c1f41$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $e8c0e15d964c1f41$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($e8c0e15d964c1f41$export$243e62d78d3b544d || ($e8c0e15d964c1f41$export$243e62d78d3b544d = {}));
const $e8c0e15d964c1f41$var$levelStringToEnum = {
    "debug": $e8c0e15d964c1f41$export$243e62d78d3b544d.DEBUG,
    "verbose": $e8c0e15d964c1f41$export$243e62d78d3b544d.VERBOSE,
    "info": $e8c0e15d964c1f41$export$243e62d78d3b544d.INFO,
    "warn": $e8c0e15d964c1f41$export$243e62d78d3b544d.WARN,
    "error": $e8c0e15d964c1f41$export$243e62d78d3b544d.ERROR,
    "silent": $e8c0e15d964c1f41$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $e8c0e15d964c1f41$var$defaultLogLevel = $e8c0e15d964c1f41$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $e8c0e15d964c1f41$var$ConsoleMethod = {
    [$e8c0e15d964c1f41$export$243e62d78d3b544d.DEBUG]: "log",
    [$e8c0e15d964c1f41$export$243e62d78d3b544d.VERBOSE]: "log",
    [$e8c0e15d964c1f41$export$243e62d78d3b544d.INFO]: "info",
    [$e8c0e15d964c1f41$export$243e62d78d3b544d.WARN]: "warn",
    [$e8c0e15d964c1f41$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $e8c0e15d964c1f41$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $e8c0e15d964c1f41$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $e8c0e15d964c1f41$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $e8c0e15d964c1f41$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $e8c0e15d964c1f41$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $e8c0e15d964c1f41$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $e8c0e15d964c1f41$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $e8c0e15d964c1f41$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $e8c0e15d964c1f41$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $e8c0e15d964c1f41$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $e8c0e15d964c1f41$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $e8c0e15d964c1f41$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $e8c0e15d964c1f41$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $e8c0e15d964c1f41$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $e8c0e15d964c1f41$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $e8c0e15d964c1f41$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $e8c0e15d964c1f41$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $e8c0e15d964c1f41$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $e8c0e15d964c1f41$export$c622e99c0ce7b1c9(level) {
    $e8c0e15d964c1f41$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $e8c0e15d964c1f41$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $e8c0e15d964c1f41$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $e8c0e15d964c1f41$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $e8c0e15d964c1f41$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $29a216a49cb08505$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $29a216a49cb08505$var$idbProxyableTypes;
let $29a216a49cb08505$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $29a216a49cb08505$var$getIdbProxyableTypes() {
    return $29a216a49cb08505$var$idbProxyableTypes || ($29a216a49cb08505$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $29a216a49cb08505$var$getCursorAdvanceMethods() {
    return $29a216a49cb08505$var$cursorAdvanceMethods || ($29a216a49cb08505$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $29a216a49cb08505$var$cursorRequestMap = new WeakMap();
const $29a216a49cb08505$var$transactionDoneMap = new WeakMap();
const $29a216a49cb08505$var$transactionStoreNamesMap = new WeakMap();
const $29a216a49cb08505$var$transformCache = new WeakMap();
const $29a216a49cb08505$export$407448d2b89b1813 = new WeakMap();
function $29a216a49cb08505$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($29a216a49cb08505$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $29a216a49cb08505$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $29a216a49cb08505$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $29a216a49cb08505$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($29a216a49cb08505$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $29a216a49cb08505$var$transactionDoneMap.set(tx, done);
}
let $29a216a49cb08505$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $29a216a49cb08505$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $29a216a49cb08505$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $29a216a49cb08505$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $29a216a49cb08505$export$43caf9889c228507(callback) {
    $29a216a49cb08505$var$idbProxyTraps = callback($29a216a49cb08505$var$idbProxyTraps);
}
function $29a216a49cb08505$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($29a216a49cb08505$export$3b14a55fb2447963(this), storeNames, ...args);
        $29a216a49cb08505$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $29a216a49cb08505$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($29a216a49cb08505$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($29a216a49cb08505$export$3b14a55fb2447963(this), args);
        return $29a216a49cb08505$export$efccba1c4a2ef57b($29a216a49cb08505$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $29a216a49cb08505$export$efccba1c4a2ef57b(func.apply($29a216a49cb08505$export$3b14a55fb2447963(this), args));
    };
}
function $29a216a49cb08505$var$transformCachableValue(value) {
    if (typeof value === "function") return $29a216a49cb08505$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $29a216a49cb08505$var$cacheDonePromiseForTransaction(value);
    if ($29a216a49cb08505$export$23f2a1d2818174ef(value, $29a216a49cb08505$var$getIdbProxyableTypes())) return new Proxy(value, $29a216a49cb08505$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $29a216a49cb08505$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $29a216a49cb08505$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($29a216a49cb08505$var$transformCache.has(value)) return $29a216a49cb08505$var$transformCache.get(value);
    const newValue = $29a216a49cb08505$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $29a216a49cb08505$var$transformCache.set(value, newValue);
        $29a216a49cb08505$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $29a216a49cb08505$export$3b14a55fb2447963 = (value)=>$29a216a49cb08505$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $5689be0d93d8c1c1$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $29a216a49cb08505$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $29a216a49cb08505$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $29a216a49cb08505$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $5689be0d93d8c1c1$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $29a216a49cb08505$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $5689be0d93d8c1c1$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $5689be0d93d8c1c1$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $5689be0d93d8c1c1$var$cachedMethods = new Map();
function $5689be0d93d8c1c1$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($5689be0d93d8c1c1$var$cachedMethods.get(prop)) return $5689be0d93d8c1c1$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $5689be0d93d8c1c1$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $5689be0d93d8c1c1$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $5689be0d93d8c1c1$var$cachedMethods.set(prop, method);
    return method;
}
(0, $29a216a49cb08505$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$5689be0d93d8c1c1$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$5689be0d93d8c1c1$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8131ce578968fe17$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($8131ce578968fe17$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $8131ce578968fe17$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $8131ce578968fe17$var$name$o = "@firebase/app";
const $8131ce578968fe17$var$version$1 = "0.9.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8131ce578968fe17$var$logger = new (0, $e8c0e15d964c1f41$export$efa9a398d6368992)("@firebase/app");
const $8131ce578968fe17$var$name$n = "@firebase/app-compat";
const $8131ce578968fe17$var$name$m = "@firebase/analytics-compat";
const $8131ce578968fe17$var$name$l = "@firebase/analytics";
const $8131ce578968fe17$var$name$k = "@firebase/app-check-compat";
const $8131ce578968fe17$var$name$j = "@firebase/app-check";
const $8131ce578968fe17$var$name$i = "@firebase/auth";
const $8131ce578968fe17$var$name$h = "@firebase/auth-compat";
const $8131ce578968fe17$var$name$g = "@firebase/database";
const $8131ce578968fe17$var$name$f = "@firebase/database-compat";
const $8131ce578968fe17$var$name$e = "@firebase/functions";
const $8131ce578968fe17$var$name$d = "@firebase/functions-compat";
const $8131ce578968fe17$var$name$c = "@firebase/installations";
const $8131ce578968fe17$var$name$b = "@firebase/installations-compat";
const $8131ce578968fe17$var$name$a = "@firebase/messaging";
const $8131ce578968fe17$var$name$9 = "@firebase/messaging-compat";
const $8131ce578968fe17$var$name$8 = "@firebase/performance";
const $8131ce578968fe17$var$name$7 = "@firebase/performance-compat";
const $8131ce578968fe17$var$name$6 = "@firebase/remote-config";
const $8131ce578968fe17$var$name$5 = "@firebase/remote-config-compat";
const $8131ce578968fe17$var$name$4 = "@firebase/storage";
const $8131ce578968fe17$var$name$3 = "@firebase/storage-compat";
const $8131ce578968fe17$var$name$2 = "@firebase/firestore";
const $8131ce578968fe17$var$name$1 = "@firebase/firestore-compat";
const $8131ce578968fe17$var$name = "firebase";
const $8131ce578968fe17$var$version = "9.23.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $8131ce578968fe17$export$9f30fa0c10967f7f = "[DEFAULT]";
const $8131ce578968fe17$var$PLATFORM_LOG_STRING = {
    [$8131ce578968fe17$var$name$o]: "fire-core",
    [$8131ce578968fe17$var$name$n]: "fire-core-compat",
    [$8131ce578968fe17$var$name$l]: "fire-analytics",
    [$8131ce578968fe17$var$name$m]: "fire-analytics-compat",
    [$8131ce578968fe17$var$name$j]: "fire-app-check",
    [$8131ce578968fe17$var$name$k]: "fire-app-check-compat",
    [$8131ce578968fe17$var$name$i]: "fire-auth",
    [$8131ce578968fe17$var$name$h]: "fire-auth-compat",
    [$8131ce578968fe17$var$name$g]: "fire-rtdb",
    [$8131ce578968fe17$var$name$f]: "fire-rtdb-compat",
    [$8131ce578968fe17$var$name$e]: "fire-fn",
    [$8131ce578968fe17$var$name$d]: "fire-fn-compat",
    [$8131ce578968fe17$var$name$c]: "fire-iid",
    [$8131ce578968fe17$var$name$b]: "fire-iid-compat",
    [$8131ce578968fe17$var$name$a]: "fire-fcm",
    [$8131ce578968fe17$var$name$9]: "fire-fcm-compat",
    [$8131ce578968fe17$var$name$8]: "fire-perf",
    [$8131ce578968fe17$var$name$7]: "fire-perf-compat",
    [$8131ce578968fe17$var$name$6]: "fire-rc",
    [$8131ce578968fe17$var$name$5]: "fire-rc-compat",
    [$8131ce578968fe17$var$name$4]: "fire-gcs",
    [$8131ce578968fe17$var$name$3]: "fire-gcs-compat",
    [$8131ce578968fe17$var$name$2]: "fire-fst",
    [$8131ce578968fe17$var$name$1]: "fire-fst-compat",
    "fire-js": "fire-js",
    [$8131ce578968fe17$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $8131ce578968fe17$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8131ce578968fe17$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $8131ce578968fe17$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $8131ce578968fe17$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $8131ce578968fe17$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $8131ce578968fe17$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($8131ce578968fe17$export$9566bce3835c0f28.has(componentName)) {
        $8131ce578968fe17$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $8131ce578968fe17$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $8131ce578968fe17$export$b4e3c36c855b14b5.values())$8131ce578968fe17$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $8131ce578968fe17$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $8131ce578968fe17$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $8131ce578968fe17$export$9f30fa0c10967f7f) {
    $8131ce578968fe17$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $8131ce578968fe17$export$3685d89b9c3cdfaf() {
    $8131ce578968fe17$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8131ce578968fe17$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
};
const $8131ce578968fe17$var$ERROR_FACTORY = new (0, $4556d6db4eb60619$export$3fa6e1b18a3b2d40)("app", "Firebase", $8131ce578968fe17$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8131ce578968fe17$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $6d116dc7a5092865$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $8131ce578968fe17$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $8131ce578968fe17$export$31499a9cd224b78c = $8131ce578968fe17$var$version;
function $8131ce578968fe17$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $8131ce578968fe17$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $8131ce578968fe17$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $4556d6db4eb60619$export$3dfb6827a9f89756)());
    if (!options) throw $8131ce578968fe17$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $8131ce578968fe17$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $4556d6db4eb60619$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $4556d6db4eb60619$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $8131ce578968fe17$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $6d116dc7a5092865$export$436a80eea5d5c0c5)(name);
    for (const component of $8131ce578968fe17$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $8131ce578968fe17$var$FirebaseAppImpl(options, config, container);
    $8131ce578968fe17$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $8131ce578968fe17$export$f9962582c9e66d99(name = $8131ce578968fe17$export$9f30fa0c10967f7f) {
    const app = $8131ce578968fe17$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $8131ce578968fe17$export$9f30fa0c10967f7f && (0, $4556d6db4eb60619$export$3dfb6827a9f89756)()) return $8131ce578968fe17$export$c55cfd413944906d();
    if (!app) throw $8131ce578968fe17$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $8131ce578968fe17$export$68ddedf7d44b3bdf() {
    return Array.from($8131ce578968fe17$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $8131ce578968fe17$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($8131ce578968fe17$export$b4e3c36c855b14b5.has(name)) {
        $8131ce578968fe17$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $8131ce578968fe17$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $8131ce578968fe17$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $8131ce578968fe17$var$logger.warn(warning.join(" "));
        return;
    }
    $8131ce578968fe17$export$c930050e7bb63965(new (0, $6d116dc7a5092865$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $8131ce578968fe17$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $8131ce578968fe17$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $e8c0e15d964c1f41$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $8131ce578968fe17$export$c622e99c0ce7b1c9(logLevel) {
    (0, $e8c0e15d964c1f41$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8131ce578968fe17$var$DB_NAME = "firebase-heartbeat-database";
const $8131ce578968fe17$var$DB_VERSION = 1;
const $8131ce578968fe17$var$STORE_NAME = "firebase-heartbeat-store";
let $8131ce578968fe17$var$dbPromise = null;
function $8131ce578968fe17$var$getDbPromise() {
    if (!$8131ce578968fe17$var$dbPromise) $8131ce578968fe17$var$dbPromise = (0, $5689be0d93d8c1c1$export$ca0ed41b1a2af7e)($8131ce578968fe17$var$DB_NAME, $8131ce578968fe17$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($8131ce578968fe17$var$STORE_NAME);
            }
        }
    }).catch((e)=>{
        throw $8131ce578968fe17$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $8131ce578968fe17$var$dbPromise;
}
async function $8131ce578968fe17$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $8131ce578968fe17$var$getDbPromise();
        const result = await db.transaction($8131ce578968fe17$var$STORE_NAME).objectStore($8131ce578968fe17$var$STORE_NAME).get($8131ce578968fe17$var$computeKey(app));
        return result;
    } catch (e) {
        if (e instanceof (0, $4556d6db4eb60619$export$dd24e9cd51226c56)) $8131ce578968fe17$var$logger.warn(e.message);
        else {
            const idbGetError = $8131ce578968fe17$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $8131ce578968fe17$var$logger.warn(idbGetError.message);
        }
    }
}
async function $8131ce578968fe17$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $8131ce578968fe17$var$getDbPromise();
        const tx = db.transaction($8131ce578968fe17$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($8131ce578968fe17$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $8131ce578968fe17$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $4556d6db4eb60619$export$dd24e9cd51226c56)) $8131ce578968fe17$var$logger.warn(e.message);
        else {
            const idbGetError = $8131ce578968fe17$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $8131ce578968fe17$var$logger.warn(idbGetError.message);
        }
    }
}
function $8131ce578968fe17$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8131ce578968fe17$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $8131ce578968fe17$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $8131ce578968fe17$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $8131ce578968fe17$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        const platformLogger = this.container.getProvider("platform-logger").getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $8131ce578968fe17$var$getUTCDateString();
        if (this._heartbeatsCache === null) this._heartbeatsCache = await this._heartbeatsCachePromise;
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $8131ce578968fe17$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const date = $8131ce578968fe17$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $8131ce578968fe17$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $4556d6db4eb60619$export$4b5284a3025a455)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $8131ce578968fe17$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $8131ce578968fe17$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $8131ce578968fe17$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($8131ce578968fe17$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($8131ce578968fe17$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $8131ce578968fe17$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $4556d6db4eb60619$export$3865db50535c2055)()) return false;
        else return (0, $4556d6db4eb60619$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $8131ce578968fe17$var$readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $8131ce578968fe17$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $8131ce578968fe17$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $8131ce578968fe17$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $4556d6db4eb60619$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8131ce578968fe17$var$registerCoreComponents(variant) {
    $8131ce578968fe17$export$c930050e7bb63965(new (0, $6d116dc7a5092865$export$16fa2f45be04daa8)("platform-logger", (container)=>new $8131ce578968fe17$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $8131ce578968fe17$export$c930050e7bb63965(new (0, $6d116dc7a5092865$export$16fa2f45be04daa8)("heartbeat", (container)=>new $8131ce578968fe17$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $8131ce578968fe17$export$d29d5299a7137abc($8131ce578968fe17$var$name$o, $8131ce578968fe17$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $8131ce578968fe17$export$d29d5299a7137abc($8131ce578968fe17$var$name$o, $8131ce578968fe17$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $8131ce578968fe17$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $8131ce578968fe17$var$registerCoreComponents("");


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $394c014f9626093e$var$extendStatics = function(d, b) {
    $394c014f9626093e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $394c014f9626093e$var$extendStatics(d, b);
};
function $394c014f9626093e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $394c014f9626093e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $394c014f9626093e$export$18ce0697a983be9b = function() {
    $394c014f9626093e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $394c014f9626093e$export$18ce0697a983be9b.apply(this, arguments);
};
function $394c014f9626093e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $394c014f9626093e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $394c014f9626093e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $394c014f9626093e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $394c014f9626093e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $394c014f9626093e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $394c014f9626093e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $394c014f9626093e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $394c014f9626093e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $394c014f9626093e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $394c014f9626093e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $394c014f9626093e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $394c014f9626093e$export$45d3717a4c69092e(o, m, p);
}
function $394c014f9626093e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $394c014f9626093e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $394c014f9626093e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($394c014f9626093e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $394c014f9626093e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $394c014f9626093e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $394c014f9626093e$export$10c90e4f7922046c(v) {
    return this instanceof $394c014f9626093e$export$10c90e4f7922046c ? (this.v = v, this) : new $394c014f9626093e$export$10c90e4f7922046c(v);
}
function $394c014f9626093e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $394c014f9626093e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $394c014f9626093e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $394c014f9626093e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $394c014f9626093e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $394c014f9626093e$export$19a8beecd37a4c45 === "function" ? $394c014f9626093e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $394c014f9626093e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $394c014f9626093e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $394c014f9626093e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $394c014f9626093e$export$45d3717a4c69092e(result, mod, k);
    }
    $394c014f9626093e$var$__setModuleDefault(result, mod);
    return result;
}
function $394c014f9626093e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $394c014f9626093e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $394c014f9626093e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $394c014f9626093e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $394c014f9626093e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $394c014f9626093e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $394c014f9626093e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $394c014f9626093e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $394c014f9626093e$export$2e2bcd8739ae039 = {
    __extends: $394c014f9626093e$export$a8ba968b8961cb8a,
    __assign: $394c014f9626093e$export$18ce0697a983be9b,
    __rest: $394c014f9626093e$export$3c9a16f847548506,
    __decorate: $394c014f9626093e$export$29e00dfd3077644b,
    __param: $394c014f9626093e$export$d5ad3fd78186038f,
    __metadata: $394c014f9626093e$export$f1db080c865becb9,
    __awaiter: $394c014f9626093e$export$1050f835b63b671e,
    __generator: $394c014f9626093e$export$67ebef60e6f28a6,
    __createBinding: $394c014f9626093e$export$45d3717a4c69092e,
    __exportStar: $394c014f9626093e$export$f33643c0debef087,
    __values: $394c014f9626093e$export$19a8beecd37a4c45,
    __read: $394c014f9626093e$export$8d051b38c9118094,
    __spread: $394c014f9626093e$export$afc72e2116322959,
    __spreadArrays: $394c014f9626093e$export$6388937ca91ccae8,
    __spreadArray: $394c014f9626093e$export$1216008129fb82ed,
    __await: $394c014f9626093e$export$10c90e4f7922046c,
    __asyncGenerator: $394c014f9626093e$export$e427f37a30a4de9b,
    __asyncDelegator: $394c014f9626093e$export$bbd80228419bb833,
    __asyncValues: $394c014f9626093e$export$e3b29a3d6162315f,
    __makeTemplateObject: $394c014f9626093e$export$4fb47efe1390b86f,
    __importStar: $394c014f9626093e$export$c21735bcef00d192,
    __importDefault: $394c014f9626093e$export$da59b14a69baef04,
    __classPrivateFieldGet: $394c014f9626093e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $394c014f9626093e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $394c014f9626093e$export$81fdc39f203e4e04,
    __addDisposableResource: $394c014f9626093e$export$88ac25d8e944e405,
    __disposeResources: $394c014f9626093e$export$8f076105dc360e92
};




/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $9ad751dca565baab$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $9ad751dca565baab$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $9ad751dca565baab$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $9ad751dca565baab$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $9ad751dca565baab$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: "The mobile app identifier is not registed for the current project.",
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ]: "The supplied auth credential is malformed or has expired.",
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: "A non-empty password must be provided",
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is missing when sending request to the backend.",
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is invalid when sending request to the backend.",
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: "The reCAPTCHA action is invalid when sending request to the backend.",
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: "reCAPTCHA Enterprise integration is not enabled for this project.",
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: "The reCAPTCHA client type is missing when sending request to the backend.",
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is missing when sending request to the backend.",
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: "Invalid request parameters.",
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is invalid when sending request to the backend."
    };
}
function $9ad751dca565baab$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $9ad751dca565baab$export$96f57966bedc81b4 = $9ad751dca565baab$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $9ad751dca565baab$export$a9c23c6ac3fc3eca = $9ad751dca565baab$var$_prodErrorMap;
const $9ad751dca565baab$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $4556d6db4eb60619$export$3fa6e1b18a3b2d40)("auth", "Firebase", $9ad751dca565baab$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $9ad751dca565baab$export$2329c99376c9d0a4 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$logClient = new (0, $e8c0e15d964c1f41$export$efa9a398d6368992)("@firebase/auth");
function $9ad751dca565baab$var$_logWarn(msg, ...args) {
    if ($9ad751dca565baab$var$logClient.logLevel <= (0, $e8c0e15d964c1f41$export$243e62d78d3b544d).WARN) $9ad751dca565baab$var$logClient.warn(`Auth (${(0, $8131ce578968fe17$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $9ad751dca565baab$var$_logError(msg, ...args) {
    if ($9ad751dca565baab$var$logClient.logLevel <= (0, $e8c0e15d964c1f41$export$243e62d78d3b544d).ERROR) $9ad751dca565baab$var$logClient.error(`Auth (${(0, $8131ce578968fe17$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$export$d66dc83d8cfc8dd(authOrCode, ...rest) {
    throw $9ad751dca565baab$var$createErrorInternal(authOrCode, ...rest);
}
function $9ad751dca565baab$export$3d12bd131bb975d1(authOrCode, ...rest) {
    return $9ad751dca565baab$var$createErrorInternal(authOrCode, ...rest);
}
function $9ad751dca565baab$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $9ad751dca565baab$export$a9c23c6ac3fc3eca()), {
        [code]: message
    });
    const factory = new (0, $4556d6db4eb60619$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $9ad751dca565baab$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $9ad751dca565baab$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $9ad751dca565baab$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $9ad751dca565baab$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $9ad751dca565baab$export$91c6e00c14e7e6fd(assertion, authOrCode, ...rest) {
    if (!assertion) throw $9ad751dca565baab$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $9ad751dca565baab$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $9ad751dca565baab$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $9ad751dca565baab$export$6554612db691658e(assertion, message) {
    if (!assertion) $9ad751dca565baab$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $9ad751dca565baab$var$_isHttpOrHttps() {
    return $9ad751dca565baab$var$_getCurrentScheme() === "http:" || $9ad751dca565baab$var$_getCurrentScheme() === "https:";
}
function $9ad751dca565baab$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $9ad751dca565baab$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($9ad751dca565baab$var$_isHttpOrHttps() || (0, $4556d6db4eb60619$export$caa8774a9107a58e)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $9ad751dca565baab$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $9ad751dca565baab$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $9ad751dca565baab$export$6554612db691658e(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $4556d6db4eb60619$export$872f8323f01d7ae0)() || (0, $4556d6db4eb60619$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$9ad751dca565baab$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$_emulatorUrl(config, path) {
    $9ad751dca565baab$export$6554612db691658e(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$export$faec65b429be379 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        $9ad751dca565baab$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        $9ad751dca565baab$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        $9ad751dca565baab$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $9ad751dca565baab$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$DEFAULT_API_TIMEOUT_MS = new $9ad751dca565baab$var$Delay(30000, 60000);
function $9ad751dca565baab$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $9ad751dca565baab$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $9ad751dca565baab$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $4556d6db4eb60619$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $9ad751dca565baab$export$faec65b429be379.fetch()($9ad751dca565baab$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: "no-referrer"
        }, body));
    });
}
async function $9ad751dca565baab$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $9ad751dca565baab$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $9ad751dca565baab$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $9ad751dca565baab$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $9ad751dca565baab$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $9ad751dca565baab$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $9ad751dca565baab$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $9ad751dca565baab$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $4556d6db4eb60619$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            "message": String(e)
        });
    }
}
async function $9ad751dca565baab$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $9ad751dca565baab$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $9ad751dca565baab$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $9ad751dca565baab$var$_emulatorUrl(auth.config, base);
}
class $9ad751dca565baab$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($9ad751dca565baab$export$3d12bd131bb975d1(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $9ad751dca565baab$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $9ad751dca565baab$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $9ad751dca565baab$export$3d12bd131bb975d1(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$deleteAccount(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $9ad751dca565baab$var$deleteLinkedAccounts(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $9ad751dca565baab$var$getAccountInfo(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $9ad751dca565baab$export$ab83b03e4111b1d0(user, forceRefresh = false) {
    return (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $9ad751dca565baab$export$1a82df3d29112e01(user, forceRefresh = false) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $9ad751dca565baab$var$_parseToken(token);
    $9ad751dca565baab$export$91c6e00c14e7e6fd(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $9ad751dca565baab$var$utcTimestampToDateString($9ad751dca565baab$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $9ad751dca565baab$var$utcTimestampToDateString($9ad751dca565baab$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $9ad751dca565baab$var$utcTimestampToDateString($9ad751dca565baab$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $9ad751dca565baab$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $9ad751dca565baab$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $9ad751dca565baab$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $4556d6db4eb60619$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $9ad751dca565baab$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $9ad751dca565baab$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $9ad751dca565baab$var$_tokenExpiresIn(token) {
    const parsedToken = $9ad751dca565baab$var$_parseToken(token);
    $9ad751dca565baab$export$91c6e00c14e7e6fd(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $4556d6db4eb60619$export$dd24e9cd51226c56) && $9ad751dca565baab$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $9ad751dca565baab$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $9ad751dca565baab$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $9ad751dca565baab$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $9ad751dca565baab$var$_logoutIfInvalidated(user, $9ad751dca565baab$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $9ad751dca565baab$export$91c6e00c14e7e6fd(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $9ad751dca565baab$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $9ad751dca565baab$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $9ad751dca565baab$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $9ad751dca565baab$export$2f6ca3d3b1f80bf5(user) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    await $9ad751dca565baab$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $9ad751dca565baab$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $9ad751dca565baab$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $394c014f9626093e$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$requestStsToken(auth, refreshToken) {
    const response = await $9ad751dca565baab$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $4556d6db4eb60619$export$ac4103b836844853)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $9ad751dca565baab$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $9ad751dca565baab$export$faec65b429be379.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $9ad751dca565baab$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $9ad751dca565baab$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(!this.accessToken || this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $9ad751dca565baab$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $9ad751dca565baab$var$StsTokenManager();
        if (refreshToken) {
            $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $9ad751dca565baab$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $9ad751dca565baab$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$assertStringOrUndefined(assertion, appName) {
    $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $9ad751dca565baab$export$b9a6b53f9be3734 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $394c014f9626093e$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $9ad751dca565baab$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $9ad751dca565baab$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $9ad751dca565baab$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $9ad751dca565baab$export$91c6e00c14e7e6fd(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $9ad751dca565baab$export$1a82df3d29112e01(this, forceRefresh);
    }
    reload() {
        return $9ad751dca565baab$export$2f6ca3d3b1f80bf5(this);
    }
    _assign(user) {
        if (this === user) return;
        $9ad751dca565baab$export$91c6e00c14e7e6fd(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $9ad751dca565baab$export$b9a6b53f9be3734(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $9ad751dca565baab$export$91c6e00c14e7e6fd(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $9ad751dca565baab$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        const idToken = await this.getIdToken();
        await $9ad751dca565baab$var$_logoutIfInvalidated(this, $9ad751dca565baab$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $9ad751dca565baab$export$91c6e00c14e7e6fd(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $9ad751dca565baab$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $9ad751dca565baab$var$assertStringOrUndefined(displayName, auth.name);
        $9ad751dca565baab$var$assertStringOrUndefined(email, auth.name);
        $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $9ad751dca565baab$var$assertStringOrUndefined(phoneNumber, auth.name);
        $9ad751dca565baab$var$assertStringOrUndefined(photoURL, auth.name);
        $9ad751dca565baab$var$assertStringOrUndefined(tenantId, auth.name);
        $9ad751dca565baab$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $9ad751dca565baab$var$assertStringOrUndefined(createdAt, auth.name);
        $9ad751dca565baab$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $9ad751dca565baab$export$b9a6b53f9be3734({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $9ad751dca565baab$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $9ad751dca565baab$export$b9a6b53f9be3734({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $9ad751dca565baab$var$_reloadWithoutSaving(user);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$instanceCache = new Map();
function $9ad751dca565baab$export$890c4ad488842ce7(cls) {
    $9ad751dca565baab$export$6554612db691658e(cls instanceof Function, "Expected a class definition");
    let instance = $9ad751dca565baab$var$instanceCache.get(cls);
    if (instance) {
        $9ad751dca565baab$export$6554612db691658e(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $9ad751dca565baab$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$9ad751dca565baab$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $9ad751dca565baab$export$a07804094c3ecf2d = $9ad751dca565baab$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$export$24baa2b76016ce0e(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $9ad751dca565baab$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $9ad751dca565baab$export$24baa2b76016ce0e(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $9ad751dca565baab$export$24baa2b76016ce0e("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $9ad751dca565baab$export$b9a6b53f9be3734._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $9ad751dca565baab$var$PersistenceUserManager($9ad751dca565baab$export$890c4ad488842ce7($9ad751dca565baab$export$a07804094c3ecf2d), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $9ad751dca565baab$export$890c4ad488842ce7($9ad751dca565baab$export$a07804094c3ecf2d);
        const key = $9ad751dca565baab$export$24baa2b76016ce0e(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $9ad751dca565baab$export$b9a6b53f9be3734._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $9ad751dca565baab$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $9ad751dca565baab$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $9ad751dca565baab$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($9ad751dca565baab$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($9ad751dca565baab$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($9ad751dca565baab$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($9ad751dca565baab$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($9ad751dca565baab$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $9ad751dca565baab$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($9ad751dca565baab$export$1fbe638ecf81657e(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $9ad751dca565baab$var$_isFirefox(ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $9ad751dca565baab$var$_isSafari(userAgent = (0, $4556d6db4eb60619$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $9ad751dca565baab$var$_isChromeIOS(ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $9ad751dca565baab$var$_isIEMobile(ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $9ad751dca565baab$export$1fbe638ecf81657e(ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $9ad751dca565baab$var$_isBlackBerry(ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $9ad751dca565baab$var$_isWebOS(ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $9ad751dca565baab$export$493d36ec626b6698(ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $9ad751dca565baab$export$28f7fcd39efa255(ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $9ad751dca565baab$var$_isIOSStandalone(ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)()) {
    var _a;
    return $9ad751dca565baab$export$493d36ec626b6698(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $9ad751dca565baab$var$_isIE10() {
    return (0, $4556d6db4eb60619$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $9ad751dca565baab$var$_isMobileBrowser(ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $9ad751dca565baab$export$493d36ec626b6698(ua) || $9ad751dca565baab$export$1fbe638ecf81657e(ua) || $9ad751dca565baab$var$_isWebOS(ua) || $9ad751dca565baab$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $9ad751dca565baab$var$_isIEMobile(ua);
}
function $9ad751dca565baab$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $9ad751dca565baab$export$23ebac1979863676(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $9ad751dca565baab$var$_getBrowserName((0, $4556d6db4eb60619$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$9ad751dca565baab$var$_getBrowserName((0, $4556d6db4eb60619$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $8131ce578968fe17$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$getRecaptchaParams(auth) {
    return (await $9ad751dca565baab$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
async function $9ad751dca565baab$var$getRecaptchaConfig(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $9ad751dca565baab$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $9ad751dca565baab$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The reCAPTCHA enablement status of the {@link EmailAuthProvider} for the current tenant.
         */ this.emailPasswordEnabled = false;
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.emailPasswordEnabled = response.recaptchaEnforcementState.some((enforcementState)=>enforcementState.provider === "EMAIL_PASSWORD_PROVIDER" && enforcementState.enforcementState !== "OFF");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function $9ad751dca565baab$var$_loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise((resolve, reject)=>{
        const el = document.createElement("script");
        el.setAttribute("src", url);
        el.onload = resolve;
        el.onerror = (e)=>{
            const error = $9ad751dca565baab$export$3d12bd131bb975d1("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            error.customData = e;
            reject(error);
        };
        el.type = "text/javascript";
        el.charset = "UTF-8";
        $9ad751dca565baab$var$getScriptParentElement().appendChild(el);
    });
}
function $9ad751dca565baab$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $9ad751dca565baab$var$RECAPTCHA_ENTERPRISE_URL = "https://www.google.com/recaptcha/enterprise.js?render=";
const $9ad751dca565baab$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
const $9ad751dca565baab$var$FAKE_TOKEN = "NO_RECAPTCHA";
class $9ad751dca565baab$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $9ad751dca565baab$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $9ad751dca565baab$export$a33b77bbdbb8366c(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = "verify", forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $9ad751dca565baab$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                    else {
                        const config = new $9ad751dca565baab$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($9ad751dca565baab$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($9ad751dca565baab$var$FAKE_TOKEN);
                });
            });
            else reject(Error("No reCAPTCHA enterprise script loaded."));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $9ad751dca565baab$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                    }
                    $9ad751dca565baab$var$_loadJS($9ad751dca565baab$var$RECAPTCHA_ENTERPRISE_URL + siteKey).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $9ad751dca565baab$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $9ad751dca565baab$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        "captchaResp": captchaResponse
    });
    Object.assign(newRequest, {
        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$export$a05254e7c3aeba6e {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $9ad751dca565baab$var$Subscription(this);
        this.idTokenSubscription = new $9ad751dca565baab$var$Subscription(this);
        this.beforeStateQueue = new $9ad751dca565baab$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $9ad751dca565baab$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $9ad751dca565baab$export$890c4ad488842ce7(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $9ad751dca565baab$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $9ad751dca565baab$export$91c6e00c14e7e6fd(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $9ad751dca565baab$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $9ad751dca565baab$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $9ad751dca565baab$export$91c6e00c14e7e6fd(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $9ad751dca565baab$export$91c6e00c14e7e6fd(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($9ad751dca565baab$export$890c4ad488842ce7(persistence));
        });
    }
    async initializeRecaptchaConfig() {
        const response = await $9ad751dca565baab$var$getRecaptchaConfig(this, {
            clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
            version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
        });
        const config = new $9ad751dca565baab$var$RecaptchaConfig(response);
        if (this.tenantId == null) this._agentRecaptchaConfig = config;
        else this._tenantRecaptchaConfigs[this.tenantId] = config;
        if (config.emailPasswordEnabled) {
            const verifier = new $9ad751dca565baab$var$RecaptchaEnterpriseVerifier(this);
            verifier.verify();
        }
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $4556d6db4eb60619$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $9ad751dca565baab$export$890c4ad488842ce7(popupRedirectResolver) || this._popupRedirectResolver;
            $9ad751dca565baab$export$91c6e00c14e7e6fd(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $9ad751dca565baab$var$PersistenceUserManager.create(this, [
                $9ad751dca565baab$export$890c4ad488842ce7(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $9ad751dca565baab$export$91c6e00c14e7e6fd(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>cb(this.currentUser));
        if (typeof nextOrObserver === "function") return subscription.addObserver(nextOrObserver, error, completed);
        else return subscription.addObserver(nextOrObserver);
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $9ad751dca565baab$export$23ebac1979863676(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $9ad751dca565baab$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $9ad751dca565baab$export$a33b77bbdbb8366c(auth) {
    return (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $9ad751dca565baab$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $4556d6db4eb60619$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $9ad751dca565baab$export$7f8ddf7c7c20b3cd(app, deps) {
    const provider = (0, $8131ce578968fe17$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $4556d6db4eb60619$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $9ad751dca565baab$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($9ad751dca565baab$export$890c4ad488842ce7);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $9ad751dca565baab$export$9bb611d729802a56(auth, url, options) {
    const authInternal = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    $9ad751dca565baab$export$91c6e00c14e7e6fd(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $9ad751dca565baab$export$91c6e00c14e7e6fd(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $9ad751dca565baab$var$extractProtocol(url);
    const { host: host, port: port } = $9ad751dca565baab$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $9ad751dca565baab$var$emitEmulatorWarning();
}
function $9ad751dca565baab$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $9ad751dca565baab$var$extractHostAndPort(url) {
    const protocol = $9ad751dca565baab$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $9ad751dca565baab$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $9ad751dca565baab$var$parsePort(port)
        };
    }
}
function $9ad751dca565baab$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $9ad751dca565baab$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $9ad751dca565baab$export$b4171a6734a65d42 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $9ad751dca565baab$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $9ad751dca565baab$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $9ad751dca565baab$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $9ad751dca565baab$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$resetPassword(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
async function $9ad751dca565baab$var$updateEmailPassword(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $9ad751dca565baab$var$applyActionCode$1(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$signInWithPassword(auth, request) {
    return $9ad751dca565baab$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
async function $9ad751dca565baab$var$sendOobCode(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
async function $9ad751dca565baab$var$sendEmailVerification$1(auth, request) {
    return $9ad751dca565baab$var$sendOobCode(auth, request);
}
async function $9ad751dca565baab$var$sendPasswordResetEmail$1(auth, request) {
    return $9ad751dca565baab$var$sendOobCode(auth, request);
}
async function $9ad751dca565baab$var$sendSignInLinkToEmail$1(auth, request) {
    return $9ad751dca565baab$var$sendOobCode(auth, request);
}
async function $9ad751dca565baab$var$verifyAndChangeEmail(auth, request) {
    return $9ad751dca565baab$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$signInWithEmailLink$1(auth, request) {
    return $9ad751dca565baab$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
async function $9ad751dca565baab$var$signInWithEmailLinkForLinking(auth, request) {
    return $9ad751dca565baab$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $9ad751dca565baab$export$3466f893ebf79586 extends $9ad751dca565baab$export$b4171a6734a65d42 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $9ad751dca565baab$export$3466f893ebf79586(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $9ad751dca565baab$export$3466f893ebf79586(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        var _a;
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                if ((_a = auth._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
                    const requestWithRecaptcha = await $9ad751dca565baab$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ );
                    return $9ad751dca565baab$var$signInWithPassword(auth, requestWithRecaptcha);
                } else return $9ad751dca565baab$var$signInWithPassword(auth, request).catch(async (error)=>{
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                        console.log("Sign-in with email address and password is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                        const requestWithRecaptcha = await $9ad751dca565baab$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ );
                        return $9ad751dca565baab$var$signInWithPassword(auth, requestWithRecaptcha);
                    } else return Promise.reject(error);
                });
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $9ad751dca565baab$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                return $9ad751dca565baab$var$updateEmailPassword(auth, {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $9ad751dca565baab$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$signInWithIdp(auth, request) {
    return $9ad751dca565baab$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $9ad751dca565baab$export$61196ced6d74a310 extends $9ad751dca565baab$export$b4171a6734a65d42 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $9ad751dca565baab$export$61196ced6d74a310(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $9ad751dca565baab$export$d66dc83d8cfc8dd("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $394c014f9626093e$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $9ad751dca565baab$export$61196ced6d74a310(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $9ad751dca565baab$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $9ad751dca565baab$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $9ad751dca565baab$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $9ad751dca565baab$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $4556d6db4eb60619$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$sendPhoneVerificationCode(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
async function $9ad751dca565baab$var$signInWithPhoneNumber$1(auth, request) {
    return $9ad751dca565baab$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
async function $9ad751dca565baab$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $9ad751dca565baab$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $9ad751dca565baab$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $9ad751dca565baab$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $9ad751dca565baab$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $9ad751dca565baab$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, apiRequest), $9ad751dca565baab$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $9ad751dca565baab$export$3a1a48c8f6ef640e extends $9ad751dca565baab$export$b4171a6734a65d42 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $9ad751dca565baab$export$3a1a48c8f6ef640e({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $9ad751dca565baab$export$3a1a48c8f6ef640e({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $9ad751dca565baab$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $9ad751dca565baab$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $9ad751dca565baab$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $9ad751dca565baab$export$3a1a48c8f6ef640e({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $9ad751dca565baab$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $9ad751dca565baab$var$parseDeepLink(url) {
    const link = (0, $4556d6db4eb60619$export$c1271ca4c8a70741)((0, $4556d6db4eb60619$export$1a8408415472d8ed)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $4556d6db4eb60619$export$c1271ca4c8a70741)((0, $4556d6db4eb60619$export$1a8408415472d8ed)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $4556d6db4eb60619$export$c1271ca4c8a70741)((0, $4556d6db4eb60619$export$1a8408415472d8ed)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $4556d6db4eb60619$export$c1271ca4c8a70741)((0, $4556d6db4eb60619$export$1a8408415472d8ed)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $9ad751dca565baab$export$ee7c8ad385a60b7b {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $4556d6db4eb60619$export$c1271ca4c8a70741)((0, $4556d6db4eb60619$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $9ad751dca565baab$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $9ad751dca565baab$export$91c6e00c14e7e6fd(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $9ad751dca565baab$var$parseDeepLink(link);
        try {
            return new $9ad751dca565baab$export$ee7c8ad385a60b7b(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $9ad751dca565baab$export$995eb9fca571757(link) {
    return $9ad751dca565baab$export$ee7c8ad385a60b7b.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $9ad751dca565baab$export$3722cfe417b6ed86 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $9ad751dca565baab$export$3722cfe417b6ed86.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $9ad751dca565baab$export$3466f893ebf79586._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $9ad751dca565baab$export$ee7c8ad385a60b7b.parseLink(emailLink);
        $9ad751dca565baab$export$91c6e00c14e7e6fd(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $9ad751dca565baab$export$3466f893ebf79586._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $9ad751dca565baab$export$3722cfe417b6ed86.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $9ad751dca565baab$export$3722cfe417b6ed86.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $9ad751dca565baab$export$3722cfe417b6ed86.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $9ad751dca565baab$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $9ad751dca565baab$var$BaseOAuthProvider extends $9ad751dca565baab$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $9ad751dca565baab$export$78acf4525d8a74c4 extends $9ad751dca565baab$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $9ad751dca565baab$export$91c6e00c14e7e6fd("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $9ad751dca565baab$export$61196ced6d74a310._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $9ad751dca565baab$export$61196ced6d74a310._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9ad751dca565baab$export$78acf4525d8a74c4.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9ad751dca565baab$export$78acf4525d8a74c4.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $9ad751dca565baab$export$78acf4525d8a74c4(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $9ad751dca565baab$export$3a6d5c9ae78a2c08 extends $9ad751dca565baab$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $9ad751dca565baab$export$61196ced6d74a310._fromParams({
            providerId: $9ad751dca565baab$export$3a6d5c9ae78a2c08.PROVIDER_ID,
            signInMethod: $9ad751dca565baab$export$3a6d5c9ae78a2c08.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9ad751dca565baab$export$3a6d5c9ae78a2c08.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9ad751dca565baab$export$3a6d5c9ae78a2c08.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $9ad751dca565baab$export$3a6d5c9ae78a2c08.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $9ad751dca565baab$export$3a6d5c9ae78a2c08.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $9ad751dca565baab$export$3a6d5c9ae78a2c08.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $9ad751dca565baab$export$e7c866399fa523f5 extends $9ad751dca565baab$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $9ad751dca565baab$export$61196ced6d74a310._fromParams({
            providerId: $9ad751dca565baab$export$e7c866399fa523f5.PROVIDER_ID,
            signInMethod: $9ad751dca565baab$export$e7c866399fa523f5.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9ad751dca565baab$export$e7c866399fa523f5.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9ad751dca565baab$export$e7c866399fa523f5.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $9ad751dca565baab$export$e7c866399fa523f5.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $9ad751dca565baab$export$e7c866399fa523f5.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $9ad751dca565baab$export$e7c866399fa523f5.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $9ad751dca565baab$export$71cec2538cb2c617 extends $9ad751dca565baab$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ static credential(accessToken) {
        return $9ad751dca565baab$export$61196ced6d74a310._fromParams({
            providerId: $9ad751dca565baab$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $9ad751dca565baab$export$71cec2538cb2c617.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9ad751dca565baab$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9ad751dca565baab$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $9ad751dca565baab$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $9ad751dca565baab$export$71cec2538cb2c617.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $9ad751dca565baab$export$71cec2538cb2c617.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $9ad751dca565baab$export$c03999cb2f36933f extends $9ad751dca565baab$export$b4171a6734a65d42 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $9ad751dca565baab$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $9ad751dca565baab$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $9ad751dca565baab$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $9ad751dca565baab$export$c03999cb2f36933f(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $9ad751dca565baab$export$c03999cb2f36933f(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $9ad751dca565baab$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $9ad751dca565baab$export$8743009a87fcb00f extends $9ad751dca565baab$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $9ad751dca565baab$export$91c6e00c14e7e6fd(providerId.startsWith($9ad751dca565baab$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9ad751dca565baab$export$8743009a87fcb00f.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9ad751dca565baab$export$8743009a87fcb00f.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $9ad751dca565baab$export$c03999cb2f36933f.fromJSON(json);
        $9ad751dca565baab$export$91c6e00c14e7e6fd(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $9ad751dca565baab$export$c03999cb2f36933f._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $9ad751dca565baab$export$dc98b0b04f4c7758 extends $9ad751dca565baab$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $9ad751dca565baab$export$61196ced6d74a310._fromParams({
            providerId: $9ad751dca565baab$export$dc98b0b04f4c7758.PROVIDER_ID,
            signInMethod: $9ad751dca565baab$export$dc98b0b04f4c7758.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9ad751dca565baab$export$dc98b0b04f4c7758.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9ad751dca565baab$export$dc98b0b04f4c7758.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $9ad751dca565baab$export$dc98b0b04f4c7758.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $9ad751dca565baab$export$dc98b0b04f4c7758.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $9ad751dca565baab$export$dc98b0b04f4c7758.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$signUp(auth, request) {
    return $9ad751dca565baab$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $9ad751dca565baab$export$b9a6b53f9be3734._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $9ad751dca565baab$var$providerIdForResponse(idTokenResponse);
        const userCred = new $9ad751dca565baab$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $9ad751dca565baab$var$providerIdForResponse(response);
        return new $9ad751dca565baab$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $9ad751dca565baab$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $9ad751dca565baab$export$71511d61b312f219(auth) {
    var _a;
    const authInternal = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $9ad751dca565baab$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $9ad751dca565baab$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $9ad751dca565baab$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$MultiFactorError extends (0, $4556d6db4eb60619$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $9ad751dca565baab$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $9ad751dca565baab$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $9ad751dca565baab$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $9ad751dca565baab$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $9ad751dca565baab$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $9ad751dca565baab$export$306ddfe3a8403e2(user, providerId) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    await $9ad751dca565baab$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $9ad751dca565baab$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $9ad751dca565baab$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $9ad751dca565baab$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $9ad751dca565baab$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $9ad751dca565baab$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $9ad751dca565baab$var$_assertLinkedStatus(expected, user, provider) {
    await $9ad751dca565baab$var$_reloadWithoutSaving(user);
    const providerIds = $9ad751dca565baab$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $9ad751dca565baab$export$91c6e00c14e7e6fd(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $9ad751dca565baab$var$_logoutIfInvalidated(user, $9ad751dca565baab$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $9ad751dca565baab$export$91c6e00c14e7e6fd(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $9ad751dca565baab$var$_parseToken(response.idToken);
        $9ad751dca565baab$export$91c6e00c14e7e6fd(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $9ad751dca565baab$export$91c6e00c14e7e6fd(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $9ad751dca565baab$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $9ad751dca565baab$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $9ad751dca565baab$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $9ad751dca565baab$export$3d8c2f653ac9d0b9(auth, credential) {
    return $9ad751dca565baab$var$_signInWithCredential($9ad751dca565baab$export$a33b77bbdbb8366c(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $9ad751dca565baab$export$34aec0b863436764(user, credential) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    await $9ad751dca565baab$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $9ad751dca565baab$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $9ad751dca565baab$export$3c2fa207a37baaea(user, credential) {
    return $9ad751dca565baab$var$_reauthenticate((0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$signInWithCustomToken$1(auth, request) {
    return $9ad751dca565baab$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $9ad751dca565baab$export$ce26c07117d59d6a(auth, customToken) {
    const authInternal = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    const response = await $9ad751dca565baab$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $9ad751dca565baab$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $9ad751dca565baab$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ("totpInfo" in enrollment) return $9ad751dca565baab$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $9ad751dca565baab$var$PhoneMultiFactorInfoImpl extends $9ad751dca565baab$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $9ad751dca565baab$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $9ad751dca565baab$var$TotpMultiFactorInfoImpl extends $9ad751dca565baab$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $9ad751dca565baab$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $9ad751dca565baab$export$91c6e00c14e7e6fd(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $9ad751dca565baab$export$6559d589eb85fbb6(auth, email, actionCodeSettings) {
    var _a;
    const authInternal = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $9ad751dca565baab$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
        if (actionCodeSettings) $9ad751dca565baab$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
        await $9ad751dca565baab$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha);
    } else {
        if (actionCodeSettings) $9ad751dca565baab$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
        await $9ad751dca565baab$var$sendPasswordResetEmail$1(authInternal, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log("Password resets are protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the password reset flow.");
                const requestWithRecaptcha = await $9ad751dca565baab$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
                if (actionCodeSettings) $9ad751dca565baab$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
                await $9ad751dca565baab$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    }
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $9ad751dca565baab$export$efca4cbe5dd06740(auth, oobCode, newPassword) {
    await $9ad751dca565baab$var$resetPassword((0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $9ad751dca565baab$export$a8550f7dbe79f93a(auth, oobCode) {
    await $9ad751dca565baab$var$applyActionCode$1((0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $9ad751dca565baab$export$2e2af4578d910ddf(auth, oobCode) {
    const authModular = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth);
    const response = await $9ad751dca565baab$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $9ad751dca565baab$export$91c6e00c14e7e6fd(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $9ad751dca565baab$export$91c6e00c14e7e6fd(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $9ad751dca565baab$export$91c6e00c14e7e6fd(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $9ad751dca565baab$export$91c6e00c14e7e6fd(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $9ad751dca565baab$var$MultiFactorInfoImpl._fromServerResponse($9ad751dca565baab$export$a33b77bbdbb8366c(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $9ad751dca565baab$export$a93c5207d687da10(auth, code) {
    const { data: data } = await $9ad751dca565baab$export$2e2af4578d910ddf((0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $9ad751dca565baab$export$c3950d9923825c02(auth, email, password) {
    var _a;
    const authInternal = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    let signUpResponse;
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $9ad751dca565baab$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ );
        signUpResponse = $9ad751dca565baab$var$signUp(authInternal, requestWithRecaptcha);
    } else signUpResponse = $9ad751dca565baab$var$signUp(authInternal, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log("Sign-up is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-up flow.");
            const requestWithRecaptcha = await $9ad751dca565baab$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ );
            return $9ad751dca565baab$var$signUp(authInternal, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
    const response = await signUpResponse.catch((error)=>{
        return Promise.reject(error);
    });
    const userCredential = await $9ad751dca565baab$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $9ad751dca565baab$export$a9c996f45e5784d0(auth, email, password) {
    return $9ad751dca565baab$export$3d8c2f653ac9d0b9((0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth), $9ad751dca565baab$export$3722cfe417b6ed86.credential(email, password));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $9ad751dca565baab$export$7910e0436ed8d1de(auth, email, actionCodeSettings) {
    var _a;
    const authInternal = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $9ad751dca565baab$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $9ad751dca565baab$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
        setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
        await $9ad751dca565baab$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha);
    } else {
        setActionCodeSettings(request, actionCodeSettings);
        await $9ad751dca565baab$var$sendSignInLinkToEmail$1(authInternal, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log("Email link sign-in is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                const requestWithRecaptcha = await $9ad751dca565baab$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
                setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
                await $9ad751dca565baab$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    }
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $9ad751dca565baab$export$555508cbc6add439(auth, emailLink) {
    const actionCodeUrl = $9ad751dca565baab$export$ee7c8ad385a60b7b.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $9ad751dca565baab$export$2219238a014317b0(auth, email, emailLink) {
    const authModular = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth);
    const credential = $9ad751dca565baab$export$3722cfe417b6ed86.credentialWithLink(email, emailLink || $9ad751dca565baab$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $9ad751dca565baab$export$91c6e00c14e7e6fd(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $9ad751dca565baab$export$3d8c2f653ac9d0b9(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$createAuthUri(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */ async function $9ad751dca565baab$export$4c3d22f3d993c33f(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $9ad751dca565baab$var$_isHttpOrHttps() ? $9ad751dca565baab$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $9ad751dca565baab$var$createAuthUri((0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $9ad751dca565baab$export$f787f51d84a910ad(user, actionCodeSettings) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $9ad751dca565baab$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $9ad751dca565baab$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $9ad751dca565baab$export$c9170ad7d4cd7e57(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $9ad751dca565baab$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $9ad751dca565baab$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$var$updateProfile$1(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $9ad751dca565baab$export$f38c853ae54ed474(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $9ad751dca565baab$var$_logoutIfInvalidated(userInternal, $9ad751dca565baab$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */ function $9ad751dca565baab$export$3b513254972cfc9c(user, newEmail) {
    return $9ad751dca565baab$var$updateEmailOrPassword((0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $9ad751dca565baab$export$21579262ef46735b(user, newPassword) {
    return $9ad751dca565baab$var$updateEmailOrPassword((0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $9ad751dca565baab$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $9ad751dca565baab$var$_logoutIfInvalidated(user, $9ad751dca565baab$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $9ad751dca565baab$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $9ad751dca565baab$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $9ad751dca565baab$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $9ad751dca565baab$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $9ad751dca565baab$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $9ad751dca565baab$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $9ad751dca565baab$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $9ad751dca565baab$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $9ad751dca565baab$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $9ad751dca565baab$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $9ad751dca565baab$var$FederatedAdditionalUserInfoWithUsername extends $9ad751dca565baab$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $9ad751dca565baab$var$FacebookAdditionalUserInfo extends $9ad751dca565baab$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $9ad751dca565baab$var$GithubAdditionalUserInfo extends $9ad751dca565baab$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $9ad751dca565baab$var$GoogleAdditionalUserInfo extends $9ad751dca565baab$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $9ad751dca565baab$var$TwitterAdditionalUserInfo extends $9ad751dca565baab$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $9ad751dca565baab$export$7a38258bbe170828(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $9ad751dca565baab$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $9ad751dca565baab$export$9e5f44173e64f162(auth, persistence) {
    return (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $9ad751dca565baab$export$625550452a3fa3ec(auth) {
    const authInternal = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    return authInternal.initializeRecaptchaConfig();
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $9ad751dca565baab$export$90a7f3efeed30595(auth, nextOrObserver, error, completed) {
    return (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $9ad751dca565baab$export$efccba1c4a2ef57b(auth, callback, onAbort) {
    return (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $9ad751dca565baab$export$d141bba7fdc215a3(auth, nextOrObserver, error, completed) {
    return (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $9ad751dca565baab$export$4a5767248b18ef41(auth) {
    (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $9ad751dca565baab$export$df995fae86a55f06(auth, user) {
    return (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $9ad751dca565baab$export$ef35774e6d314e91(auth) {
    return (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $9ad751dca565baab$export$e7094788287c5e9b(user) {
    return (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user).delete();
}
class $9ad751dca565baab$var$MultiFactorSessionImpl {
    constructor(type, credential, auth){
        this.type = type;
        this.credential = credential;
        this.auth = auth;
    }
    static _fromIdtoken(idToken, auth) {
        return new $9ad751dca565baab$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, auth);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $9ad751dca565baab$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $9ad751dca565baab$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $9ad751dca565baab$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $9ad751dca565baab$export$a33b77bbdbb8366c(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$9ad751dca565baab$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $9ad751dca565baab$export$91c6e00c14e7e6fd(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $9ad751dca565baab$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $9ad751dca565baab$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $9ad751dca565baab$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $9ad751dca565baab$export$91c6e00c14e7e6fd(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $9ad751dca565baab$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $9ad751dca565baab$export$8a5498727ef6be21(auth, error) {
    var _a;
    const authModular = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $9ad751dca565baab$export$91c6e00c14e7e6fd(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $9ad751dca565baab$export$91c6e00c14e7e6fd((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $9ad751dca565baab$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$startEnrollPhoneMfa(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
function $9ad751dca565baab$var$finalizeEnrollPhoneMfa(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
function $9ad751dca565baab$var$startEnrollTotpMfa(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
function $9ad751dca565baab$var$finalizeEnrollTotpMfa(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
function $9ad751dca565baab$var$withdrawMfa(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
class $9ad751dca565baab$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$9ad751dca565baab$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $9ad751dca565baab$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $9ad751dca565baab$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user.auth);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $9ad751dca565baab$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $9ad751dca565baab$var$_logoutIfInvalidated(this.user, $9ad751dca565baab$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $9ad751dca565baab$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $9ad751dca565baab$export$d24c54395ce0c509(user) {
    const userModular = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    if (!$9ad751dca565baab$var$multiFactorUserCache.has(userModular)) $9ad751dca565baab$var$multiFactorUserCache.set(userModular, $9ad751dca565baab$var$MultiFactorUserImpl._fromUser(userModular));
    return $9ad751dca565baab$var$multiFactorUserCache.get(userModular);
}
const $9ad751dca565baab$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $9ad751dca565baab$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($9ad751dca565baab$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($9ad751dca565baab$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$_iframeCannotSyncWebStorage() {
    const ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)();
    return $9ad751dca565baab$var$_isSafari(ua) || $9ad751dca565baab$export$493d36ec626b6698(ua);
}
// The polling period in case events are not supported
const $9ad751dca565baab$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $9ad751dca565baab$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $9ad751dca565baab$var$BrowserLocalPersistence extends $9ad751dca565baab$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = $9ad751dca565baab$var$_iframeCannotSyncWebStorage() && $9ad751dca565baab$var$_isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $9ad751dca565baab$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) // Value changed from current value.
                this.storage.setItem(key, event.newValue);
                else // Current value deleted.
                this.storage.removeItem(key);
            } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
            return;
        }
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($9ad751dca565baab$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $9ad751dca565baab$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $9ad751dca565baab$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$9ad751dca565baab$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $9ad751dca565baab$export$8b22cf2602fb60ce = $9ad751dca565baab$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$BrowserSessionPersistence extends $9ad751dca565baab$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$9ad751dca565baab$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $9ad751dca565baab$export$407448d2b89b1813 = $9ad751dca565baab$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $9ad751dca565baab$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $9ad751dca565baab$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $9ad751dca565baab$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $9ad751dca565baab$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$9ad751dca565baab$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$export$91477dc880baac21(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $9ad751dca565baab$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $9ad751dca565baab$export$91477dc880baac21("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $9ad751dca565baab$var$_window() {
    return window;
}
function $9ad751dca565baab$var$_setWindowLocation(url) {
    $9ad751dca565baab$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$_isWorker() {
    return typeof $9ad751dca565baab$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $9ad751dca565baab$var$_window()["importScripts"] === "function";
}
async function $9ad751dca565baab$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $9ad751dca565baab$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $9ad751dca565baab$var$_getWorkerGlobalScope() {
    return $9ad751dca565baab$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$DB_NAME = "firebaseLocalStorageDb";
const $9ad751dca565baab$var$DB_VERSION = 1;
const $9ad751dca565baab$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $9ad751dca565baab$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $9ad751dca565baab$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $9ad751dca565baab$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $9ad751dca565baab$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($9ad751dca565baab$var$DB_OBJECTSTORE_NAME);
}
function $9ad751dca565baab$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($9ad751dca565baab$var$DB_NAME);
    return new $9ad751dca565baab$var$DBPromise(request).toPromise();
}
function $9ad751dca565baab$var$_openDatabase() {
    const request = indexedDB.open($9ad751dca565baab$var$DB_NAME, $9ad751dca565baab$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($9ad751dca565baab$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $9ad751dca565baab$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($9ad751dca565baab$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $9ad751dca565baab$var$_deleteDatabase();
                resolve(await $9ad751dca565baab$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $9ad751dca565baab$var$_putObject(db, key, value) {
    const request = $9ad751dca565baab$var$getObjectStore(db, true).put({
        [$9ad751dca565baab$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $9ad751dca565baab$var$DBPromise(request).toPromise();
}
async function $9ad751dca565baab$var$getObject(db, key) {
    const request = $9ad751dca565baab$var$getObjectStore(db, false).get(key);
    const data = await new $9ad751dca565baab$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $9ad751dca565baab$var$_deleteObject(db, key) {
    const request = $9ad751dca565baab$var$getObjectStore(db, true).delete(key);
    return new $9ad751dca565baab$var$DBPromise(request).toPromise();
}
const $9ad751dca565baab$var$_POLLING_INTERVAL_MS = 800;
const $9ad751dca565baab$var$_TRANSACTION_RETRY_COUNT = 3;
class $9ad751dca565baab$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $9ad751dca565baab$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $9ad751dca565baab$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $9ad751dca565baab$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $9ad751dca565baab$var$Receiver._getInstance($9ad751dca565baab$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $9ad751dca565baab$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $9ad751dca565baab$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $9ad751dca565baab$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $9ad751dca565baab$var$_openDatabase();
            await $9ad751dca565baab$var$_putObject(db, $9ad751dca565baab$var$STORAGE_AVAILABLE_KEY, "1");
            await $9ad751dca565baab$var$_deleteObject(db, $9ad751dca565baab$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$9ad751dca565baab$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$9ad751dca565baab$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$9ad751dca565baab$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $9ad751dca565baab$var$getObjectStore(db, false).getAll();
            return new $9ad751dca565baab$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $9ad751dca565baab$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$9ad751dca565baab$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $9ad751dca565baab$export$23f2a1d2818174ef = $9ad751dca565baab$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$startSignInPhoneMfa(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
function $9ad751dca565baab$var$finalizeSignInPhoneMfa(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
function $9ad751dca565baab$var$finalizeSignInTotpMfa(auth, request) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $9ad751dca565baab$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$_SOLVE_TIME_MS = 500;
const $9ad751dca565baab$var$_EXPIRATION_TIME_MS = 60000;
const $9ad751dca565baab$var$_WIDGET_ID_START = 1000000000000;
class $9ad751dca565baab$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $9ad751dca565baab$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $9ad751dca565baab$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $9ad751dca565baab$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $9ad751dca565baab$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $9ad751dca565baab$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $9ad751dca565baab$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $9ad751dca565baab$export$91c6e00c14e7e6fd(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $9ad751dca565baab$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $9ad751dca565baab$var$_EXPIRATION_TIME_MS);
        }, $9ad751dca565baab$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $9ad751dca565baab$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $9ad751dca565baab$var$_JSLOAD_CALLBACK = $9ad751dca565baab$var$_generateCallbackName("rcb");
const $9ad751dca565baab$var$NETWORK_TIMEOUT_DELAY = new $9ad751dca565baab$var$Delay(30000, 60000);
const $9ad751dca565baab$var$RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $9ad751dca565baab$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $9ad751dca565baab$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = "") {
        $9ad751dca565baab$export$91c6e00c14e7e6fd($9ad751dca565baab$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $9ad751dca565baab$var$isV2($9ad751dca565baab$var$_window().grecaptcha)) return Promise.resolve($9ad751dca565baab$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $9ad751dca565baab$var$_window().setTimeout(()=>{
                reject($9ad751dca565baab$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $9ad751dca565baab$var$NETWORK_TIMEOUT_DELAY.get());
            $9ad751dca565baab$var$_window()[$9ad751dca565baab$var$_JSLOAD_CALLBACK] = ()=>{
                $9ad751dca565baab$var$_window().clearTimeout(networkTimeout);
                delete $9ad751dca565baab$var$_window()[$9ad751dca565baab$var$_JSLOAD_CALLBACK];
                const recaptcha = $9ad751dca565baab$var$_window().grecaptcha;
                if (!recaptcha || !$9ad751dca565baab$var$isV2(recaptcha)) {
                    reject($9ad751dca565baab$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$9ad751dca565baab$var$RECAPTCHA_BASE}?${(0, $4556d6db4eb60619$export$ac4103b836844853)({
                onload: $9ad751dca565baab$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $9ad751dca565baab$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($9ad751dca565baab$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $9ad751dca565baab$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $9ad751dca565baab$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $9ad751dca565baab$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $9ad751dca565baab$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $9ad751dca565baab$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @public
 */ class $9ad751dca565baab$export$db202ddc8be9136 {
    /**
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     */ constructor(containerOrId, parameters = Object.assign({}, $9ad751dca565baab$var$DEFAULT_PARAMS), authExtern){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $9ad751dca565baab$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $9ad751dca565baab$export$a33b77bbdbb8366c(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $9ad751dca565baab$export$91c6e00c14e7e6fd(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $9ad751dca565baab$var$MockReCaptchaLoaderImpl() : new $9ad751dca565baab$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $9ad751dca565baab$export$91c6e00c14e7e6fd(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $9ad751dca565baab$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $9ad751dca565baab$export$91c6e00c14e7e6fd($9ad751dca565baab$var$_isHttpOrHttps() && !$9ad751dca565baab$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $9ad751dca565baab$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $9ad751dca565baab$var$getRecaptchaParams(this.auth);
        $9ad751dca565baab$export$91c6e00c14e7e6fd(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $9ad751dca565baab$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $9ad751dca565baab$export$3a1a48c8f6ef640e._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $9ad751dca565baab$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    const authInternal = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    const verificationId = await $9ad751dca565baab$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(appVerifier));
    return new $9ad751dca565baab$var$ConfirmationResultImpl(verificationId, (cred)=>$9ad751dca565baab$export$3d8c2f653ac9d0b9(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $9ad751dca565baab$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    await $9ad751dca565baab$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $9ad751dca565baab$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(appVerifier));
    return new $9ad751dca565baab$var$ConfirmationResultImpl(verificationId, (cred)=>$9ad751dca565baab$export$34aec0b863436764(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $9ad751dca565baab$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    const verificationId = await $9ad751dca565baab$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(appVerifier));
    return new $9ad751dca565baab$var$ConfirmationResultImpl(verificationId, (cred)=>$9ad751dca565baab$export$3c2fa207a37baaea(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $9ad751dca565baab$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $9ad751dca565baab$export$91c6e00c14e7e6fd(verifier.type === $9ad751dca565baab$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $9ad751dca565baab$export$91c6e00c14e7e6fd(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $9ad751dca565baab$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $9ad751dca565baab$export$91c6e00c14e7e6fd(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $9ad751dca565baab$export$91c6e00c14e7e6fd(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $9ad751dca565baab$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $9ad751dca565baab$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $9ad751dca565baab$export$3b14a55fb2447963(user, credential) {
    await $9ad751dca565baab$var$_link$1((0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $9ad751dca565baab$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $9ad751dca565baab$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $9ad751dca565baab$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $9ad751dca565baab$export$3a1a48c8f6ef640e._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $9ad751dca565baab$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $9ad751dca565baab$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $9ad751dca565baab$export$3a1a48c8f6ef640e._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $9ad751dca565baab$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $9ad751dca565baab$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $9ad751dca565baab$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $9ad751dca565baab$export$890c4ad488842ce7(resolverOverride);
    $9ad751dca565baab$export$91c6e00c14e7e6fd(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$IdpCredential extends $9ad751dca565baab$export$b4171a6734a65d42 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $9ad751dca565baab$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $9ad751dca565baab$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $9ad751dca565baab$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $9ad751dca565baab$var$_signIn(params) {
    return $9ad751dca565baab$var$_signInWithCredential(params.auth, new $9ad751dca565baab$var$IdpCredential(params), params.bypassAuthState);
}
function $9ad751dca565baab$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $9ad751dca565baab$export$91c6e00c14e7e6fd(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $9ad751dca565baab$var$_reauthenticate(user, new $9ad751dca565baab$var$IdpCredential(params), params.bypassAuthState);
}
async function $9ad751dca565baab$var$_link(params) {
    const { auth: auth, user: user } = params;
    $9ad751dca565baab$export$91c6e00c14e7e6fd(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $9ad751dca565baab$var$_link$1(user, new $9ad751dca565baab$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $9ad751dca565baab$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $9ad751dca565baab$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $9ad751dca565baab$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $9ad751dca565baab$var$_reauth;
            default:
                $9ad751dca565baab$export$d66dc83d8cfc8dd(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $9ad751dca565baab$export$6554612db691658e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $9ad751dca565baab$export$6554612db691658e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $9ad751dca565baab$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */ async function $9ad751dca565baab$export$db3b6bfb95261072(auth, provider, resolver) {
    const authInternal = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    $9ad751dca565baab$var$_assertInstanceOf(auth, provider, $9ad751dca565baab$var$FederatedAuthProvider);
    const resolverInternal = $9ad751dca565baab$var$_withDefaultResolver(authInternal, resolver);
    const action = new $9ad751dca565baab$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $9ad751dca565baab$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    $9ad751dca565baab$var$_assertInstanceOf(userInternal.auth, provider, $9ad751dca565baab$var$FederatedAuthProvider);
    const resolverInternal = $9ad751dca565baab$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $9ad751dca565baab$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $9ad751dca565baab$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    $9ad751dca565baab$var$_assertInstanceOf(userInternal.auth, provider, $9ad751dca565baab$var$FederatedAuthProvider);
    const resolverInternal = $9ad751dca565baab$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $9ad751dca565baab$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $9ad751dca565baab$var$PopupOperation extends $9ad751dca565baab$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($9ad751dca565baab$var$PopupOperation.currentPopupAction) $9ad751dca565baab$var$PopupOperation.currentPopupAction.cancel();
        $9ad751dca565baab$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $9ad751dca565baab$export$91c6e00c14e7e6fd(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $9ad751dca565baab$export$6554612db691658e(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $9ad751dca565baab$export$91477dc880baac21();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($9ad751dca565baab$export$3d12bd131bb975d1(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($9ad751dca565baab$export$3d12bd131bb975d1(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $9ad751dca565baab$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($9ad751dca565baab$export$3d12bd131bb975d1(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $9ad751dca565baab$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$9ad751dca565baab$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $9ad751dca565baab$var$redirectOutcomeMap = new Map();
class $9ad751dca565baab$var$RedirectAction extends $9ad751dca565baab$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $9ad751dca565baab$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $9ad751dca565baab$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $9ad751dca565baab$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $9ad751dca565baab$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $9ad751dca565baab$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $9ad751dca565baab$var$pendingRedirectKey(auth);
    const persistence = $9ad751dca565baab$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $9ad751dca565baab$var$_setPendingRedirectStatus(resolver, auth) {
    return $9ad751dca565baab$var$resolverPersistence(resolver)._set($9ad751dca565baab$var$pendingRedirectKey(auth), "true");
}
function $9ad751dca565baab$export$53a70dd1ebbae346() {
    $9ad751dca565baab$var$redirectOutcomeMap.clear();
}
function $9ad751dca565baab$export$cf2f7c5792f80b46(auth, result) {
    $9ad751dca565baab$var$redirectOutcomeMap.set(auth._key(), result);
}
function $9ad751dca565baab$var$resolverPersistence(resolver) {
    return $9ad751dca565baab$export$890c4ad488842ce7(resolver._redirectPersistence);
}
function $9ad751dca565baab$var$pendingRedirectKey(auth) {
    return $9ad751dca565baab$export$24baa2b76016ce0e($9ad751dca565baab$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $9ad751dca565baab$export$2d1720544b23b823(auth, provider, resolver) {
    return $9ad751dca565baab$var$_signInWithRedirect(auth, provider, resolver);
}
async function $9ad751dca565baab$var$_signInWithRedirect(auth, provider, resolver) {
    const authInternal = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    $9ad751dca565baab$var$_assertInstanceOf(auth, provider, $9ad751dca565baab$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $9ad751dca565baab$var$_withDefaultResolver(authInternal, resolver);
    await $9ad751dca565baab$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $9ad751dca565baab$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $9ad751dca565baab$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $9ad751dca565baab$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    $9ad751dca565baab$var$_assertInstanceOf(userInternal.auth, provider, $9ad751dca565baab$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $9ad751dca565baab$var$_withDefaultResolver(userInternal.auth, resolver);
    await $9ad751dca565baab$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $9ad751dca565baab$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */ function $9ad751dca565baab$export$39b482c5e57630a8(user, provider, resolver) {
    return $9ad751dca565baab$var$_linkWithRedirect(user, provider, resolver);
}
async function $9ad751dca565baab$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(user);
    $9ad751dca565baab$var$_assertInstanceOf(userInternal.auth, provider, $9ad751dca565baab$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $9ad751dca565baab$var$_withDefaultResolver(userInternal.auth, resolver);
    await $9ad751dca565baab$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $9ad751dca565baab$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $9ad751dca565baab$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $9ad751dca565baab$export$35e795649ee09318(auth, resolver) {
    await $9ad751dca565baab$export$a33b77bbdbb8366c(auth)._initializationPromise;
    return $9ad751dca565baab$export$158acd800e1ef08b(auth, resolver, false);
}
async function $9ad751dca565baab$export$158acd800e1ef08b(auth, resolverExtern, bypassAuthState = false) {
    const authInternal = $9ad751dca565baab$export$a33b77bbdbb8366c(auth);
    const resolver = $9ad751dca565baab$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $9ad751dca565baab$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $9ad751dca565baab$var$prepareUserForRedirect(user) {
    const eventId = $9ad751dca565baab$export$91477dc880baac21(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $9ad751dca565baab$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $9ad751dca565baab$export$9d398bebfec1c039 {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$9ad751dca565baab$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$9ad751dca565baab$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($9ad751dca565baab$export$3d12bd131bb975d1(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $9ad751dca565baab$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($9ad751dca565baab$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($9ad751dca565baab$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $9ad751dca565baab$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $9ad751dca565baab$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $9ad751dca565baab$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $9ad751dca565baab$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9ad751dca565baab$export$9fa96a7d116ea3ce(auth, request = {}) {
    return $9ad751dca565baab$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $9ad751dca565baab$var$HTTP_REGEX = /^https?/;
async function $9ad751dca565baab$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $9ad751dca565baab$export$9fa96a7d116ea3ce(auth);
    for (const domain of authorizedDomains)try {
        if ($9ad751dca565baab$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $9ad751dca565baab$var$matchDomain(expected) {
    const currentUrl = $9ad751dca565baab$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$9ad751dca565baab$var$HTTP_REGEX.test(protocol)) return false;
    if ($9ad751dca565baab$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$NETWORK_TIMEOUT = new $9ad751dca565baab$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $9ad751dca565baab$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $9ad751dca565baab$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $9ad751dca565baab$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $9ad751dca565baab$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $9ad751dca565baab$var$resetUnloadedGapiModules();
                    reject($9ad751dca565baab$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $9ad751dca565baab$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $9ad751dca565baab$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $9ad751dca565baab$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $9ad751dca565baab$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $9ad751dca565baab$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($9ad751dca565baab$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $9ad751dca565baab$var$_loadJS(`https://apis.google.com/js/api.js?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $9ad751dca565baab$var$cachedGApiLoader = null;
        throw error;
    });
}
let $9ad751dca565baab$var$cachedGApiLoader = null;
function $9ad751dca565baab$var$_loadGapi(auth) {
    $9ad751dca565baab$var$cachedGApiLoader = $9ad751dca565baab$var$cachedGApiLoader || $9ad751dca565baab$var$loadGapi(auth);
    return $9ad751dca565baab$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$PING_TIMEOUT = new $9ad751dca565baab$var$Delay(5000, 15000);
const $9ad751dca565baab$var$IFRAME_PATH = "__/auth/iframe";
const $9ad751dca565baab$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $9ad751dca565baab$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $9ad751dca565baab$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $9ad751dca565baab$var$getIframeUrl(auth) {
    const config = auth.config;
    $9ad751dca565baab$export$91c6e00c14e7e6fd(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $9ad751dca565baab$var$_emulatorUrl(config, $9ad751dca565baab$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$9ad751dca565baab$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $8131ce578968fe17$export$31499a9cd224b78c)
    };
    const eid = $9ad751dca565baab$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $4556d6db4eb60619$export$ac4103b836844853)(params).slice(1)}`;
}
async function $9ad751dca565baab$var$_openIframe(auth) {
    const context = await $9ad751dca565baab$var$_loadGapi(auth);
    const gapi1 = $9ad751dca565baab$var$_window().gapi;
    $9ad751dca565baab$export$91c6e00c14e7e6fd(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $9ad751dca565baab$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $9ad751dca565baab$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $9ad751dca565baab$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $9ad751dca565baab$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $9ad751dca565baab$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $9ad751dca565baab$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $9ad751dca565baab$var$DEFAULT_WIDTH = 500;
const $9ad751dca565baab$var$DEFAULT_HEIGHT = 600;
const $9ad751dca565baab$var$TARGET_BLANK = "_blank";
const $9ad751dca565baab$var$FIREFOX_EMPTY_URL = "http://localhost";
class $9ad751dca565baab$export$9f4f30ee63539e24 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $9ad751dca565baab$var$_open(auth, url, name, width = $9ad751dca565baab$var$DEFAULT_WIDTH, height = $9ad751dca565baab$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $9ad751dca565baab$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $4556d6db4eb60619$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $9ad751dca565baab$var$_isChromeIOS(ua) ? $9ad751dca565baab$var$TARGET_BLANK : name;
    if ($9ad751dca565baab$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $9ad751dca565baab$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($9ad751dca565baab$var$_isIOSStandalone(ua) && target !== "_self") {
        $9ad751dca565baab$var$openAsNewWindowIOS(url || "", target);
        return new $9ad751dca565baab$export$9f4f30ee63539e24(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $9ad751dca565baab$export$91c6e00c14e7e6fd(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $9ad751dca565baab$export$9f4f30ee63539e24(newWin);
}
function $9ad751dca565baab$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $9ad751dca565baab$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $9ad751dca565baab$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $9ad751dca565baab$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function $9ad751dca565baab$export$92108d983e8ee699(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $9ad751dca565baab$export$91c6e00c14e7e6fd(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $9ad751dca565baab$export$91c6e00c14e7e6fd(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $8131ce578968fe17$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $9ad751dca565baab$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $4556d6db4eb60619$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $9ad751dca565baab$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$9ad751dca565baab$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : "";
    // Start at index 1 to skip the leading '&' in the query string
    return `${$9ad751dca565baab$var$getHandlerBase(auth)}?${(0, $4556d6db4eb60619$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $9ad751dca565baab$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$9ad751dca565baab$var$WIDGET_PATH}`;
    return $9ad751dca565baab$var$_emulatorUrl(config, $9ad751dca565baab$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $9ad751dca565baab$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $9ad751dca565baab$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $9ad751dca565baab$export$407448d2b89b1813;
        this._completeRedirectFn = $9ad751dca565baab$export$158acd800e1ef08b;
        this._overrideRedirectResult = $9ad751dca565baab$export$cf2f7c5792f80b46;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $9ad751dca565baab$export$6554612db691658e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = await $9ad751dca565baab$export$92108d983e8ee699(auth, provider, authType, $9ad751dca565baab$var$_getCurrentUrl(), eventId);
        return $9ad751dca565baab$var$_open(auth, url, $9ad751dca565baab$export$91477dc880baac21());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $9ad751dca565baab$export$92108d983e8ee699(auth, provider, authType, $9ad751dca565baab$var$_getCurrentUrl(), eventId);
        $9ad751dca565baab$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $9ad751dca565baab$export$6554612db691658e(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $9ad751dca565baab$var$_openIframe(auth);
        const manager = new $9ad751dca565baab$export$9d398bebfec1c039(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $9ad751dca565baab$export$91c6e00c14e7e6fd(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($9ad751dca565baab$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $9ad751dca565baab$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$9ad751dca565baab$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $9ad751dca565baab$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $9ad751dca565baab$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $9ad751dca565baab$var$_isMobileBrowser() || $9ad751dca565baab$var$_isSafari() || $9ad751dca565baab$export$493d36ec626b6698();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @public
 */ const $9ad751dca565baab$export$342063e11d6c3cad = $9ad751dca565baab$var$BrowserPopupRedirectResolver;
class $9ad751dca565baab$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $9ad751dca565baab$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $9ad751dca565baab$var$PhoneMultiFactorAssertionImpl extends $9ad751dca565baab$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $9ad751dca565baab$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $9ad751dca565baab$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $9ad751dca565baab$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $9ad751dca565baab$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $9ad751dca565baab$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $9ad751dca565baab$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $9ad751dca565baab$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $9ad751dca565baab$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $9ad751dca565baab$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        const mfaSession = session;
        $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof mfaSession.auth !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $9ad751dca565baab$var$startEnrollTotpMfa(mfaSession.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $9ad751dca565baab$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $9ad751dca565baab$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $9ad751dca565baab$var$TotpMultiFactorAssertionImpl extends $9ad751dca565baab$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $9ad751dca565baab$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $9ad751dca565baab$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(typeof this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $9ad751dca565baab$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $9ad751dca565baab$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $9ad751dca565baab$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $9ad751dca565baab$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($9ad751dca565baab$var$_isEmptyString(accountName) || $9ad751dca565baab$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($9ad751dca565baab$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
            if ($9ad751dca565baab$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $9ad751dca565baab$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $9ad751dca565baab$var$name = "@firebase/auth";
var $9ad751dca565baab$var$version = "0.23.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ad751dca565baab$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $9ad751dca565baab$export$91c6e00c14e7e6fd(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ad751dca565baab$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        default:
            return undefined;
    }
}
/** @internal */ function $9ad751dca565baab$var$registerAuth(clientPlatform) {
    (0, $8131ce578968fe17$export$c930050e7bb63965)(new (0, $6d116dc7a5092865$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider = container.getProvider("app-check-internal");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $9ad751dca565baab$export$91c6e00c14e7e6fd(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $9ad751dca565baab$export$23ebac1979863676(clientPlatform)
        };
        const authInstance = new $9ad751dca565baab$export$a05254e7c3aeba6e(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $9ad751dca565baab$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $8131ce578968fe17$export$c930050e7bb63965)(new (0, $6d116dc7a5092865$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $9ad751dca565baab$export$a33b77bbdbb8366c(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $9ad751dca565baab$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $8131ce578968fe17$export$d29d5299a7137abc)($9ad751dca565baab$var$name, $9ad751dca565baab$var$version, $9ad751dca565baab$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $8131ce578968fe17$export$d29d5299a7137abc)($9ad751dca565baab$var$name, $9ad751dca565baab$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ad751dca565baab$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $9ad751dca565baab$var$authIdTokenMaxAge = (0, $4556d6db4eb60619$export$5539a1a3afe87d6)("authIdTokenMaxAge") || $9ad751dca565baab$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $9ad751dca565baab$var$lastPostedIdToken = null;
const $9ad751dca565baab$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $9ad751dca565baab$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($9ad751dca565baab$var$lastPostedIdToken === idToken) return;
        $9ad751dca565baab$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? "POST" : "DELETE",
            headers: idToken ? {
                "Authorization": `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $9ad751dca565baab$export$ae1af26003f05816(app = (0, $8131ce578968fe17$export$f9962582c9e66d99)()) {
    const provider = (0, $8131ce578968fe17$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $9ad751dca565baab$export$7f8ddf7c7c20b3cd(app, {
        popupRedirectResolver: $9ad751dca565baab$export$342063e11d6c3cad,
        persistence: [
            $9ad751dca565baab$export$23f2a1d2818174ef,
            $9ad751dca565baab$export$8b22cf2602fb60ce,
            $9ad751dca565baab$export$407448d2b89b1813
        ]
    });
    const authTokenSyncUrl = (0, $4556d6db4eb60619$export$5539a1a3afe87d6)("authTokenSyncURL");
    if (authTokenSyncUrl) {
        const mintCookie = $9ad751dca565baab$var$mintCookieFactory(authTokenSyncUrl);
        $9ad751dca565baab$export$efccba1c4a2ef57b(auth, mintCookie, ()=>mintCookie(auth.currentUser));
        $9ad751dca565baab$export$90a7f3efeed30595(auth, (user)=>mintCookie(user));
    }
    const authEmulatorHost = (0, $4556d6db4eb60619$export$9c11895284c8adad)("auth");
    if (authEmulatorHost) $9ad751dca565baab$export$9bb611d729802a56(auth, `http://${authEmulatorHost}`);
    return auth;
}
$9ad751dca565baab$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );














var $bbf3421649dca38a$var$name = "firebase";
var $bbf3421649dca38a$var$version = "9.23.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $8131ce578968fe17$export$d29d5299a7137abc)($bbf3421649dca38a$var$name, $bbf3421649dca38a$var$version, "app");





/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $0f33d186fe732c93$var$DEFAULT_HOST = "firebasestorage.googleapis.com";
/**
 * The key in Firebase config json for the storage bucket.
 */ const $0f33d186fe732c93$var$CONFIG_STORAGE_BUCKET_KEY = "storageBucket";
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $0f33d186fe732c93$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $0f33d186fe732c93$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const $0f33d186fe732c93$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $0f33d186fe732c93$export$697502632950e9d3 extends (0, $4556d6db4eb60619$export$dd24e9cd51226c56) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super($0f33d186fe732c93$var$prependCode(code), `Firebase Storage: ${message} (${$0f33d186fe732c93$var$prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $0f33d186fe732c93$export$697502632950e9d3.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $0f33d186fe732c93$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $0f33d186fe732c93$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($0f33d186fe732c93$export$54592d666d6ce114 || ($0f33d186fe732c93$export$54592d666d6ce114 = {}));
function $0f33d186fe732c93$var$prependCode(code) {
    return "storage/" + code;
}
function $0f33d186fe732c93$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.UNKNOWN, message);
}
function $0f33d186fe732c93$var$objectNotFound(path) {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $0f33d186fe732c93$var$quotaExceeded(bucket) {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + "https://firebase.google.com/pricing/.");
}
function $0f33d186fe732c93$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $0f33d186fe732c93$var$unauthorizedApp() {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.UNAUTHORIZED_APP, "This app does not have permission to access Firebase Storage on this project.");
}
function $0f33d186fe732c93$var$unauthorized(path) {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $0f33d186fe732c93$var$retryLimitExceeded() {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, "Max retry time for operation exceeded, please try again.");
}
function $0f33d186fe732c93$var$canceled() {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.CANCELED, "User canceled the upload/download.");
}
function $0f33d186fe732c93$var$invalidUrl(url) {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $0f33d186fe732c93$var$invalidDefaultBucket(bucket) {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $0f33d186fe732c93$var$noDefaultBucket() {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $0f33d186fe732c93$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $0f33d186fe732c93$var$cannotSliceBlob() {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.CANNOT_SLICE_BLOB, "Cannot slice blob for upload. Please retry the upload.");
}
function $0f33d186fe732c93$var$serverFileWrongSize() {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, "Server recorded incorrect upload file size, please retry the upload.");
}
function $0f33d186fe732c93$var$noDownloadURL() {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.NO_DOWNLOAD_URL, "The given file does not have any download URLs.");
}
function $0f33d186fe732c93$var$missingPolyFill(polyFill) {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function $0f33d186fe732c93$export$8f74d9881d1936fd(message) {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $0f33d186fe732c93$var$appDeleted() {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.APP_DELETED, "The Firebase app was deleted.");
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $0f33d186fe732c93$export$61f54cdc36500ad(name) {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $0f33d186fe732c93$var$invalidFormat(format, message) {
    return new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $0f33d186fe732c93$var$internalError(message) {
    throw new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.INTERNAL_ERROR, "Internal error: " + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $0f33d186fe732c93$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return "/b/" + encode(this.bucket) + "/o/" + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return "/b/" + encode(this.bucket) + "/o";
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $0f33d186fe732c93$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $0f33d186fe732c93$export$adb98fff6714334(bucketString, "");
        }
        if (bucketLocation.path === "") return bucketLocation;
        else throw $0f33d186fe732c93$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = "([A-Za-z0-9.\\-_]+)";
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === "/") loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = "(/(.*))?$";
        const gsRegex = new RegExp("^gs://" + bucketDomain + gsPath, "i");
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = "v[A-Za-z0-9_]+";
        const firebaseStorageHost = host.replace(/[.]/g, "\\.");
        const firebaseStoragePath = "(/([^?#]*).*)?$";
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, "i");
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $0f33d186fe732c93$var$DEFAULT_HOST ? "(?:storage.googleapis.com|storage.cloud.google.com)" : host;
        const cloudStoragePath = "([^?#]*)";
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, "i");
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = "";
                location = new $0f33d186fe732c93$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $0f33d186fe732c93$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $0f33d186fe732c93$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $0f33d186fe732c93$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $0f33d186fe732c93$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f33d186fe732c93$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $0f33d186fe732c93$var$isFunction(p) {
    return typeof p === "function";
}
function $0f33d186fe732c93$var$isNonArrayObject(p) {
    return typeof p === "object" && !Array.isArray(p);
}
function $0f33d186fe732c93$var$isString(p) {
    return typeof p === "string" || p instanceof String;
}
function $0f33d186fe732c93$var$isNativeBlob(p) {
    return $0f33d186fe732c93$var$isNativeBlobDefined() && p instanceof Blob;
}
function $0f33d186fe732c93$var$isNativeBlobDefined() {
    // Note: The `isNode()` check can be removed when `node-fetch` adds native Blob support
    // PR: https://github.com/node-fetch/node-fetch/pull/1664
    return typeof Blob !== "undefined" && !(0, $4556d6db4eb60619$export$8ee0fc9ee280b4ee)();
}
function $0f33d186fe732c93$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $0f33d186fe732c93$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $0f33d186fe732c93$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f33d186fe732c93$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $0f33d186fe732c93$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = "?";
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + "=" + encode(params[key]);
        queryPart = queryPart + nextPart + "&";
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error codes for requests made by the the XhrIo wrapper.
 */ var $0f33d186fe732c93$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($0f33d186fe732c93$var$ErrorCode || ($0f33d186fe732c93$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $0f33d186fe732c93$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $0f33d186fe732c93$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $0f33d186fe732c93$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $0f33d186fe732c93$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || $0f33d186fe732c93$var$isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === $0f33d186fe732c93$var$ErrorCode.ABORT;
                    backoffCallback(false, new $0f33d186fe732c93$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $0f33d186fe732c93$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($0f33d186fe732c93$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $0f33d186fe732c93$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $0f33d186fe732c93$var$appDeleted() : $0f33d186fe732c93$var$canceled();
                    reject(err);
                } else {
                    const err = $0f33d186fe732c93$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $0f33d186fe732c93$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $0f33d186fe732c93$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $0f33d186fe732c93$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $0f33d186fe732c93$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $0f33d186fe732c93$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers["Authorization"] = "Firebase " + authToken;
}
function $0f33d186fe732c93$var$addVersionHeader_(headers, firebaseVersion) {
    headers["X-Firebase-Storage-Version"] = "webjs/" + (firebaseVersion !== null && firebaseVersion !== void 0 ? firebaseVersion : "AppManager");
}
function $0f33d186fe732c93$var$addGmpidHeader_(headers, appId) {
    if (appId) headers["X-Firebase-GMPID"] = appId;
}
function $0f33d186fe732c93$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers["X-Firebase-AppCheck"] = appCheckToken;
}
function $0f33d186fe732c93$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true) {
    const queryPart = $0f33d186fe732c93$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $0f33d186fe732c93$var$addGmpidHeader_(headers, appId);
    $0f33d186fe732c93$var$addAuthHeader_(headers, authToken);
    $0f33d186fe732c93$var$addVersionHeader_(headers, firebaseVersion);
    $0f33d186fe732c93$var$addAppCheckHeader_(headers, appCheckToken);
    return new $0f33d186fe732c93$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f33d186fe732c93$var$getBlobBuilder() {
    if (typeof BlobBuilder !== "undefined") return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== "undefined") return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $0f33d186fe732c93$var$getBlob$1(...args) {
    const BlobBuilder1 = $0f33d186fe732c93$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($0f33d186fe732c93$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $0f33d186fe732c93$export$697502632950e9d3($0f33d186fe732c93$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $0f33d186fe732c93$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $0f33d186fe732c93$var$decodeBase64(encoded) {
    if (typeof atob === "undefined") throw $0f33d186fe732c93$var$missingPolyFill("base-64");
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $0f33d186fe732c93$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: "raw",
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: "base64",
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: "base64url",
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: "data_url"
};
class $0f33d186fe732c93$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $0f33d186fe732c93$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $0f33d186fe732c93$export$f22e7fe56db8ae03.RAW:
            return new $0f33d186fe732c93$var$StringData($0f33d186fe732c93$var$utf8Bytes_(stringData));
        case $0f33d186fe732c93$export$f22e7fe56db8ae03.BASE64:
        case $0f33d186fe732c93$export$f22e7fe56db8ae03.BASE64URL:
            return new $0f33d186fe732c93$var$StringData($0f33d186fe732c93$var$base64Bytes_(format, stringData));
        case $0f33d186fe732c93$export$f22e7fe56db8ae03.DATA_URL:
            return new $0f33d186fe732c93$var$StringData($0f33d186fe732c93$var$dataURLBytes_(stringData), $0f33d186fe732c93$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $0f33d186fe732c93$var$unknown();
}
function $0f33d186fe732c93$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $0f33d186fe732c93$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $0f33d186fe732c93$var$invalidFormat($0f33d186fe732c93$export$f22e7fe56db8ae03.DATA_URL, "Malformed data URL.");
    }
    return $0f33d186fe732c93$var$utf8Bytes_(decoded);
}
function $0f33d186fe732c93$var$base64Bytes_(format, value) {
    switch(format){
        case $0f33d186fe732c93$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf("-") !== -1;
                const hasUnder = value.indexOf("_") !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? "-" : "_";
                    throw $0f33d186fe732c93$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $0f33d186fe732c93$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf("+") !== -1;
                const hasSlash = value.indexOf("/") !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? "+" : "/";
                    throw $0f33d186fe732c93$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, "+").replace(/_/g, "/");
                break;
            }
    }
    let bytes;
    try {
        bytes = $0f33d186fe732c93$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes("polyfill")) throw e;
        throw $0f33d186fe732c93$var$invalidFormat(format, "Invalid character found");
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $0f33d186fe732c93$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $0f33d186fe732c93$var$invalidFormat($0f33d186fe732c93$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $0f33d186fe732c93$var$endsWith(middle, ";base64");
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(",") + 1);
    }
}
function $0f33d186fe732c93$var$dataURLBytes_(dataUrl) {
    const parts = new $0f33d186fe732c93$var$DataURLParts(dataUrl);
    if (parts.base64) return $0f33d186fe732c93$var$base64Bytes_($0f33d186fe732c93$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $0f33d186fe732c93$var$percentEncodedBytes_(parts.rest);
}
function $0f33d186fe732c93$var$dataURLContentType_(dataUrl) {
    const parts = new $0f33d186fe732c93$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $0f33d186fe732c93$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $0f33d186fe732c93$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = "";
        if ($0f33d186fe732c93$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($0f33d186fe732c93$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $0f33d186fe732c93$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $0f33d186fe732c93$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $0f33d186fe732c93$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($0f33d186fe732c93$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $0f33d186fe732c93$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $0f33d186fe732c93$export$8deea8629ff0b8a7($0f33d186fe732c93$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($0f33d186fe732c93$var$isString(val)) return $0f33d186fe732c93$export$d80b9b5a2ccdd3e0($0f33d186fe732c93$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $0f33d186fe732c93$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $0f33d186fe732c93$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($0f33d186fe732c93$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $0f33d186fe732c93$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf("/");
    if (index === -1) return "";
    const newPath = path.slice(0, index);
    return newPath;
}
function $0f33d186fe732c93$var$child(path, childPath) {
    const canonicalChildPath = childPath.split("/").filter((component)=>component.length > 0).join("/");
    if (path.length === 0) return canonicalChildPath;
    else return path + "/" + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $0f33d186fe732c93$var$lastComponent(path) {
    const index = path.lastIndexOf("/", path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f33d186fe732c93$var$noXform_(metadata, value) {
    return value;
}
class $0f33d186fe732c93$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $0f33d186fe732c93$var$noXform_;
    }
}
let $0f33d186fe732c93$var$mappings_ = null;
function $0f33d186fe732c93$var$xformPath(fullPath) {
    if (!$0f33d186fe732c93$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $0f33d186fe732c93$var$lastComponent(fullPath);
}
function $0f33d186fe732c93$var$getMappings() {
    if ($0f33d186fe732c93$var$mappings_) return $0f33d186fe732c93$var$mappings_;
    const mappings = [];
    mappings.push(new $0f33d186fe732c93$var$Mapping("bucket"));
    mappings.push(new $0f33d186fe732c93$var$Mapping("generation"));
    mappings.push(new $0f33d186fe732c93$var$Mapping("metageneration"));
    mappings.push(new $0f33d186fe732c93$var$Mapping("name", "fullPath", true));
    function mappingsXformPath(_metadata, fullPath) {
        return $0f33d186fe732c93$var$xformPath(fullPath);
    }
    const nameMapping = new $0f33d186fe732c93$var$Mapping("name");
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $0f33d186fe732c93$var$Mapping("size");
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $0f33d186fe732c93$var$Mapping("timeCreated"));
    mappings.push(new $0f33d186fe732c93$var$Mapping("updated"));
    mappings.push(new $0f33d186fe732c93$var$Mapping("md5Hash", null, true));
    mappings.push(new $0f33d186fe732c93$var$Mapping("cacheControl", null, true));
    mappings.push(new $0f33d186fe732c93$var$Mapping("contentDisposition", null, true));
    mappings.push(new $0f33d186fe732c93$var$Mapping("contentEncoding", null, true));
    mappings.push(new $0f33d186fe732c93$var$Mapping("contentLanguage", null, true));
    mappings.push(new $0f33d186fe732c93$var$Mapping("contentType", null, true));
    mappings.push(new $0f33d186fe732c93$var$Mapping("metadata", "customMetadata", true));
    $0f33d186fe732c93$var$mappings_ = mappings;
    return $0f33d186fe732c93$var$mappings_;
}
function $0f33d186fe732c93$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata["bucket"];
        const path = metadata["fullPath"];
        const loc = new $0f33d186fe732c93$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, "ref", {
        get: generateRef
    });
}
function $0f33d186fe732c93$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata["type"] = "file";
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $0f33d186fe732c93$var$addRef(metadata, service);
    return metadata;
}
function $0f33d186fe732c93$var$fromResourceString(service, resourceString, mappings) {
    const obj = $0f33d186fe732c93$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $0f33d186fe732c93$var$fromResource(service, resource, mappings);
}
function $0f33d186fe732c93$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $0f33d186fe732c93$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$0f33d186fe732c93$var$isString(obj["downloadTokens"])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj["downloadTokens"];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(",");
    const urls = tokensList.map((token)=>{
        const bucket = metadata["bucket"];
        const path = metadata["fullPath"];
        const urlPart = "/b/" + encode(bucket) + "/o/" + encode(path);
        const base = $0f33d186fe732c93$var$makeUrl(urlPart, host, protocol);
        const queryString = $0f33d186fe732c93$var$makeQueryString({
            alt: "media",
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $0f33d186fe732c93$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f33d186fe732c93$var$PREFIXES_KEY = "prefixes";
const $0f33d186fe732c93$var$ITEMS_KEY = "items";
function $0f33d186fe732c93$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource["nextPageToken"]
    };
    if (resource[$0f33d186fe732c93$var$PREFIXES_KEY]) for (const path of resource[$0f33d186fe732c93$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, "");
        const reference = service._makeStorageReference(new $0f33d186fe732c93$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$0f33d186fe732c93$var$ITEMS_KEY]) for (const item of resource[$0f33d186fe732c93$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $0f33d186fe732c93$export$adb98fff6714334(bucket, item["name"]));
        listResult.items.push(reference);
    }
    return listResult;
}
function $0f33d186fe732c93$var$fromResponseString(service, bucket, resourceString) {
    const obj = $0f33d186fe732c93$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $0f33d186fe732c93$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $0f33d186fe732c93$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $0f33d186fe732c93$var$handlerCheck(cndn) {
    if (!cndn) throw $0f33d186fe732c93$var$unknown();
}
function $0f33d186fe732c93$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $0f33d186fe732c93$var$fromResourceString(service, text, mappings);
        $0f33d186fe732c93$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $0f33d186fe732c93$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $0f33d186fe732c93$var$fromResponseString(service, bucket, text);
        $0f33d186fe732c93$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $0f33d186fe732c93$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $0f33d186fe732c93$var$fromResourceString(service, text, mappings);
        $0f33d186fe732c93$var$handlerCheck(metadata !== null);
        return $0f33d186fe732c93$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $0f33d186fe732c93$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes("Firebase App Check token is invalid")) newErr = $0f33d186fe732c93$var$unauthorizedApp();
            else newErr = $0f33d186fe732c93$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $0f33d186fe732c93$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $0f33d186fe732c93$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $0f33d186fe732c93$var$objectErrorHandler(location) {
    const shared = $0f33d186fe732c93$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $0f33d186fe732c93$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $0f33d186fe732c93$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $0f33d186fe732c93$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $0f33d186fe732c93$var$RequestInfo(url, method, $0f33d186fe732c93$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $0f33d186fe732c93$var$objectErrorHandler(location);
    return requestInfo;
}
function $0f33d186fe732c93$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams["prefix"] = "";
    else urlParams["prefix"] = location.path + "/";
    if (delimiter && delimiter.length > 0) urlParams["delimiter"] = delimiter;
    if (pageToken) urlParams["pageToken"] = pageToken;
    if (maxResults) urlParams["maxResults"] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $0f33d186fe732c93$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $0f33d186fe732c93$var$RequestInfo(url, method, $0f33d186fe732c93$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $0f33d186fe732c93$var$sharedErrorHandler(location);
    return requestInfo;
}
function $0f33d186fe732c93$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $0f33d186fe732c93$var$makeUrl(urlPart, service.host, service._protocol) + "?alt=media";
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $0f33d186fe732c93$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $0f33d186fe732c93$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers["Range"] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $0f33d186fe732c93$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $0f33d186fe732c93$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $0f33d186fe732c93$var$RequestInfo(url, method, $0f33d186fe732c93$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $0f33d186fe732c93$var$objectErrorHandler(location);
    return requestInfo;
}
function $0f33d186fe732c93$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $0f33d186fe732c93$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "PATCH";
    const body = $0f33d186fe732c93$var$toResourceString(metadata, mappings);
    const headers = {
        "Content-Type": "application/json; charset=utf-8"
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $0f33d186fe732c93$var$RequestInfo(url, method, $0f33d186fe732c93$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $0f33d186fe732c93$var$objectErrorHandler(location);
    return requestInfo;
}
function $0f33d186fe732c93$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $0f33d186fe732c93$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "DELETE";
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $0f33d186fe732c93$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $0f33d186fe732c93$var$objectErrorHandler(location);
    return requestInfo;
}
function $0f33d186fe732c93$var$determineContentType_(metadata, blob) {
    return metadata && metadata["contentType"] || blob && blob.type() || "application/octet-stream";
}
function $0f33d186fe732c93$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone["fullPath"] = location.path;
    metadataClone["size"] = blob.size();
    if (!metadataClone["contentType"]) metadataClone["contentType"] = $0f33d186fe732c93$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $0f33d186fe732c93$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        "X-Goog-Upload-Protocol": "multipart"
    };
    function genBoundary() {
        let str = "";
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers["Content-Type"] = "multipart/related; boundary=" + boundary;
    const metadata_ = $0f33d186fe732c93$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $0f33d186fe732c93$var$toResourceString(metadata_, mappings);
    const preBlobPart = "--" + boundary + "\r\n" + "Content-Type: application/json; charset=utf-8\r\n\r\n" + metadataString + "\r\n--" + boundary + "\r\n" + "Content-Type: " + metadata_["contentType"] + "\r\n\r\n";
    const postBlobPart = "\r\n--" + boundary + "--";
    const body = $0f33d186fe732c93$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $0f33d186fe732c93$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_["fullPath"]
    };
    const url = $0f33d186fe732c93$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $0f33d186fe732c93$var$RequestInfo(url, method, $0f33d186fe732c93$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $0f33d186fe732c93$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $0f33d186fe732c93$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $0f33d186fe732c93$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader("X-Goog-Upload-Status");
    } catch (e) {
        $0f33d186fe732c93$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        "active"
    ];
    $0f33d186fe732c93$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $0f33d186fe732c93$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $0f33d186fe732c93$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload["fullPath"]
    };
    const url = $0f33d186fe732c93$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "POST";
    const headers = {
        "X-Goog-Upload-Protocol": "resumable",
        "X-Goog-Upload-Command": "start",
        "X-Goog-Upload-Header-Content-Length": `${blob.size()}`,
        "X-Goog-Upload-Header-Content-Type": metadataForUpload["contentType"],
        "Content-Type": "application/json; charset=utf-8"
    };
    const body = $0f33d186fe732c93$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $0f33d186fe732c93$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader("X-Goog-Upload-URL");
        } catch (e) {
            $0f33d186fe732c93$var$handlerCheck(false);
        }
        $0f33d186fe732c93$var$handlerCheck($0f33d186fe732c93$var$isString(url));
        return url;
    }
    const requestInfo = new $0f33d186fe732c93$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $0f33d186fe732c93$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $0f33d186fe732c93$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        "X-Goog-Upload-Command": "query"
    };
    function handler(xhr) {
        const status = $0f33d186fe732c93$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader("X-Goog-Upload-Size-Received");
        } catch (e) {
            $0f33d186fe732c93$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $0f33d186fe732c93$var$handlerCheck(false);
        const size = Number(sizeString);
        $0f33d186fe732c93$var$handlerCheck(!isNaN(size));
        return new $0f33d186fe732c93$var$ResumableUploadStatus(size, blob.size(), status === "final");
    }
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $0f33d186fe732c93$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $0f33d186fe732c93$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $0f33d186fe732c93$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $0f33d186fe732c93$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $0f33d186fe732c93$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $0f33d186fe732c93$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = "";
    if (bytesToUpload === 0) uploadCommand = "finalize";
    else if (bytesLeft === bytesToUpload) uploadCommand = "upload, finalize";
    else uploadCommand = "upload";
    const headers = {
        "X-Goog-Upload-Command": uploadCommand,
        "X-Goog-Upload-Offset": `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $0f33d186fe732c93$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $0f33d186fe732c93$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === "final") metadata = $0f33d186fe732c93$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $0f33d186fe732c93$var$ResumableUploadStatus(newCurrent, size, uploadStatus === "final", metadata);
    }
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $0f33d186fe732c93$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $0f33d186fe732c93$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $0f33d186fe732c93$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: "state_changed"
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $0f33d186fe732c93$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: "running",
    /** The task was paused by the user. */ PAUSED: "paused",
    /** The task completed successfully. */ SUCCESS: "success",
    /** The task was canceled. */ CANCELED: "canceled",
    /** The task failed with an error. */ ERROR: "error"
};
function $0f33d186fe732c93$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $0f33d186fe732c93$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $0f33d186fe732c93$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $0f33d186fe732c93$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $0f33d186fe732c93$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $0f33d186fe732c93$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $0f33d186fe732c93$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f33d186fe732c93$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $0f33d186fe732c93$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error !== null && error !== void 0 ? error : undefined;
            this.complete = complete !== null && complete !== void 0 ? complete : undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $0f33d186fe732c93$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $0f33d186fe732c93$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $0f33d186fe732c93$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $0f33d186fe732c93$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener("abort", ()=>{
                this.errorCode_ = $0f33d186fe732c93$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener("error", ()=>{
                this.errorCode_ = $0f33d186fe732c93$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener("load", ()=>{
                resolve();
            });
        });
    }
    send(url, method, body, headers) {
        if (this.sent_) throw $0f33d186fe732c93$var$internalError("cannot .send() more than once");
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $0f33d186fe732c93$var$internalError("cannot .getErrorCode() before sending");
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $0f33d186fe732c93$var$internalError("cannot .getStatus() before sending");
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $0f33d186fe732c93$var$internalError("cannot .getResponse() before sending");
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $0f33d186fe732c93$var$internalError("cannot .getErrorText() before sending");
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener("progress", listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener("progress", listener);
    }
}
class $0f33d186fe732c93$var$XhrTextConnection extends $0f33d186fe732c93$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "text";
    }
}
function $0f33d186fe732c93$var$newTextConnection() {
    return $0f33d186fe732c93$var$textFactoryOverride ? $0f33d186fe732c93$var$textFactoryOverride() : new $0f33d186fe732c93$var$XhrTextConnection();
}
class $0f33d186fe732c93$var$XhrBytesConnection extends $0f33d186fe732c93$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "arraybuffer";
    }
}
function $0f33d186fe732c93$var$newBytesConnection() {
    return new $0f33d186fe732c93$var$XhrBytesConnection();
}
class $0f33d186fe732c93$var$XhrBlobConnection extends $0f33d186fe732c93$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "blob";
    }
}
function $0f33d186fe732c93$var$newBlobConnection() {
    return new $0f33d186fe732c93$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $0f33d186fe732c93$export$86a2a9b92406a048 {
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $0f33d186fe732c93$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals($0f33d186fe732c93$export$54592d666d6ce114.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if ($0f33d186fe732c93$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $0f33d186fe732c93$var$retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, $0f33d186fe732c93$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals($0f33d186fe732c93$export$54592d666d6ce114.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $0f33d186fe732c93$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $0f33d186fe732c93$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $0f33d186fe732c93$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $0f33d186fe732c93$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $0f33d186fe732c93$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $0f33d186fe732c93$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $0f33d186fe732c93$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $0f33d186fe732c93$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $0f33d186fe732c93$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $0f33d186fe732c93$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $0f33d186fe732c93$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $0f33d186fe732c93$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $0f33d186fe732c93$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $0f33d186fe732c93$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $0f33d186fe732c93$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new $0f33d186fe732c93$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($0f33d186fe732c93$var$taskStateFromInternalTaskState(this._state)){
                case $0f33d186fe732c93$export$9dc4203728a9a7c9.SUCCESS:
                    $0f33d186fe732c93$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $0f33d186fe732c93$export$9dc4203728a9a7c9.CANCELED:
                case $0f33d186fe732c93$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $0f33d186fe732c93$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $0f33d186fe732c93$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $0f33d186fe732c93$export$9dc4203728a9a7c9.RUNNING:
            case $0f33d186fe732c93$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $0f33d186fe732c93$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $0f33d186fe732c93$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $0f33d186fe732c93$var$async(observer.complete.bind(observer))();
                break;
            case $0f33d186fe732c93$export$9dc4203728a9a7c9.CANCELED:
            case $0f33d186fe732c93$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $0f33d186fe732c93$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $0f33d186fe732c93$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $0f33d186fe732c93$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $0f33d186fe732c93$export$adb98fff6714334) this._location = location;
        else this._location = $0f33d186fe732c93$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return "gs://" + this._location.bucket + "/" + this._location.path;
    }
    _newRef(service, location) {
        return new $0f33d186fe732c93$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $0f33d186fe732c93$export$adb98fff6714334(this._location.bucket, "");
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $0f33d186fe732c93$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $0f33d186fe732c93$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $0f33d186fe732c93$export$adb98fff6714334(this._location.bucket, newPath);
        return new $0f33d186fe732c93$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === "") throw $0f33d186fe732c93$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $0f33d186fe732c93$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot("getBytes");
    const requestInfo = $0f33d186fe732c93$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $0f33d186fe732c93$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $0f33d186fe732c93$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot("getBlob");
    const requestInfo = $0f33d186fe732c93$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $0f33d186fe732c93$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $0f33d186fe732c93$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot("uploadBytes");
    const requestInfo = $0f33d186fe732c93$var$multipartUpload(ref.storage, ref._location, $0f33d186fe732c93$var$getMappings(), new $0f33d186fe732c93$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $0f33d186fe732c93$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $0f33d186fe732c93$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot("uploadBytesResumable");
    return new $0f33d186fe732c93$export$86a2a9b92406a048(ref, new $0f33d186fe732c93$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $0f33d186fe732c93$var$uploadString$1(ref, value, format = $0f33d186fe732c93$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot("uploadString");
    const data = $0f33d186fe732c93$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = Object.assign({}, metadata);
    if (metadataClone["contentType"] == null && data.contentType != null) metadataClone["contentType"] = data.contentType;
    return $0f33d186fe732c93$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $0f33d186fe732c93$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $0f33d186fe732c93$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $0f33d186fe732c93$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $0f33d186fe732c93$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $0f33d186fe732c93$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $0f33d186fe732c93$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === "number") $0f33d186fe732c93$var$validateNumber("options.maxResults", /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $0f33d186fe732c93$var$list$2(ref.storage, ref._location, /*delimiter= */ "/", op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $0f33d186fe732c93$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $0f33d186fe732c93$var$getMetadata$1(ref) {
    ref._throwIfRoot("getMetadata");
    const requestInfo = $0f33d186fe732c93$var$getMetadata$2(ref.storage, ref._location, $0f33d186fe732c93$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $0f33d186fe732c93$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $0f33d186fe732c93$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot("updateMetadata");
    const requestInfo = $0f33d186fe732c93$var$updateMetadata$2(ref.storage, ref._location, metadata, $0f33d186fe732c93$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $0f33d186fe732c93$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $0f33d186fe732c93$var$getDownloadURL$1(ref) {
    ref._throwIfRoot("getDownloadURL");
    const requestInfo = $0f33d186fe732c93$var$getDownloadUrl(ref.storage, ref._location, $0f33d186fe732c93$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $0f33d186fe732c93$var$newTextConnection).then((url)=>{
        if (url === null) throw $0f33d186fe732c93$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $0f33d186fe732c93$var$deleteObject$1(ref) {
    ref._throwIfRoot("deleteObject");
    const requestInfo = $0f33d186fe732c93$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $0f33d186fe732c93$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $0f33d186fe732c93$var$_getChild$1(ref, childPath) {
    const newPath = $0f33d186fe732c93$var$child(ref._location.path, childPath);
    const location = new $0f33d186fe732c93$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $0f33d186fe732c93$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f33d186fe732c93$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $0f33d186fe732c93$var$refFromURL(service, url) {
    return new $0f33d186fe732c93$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $0f33d186fe732c93$var$refFromPath(ref, path) {
    if (ref instanceof $0f33d186fe732c93$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $0f33d186fe732c93$var$noDefaultBucket();
        const reference = new $0f33d186fe732c93$var$Reference(service, service._bucket);
        if (path != null) return $0f33d186fe732c93$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $0f33d186fe732c93$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $0f33d186fe732c93$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $0f33d186fe732c93$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $0f33d186fe732c93$var$FirebaseStorageImpl) return $0f33d186fe732c93$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $0f33d186fe732c93$export$8f74d9881d1936fd("To use ref(service, url), the first argument must be a Storage instance.");
    } else return $0f33d186fe732c93$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $0f33d186fe732c93$var$extractBucket(host, config) {
    const bucketString = config === null || config === void 0 ? void 0 : config[$0f33d186fe732c93$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $0f33d186fe732c93$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $0f33d186fe732c93$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    storage._protocol = "http";
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === "string" ? mockUserToken : (0, $4556d6db4eb60619$export$367bf224123348f1)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $0f33d186fe732c93$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $0f33d186fe732c93$var$DEFAULT_HOST;
        this._protocol = "https";
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $0f33d186fe732c93$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $0f33d186fe732c93$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $0f33d186fe732c93$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $0f33d186fe732c93$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $0f33d186fe732c93$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $0f33d186fe732c93$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $0f33d186fe732c93$var$validateNumber("time", /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $0f33d186fe732c93$var$validateNumber("time", /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $0f33d186fe732c93$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = $0f33d186fe732c93$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $0f33d186fe732c93$var$FailRequest($0f33d186fe732c93$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $0f33d186fe732c93$var$name = "@firebase/storage";
const $0f33d186fe732c93$var$version = "0.11.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $0f33d186fe732c93$var$STORAGE_TYPE = "storage";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $0f33d186fe732c93$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(ref);
    return $0f33d186fe732c93$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $0f33d186fe732c93$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(ref);
    return $0f33d186fe732c93$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $0f33d186fe732c93$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(ref);
    return $0f33d186fe732c93$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $0f33d186fe732c93$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(ref);
    return $0f33d186fe732c93$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $0f33d186fe732c93$export$8548546c0aa631e6(ref) {
    ref = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(ref);
    return $0f33d186fe732c93$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $0f33d186fe732c93$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(ref);
    return $0f33d186fe732c93$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $0f33d186fe732c93$export$8837f4fc672e936d(ref, options) {
    ref = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(ref);
    return $0f33d186fe732c93$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $0f33d186fe732c93$export$6a265a7d315dec03(ref) {
    ref = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(ref);
    return $0f33d186fe732c93$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $0f33d186fe732c93$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(ref);
    return $0f33d186fe732c93$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $0f33d186fe732c93$export$39c5ed4ec960eade(ref) {
    ref = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(ref);
    return $0f33d186fe732c93$var$deleteObject$1(ref);
}
function $0f33d186fe732c93$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(serviceOrRef);
    return $0f33d186fe732c93$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $0f33d186fe732c93$export$9acd24c0fce96a85(ref, childPath) {
    return $0f33d186fe732c93$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $0f33d186fe732c93$export$fbd9b57a66480737(app = (0, $8131ce578968fe17$export$f9962582c9e66d99)(), bucketUrl) {
    app = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(app);
    const storageProvider = (0, $8131ce578968fe17$export$fa0d6da0f5838f50)(app, $0f33d186fe732c93$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, $4556d6db4eb60619$export$a3febcf1f14a3a0c)("storage");
    if (emulator) $0f33d186fe732c93$export$9850e656f954b889(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $0f33d186fe732c93$export$9850e656f954b889(storage, host, port, options = {}) {
    $0f33d186fe732c93$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $0f33d186fe732c93$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $4556d6db4eb60619$export$4befe9b5fa509a1b)(ref);
    return $0f33d186fe732c93$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $0f33d186fe732c93$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error("getStream() is only supported by NodeJS builds");
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $0f33d186fe732c93$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider("app").getImmediate();
    const authProvider = container.getProvider("auth-internal");
    const appCheckProvider = container.getProvider("app-check-internal");
    return new $0f33d186fe732c93$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $8131ce578968fe17$export$31499a9cd224b78c));
}
function $0f33d186fe732c93$var$registerStorage() {
    (0, $8131ce578968fe17$export$c930050e7bb63965)(new (0, $6d116dc7a5092865$export$16fa2f45be04daa8)($0f33d186fe732c93$var$STORAGE_TYPE, $0f33d186fe732c93$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $8131ce578968fe17$export$d29d5299a7137abc)($0f33d186fe732c93$var$name, $0f33d186fe732c93$var$version, "");
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $8131ce578968fe17$export$d29d5299a7137abc)($0f33d186fe732c93$var$name, $0f33d186fe732c93$var$version, "esm2017");
}
$0f33d186fe732c93$var$registerStorage();





const $e4ee9ee9945bfcc1$var$firebaseConfig = {
    apiKey: "AIzaSyCL_K3kfTmXMN8kP0UZRLikZMydHQkUyFE",
    authDomain: "beta.getcookbook.io",
    projectId: "cookbook-beta-46bc5",
    storageBucket: "ookbook-beta-46bc5.appspot.com"
};
const $e4ee9ee9945bfcc1$export$2cd8252107eb640b = ()=>(0, $8131ce578968fe17$export$c55cfd413944906d)($e4ee9ee9945bfcc1$var$firebaseConfig);
const $e4ee9ee9945bfcc1$export$58b3679c46e6370d = async (file)=>{
    return new Promise((resolve, reject)=>{
        const app = (0, $8131ce578968fe17$export$f9962582c9e66d99)();
        const storage = (0, $0f33d186fe732c93$export$fbd9b57a66480737)(app);
        const ext = file.type.split("/")[1];
        const metadata = {
            contentType: file.type
        };
        // https://firebase.google.com/docs/storage/web/create-reference
        const imagesRef = (0, $0f33d186fe732c93$export$eff4d24c3ff7876e)(storage, `images/banner/${(0, $d827eaefca5d884a$export$2e2bcd8739ae039)()}.${ext}`);
        (0, $0f33d186fe732c93$export$ac40f56b52f99dd1)(imagesRef, file, metadata).then(()=>{
            (0, $0f33d186fe732c93$export$c8bf645a0c2a7d9f)(imagesRef).then((downloadURL)=>{
                resolve(downloadURL);
            });
        });
    });
};


(0, $e4ee9ee9945bfcc1$export$2cd8252107eb640b)();
const $2ac8aa4e378a4923$export$9535a95e0a14178f = (user)=>({
        id: user.uid,
        email: user.email,
        role: (0, $228ef9ae46c6f5ac$export$2e2bcd8739ae039).User
    });
// TODO clear unused functions
const $2ac8aa4e378a4923$var$retrieveToken = async ()=>{
    const auth = (0, $9ad751dca565baab$export$ae1af26003f05816)();
    if (!auth.currentUser) {
        console.error("auth", auth);
        throw new Error("Impossible to retrieve token");
    }
    const token = await auth.currentUser.getIdToken();
    (0, $e324a700d775dca8$export$57e714f81a2c3d86)(token);
};
const $2ac8aa4e378a4923$export$bfea3ca855201131 = async (email)=>{
    const auth = (0, $9ad751dca565baab$export$ae1af26003f05816)();
    await (0, $9ad751dca565baab$export$2219238a014317b0)(auth, email, window.location.href);
    await $2ac8aa4e378a4923$var$retrieveToken();
    return $2ac8aa4e378a4923$export$9535a95e0a14178f(auth.currentUser);
};
const $2ac8aa4e378a4923$export$a0973bcfe11b05c9 = async ()=>{
    const auth = (0, $9ad751dca565baab$export$ae1af26003f05816)();
    return await (0, $9ad751dca565baab$export$ef35774e6d314e91)(auth);
};
const $2ac8aa4e378a4923$export$9670d83f11d4b64a = async (token, email)=>{
    const auth = (0, $9ad751dca565baab$export$ae1af26003f05816)();
    await (0, $9ad751dca565baab$export$ce26c07117d59d6a)(auth, token);
    if (auth.currentUser) await (0, $9ad751dca565baab$export$3b513254972cfc9c)(auth.currentUser, email);
    await $2ac8aa4e378a4923$var$retrieveToken();
    return $2ac8aa4e378a4923$export$9535a95e0a14178f({
        ...auth.currentUser,
        email: email
    });
};
const $2ac8aa4e378a4923$export$403ed9a23f6abb2d = async ()=>{
    // https://firebase.google.com/docs/auth/web/auth-state-persistence
    const auth = (0, $9ad751dca565baab$export$ae1af26003f05816)();
    // await setPersistence(auth, browserLocalPersistence)
    await $2ac8aa4e378a4923$var$retrieveToken();
    return $2ac8aa4e378a4923$export$9535a95e0a14178f(auth.currentUser);
};
const $2ac8aa4e378a4923$export$45abfc3976589d02 = async ()=>{
    const auth = (0, $9ad751dca565baab$export$ae1af26003f05816)();
    if (auth.currentUser) await (0, $9ad751dca565baab$export$e7094788287c5e9b)(auth.currentUser);
};


const $2503a745c61c2eb7$var$useAuthentication = ()=>{
    const { isLoaded: isLoaded, signIn: signIn, setActive: setActive } = (0, $fdf8b244281e92e7$export$23b74bf0884fc372)();
    const { signUp: signUp } = (0, $c42a753ff181698a$export$c15557d6465f6121)();
    const { signOut: signOut, isSignedIn: isSignedIn, getToken: getToken } = (0, $ada25319dc58517a$export$1d39dc5b47e56ff0)();
    const { user: user } = (0, $23b3856353385633$export$23bbbc4533528f03)();
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const email = user?.primaryEmailAddress?.emailAddress ?? "";
    const linking = (0, $3QbnI.useRef)(true);
    // https://clerk.dev/docs/integration/firebase
    const linkToFirebase = (0, $3QbnI.useCallback)(async ()=>{
        if (linking.current) return;
        linking.current = true;
        try {
            const token = await getToken({
                template: "integration_firebase"
            });
            if (token) {
                const authenticatedUser = await $2ac8aa4e378a4923$export$9670d83f11d4b64a(token, email);
                dispatch((0, $68690f862a398578$export$596d806903d1f59e)(authenticatedUser));
            } else dispatch((0, $68690f862a398578$export$a0973bcfe11b05c9)());
        } catch (error) {
            dispatch((0, $68690f862a398578$export$a0973bcfe11b05c9)());
        }
    }, [
        getToken,
        dispatch,
        email
    ]);
    (0, $3QbnI.useEffect)(()=>{
        if (isSignedIn && !linking.current) linkToFirebase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSignedIn
    ]);
    return (0, $3QbnI.useMemo)(()=>({
            sendVerificationCodeForSignUp: async (email)=>{
                if (!isLoaded) throw new Error("not loaded");
                if (!signUp) throw new Error("signUp is null");
                console.log("email", email);
                const signUpAttempt = await signUp.create({
                    emailAddress: email
                });
                return await signUpAttempt.prepareEmailAddressVerification();
            },
            checkVerificationCodeForSignUp: async (code)=>{
                if (!isLoaded) throw new Error("not loaded");
                if (!signUp) throw new Error("signUp is null");
                linking.current = false;
                const { status: status, createdSessionId: createdSessionId } = await signUp.attemptEmailAddressVerification({
                    code: code
                });
                if (status !== "complete") throw new Error(status ?? "");
                setActive({
                    session: createdSessionId
                });
            },
            sendVerificationCodeForLogin: async (email)=>{
                if (!isLoaded) throw new Error("not loaded");
                console.log("email", email);
                const signInAttempt = await signIn.create({
                    identifier: email
                });
                const emailCodeFactor = signInAttempt.supportedFirstFactors.find((factor)=>factor.strategy === "email_code");
                await signInAttempt.prepareFirstFactor({
                    strategy: "email_code",
                    emailAddressId: emailCodeFactor.emailAddressId
                });
            },
            checkVerificationCodeForLogin: async (code)=>{
                if (!isLoaded) throw new Error("not loaded");
                linking.current = false;
                const { status: status, createdSessionId: createdSessionId } = await signIn.attemptFirstFactor({
                    strategy: "email_code",
                    code: code
                });
                if (status !== "complete") throw new Error(status ?? "");
                setActive({
                    session: createdSessionId
                });
            },
            checkSession: async ()=>{
                if (isSignedIn) linkToFirebase();
                else linking.current = false;
            },
            logout: async ()=>{
                await signOut();
                await $2ac8aa4e378a4923$export$a0973bcfe11b05c9();
                dispatch((0, $68690f862a398578$export$a0973bcfe11b05c9)());
            },
            isSignedIn: isSignedIn
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isLoaded,
        signIn,
        signOut,
        isSignedIn,
        setActive,
        dispatch
    ]);
};
var $2503a745c61c2eb7$export$2e2bcd8739ae039 = $2503a745c61c2eb7$var$useAuthentication;


const $f0c384bc416756be$var$Settings = ()=>{
    const { t: t, i18n: i18n } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const temperature = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $cb3b9bf6a0fb48f2$export$c477e9ee4c36462f));
    const automaticImport = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $cb3b9bf6a0fb48f2$export$6a52d4affff68ee8));
    const recipes = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $87c50e51b43ee465$export$3b86e2cc0677644d));
    const confirmDeleteAccountPopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)(false);
    const [error, setError] = (0, $3QbnI.useState)("");
    const [ingredientTemplate, changeIngredientTemplate] = (0, $f47422411e27ad9a$export$2e2bcd8739ae039)((0, $cb3b9bf6a0fb48f2$export$95e92655b1210e4b), (0, $cb3b9bf6a0fb48f2$export$8c38d409f26db51));
    const { logout: logout } = (0, $2503a745c61c2eb7$export$2e2bcd8739ae039)();
    const deleteAccountConfirmed = async ()=>{
        try {
            (0, $650b40fd3e752928$export$6b2a7d5132615086)("DeleteAccount");
            await dispatch((0, $87c50e51b43ee465$export$9d5822594f0e234)()).unwrap();
            // await dispatch(deleteAccount()).unwrap()
            (0, $650b40fd3e752928$export$6b2a7d5132615086)("DeleteAccountSuccess");
            await logout();
        } catch (error) {
            const exception = error;
            if (exception.code === "auth/requires-recent-login") setError("_For security reasons");
            (0, $650b40fd3e752928$export$6b2a7d5132615086)("DeleteAccountError");
        }
    };
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $bd914ef380e06327$export$2e2bcd8739ae039), {
        className: "md:w-auto space-y-6",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bd914ef380e06327$export$2e2bcd8739ae039).Item, {
                id: "languages",
                label: t("languages.Language"),
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $99a8eda2a8735c38$export$2e2bcd8739ae039), {
                    id: "languages",
                    name: "languages",
                    className: "mt-1",
                    defaultValue: i18n.language,
                    onChange: (language)=>i18n.changeLanguage(language),
                    options: (0, $c3738d05463420c7$export$d0d68bb9ed2c643d)
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bd914ef380e06327$export$2e2bcd8739ae039).Item, {
                id: "temperature",
                label: t("settings.temperatures.Temperatures unit in recipes"),
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $99a8eda2a8735c38$export$2e2bcd8739ae039), {
                    id: "temperature",
                    name: "temperature",
                    className: "mt-1",
                    defaultValue: temperature,
                    onChange: (value)=>dispatch((0, $cb3b9bf6a0fb48f2$export$1ee9c5b316663b8d)(value)),
                    options: $15adcf4933c9d401$export$802db1fec2151c6.map(({ label: label, symbol: symbol, value: value })=>({
                            value: value,
                            label: `${t(label)} ${symbol}`
                        }))
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bd914ef380e06327$export$2e2bcd8739ae039).Item, {
                id: "export",
                label: t("settings.Export"),
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).White, {
                    id: "export",
                    name: "export",
                    className: "w-full mt-1 flex-1 flex justify-center !py-0 ",
                    onClick: async ()=>{
                        await (0, $c1e23b84fcfe63c2$export$2e2bcd8739ae039)(recipes, t);
                    },
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                            className: "!py-2.5",
                            children: t("settings.Download all your recipes")
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $1aaf2d418038901b$export$2e2bcd8739ae039), {
                            className: "h-5 w-5  ml-2"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f4566e13631be5b1$export$74a362b31437ec83), {
                as: "div",
                className: "pt-6",
                children: ({ open: open })=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f4566e13631be5b1$export$74a362b31437ec83).Button, {
                                className: "flex w-full items-start justify-between text-left text-gray-400",
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                    className: "font-medium text-primary-500 group-hover:text-indigo-900 text-sm",
                                    children: open ? t("settings.Hide advanced") : t("settings.Show advanced")
                                })
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $516f3ebf7dc9f3d4$export$be58926105124dd4), {
                                enter: "transition duration-100 ease-out",
                                enterFrom: "transform scale-95 opacity-0",
                                enterTo: "transform scale-100 opacity-100",
                                leave: "transition duration-75 ease-out",
                                leaveFrom: "transform scale-100 opacity-100",
                                leaveTo: "transform scale-95 opacity-0",
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $f4566e13631be5b1$export$74a362b31437ec83).Panel, {
                                    as: "div",
                                    className: "pt-2 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bd914ef380e06327$export$2e2bcd8739ae039).Item, {
                                            id: "template",
                                            label: t("settings.ingredient template"),
                                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $2b0c6bf8582a103a$export$2e2bcd8739ae039).Black, {
                                                type: "text",
                                                name: "template",
                                                id: "template",
                                                className: "mt-1",
                                                placeholder: "$1",
                                                value: ingredientTemplate,
                                                onChange: changeIngredientTemplate
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bd914ef380e06327$export$2e2bcd8739ae039).Item, {
                                            id: "import",
                                            label: t("_Automatic import"),
                                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bd914ef380e06327$export$2e2bcd8739ae039).Switch, {
                                                description: t("_If you click on new recipe with a valid url in your clipboard, it will be automatically imported."),
                                                checked: automaticImport,
                                                onChange: async (v)=>{
                                                    if (v) await navigator.clipboard.readText();
                                                    dispatch((0, $cb3b9bf6a0fb48f2$export$65467453d81927f1)(v));
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "pt-7",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    className: "relative ",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "relative flex w-[200%] transition-all duration-300",
                        style: {
                            left: confirmDeleteAccountPopup.isOpen ? "-100%" : "0%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "relative flex-1 flex ",
                                children: !confirmDeleteAccountPopup.isOpen && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Error, {
                                    className: "flex-1 flex justify-center !py-2.5",
                                    onClick: confirmDeleteAccountPopup.open,
                                    children: t("_Delete account")
                                })
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "relative flex-1 ",
                                children: confirmDeleteAccountPopup.isOpen && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                            className: "font-medium text-red-600 text-sm",
                                            children: t("_Do you really want to delete your account?")
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                            className: "font-medium text-red-600 text-xs pb-3",
                                            children: t("_This action is definitive.")
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                            className: "flex",
                                            children: error ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                                className: "text-sm font-bold ",
                                                children: t(error)
                                            }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Error, {
                                                        className: "flex-1 flex justify-center !py-2.5 mr-1",
                                                        onClick: deleteAccountConfirmed,
                                                        children: t("_Confirm")
                                                    }),
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Black, {
                                                        className: "flex-1 flex justify-center !py-2.5 ml-1",
                                                        onClick: confirmDeleteAccountPopup.close,
                                                        children: t("_Cancel")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $f0c384bc416756be$export$2e2bcd8739ae039 = $f0c384bc416756be$var$Settings;


const $23dbbbe06688e49f$var$SettingsPopup = ({ open: open, onClose: onClose })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        icon: (0, $9d5c67811f5faceb$export$2e2bcd8739ae039),
        title: t("_settings"),
        type: (0, $b9c536326972e77d$export$9656cfe2bd6e411f).Black,
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f0c384bc416756be$export$2e2bcd8739ae039), {})
    });
};
var $23dbbbe06688e49f$export$2e2bcd8739ae039 = $23dbbbe06688e49f$var$SettingsPopup;



const $5f0b2e9935864fb1$var$UserMenu = ()=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    const isStandalone = (0, $b8ecb772f887e697$export$2e2bcd8739ae039)();
    const [appInstallationEnabled, setAppInstallationEnabled] = (0, $3QbnI.useState)((0, $b79cf78f5d739e32$export$3ff5d50241ce5ce6)() && !isStandalone);
    (0, $ec37006dda574bbc$export$2e2bcd8739ae039)(()=>{
        setAppInstallationEnabled(!isStandalone);
    });
    const installApp = async (event)=>{
        const deferredPrompt = (0, $b79cf78f5d739e32$export$3ff5d50241ce5ce6)();
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome: outcome } = await deferredPrompt.userChoice;
            console.warn(`User response to the install prompt: ${outcome}`);
            (0, $b79cf78f5d739e32$export$1f9d975a37dc085)();
        } else {
            console.error("Impossible to install");
            event.preventDefault();
            event.stopPropagation();
        }
    };
    const helpPopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)(false);
    const settingsPopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)(false);
    const { logout: logout } = (0, $2503a745c61c2eb7$export$2e2bcd8739ae039)();
    const menuOptions = [
        {
            icon: (0, $9d5c67811f5faceb$export$2e2bcd8739ae039),
            label: "_settings",
            onClick: settingsPopup.open
        },
        {
            icon: (0, $635a3877126a4f0f$export$2e2bcd8739ae039),
            label: (0, $7941da5030926682$export$d0a8044dce8ff2fc)() ? "_Install Mobile App" : "_Install Desktop App",
            disabled: !appInstallationEnabled,
            onClick: installApp
        },
        {
            icon: (0, $59ea0288aa19d2df$export$2e2bcd8739ae039),
            label: "_Help",
            onClick: helpPopup.open
        },
        {
            icon: (0, $b3448e465f742ebc$export$2e2bcd8739ae039),
            label: "_Logout",
            onClick: ()=>{
                logout();
                navigate("/");
            }
        }
    ];
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: "flex sm:items-center ltr:pl-2 rtl:pr-2",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $742ff826c2da0ee7$export$2e2bcd8739ae039), {
                as: "button",
                menuButtonClassName: "flex max-w-xs items-center rounded-full bg-white hover:text-primary-500 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
                menuButton: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                            className: "sr-only",
                            children: t("_Open Menu")
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $46a779f6e20353fb$export$2e2bcd8739ae039), {
                            className: "block h-6 w-6",
                            "aria-hidden": "true"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {
                    children: menuOptions.filter(({ disabled: disabled })=>!disabled).map(({ label: label, onClick: onClick, icon: icon })=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a41e8173b02d5c7f$export$2e2bcd8739ae039), {
                            icon: icon,
                            onClick: onClick,
                            children: t(label)
                        }, label))
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $addd86142b6def57$export$2e2bcd8739ae039), {
                open: helpPopup.isOpen,
                onClose: helpPopup.close
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $23dbbbe06688e49f$export$2e2bcd8739ae039), {
                open: settingsPopup.isOpen,
                onClose: settingsPopup.close
            })
        ]
    });
};
var $5f0b2e9935864fb1$export$2e2bcd8739ae039 = $5f0b2e9935864fb1$var$UserMenu;




var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");





















var $bb9794400ac62c15$var$he = ((u)=>(u[u.Open = 0] = "Open", u[u.Closed = 1] = "Closed", u))($bb9794400ac62c15$var$he || {}), $bb9794400ac62c15$var$He = ((e)=>(e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))($bb9794400ac62c15$var$He || {});
let $bb9794400ac62c15$var$Ge = {
    [0]: (t)=>{
        let o = {
            ...t,
            popoverState: (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(t.popoverState, {
                [0]: 1,
                [1]: 0
            })
        };
        return o.popoverState === 0 && (o.__demoMode = !1), o;
    },
    [1] (t) {
        return t.popoverState === 1 ? t : {
            ...t,
            popoverState: 1
        };
    },
    [2] (t, o) {
        return t.button === o.button ? t : {
            ...t,
            button: o.button
        };
    },
    [3] (t, o) {
        return t.buttonId === o.buttonId ? t : {
            ...t,
            buttonId: o.buttonId
        };
    },
    [4] (t, o) {
        return t.panel === o.panel ? t : {
            ...t,
            panel: o.panel
        };
    },
    [5] (t, o) {
        return t.panelId === o.panelId ? t : {
            ...t,
            panelId: o.panelId
        };
    }
}, $bb9794400ac62c15$var$ue = (0, $3QbnI.createContext)(null);
$bb9794400ac62c15$var$ue.displayName = "PopoverContext";
function $bb9794400ac62c15$var$oe(t) {
    let o = (0, $3QbnI.useContext)($bb9794400ac62c15$var$ue);
    if (o === null) {
        let u = new Error(`<${t} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(u, $bb9794400ac62c15$var$oe), u;
    }
    return o;
}
let $bb9794400ac62c15$var$ie = (0, $3QbnI.createContext)(null);
$bb9794400ac62c15$var$ie.displayName = "PopoverAPIContext";
function $bb9794400ac62c15$var$fe(t) {
    let o = (0, $3QbnI.useContext)($bb9794400ac62c15$var$ie);
    if (o === null) {
        let u = new Error(`<${t} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(u, $bb9794400ac62c15$var$fe), u;
    }
    return o;
}
let $bb9794400ac62c15$var$Pe = (0, $3QbnI.createContext)(null);
$bb9794400ac62c15$var$Pe.displayName = "PopoverGroupContext";
function $bb9794400ac62c15$var$Ee() {
    return (0, $3QbnI.useContext)($bb9794400ac62c15$var$Pe);
}
let $bb9794400ac62c15$var$re = (0, $3QbnI.createContext)(null);
$bb9794400ac62c15$var$re.displayName = "PopoverPanelContext";
function $bb9794400ac62c15$var$Ne() {
    return (0, $3QbnI.useContext)($bb9794400ac62c15$var$re);
}
function $bb9794400ac62c15$var$ke(t, o) {
    return (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(o.type, $bb9794400ac62c15$var$Ge, t, o);
}
let $bb9794400ac62c15$var$we = "div";
function $bb9794400ac62c15$var$Ue(t, o) {
    var B;
    let { __demoMode: u = !1, ...M } = t, x = (0, $3QbnI.useRef)(null), n = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(o, (0, $2965c2f720720e02$export$7029785b750eb74)((l)=>{
        x.current = l;
    })), e = (0, $3QbnI.useRef)([]), c = (0, $3QbnI.useReducer)($bb9794400ac62c15$var$ke, {
        __demoMode: u,
        popoverState: u ? 0 : 1,
        buttons: e,
        button: null,
        buttonId: null,
        panel: null,
        panelId: null,
        beforePanelSentinel: (0, $3QbnI.createRef)(),
        afterPanelSentinel: (0, $3QbnI.createRef)()
    }), [{ popoverState: f, button: s, buttonId: I, panel: a, panelId: v, beforePanelSentinel: y, afterPanelSentinel: A }, P] = c, p = (0, $0225316d43e68597$export$dd9fbcea3de0ae36)((B = x.current) != null ? B : s), E = (0, $3QbnI.useMemo)(()=>{
        if (!s || !a) return !1;
        for (let W of document.querySelectorAll("body > *"))if (Number(W == null ? void 0 : W.contains(s)) ^ Number(W == null ? void 0 : W.contains(a))) return !0;
        let l = (0, $6e492986e168be71$export$433aaa1f216cf32d)(), S = l.indexOf(s), q = (S + l.length - 1) % l.length, U = (S + 1) % l.length, z = l[q], be = l[U];
        return !a.contains(z) && !a.contains(be);
    }, [
        s,
        a
    ]), F = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)(I), D = (0, $62f55b25b9f4337e$export$86c4283a11f23f95)(v), _ = (0, $3QbnI.useMemo)(()=>({
            buttonId: F,
            panelId: D,
            close: ()=>P({
                    type: 1
                })
        }), [
        F,
        D,
        P
    ]), O = $bb9794400ac62c15$var$Ee(), L = O == null ? void 0 : O.registerPopover, $ = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        var l;
        return (l = O == null ? void 0 : O.isFocusWithinPopoverGroup()) != null ? l : (p == null ? void 0 : p.activeElement) && ((s == null ? void 0 : s.contains(p.activeElement)) || (a == null ? void 0 : a.contains(p.activeElement)));
    });
    (0, $3QbnI.useEffect)(()=>L == null ? void 0 : L(_), [
        L,
        _
    ]);
    let [i, b] = (0, $e1816142ef1407cb$export$26b8c35244a70b37)(), T = (0, $e773763f935a119d$export$445f2d1a3d9b1b9f)({
        mainTreeNodeRef: O == null ? void 0 : O.mainTreeNodeRef,
        portals: i,
        defaultContainers: [
            s,
            a
        ]
    });
    (0, $9987347a8ddb8c63$export$7080b3e976bc91ab)(p == null ? void 0 : p.defaultView, "focus", (l)=>{
        var S, q, U, z;
        l.target !== window && l.target instanceof HTMLElement && f === 0 && ($() || s && a && (T.contains(l.target) || (q = (S = y.current) == null ? void 0 : S.contains) != null && q.call(S, l.target) || (z = (U = A.current) == null ? void 0 : U.contains) != null && z.call(U, l.target) || P({
            type: 1
        })));
    }, !0), (0, $fe5967a5f12b8ede$export$71b2224f1ce5e08e)(T.resolveContainers, (l, S)=>{
        P({
            type: 1
        }), (0, $6e492986e168be71$export$ff1ec1c740b3c8d5)(S, (0, $6e492986e168be71$export$27112a34f2f8402d).Loose) || (l.preventDefault(), s == null || s.focus());
    }, f === 0);
    let d = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((l)=>{
        P({
            type: 1
        });
        let S = (()=>l ? l instanceof HTMLElement ? l : "current" in l && l.current instanceof HTMLElement ? l.current : s : s)();
        S == null || S.focus();
    }), r = (0, $3QbnI.useMemo)(()=>({
            close: d,
            isPortalled: E
        }), [
        d,
        E
    ]), m = (0, $3QbnI.useMemo)(()=>({
            open: f === 0,
            close: d
        }), [
        f,
        d
    ]), g = {
        ref: n
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($bb9794400ac62c15$var$re.Provider, {
        value: null
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($bb9794400ac62c15$var$ue.Provider, {
        value: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($bb9794400ac62c15$var$ie.Provider, {
        value: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $379c3428ac0bb4a2$export$2a0ed818b175f558), {
        value: (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(f, {
            [0]: (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open,
            [1]: (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Closed
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(b, null, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: g,
        theirProps: M,
        slot: m,
        defaultTag: $bb9794400ac62c15$var$we,
        name: "Popover"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(T.MainTreeNode, null))))));
}
let $bb9794400ac62c15$var$We = "button";
function $bb9794400ac62c15$var$Ke(t, o) {
    let u = (0, $32e547b031070140$export$f680877a34711e37)(), { id: M = `headlessui-popover-button-${u}`, ...x } = t, [n, e] = $bb9794400ac62c15$var$oe("Popover.Button"), { isPortalled: c } = $bb9794400ac62c15$var$fe("Popover.Button"), f = (0, $3QbnI.useRef)(null), s = `headlessui-focus-sentinel-${(0, $32e547b031070140$export$f680877a34711e37)()}`, I = $bb9794400ac62c15$var$Ee(), a = I == null ? void 0 : I.closeOthers, y = $bb9794400ac62c15$var$Ne() !== null;
    (0, $3QbnI.useEffect)(()=>{
        if (!y) return e({
            type: 3,
            buttonId: M
        }), ()=>{
            e({
                type: 3,
                buttonId: null
            });
        };
    }, [
        y,
        M,
        e
    ]);
    let [A] = (0, $3QbnI.useState)(()=>Symbol()), P = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(f, o, y ? null : (r)=>{
        if (r) n.buttons.current.push(A);
        else {
            let m = n.buttons.current.indexOf(A);
            m !== -1 && n.buttons.current.splice(m, 1);
        }
        n.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), r && e({
            type: 2,
            button: r
        });
    }), p = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(f, o), E = (0, $0225316d43e68597$export$dd9fbcea3de0ae36)(f), F = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((r)=>{
        var m, g, B;
        if (y) {
            if (n.popoverState === 1) return;
            switch(r.key){
                case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space:
                case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Enter:
                    r.preventDefault(), (g = (m = r.target).click) == null || g.call(m), e({
                        type: 1
                    }), (B = n.button) == null || B.focus();
                    break;
            }
        } else switch(r.key){
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space:
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Enter:
                r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (a == null || a(n.buttonId)), e({
                    type: 0
                });
                break;
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Escape:
                if (n.popoverState !== 0) return a == null ? void 0 : a(n.buttonId);
                if (!f.current || E != null && E.activeElement && !f.current.contains(E.activeElement)) return;
                r.preventDefault(), r.stopPropagation(), e({
                    type: 1
                });
                break;
        }
    }), D = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((r)=>{
        y || r.key === (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Space && r.preventDefault();
    }), _ = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((r)=>{
        var m, g;
        (0, $9fde5a40ffbcb074$export$db61f031a278447c)(r.currentTarget) || t.disabled || (y ? (e({
            type: 1
        }), (m = n.button) == null || m.focus()) : (r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (a == null || a(n.buttonId)), e({
            type: 0
        }), (g = n.button) == null || g.focus()));
    }), O = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((r)=>{
        r.preventDefault(), r.stopPropagation();
    }), L = n.popoverState === 0, $ = (0, $3QbnI.useMemo)(()=>({
            open: L
        }), [
        L
    ]), i = (0, $63b58a1e835cc3d1$export$53652b2b272efe9c)(t, f), b = y ? {
        ref: p,
        type: i,
        onKeyDown: F,
        onClick: _
    } : {
        ref: P,
        id: n.buttonId,
        type: i,
        "aria-expanded": n.popoverState === 0,
        "aria-controls": n.panel ? n.panelId : void 0,
        onKeyDown: F,
        onKeyUp: D,
        onClick: _,
        onMouseDown: O
    }, T = (0, $245e037f2cce86f7$export$19b797546aece48f)(), d = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        let r = n.panel;
        if (!r) return;
        function m() {
            (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(T.current, {
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $6e492986e168be71$export$82e1f4f412218a1d)(r, (0, $6e492986e168be71$export$807a7eae502106e7).First),
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $6e492986e168be71$export$82e1f4f412218a1d)(r, (0, $6e492986e168be71$export$807a7eae502106e7).Last)
            }) === (0, $6e492986e168be71$export$abf286375dfa6dbd).Error && (0, $6e492986e168be71$export$82e1f4f412218a1d)((0, $6e492986e168be71$export$433aaa1f216cf32d)().filter((B)=>B.dataset.headlessuiFocusGuard !== "true"), (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(T.current, {
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Forwards]: (0, $6e492986e168be71$export$807a7eae502106e7).Next,
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Backwards]: (0, $6e492986e168be71$export$807a7eae502106e7).Previous
            }), {
                relativeTo: n.button
            });
        }
        m();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).Fragment, null, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: b,
        theirProps: x,
        slot: $,
        defaultTag: $bb9794400ac62c15$var$We,
        name: "Popover.Button"
    }), L && !y && c && (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $70ad89c09b766687$export$8dc98ba7eadeaa56), {
        id: s,
        features: (0, $70ad89c09b766687$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: d
    }));
}
let $bb9794400ac62c15$var$je = "div", $bb9794400ac62c15$var$Ve = (0, $efef981be50c1ac4$export$617d79dae526d2cf).RenderStrategy | (0, $efef981be50c1ac4$export$617d79dae526d2cf).Static;
function $bb9794400ac62c15$var$$e(t, o) {
    let u = (0, $32e547b031070140$export$f680877a34711e37)(), { id: M = `headlessui-popover-overlay-${u}`, ...x } = t, [{ popoverState: n }, e] = $bb9794400ac62c15$var$oe("Popover.Overlay"), c = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(o), f = (0, $379c3428ac0bb4a2$export$fc6fdf0ecf360e)(), s = (()=>f !== null ? (f & (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open) === (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open : n === 0)(), I = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((y)=>{
        if ((0, $9fde5a40ffbcb074$export$db61f031a278447c)(y.currentTarget)) return y.preventDefault();
        e({
            type: 1
        });
    }), a = (0, $3QbnI.useMemo)(()=>({
            open: n === 0
        }), [
        n
    ]);
    return (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: c,
            id: M,
            "aria-hidden": !0,
            onClick: I
        },
        theirProps: x,
        slot: a,
        defaultTag: $bb9794400ac62c15$var$je,
        features: $bb9794400ac62c15$var$Ve,
        visible: s,
        name: "Popover.Overlay"
    });
}
let $bb9794400ac62c15$var$Je = "div", $bb9794400ac62c15$var$Xe = (0, $efef981be50c1ac4$export$617d79dae526d2cf).RenderStrategy | (0, $efef981be50c1ac4$export$617d79dae526d2cf).Static;
function $bb9794400ac62c15$var$Ye(t, o) {
    let u = (0, $32e547b031070140$export$f680877a34711e37)(), { id: M = `headlessui-popover-panel-${u}`, focus: x = !1, ...n } = t, [e, c] = $bb9794400ac62c15$var$oe("Popover.Panel"), { close: f, isPortalled: s } = $bb9794400ac62c15$var$fe("Popover.Panel"), I = `headlessui-focus-sentinel-before-${(0, $32e547b031070140$export$f680877a34711e37)()}`, a = `headlessui-focus-sentinel-after-${(0, $32e547b031070140$export$f680877a34711e37)()}`, v = (0, $3QbnI.useRef)(null), y = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(v, o, (i)=>{
        c({
            type: 4,
            panel: i
        });
    }), A = (0, $0225316d43e68597$export$dd9fbcea3de0ae36)(v), P = (0, $efef981be50c1ac4$export$81218df071161f0a)();
    (0, $4f845bb0423860c5$export$ce5ed857c741fd71)(()=>(c({
            type: 5,
            panelId: M
        }), ()=>{
            c({
                type: 5,
                panelId: null
            });
        }), [
        M,
        c
    ]);
    let p = (0, $379c3428ac0bb4a2$export$fc6fdf0ecf360e)(), E = (()=>p !== null ? (p & (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open) === (0, $379c3428ac0bb4a2$export$7254cc27399e90bd).Open : e.popoverState === 0)(), F = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((i)=>{
        var b;
        switch(i.key){
            case (0, $e7f7b1113de18964$export$4b0075e5ea5e1f26).Escape:
                if (e.popoverState !== 0 || !v.current || A != null && A.activeElement && !v.current.contains(A.activeElement)) return;
                i.preventDefault(), i.stopPropagation(), c({
                    type: 1
                }), (b = e.button) == null || b.focus();
                break;
        }
    });
    (0, $3QbnI.useEffect)(()=>{
        var i;
        t.static || e.popoverState === 1 && ((i = t.unmount) == null || i) && c({
            type: 4,
            panel: null
        });
    }, [
        e.popoverState,
        t.unmount,
        t.static,
        c
    ]), (0, $3QbnI.useEffect)(()=>{
        if (e.__demoMode || !x || e.popoverState !== 0 || !v.current) return;
        let i = A == null ? void 0 : A.activeElement;
        v.current.contains(i) || (0, $6e492986e168be71$export$82e1f4f412218a1d)(v.current, (0, $6e492986e168be71$export$807a7eae502106e7).First);
    }, [
        e.__demoMode,
        x,
        v,
        e.popoverState
    ]);
    let D = (0, $3QbnI.useMemo)(()=>({
            open: e.popoverState === 0,
            close: f
        }), [
        e,
        f
    ]), _ = {
        ref: y,
        id: M,
        onKeyDown: F,
        onBlur: x && e.popoverState === 0 ? (i)=>{
            var T, d, r, m, g;
            let b = i.relatedTarget;
            b && v.current && ((T = v.current) != null && T.contains(b) || (c({
                type: 1
            }), ((r = (d = e.beforePanelSentinel.current) == null ? void 0 : d.contains) != null && r.call(d, b) || (g = (m = e.afterPanelSentinel.current) == null ? void 0 : m.contains) != null && g.call(m, b)) && b.focus({
                preventScroll: !0
            })));
        } : void 0,
        tabIndex: -1
    }, O = (0, $245e037f2cce86f7$export$19b797546aece48f)(), L = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        let i = v.current;
        if (!i) return;
        function b() {
            (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(O.current, {
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    var d;
                    (0, $6e492986e168be71$export$82e1f4f412218a1d)(i, (0, $6e492986e168be71$export$807a7eae502106e7).First) === (0, $6e492986e168be71$export$abf286375dfa6dbd).Error && ((d = e.afterPanelSentinel.current) == null || d.focus());
                },
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var T;
                    (T = e.button) == null || T.focus({
                        preventScroll: !0
                    });
                }
            });
        }
        b();
    }), $ = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        let i = v.current;
        if (!i) return;
        function b() {
            (0, $c40f4ef5ff4b2ae4$export$4659b591c19bdf3d)(O.current, {
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    var B;
                    if (!e.button) return;
                    let T = (0, $6e492986e168be71$export$433aaa1f216cf32d)(), d = T.indexOf(e.button), r = T.slice(0, d + 1), g = [
                        ...T.slice(d + 1),
                        ...r
                    ];
                    for (let l of g.slice())if (l.dataset.headlessuiFocusGuard === "true" || (B = e.panel) != null && B.contains(l)) {
                        let S = g.indexOf(l);
                        S !== -1 && g.splice(S, 1);
                    }
                    (0, $6e492986e168be71$export$82e1f4f412218a1d)(g, (0, $6e492986e168be71$export$807a7eae502106e7).First, {
                        sorted: !1
                    });
                },
                [(0, $245e037f2cce86f7$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var d;
                    (0, $6e492986e168be71$export$82e1f4f412218a1d)(i, (0, $6e492986e168be71$export$807a7eae502106e7).Previous) === (0, $6e492986e168be71$export$abf286375dfa6dbd).Error && ((d = e.button) == null || d.focus());
                }
            });
        }
        b();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($bb9794400ac62c15$var$re.Provider, {
        value: M
    }, E && s && (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $70ad89c09b766687$export$8dc98ba7eadeaa56), {
        id: I,
        ref: e.beforePanelSentinel,
        features: (0, $70ad89c09b766687$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: L
    }), (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        mergeRefs: P,
        ourProps: _,
        theirProps: n,
        slot: D,
        defaultTag: $bb9794400ac62c15$var$Je,
        features: $bb9794400ac62c15$var$Xe,
        visible: E,
        name: "Popover.Panel"
    }), E && s && (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement((0, $70ad89c09b766687$export$8dc98ba7eadeaa56), {
        id: a,
        ref: e.afterPanelSentinel,
        features: (0, $70ad89c09b766687$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: $
    }));
}
let $bb9794400ac62c15$var$qe = "div";
function $bb9794400ac62c15$var$ze(t, o) {
    let u = (0, $3QbnI.useRef)(null), M = (0, $2965c2f720720e02$export$f6a25a78204acc7e)(u, o), [x, n] = (0, $3QbnI.useState)([]), e = (0, $e773763f935a119d$export$64db24433d7f4942)(), c = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((P)=>{
        n((p)=>{
            let E = p.indexOf(P);
            if (E !== -1) {
                let F = p.slice();
                return F.splice(E, 1), F;
            }
            return p;
        });
    }), f = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((P)=>(n((p)=>[
                ...p,
                P
            ]), ()=>c(P))), s = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)(()=>{
        var E;
        let P = (0, $a37d5afd1ae25fcd$export$b204af158042fbac)(u);
        if (!P) return !1;
        let p = P.activeElement;
        return (E = u.current) != null && E.contains(p) ? !0 : x.some((F)=>{
            var D, _;
            return ((D = P.getElementById(F.buttonId.current)) == null ? void 0 : D.contains(p)) || ((_ = P.getElementById(F.panelId.current)) == null ? void 0 : _.contains(p));
        });
    }), I = (0, $2dcba26290db42cf$export$90fc3a17d93f704c)((P)=>{
        for (let p of x)p.buttonId.current !== P && p.close();
    }), a = (0, $3QbnI.useMemo)(()=>({
            registerPopover: f,
            unregisterPopover: c,
            isFocusWithinPopoverGroup: s,
            closeOthers: I,
            mainTreeNodeRef: e.mainTreeNodeRef
        }), [
        f,
        c,
        s,
        I,
        e.mainTreeNodeRef
    ]), v = (0, $3QbnI.useMemo)(()=>({}), []), y = t, A = {
        ref: M
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement($bb9794400ac62c15$var$Pe.Provider, {
        value: a
    }, (0, $efef981be50c1ac4$export$b3890eb0ae9dca99)({
        ourProps: A,
        theirProps: y,
        slot: v,
        defaultTag: $bb9794400ac62c15$var$qe,
        name: "Popover.Group"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createElement(e.MainTreeNode, null));
}
let $bb9794400ac62c15$var$Qe = (0, $efef981be50c1ac4$export$e43f39796049410c)($bb9794400ac62c15$var$Ue), $bb9794400ac62c15$var$Ze = (0, $efef981be50c1ac4$export$e43f39796049410c)($bb9794400ac62c15$var$Ke), $bb9794400ac62c15$var$et = (0, $efef981be50c1ac4$export$e43f39796049410c)($bb9794400ac62c15$var$$e), $bb9794400ac62c15$var$tt = (0, $efef981be50c1ac4$export$e43f39796049410c)($bb9794400ac62c15$var$Ye), $bb9794400ac62c15$var$ot = (0, $efef981be50c1ac4$export$e43f39796049410c)($bb9794400ac62c15$var$ze), $bb9794400ac62c15$export$5b6b19405a83ff9d = Object.assign($bb9794400ac62c15$var$Qe, {
    Button: $bb9794400ac62c15$var$Ze,
    Overlay: $bb9794400ac62c15$var$et,
    Panel: $bb9794400ac62c15$var$tt,
    Group: $bb9794400ac62c15$var$ot
});




const $056015557140b68d$var$SelectMenu = ({ children: children })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bb9794400ac62c15$export$5b6b19405a83ff9d), {
        className: "relative",
        children: ({ open: open })=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bb9794400ac62c15$export$5b6b19405a83ff9d).Button, {
                        as: (0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary,
                        className: "hidden md:block",
                        "aria-label": t("_New Recipe"),
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                            className: "ltr:ml-0.5 rtl:mr-0.5 text-normal",
                            children: t("_New Recipe")
                        })
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $516f3ebf7dc9f3d4$export$be58926105124dd4), {
                        show: open,
                        as: (0, $3QbnI.Fragment),
                        leave: "transition ease-in duration-100",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bb9794400ac62c15$export$5b6b19405a83ff9d).Panel, {
                            className: "absolute cursor-default w-96 z-10 mt-2 ltr:right-0  ltr:origin-top-right rtl:left-0 rtl:origin-top-left overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none p-4",
                            children: children
                        })
                    })
                ]
            })
    });
};
var $056015557140b68d$export$2e2bcd8739ae039 = $056015557140b68d$var$SelectMenu;


/* eslint-disable i18next/no-literal-string */ 


var $3QbnI = parcelRequire("3QbnI");



var $3QbnI = parcelRequire("3QbnI");
function $3b8b51749f3e9091$var$ExclamationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 5Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
    }));
}
const $3b8b51749f3e9091$var$ForwardRef = $3QbnI.forwardRef($3b8b51749f3e9091$var$ExclamationCircleIcon);
var $3b8b51749f3e9091$export$2e2bcd8739ae039 = $3b8b51749f3e9091$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $beb341bc99a88c61$var$QuestionMarkCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM8.94 6.94a.75.75 0 1 1-1.061-1.061 3 3 0 1 1 2.871 5.026v.345a.75.75 0 0 1-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 1 0 8.94 6.94ZM10 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
    }));
}
const $beb341bc99a88c61$var$ForwardRef = $3QbnI.forwardRef($beb341bc99a88c61$var$QuestionMarkCircleIcon);
var $beb341bc99a88c61$export$2e2bcd8739ae039 = $beb341bc99a88c61$var$ForwardRef;


var $87d8b6d2bdea6924$export$25797730d91827ca;
(function(ImportUrlStatus) {
    ImportUrlStatus[ImportUrlStatus["NotUrl"] = 0] = "NotUrl";
    ImportUrlStatus[ImportUrlStatus["Empty"] = 1] = "Empty";
    ImportUrlStatus[ImportUrlStatus["Ok"] = 2] = "Ok";
    ImportUrlStatus[ImportUrlStatus["NotAManagedWebsite"] = 3] = "NotAManagedWebsite";
    ImportUrlStatus[ImportUrlStatus["Error"] = 4] = "Error";
})($87d8b6d2bdea6924$export$25797730d91827ca || ($87d8b6d2bdea6924$export$25797730d91827ca = {}));
const $87d8b6d2bdea6924$var$expression = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;
const $87d8b6d2bdea6924$export$6b36b10bfd91fb55 = (url)=>{
    if (url.length === 0) return 1;
    if (!url.match($87d8b6d2bdea6924$var$expression)) return 0;
    return 2;
};






const $571576b994bd2c02$var$LoadingSpinner = ({ className: className = "h-6 w-6" })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("svg", {
            className: `animate-spin ${className}`,
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: "4"
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                })
            ]
        })
    });
};
var $571576b994bd2c02$export$2e2bcd8739ae039 = $571576b994bd2c02$var$LoadingSpinner;


const $4a262d36d885163e$var$PrimaryLoadingSpinner = ({ className: className = "h-6 w-6" })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $571576b994bd2c02$export$2e2bcd8739ae039), {
        className: `text-primary-400 ${className}`
    });
};
var $4a262d36d885163e$export$2e2bcd8739ae039 = $4a262d36d885163e$var$PrimaryLoadingSpinner;





const $5e4be98a434b893c$var$NewRecipeForm = ({ onHelpRequest: onHelpRequest = ()=>{} })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const [url, setUrl] = (0, $3QbnI.useState)("");
    const [status, setStatus] = (0, $3QbnI.useState)((0, $87d8b6d2bdea6924$export$25797730d91827ca).Empty);
    const [isLoading, setLoading] = (0, $3QbnI.useState)(false);
    const officialWebsites = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $e55c7c0b1e5b11b1$export$e141af6c897b69ed));
    const automaticImport = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $cb3b9bf6a0fb48f2$export$6a52d4affff68ee8));
    const onUrlChange = (newUrl)=>{
        setUrl(newUrl);
        setStatus((0, $87d8b6d2bdea6924$export$6b36b10bfd91fb55)(newUrl));
    };
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    const startImportingRecipe = (0, $3QbnI.useCallback)(async ()=>{
        if (isLoading) return;
        try {
            (0, $650b40fd3e752928$export$6b2a7d5132615086)("ImportRecipe");
            setLoading(true);
            const recipe = await dispatch((0, $87c50e51b43ee465$export$1f4a3fe10896614d)(url)).unwrap();
            navigate(`/recipes/${recipe.id}`);
            (0, $650b40fd3e752928$export$6b2a7d5132615086)("ImportRecipeSuccess");
        } catch (error) {
            const { hostname: hostname } = new URL(url);
            if (officialWebsites.includes(hostname)) setStatus((0, $87d8b6d2bdea6924$export$25797730d91827ca).Error);
            else setStatus((0, $87d8b6d2bdea6924$export$25797730d91827ca).NotAManagedWebsite);
            (0, $650b40fd3e752928$export$6b2a7d5132615086)("ImportRecipeError");
        } finally{
            setLoading(false);
        }
    }, [
        url,
        dispatch,
        setLoading,
        navigate,
        isLoading,
        officialWebsites
    ]);
    const init = (0, $3QbnI.useCallback)(async ()=>{
        const newUrl = await navigator.clipboard.readText();
        if ((0, $87d8b6d2bdea6924$export$6b36b10bfd91fb55)(newUrl) === (0, $87d8b6d2bdea6924$export$25797730d91827ca).NotUrl) return;
        setUrl(newUrl);
        onUrlChange(newUrl);
    }, []);
    (0, $3QbnI.useEffect)(()=>{
        if (automaticImport) init();
    }, [
        init,
        automaticImport
    ]);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
            className: "p-5",
            children: [
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                    className: "text-left w-full",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("label", {
                            htmlFor: "url",
                            className: "flex text-sm font-medium text-gray-700 items-center",
                            children: [
                                t("import.Import from a recipe catalog"),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("button", {
                                    onClick: onHelpRequest,
                                    children: [
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                            className: "sr-only",
                                            children: t("_See the official websites")
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $beb341bc99a88c61$export$2e2bcd8739ae039), {
                                            className: "inline h-4 w-4 ms-1"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                            className: "mt-1 flex rounded-md shadow-sm w-full",
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                    className: "relative flex flex-grow items-stretch focus-within:z-10",
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("input", {
                                        type: "text",
                                        name: "url",
                                        id: "url",
                                        className: "block w-full rounded-none ltr:rounded-l-md rtl:rounded-r-md border-gray-300 focus:border-primary-400 focus:ring-primary-400 sm:text-sm",
                                        placeholder: t("import.Enter a url"),
                                        onChange: (event)=>onUrlChange(event.target.value),
                                        value: url,
                                        autoComplete: "off"
                                    })
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("button", {
                                    type: "button",
                                    disabled: status !== (0, $87d8b6d2bdea6924$export$25797730d91827ca).Ok,
                                    onClick: startImportingRecipe,
                                    className: "relative ltr:-ml-px rtl:-mr-px inline-flex items-center space-x-2 ltr:rounded-r-md rtl:rounded-l-md border border-gray-300 bg-gray-50 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 whitespace-nowrap disabled:opacity-50",
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                        children: isLoading ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4a262d36d885163e$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }) : t("import.Import")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $516f3ebf7dc9f3d4$export$be58926105124dd4), {
                            show: status !== (0, $87d8b6d2bdea6924$export$25797730d91827ca).Ok && status !== (0, $87d8b6d2bdea6924$export$25797730d91827ca).Empty,
                            enter: "transition-all duration-75",
                            enterFrom: "h-0",
                            enterTo: "h-7",
                            leave: "transition-all duration-150",
                            leaveFrom: "h-7",
                            leaveTo: "h-0",
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("span", {
                                className: "flex items-center mt-2 text-xs text-red-600 ",
                                children: [
                                    status !== (0, $87d8b6d2bdea6924$export$25797730d91827ca).Ok && status !== (0, $87d8b6d2bdea6924$export$25797730d91827ca).Empty && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $3b8b51749f3e9091$export$2e2bcd8739ae039), {
                                        className: "inline w-5 h-5 align-middle mr-1"
                                    }),
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("span", {
                                        children: [
                                            status === (0, $87d8b6d2bdea6924$export$25797730d91827ca).NotUrl && t("import.Enter a valid url"),
                                            status === (0, $87d8b6d2bdea6924$export$25797730d91827ca).Error && t("import.Oups an error happened. We suggest you to enter the recipe manually this time."),
                                            status === (0, $87d8b6d2bdea6924$export$25797730d91827ca).NotAManagedWebsite && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                                children: [
                                                    t("import.Only few recipe catalog are managed"),
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                    className: "relative mt-5 mb-5",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                            className: "absolute inset-0 flex items-center",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "w-full border-t border-gray-200"
                            })
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                            className: "relative flex justify-center",
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                className: "bg-white px-4 text-sm font-medium text-gray-500",
                                children: t("import.or")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Black, {
                    to: "/recipes/new",
                    className: "flex w-full items-center justify-center bg-black py-2.5 text-white hover:bg-gray-800 focus:ring-gray-900",
                    children: t("import.Create new from blank page")
                })
            ]
        })
    });
};
var $5e4be98a434b893c$export$2e2bcd8739ae039 = $5e4be98a434b893c$var$NewRecipeForm;








var $3QbnI = parcelRequire("3QbnI");


var $3QbnI = parcelRequire("3QbnI");
function $15cf4acae0354248$var$SquaresPlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z"
    }));
}
const $15cf4acae0354248$var$ForwardRef = $3QbnI.forwardRef($15cf4acae0354248$var$SquaresPlusIcon);
var $15cf4acae0354248$export$2e2bcd8739ae039 = $15cf4acae0354248$var$ForwardRef;



var $3QbnI = parcelRequire("3QbnI");
function $f76f2b54eee5c351$var$ChevronLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z",
        clipRule: "evenodd"
    }));
}
const $f76f2b54eee5c351$var$ForwardRef = $3QbnI.forwardRef($f76f2b54eee5c351$var$ChevronLeftIcon);
var $f76f2b54eee5c351$export$2e2bcd8739ae039 = $f76f2b54eee5c351$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $ae741233dfd13442$var$ChevronRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $ae741233dfd13442$var$ForwardRef = $3QbnI.forwardRef($ae741233dfd13442$var$ChevronRightIcon);
var $ae741233dfd13442$export$2e2bcd8739ae039 = $ae741233dfd13442$var$ForwardRef;




var $3QbnI = parcelRequire("3QbnI");

var $fedaffc39b995a23$var$SearchStatus;
(function(SearchStatus) {
    SearchStatus[SearchStatus["Category"] = 0] = "Category";
    SearchStatus[SearchStatus["Generic"] = 1] = "Generic";
    SearchStatus[SearchStatus["Unactive"] = 2] = "Unactive";
    SearchStatus[SearchStatus["ReadyForSearch"] = 3] = "ReadyForSearch";
    SearchStatus[SearchStatus["NoCategory"] = 4] = "NoCategory";
})($fedaffc39b995a23$var$SearchStatus || ($fedaffc39b995a23$var$SearchStatus = {}));
var $fedaffc39b995a23$export$2e2bcd8739ae039 = $fedaffc39b995a23$var$SearchStatus;



const $9bbe458d9580bfd1$var$estimateSearchStatus = (query)=>{
    if (query === undefined || query === null) return (0, $fedaffc39b995a23$export$2e2bcd8739ae039).Unactive;
    if (query === "") return (0, $fedaffc39b995a23$export$2e2bcd8739ae039).ReadyForSearch;
    if (query.startsWith("#")) return (0, $fedaffc39b995a23$export$2e2bcd8739ae039).Category;
    if (query === "@no category") return (0, $fedaffc39b995a23$export$2e2bcd8739ae039).NoCategory;
    return (0, $fedaffc39b995a23$export$2e2bcd8739ae039).Generic;
};
var $9bbe458d9580bfd1$export$2e2bcd8739ae039 = $9bbe458d9580bfd1$var$estimateSearchStatus;


const $b62c837cabb699aa$var$ENCODED_HASHTAG = "%23";
const $b62c837cabb699aa$var$cleanQuery = (query)=>typeof query === "string" ? query.toLowerCase() : query;
const $b62c837cabb699aa$var$useSearch = ()=>{
    const location = (0, $e724dc7e3b3eec8a$export$45d76561a5302f2b)();
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    // bug with useSearchParams in production, the searchParams doesn't seem to work
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let [_, setSearchParams] = (0, $500dda12544a1f09$export$f1a78c17382fe22a)();
    const searchParams = new URLSearchParams(window.location.search);
    const query = typeof searchParams.get("q") === "string" ? searchParams.get("q") : undefined;
    return (0, $3QbnI.useMemo)(()=>{
        const searchStatus = (0, $9bbe458d9580bfd1$export$2e2bcd8739ae039)(query);
        const setSearch = (newQuery)=>{
            if (location.pathname !== "/recipes") navigate(`/recipes?q=${newQuery}`);
            else if (typeof newQuery === "string") setSearchParams({
                q: newQuery
            });
            else setSearchParams({});
        };
        const setCategory = (newQuery)=>{
            if (location.pathname !== "/recipes") navigate(`/recipes?q=${$b62c837cabb699aa$var$ENCODED_HASHTAG}${newQuery}`);
            else if (newQuery !== undefined) setSearchParams({
                q: `#${newQuery}`
            });
            else setSearchParams({});
        };
        return {
            query: $b62c837cabb699aa$var$cleanQuery(query),
            searchStatus: searchStatus,
            isSearchActive: searchStatus !== (0, $fedaffc39b995a23$export$2e2bcd8739ae039).Unactive,
            setSearch: setSearch,
            setCategory: setCategory
        };
    }, [
        query,
        location,
        navigate,
        setSearchParams
    ]);
};
var $b62c837cabb699aa$export$2e2bcd8739ae039 = $b62c837cabb699aa$var$useSearch;





const $1904509318c783c3$var$isRightToLeft = ()=>document.querySelector("body")?.getAttribute("dir") === "rtl";
var $1904509318c783c3$export$2e2bcd8739ae039 = $1904509318c783c3$var$isRightToLeft;




var $3QbnI = parcelRequire("3QbnI");




var $22I3K = parcelRequire("22I3K");
/**
 * Current version.
 */ const $05b8b0a9326cf72e$export$a4ad2735b021c132 = "4.1.2";


/**
 * List of supported colors.
 */ const $5994bd0b27d605b9$var$COLORS = {
    "aliceblue": "#f0f8ff",
    "antiquewhite": "#faebd7",
    "aqua": "#00ffff",
    "aquamarine": "#7fffd4",
    "azure": "#f0ffff",
    "beige": "#f5f5dc",
    "bisque": "#ffe4c4",
    "black": "#000000",
    "blanchedalmond": "#ffebcd",
    "blue": "#0000ff",
    "blueviolet": "#8a2be2",
    "brown": "#a52a2a",
    "burlywood": "#deb887",
    "cadetblue": "#5f9ea0",
    "chartreuse": "#7fff00",
    "chocolate": "#d2691e",
    "coral": "#ff7f50",
    "cornflowerblue": "#6495ed",
    "cornsilk": "#fff8dc",
    "crimson": "#dc143c",
    "cyan": "#00ffff",
    "darkblue": "#00008b",
    "darkcyan": "#008b8b",
    "darkgoldenrod": "#b8860b",
    "darkgray": "#a9a9a9",
    "darkgreen": "#006400",
    "darkkhaki": "#bdb76b",
    "darkmagenta": "#8b008b",
    "darkolivegreen": "#556b2f",
    "darkorange": "#ff8c00",
    "darkorchid": "#9932cc",
    "darkred": "#8b0000",
    "darksalmon": "#e9967a",
    "darkseagreen": "#8fbc8f",
    "darkslateblue": "#483d8b",
    "darkslategray": "#2f4f4f",
    "darkturquoise": "#00ced1",
    "darkviolet": "#9400d3",
    "deeppink": "#ff1493",
    "deepskyblue": "#00bfff",
    "dimgray": "#696969",
    "dodgerblue": "#1e90ff",
    "firebrick": "#b22222",
    "floralwhite": "#fffaf0",
    "forestgreen": "#228b22",
    "fuchsia": "#ff00ff",
    "gainsboro": "#dcdcdc",
    "ghostwhite": "#f8f8ff",
    "gold": "#ffd700",
    "goldenrod": "#daa520",
    "gray": "#808080",
    "green": "#008000",
    "greenyellow": "#adff2f",
    "honeydew": "#f0fff0",
    "hotpink": "#ff69b4",
    "indianred ": "#cd5c5c",
    "indigo": "#4b0082",
    "ivory": "#fffff0",
    "khaki": "#f0e68c",
    "lavender": "#e6e6fa",
    "lavenderblush": "#fff0f5",
    "lawngreen": "#7cfc00",
    "lemonchiffon": "#fffacd",
    "lightblue": "#add8e6",
    "lightcoral": "#f08080",
    "lightcyan": "#e0ffff",
    "lightgoldenrodyellow": "#fafad2",
    "lightgrey": "#d3d3d3",
    "lightgreen": "#90ee90",
    "lightpink": "#ffb6c1",
    "lightsalmon": "#ffa07a",
    "lightseagreen": "#20b2aa",
    "lightskyblue": "#87cefa",
    "lightslategray": "#778899",
    "lightsteelblue": "#b0c4de",
    "lightyellow": "#ffffe0",
    "lime": "#00ff00",
    "limegreen": "#32cd32",
    "linen": "#faf0e6",
    "magenta": "#ff00ff",
    "maroon": "#800000",
    "mediumaquamarine": "#66cdaa",
    "mediumblue": "#0000cd",
    "mediumorchid": "#ba55d3",
    "mediumpurple": "#9370d8",
    "mediumseagreen": "#3cb371",
    "mediumslateblue": "#7b68ee",
    "mediumspringgreen": "#00fa9a",
    "mediumturquoise": "#48d1cc",
    "mediumvioletred": "#c71585",
    "midnightblue": "#191970",
    "mintcream": "#f5fffa",
    "mistyrose": "#ffe4e1",
    "moccasin": "#ffe4b5",
    "navajowhite": "#ffdead",
    "navy": "#000080",
    "oldlace": "#fdf5e6",
    "olive": "#808000",
    "olivedrab": "#6b8e23",
    "orange": "#ffa500",
    "orangered": "#ff4500",
    "orchid": "#da70d6",
    "palegoldenrod": "#eee8aa",
    "palegreen": "#98fb98",
    "paleturquoise": "#afeeee",
    "palevioletred": "#d87093",
    "papayawhip": "#ffefd5",
    "peachpuff": "#ffdab9",
    "peru": "#cd853f",
    "pink": "#ffc0cb",
    "plum": "#dda0dd",
    "powderblue": "#b0e0e6",
    "purple": "#800080",
    "rebeccapurple": "#663399",
    "red": "#ff0000",
    "rosybrown": "#bc8f8f",
    "royalblue": "#4169e1",
    "saddlebrown": "#8b4513",
    "salmon": "#fa8072",
    "sandybrown": "#f4a460",
    "seagreen": "#2e8b57",
    "seashell": "#fff5ee",
    "sienna": "#a0522d",
    "silver": "#c0c0c0",
    "skyblue": "#87ceeb",
    "slateblue": "#6a5acd",
    "slategray": "#708090",
    "snow": "#fffafa",
    "springgreen": "#00ff7f",
    "steelblue": "#4682b4",
    "tan": "#d2b48c",
    "teal": "#008080",
    "thistle": "#d8bfd8",
    "tomato": "#ff6347",
    "turquoise": "#40e0d0",
    "violet": "#ee82ee",
    "wheat": "#f5deb3",
    "white": "#ffffff",
    "whitesmoke": "#f5f5f5",
    "yellow": "#ffff00",
    "yellowgreen": "#9acd32"
};
function $5994bd0b27d605b9$export$6e865ea70d7724f(colorName) {
    if (colorName.startsWith("#")) {
        if (colorName.length === 4) // support shorthand
        return `#${colorName[1]}${colorName[1]}${colorName[2]}${colorName[2]}${colorName[3]}${colorName[3]}`;
        else return colorName;
    } else return $5994bd0b27d605b9$var$COLORS[colorName.toLowerCase()] || "#000000";
}
function $5994bd0b27d605b9$export$a57960acb3070b5(colors) {
    const list = colors.split(",").filter((c)=>c).map((c)=>c.split(":")).filter((c)=>c.length == 2);
    return list.reduce((p, c)=>{
        const a = c[0];
        p[a.toLowerCase()] = $5994bd0b27d605b9$export$6e865ea70d7724f(c[1]);
        return p;
    }, {});
}


/**
 * Deep clone of value.
 * @param value
 */ function $6db2af7a7bb4b366$export$b7d58db314e0ac27(value) {
    return JSON.parse(JSON.stringify(value));
}
function $6db2af7a7bb4b366$export$984f70f9382f5d27(value) {
    return value === null || value === undefined;
}
function $6db2af7a7bb4b366$export$c10d0b04eaa80a43(value) {
    return value !== null && typeof value === "object";
}
function $6db2af7a7bb4b366$export$a4f4bb6b1453fff5(object, path) {
    const newPath = Array.isArray(path) ? path : path.split(".");
    let current = object;
    for (const key of newPath){
        if (!$6db2af7a7bb4b366$export$c10d0b04eaa80a43(current)) return false;
        if (!(key in current)) return false;
        current = current[key];
    }
    return true;
}
function $6db2af7a7bb4b366$export$3988ae62b71be9a3(object, path, defaultValue) {
    const newPath = Array.isArray(path) ? path : path.split(".");
    let current = object;
    for (const key of newPath){
        if (!$6db2af7a7bb4b366$export$c10d0b04eaa80a43(current)) return defaultValue;
        if (!(key in current)) return defaultValue;
        current = current[key];
    }
    return current === undefined ? defaultValue : current;
}
function $6db2af7a7bb4b366$export$adaa4cf7ef1b65be(object, path, value) {
    let current = object;
    const newPath = Array.isArray(path) ? path : path.split(".");
    for(let i = 0; i < newPath.length; ++i)if (i === newPath.length - 1) current[newPath[i]] = value;
    else current = current[newPath[i]];
}


/**
 * Use constructable stylesheets if supported (https://developers.google.com/web/updates/2019/02/constructable-stylesheets)
 */ const $44200311ade9f8b6$var$SUPPORTS_ADOPTING_STYLE_SHEETS = "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype;
/**
 * Default value for many of supported properties.
 * For example stroke can be changed in 0-100 range.
 */ const $44200311ade9f8b6$var$CENTER_VALUE = 50;
/**
 * List of events support on intersection loading.
 */ const $44200311ade9f8b6$var$INTERSECTION_LOADING_EVENTS = [
    "click",
    "mouseenter",
    "mouseleave"
];
/**
 * Style for this element.
 */ const $44200311ade9f8b6$var$ELEMENT_STYLE = `:host{position:relative;display:inline-block;width:32px;height:32px;transform:translate3d(0,0,0)}:host(.current-color) svg path[fill]{fill:currentColor}:host(.current-color) svg path[stroke]{stroke:currentColor}:host(:not(.current-color)) svg .primary path[fill]{fill:var(--lord-icon-primary, var(--lord-icon-primary-base))}:host(:not(.current-color)) svg .primary path[stroke]{stroke:var(--lord-icon-primary, var(--lord-icon-primary-base))}:host(:not(.current-color)) svg .secondary path[fill]{fill:var(--lord-icon-secondary, var(--lord-icon-secondary-base))}:host(:not(.current-color)) svg .secondary path[stroke]{stroke:var(--lord-icon-secondary, var(--lord-icon-secondary-base))}svg{position:absolute;pointer-events:none;display:block;transform:unset!important}::slotted(*){position:absolute;left:0;top:0;width:100%;height:100%}.body.ready ::slotted(*){display:none}`;
/**
 * Current style sheet instance (if supported).
 */ let $44200311ade9f8b6$var$styleSheet;
/**
 * Observed attributes for this custom element.
 */ const $44200311ade9f8b6$var$OBSERVED_ATTRIBUTES = [
    "colors",
    "src",
    "icon",
    "state",
    "trigger",
    "loading",
    "target",
    "stroke"
];
class $44200311ade9f8b6$export$db77ccec0bb4ccac extends HTMLElement {
    static _iconLoader;
    static _playerFactory;
    static _definedTriggers = new Map();
    /**
     * Get element version.
     */ static get version() {
        return 0, $05b8b0a9326cf72e$export$a4ad2735b021c132;
    }
    /**
     * Custom element observed attributes.
     */ static get observedAttributes() {
        return $44200311ade9f8b6$var$OBSERVED_ATTRIBUTES;
    }
    /**
     * Assign callback responsible for loading icons. Allows our {@link element.Element | Element} to load {@link interfaces.IconData | icon data} from any source.
     * Remember to assign _icon loader_ before defining `lord-icon` custom element to take effect.
     *
     * Example:
     * ```js
     * import lottie from 'lottie-web';
     * import { defineElement } from 'lord-icon-element';
     * import { Element } from 'lord-icon-element/element';
     *
     * Element.setIconLoader(async (name) => {
     *     const response = await fetch(`https://example.com/${name}.json`);
     *     return await response.json();
     * });
     *
     * defineElement(lottie.loadAnimation);
     * ```
     *
     * @param loader Custom icon loader callback.
     */ static setIconLoader(loader) {
        $44200311ade9f8b6$export$db77ccec0bb4ccac._iconLoader = loader;
    }
    /**
     * Assign callback which create a player. Player is responsible for customizing icons and playing animations.
     * @param loader
     */ static setPlayerFactory(loader) {
        $44200311ade9f8b6$export$db77ccec0bb4ccac._playerFactory = loader;
    }
    /**
     * Define supported trigger. Triggers allows to define interaction strategy with icon.
     * @param name
     * @param triggerClass
     */ static defineTrigger(name, triggerClass) {
        $44200311ade9f8b6$export$db77ccec0bb4ccac._definedTriggers.set(name, triggerClass);
    }
    _root;
    _isConnected = false;
    _isReady = false;
    _triggerInstance;
    _assignedIconData;
    _loadedIconData;
    _player;
    /**
     * Callback created by one of the lazy loading methods.
     * Enables the process to continue immediately.
     */ delayedLoading = null;
    /**
     * Handle attribute update.
     * @param name
     * @param oldValue
     * @param newValue
     */ attributeChangedCallback(name, oldValue, newValue) {
        this[`${name}Changed`].call(this);
    }
    /**
     * Element connected.
     */ connectedCallback() {
        // create elements only once
        if (!this._root) this.createElements();
        if (this.loading === "lazy") {
            let intersectionObserver = undefined;
            this.delayedLoading = (cancel)=>{
                intersectionObserver.unobserve(this);
                intersectionObserver = undefined;
                this.delayedLoading = null;
                if (!cancel) this.createPlayer();
            };
            const callback = (entries, observer)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting && intersectionObserver) {
                        if (this.delayedLoading) this.delayedLoading();
                    }
                });
            };
            intersectionObserver = new IntersectionObserver(callback);
            intersectionObserver.observe(this);
        } else if (this.loading === "interaction") {
            let interactionEvent = undefined;
            this.delayedLoading = (cancel)=>{
                for (const eventName of $44200311ade9f8b6$var$INTERSECTION_LOADING_EVENTS)(targetElement || this).removeEventListener(eventName, intersectionCallback);
                this.delayedLoading = null;
                if (!cancel) this.createPlayer().then(()=>{
                    (targetElement || this).dispatchEvent(new Event(interactionEvent));
                });
            };
            const targetElement = this.target ? this.closest(this.target) : null;
            let intersectionCallback = (event)=>{
                const eventName = event?.type;
                if (!interactionEvent) {
                    interactionEvent = eventName;
                    if (this.delayedLoading) this.delayedLoading();
                } else interactionEvent = eventName;
            };
            intersectionCallback = intersectionCallback.bind(this);
            for (const eventName of $44200311ade9f8b6$var$INTERSECTION_LOADING_EVENTS)(targetElement || this).addEventListener(eventName, intersectionCallback);
        } else this.createPlayer();
        this._isConnected = true;
    }
    /**
     * Element disconnected.
     */ disconnectedCallback() {
        // clean state from delayed loading
        if (this.delayedLoading) this.delayedLoading(true);
        // remove player
        this.destroyPlayer();
        this._isConnected = false;
    }
    /**
     * Create DOM elements.
     * @returns
     */ createElements() {
        // create shadow root for this element
        this._root = this.attachShadow({
            mode: "open"
        });
        if ($44200311ade9f8b6$var$SUPPORTS_ADOPTING_STYLE_SHEETS) {
            if (!$44200311ade9f8b6$var$styleSheet) {
                $44200311ade9f8b6$var$styleSheet = new CSSStyleSheet();
                $44200311ade9f8b6$var$styleSheet.replaceSync($44200311ade9f8b6$var$ELEMENT_STYLE);
            }
            this._root.adoptedStyleSheets = [
                $44200311ade9f8b6$var$styleSheet
            ];
        } else {
            const style = document.createElement("style");
            style.innerHTML = $44200311ade9f8b6$var$ELEMENT_STYLE;
            this._root.appendChild(style);
        }
        // create container
        const container = document.createElement("div");
        container.classList.add("body");
        this._root.appendChild(container);
        // create slot
        const slot = document.createElement("slot");
        container.appendChild(slot);
    }
    /**
     * Instantiate player intance on demand with assigned player factory.
     * @returns
     */ async createPlayer() {
        // notify about missing loader
        if (!$44200311ade9f8b6$export$db77ccec0bb4ccac._playerFactory) throw new Error("Missing player loader!");
        // we are already on lazy loading process
        if (this.delayedLoading) return;
        const iconData = await this.loadIconData();
        if (!iconData) return;
        this._player = $44200311ade9f8b6$export$db77ccec0bb4ccac._playerFactory(this.animationContainer, iconData);
        this._player.connect();
        // assign initial properties for icon
        if (this.state || this.colors || this.stroke) this.player.resetProperties({
            colors: (0, $5994bd0b27d605b9$export$a57960acb3070b5)(this.colors || ""),
            stroke: this.stroke,
            state: this.state
        });
        // listen for ready
        this._player.addEventListener("ready", ()=>{
            if (this._triggerInstance && this._triggerInstance.onReady) this._triggerInstance.onReady();
        });
        // listen for refresh
        this._player.addEventListener("refresh", ()=>{
            this.refresh();
            if (this._triggerInstance && this._triggerInstance.onRefresh) this._triggerInstance.onRefresh();
        });
        // listen for complete
        this._player.addEventListener("complete", ()=>{
            if (this._triggerInstance && this._triggerInstance.onComplete) this._triggerInstance.onComplete();
        });
        // listen for frame
        this._player.addEventListener("frame", ()=>{
            if (this._triggerInstance && this._triggerInstance.onFrame) this._triggerInstance.onFrame();
        });
        // refresh element instantly
        this.refresh();
        // create trigger (only if assigned)
        this.triggerChanged();
        // wait for player ready
        await new Promise((resolve, reject)=>{
            if (this._player.isReady) resolve();
            else this._player.addEventListener("ready", resolve);
        });
        // mark ready
        this._isReady = true;
        // notify about ready
        this.dispatchEvent(new CustomEvent("ready"));
    }
    /**
     * Destroy connected player and connected trigger.
     * Player is recreated on every icon data change.
     */ destroyPlayer() {
        // mark not ready
        this._isReady = false;
        // clear stored icon data
        this._loadedIconData = undefined;
        // remove trigger
        if (this._triggerInstance) {
            if (this._triggerInstance.onDisconnected) this._triggerInstance.onDisconnected();
            this._triggerInstance = undefined;
        }
        // remove player
        if (this._player) {
            this._player.disconnect();
            this._player = undefined;
        }
    }
    /**
     * Load icon with assigned icon loader or source indicated by src attribute.
     * @returns Icon data.
     */ async loadIconData() {
        let iconData = this.iconData;
        if (!iconData) {
            if (this.icon && $44200311ade9f8b6$export$db77ccec0bb4ccac._iconLoader) this._loadedIconData = iconData = await $44200311ade9f8b6$export$db77ccec0bb4ccac._iconLoader(this.icon);
            else if (this.src) {
                const response = await fetch(this.src);
                this._loadedIconData = iconData = await response.json();
            }
        }
        return iconData;
    }
    /**
     * Synchronize element state with player.
     */ refresh() {
        this.movePaletteToCssVariables();
    }
    /**
     * Update defaults for css variables.
     * Notice: css variables take precedence over colors assigned by other methods!
     */ movePaletteToCssVariables() {
        for (const [key, value] of Object.entries(this.player.colors || {}))this.animationContainer.style.setProperty(`--lord-icon-${key}-base`, value);
    }
    /**
     * Target attribute changed. Element should reload it's trigger.
     */ targetChanged() {
        this.triggerChanged();
    }
    /**
     * Loading attribute changed.
     */ loadingChanged() {}
    /**
     * Trigger attribute changed. Disconnect old trigger and instantiate new one.
     */ triggerChanged() {
        if (this._triggerInstance) {
            if (this._triggerInstance.onDisconnected) this._triggerInstance.onDisconnected();
            this._triggerInstance = undefined;
            this.player?.pause();
        }
        if (!this.trigger || !this._player) return;
        const TriggerClass = $44200311ade9f8b6$export$db77ccec0bb4ccac._definedTriggers.get(this.trigger);
        if (!TriggerClass) throw new Error(`Can't use unregistered trigger!`);
        const targetElement = this.target ? this.closest(this.target) : null;
        this._triggerInstance = new TriggerClass(this, targetElement || this, this._player);
        if (this._triggerInstance.onConnected) this._triggerInstance.onConnected();
        if (this._player.isReady && this._triggerInstance.onReady) this._triggerInstance.onReady();
    }
    /**
     * Colors attribute changed. Notify about new value player.
     */ colorsChanged() {
        if (!this.player) return;
        this.player.colors = (0, $5994bd0b27d605b9$export$a57960acb3070b5)(this.colors || "");
    }
    /**
     * Stroke attribute changed. Notify about new value player.
     */ strokeChanged() {
        if (!this.player) return;
        this.player.stroke = this.stroke;
    }
    /**
     * State attribute changed. Notify about new value player.
     */ stateChanged() {
        if (!this.player) return;
        this.player.state = this.state;
    }
    /**
     * Icon attribute changed. Reload our player.
     */ iconChanged() {
        if (!this._isConnected) return;
        this.destroyPlayer();
        this.createPlayer();
    }
    /**
     * Src attribute changed. Reload our player.
     */ srcChanged() {
        if (!this._isConnected) return;
        this.destroyPlayer();
        this.createPlayer();
    }
    /**
     * Update current icon. We can assign here icon name handled by {@link interfaces.IconLoader | icon loader} or right away {@link interfaces.IconData | icon data}.
     */ set icon(value) {
        if (value && (0, $6db2af7a7bb4b366$export$c10d0b04eaa80a43)(value)) {
            if (this._assignedIconData !== value) {
                this._assignedIconData = value;
                if (this.hasAttribute("icon")) this.removeAttribute("icon");
                else this.iconChanged();
            }
        } else {
            const oldIconData = this._assignedIconData;
            this._assignedIconData = undefined;
            if (value && typeof value === "string") this.setAttribute("icon", value);
            else {
                this.removeAttribute("icon");
                if (oldIconData) this.iconChanged();
            }
        }
    }
    /**
     * Get icon (icon name or assiged directly {@link interfaces.IconData | icon data})
     */ get icon() {
        return this._assignedIconData || this.getAttribute("icon");
    }
    /**
     * Set src value.
     */ set src(value) {
        if (value) this.setAttribute("src", value);
        else this.removeAttribute("src");
    }
    /**
     * Get src value.
     */ get src() {
        return this.getAttribute("src");
    }
    /**
     * Set state value.
     *
     * Notice: you can check available states for loaded icon with `states` property.
     */ set state(value) {
        if (value) this.setAttribute("state", value);
        else this.removeAttribute("state");
    }
    /**
     * Get state value.
     */ get state() {
        return this.getAttribute("state");
    }
    /**
     * Set colors value. We support here string format with comma color separation: "primary:#fdd394,secondary:#03a9f4".
     *
     * Example:
     * ```html
     * <lord-icon colors="primary:#fdd394,secondary:#03a9f4" src="/icons/confetti.json"></lord-icon>
     * ```
     */ set colors(value) {
        if (value) this.setAttribute("colors", value);
        else this.removeAttribute("colors");
    }
    /**
     * Get colors value.
     */ get colors() {
        return this.getAttribute("colors");
    }
    /**
     * Set trigger value. Provide name of already defined trigger!
     */ set trigger(value) {
        if (value) this.setAttribute("trigger", value);
        else this.removeAttribute("trigger");
    }
    /**
     * Get trigger value.
     */ get trigger() {
        return this.getAttribute("trigger");
    }
    /**
     * Set loading strategy. By default {@link interfaces.IconData | icon data} are loaded instantly on {@link interfaces.IPlayer | player} initialisation.
     * It's possible to delay icon loading (with _src_ and _icon_ attribute) by changing _loading_ value to _lazy_.
     */ set loading(value) {
        if (value) this.setAttribute("loading", value);
        else this.removeAttribute("loading");
    }
    /**
     * Get loading value.
     */ get loading() {
        if (this.getAttribute("loading")) {
            const param = this.getAttribute("loading").toLowerCase();
            if (param === "lazy") return "lazy";
            else if (param === "interaction") return "interaction";
        }
        return null;
    }
    /**
     * Assign query selector for closest element target used for listening events.
     */ set target(value) {
        if (value) this.setAttribute("target", value);
        else this.removeAttribute("target");
    }
    /**
     * Get target value.
     */ get target() {
        return this.getAttribute("target");
    }
    /**
     * Set stroke value (in range 0-100).
     */ set stroke(value) {
        if ((0, $6db2af7a7bb4b366$export$984f70f9382f5d27)(value)) this.removeAttribute("stroke");
        else this.setAttribute("stroke", "" + value);
    }
    /**
     * Get stroke value.
     */ get stroke() {
        if (this.hasAttribute("stroke")) return parseFloat(this.getAttribute("stroke"));
        return null;
    }
    /**
     * Access animation {@link interfaces.IPlayer | player}.
     */ get player() {
        return this._player;
    }
    /**
     * Check whether the element is ready (instantiated player, trigger and loaded icon data).
     *
     * You can listen for element ready with event listener:
     * ```js
     * element.addEventListener('ready', () => {});
     * ```
     */ get isReady() {
        return this._isReady;
    }
    /**
     * Access connected {@link interfaces.ITrigger | trigger} instance.
     */ get triggerInstance() {
        return this._triggerInstance;
    }
    /**
     * Access animation container element.
     */ get animationContainer() {
        return this._root.lastElementChild;
    }
    /**
     * Access loaded {@link interfaces.IconData | icon data}.
     */ get iconData() {
        return this._assignedIconData || this._loadedIconData;
    }
}





/**
 * Convert to hexadecimal value.
 * @param c
 * @returns
 */ function $36313d8e279739b7$var$componentToHex(c) {
    const hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
}
/**
 * Convert from color object to hex value.
 * @param value
 * @returns
 */ function $36313d8e279739b7$var$rgbToHex(value) {
    return "#" + $36313d8e279739b7$var$componentToHex(value.r) + $36313d8e279739b7$var$componentToHex(value.g) + $36313d8e279739b7$var$componentToHex(value.b);
}
/**
 * Conver from hex to color object.
 * @param hex
 * @returns
 */ function $36313d8e279739b7$var$hexToRgb(hex) {
    let data = parseInt(hex[0] != "#" ? hex : hex.substring(1), 16);
    return {
        r: data >> 16 & 255,
        g: data >> 8 & 255,
        b: data & 255
    };
}
/**
 * Helper method for scale value.
 * @param n
 * @returns
 */ function $36313d8e279739b7$var$toUnitVector(n) {
    return Math.round(n / 255 * 1000) / 1000;
}
/**
 * Helper method for scale value.
 * @param n
 * @returns
 */ function $36313d8e279739b7$var$fromUnitVector(n) {
    return Math.round(n * 255);
}
function $36313d8e279739b7$export$9b1326861d45e1fc(hex) {
    const { r: r, g: g, b: b } = $36313d8e279739b7$var$hexToRgb(hex);
    return [
        $36313d8e279739b7$var$toUnitVector(r),
        $36313d8e279739b7$var$toUnitVector(g),
        $36313d8e279739b7$var$toUnitVector(b)
    ];
}
function $36313d8e279739b7$export$f298b1946e7d77f(value) {
    const color = {
        r: $36313d8e279739b7$var$fromUnitVector(value[0]),
        g: $36313d8e279739b7$var$fromUnitVector(value[1]),
        b: $36313d8e279739b7$var$fromUnitVector(value[2])
    };
    return $36313d8e279739b7$var$rgbToHex(color);
}
function $36313d8e279739b7$export$3cb21709c4058847(data, options = {}) {
    const result = [];
    const { lottieInstance: lottieInstance } = options;
    if (!data || !data.layers) return result;
    data.layers.forEach((layer, layerIndex)=>{
        if (!layer.nm || !layer.ef || !layer.nm.toLowerCase().includes("change")) return;
        layer.ef.forEach((field, fieldIndex)=>{
            const value = field?.ef?.[0]?.v?.k;
            if (value === undefined) return;
            let path;
            if (lottieInstance) path = `renderer.elements.${layerIndex}.effectsManager.effectElements.${fieldIndex}.effectElements.0.p.v`;
            else path = `layers.${layerIndex}.ef.${fieldIndex}.ef.0.v.k`;
            let type;
            if (field.mn === "ADBE Color Control") type = "color";
            else if (field.mn === "ADBE Slider Control") type = "slider";
            else if (field.mn === "ADBE Point Control") type = "point";
            else if (field.mn === "ADBE Checkbox Control") type = "checkbox";
            if (!type) return;
            const name = field.nm.toLowerCase();
            result.push({
                name: name,
                path: path,
                value: value,
                type: type
            });
        });
    });
    return result;
}
function $36313d8e279739b7$export$ef218909be242c2(data, properties) {
    for (const property of properties)(0, $6db2af7a7bb4b366$export$adaa4cf7ef1b65be)(data, property.path, property.value);
}
function $36313d8e279739b7$export$d6d42e8cf3bb7a8(data, properties, value, { scale: scale } = {}) {
    for (const property of properties){
        if (property.type === "color") {
            if (typeof value === "object" && "r" in value && "g" in value && "b" in value) (0, $6db2af7a7bb4b366$export$adaa4cf7ef1b65be)(data, property.path, [
                $36313d8e279739b7$var$toUnitVector(value.r),
                $36313d8e279739b7$var$toUnitVector(value.g),
                $36313d8e279739b7$var$toUnitVector(value.b)
            ]);
            else if (Array.isArray(value)) (0, $6db2af7a7bb4b366$export$adaa4cf7ef1b65be)(data, property.path, value);
            else if (typeof value === "string") (0, $6db2af7a7bb4b366$export$adaa4cf7ef1b65be)(data, property.path, $36313d8e279739b7$export$9b1326861d45e1fc((0, $5994bd0b27d605b9$export$6e865ea70d7724f)(value)));
        } else if (property.type === "point") {
            let ratio = 1;
            if (scale) ratio = (property.value[0] + property.value[1]) / 2 / scale;
            if (typeof value === "object" && "x" in value && "y" in value) {
                (0, $6db2af7a7bb4b366$export$adaa4cf7ef1b65be)(data, property.path + ".0", value.x * ratio);
                (0, $6db2af7a7bb4b366$export$adaa4cf7ef1b65be)(data, property.path + ".1", value.y * ratio);
            } else if (Array.isArray(value)) {
                (0, $6db2af7a7bb4b366$export$adaa4cf7ef1b65be)(data, property.path + ".0", value[0] * ratio);
                (0, $6db2af7a7bb4b366$export$adaa4cf7ef1b65be)(data, property.path + ".1", value[1] * ratio);
            }
        } else {
            let ratio = 1;
            if (scale) ratio = property.value / scale;
            (0, $6db2af7a7bb4b366$export$adaa4cf7ef1b65be)(data, property.path, value * ratio);
        }
    }
}


const $c0e7d3c02a318605$export$e072de034011cabd = 50;
const $c0e7d3c02a318605$export$7571dcd03843eb5b = "state-";
const $c0e7d3c02a318605$export$9270a7c43b2d2573 = {
    renderer: "svg",
    loop: false,
    autoplay: false,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid meet",
        progressiveLoad: true,
        hideOnTransparent: true
    }
};
/**
 * Create convenient proxy for manipulating colors.
 */ function $c0e7d3c02a318605$var$createColorsProxy() {
    return new Proxy(this, {
        set: (target, property, value, receiver)=>{
            if (typeof property === "string") {
                if (value) (0, $36313d8e279739b7$export$d6d42e8cf3bb7a8)(this.lottie, this.rawProperties.filter((c)=>c.type === "color" && c.name === property.toLowerCase()), value);
                else (0, $36313d8e279739b7$export$ef218909be242c2)(this.lottie, this.rawProperties.filter((c)=>c.type === "color" && c.name === property.toLowerCase()));
                target.refresh();
            }
            return true;
        },
        get: (target, property, receiver)=>{
            for (const current of target.rawProperties)if (current.type == "color" && typeof property === "string" && property.toLowerCase() == current.name) {
                const data = (0, $6db2af7a7bb4b366$export$3988ae62b71be9a3)(this.lottie, current.path);
                if (data) return (0, $36313d8e279739b7$export$f298b1946e7d77f)(data);
            }
            return undefined;
        },
        deleteProperty: (target, property)=>{
            if (typeof property === "string") {
                (0, $36313d8e279739b7$export$ef218909be242c2)(this.lottie, this.rawProperties.filter((c)=>c.type === "color" && c.name === property.toLowerCase()));
                target.refresh();
            }
            return true;
        },
        ownKeys: (target)=>{
            return target.rawProperties.filter((c)=>c.type == "color").map((c)=>c.name);
        },
        has: (target, property)=>{
            for (const current of target.rawProperties){
                if (current.type == "color" && typeof property === "string" && property.toLowerCase() == current.name) return true;
            }
            return false;
        },
        getOwnPropertyDescriptor: (target)=>{
            return {
                enumerable: true,
                configurable: true
            };
        }
    });
}
class $c0e7d3c02a318605$export$2616165974278734 {
    _animationLoader;
    _container;
    _iconData;
    _options;
    _lottie;
    _isReady = false;
    _colorsProxy;
    _direction = 1;
    _speed = 1;
    _rawProperties;
    _eventCallbacks = {};
    /**
     *
     * @param animationLoader Provide `loadAnimation` here from `lottie-web`.
     * @param container DOM element in which the animation will be drawn.
     * @param iconData Lottie icon data.
     * @param options Options for `lottie-web`. If not provided {@link DEFAULT_LOTTIE_WEB_OPTIONS | default} will be used.
     */ constructor(animationLoader, container, iconData, options){
        this._animationLoader = animationLoader;
        this._container = container;
        this._iconData = iconData;
        this._options = options || $c0e7d3c02a318605$export$9270a7c43b2d2573;
    }
    connect() {
        if (this._lottie) throw new Error("Already connected player!");
        this._lottie = this._animationLoader({
            ...this._options,
            container: this._container,
            animationData: (0, $6db2af7a7bb4b366$export$b7d58db314e0ac27)(this._iconData)
        });
        this._lottie.addEventListener("complete", ()=>{
            this.triggerEvent("complete");
        });
        this._lottie.addEventListener("loopComplete", ()=>{
            this.triggerEvent("complete");
        });
        this._lottie.addEventListener("enterFrame", (params)=>{
            this.triggerEvent("frame");
        });
        if (this._lottie.isLoaded) {
            this._container.classList.add("ready");
            this._isReady = true;
            this.triggerEvent("ready");
        } else this._lottie.addEventListener("config_ready", ()=>{
            this._container.classList.add("ready");
            this._isReady = true;
            this.triggerEvent("ready");
        });
    }
    disconnect() {
        if (!this._lottie) throw new Error("Not connected player!");
        this._isReady = false;
        this._lottie.destroy();
        this._lottie = undefined;
        this._colorsProxy = undefined;
        this._rawProperties = undefined;
        this._container.classList.remove("ready");
    }
    addEventListener(name, callback) {
        if (!this._eventCallbacks[name]) this._eventCallbacks[name] = [];
        this._eventCallbacks[name].push(callback);
        return ()=>{
            this.removeEventListener(name, callback);
        };
    }
    removeEventListener(eventName, callback) {
        if (!callback) this._eventCallbacks[eventName] = null;
        else if (this._eventCallbacks[eventName]) {
            let i = 0;
            let len = this._eventCallbacks[eventName].length;
            while(i < len){
                if (this._eventCallbacks[eventName][i] === callback) {
                    this._eventCallbacks[eventName].splice(i, 1);
                    i -= 1;
                    len -= 1;
                }
                i += 1;
            }
            if (!this._eventCallbacks[eventName].length) this._eventCallbacks[eventName] = null;
        }
    }
    /**
     * Trigger event.
     * @param eventName Event name.
     * @param args Args.
     */ triggerEvent(eventName, args) {
        if (this._eventCallbacks[eventName]) {
            const callbacks = this._eventCallbacks[eventName];
            for(let i = 0; i < callbacks.length; i += 1)callbacks[i](args);
        }
    }
    /**
     * Refresh animation and notify about that fact.
     */ refresh() {
        this._lottie?.renderer.renderFrame(null);
        this.triggerEvent("refresh");
    }
    play() {
        this._lottie.play();
    }
    playFromBeginning() {
        this._lottie.goToAndPlay(0);
    }
    playSegment(from, to) {
        this._lottie.playSegments([
            from,
            to
        ], true);
    }
    pause() {
        this._lottie.pause();
    }
    stop() {
        this._lottie.stop();
    }
    goToFrame(frame) {
        this._lottie.goToAndStop(frame, true);
    }
    goToFirstFrame() {
        this.goToFrame(0);
    }
    goToLastFrame() {
        this.goToFrame(Math.max(0, this._lottie.getDuration(true) - 1));
    }
    resetProperties(properties = {}) {
        if (!properties || typeof properties !== "object") return;
        // allows to optimize initial assign properties without redundant reset to default
        const alreadyCustomized = this._rawProperties ? true : false;
        // colors
        if (alreadyCustomized) (0, $36313d8e279739b7$export$ef218909be242c2)(this._lottie, this.rawProperties.filter((c)=>c.type === "color"));
        if (properties.colors && !(0, $6db2af7a7bb4b366$export$984f70f9382f5d27)(properties.colors)) for (const [key, value] of Object.entries(properties.colors))(0, $36313d8e279739b7$export$d6d42e8cf3bb7a8)(this._lottie, this.rawProperties.filter((c)=>c.type === "color" && c.name === key.toLowerCase()), value);
        // state
        if (alreadyCustomized) (0, $36313d8e279739b7$export$ef218909be242c2)(this._lottie, this.rawProperties.filter((c)=>c.name.startsWith($c0e7d3c02a318605$export$7571dcd03843eb5b)));
        if (!(0, $6db2af7a7bb4b366$export$984f70f9382f5d27)(properties.state) && properties.state) {
            const name = `${$c0e7d3c02a318605$export$7571dcd03843eb5b}${properties.state.toLowerCase()}`;
            (0, $36313d8e279739b7$export$d6d42e8cf3bb7a8)(this._lottie, this.rawProperties.filter((c)=>c.name.startsWith($c0e7d3c02a318605$export$7571dcd03843eb5b)), 0);
            (0, $36313d8e279739b7$export$d6d42e8cf3bb7a8)(this._lottie, this.rawProperties.filter((c)=>c.name === name), 1);
        }
        // stroke
        if (!(0, $6db2af7a7bb4b366$export$984f70f9382f5d27)(properties.stroke)) (0, $36313d8e279739b7$export$d6d42e8cf3bb7a8)(this._lottie, this.rawProperties.filter((c)=>c.name === "stroke"), properties.stroke, {
            scale: $c0e7d3c02a318605$export$e072de034011cabd
        });
        else if (alreadyCustomized) (0, $36313d8e279739b7$export$ef218909be242c2)(this._lottie, this.rawProperties.filter((c)=>c.name === "stroke"));
        this.refresh();
    }
    set colors(colors) {
        (0, $36313d8e279739b7$export$ef218909be242c2)(this._lottie, this.rawProperties.filter((c)=>c.type === "color"));
        if (colors) for (const [key, value] of Object.entries(colors))(0, $36313d8e279739b7$export$d6d42e8cf3bb7a8)(this._lottie, this.rawProperties.filter((c)=>c.type === "color" && c.name === key.toLowerCase()), value);
        this.refresh();
    }
    get colors() {
        if (!this._colorsProxy) this._colorsProxy = $c0e7d3c02a318605$var$createColorsProxy.call(this);
        return this._colorsProxy;
    }
    set stroke(stroke) {
        if ((0, $6db2af7a7bb4b366$export$984f70f9382f5d27)(stroke)) (0, $36313d8e279739b7$export$ef218909be242c2)(this._lottie, this.rawProperties.filter((c)=>c.name === "stroke"));
        else (0, $36313d8e279739b7$export$d6d42e8cf3bb7a8)(this._lottie, this.rawProperties.filter((c)=>c.name === "stroke"), stroke, {
            scale: $c0e7d3c02a318605$export$e072de034011cabd
        });
        this.refresh();
    }
    get stroke() {
        const property = this.rawProperties.filter((c)=>c.name === "stroke")[0];
        if (property) return (0, $6db2af7a7bb4b366$export$3988ae62b71be9a3)(this._lottie, property.path) * ($c0e7d3c02a318605$export$e072de034011cabd / property.value);
        return null;
    }
    set state(state) {
        if ((0, $6db2af7a7bb4b366$export$984f70f9382f5d27)(state)) (0, $36313d8e279739b7$export$ef218909be242c2)(this._lottie, this.rawProperties.filter((c)=>c.name.startsWith($c0e7d3c02a318605$export$7571dcd03843eb5b)));
        else {
            const name = `${$c0e7d3c02a318605$export$7571dcd03843eb5b}${state.toLowerCase()}`;
            (0, $36313d8e279739b7$export$d6d42e8cf3bb7a8)(this._lottie, this.rawProperties.filter((c)=>c.name.startsWith($c0e7d3c02a318605$export$7571dcd03843eb5b)), 0);
            (0, $36313d8e279739b7$export$d6d42e8cf3bb7a8)(this._lottie, this.rawProperties.filter((c)=>c.name === name), 1);
        }
        this.refresh();
    }
    get state() {
        for (const property of this.rawProperties.filter((c)=>c.name.startsWith($c0e7d3c02a318605$export$7571dcd03843eb5b))){
            const value = (0, $6db2af7a7bb4b366$export$3988ae62b71be9a3)(this._lottie, property.path);
            if (value) return property.name.substr($c0e7d3c02a318605$export$7571dcd03843eb5b.length);
        }
        return null;
    }
    set speed(speed) {
        this._speed = speed;
        this._lottie?.setSpeed(speed);
    }
    get speed() {
        return this._speed;
    }
    set direction(direction) {
        this._direction = direction;
        this._lottie.setDirection(direction);
    }
    get direction() {
        return this._direction;
    }
    set loop(loop) {
        this._lottie.loop = loop;
    }
    get loop() {
        return this._lottie.loop ? true : false;
    }
    set frame(frame) {
        this.goToFrame(Math.max(0, Math.min(this.frames, frame)));
    }
    get frame() {
        return this._lottie.currentFrame;
    }
    get states() {
        return this.rawProperties.filter((c)=>c.name.startsWith($c0e7d3c02a318605$export$7571dcd03843eb5b)).map((c)=>{
            return c.name.substr($c0e7d3c02a318605$export$7571dcd03843eb5b.length);
        });
    }
    get isPlaying() {
        return !this._lottie.isPaused;
    }
    get isReady() {
        return this._isReady;
    }
    get frames() {
        return this._lottie.getDuration(true) - 1;
    }
    get duration() {
        return this._lottie.getDuration(false);
    }
    /**
     * Access to internal lottie player instance.
     */ get lottie() {
        return this._lottie;
    }
    /**
     * Supported customizable properties by loaded icon.
     */ get rawProperties() {
        if (!this._rawProperties && this._iconData) this._rawProperties = (0, $36313d8e279739b7$export$3cb21709c4058847)(this._iconData, {
            lottieInstance: true
        });
        return this._rawProperties || [];
    }
}


/**
 * Boomerang trigger plays animation from first to last frame when you hover over them, then play in reverse once you move the cursor away.
 */ class $c88ebfae7e3924cb$export$1edb88dd751a3efa {
    element;
    targetElement;
    player;
    constructor(element, targetElement, player){
        this.element = element;
        this.targetElement = targetElement;
        this.player = player;
        this.onHover = this.onHover.bind(this);
    }
    onConnected() {
        this.targetElement.addEventListener("mouseenter", this.onHover);
    }
    onDisconnected() {
        this.targetElement.removeEventListener("mouseenter", this.onHover);
        this.player.direction = 1;
    }
    onComplete() {
        this.player.direction = -1;
        this.player.play();
    }
    onHover() {
        this.player.direction = 1;
        this.player.play();
    }
}


const $7c6ab9e6f015be9e$var$CLICK_EVENTS = [
    {
        name: "mousedown"
    },
    {
        name: "touchstart",
        options: {
            passive: true
        }
    }
];
class $7c6ab9e6f015be9e$export$f84687c21789d9a3 {
    element;
    targetElement;
    player;
    constructor(element, targetElement, player){
        this.element = element;
        this.targetElement = targetElement;
        this.player = player;
        this.onClick = this.onClick.bind(this);
    }
    onConnected() {
        for (const event of $7c6ab9e6f015be9e$var$CLICK_EVENTS)this.targetElement.addEventListener(event.name, this.onClick, event.options);
    }
    onDisconnected() {
        for (const event of $7c6ab9e6f015be9e$var$CLICK_EVENTS)this.targetElement.removeEventListener(event.name, this.onClick);
    }
    onClick() {
        if (this.player.isPlaying) return;
        this.player.playFromBeginning();
    }
}


/**
 * Hover trigger plays the animation from the first to last frame when the cursor hovers over the icon bounding box.
 */ class $aa25da5e59bb91a2$export$70dd375dd4457bf8 {
    element;
    targetElement;
    player;
    constructor(element, targetElement, player){
        this.element = element;
        this.targetElement = targetElement;
        this.player = player;
        this.onHover = this.onHover.bind(this);
    }
    onConnected() {
        this.targetElement.addEventListener("mouseenter", this.onHover);
    }
    onDisconnected() {
        this.targetElement.removeEventListener("mouseenter", this.onHover);
    }
    onHover() {
        if (this.player.isPlaying) return;
        this.player.playFromBeginning();
    }
}


/**
 * LoopOnHover trigger plays the animation from first to last frame infinitely, when the cursor hovers over the icon.
 */ class $3150a8e909e09b98$export$1ee5e99d97c6567 {
    element;
    targetElement;
    player;
    playTimeout = null;
    mouseIn = false;
    constructor(element, targetElement, player){
        this.element = element;
        this.targetElement = targetElement;
        this.player = player;
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }
    onConnected() {
        this.targetElement.addEventListener("mouseenter", this.onMouseEnter);
        this.targetElement.addEventListener("mouseleave", this.onMouseLeave);
    }
    onDisconnected() {
        this.targetElement.removeEventListener("mouseenter", this.onMouseEnter);
        this.targetElement.removeEventListener("mouseleave", this.onMouseLeave);
        this.resetPlayDelayTimer();
    }
    onMouseEnter() {
        this.mouseIn = true;
        if (!this.player.isPlaying) this.play();
    }
    onMouseLeave() {
        this.mouseIn = false;
        this.resetPlayDelayTimer();
    }
    onComplete() {
        this.play();
    }
    play() {
        this.resetPlayDelayTimer();
        if (!this.mouseIn) return;
        if (this.delay > 0) this.playTimeout = setTimeout(()=>{
            this.player.playFromBeginning();
        }, this.delay);
        else this.player.playFromBeginning();
    }
    resetPlayDelayTimer() {
        if (!this.playTimeout) return;
        clearTimeout(this.playTimeout);
        this.playTimeout = null;
    }
    get delay() {
        const value = this.element.hasAttribute("delay") ? +(this.element.getAttribute("delay") || 0) : 0;
        return Math.max(value, 0);
    }
}


/**
 * Loop trigger plays the animation from first to last frame infinitely, with no interaction necessary.
 */ class $0b6681fc328ef380$export$550acbd06a1f5a6a {
    element;
    targetElement;
    player;
    playTimeout = null;
    constructor(element, targetElement, player){
        this.element = element;
        this.targetElement = targetElement;
        this.player = player;
    }
    onReady() {
        this.play();
    }
    onComplete() {
        this.play();
    }
    onDisconnected() {
        this.resetPlayDelayTimer();
    }
    play() {
        this.resetPlayDelayTimer();
        if (this.delay > 0) this.playTimeout = setTimeout(()=>{
            this.player.playFromBeginning();
        }, this.delay);
        else this.player.playFromBeginning();
    }
    resetPlayDelayTimer() {
        if (!this.playTimeout) return;
        clearTimeout(this.playTimeout);
        this.playTimeout = null;
    }
    get delay() {
        const value = this.element.hasAttribute("delay") ? +(this.element.getAttribute("delay") || 0) : 0;
        return Math.max(value, 0);
    }
}


/**
 * Hover or click the icon to plays the animation from first to the last frame. After moving or clicking away, the animation plays in reverse.
 */ class $1efd4c610bd8fa48$export$24a95a7694c627b7 {
    element;
    targetElement;
    player;
    constructor(element, targetElement, player){
        this.element = element;
        this.targetElement = targetElement;
        this.player = player;
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }
    onConnected() {
        this.targetElement.addEventListener("mouseenter", this.onMouseEnter);
        this.targetElement.addEventListener("mouseleave", this.onMouseLeave);
    }
    onDisconnected() {
        this.targetElement.removeEventListener("mouseenter", this.onMouseEnter);
        this.targetElement.removeEventListener("mouseleave", this.onMouseLeave);
        this.player.direction = 1;
    }
    onMouseEnter() {
        this.player.direction = 1;
        this.player.play();
    }
    onMouseLeave() {
        this.player.direction = -1;
        this.player.play();
    }
}


const $28727ad226a08f18$var$NUMBER_REGEX = /^\d*(\.\d+)?$/;
const $28727ad226a08f18$var$MUTATION_OBSERVER_CONFIG = {
    attributes: true,
    childList: false,
    subtree: false
};
class $28727ad226a08f18$export$edde1bcb1b2b310e {
    element;
    targetElement;
    player;
    sequenceIndex = 0;
    frameState = null;
    frameDelayFirst = null;
    frameDelayLast = null;
    timer;
    observer;
    constructor(element, targetElement, player){
        this.element = element;
        this.targetElement = targetElement;
        this.player = player;
        this.observer = new MutationObserver((mutationList, observer)=>{
            for (const mutation of mutationList)if (mutation.type === "attributes" && mutation.attributeName === "sequence") {
                this.reset();
                this.step();
            }
        });
    }
    onReady() {
        this.step();
    }
    onComplete() {
        this.timer = setTimeout(()=>{
            this.timer = null;
            this.frameDelayLast = null;
            this.step();
        }, this.frameDelayLast || 0);
    }
    onConnected() {
        this.observer.observe(this.element, $28727ad226a08f18$var$MUTATION_OBSERVER_CONFIG);
    }
    onDisconnected() {
        this.observer.disconnect();
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }
    reset() {
        this.player.pause();
        this.sequenceIndex = 0;
        this.frameState = this.frameDelayFirst = this.frameDelayLast = null;
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }
    takeStep() {
        const steps = this.sequence.split(",");
        const step = steps[this.sequenceIndex];
        this.sequenceIndex++;
        if (this.sequenceIndex >= steps.length) this.sequenceIndex = 0;
        const [action, ...params] = step.split(":");
        return {
            action: action,
            params: params
        };
    }
    handleStep(action, params) {
        if (action === "play") {
            if (this.frameState) {
                this.player.state = this.frameState;
                this.frameState = null;
            }
            const hasReverse = params.includes("reverse");
            if (hasReverse) {
                this.player.goToLastFrame();
                this.player.direction = -1;
            } else {
                this.player.goToFirstFrame();
                this.player.direction = 1;
            }
            this.timer = setTimeout(()=>{
                this.timer = null;
                this.frameDelayFirst = null;
                this.player.play();
            }, this.frameDelayFirst || 0);
        } else if (action === "frame") {
            let frameIndex = 0;
            if (params.length && params[0].match($28727ad226a08f18$var$NUMBER_REGEX)) frameIndex = Math.max(0, Math.min(this.player.frames, +params[0]));
            this.player.frame = frameIndex;
            this.timer = setTimeout(()=>{
                this.timer = null;
                this.frameDelayFirst = null;
                this.step();
            }, this.frameDelayFirst || 0);
        } else if (action === "state") {
            this.frameState = params[0];
            this.step();
        } else if (action === "delay") {
            let value = null;
            for (const param of params)if (param && param.match($28727ad226a08f18$var$NUMBER_REGEX)) value = +param;
            if (value && value > 0) {
                if (params.includes("first") && params.includes("last")) {
                    this.frameDelayFirst = value;
                    this.frameDelayLast = value;
                } else if (params.includes("first")) this.frameDelayFirst = value;
                else if (params.includes("last")) this.frameDelayLast = value;
                else this.frameDelayFirst = value;
            }
            this.step();
        } else if (action === "idle") ;
        else throw new Error(`Invalid sequence action: ${action}`);
    }
    step() {
        const { action: action, params: params } = this.takeStep();
        if (!action) return;
        this.handleStep(action, params);
    }
    get sequence() {
        return this.element.getAttribute("sequence") || "";
    }
}


function $5162d7e40691ff4b$export$f1a7b7f485988794(animationLoader) {
    (0, $44200311ade9f8b6$export$db77ccec0bb4ccac).setPlayerFactory((container, iconData)=>{
        return new (0, $c0e7d3c02a318605$export$2616165974278734)(animationLoader, container, iconData);
    });
    (0, $44200311ade9f8b6$export$db77ccec0bb4ccac).defineTrigger("click", (0, $7c6ab9e6f015be9e$export$f84687c21789d9a3));
    (0, $44200311ade9f8b6$export$db77ccec0bb4ccac).defineTrigger("hover", (0, $aa25da5e59bb91a2$export$70dd375dd4457bf8));
    (0, $44200311ade9f8b6$export$db77ccec0bb4ccac).defineTrigger("loop", (0, $0b6681fc328ef380$export$550acbd06a1f5a6a));
    (0, $44200311ade9f8b6$export$db77ccec0bb4ccac).defineTrigger("loop-on-hover", (0, $3150a8e909e09b98$export$1ee5e99d97c6567));
    (0, $44200311ade9f8b6$export$db77ccec0bb4ccac).defineTrigger("morph", (0, $1efd4c610bd8fa48$export$24a95a7694c627b7));
    (0, $44200311ade9f8b6$export$db77ccec0bb4ccac).defineTrigger("boomerang", (0, $c88ebfae7e3924cb$export$1edb88dd751a3efa));
    (0, $44200311ade9f8b6$export$db77ccec0bb4ccac).defineTrigger("sequence", (0, $28727ad226a08f18$export$edde1bcb1b2b310e));
    if (!customElements.get || !customElements.get("lord-icon")) customElements.define("lord-icon", (0, $44200311ade9f8b6$export$db77ccec0bb4ccac));
}


// register lottie and define custom element
(0, $5162d7e40691ff4b$export$f1a7b7f485988794)((0, (/*@__PURE__*/$parcel$interopDefault($22I3K))).loadAnimation);
const $8420720b4bfb8079$var$LordIcon = ({ colors: colors, src: src, size: size, trigger: trigger = "morph", delay: delay })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("lord-icon", {
        colors: `primary:${colors?.primary},secondary:${colors?.secondary}`,
        src: src,
        trigger: trigger,
        delay: delay,
        style: {
            strokeWidth: 10,
            width: size,
            height: size
        }
    });
};
var $8420720b4bfb8079$export$2e2bcd8739ae039 = $8420720b4bfb8079$var$LordIcon;


const $19dce42d13e14dcb$export$33c5fb191636518a = (s)=>s.charAt(0).toUpperCase() + s.slice(1);


const $f80bd28e425406b2$var$CategoryPreview = ({ category: category, active: active, onClick: onClick, className: className })=>{
    const [isHover, setHover] = (0, $3QbnI.useState)(false);
    const color = onClick && (isHover || active) ? "#111827" : "#6B7280";
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("categories");
    const title = (0, $19dce42d13e14dcb$export$33c5fb191636518a)(t(category.name));
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("relative flex-[0_0_60px] w-[100px] flex flex-col items-center pt-0 pb-4 md:pb-4 text-gray-500 transition-all outline-none outline-0 ", {
            "text-gray-900": active,
            "hover:text-gray-900": onClick,
            "cursor-pointer": onClick && !active,
            "cursor-default	": !onClick || active
        }, className),
        onMouseEnter: ()=>setHover(true),
        onMouseLeave: ()=>setHover(false),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $8420720b4bfb8079$export$2e2bcd8739ae039), {
                src: `/icons/${category.image}.json`,
                colors: {
                    primary: color,
                    secondary: color
                },
                size: 45
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "text-2xs font-medium w-16",
                children: title
            }),
            active ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "absolute left-0 right-0 bottom-1 md:bottom-2 flex justify-center",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    className: "bg-gray-900 h-[6px] w-[6px] rounded-full"
                })
            }) : null
        ]
    });
};
var $f80bd28e425406b2$export$2e2bcd8739ae039 = $f80bd28e425406b2$var$CategoryPreview;


const $2dfa5316a961482a$var$matchCategory = (query, category)=>{
    if (typeof query !== "string" || !query.startsWith("#")) return false;
    return query.toLowerCase().substring(1) === category.name.toLowerCase();
};
var $2dfa5316a961482a$export$2e2bcd8739ae039 = $2dfa5316a961482a$var$matchCategory;


const $3483a31e557c8105$var$shouldHelpUserAboutCategories = (recipes, categories)=>recipes.length > 5 && categories.length < 4 && recipes.length > 10 * categories.length;
var $3483a31e557c8105$export$2e2bcd8739ae039 = $3483a31e557c8105$var$shouldHelpUserAboutCategories;






/**
 * These categories are groups of recipes based on
 *  - the healthiest
 *  - special diets
 *  - the most popular
 *  - time of the days
 *  - promoting fruits
 *
 * 7 meals of the day https://www.englishclub.com/ref/esl/Power_of_7/7_Meals_of_the_Day_2946.php
 */ const $123d6e77c3059d22$var$categories = [
    {
        name: "vegan",
        image: "586-vege-outline-edited"
    },
    {
        name: "gluten-free",
        image: "597-gluten-free-outline-edited"
    },
    {
        name: "fish",
        image: "522-fish-outline-edited"
    },
    // { name: 'cocktail', image: 'kplycyjp' },
    {
        name: "sushi",
        image: "621-shushi-outline-edited"
    },
    {
        name: "pie",
        image: "573-apple-pie-outline-edited"
    },
    {
        name: "ice cream",
        image: "549-ice-cream-scoops-outline-edited"
    },
    {
        name: "rice",
        image: "2236-risotto-rice-dish-outline-edited"
    },
    {
        name: "soup",
        image: "2372-bowl-of-soup-outline-edited"
    },
    {
        name: "dessert",
        image: "548-birthday-cake-candle-outline-edited"
    },
    {
        name: "meat",
        image: "550-meat-outline-edited"
    },
    {
        name: "seafood",
        image: "568-shrimp-outline-edited"
    },
    {
        name: "juice",
        image: "600-juice-outline-edited"
    },
    {
        name: "pasta",
        image: "603-plate-pasta-outline-edited"
    },
    {
        name: "cheese",
        image: "556-cheese-outline-edited"
    },
    {
        name: "taco",
        image: "566-taco-outline-edited"
    },
    {
        name: "candy",
        image: "2230-candy-cane-outline-edited"
    },
    {
        name: "egg",
        image: "619-fried-egg-outline-edited"
    },
    {
        name: "pastry",
        image: "574-croissant-outline-edited"
    },
    {
        name: "breakfast",
        image: "2348-pancakes-outline-edited"
    },
    {
        name: "bread",
        image: "546-bread-outline-edited"
    },
    {
        name: "chocolate",
        image: "517-chocolate-bar-outline-edited"
    },
    {
        name: "fritters",
        image: "2333-fritters-outline-edited"
    },
    {
        name: "coffee",
        image: "239-coffee-outline-edited"
    },
    {
        name: "biscuit",
        image: "2335-shortbread-outline-edited"
    },
    {
        name: "donut",
        image: "564-donut-outline-edited"
    },
    {
        name: "fries",
        image: "567-french-fries-chips-outline-edited"
    },
    {
        name: "strawberries",
        image: "578-strawberry-outline-edited"
    },
    {
        name: "grape",
        image: "581-grape-outline-edited"
    },
    {
        name: "banana",
        image: "577-banana-outline-edited"
    },
    {
        name: "pizza",
        image: "13-pizza-outline-edited"
    },
    {
        name: "apple",
        image: "543-apple-outline-edited"
    },
    {
        name: "baby",
        image: "1512-mom-feeding-baby-outline-edited"
    },
    {
        name: "pregnancy diet",
        image: "1270-fetus-outline-edited"
    },
    {
        name: "pineapple",
        image: "1843-pineapple-outline-edited"
    },
    {
        name: "drink",
        image: "600-juice-outline-edited"
    },
    {
        name: "spicy",
        image: "587-one-chili-pepper-hot-outline-edited"
    },
    {
        name: "honey",
        image: "557-honey-outline-edited"
    },
    {
        name: "appetizer",
        image: "627-brezel-outline-edited"
    },
    {
        name: "snack",
        image: "565-toast-sandwich-outline-edited"
    },
    // { name: 'baking', image: '675-male-cook-outline-edited' },
    {
        name: "avocado",
        image: "594-avocado-outline-edited"
    },
    {
        name: "alcohol",
        image: "519-glass-pint-beer-outline-edited"
    },
    {
        name: "waffle",
        image: "2375-waffle-outline-edited"
    },
    {
        name: "sausage",
        image: "563-sausage-outline-edited"
    },
    // { name: 'cookie', image: 'jwdvjivv' }, // not common
    {
        name: "nuts",
        image: "2371-nuts-outline-edited"
    }
];
var $123d6e77c3059d22$export$2e2bcd8739ae039 = $123d6e77c3059d22$var$categories;


const $163820ab4cc89429$export$32870b1225ca4cee = (0, $025f9f9d97dabd31$export$595d22ed68ca2841)((0, $87c50e51b43ee465$export$f07ccb41aacbe85f), (keywords)=>(0, $123d6e77c3059d22$export$2e2bcd8739ae039).filter((c)=>keywords.includes(c.name)));
const $163820ab4cc89429$export$26c8a88487819158 = (0, $025f9f9d97dabd31$export$595d22ed68ca2841)((0, $87c50e51b43ee465$export$3b86e2cc0677644d), (recipes)=>(0, $123d6e77c3059d22$export$2e2bcd8739ae039).filter((c)=>!recipes.some((r)=>r.keywords.includes(c.name))));
const $163820ab4cc89429$export$4477981a0058a5c4 = (0, $025f9f9d97dabd31$export$595d22ed68ca2841)($163820ab4cc89429$export$32870b1225ca4cee, (categories)=>categories.length >= 1);





const $97b0e1721aec3c95$var$CategoriesList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).forwardRef(// eslint-disable-next-line sonarjs/cognitive-complexity
({ className: className }, ref)=>{
    const { query: query, searchStatus: searchStatus, setCategory: setCategory, setSearch: setSearch } = (0, $b62c837cabb699aa$export$2e2bcd8739ae039)();
    const availableCategories = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $163820ab4cc89429$export$32870b1225ca4cee));
    const areCategoriesVisible = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $163820ab4cc89429$export$4477981a0058a5c4));
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const recipes = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $87c50e51b43ee465$export$3b86e2cc0677644d));
    const helpPopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    const recipesWithoutCategories = recipes.filter((r)=>r.keywords.length === 0);
    const unusedCategories = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $163820ab4cc89429$export$26c8a88487819158));
    const listRef = (0, $3QbnI.useRef)(null);
    const listContainerRef = (0, $3QbnI.useRef)(null);
    const [isLeftArrowVisible, showLeftArrow] = (0, $3QbnI.useState)(false);
    const [isRightArrowVisible, showRightArrow] = (0, $3QbnI.useState)(false);
    const updateArrows = (0, $3QbnI.useCallback)(()=>{
        if ((0, $1904509318c783c3$export$2e2bcd8739ae039)()) {
            showRightArrow(listRef.current?.scrollLeft !== 0);
            if (listContainerRef.current && listRef.current) showLeftArrow(listRef.current?.scrollWidth !== listRef.current?.offsetWidth + listRef.current?.scrollLeft);
        } else {
            showLeftArrow(listRef.current?.scrollLeft !== 0);
            if (listContainerRef.current && listRef.current) showRightArrow(listRef.current?.scrollWidth !== listRef.current?.offsetWidth + listRef.current?.scrollLeft);
        }
    }, []);
    (0, $3QbnI.useEffect)(()=>{
        updateArrows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recipes
    ]);
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("scroll", updateArrows, listRef.current);
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("resize", updateArrows);
    if (!areCategoriesVisible) return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {});
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: className,
                ref: ref,
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    className: "relative h-26 !p-0 md:!px-4 lg:!px-16",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                        className: "w-full h-24 overflow-hidden relative",
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                            className: "overflow-x-scroll scroll-smooth ",
                            ref: listRef,
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                className: "pt-1 md:pt-2 pb-10 flex items-center gap-x-0 md:gap-x-2 lg:gap-x-4",
                                ref: listContainerRef,
                                children: [
                                    availableCategories.map((c)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f80bd28e425406b2$export$2e2bcd8739ae039), {
                                            category: c,
                                            active: (0, $2dfa5316a961482a$export$2e2bcd8739ae039)(query, c),
                                            onClick: ()=>{
                                                const newCategory = (0, $2dfa5316a961482a$export$2e2bcd8739ae039)(query, c) ? undefined : c.name;
                                                setCategory(newCategory);
                                            }
                                        }, c.name)),
                                    (0, $3483a31e557c8105$export$2e2bcd8739ae039)(recipes, availableCategories) && searchStatus !== (0, $fedaffc39b995a23$export$2e2bcd8739ae039).NoCategory ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).White, {
                                        className: "ml-5 hidden md:inline-flex items-center",
                                        onClick: helpPopup.open,
                                        children: [
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $15cf4acae0354248$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 mr-2 stroke-2"
                                            }),
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                                className: "text-xs font-semibold",
                                                children: t("Add more categories")
                                            })
                                        ]
                                    }) : null,
                                    searchStatus === (0, $fedaffc39b995a23$export$2e2bcd8739ae039).NoCategory ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).White, {
                                        className: "ml-5 hidden md:inline-flex",
                                        onClick: ()=>setSearch(undefined),
                                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                            className: "text-xs font-semibold",
                                            children: t("_Show all recipes")
                                        })
                                    }) : null,
                                    isLeftArrowVisible && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                                className: "hidden absolute top-0 bottom-0 left-0 w-16 md:flex flex-col justify-center items-start",
                                                children: [
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                        className: "absolute top-0 bottom-0 left-0 bg-white w-6"
                                                    }),
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                        className: "absolute top-0 bottom-0 left-6 bg-gradient-to-r from-white to-transparent w-10"
                                                    }),
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Circle, {
                                                        "aria-label": "fdf",
                                                        className: "relative",
                                                        onClick: ()=>{
                                                            if (listRef.current) listRef.current.scrollLeft -= listRef.current.clientWidth / 2;
                                                        },
                                                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f76f2b54eee5c351$export$2e2bcd8739ae039), {
                                                            className: "h-6 w-6 stroke-2"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                className: "absolute block md:hidden top-0 bottom-0 left-0 bg-gradient-to-r from-white to-transparent w-10"
                                            })
                                        ]
                                    }),
                                    isRightArrowVisible && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                                className: "hidden absolute top-0 bottom-0 right-0 w-16 md:flex flex-col justify-center items-end",
                                                children: [
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                        className: "absolute top-0 bottom-0 right-0 bg-white w-6"
                                                    }),
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                        className: "absolute top-0 bottom-0 right-6 bg-gradient-to-l from-white to-transparent w-10"
                                                    }),
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Circle, {
                                                        "aria-label": "fdf",
                                                        className: "relative",
                                                        onClick: ()=>{
                                                            if (listRef.current) listRef.current.scrollLeft += listRef.current.clientWidth / 2;
                                                        },
                                                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ae741233dfd13442$export$2e2bcd8739ae039), {
                                                            className: "h-6 w-6 stroke-2"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                className: "absolute block md:hidden top-0 bottom-0 right-0 bg-gradient-to-l from-white to-transparent w-10"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
                open: helpPopup.isOpen,
                onClose: helpPopup.close,
                title: t("_How to add categories?"),
                description: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                            children: t("_Some categories are not used", {
                                categoriesCount: unusedCategories.length
                            })
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                            className: "relative py-5",
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("grid grid-cols-3  overflow-hidden relative", {
                                        "h-[145px]": unusedCategories.length > 6
                                    }),
                                    children: [
                                        unusedCategories.slice(0, 6).map((c)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f80bd28e425406b2$export$2e2bcd8739ae039), {
                                                category: c,
                                                className: "!m-0"
                                            }, c.name)),
                                        unusedCategories.length > 6 && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                            className: "absolute h-28 bottom-0 left-0 right-0 bg-gradient-to-b from-transparent to-white"
                                        })
                                    ]
                                }),
                                unusedCategories.length > 6 && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                    className: "text-xs font-semibold text-gray-900",
                                    children: t("And many more...")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("p", {
                            className: "pt-2",
                            children: [
                                t("_Add some suggested keywords to your recipes"),
                                t("_They could help you to find your recipes even easier")
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Black, {
                    className: "w-full",
                    onClick: ()=>{
                        setSearch("@no category");
                        helpPopup.close();
                    },
                    children: t("_Show the recipes without categories", {
                        recipesCount: recipesWithoutCategories.length
                    })
                })
            })
        ]
    });
});
$97b0e1721aec3c95$var$CategoriesList.displayName = "CategoriesList";
var $97b0e1721aec3c95$export$2e2bcd8739ae039 = $97b0e1721aec3c95$var$CategoriesList;





var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
function $f0c816fe81928fc7$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        d: "M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
    }));
}
const $f0c816fe81928fc7$var$ForwardRef = $3QbnI.forwardRef($f0c816fe81928fc7$var$XMarkIcon);
var $f0c816fe81928fc7$export$2e2bcd8739ae039 = $f0c816fe81928fc7$var$ForwardRef;





var $3QbnI = parcelRequire("3QbnI");
const $81bc4de07ec4fa7e$var$useTimeout = ()=>{
    const timeouts = (0, $3QbnI.useRef)([]);
    const setCustomTimeout = (callback, timeout)=>{
        const t = setTimeout(callback, timeout);
        timeouts.current.push(t);
        return t;
    };
    (0, $3QbnI.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            timeouts.current.forEach((t)=>{
                clearTimeout(t);
            });
        };
    }, []);
    return setCustomTimeout;
};
var $81bc4de07ec4fa7e$export$2e2bcd8739ae039 = $81bc4de07ec4fa7e$var$useTimeout;



const $6feff3a951ac50d7$var$SearchInput = /*#__PURE__*/ (0, $3QbnI.forwardRef)(({ className: className, disableAutoClose: disableAutoClose }, ref)=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const { query: query, isSearchActive: isSearchActive, setSearch: setSearch } = (0, $b62c837cabb699aa$export$2e2bcd8739ae039)();
    const setTimeoutSafe = (0, $81bc4de07ec4fa7e$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("relative", className),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "absolute inset-y-0 ltr:left-0 ltr:pl-3 rtl:right-0 rtl:pr-3 flex items-center pointer-events-none",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a430323085bba83a$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("h-5 w-5", isSearchActive ? "text-primary-600 font-extrabold" : "text-gray-400"),
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("input", {
                id: "search",
                name: "search-recipes",
                className: "block w-full ltr:pl-10 ltr:pr-3 rtl:pr-10 rtl:pl-3 py-2 border border-gray-300 rounded-full leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-primary-500 focus:border-primary-500 sm:text-sm",
                placeholder: isSearchActive ? t("_Search in recipes") : t("_Search"),
                type: "text",
                ref: ref,
                onChange: (event)=>setSearch(event.target.value),
                onKeyDown: (event)=>{
                    if (event.key === "Escape") setSearch(undefined);
                },
                value: query || "",
                "aria-label": t("_Search in recipes"),
                onFocus: ()=>{
                    if (query === undefined) setSearch("");
                },
                onBlur: ()=>{
                    if (!disableAutoClose && !query) setTimeoutSafe(()=>{
                        setSearch(undefined);
                    }, 100);
                }
            }),
            isSearchActive ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("button", {
                className: "absolute inset-y-0 ltr:right-0 ltr:pr-1.5 rtl:left-0 rtl:pl-1.5 flex py-1.5 items-center cursor-pointer ",
                onClick: ()=>{
                    setSearch(undefined);
                },
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f0c816fe81928fc7$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 stroke-1 text-gray-400 rounded-full hover:text-gray-300 block",
                    "aria-hidden": "true"
                })
            }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "absolute inset-y-0 ltr:right-0 ltr:pr-1.5 rtl:left-0 rtl:pl-1.5 flex py-1.5 hidden lg:block pointer-events-none",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("kbd", {
                    className: "inline-flex items-center rounded-full px-2 text-sm font-sans font-medium text-gray-400 bg-white",
                    children: "\u2318K"
                })
            })
        ]
    });
});
var $6feff3a951ac50d7$export$2e2bcd8739ae039 = $6feff3a951ac50d7$var$SearchInput;




const $828fdd92dea8ba54$var$RecipeListHeader = ({ restRef: restRef, hideSearch: hideSearch, className: className })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const { isSearchActive: isSearchActive, setSearch: setSearch } = (0, $b62c837cabb699aa$export$2e2bcd8739ae039)();
    const startSearchOnMobile = ()=>{
        setSearch("");
        setTimeout(()=>{
            if (!inputMobileRef.current) return;
            inputMobileRef.current.focus();
        }, 100);
    };
    const newRecipePopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    const importHelpPopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    const inputMobileRef = (0, $3QbnI.useRef)(null);
    const inputRef = (0, $3QbnI.useRef)(null);
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("keydown", (event)=>{
        if (event.key === "k" && (event.metaKey || event.ctrlKey) && inputRef.current) {
            event.preventDefault();
            inputRef?.current?.focus();
        }
    });
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a3758683e16a4079$export$2e2bcd8739ae039), {
                restRef: restRef,
                offset: 0,
                className: `bg-white ${className}`,
                children: (isMaximized)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))({
                            shadow: isMaximized
                        }),
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4bf72665163a8648$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                className: "border-b border-gray-200",
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                    className: "flex-auto flex items-center pointer-events-auto",
                                    children: [
                                        isSearchActive && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $6feff3a951ac50d7$export$2e2bcd8739ae039), {
                                            className: "flex-1 block md:hidden",
                                            disableAutoClose: true,
                                            ref: inputMobileRef
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("flex-1 items-center", {
                                                "hidden md:flex": isSearchActive,
                                                flex: !isSearchActive
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $2177ccffcfec9146$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                                    className: "flex-1"
                                                }),
                                                !hideSearch && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("flex-1 hidden lg:block me-4 ms-0 transition-all", isSearchActive ? "lg:max-w-xs" : "lg:max-w-[10rem]"),
                                                            children: [
                                                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("label", {
                                                                    htmlFor: "search",
                                                                    className: "sr-only",
                                                                    children: t("_Try banana bread")
                                                                }),
                                                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $6feff3a951ac50d7$export$2e2bcd8739ae039), {
                                                                    ref: inputRef
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("button", {
                                                            className: "mr-4 hidden md:block lg:hidden text-gray-400 rounded-full hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500",
                                                            onClick: startSearchOnMobile,
                                                            "aria-label": t("_Search in recipes"),
                                                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a430323085bba83a$export$2e2bcd8739ae039), {
                                                                className: "h-8 w-8 stroke-1 ",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $056015557140b68d$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5e4be98a434b893c$export$2e2bcd8739ae039), {
                                                        onHelpRequest: importHelpPopup.open
                                                    })
                                                }),
                                                !hideSearch && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("button", {
                                                    className: "ml-4 mr-4 block md:hidden text-gray-400 rounded-full hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500",
                                                    onClick: startSearchOnMobile,
                                                    "aria-label": t("_Search in recipes"),
                                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a430323085bba83a$export$2e2bcd8739ae039), {
                                                        className: "h-8 w-8 stroke-1 ",
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Icon, {
                                                    onClick: newRecipePopup.open,
                                                    icon: (0, $b9c44658f5039ce5$export$2e2bcd8739ae039),
                                                    className: "block md:hidden rounded-md !text-white !bg-primary-500 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500",
                                                    "aria-label": t("_Create Recipe")
                                                }),
                                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5f0b2e9935864fb1$export$2e2bcd8739ae039), {})
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $97b0e1721aec3c95$export$2e2bcd8739ae039), {})
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
                title: t("_New Recipe"),
                open: newRecipePopup.isOpen,
                onClose: newRecipePopup.close,
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5e4be98a434b893c$export$2e2bcd8739ae039), {
                    onHelpRequest: importHelpPopup.open
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $08c6359faa91c4f1$export$2e2bcd8739ae039), {
                open: importHelpPopup.isOpen,
                onClose: importHelpPopup.close
            })
        ]
    });
};
var $828fdd92dea8ba54$export$2e2bcd8739ae039 = $828fdd92dea8ba54$var$RecipeListHeader;





const $da9a8dcd6ea2647a$var$EmptyMessage = ({ title: title, message: message, children: children })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h3", {
                className: "mt-2 text-base font-medium text-gray-900",
                children: title
            }),
            message && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                className: "mt-1 text-base text-gray-500",
                children: message
            }),
            children && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "mt-6",
                children: children
            })
        ]
    });
};
var $da9a8dcd6ea2647a$export$2e2bcd8739ae039 = $da9a8dcd6ea2647a$var$EmptyMessage;






var $3QbnI = parcelRequire("3QbnI");






var $3QbnI = parcelRequire("3QbnI");

const $8d3f0d7eea683f25$var$thumbnailUrl = (url)=>url.replace(/banner%2F([a-zA-Z0-9-]*\.[a-zAZ])/, `banner%2Fthumb_$1`);
var $8d3f0d7eea683f25$export$2e2bcd8739ae039 = $8d3f0d7eea683f25$var$thumbnailUrl;





var $48afa93f9f65698e$export$2d718f8c6ef64076;
(function(BadgeSize) {
    BadgeSize[BadgeSize["small"] = 0] = "small";
    BadgeSize[BadgeSize["large"] = 1] = "large";
})($48afa93f9f65698e$export$2d718f8c6ef64076 || ($48afa93f9f65698e$export$2d718f8c6ef64076 = {}));
const $48afa93f9f65698e$var$Badge = ({ className: className = "", children: children, size: size = 0, onClick: onClick = ()=>{} })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        role: "link",
        onKeyDown: ()=>{},
        onClick: onClick,
        tabIndex: 0,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))(`flex flex-initial items-center px-2 py-0.5 rounded font-medium ${className} -events-auto`, size === 0 ? `text-xs` : `text-sm md:text-xs`),
        children: children
    });
};
var $48afa93f9f65698e$export$2e2bcd8739ae039 = $48afa93f9f65698e$var$Badge;






const $8af98c9f3ec0d1ab$var$colors = [
    "gray",
    "red",
    "yellow",
    "green",
    "blue",
    "indigo",
    "pink"
];
const $8af98c9f3ec0d1ab$var$sum = (...args)=>args.length > 0 ? args[0] + $8af98c9f3ec0d1ab$var$sum(...args.slice(1)) : 0;
const $8af98c9f3ec0d1ab$var$findRandomColor = (words)=>{
    const colorIndex = $8af98c9f3ec0d1ab$var$sum(...words.split(" ").map((w)=>w.toUpperCase().charCodeAt(0))) % $8af98c9f3ec0d1ab$var$colors.length;
    return $8af98c9f3ec0d1ab$var$colors[colorIndex];
};
const $8af98c9f3ec0d1ab$var$ENCODED_HASHTAG = "%23";
const $8af98c9f3ec0d1ab$var$CategoryBadge = ({ className: className = "", category: category, size: size = (0, $48afa93f9f65698e$export$2d718f8c6ef64076).small, onChangeQuery: onChangeQuery })=>{
    const foundColor = $8af98c9f3ec0d1ab$var$findRandomColor(category);
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("categories");
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $500dda12544a1f09$export$a6c7ac8248d6e38a), {
        className: `inline-flex ${className}`,
        to: `/recipes?q=${$8af98c9f3ec0d1ab$var$ENCODED_HASHTAG}${category}`,
        onClick: ()=>onChangeQuery(`#${category}`),
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $48afa93f9f65698e$export$2e2bcd8739ae039), {
            className: `bg-${foundColor}-100 text-${foundColor}-800`,
            size: size,
            children: t(category)
        })
    });
};
var $8af98c9f3ec0d1ab$export$2e2bcd8739ae039 = $8af98c9f3ec0d1ab$var$CategoryBadge;


const $1c34a5a43db5f61d$var$KeywordList = ({ categories: categories, className: className = "", onChangeQuery: onChangeQuery = ()=>{}, size: size = (0, $48afa93f9f65698e$export$2d718f8c6ef64076).small })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: `text-left rtl:text-right ${className}`,
        children: categories.map((category)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $8af98c9f3ec0d1ab$export$2e2bcd8739ae039), {
                className: `${size === (0, $48afa93f9f65698e$export$2d718f8c6ef64076).small ? "mr-1" : "mr-2"}`,
                size: size,
                category: category,
                onChangeQuery: onChangeQuery
            }, category))
    });
};
var $1c34a5a43db5f61d$export$2e2bcd8739ae039 = $1c34a5a43db5f61d$var$KeywordList;



const $79b5349d693397a6$var$RecipePreview = ({ recipe: recipe, onClick: onClick = ()=>{} })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const [previewUrl, setPreviewUrl] = (0, $3QbnI.useState)((0, $8d3f0d7eea683f25$export$2e2bcd8739ae039)(recipe.imageUrl));
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        role: "button",
        tabIndex: 0,
        className: "relative group",
        // to={`/recipes/${recipe.id}`}
        onClick: (event)=>{
            onClick(event);
            navigate(`/recipes/${recipe.id}`);
            event.preventDefault();
        },
        onKeyDown: ()=>{},
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                className: "aspect-w-3 aspect-h-2 rounded-xl overflow-hidden bg-gray-200",
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("img", {
                        src: previewUrl,
                        alt: recipe.name,
                        className: "object-center object-cover indent-[-9999px]",
                        onError: ()=>setPreviewUrl(recipe.imageUrl)
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                        className: "flex items-end opacity-0 p-4 group-hover:opacity-100",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                            className: "w-full bg-white bg-opacity-75 backdrop-filter backdrop-blur py-2 px-4 rounded-md text-sm font-medium text-gray-900 text-center",
                            children: t("_View Recipe")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "mt-1 md:mt-2.5 flex items-center justify-between text-sm md:text-sm font-medium text-gray-900 space-x-8",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("h3", {
                    className: "break-words line-clamp-1 text-ellipsis",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                            "aria-hidden": "true",
                            className: "absolute inset-0"
                        }),
                        recipe.name
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $1c34a5a43db5f61d$export$2e2bcd8739ae039), {
                className: "mt-1 text-sm text-gray-500 break-words line-clamp-1 text-ellipsis",
                size: (0, $48afa93f9f65698e$export$2d718f8c6ef64076).large,
                categories: recipe.keywords
            })
        ]
    });
};
var $79b5349d693397a6$export$2e2bcd8739ae039 = $79b5349d693397a6$var$RecipePreview;



const $3730ae85ea413570$var$SectionTitle = ({ children: children, more: more, className: className })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("h2", {
        className: `text-lg leading-6 lg:text-xl xl:text-2xl font-semibold text-primary-400 pb-6 flex flex-row items-center justify-left ${className}`,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "flex-1",
                children: children
            }),
            more
        ]
    });
};
var $3730ae85ea413570$export$2e2bcd8739ae039 = $3730ae85ea413570$var$SectionTitle;


const $10dfb313e2ae4d97$var$RecipeListSection = ({ title: title, recipes: recipes, onClick: onClick = ()=>{}, className: className })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: "pb-10 md:pb-20",
        children: [
            title && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $3730ae85ea413570$export$2e2bcd8739ae039), {
                children: title
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("grid gap-x-4 md:gap-x-6 gap-y-8 sm:gap-y-10 grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 5xl:grid-cols-7", className),
                children: recipes.filter(Boolean).map((recipe)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $79b5349d693397a6$export$2e2bcd8739ae039), {
                        recipe: recipe,
                        onClick: ()=>{
                            onClick(recipe);
                        }
                    }, recipe.id))
            })
        ]
    });
};
var $10dfb313e2ae4d97$export$2e2bcd8739ae039 = $10dfb313e2ae4d97$var$RecipeListSection;


const $ef3582e39f3d5f7a$export$cb4420d1c196337d = (a, b)=>{
    if (a?.updatedAt === null || a?.updatedAt === undefined) {
        if (b?.updatedAt === null || b?.updatedAt === undefined) return 0;
        return 1;
    }
    if (b?.updatedAt === null || b?.updatedAt === undefined) return -1;
    if (a?.updatedAt < b?.updatedAt) return 1;
    if (a?.updatedAt > b?.updatedAt) return -1;
    return 1;
};
var $ef3582e39f3d5f7a$export$2e2bcd8739ae039 = $ef3582e39f3d5f7a$export$cb4420d1c196337d;


const $fb3edc52a9fda450$var$sortByName = (a, b)=>a.name.localeCompare(b.name);
var $fb3edc52a9fda450$export$2e2bcd8739ae039 = $fb3edc52a9fda450$var$sortByName;



const $ea950372bc18e9bc$var$getNumberOfMostRecents = ()=>{
    if (window.innerWidth > 2200) return 7;
    if (window.innerWidth > 1536) return 6;
    if (window.innerWidth > 1280) return 5;
    if (window.innerWidth > 1024) return 4;
    return 4;
};
const $ea950372bc18e9bc$var$RecipeListAll = ({ recipes: recipes })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const [mostRecentRecipes, setMostRecentRecipes] = (0, $3QbnI.useState)([
        ...recipes
    ].sort((0, $ef3582e39f3d5f7a$export$2e2bcd8739ae039)).slice(0, $ea950372bc18e9bc$var$getNumberOfMostRecents()));
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("resize", ()=>{
        setMostRecentRecipes([
            ...recipes
        ].sort((0, $ef3582e39f3d5f7a$export$2e2bcd8739ae039)).slice(0, $ea950372bc18e9bc$var$getNumberOfMostRecents()));
    });
    const allRecipes = (0, $3QbnI.useMemo)(()=>recipes.sort((0, $fb3edc52a9fda450$export$2e2bcd8739ae039)), [
        recipes
    ]);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
        children: [
            recipes.length > 8 && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $10dfb313e2ae4d97$export$2e2bcd8739ae039), {
                title: t("_Most Recents"),
                recipes: mostRecentRecipes
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $10dfb313e2ae4d97$export$2e2bcd8739ae039), {
                title: recipes.length > 8 ? t("_All") : "",
                recipes: allRecipes
            })
        ]
    });
};
var $ea950372bc18e9bc$export$2e2bcd8739ae039 = $ea950372bc18e9bc$var$RecipeListAll;






var $3QbnI = parcelRequire("3QbnI");
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $ac502997e977d961$var$isArray(value) {
    return !Array.isArray ? $ac502997e977d961$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $ac502997e977d961$var$INFINITY = 1 / 0;
function $ac502997e977d961$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$ac502997e977d961$var$INFINITY ? "-0" : result;
}
function $ac502997e977d961$var$toString(value) {
    return value == null ? "" : $ac502997e977d961$var$baseToString(value);
}
function $ac502997e977d961$var$isString(value) {
    return typeof value === "string";
}
function $ac502997e977d961$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $ac502997e977d961$var$isBoolean(value) {
    return value === true || value === false || $ac502997e977d961$var$isObjectLike(value) && $ac502997e977d961$var$getTag(value) == "[object Boolean]";
}
function $ac502997e977d961$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $ac502997e977d961$var$isObjectLike(value) {
    return $ac502997e977d961$var$isObject(value) && value !== null;
}
function $ac502997e977d961$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $ac502997e977d961$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $ac502997e977d961$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $ac502997e977d961$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $ac502997e977d961$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $ac502997e977d961$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $ac502997e977d961$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $ac502997e977d961$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $ac502997e977d961$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $ac502997e977d961$var$hasOwn = Object.prototype.hasOwnProperty;
class $ac502997e977d961$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $ac502997e977d961$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $ac502997e977d961$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($ac502997e977d961$var$isString(key) || $ac502997e977d961$var$isArray(key)) {
        src = key;
        path = $ac502997e977d961$var$createKeyPath(key);
        id = $ac502997e977d961$var$createKeyId(key);
    } else {
        if (!$ac502997e977d961$var$hasOwn.call(key, "name")) throw new Error($ac502997e977d961$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($ac502997e977d961$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($ac502997e977d961$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $ac502997e977d961$var$createKeyPath(name);
        id = $ac502997e977d961$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $ac502997e977d961$var$createKeyPath(key) {
    return $ac502997e977d961$var$isArray(key) ? key : key.split(".");
}
function $ac502997e977d961$var$createKeyId(key) {
    return $ac502997e977d961$var$isArray(key) ? key.join(".") : key;
}
function $ac502997e977d961$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$ac502997e977d961$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$ac502997e977d961$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($ac502997e977d961$var$isString(value) || $ac502997e977d961$var$isNumber(value) || $ac502997e977d961$var$isBoolean(value))) list.push($ac502997e977d961$var$toString(value));
            else if ($ac502997e977d961$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $ac502997e977d961$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $ac502997e977d961$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $ac502997e977d961$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $ac502997e977d961$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $ac502997e977d961$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $ac502997e977d961$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $ac502997e977d961$var$Config = {
    ...$ac502997e977d961$var$BasicOptions,
    ...$ac502997e977d961$var$MatchOptions,
    ...$ac502997e977d961$var$FuzzyOptions,
    ...$ac502997e977d961$var$AdvancedOptions
};
const $ac502997e977d961$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $ac502997e977d961$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($ac502997e977d961$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $ac502997e977d961$var$FuseIndex {
    constructor({ getFn: getFn = $ac502997e977d961$var$Config.getFn, fieldNormWeight: fieldNormWeight = $ac502997e977d961$var$Config.fieldNormWeight } = {}){
        this.norm = $ac502997e977d961$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($ac502997e977d961$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($ac502997e977d961$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$ac502997e977d961$var$isDefined(doc) || $ac502997e977d961$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$ac502997e977d961$var$isDefined(value)) return;
            if ($ac502997e977d961$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$ac502997e977d961$var$isDefined(value)) continue;
                    if ($ac502997e977d961$var$isString(value) && !$ac502997e977d961$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($ac502997e977d961$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($ac502997e977d961$var$isString(value) && !$ac502997e977d961$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $ac502997e977d961$var$createIndex(keys, docs, { getFn: getFn = $ac502997e977d961$var$Config.getFn, fieldNormWeight: fieldNormWeight = $ac502997e977d961$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $ac502997e977d961$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($ac502997e977d961$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $ac502997e977d961$var$parseIndex(data, { getFn: getFn = $ac502997e977d961$var$Config.getFn, fieldNormWeight: fieldNormWeight = $ac502997e977d961$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $ac502997e977d961$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $ac502997e977d961$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $ac502997e977d961$var$Config.distance, ignoreLocation: ignoreLocation = $ac502997e977d961$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $ac502997e977d961$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $ac502997e977d961$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $ac502997e977d961$var$MAX_BITS = 32;
function $ac502997e977d961$var$search(text, pattern, patternAlphabet, { location: location = $ac502997e977d961$var$Config.location, distance: distance = $ac502997e977d961$var$Config.distance, threshold: threshold = $ac502997e977d961$var$Config.threshold, findAllMatches: findAllMatches = $ac502997e977d961$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $ac502997e977d961$var$Config.minMatchCharLength, includeMatches: includeMatches = $ac502997e977d961$var$Config.includeMatches, ignoreLocation: ignoreLocation = $ac502997e977d961$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $ac502997e977d961$var$MAX_BITS) throw new Error($ac502997e977d961$var$PATTERN_LENGTH_TOO_LARGE($ac502997e977d961$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $ac502997e977d961$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $ac502997e977d961$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $ac502997e977d961$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $ac502997e977d961$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $ac502997e977d961$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $ac502997e977d961$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $ac502997e977d961$var$BitapSearch {
    constructor(pattern, { location: location = $ac502997e977d961$var$Config.location, threshold: threshold = $ac502997e977d961$var$Config.threshold, distance: distance = $ac502997e977d961$var$Config.distance, includeMatches: includeMatches = $ac502997e977d961$var$Config.includeMatches, findAllMatches: findAllMatches = $ac502997e977d961$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $ac502997e977d961$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $ac502997e977d961$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $ac502997e977d961$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $ac502997e977d961$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $ac502997e977d961$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $ac502997e977d961$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $ac502997e977d961$var$MAX_BITS), i);
                i += $ac502997e977d961$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $ac502997e977d961$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $ac502997e977d961$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $ac502997e977d961$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $ac502997e977d961$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $ac502997e977d961$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $ac502997e977d961$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $ac502997e977d961$var$ExactMatch extends $ac502997e977d961$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $ac502997e977d961$var$InverseExactMatch extends $ac502997e977d961$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $ac502997e977d961$var$PrefixExactMatch extends $ac502997e977d961$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $ac502997e977d961$var$InversePrefixExactMatch extends $ac502997e977d961$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $ac502997e977d961$var$SuffixExactMatch extends $ac502997e977d961$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $ac502997e977d961$var$InverseSuffixExactMatch extends $ac502997e977d961$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $ac502997e977d961$var$FuzzyMatch extends $ac502997e977d961$var$BaseMatch {
    constructor(pattern, { location: location = $ac502997e977d961$var$Config.location, threshold: threshold = $ac502997e977d961$var$Config.threshold, distance: distance = $ac502997e977d961$var$Config.distance, includeMatches: includeMatches = $ac502997e977d961$var$Config.includeMatches, findAllMatches: findAllMatches = $ac502997e977d961$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $ac502997e977d961$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $ac502997e977d961$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $ac502997e977d961$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $ac502997e977d961$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $ac502997e977d961$var$IncludeMatch extends $ac502997e977d961$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $ac502997e977d961$var$searchers = [
    $ac502997e977d961$var$ExactMatch,
    $ac502997e977d961$var$IncludeMatch,
    $ac502997e977d961$var$PrefixExactMatch,
    $ac502997e977d961$var$InversePrefixExactMatch,
    $ac502997e977d961$var$InverseSuffixExactMatch,
    $ac502997e977d961$var$SuffixExactMatch,
    $ac502997e977d961$var$InverseExactMatch,
    $ac502997e977d961$var$FuzzyMatch
];
const $ac502997e977d961$var$searchersLen = $ac502997e977d961$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $ac502997e977d961$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $ac502997e977d961$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $ac502997e977d961$var$parseQuery(pattern, options = {}) {
    return pattern.split($ac502997e977d961$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($ac502997e977d961$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $ac502997e977d961$var$searchersLen){
                const searcher = $ac502997e977d961$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $ac502997e977d961$var$searchersLen){
                const searcher = $ac502997e977d961$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $ac502997e977d961$var$MultiMatchSet = new Set([
    $ac502997e977d961$var$FuzzyMatch.type,
    $ac502997e977d961$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $ac502997e977d961$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $ac502997e977d961$var$Config.isCaseSensitive, includeMatches: includeMatches = $ac502997e977d961$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $ac502997e977d961$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $ac502997e977d961$var$Config.ignoreLocation, findAllMatches: findAllMatches = $ac502997e977d961$var$Config.findAllMatches, location: location = $ac502997e977d961$var$Config.location, threshold: threshold = $ac502997e977d961$var$Config.threshold, distance: distance = $ac502997e977d961$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $ac502997e977d961$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($ac502997e977d961$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $ac502997e977d961$var$registeredSearchers = [];
function $ac502997e977d961$var$register(...args) {
    $ac502997e977d961$var$registeredSearchers.push(...args);
}
function $ac502997e977d961$var$createSearcher(pattern, options) {
    for(let i = 0, len = $ac502997e977d961$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $ac502997e977d961$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $ac502997e977d961$var$BitapSearch(pattern, options);
}
const $ac502997e977d961$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $ac502997e977d961$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $ac502997e977d961$var$isExpression = (query)=>!!(query[$ac502997e977d961$var$LogicalOperator.AND] || query[$ac502997e977d961$var$LogicalOperator.OR]);
const $ac502997e977d961$var$isPath = (query)=>!!query[$ac502997e977d961$var$KeyType.PATH];
const $ac502997e977d961$var$isLeaf = (query)=>!$ac502997e977d961$var$isArray(query) && $ac502997e977d961$var$isObject(query) && !$ac502997e977d961$var$isExpression(query);
const $ac502997e977d961$var$convertToExplicit = (query)=>({
        [$ac502997e977d961$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $ac502997e977d961$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $ac502997e977d961$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$ac502997e977d961$var$isExpression(query)) return next($ac502997e977d961$var$convertToExplicit(query));
        if ($ac502997e977d961$var$isLeaf(query)) {
            const key = isQueryPath ? query[$ac502997e977d961$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$ac502997e977d961$var$KeyType.PATTERN] : query[key];
            if (!$ac502997e977d961$var$isString(pattern)) throw new Error($ac502997e977d961$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $ac502997e977d961$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $ac502997e977d961$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($ac502997e977d961$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$ac502997e977d961$var$isExpression(query)) query = $ac502997e977d961$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $ac502997e977d961$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $ac502997e977d961$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $ac502997e977d961$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$ac502997e977d961$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$ac502997e977d961$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $ac502997e977d961$var$transformScore(result, data) {
    data.score = result.score;
}
function $ac502997e977d961$var$format(results, docs, { includeMatches: includeMatches = $ac502997e977d961$var$Config.includeMatches, includeScore: includeScore = $ac502997e977d961$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($ac502997e977d961$var$transformMatches);
    if (includeScore) transformers.push($ac502997e977d961$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $ac502997e977d961$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$ac502997e977d961$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $ac502997e977d961$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $ac502997e977d961$var$FuseIndex)) throw new Error($ac502997e977d961$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $ac502997e977d961$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$ac502997e977d961$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $ac502997e977d961$var$isString(query) ? $ac502997e977d961$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $ac502997e977d961$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($ac502997e977d961$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $ac502997e977d961$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $ac502997e977d961$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$ac502997e977d961$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $ac502997e977d961$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $ac502997e977d961$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($ac502997e977d961$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $ac502997e977d961$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$ac502997e977d961$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$ac502997e977d961$var$isDefined(value)) return [];
        let matches = [];
        if ($ac502997e977d961$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$ac502997e977d961$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$ac502997e977d961$export$2e2bcd8739ae039.version = "6.6.2";
$ac502997e977d961$export$2e2bcd8739ae039.createIndex = $ac502997e977d961$var$createIndex;
$ac502997e977d961$export$2e2bcd8739ae039.parseIndex = $ac502997e977d961$var$parseIndex;
$ac502997e977d961$export$2e2bcd8739ae039.config = $ac502997e977d961$var$Config;
$ac502997e977d961$export$2e2bcd8739ae039.parseQuery = $ac502997e977d961$var$parse;
$ac502997e977d961$var$register($ac502997e977d961$var$ExtendedSearch);


const $45398165e5730ed2$var$initializeFuse = (recipes)=>new (0, $ac502997e977d961$export$2e2bcd8739ae039)(recipes, {
        keys: [
            "name",
            "keywords",
            "ingredients",
            "steps"
        ],
        minMatchCharLength: 1,
        includeScore: true
    });
const $45398165e5730ed2$var$sortByScore = (a, b)=>a.score !== undefined && b.score !== undefined ? a.score - b.score : 0;
const $45398165e5730ed2$var$sortByName = (a, b)=>{
    return a.name.localeCompare(b.name);
};
const $45398165e5730ed2$var$useFuse = (list, query)=>{
    const fuse = (0, $3QbnI.useRef)($45398165e5730ed2$var$initializeFuse(list));
    (0, $3QbnI.useEffect)(()=>{
        fuse.current.setCollection(list);
    }, [
        list
    ]);
    const search = (query, list)=>query ? fuse.current.search(query).sort($45398165e5730ed2$var$sortByScore).filter((item)=>item?.score && item.score < 0.5).map((i)=>i.item) : [
            ...list
        ].sort($45398165e5730ed2$var$sortByName);
    return (0, $3QbnI.useMemo)(()=>{
        const keywords = (query.match(/#([a-zA-Z]*)/) || []).slice(1);
        const queryWithoutKeywords = query.replace(/#[a-zA-Z]*/i, "").trim();
        return search(queryWithoutKeywords, list).filter((r)=>keywords.every((keyword)=>r.keywords.find((k)=>k.toLowerCase().includes(keyword.toLowerCase()))));
    }, [
        query,
        list
    ]);
};
var $45398165e5730ed2$export$2e2bcd8739ae039 = $45398165e5730ed2$var$useFuse;



const $5686b9da07d64740$var$NoRecipeList = ({ children: children })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: "flex justify-center p-5",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
            className: "text-base text-gray-500 text-center",
            children: children
        })
    });
};
var $5686b9da07d64740$export$2e2bcd8739ae039 = $5686b9da07d64740$var$NoRecipeList;








const $6c7560fbc24bca5f$var$RecipeListSearchResults = ({ recipes: recipes })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const { query: query, searchStatus: searchStatus } = (0, $b62c837cabb699aa$export$2e2bcd8739ae039)();
    const searchedRecipes = (0, $45398165e5730ed2$export$2e2bcd8739ae039)(recipes, query || "");
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    if (typeof query !== "string") return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {});
    return searchedRecipes.length > 0 ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $10dfb313e2ae4d97$export$2e2bcd8739ae039), {
        title: searchStatus === (0, $fedaffc39b995a23$export$2e2bcd8739ae039).Category ? t(`_Category's Recipes`, {
            category: (0, $19dce42d13e14dcb$export$33c5fb191636518a)(query.slice(1).toLowerCase())
        }) : t("_Results"),
        recipes: searchedRecipes,
        onClick: (recipe)=>{
            dispatch((0, $87c50e51b43ee465$export$74e99d9695eabee6)(recipe));
        }
    }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5686b9da07d64740$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $da9a8dcd6ea2647a$export$2e2bcd8739ae039), {
            title: t("_No Recipes found"),
            message: t("_Try a different search.")
        })
    });
};
var $6c7560fbc24bca5f$export$2e2bcd8739ae039 = $6c7560fbc24bca5f$var$RecipeListSearchResults;









const $d51888e3fd6cd032$var$RecipeListRecentSearches = ({ recipes: recipes })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const recentSearches = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $87c50e51b43ee465$export$1216255791599668));
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {
        children: recentSearches.length > 0 ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $10dfb313e2ae4d97$export$2e2bcd8739ae039), {
            title: t("_Recent Searches"),
            recipes: recentSearches
        }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ea950372bc18e9bc$export$2e2bcd8739ae039), {
            recipes: recipes
        })
    });
};
var $d51888e3fd6cd032$export$2e2bcd8739ae039 = $d51888e3fd6cd032$var$RecipeListRecentSearches;







const $fedc34e3673bd87f$var$RecipeListNoCategories = ({ recipes: recipes })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const recipesWithoutCategories = recipes.filter((r)=>r.keywords.length === 0);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $10dfb313e2ae4d97$export$2e2bcd8739ae039), {
        title: t("_Recipes without categories"),
        recipes: recipesWithoutCategories
    });
};
var $fedc34e3673bd87f$export$2e2bcd8739ae039 = $fedc34e3673bd87f$var$RecipeListNoCategories;





var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
function $f213aa5db5d17cb4$var$Cog6ToothIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
    }), /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    }));
}
const $f213aa5db5d17cb4$var$ForwardRef = $3QbnI.forwardRef($f213aa5db5d17cb4$var$Cog6ToothIcon);
var $f213aa5db5d17cb4$export$2e2bcd8739ae039 = $f213aa5db5d17cb4$var$ForwardRef;










const $50e512355f25ee80$var$MobileRecipeListHeader = (props)=>{
    const categoryListRef = (0, $3QbnI.useRef)(null);
    const shouldBeSticky = ()=>categoryListRef.current?.getBoundingClientRect().y === 0;
    const [isSticky, setIsSticky] = (0, $3QbnI.useState)(shouldBeSticky());
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("scroll", ()=>{
        setIsSticky(shouldBeSticky());
    });
    const { isSearchActive: isSearchActive } = (0, $b62c837cabb699aa$export$2e2bcd8739ae039)();
    const inputRef = (0, $3QbnI.useRef)(null);
    (0, $3QbnI.useEffect)(()=>{
        if (isSearchActive) inputRef?.current?.focus();
    }, [
        isSearchActive
    ]);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4bf72665163a8648$export$2e2bcd8739ae039), {
                className: "block md:hidden border-b border-gray-200",
                children: isSearchActive ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $6feff3a951ac50d7$export$2e2bcd8739ae039), {
                    className: "w-full",
                    ref: inputRef,
                    disableAutoClose: true
                }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $2177ccffcfec9146$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $500dda12544a1f09$export$a6c7ac8248d6e38a), {
                            to: "/preferences",
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f213aa5db5d17cb4$export$2e2bcd8739ae039), {
                                className: "h-9 w-9 stroke-1 antialiased"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $97b0e1721aec3c95$export$2e2bcd8739ae039), {
                ref: categoryListRef,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("block md:hidden sticky top-0 z-50 bg-white", {
                    shadow: isSticky
                })
            })
        ]
    });
};
var $50e512355f25ee80$export$2e2bcd8739ae039 = $50e512355f25ee80$var$MobileRecipeListHeader;







var $3QbnI = parcelRequire("3QbnI");
function $a35580c3b0e5a05a$var$HomeIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
    }));
}
const $a35580c3b0e5a05a$var$ForwardRef = $3QbnI.forwardRef($a35580c3b0e5a05a$var$HomeIcon);
var $a35580c3b0e5a05a$export$2e2bcd8739ae039 = $a35580c3b0e5a05a$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $0efa43c1cdf98983$var$MagnifyingGlassIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    }));
}
const $0efa43c1cdf98983$var$ForwardRef = $3QbnI.forwardRef($0efa43c1cdf98983$var$MagnifyingGlassIcon);
var $0efa43c1cdf98983$export$2e2bcd8739ae039 = $0efa43c1cdf98983$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $6be8f6e1ef182e2f$var$PlusCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $6be8f6e1ef182e2f$var$ForwardRef = $3QbnI.forwardRef($6be8f6e1ef182e2f$var$PlusCircleIcon);
var $6be8f6e1ef182e2f$export$2e2bcd8739ae039 = $6be8f6e1ef182e2f$var$ForwardRef;



var $3QbnI = parcelRequire("3QbnI");
function $938e0740f1ba5cf2$var$HomeIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        d: "M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z"
    }), /*#__PURE__*/ $3QbnI.createElement("path", {
        d: "m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z"
    }));
}
const $938e0740f1ba5cf2$var$ForwardRef = $3QbnI.forwardRef($938e0740f1ba5cf2$var$HomeIcon);
var $938e0740f1ba5cf2$export$2e2bcd8739ae039 = $938e0740f1ba5cf2$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $fe4221dac80b2454$var$MagnifyingGlassIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z",
        clipRule: "evenodd"
    }));
}
const $fe4221dac80b2454$var$ForwardRef = $3QbnI.forwardRef($fe4221dac80b2454$var$MagnifyingGlassIcon);
var $fe4221dac80b2454$export$2e2bcd8739ae039 = $fe4221dac80b2454$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $7985454d88c41b18$var$PlusCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z",
        clipRule: "evenodd"
    }));
}
const $7985454d88c41b18$var$ForwardRef = $3QbnI.forwardRef($7985454d88c41b18$var$PlusCircleIcon);
var $7985454d88c41b18$export$2e2bcd8739ae039 = $7985454d88c41b18$var$ForwardRef;







const $16a2ce675b3abce9$var$MobileDock = ()=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const newRecipePopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    const importHelpPopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    const { isSearchActive: isSearchActive, setSearch: setSearch } = (0, $b62c837cabb699aa$export$2e2bcd8739ae039)();
    const location = (0, $e724dc7e3b3eec8a$export$45d76561a5302f2b)();
    const items = [
        {
            Icon: (0, $938e0740f1ba5cf2$export$2e2bcd8739ae039),
            IconOutline: (0, $a35580c3b0e5a05a$export$2e2bcd8739ae039),
            id: "home",
            label: "_Home",
            onClick: ()=>{
                setSearch(null);
            },
            isActive: !isSearchActive && !newRecipePopup.isOpen && !location.pathname.includes("/shopping-list")
        },
        {
            Icon: (0, $fe4221dac80b2454$export$2e2bcd8739ae039),
            IconOutline: (0, $0efa43c1cdf98983$export$2e2bcd8739ae039),
            id: "search",
            label: "_Search",
            onClick: ()=>setSearch(""),
            isActive: isSearchActive
        },
        {
            Icon: (0, $7985454d88c41b18$export$2e2bcd8739ae039),
            IconOutline: (0, $6be8f6e1ef182e2f$export$2e2bcd8739ae039),
            id: "new-recipe",
            label: "_New Recipe",
            onClick: ()=>newRecipePopup.open(),
            isActive: newRecipePopup.isOpen
        }
    ];
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: "block md:hidden bg-white fixed z-50 bottom-0 left-0 right-0 shadow flex items-stretch shadow border-t border-gray-200",
        children: [
            items.map((i)=>i.isActive ? {
                    ...i,
                    IconOutline: i.Icon
                } : i).map(({ IconOutline: IconOutline, id: id, label: label, onClick: onClick, isActive: isActive })=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("button", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("flex-1 flex flex-col items-center justify-center outline-none p-3 focus:outline-none", isActive ? "text-black" : "text-gray-400"),
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(IconOutline, {
                            className: "h-8 w-8 stroke-1 antialiased"
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                            className: "text-xs",
                            children: t(label)
                        })
                    ]
                }, id)),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
                title: t("_New Recipe"),
                open: newRecipePopup.isOpen,
                onClose: newRecipePopup.close,
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5e4be98a434b893c$export$2e2bcd8739ae039), {
                    onHelpRequest: importHelpPopup.open
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $08c6359faa91c4f1$export$2e2bcd8739ae039), {
                open: importHelpPopup.isOpen,
                onClose: importHelpPopup.close
            })
        ]
    });
};
var $16a2ce675b3abce9$export$2e2bcd8739ae039 = $16a2ce675b3abce9$var$MobileDock;


const $44d5673b7a91e670$var$scroll = (0, $fb882a1fb757da57$export$2e2bcd8739ae039)();
const $44d5673b7a91e670$var$HEADER_HEIGHT = 64;
const $44d5673b7a91e670$var$RecipeList = ()=>{
    const areFetched = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $87c50e51b43ee465$export$c341f62fd7d1eec8));
    const recipes = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $87c50e51b43ee465$export$3b86e2cc0677644d));
    const ref = (0, $3QbnI.useRef)(null);
    const { searchStatus: searchStatus, isSearchActive: isSearchActive } = (0, $b62c837cabb699aa$export$2e2bcd8739ae039)();
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const areCategoriesVisible = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $163820ab4cc89429$export$4477981a0058a5c4));
    const isMobile = window.innerWidth < 768;
    const windowHeight = window.innerHeight + (!isSearchActive ? $44d5673b7a91e670$var$HEADER_HEIGHT : 0);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e91e729a6066c3b7$export$2e2bcd8739ae039), {
        title: t("_Recipes"),
        scroll: $44d5673b7a91e670$var$scroll.scroll,
        onScroll: (v)=>$44d5673b7a91e670$var$scroll.onScroll(v),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("bg-white min-h-[100vh] md:h-auto", areCategoriesVisible ? "md:mt-32" : "md:m-10"),
                style: {
                    minHeight: isMobile ? windowHeight : "auto"
                },
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $50e512355f25ee80$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                            className: "flex-1 relative z-10 pt-5 md:pt-24",
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                    className: "relative z-10 ",
                                    ref: ref
                                }),
                                searchStatus === (0, $fedaffc39b995a23$export$2e2bcd8739ae039).NoCategory && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $fedc34e3673bd87f$export$2e2bcd8739ae039), {
                                    recipes: recipes
                                }),
                                (searchStatus === (0, $fedaffc39b995a23$export$2e2bcd8739ae039).Category || searchStatus === (0, $fedaffc39b995a23$export$2e2bcd8739ae039).Generic) && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $6c7560fbc24bca5f$export$2e2bcd8739ae039), {
                                    recipes: recipes
                                }),
                                recipes.length > 0 && searchStatus === (0, $fedaffc39b995a23$export$2e2bcd8739ae039).Unactive && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ea950372bc18e9bc$export$2e2bcd8739ae039), {
                                    recipes: recipes
                                }),
                                searchStatus === (0, $fedaffc39b995a23$export$2e2bcd8739ae039).ReadyForSearch && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d51888e3fd6cd032$export$2e2bcd8739ae039), {
                                    recipes: recipes
                                }),
                                recipes.length === 0 && !areFetched && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5686b9da07d64740$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4a262d36d885163e$export$2e2bcd8739ae039), {})
                                }),
                                recipes.length === 0 && areFetched && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5686b9da07d64740$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $da9a8dcd6ea2647a$export$2e2bcd8739ae039), {
                                        title: t("_No Recipes created"),
                                        message: t("_Get started by creating a new recipe")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $828fdd92dea8ba54$export$2e2bcd8739ae039), {
                restRef: ref,
                hideSearch: recipes.length === 0,
                className: "hidden md:block"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $16a2ce675b3abce9$export$2e2bcd8739ae039), {})
        ]
    });
};
var $44d5673b7a91e670$export$2e2bcd8739ae039 = $44d5673b7a91e670$var$RecipeList;




var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
function $b0110c46b44ec025$var$PencilIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
    }));
}
const $b0110c46b44ec025$var$ForwardRef = $3QbnI.forwardRef($b0110c46b44ec025$var$PencilIcon);
var $b0110c46b44ec025$export$2e2bcd8739ae039 = $b0110c46b44ec025$var$ForwardRef;






var $3QbnI = parcelRequire("3QbnI");
const $462140c0f3a53058$var$Box = /*#__PURE__*/ (0, $3QbnI.forwardRef)(({ className: className, children: children, style: style = {} }, ref)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: `bg-white shadow rounded-md ${className}`,
        ref: ref,
        style: style,
        children: children
    }));
var $462140c0f3a53058$export$2e2bcd8739ae039 = $462140c0f3a53058$var$Box;




var $3QbnI = parcelRequire("3QbnI");


var $3QbnI = parcelRequire("3QbnI");
function $f01a32c470910d9c$var$ShoppingCartIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    }));
}
const $f01a32c470910d9c$var$ForwardRef = $3QbnI.forwardRef($f01a32c470910d9c$var$ShoppingCartIcon);
var $f01a32c470910d9c$export$2e2bcd8739ae039 = $f01a32c470910d9c$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $34deacc023334115$var$XCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $34deacc023334115$var$ForwardRef = $3QbnI.forwardRef($34deacc023334115$var$XCircleIcon);
var $34deacc023334115$export$2e2bcd8739ae039 = $34deacc023334115$var$ForwardRef;





// TODO improve predictability of render
const $e2959a6776dd96f2$var$renderMeasure = (measure, { explicit: explicit } = {})=>{
    const { unit: unit } = measure;
    if (unit === "some") return measure.value > 0 || explicit ? `some` : "";
    if (unit === "none") return "";
    const unitLabel = unit !== "count" ? ` ${measure.unit}` : "";
    return `${measure.value}${unitLabel}`;
};
var $e2959a6776dd96f2$export$2e2bcd8739ae039 = $e2959a6776dd96f2$var$renderMeasure;


const $786107c49b06bb46$export$f993c945890e93ba = ()=>navigator.platform.indexOf("Win") > -1;
const $786107c49b06bb46$export$26faf859555f8035 = ()=>$786107c49b06bb46$export$f993c945890e93ba() ? `\r\n` : `\n`;


const $205d42033fb9c818$var$renderIngredient = (ingredient, template)=>{
    if (template.length === 0) return ingredient;
    return template.replace("$1", ingredient);
};
const $205d42033fb9c818$var$renderIngredients = (ingredients, template)=>{
    return ingredients.map((i)=>{
        const measure = (0, $e2959a6776dd96f2$export$2e2bcd8739ae039)(i.measure);
        return `${measure}${measure ? " " : ""}${i.name}`;
    }).map((i)=>$205d42033fb9c818$var$renderIngredient(i, template)).join((0, $786107c49b06bb46$export$26faf859555f8035)());
};
var $205d42033fb9c818$export$2e2bcd8739ae039 = $205d42033fb9c818$var$renderIngredients;


const $0685de3407cda9b0$var$sendToClipboard = (text)=>navigator.clipboard.writeText(text);
var $0685de3407cda9b0$var$SharingStatus;
(function(SharingStatus) {
    SharingStatus[SharingStatus["Shared"] = 0] = "Shared";
    SharingStatus[SharingStatus["ShareCancelled"] = 1] = "ShareCancelled";
    SharingStatus[SharingStatus["CopiedToClipboard"] = 2] = "CopiedToClipboard";
    SharingStatus[SharingStatus["Downloaded"] = 3] = "Downloaded";
})($0685de3407cda9b0$var$SharingStatus || ($0685de3407cda9b0$var$SharingStatus = {}));
const $0685de3407cda9b0$export$c6083d60acc62a08 = ()=>typeof navigator.share === "function";
const $0685de3407cda9b0$export$ed7ca78295c017be = async (text)=>{
    if (!$0685de3407cda9b0$export$c6083d60acc62a08()) {
        await $0685de3407cda9b0$var$sendToClipboard(text);
        return {
            status: 2
        };
    }
    try {
        await navigator.share({
            text: text
        });
        return {
            status: 0
        };
    } catch (err) {
        return {
            status: 1
        };
    }
};
const $0685de3407cda9b0$export$57724ff03bad689a = (result)=>result.status === 2;
const $0685de3407cda9b0$export$973d2af2aea58feb = (result)=>result.status === 0;




const $f937bf1c18ff7494$var$waitFor = (milliseconds)=>new Promise((resolve)=>setTimeout(resolve, milliseconds));
var $f937bf1c18ff7494$export$2e2bcd8739ae039 = $f937bf1c18ff7494$var$waitFor;



const $e200d3b9a174836d$var$SectionAction = ({ label: label, onClick: onClick, tooltip: tooltip, children: children })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("button", {
        className: "flex items-center text-gray-400 hover:text-primary-500 cursor-pointer",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "ltr:mr-2 rtl:ml-2 font-normal text-xs",
                children: label
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                children: children
            })
        ]
    });
};
var $e200d3b9a174836d$export$2e2bcd8739ae039 = $e200d3b9a174836d$var$SectionAction;





const $ec2436c670cc4a41$var$key = (ingredient, index)=>`${ingredient.name}${index}`;
const $ec2436c670cc4a41$var$IngredientTable = ({ ingredients: ingredients, itemClassName: itemClassName, itemOnClick: itemOnClick = ()=>()=>{}, itemComponent: ItemComponent = ()=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {}) })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("table", {
        className: "min-w-full divide-y divide-gray-300",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("tbody", {
            className: "divide-y divide-gray-200 bg-white",
            children: ingredients.map((ingredient, index)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("tr", {
                    onClick: itemOnClick(index),
                    className: itemClassName,
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)(ItemComponent, {
                            index: index
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("td", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("whitespace-wrap py-4 align-top text-sm font-medium text-gray-900 text-right w-10 max-w-10", (0, $e2959a6776dd96f2$export$2e2bcd8739ae039)(ingredient.measure, {
                                explicit: true
                            }).length > 15 ? "whitespace-wrap" : "whitespace-nowrap"),
                            children: (0, $e2959a6776dd96f2$export$2e2bcd8739ae039)(ingredient.measure, {
                                explicit: true
                            })
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("td", {
                            className: "px-3 py-4 pr-6 align-top text-sm text-gray-500 w-60",
                            children: ingredient.name
                        })
                    ]
                }, $ec2436c670cc4a41$var$key(ingredient, index)))
        })
    });
};
var $ec2436c670cc4a41$export$2e2bcd8739ae039 = $ec2436c670cc4a41$var$IngredientTable;


const $f5b1c89a6a08fea4$var$IngredientList = ({ formattedRecipe: formattedRecipe })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const shoppingBag = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)(false);
    const [checkedIngredients, setCheckedIngredients] = (0, $3QbnI.useState)(formattedRecipe.ingredients.map((_, index)=>index));
    const [sharedIngredientsWithClipboard, setSharedIngredientsWithClipboard] = (0, $3QbnI.useState)(false);
    const ingredientTemplate = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $cb3b9bf6a0fb48f2$export$95e92655b1210e4b));
    const toggleCheckedIngredient = (ingredientIndex)=>(event)=>{
            if (!shoppingBag.isOpen) return;
            setCheckedIngredients([
                ...checkedIngredients,
                ingredientIndex
            ]);
            if (checkedIngredients.includes(ingredientIndex)) setCheckedIngredients(checkedIngredients.filter((index)=>index !== ingredientIndex));
            else setCheckedIngredients([
                ...checkedIngredients,
                ingredientIndex
            ]);
            event.stopPropagation();
        };
    const ingredientsToBeShared = formattedRecipe.ingredients.filter((_, index)=>checkedIngredients.includes(index));
    const shareIngredients = async ()=>{
        const ingredients = (0, $205d42033fb9c818$export$2e2bcd8739ae039)(ingredientsToBeShared, ingredientTemplate);
        const result = await (0, $0685de3407cda9b0$export$ed7ca78295c017be)(ingredients);
        if ((0, $0685de3407cda9b0$export$57724ff03bad689a)(result)) {
            setSharedIngredientsWithClipboard(true);
            await (0, $f937bf1c18ff7494$export$2e2bcd8739ae039)(5000);
            shoppingBag.close();
            setSharedIngredientsWithClipboard(false);
        } else if ((0, $0685de3407cda9b0$export$973d2af2aea58feb)(result)) shoppingBag.close();
    };
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $3730ae85ea413570$export$2e2bcd8739ae039), {
                more: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e200d3b9a174836d$export$2e2bcd8739ae039), {
                    label: shoppingBag.isOpen ? t("shoppingList.Close shopping list") : t("shoppingList.Shopping list"),
                    onClick: shoppingBag.toggle,
                    tooltip: shoppingBag.isOpen ? t("shoppingList.Close shopping list") : t("shoppingList.Create shopping list"),
                    children: shoppingBag.isOpen ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $34deacc023334115$export$2e2bcd8739ae039), {
                        className: "h-7 w-7 focus:outline-none",
                        "aria-hidden": "true"
                    }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f01a32c470910d9c$export$2e2bcd8739ae039), {
                        className: "h-7 w-7 cursor-pointer focus:outline-none",
                        "aria-hidden": "true",
                        onClick: shoppingBag.toggle
                    })
                }),
                children: t("_Ingredients")
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ec2436c670cc4a41$export$2e2bcd8739ae039), {
                ingredients: formattedRecipe.ingredients,
                itemOnClick: (index)=>()=>toggleCheckedIngredient(index),
                itemClassName: shoppingBag.isOpen ? "cursor-pointer" : "select-text",
                itemComponent: ({ index: index })=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("td", {
                        className: "w-10 align-middle text-center",
                        children: shoppingBag.isOpen && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("input", {
                            id: "candidates",
                            "aria-describedby": "candidates-description",
                            name: "candidates",
                            type: "checkbox",
                            className: "relative h-4 w-4 top-[-2px] rounded border-gray-300 text-primary-400 focus:ring-primary-400 cursor-pointer",
                            checked: checkedIngredients.includes(index),
                            onChange: toggleCheckedIngredient(index)
                        })
                    })
            }),
            shoppingBag.isOpen && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "mt-4 shadow-[0_-1px_3px_0_rgba(0,0,0,0.1)] fixed z-50 bottom-0 left-0 right-0 md:relative p-4 bg-white md:p-0",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary, {
                    className: "w-full justify-center !p-3 ",
                    disabled: checkedIngredients.length === 0,
                    onClick: shareIngredients,
                    children: [
                        sharedIngredientsWithClipboard && t("shoppingList.Shopping list copied to clipboard"),
                        !sharedIngredientsWithClipboard && ((0, $0685de3407cda9b0$export$c6083d60acc62a08)() ? t("shoppingList.Share shopping list") : t("shoppingList.Copy shopping list to clipboard"))
                    ]
                })
            })
        ]
    });
};
var $f5b1c89a6a08fea4$export$2e2bcd8739ae039 = $f5b1c89a6a08fea4$var$IngredientList;





var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
function $9347c05b3a29f520$var$BoltIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M14.615 1.595a.75.75 0 0 1 .359.852L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262l-10.5 11.25a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262l10.5-11.25a.75.75 0 0 1 .913-.143Z",
        clipRule: "evenodd"
    }));
}
const $9347c05b3a29f520$var$ForwardRef = $3QbnI.forwardRef($9347c05b3a29f520$var$BoltIcon);
var $9347c05b3a29f520$export$2e2bcd8739ae039 = $9347c05b3a29f520$var$ForwardRef;




var $3QbnI = parcelRequire("3QbnI");
function $328ce2c05a6b4d53$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z",
        clipRule: "evenodd"
    }));
}
const $328ce2c05a6b4d53$var$ForwardRef = $3QbnI.forwardRef($328ce2c05a6b4d53$var$CheckIcon);
var $328ce2c05a6b4d53$export$2e2bcd8739ae039 = $328ce2c05a6b4d53$var$ForwardRef;




var $3QbnI = parcelRequire("3QbnI");

var $bei3G = parcelRequire("bei3G");
const $ea42ddd831639d75$var$excludingWords = [
    "yours",
    "your"
];
const $ea42ddd831639d75$var$cleanWord = (word)=>word.trim().replace(/^[.,']/, "").replace(/[.,s']$/, "").toLowerCase();
const $ea42ddd831639d75$var$match = (wordA, wordB)=>wordA === wordB;
const $ea42ddd831639d75$var$matchingIngredients = (ingredient, description)=>{
    const indexOfExactIngredient = description.toLowerCase().indexOf(ingredient.name.toLowerCase());
    if (indexOfExactIngredient >= 0) return indexOfExactIngredient;
    const significantWords = ingredient.name.split(/[\s']/).map($ea42ddd831639d75$var$cleanWord).filter((word)=>!$ea42ddd831639d75$var$excludingWords.find((w)=>$ea42ddd831639d75$var$match(word, w))).filter((word)=>word.length >= 3);
    return description.split(/[\s']/).map($ea42ddd831639d75$var$cleanWord).findIndex((word)=>significantWords.some((w)=>$ea42ddd831639d75$var$match(word, w)));
};
var $ea42ddd831639d75$export$2e2bcd8739ae039 = $ea42ddd831639d75$var$matchingIngredients;


const $e430a84573a8ea03$export$364bbe8a1f885e87 = (name, value, unit)=>({
        name: name,
        measure: {
            unit: unit,
            value: value
        }
    });
const $e430a84573a8ea03$export$b141efd0b0fb9174 = (ingredientA, ingredientB)=>ingredientA.name === ingredientB.name && ingredientA.measure.value === ingredientB.measure.value && ingredientA.measure.unit === ingredientB.measure.unit;


const $0365b02fcfe93ef4$var$shortedIngredientName = (ingredient)=>{
    if (ingredient.name.length > 15) {
        const shorterName = ingredient.name.split(/[.:]/)?.[0];
        if (shorterName.length > 5) return shorterName;
    }
    return ingredient.name;
};
var $0365b02fcfe93ef4$export$2e2bcd8739ae039 = $0365b02fcfe93ef4$var$shortedIngredientName;


const $c4c4edfd94631c88$var$expression = /((http:\/\/|https:\/\/|)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?)/gi;
const $c4c4edfd94631c88$export$85f162e0661c509 = (description, className = "")=>description.replace($c4c4edfd94631c88$var$expression, `<a href="$1" target="_blank" class="${className}">$1</a>`);
const $c4c4edfd94631c88$var$notInIfLongerThan = (list, length)=>(ingredient)=>(0, $0365b02fcfe93ef4$export$2e2bcd8739ae039)(ingredient).length > length ? list.every((i)=>!(0, $e430a84573a8ea03$export$b141efd0b0fb9174)(i, ingredient)) : true;
const $c4c4edfd94631c88$var$byIndex = ({ index: indexA }, { index: indexB })=>indexA - indexB;
const $c4c4edfd94631c88$export$79fa8b4f990875e0 = (recipe)=>recipe.steps.reduce((acc, step)=>{
        const { steps: steps, ingredientsAlreadyUsed: ingredientsAlreadyUsed } = acc;
        const ingredients = recipe.ingredients.map((i)=>({
                ingredient: i,
                index: (0, $ea42ddd831639d75$export$2e2bcd8739ae039)(i, step.description)
            })).filter(({ index: index })=>index >= 0).sort($c4c4edfd94631c88$var$byIndex).map(({ ingredient: ingredient })=>ingredient).filter($c4c4edfd94631c88$var$notInIfLongerThan(ingredientsAlreadyUsed, 15));
        return {
            steps: [
                ...steps,
                ingredients
            ],
            ingredientsAlreadyUsed: [
                ...ingredientsAlreadyUsed,
                ...ingredients
            ]
        };
    }, {
        steps: [],
        ingredientsAlreadyUsed: []
    })?.steps;





const $7101986cc211da4e$var$round = (x)=>Math.ceil(x / 5) * 5;
const $7101986cc211da4e$var$cToF = (celsius)=>$7101986cc211da4e$var$round(celsius * 9 / 5 + 32);
const $7101986cc211da4e$var$fToC = (fahrenheit)=>$7101986cc211da4e$var$round((fahrenheit - 32) * 5 / 9);
const $7101986cc211da4e$var$thermostatRegex = /(th\.|thermostat)\s*([0-9]+)/i;
// http://www.recettes-bretonnes.fr/cuisine-arts-de-la-table/degres-thermostats.html
const $7101986cc211da4e$var$thermostatToC = (thermostat)=>30 * thermostat;
const $7101986cc211da4e$var$convertTemperature = (description, temperature)=>{
    if (temperature === (0, $e321886f11c1d045$export$2e2bcd8739ae039).Unknown) return description;
    if (temperature === (0, $e321886f11c1d045$export$2e2bcd8739ae039).Farenheit) {
        if (description.includes("\xb0F")) return description;
        return description.replace(/[0-9]+°C/g, (celsius)=>`${$7101986cc211da4e$var$cToF(parseInt(celsius, 10))}\xb0F`).replace(new RegExp($7101986cc211da4e$var$thermostatRegex, "g"), (thermostat)=>{
            const match = thermostat.match($7101986cc211da4e$var$thermostatRegex)?.[2] || "";
            return `${$7101986cc211da4e$var$cToF($7101986cc211da4e$var$thermostatToC(parseInt(match, 10)))}\xb0F`;
        });
    }
    if (temperature === (0, $e321886f11c1d045$export$2e2bcd8739ae039).Celsius) {
        if (description.includes("\xb0C")) return description;
        return description.replace(/[0-9]+°F/g, (farenheit)=>`${$7101986cc211da4e$var$fToC(parseInt(farenheit, 10))}\xb0C`).replace(new RegExp($7101986cc211da4e$var$thermostatRegex, "g"), (thermostat)=>{
            const match = thermostat.match($7101986cc211da4e$var$thermostatRegex)?.[2] || "";
            return `${$7101986cc211da4e$var$thermostatToC(parseInt(match, 10))}\xb0C`;
        });
    }
    return description;
};
var $7101986cc211da4e$export$2e2bcd8739ae039 = $7101986cc211da4e$var$convertTemperature;






const $f1ff94ed81b306e0$var$IngredientBadge = ({ className: className, ingredient: ingredient })=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $48afa93f9f65698e$export$2e2bcd8739ae039), {
        className: `bg-indigo-100 text-indigo-800 ${className}`,
        children: `${(0, $e2959a6776dd96f2$export$2e2bcd8739ae039)(ingredient.measure)} ${(0, $0365b02fcfe93ef4$export$2e2bcd8739ae039)(ingredient)}`
    });
var $f1ff94ed81b306e0$export$2e2bcd8739ae039 = $f1ff94ed81b306e0$var$IngredientBadge;



const $ae9ef906e6d8d3fd$var$regexes = [
    {
        regex: [
            /([0-9]+)\s*(min|minutes?)/,
            /([0-9]+)\sà\s[0-9]+\s*(min|minutes?)/,
            /([0-9]+)\s-\s[0-9]+\s*(min|minutes?)/
        ],
        parse: (description, regex)=>{
            const match = description.match(regex);
            return match ? (0, $c625d0b818733e5c$export$22ca6081c4f2dca9)(parseInt(match[1])) : 0;
        }
    },
    {
        regex: [
            /([0-9]+)\s*(h|heures?)/,
            /([0-9]+)\sà\s[0-9]+\s*(h|heures?)/
        ],
        parse: (description, regex)=>{
            const match = description.match(regex);
            return match ? (0, $c625d0b818733e5c$export$94476e93d16b1f00)(parseInt(match[1])) : 0;
        }
    }
];
const $ae9ef906e6d8d3fd$var$onlyUnique = (duration, index, array)=>array.indexOf(duration) === index;
const $ae9ef906e6d8d3fd$var$findDurationString = (description)=>({ regex: regex, parse: parse })=>regex.map((r)=>({
                parse: parse,
                regex: r,
                descriptions: description.match(new RegExp(r, "g"))
            }));
const $ae9ef906e6d8d3fd$var$convertStringToDuration = ({ regex: regex, parse: parse, descriptions: descriptions })=>descriptions ? descriptions.map((d)=>parse(d, regex)) : [];
const $ae9ef906e6d8d3fd$var$findDurations = (description)=>$ae9ef906e6d8d3fd$var$regexes.flatMap($ae9ef906e6d8d3fd$var$findDurationString(description)).filter((r)=>Boolean(r.descriptions)).flatMap($ae9ef906e6d8d3fd$var$convertStringToDuration).filter(Boolean).sort((0, $c625d0b818733e5c$export$7cda90e0c352f241)).filter($ae9ef906e6d8d3fd$var$onlyUnique);
var $ae9ef906e6d8d3fd$export$2e2bcd8739ae039 = $ae9ef906e6d8d3fd$var$findDurations;





var $3QbnI = parcelRequire("3QbnI");
function $cf4a75e9ae5415e8$var$PlayIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        d: "M6.3 2.84A1.5 1.5 0 0 0 4 4.11v11.78a1.5 1.5 0 0 0 2.3 1.27l9.344-5.891a1.5 1.5 0 0 0 0-2.538L6.3 2.841Z"
    }));
}
const $cf4a75e9ae5415e8$var$ForwardRef = $3QbnI.forwardRef($cf4a75e9ae5415e8$var$PlayIcon);
var $cf4a75e9ae5415e8$export$2e2bcd8739ae039 = $cf4a75e9ae5415e8$var$ForwardRef;



const $bb7f350e3a3a0f1f$var$oneHour = (0, $c625d0b818733e5c$export$94476e93d16b1f00)(1);
const $bb7f350e3a3a0f1f$export$a2d8d5410f76f0cd = (duration)=>{
    const date = new Date(0);
    date.setSeconds((0, $c625d0b818733e5c$export$a472b8b4d115b7a3)(duration));
    return date.toISOString().substring(duration > $bb7f350e3a3a0f1f$var$oneHour ? 11 : 14, 19);
};
const $bb7f350e3a3a0f1f$export$7375ed2425bb3037 = (number)=>number % $bb7f350e3a3a0f1f$var$oneHour === 0 ? `${number / $bb7f350e3a3a0f1f$var$oneHour}h` : $bb7f350e3a3a0f1f$export$a2d8d5410f76f0cd(number);




var $3QbnI = parcelRequire("3QbnI");




const $1b50197a1f6134fc$var$parseWithoutUnit = (line)=>{
    const matchWithoutUnit = line.match(/^(([0-9]|\.|\s|\/|-)*[0-9]) (.+)/);
    if (matchWithoutUnit) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [value, _, name] = matchWithoutUnit.slice(1);
        return (0, $e430a84573a8ea03$export$364bbe8a1f885e87)(name, value, "count");
    }
    return null;
};
const $1b50197a1f6134fc$var$parseDefault = (line)=>{
    return (0, $e430a84573a8ea03$export$364bbe8a1f885e87)(line, 0, "none");
};
const $1b50197a1f6134fc$var$parsers = [
    $1b50197a1f6134fc$var$parseWithoutUnit,
    $1b50197a1f6134fc$var$parseDefault
];
var $1b50197a1f6134fc$export$2e2bcd8739ae039 = $1b50197a1f6134fc$var$parsers;



const $c74a1c8e52a9577d$var$parseAsExplicitSome = (line)=>{
    const matchExplicitSome = line.match(/^some (.+)/i);
    if (matchExplicitSome) {
        const [name] = matchExplicitSome.slice(1);
        return (0, $e430a84573a8ea03$export$364bbe8a1f885e87)(name, 1, "some");
    }
    return null;
};
const $c74a1c8e52a9577d$var$parseAsWithOfAndUnit = (line)=>{
    const match = line.match(/^(([0-9]|\.|\s|\/)*[0-9])\s*([a-zA-Z]*)\s*of\s*(.+)/i);
    if (match) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [value, _, unit, name] = match.slice(1);
        return (0, $e430a84573a8ea03$export$364bbe8a1f885e87)(name, value, unit);
    }
    return null;
};
// https://en.wikibooks.org/wiki/Cookbook:Units_of_measurement
const $c74a1c8e52a9577d$var$units = [
    "ml",
    "teaspoon",
    "tsp",
    "tablespoon",
    "tbs",
    "fl oz",
    "cup",
    "pint",
    "gallon",
    "mg",
    // 'g',
    "kg",
    "pound",
    "lb",
    "ounce",
    "oz"
];
const $c74a1c8e52a9577d$var$parseAsWithUnitWithoutOf = (line)=>{
    const unit = $c74a1c8e52a9577d$var$units.map((u)=>{
        const match = line.match(new RegExp(`[0-9\\s-]+(${u}[a-z.]*) (of|)`, "i"));
        return match ? match[1] : null;
    }).find(Boolean);
    if (unit) {
        const [value, name] = line.split(new RegExp(`${unit}`, "i"));
        return (0, $e430a84573a8ea03$export$364bbe8a1f885e87)(name.trim(), value.trim(), unit);
    }
    return null;
};
const $c74a1c8e52a9577d$var$parsers = [
    $c74a1c8e52a9577d$var$parseAsExplicitSome,
    $c74a1c8e52a9577d$var$parseAsWithOfAndUnit,
    $c74a1c8e52a9577d$var$parseAsWithUnitWithoutOf
];
var $c74a1c8e52a9577d$export$2e2bcd8739ae039 = $c74a1c8e52a9577d$var$parsers;



// const isValue = (value: string) => value.match(/[0-9½]/)
// const parseAsExplicitUnitFrench = (line: string): Ingredient | null => {
//   const match = line.match(/^([0-9.\s/½]*[0-9½])\s*(.*)\s+(de|d'|d’)\s*(.+)/i)
//   if (match) {
//     // eslint-disable-next-line @typescript-eslint/no-unused-vars
//     const [value, unit, _2, name] = match.slice(1)
//     // if (isValue(value)) {
//     return buildIngredient(name, value, unit)
//     // }
//   }
//   return null
// }
// https://en.wikibooks.org/wiki/Cookbook:Units_of_measurement
const $d76797928670411e$var$units = [
    "c\\. \xe0 th\xe9",
    "tasse",
    "c\\. \xe0 caf\xe9",
    "c\\.\xe0\\.s",
    "c\\.\xe0\\.c",
    "cuill\xe8re \xe0 th\xe9",
    "cuilli\xe8re \xe0 caf\xe9",
    "c. \xe0 soupe",
    "cl",
    "l",
    "L",
    "g"
];
const $d76797928670411e$var$parseKnownUnit = (line)=>{
    const result = $d76797928670411e$var$units.map((u)=>{
        const match = line.match(new RegExp(`([0-9\\s/\xbd]+)[ ]*(${u})[ ]+(de|d'|d\u{2019}|)*(.*)`, "i"));
        return match ? {
            value: match[1],
            unit: match[2],
            name: match[4]
        } : null;
    }).find(Boolean);
    if (result) {
        const { name: name, value: value, unit: unit } = result;
        return (0, $e430a84573a8ea03$export$364bbe8a1f885e87)(name, value, unit);
    }
    return null;
};
const $d76797928670411e$var$parsers = [
    $d76797928670411e$var$parseKnownUnit
];
var $d76797928670411e$export$2e2bcd8739ae039 = $d76797928670411e$var$parsers;


const $ed0229c133ba6e06$var$parsers = [
    ...(0, $c74a1c8e52a9577d$export$2e2bcd8739ae039),
    ...(0, $d76797928670411e$export$2e2bcd8739ae039),
    ...(0, $1b50197a1f6134fc$export$2e2bcd8739ae039)
];
const $ed0229c133ba6e06$export$33f062f47f21a01 = (value)=>{
    if (typeof value === "number") return value;
    const cleanedValue = value.trim().replace(/-$/, "");
    const number = parseFloat(cleanedValue);
    return `${number}` === cleanedValue ? number : cleanedValue;
};
const $ed0229c133ba6e06$var$cleanIngredient = (ingredient)=>({
        ...ingredient,
        name: ingredient.name.trim(),
        measure: {
            unit: ingredient.measure.unit.trim(),
            value: $ed0229c133ba6e06$export$33f062f47f21a01(ingredient.measure.value)
        }
    });
const $ed0229c133ba6e06$var$parseIngredient = (line)=>{
    const ingredient = $ed0229c133ba6e06$var$parsers.map((parser)=>parser(line)).filter(Boolean).map((i)=>i)[0];
    return ingredient ? $ed0229c133ba6e06$var$cleanIngredient(ingredient) : {
        source: "ingredients",
        message: `impossible to parse ingredient ${ingredient}`
    };
};
var $ed0229c133ba6e06$export$2e2bcd8739ae039 = $ed0229c133ba6e06$var$parseIngredient;




var $bei3G = parcelRequire("bei3G");
const $45977b49cf6e2fbf$var$cleanKeywords = (keywords)=>(0, $bei3G.uniq)(keywords.filter(Boolean).map((s)=>s.toLowerCase()));
var $45977b49cf6e2fbf$export$2e2bcd8739ae039 = $45977b49cf6e2fbf$var$cleanKeywords;


const $155871c54ecd5932$export$f2bbc8bb71caffd4 = (step, ingredients)=>({
        description: step,
        ingredients: ingredients.filter((i)=>i.name.split(" ").filter((w)=>w.length > 3).some((w)=>step.includes(w)))
    });
const $155871c54ecd5932$var$parseRecipe = (recipe)=>{
    // const stats = {}
    // if (recipe.stats.servings) {
    //   Object.assign(stats, {
    //     ...stats,
    //     servings: {
    //       value: parseInt(recipe.stats.servings.value, 10),
    //       unit: 'count',
    //     },
    //   })
    // }
    // if (recipe.stats.duration) {
    //   Object.assign(stats, {
    //     ...stats,
    //     duration: {
    //       value: parseInt(recipe.stats.duration.value, 10),
    //       unit: 'min',
    //     },
    //   })
    // }
    const ingredients = (0, $450cace7f3a9ea5d$export$2e2bcd8739ae039)(recipe.ingredients).map((0, $ed0229c133ba6e06$export$2e2bcd8739ae039)).filter((e)=>!("source" in e)).map((e)=>e);
    return {
        ...recipe,
        ingredients: ingredients,
        steps: (0, $450cace7f3a9ea5d$export$2e2bcd8739ae039)(recipe.steps).map((step)=>$155871c54ecd5932$export$f2bbc8bb71caffd4(step, ingredients)),
        keywords: (0, $45977b49cf6e2fbf$export$2e2bcd8739ae039)(recipe.keywords)
    };
};
var $155871c54ecd5932$export$2e2bcd8739ae039 = $155871c54ecd5932$var$parseRecipe;


const $0912099e05b0bf2b$var$useCurrentRecipe = ()=>{
    const { recipeId: recipeId } = (0, $e724dc7e3b3eec8a$export$99eaa27ddbbb95ef)();
    const recipe = (0, $67ed7bda3729d158$export$a7347740d65f620b)((state)=>(0, $87c50e51b43ee465$export$d3bef8d36f4e0ca4)(state, recipeId));
    return (0, $3QbnI.useMemo)(()=>[
            recipe,
            recipe ? (0, $155871c54ecd5932$export$2e2bcd8739ae039)(recipe) : null
        ], [
        recipe
    ]);
};
var $0912099e05b0bf2b$export$2e2bcd8739ae039 = $0912099e05b0bf2b$var$useCurrentRecipe;



const $5e25506f699a3f21$var$DurationBadge = ({ className: className, duration: duration })=>{
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const [recipe] = (0, $0912099e05b0bf2b$export$2e2bcd8739ae039)();
    if (!recipe) return null;
    return(// eslint-disable-next-line i18next/no-literal-string
    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $48afa93f9f65698e$export$2e2bcd8739ae039), {
        className: `inline-flex items-center text-white bg-slate-900 ${className}`,
        onClick: ()=>{
            dispatch((0, $c7da68fdd590423e$export$5985f5b4428bec55)({
                recipeId: recipe.id,
                duration: duration
            }));
        },
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $cf4a75e9ae5415e8$export$2e2bcd8739ae039), {
                className: "h-3 w-3 text-white mr-1"
            }),
            (0, $bb7f350e3a3a0f1f$export$7375ed2425bb3037)(duration)
        ]
    }));
};
var $5e25506f699a3f21$export$2e2bcd8739ae039 = $5e25506f699a3f21$var$DurationBadge;



const $d5f9f7d1c8fc38e9$var$StepItemGeneric = ({ className: className, linkClassName: linkClassName, isLastOne: isLastOne = false, iconClassName: iconClassName, description: description, descriptionClassName: descriptionClassName, icon: icon, onClick: onClick, ingredients: ingredients = [] })=>{
    const temperature = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $cb3b9bf6a0fb48f2$export$c477e9ee4c36462f));
    const descriptionParsed = (0, $3QbnI.useMemo)(()=>typeof description === "string" ? (0, $7101986cc211da4e$export$2e2bcd8739ae039)((0, $c4c4edfd94631c88$export$85f162e0661c509)((0, $bei3G.unescape)(description), "underline"), temperature) : "", [
        description,
        temperature
    ]);
    const durations = (0, $3QbnI.useMemo)(()=>typeof description === "string" ? (0, $ae9ef906e6d8d3fd$export$2e2bcd8739ae039)(description) : [], [
        description
    ]);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("li", {
        className: `relative ${className}`,
        children: [
            !isLastOne ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: `ltr:-ml-px rtl:-mr-px absolute ltr:mt-0.5 rtl:ml-0.5 top-4 ltr:left-4 rtl:right-4 w-0.5 h-full ${linkClassName}`,
                "aria-hidden": "true"
            }) : null,
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("button", {
                onClick: onClick,
                className: "relative z-10 flex items-start group",
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                        className: "h-9 flex items-center",
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                            className: `w-8 h-8 flex items-center justify-center rounded-full ${iconClassName}`,
                            children: icon
                        })
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "ms-4 min-w-0 flex flex-col",
                        children: [
                            descriptionParsed ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: `text-sm ltr:text-left rtl:text-right select-text ${descriptionClassName}`,
                                dangerouslySetInnerHTML: {
                                    __html: descriptionParsed
                                }
                            }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: `text-sm ltr:text-left rtl:text-right select-text ${descriptionClassName}`,
                                children: description
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                className: "flex flex-row flex-wrap",
                                onClick: (event)=>event.stopPropagation(),
                                onKeyDown: ()=>{},
                                role: "link",
                                tabIndex: 0,
                                children: [
                                    ingredients.map((ingredient, index)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f1ff94ed81b306e0$export$2e2bcd8739ae039), {
                                            className: "mr-1 mb-1",
                                            ingredient: ingredient
                                        }, `${ingredient.name} ${index}`)),
                                    (0, $089eebd7fd208286$export$25eaa035e2e3a214)("timer") && durations.map((duration)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5e25506f699a3f21$export$2e2bcd8739ae039), {
                                            duration: duration,
                                            className: "mr-1 mb-1"
                                        }, duration))
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $d5f9f7d1c8fc38e9$export$2e2bcd8739ae039 = $d5f9f7d1c8fc38e9$var$StepItemGeneric;


const $fe68732f0e15c8e5$var$StepItem = ({ step: step, status: status, isLastOne: isLastOne, onClick: onClick, ingredients: ingredients })=>{
    const linkClassName = status === "completed" ? "bg-gray-600" : "bg-gray-300";
    const iconClassName = status === "completed" ? "bg-gray-600 group-hover:bg-black" : status === "current" ? "bg-white border-2 border-primary-400" : "bg-white border-2 border-gray-300 group-hover:border-gray-400";
    const descriptionClassName = status === "completed" ? "text-gray-600" : status === "current" ? "text-gray-800" : "text-gray-500";
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d5f9f7d1c8fc38e9$export$2e2bcd8739ae039), {
        className: !isLastOne ? "pb-10" : "",
        linkClassName: linkClassName,
        isLastOne: isLastOne,
        iconClassName: iconClassName,
        icon: status === "completed" ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $328ce2c05a6b4d53$export$2e2bcd8739ae039), {
            className: "w-5 h-5 text-white",
            "aria-hidden": "true"
        }) : status === "current" ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
            className: "h-2.5 w-2.5 bg-black rounded-full"
        }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
            className: "h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300"
        }),
        description: step.description,
        descriptionClassName: descriptionClassName,
        onClick: onClick,
        ingredients: ingredients
    });
};
var $fe68732f0e15c8e5$export$2e2bcd8739ae039 = $fe68732f0e15c8e5$var$StepItem;








const $89f330e2a1363d7c$var$Toggle = ({ enabled: enabled, onChange: onChange, "aria-label": ariaLabel })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $0525ea1cb21a4d92$export$b5d5cf8927ab7262), {
        checked: enabled,
        onChange: onChange,
        as: "div",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))(enabled ? "bg-primary-400" : "bg-gray-300", "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                className: "sr-only",
                children: ariaLabel
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))(enabled ? "translate-x-5" : "translate-x-0", "pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"),
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))(enabled ? "opacity-100 ease-in duration-200" : "opacity-0 ease-out duration-100", "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"),
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $9347c05b3a29f520$export$2e2bcd8739ae039), {
                        className: "h-3 w-3 text-primary-500"
                    })
                })
            })
        ]
    });
};
var $89f330e2a1363d7c$export$2e2bcd8739ae039 = $89f330e2a1363d7c$var$Toggle;






var $ea022229e0f77b84$exports = {};
var $b9cf6ac4f1910d59$exports = {};
$b9cf6ac4f1910d59$exports = {
    webm: "data:video/webm;base64,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",
    mp4: "data:video/mp4;base64,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"
};


var $ea022229e0f77b84$require$webm = $b9cf6ac4f1910d59$exports.webm;
var $ea022229e0f77b84$require$mp4 = $b9cf6ac4f1910d59$exports.mp4;
// Detect iOS browsers < version 10
const $ea022229e0f77b84$var$oldIOS = ()=>typeof navigator !== "undefined" && parseFloat(("" + (/CPU.*OS ([0-9_]{3,4})[0-9_]{0,1}|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [
        0,
        ""
    ])[1]).replace("undefined", "3_2").replace("_", ".").replace("_", "")) < 10 && !window.MSStream;
// Detect native Wake Lock API support
const $ea022229e0f77b84$var$nativeWakeLock = ()=>"wakeLock" in navigator;
class $ea022229e0f77b84$var$NoSleep {
    constructor(){
        this.enabled = false;
        if ($ea022229e0f77b84$var$nativeWakeLock()) {
            this._wakeLock = null;
            const handleVisibilityChange = ()=>{
                if (this._wakeLock !== null && document.visibilityState === "visible") this.enable();
            };
            document.addEventListener("visibilitychange", handleVisibilityChange);
            document.addEventListener("fullscreenchange", handleVisibilityChange);
        } else if ($ea022229e0f77b84$var$oldIOS()) this.noSleepTimer = null;
        else {
            // Set up no sleep video element
            this.noSleepVideo = document.createElement("video");
            this.noSleepVideo.setAttribute("title", "No Sleep");
            this.noSleepVideo.setAttribute("playsinline", "");
            this._addSourceToVideo(this.noSleepVideo, "webm", $ea022229e0f77b84$require$webm);
            this._addSourceToVideo(this.noSleepVideo, "mp4", $ea022229e0f77b84$require$mp4);
            this.noSleepVideo.addEventListener("loadedmetadata", ()=>{
                if (this.noSleepVideo.duration <= 1) // webm source
                this.noSleepVideo.setAttribute("loop", "");
                else // mp4 source
                this.noSleepVideo.addEventListener("timeupdate", ()=>{
                    if (this.noSleepVideo.currentTime > 0.5) this.noSleepVideo.currentTime = Math.random();
                });
            });
        }
    }
    _addSourceToVideo(element, type, dataURI) {
        var source = document.createElement("source");
        source.src = dataURI;
        source.type = `video/${type}`;
        element.appendChild(source);
    }
    get isEnabled() {
        return this.enabled;
    }
    enable() {
        if ($ea022229e0f77b84$var$nativeWakeLock()) return navigator.wakeLock.request("screen").then((wakeLock)=>{
            this._wakeLock = wakeLock;
            this.enabled = true;
            console.log("Wake Lock active.");
            this._wakeLock.addEventListener("release", ()=>{
                // ToDo: Potentially emit an event for the page to observe since
                // Wake Lock releases happen when page visibility changes.
                // (https://web.dev/wakelock/#wake-lock-lifecycle)
                console.log("Wake Lock released.");
            });
        }).catch((err)=>{
            this.enabled = false;
            console.error(`${err.name}, ${err.message}`);
            throw err;
        });
        else if ($ea022229e0f77b84$var$oldIOS()) {
            this.disable();
            console.warn(`
        NoSleep enabled for older iOS devices. This can interrupt
        active or long-running network requests from completing successfully.
        See https://github.com/richtr/NoSleep.js/issues/15 for more details.
      `);
            this.noSleepTimer = window.setInterval(()=>{
                if (!document.hidden) {
                    window.location.href = window.location.href.split("#")[0];
                    window.setTimeout(window.stop, 0);
                }
            }, 15000);
            this.enabled = true;
            return Promise.resolve();
        } else {
            let playPromise = this.noSleepVideo.play();
            return playPromise.then((res)=>{
                this.enabled = true;
                return res;
            }).catch((err)=>{
                this.enabled = false;
                throw err;
            });
        }
    }
    disable() {
        if ($ea022229e0f77b84$var$nativeWakeLock()) {
            if (this._wakeLock) this._wakeLock.release();
            this._wakeLock = null;
        } else if ($ea022229e0f77b84$var$oldIOS()) {
            if (this.noSleepTimer) {
                console.warn(`
          NoSleep now disabled for older iOS devices.
        `);
                window.clearInterval(this.noSleepTimer);
                this.noSleepTimer = null;
            }
        } else this.noSleepVideo.pause();
        this.enabled = false;
    }
}
$ea022229e0f77b84$exports = $ea022229e0f77b84$var$NoSleep;


const $894312bca871a60f$var$noSleep = new (0, (/*@__PURE__*/$parcel$interopDefault($ea022229e0f77b84$exports)))();
let $894312bca871a60f$var$wakeLock = false;
const $894312bca871a60f$export$1d0d101be0e1eace = async ()=>{
    if (!$894312bca871a60f$var$wakeLock) $894312bca871a60f$var$noSleep.enable();
};
const $894312bca871a60f$export$59fac9bdf8c1da6a = async ()=>{
    if ($894312bca871a60f$var$wakeLock) $894312bca871a60f$var$noSleep.disable();
};




const $1dc878000b2ca0e8$var$key = (step, index)=>`${step.description}${index}`;
const $1dc878000b2ca0e8$var$evaluateStatus = (index, currentStepIndex)=>{
    return index < currentStepIndex ? "completed" : index === currentStepIndex ? "current" : "todo";
};
const $1dc878000b2ca0e8$var$StepList = ({ recipe: recipe, progress: progress, onSelectStep: onSelectStep })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const ingredientsByStep = (0, $c4c4edfd94631c88$export$79fa8b4f990875e0)(recipe);
    const [focusModeEnabled, enableFocusMode] = (0, $3QbnI.useState)(false);
    const confirmCookingMode = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    const cookingModeActivatedOnce = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $cb3b9bf6a0fb48f2$export$e6d9f46a816dd14));
    const toggleFocusMode = ()=>{
        if (focusModeEnabled) enableFocusMode(false);
        else if (cookingModeActivatedOnce) {
            (0, $894312bca871a60f$export$1d0d101be0e1eace)();
            enableFocusMode(true);
        } else confirmCookingMode.open();
    };
    (0, $3QbnI.useEffect)(()=>{
        return ()=>{
            (0, $894312bca871a60f$export$59fac9bdf8c1da6a)();
        };
    }, []);
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: "pb-10 relative z-10",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $3730ae85ea413570$export$2e2bcd8739ae039), {
                        more: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e200d3b9a174836d$export$2e2bcd8739ae039), {
                            label: t("_Focus Mode"),
                            onClick: toggleFocusMode,
                            tooltip: focusModeEnabled ? t("shoppingList.Close shopping list") : t("shoppingList.Create shopping list"),
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $89f330e2a1363d7c$export$2e2bcd8739ae039), {
                                enabled: focusModeEnabled,
                                onChange: toggleFocusMode,
                                "aria-label": t("Toggle focus mode")
                            })
                        }),
                        children: t("_Steps")
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("ol", {
                        className: "overflow-hidden",
                        children: [
                            recipe.steps.map((step, stepIdx)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $fe68732f0e15c8e5$export$2e2bcd8739ae039), {
                                    step: step,
                                    isLastOne: recipe.originUrl ? false : stepIdx === recipe.steps.length - 1,
                                    status: $1dc878000b2ca0e8$var$evaluateStatus(stepIdx, progress),
                                    onClick: ()=>onSelectStep(stepIdx),
                                    ingredients: ingredientsByStep[stepIdx]
                                }, $1dc878000b2ca0e8$var$key(step, stepIdx))),
                            recipe.originUrl && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $fe68732f0e15c8e5$export$2e2bcd8739ae039), {
                                step: {
                                    description: t("_originUrl", {
                                        url: recipe.originUrl
                                    })
                                },
                                isLastOne: true,
                                status: $1dc878000b2ca0e8$var$evaluateStatus(recipe.steps.length, progress),
                                onClick: ()=>onSelectStep(recipe.steps.length),
                                ingredients: []
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
                open: confirmCookingMode.isOpen,
                onClose: confirmCookingMode.close,
                icon: (0, $9347c05b3a29f520$export$2e2bcd8739ae039),
                title: t("_Focus Mode"),
                type: (0, $b9c536326972e77d$export$9656cfe2bd6e411f).Info,
                description: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                        children: t("focusMode.Your device will not go to sleep")
                    })
                }),
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).White, {
                        className: "mb-3 w-full",
                        onClick: confirmCookingMode.close,
                        children: t("_Cancel")
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary, {
                        className: "mb-3 w-full",
                        onClick: ()=>{
                            dispatch((0, $cb3b9bf6a0fb48f2$export$d435de81108eeb49)());
                            enableFocusMode(true);
                            (0, $894312bca871a60f$export$1d0d101be0e1eace)();
                            confirmCookingMode.close();
                        },
                        children: t("focusMode.Activate")
                    })
                ]
            })
        ]
    });
};
var $1dc878000b2ca0e8$export$2e2bcd8739ae039 = $1dc878000b2ca0e8$var$StepList;




parcelRequire("3QbnI");

const $6d48233ba4b818b9$var$RecipeHeader = ({ recipeName: recipeName, children: children, keywords: keywords })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: "flex-1 relative h-full flex items-center z-50",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
            className: "absolute w-full pr-1 pl-2 leading-0 flex flex-col justify-center pointer-events-auto z-50",
            children: [
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h1", {
                    className: "text-left rtl:text-right font-bold leading-2 text-gray-900 text-lg lg:text-2xl line-clamp-1 text-left flex flex-col items-center text-ellipsis break-words",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("span", {
                        children: [
                            recipeName,
                            " ",
                            children
                        ]
                    })
                }),
                keywords.length > 0 ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $1c34a5a43db5f61d$export$2e2bcd8739ae039), {
                    className: "text-left text-ellipsis break-words line-clamp-1 mt-[-5px]",
                    categories: keywords
                }) : null
            ]
        })
    });
};
var $6d48233ba4b818b9$export$2e2bcd8739ae039 = $6d48233ba4b818b9$var$RecipeHeader;






var $3QbnI = parcelRequire("3QbnI");
const $c17029512d70ed45$var$ImageBanner = ({ imageUrl: imageUrl, alt: alt, loading: loading })=>{
    const [shift, setShift] = (0, $3QbnI.useState)(0);
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("scroll", ()=>{
        setShift(-window.scrollY / 3);
    });
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: "h-96 relative overflow-hidden",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
            className: "h-96 w-full fixed z-0 overflow-hidden",
            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("img", {
                src: imageUrl,
                className: "h-[35rem] w-full object-cover relative",
                alt: alt,
                style: {
                    top: shift
                }
            })
        })
    });
};
var $c17029512d70ed45$export$2e2bcd8739ae039 = $c17029512d70ed45$var$ImageBanner;






const $612b8584eefdc0c3$var$CenterPage = ({ className: className = "", children: children, title: title })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e91e729a6066c3b7$export$2e2bcd8739ae039), {
        title: title,
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
            className: "h-screen w-full flex items-center justify-center relative",
            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: className,
                children: children
            })
        })
    });
};
var $612b8584eefdc0c3$export$2e2bcd8739ae039 = $612b8584eefdc0c3$var$CenterPage;


const $b11190345c4c4e48$var$Loading = ()=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $612b8584eefdc0c3$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4a262d36d885163e$export$2e2bcd8739ae039), {})
    });
};
var $b11190345c4c4e48$export$2e2bcd8739ae039 = $b11190345c4c4e48$var$Loading;






const $5daa306c145fc294$var$NotFound404 = ()=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $612b8584eefdc0c3$export$2e2bcd8739ae039), {
        title: "404",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                    className: "text-base font-semibold text-primary-400",
                    children: "404"
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h1", {
                    className: "mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                    children: t("_Page not found.")
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                    className: "mt-2 text-base text-gray-500",
                    children: t("_Sorry, we couldn\u2019t find the page you\u2019re looking for.")
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $500dda12544a1f09$export$a6c7ac8248d6e38a), {
                        to: "/recipes",
                        className: "text-base font-medium text-indigo-600 hover:text-primary-500",
                        title: t("_Back to landing page"),
                        children: [
                            t("_Go back home"),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                "aria-hidden": "true",
                                children: " \u2192"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $5daa306c145fc294$export$2e2bcd8739ae039 = $5daa306c145fc294$var$NotFound404;





var $3QbnI = parcelRequire("3QbnI");








var $3QbnI = parcelRequire("3QbnI");



var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
var $5a514609e57fd0d8$var$index = (0, $3QbnI.useLayoutEffect);
var $5a514609e57fd0d8$export$2e2bcd8739ae039 = $5a514609e57fd0d8$var$index;


var $b116a69b498f555b$export$2e2bcd8739ae039 = function useLatest(value) {
    var ref = $3QbnI.useRef(value);
    (0, $5a514609e57fd0d8$export$2e2bcd8739ae039)(function() {
        ref.current = value;
    });
    return ref;
};



var $3QbnI = parcelRequire("3QbnI");
var $67dc24cb5fb8d47c$var$updateRef = function updateRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    ref.current = value;
};
var $67dc24cb5fb8d47c$var$useComposedRef = function useComposedRef(libRef, userRef) {
    var prevUserRef = (0, $3QbnI.useRef)();
    return (0, $3QbnI.useCallback)(function(instance) {
        libRef.current = instance;
        if (prevUserRef.current) $67dc24cb5fb8d47c$var$updateRef(prevUserRef.current, null);
        prevUserRef.current = userRef;
        if (!userRef) return;
        $67dc24cb5fb8d47c$var$updateRef(userRef, instance);
    }, [
        userRef
    ]);
};
var $67dc24cb5fb8d47c$export$2e2bcd8739ae039 = $67dc24cb5fb8d47c$var$useComposedRef;


var $006db73b9d2bd363$var$HIDDEN_TEXTAREA_STYLE = {
    "min-height": "0",
    "max-height": "none",
    height: "0",
    visibility: "hidden",
    overflow: "hidden",
    position: "absolute",
    "z-index": "-1000",
    top: "0",
    right: "0"
};
var $006db73b9d2bd363$var$forceHiddenStyles = function forceHiddenStyles(node) {
    Object.keys($006db73b9d2bd363$var$HIDDEN_TEXTAREA_STYLE).forEach(function(key) {
        node.style.setProperty(key, $006db73b9d2bd363$var$HIDDEN_TEXTAREA_STYLE[key], "important");
    });
};
var $006db73b9d2bd363$var$forceHiddenStyles$1 = $006db73b9d2bd363$var$forceHiddenStyles;
// TODO: use labelled tuples once they are avaiable:
//   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259
var $006db73b9d2bd363$var$hiddenTextarea = null;
var $006db73b9d2bd363$var$getHeight = function getHeight(node, sizingData) {
    var height = node.scrollHeight;
    if (sizingData.sizingStyle.boxSizing === "border-box") // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
    // remove padding, since height = content
    return height - sizingData.paddingSize;
};
function $006db73b9d2bd363$var$calculateNodeHeight(sizingData, value, minRows, maxRows) {
    if (minRows === void 0) minRows = 1;
    if (maxRows === void 0) maxRows = Infinity;
    if (!$006db73b9d2bd363$var$hiddenTextarea) {
        $006db73b9d2bd363$var$hiddenTextarea = document.createElement("textarea");
        $006db73b9d2bd363$var$hiddenTextarea.setAttribute("tabindex", "-1");
        $006db73b9d2bd363$var$hiddenTextarea.setAttribute("aria-hidden", "true");
        $006db73b9d2bd363$var$forceHiddenStyles$1($006db73b9d2bd363$var$hiddenTextarea);
    }
    if ($006db73b9d2bd363$var$hiddenTextarea.parentNode === null) document.body.appendChild($006db73b9d2bd363$var$hiddenTextarea);
    var paddingSize = sizingData.paddingSize, borderSize = sizingData.borderSize, sizingStyle = sizingData.sizingStyle;
    var boxSizing = sizingStyle.boxSizing;
    Object.keys(sizingStyle).forEach(function(_key) {
        var key = _key;
        $006db73b9d2bd363$var$hiddenTextarea.style[key] = sizingStyle[key];
    });
    $006db73b9d2bd363$var$forceHiddenStyles$1($006db73b9d2bd363$var$hiddenTextarea);
    $006db73b9d2bd363$var$hiddenTextarea.value = value;
    var height = $006db73b9d2bd363$var$getHeight($006db73b9d2bd363$var$hiddenTextarea, sizingData);
    // Double set and calc due to Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1795904
    $006db73b9d2bd363$var$hiddenTextarea.value = value;
    height = $006db73b9d2bd363$var$getHeight($006db73b9d2bd363$var$hiddenTextarea, sizingData);
    // measure height of a textarea with a single row
    $006db73b9d2bd363$var$hiddenTextarea.value = "x";
    var rowHeight = $006db73b9d2bd363$var$hiddenTextarea.scrollHeight - paddingSize;
    var minHeight = rowHeight * minRows;
    if (boxSizing === "border-box") minHeight = minHeight + paddingSize + borderSize;
    height = Math.max(minHeight, height);
    var maxHeight = rowHeight * maxRows;
    if (boxSizing === "border-box") maxHeight = maxHeight + paddingSize + borderSize;
    height = Math.min(maxHeight, height);
    return [
        height,
        rowHeight
    ];
}
var $006db73b9d2bd363$var$noop = function noop() {};
var $006db73b9d2bd363$var$pick = function pick(props, obj) {
    return props.reduce(function(acc, prop) {
        acc[prop] = obj[prop];
        return acc;
    }, {});
};
var $006db73b9d2bd363$var$SIZING_STYLE = [
    "borderBottomWidth",
    "borderLeftWidth",
    "borderRightWidth",
    "borderTopWidth",
    "boxSizing",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    // non-standard
    "tabSize",
    "textIndent",
    // non-standard
    "textRendering",
    "textTransform",
    "width",
    "wordBreak"
];
var $006db73b9d2bd363$var$isIE = !!document.documentElement.currentStyle;
var $006db73b9d2bd363$var$getSizingData = function getSizingData(node) {
    var style = window.getComputedStyle(node);
    if (style === null) return null;
    var sizingStyle = $006db73b9d2bd363$var$pick($006db73b9d2bd363$var$SIZING_STYLE, style);
    var boxSizing = sizingStyle.boxSizing;
    // probably node is detached from DOM, can't read computed dimensions
    if (boxSizing === "") return null;
    // IE (Edge has already correct behaviour) returns content width as computed width
    // so we need to add manually padding and border widths
    if ($006db73b9d2bd363$var$isIE && boxSizing === "border-box") sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + "px";
    var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
    var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
    return {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize
    };
};
var $006db73b9d2bd363$var$getSizingData$1 = $006db73b9d2bd363$var$getSizingData;
function $006db73b9d2bd363$var$useListener(target, type, listener) {
    var latestListener = (0, $b116a69b498f555b$export$2e2bcd8739ae039)(listener);
    $3QbnI.useLayoutEffect(function() {
        var handler = function handler(ev) {
            return latestListener.current(ev);
        };
        // might happen if document.fonts is not defined, for instance
        if (!target) return;
        target.addEventListener(type, handler);
        return function() {
            return target.removeEventListener(type, handler);
        };
    }, []);
}
var $006db73b9d2bd363$var$useWindowResizeListener = function useWindowResizeListener(listener) {
    $006db73b9d2bd363$var$useListener(window, "resize", listener);
};
var $006db73b9d2bd363$var$useFontsLoadedListener = function useFontsLoadedListener(listener) {
    $006db73b9d2bd363$var$useListener(document.fonts, "loadingdone", listener);
};
var $006db73b9d2bd363$var$_excluded = [
    "cacheMeasurements",
    "maxRows",
    "minRows",
    "onChange",
    "onHeightChange"
];
var $006db73b9d2bd363$var$TextareaAutosize = function TextareaAutosize(_ref, userRef) {
    var cacheMeasurements = _ref.cacheMeasurements, maxRows = _ref.maxRows, minRows = _ref.minRows, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? $006db73b9d2bd363$var$noop : _ref$onChange, _ref$onHeightChange = _ref.onHeightChange, onHeightChange = _ref$onHeightChange === void 0 ? $006db73b9d2bd363$var$noop : _ref$onHeightChange, props = (0, $506f89d9550e4bd4$export$2e2bcd8739ae039)(_ref, $006db73b9d2bd363$var$_excluded);
    var isControlled = props.value !== undefined;
    var libRef = $3QbnI.useRef(null);
    var ref = (0, $67dc24cb5fb8d47c$export$2e2bcd8739ae039)(libRef, userRef);
    var heightRef = $3QbnI.useRef(0);
    var measurementsCacheRef = $3QbnI.useRef();
    var resizeTextarea = function resizeTextarea() {
        var node = libRef.current;
        var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : $006db73b9d2bd363$var$getSizingData$1(node);
        if (!nodeSizingData) return;
        measurementsCacheRef.current = nodeSizingData;
        var _calculateNodeHeight = $006db73b9d2bd363$var$calculateNodeHeight(nodeSizingData, node.value || node.placeholder || "x", minRows, maxRows), height = _calculateNodeHeight[0], rowHeight = _calculateNodeHeight[1];
        if (heightRef.current !== height) {
            heightRef.current = height;
            node.style.setProperty("height", height + "px", "important");
            onHeightChange(height, {
                rowHeight: rowHeight
            });
        }
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) resizeTextarea();
        onChange(event);
    };
    $3QbnI.useLayoutEffect(resizeTextarea);
    $006db73b9d2bd363$var$useWindowResizeListener(resizeTextarea);
    $006db73b9d2bd363$var$useFontsLoadedListener(resizeTextarea);
    return /*#__PURE__*/ $3QbnI.createElement("textarea", (0, $dc9dd96d66af11b0$export$2e2bcd8739ae039)({}, props, {
        onChange: handleChange,
        ref: ref
    }));
};
var $006db73b9d2bd363$export$2e2bcd8739ae039 = /* #__PURE__ */ $3QbnI.forwardRef($006db73b9d2bd363$var$TextareaAutosize);



const $6c8b45a774d729b1$var$TextArea = ({ className: className, onChange: onChange, id: id, value: value, placeholder: placeholder = "", rows: rows = 3, ...props })=>{
    const [isFocused, setFocus] = (0, $3QbnI.useState)(false);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("relative relative before:block before:absolute before:top-0 before:bottom-0 before:left-[-10px] before:w-1", {
            "before:bg-primary-500": isFocused,
            "before:bg-gray-200": !isFocused
        }),
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $006db73b9d2bd363$export$2e2bcd8739ae039), {
            name: id,
            id: id,
            className: `p-0 border-0 outline-none focus:outline-none focus:ring-0 resize-none ${className}`,
            onChange: (e)=>onChange(e.target.value),
            value: value,
            minRows: rows,
            placeholder: placeholder,
            onFocus: ()=>setFocus(true),
            onBlur: ()=>setFocus(false),
            ...props
        })
    });
};
var $6c8b45a774d729b1$export$2e2bcd8739ae039 = $6c8b45a774d729b1$var$TextArea;



const $6b791eaa7df4640d$var$TextArea = ({ className: className, onChange: onChange, id: id, value: value, placeholder: placeholder = "", rows: rows = 3, ...props })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("textarea", {
        name: id,
        id: id,
        className: `focus:ring-primary-500 focus:border-primary-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ${className}`,
        onChange: (e)=>onChange(e.target.value),
        value: value,
        rows: rows,
        placeholder: placeholder,
        ...props
    });
};
var $6b791eaa7df4640d$export$2e2bcd8739ae039 = $6b791eaa7df4640d$var$TextArea;




const $62262b4b316752ca$var$TextArea = ({ className: className, onChange: onChange, id: id, value: value, placeholder: placeholder = "", rows: rows = 3, ...props })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $006db73b9d2bd363$export$2e2bcd8739ae039), {
        name: id,
        id: id,
        className: `focus:ring-black focus:border-black block w-full shadow-sm sm:text-sm border-gray-300 rounded-md resize-none ${className}`,
        onChange: (e)=>onChange(e.target.value),
        value: value,
        minRows: rows,
        placeholder: placeholder,
        ...props
    });
};
var $62262b4b316752ca$export$2e2bcd8739ae039 = $62262b4b316752ca$var$TextArea;


const $b812009e1783c3da$var$TextArea = {
    Basic: (0, $6c8b45a774d729b1$export$2e2bcd8739ae039),
    Normal: (0, $6b791eaa7df4640d$export$2e2bcd8739ae039),
    Primary: (0, $62262b4b316752ca$export$2e2bcd8739ae039)
};
var $b812009e1783c3da$export$2e2bcd8739ae039 = $b812009e1783c3da$var$TextArea;



var $3QbnI = parcelRequire("3QbnI");
function $7611779e7636face$var$ArrowUpOnSquareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15"
    }));
}
const $7611779e7636face$var$ForwardRef = $3QbnI.forwardRef($7611779e7636face$var$ArrowUpOnSquareIcon);
var $7611779e7636face$export$2e2bcd8739ae039 = $7611779e7636face$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $a38edbf373485c2b$var$ShareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
    }));
}
const $a38edbf373485c2b$var$ForwardRef = $3QbnI.forwardRef($a38edbf373485c2b$var$ShareIcon);
var $a38edbf373485c2b$export$2e2bcd8739ae039 = $a38edbf373485c2b$var$ForwardRef;



const $3c1fb25d513b3c7e$var$ShareIcon = (0, $7941da5030926682$export$97c02de5f74f3224)() ? (0, $7611779e7636face$export$2e2bcd8739ae039) : (0, $a38edbf373485c2b$export$2e2bcd8739ae039);
var $3c1fb25d513b3c7e$export$2e2bcd8739ae039 = $3c1fb25d513b3c7e$var$ShareIcon;


const $4411f29ab91a4443$var$SharePopup = ({ open: open, recipe: recipe, onClose: onClose })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const [sharedRecipeWithClipboard, setSharedRecipeWithClipboard] = (0, $3QbnI.useState)(false);
    const [shareableRecipe, setShareableRecipe] = (0, $3QbnI.useState)("");
    (0, $3QbnI.useEffect)(()=>{
        const createShareable = async ()=>{
            setShareableRecipe(await (0, $a818b7f1c8cbc256$export$2e2bcd8739ae039)(recipe, t));
        };
        createShareable().catch(console.error);
    }, [
        recipe,
        t
    ]);
    const startSharingText = async ()=>{
        const result = await (0, $0685de3407cda9b0$export$ed7ca78295c017be)(shareableRecipe);
        if ((0, $0685de3407cda9b0$export$57724ff03bad689a)(result)) {
            setSharedRecipeWithClipboard(true);
            await (0, $f937bf1c18ff7494$export$2e2bcd8739ae039)(2500);
            onClose();
            setSharedRecipeWithClipboard(false);
        } else if ((0, $0685de3407cda9b0$export$973d2af2aea58feb)(result)) onClose();
    };
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
        icon: (0, $3c1fb25d513b3c7e$export$2e2bcd8739ae039),
        type: (0, $b9c536326972e77d$export$9656cfe2bd6e411f).Black,
        open: open,
        onClose: onClose,
        title: t("_Share Recipe"),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b812009e1783c3da$export$2e2bcd8739ae039).Normal, {
                value: shareableRecipe,
                className: "h-32 resize-none",
                id: "recipe",
                onChange: ()=>{}
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Black, {
                className: "w-full mt-4",
                onClick: startSharingText,
                children: sharedRecipeWithClipboard ? t("_Recipe copied to clipboard") : t("_Copy Recipe to clipboard")
            })
        ]
    });
};
var $4411f29ab91a4443$export$2e2bcd8739ae039 = $4411f29ab91a4443$var$SharePopup;





var $3QbnI = parcelRequire("3QbnI");


var $3QbnI = parcelRequire("3QbnI");
function $e63129eb30406fce$var$ArrowLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
    }));
}
const $e63129eb30406fce$var$ForwardRef = $3QbnI.forwardRef($e63129eb30406fce$var$ArrowLeftIcon);
var $e63129eb30406fce$export$2e2bcd8739ae039 = $e63129eb30406fce$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $17bccec629f9269a$var$ArrowRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
    }));
}
const $17bccec629f9269a$var$ForwardRef = $3QbnI.forwardRef($17bccec629f9269a$var$ArrowRightIcon);
var $17bccec629f9269a$export$2e2bcd8739ae039 = $17bccec629f9269a$var$ForwardRef;




var $3QbnI = parcelRequire("3QbnI");
const $a050a4f7c2d8a5ac$var$HistoryContext = (0, $3QbnI.createContext)({
    previousLocation: ""
});
var $a050a4f7c2d8a5ac$export$2e2bcd8739ae039 = $a050a4f7c2d8a5ac$var$HistoryContext;



const $525000a460d770e0$var$BackButton = ({ url: url, className: className, basic: basic, disabled: disabled, title: title })=>{
    const { previousLocation: previousLocation } = (0, $3QbnI.useContext)((0, $a050a4f7c2d8a5ac$export$2e2bcd8739ae039));
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    const icon = (0, $1904509318c783c3$export$2e2bcd8739ae039)() ? (0, $17bccec629f9269a$export$2e2bcd8739ae039) : (0, $e63129eb30406fce$export$2e2bcd8739ae039);
    const shouldForgetPreviousLocation = $525000a460d770e0$var$useForgetPreviousLocationAfter(30000);
    if (previousLocation && previousLocation === url && !shouldForgetPreviousLocation) return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
        "data-tip": title,
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Icon, {
            onClick: ()=>navigate(-1),
            icon: icon,
            basic: basic,
            className: className,
            disabled: disabled,
            title: title
        })
    });
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
        "data-tip": title,
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Icon, {
            url: url,
            icon: icon,
            basic: basic,
            className: className,
            disabled: disabled,
            title: title
        })
    });
};
var $525000a460d770e0$export$2e2bcd8739ae039 = $525000a460d770e0$var$BackButton;
function $525000a460d770e0$var$useForgetPreviousLocationAfter(timeout) {
    const [shouldForgetPreviousLocation, forgetPreviousLocation] = (0, $3QbnI.useState)(false);
    (0, $3QbnI.useEffect)(()=>{
        let t = setTimeout(()=>{
            forgetPreviousLocation(true);
        }, timeout);
        return ()=>clearTimeout(t);
    }, [
        timeout
    ]);
    return shouldForgetPreviousLocation;
}













var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
function $d93e74b6834e15fe$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
        clipRule: "evenodd"
    }));
}
const $d93e74b6834e15fe$var$ForwardRef = $3QbnI.forwardRef($d93e74b6834e15fe$var$CheckCircleIcon);
var $d93e74b6834e15fe$export$2e2bcd8739ae039 = $d93e74b6834e15fe$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $88b8b528fa539027$var$StopIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        d: "M5.25 3A2.25 2.25 0 0 0 3 5.25v9.5A2.25 2.25 0 0 0 5.25 17h9.5A2.25 2.25 0 0 0 17 14.75v-9.5A2.25 2.25 0 0 0 14.75 3h-9.5Z"
    }));
}
const $88b8b528fa539027$var$ForwardRef = $3QbnI.forwardRef($88b8b528fa539027$var$StopIcon);
var $88b8b528fa539027$export$2e2bcd8739ae039 = $88b8b528fa539027$var$ForwardRef;



var $3QbnI = parcelRequire("3QbnI");
function $44e1ecd86c845518$var$ClockIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $44e1ecd86c845518$var$ForwardRef = $3QbnI.forwardRef($44e1ecd86c845518$var$ClockIcon);
var $44e1ecd86c845518$export$2e2bcd8739ae039 = $44e1ecd86c845518$var$ForwardRef;








var $b86c266d5b5a6d78$var$TimerStatus;
(function(TimerStatus) {
    TimerStatus[TimerStatus["NotFinished"] = 0] = "NotFinished";
    TimerStatus[TimerStatus["SoonFinished"] = 1] = "SoonFinished";
    TimerStatus[TimerStatus["AlmostFinished"] = 2] = "AlmostFinished";
    TimerStatus[TimerStatus["Finished"] = 3] = "Finished";
})($b86c266d5b5a6d78$var$TimerStatus || ($b86c266d5b5a6d78$var$TimerStatus = {}));
const $b86c266d5b5a6d78$var$CountDownTimer = ({ timer: timer })=>{
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const [status, setStatus] = (0, $3QbnI.useState)(0);
    const [countDown, setCountDown] = (0, $3QbnI.useState)(timer.duration - (0, $c625d0b818733e5c$export$fb26b2980ae1a225)(1));
    (0, $3QbnI.useEffect)(()=>{
        const duration = (0, $44f2d6ec1445318c$export$a4665e647d64ae09)(timer);
        setCountDown(Math.max(0, duration));
        setStatus(0);
        let interval = setInterval(()=>{
            const duration = (0, $44f2d6ec1445318c$export$a4665e647d64ae09)(timer);
            setCountDown(Math.max(0, duration));
            if ((0, $c625d0b818733e5c$export$bd4bc282a1a0d264)(duration, 0)) setStatus(3);
            else if ((0, $c625d0b818733e5c$export$bd4bc282a1a0d264)(duration, (0, $c625d0b818733e5c$export$fb26b2980ae1a225)(10))) setStatus(2);
            else if ((0, $c625d0b818733e5c$export$bd4bc282a1a0d264)(duration, (0, $c625d0b818733e5c$export$fb26b2980ae1a225)(30))) setStatus(1);
            else setStatus(0);
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        timer
    ]);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("flex justify-around items-center px-3 md:px-4 gap-x-3 text-3xl md:text-lg font-medium shadow-2xl rounded-md  overflow-hidden", {
            "bg-white bg-opacity-50 backdrop-filter backdrop-blur": status === 0,
            "bg-primary-500 text-white": status !== 0
        }),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $44e1ecd86c845518$export$2e2bcd8739ae039), {
                className: "h-8 w-8 md:h-6 md:w-6 stroke-2"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("text-4xl md:text-2xl py-2 md:py-4", {
                    "animate-[pulse_1s_ease-in-out_infinite]": status === 2,
                    "animate-[pulse_0.25s_ease-in-out_infinite]": status === 3
                }),
                children: (0, $bb7f350e3a3a0f1f$export$a2d8d5410f76f0cd)(countDown)
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("button", {
                className: "py-3 md:py-4 hover:text-gray-200",
                onClick: ()=>dispatch((0, $c7da68fdd590423e$export$4d41f7386211339a)(timer.id)),
                children: status === 3 ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d93e74b6834e15fe$export$2e2bcd8739ae039), {
                    className: "h-8 w-8 md:h-6 md:w-6"
                }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $88b8b528fa539027$export$2e2bcd8739ae039), {
                    className: "h-8 w-8 md:h-6 md:w-6"
                })
            })
        ]
    });
};
var $b86c266d5b5a6d78$export$2e2bcd8739ae039 = $b86c266d5b5a6d78$var$CountDownTimer;





const $eb81585a356437b3$var$TimerCenter = ()=>{
    const activeTimer = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $c7da68fdd590423e$export$b46d238f7ff52d9f));
    if (!activeTimer || !(0, $089eebd7fd208286$export$25eaa035e2e3a214)("timer")) return null;
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: "fixed bottom-2 left-2 right-2 md:bottom-5 md:left-auto md:right-5 z-50",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b86c266d5b5a6d78$export$2e2bcd8739ae039), {
            timer: activeTimer
        })
    });
};
var $eb81585a356437b3$export$2e2bcd8739ae039 = $eb81585a356437b3$var$TimerCenter;



const $27ababeb22c6e032$var$RecipeView = ()=>{
    const [recipe, formattedRecipe] = (0, $0912099e05b0bf2b$export$2e2bcd8739ae039)();
    const areFetched = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $87c50e51b43ee465$export$c341f62fd7d1eec8));
    const progress = (0, $67ed7bda3729d158$export$a7347740d65f620b)((state)=>(0, $87c50e51b43ee465$export$98c5022c36dab2d1)(state, recipe?.id));
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const ref = (0, $3QbnI.useRef)(null);
    const sharePopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    if (!recipe || !formattedRecipe) {
        if (!areFetched) return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b11190345c4c4e48$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5daa306c145fc294$export$2e2bcd8739ae039), {});
    }
    const changeRecipeProgress = (index)=>{
        dispatch((0, $87c50e51b43ee465$export$f55860a67b188c55)({
            recipeId: recipe.id,
            index: index
        }));
    };
    const startSharing = async ()=>{
        if ((0, $0685de3407cda9b0$export$c6083d60acc62a08)()) await (0, $0685de3407cda9b0$export$ed7ca78295c017be)(await (0, $a818b7f1c8cbc256$export$2e2bcd8739ae039)(recipe, t));
        else sharePopup.open();
    };
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e91e729a6066c3b7$export$2e2bcd8739ae039), {
        title: recipe.name,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $c17029512d70ed45$export$2e2bcd8739ae039), {
                imageUrl: recipe.imageUrl,
                alt: recipe.name
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "relative z-20 bg-white",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
                    className: "flex-1 relative z-20 bg-white",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "flex flex-col items-stretch lg:flex-row lg:items-start",
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                ref: ref
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "w-full lg:flex-[0_0_400px] lg:max-w-screen-md relative top-[-7rem]",
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $462140c0f3a53058$export$2e2bcd8739ae039), {
                                    className: "p-4 lg:w-[400px] relative",
                                    children: [
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h1", {
                                            className: "text-2xl sm:text-3xl font-bold leading-7 text-gray-900 break-words overflow-hidden text-center ltr:lg:text-left rtl:lg:text-right pb-2 select-text",
                                            children: formattedRecipe.name
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $1c34a5a43db5f61d$export$2e2bcd8739ae039), {
                                            className: "text-center lg:text-left",
                                            size: (0, $48afa93f9f65698e$export$2d718f8c6ef64076).large,
                                            categories: formattedRecipe.keywords
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                            className: "pt-6",
                                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f5b1c89a6a08fea4$export$2e2bcd8739ae039), {
                                                formattedRecipe: formattedRecipe
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "flex-1 relative ltr:lg:pl-10 rtl:lg:pr-10 lg:pt-10 top-[-5rem] lg:top-[0rem]",
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $1dc878000b2ca0e8$export$2e2bcd8739ae039), {
                                    recipe: formattedRecipe,
                                    progress: progress,
                                    onSelectStep: changeRecipeProgress
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a3758683e16a4079$export$2e2bcd8739ae039), {
                restRef: ref,
                className: "pointer-events-none",
                children: (isMaximized)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $4bf72665163a8648$export$2e2bcd8739ae039), {
                        white: isMaximized,
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $525000a460d770e0$export$2e2bcd8739ae039), {
                                url: "/recipes",
                                title: t("_Back to recipes")
                            }),
                            isMaximized ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $6d48233ba4b818b9$export$2e2bcd8739ae039), {
                                recipeName: formattedRecipe.name,
                                keywords: formattedRecipe.keywords
                            }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "flex-1"
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                "data-tip": t("_Share Recipe"),
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Icon, {
                                    className: "ltr:mr-3 rtl:ml-3",
                                    onClick: startSharing,
                                    icon: (0, $3c1fb25d513b3c7e$export$2e2bcd8739ae039),
                                    blur: true,
                                    title: t("_Share Recipe")
                                })
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                "data-tip": t("_Edit Recipe"),
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Icon, {
                                    url: `/recipes/${recipe.id}/edit`,
                                    icon: (0, $b0110c46b44ec025$export$2e2bcd8739ae039),
                                    title: t("_Edit Recipe"),
                                    blur: true
                                })
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4411f29ab91a4443$export$2e2bcd8739ae039), {
                recipe: recipe,
                open: sharePopup.isOpen,
                onClose: sharePopup.close
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $eb81585a356437b3$export$2e2bcd8739ae039), {})
        ]
    });
};
var $27ababeb22c6e032$export$2e2bcd8739ae039 = $27ababeb22c6e032$var$RecipeView;




var $3QbnI = parcelRequire("3QbnI");


var $3QbnI = parcelRequire("3QbnI");
function $21534527083f74ba$var$ExclamationTriangleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
    }));
}
const $21534527083f74ba$var$ForwardRef = $3QbnI.forwardRef($21534527083f74ba$var$ExclamationTriangleIcon);
var $21534527083f74ba$export$2e2bcd8739ae039 = $21534527083f74ba$var$ForwardRef;




const $dc1f28f2a2058ab5$var$MainPage = ({ children: children, className: className })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: `bg-white px-4 lg:px-10 py-4 lg:py-10 ${className}`,
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
            className: "max-w-screen-md m-auto",
            children: children
        })
    });
};
var $dc1f28f2a2058ab5$export$2e2bcd8739ae039 = $dc1f28f2a2058ab5$var$MainPage;





/* eslint-disable i18next/no-literal-string */ 
const $ef4845f210b5ac00$var$PreferencesEntry = ({ title: title, description: description, children: children = [], onClick: onClick })=>{
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: "py-4 sm:py-5 flex items-center",
        role: "button",
        tabIndex: -1,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("dt", {
                        className: "text-sm font-medium text-gray-500",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("dd", {
                        className: "mt-1 flex text-sm text-gray-900 sm:col-span-2 sm:mt-0",
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                className: "flex-grow",
                                children: description
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                className: "ml-4 flex-shrink-0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                children: children
            })
        ]
    }));
};
var $ef4845f210b5ac00$export$2e2bcd8739ae039 = $ef4845f210b5ac00$var$PreferencesEntry;



const $08f672fd9f3a0676$var$PreferencesSection = ({ title: title, description: description, children: children = [] })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: "mt-10",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h3", {
                        className: "text-lg font-medium leading-6 text-gray-900",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                        className: "max-w-2xl text-sm text-gray-500",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "mt-0.5",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("dl", {
                    className: "",
                    children: children
                })
            })
        ]
    });
};
var $08f672fd9f3a0676$export$2e2bcd8739ae039 = $08f672fd9f3a0676$var$PreferencesSection;












const $ac6f7da1fdf0ffa3$var$Switch = ({ checked: checked = false, onChange: onChange = ()=>{}, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $0525ea1cb21a4d92$export$b5d5cf8927ab7262), {
        checked: checked,
        onChange: onChange,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))(checked ? "bg-black" : "bg-gray-200", {
            "cursor-pointer": !disabled
        }, "me-1 ms-4 relative  inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"),
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
            "aria-hidden": "true",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))(checked ? "translate-x-5" : "translate-x-0", "inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out")
        })
    });
};
var $ac6f7da1fdf0ffa3$export$2e2bcd8739ae039 = $ac6f7da1fdf0ffa3$var$Switch;









var $3QbnI = parcelRequire("3QbnI");
function $e9b2621952a19fb5$var$ShoppingBagIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        fillRule: "evenodd",
        d: "M6 5v1H4.667a1.75 1.75 0 0 0-1.743 1.598l-.826 9.5A1.75 1.75 0 0 0 3.84 19H16.16a1.75 1.75 0 0 0 1.743-1.902l-.826-9.5A1.75 1.75 0 0 0 15.333 6H14V5a4 4 0 0 0-8 0Zm4-2.5A2.5 2.5 0 0 0 7.5 5v1h5V5A2.5 2.5 0 0 0 10 2.5ZM7.5 10a2.5 2.5 0 0 0 5 0V8.75a.75.75 0 0 1 1.5 0V10a4 4 0 0 1-8 0V8.75a.75.75 0 0 1 1.5 0V10Z",
        clipRule: "evenodd"
    }));
}
const $e9b2621952a19fb5$var$ForwardRef = $3QbnI.forwardRef($e9b2621952a19fb5$var$ShoppingBagIcon);
var $e9b2621952a19fb5$export$2e2bcd8739ae039 = $e9b2621952a19fb5$var$ForwardRef;


const $2cf84599f98380d6$var$Preferences = ()=>{
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const { t: t, i18n: i18n } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const user = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $68690f862a398578$export$e5432d4c8eb97ea7));
    const temperature = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $cb3b9bf6a0fb48f2$export$c477e9ee4c36462f));
    const ref = (0, $3QbnI.useRef)(null);
    const recipes = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $87c50e51b43ee465$export$3b86e2cc0677644d));
    const automaticImport = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $cb3b9bf6a0fb48f2$export$6a52d4affff68ee8));
    const { logout: logout } = (0, $2503a745c61c2eb7$export$2e2bcd8739ae039)();
    const confirmDeleteAccountPopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    const [error, setError] = (0, $3QbnI.useState)("");
    const deleteAccountConfirmed = async ()=>{
        try {
            (0, $650b40fd3e752928$export$6b2a7d5132615086)("DeleteAccount");
            await dispatch((0, $87c50e51b43ee465$export$9d5822594f0e234)()).unwrap();
            // await dispatch(deleteAccount()).unwrap()
            (0, $650b40fd3e752928$export$6b2a7d5132615086)("DeleteAccountSuccess");
            await logout();
        } catch (error) {
            const exception = error;
            if (exception.code === "auth/requires-recent-login") setError("_For security reasons");
            (0, $650b40fd3e752928$export$6b2a7d5132615086)("DeleteAccountError");
        }
    };
    const ingredientTemplatePopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    const [ingredientTemplate, changeIngredientTemplate] = (0, $f47422411e27ad9a$export$2e2bcd8739ae039)((0, $cb3b9bf6a0fb48f2$export$95e92655b1210e4b), (0, $cb3b9bf6a0fb48f2$export$8c38d409f26db51));
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e91e729a6066c3b7$export$2e2bcd8739ae039), {
        title: t("_settings"),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $dc1f28f2a2058ab5$export$2e2bcd8739ae039), {
                className: "flex-1 relative z-10",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                    className: "pt-20",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                            ref: ref
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $08f672fd9f3a0676$export$2e2bcd8739ae039), {
                            title: t("settings.userInterface"),
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ef4845f210b5ac00$export$2e2bcd8739ae039), {
                                    title: t("languages.Language"),
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $99a8eda2a8735c38$export$2e2bcd8739ae039), {
                                        id: "languages",
                                        name: "languages",
                                        className: "mt-1",
                                        defaultValue: i18n.language,
                                        onChange: (language)=>i18n.changeLanguage(language),
                                        options: (0, $c3738d05463420c7$export$d0d68bb9ed2c643d)
                                    })
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ef4845f210b5ac00$export$2e2bcd8739ae039), {
                                    title: t("settings.temperatures.Temperatures"),
                                    description: t("settings.temperatures.Unit in recipes"),
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $99a8eda2a8735c38$export$2e2bcd8739ae039), {
                                        id: "temperature",
                                        name: "temperature",
                                        className: "mt-1",
                                        defaultValue: temperature,
                                        onChange: (value)=>dispatch((0, $cb3b9bf6a0fb48f2$export$1ee9c5b316663b8d)(value)),
                                        options: $15adcf4933c9d401$export$802db1fec2151c6.map(({ label: label, symbol: symbol, value: value })=>({
                                                value: value,
                                                label: `${t(label)} ${symbol}`
                                            }))
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $08f672fd9f3a0676$export$2e2bcd8739ae039), {
                            title: t("import.Import"),
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ef4845f210b5ac00$export$2e2bcd8739ae039), {
                                title: t("_Automatic import"),
                                description: t("_when you click on new recipe with a valid url in your clipboard"),
                                onClick: async ()=>{
                                    const v = !automaticImport;
                                    if (v) await navigator.clipboard.readText();
                                    dispatch((0, $cb3b9bf6a0fb48f2$export$65467453d81927f1)(v));
                                },
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ac6f7da1fdf0ffa3$export$2e2bcd8739ae039), {
                                    checked: automaticImport,
                                    onChange: async (v)=>{
                                        if (v) await navigator.clipboard.readText();
                                        dispatch((0, $cb3b9bf6a0fb48f2$export$65467453d81927f1)(v));
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $08f672fd9f3a0676$export$2e2bcd8739ae039), {
                            title: t("settings.advanced"),
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ef4845f210b5ac00$export$2e2bcd8739ae039), {
                                    title: t("settings.ingredient template"),
                                    description: t("settings.ingredient template description"),
                                    onClick: ingredientTemplatePopup.open
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
                                    open: ingredientTemplatePopup.isOpen,
                                    onClose: ingredientTemplatePopup.close,
                                    icon: (0, $e9b2621952a19fb5$export$2e2bcd8739ae039),
                                    type: (0, $b9c536326972e77d$export$9656cfe2bd6e411f).Success,
                                    description: t("settings.ingredient template"),
                                    children: [
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $2b0c6bf8582a103a$export$2e2bcd8739ae039).Black, {
                                            type: "text",
                                            name: "template",
                                            id: "template",
                                            placeholder: "$1",
                                            value: ingredientTemplate,
                                            onChange: changeIngredientTemplate
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).White, {
                                            className: "mt-3 w-full",
                                            onClick: ingredientTemplatePopup.close,
                                            children: t("notifications.Close")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $08f672fd9f3a0676$export$2e2bcd8739ae039), {
                            title: t("settings.account"),
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ef4845f210b5ac00$export$2e2bcd8739ae039), {
                                    title: t("settings.Export"),
                                    description: t("settings.Download all your recipes"),
                                    onClick: async ()=>await (0, $c1e23b84fcfe63c2$export$2e2bcd8739ae039)(recipes, t),
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $1aaf2d418038901b$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 ml-2"
                                    })
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ef4845f210b5ac00$export$2e2bcd8739ae039), {
                                    title: t("_Logout"),
                                    description: t("settings._You are logged in as", {
                                        emailAddress: user?.email
                                    }),
                                    onClick: logout,
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b3448e465f742ebc$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 ml-2"
                                    })
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ef4845f210b5ac00$export$2e2bcd8739ae039), {
                                    title: t("_Delete account"),
                                    description: t("_This action is definitive."),
                                    onClick: confirmDeleteAccountPopup.open,
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $21534527083f74ba$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 ml-2 text-orange-400"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a3758683e16a4079$export$2e2bcd8739ae039), {
                restRef: ref,
                children: (isMaximized)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $4bf72665163a8648$export$2e2bcd8739ae039), {
                        white: isMaximized,
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $525000a460d770e0$export$2e2bcd8739ae039), {
                                url: "/recipes",
                                basic: true,
                                title: t("_Back to recipes")
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h1", {
                                className: "text-2xl font-extrabold text-gray-900 pl-4",
                                children: t("_settings")
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "flex-1"
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
                open: confirmDeleteAccountPopup.isOpen,
                onClose: confirmDeleteAccountPopup.close,
                icon: (0, $21534527083f74ba$export$2e2bcd8739ae039),
                type: (0, $b9c536326972e77d$export$9656cfe2bd6e411f).Warning,
                description: t("_Do you really want to delete your account?"),
                children: error ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                    className: "text-sm font-bold ",
                    children: t(error)
                }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).White, {
                            className: "mb-3 w-full",
                            onClick: confirmDeleteAccountPopup.close,
                            children: t("_Cancel")
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Black, {
                            className: "mb-3 w-full",
                            onClick: deleteAccountConfirmed,
                            children: t("_Delete account")
                        })
                    ]
                })
            })
        ]
    });
};
var $2cf84599f98380d6$export$2e2bcd8739ae039 = $2cf84599f98380d6$var$Preferences;




var $3QbnI = parcelRequire("3QbnI");







const $fd1a5f943881bd1f$var$PortalLayout = ({ children: children })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: "min-h-screen fixed flex w-full",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    className: "mx-auto w-full max-w-sm lg:w-96 text-center md:text-left text-left rtl:text-right",
                    children: children
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "hidden lg:block relative w-0 flex-1",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("img", {
                    className: "absolute inset-0 h-full w-full object-cover",
                    src: "https://images.unsplash.com/photo-1514986888952-8cd320577b68?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1752",
                    alt: ""
                })
            })
        ]
    });
};
var $fd1a5f943881bd1f$export$2e2bcd8739ae039 = $fd1a5f943881bd1f$var$PortalLayout;


const $8e9e52b7745f05dc$var$LoginPage = ({ children: children, title: title, description: description })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e91e729a6066c3b7$export$2e2bcd8739ae039), {
        title: title,
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $fd1a5f943881bd1f$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $525000a460d770e0$export$2e2bcd8739ae039), {
                    url: "/",
                    className: "fixed top-5 left-5 lg:top-10 lg:left-10",
                    title: t("_Back to landing page")
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h2", {
                    className: "mt-6 text-3xl font-extrabold text-gray-900",
                    children: title
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                    className: "mt-2 text-sm text-gray-600",
                    children: description
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    className: "mt-8",
                    children: children
                })
            ]
        })
    });
};
var $8e9e52b7745f05dc$export$2e2bcd8739ae039 = $8e9e52b7745f05dc$var$LoginPage;






const $ed5cc2db846f00c6$var$Login = ()=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("login");
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    const [email, setEmail] = (0, $3QbnI.useState)("");
    const [isLoading, setLoading] = (0, $3QbnI.useState)(false);
    const { sendVerificationCodeForLogin: sendVerificationCodeForLogin } = (0, $2503a745c61c2eb7$export$2e2bcd8739ae039)();
    const login = async (event)=>{
        setLoading(true);
        try {
            await sendVerificationCodeForLogin(email);
            navigate(`/login/code-verify?email=${email}`);
        } catch (e) {} finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $8e9e52b7745f05dc$export$2e2bcd8739ae039), {
        title: t("_Log in"),
        description: t("_We need your email"),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $bd914ef380e06327$export$2e2bcd8739ae039), {
                className: "space-y-4",
                onSubmit: login,
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("label", {
                                htmlFor: "email",
                                className: "block text-sm font-medium text-gray-700",
                                children: t("_Email address")
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("input", {
                                    id: "email",
                                    name: "email",
                                    type: "email",
                                    autoComplete: "email",
                                    onChange: (e)=>setEmail(e.target.value),
                                    required: true,
                                    placeholder: "john.smith@gmail.com",
                                    className: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary, {
                            type: "submit",
                            className: "w-full",
                            children: isLoading ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $571576b994bd2c02$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-white"
                            }) : t("_Send code")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("p", {
                className: "mt-5 text-left text-sm text-gray-500",
                children: [
                    t("_No account"),
                    " ",
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $500dda12544a1f09$export$a6c7ac8248d6e38a), {
                        to: "/signup",
                        className: "font-semibold leading-6 text-primary-500 hover:text-primary-600",
                        children: t("_Sign up")
                    })
                ]
            })
        ]
    });
};
var $ed5cc2db846f00c6$export$2e2bcd8739ae039 = $ed5cc2db846f00c6$var$Login;




var $3QbnI = parcelRequire("3QbnI");







var $3QbnI = parcelRequire("3QbnI");


var $3QbnI = parcelRequire("3QbnI");
function $7d7d40110bedef52$var$PhotoIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    }));
}
const $7d7d40110bedef52$var$ForwardRef = $3QbnI.forwardRef($7d7d40110bedef52$var$PhotoIcon);
var $7d7d40110bedef52$export$2e2bcd8739ae039 = $7d7d40110bedef52$var$ForwardRef;










var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
function $5f3f037cc9fe8466$var$CloudArrowUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
    }));
}
const $5f3f037cc9fe8466$var$ForwardRef = $3QbnI.forwardRef($5f3f037cc9fe8466$var$CloudArrowUpIcon);
var $5f3f037cc9fe8466$export$2e2bcd8739ae039 = $5f3f037cc9fe8466$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $601f0d6c10845bfb$var$NoSymbolIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636"
    }));
}
const $601f0d6c10845bfb$var$ForwardRef = $3QbnI.forwardRef($601f0d6c10845bfb$var$NoSymbolIcon);
var $601f0d6c10845bfb$export$2e2bcd8739ae039 = $601f0d6c10845bfb$var$ForwardRef;






const $f558be7202437921$var$defaultAuthorizedTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/gif"
];
const $f558be7202437921$var$getItem = (event)=>event.dataTransfer?.items?.[0];
const $f558be7202437921$var$ImageUploader = /*#__PURE__*/ (0, $3QbnI.forwardRef)(({ onChange: onChange, isUploading: isUploading, authorizedTypes: authorizedTypes = $f558be7202437921$var$defaultAuthorizedTypes, children: children }, ref)=>{
    const [isDragging, setDragging] = (0, $3QbnI.useState)(false);
    const [areFilesAuthorized, setFilesAuthorized] = (0, $3QbnI.useState)(false);
    (0, $3QbnI.useEffect)(()=>{
        if (isUploading) setDragging(false);
    }, [
        isUploading
    ]);
    const onUploadImage = async (event)=>{
        if (event.currentTarget.files && event.currentTarget.files?.length > 0) onChange(event.currentTarget.files[0]);
    };
    const onDrop = async (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const item = $f558be7202437921$var$getItem(event);
        if (item && item.kind === "file") {
            const file = item.getAsFile();
            if (file !== null) onChange(file);
        }
    };
    const onDragEnter = async (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const item = $f558be7202437921$var$getItem(event);
        if (item) {
            const hasAuthorizedTypes = authorizedTypes.includes(item?.type);
            setFilesAuthorized(hasAuthorizedTypes);
            setDragging(true);
        }
    };
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("drop", (event)=>{
        event.stopPropagation();
        event.preventDefault();
    });
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("dragover", (event)=>{
        event.stopPropagation();
        event.preventDefault();
    });
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("absolute inset-0 text-white flex items-center justify-center transition-colors", {
                    "bg-[#000000cc]": isUploading || isDragging
                }),
                onDrop: onDrop,
                onDragEnter: onDragEnter,
                onDragLeave: ()=>setDragging(false),
                children: [
                    isUploading && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4a262d36d885163e$export$2e2bcd8739ae039), {}),
                    isDragging && areFilesAuthorized && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5f3f037cc9fe8466$export$2e2bcd8739ae039), {
                                className: "h-7 w-7",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                children: t("_Drop image there")
                            })
                        ]
                    }),
                    isDragging && !areFilesAuthorized && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $601f0d6c10845bfb$export$2e2bcd8739ae039), {
                                className: "h-7 w-7",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                children: t("_only PNG, JPG, GIF up to 10MB")
                            })
                        ]
                    }),
                    !isDragging && !isUploading && children
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("input", {
                id: "file-upload",
                name: "file-upload",
                type: "file",
                "aria-label": t("_Change image"),
                className: "sr-only",
                accept: authorizedTypes.join(", "),
                onChange: onUploadImage,
                ref: ref
            })
        ]
    });
});
var $f558be7202437921$export$2e2bcd8739ae039 = $f558be7202437921$var$ImageUploader;




var $5543cf8485380abc$exports = {};
"use strict";
Object.defineProperty($5543cf8485380abc$exports, "__esModule", {
    value: true
});
Object.defineProperty($5543cf8485380abc$exports, "KEYS", {
    enumerable: true,
    get: function get() {
        return $g21To.KEYS;
    }
});
$5543cf8485380abc$exports.WithOutContext = $5543cf8485380abc$exports.WithContext = void 0;

var $5543cf8485380abc$var$_react = $5543cf8485380abc$var$_interopRequireWildcard((parcelRequire("3QbnI")));



var $rwcxx = parcelRequire("rwcxx");
// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ function $d7ec88c70d64a40a$export$3988ae62b71be9a3(obj, path, defaultValue) {
    return path.split(".").reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null, obj);
}
function $d7ec88c70d64a40a$export$5d14bf425b37f49e(items, item) {
    return items.filter((i)=>i !== item);
}
function $d7ec88c70d64a40a$export$844ec244b1367d54(input) {
    return typeof input === "string";
}
function $d7ec88c70d64a40a$export$a6cdc56e425d0d0a(input) {
    return typeof input === "object";
}
function $d7ec88c70d64a40a$export$6444ef5cd411280c(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) result.push(key);
    });
    return result;
}
function $d7ec88c70d64a40a$export$bc86dfbf7795668c(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1);
}


const $6af267d9511f99a8$export$3fc3a33e48b33945 = "dnd-core/INIT_COORDS";
const $6af267d9511f99a8$export$98f9b4193e6b55e6 = "dnd-core/BEGIN_DRAG";
const $6af267d9511f99a8$export$22d1d88e2de0d0e0 = "dnd-core/PUBLISH_DRAG_SOURCE";
const $6af267d9511f99a8$export$9d358706ccac3727 = "dnd-core/HOVER";
const $6af267d9511f99a8$export$b4af72c40fd57063 = "dnd-core/DROP";
const $6af267d9511f99a8$export$d300627d16aeb9cc = "dnd-core/END_DRAG";


function $1a0e27d679cba7c1$export$844048139dfc906d(clientOffset, sourceClientOffset) {
    return {
        type: (0, $6af267d9511f99a8$export$3fc3a33e48b33945),
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}



const $73f62a9ba24a8fbf$var$ResetCoordinatesAction = {
    type: (0, $6af267d9511f99a8$export$3fc3a33e48b33945),
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $73f62a9ba24a8fbf$export$d6542eb0d76867d6(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource: publishSource = true, clientOffset: clientOffset, getSourceClientOffset: getSourceClientOffset } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch((0, $1a0e27d679cba7c1$export$844048139dfc906d)(clientOffset));
        $73f62a9ba24a8fbf$var$verifyInvariants(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = $73f62a9ba24a8fbf$var$getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch($73f62a9ba24a8fbf$var$ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error("getSourceClientOffset must be defined");
            $73f62a9ba24a8fbf$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch((0, $1a0e27d679cba7c1$export$844048139dfc906d)(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        $73f62a9ba24a8fbf$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: (0, $6af267d9511f99a8$export$98f9b4193e6b55e6),
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $73f62a9ba24a8fbf$var$verifyInvariants(sourceIds, monitor, registry) {
    (0, $rwcxx.invariant)(!monitor.isDragging(), "Cannot call beginDrag while dragging.");
    sourceIds.forEach(function(sourceId) {
        (0, $rwcxx.invariant)(registry.getSource(sourceId), "Expected sourceIds to be registered.");
    });
}
function $73f62a9ba24a8fbf$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, $rwcxx.invariant)(typeof getSourceClientOffset === "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function $73f62a9ba24a8fbf$var$verifyItemIsObject(item) {
    (0, $rwcxx.invariant)((0, $d7ec88c70d64a40a$export$a6cdc56e425d0d0a)(item), "Item must be an object.");
}
function $73f62a9ba24a8fbf$var$getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}



var $rwcxx = parcelRequire("rwcxx");


function $b7ae3d33ba53842b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b7ae3d33ba53842b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $b7ae3d33ba53842b$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $b7ae3d33ba53842b$export$9f5cbae8d079dda0(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $b7ae3d33ba53842b$var$verifyInvariants(monitor);
        const targetIds = $b7ae3d33ba53842b$var$getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = $b7ae3d33ba53842b$var$determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: (0, $6af267d9511f99a8$export$b4af72c40fd57063),
                payload: {
                    dropResult: $b7ae3d33ba53842b$var$_objectSpread({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $b7ae3d33ba53842b$var$verifyInvariants(monitor) {
    (0, $rwcxx.invariant)(monitor.isDragging(), "Cannot call drop while not dragging.");
    (0, $rwcxx.invariant)(!monitor.didDrop(), "Cannot call drop twice during one drag operation.");
}
function $b7ae3d33ba53842b$var$determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    $b7ae3d33ba53842b$var$verifyDropResultType(dropResult);
    if (typeof dropResult === "undefined") dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $b7ae3d33ba53842b$var$verifyDropResultType(dropResult) {
    (0, $rwcxx.invariant)(typeof dropResult === "undefined" || (0, $d7ec88c70d64a40a$export$a6cdc56e425d0d0a)(dropResult), "Drop result must either be an object or undefined.");
}
function $b7ae3d33ba53842b$var$getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}



var $rwcxx = parcelRequire("rwcxx");

function $96e2aaa289c7dc31$export$2f5c7d4805260fdf(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $96e2aaa289c7dc31$var$verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: (0, $6af267d9511f99a8$export$d300627d16aeb9cc)
        };
    };
}
function $96e2aaa289c7dc31$var$verifyIsDragging(monitor) {
    (0, $rwcxx.invariant)(monitor.isDragging(), "Cannot call endDrag while not dragging.");
}



var $rwcxx = parcelRequire("rwcxx");
function $15753f42f4954bac$export$2d6239ff106f142f(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType) : targetType === draggedItemType;
}



function $cadce1b3b4f8566b$export$2f85b44a1d72ad03(manager) {
    return function hover(targetIdsArg, { clientOffset: clientOffset } = {}) {
        $cadce1b3b4f8566b$var$verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        const draggedItemType = monitor.getItemType();
        $cadce1b3b4f8566b$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $cadce1b3b4f8566b$var$checkInvariants(targetIds, monitor, registry);
        $cadce1b3b4f8566b$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: (0, $6af267d9511f99a8$export$9d358706ccac3727),
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $cadce1b3b4f8566b$var$verifyTargetIdsIsArray(targetIdsArg) {
    (0, $rwcxx.invariant)(Array.isArray(targetIdsArg), "Expected targetIds to be an array.");
}
function $cadce1b3b4f8566b$var$checkInvariants(targetIds, monitor, registry) {
    (0, $rwcxx.invariant)(monitor.isDragging(), "Cannot call hover while not dragging.");
    (0, $rwcxx.invariant)(!monitor.didDrop(), "Cannot call hover after drop.");
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        (0, $rwcxx.invariant)(targetIds.lastIndexOf(targetId) === i, "Expected targetIds to be unique in the passed array.");
        const target = registry.getTarget(targetId);
        (0, $rwcxx.invariant)(target, "Expected targetIds to be registered.");
    }
}
function $cadce1b3b4f8566b$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!(0, $15753f42f4954bac$export$2d6239ff106f142f)(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $cadce1b3b4f8566b$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}



function $b0fdac8a358b5a32$export$1675a481db21e714(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: (0, $6af267d9511f99a8$export$22d1d88e2de0d0e0)
        };
        return;
    };
}



function $5f2df2ad114e9b79$export$ac1b80e79f04247f(manager) {
    return {
        beginDrag: (0, $73f62a9ba24a8fbf$export$d6542eb0d76867d6)(manager),
        publishDragSource: (0, $b0fdac8a358b5a32$export$1675a481db21e714)(manager),
        hover: (0, $cadce1b3b4f8566b$export$2f85b44a1d72ad03)(manager),
        drop: (0, $b7ae3d33ba53842b$export$9f5cbae8d079dda0)(manager),
        endDrag: (0, $96e2aaa289c7dc31$export$2f5c7d4805260fdf)(manager)
    };
}


class $574ae2c928a77d87$export$1141bbf61324c55f {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch: dispatch } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== "undefined") dispatch(action);
            };
        }
        const actions = (0, $5f2df2ad114e9b79$export$ac1b80e79f04247f)(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}



var $rwcxx = parcelRequire("rwcxx");
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $8113ef1f129d5c9e$export$e16d8520af44a096(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function $8113ef1f129d5c9e$export$4e2d2ead65e5f7e3(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $8113ef1f129d5c9e$export$b6a5970fca17c71e(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset, initialSourceClientOffset: initialSourceClientOffset } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $8113ef1f129d5c9e$export$4e2d2ead65e5f7e3($8113ef1f129d5c9e$export$e16d8520af44a096(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function $8113ef1f129d5c9e$export$b57ee1a41eb1620b(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset } = state;
    if (!clientOffset || !initialClientOffset) return null;
    return $8113ef1f129d5c9e$export$4e2d2ead65e5f7e3(clientOffset, initialClientOffset);
}



const $76cb01401f499fae$export$c53d0f541b41b88e = [];
const $76cb01401f499fae$export$61b49a5ae59d663 = [];
$76cb01401f499fae$export$c53d0f541b41b88e.__IS_NONE__ = true;
$76cb01401f499fae$export$61b49a5ae59d663.__IS_ALL__ = true;
function $76cb01401f499fae$export$3347776eeed47180(dirtyIds, handlerIds) {
    if (dirtyIds === $76cb01401f499fae$export$c53d0f541b41b88e) return false;
    if (dirtyIds === $76cb01401f499fae$export$61b49a5ae59d663 || typeof handlerIds === "undefined") return true;
    const commonIds = (0, $d7ec88c70d64a40a$export$bc86dfbf7795668c)(handlerIds, dirtyIds);
    return commonIds.length > 0;
}



class $71b34486b2d95e1a$export$e220263e518daaed {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds: handlerIds } = options;
        (0, $rwcxx.invariant)(typeof listener === "function", "listener must be a function.");
        (0, $rwcxx.invariant)(typeof handlerIds === "undefined" || Array.isArray(handlerIds), "handlerIds, when specified, must be an array of strings.");
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, $76cb01401f499fae$export$3347776eeed47180)(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) listener();
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        (0, $rwcxx.invariant)(typeof listener === "function", "listener must be a function.");
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) return;
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId);
        (0, $rwcxx.invariant)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) return false;
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) return false;
        const target = this.registry.getTarget(targetId);
        (0, $rwcxx.invariant)(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return (0, $15753f42f4954bac$export$2d6239ff106f142f)(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId, true);
        (0, $rwcxx.invariant)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) return false;
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) return false;
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) return false;
        const { shallow: shallow } = options;
        if (!this.isDragging()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !(0, $15753f42f4954bac$export$2d6239ff106f142f)(targetType, draggedItemType)) return false;
        const targetIds = this.getTargetIds();
        if (!targetIds.length) return false;
        const index = targetIds.indexOf(targetId);
        if (shallow) return index === targetIds.length - 1;
        else return index > -1;
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return (0, $8113ef1f129d5c9e$export$b6a5970fca17c71e)(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return (0, $8113ef1f129d5c9e$export$b57ee1a41eb1620b)(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}


/* eslint-disable no-restricted-globals, @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-non-null-assertion */ // Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $cf664d87bcc145b5$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
const $cf664d87bcc145b5$var$BrowserMutationObserver = $cf664d87bcc145b5$var$scope.MutationObserver || $cf664d87bcc145b5$var$scope.WebKitMutationObserver;
function $cf664d87bcc145b5$export$27a7cafb047f3c77(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function $cf664d87bcc145b5$export$2785f4493cc9ca62(callback) {
    let toggle = 1;
    const observer = new $cf664d87bcc145b5$var$BrowserMutationObserver(callback);
    const node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $cf664d87bcc145b5$export$29545a1340296ce3 = typeof $cf664d87bcc145b5$var$BrowserMutationObserver === "function" ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$cf664d87bcc145b5$export$2785f4493cc9ca62 : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$cf664d87bcc145b5$export$27a7cafb047f3c77;


class $ecd622942b91cffb$export$d3f0708de0e313ed {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q, requestFlush: requestFlush } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = (0, $cf664d87bcc145b5$export$29545a1340296ce3)(this.flush);
        this.requestErrorThrow = (0, $cf664d87bcc145b5$export$27a7cafb047f3c77)(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
 // original foundation for this library.
 // http://www.nonblocking.io/2011/06/windownexttick.html
 // Safari 6.0.5 (at least) intermittently fails to create message ports on a
 // page's first load. Thankfully, this version of Safari supports
 // MutationObservers, so we don't need to fall back in that case.
 // function makeRequestCallFromMessageChannel(callback) {
 //     var channel = new MessageChannel();
 //     channel.port1.onmessage = callback;
 //     return function requestCall() {
 //         channel.port2.postMessage(0);
 //     };
 // }
 // For reasons explained above, we are also unable to use `setImmediate`
 // under any circumstances.
 // Even if we were, there is another bug in Internet Explorer 10.
 // It is not sufficient to assign `setImmediate` to `requestFlush` because
 // `setImmediate` must be called *by name* and therefore must be wrapped in a
 // closure.
 // Never forget.
 // function makeRequestCallFromSetImmediate(callback) {
 //     return function requestCall() {
 //         setImmediate(callback);
 //     };
 // }
 // Safari 6.0 has a problem where timers will get lost while the user is
 // scrolling. This problem does not impact ASAP because Safari 6.0 supports
 // mutation observers, so that implementation is used instead.
 // However, if we ever elect to use timers in Safari, the prevalent work-around
 // is to add a scroll event listener that calls for a flush.
 // `setTimeout` does not call the passed callback if the delay is less than
 // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
 // even then.
 // This is for `asap.js` only.
 // Its name will be periodically randomized to break any code that depends on
 // // its existence.
 // rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
 // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js


// `call`, just like a function.
class $0a519384d3ad4271$export$c84b69da61b33d93 {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}


class $df6c0989c0e12063$export$4577931b6c22c63b {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new (0, $0a519384d3ad4271$export$c84b69da61b33d93)(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}


const $755c4bdca903e29d$var$asapQueue = new (0, $ecd622942b91cffb$export$d3f0708de0e313ed)();
const $755c4bdca903e29d$var$taskFactory = new (0, $df6c0989c0e12063$export$4577931b6c22c63b)($755c4bdca903e29d$var$asapQueue.registerPendingError);
function $755c4bdca903e29d$export$dc4d482300a341e1(task) {
    $755c4bdca903e29d$var$asapQueue.enqueueTask($755c4bdca903e29d$var$taskFactory.create(task));
}









var $rwcxx = parcelRequire("rwcxx");
const $39987069572fb20b$export$b36933c81fb1c092 = "dnd-core/ADD_SOURCE";
const $39987069572fb20b$export$2c313542981556ae = "dnd-core/ADD_TARGET";
const $39987069572fb20b$export$13332566b98b8783 = "dnd-core/REMOVE_SOURCE";
const $39987069572fb20b$export$82ace346d17d8869 = "dnd-core/REMOVE_TARGET";
function $39987069572fb20b$export$bc333c64f07a75c4(sourceId) {
    return {
        type: $39987069572fb20b$export$b36933c81fb1c092,
        payload: {
            sourceId: sourceId
        }
    };
}
function $39987069572fb20b$export$9dd68fe78f37278b(targetId) {
    return {
        type: $39987069572fb20b$export$2c313542981556ae,
        payload: {
            targetId: targetId
        }
    };
}
function $39987069572fb20b$export$c724aacd61334138(sourceId) {
    return {
        type: $39987069572fb20b$export$13332566b98b8783,
        payload: {
            sourceId: sourceId
        }
    };
}
function $39987069572fb20b$export$20ae7ec87f7f8696(targetId) {
    return {
        type: $39987069572fb20b$export$82ace346d17d8869,
        payload: {
            targetId: targetId
        }
    };
}



var $rwcxx = parcelRequire("rwcxx");
function $8bcb19538ab4d48e$export$a7a13c013ce18993(source) {
    (0, $rwcxx.invariant)(typeof source.canDrag === "function", "Expected canDrag to be a function.");
    (0, $rwcxx.invariant)(typeof source.beginDrag === "function", "Expected beginDrag to be a function.");
    (0, $rwcxx.invariant)(typeof source.endDrag === "function", "Expected endDrag to be a function.");
}
function $8bcb19538ab4d48e$export$77d3cd1340fdeb5a(target) {
    (0, $rwcxx.invariant)(typeof target.canDrop === "function", "Expected canDrop to be a function.");
    (0, $rwcxx.invariant)(typeof target.hover === "function", "Expected hover to be a function.");
    (0, $rwcxx.invariant)(typeof target.drop === "function", "Expected beginDrag to be a function.");
}
function $8bcb19538ab4d48e$export$831a593efd22380d(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>$8bcb19538ab4d48e$export$831a593efd22380d(t, false));
        return;
    }
    (0, $rwcxx.invariant)(typeof type === "string" || typeof type === "symbol", allowArray ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}


var $c04ba77dec793192$export$bb8f0843d7d66cb0;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($c04ba77dec793192$export$bb8f0843d7d66cb0 || ($c04ba77dec793192$export$bb8f0843d7d66cb0 = {}));


let $d145b13c400f1df7$var$nextUniqueId = 0;
function $d145b13c400f1df7$export$dbfb29c8f2c7bb44() {
    return $d145b13c400f1df7$var$nextUniqueId++;
}


function $00f4dbbfad5037dd$var$getNextHandlerId(role) {
    const id = (0, $d145b13c400f1df7$export$dbfb29c8f2c7bb44)().toString();
    switch(role){
        case (0, $c04ba77dec793192$export$bb8f0843d7d66cb0).SOURCE:
            return `S${id}`;
        case (0, $c04ba77dec793192$export$bb8f0843d7d66cb0).TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function $00f4dbbfad5037dd$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case "S":
            return (0, $c04ba77dec793192$export$bb8f0843d7d66cb0).SOURCE;
        case "T":
            return (0, $c04ba77dec793192$export$bb8f0843d7d66cb0).TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function $00f4dbbfad5037dd$var$mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done: done, value: [, value] } = entries.next();
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
class $00f4dbbfad5037dd$export$60ceab237232d5db {
    addSource(type, source) {
        (0, $8bcb19538ab4d48e$export$831a593efd22380d)(type);
        (0, $8bcb19538ab4d48e$export$a7a13c013ce18993)(source);
        const sourceId = this.addHandler((0, $c04ba77dec793192$export$bb8f0843d7d66cb0).SOURCE, type, source);
        this.store.dispatch((0, $39987069572fb20b$export$bc333c64f07a75c4)(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        (0, $8bcb19538ab4d48e$export$831a593efd22380d)(type, true);
        (0, $8bcb19538ab4d48e$export$77d3cd1340fdeb5a)(target);
        const targetId = this.addHandler((0, $c04ba77dec793192$export$bb8f0843d7d66cb0).TARGET, type, target);
        this.store.dispatch((0, $39987069572fb20b$export$9dd68fe78f37278b)(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return $00f4dbbfad5037dd$var$mapContainsValue(this.dragSources, handler) || $00f4dbbfad5037dd$var$mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        (0, $rwcxx.invariant)(this.isSourceId(sourceId), "Expected a valid source ID.");
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        (0, $rwcxx.invariant)(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        (0, $rwcxx.invariant)(this.isSourceId(sourceId), "Expected a valid source ID.");
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        (0, $rwcxx.invariant)(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = $00f4dbbfad5037dd$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $c04ba77dec793192$export$bb8f0843d7d66cb0).SOURCE;
    }
    isTargetId(handlerId) {
        const role = $00f4dbbfad5037dd$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $c04ba77dec793192$export$bb8f0843d7d66cb0).TARGET;
    }
    removeSource(sourceId) {
        (0, $rwcxx.invariant)(this.getSource(sourceId), "Expected an existing source.");
        this.store.dispatch((0, $39987069572fb20b$export$c724aacd61334138)(sourceId));
        (0, $755c4bdca903e29d$export$dc4d482300a341e1)(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        (0, $rwcxx.invariant)(this.getTarget(targetId), "Expected an existing target.");
        this.store.dispatch((0, $39987069572fb20b$export$20ae7ec87f7f8696)(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        (0, $rwcxx.invariant)(source, "Expected an existing source.");
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        (0, $rwcxx.invariant)(this.pinnedSource, "No source is pinned at the time.");
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = $00f4dbbfad5037dd$var$getNextHandlerId(role);
        this.types.set(id, type);
        if (role === (0, $c04ba77dec793192$export$bb8f0843d7d66cb0).SOURCE) this.dragSources.set(id, handler);
        else if (role === (0, $c04ba77dec793192$export$bb8f0843d7d66cb0).TARGET) this.dropTargets.set(id, handler);
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}






const $7876429d54f28e39$export$2116cbe61f6a442a = (a, b)=>a === b;
function $7876429d54f28e39$export$102b20725d4d2263(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function $7876429d54f28e39$export$94fd53d40f0652a(a, b, isEqual = $7876429d54f28e39$export$2116cbe61f6a442a) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}



function $69804cf32d28a69b$export$533b26079ad0b4b(_state = (0, $76cb01401f499fae$export$c53d0f541b41b88e), action) {
    switch(action.type){
        case 0, $6af267d9511f99a8$export$9d358706ccac3727:
            break;
        case 0, $39987069572fb20b$export$b36933c81fb1c092:
        case 0, $39987069572fb20b$export$2c313542981556ae:
        case 0, $39987069572fb20b$export$82ace346d17d8869:
        case 0, $39987069572fb20b$export$13332566b98b8783:
            return 0, $76cb01401f499fae$export$c53d0f541b41b88e;
        case 0, $6af267d9511f99a8$export$98f9b4193e6b55e6:
        case 0, $6af267d9511f99a8$export$22d1d88e2de0d0e0:
        case 0, $6af267d9511f99a8$export$d300627d16aeb9cc:
        case 0, $6af267d9511f99a8$export$b4af72c40fd57063:
        default:
            return 0, $76cb01401f499fae$export$61b49a5ae59d663;
    }
    const { targetIds: targetIds = [], prevTargetIds: prevTargetIds = [] } = action.payload;
    const result = (0, $d7ec88c70d64a40a$export$6444ef5cd411280c)(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !(0, $7876429d54f28e39$export$94fd53d40f0652a)(targetIds, prevTargetIds);
    if (!didChange) return 0, $76cb01401f499fae$export$c53d0f541b41b88e;
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}




function $8a493f9e735d275c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8a493f9e735d275c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $8a493f9e735d275c$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $8a493f9e735d275c$var$initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $8a493f9e735d275c$export$533b26079ad0b4b(state = $8a493f9e735d275c$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $6af267d9511f99a8$export$3fc3a33e48b33945:
        case 0, $6af267d9511f99a8$export$98f9b4193e6b55e6:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case 0, $6af267d9511f99a8$export$9d358706ccac3727:
            if ((0, $7876429d54f28e39$export$102b20725d4d2263)(state.clientOffset, payload.clientOffset)) return state;
            return $8a493f9e735d275c$var$_objectSpread({}, state, {
                clientOffset: payload.clientOffset
            });
        case 0, $6af267d9511f99a8$export$d300627d16aeb9cc:
        case 0, $6af267d9511f99a8$export$b4af72c40fd57063:
            return $8a493f9e735d275c$var$initialState;
        default:
            return state;
    }
}





function $38fa631a84bb563b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $38fa631a84bb563b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $38fa631a84bb563b$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $38fa631a84bb563b$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $38fa631a84bb563b$export$533b26079ad0b4b(state = $38fa631a84bb563b$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $6af267d9511f99a8$export$98f9b4193e6b55e6:
            return $38fa631a84bb563b$var$_objectSpread({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case 0, $6af267d9511f99a8$export$22d1d88e2de0d0e0:
            return $38fa631a84bb563b$var$_objectSpread({}, state, {
                isSourcePublic: true
            });
        case 0, $6af267d9511f99a8$export$9d358706ccac3727:
            return $38fa631a84bb563b$var$_objectSpread({}, state, {
                targetIds: payload.targetIds
            });
        case 0, $39987069572fb20b$export$82ace346d17d8869:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $38fa631a84bb563b$var$_objectSpread({}, state, {
                targetIds: (0, $d7ec88c70d64a40a$export$5d14bf425b37f49e)(state.targetIds, payload.targetId)
            });
        case 0, $6af267d9511f99a8$export$b4af72c40fd57063:
            return $38fa631a84bb563b$var$_objectSpread({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case 0, $6af267d9511f99a8$export$d300627d16aeb9cc:
            return $38fa631a84bb563b$var$_objectSpread({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}



function $ead6a5d73ef73c21$export$533b26079ad0b4b(state = 0, action) {
    switch(action.type){
        case 0, $39987069572fb20b$export$b36933c81fb1c092:
        case 0, $39987069572fb20b$export$2c313542981556ae:
            return state + 1;
        case 0, $39987069572fb20b$export$13332566b98b8783:
        case 0, $39987069572fb20b$export$82ace346d17d8869:
            return state - 1;
        default:
            return state;
    }
}


function $06a96aa1b656da38$export$533b26079ad0b4b(state = 0) {
    return state + 1;
}


function $7751230655f7c863$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7751230655f7c863$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $7751230655f7c863$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $7751230655f7c863$export$533b26079ad0b4b(state = {}, action) {
    return {
        dirtyHandlerIds: (0, $69804cf32d28a69b$export$533b26079ad0b4b)(state.dirtyHandlerIds, {
            type: action.type,
            payload: $7751230655f7c863$var$_objectSpread({}, action.payload, {
                prevTargetIds: (0, $d7ec88c70d64a40a$export$3988ae62b71be9a3)(state, "dragOperation.targetIds", [])
            })
        }),
        dragOffset: (0, $8a493f9e735d275c$export$533b26079ad0b4b)(state.dragOffset, action),
        refCount: (0, $ead6a5d73ef73c21$export$533b26079ad0b4b)(state.refCount, action),
        dragOperation: (0, $38fa631a84bb563b$export$533b26079ad0b4b)(state.dragOperation, action),
        stateId: (0, $06a96aa1b656da38$export$533b26079ad0b4b)(state.stateId)
    };
}


function $fd84248f67e69802$export$ff47aa43d5fd3e5d(backendFactory, globalContext, backendOptions = {}, debugMode = false) {
    const store = $fd84248f67e69802$var$makeStoreInstance(debugMode);
    const monitor = new (0, $71b34486b2d95e1a$export$e220263e518daaed)(store, new (0, $00f4dbbfad5037dd$export$60ceab237232d5db)(store));
    const manager = new (0, $574ae2c928a77d87$export$1141bbf61324c55f)(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function $fd84248f67e69802$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, $f57e9dc67fd3979f$export$f51a9068ac82ea43)((0, $7751230655f7c863$export$533b26079ad0b4b), debugMode && reduxDevTools && reduxDevTools({
        name: "dnd-core",
        instanceId: "dnd-core"
    }));
}



var $3QbnI = parcelRequire("3QbnI");

var $h8sf9 = parcelRequire("h8sf9");
function $3c3cb22ca9922807$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3c3cb22ca9922807$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3c3cb22ca9922807$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $3c3cb22ca9922807$var$refCount = 0;
const $3c3cb22ca9922807$var$INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var $3c3cb22ca9922807$export$9861489d68213f9c = /*#__PURE__*/ (0, $3QbnI.memo)(function DndProvider(_param) {
    var { children: children } = _param, props = $3c3cb22ca9922807$var$_objectWithoutProperties(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = $3c3cb22ca9922807$var$getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ (0, $3QbnI.useEffect)(()=>{
        if (isGlobalInstance) {
            const context = $3c3cb22ca9922807$var$getGlobalContext();
            ++$3c3cb22ca9922807$var$refCount;
            return ()=>{
                if (--$3c3cb22ca9922807$var$refCount === 0) context[$3c3cb22ca9922807$var$INSTANCE_SYM] = null;
            };
        }
        return;
    }, []);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $h8sf9.DndContext).Provider, {
        value: manager,
        children: children
    });
});
function $3c3cb22ca9922807$var$getDndContextValue(props) {
    if ("manager" in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = $3c3cb22ca9922807$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function $3c3cb22ca9922807$var$createSingletonDndContext(backend, context = $3c3cb22ca9922807$var$getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[$3c3cb22ca9922807$var$INSTANCE_SYM]) ctx[$3c3cb22ca9922807$var$INSTANCE_SYM] = {
        dragDropManager: (0, $fd84248f67e69802$export$ff47aa43d5fd3e5d)(backend, context, options, debugMode)
    };
    return ctx[$3c3cb22ca9922807$var$INSTANCE_SYM];
}
function $3c3cb22ca9922807$var$getGlobalContext() {
    return typeof $parcel$global !== "undefined" ? $parcel$global : window;
}


// cheap lodash replacements
function $1cab7ae89b6b8b4e$export$fc10aeed3a532e2a(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
function $1cab7ae89b6b8b4e$export$5d14bf425b37f49e(items, item) {
    return items.filter((i)=>i !== item);
}
function $1cab7ae89b6b8b4e$export$971dd5b0dfd021b6(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item);
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key));
    return result;
}


class $09ad971a03ebf483$export$9ff3e6eb5c734d0d {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
        this.entered = (0, $1cab7ae89b6b8b4e$export$971dd5b0dfd021b6)(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = (0, $1cab7ae89b6b8b4e$export$5d14bf425b37f49e)(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}


class $2f8cac8d4d715bf2$export$f22384f077cf51c4 {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) newProperties[property] = {
                    value: propertyFn(dataTransfer, this.config.matchesTypes),
                    configurable: true,
                    enumerable: true
                };
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}


var $00efe9f6c12f8faa$exports = {};

$parcel$export($00efe9f6c12f8faa$exports, "FILE", function () { return $00efe9f6c12f8faa$export$1802dbfd31b58482; });
$parcel$export($00efe9f6c12f8faa$exports, "URL", function () { return $00efe9f6c12f8faa$export$61abde59b50deb8e; });
$parcel$export($00efe9f6c12f8faa$exports, "TEXT", function () { return $00efe9f6c12f8faa$export$d597759d33be802e; });
$parcel$export($00efe9f6c12f8faa$exports, "HTML", function () { return $00efe9f6c12f8faa$export$9dcd2b1ca4768128; });
const $00efe9f6c12f8faa$export$1802dbfd31b58482 = "__NATIVE_FILE__";
const $00efe9f6c12f8faa$export$61abde59b50deb8e = "__NATIVE_URL__";
const $00efe9f6c12f8faa$export$d597759d33be802e = "__NATIVE_TEXT__";
const $00efe9f6c12f8faa$export$9dcd2b1ca4768128 = "__NATIVE_HTML__";


function $6de3daeb4ca0e9ff$export$dc02f6a7b68f305f(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry), "");
    return result != null ? result : defaultValue;
}


const $91bbaa29e97a7f6c$export$8cc89d9b8cb1bd88 = {
    [$00efe9f6c12f8faa$export$1802dbfd31b58482]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files),
            items: (dataTransfer)=>dataTransfer.items,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Files"
        ]
    },
    [$00efe9f6c12f8faa$export$9dcd2b1ca4768128]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>(0, $6de3daeb4ca0e9ff$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Html",
            "text/html"
        ]
    },
    [$00efe9f6c12f8faa$export$61abde59b50deb8e]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>(0, $6de3daeb4ca0e9ff$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, "").split("\n"),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Url",
            "text/uri-list"
        ]
    },
    [$00efe9f6c12f8faa$export$d597759d33be802e]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>(0, $6de3daeb4ca0e9ff$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Text",
            "text/plain"
        ]
    }
};


function $59a7cea2b8cf541f$export$ada362c01636774d(type, dataTransfer) {
    const config = (0, $91bbaa29e97a7f6c$export$8cc89d9b8cb1bd88)[type];
    if (!config) throw new Error(`native type ${type} has no configuration`);
    const result = new (0, $2f8cac8d4d715bf2$export$f22384f077cf51c4)(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function $59a7cea2b8cf541f$export$11b547ed8c182c11(dataTransfer) {
    if (!dataTransfer) return null;
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys((0, $91bbaa29e97a7f6c$export$8cc89d9b8cb1bd88)).filter((nativeItemType)=>{
        const typeConfig = (0, $91bbaa29e97a7f6c$export$8cc89d9b8cb1bd88)[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) return false;
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1);
    })[0] || null;
}




const $a7784026c09ca0c4$export$b7d78993b74f766d = (0, $1cab7ae89b6b8b4e$export$fc10aeed3a532e2a)(()=>/firefox/i.test(navigator.userAgent));
const $a7784026c09ca0c4$export$95df08bae54cb4df = (0, $1cab7ae89b6b8b4e$export$fc10aeed3a532e2a)(()=>Boolean(window.safari));


class $fe17e1b5d5c3112a$export$6d87c156c5199b02 {
    interpolate(x) {
        const { xs: xs, ys: ys, c1s: c1s, c2s: c2s, c3s: c3s } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) return ys[i];
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) low = mid + 1;
            else if (xHere > x) high = mid - 1;
            else return ys[mid];
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length: length } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++)indexes.push(i);
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1);
        // Get consecutive differences and slopes
        const dys = [];
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}


const $2ae4643f27025fa8$var$ELEMENT_NODE = 1;
function $2ae4643f27025fa8$export$8419e8612027b1d8(node) {
    const el = node.nodeType === $2ae4643f27025fa8$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    const { top: top, left: left } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $2ae4643f27025fa8$export$710c829989c68339(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $2ae4643f27025fa8$var$isImageNode(node) {
    var ref;
    return node.nodeName === "IMG" && ((0, $a7784026c09ca0c4$export$b7d78993b74f766d)() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function $2ae4643f27025fa8$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ((0, $a7784026c09ca0c4$export$95df08bae54cb4df)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $2ae4643f27025fa8$export$e99fdbb90efc75c5(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = $2ae4643f27025fa8$var$isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = $2ae4643f27025fa8$export$8419e8612027b1d8(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth, offsetHeight: sourceHeight } = sourceNode;
    const { anchorX: anchorX, anchorY: anchorY } = anchorPoint;
    const { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight } = $2ae4643f27025fa8$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new (0, $fe17e1b5d5c3112a$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ((0, $a7784026c09ca0c4$export$95df08bae54cb4df)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new (0, $fe17e1b5d5c3112a$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX: offsetX, offsetY: offsetY } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}


class $14da763db7f1b2d9$export$2b3a268803e49e64 {
    get window() {
        if (this.globalContext) return this.globalContext;
        else if (typeof window !== "undefined") return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) return this.globalContext.document;
        else if (this.window) return this.window.document;
        else return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
}


function $99583b834deecf34$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $99583b834deecf34$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $99583b834deecf34$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
class $99583b834deecf34$export$3a01990c235a9281 {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) return;
        if (root.__isReactDndBackendSetUp) throw new Error("Cannot have two HTML5 backends at the same time.");
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) return;
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 || ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId);
        const handleSelectStart = (e)=>this.handleSelectStart(e);
        node.setAttribute("draggable", "true");
        node.addEventListener("dragstart", handleDragStart);
        node.addEventListener("selectstart", handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener("dragstart", handleDragStart);
            node.removeEventListener("selectstart", handleSelectStart);
            node.setAttribute("draggable", "false");
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId);
        const handleDragOver = (e)=>this.handleDragOver(e, targetId);
        const handleDrop = (e)=>this.handleDrop(e, targetId);
        node.addEventListener("dragenter", handleDragEnter);
        node.addEventListener("dragover", handleDragOver);
        node.addEventListener("drop", handleDrop);
        return ()=>{
            node.removeEventListener("dragenter", handleDragEnter);
            node.removeEventListener("dragover", handleDragOver);
            node.removeEventListener("drop", handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) return;
        target.addEventListener("dragstart", this.handleTopDragStart);
        target.addEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.addEventListener("dragend", this.handleTopDragEndCapture, true);
        target.addEventListener("dragenter", this.handleTopDragEnter);
        target.addEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.addEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.addEventListener("dragover", this.handleTopDragOver);
        target.addEventListener("dragover", this.handleTopDragOverCapture, true);
        target.addEventListener("drop", this.handleTopDrop);
        target.addEventListener("drop", this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) return;
        target.removeEventListener("dragstart", this.handleTopDragStart);
        target.removeEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.removeEventListener("dragend", this.handleTopDragEndCapture, true);
        target.removeEventListener("dragenter", this.handleTopDragEnter);
        target.removeEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.removeEventListener("dragover", this.handleTopDragOver);
        target.removeEventListener("dragover", this.handleTopDragOverCapture, true);
        target.removeEventListener("drop", this.handleTopDrop);
        target.removeEventListener("drop", this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return $99583b834deecf34$var$_objectSpread({
            dropEffect: this.altKeyPressed ? "copy" : "move"
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
        return "copy";
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return $99583b834deecf34$var$_objectSpread({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys($00efe9f6c12f8faa$exports).some((key)=>$00efe9f6c12f8faa$exports[key] === itemType);
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = (0, $59a7cea2b8cf541f$export$ada362c01636774d)(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 || ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) return;
        if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && (0, $2ae4643f27025fa8$export$8419e8612027b1d8)(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) return;
            this.actions.endDrag();
            if (this.currentNativeHandle) this.registry.removeSource(this.currentNativeHandle);
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) return;
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.scheduleHover = (dragOverTargetIds)=>{
            if (this.hoverRafId === null && typeof requestAnimationFrame !== "undefined") this.hoverRafId = requestAnimationFrame(()=>{
                if (this.monitor.isDragging()) this.actions.hover(dragOverTargetIds || [], {
                    clientOffset: this.lastClientOffset
                });
                this.hoverRafId = null;
            });
        };
        this.cancelHover = ()=>{
            if (this.hoverRafId !== null && typeof cancelAnimationFrame !== "undefined") {
                cancelAnimationFrame(this.hoverRafId);
                this.hoverRafId = null;
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) return;
            const { dragStartSourceIds: dragStartSourceIds } = this;
            this.dragStartSourceIds = null;
            const clientOffset = (0, $2ae4643f27025fa8$export$710c829989c68339)(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
                this.cancelHover();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            const { dataTransfer: dataTransfer } = e;
            const nativeType = (0, $59a7cea2b8cf541f$export$11b547ed8c182c11)(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === "function") {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX: anchorX, anchorY: anchorY, offsetX: offsetX, offsetY: offsetY } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        const offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        const dragPreviewOffset = (0, $2ae4643f27025fa8$export$e99fdbb90efc75c5)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 || dataTransfer.setData("application/json", {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState: captureDraggingState } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(()=>this.actions.publishDragSource(), 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            this.actions.endDrag();
            this.cancelHover();
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) return;
            const { dataTransfer: dataTransfer } = e;
            const nativeType = (0, $59a7cea2b8cf541f$export$11b547ed8c182c11)(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            this.beginDragNativeItem(nativeType, dataTransfer);
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds: dragEnterTargetIds } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) this.actions.hover(dragEnterTargetIds, {
                clientOffset: (0, $2ae4643f27025fa8$export$710c829989c68339)(e)
            });
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds: dragOverTargetIds } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = (0, $2ae4643f27025fa8$export$710c829989c68339)(e);
            this.scheduleHover(dragOverTargetIds);
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            } else if (this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) e.preventDefault();
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (this.isDraggingNativeItem()) setTimeout(()=>this.endDragNativeItem(), 0);
            this.cancelHover();
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            } else if ((0, $59a7cea2b8cf541f$export$11b547ed8c182c11)(e.dataTransfer)) // Dragging some elements, like <a> and <img> may still behave like a native drag event,
            // even if the current drag event matches a user-defined type.
            // Stop the default behavior when we're not expecting a native item to be dropped.
            e.preventDefault();
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds: dropTargetIds } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: (0, $2ae4643f27025fa8$export$710c829989c68339)(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) this.endDragNativeItem();
            else if (this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== "function") return;
            // Inputs and textareas should be selectable
            if (target.tagName === "INPUT" || target.tagName === "SELECT" || target.tagName === "TEXTAREA" || target.isContentEditable) return;
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new (0, $14da763db7f1b2d9$export$2b3a268803e49e64)(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new (0, $09ad971a03ebf483$export$9ff3e6eb5c734d0d)(this.isNodeInDocument);
    }
}




const $ecb76deb45df5e3c$export$f4f61d779bb20744 = function createBackend(manager, context, options) {
    return new (0, $99583b834deecf34$export$3a01990c235a9281)(manager, context, options);
};



var $5543cf8485380abc$var$_isEqual = $5543cf8485380abc$var$_interopRequireDefault((parcelRequire("kzj6W")));

var $5543cf8485380abc$var$_noop = $5543cf8485380abc$var$_interopRequireDefault((parcelRequire("bAbuX")));

var $5543cf8485380abc$var$_uniq = $5543cf8485380abc$var$_interopRequireDefault((parcelRequire("5kW8A")));

var $5543cf8485380abc$var$_ClearAllTags = $5543cf8485380abc$var$_interopRequireDefault((parcelRequire("2LA01")));

var $5543cf8485380abc$var$_Suggestions = $5543cf8485380abc$var$_interopRequireDefault((parcelRequire("a5YPb")));

var $5543cf8485380abc$var$_propTypes = $5543cf8485380abc$var$_interopRequireDefault((parcelRequire("bZSVP")));

var $5543cf8485380abc$var$_classnames = $5543cf8485380abc$var$_interopRequireDefault((parcelRequire("jVS5x")));

var $5543cf8485380abc$var$_Tag = $5543cf8485380abc$var$_interopRequireDefault((parcelRequire("dAEho")));

var $iWuDm = parcelRequire("iWuDm");

var $g21To = parcelRequire("g21To");
function $5543cf8485380abc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5543cf8485380abc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5543cf8485380abc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5543cf8485380abc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $5543cf8485380abc$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $5543cf8485380abc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5543cf8485380abc$var$_toConsumableArray(arr) {
    return $5543cf8485380abc$var$_arrayWithoutHoles(arr) || $5543cf8485380abc$var$_iterableToArray(arr) || $5543cf8485380abc$var$_unsupportedIterableToArray(arr) || $5543cf8485380abc$var$_nonIterableSpread();
}
function $5543cf8485380abc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5543cf8485380abc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5543cf8485380abc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5543cf8485380abc$var$_arrayLikeToArray(o, minLen);
}
function $5543cf8485380abc$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5543cf8485380abc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5543cf8485380abc$var$_arrayLikeToArray(arr);
}
function $5543cf8485380abc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5543cf8485380abc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5543cf8485380abc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5543cf8485380abc$var$_typeof(o);
}
function $5543cf8485380abc$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $5543cf8485380abc$var$_extends() {
    $5543cf8485380abc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5543cf8485380abc$var$_extends.apply(this, arguments);
}
function $5543cf8485380abc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5543cf8485380abc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5543cf8485380abc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5543cf8485380abc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5543cf8485380abc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5543cf8485380abc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5543cf8485380abc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5543cf8485380abc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5543cf8485380abc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5543cf8485380abc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5543cf8485380abc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5543cf8485380abc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5543cf8485380abc$var$_setPrototypeOf(subClass, superClass);
}
function $5543cf8485380abc$var$_setPrototypeOf(o, p) {
    $5543cf8485380abc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5543cf8485380abc$var$_setPrototypeOf(o, p);
}
function $5543cf8485380abc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5543cf8485380abc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5543cf8485380abc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5543cf8485380abc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5543cf8485380abc$var$_possibleConstructorReturn(this, result);
    };
}
function $5543cf8485380abc$var$_possibleConstructorReturn(self, call) {
    if (call && ($5543cf8485380abc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5543cf8485380abc$var$_assertThisInitialized(self);
}
function $5543cf8485380abc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5543cf8485380abc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5543cf8485380abc$var$_getPrototypeOf(o) {
    $5543cf8485380abc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5543cf8485380abc$var$_getPrototypeOf(o);
}
function $5543cf8485380abc$var$_defineProperty(obj, key, value) {
    key = $5543cf8485380abc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5543cf8485380abc$var$_toPropertyKey(arg) {
    var key = $5543cf8485380abc$var$_toPrimitive(arg, "string");
    return $5543cf8485380abc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5543cf8485380abc$var$_toPrimitive(input, hint) {
    if ($5543cf8485380abc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5543cf8485380abc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} //Constants
var $5543cf8485380abc$var$ReactTags = $5543cf8485380abc$exports.WithOutContext = /*#__PURE__*/ function(_Component) {
    $5543cf8485380abc$var$_inherits(ReactTags, _Component);
    var _super = $5543cf8485380abc$var$_createSuper(ReactTags);
    function ReactTags(props) {
        var _this;
        $5543cf8485380abc$var$_classCallCheck(this, ReactTags);
        _this = _super.call(this, props);
        $5543cf8485380abc$var$_defineProperty($5543cf8485380abc$var$_assertThisInitialized(_this), "filteredSuggestions", function(query) {
            var suggestions = _this.props.suggestions;
            if (_this.props.allowUnique) {
                var existingTags = _this.props.tags.map(function(tag) {
                    return tag.id.trim().toLowerCase();
                });
                suggestions = suggestions.filter(function(suggestion) {
                    return !existingTags.includes(suggestion.id.toLowerCase());
                });
            }
            if (_this.props.handleFilterSuggestions) return _this.props.handleFilterSuggestions(query, suggestions);
            var exactSuggestions = suggestions.filter(function(item) {
                return _this.getQueryIndex(query, item) === 0;
            });
            var partialSuggestions = suggestions.filter(function(item) {
                return _this.getQueryIndex(query, item) > 0;
            });
            return exactSuggestions.concat(partialSuggestions);
        });
        $5543cf8485380abc$var$_defineProperty($5543cf8485380abc$var$_assertThisInitialized(_this), "getQueryIndex", function(query, item) {
            return item[_this.props.labelField].toLowerCase().indexOf(query.toLowerCase());
        });
        $5543cf8485380abc$var$_defineProperty($5543cf8485380abc$var$_assertThisInitialized(_this), "resetAndFocusInput", function() {
            _this.setState({
                query: ""
            });
            if (_this.textInput) {
                _this.textInput.value = "";
                _this.textInput.focus();
            }
        });
        $5543cf8485380abc$var$_defineProperty($5543cf8485380abc$var$_assertThisInitialized(_this), "updateSuggestions", function() {
            var _this$state = _this.state, query = _this$state.query, selectedIndex = _this$state.selectedIndex;
            var suggestions = _this.filteredSuggestions(query);
            _this.setState({
                suggestions: suggestions,
                selectedIndex: selectedIndex >= suggestions.length ? suggestions.length - 1 : selectedIndex
            });
        });
        $5543cf8485380abc$var$_defineProperty($5543cf8485380abc$var$_assertThisInitialized(_this), "addTag", function(tag) {
            var _this$props = _this.props, tags = _this$props.tags, labelField = _this$props.labelField, allowUnique = _this$props.allowUnique;
            var currentEditIndex = _this.state.currentEditIndex;
            if (!tag.id || !tag[labelField]) return;
            if (currentEditIndex === -1) {
                if (_this.tagLimitReached()) {
                    _this.setState({
                        error: $g21To.ERRORS.TAG_LIMIT
                    });
                    _this.resetAndFocusInput();
                    return;
                }
                _this.setState({
                    error: ""
                });
            }
            var existingKeys = tags.map(function(tag) {
                return tag.id.toLowerCase();
            });
            // Return if tag has been already added
            if (allowUnique && existingKeys.indexOf(tag.id.trim().toLowerCase()) >= 0) return;
            if (_this.props.autocomplete) {
                var possibleMatches = _this.filteredSuggestions(tag[labelField]);
                if (_this.props.autocomplete === 1 && possibleMatches.length === 1 || _this.props.autocomplete === true && possibleMatches.length) tag = possibleMatches[0];
            }
            // call method to add
            if (currentEditIndex !== -1 && _this.props.onTagUpdate) _this.props.onTagUpdate(currentEditIndex, tag);
            else _this.props.handleAddition(tag);
            // reset the state
            _this.setState({
                query: "",
                selectionMode: false,
                selectedIndex: -1,
                currentEditIndex: -1
            });
            _this.resetAndFocusInput();
        });
        $5543cf8485380abc$var$_defineProperty($5543cf8485380abc$var$_assertThisInitialized(_this), "clearAll", function() {
            if (_this.props.onClearAll) _this.props.onClearAll();
            _this.setState({
                error: ""
            });
        });
        $5543cf8485380abc$var$_defineProperty($5543cf8485380abc$var$_assertThisInitialized(_this), "getTagItems", function() {
            var _this$props2 = _this.props, tags = _this$props2.tags, labelField = _this$props2.labelField, removeComponent = _this$props2.removeComponent, readOnly = _this$props2.readOnly, allowDragDrop = _this$props2.allowDragDrop;
            var classNames = $5543cf8485380abc$var$_objectSpread($5543cf8485380abc$var$_objectSpread({}, $g21To.DEFAULT_CLASSNAMES), _this.props.classNames);
            var _this$state2 = _this.state, currentEditIndex = _this$state2.currentEditIndex, query = _this$state2.query;
            var moveTag = allowDragDrop ? _this.moveTag : null;
            return tags.map(function(tag, index) {
                return /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement($5543cf8485380abc$var$_react["default"].Fragment, {
                    key: index
                }, currentEditIndex === index ? /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement("div", {
                    className: classNames.editTagInput
                }, /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement("input", {
                    ref: function ref(input) {
                        _this.tagInput = input;
                    },
                    onFocus: _this.handleFocus,
                    value: query,
                    onChange: _this.handleChange,
                    onKeyDown: _this.handleKeyDown,
                    onBlur: _this.handleBlur,
                    className: classNames.editTagInputField,
                    onPaste: _this.handlePaste,
                    "data-testid": "tag-edit"
                })) : /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement($5543cf8485380abc$var$_Tag["default"], {
                    index: index,
                    tag: tag,
                    labelField: labelField,
                    onDelete: _this.handleDelete.bind($5543cf8485380abc$var$_assertThisInitialized(_this), index),
                    moveTag: moveTag,
                    removeComponent: removeComponent,
                    onTagClicked: _this.handleTagClick.bind($5543cf8485380abc$var$_assertThisInitialized(_this), index, tag),
                    readOnly: readOnly,
                    classNames: classNames,
                    allowDragDrop: allowDragDrop
                }));
            });
        });
        if (!props.inline) /* eslint-disable no-console */ console.warn("[Deprecation] The inline attribute is deprecated and will be removed in v7.x.x, please use inputFieldPosition instead.");
        var _suggestions = props.suggestions;
        _this.state = {
            suggestions: _suggestions,
            query: "",
            isFocused: false,
            selectedIndex: -1,
            selectionMode: false,
            ariaLiveStatus: "",
            currentEditIndex: -1,
            error: ""
        };
        _this.reactTagsRef = /*#__PURE__*/ (0, $5543cf8485380abc$var$_react.createRef)();
        _this.handleFocus = _this.handleFocus.bind($5543cf8485380abc$var$_assertThisInitialized(_this));
        _this.handleBlur = _this.handleBlur.bind($5543cf8485380abc$var$_assertThisInitialized(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind($5543cf8485380abc$var$_assertThisInitialized(_this));
        _this.handleChange = _this.handleChange.bind($5543cf8485380abc$var$_assertThisInitialized(_this));
        _this.moveTag = _this.moveTag.bind($5543cf8485380abc$var$_assertThisInitialized(_this));
        _this.handlePaste = _this.handlePaste.bind($5543cf8485380abc$var$_assertThisInitialized(_this));
        _this.handleSuggestionHover = _this.handleSuggestionHover.bind($5543cf8485380abc$var$_assertThisInitialized(_this));
        _this.handleSuggestionClick = _this.handleSuggestionClick.bind($5543cf8485380abc$var$_assertThisInitialized(_this));
        return _this;
    }
    $5543cf8485380abc$var$_createClass(ReactTags, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props3 = this.props, autofocus = _this$props3.autofocus, readOnly = _this$props3.readOnly;
                if (autofocus && !readOnly) this.resetAndFocusInput();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!(0, $5543cf8485380abc$var$_isEqual["default"])(prevProps.suggestions, this.props.suggestions)) this.updateSuggestions();
            }
        },
        {
            key: "handleDelete",
            value: function handleDelete(index, event) {
                event.preventDefault();
                event.stopPropagation();
                var currentTags = this.props.tags.slice();
                // Early exit from the function if the array
                // is already empty
                if (currentTags.length === 0) return;
                this.setState({
                    error: ""
                });
                var ariaLiveStatus = "Tag at index ".concat(index, " with value ").concat(currentTags[index].id, " deleted.");
                this.props.handleDelete(index, event);
                var allTags = this.reactTagsRef.current.querySelectorAll(".ReactTags__remove");
                var nextElementToFocus, nextIndex, nextTag;
                if (index === 0 && currentTags.length > 1) {
                    nextElementToFocus = allTags[0];
                    nextIndex = 0;
                    nextTag = currentTags[1];
                } else {
                    nextElementToFocus = allTags[index - 1];
                    nextIndex = index - 1;
                    nextTag = currentTags[nextIndex];
                }
                if (!nextElementToFocus) {
                    nextIndex = -1;
                    nextElementToFocus = this.textInput;
                }
                if (nextIndex >= 0) ariaLiveStatus += " Tag at index ".concat(nextIndex, " with value ").concat(nextTag.id, " focussed. Press backspace to remove");
                else ariaLiveStatus += "Input focussed. Press enter to add a new tag";
                nextElementToFocus.focus();
                this.setState({
                    ariaLiveStatus: ariaLiveStatus
                });
            }
        },
        {
            key: "handleTagClick",
            value: function handleTagClick(i, tag, e) {
                var _this2 = this;
                var _this$props4 = this.props, editable = _this$props4.editable, handleTagClick = _this$props4.handleTagClick, labelField = _this$props4.labelField;
                if (editable) this.setState({
                    currentEditIndex: i,
                    query: tag[labelField]
                }, function() {
                    _this2.tagInput.focus();
                });
                if (handleTagClick) handleTagClick(i, e);
            }
        },
        {
            key: "handleChange",
            value: function handleChange(e) {
                if (this.props.handleInputChange) this.props.handleInputChange(e.target.value, e);
                var query = e.target.value.trim();
                this.setState({
                    query: query
                }, this.updateSuggestions);
            }
        },
        {
            key: "handleFocus",
            value: function handleFocus(event) {
                var value = event.target.value;
                if (this.props.handleInputFocus) this.props.handleInputFocus(value, event);
                this.setState({
                    isFocused: true
                });
            }
        },
        {
            key: "handleBlur",
            value: function handleBlur(event) {
                var value = event.target.value;
                if (this.props.handleInputBlur) {
                    this.props.handleInputBlur(value, event);
                    if (this.textInput) this.textInput.value = "";
                }
                this.setState({
                    isFocused: false,
                    currentEditIndex: -1
                });
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(e) {
                var _this$state3 = this.state, query = _this$state3.query, selectedIndex = _this$state3.selectedIndex, suggestions = _this$state3.suggestions, selectionMode = _this$state3.selectionMode;
                // hide suggestions menu on escape
                if (e.keyCode === $g21To.KEYS.ESCAPE) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.setState({
                        selectedIndex: -1,
                        selectionMode: false,
                        suggestions: [],
                        currentEditIndex: -1
                    });
                }
                // When one of the terminating keys is pressed, add current query to the tags.
                // If no text is typed in so far, ignore the action - so we don't end up with a terminating
                // character typed in.
                if (this.props.delimiters.indexOf(e.keyCode) !== -1 && !e.shiftKey) {
                    if (e.keyCode !== $g21To.KEYS.TAB || query !== "") e.preventDefault();
                    var selectedQuery = selectionMode && selectedIndex !== -1 ? suggestions[selectedIndex] : $5543cf8485380abc$var$_defineProperty({
                        id: query.trim()
                    }, this.props.labelField, query.trim());
                    if (Object.keys(selectedQuery)) this.addTag(selectedQuery);
                }
                // when backspace key is pressed and query is blank, delete tag
                if (e.keyCode === $g21To.KEYS.BACKSPACE && query === "" && this.props.allowDeleteFromEmptyInput) this.handleDelete(this.props.tags.length - 1, e);
                // up arrow
                if (e.keyCode === $g21To.KEYS.UP_ARROW) {
                    e.preventDefault();
                    this.setState({
                        selectedIndex: selectedIndex <= 0 ? suggestions.length - 1 : selectedIndex - 1,
                        selectionMode: true
                    });
                }
                // down arrow
                if (e.keyCode === $g21To.KEYS.DOWN_ARROW) {
                    e.preventDefault();
                    this.setState({
                        selectedIndex: suggestions.length === 0 ? -1 : (selectedIndex + 1) % suggestions.length,
                        selectionMode: true
                    });
                }
            }
        },
        {
            key: "tagLimitReached",
            value: function tagLimitReached() {
                var _this$props5 = this.props, tags = _this$props5.tags, maxTags = _this$props5.maxTags;
                return maxTags && tags.length >= maxTags;
            }
        },
        {
            key: "handlePaste",
            value: function handlePaste(e) {
                var _this3 = this;
                if (!this.props.allowAdditionFromPaste) return;
                if (this.tagLimitReached()) {
                    this.setState({
                        error: $g21To.ERRORS.TAG_LIMIT
                    });
                    this.resetAndFocusInput();
                    return;
                }
                this.setState({
                    error: ""
                });
                e.preventDefault();
                var clipboardData = e.clipboardData || window.clipboardData;
                var clipboardText = clipboardData.getData("text");
                var _this$props$maxLength = this.props.maxLength, maxLength = _this$props$maxLength === void 0 ? clipboardText.length : _this$props$maxLength;
                var maxTextLength = Math.min(maxLength, clipboardText.length);
                var pastedText = clipboardData.getData("text").substr(0, maxTextLength);
                // Used to determine how the pasted content is split.
                var delimiterRegExp = (0, $iWuDm.buildRegExpFromDelimiters)(this.props.delimiters);
                var tags = pastedText.split(delimiterRegExp).map(function(tag) {
                    return tag.trim();
                });
                // Only add unique tags
                (0, $5543cf8485380abc$var$_uniq["default"])(tags).forEach(function(tag) {
                    return _this3.addTag($5543cf8485380abc$var$_defineProperty({
                        id: tag.trim()
                    }, _this3.props.labelField, tag.trim()));
                });
            }
        },
        {
            key: "handleSuggestionClick",
            value: function handleSuggestionClick(i) {
                this.addTag(this.state.suggestions[i]);
            }
        },
        {
            key: "handleSuggestionHover",
            value: function handleSuggestionHover(i) {
                this.setState({
                    selectedIndex: i,
                    selectionMode: true
                });
            }
        },
        {
            key: "moveTag",
            value: function moveTag(dragIndex, hoverIndex) {
                var tags = this.props.tags;
                // locate tags
                var dragTag = tags[dragIndex];
                // call handler with the index of the dragged tag
                // and the tag that is hovered
                this.props.handleDrag(dragTag, dragIndex, hoverIndex);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var tagItems = this.getTagItems();
                var classNames = $5543cf8485380abc$var$_objectSpread($5543cf8485380abc$var$_objectSpread({}, $g21To.DEFAULT_CLASSNAMES), this.props.classNames);
                // get the suggestions for the given query
                var query = this.state.query.trim(), selectedIndex = this.state.selectedIndex, suggestions = this.state.suggestions, error = this.state.error;
                var _this$props6 = this.props, placeholder = _this$props6.placeholder, inputName = _this$props6.name, inputId = _this$props6.id, maxLength = _this$props6.maxLength, inline = _this$props6.inline, inputFieldPosition = _this$props6.inputFieldPosition, inputValue = _this$props6.inputValue, inputProps = _this$props6.inputProps, clearAll = _this$props6.clearAll, tags = _this$props6.tags;
                var position = !inline ? $g21To.INPUT_FIELD_POSITIONS.BOTTOM : inputFieldPosition;
                var tagInput = !this.props.readOnly ? /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement("div", {
                    className: classNames.tagInput
                }, /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement("input", $5543cf8485380abc$var$_extends({}, inputProps, {
                    ref: function ref(input) {
                        _this4.textInput = input;
                    },
                    className: classNames.tagInputField,
                    type: "text",
                    placeholder: placeholder,
                    "aria-label": placeholder,
                    onFocus: this.handleFocus,
                    onBlur: this.handleBlur,
                    onChange: this.handleChange,
                    onKeyDown: this.handleKeyDown,
                    onPaste: this.handlePaste,
                    name: inputName,
                    id: inputId,
                    maxLength: maxLength,
                    value: inputValue,
                    "data-automation": "input",
                    "data-testid": "input"
                })), /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement($5543cf8485380abc$var$_Suggestions["default"], {
                    query: query,
                    suggestions: suggestions,
                    labelField: this.props.labelField,
                    selectedIndex: selectedIndex,
                    handleClick: this.handleSuggestionClick,
                    handleHover: this.handleSuggestionHover,
                    minQueryLength: this.props.minQueryLength,
                    shouldRenderSuggestions: this.props.shouldRenderSuggestions,
                    isFocused: this.state.isFocused,
                    classNames: classNames,
                    renderSuggestion: this.props.renderSuggestion
                }), clearAll && tags.length > 0 && /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement($5543cf8485380abc$var$_ClearAllTags["default"], {
                    classNames: classNames,
                    onClick: this.clearAll
                }), error && /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement("div", {
                    "data-testid": "error",
                    className: "ReactTags__error"
                }, /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512",
                    height: "24",
                    width: "24",
                    fill: "#e03131"
                }, /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement("path", {
                    d: "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                })), error)) : null;
                return /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement("div", {
                    className: (0, $5543cf8485380abc$var$_classnames["default"])(classNames.tags, "react-tags-wrapper"),
                    ref: this.reactTagsRef
                }, /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement("p", {
                    role: "alert",
                    className: "sr-only",
                    style: {
                        position: "absolute",
                        overflow: "hidden",
                        clip: "rect(0 0 0 0)",
                        margin: "-1px",
                        padding: 0,
                        width: "1px",
                        height: "1px",
                        border: 0
                    }
                }, this.state.ariaLiveStatus), position === $g21To.INPUT_FIELD_POSITIONS.TOP && tagInput, /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement("div", {
                    className: classNames.selected
                }, tagItems, position === $g21To.INPUT_FIELD_POSITIONS.INLINE && tagInput), position === $g21To.INPUT_FIELD_POSITIONS.BOTTOM && tagInput);
            }
        }
    ]);
    return ReactTags;
}($5543cf8485380abc$var$_react.Component);
$5543cf8485380abc$var$_defineProperty($5543cf8485380abc$var$ReactTags, "propTypes", {
    placeholder: $5543cf8485380abc$var$_propTypes["default"].string,
    labelField: $5543cf8485380abc$var$_propTypes["default"].string,
    suggestions: $5543cf8485380abc$var$_propTypes["default"].arrayOf($5543cf8485380abc$var$_propTypes["default"].shape({
        id: $5543cf8485380abc$var$_propTypes["default"].string.isRequired
    })),
    delimiters: $5543cf8485380abc$var$_propTypes["default"].arrayOf($5543cf8485380abc$var$_propTypes["default"].number),
    autofocus: $5543cf8485380abc$var$_propTypes["default"].bool,
    inline: $5543cf8485380abc$var$_propTypes["default"].bool,
    // TODO: Remove in v7.x.x
    inputFieldPosition: $5543cf8485380abc$var$_propTypes["default"].oneOf([
        $g21To.INPUT_FIELD_POSITIONS.INLINE,
        $g21To.INPUT_FIELD_POSITIONS.TOP,
        $g21To.INPUT_FIELD_POSITIONS.BOTTOM
    ]),
    handleDelete: $5543cf8485380abc$var$_propTypes["default"].func,
    handleAddition: $5543cf8485380abc$var$_propTypes["default"].func,
    onTagUpdate: $5543cf8485380abc$var$_propTypes["default"].func,
    handleDrag: $5543cf8485380abc$var$_propTypes["default"].func,
    handleFilterSuggestions: $5543cf8485380abc$var$_propTypes["default"].func,
    handleTagClick: $5543cf8485380abc$var$_propTypes["default"].func,
    allowDeleteFromEmptyInput: $5543cf8485380abc$var$_propTypes["default"].bool,
    allowAdditionFromPaste: $5543cf8485380abc$var$_propTypes["default"].bool,
    allowDragDrop: $5543cf8485380abc$var$_propTypes["default"].bool,
    handleInputChange: $5543cf8485380abc$var$_propTypes["default"].func,
    handleInputFocus: $5543cf8485380abc$var$_propTypes["default"].func,
    handleInputBlur: $5543cf8485380abc$var$_propTypes["default"].func,
    minQueryLength: $5543cf8485380abc$var$_propTypes["default"].number,
    shouldRenderSuggestions: $5543cf8485380abc$var$_propTypes["default"].func,
    removeComponent: $5543cf8485380abc$var$_propTypes["default"].func,
    autocomplete: $5543cf8485380abc$var$_propTypes["default"].oneOfType([
        $5543cf8485380abc$var$_propTypes["default"].bool,
        $5543cf8485380abc$var$_propTypes["default"].number
    ]),
    readOnly: $5543cf8485380abc$var$_propTypes["default"].bool,
    classNames: $5543cf8485380abc$var$_propTypes["default"].object,
    name: $5543cf8485380abc$var$_propTypes["default"].string,
    id: $5543cf8485380abc$var$_propTypes["default"].string,
    maxLength: $5543cf8485380abc$var$_propTypes["default"].number,
    inputValue: $5543cf8485380abc$var$_propTypes["default"].string,
    maxTags: $5543cf8485380abc$var$_propTypes["default"].number,
    tags: $5543cf8485380abc$var$_propTypes["default"].arrayOf($5543cf8485380abc$var$_propTypes["default"].shape({
        id: $5543cf8485380abc$var$_propTypes["default"].string.isRequired,
        className: $5543cf8485380abc$var$_propTypes["default"].string
    })),
    allowUnique: $5543cf8485380abc$var$_propTypes["default"].bool,
    renderSuggestion: $5543cf8485380abc$var$_propTypes["default"].func,
    inputProps: $5543cf8485380abc$var$_propTypes["default"].object,
    editable: $5543cf8485380abc$var$_propTypes["default"].bool,
    clearAll: $5543cf8485380abc$var$_propTypes["default"].bool,
    onClearAll: $5543cf8485380abc$var$_propTypes["default"].func
});
$5543cf8485380abc$var$_defineProperty($5543cf8485380abc$var$ReactTags, "defaultProps", {
    placeholder: $g21To.DEFAULT_PLACEHOLDER,
    labelField: $g21To.DEFAULT_LABEL_FIELD,
    suggestions: [],
    delimiters: [].concat($5543cf8485380abc$var$_toConsumableArray($g21To.KEYS.ENTER), [
        $g21To.KEYS.TAB
    ]),
    autofocus: true,
    inline: true,
    // TODO: Remove in v7.x.x
    inputFieldPosition: $g21To.INPUT_FIELD_POSITIONS.INLINE,
    handleDelete: $5543cf8485380abc$var$_noop["default"],
    handleAddition: $5543cf8485380abc$var$_noop["default"],
    allowDeleteFromEmptyInput: true,
    allowAdditionFromPaste: true,
    autocomplete: false,
    readOnly: false,
    allowUnique: true,
    allowDragDrop: true,
    tags: [],
    inputProps: {},
    onTagUpdate: $5543cf8485380abc$var$_noop["default"],
    editable: false,
    clearAll: false,
    handleClearAll: $5543cf8485380abc$var$_noop["default"]
});
var $5543cf8485380abc$var$WithContext = $5543cf8485380abc$exports.WithContext = function WithContext(_ref2) {
    var props = $5543cf8485380abc$var$_extends({}, ($5543cf8485380abc$var$_objectDestructuringEmpty(_ref2), _ref2));
    return /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement($3c3cb22ca9922807$export$9861489d68213f9c, {
        backend: $ecb76deb45df5e3c$export$f4f61d779bb20744
    }, /*#__PURE__*/ $5543cf8485380abc$var$_react["default"].createElement($5543cf8485380abc$var$ReactTags, props));
};





const $2dbf729c7933bb1a$var$KeyCodes = {
    comma: 188,
    enter: 13,
    space: 32
};
const $2dbf729c7933bb1a$var$delimiters = [
    $2dbf729c7933bb1a$var$KeyCodes.comma,
    $2dbf729c7933bb1a$var$KeyCodes.enter,
    $2dbf729c7933bb1a$var$KeyCodes.space
];
const $2dbf729c7933bb1a$var$KeywordsEditor = ({ keywords: keywords, onChange: onChange })=>{
    const { t: tCategories } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("categories");
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("default");
    const tags = keywords.map((k)=>({
            id: k,
            text: tCategories(k)
        }));
    const handleDelete = (i)=>{
        onChange((0, $45977b49cf6e2fbf$export$2e2bcd8739ae039)(keywords.filter((k, index)=>index !== i)));
    };
    const handleAddition = (tag)=>{
        onChange((0, $45977b49cf6e2fbf$export$2e2bcd8739ae039)([
            ...keywords,
            tag.id
        ]));
    };
    const handleDrag = (tag, currentPosition, newPosition)=>{
        const newKeywords = [
            ...keywords
        ];
        newKeywords.splice(currentPosition, 1);
        newKeywords.splice(newPosition, 0, tag.text);
        onChange(newKeywords);
    };
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5543cf8485380abc$exports.WithContext), {
        tags: tags,
        delimiters: $2dbf729c7933bb1a$var$delimiters,
        inputFieldPosition: "inline",
        handleDelete: handleDelete,
        handleAddition: handleAddition,
        handleDrag: handleDrag,
        inline: true,
        id: "keywords",
        classNames: {
            selected: "flex flex-row items-start flex-wrap",
            tag: "p-0.25 px-1 my-1.5 mx-1 rounded font-medium bg-indigo-100 text-indigo-800",
            tagInput: "border-0 overflow-none flex-1 min-w-[100px]",
            tagInputField: "border border-gray-300  overflow-none focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-black focus:border-black shadow-sm rounded-md w-full p-1.5",
            remove: "ml-0.5",
            suggestions: "absolute rounded mt-2 p-1 font-medium bg-red-100 text-red-800",
            activeSuggestion: "bg-red-200 cursor-pointer"
        },
        allowDragDrop: true,
        placeholder: t("_Press enter to add a keyword"),
        autofocus: false,
        suggestions: (0, $123d6e77c3059d22$export$2e2bcd8739ae039).map((c)=>({
                id: c.name,
                text: tCategories(c.name)
            }))
    });
};
var $2dbf729c7933bb1a$export$2e2bcd8739ae039 = $2dbf729c7933bb1a$var$KeywordsEditor;


const $70d7764424ac4ddf$var$RecipeEditor = /*#__PURE__*/ (0, $3QbnI.forwardRef)(({ recipe: recipe, onChange: onChange, children: children }, ref)=>{
    const [isUploading, setIsUploading] = (0, $3QbnI.useState)(false);
    const uploadRef = (0, $3QbnI.useRef)(null);
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const change = (props)=>onChange({
            ...recipe,
            ...props
        });
    // const changeStats = (props: any) => onChange({ ...recipe, stats: { ...recipe.stats, [] } })
    const changeImageUrl = async (file)=>{
        setIsUploading(true);
        const imageUrl = await (0, $e4ee9ee9945bfcc1$export$58b3679c46e6370d)(file);
        change({
            imageUrl: imageUrl
        });
        setIsUploading(false);
    };
    const { name: name, ingredients: ingredients, steps: steps, keywords: keywords, imageUrl: imageUrl } = recipe;
    // const DurationIcon = findUnitIcon('min')
    // const ServingsIcon = findUnitIcon('servings')
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $c17029512d70ed45$export$2e2bcd8739ae039), {
                imageUrl: imageUrl,
                alt: name
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "h-64 md:h-96 absolute top-0 left-0 right-0 flex",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f558be7202437921$export$2e2bcd8739ae039), {
                    ref: uploadRef,
                    onChange: changeImageUrl,
                    isUploading: isUploading,
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Icon, {
                        blur: true,
                        onClick: ()=>uploadRef.current?.click(),
                        icon: (0, $7d7d40110bedef52$export$2e2bcd8739ae039),
                        children: t("_Change image")
                    })
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
                className: "bg-white",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $462140c0f3a53058$export$2e2bcd8739ae039), {
                    className: "p-4 relative top-[-7rem]",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "max-w-screen-md m-auto sm:p-6 space-y-8",
                        ref: ref,
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b812009e1783c3da$export$2e2bcd8739ae039).Primary, {
                                className: "text-2xl sm:text-3xl font-bold leading-7 text-gray-900 w-full",
                                id: "recipe-name",
                                rows: 1,
                                placeholder: t("_Recipe Name [required]"),
                                value: name,
                                onChange: (name)=>change({
                                        name: name.replace(/\n/g, "")
                                    })
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $3730ae85ea413570$export$2e2bcd8739ae039), {
                                        className: "pb-3",
                                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("label", {
                                            htmlFor: "ingredients",
                                            children: t("_Ingredients")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b812009e1783c3da$export$2e2bcd8739ae039).Primary, {
                                        className: "mt-1 w-full resize-none",
                                        id: "ingredients",
                                        rows: 5,
                                        placeholder: t("editor.Add ingredients there"),
                                        value: ingredients,
                                        onChange: (ingredients)=>change({
                                                ingredients: ingredients
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $3730ae85ea413570$export$2e2bcd8739ae039), {
                                        className: "pb-3",
                                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("label", {
                                            htmlFor: "steps",
                                            children: t("_Steps")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b812009e1783c3da$export$2e2bcd8739ae039).Primary, {
                                        className: "mt-1 w-full resize-none",
                                        id: "steps",
                                        rows: 5,
                                        placeholder: t("editor.Add steps there"),
                                        value: steps,
                                        onChange: (steps)=>change({
                                                steps: steps
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $3730ae85ea413570$export$2e2bcd8739ae039), {
                                        className: "pb-3",
                                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("label", {
                                            htmlFor: "keywords",
                                            children: t("_Categories")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $2dbf729c7933bb1a$export$2e2bcd8739ae039), {
                                        keywords: keywords,
                                        onChange: (keywords)=>change({
                                                keywords: keywords
                                            })
                                    })
                                ]
                            }),
                            children
                        ]
                    })
                })
            })
        ]
    });
});
var $70d7764424ac4ddf$export$2e2bcd8739ae039 = $70d7764424ac4ddf$var$RecipeEditor;





var $3b068fd6f0e6fd5c$export$cbbc350c1dfc80cb;
(function(Stat) {
    Stat[Stat["Duration"] = 0] = "Duration";
    Stat[Stat["Servings"] = 1] = "Servings";
})($3b068fd6f0e6fd5c$export$cbbc350c1dfc80cb || ($3b068fd6f0e6fd5c$export$cbbc350c1dfc80cb = {}));
const $3b068fd6f0e6fd5c$export$b95174cb9475c373 = ()=>({
        id: (0, $d827eaefca5d884a$export$2e2bcd8739ae039)(),
        name: "",
        keywords: [],
        imageUrl: "https://images.unsplash.com/photo-1601740982034-56bc80e986ee",
        stats: {},
        ingredients: "",
        steps: "",
        createdAt: null,
        updatedAt: null
    });









const $e61b4da0b1450a33$var$DeleteConfirmation = ({ open: open, onClose: onClose, onSubmit: onSubmit })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        icon: (0, $21534527083f74ba$export$2e2bcd8739ae039),
        type: (0, $b9c536326972e77d$export$9656cfe2bd6e411f).Warning,
        description: t("_If you leave"),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).White, {
                className: "mb-3 w-full",
                onClick: onClose,
                children: t("_Cancel")
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Black, {
                className: "mb-3 w-full",
                onClick: onSubmit,
                children: t("_Lose my recipe")
            })
        ]
    });
};
var $e61b4da0b1450a33$export$2e2bcd8739ae039 = $e61b4da0b1450a33$var$DeleteConfirmation;





const $a8da142c449c374a$var$RecipeNew = ()=>{
    const [recipe, setRecipe] = (0, $3QbnI.useState)((0, $3b068fd6f0e6fd5c$export$b95174cb9475c373)());
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    const save = async ()=>{
        if (disabled) return;
        try {
            const newRecipe = await dispatch((0, $87c50e51b43ee465$export$b49cb8e3052514a2)(recipe)).unwrap();
            navigate(`/recipes/${newRecipe.id}`, {
                replace: true
            });
        } catch (error) {
            console.error("error", error);
        }
    };
    const deleteConfirmationPopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const disabled = recipe.name.length === 0;
    const ref = (0, $3QbnI.useRef)(null);
    const confirmLosing = ()=>{
        navigate(-1);
    };
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("beforeunload", (event)=>{
        if (!disabled) {
            (event || window.event).returnValue = t("_If you leave");
            return t("_If you leave");
        }
    });
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e91e729a6066c3b7$export$2e2bcd8739ae039), {
        title: t("_Create Recipe"),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $70d7764424ac4ddf$export$2e2bcd8739ae039), {
                recipe: recipe,
                onChange: setRecipe,
                ref: ref,
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary, {
                        onClick: save,
                        disabled: disabled,
                        children: t("_Save new recipe")
                    })
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a3758683e16a4079$export$2e2bcd8739ae039), {
                restRef: ref,
                children: (isMaximized)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $4bf72665163a8648$export$2e2bcd8739ae039), {
                        white: isMaximized,
                        children: [
                            disabled ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $525000a460d770e0$export$2e2bcd8739ae039), {
                                url: "/recipes",
                                title: t("_Back to recipes")
                            }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Icon, {
                                icon: (0, $e63129eb30406fce$export$2e2bcd8739ae039),
                                title: t("_Back to recipes"),
                                onClick: deleteConfirmationPopup.open
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "flex-1"
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e61b4da0b1450a33$export$2e2bcd8739ae039), {
                open: deleteConfirmationPopup.isOpen,
                onClose: deleteConfirmationPopup.close,
                onSubmit: confirmLosing
            })
        ]
    });
};
var $a8da142c449c374a$export$2e2bcd8739ae039 = $a8da142c449c374a$var$RecipeNew;




var $3QbnI = parcelRequire("3QbnI");


var $3QbnI = parcelRequire("3QbnI");
function $438ad95cc8edf5a0$var$DocumentDuplicateIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
    }));
}
const $438ad95cc8edf5a0$var$ForwardRef = $3QbnI.forwardRef($438ad95cc8edf5a0$var$DocumentDuplicateIcon);
var $438ad95cc8edf5a0$export$2e2bcd8739ae039 = $438ad95cc8edf5a0$var$ForwardRef;


var $3QbnI = parcelRequire("3QbnI");
function $08f3ecba2f0fd157$var$TrashIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    }));
}
const $08f3ecba2f0fd157$var$ForwardRef = $3QbnI.forwardRef($08f3ecba2f0fd157$var$TrashIcon);
var $08f3ecba2f0fd157$export$2e2bcd8739ae039 = $08f3ecba2f0fd157$var$ForwardRef;










const $a6ec92baa3f5f222$var$Saved = ({ className: className })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("inline-flex items-center rounded-full bg-yellow-100 px-3 py-0.5 text-sm font-medium text-yellow-800", className),
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("svg", {
                className: "-ml-1 mr-1.5 h-2 w-2 text-yellow-800",
                fill: "currentColor",
                viewBox: "0 0 8 8",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("circle", {
                    cx: "4",
                    cy: "4",
                    r: "3"
                })
            }),
            t("_Saving")
        ]
    });
};
var $a6ec92baa3f5f222$export$2e2bcd8739ae039 = $a6ec92baa3f5f222$var$Saved;










const $7b57ba433cd039bb$var$duplicateName = (name)=>{
    const match = name.match(/(.*?)([0-9]+)/);
    return match ? `${match[1]}${parseInt(match[2], 10) + 1}` : `${name} 2`;
};
var $7b57ba433cd039bb$export$2e2bcd8739ae039 = $7b57ba433cd039bb$var$duplicateName;


const $054b6ff01c922037$var$RecipeEdit = ()=>{
    const { recipeId: recipeId } = (0, $e724dc7e3b3eec8a$export$99eaa27ddbbb95ef)();
    const savedRecipe = (0, $67ed7bda3729d158$export$a7347740d65f620b)((state)=>(0, $87c50e51b43ee465$export$d3bef8d36f4e0ca4)(state, recipeId));
    const areFetched = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $87c50e51b43ee465$export$c341f62fd7d1eec8));
    const [recipe, setRecipe] = (0, $3QbnI.useState)(savedRecipe);
    const [saved, setSaved] = (0, $3QbnI.useState)(true);
    const [savedAtLeastOnce, setSavedAtLeastOnce] = (0, $3QbnI.useState)(false);
    (0, $3QbnI.useEffect)(()=>{
        if (!recipe?.name) setRecipe(savedRecipe);
    }, [
        savedRecipe,
        recipe?.name
    ]);
    (0, $3QbnI.useEffect)(()=>{
        if (savedRecipe) setRecipe(savedRecipe);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recipeId
    ]);
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const timeout = (0, $3QbnI.useRef)(undefined);
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    const ref = (0, $3QbnI.useRef)(null);
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    if (!recipe || !savedRecipe) {
        if (!areFetched) return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b11190345c4c4e48$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5daa306c145fc294$export$2e2bcd8739ae039), {});
    }
    const saveDebounced = (newRecipe)=>{
        clearInterval(timeout.current);
        setSaved(false);
        setRecipe(newRecipe);
        timeout.current = setTimeout(()=>{
            if (newRecipe) try {
                dispatch((0, $87c50e51b43ee465$export$ce41afa5774ede8f)(newRecipe)).unwrap();
                setSaved(true);
                setSavedAtLeastOnce(true);
            } catch (error) {
                console.error("error", error);
            }
        }, 2000);
    };
    const requestDeleteRecipe = async ()=>{
        await dispatch((0, $87c50e51b43ee465$export$a4f60186122287ba)(recipe)).unwrap();
        navigate(`/recipes`);
    };
    const duplicate = async ()=>{
        try {
            const newRecipe = await dispatch((0, $87c50e51b43ee465$export$b49cb8e3052514a2)({
                ...recipe,
                name: (0, $7b57ba433cd039bb$export$2e2bcd8739ae039)(recipe.name)
            })).unwrap();
            navigate(`/recipes/${newRecipe.id}/edit`, {
                replace: true
            });
        } catch (error) {
            console.error("error", error);
        }
    };
    const saving = !saved;
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e91e729a6066c3b7$export$2e2bcd8739ae039), {
        title: recipe.name,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $70d7764424ac4ddf$export$2e2bcd8739ae039), {
                ref: ref,
                saved: saved,
                recipe: recipe,
                onChange: saveDebounced,
                children: [
                    savedAtLeastOnce && saved && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "py-10 pt-10 flex flex-col items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                className: "px-2 py-1 rounded font-semibold text-lg bg-teal-100 text-teal-800 flex items-center",
                                children: [
                                    t("editor._Saved"),
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d93e74b6834e15fe$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 ml-2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "pt-2 text-sm font-medium text-gray-500",
                                children: t("editor._No need to save manually. Everything is saved in really time.")
                            })
                        ]
                    }),
                    saving && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                        className: "py-10 pt-10 flex flex-col items-center justify-center",
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                            className: "px-2 py-1 rounded font-semibold text-lg bg-orange-100 text-orange-800 flex items-center",
                            children: t("editor._Saving in progress...")
                        })
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "py-10 pt-20 flex items-center justify-end gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).White, {
                                onClick: duplicate,
                                children: [
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $438ad95cc8edf5a0$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 mr-2",
                                        "aria-hidden": "true"
                                    }),
                                    t("_duplicate recipe")
                                ]
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Black, {
                                onClick: requestDeleteRecipe,
                                children: [
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $08f3ecba2f0fd157$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 mr-2",
                                        "aria-hidden": "true"
                                    }),
                                    t("_delete recipe")
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a3758683e16a4079$export$2e2bcd8739ae039), {
                restRef: ref,
                className: "pointer-events-none",
                children: (isMaximized)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $4bf72665163a8648$export$2e2bcd8739ae039), {
                        white: isMaximized,
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $525000a460d770e0$export$2e2bcd8739ae039), {
                                url: `/recipes/${recipe.id}`,
                                disabled: saving,
                                title: t("_Back to recipe")
                            }),
                            isMaximized ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $6d48233ba4b818b9$export$2e2bcd8739ae039), {
                                recipeName: recipe?.name,
                                keywords: recipe?.keywords,
                                children: saving && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a6ec92baa3f5f222$export$2e2bcd8739ae039), {
                                            className: "ml-5"
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                            className: "flex-1"
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {
                                children: saving && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a6ec92baa3f5f222$export$2e2bcd8739ae039), {
                                            className: "ml-2"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                            className: "flex-1"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
            })
        ]
    });
};
var $054b6ff01c922037$export$2e2bcd8739ae039 = $054b6ff01c922037$var$RecipeEdit;




var $3QbnI = parcelRequire("3QbnI");


var $3QbnI = parcelRequire("3QbnI");
function $7a6819d528babbc5$var$AdjustmentsHorizontalIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
    }));
}
const $7a6819d528babbc5$var$ForwardRef = $3QbnI.forwardRef($7a6819d528babbc5$var$AdjustmentsHorizontalIcon);
var $7a6819d528babbc5$export$2e2bcd8739ae039 = $7a6819d528babbc5$var$ForwardRef;













// import React, { useState } from 'react'
// import { useTranslation } from 'react-i18next'
// import { ShoppingBagIcon, XCircleIcon } from '@heroicons/react/24/outline'





const $6ad284f288c7198f$var$key = (ingredient, index)=>`${ingredient.name}${index}`;
const $6ad284f288c7198f$var$IngredientListFocus = ({ recipe: recipe })=>{
    // const { t } = useTranslation()
    const rawRecipe = (0, $67ed7bda3729d158$export$a7347740d65f620b)((state)=>(0, $87c50e51b43ee465$export$d3bef8d36f4e0ca4)(state, recipe.id));
    if (!rawRecipe) return null;
    const smaller = recipe.ingredients.length > 7;
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("table", {
        className: "min-w-full divide-y divide-gray-300",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("tbody", {
            className: "divide-y divide-gray-200 bg-white",
            children: recipe.ingredients.map((ingredient, index)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("tr", {
                    className: "select-text",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("td", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("whitespace-wrap align-top text-md font-medium text-gray-900 text-right w-20", (0, $e2959a6776dd96f2$export$2e2bcd8739ae039)(ingredient.measure, {
                                explicit: true
                            }).length > 15 ? "whitespace-wrap" : "whitespace-nowrap", smaller ? "py-3" : "py-4"),
                            children: (0, $e2959a6776dd96f2$export$2e2bcd8739ae039)(ingredient.measure, {
                                explicit: true
                            })
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("td", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("px-3 pr-6 align-top text-md text-gray-500 w-60", smaller ? "py-3" : "py-4"),
                            children: ingredient.name
                        })
                    ]
                }, $6ad284f288c7198f$var$key(ingredient, index)))
        })
    });
};
var $6ad284f288c7198f$export$2e2bcd8739ae039 = $6ad284f288c7198f$var$IngredientListFocus;




const $9f448885915d04e1$var$SlidePage = ({ id: id, title: title, children: children })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: "relative w-full h-screen flex items-center snap-center z-10",
        id: id,
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
            className: "flex-1 max-h-screen overflow-y-auto p-4 lg:p-10 py-20",
            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $462140c0f3a53058$export$2e2bcd8739ae039), {
                className: "relative max-w-screen-md m-auto p-5 lg:p-10 z-10",
                children: [
                    title && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h2", {
                        className: "mb-10 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                        className: "text-left",
                        children: children
                    })
                ]
            })
        })
    });
};
var $9f448885915d04e1$export$2e2bcd8739ae039 = $9f448885915d04e1$var$SlidePage;







const $0f446f7ba8e5048c$var$StepFocus = ({ step: step, index: index, ingredients: ingredients, length: length, children: children })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $9f448885915d04e1$export$2e2bcd8739ae039), {
            title: t("focusMode.Step", {
                stepIndex: index + 1,
                stepLength: length
            }),
            id: `step-${index + 1}`,
            children: [
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    className: "text-lg text-gray-900 leading-7",
                    children: step.description
                }),
                ingredients.length > 0 && /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    className: "text-left pt-5",
                    children: ingredients.map((ingredient, index)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f1ff94ed81b306e0$export$2e2bcd8739ae039), {
                            className: "mr-2 mb-2 text-base",
                            ingredient: ingredient
                        }, `${ingredient.name} ${index}`))
                }),
                children
            ]
        })
    });
};
var $0f446f7ba8e5048c$export$2e2bcd8739ae039 = $0f446f7ba8e5048c$var$StepFocus;




var $3QbnI = parcelRequire("3QbnI");
function $fe766d9bd9c25ec8$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m4.5 12.75 6 6 9-13.5"
    }));
}
const $fe766d9bd9c25ec8$var$ForwardRef = $3QbnI.forwardRef($fe766d9bd9c25ec8$var$CheckIcon);
var $fe766d9bd9c25ec8$export$2e2bcd8739ae039 = $fe766d9bd9c25ec8$var$ForwardRef;



var $3QbnI = parcelRequire("3QbnI");




const $d8136a4f471f825e$var$FocusActions = ({ recipe: recipe, index: index, step: step, onNextStepClick: onNextStepClick, speaking: speaking })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    const durations = (0, $3QbnI.useMemo)(()=>step ? (0, $ae9ef906e6d8d3fd$export$2e2bcd8739ae039)(step.description) : [], [
        step
    ]);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: "pt-2 flex flex-row justify-end",
        children: [
            durations.map((duration)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    "data-tip": t("focusMode.Start Timer"),
                    className: "mr-5",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Icon, {
                        className: "rounded-md",
                        icon: (0, $44e1ecd86c845518$export$2e2bcd8739ae039),
                        title: t("focusMode.Start Timer"),
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                            className: "pl-1",
                            children: (0, $bb7f350e3a3a0f1f$export$a2d8d5410f76f0cd)(duration)
                        })
                    })
                }, (0, $bb7f350e3a3a0f1f$export$a2d8d5410f76f0cd)(duration))),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                "data-tip": t("focusMode.Next Step"),
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Icon, {
                    className: "rounded-md !text-white !bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500",
                    onClick: onNextStepClick,
                    icon: (0, $fe766d9bd9c25ec8$export$2e2bcd8739ae039),
                    blur: true,
                    title: t("focusMode.Next Step")
                })
            })
        ]
    });
};
var $d8136a4f471f825e$export$2e2bcd8739ae039 = $d8136a4f471f825e$var$FocusActions;




var $c9b37484e330a3da$exports = {};
"use strict";
function $c9b37484e330a3da$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c9b37484e330a3da$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c9b37484e330a3da$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c9b37484e330a3da$var$_typeof(obj);
}
Object.defineProperty($c9b37484e330a3da$exports, "__esModule", {
    value: true
});
Object.defineProperty($c9b37484e330a3da$exports, "useSpeechRecognition", {
    enumerable: true,
    get: function get() {
        return $c9b37484e330a3da$var$_SpeechRecognition.useSpeechRecognition;
    }
});
$c9b37484e330a3da$exports["default"] = void 0;

var $c9b37484e330a3da$var$_SpeechRecognition = $c9b37484e330a3da$var$_interopRequireWildcard((parcelRequire("9wden")));
function $c9b37484e330a3da$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $c9b37484e330a3da$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $c9b37484e330a3da$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $c9b37484e330a3da$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $c9b37484e330a3da$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $c9b37484e330a3da$var$_default = $c9b37484e330a3da$var$_SpeechRecognition["default"];
$c9b37484e330a3da$exports["default"] = $c9b37484e330a3da$var$_default;





const $7cc6bfc95b9ff78c$var$RecipeFocus = ()=>{
    const [recipe, formattedRecipe] = (0, $0912099e05b0bf2b$export$2e2bcd8739ae039)();
    const areFetched = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $87c50e51b43ee465$export$c341f62fd7d1eec8));
    // const progress = useAppSelector(state => getRecipeProgress(state, recipe?.id))
    // const dispatch = useAppDispatch()
    const ref = (0, $3QbnI.useRef)(null);
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    (0, $3QbnI.useEffect)(()=>{
        return ()=>{
            (0, $894312bca871a60f$export$59fac9bdf8c1da6a)();
        };
    }, []);
    // useEffect(() => {
    //   console.log('transcript', transcript)
    // }, [transcript])
    const location = (0, $e724dc7e3b3eec8a$export$45d76561a5302f2b)();
    const currentStepIndex = location.hash ? parseInt(location.hash.replace(/^#step-/, ""), 10) : 0;
    const [currentStep, setStep] = (0, $3QbnI.useState)(currentStepIndex);
    (0, $3QbnI.useEffect)(()=>{
        const element = document.getElementById(location.hash.replace(/^#/, ""));
        if (element) element.scrollIntoView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    const update = (0, $3QbnI.useCallback)(async (newIndex)=>{
        const element = document.getElementById(`step-${newIndex}`);
        if (element) {
            element.scrollIntoView({
                behavior: "smooth"
            });
            await (0, $894312bca871a60f$export$1d0d101be0e1eace)();
            navigate(`/recipes/${recipe?.id}/focus#step-${newIndex}`);
            setStep(newIndex);
        }
    }, [
        setStep,
        navigate,
        recipe
    ]);
    const maxStepIndex = (formattedRecipe?.steps?.length || 0) + 1;
    const nextStep = (0, $3QbnI.useCallback)(async ()=>{
        console.warn("nextStep", currentStep, maxStepIndex);
        if (currentStep < maxStepIndex) await update(currentStep + 1);
    }, [
        currentStep,
        update,
        maxStepIndex
    ]);
    const previousStep = (0, $3QbnI.useCallback)(async ()=>{
        if (currentStep > 0) await update(currentStep - 1);
    }, [
        currentStep,
        update
    ]);
    const [voiceControlEnabled, setVoiceControlEnable] = (0, $f47422411e27ad9a$export$2e2bcd8739ae039)((0, $cb3b9bf6a0fb48f2$export$5991c89680fe146f), (0, $cb3b9bf6a0fb48f2$export$8659b451a486d08e));
    const [gestureControlEnabled, setGestureControlEnable] = (0, $f47422411e27ad9a$export$2e2bcd8739ae039)((0, $cb3b9bf6a0fb48f2$export$5df00f26df02d21b), (0, $cb3b9bf6a0fb48f2$export$b4f70692e17432c4));
    (0, $3QbnI.useEffect)(()=>{
        if (voiceControlEnabled) (0, (/*@__PURE__*/$parcel$interopDefault($c9b37484e330a3da$exports))).startListening({
            continuous: true
        });
        else (0, (/*@__PURE__*/$parcel$interopDefault($c9b37484e330a3da$exports))).stopListening();
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($c9b37484e330a3da$exports))).stopListening();
        };
    }, [
        voiceControlEnabled
    ]);
    const { transcript: transcript, browserSupportsSpeechRecognition: // listening,
    browserSupportsSpeechRecognition } = (0, $c9b37484e330a3da$exports.useSpeechRecognition)({
        commands: [
            {
                command: "next*",
                callback: ()=>{
                    console.warn("next");
                    nextStep();
                }
            },
            {
                command: "previous*",
                callback: ()=>{
                    previousStep();
                }
            }
        ]
    });
    const description = browserSupportsSpeechRecognition ? "focusMode.Say next to Move to the next step" : "focusMode.Voice recognition not supported by your browser";
    const settingsPopup = (0, $4e9e193b5c2ac11b$export$2e2bcd8739ae039)();
    if (!recipe || !formattedRecipe) {
        if (!areFetched) return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b11190345c4c4e48$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5daa306c145fc294$export$2e2bcd8739ae039), {});
    }
    // const changeRecipeProgress = (index: number) => {
    //   dispatch(setRecipeProgress({ recipeId: recipe.id, index }))
    // }
    const ingredientsBySteps = (0, $c4c4edfd94631c88$export$79fa8b4f990875e0)(formattedRecipe);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e91e729a6066c3b7$export$2e2bcd8739ae039), {
        title: recipe.name,
        className: "snap-both snap-mandatory",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "fixed top-0 left-0 right-0 bottom-0 bg-cover bg-center blur-lg",
                style: {
                    backgroundImage: `url(${formattedRecipe.imageUrl})`
                }
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $9f448885915d04e1$export$2e2bcd8739ae039), {
                id: `step-0`,
                title: t("_Ingredients"),
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $6ad284f288c7198f$export$2e2bcd8739ae039), {
                        recipe: formattedRecipe
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d8136a4f471f825e$export$2e2bcd8739ae039), {
                        index: 0,
                        recipe: recipe,
                        onNextStepClick: nextStep,
                        speaking: Boolean(transcript)
                    })
                ]
            }),
            formattedRecipe.steps.map((step, stepIdx)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $0f446f7ba8e5048c$export$2e2bcd8739ae039), {
                    step: step,
                    length: formattedRecipe.steps.length,
                    index: stepIdx,
                    ingredients: ingredientsBySteps[stepIdx],
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d8136a4f471f825e$export$2e2bcd8739ae039), {
                        index: stepIdx + 1,
                        recipe: recipe,
                        step: step,
                        onNextStepClick: nextStep,
                        speaking: Boolean(transcript)
                    })
                }, `${step.description} ${stepIdx}`)),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $9f448885915d04e1$export$2e2bcd8739ae039), {
                id: `step-${maxStepIndex}`,
                title: t("focusMode.Enjoy your meal"),
                children: t("focusMode.And remember to take photos")
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
                open: settingsPopup.isOpen,
                onClose: settingsPopup.close,
                icon: (0, $7a6819d528babbc5$export$2e2bcd8739ae039),
                title: t("focusMode.Controls settings"),
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $bd914ef380e06327$export$2e2bcd8739ae039), {
                    className: "space-y-6",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bd914ef380e06327$export$2e2bcd8739ae039).Item, {
                            label: t("focusMode.Voice control"),
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bd914ef380e06327$export$2e2bcd8739ae039).Switch, {
                                checked: voiceControlEnabled,
                                onChange: (v)=>setVoiceControlEnable(v),
                                disabled: !browserSupportsSpeechRecognition,
                                description: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $242f1f28d80c68d3$export$8d6a9236f2e3f2ce), {
                                    i18nKey: description
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bd914ef380e06327$export$2e2bcd8739ae039).Item, {
                            label: t("focusMode.Gesture control"),
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $bd914ef380e06327$export$2e2bcd8739ae039).Switch, {
                                checked: gestureControlEnabled,
                                onChange: (v)=>setGestureControlEnable(v),
                                description: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $242f1f28d80c68d3$export$8d6a9236f2e3f2ce), {
                                    i18nKey: "focusMode.Make a thumbs up"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a3758683e16a4079$export$2e2bcd8739ae039), {
                restRef: ref,
                className: "pointer-events-none",
                disableMaximize: true,
                children: (isMaximized)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $4bf72665163a8648$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $525000a460d770e0$export$2e2bcd8739ae039), {
                                url: `/recipes/${recipe.id}`,
                                title: t("_Back to recipe")
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "flex-1"
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Icon, {
                                icon: (0, $7a6819d528babbc5$export$2e2bcd8739ae039),
                                title: t("focusMode.Controls settings"),
                                onClick: settingsPopup.open,
                                blur: true
                            })
                        ]
                    })
            })
        ]
    });
};
var $7cc6bfc95b9ff78c$export$2e2bcd8739ae039 = $7cc6bfc95b9ff78c$var$RecipeFocus;



/* eslint-disable i18next/no-literal-string */ 

var $3QbnI = parcelRequire("3QbnI");



var $3QbnI = parcelRequire("3QbnI");
function $1960464086733c2a$var$ArrowDownOnSquareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $3QbnI.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $3QbnI.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $3QbnI.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25"
    }));
}
const $1960464086733c2a$var$ForwardRef = $3QbnI.forwardRef($1960464086733c2a$var$ArrowDownOnSquareIcon);
var $1960464086733c2a$export$2e2bcd8739ae039 = $1960464086733c2a$var$ForwardRef;























const $44d1c9c9ae09e216$var$LineSkeleton = ({ className: className })=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("bg-gray-200 rounded-full", className)
    });
const $44d1c9c9ae09e216$var$RecipeShare = ()=>{
    const { linkId: linkId } = (0, $e724dc7e3b3eec8a$export$99eaa27ddbbb95ef)();
    const [loading, setLoading] = (0, $3QbnI.useState)(true);
    const user = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $68690f862a398578$export$e5432d4c8eb97ea7));
    const [{ recipe: recipe, formattedRecipe: formattedRecipe }, setRecipe] = (0, $3QbnI.useState)({
        recipe: null,
        formattedRecipe: null
    });
    const alreadyExistingRecipe = (0, $67ed7bda3729d158$export$a7347740d65f620b)((state)=>(0, $87c50e51b43ee465$export$d3bef8d36f4e0ca4)(state, recipe?.id));
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    (0, $3QbnI.useEffect)(()=>{
        if (alreadyExistingRecipe) navigate(`/recipes/${alreadyExistingRecipe.id}`);
    }, [
        alreadyExistingRecipe,
        navigate
    ]);
    const fetch = async ()=>{
        try {
            if (linkId) {
                const recipe = await $f7bebd229d5ef758$export$2d5f223c4223f53c(linkId);
                const formattedRecipe = (0, $155871c54ecd5932$export$2e2bcd8739ae039)(recipe);
                setRecipe({
                    recipe: recipe,
                    formattedRecipe: formattedRecipe
                });
            }
        } catch (error) {
            console.error("error", error);
        } finally{
            setLoading(false);
        }
    };
    (0, $3QbnI.useEffect)(()=>{
        fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const ref = (0, $3QbnI.useRef)(null);
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    if (!recipe || !formattedRecipe || !linkId) {
        if (loading) return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b11190345c4c4e48$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5daa306c145fc294$export$2e2bcd8739ae039), {});
    }
    const importSharedRecipe = async ()=>{
        try {
            const url = (0, $372477af3890afd9$export$9a12c63cbd521171)(linkId);
            const recipe = await dispatch((0, $87c50e51b43ee465$export$1f4a3fe10896614d)(url)).unwrap();
            navigate(`/recipes/${recipe.id}`);
        } catch (error) {
            console.error(error);
        }
    };
    const login = ()=>{
        (0, $372477af3890afd9$export$b8e943e271d87bdd)([
            ...(0, $372477af3890afd9$export$e19bc8b568728edd)(),
            linkId
        ]);
        navigate("/login");
    };
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e91e729a6066c3b7$export$2e2bcd8739ae039), {
        title: recipe.name,
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $c17029512d70ed45$export$2e2bcd8739ae039), {
                imageUrl: recipe.imageUrl,
                alt: recipe.name
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
                className: "flex-1 relative z-10",
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                    className: "flex flex-col items-stretch lg:flex-row lg:items-start",
                    children: [
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                            ref: ref
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                            className: "w-full lg:flex-[0_0_400px] lg:max-w-screen-md relative top-[-7rem]",
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $462140c0f3a53058$export$2e2bcd8739ae039), {
                                className: "p-4 lg:w-[400px] relative",
                                children: [
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h1", {
                                        className: "text-2xl sm:text-3xl font-bold leading-7 text-gray-900 break-words overflow-hidden text-center ltr:lg:text-left rtl:lg:text-right pb-2 select-text",
                                        children: formattedRecipe.name
                                    }),
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                        className: "text-center lg:text-left",
                                        children: formattedRecipe.keywords.map((keyword)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $500dda12544a1f09$export$a6c7ac8248d6e38a), {
                                                className: "mr-1",
                                                to: `/recipes?q=${keyword}`,
                                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $48afa93f9f65698e$export$2e2bcd8739ae039), {
                                                    children: keyword
                                                })
                                            }, keyword))
                                    }),
                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                                        className: "pt-6",
                                        children: [
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $3730ae85ea413570$export$2e2bcd8739ae039), {
                                                children: t("_Ingredients")
                                            }),
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                className: "h-2.5 w-48 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                className: "h-2.5 w-28 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                className: "h-2.5 w-52 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                className: "h-2.5 w-60 mb-4"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                            className: "flex-1 relative ltr:lg:pl-10 rtl:lg:pr-10 lg:pt-10 top-[-5rem] lg:top-[0rem]",
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $3730ae85ea413570$export$2e2bcd8739ae039), {
                                    children: t("_Steps")
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("ol", {
                                    className: "overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d5f9f7d1c8fc38e9$export$2e2bcd8739ae039), {
                                            linkClassName: "bg-gray-300",
                                            iconClassName: "bg-white border-2 border-gray-300 group-hover:border-gray-400",
                                            icon: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                                className: "h-2.5 w-2.5 bg-black rounded-full"
                                            }),
                                            description: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                        className: "h-2.5 w-48 mb-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                        className: "h-2.5 w-28 mb-4"
                                                    })
                                                ]
                                            }),
                                            onClick: ()=>{},
                                            ingredients: []
                                        }),
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d5f9f7d1c8fc38e9$export$2e2bcd8739ae039), {
                                            linkClassName: "bg-gray-300",
                                            iconClassName: "bg-white border-2 border-gray-300 group-hover:border-gray-400",
                                            icon: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                                className: "h-2.5 w-2.5 bg-black rounded-full"
                                            }),
                                            description: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                        className: "h-2.5 w-48 mb-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                        className: "h-2.5 w-28 mb-4"
                                                    })
                                                ]
                                            }),
                                            onClick: ()=>{},
                                            ingredients: []
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d5f9f7d1c8fc38e9$export$2e2bcd8739ae039), {
                                            linkClassName: "bg-gray-300",
                                            iconClassName: "bg-white border-2 border-gray-300 group-hover:border-gray-400",
                                            icon: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                                className: "h-2.5 w-2.5 bg-black rounded-full"
                                            }),
                                            description: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                        className: "h-2.5 w-48 mb-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                        className: "h-2.5 w-28 mb-4"
                                                    })
                                                ]
                                            }),
                                            onClick: ()=>{},
                                            ingredients: []
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d5f9f7d1c8fc38e9$export$2e2bcd8739ae039), {
                                            linkClassName: "bg-gray-300",
                                            iconClassName: "bg-white border-2 border-gray-300 group-hover:border-gray-400",
                                            icon: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                                className: "h-2.5 w-2.5 bg-black rounded-full"
                                            }),
                                            description: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                        className: "h-2.5 w-48 mb-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)($44d1c9c9ae09e216$var$LineSkeleton, {
                                                        className: "h-2.5 w-28 mb-4"
                                                    })
                                                ]
                                            }),
                                            onClick: ()=>{},
                                            ingredients: []
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                className: "fixed inset-0 z-20 flex items-center justify-center bg-gradient-to-b from-transparent via-white to-white"
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $b9c536326972e77d$export$2e2bcd8739ae039), {
                open: true,
                type: (0, $b9c536326972e77d$export$9656cfe2bd6e411f).Black,
                icon: (0, $1960464086733c2a$export$2e2bcd8739ae039),
                onClose: ()=>{},
                description: t("_To view this recipe, you need to import it in CookBook."),
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    className: "text-center",
                    children: user ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary, {
                        onClick: importSharedRecipe,
                        children: t("_Import in CookBook")
                    }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary, {
                        onClick: login,
                        children: t("_Log in and import it")
                    })
                })
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a3758683e16a4079$export$2e2bcd8739ae039), {
                restRef: ref,
                className: "pointer-events-none",
                children: (isMaximized)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $4bf72665163a8648$export$2e2bcd8739ae039), {
                        children: [
                            user ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $525000a460d770e0$export$2e2bcd8739ae039), {
                                url: "/recipes",
                                title: t("_Back to recipes")
                            }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $525000a460d770e0$export$2e2bcd8739ae039), {
                                url: "/",
                                title: t("_Back to landing page")
                            }),
                            isMaximized ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $6d48233ba4b818b9$export$2e2bcd8739ae039), {
                                recipeName: formattedRecipe.name,
                                keywords: formattedRecipe.keywords
                            }) : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "flex-1"
                            })
                        ]
                    })
            })
        ]
    });
};
var $44d1c9c9ae09e216$export$2e2bcd8739ae039 = $44d1c9c9ae09e216$var$RecipeShare;




var $3QbnI = parcelRequire("3QbnI");







var $3QbnI = parcelRequire("3QbnI");

var $3QbnI = parcelRequire("3QbnI");
const $c00f0eec9bcf21c3$var$VerificationCodeContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).createContext("");
var $c00f0eec9bcf21c3$export$2e2bcd8739ae039 = $c00f0eec9bcf21c3$var$VerificationCodeContext;


// https://beta.reactjs.org/learn/manipulating-the-dom-with-refs#how-to-manage-a-list-of-refs-using-a-ref-callback
// https://codepen.io/tatthien/pen/LYZxEmv
const $851347b582124326$var$VerificationCodeInput = ({ className: className, onChange: onChange = ()=>{}, onComplete: onComplete = ()=>{}, fields: fields = 4, "aria-label": ariaLabel })=>{
    const [values, setValues] = (0, $3QbnI.useState)(new Array(fields).fill(""));
    const inputRefs = (0, $3QbnI.useRef)(new Map());
    const changeValues = (newValues)=>{
        setValues(newValues);
        onChange(newValues);
        if (newValues.join("").length === fields) onComplete(newValues.join(""));
    };
    const context = (0, $3QbnI.useContext)((0, $c00f0eec9bcf21c3$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
        className: context ?? "flex justify-center gap-x-2",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("input", {
                type: "text",
                className: "sr-only",
                "aria-label": ariaLabel
            }),
            values.map((_, index)=>index).map((f, index)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("input", {
                    type: "tel",
                    autoComplete: "none",
                    className: className,
                    name: "",
                    id: "",
                    maxLength: 1,
                    "aria-hidden": true,
                    value: values[index],
                    ref: (node)=>{
                        if (node) inputRefs.current.set(index, node);
                        else inputRefs.current.delete(index);
                    },
                    onPaste: (event)=>{
                        const paste = event.clipboardData.getData("text");
                        changeValues([
                            ...index > 0 ? values.slice(0, index) : [],
                            ...paste.substring(0, fields - index).split(""),
                            ...values.slice(index + paste.split("").length)
                        ]);
                    },
                    onChange: (event)=>{
                        const newValues = [
                            ...values
                        ];
                        const oldValue = newValues[index];
                        const newValue = event.target.value;
                        newValues[index] = newValue;
                        changeValues(newValues);
                        if (!oldValue && newValue) inputRefs.current.get(index + 1)?.select();
                    },
                    onKeyDown: (event)=>{
                        if (event.key === "ArrowLeft") inputRefs.current.get(index - 1)?.select();
                        else if (event.key === "ArrowRight") inputRefs.current.get(index + 1)?.select();
                        else if (event.key === "Backspace" && !values[index]) inputRefs.current.get(index - 1)?.select();
                    },
                    onFocus: (event)=>{
                        setTimeout(()=>{
                            event.target.select();
                        }, 0);
                    }
                }, f))
        ]
    });
};
var $851347b582124326$export$2e2bcd8739ae039 = $851347b582124326$var$VerificationCodeInput;




// https://beta.reactjs.org/learn/manipulating-the-dom-with-refs#how-to-manage-a-list-of-refs-using-a-ref-callback
// https://codepen.io/tatthien/pen/LYZxEmv
const $797dc204df9d66fc$var$VerificationCodeInputWrapper = ({ className: className, children: children })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $c00f0eec9bcf21c3$export$2e2bcd8739ae039).Provider, {
        value: className || "",
        children: children
    });
};
var $797dc204df9d66fc$export$2e2bcd8739ae039 = $797dc204df9d66fc$var$VerificationCodeInputWrapper;


var $921c6f346592fcb4$export$2e2bcd8739ae039 = Object.assign((0, $851347b582124326$export$2e2bcd8739ae039), {
    Wrapper: (0, $797dc204df9d66fc$export$2e2bcd8739ae039)
});




const $408b090004cde0e2$var$CODE_LENGTH = 6;
const $408b090004cde0e2$var$LoginCodeVerify = ()=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("login");
    const [code, setCode] = (0, $3QbnI.useState)("");
    const [searchParams] = (0, $500dda12544a1f09$export$f1a78c17382fe22a)();
    const [email] = (0, $3QbnI.useState)(searchParams.get("email"));
    const [isLoading, setLoading] = (0, $3QbnI.useState)(false);
    const { checkVerificationCodeForLogin: checkVerificationCodeForLogin } = (0, $2503a745c61c2eb7$export$2e2bcd8739ae039)();
    const validateCode = async (newCode)=>{
        setLoading(true);
        try {
            await checkVerificationCodeForLogin(newCode);
        } catch (error) {
            setLoading(false);
            console.error(error);
        } finally{}
    };
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $8e9e52b7745f05dc$export$2e2bcd8739ae039), {
        title: t("_Log in"),
        description: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $242f1f28d80c68d3$export$8d6a9236f2e3f2ce), {
            t: t,
            i18nKey: "_An email on its way",
            values: {
                email: email
            }
        }),
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $bd914ef380e06327$export$2e2bcd8739ae039), {
            className: "space-y-4",
            onSubmit: ()=>validateCode(code),
            children: [
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $921c6f346592fcb4$export$2e2bcd8739ae039).Wrapper, {
                    className: "flex justify-center md:justify-start gap-x-3",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $921c6f346592fcb4$export$2e2bcd8739ae039), {
                        fields: $408b090004cde0e2$var$CODE_LENGTH,
                        className: "w-12 h-12 flex flex-col items-center justify-center text-center outline-none rounded-xl border border-gray-300 text-lg bg-white focus:bg-gray-50 focus:ring-1 focus:ring-primary-500 focus:border-primary-500",
                        onComplete: validateCode,
                        onChange: (v)=>setCode(v.join(""))
                    })
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary, {
                        type: "submit",
                        className: "w-full",
                        disabled: code.length < 6,
                        children: isLoading ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $571576b994bd2c02$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-white"
                        }) : t("_Verify")
                    })
                })
            ]
        })
    });
};
var $408b090004cde0e2$export$2e2bcd8739ae039 = $408b090004cde0e2$var$LoginCodeVerify;




var $3QbnI = parcelRequire("3QbnI");



var $3QbnI = parcelRequire("3QbnI");


const $079261757b48a3cf$var$useWhenLoggedIn = (callback = ()=>{})=>{
    const isLoggedIn = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $68690f862a398578$export$c7606e33e48d5b45));
    (0, $3QbnI.useEffect)(()=>{
        if (isLoggedIn) callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoggedIn
    ]);
};
var $079261757b48a3cf$export$2e2bcd8739ae039 = $079261757b48a3cf$var$useWhenLoggedIn;



var $3QbnI = parcelRequire("3QbnI");



const $3576757c151db680$var$useWhenLoggedOut = (callback = ()=>{}, onlyRoles)=>{
    const currentUser = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $68690f862a398578$export$e5432d4c8eb97ea7));
    const loggedOut = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $68690f862a398578$export$1ee9436926beb645));
    const loggedIn = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $68690f862a398578$export$c7606e33e48d5b45));
    (0, $3QbnI.useEffect)(()=>{
        if (loggedOut || loggedIn && !(0, $228ef9ae46c6f5ac$export$b0158c8cc002b36f)(currentUser, onlyRoles)) callback();
    }, [
        loggedOut,
        loggedIn,
        currentUser,
        onlyRoles,
        callback
    ]);
};
var $3576757c151db680$export$2e2bcd8739ae039 = $3576757c151db680$var$useWhenLoggedOut;








const $a1f6a8916e72ae90$var$Notification = ({ message: message, actions: actions, onClose: onClose })=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
            className: "p-4",
            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        className: "flex w-0 flex-1 justify-between",
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("p", {
                                className: "w-0 flex-1 text-sm font-medium text-gray-400",
                                children: message
                            }),
                            actions.map(({ label: label, onClick: onClick })=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("button", {
                                    type: "button",
                                    className: "ml-3 flex-shrink-0 rounded-md bg-gray-900 text-sm font-medium text-white hover:text-gray-300",
                                    onClick: onClick,
                                    children: label
                                }))
                        ]
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                        className: "ml-4 flex flex-shrink-0",
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("button", {
                            type: "button",
                            className: "inline-flex rounded-md bg-gray-900 hover:bg-gray-800 text-gray-400 focus:text-white",
                            onClick: onClose,
                            children: [
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: t("notifications.Close")
                                }),
                                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("svg", {
                                    className: "h-5 w-5",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 20 20",
                                    fill: "currentColor",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("path", {
                                        d: "M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $a1f6a8916e72ae90$export$2e2bcd8739ae039 = $a1f6a8916e72ae90$var$Notification;




const $c1b3366a11774f70$var$Notifications = ()=>{
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const container = document.getElementById("notifications");
    const recipes = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $87c50e51b43ee465$export$7de8bac5e848e0d5));
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    if (!container) return null;
    return /*#__PURE__*/ (0, $70c58451959e30b3$exports.createPortal)(/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        "aria-live": "assertive",
        className: "fixed bottom-0 inset-x-0 z-50 flex items-start px-4 py-6 pointer-events-none sm:p-6",
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
            className: "w-full flex flex-col items-center space-y-4 sm:items-start",
            children: recipes.map((recipe)=>/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a1f6a8916e72ae90$export$2e2bcd8739ae039), {
                    message: t("_Recipe deleted", {
                        recipeName: recipe.name
                    }),
                    actions: [
                        {
                            label: t("_Undo"),
                            onClick: ()=>dispatch((0, $87c50e51b43ee465$export$35820ded2652368d)(recipe))
                        }
                    ],
                    onClose: ()=>dispatch((0, $87c50e51b43ee465$export$4579f09ab2381822)(recipe))
                }, recipe.id))
        })
    }), container);
};
var $c1b3366a11774f70$export$2e2bcd8739ae039 = $c1b3366a11774f70$var$Notifications;





const $62238c3c493a80b0$var$Transition = ({ className: className, onAnimationEnd: onAnimationEnd, children: children })=>{
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
        id: "app",
        className: className,
        onAnimationEnd: onAnimationEnd,
        children: children
    });
};
var $62238c3c493a80b0$export$2e2bcd8739ae039 = $62238c3c493a80b0$var$Transition;


const $d6959a8978dbeaa5$var$ProtectedRoute = ({ onlyRoles: onlyRoles, children: children, className: className, onAnimationEnd: onAnimationEnd })=>{
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    const redirectToHome = (0, $3QbnI.useCallback)(()=>{
        navigate("/login");
    }, [
        navigate
    ]);
    (0, $3576757c151db680$export$2e2bcd8739ae039)(redirectToHome, onlyRoles);
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    const recipesFetched = (0, $67ed7bda3729d158$export$a7347740d65f620b)((0, $87c50e51b43ee465$export$c341f62fd7d1eec8));
    const fetch = (0, $3QbnI.useCallback)(()=>{
        if (!recipesFetched) dispatch((0, $87c50e51b43ee465$export$984e0109ba03b979)());
    }, [
        recipesFetched,
        dispatch
    ]);
    (0, $079261757b48a3cf$export$2e2bcd8739ae039)(fetch);
    (0, $382adfbc1e51da84$export$2e2bcd8739ae039)("visibilitychange", ()=>{
        if (document.visibilityState === "visible") dispatch((0, $87c50e51b43ee465$export$984e0109ba03b979)());
    });
    const importSaved = (0, $3QbnI.useCallback)(async ()=>{
        const linkIds = (0, $372477af3890afd9$export$e19bc8b568728edd)();
        (0, $372477af3890afd9$export$fd0bf85c110f02fb)();
        await Promise.all(linkIds.map((0, $372477af3890afd9$export$9a12c63cbd521171)).map((url)=>dispatch((0, $87c50e51b43ee465$export$1f4a3fe10896614d)(url)).unwrap()));
    }, [
        dispatch
    ]);
    (0, $079261757b48a3cf$export$2e2bcd8739ae039)(importSaved);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $a359a61ebad41d43$exports.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $62238c3c493a80b0$export$2e2bcd8739ae039), {
                className: className,
                onAnimationEnd: onAnimationEnd,
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$910ae8079b2c2852), {})
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $c1b3366a11774f70$export$2e2bcd8739ae039), {})
        ]
    });
};
var $d6959a8978dbeaa5$export$2e2bcd8739ae039 = $d6959a8978dbeaa5$var$ProtectedRoute;




var $3QbnI = parcelRequire("3QbnI");



const $f7b4c2b50e83adfb$var$PortalRoute = ({ children: children, className: className, onAnimationEnd: onAnimationEnd })=>{
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    const goToRecipesPage = (0, $3QbnI.useCallback)(()=>navigate("/recipes"), [
        navigate
    ]);
    (0, $079261757b48a3cf$export$2e2bcd8739ae039)(goToRecipesPage);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $62238c3c493a80b0$export$2e2bcd8739ae039), {
        className: className,
        onAnimationEnd: onAnimationEnd,
        children: children ? children : /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$910ae8079b2c2852), {})
    });
};
var $f7b4c2b50e83adfb$export$2e2bcd8739ae039 = $f7b4c2b50e83adfb$var$PortalRoute;




var $3QbnI = parcelRequire("3QbnI");



const $8a41139e6621bc54$var$GlobalRoute = ({ children: children })=>{
    (0, $2503a745c61c2eb7$export$2e2bcd8739ae039)();
    const dispatch = (0, $67ed7bda3729d158$export$f51d452c10d5b956)();
    (0, $3QbnI.useEffect)(()=>{
        dispatch((0, $e55c7c0b1e5b11b1$export$19857d102f0f8f66)());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {
        children: children
    });
};
var $8a41139e6621bc54$export$2e2bcd8739ae039 = $8a41139e6621bc54$var$GlobalRoute;








/* eslint-disable i18next/no-literal-string */ 
parcelRequire("3QbnI");


const $4a869076ac936f4a$var$MobileShoppingListHeader = (props)=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a359a61ebad41d43$exports.Fragment), {
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4bf72665163a8648$export$2e2bcd8739ae039), {
            className: "block md:hidden border-b border-gray-200",
            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("h1", {
                className: "text-xl font-semibold leading-6 text-gray-900",
                children: t("shoppingList.Shopping list")
            })
        })
    });
};
var $4a869076ac936f4a$export$2e2bcd8739ae039 = $4a869076ac936f4a$var$MobileShoppingListHeader;



const $ffdfb5592ad864a5$var$ShoppingList = ()=>{
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e91e729a6066c3b7$export$2e2bcd8739ae039), {
        title: t("shoppingList.Shopping list"),
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d890da727bd41033$exports)))("bg-white min-h-[100vh] md:h-auto md:m-10"),
            children: [
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $4a869076ac936f4a$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7d9071b508ba2a12$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ec2436c670cc4a41$export$2e2bcd8739ae039), {
                        ingredients: []
                    })
                })
            ]
        })
    });
};
var $ffdfb5592ad864a5$export$2e2bcd8739ae039 = $ffdfb5592ad864a5$var$ShoppingList;




var $3QbnI = parcelRequire("3QbnI");


const $d8e316080a2ef24f$var$PREFERENCES = "/preferences";
const $d8e316080a2ef24f$var$areLocationIncludes = (location1, location2, routes)=>routes.some((r)=>location1.pathname.includes(r) && location2.pathname.includes(r));
const $d8e316080a2ef24f$var$areLocationDifferent = (location1, location2)=>location1.pathname !== location2.pathname;
const $d8e316080a2ef24f$var$useTransition = ()=>{
    const location = (0, $e724dc7e3b3eec8a$export$45d76561a5302f2b)();
    const [previousLocation, setPreviousLocation] = (0, $3QbnI.useState)("");
    const [displayLocation, setDisplayLocation] = (0, $3QbnI.useState)(location);
    const [transitionStage, setTransistionStage] = (0, $3QbnI.useState)("");
    (0, $3QbnI.useEffect)(()=>{
        if ($d8e316080a2ef24f$var$areLocationDifferent(location, displayLocation)) {
            if ((0, $7941da5030926682$export$d0a8044dce8ff2fc)() && ($d8e316080a2ef24f$var$areLocationIncludes(location, displayLocation, [
                "/recipes",
                "/login",
                "/signup"
            ]) || location.pathname === $d8e316080a2ef24f$var$PREFERENCES || displayLocation.pathname === $d8e316080a2ef24f$var$PREFERENCES)) {
                if (displayLocation.pathname.includes(location.pathname) || displayLocation.pathname === $d8e316080a2ef24f$var$PREFERENCES) setTransistionStage("slideRight");
                else setTransistionStage("slideLeft");
            } else setDisplayLocation(location);
            setPreviousLocation(displayLocation.pathname);
        }
    }, [
        location,
        displayLocation
    ]);
    const onAnimationEnd = (0, $3QbnI.useCallback)(()=>{
        if (transitionStage === "slideRight") {
            setTransistionStage("slideRightEnd");
            setDisplayLocation(location);
        } else if (transitionStage === "slideLeft") {
            setTransistionStage("slideLeftEnd");
            setDisplayLocation(location);
        }
    }, [
        transitionStage,
        setTransistionStage,
        setDisplayLocation,
        location
    ]);
    return (0, $3QbnI.useMemo)(()=>[
            transitionStage,
            previousLocation,
            displayLocation,
            onAnimationEnd
        ], [
        transitionStage,
        previousLocation,
        displayLocation,
        onAnimationEnd
    ]);
};
var $d8e316080a2ef24f$export$2e2bcd8739ae039 = $d8e316080a2ef24f$var$useTransition;




var $3QbnI = parcelRequire("3QbnI");







function $94d4583ba8fbd3aa$export$2e2bcd8739ae039() {
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("login");
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    const [email, setEmail] = (0, $3QbnI.useState)("");
    const [isLoading, setLoading] = (0, $3QbnI.useState)(false);
    const { sendVerificationCodeForSignUp: sendVerificationCodeForSignUp } = (0, $2503a745c61c2eb7$export$2e2bcd8739ae039)();
    const login = async ()=>{
        setLoading(true);
        try {
            const { status: status } = await sendVerificationCodeForSignUp(email);
            console.log("status", status);
            navigate(`/signup/code-verify?email=${email}`);
        } catch (error) {
            console.log("error");
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $8e9e52b7745f05dc$export$2e2bcd8739ae039), {
        title: t("_Sign up"),
        description: "\u200E",
        children: [
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $bd914ef380e06327$export$2e2bcd8739ae039), {
                className: "space-y-4",
                onSubmit: login,
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("label", {
                                htmlFor: "email",
                                className: "block text-sm font-medium text-gray-700",
                                children: t("_Email address")
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("input", {
                                    id: "email",
                                    name: "email",
                                    type: "email",
                                    autoComplete: "email",
                                    onChange: (e)=>setEmail(e.target.value),
                                    required: true,
                                    placeholder: "john.smith@gmail.com",
                                    className: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary, {
                            type: "submit",
                            className: "w-full",
                            children: isLoading ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $571576b994bd2c02$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-white"
                            }) : t("_Send code")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)("p", {
                className: "mt-5 text-left text-sm text-gray-500",
                children: [
                    t("_Already an account"),
                    " ",
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $500dda12544a1f09$export$a6c7ac8248d6e38a), {
                        to: "/login",
                        className: "font-semibold leading-6 text-primary-500 hover:text-primary-600",
                        children: t("_Log in")
                    })
                ]
            })
        ]
    });
}




var $3QbnI = parcelRequire("3QbnI");








const $43034d4ba8432a9b$var$CODE_LENGTH = 6;
function $43034d4ba8432a9b$export$2e2bcd8739ae039() {
    const { t: t } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)("login");
    const [code, setCode] = (0, $3QbnI.useState)("");
    const [searchParams] = (0, $500dda12544a1f09$export$f1a78c17382fe22a)();
    const [email] = (0, $3QbnI.useState)(searchParams.get("email"));
    const [isLoading, setLoading] = (0, $3QbnI.useState)(false);
    const { checkVerificationCodeForSignUp: checkVerificationCodeForSignUp } = (0, $2503a745c61c2eb7$export$2e2bcd8739ae039)();
    const validateCode = async (newCode)=>{
        setLoading(true);
        try {
            await checkVerificationCodeForSignUp(newCode);
        } catch (error) {
            setLoading(false);
            console.error(error);
        } finally{}
    };
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $8e9e52b7745f05dc$export$2e2bcd8739ae039), {
        title: t("_Sign Up"),
        description: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $242f1f28d80c68d3$export$8d6a9236f2e3f2ce), {
            t: t,
            i18nKey: "_An email on its way",
            values: {
                email: email
            }
        }),
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $bd914ef380e06327$export$2e2bcd8739ae039), {
            className: "space-y-4",
            onSubmit: ()=>validateCode(code),
            children: [
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $921c6f346592fcb4$export$2e2bcd8739ae039).Wrapper, {
                    className: "flex justify-center md:justify-start gap-x-3",
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $921c6f346592fcb4$export$2e2bcd8739ae039), {
                        fields: $43034d4ba8432a9b$var$CODE_LENGTH,
                        className: "w-12 h-12 flex flex-col items-center justify-center text-center outline-none rounded-xl border border-gray-300 text-lg bg-white focus:bg-gray-50 focus:ring-1 focus:ring-primary-500 focus:border-primary-500",
                        onComplete: validateCode,
                        onChange: (v)=>setCode(v.join(""))
                    })
                }),
                /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e8867e1811a3f10f$export$2e2bcd8739ae039).Primary, {
                        type: "submit",
                        className: "w-full",
                        disabled: code.length < 6,
                        children: isLoading ? /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $571576b994bd2c02$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-white"
                        }) : t("_Verify")
                    })
                })
            ]
        })
    });
}


const $7e1bd9d654e310e3$var$App = ()=>{
    const [transitionStage, previousLocation, displayLocation, onAnimationEnd] = (0, $d8e316080a2ef24f$export$2e2bcd8739ae039)();
    const { i18n: i18n } = (0, $358cc1813d9f14d1$export$9fc83ad70ead8663)();
    document.body.dir = i18n.dir();
    const { checkSession: checkSession } = (0, $2503a745c61c2eb7$export$2e2bcd8739ae039)();
    checkSession();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a050a4f7c2d8a5ac$export$2e2bcd8739ae039).Provider, {
        value: {
            previousLocation: previousLocation
        },
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $8a41139e6621bc54$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e724dc7e3b3eec8a$export$3565eb3d00ca5a74), {
                location: displayLocation,
                children: [
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $1302b8474027e87c$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                        path: "/recipes",
                        element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d6959a8978dbeaa5$export$2e2bcd8739ae039), {
                            className: transitionStage,
                            onAnimationEnd: onAnimationEnd,
                            onlyRoles: [
                                (0, $228ef9ae46c6f5ac$export$2e2bcd8739ae039).User
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                                path: "",
                                element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $44d5673b7a91e670$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                                path: "new",
                                element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $a8da142c449c374a$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                                path: "shopping-list",
                                element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ffdfb5592ad864a5$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                                path: ":recipeId",
                                element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $27ababeb22c6e032$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                                path: ":recipeId/focus",
                                element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7cc6bfc95b9ff78c$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                                path: ":recipeId/edit",
                                element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $054b6ff01c922037$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                        path: "/share/:linkId",
                        element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $44d1c9c9ae09e216$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                        path: "/preferences",
                        element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $d6959a8978dbeaa5$export$2e2bcd8739ae039), {
                            className: transitionStage,
                            onAnimationEnd: onAnimationEnd,
                            onlyRoles: [
                                (0, $228ef9ae46c6f5ac$export$2e2bcd8739ae039).User
                            ],
                            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $2cf84599f98380d6$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                        path: "/signup",
                        element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f7b4c2b50e83adfb$export$2e2bcd8739ae039), {
                            className: transitionStage,
                            onAnimationEnd: onAnimationEnd
                        }),
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                                path: "code-verify",
                                element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $43034d4ba8432a9b$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                                path: "",
                                element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $94d4583ba8fbd3aa$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsxs)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                        path: "/login",
                        element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $f7b4c2b50e83adfb$export$2e2bcd8739ae039), {
                            className: transitionStage,
                            onAnimationEnd: onAnimationEnd
                        }),
                        children: [
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                                path: "code-verify",
                                element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $408b090004cde0e2$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                                path: "",
                                element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $ed5cc2db846f00c6$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $e724dc7e3b3eec8a$export$e7b0ac011bb776c6), {
                        path: "/*",
                        element: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $5daa306c145fc294$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        })
    });
};
var $7e1bd9d654e310e3$export$2e2bcd8739ae039 = $7e1bd9d654e310e3$var$App;



const $c2c22c8bdbfd9da6$var$reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) (parcelRequire("hnAsU")).then(({ getCLS: getCLS, getFID: getFID, getFCP: getFCP, getLCP: getLCP, getTTFB: getTTFB })=>{
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    });
};
var $c2c22c8bdbfd9da6$export$2e2bcd8739ae039 = $c2c22c8bdbfd9da6$var$reportWebVitals;






const $70d267660b93b073$var$AuthProvider = ({ children: children })=>{
    const navigate = (0, $e724dc7e3b3eec8a$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $80fa3740fa1bfa8c$export$9d21b78f14bcb891), {
        publishableKey: "pk_test_ZmxlZXQtY3ViLTk0LmNsZXJrLmFjY291bnRzLmRldiQ" ?? "",
        navigate: (to)=>navigate(to),
        children: children
    });
};
var $70d267660b93b073$export$2e2bcd8739ae039 = $70d267660b93b073$var$AuthProvider;


const $d0bb92445f8cf837$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($b44a20a3fc7684be$exports))).createRoot(document.getElementById("root"));
$d0bb92445f8cf837$var$root.render(/*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QbnI))).StrictMode, {
    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $0bd4b6cc11215fa4$export$4719288a8f5f7e71), {
        children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $500dda12544a1f09$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $70d267660b93b073$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $37606b2ec2c6e282$export$2e2bcd8739ae039), {
                    store: (0, $465de4f5e1bc4524$export$2e2bcd8739ae039),
                    children: /*#__PURE__*/ (0, $a359a61ebad41d43$exports.jsx)((0, $7e1bd9d654e310e3$export$2e2bcd8739ae039), {})
                })
            })
        })
    })
}));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $c2c22c8bdbfd9da6$export$2e2bcd8739ae039)() // If you want your app to work offline and load faster, you can change
 // unregister() to register() below. Note this comes with some pitfalls.
 // Learn more about service workers: https://cra.link/PWA
 // serviceWorkerRegistration.register()
;


//# sourceMappingURL=index.aa6d4633.js.map
